
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6bbb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6bbb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRegister("bh6RR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cCfq4"));

});
parcelRegister("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $92f4fea5bc247620$export$3ba232387fd5d6dd; }, function (v) { return $92f4fea5bc247620$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$3ba232387fd5d6dd;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
"use strict";
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
function $92f4fea5bc247620$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$3ba232387fd5d6dd = $92f4fea5bc247620$var$X;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = $92f4fea5bc247620$var$X;
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$Lg(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$Lg(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$Sg(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Tg(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Ug = $b36288e2db101ba3$var$Og(!0), $b36288e2db101ba3$var$Vg = $b36288e2db101ba3$var$Og(!1), $b36288e2db101ba3$var$Wg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Xg = null, $b36288e2db101ba3$var$Yg = null, $b36288e2db101ba3$var$Zg = null;
function $b36288e2db101ba3$var$$g() {
    $b36288e2db101ba3$var$Zg = $b36288e2db101ba3$var$Yg = $b36288e2db101ba3$var$Xg = null;
}
function $b36288e2db101ba3$var$ah(a) {
    var b = $b36288e2db101ba3$var$Wg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$ch(a, b) {
    $b36288e2db101ba3$var$Xg = a;
    $b36288e2db101ba3$var$Zg = $b36288e2db101ba3$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$dh = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$eh(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Yg) {
            if (null === $b36288e2db101ba3$var$Xg) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Yg = a;
            $b36288e2db101ba3$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Yg = $b36288e2db101ba3$var$Yg.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$fh = null;
function $b36288e2db101ba3$var$gh(a) {
    null === $b36288e2db101ba3$var$fh ? $b36288e2db101ba3$var$fh = [
        a
    ] : $b36288e2db101ba3$var$fh.push(a);
}
function $b36288e2db101ba3$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$ih(a, d);
}
function $b36288e2db101ba3$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$jh = !1;
function $b36288e2db101ba3$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$ih(a, c);
}
function $b36288e2db101ba3$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$th = {}, $b36288e2db101ba3$var$uh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th), $b36288e2db101ba3$var$vh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th), $b36288e2db101ba3$var$wh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th);
function $b36288e2db101ba3$var$xh(a) {
    if (a === $b36288e2db101ba3$var$th) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$yh(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$wh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$vh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, $b36288e2db101ba3$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, b);
}
function $b36288e2db101ba3$var$zh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$vh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$wh);
}
function $b36288e2db101ba3$var$Ah(a) {
    $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
    var b = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$vh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, c));
}
function $b36288e2db101ba3$var$Bh(a) {
    $b36288e2db101ba3$var$vh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$vh));
}
var $b36288e2db101ba3$var$L = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Dh = [];
function $b36288e2db101ba3$var$Eh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Dh.length; a++)$b36288e2db101ba3$var$Dh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Dh.length = 0;
}
var $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Hh = 0, $b36288e2db101ba3$var$M = null, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$Ih = !1, $b36288e2db101ba3$var$Jh = !1, $b36288e2db101ba3$var$Kh = 0, $b36288e2db101ba3$var$Lh = 0;
function $b36288e2db101ba3$var$P() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Nh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Hh = f;
    $b36288e2db101ba3$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Fh.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Oh : $b36288e2db101ba3$var$Ph;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Jh) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Jh = !1;
            $b36288e2db101ba3$var$Kh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Qh;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Jh);
    }
    $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Rh;
    b = null !== $b36288e2db101ba3$var$N && null !== $b36288e2db101ba3$var$N.next;
    $b36288e2db101ba3$var$Hh = 0;
    $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = $b36288e2db101ba3$var$M = null;
    $b36288e2db101ba3$var$Ih = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$Sh() {
    var a = 0 !== $b36288e2db101ba3$var$Kh;
    $b36288e2db101ba3$var$Kh = 0;
    return a;
}
function $b36288e2db101ba3$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState = $b36288e2db101ba3$var$O = a : $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$O.next = a;
    return $b36288e2db101ba3$var$O;
}
function $b36288e2db101ba3$var$Uh() {
    if (null === $b36288e2db101ba3$var$N) {
        var a = $b36288e2db101ba3$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$N.next;
    var b = null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState : $b36288e2db101ba3$var$O.next;
    if (null !== b) $b36288e2db101ba3$var$O = b, $b36288e2db101ba3$var$N = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$N = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$N.memoizedState,
            baseState: $b36288e2db101ba3$var$N.baseState,
            baseQueue: $b36288e2db101ba3$var$N.baseQueue,
            queue: $b36288e2db101ba3$var$N.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState = $b36288e2db101ba3$var$O = a : $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$O.next = a;
    }
    return $b36288e2db101ba3$var$O;
}
function $b36288e2db101ba3$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$Wh(a) {
    var b = $b36288e2db101ba3$var$Uh(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$M.lanes |= m;
                $b36288e2db101ba3$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$M.lanes |= f, $b36288e2db101ba3$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$Xh(a) {
    var b = $b36288e2db101ba3$var$Uh(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$Yh() {}
function $b36288e2db101ba3$var$Zh(a, b) {
    var c = $b36288e2db101ba3$var$M, d = $b36288e2db101ba3$var$Uh(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$dh = !0);
    d = d.queue;
    $b36288e2db101ba3$var$$h($b36288e2db101ba3$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$O && $b36288e2db101ba3$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$bi(9, $b36288e2db101ba3$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$Q) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Hh & 30) || $b36288e2db101ba3$var$di(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$ei(b) && $b36288e2db101ba3$var$fi(a);
}
function $b36288e2db101ba3$var$ai(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$ei(b) && $b36288e2db101ba3$var$fi(a);
    });
}
function $b36288e2db101ba3$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$ih(a, 1);
    null !== b && $b36288e2db101ba3$var$gi(b, a, 1, -1);
}
function $b36288e2db101ba3$var$hi(a) {
    var b = $b36288e2db101ba3$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ii.bind(null, $b36288e2db101ba3$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$ji() {
    return $b36288e2db101ba3$var$Uh().memoizedState;
}
function $b36288e2db101ba3$var$ki(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Th();
    $b36288e2db101ba3$var$M.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$N) {
        var g = $b36288e2db101ba3$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Mh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$bi(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$M.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$bi(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$mi(a, b) {
    return $b36288e2db101ba3$var$ki(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$$h(a, b) {
    return $b36288e2db101ba3$var$li(2048, 8, a, b);
}
function $b36288e2db101ba3$var$ni(a, b) {
    return $b36288e2db101ba3$var$li(4, 2, a, b);
}
function $b36288e2db101ba3$var$oi(a, b) {
    return $b36288e2db101ba3$var$li(4, 4, a, b);
}
function $b36288e2db101ba3$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$li(4, 4, $b36288e2db101ba3$var$pi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$ri() {}
function $b36288e2db101ba3$var$si(a, b) {
    var c = $b36288e2db101ba3$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$ti(a, b) {
    var c = $b36288e2db101ba3$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$ui(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Hh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$dh = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$M.lanes |= c, $b36288e2db101ba3$var$rh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$vi(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Gh.transition;
    $b36288e2db101ba3$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Gh.transition = d;
    }
}
function $b36288e2db101ba3$var$wi() {
    return $b36288e2db101ba3$var$Uh().memoizedState;
}
function $b36288e2db101ba3$var$xi(a, b, c) {
    var d = $b36288e2db101ba3$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$zi(a)) $b36288e2db101ba3$var$Ai(b, c);
    else if (c = $b36288e2db101ba3$var$hh(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$R();
        $b36288e2db101ba3$var$gi(c, a, d, e);
        $b36288e2db101ba3$var$Bi(c, b, d);
    }
}
function $b36288e2db101ba3$var$ii(a, b, c) {
    var d = $b36288e2db101ba3$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$zi(a)) $b36288e2db101ba3$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$hh(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$R(), $b36288e2db101ba3$var$gi(c, a, d, e), $b36288e2db101ba3$var$Bi(c, b, d));
    }
}
function $b36288e2db101ba3$var$zi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$M || null !== b && b === $b36288e2db101ba3$var$M;
}
function $b36288e2db101ba3$var$Ai(a, b) {
    $b36288e2db101ba3$var$Jh = $b36288e2db101ba3$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$Rh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$P,
    useContext: $b36288e2db101ba3$var$P,
    useEffect: $b36288e2db101ba3$var$P,
    useImperativeHandle: $b36288e2db101ba3$var$P,
    useInsertionEffect: $b36288e2db101ba3$var$P,
    useLayoutEffect: $b36288e2db101ba3$var$P,
    useMemo: $b36288e2db101ba3$var$P,
    useReducer: $b36288e2db101ba3$var$P,
    useRef: $b36288e2db101ba3$var$P,
    useState: $b36288e2db101ba3$var$P,
    useDebugValue: $b36288e2db101ba3$var$P,
    useDeferredValue: $b36288e2db101ba3$var$P,
    useTransition: $b36288e2db101ba3$var$P,
    useMutableSource: $b36288e2db101ba3$var$P,
    useSyncExternalStore: $b36288e2db101ba3$var$P,
    useId: $b36288e2db101ba3$var$P,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Oh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ki(4194308, 4, $b36288e2db101ba3$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$xi.bind(null, $b36288e2db101ba3$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$hi,
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$hi(!1), b = a[0];
        a = $b36288e2db101ba3$var$vi.bind(null, a[1]);
        $b36288e2db101ba3$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$M, e = $b36288e2db101ba3$var$Th();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$Q) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Hh & 30) || $b36288e2db101ba3$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$mi($b36288e2db101ba3$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$bi(9, $b36288e2db101ba3$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$Th(), b = $b36288e2db101ba3$var$Q.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Ph = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$si,
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$$h,
    useImperativeHandle: $b36288e2db101ba3$var$qi,
    useInsertionEffect: $b36288e2db101ba3$var$ni,
    useLayoutEffect: $b36288e2db101ba3$var$oi,
    useMemo: $b36288e2db101ba3$var$ti,
    useReducer: $b36288e2db101ba3$var$Wh,
    useRef: $b36288e2db101ba3$var$ji,
    useState: function() {
        return $b36288e2db101ba3$var$Wh($b36288e2db101ba3$var$Vh);
    },
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Uh();
        return $b36288e2db101ba3$var$ui(b, $b36288e2db101ba3$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Wh($b36288e2db101ba3$var$Vh)[0], b = $b36288e2db101ba3$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$Yh,
    useSyncExternalStore: $b36288e2db101ba3$var$Zh,
    useId: $b36288e2db101ba3$var$wi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Qh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$si,
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$$h,
    useImperativeHandle: $b36288e2db101ba3$var$qi,
    useInsertionEffect: $b36288e2db101ba3$var$ni,
    useLayoutEffect: $b36288e2db101ba3$var$oi,
    useMemo: $b36288e2db101ba3$var$ti,
    useReducer: $b36288e2db101ba3$var$Xh,
    useRef: $b36288e2db101ba3$var$ji,
    useState: function() {
        return $b36288e2db101ba3$var$Xh($b36288e2db101ba3$var$Vh);
    },
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Uh();
        return null === $b36288e2db101ba3$var$N ? b.memoizedState = a : $b36288e2db101ba3$var$ui(b, $b36288e2db101ba3$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Xh($b36288e2db101ba3$var$Vh)[0], b = $b36288e2db101ba3$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$Yh,
    useSyncExternalStore: $b36288e2db101ba3$var$Zh,
    useId: $b36288e2db101ba3$var$wi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $b36288e2db101ba3$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$R(), e = $b36288e2db101ba3$var$yi(a), f = $b36288e2db101ba3$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$nh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, e, d), $b36288e2db101ba3$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$R(), e = $b36288e2db101ba3$var$yi(a), f = $b36288e2db101ba3$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$nh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, e, d), $b36288e2db101ba3$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$R(), d = $b36288e2db101ba3$var$yi(a), e = $b36288e2db101ba3$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$nh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, d, c), $b36288e2db101ba3$var$oh(b, a, d));
    }
};
function $b36288e2db101ba3$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$eh(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $b36288e2db101ba3$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$eh(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$Ei.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Ni(a, b, c) {
    c = $b36288e2db101ba3$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Oi || ($b36288e2db101ba3$var$Oi = !0, $b36288e2db101ba3$var$Pi = d);
        $b36288e2db101ba3$var$Li(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Qi(a, b, c) {
    c = $b36288e2db101ba3$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Li(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Ri ? $b36288e2db101ba3$var$Ri = new Set([
            this
        ]) : $b36288e2db101ba3$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$mh(-1, 1), b.tag = 2, $b36288e2db101ba3$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Wi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$dh = !1;
function $b36288e2db101ba3$var$Xi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Vg(b, null, c, d) : $b36288e2db101ba3$var$Ug(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$ch(b, e);
    d = $b36288e2db101ba3$var$Nh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$Sh();
    if (null !== a && !$b36288e2db101ba3$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$Zi(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Xi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$bj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$dh = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$Zi(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$cj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj);
            $b36288e2db101ba3$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= d;
    $b36288e2db101ba3$var$Xi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$ch(b, e);
    c = $b36288e2db101ba3$var$Nh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$Sh();
    if (null !== a && !$b36288e2db101ba3$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$Zi(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Xi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$ch(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$ij(a, b), $b36288e2db101ba3$var$Gi(b, c, d), $b36288e2db101ba3$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$eh(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$Hi(b, g, d, l);
        $b36288e2db101ba3$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$jh ? ("function" === typeof m && ($b36288e2db101ba3$var$Di(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$jh || $b36288e2db101ba3$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$eh(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$Hi(b, g, d, k);
        $b36288e2db101ba3$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$jh ? ("function" === typeof y && ($b36288e2db101ba3$var$Di(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$jh || $b36288e2db101ba3$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$jj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$jj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$Zi(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Ug(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Ug(b, null, h, f)) : $b36288e2db101ba3$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$yh(a, b.containerInfo);
}
function $b36288e2db101ba3$var$lj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Xi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$oj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$pj(g, d, 0, null), a = $b36288e2db101ba3$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$nj(c), b.memoizedState = $b36288e2db101ba3$var$mj, a) : $b36288e2db101ba3$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$Pg(h, f) : (f = $b36288e2db101ba3$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$qj(a, b) {
    b = $b36288e2db101ba3$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$sj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Ug(b, a.child, null, c);
    a = $b36288e2db101ba3$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$nj(g);
        b.memoizedState = $b36288e2db101ba3$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Ki(f, d, void 0);
        return $b36288e2db101ba3$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$dh || h) {
        d = $b36288e2db101ba3$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$ih(a, e), $b36288e2db101ba3$var$gi(d, a, e, -1));
        }
        $b36288e2db101ba3$var$tj();
        d = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$bh(a.return, b, c);
}
function $b36288e2db101ba3$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Xi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$vj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$kj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Ah(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$oj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1);
                a = $b36288e2db101ba3$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$dj(a, b, c);
    }
    return $b36288e2db101ba3$var$Zi(a, b, c);
}
var $b36288e2db101ba3$var$zj, $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj;
$b36288e2db101ba3$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Aj = function() {};
$b36288e2db101ba3$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Dj(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$zh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Fj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Aj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Bh(b);
            var e = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
                $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Fj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$L.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$zh(), $b36288e2db101ba3$var$Aj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$ah(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Dj(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Gj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$L.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$fj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Ij(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$zh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Bh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L), null;
        case 4:
            return $b36288e2db101ba3$var$zh(), null;
        case 10:
            return $b36288e2db101ba3$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Jj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Nj = !1;
function $b36288e2db101ba3$var$Oj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Nj;
    $b36288e2db101ba3$var$Nj = !1;
    return n;
}
function $b36288e2db101ba3$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Vj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Vj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Xj = !1;
function $b36288e2db101ba3$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$Zj(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$Zj(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Lj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Xj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Xj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Xj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Xj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Xj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Xj = !0;
            $b36288e2db101ba3$var$Yj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Mj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Yj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Yj(a, b, c);
    }
}
function $b36288e2db101ba3$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Kj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Xj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Xj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$Zj(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$dk(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Pj(3, a, a.return), $b36288e2db101ba3$var$Qj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Pj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Lj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            break;
        case 13:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$fk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$ck(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 4 && $b36288e2db101ba3$var$ak(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$ck(b, a), $b36288e2db101ba3$var$ek(a);
    }
}
function $b36288e2db101ba3$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Uj(a);
                    $b36288e2db101ba3$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Uj(a);
                    $b36288e2db101ba3$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$hk(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$ik(a, b, c);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Jj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Jj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$jk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$jk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$ik(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Jj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$kk(a, b, c);
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Rj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$gk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$jk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Qj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$lk = Math.ceil, $b36288e2db101ba3$var$mk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$fj = 0, $b36288e2db101ba3$var$ej = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$pk = null, $b36288e2db101ba3$var$rh = 0, $b36288e2db101ba3$var$qk = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = null, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$fk = 0, $b36288e2db101ba3$var$Gj = Infinity, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Oi = !1, $b36288e2db101ba3$var$Pi = null, $b36288e2db101ba3$var$Ri = null, $b36288e2db101ba3$var$vk = !1, $b36288e2db101ba3$var$wk = null, $b36288e2db101ba3$var$xk = 0, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = null, $b36288e2db101ba3$var$Ak = -1, $b36288e2db101ba3$var$Bk = 0;
function $b36288e2db101ba3$var$R() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$Ak : $b36288e2db101ba3$var$Ak = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Bk && ($b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Bk;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$gi(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$yk) throw $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$Q) a === $b36288e2db101ba3$var$Q && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$qk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Ck(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Dk(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Dk(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$Q ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Ek.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Ek.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Fk(c, $b36288e2db101ba3$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Gk(a, b) {
    $b36288e2db101ba3$var$Ak = -1;
    $b36288e2db101ba3$var$Bk = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Hk() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$Q ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Ik(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Jk();
        if ($b36288e2db101ba3$var$Q !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Kk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Lk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Mk(a, h);
        }
        $b36288e2db101ba3$var$$g();
        $b36288e2db101ba3$var$mk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Nk(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, d), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Ok(e) && (b = $b36288e2db101ba3$var$Ik(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Nk(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, d), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$fk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Pk.bind(null, a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Pk.bind(null, a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Gk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    var c = $b36288e2db101ba3$var$sk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Kk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Ik(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$tk = c, null !== b && $b36288e2db101ba3$var$Fj(b));
    return a;
}
function $b36288e2db101ba3$var$Fj(a) {
    null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = a : $b36288e2db101ba3$var$tk.push.apply($b36288e2db101ba3$var$tk, a);
}
function $b36288e2db101ba3$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Ck(a, b) {
    b &= ~$b36288e2db101ba3$var$rk;
    b &= ~$b36288e2db101ba3$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Ek(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Hk();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Nk(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, b), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Qk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Rk(a) {
    null !== $b36288e2db101ba3$var$wk && 0 === $b36288e2db101ba3$var$wk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Hk();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$ok.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$ok.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$ok.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Hj() {
    $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$ej.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$ej);
}
function $b36288e2db101ba3$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$zh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Eh();
                break;
            case 5:
                $b36288e2db101ba3$var$Bh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$zh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
                break;
            case 10:
                $b36288e2db101ba3$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Hj();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$Q = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$Pg(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$fj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$pk = null;
    $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$qk = $b36288e2db101ba3$var$rh = 0;
    $b36288e2db101ba3$var$tk = $b36288e2db101ba3$var$sk = null;
    if (null !== $b36288e2db101ba3$var$fh) {
        for(b = 0; b < $b36288e2db101ba3$var$fh.length; b++)if (c = $b36288e2db101ba3$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$fh = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Mk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$$g();
            $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Rh;
            if ($b36288e2db101ba3$var$Ih) {
                for(var d = $b36288e2db101ba3$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Ih = !1;
            }
            $b36288e2db101ba3$var$Hh = 0;
            $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = $b36288e2db101ba3$var$M = null;
            $b36288e2db101ba3$var$Jh = !1;
            $b36288e2db101ba3$var$Kh = 0;
            $b36288e2db101ba3$var$nk.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$pk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Si(f, l, b);
                            $b36288e2db101ba3$var$tj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Vi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ji(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$sk ? $b36288e2db101ba3$var$sk = [
                    f
                ] : $b36288e2db101ba3$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Ni(f, k, b);
                            $b36288e2db101ba3$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Ri || !$b36288e2db101ba3$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Qi(f, h, b);
                                $b36288e2db101ba3$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Sk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Jk() {
    var a = $b36288e2db101ba3$var$mk.current;
    $b36288e2db101ba3$var$mk.current = $b36288e2db101ba3$var$Rh;
    return null === a ? $b36288e2db101ba3$var$Rh : a;
}
function $b36288e2db101ba3$var$tj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$Q || 0 === ($b36288e2db101ba3$var$rh & 268435455) && 0 === ($b36288e2db101ba3$var$qk & 268435455) || $b36288e2db101ba3$var$Ck($b36288e2db101ba3$var$Q, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Ik(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Jk();
    if ($b36288e2db101ba3$var$Q !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Kk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Tk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Mk(a, e);
    }
    $b36288e2db101ba3$var$$g();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$mk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$Q = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Tk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Uk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Lk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Uk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Uk(a) {
    var b = $b36288e2db101ba3$var$Vk(a.alternate, a, $b36288e2db101ba3$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Sk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$nk.current = null;
}
function $b36288e2db101ba3$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Ej(c, b, $b36288e2db101ba3$var$fj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Pk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$ok.transition;
    try {
        $b36288e2db101ba3$var$ok.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Wk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$ok.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Wk(a, b, c, d) {
    do $b36288e2db101ba3$var$Hk();
    while (null !== $b36288e2db101ba3$var$wk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$Q && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$vk || ($b36288e2db101ba3$var$vk = !0, $b36288e2db101ba3$var$Fk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$ok.transition;
        $b36288e2db101ba3$var$ok.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$nk.current = null;
        $b36288e2db101ba3$var$Oj(a, c);
        $b36288e2db101ba3$var$dk(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$hk(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$ok.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$vk && ($b36288e2db101ba3$var$vk = !1, $b36288e2db101ba3$var$wk = a, $b36288e2db101ba3$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Ri = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Oi) throw $b36288e2db101ba3$var$Oi = !1, a = $b36288e2db101ba3$var$Pi, $b36288e2db101ba3$var$Pi = null, a;
    0 !== ($b36288e2db101ba3$var$xk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$zk ? $b36288e2db101ba3$var$yk++ : ($b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = a) : $b36288e2db101ba3$var$yk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Hk() {
    if (null !== $b36288e2db101ba3$var$wk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$xk), b = $b36288e2db101ba3$var$ok.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$ok.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$wk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$wk;
                $b36288e2db101ba3$var$wk = null;
                $b36288e2db101ba3$var$xk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Sj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Qj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$ok.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Xk(a, b, c) {
    b = $b36288e2db101ba3$var$Ji(c, b);
    b = $b36288e2db101ba3$var$Ni(a, b, 1);
    a = $b36288e2db101ba3$var$nh(a, b, 1);
    b = $b36288e2db101ba3$var$R();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Dk(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Ri || !$b36288e2db101ba3$var$Ri.has(d))) {
                a = $b36288e2db101ba3$var$Ji(c, a);
                a = $b36288e2db101ba3$var$Qi(b, a, 1);
                b = $b36288e2db101ba3$var$nh(b, a, 1);
                a = $b36288e2db101ba3$var$R();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$Q === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$fk ? $b36288e2db101ba3$var$Kk(a, 0) : $b36288e2db101ba3$var$rk |= c);
    $b36288e2db101ba3$var$Dk(a, b);
}
function $b36288e2db101ba3$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$R();
    a = $b36288e2db101ba3$var$ih(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Dk(a, c));
}
function $b36288e2db101ba3$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Yk(a, c);
}
function $b36288e2db101ba3$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Yk(a, c);
}
var $b36288e2db101ba3$var$Vk;
$b36288e2db101ba3$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$dh = !1, $b36288e2db101ba3$var$yj(a, b, c);
            $b36288e2db101ba3$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$dh = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$ij(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$ch(b, c);
            e = $b36288e2db101ba3$var$Nh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$kh(b), e.updater = $b36288e2db101ba3$var$Ei, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$Ii(b, d, a, c), b = $b36288e2db101ba3$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$Zk(d);
                a = $b36288e2db101ba3$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$$i(null, b, d, $b36288e2db101ba3$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$kj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$lh(a, b);
                $b36288e2db101ba3$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ji(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ji(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$lj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$Zi(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Ah(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$gj(a, b), $b36288e2db101ba3$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$oj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Ug(b, null, d, c) : $b36288e2db101ba3$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$Yi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$ch(b, c), e = $b36288e2db101ba3$var$eh(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Ci(d, b.pendingProps), e = $b36288e2db101ba3$var$Ci(d.type, e), $b36288e2db101ba3$var$$i(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$ij(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$ch(b, c), $b36288e2db101ba3$var$Gi(b, d, e), $b36288e2db101ba3$var$Ii(b, d, e, c), $b36288e2db101ba3$var$jj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$xj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$dj(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Fk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$$k(a, b, c, d);
}
function $b36288e2db101ba3$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$Zk(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Tg(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Tg(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$pj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$Qg(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$kh(f);
    return a;
}
function $b36288e2db101ba3$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$dl(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$el(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$dl(null);
    c = a.current;
    d = $b36288e2db101ba3$var$R();
    e = $b36288e2db101ba3$var$yi(c);
    f = $b36288e2db101ba3$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$nh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Dk(a, d);
    return a;
}
function $b36288e2db101ba3$var$fl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$R(), g = $b36288e2db101ba3$var$yi(e);
    c = $b36288e2db101ba3$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$nh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$gi(a, e, g, f), $b36288e2db101ba3$var$oh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    $b36288e2db101ba3$var$hl(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$hl(a, b);
}
function $b36288e2db101ba3$var$jl() {
    return null;
}
var $b36288e2db101ba3$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ll(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$ml.prototype.render = $b36288e2db101ba3$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$fl(a, b, null, null);
};
$b36288e2db101ba3$var$ml.prototype.unmount = $b36288e2db101ba3$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Rk(function() {
            $b36288e2db101ba3$var$fl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$pl() {}
function $b36288e2db101ba3$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$gl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$el(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$pl);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$gl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$bl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$pl);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Rk(function() {
        $b36288e2db101ba3$var$fl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$gl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$fl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$ql(c, b, a, e, d);
    return $b36288e2db101ba3$var$gl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Dk(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Rk(function() {
                var b = $b36288e2db101ba3$var$ih(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$R();
                    $b36288e2db101ba3$var$gi(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$il(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$ih(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$R();
            $b36288e2db101ba3$var$gi(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$il(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$yi(a), c = $b36288e2db101ba3$var$ih(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$R();
            $b36288e2db101ba3$var$gi(c, a, b, d);
        }
        $b36288e2db101ba3$var$il(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Qk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Rk;
var $b36288e2db101ba3$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Qk
    ]
}, $b36288e2db101ba3$var$tl = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$ul = {
    bundleType: $b36288e2db101ba3$var$tl.bundleType,
    version: $b36288e2db101ba3$var$tl.version,
    rendererPackageName: $b36288e2db101ba3$var$tl.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$tl.findFiberByHostInstance || $b36288e2db101ba3$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$vl.isDisabled && $b36288e2db101ba3$var$vl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$vl.inject($b36288e2db101ba3$var$ul), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$vl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$sl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$nl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$cl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$nl(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ll(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Rk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$rl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$nl(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$rl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Rk(function() {
        $b36288e2db101ba3$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Qk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$ol(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$rl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("4LCdk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8BKFp"));

});
parcelRegister("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
"use strict";
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});



parcelRegister("kEUo3", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("eCfBx", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa40b802dd2fccfc$var$ReactIs, $aa40b802dd2fccfc$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("2tbKl"))();

});
parcelRegister("2tbKl", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $c3YnH = parcelRequire("c3YnH");
function $1cc766ccf0672393$var$emptyFunction() {}
function $1cc766ccf0672393$var$emptyFunctionWithReset() {}
$1cc766ccf0672393$var$emptyFunctionWithReset.resetWarningCache = $1cc766ccf0672393$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $c3YnH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $1cc766ccf0672393$var$emptyFunctionWithReset,
        resetWarningCache: $1cc766ccf0672393$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("c3YnH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $8c849a51633fc8b0$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $8c849a51633fc8b0$var$ReactPropTypesSecret;

});



parcelRegister("cxTnx", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

var $d4dab640dcbe486c$exports = {};
"use strict";

$d4dab640dcbe486c$exports = (parcelRequire("0qhf8"));


parcelRequire("bh6RR");
var $6fc264ec92100d3a$exports = {};

$parcel$export($6fc264ec92100d3a$exports, "createRoot", function () { return $6fc264ec92100d3a$export$882461b6382ed46c; }, function (v) { return $6fc264ec92100d3a$export$882461b6382ed46c = v; });
$parcel$export($6fc264ec92100d3a$exports, "hydrateRoot", function () { return $6fc264ec92100d3a$export$757ceba2d55c277e; }, function (v) { return $6fc264ec92100d3a$export$757ceba2d55c277e = v; });
var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
"use strict";
var $47cfd4084854a574$exports = {};
"use strict";
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

$47cfd4084854a574$exports = (parcelRequire("foRq4"));


var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $47cfd4084854a574$exports.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $47cfd4084854a574$exports.hydrateRoot;








var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
const $24b0690cf0996c45$var$encodeQueryData = (obj)=>Object.entries(obj).map(([key, val])=>val ? `${key}=${val}` : "").join("&");
var $24b0690cf0996c45$export$2e2bcd8739ae039 = $24b0690cf0996c45$var$encodeQueryData;




var $bh6RR = parcelRequire("bh6RR");
function $f1997b3013235ba8$var$toastReducer(state, action) {
    switch(action.type){
        case "addToast":
            return {
                ...state,
                toasts: [
                    ...state.toasts,
                    action.payload.toast
                ]
            };
        case "updateToast":
            return {
                ...state,
                toasts: [
                    ...state.toasts.map((toast)=>toast.id == action.payload.id ? action.payload : toast)
                ]
            };
        case "deleteToast":
            return {
                ...state,
                toasts: [
                    ...state.toasts.filter((toast)=>toast.id != action.payload.id)
                ]
            };
        default:
            throw new Error("unhandled action");
    }
}
var $f1997b3013235ba8$export$2e2bcd8739ae039 = $f1997b3013235ba8$var$toastReducer;


const $ef906e3366032645$var$toastDuration = 3000;
var $ef906e3366032645$export$2e2bcd8739ae039 = $ef906e3366032645$var$toastDuration;


function $5a5eecf94aeed79d$var$setupToast(dispatch, type, title, message, duration = (0, $ef906e3366032645$export$2e2bcd8739ae039), deleteTime) {
    const id = Math.random().toString(36).substr(2, 9);
    deleteTime = deleteTime != undefined ? deleteTime : duration;
    const toast = {
        type: type,
        message: message,
        id: id,
        title: title,
        duration: duration,
        deleteTime: deleteTime
    };
    dispatch({
        type: "addToast",
        payload: {
            toast: toast
        }
    });
    if (deleteTime != 0) setTimeout(()=>{
        dispatch({
            type: "deleteToast",
            payload: {
                id: id
            }
        });
    }, deleteTime);
    return toast;
}
var $5a5eecf94aeed79d$export$2e2bcd8739ae039 = $5a5eecf94aeed79d$var$setupToast;


const $8a53d819e82d540b$var$ToastStateContext = /*#__PURE__*/ (0, $bh6RR.createContext)({
    toasts: []
});
const $8a53d819e82d540b$var$ToastDispatchContext = /*#__PURE__*/ (0, $bh6RR.createContext)(null);
function $8a53d819e82d540b$var$ToastContextProvider({ children: children }) {
    const [state, dispatch] = (0, $bh6RR.useReducer)((0, $f1997b3013235ba8$export$2e2bcd8739ae039), {
        toasts: []
    });
    const toast = {
        dispatch: dispatch,
        error: (title, element, duration, deleteTime)=>(0, $5a5eecf94aeed79d$export$2e2bcd8739ae039)(dispatch, "error", title, element, duration, deleteTime),
        success: (title, element, duration, deleteTime)=>(0, $5a5eecf94aeed79d$export$2e2bcd8739ae039)(dispatch, "success", title, element, duration, deleteTime),
        info: (title, element, duration, deleteTime)=>(0, $5a5eecf94aeed79d$export$2e2bcd8739ae039)(dispatch, "info", title, element, duration, deleteTime),
        warning: (title, element, duration, deleteTime)=>(0, $5a5eecf94aeed79d$export$2e2bcd8739ae039)(dispatch, "warning", title, element, duration, deleteTime)
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($8a53d819e82d540b$var$ToastStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($8a53d819e82d540b$var$ToastDispatchContext.Provider, {
            value: toast,
            children: children
        })
    });
}
var $8a53d819e82d540b$export$2e2bcd8739ae039 = $8a53d819e82d540b$var$ToastContextProvider;
const $8a53d819e82d540b$export$d2fbf2d5ee3dcf9e = ()=>(0, $bh6RR.useContext)($8a53d819e82d540b$var$ToastStateContext);
const $8a53d819e82d540b$export$ad0b1cd0425e5c95 = ()=>(0, $bh6RR.useContext)($8a53d819e82d540b$var$ToastDispatchContext);


const $878480337414c3a8$var$usePagination = (apiServiceCall = ()=>{}, filterPostRequest, [refreshTable, setRefreshTable], filterValues, withPagination, defaultSort)=>{
    const [data, setData] = (0, $bh6RR.useState)([]);
    const [totalNbData, setTotalNbData] = (0, $bh6RR.useState)(0);
    const [param, setParam] = (0, $bh6RR.useState)({
        page: 1,
        filters: filterValues ?? {}
    });
    const [fetching, setFetching] = (0, $bh6RR.useState)(false);
    const [isSorted, setIsSorted] = (0, $bh6RR.useState)(defaultSort || {
        column: "",
        val: false
    });
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const fetchData = async (addingMode = true)=>{
        const { page: page, filters: filters } = param;
        setFetching(true);
        var [response, error] = await apiServiceCall({
            ...withPagination ? {
                page: page
            } : {},
            ...filters
        });
        if (error) {
            toast.error("Error Fetch", "Unable to reach data, see network section for more info");
            return;
        }
        if (withPagination == false) response = {
            data: response,
            total: response.length
        };
        var { data: rawData } = response;
        rawData = rawData.filter(filterPostRequest);
        if (response.meta) {
            response = {
                ...response,
                ...response.meta
            };
            delete response.meta;
        }
        setTotalNbData(response.total - (response.data.length - rawData.length));
        let finalData = [];
        finalData = param.page == 1 ? rawData : addingMode ? [
            ...data,
            ...rawData
        ] : [
            ...data
        ];
        if (isSorted.column != "") actualiseSortAsc(finalData);
        else setData(finalData);
        setFetching(false);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (fetching == true) return;
        fetchData();
    }, [
        apiServiceCall,
        param.page,
        param.filters
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (fetching == true) return;
        fetchData(false);
        if (refreshTable && setRefreshTable) setRefreshTable(false);
    }, [
        refreshTable
    ]);
    const addPage = ()=>{
        if (fetching == true) return;
        setParam({
            ...param,
            page: param.page + 1
        });
    };
    const setFilter = (filter)=>{
        const filters = {
            ...param.filters,
            ...filter
        };
        setParam({
            page: 1,
            filters: filters
        });
    };
    const setFiltersAll = (filter)=>{
        const filters = {
            ...filter
        };
        setParam({
            page: 1,
            filters: filters
        });
    };
    const getIndex = (id)=>data.findIndex((row)=>row.id == id);
    const getRowByIndex = (id)=>{
        let index = getIndex(id) != null;
        return index == null ? null : data[index];
    };
    const deleteRow = (id, label = "id")=>{
        setTotalNbData(totalNbData - 1);
        setData(data.filter((row)=>row[label] != id));
    };
    const addRow = (row)=>setData([
            row,
            ...data
        ]);
    const updateRow = (value)=>{
        setData(data.map((row)=>row.id == value.id ? {
                ...value
            } : row));
    };
    const sortData = (result)=>{
        setData(result.map((row)=>row));
    };
    const compareValues = (valueA, valueB)=>{
        // Gérer les valeurs nulles
        if (valueA === null && valueB === null) return 0;
        else if (valueA === null) return 1;
        else if (valueB === null) return -1;
        // Essayer de parser les dates
        const dateA = new Date(valueA);
        const dateB = new Date(valueB);
        if (!isNaN(dateA) && !isNaN(dateB)) // Les deux sont des dates valides
        return dateA - dateB;
        // Si les deux sont des nombres
        if (!isNaN(valueA) && !isNaN(valueB)) return valueA - valueB;
        // Comparer en tant que chaînes de caractères
        return String(valueA).localeCompare(String(valueB));
    };
    const actualiseSortAsc = (data)=>{
        let name = isSorted.column;
        if (name === "" || data == null || data.length === 0) return;
        // Recherche de la première valeur non null sur laquelle baser le tri
        let firstNonNullValueIndex = data.findIndex((item)=>getObjectValueWithStringPropertyName(item, name) !== null);
        // Si aucune valeur non null n'est trouvée, retourner
        if (firstNonNullValueIndex === -1) return;
        let result = data.sort((a, b)=>{
            let valueA = getObjectValueWithStringPropertyName(isSorted.val ? a : b, name);
            let valueB = getObjectValueWithStringPropertyName(isSorted.val ? b : a, name);
            return compareValues(valueA, valueB);
        });
        sortData(result);
    };
    const getObjectValueWithStringPropertyName = (item, nameProperties)=>{
        let result = item;
        let hashProperties = nameProperties.split(".");
        for(let i = 0; i < hashProperties.length; i++){
            if (result == null) continue;
            result = result[hashProperties[i]];
        }
        return result;
    };
    (0, $bh6RR.useEffect)(()=>{
        actualiseSortAsc(data);
    }, [
        isSorted
    ]);
    return [
        data,
        totalNbData,
        {
            addPage: addPage,
            setFilter: setFilter,
            setFiltersAll: setFiltersAll
        },
        {
            getIndex: getIndex,
            getRowByIndex: getRowByIndex,
            deleteRow: deleteRow,
            addRow: addRow,
            updateRow: updateRow
        },
        fetching,
        isSorted,
        setIsSorted
    ];
};
var $878480337414c3a8$export$2e2bcd8739ae039 = $878480337414c3a8$var$usePagination;


function $c250361150c8f4e2$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $c250361150c8f4e2$export$2e2bcd8739ae039 = $c250361150c8f4e2$var$capitalizeFirstLetter;



parcelRequire("bh6RR");
function $b1d9e4da4611e18b$var$isHtml(string) {
    return /<\/?[a-z][\s\S]*>/i.test(string);
}
var $b1d9e4da4611e18b$export$2e2bcd8739ae039 = $b1d9e4da4611e18b$var$isHtml;



parcelRequire("kEUo3");
function $cbf58a06f6fccf5a$var$objectResolve(path, obj) {
    return path.split(".").reduce(function(prev, curr) {
        return prev ? prev[curr] : null;
    }, obj || self);
}
var $cbf58a06f6fccf5a$export$2e2bcd8739ae039 = $cbf58a06f6fccf5a$var$objectResolve;


var $726d757834788151$exports = {};
/*! @license DOMPurify 3.3.2 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.3.2/LICENSE */ (function(global, factory) {
    $726d757834788151$exports = factory();
})($726d757834788151$exports, function() {
    "use strict";
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== "undefined" && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(func, thisArg) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return func.apply(thisArg, args);
    };
    if (!construct) construct = function construct(Func) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySplice = unapply(Array.prototype.splice);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(Func) {
        return function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return construct(Func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === "string") {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === "object" && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === "function") return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        "a",
        "abbr",
        "acronym",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "bdi",
        "bdo",
        "big",
        "blink",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "content",
        "data",
        "datalist",
        "dd",
        "decorator",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "element",
        "em",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meter",
        "nav",
        "nobr",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "search",
        "section",
        "select",
        "shadow",
        "slot",
        "small",
        "source",
        "spacer",
        "span",
        "strike",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr"
    ]);
    const svg$1 = freeze([
        "svg",
        "a",
        "altglyph",
        "altglyphdef",
        "altglyphitem",
        "animatecolor",
        "animatemotion",
        "animatetransform",
        "circle",
        "clippath",
        "defs",
        "desc",
        "ellipse",
        "enterkeyhint",
        "exportparts",
        "filter",
        "font",
        "g",
        "glyph",
        "glyphref",
        "hkern",
        "image",
        "inputmode",
        "line",
        "lineargradient",
        "marker",
        "mask",
        "metadata",
        "mpath",
        "part",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "radialgradient",
        "rect",
        "stop",
        "style",
        "switch",
        "symbol",
        "text",
        "textpath",
        "title",
        "tref",
        "tspan",
        "view",
        "vkern"
    ]);
    const svgFilters = freeze([
        "feBlend",
        "feColorMatrix",
        "feComponentTransfer",
        "feComposite",
        "feConvolveMatrix",
        "feDiffuseLighting",
        "feDisplacementMap",
        "feDistantLight",
        "feDropShadow",
        "feFlood",
        "feFuncA",
        "feFuncB",
        "feFuncG",
        "feFuncR",
        "feGaussianBlur",
        "feImage",
        "feMerge",
        "feMergeNode",
        "feMorphology",
        "feOffset",
        "fePointLight",
        "feSpecularLighting",
        "feSpotLight",
        "feTile",
        "feTurbulence"
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        "animate",
        "color-profile",
        "cursor",
        "discard",
        "font-face",
        "font-face-format",
        "font-face-name",
        "font-face-src",
        "font-face-uri",
        "foreignobject",
        "hatch",
        "hatchpath",
        "mesh",
        "meshgradient",
        "meshpatch",
        "meshrow",
        "missing-glyph",
        "script",
        "set",
        "solidcolor",
        "unknown",
        "use"
    ]);
    const mathMl$1 = freeze([
        "math",
        "menclose",
        "merror",
        "mfenced",
        "mfrac",
        "mglyph",
        "mi",
        "mlabeledtr",
        "mmultiscripts",
        "mn",
        "mo",
        "mover",
        "mpadded",
        "mphantom",
        "mroot",
        "mrow",
        "ms",
        "mspace",
        "msqrt",
        "mstyle",
        "msub",
        "msup",
        "msubsup",
        "mtable",
        "mtd",
        "mtext",
        "mtr",
        "munder",
        "munderover",
        "mprescripts"
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        "maction",
        "maligngroup",
        "malignmark",
        "mlongdiv",
        "mscarries",
        "mscarry",
        "msgroup",
        "mstack",
        "msline",
        "msrow",
        "semantics",
        "annotation",
        "annotation-xml",
        "mprescripts",
        "none"
    ]);
    const text = freeze([
        "#text"
    ]);
    const html = freeze([
        "accept",
        "action",
        "align",
        "alt",
        "autocapitalize",
        "autocomplete",
        "autopictureinpicture",
        "autoplay",
        "background",
        "bgcolor",
        "border",
        "capture",
        "cellpadding",
        "cellspacing",
        "checked",
        "cite",
        "class",
        "clear",
        "color",
        "cols",
        "colspan",
        "controls",
        "controlslist",
        "coords",
        "crossorigin",
        "datetime",
        "decoding",
        "default",
        "dir",
        "disabled",
        "disablepictureinpicture",
        "disableremoteplayback",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "exportparts",
        "face",
        "for",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "id",
        "inert",
        "inputmode",
        "integrity",
        "ismap",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "loop",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "multiple",
        "muted",
        "name",
        "nonce",
        "noshade",
        "novalidate",
        "nowrap",
        "open",
        "optimum",
        "part",
        "pattern",
        "placeholder",
        "playsinline",
        "popover",
        "popovertarget",
        "popovertargetaction",
        "poster",
        "preload",
        "pubdate",
        "radiogroup",
        "readonly",
        "rel",
        "required",
        "rev",
        "reversed",
        "role",
        "rows",
        "rowspan",
        "spellcheck",
        "scope",
        "selected",
        "shape",
        "size",
        "sizes",
        "slot",
        "span",
        "srclang",
        "start",
        "src",
        "srcset",
        "step",
        "style",
        "summary",
        "tabindex",
        "title",
        "translate",
        "type",
        "usemap",
        "valign",
        "value",
        "width",
        "wrap",
        "xmlns",
        "slot"
    ]);
    const svg = freeze([
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "amplitude",
        "ascent",
        "attributename",
        "attributetype",
        "azimuth",
        "basefrequency",
        "baseline-shift",
        "begin",
        "bias",
        "by",
        "class",
        "clip",
        "clippathunits",
        "clip-path",
        "clip-rule",
        "color",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "cx",
        "cy",
        "d",
        "dx",
        "dy",
        "diffuseconstant",
        "direction",
        "display",
        "divisor",
        "dur",
        "edgemode",
        "elevation",
        "end",
        "exponent",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterunits",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyphref",
        "gradientunits",
        "gradienttransform",
        "height",
        "href",
        "id",
        "image-rendering",
        "in",
        "in2",
        "intercept",
        "k",
        "k1",
        "k2",
        "k3",
        "k4",
        "kerning",
        "keypoints",
        "keysplines",
        "keytimes",
        "lang",
        "lengthadjust",
        "letter-spacing",
        "kernelmatrix",
        "kernelunitlength",
        "lighting-color",
        "local",
        "marker-end",
        "marker-mid",
        "marker-start",
        "markerheight",
        "markerunits",
        "markerwidth",
        "maskcontentunits",
        "maskunits",
        "max",
        "mask",
        "mask-type",
        "media",
        "method",
        "mode",
        "min",
        "name",
        "numoctaves",
        "offset",
        "operator",
        "opacity",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "paint-order",
        "path",
        "pathlength",
        "patterncontentunits",
        "patterntransform",
        "patternunits",
        "points",
        "preservealpha",
        "preserveaspectratio",
        "primitiveunits",
        "r",
        "rx",
        "ry",
        "radius",
        "refx",
        "refy",
        "repeatcount",
        "repeatdur",
        "restart",
        "result",
        "rotate",
        "scale",
        "seed",
        "shape-rendering",
        "slope",
        "specularconstant",
        "specularexponent",
        "spreadmethod",
        "startoffset",
        "stddeviation",
        "stitchtiles",
        "stop-color",
        "stop-opacity",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke",
        "stroke-width",
        "style",
        "surfacescale",
        "systemlanguage",
        "tabindex",
        "tablevalues",
        "targetx",
        "targety",
        "transform",
        "transform-origin",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "textlength",
        "type",
        "u1",
        "u2",
        "unicode",
        "values",
        "viewbox",
        "visibility",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "width",
        "word-spacing",
        "wrap",
        "writing-mode",
        "xchannelselector",
        "ychannelselector",
        "x",
        "x1",
        "x2",
        "xmlns",
        "y",
        "y1",
        "y2",
        "z",
        "zoomandpan"
    ]);
    const mathMl = freeze([
        "accent",
        "accentunder",
        "align",
        "bevelled",
        "close",
        "columnsalign",
        "columnlines",
        "columnspan",
        "denomalign",
        "depth",
        "dir",
        "display",
        "displaystyle",
        "encoding",
        "fence",
        "frame",
        "height",
        "href",
        "id",
        "largeop",
        "length",
        "linethickness",
        "lspace",
        "lquote",
        "mathbackground",
        "mathcolor",
        "mathsize",
        "mathvariant",
        "maxsize",
        "minsize",
        "movablelimits",
        "notation",
        "numalign",
        "open",
        "rowalign",
        "rowlines",
        "rowspacing",
        "rowspan",
        "rspace",
        "rquote",
        "scriptlevel",
        "scriptminsize",
        "scriptsizemultiplier",
        "selection",
        "separator",
        "separators",
        "stretchy",
        "subscriptshift",
        "supscriptshift",
        "symmetric",
        "voffset",
        "width",
        "xmlns"
    ]);
    const xml = freeze([
        "xlink:href",
        "xml:id",
        "xlink:title",
        "xml:space",
        "xmlns:xlink"
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        ARIA_ATTR: ARIA_ATTR,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT,
        DATA_ATTR: DATA_ATTR,
        DOCTYPE_NAME: DOCTYPE_NAME,
        ERB_EXPR: ERB_EXPR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR
    });
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === "undefined" ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = "data-tt-policy-suffix";
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = "dompurify" + (suffix ? "#" + suffix : "");
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn("TrustedTypes policy " + policyName + " could not be created.");
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = "3.3.2";
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, "cloneNode");
        const remove = lookupGetter(ElementPrototype, "remove");
        const getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
        const getChildNodes = lookupGetter(ElementPrototype, "childNodes");
        const getParentNode = lookupGetter(ElementPrototype, "parentNode");
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === "function") {
            const template = document.createElement("template");
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = "";
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === "function" && typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
            tagCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            }
        }));
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            "annotation-xml",
            "audio",
            "colgroup",
            "desc",
            "foreignobject",
            "head",
            "iframe",
            "math",
            "mi",
            "mn",
            "mo",
            "ms",
            "mtext",
            "noembed",
            "noframes",
            "noscript",
            "plaintext",
            "script",
            "style",
            "svg",
            "template",
            "thead",
            "title",
            "video",
            "xmp"
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            "audio",
            "video",
            "img",
            "source",
            "image",
            "track"
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            "alt",
            "class",
            "for",
            "id",
            "label",
            "name",
            "pattern",
            "placeholder",
            "role",
            "summary",
            "title",
            "value",
            "style",
            "xmlns"
        ]);
        const MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
        const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
        const HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            "mi",
            "mo",
            "mn",
            "ms",
            "mtext"
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, [
            "annotation-xml"
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            "title",
            "style",
            "font",
            "a",
            "script"
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            "application/xhtml+xml",
            "text/html"
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = "text/html";
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement("form");
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== "object") cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, "ALLOWED_TAGS") ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, "ALLOWED_ATTR") ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, "ALLOWED_NAMESPACES") ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, "ADD_URI_SAFE_ATTR") ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, "ADD_DATA_URI_TAGS") ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, "FORBID_CONTENTS") ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, "FORBID_TAGS") ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : clone({});
            FORBID_ATTR = objectHasOwnProperty(cfg, "FORBID_ATTR") ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : clone({});
            USE_PROFILES = objectHasOwnProperty(cfg, "USE_PROFILES") ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
            HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === "boolean") CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = create(null);
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Prevent function-based ADD_ATTR / ADD_TAGS from leaking across calls */ if (!objectHasOwnProperty(cfg, "ADD_TAGS")) EXTRA_ELEMENT_HANDLING.tagCheck = null;
            if (!objectHasOwnProperty(cfg, "ADD_ATTR")) EXTRA_ELEMENT_HANDLING.attributeCheck = null;
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (typeof cfg.ADD_TAGS === "function") EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
                else {
                    if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                    addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
                }
            }
            if (cfg.ADD_ATTR) {
                if (typeof cfg.ADD_ATTR === "function") EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
                else {
                    if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                    addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
                }
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            if (cfg.ADD_FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                "html",
                "head",
                "body"
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    "tbody"
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== "function") throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== "function") throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML("");
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === "string") emptyHTML = trustedTypesPolicy.createHTML("");
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: "template"
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === "is") {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, "");
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + "</body></html>";
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, "template", null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            return element instanceof HTMLFormElement && (typeof element.nodeName !== "string" || typeof element.textContent !== "string" || typeof element.removeChild !== "function" || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== "function" || typeof element.setAttribute !== "function" || typeof element.namespaceURI !== "string" || typeof element.insertBefore !== "function" || typeof element.hasChildNodes !== "function");
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param value object to check whether it's a DOM node
     * @return true is object is a DOM node
     */ const _isNode = function _isNode(value) {
            return typeof Node === "function" && value instanceof Node;
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName])) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, " ");
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* FORBID_ATTR must always win, even if ADD_ATTR predicate would allow it */ if (FORBID_ATTR[lcName]) return false;
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ""))) ;
            else if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ""))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== "annotation-xml" && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            const hookEvent = {
                attrName: "",
                attrValue: "",
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                const initValue = attrValue;
                let value = name === "value" ? initValue : stringTrim(initValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name")) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === "attributename" && stringMatch(value, "href")) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, " ");
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === "object" && typeof trustedTypes.getAttributeType === "function") {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case "TrustedHTML":
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case "TrustedScriptURL":
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {
                    _removeAttribute(name, currentNode);
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = "<!-->";
            /* Stringify, in case dirty is an object */ if (typeof dirty !== "string" && !_isNode(dirty)) {
                if (typeof dirty.toString === "function") {
                    dirty = dirty.toString();
                    if (typeof dirty !== "string") throw typeErrorCreate("dirty is not a string, aborting");
                } else throw typeErrorCreate("toString is not a function");
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === "string") IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument("<!---->");
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === "BODY") /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === "HTML") body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, " ");
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== "function") return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (hookFunction !== undefined) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});


function $137c8dff7df1dfd1$var$Row({ info: info, cells: cells, actions: actions, functions: functions, width: width }) {
    var widthPerCell = width / (cells.length + (actions.length > 0 ? 1 : 0));
    widthPerCell = isNaN(widthPerCell) ? 0 : widthPerCell;
    const row = cells.map((cell, index)=>{
        let value = {};
        if (Array.isArray(cell.name)) value = cell.name.map((c)=>(0, $cbf58a06f6fccf5a$export$2e2bcd8739ae039)(c, info));
        else if (cell.name) value = (0, $cbf58a06f6fccf5a$export$2e2bcd8739ae039)(cell.name, info);
        value = cell.show == undefined ? value : cell.show(value);
        return (0, $b1d9e4da4611e18b$export$2e2bcd8739ae039)(value) ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
            dangerouslySetInnerHTML: {
                __html: $726d757834788151$exports.sanitize(value, {
                    sanitize: true
                })
            },
            style: {
                width: widthPerCell
            }
        }, "td" + index) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
            style: {
                width: widthPerCell
            },
            children: value
        }, "td" + index);
    });
    var actionComponent = actions.map((action, index)=>{
        if (action.label != null || action.condition != null && (Array.isArray(action.condition_match) && action.condition_match.includes(info[action.condition]) || !Array.isArray(action.condition_match) && info[action.condition] == action.condition_match)) return;
        if (action.label != null || action.other_condition != null && info[action.other_condition] == action.other_match) return;
        const { onClick: onClick } = {
            ...action
        };
        const click = onClick.bind(null, {
            row: {
                ...info
            },
            ...functions
        });
        // delete action.condition_match;
        // delete action.condition;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
            ...action,
            onClick: click,
            "aria-hidden": "true"
        }, index);
    });
    if (actions.length > 0) row.push(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
        className: "actions",
        style: {
            width: widthPerCell
        },
        children: actionComponent
    }, "td-action"));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tr", {
        children: row
    });
}
var $137c8dff7df1dfd1$export$2e2bcd8739ae039 = $137c8dff7df1dfd1$var$Row;





function $91ecd156adcbdc22$var$IconButton({ id: id, className: className, type: type, disabled: disabled, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, icon: icon, style: style, title: title }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
        id: id,
        type: type,
        style: style,
        className: className,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        disabled: disabled,
        onClick: onClick,
        title: title,
        children: [
            " ",
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                className: icon,
                "aria-hidden": "true"
            })
        ]
    });
}
$91ecd156adcbdc22$var$IconButton.defaultProps = {
    className: "validate",
    type: "button",
    disabled: false,
    style: {}
};
var $91ecd156adcbdc22$export$2e2bcd8739ae039 = $91ecd156adcbdc22$var$IconButton;






var $bh6RR = parcelRequire("bh6RR");
const $3076e45868839394$var$TextInput = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, ref)=>{
    const prefixeClassName = "input";
    const [passwordShown, setPasswordShown] = (0, $bh6RR.useState)(false);
    const togglePassword = ()=>{
        setPasswordShown(!passwordShown);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: props.type == "password" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            style: {
                display: "flex"
            },
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                    ...props,
                    ref: ref,
                    type: props.type == "password" ? passwordShown ? "text" : "password" : props.type,
                    value: props.value,
                    className: prefixeClassName + (props.className ? " " + props.className : "") + (props.type == "password" ? " input_auth" : "")
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    className: "icon_toggle_password " + (passwordShown ? "fas fa-eye-slash" : "fas fa-eye"),
                    onClick: ()=>togglePassword()
                })
            ]
        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
            ...props,
            ref: ref,
            className: prefixeClassName + (props.className ? " " + props.className : "")
        })
    });
});
$3076e45868839394$var$TextInput.defaultProps = {
    className: "full-width input-space",
    type: "text",
    autoComplete: "chrome-off"
};
var $3076e45868839394$export$2e2bcd8739ae039 = $3076e45868839394$var$TextInput;




function $b8b90ec975873f14$var$InputSearch({ name: name, timeout: timeout, placeholderLibelle: placeholderLibelle, onChange: onChange, style: style = {} }) {
    var typingTimer;
    const onKeyUp = (e)=>{
        clearTimeout(typingTimer);
        typingTimer = setTimeout(()=>onChange(e), timeout);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: "inputSearch-container",
            style: {
                ...style
            },
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                onKeyUp: onKeyUp,
                className: "inputSearch placeholder-input",
                placeholder: "Filter by " + placeholderLibelle,
                name: name
            })
        })
    });
}
$b8b90ec975873f14$var$InputSearch.defaultProps = {
    timeout: 500
};
var $b8b90ec975873f14$export$2e2bcd8739ae039 = $b8b90ec975873f14$var$InputSearch;




var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
// Hook for checking if a mouse click occured outside a dom element, trigger a callback if true
function $e9725e0bc7ac6543$var$clickOutside(ref, onClickOutside, exceptionClassList = []) {
    (0, $bh6RR.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target) && !exceptionClassList.some((className)=>event.target.classList.contains(className))) onClickOutside(event);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref,
        onClickOutside
    ]);
}
var $e9725e0bc7ac6543$export$2e2bcd8739ae039 = $e9725e0bc7ac6543$var$clickOutside;



const $161312200a6f79f6$var$DropDown = /*#__PURE__*/ (0, $bh6RR.forwardRef)(({ choices: choices, placeholder: placeholder, defaultChoice: defaultChoice, heightFix: heightFix, className: className, width: width, name: name, onChange: onChange, onBlur: onBlur, setValue: setValue, icon: icon, hideSelectItem: hideSelectItem, noChangeOnSelect: noChangeOnSelect, reverse: reverse, disabled: disabled }, ref)=>{
    if (defaultChoice) defaultChoice = choices.filter((choice)=>choice.value == defaultChoice).pop();
    if (placeholder) defaultChoice = {
        text: placeholder,
        value: ""
    };
    var maxWidth = 0;
    if (typeof width === "number" || width instanceof Number) {
        width = width < 100 ? 100 : width;
        maxWidth = width - 60 + "px";
        width = width + "px";
    } else maxWidth = "calc(" + width + " - 60px)";
    if (defaultChoice == undefined || defaultChoice == "") defaultChoice = choices[0];
    const [expanded, setExpanded] = (0, $bh6RR.useState)(false);
    const [selected, setSelected] = (0, $bh6RR.useState)(defaultChoice);
    const [lastDefaultChoice, setLastDefaultChoice] = (0, $bh6RR.useState)(defaultChoice);
    if (lastDefaultChoice.value != defaultChoice.value) {
        setSelected(defaultChoice);
        setLastDefaultChoice(defaultChoice);
    }
    if (hideSelectItem == true) choices = choices.filter((choice)=>selected.value != choice.value);
    const listStyle = {
        "overflowY": expanded ? "auto" : "hidden",
        "height": expanded ? heightFix ? heightFix : choices.length * 35 + "px" : "0"
    };
    if (reverse) {
        listStyle.paddingTop = "0px";
        listStyle.bottom = "15px";
    }
    const onClick = ()=>{
        if (!expanded) dropdownRef.current && (dropdownRef.current.style.zIndex = 10);
        else setTimeout(()=>dropdownRef.current ? dropdownRef.current.style.zIndex = 0 : null, 500);
        setExpanded(!expanded);
    };
    const onSelect = (choice)=>{
        if (choice.text === "Import my logo") {
            const fileInput = document.createElement("input");
            fileInput.setAttribute("type", "file");
            fileInput.setAttribute("name", "avatar");
            fileInput.click();
            fileInput.addEventListener("change", (event)=>{
                const file = event.target.files[0];
                if (setValue) {
                    setValue(name, file, {
                        state: selected,
                        func: setSelected
                    });
                    setSelected({
                        value: file.name,
                        text: file.name
                    });
                }
            });
        } else {
            if (!noChangeOnSelect) setSelected(choice);
            setExpanded(false);
            setTimeout(()=>dropdownRef.current ? dropdownRef.current.style.zIndex = 0 : null, 500);
            if (!setValue) return;
            setValue(name, choice.value, {
                state: selected,
                func: setSelected
            });
        }
    };
    const dropdownRef = (0, $bh6RR.useRef)("dropdown");
    (0, $e9725e0bc7ac6543$export$2e2bcd8739ae039)(dropdownRef, ()=>{
        if (expanded) setTimeout(()=>dropdownRef.current ? dropdownRef.current.style.zIndex = 0 : null, 500);
        setExpanded(false);
    });
    const createChoice = (choice)=>{
        var iconPadding = icon ? 30 : 60;
        var paddingLeft = 25;
        if (choice.icon) paddingLeft = 0;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: [
                choice.icon && (typeof choice.icon === "string" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "icon",
                    style: {
                        backgroundImage: `url(${choice.icon})`
                    }
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "icon",
                    children: choice.icon
                })),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    className: "text",
                    style: {
                        fontWeight: selected.value == choice.value ? 700 : 400,
                        maxWidth: "calc(" + width + " - " + iconPadding + "px)",
                        paddingLeft: paddingLeft
                    },
                    children: [
                        choice.text,
                        " "
                    ]
                })
            ]
        });
    };
    //[...document.getElementsByClassName('dropdown')].map((element, index) => element.style.zIndex = 0);
    if (disabled) className = className ? className + " disabled" : "disabled";
    className = className ? "dropdown " + className : "dropdown";
    var iconBackground = icon ? icon : selected.icon;
    var paddingLeft = 25;
    if (iconBackground) paddingLeft = 0;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: className,
        ref: dropdownRef,
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                ref: ref,
                onChange: onChange,
                onBlur: onBlur,
                name: name,
                type: "hidden",
                value: selected.value == null ? "" : selected.value
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "custom-dropdown",
                style: {
                    width: width
                },
                onClick: onClick,
                children: [
                    iconBackground && (typeof iconBackground === "string" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "icon",
                        style: {
                            width: "25px",
                            height: "25px",
                            backgroundImage: `url(${iconBackground})`
                        }
                    }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "icon",
                        style: {
                            width: "auto",
                            backgroundColor: "white"
                        },
                        children: iconBackground
                    })),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "text",
                        style: {
                            maxWidth: maxWidth,
                            paddingLeft: paddingLeft
                        },
                        children: selected.text
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "container-arrow",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: `arrow ${expanded ? "reverse" : ""}`
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("ul", {
                        style: {
                            ...listStyle
                        },
                        children: choices && choices.map((choice, index)=>{
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                onClick: ()=>onSelect(choice),
                                children: createChoice(choice)
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
});
$161312200a6f79f6$var$DropDown.defaultProps = {
    width: 170,
    choices: [],
    disable: false,
    name: "",
    defaultChoice: "",
    icon: "",
    hideSelectItem: true,
    noChangeOnSelect: false,
    reverse: false
};
var $161312200a6f79f6$export$2e2bcd8739ae039 = $161312200a6f79f6$var$DropDown;


/* Detect-zoom
* -----------
* Cross Browser Zoom and Pixel Ratio Detector
* Version 1.0.2 | Feb 25 2013
* dual-licensed under the WTFPL and MIT license
* Maintained by https://github/tombigel
* Original developer https://github.com/yonran
*/ //AMD and CommonJS initialization copied from https://github.com/zohararad/audio5js
/**
 * Use devicePixelRatio if supported by the browser
 * @return {Number}
 * @private
 */ var $65efcc234d9e0718$var$devicePixelRatio = function() {
    return window.devicePixelRatio || 1;
};
/**
 * Fallback function to set default values
 * @return {Object}
 * @private
 */ var $65efcc234d9e0718$var$fallback = function() {
    return {
        zoom: 1,
        devicePxPerCssPx: 1
    };
};
/**
 * IE 8 and 9: no trick needed!
 * TODO: Test on IE10 and Windows 8 RT
 * @return {Object}
 * @private
 **/ var $65efcc234d9e0718$var$ie8 = function() {
    var zoom = Math.round(screen.deviceXDPI / screen.logicalXDPI * 100) / 100;
    return {
        zoom: zoom,
        devicePxPerCssPx: zoom * $65efcc234d9e0718$var$devicePixelRatio()
    };
};
/**
 * For IE10 we need to change our technique again...
 * thanks https://github.com/stefanvanburen
 * @return {Object}
 * @private
 */ var $65efcc234d9e0718$var$ie10 = function() {
    var zoom = Math.round(document.documentElement.offsetHeight / window.innerHeight * 100) / 100;
    return {
        zoom: zoom,
        devicePxPerCssPx: zoom * $65efcc234d9e0718$var$devicePixelRatio()
    };
};
/**
 * Mobile WebKit
 * the trick: window.innerWIdth is in CSS pixels, while
 * screen.width and screen.height are in system pixels.
 * And there are no scrollbars to mess up the measurement.
 * @return {Object}
 * @private
 */ var $65efcc234d9e0718$var$webkitMobile = function() {
    var deviceWidth = Math.abs(window.orientation) == 90 ? screen.height : screen.width;
    var zoom = deviceWidth / window.innerWidth;
    return {
        zoom: zoom,
        devicePxPerCssPx: zoom * $65efcc234d9e0718$var$devicePixelRatio()
    };
};
/**
 * Desktop Webkit
 * the trick: an element's clientHeight is in CSS pixels, while you can
 * set its line-height in system pixels using font-size and
 * -webkit-text-size-adjust:none.
 * device-pixel-ratio: http://www.webkit.org/blog/55/high-dpi-web-sites/
 *
 * Previous trick (used before http://trac.webkit.org/changeset/100847):
 * documentElement.scrollWidth is in CSS pixels, while
 * document.width was in system pixels. Note that this is the
 * layout width of the document, which is slightly different from viewport
 * because document width does not include scrollbars and might be wider
 * due to big elements.
 * @return {Object}
 * @private
 */ var $65efcc234d9e0718$var$webkit = function() {
    var important = function(str) {
        return str.replace(/;/g, " !important;");
    };
    var div = document.createElement("div");
    div.innerHTML = "1<br>2<br>3<br>4<br>5<br>6<br>7<br>8<br>9<br>0";
    div.setAttribute("style", important("font: 100px/1em sans-serif;            -webkit-text-size-adjust: none; height: auto; width: 1em; padding: 0; overflow: visible;"));
    // The container exists so that the div will be laid out in its own flow
    // while not impacting the layout, viewport size, or display of the
    // webpage as a whole.
    // Add !important and relevant CSS rule resets
    // so that other rules cannot affect the results.
    var container = document.createElement("div");
    container.setAttribute("style", important("width:0; height:0; overflow:hidden; visibility:hidden; position: absolute;"));
    container.appendChild(div);
    document.body.appendChild(container);
    var zoom = 1000 / div.clientHeight;
    zoom = Math.round(zoom * 100) / 100;
    document.body.removeChild(container);
    return {
        zoom: zoom,
        devicePxPerCssPx: zoom * $65efcc234d9e0718$var$devicePixelRatio()
    };
};
/**
 * no real trick; device-pixel-ratio is the ratio of device dpi / css dpi.
 * (Note that this is a different interpretation than Webkit's device
 * pixel ratio, which is the ratio device dpi / system dpi).
 *
 * Also, for Mozilla, there is no difference between the zoom factor and the device ratio.
 *
 * @return {Object}
 * @private
 */ var $65efcc234d9e0718$var$firefox4 = function() {
    var zoom = $65efcc234d9e0718$var$mediaQueryBinarySearch("min--moz-device-pixel-ratio", "", 0, 10, 20, 0.0001);
    zoom = Math.round(zoom * 100) / 100;
    return {
        zoom: zoom,
        devicePxPerCssPx: zoom
    };
};
/**
 * Firefox 18.x
 * Mozilla added support for devicePixelRatio to Firefox 18,
 * but it is affected by the zoom level, so, like in older
 * Firefox we can't tell if we are in zoom mode or in a device
 * with a different pixel ratio
 * @return {Object}
 * @private
 */ var $65efcc234d9e0718$var$firefox18 = function() {
    return {
        zoom: $65efcc234d9e0718$var$firefox4().zoom,
        devicePxPerCssPx: $65efcc234d9e0718$var$devicePixelRatio()
    };
};
/**
 * works starting Opera 11.11
 * the trick: outerWidth is the viewport width including scrollbars in
 * system px, while innerWidth is the viewport width including scrollbars
 * in CSS px
 * @return {Object}
 * @private
 */ var $65efcc234d9e0718$var$opera11 = function() {
    var zoom = window.top.outerWidth / window.top.innerWidth;
    zoom = Math.round(zoom * 100) / 100;
    return {
        zoom: zoom,
        devicePxPerCssPx: zoom * $65efcc234d9e0718$var$devicePixelRatio()
    };
};
/**
 * Use a binary search through media queries to find zoom level in Firefox
 * @param property
 * @param unit
 * @param a
 * @param b
 * @param maxIter
 * @param epsilon
 * @return {Number}
 */ var $65efcc234d9e0718$var$mediaQueryBinarySearch = function(property, unit, a, b, maxIter, epsilon) {
    var matchMedia;
    var head, style, div;
    if (window.matchMedia) matchMedia = window.matchMedia;
    else {
        head = document.getElementsByTagName("head")[0];
        style = document.createElement("style");
        head.appendChild(style);
        div = document.createElement("div");
        div.className = "mediaQueryBinarySearch";
        div.style.display = "none";
        document.body.appendChild(div);
        matchMedia = function(query) {
            style.sheet.insertRule("@media " + query + "{.mediaQueryBinarySearch " + "{text-decoration: underline} }", 0);
            var matched = getComputedStyle(div, null).textDecoration == "underline";
            style.sheet.deleteRule(0);
            return {
                matches: matched
            };
        };
    }
    var ratio = binarySearch(a, b, maxIter);
    if (div) {
        head.removeChild(style);
        document.body.removeChild(div);
    }
    return ratio;
    function binarySearch(a, b, maxIter) {
        var mid = (a + b) / 2;
        if (maxIter <= 0 || b - a < epsilon) return mid;
        var query = "(" + property + ":" + mid + unit + ")";
        if (matchMedia(query).matches) return binarySearch(mid, b, maxIter - 1);
        else return binarySearch(a, mid, maxIter - 1);
    }
};
/**
 * Generate detection function
 * @private
 */ var $65efcc234d9e0718$var$detectFunction = function() {
    var func = $65efcc234d9e0718$var$fallback;
    //IE8+
    if (!isNaN(screen.logicalXDPI) && !isNaN(screen.systemXDPI)) func = $65efcc234d9e0718$var$ie8;
    else if (window.navigator.msMaxTouchPoints) func = $65efcc234d9e0718$var$ie10;
    else if ("ontouchstart" in window && typeof document.body.style.webkitTextSizeAdjust === "string") func = $65efcc234d9e0718$var$webkitMobile;
    else if (typeof document.body.style.webkitTextSizeAdjust === "string") func = $65efcc234d9e0718$var$webkit;
    else if (navigator.userAgent.indexOf("Opera") >= 0) func = $65efcc234d9e0718$var$opera11;
    else if (window.devicePixelRatio) func = $65efcc234d9e0718$var$firefox18;
    else if ($65efcc234d9e0718$var$firefox4().zoom > 0.001) func = $65efcc234d9e0718$var$firefox4;
    return func();
};
var $65efcc234d9e0718$export$2e2bcd8739ae039 = {
    zoom: ()=>$65efcc234d9e0718$var$detectFunction().zoom,
    device: ()=>$65efcc234d9e0718$var$detectFunction().devicePxPerCssPx
};



var $kEUo3 = parcelRequire("kEUo3");



var $bh6RR = parcelRequire("bh6RR");
function $f89c36ea9a3f3d1e$var$ProgressBarTable({ delayMax: delayMax = 60, isFound: isFound = false }) {
    const [currentDelay, setCurrentDelay] = (0, $bh6RR.useState)(0);
    const [hasFinished, setHasFinished] = (0, $bh6RR.useState)(false);
    async function waitForProgress() {
        await timeout(10);
        let val = isFound ? 0.05 : 0.0001;
        let res = currentDelay + val * delayMax;
        setCurrentDelay(res);
        if (res >= 100) {
            await timeout(1000);
            if (res <= 100) return;
            setHasFinished(true);
        }
    }
    const resetProgressBar = ()=>{
        setHasFinished(false);
        setCurrentDelay(0);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (delayMax <= 0 || currentDelay > 100) return;
        waitForProgress();
    }, [
        currentDelay
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (currentDelay > 0 && isFound == false) resetProgressBar();
    }, [
        isFound
    ]);
    function timeout(ms) {
        return new Promise((resolve)=>setTimeout(resolve, ms));
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "table_progress_bar_container",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: "table_progress_bar " + (hasFinished ? "table_progress_bar_disapear" : ""),
            style: {
                width: currentDelay + "%"
            }
        })
    });
}
var $f89c36ea9a3f3d1e$export$2e2bcd8739ae039 = $f89c36ea9a3f3d1e$var$ProgressBarTable;


const $67108b46a15aa360$var$zoomLevels = {
    25: 620,
    33: 580,
    50: 520,
    67: 500,
    75: 460,
    80: 420,
    90: 380,
    100: 340,
    110: 300,
    125: 260,
    150: 220
};
function $67108b46a15aa360$var$Table({ className: className, cells: cells, name: name, api: api, actions: actions = [], actionExtension: actionExtension, buttons: buttons, filters: filters, filterValues: filterValues, filterPostRequest: filterPostRequest, filterButton: filterButton, refreshState: refreshState = [], plurial: plurial, withPagination: withPagination = true, defaultSort: defaultSort }) {
    const [data, totalNbData, { addPage: addPage, setFilter: setFilter, setFiltersAll: setFiltersAll }, rowActions, fetching, isSorted, setIsSorted] = (0, $878480337414c3a8$export$2e2bcd8739ae039)(api, filterPostRequest, refreshState, filterValues, withPagination, defaultSort);
    const [maxHeight, setMaxHeight] = (0, $bh6RR.useState)(0);
    const [width, setWidth] = (0, $bh6RR.useState)(0);
    const [defaultWidth, setDefaultWidth] = (0, $bh6RR.useState)(0);
    const [zoomFactor, setZoomFactor] = (0, $bh6RR.useState)((0, $65efcc234d9e0718$export$2e2bcd8739ae039).zoom());
    const [height, setHeight] = (0, $bh6RR.useState)(100);
    const sortAsc = (name)=>{
        setIsSorted({
            column: name,
            val: !isSorted.val
        });
    };
    const refScroll = (0, $bh6RR.useRef)();
    const refDataContainer = (0, $bh6RR.useRef)();
    const onScroll = (e)=>{
        const { scrollHeight: scrollHeight, scrollTop: scrollTop, clientHeight: clientHeight } = e.target;
        if (scrollHeight - scrollTop - clientHeight > 40 || withPagination == false) return null;
        addPage();
    };
    const onChange = (e)=>{
        const { name: name, value: value } = e.target;
        setFilter({
            [name]: value
        });
    };
    const createColumns = (rowWidth)=>{
        var widthPerCell = rowWidth / (cells.length + (actions.length > 0 ? 1 : 0));
        widthPerCell = isNaN(widthPerCell) ? 0 : widthPerCell;
        if (widthPerCell == 0) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
        const columns = cells.map((cell, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("th", {
                style: {
                    width: widthPerCell
                },
                children: [
                    cell.column,
                    " ",
                    cell.sort ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        className: "fas " + (isSorted ? "fa-sort-alpha-up" : "fa-sort-alpha-down") + " sort_icon",
                        onClick: ()=>sortAsc(cell.name)
                    }) : ""
                ]
            }, "th" + index));
        if (actions.length > 0) columns.push(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("th", {
            style: {
                width: widthPerCell
            },
            children: actionExtension ? actionExtension : "Actions"
        }, "th-action"));
        return columns;
    };
    const createButtons = ()=>{
        if (!buttons) return null;
        const buttonsComponent = buttons.map((button, index)=>{
            const { onClick: onClick } = {
                ...button
            };
            const click = onClick.bind(null, {
                ...rowActions
            });
            return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                className: "main-iconButton profil_action main_add-button space_tableButton",
                ...button,
                onClick: click,
                key: "button-" + index
            });
        });
        return buttonsComponent;
    };
    const setMaxHeightWithFactor = ()=>{
        const tableContainer = document.querySelector(".background-table").offsetHeight;
        const zoomLevel = ((0, $65efcc234d9e0718$export$2e2bcd8739ae039).zoom() * 100).toFixed(0);
        const constantZoom = $67108b46a15aa360$var$zoomLevels[zoomLevel];
        var newMaxHeight = tableContainer - constantZoom * (0, $65efcc234d9e0718$export$2e2bcd8739ae039).zoom();
        setMaxHeight(newMaxHeight);
        var zoomDiff = zoomFactor - (0, $65efcc234d9e0718$export$2e2bcd8739ae039).device();
        const zoomValue = 1 + zoomDiff;
        setWidth(defaultWidth * zoomValue);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (refScroll.current == undefined) return;
        setMaxHeightWithFactor();
        refScroll.current.addEventListener("scroll", onScroll);
        return ()=>{
            refScroll.current?.removeEventListener("scroll", onScroll);
        };
    }, [
        fetching,
        height
    ]);
    (0, $bh6RR.useEffect)(()=>{
        window.addEventListener("resize", setMaxHeightWithFactor);
        return ()=>{
            window.removeEventListener("resize", setMaxHeightWithFactor);
        };
    }, [
        defaultWidth,
        height
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (filterValues == undefined) return;
        setFiltersAll(filterValues);
    }, [
        filterValues
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (refDataContainer.current == undefined) return;
        if (refDataContainer.current.firstChild.offsetHeight != 0) setHeight(refDataContainer.current.firstChild.offsetHeight);
        if (refDataContainer.current.firstChild.offsetWidth != 0) setDefaultWidth(50000);
    }, [
        refDataContainer,
        data
    ]);
    if (height > maxHeight) className = `scroll ${className}`;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        onScroll: onScroll,
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "search-container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "start-row",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "input-container no-margin",
                            style: {
                                justifyContent: "center"
                            },
                            children: filters.map((filter, index)=>{
                                if (filter.type == "input") return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b8b90ec975873f14$export$2e2bcd8739ae039), {
                                    style: {
                                        marginRight: 20
                                    },
                                    placeholderLibelle: filter.placeholder,
                                    name: filter.name,
                                    onChange: onChange
                                }, index);
                                if (filter.type == "dropdown") return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "dropdown-filter",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                            children: (0, $kEUo3.upperFirst)(filter.name)
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                            ...filter,
                                            setValue: (name, value)=>onChange({
                                                    target: {
                                                        name: name,
                                                        value: value
                                                    }
                                                })
                                        })
                                    ]
                                }, index);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "end-row",
                        children: [
                            createButtons(),
                            filterButton && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                style: {
                                    marginRight: "5px"
                                },
                                children: filterButton
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("table", {
                className: "table-data",
                style: {
                    visibility: "hidden",
                    position: "absolute"
                },
                ref: refDataContainer,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tfoot", {
                    children: data && data.map((row)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $137c8dff7df1dfd1$export$2e2bcd8739ae039), {
                            info: row,
                            cells: cells,
                            actions: actions,
                            functions: rowActions
                        }, new Date().getTime() + "_" + Math.floor(Math.random() * 100000) + row.id))
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("table", {
                cellSpacing: "0",
                className: className,
                ref: refScroll,
                style: {
                    maxHeight: maxHeight,
                    height: height
                },
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f89c36ea9a3f3d1e$export$2e2bcd8739ae039), {
                        isFound: !fetching
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("caption", {
                        className: "table-info",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                            children: [
                                "List of ",
                                (0, $c250361150c8f4e2$export$2e2bcd8739ae039)(name) + (plurial === false ? "" : "s"),
                                " ",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                    className: "fas fa-arrow-right arrow_icon_table"
                                }),
                                " ",
                                data.length,
                                " / ",
                                totalNbData > data.length ? totalNbData : data.length
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tr", {
                            children: createColumns(width)
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("tbody", {
                        children: data && data.map((row)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $137c8dff7df1dfd1$export$2e2bcd8739ae039), {
                                info: row,
                                cells: cells,
                                actions: actions,
                                functions: rowActions,
                                width: width
                            }, new Date().getTime() + "_" + Math.floor(Math.random() * 100000) + row.id))
                    })
                ]
            })
        ]
    });
}
$67108b46a15aa360$var$Table.defaultProps = {
    filters: [],
    className: "table",
    filterPostRequest: (value)=>value
};
var $67108b46a15aa360$export$2e2bcd8739ae039 = $67108b46a15aa360$var$Table;


var $3822f7270824b8aa$export$2e2bcd8739ae039 = (0, $67108b46a15aa360$export$2e2bcd8739ae039);


const $20cf8d8a58f4d669$var$encodeQueryData = (obj)=>Object.entries(obj).map(([key, val])=>`${key}=${val}`).join("&");
var $20cf8d8a58f4d669$export$2e2bcd8739ae039 = $20cf8d8a58f4d669$var$encodeQueryData;


const $4c4dbb9dba926a1c$var$asyncWrapper = async (fn, ...args)=>{
    try {
        const data = await fn(...args);
        return [
            data,
            null
        ];
    } catch (error) {
        return [
            null,
            error
        ];
    }
};
var $4c4dbb9dba926a1c$export$2e2bcd8739ae039 = $4c4dbb9dba926a1c$var$asyncWrapper;


const $b5643a9ede795dea$var$fetchWrapper = (url, options)=>(0, $4c4dbb9dba926a1c$export$2e2bcd8739ae039)($b5643a9ede795dea$var$fetchMethod, url, options);
const $b5643a9ede795dea$var$fetchMethod = (url, options)=>new Promise((resolve, reject)=>{
        var status;
        fetch(url, options).then((response)=>{
            status = response.status;
            return response.json();
        }).then((body)=>status === 200 || status === 201 ? resolve(body) : reject(body)).catch((err)=>{
            if (navigator.onLine == false) return;
            reject(err);
        });
    });
var $b5643a9ede795dea$export$2e2bcd8739ae039 = $b5643a9ede795dea$var$fetchWrapper;


var $07d55ecd4e888d68$exports = {};
/* eslint-env browser */ $07d55ecd4e888d68$exports = typeof self == "object" ? self.FormData : window.FormData;


const $651df53b10514175$var$staging = window.env?.REACT_APP_API_PATH ?? undefined;
const $651df53b10514175$var$prod = window.env?.REACT_APP_API_PROD_PATH ?? undefined;
const $651df53b10514175$export$a7b6bc01c63cdfc3 = {
    REACT_APP_API_PATH: $651df53b10514175$var$staging,
    REACT_APP_API_PROD_PATH: $651df53b10514175$var$prod ?? $651df53b10514175$var$staging,
    REACT_APP_DEBUG: window.env?.REACT_APP_DEBUG ?? undefined
};


function $c8b97750e6a6e84e$var$storage(type) {
    const api = type == "local" ? "localStorage" : "sessionStorage";
    return {
        set (key, value) {
            if (typeof value === "object" && value !== null) value = JSON.stringify(value);
            window[api].setItem(key, value);
        },
        get (key) {
            var value = window[api].getItem(key);
            if (value == null || value == "") return value;
            let tmp = null;
            try {
                tmp = JSON.parse(value);
            } catch (e) {}
            return tmp ? tmp : value;
        },
        remove (key) {
            window[api].removeItem(key);
        }
    };
}
var $c8b97750e6a6e84e$export$2e2bcd8739ae039 = $c8b97750e6a6e84e$var$storage;


const $04e377a52ef60d56$var$storageSession = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session");
const $04e377a52ef60d56$var$storageLocal = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local");
function $04e377a52ef60d56$var$client() {
    const url = (0, $651df53b10514175$export$a7b6bc01c63cdfc3).REACT_APP_API_PATH + "/";
    const generateHeaders = (options = {})=>{
        const token = $04e377a52ef60d56$var$storageLocal.get("token");
        if (token) options.Authorization = "Bearer " + token;
        return options;
    };
    const fetchInterceptorRequest = (url, options)=>{
        const company = $04e377a52ef60d56$var$storageSession.get("company");
        if (location.pathname.startsWith("/company") && company) url += (url.match(/[\?]/g) ? "&" : "?") + `company=${company.id}`;
        if (!company && location.pathname.startsWith("/company")) {
            var company_name = location.pathname.split("/company/")[1].split("/")[0];
            console.log(location.pathname.split("/company"));
            url += (url.match(/[\?]/g) ? "&" : "?") + `company=${company_name}`;
        }
        options = {
            ...options,
            headers: {
                ...options.headers,
                "Ngrok-Skip-Browser-Warning": "true"
            }
        };
        return {
            url: url,
            options: options
        };
    };
    const fetchInterceptorResponse = async (response, error, request)=>{
        if (error === null || error.status != 401 || $04e377a52ef60d56$var$storageLocal.get("token") == false) return [
            response,
            error
        ];
        const { url: uri, options: options } = request;
        [
            response,
            error
        ] = await (0, $b5643a9ede795dea$export$2e2bcd8739ae039)(`${url}refresh-token`, {
            method: "post",
            headers: generateHeaders({
                "Content-Type": "application/json",
                "Ngrok-Skip-Browser-Warning": "true"
            }),
            body: JSON.stringify({
                refresh_token: $04e377a52ef60d56$var$storageLocal.get("refresh_token")
            })
        });
        if (error) return [
            response,
            error
        ];
        const { token: token } = response;
        $04e377a52ef60d56$var$storageLocal.set("token", token);
        options.headers = generateHeaders(options.headers);
        [response, error] = await (0, $b5643a9ede795dea$export$2e2bcd8739ae039)(uri, options);
        return [
            response,
            error
        ];
    };
    const apiCall = async (...arg)=>{
        const { url: url, options: options } = fetchInterceptorRequest(...arg);
        let [response, error] = await (0, $b5643a9ede795dea$export$2e2bcd8739ae039)(url, options);
        [response, error] = await fetchInterceptorResponse(response, error, {
            url: url,
            options: options
        });
        return [
            response,
            error
        ];
    };
    return {
        get: function(uri, params = {}) {
            const content = {
                method: "get",
                headers: generateHeaders({
                    "Content-Type": "application/json"
                })
            };
            const data = (0, $20cf8d8a58f4d669$export$2e2bcd8739ae039)(params);
            return apiCall(url + uri + (data ? "?" + data : ""), content);
        },
        post: function(uri, data) {
            const content = {
                method: "post",
                headers: generateHeaders()
            };
            if (data instanceof (0, (/*@__PURE__*/$parcel$interopDefault($07d55ecd4e888d68$exports))) === false) {
                content.headers = generateHeaders({
                    "Content-Type": "application/json"
                });
                content.body = JSON.stringify(data);
            } else content.body = data;
            return apiCall(url + uri, content);
        },
        put: function(uri, data) {
            const content = {
                method: "put",
                headers: generateHeaders()
            };
            if (data instanceof (0, (/*@__PURE__*/$parcel$interopDefault($07d55ecd4e888d68$exports))) === false) {
                content.headers = generateHeaders({
                    "Content-Type": "application/json"
                });
                content.body = JSON.stringify(data);
            } else {
                content.method = "post";
                uri = uri + "?_method=PUT";
                content.body = data;
            }
            return apiCall(url + uri, content);
        },
        delete: function(uri, params = {}) {
            const content = {
                method: "delete",
                headers: generateHeaders({
                    "Content-Type": "application/json"
                })
            };
            const queryString = (0, $20cf8d8a58f4d669$export$2e2bcd8739ae039)(params);
            const fullUrl = queryString ? `${url}${uri}?${queryString}` : `${url}${uri}`;
            return apiCall(fullUrl, content);
        }
    };
}
var $04e377a52ef60d56$export$2e2bcd8739ae039 = $04e377a52ef60d56$var$client();


var $24a8370de200c756$export$2e2bcd8739ae039 = {
    addBot: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post("bot", data),
    getBots: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("bots", data),
    updateBot: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`bot/${id}`, data),
    deleteBot: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`bot/${id}`, data),
    getBotsChannels: ()=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("bots", [
            "channels"
        ]),
    isBotNameAvailable: (name)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`bots?name=${name}`),
    getVoices: (id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`bot/voices`),
    getBotsShared: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`bots/dashboards`, data)
};




var $bh6RR = parcelRequire("bh6RR");
/* *********************************************************
 * Copyright 2021 eBay Inc.

 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
*********************************************************** */ 
var $bh6RR = parcelRequire("bh6RR");
var $36c8369d2da2c3c8$var$__assign = undefined && undefined.__assign || function() {
    $36c8369d2da2c3c8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $36c8369d2da2c3c8$var$__assign.apply(this, arguments);
};
var $36c8369d2da2c3c8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $36c8369d2da2c3c8$var$symModalId = Symbol("NiceModalId");
var $36c8369d2da2c3c8$var$initialState = {};
var $36c8369d2da2c3c8$export$151b77cb09f8468b = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext($36c8369d2da2c3c8$var$initialState);
var $36c8369d2da2c3c8$var$NiceModalIdContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
var $36c8369d2da2c3c8$var$MODAL_REGISTRY = {};
var $36c8369d2da2c3c8$var$ALREADY_MOUNTED = {};
var $36c8369d2da2c3c8$var$uidSeed = 0;
var $36c8369d2da2c3c8$var$dispatch = function() {
    throw new Error("No dispatch method detected, did you embed your app with NiceModal.Provider?");
};
var $36c8369d2da2c3c8$var$getUid = function() {
    return "_nice_modal_" + $36c8369d2da2c3c8$var$uidSeed++;
};
var $36c8369d2da2c3c8$export$1650419e431d3ba3 = function(state, action) {
    var _a, _b, _c;
    if (state === void 0) state = $36c8369d2da2c3c8$var$initialState;
    switch(action.type){
        case "nice-modal/show":
            var _d = action.payload, modalId = _d.modalId, args = _d.args;
            return $36c8369d2da2c3c8$var$__assign($36c8369d2da2c3c8$var$__assign({}, state), (_a = {}, _a[modalId] = $36c8369d2da2c3c8$var$__assign($36c8369d2da2c3c8$var$__assign({}, state[modalId]), {
                id: modalId,
                args: args,
                // If modal is not mounted, mount it first then make it visible.
                // There is logic inside HOC wrapper to make it visible after its first mount.
                // This mechanism ensures the entering transition.
                visible: !!$36c8369d2da2c3c8$var$ALREADY_MOUNTED[modalId],
                delayVisible: !$36c8369d2da2c3c8$var$ALREADY_MOUNTED[modalId]
            }), _a));
        case "nice-modal/hide":
            var modalId = action.payload.modalId;
            if (!state[modalId]) return state;
            return $36c8369d2da2c3c8$var$__assign($36c8369d2da2c3c8$var$__assign({}, state), (_b = {}, _b[modalId] = $36c8369d2da2c3c8$var$__assign($36c8369d2da2c3c8$var$__assign({}, state[modalId]), {
                visible: false
            }), _b));
        case "nice-modal/remove":
            var modalId = action.payload.modalId;
            var newState = $36c8369d2da2c3c8$var$__assign({}, state);
            delete newState[modalId];
            return newState;
        case "nice-modal/set-flags":
            var _e = action.payload, modalId = _e.modalId, flags = _e.flags;
            return $36c8369d2da2c3c8$var$__assign($36c8369d2da2c3c8$var$__assign({}, state), (_c = {}, _c[modalId] = $36c8369d2da2c3c8$var$__assign($36c8369d2da2c3c8$var$__assign({}, state[modalId]), flags), _c));
        default:
            return state;
    }
};
// Get modal component by modal id
function $36c8369d2da2c3c8$var$getModal(modalId) {
    var _a;
    return (_a = $36c8369d2da2c3c8$var$MODAL_REGISTRY[modalId]) === null || _a === void 0 ? void 0 : _a.comp;
}
// action creator to show a modal
function $36c8369d2da2c3c8$var$showModal(modalId, args) {
    return {
        type: "nice-modal/show",
        payload: {
            modalId: modalId,
            args: args
        }
    };
}
// action creator to set flags of a modal
function $36c8369d2da2c3c8$var$setModalFlags(modalId, flags) {
    return {
        type: "nice-modal/set-flags",
        payload: {
            modalId: modalId,
            flags: flags
        }
    };
}
// action creator to hide a modal
function $36c8369d2da2c3c8$var$hideModal(modalId) {
    return {
        type: "nice-modal/hide",
        payload: {
            modalId: modalId
        }
    };
}
// action creator to remove a modal
function $36c8369d2da2c3c8$var$removeModal(modalId) {
    return {
        type: "nice-modal/remove",
        payload: {
            modalId: modalId
        }
    };
}
var $36c8369d2da2c3c8$var$modalCallbacks = {};
var $36c8369d2da2c3c8$var$hideModalCallbacks = {};
var $36c8369d2da2c3c8$var$getModalId = function(modal) {
    if (typeof modal === "string") return modal;
    if (!modal[$36c8369d2da2c3c8$var$symModalId]) modal[$36c8369d2da2c3c8$var$symModalId] = $36c8369d2da2c3c8$var$getUid();
    return modal[$36c8369d2da2c3c8$var$symModalId];
};
function $36c8369d2da2c3c8$export$57bf213be019eeb0(modal, args) {
    var modalId = $36c8369d2da2c3c8$var$getModalId(modal);
    if (typeof modal !== "string" && !$36c8369d2da2c3c8$var$MODAL_REGISTRY[modalId]) $36c8369d2da2c3c8$export$6503ec6e8aabbaf(modalId, modal);
    $36c8369d2da2c3c8$var$dispatch($36c8369d2da2c3c8$var$showModal(modalId, args));
    if (!$36c8369d2da2c3c8$var$modalCallbacks[modalId]) {
        // `!` tell ts that theResolve will be written before it is used
        var theResolve_1;
        // `!` tell ts that theResolve will be written before it is used
        var theReject_1;
        var promise = new Promise(function(resolve, reject) {
            theResolve_1 = resolve;
            theReject_1 = reject;
        });
        $36c8369d2da2c3c8$var$modalCallbacks[modalId] = {
            resolve: theResolve_1,
            reject: theReject_1,
            promise: promise
        };
    }
    return $36c8369d2da2c3c8$var$modalCallbacks[modalId].promise;
}
function $36c8369d2da2c3c8$export$fe8985bb6374093c(modal) {
    var modalId = $36c8369d2da2c3c8$var$getModalId(modal);
    $36c8369d2da2c3c8$var$dispatch($36c8369d2da2c3c8$var$hideModal(modalId));
    // Should also delete the callback for modal.resolve #35
    delete $36c8369d2da2c3c8$var$modalCallbacks[modalId];
    if (!$36c8369d2da2c3c8$var$hideModalCallbacks[modalId]) {
        // `!` tell ts that theResolve will be written before it is used
        var theResolve_2;
        // `!` tell ts that theResolve will be written before it is used
        var theReject_2;
        var promise = new Promise(function(resolve, reject) {
            theResolve_2 = resolve;
            theReject_2 = reject;
        });
        $36c8369d2da2c3c8$var$hideModalCallbacks[modalId] = {
            resolve: theResolve_2,
            reject: theReject_2,
            promise: promise
        };
    }
    return $36c8369d2da2c3c8$var$hideModalCallbacks[modalId].promise;
}
var $36c8369d2da2c3c8$export$cd7f480d6b8286c3 = function(modal) {
    var modalId = $36c8369d2da2c3c8$var$getModalId(modal);
    $36c8369d2da2c3c8$var$dispatch($36c8369d2da2c3c8$var$removeModal(modalId));
    delete $36c8369d2da2c3c8$var$modalCallbacks[modalId];
    delete $36c8369d2da2c3c8$var$hideModalCallbacks[modalId];
};
var $36c8369d2da2c3c8$var$setFlags = function(modalId, flags) {
    $36c8369d2da2c3c8$var$dispatch($36c8369d2da2c3c8$var$setModalFlags(modalId, flags));
};
function $36c8369d2da2c3c8$export$33ffd74ebf07f060(modal, args) {
    var modals = (0, $bh6RR.useContext)($36c8369d2da2c3c8$export$151b77cb09f8468b);
    var contextModalId = (0, $bh6RR.useContext)($36c8369d2da2c3c8$var$NiceModalIdContext);
    var modalId = null;
    var isUseComponent = modal && typeof modal !== "string";
    if (!modal) modalId = contextModalId;
    else modalId = $36c8369d2da2c3c8$var$getModalId(modal);
    // Only if contextModalId doesn't exist
    if (!modalId) throw new Error("No modal id found in NiceModal.useModal.");
    var mid = modalId;
    // If use a component directly, register it.
    (0, $bh6RR.useEffect)(function() {
        if (isUseComponent && !$36c8369d2da2c3c8$var$MODAL_REGISTRY[mid]) $36c8369d2da2c3c8$export$6503ec6e8aabbaf(mid, modal, args);
    }, [
        isUseComponent,
        mid,
        modal,
        args
    ]);
    var modalInfo = modals[mid];
    var showCallback = (0, $bh6RR.useCallback)(function(args) {
        return $36c8369d2da2c3c8$export$57bf213be019eeb0(mid, args);
    }, [
        mid
    ]);
    var hideCallback = (0, $bh6RR.useCallback)(function() {
        return $36c8369d2da2c3c8$export$fe8985bb6374093c(mid);
    }, [
        mid
    ]);
    var removeCallback = (0, $bh6RR.useCallback)(function() {
        return $36c8369d2da2c3c8$export$cd7f480d6b8286c3(mid);
    }, [
        mid
    ]);
    var resolveCallback = (0, $bh6RR.useCallback)(function(args) {
        var _a;
        (_a = $36c8369d2da2c3c8$var$modalCallbacks[mid]) === null || _a === void 0 || _a.resolve(args);
        delete $36c8369d2da2c3c8$var$modalCallbacks[mid];
    }, [
        mid
    ]);
    var rejectCallback = (0, $bh6RR.useCallback)(function(args) {
        var _a;
        (_a = $36c8369d2da2c3c8$var$modalCallbacks[mid]) === null || _a === void 0 || _a.reject(args);
        delete $36c8369d2da2c3c8$var$modalCallbacks[mid];
    }, [
        mid
    ]);
    var resolveHide = (0, $bh6RR.useCallback)(function(args) {
        var _a;
        (_a = $36c8369d2da2c3c8$var$hideModalCallbacks[mid]) === null || _a === void 0 || _a.resolve(args);
        delete $36c8369d2da2c3c8$var$hideModalCallbacks[mid];
    }, [
        mid
    ]);
    return (0, $bh6RR.useMemo)(function() {
        return {
            id: mid,
            args: modalInfo === null || modalInfo === void 0 ? void 0 : modalInfo.args,
            visible: !!(modalInfo === null || modalInfo === void 0 ? void 0 : modalInfo.visible),
            keepMounted: !!(modalInfo === null || modalInfo === void 0 ? void 0 : modalInfo.keepMounted),
            show: showCallback,
            hide: hideCallback,
            remove: removeCallback,
            resolve: resolveCallback,
            reject: rejectCallback,
            resolveHide: resolveHide
        };
    }, [
        mid,
        modalInfo === null || modalInfo === void 0 ? void 0 : modalInfo.args,
        modalInfo === null || modalInfo === void 0 ? void 0 : modalInfo.visible,
        modalInfo === null || modalInfo === void 0 ? void 0 : modalInfo.keepMounted,
        showCallback,
        hideCallback,
        removeCallback,
        resolveCallback,
        rejectCallback,
        resolveHide
    ]);
}
var $36c8369d2da2c3c8$export$185802fd694ee1f5 = function(Comp) {
    return function(_a) {
        var _b;
        var defaultVisible = _a.defaultVisible, keepMounted = _a.keepMounted, id = _a.id, props = $36c8369d2da2c3c8$var$__rest(_a, [
            "defaultVisible",
            "keepMounted",
            "id"
        ]);
        var _c = $36c8369d2da2c3c8$export$33ffd74ebf07f060(id), args = _c.args, show = _c.show;
        // If there's modal state, then should mount it.
        var modals = (0, $bh6RR.useContext)($36c8369d2da2c3c8$export$151b77cb09f8468b);
        var shouldMount = !!modals[id];
        (0, $bh6RR.useEffect)(function() {
            // If defaultVisible, show it after mounted.
            if (defaultVisible) show();
            $36c8369d2da2c3c8$var$ALREADY_MOUNTED[id] = true;
            return function() {
                delete $36c8369d2da2c3c8$var$ALREADY_MOUNTED[id];
            };
        }, [
            id,
            show,
            defaultVisible
        ]);
        (0, $bh6RR.useEffect)(function() {
            if (keepMounted) $36c8369d2da2c3c8$var$setFlags(id, {
                keepMounted: true
            });
        }, [
            id,
            keepMounted
        ]);
        var delayVisible = (_b = modals[id]) === null || _b === void 0 ? void 0 : _b.delayVisible;
        // If modal.show is called
        //  1. If modal was mounted, should make it visible directly
        //  2. If modal has not been mounted, should mount it first, then make it visible
        (0, $bh6RR.useEffect)(function() {
            if (delayVisible) // delayVisible: false => true, it means the modal.show() is called, should show it.
            show(args);
        }, [
            delayVisible,
            args,
            show
        ]);
        if (!shouldMount) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($36c8369d2da2c3c8$var$NiceModalIdContext.Provider, {
            value: id
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Comp, $36c8369d2da2c3c8$var$__assign({}, props, args)));
    };
};
var $36c8369d2da2c3c8$export$6503ec6e8aabbaf = function(id, comp, props) {
    if (!$36c8369d2da2c3c8$var$MODAL_REGISTRY[id]) $36c8369d2da2c3c8$var$MODAL_REGISTRY[id] = {
        comp: comp,
        props: props
    };
    else $36c8369d2da2c3c8$var$MODAL_REGISTRY[id].props = props;
};
var $36c8369d2da2c3c8$export$d07f55d4c15c0440 = function(id) {
    delete $36c8369d2da2c3c8$var$MODAL_REGISTRY[id];
};
// The placeholder component is used to auto render modals when call modal.show()
// When modal.show() is called, it means there've been modal info
var $36c8369d2da2c3c8$var$NiceModalPlaceholder = function() {
    var modals = (0, $bh6RR.useContext)($36c8369d2da2c3c8$export$151b77cb09f8468b);
    var visibleModalIds = Object.keys(modals).filter(function(id) {
        return !!modals[id];
    });
    visibleModalIds.forEach(function(id) {
        if (!$36c8369d2da2c3c8$var$MODAL_REGISTRY[id] && !$36c8369d2da2c3c8$var$ALREADY_MOUNTED[id]) {
            console.warn("No modal found for id: " + id + ". Please check the id or if it is registered or declared via JSX.");
            return;
        }
    });
    var toRender = visibleModalIds.filter(function(id) {
        return $36c8369d2da2c3c8$var$MODAL_REGISTRY[id];
    }).map(function(id) {
        return $36c8369d2da2c3c8$var$__assign({
            id: id
        }, $36c8369d2da2c3c8$var$MODAL_REGISTRY[id]);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, toRender.map(function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(t.comp, $36c8369d2da2c3c8$var$__assign({
            key: t.id,
            id: t.id
        }, t.props));
    }));
};
var $36c8369d2da2c3c8$var$InnerContextProvider = function(_a) {
    var children = _a.children;
    var arr = (0, $bh6RR.useReducer)($36c8369d2da2c3c8$export$1650419e431d3ba3, $36c8369d2da2c3c8$var$initialState);
    var modals = arr[0];
    $36c8369d2da2c3c8$var$dispatch = arr[1];
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($36c8369d2da2c3c8$export$151b77cb09f8468b.Provider, {
        value: modals
    }, children, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($36c8369d2da2c3c8$var$NiceModalPlaceholder, null));
};
var $36c8369d2da2c3c8$export$2881499e37b75b9a = function(_a) {
    var children = _a.children, givenDispatch = _a.dispatch, givenModals = _a.modals;
    if (!givenDispatch || !givenModals) return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($36c8369d2da2c3c8$var$InnerContextProvider, null, children);
    $36c8369d2da2c3c8$var$dispatch = givenDispatch;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($36c8369d2da2c3c8$export$151b77cb09f8468b.Provider, {
        value: givenModals
    }, children, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($36c8369d2da2c3c8$var$NiceModalPlaceholder, null));
};
var $36c8369d2da2c3c8$export$60bf8df6b14da1b8 = function(_a) {
    var id = _a.id, component = _a.component;
    (0, $bh6RR.useEffect)(function() {
        $36c8369d2da2c3c8$export$6503ec6e8aabbaf(id, component);
        return function() {
            $36c8369d2da2c3c8$export$d07f55d4c15c0440(id);
        };
    }, [
        id,
        component
    ]);
    return null;
};
var $36c8369d2da2c3c8$export$15ecf9ebada78887 = function(_a) {
    var _b;
    var modal = _a.modal, _c = _a.handler, handler = _c === void 0 ? {} : _c, restProps = $36c8369d2da2c3c8$var$__rest(_a, [
        "modal",
        "handler"
    ]);
    var mid = (0, $bh6RR.useMemo)(function() {
        return $36c8369d2da2c3c8$var$getUid();
    }, []);
    var ModalComp = typeof modal === "string" ? (_b = $36c8369d2da2c3c8$var$MODAL_REGISTRY[modal]) === null || _b === void 0 ? void 0 : _b.comp : modal;
    if (!handler) throw new Error("No handler found in NiceModal.ModalHolder.");
    if (!ModalComp) throw new Error("No modal found for id: " + modal + " in NiceModal.ModalHolder.");
    handler.show = (0, $bh6RR.useCallback)(function(args) {
        return $36c8369d2da2c3c8$export$57bf213be019eeb0(mid, args);
    }, [
        mid
    ]);
    handler.hide = (0, $bh6RR.useCallback)(function() {
        return $36c8369d2da2c3c8$export$fe8985bb6374093c(mid);
    }, [
        mid
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(ModalComp, $36c8369d2da2c3c8$var$__assign({
        id: mid
    }, restProps));
};
var $36c8369d2da2c3c8$export$7b1ef6cdd4b088ba = function(modal) {
    return {
        visible: modal.visible,
        onOk: function() {
            return modal.hide();
        },
        onCancel: function() {
            return modal.hide();
        },
        afterClose: function() {
            // Need to resolve before remove
            modal.resolveHide();
            if (!modal.keepMounted) modal.remove();
        }
    };
};
var $36c8369d2da2c3c8$export$848bd1aa7c3a3966 = function(modal) {
    var _a = $36c8369d2da2c3c8$export$7b1ef6cdd4b088ba(modal), onOk = _a.onOk, onCancel = _a.onCancel, afterClose = _a.afterClose;
    return {
        open: modal.visible,
        onOk: onOk,
        onCancel: onCancel,
        afterClose: afterClose
    };
};
var $36c8369d2da2c3c8$export$5d4bbe225418fb11 = function(modal) {
    return {
        visible: modal.visible,
        onClose: function() {
            return modal.hide();
        },
        afterVisibleChange: function(v) {
            if (!v) modal.resolveHide();
            !v && !modal.keepMounted && modal.remove();
        }
    };
};
var $36c8369d2da2c3c8$export$2ffb86c76d24994 = function(modal) {
    var _a = $36c8369d2da2c3c8$export$5d4bbe225418fb11(modal), onClose = _a.onClose, afterOpenChange = _a.afterVisibleChange;
    return {
        open: modal.visible,
        onClose: onClose,
        afterOpenChange: afterOpenChange
    };
};
var $36c8369d2da2c3c8$export$9582c7650deef8f0 = function(modal) {
    return {
        open: modal.visible,
        onClose: function() {
            return modal.hide();
        },
        onExited: function() {
            modal.resolveHide();
            !modal.keepMounted && modal.remove();
        }
    };
};
var $36c8369d2da2c3c8$export$23ffa2c2f4640a1e = function(modal) {
    return {
        open: modal.visible,
        onClose: function() {
            return modal.hide();
        },
        TransitionProps: {
            onExited: function() {
                modal.resolveHide();
                !modal.keepMounted && modal.remove();
            }
        }
    };
};
var $36c8369d2da2c3c8$export$7bece38dfb2f2f7c = function(modal) {
    return {
        show: modal.visible,
        onHide: function() {
            return modal.hide();
        },
        onExited: function() {
            modal.resolveHide();
            !modal.keepMounted && modal.remove();
        }
    };
};
var $36c8369d2da2c3c8$var$NiceModal = {
    Provider: $36c8369d2da2c3c8$export$2881499e37b75b9a,
    ModalDef: $36c8369d2da2c3c8$export$60bf8df6b14da1b8,
    ModalHolder: $36c8369d2da2c3c8$export$15ecf9ebada78887,
    NiceModalContext: $36c8369d2da2c3c8$export$151b77cb09f8468b,
    create: $36c8369d2da2c3c8$export$185802fd694ee1f5,
    register: $36c8369d2da2c3c8$export$6503ec6e8aabbaf,
    getModal: $36c8369d2da2c3c8$var$getModal,
    show: $36c8369d2da2c3c8$export$57bf213be019eeb0,
    hide: $36c8369d2da2c3c8$export$fe8985bb6374093c,
    remove: $36c8369d2da2c3c8$export$cd7f480d6b8286c3,
    useModal: $36c8369d2da2c3c8$export$33ffd74ebf07f060,
    reducer: $36c8369d2da2c3c8$export$1650419e431d3ba3,
    antdModal: $36c8369d2da2c3c8$export$7b1ef6cdd4b088ba,
    antdDrawer: $36c8369d2da2c3c8$export$5d4bbe225418fb11,
    muiDialog: $36c8369d2da2c3c8$export$9582c7650deef8f0,
    bootstrapDialog: $36c8369d2da2c3c8$export$7bece38dfb2f2f7c
};
var $36c8369d2da2c3c8$export$2e2bcd8739ae039 = $36c8369d2da2c3c8$var$NiceModal;





var $bh6RR = parcelRequire("bh6RR");
function $e3f638d04018c279$var$Modal({ children: children, name: name, onClose: onClose, id: id, modalClass: modalClass, autoClose: autoClose, style: style }) {
    const ref = (0, $bh6RR.useRef)();
    const onClick = (event)=>{
        // voir https://tekolio.com/how-to-detect-a-click-outside-of-a-react-component-using-hooks/?trk=article-ssr-frontend-pulse_little-text-block
        if (ref.current.contains(event.target) == false && document.querySelectorAll('[id^="_nice_modal"]').length == 1) {
            onClose();
            return;
        }
        if (autoClose == false || event.target.id != id) return null;
        onClose();
    };
    (0, $bh6RR.useEffect)(()=>{
        document.addEventListener("mousedown", onClick);
        return ()=>{
            document.removeEventListener("mousedown", onClick);
        };
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        id: id,
        ref: ref,
        className: modalClass + " " + name,
        onMouseDown: onClick,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: "modal-container " + name,
            style: style,
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "modal-info flex-column",
                children: children
            })
        })
    });
}
$e3f638d04018c279$var$Modal.defaultProps = {
    modalClass: "modal",
    closeTimer: 300,
    name: "default",
    autoClose: true
};
var $e3f638d04018c279$export$2e2bcd8739ae039 = $e3f638d04018c279$var$Modal;


function $588bd62b5d9ae093$var$useModalHelper(modal) {
    const onClose = (params = {
        duration: 300,
        idIconModal: null
    })=>{
        var { duration: duration, idIconModal: idIconModal } = params;
        duration = Number.isInteger(duration) ? duration : 300;
        const element = document.getElementById(modal.id);
        if (idIconModal != null) {
            console.log(duration);
            const close_button = document.getElementById(idIconModal);
            close_button.classList.add("close_button_action");
        }
        if (element != null) element.classList.add("closing");
        setTimeout(()=>modal.remove(), duration);
    };
    return {
        onClose: onClose
    };
}
var $588bd62b5d9ae093$export$2e2bcd8739ae039 = $588bd62b5d9ae093$var$useModalHelper;




function $3df48224cec6bb9c$var$Form({ className: className, children: children, onSubmit: onSubmit }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("form", {
        onSubmit: onSubmit,
        className: "form " + (className ? className : ""),
        children: children
    });
}
$3df48224cec6bb9c$var$Form.Title = ({ children: children, className: className })=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "first-row " + (className ? className : ""),
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
            className: "title",
            children: children
        })
    });
$3df48224cec6bb9c$var$Form.Buttons = ({ children: children, className: className })=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "last-row " + (className ? className : ""),
        children: children
    });
$3df48224cec6bb9c$var$Form.Body = ({ children: children, className: className })=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "center " + (className ? className : ""),
        children: children
    });
$3df48224cec6bb9c$var$Form.defaultProps = {
    name: ""
};
$3df48224cec6bb9c$var$Form.Title.defaultProps = {
    className: ""
};
$3df48224cec6bb9c$var$Form.Buttons.defaultProps = {
    className: ""
};
$3df48224cec6bb9c$var$Form.Body.defaultProps = {
    className: ""
};
var $3df48224cec6bb9c$export$2e2bcd8739ae039 = $3df48224cec6bb9c$var$Form;




function $06d28f450b1ec943$var$Button({ id: id, label: label, className: className, type: type, disabled: disabled, onClick: onClick, style: style }) {
    const classNamePrefix = "button ";
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
        id: id,
        type: type,
        style: style,
        className: classNamePrefix + className,
        disabled: disabled,
        onClick: onClick,
        children: label
    });
}
$06d28f450b1ec943$var$Button.defaultProps = {
    className: "validate",
    type: "button",
    disabled: false,
    style: {}
};
var $06d28f450b1ec943$export$2e2bcd8739ae039 = $06d28f450b1ec943$var$Button;




function $174898365ac03a05$var$Field({ label: label, children: children, listClassName: listClassName, listLabelClassName: listLabelClassName, title: title }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "field " + listClassName,
        title: title ? title : label,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                className: listLabelClassName,
                children: label
            }),
            children
        ]
    });
}
$174898365ac03a05$var$Field.defaultProps = {
    listClassName: ""
};
var $174898365ac03a05$export$2e2bcd8739ae039 = $174898365ac03a05$var$Field;




var $bh6RR = parcelRequire("bh6RR");
var $ee9f4a2880885da1$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $ee9f4a2880885da1$var$isDateObject = (value1)=>value1 instanceof Date;
var $ee9f4a2880885da1$var$isNullOrUndefined = (value1)=>value1 == null;
const $ee9f4a2880885da1$var$isObjectType = (value1)=>typeof value1 === "object";
var $ee9f4a2880885da1$var$isObject = (value1)=>!$ee9f4a2880885da1$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $ee9f4a2880885da1$var$isObjectType(value1) && !$ee9f4a2880885da1$var$isDateObject(value1);
var $ee9f4a2880885da1$var$getEventValue = (event)=>$ee9f4a2880885da1$var$isObject(event) && event.target ? $ee9f4a2880885da1$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $ee9f4a2880885da1$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $ee9f4a2880885da1$var$isNameInFieldArray = (names, name)=>names.has($ee9f4a2880885da1$var$getNodeParentName(name));
var $ee9f4a2880885da1$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $ee9f4a2880885da1$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $ee9f4a2880885da1$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $ee9f4a2880885da1$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($ee9f4a2880885da1$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $ee9f4a2880885da1$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$ee9f4a2880885da1$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $ee9f4a2880885da1$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $ee9f4a2880885da1$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $ee9f4a2880885da1$var$isUndefined = (val)=>val === undefined;
var $ee9f4a2880885da1$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$ee9f4a2880885da1$var$isObject(object)) return defaultValue;
    const result = $ee9f4a2880885da1$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$ee9f4a2880885da1$var$isNullOrUndefined(result) ? result : result[key], object);
    return $ee9f4a2880885da1$var$isUndefined(result) || result === object ? $ee9f4a2880885da1$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $ee9f4a2880885da1$var$isBoolean = (value1)=>typeof value1 === "boolean";
var $ee9f4a2880885da1$var$isKey = (value1)=>/^\w*$/.test(value1);
var $ee9f4a2880885da1$var$stringToPath = (input)=>$ee9f4a2880885da1$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
var $ee9f4a2880885da1$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $ee9f4a2880885da1$var$isKey(path) ? [
        path
    ] : $ee9f4a2880885da1$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $ee9f4a2880885da1$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === "__proto__") return;
        object[key] = newValue;
        object = object[key];
    }
    return object;
};
const $ee9f4a2880885da1$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $ee9f4a2880885da1$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $ee9f4a2880885da1$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $ee9f4a2880885da1$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $ee9f4a2880885da1$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($ee9f4a2880885da1$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $ee9f4a2880885da1$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($ee9f4a2880885da1$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $ee9f4a2880885da1$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $ee9f4a2880885da1$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $ee9f4a2880885da1$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $ee9f4a2880885da1$var$isEmptyObject = (value1)=>$ee9f4a2880885da1$var$isObject(value1) && !Object.keys(value1).length;
var $ee9f4a2880885da1$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $ee9f4a2880885da1$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $ee9f4a2880885da1$var$VALIDATION_MODE.all));
};
var $ee9f4a2880885da1$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $ee9f4a2880885da1$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $ee9f4a2880885da1$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $ee9f4a2880885da1$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $ee9f4a2880885da1$export$606f11b2eb45ecc6(props) {
    const methods = $ee9f4a2880885da1$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(name);
    _name.current = name;
    $ee9f4a2880885da1$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $ee9f4a2880885da1$var$shouldSubscribeByName(_name.current, value1.name, exact) && $ee9f4a2880885da1$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $ee9f4a2880885da1$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $ee9f4a2880885da1$var$isString = (value1)=>typeof value1 === "string";
var $ee9f4a2880885da1$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($ee9f4a2880885da1$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $ee9f4a2880885da1$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $ee9f4a2880885da1$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $ee9f4a2880885da1$export$3c773aa2b84f29e0(props) {
    const methods = $ee9f4a2880885da1$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(name);
    _name.current = name;
    $ee9f4a2880885da1$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($ee9f4a2880885da1$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($ee9f4a2880885da1$var$cloneObject($ee9f4a2880885da1$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>control._removeUnmounted());
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $ee9f4a2880885da1$export$e8c786024a2b0a79(props) {
    const methods = $ee9f4a2880885da1$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $ee9f4a2880885da1$var$isNameInFieldArray(control._names.array, name);
    const value1 = $ee9f4a2880885da1$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $ee9f4a2880885da1$export$3988ae62b71be9a3(control._formValues, name, $ee9f4a2880885da1$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $ee9f4a2880885da1$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: true
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$ee9f4a2880885da1$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $ee9f4a2880885da1$var$cloneObject($ee9f4a2880885da1$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $ee9f4a2880885da1$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($ee9f4a2880885da1$var$isUndefined($ee9f4a2880885da1$export$3988ae62b71be9a3(control._formValues, name))) $ee9f4a2880885da1$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if ($ee9f4a2880885da1$export$3988ae62b71be9a3(control._fields, name)) control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name,
            value: $ee9f4a2880885da1$export$3988ae62b71be9a3(control._fields, name)._f.value
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name: name,
            value: value1,
            ...$ee9f4a2880885da1$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $ee9f4a2880885da1$var$getEventValue(event),
                        name: name
                    },
                    type: $ee9f4a2880885da1$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $ee9f4a2880885da1$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $ee9f4a2880885da1$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback((elm)=>{
                const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }, [
                control._fields,
                name
            ])
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$ee9f4a2880885da1$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$ee9f4a2880885da1$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$ee9f4a2880885da1$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$ee9f4a2880885da1$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$ee9f4a2880885da1$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $ee9f4a2880885da1$export$bd0bf19f25da8474 = (props)=>props.render($ee9f4a2880885da1$export$e8c786024a2b0a79(props));
const $ee9f4a2880885da1$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($ee9f4a2880885da1$var$isObjectType(obj[key])) {
        const nested = $ee9f4a2880885da1$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const $ee9f4a2880885da1$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $ee9f4a2880885da1$export$a7fed597f4b8afd8(props) {
    const methods = $ee9f4a2880885da1$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $ee9f4a2880885da1$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = $ee9f4a2880885da1$var$flatten(control._formValues);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(action, {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $ee9f4a2880885da1$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $ee9f4a2880885da1$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $ee9f4a2880885da1$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $ee9f4a2880885da1$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$ee9f4a2880885da1$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $ee9f4a2880885da1$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $ee9f4a2880885da1$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $ee9f4a2880885da1$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $ee9f4a2880885da1$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $ee9f4a2880885da1$var$VALIDATION_MODE.all,
        isOnTouch: mode === $ee9f4a2880885da1$var$VALIDATION_MODE.onTouched
    });
var $ee9f4a2880885da1$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $ee9f4a2880885da1$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($ee9f4a2880885da1$var$iterateFieldsByAction(currentField, action)) break;
                }
            } else if ($ee9f4a2880885da1$var$isObject(currentField)) {
                if ($ee9f4a2880885da1$var$iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
var $ee9f4a2880885da1$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $ee9f4a2880885da1$var$convertToArrayPayload($ee9f4a2880885da1$export$3988ae62b71be9a3(errors, name));
    $ee9f4a2880885da1$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $ee9f4a2880885da1$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $ee9f4a2880885da1$var$isFileInput = (element)=>element.type === "file";
var $ee9f4a2880885da1$var$isFunction = (value1)=>typeof value1 === "function";
var $ee9f4a2880885da1$var$isHTMLElement = (value1)=>{
    if (!$ee9f4a2880885da1$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $ee9f4a2880885da1$var$isMessage = (value1)=>$ee9f4a2880885da1$var$isString(value1);
var $ee9f4a2880885da1$var$isRadioInput = (element)=>element.type === "radio";
var $ee9f4a2880885da1$var$isRegex = (value1)=>value1 instanceof RegExp;
const $ee9f4a2880885da1$var$defaultResult = {
    value: false,
    isValid: false
};
const $ee9f4a2880885da1$var$validResult = {
    value: true,
    isValid: true
};
var $ee9f4a2880885da1$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$ee9f4a2880885da1$var$isUndefined(options[0].attributes.value) ? $ee9f4a2880885da1$var$isUndefined(options[0].value) || options[0].value === "" ? $ee9f4a2880885da1$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $ee9f4a2880885da1$var$validResult : $ee9f4a2880885da1$var$defaultResult;
    }
    return $ee9f4a2880885da1$var$defaultResult;
};
const $ee9f4a2880885da1$var$defaultReturn = {
    isValid: false,
    value: null
};
var $ee9f4a2880885da1$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $ee9f4a2880885da1$var$defaultReturn) : $ee9f4a2880885da1$var$defaultReturn;
function $ee9f4a2880885da1$var$getValidateError(result, ref, type = "validate") {
    if ($ee9f4a2880885da1$var$isMessage(result) || Array.isArray(result) && result.every($ee9f4a2880885da1$var$isMessage) || $ee9f4a2880885da1$var$isBoolean(result) && !result) return {
        type: type,
        message: $ee9f4a2880885da1$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $ee9f4a2880885da1$var$getValueAndMessage = (validationData)=>$ee9f4a2880885da1$var$isObject(validationData) && !$ee9f4a2880885da1$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $ee9f4a2880885da1$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $ee9f4a2880885da1$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($ee9f4a2880885da1$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $ee9f4a2880885da1$var$isRadioInput(ref);
    const isCheckBox = $ee9f4a2880885da1$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $ee9f4a2880885da1$var$isFileInput(ref)) && $ee9f4a2880885da1$var$isUndefined(ref.value) && $ee9f4a2880885da1$var$isUndefined(inputValue) || $ee9f4a2880885da1$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $ee9f4a2880885da1$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $ee9f4a2880885da1$var$INPUT_VALIDATION_RULES.maxLength, minType = $ee9f4a2880885da1$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $ee9f4a2880885da1$var$isNullOrUndefined(inputValue)) || $ee9f4a2880885da1$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$ee9f4a2880885da1$var$getCheckboxValue(refs).isValid || isRadio && !$ee9f4a2880885da1$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $ee9f4a2880885da1$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $ee9f4a2880885da1$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $ee9f4a2880885da1$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($ee9f4a2880885da1$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$ee9f4a2880885da1$var$isNullOrUndefined(min) || !$ee9f4a2880885da1$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $ee9f4a2880885da1$var$getValueAndMessage(max);
        const minOutput = $ee9f4a2880885da1$var$getValueAndMessage(min);
        if (!$ee9f4a2880885da1$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$ee9f4a2880885da1$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$ee9f4a2880885da1$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($ee9f4a2880885da1$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($ee9f4a2880885da1$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $ee9f4a2880885da1$var$INPUT_VALIDATION_RULES.max, $ee9f4a2880885da1$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($ee9f4a2880885da1$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $ee9f4a2880885da1$var$getValueAndMessage(maxLength);
        const minLengthOutput = $ee9f4a2880885da1$var$getValueAndMessage(minLength);
        const exceedMax = !$ee9f4a2880885da1$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$ee9f4a2880885da1$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $ee9f4a2880885da1$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $ee9f4a2880885da1$var$getValueAndMessage(pattern);
        if ($ee9f4a2880885da1$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $ee9f4a2880885da1$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($ee9f4a2880885da1$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($ee9f4a2880885da1$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $ee9f4a2880885da1$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($ee9f4a2880885da1$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($ee9f4a2880885da1$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$ee9f4a2880885da1$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $ee9f4a2880885da1$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$ee9f4a2880885da1$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
var $ee9f4a2880885da1$var$appendAt = (data, value1)=>[
        ...data,
        ...$ee9f4a2880885da1$var$convertToArrayPayload(value1)
    ];
var $ee9f4a2880885da1$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $ee9f4a2880885da1$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$ee9f4a2880885da1$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $ee9f4a2880885da1$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($ee9f4a2880885da1$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $ee9f4a2880885da1$var$prependAt = (data, value1)=>[
        ...$ee9f4a2880885da1$var$convertToArrayPayload(value1),
        ...$ee9f4a2880885da1$var$convertToArrayPayload(data)
    ];
function $ee9f4a2880885da1$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $ee9f4a2880885da1$var$compact(temp).length ? temp : [];
}
var $ee9f4a2880885da1$var$removeArrayAt = (data, index)=>$ee9f4a2880885da1$var$isUndefined(index) ? [] : $ee9f4a2880885da1$var$removeAtIndexes(data, $ee9f4a2880885da1$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $ee9f4a2880885da1$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function $ee9f4a2880885da1$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $ee9f4a2880885da1$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $ee9f4a2880885da1$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$ee9f4a2880885da1$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $ee9f4a2880885da1$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $ee9f4a2880885da1$var$isKey(path) ? [
        path
    ] : $ee9f4a2880885da1$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $ee9f4a2880885da1$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($ee9f4a2880885da1$var$isObject(childObject) && $ee9f4a2880885da1$var$isEmptyObject(childObject) || Array.isArray(childObject) && $ee9f4a2880885da1$var$isEmptyArray(childObject))) $ee9f4a2880885da1$var$unset(object, paths.slice(0, -1));
    return object;
}
var $ee9f4a2880885da1$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $ee9f4a2880885da1$export$310131896651d559(props) {
    const methods = $ee9f4a2880885da1$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(control._getFieldArray(name).map($ee9f4a2880885da1$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $ee9f4a2880885da1$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $ee9f4a2880885da1$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($ee9f4a2880885da1$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $ee9f4a2880885da1$var$convertToArrayPayload($ee9f4a2880885da1$var$cloneObject(value1));
        const updatedFieldArrayValues = $ee9f4a2880885da1$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $ee9f4a2880885da1$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $ee9f4a2880885da1$var$appendAt(ids.current, appendValue.map($ee9f4a2880885da1$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ee9f4a2880885da1$var$appendAt, {
            argA: $ee9f4a2880885da1$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $ee9f4a2880885da1$var$convertToArrayPayload($ee9f4a2880885da1$var$cloneObject(value1));
        const updatedFieldArrayValues = $ee9f4a2880885da1$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $ee9f4a2880885da1$var$getFocusFieldName(name, 0, options);
        ids.current = $ee9f4a2880885da1$var$prependAt(ids.current, prependValue.map($ee9f4a2880885da1$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ee9f4a2880885da1$var$prependAt, {
            argA: $ee9f4a2880885da1$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $ee9f4a2880885da1$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $ee9f4a2880885da1$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ee9f4a2880885da1$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $ee9f4a2880885da1$var$convertToArrayPayload($ee9f4a2880885da1$var$cloneObject(value1));
        const updatedFieldArrayValues = $ee9f4a2880885da1$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $ee9f4a2880885da1$var$getFocusFieldName(name, index, options);
        ids.current = $ee9f4a2880885da1$var$insert(ids.current, index, insertValue.map($ee9f4a2880885da1$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ee9f4a2880885da1$var$insert, {
            argA: index,
            argB: $ee9f4a2880885da1$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $ee9f4a2880885da1$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $ee9f4a2880885da1$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ee9f4a2880885da1$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $ee9f4a2880885da1$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $ee9f4a2880885da1$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ee9f4a2880885da1$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $ee9f4a2880885da1$var$cloneObject(value1);
        const updatedFieldArrayValues = $ee9f4a2880885da1$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $ee9f4a2880885da1$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $ee9f4a2880885da1$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $ee9f4a2880885da1$var$convertToArrayPayload($ee9f4a2880885da1$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($ee9f4a2880885da1$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        control._state.action = false;
        $ee9f4a2880885da1$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$ee9f4a2880885da1$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $ee9f4a2880885da1$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $ee9f4a2880885da1$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $ee9f4a2880885da1$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $ee9f4a2880885da1$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($ee9f4a2880885da1$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $ee9f4a2880885da1$var$getValidationModes(control._options.mode).isOnSubmit)) $ee9f4a2880885da1$var$validateField(field, control._formValues, control._options.criteriaMode === $ee9f4a2880885da1$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$ee9f4a2880885da1$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $ee9f4a2880885da1$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $ee9f4a2880885da1$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = "";
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        !$ee9f4a2880885da1$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $ee9f4a2880885da1$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
var $ee9f4a2880885da1$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $ee9f4a2880885da1$var$isPrimitive = (value1)=>$ee9f4a2880885da1$var$isNullOrUndefined(value1) || !$ee9f4a2880885da1$var$isObjectType(value1);
function $ee9f4a2880885da1$var$deepEqual(object1, object2) {
    if ($ee9f4a2880885da1$var$isPrimitive(object1) || $ee9f4a2880885da1$var$isPrimitive(object2)) return object1 === object2;
    if ($ee9f4a2880885da1$var$isDateObject(object1) && $ee9f4a2880885da1$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($ee9f4a2880885da1$var$isDateObject(val1) && $ee9f4a2880885da1$var$isDateObject(val2) || $ee9f4a2880885da1$var$isObject(val1) && $ee9f4a2880885da1$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$ee9f4a2880885da1$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $ee9f4a2880885da1$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $ee9f4a2880885da1$var$isRadioOrCheckbox = (ref)=>$ee9f4a2880885da1$var$isRadioInput(ref) || $ee9f4a2880885da1$var$isCheckBoxInput(ref);
var $ee9f4a2880885da1$var$live = (ref)=>$ee9f4a2880885da1$var$isHTMLElement(ref) && ref.isConnected;
var $ee9f4a2880885da1$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($ee9f4a2880885da1$var$isFunction(data[key])) return true;
    }
    return false;
};
function $ee9f4a2880885da1$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($ee9f4a2880885da1$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $ee9f4a2880885da1$var$isObject(data[key]) && !$ee9f4a2880885da1$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $ee9f4a2880885da1$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$ee9f4a2880885da1$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $ee9f4a2880885da1$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($ee9f4a2880885da1$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $ee9f4a2880885da1$var$isObject(data[key]) && !$ee9f4a2880885da1$var$objectHasFunction(data[key])) {
            if ($ee9f4a2880885da1$var$isUndefined(formValues) || $ee9f4a2880885da1$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $ee9f4a2880885da1$var$markFieldsDirty(data[key], []) : {
                ...$ee9f4a2880885da1$var$markFieldsDirty(data[key])
            };
            else $ee9f4a2880885da1$var$getDirtyFieldsFromDefaultValues(data[key], $ee9f4a2880885da1$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$ee9f4a2880885da1$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $ee9f4a2880885da1$var$getDirtyFields = (defaultValues, formValues)=>$ee9f4a2880885da1$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $ee9f4a2880885da1$var$markFieldsDirty(formValues));
var $ee9f4a2880885da1$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$ee9f4a2880885da1$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $ee9f4a2880885da1$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $ee9f4a2880885da1$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($ee9f4a2880885da1$var$isFileInput(ref)) return ref.files;
    if ($ee9f4a2880885da1$var$isRadioInput(ref)) return $ee9f4a2880885da1$var$getRadioValue(_f.refs).value;
    if ($ee9f4a2880885da1$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($ee9f4a2880885da1$var$isCheckBoxInput(ref)) return $ee9f4a2880885da1$var$getCheckboxValue(_f.refs).value;
    return $ee9f4a2880885da1$var$getFieldValueAs($ee9f4a2880885da1$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $ee9f4a2880885da1$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
        field && $ee9f4a2880885da1$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $ee9f4a2880885da1$var$getRuleValue = (rule)=>$ee9f4a2880885da1$var$isUndefined(rule) ? rule : $ee9f4a2880885da1$var$isRegex(rule) ? rule.source : $ee9f4a2880885da1$var$isObject(rule) ? $ee9f4a2880885da1$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
const $ee9f4a2880885da1$var$ASYNC_FUNCTION = "AsyncFunction";
var $ee9f4a2880885da1$var$hasPromiseValidation = (fieldReference)=>(!fieldReference || !fieldReference.validate) && !!($ee9f4a2880885da1$var$isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === $ee9f4a2880885da1$var$ASYNC_FUNCTION || $ee9f4a2880885da1$var$isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === $ee9f4a2880885da1$var$ASYNC_FUNCTION));
var $ee9f4a2880885da1$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $ee9f4a2880885da1$var$schemaErrorLookup(errors, _fields, name) {
    const error = $ee9f4a2880885da1$export$3988ae62b71be9a3(errors, name);
    if (error || $ee9f4a2880885da1$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $ee9f4a2880885da1$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $ee9f4a2880885da1$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $ee9f4a2880885da1$var$unsetEmptyArray = (ref, name)=>!$ee9f4a2880885da1$var$compact($ee9f4a2880885da1$export$3988ae62b71be9a3(ref, name)).length && $ee9f4a2880885da1$var$unset(ref, name);
const $ee9f4a2880885da1$var$defaultOptions = {
    mode: $ee9f4a2880885da1$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $ee9f4a2880885da1$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $ee9f4a2880885da1$var$createFormControl(props = {}) {
    let _options = {
        ...$ee9f4a2880885da1$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $ee9f4a2880885da1$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $ee9f4a2880885da1$var$isObject(_options.defaultValues) || $ee9f4a2880885da1$var$isObject(_options.values) ? $ee9f4a2880885da1$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $ee9f4a2880885da1$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $ee9f4a2880885da1$var$createSubject(),
        array: $ee9f4a2880885da1$var$createSubject(),
        state: $ee9f4a2880885da1$var$createSubject()
    };
    const validationModeBeforeSubmit = $ee9f4a2880885da1$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $ee9f4a2880885da1$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $ee9f4a2880885da1$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (!props.disabled && (_proxyFormState.isValid || shouldUpdateValid)) {
            const isValid = _options.resolver ? $ee9f4a2880885da1$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!props.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $ee9f4a2880885da1$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$ee9f4a2880885da1$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !props.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $ee9f4a2880885da1$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $ee9f4a2880885da1$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $ee9f4a2880885da1$export$3988ae62b71be9a3(_formValues, name, $ee9f4a2880885da1$var$isUndefined(value1) ? $ee9f4a2880885da1$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $ee9f4a2880885da1$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $ee9f4a2880885da1$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!props.disabled) {
            const disabledField = !!($ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name) && $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name)._f && $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name)._f.disabled);
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = disabledField || $ee9f4a2880885da1$var$deepEqual($ee9f4a2880885da1$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                isPreviousDirty = !!(!disabledField && $ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.dirtyFields, name));
                isCurrentFieldPristine || disabledField ? $ee9f4a2880885da1$var$unset(_formState.dirtyFields, name) : $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $ee9f4a2880885da1$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $ee9f4a2880885da1$var$unset(_formState.errors, name);
        }
        if ((error ? !$ee9f4a2880885da1$var$deepEqual(previousFieldError, error) : previousFieldError) || !$ee9f4a2880885da1$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $ee9f4a2880885da1$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _executeSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $ee9f4a2880885da1$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $ee9f4a2880885da1$export$3988ae62b71be9a3(errors, name);
            error ? $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $ee9f4a2880885da1$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $ee9f4a2880885da1$var$hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ], true);
                    const fieldError = await $ee9f4a2880885da1$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($ee9f4a2880885da1$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $ee9f4a2880885da1$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $ee9f4a2880885da1$var$unset(_formState.errors, _f.name));
                }
                !$ee9f4a2880885da1$var$isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$ee9f4a2880885da1$var$live(ref)) : !$ee9f4a2880885da1$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!props.disabled && (name && data && $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formValues, name, data), !$ee9f4a2880885da1$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$ee9f4a2880885da1$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $ee9f4a2880885da1$var$isUndefined(defaultValue) ? _defaultValues : $ee9f4a2880885da1$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$ee9f4a2880885da1$var$compact($ee9f4a2880885da1$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $ee9f4a2880885da1$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formValues, name, $ee9f4a2880885da1$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $ee9f4a2880885da1$var$isHTMLElement(fieldReference.ref) && $ee9f4a2880885da1$var$isNullOrUndefined(value1) ? "" : value1;
                if ($ee9f4a2880885da1$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($ee9f4a2880885da1$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($ee9f4a2880885da1$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || $ee9f4a2880885da1$var$isObject(fieldValue) || field && !field._f) && !$ee9f4a2880885da1$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $ee9f4a2880885da1$var$cloneObject(value1);
        $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $ee9f4a2880885da1$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$ee9f4a2880885da1$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $ee9f4a2880885da1$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: _state.mount ? name : undefined,
            values: {
                ..._formValues
            }
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $ee9f4a2880885da1$var$getFieldValue(field._f) : $ee9f4a2880885da1$var$getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $ee9f4a2880885da1$var$isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || $ee9f4a2880885da1$var$deepEqual(fieldValue, $ee9f4a2880885da1$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $ee9f4a2880885da1$var$EVENTS.BLUR || event.type === $ee9f4a2880885da1$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$ee9f4a2880885da1$var$hasValidation(field._f) && !_options.resolver && !$ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $ee9f4a2880885da1$var$skipValidation(isBlurEvent, $ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $ee9f4a2880885da1$var$isWatched(name, _names, isBlurEvent);
            $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$ee9f4a2880885da1$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid) {
                    if (props.mode === "onBlur") {
                        if (isBlurEvent) _updateValid();
                    } else _updateValid();
                }
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $ee9f4a2880885da1$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $ee9f4a2880885da1$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $ee9f4a2880885da1$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $ee9f4a2880885da1$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $ee9f4a2880885da1$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($ee9f4a2880885da1$var$isUndefined(name) ? name : fieldNames);
            isValid = $ee9f4a2880885da1$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$ee9f4a2880885da1$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$ee9f4a2880885da1$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $ee9f4a2880885da1$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        return $ee9f4a2880885da1$var$isUndefined(fieldNames) ? values : $ee9f4a2880885da1$var$isString(fieldNames) ? $ee9f4a2880885da1$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$ee9f4a2880885da1$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$ee9f4a2880885da1$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$ee9f4a2880885da1$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $ee9f4a2880885da1$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$ee9f4a2880885da1$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && $ee9f4a2880885da1$var$convertToArrayPayload(name).forEach((inputName)=>$ee9f4a2880885da1$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type, ...restOfErrorTree } = currentError;
        $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$ee9f4a2880885da1$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $ee9f4a2880885da1$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $ee9f4a2880885da1$var$unset(_fields, fieldName);
                $ee9f4a2880885da1$var$unset(_formValues, fieldName);
            }
            !options.keepError && $ee9f4a2880885da1$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $ee9f4a2880885da1$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $ee9f4a2880885da1$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $ee9f4a2880885da1$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $ee9f4a2880885da1$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled, name: name, field: field, fields: fields, value: value1 })=>{
        if ($ee9f4a2880885da1$var$isBoolean(disabled) && _state.mount || !!disabled) {
            const inputValue = disabled ? undefined : $ee9f4a2880885da1$var$isUndefined(value1) ? $ee9f4a2880885da1$var$getFieldValue(field ? field._f : $ee9f4a2880885da1$export$3988ae62b71be9a3(fields, name)._f) : value1;
            $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $ee9f4a2880885da1$var$isBoolean(options.disabled) || $ee9f4a2880885da1$var$isBoolean(props.disabled);
        $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: $ee9f4a2880885da1$var$isBoolean(options.disabled) ? options.disabled : props.disabled,
            name: name,
            value: options.value
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || props.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $ee9f4a2880885da1$var$getRuleValue(options.min),
                max: $ee9f4a2880885da1$var$getRuleValue(options.max),
                minLength: $ee9f4a2880885da1$var$getRuleValue(options.minLength),
                maxLength: $ee9f4a2880885da1$var$getRuleValue(options.maxLength),
                pattern: $ee9f4a2880885da1$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $ee9f4a2880885da1$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $ee9f4a2880885da1$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($ee9f4a2880885da1$var$live),
                                    fieldRef,
                                    ...Array.isArray($ee9f4a2880885da1$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($ee9f4a2880885da1$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $ee9f4a2880885da1$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($ee9f4a2880885da1$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $ee9f4a2880885da1$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $ee9f4a2880885da1$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $ee9f4a2880885da1$var$unset(_formState.errors, "root");
            if ($ee9f4a2880885da1$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $ee9f4a2880885da1$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name)) {
            if ($ee9f4a2880885da1$var$isUndefined(options.defaultValue)) setValue(name, $ee9f4a2880885da1$var$cloneObject($ee9f4a2880885da1$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $ee9f4a2880885da1$export$adaa4cf7ef1b65be(_defaultValues, name, $ee9f4a2880885da1$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $ee9f4a2880885da1$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $ee9f4a2880885da1$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $ee9f4a2880885da1$var$cloneObject($ee9f4a2880885da1$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $ee9f4a2880885da1$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $ee9f4a2880885da1$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $ee9f4a2880885da1$var$cloneObject(updatedValues);
        const isEmptyResetValues = $ee9f4a2880885da1$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys($ee9f4a2880885da1$var$getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck))$ee9f4a2880885da1$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $ee9f4a2880885da1$export$adaa4cf7ef1b65be(values, fieldName, $ee9f4a2880885da1$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $ee9f4a2880885da1$export$3988ae62b71be9a3(values, fieldName));
            } else {
                if ($ee9f4a2880885da1$var$isWeb && $ee9f4a2880885da1$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($ee9f4a2880885da1$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $ee9f4a2880885da1$var$cloneObject(_defaultValues) : {} : $ee9f4a2880885da1$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$ee9f4a2880885da1$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $ee9f4a2880885da1$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $ee9f4a2880885da1$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($ee9f4a2880885da1$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $ee9f4a2880885da1$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$ee9f4a2880885da1$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            _setErrors: _setErrors,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $ee9f4a2880885da1$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef();
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $ee9f4a2880885da1$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: $ee9f4a2880885da1$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$ee9f4a2880885da1$var$createFormControl(props),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $ee9f4a2880885da1$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($ee9f4a2880885da1$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (props.values && !$ee9f4a2880885da1$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (props.errors) control._setErrors(props.errors);
    }, [
        props.errors,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        props.shouldUnregister && control._subjects.values.next({
            values: control._getWatch()
        });
    }, [
        props.shouldUnregister,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (_formControl.current) _formControl.current.watch = _formControl.current.watch.bind({});
    }, [
        formState
    ]);
    _formControl.current.formState = $ee9f4a2880885da1$var$getProxyFormState(formState, control);
    return _formControl.current;
}



const $defe4a8e979bd5d1$var$ApiModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ title: title, body: body, api: api, buttons: buttons, confirm: confirm, maxTitleSize: maxTitleSize = 60 })=>{
    var sub_title = title;
    if (title.length > maxTitleSize) {
        sub_title = title.substring(0, maxTitleSize);
        sub_title += "...";
    }
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    var { request: request, param: param } = api;
    const { handleSubmit: handleSubmit } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)();
    //const [confirmDelete, setConfirmDelete] = useState(false);
    const [checkError, setCheckError] = (0, $bh6RR.useState)("");
    const onSubmit = async ()=>{
        if (request == null) {
            modal.resolve(true);
            onClose();
        }
        if (confirm != null && Array.isArray(confirm.name)) param = [
            ...param,
            getValueConfirm(document.getElementById("confirm-delete").value)
        ];
        const [response, error] = await request(...param);
        if (error !== null) {
            onClose();
            modal.resolve(error);
            return;
        }
        modal.resolve(response);
        onClose();
    };
    const isValueConfirm = (value)=>{
        if (Array.isArray(confirm.name)) return confirm.name.filter((data)=>data.value == value).length > 0;
        return value == confirm.name;
    };
    const getValueConfirm = (value)=>{
        if (Array.isArray(confirm.name)) {
            const data = confirm.name.filter((data)=>data.value == value).pop();
            return data.id ? data.id : data.value;
        }
        return confirm.name;
    };
    const checkConfirm = ()=>{
        if (confirm != null && isValueConfirm(document.getElementById("confirm-delete").value) == false) {
            setCheckError(true);
            return;
        }
        onSubmit();
    };
    const haveToConfirm = (props)=>{
        if (props != null && confirm != null) return props.type == "submit";
        return false;
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        name: "logout",
        id: modal.id,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "leave-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
                className: "modal-form",
                onSubmit: handleSubmit(checkConfirm),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                        children: sub_title
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                            children: body
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        children: [
                            confirm != null ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Tap the name of " + confirm.fieldName
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            style: {
                                                marginBottom: "15px",
                                                borderColor: checkError === false ? "var(--pink)" : ""
                                            },
                                            id: "confirm-delete",
                                            onKeyDown: (e)=>e.keyCode == 13 ? e.preventDefault() : null,
                                            onChange: (e)=>setCheckError(isValueConfirm(e.target.value))
                                        })
                                    ]
                                })
                            }) : null,
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                style: {
                                    display: "flex"
                                },
                                children: buttons && buttons.map((props, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
                                        children: /*#__PURE__*/ (0, $bh6RR.createElement)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                            ...props,
                                            disabled: haveToConfirm(props) ? !checkError : false,
                                            style: {
                                                margin: 10
                                            },
                                            onClick: ()=>haveToConfirm() ? checkConfirm() : props.type != "submit" ? onClose() : "",
                                            key: "btn-" + index
                                        })
                                    }))
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
$defe4a8e979bd5d1$var$ApiModal.defaultProps = {
    api: {
        request: null,
        param: []
    },
    buttons: [
        {
            className: "validate",
            label: "Back"
        },
        {
            className: "cancel",
            label: "Leave",
            type: "submit"
        }
    ]
};
var $defe4a8e979bd5d1$export$2e2bcd8739ae039 = $defe4a8e979bd5d1$var$ApiModal;


function $8c1b7af6bdc5aba6$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $8c1b7af6bdc5aba6$export$2e2bcd8739ae039 = $8c1b7af6bdc5aba6$var$capitalizeFirstLetter;


const $df9ad4654a227866$export$3ae94a2503e890a1 = (date)=>{
    let _date = new Date(date);
    let result = _date.getDate() + " " + _date.toLocaleString("en-EU", {
        month: "short"
    }) + " " + _date.getFullYear();
    //let result =  _date.getFullYear()+" "  + _date.toLocaleString('en-EU',{month: 'short'}) + " "  + _date.getDay()
    return result;
};


/**
 * React Router DOM v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");

/**
 * @remix-run/router v1.20.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $b8f852338811df1a$var$_extends() {
    $b8f852338811df1a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b8f852338811df1a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $b8f852338811df1a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($b8f852338811df1a$export$e19cd5f9376f8cee || ($b8f852338811df1a$export$e19cd5f9376f8cee = {}));
const $b8f852338811df1a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $b8f852338811df1a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $b8f852338811df1a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $b8f852338811df1a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $b8f852338811df1a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $b8f852338811df1a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
    }
    return $b8f852338811df1a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $b8f852338811df1a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $b8f852338811df1a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $b8f852338811df1a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $b8f852338811df1a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $b8f852338811df1a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $b8f852338811df1a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $b8f852338811df1a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $b8f852338811df1a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $b8f852338811df1a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $b8f852338811df1a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $b8f852338811df1a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $b8f852338811df1a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $b8f852338811df1a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $b8f852338811df1a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $b8f852338811df1a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($b8f852338811df1a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        let location = $b8f852338811df1a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $b8f852338811df1a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        let location = $b8f852338811df1a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $b8f852338811df1a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $b8f852338811df1a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($b8f852338811df1a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($b8f852338811df1a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $b8f852338811df1a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($b8f852338811df1a$var$ResultType || ($b8f852338811df1a$var$ResultType = {}));
const $b8f852338811df1a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $b8f852338811df1a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $b8f852338811df1a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $b8f852338811df1a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $b8f852338811df1a$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($b8f852338811df1a$var$isIndexRoute(route)) {
            let indexRoute = $b8f852338811df1a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $b8f852338811df1a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $b8f852338811df1a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $b8f852338811df1a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $b8f852338811df1a$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $b8f852338811df1a$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $b8f852338811df1a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $b8f852338811df1a$var$flattenRoutes(routes);
    $b8f852338811df1a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $b8f852338811df1a$export$30d21fd6d7295f52(pathname);
        matches = $b8f852338811df1a$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $b8f852338811df1a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $b8f852338811df1a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $b8f852338811df1a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $b8f852338811df1a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $b8f852338811df1a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $b8f852338811df1a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $b8f852338811df1a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $b8f852338811df1a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $b8f852338811df1a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $b8f852338811df1a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $b8f852338811df1a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $b8f852338811df1a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $b8f852338811df1a$var$paramRe = /^:[\w-]+$/;
const $b8f852338811df1a$var$dynamicSegmentValue = 3;
const $b8f852338811df1a$var$indexRouteValue = 2;
const $b8f852338811df1a$var$emptySegmentValue = 1;
const $b8f852338811df1a$var$staticSegmentValue = 10;
const $b8f852338811df1a$var$splatPenalty = -2;
const $b8f852338811df1a$var$isSplat = (s)=>s === "*";
function $b8f852338811df1a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($b8f852338811df1a$var$isSplat)) initialScore += $b8f852338811df1a$var$splatPenalty;
    if (index) initialScore += $b8f852338811df1a$var$indexRouteValue;
    return segments.filter((s)=>!$b8f852338811df1a$var$isSplat(s)).reduce((score, segment)=>score + ($b8f852338811df1a$var$paramRe.test(segment) ? $b8f852338811df1a$var$dynamicSegmentValue : segment === "" ? $b8f852338811df1a$var$emptySegmentValue : $b8f852338811df1a$var$staticSegmentValue), initialScore);
}
function $b8f852338811df1a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $b8f852338811df1a$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $b8f852338811df1a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $b8f852338811df1a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $b8f852338811df1a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $b8f852338811df1a$export$a5c6d149b50c1d86($b8f852338811df1a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $b8f852338811df1a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $b8f852338811df1a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $b8f852338811df1a$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $b8f852338811df1a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $b8f852338811df1a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $b8f852338811df1a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $b8f852338811df1a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $b8f852338811df1a$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $b8f852338811df1a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $b8f852338811df1a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $b8f852338811df1a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $b8f852338811df1a$var$normalizeSearch(search),
        hash: $b8f852338811df1a$var$normalizeHash(hash)
    };
}
function $b8f852338811df1a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $b8f852338811df1a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $b8f852338811df1a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $b8f852338811df1a$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $b8f852338811df1a$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $b8f852338811df1a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $b8f852338811df1a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $b8f852338811df1a$var$_extends({}, toArg);
        $b8f852338811df1a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $b8f852338811df1a$var$getInvalidPathError("?", "pathname", "search", to));
        $b8f852338811df1a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $b8f852338811df1a$var$getInvalidPathError("#", "pathname", "hash", to));
        $b8f852338811df1a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $b8f852338811df1a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $b8f852338811df1a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $b8f852338811df1a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $b8f852338811df1a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $b8f852338811df1a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $b8f852338811df1a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $b8f852338811df1a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $b8f852338811df1a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $b8f852338811df1a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $b8f852338811df1a$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $b8f852338811df1a$export$4051a07651545597(data, init) {
    return new $b8f852338811df1a$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $b8f852338811df1a$export$42a99a7a4bc0e76a extends Error {
}
class $b8f852338811df1a$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $b8f852338811df1a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $b8f852338811df1a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $b8f852338811df1a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $b8f852338811df1a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $b8f852338811df1a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $b8f852338811df1a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $b8f852338811df1a$var$unwrapTrackedPromise(value) {
    if (!$b8f852338811df1a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $b8f852338811df1a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $b8f852338811df1a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b8f852338811df1a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $b8f852338811df1a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b8f852338811df1a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $b8f852338811df1a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b8f852338811df1a$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $b8f852338811df1a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $b8f852338811df1a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $b8f852338811df1a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $b8f852338811df1a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $b8f852338811df1a$var$validMutationMethods = new Set($b8f852338811df1a$var$validMutationMethodsArr);
const $b8f852338811df1a$var$validRequestMethodsArr = [
    "get",
    ...$b8f852338811df1a$var$validMutationMethodsArr
];
const $b8f852338811df1a$var$validRequestMethods = new Set($b8f852338811df1a$var$validRequestMethodsArr);
const $b8f852338811df1a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $b8f852338811df1a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $b8f852338811df1a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b8f852338811df1a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b8f852338811df1a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $b8f852338811df1a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $b8f852338811df1a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $b8f852338811df1a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $b8f852338811df1a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $b8f852338811df1a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b8f852338811df1a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $b8f852338811df1a$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $b8f852338811df1a$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$b8f852338811df1a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$b8f852338811df1a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $b8f852338811df1a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $b8f852338811df1a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $b8f852338811df1a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $b8f852338811df1a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$b8f852338811df1a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($b8f852338811df1a$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $b8f852338811df1a$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $b8f852338811df1a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $b8f852338811df1a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $b8f852338811df1a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $b8f852338811df1a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($b8f852338811df1a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $b8f852338811df1a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $b8f852338811df1a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $b8f852338811df1a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $b8f852338811df1a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $b8f852338811df1a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $b8f852338811df1a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $b8f852338811df1a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $b8f852338811df1a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $b8f852338811df1a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $b8f852338811df1a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $b8f852338811df1a$var$findNearestBoundary(matches).route.id,
            {
                type: $b8f852338811df1a$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $b8f852338811df1a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($b8f852338811df1a$var$isErrorResult(result) && $b8f852338811df1a$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $b8f852338811df1a$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $b8f852338811df1a$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $b8f852338811df1a$var$_extends({
            matches: updatedMatches || matches
        }, $b8f852338811df1a$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $b8f852338811df1a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $b8f852338811df1a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $b8f852338811df1a$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $b8f852338811df1a$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $b8f852338811df1a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $b8f852338811df1a$var$ResultType.error,
            error: $b8f852338811df1a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($b8f852338811df1a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $b8f852338811df1a$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($b8f852338811df1a$var$isDeferredResult(result)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $b8f852338811df1a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $b8f852338811df1a$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($b8f852338811df1a$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $b8f852338811df1a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $b8f852338811df1a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $b8f852338811df1a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $b8f852338811df1a$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $b8f852338811df1a$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $b8f852338811df1a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $b8f852338811df1a$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $b8f852338811df1a$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$b8f852338811df1a$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $b8f852338811df1a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $b8f852338811df1a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $b8f852338811df1a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $b8f852338811df1a$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $b8f852338811df1a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b8f852338811df1a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $b8f852338811df1a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $b8f852338811df1a$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($b8f852338811df1a$var$isRedirectResult(actionResult) || $b8f852338811df1a$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($b8f852338811df1a$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $b8f852338811df1a$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($b8f852338811df1a$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($b8f852338811df1a$var$isDeferredResult(actionResult)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $b8f852338811df1a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $b8f852338811df1a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $b8f852338811df1a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $b8f852338811df1a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $b8f852338811df1a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $b8f852338811df1a$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $b8f852338811df1a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $b8f852338811df1a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $b8f852338811df1a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b8f852338811df1a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $b8f852338811df1a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $b8f852338811df1a$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($b8f852338811df1a$var$isDeferredResult(result)) result = await $b8f852338811df1a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($b8f852338811df1a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $b8f852338811df1a$export$3e9cee6b33872309(!$b8f852338811df1a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $b8f852338811df1a$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $b8f852338811df1a$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $b8f852338811df1a$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $b8f852338811df1a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $b8f852338811df1a$export$e19cd5f9376f8cee.Replace : $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $b8f852338811df1a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($b8f852338811df1a$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $b8f852338811df1a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $b8f852338811df1a$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $b8f852338811df1a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $b8f852338811df1a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $b8f852338811df1a$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($b8f852338811df1a$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $b8f852338811df1a$var$ResultType.redirect,
                response: $b8f852338811df1a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $b8f852338811df1a$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $b8f852338811df1a$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $b8f852338811df1a$var$ResultType.error,
                    error: $b8f852338811df1a$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $b8f852338811df1a$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $b8f852338811df1a$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $b8f852338811df1a$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $b8f852338811df1a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $b8f852338811df1a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $b8f852338811df1a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $b8f852338811df1a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $b8f852338811df1a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $b8f852338811df1a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $b8f852338811df1a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$b8f852338811df1a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $b8f852338811df1a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $b8f852338811df1a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $b8f852338811df1a$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $b8f852338811df1a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $b8f852338811df1a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $b8f852338811df1a$export$4d0306f8f6a4585b = Symbol("deferred");
function $b8f852338811df1a$export$3336b097a6fbc59a(routes, opts) {
    $b8f852338811df1a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b8f852338811df1a$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $b8f852338811df1a$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b8f852338811df1a$var$createLocation("", $b8f852338811df1a$export$fe53371bee54353d(url), null, "default");
        let matches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b8f852338811df1a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($b8f852338811df1a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $b8f852338811df1a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b8f852338811df1a$var$createLocation("", $b8f852338811df1a$export$fe53371bee54353d(url), null, "default");
        let matches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b8f852338811df1a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $b8f852338811df1a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $b8f852338811df1a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $b8f852338811df1a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($b8f852338811df1a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$b8f852338811df1a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $b8f852338811df1a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($b8f852338811df1a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $b8f852338811df1a$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $b8f852338811df1a$var$isResponse(result) ? result : $b8f852338811df1a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($b8f852338811df1a$var$isDataStrategyResult(e) && $b8f852338811df1a$var$isResponse(e.result)) {
                if (e.type === $b8f852338811df1a$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($b8f852338811df1a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b8f852338811df1a$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $b8f852338811df1a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($b8f852338811df1a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($b8f852338811df1a$var$isDeferredResult(result)) {
            let error = $b8f852338811df1a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b8f852338811df1a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($b8f852338811df1a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $b8f852338811df1a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $b8f852338811df1a$var$_extends({}, context, {
                statusCode: $b8f852338811df1a$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $b8f852338811df1a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $b8f852338811df1a$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $b8f852338811df1a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $b8f852338811df1a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $b8f852338811df1a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $b8f852338811df1a$var$callDataStrategyImpl(dataStrategy || $b8f852338811df1a$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($b8f852338811df1a$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $b8f852338811df1a$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($b8f852338811df1a$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $b8f852338811df1a$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $b8f852338811df1a$export$fec11da027c70692(routes, context, error) {
    let newContext = $b8f852338811df1a$var$_extends({}, context, {
        statusCode: $b8f852338811df1a$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $b8f852338811df1a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $b8f852338811df1a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $b8f852338811df1a$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $b8f852338811df1a$export$cae722b0cc860f13(to ? to : ".", $b8f852338811df1a$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $b8f852338811df1a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $b8f852338811df1a$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $b8f852338811df1a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $b8f852338811df1a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $b8f852338811df1a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$b8f852338811df1a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$b8f852338811df1a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $b8f852338811df1a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $b8f852338811df1a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $b8f852338811df1a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$b8f852338811df1a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$b8f852338811df1a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $b8f852338811df1a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $b8f852338811df1a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $b8f852338811df1a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($b8f852338811df1a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $b8f852338811df1a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $b8f852338811df1a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $b8f852338811df1a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $b8f852338811df1a$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $b8f852338811df1a$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($b8f852338811df1a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $b8f852338811df1a$var$shouldRevalidateLoader(match, $b8f852338811df1a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $b8f852338811df1a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $b8f852338811df1a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $b8f852338811df1a$var$shouldRevalidateLoader(fetcherMatch, $b8f852338811df1a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $b8f852338811df1a$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $b8f852338811df1a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $b8f852338811df1a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $b8f852338811df1a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $b8f852338811df1a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $b8f852338811df1a$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$b8f852338811df1a$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $b8f852338811df1a$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$b8f852338811df1a$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $b8f852338811df1a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $b8f852338811df1a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $b8f852338811df1a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$b8f852338811df1a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $b8f852338811df1a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $b8f852338811df1a$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $b8f852338811df1a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $b8f852338811df1a$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $b8f852338811df1a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $b8f852338811df1a$var$ResultType.data,
                result: undefined
            });
        };
        return $b8f852338811df1a$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $b8f852338811df1a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $b8f852338811df1a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $b8f852338811df1a$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $b8f852338811df1a$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $b8f852338811df1a$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $b8f852338811df1a$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($b8f852338811df1a$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $b8f852338811df1a$var$ResultType.error,
                error: e
            };
        }
        if (type === $b8f852338811df1a$var$ResultType.error) return {
            type: $b8f852338811df1a$var$ResultType.error,
            error: new $b8f852338811df1a$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $b8f852338811df1a$var$ResultType.error) {
        if ($b8f852338811df1a$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $b8f852338811df1a$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $b8f852338811df1a$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $b8f852338811df1a$var$ResultType.error,
            error: result,
            statusCode: $b8f852338811df1a$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($b8f852338811df1a$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $b8f852338811df1a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($b8f852338811df1a$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $b8f852338811df1a$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $b8f852338811df1a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $b8f852338811df1a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $b8f852338811df1a$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $b8f852338811df1a$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $b8f852338811df1a$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $b8f852338811df1a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($b8f852338811df1a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $b8f852338811df1a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $b8f852338811df1a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $b8f852338811df1a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $b8f852338811df1a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $b8f852338811df1a$export$3e9cee6b33872309(!$b8f852338811df1a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $b8f852338811df1a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($b8f852338811df1a$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $b8f852338811df1a$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $b8f852338811df1a$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($b8f852338811df1a$var$isErrorResult(result)) {
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $b8f852338811df1a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($b8f852338811df1a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $b8f852338811df1a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($b8f852338811df1a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $b8f852338811df1a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $b8f852338811df1a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $b8f852338811df1a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $b8f852338811df1a$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $b8f852338811df1a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $b8f852338811df1a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $b8f852338811df1a$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $b8f852338811df1a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $b8f852338811df1a$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($b8f852338811df1a$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $b8f852338811df1a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(path) : path;
    return $b8f852338811df1a$export$fe53371bee54353d($b8f852338811df1a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $b8f852338811df1a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $b8f852338811df1a$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $b8f852338811df1a$var$ResultType.data || result.type === $b8f852338811df1a$var$ResultType.error);
}
function $b8f852338811df1a$var$isRedirectDataStrategyResultResult(result) {
    return $b8f852338811df1a$var$isResponse(result.result) && $b8f852338811df1a$var$redirectStatusCodes.has(result.result.status);
}
function $b8f852338811df1a$var$isDeferredResult(result) {
    return result.type === $b8f852338811df1a$var$ResultType.deferred;
}
function $b8f852338811df1a$var$isErrorResult(result) {
    return result.type === $b8f852338811df1a$var$ResultType.error;
}
function $b8f852338811df1a$var$isRedirectResult(result) {
    return (result && result.type) === $b8f852338811df1a$var$ResultType.redirect;
}
function $b8f852338811df1a$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $b8f852338811df1a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $b8f852338811df1a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $b8f852338811df1a$var$isRedirectResponse(result) {
    if (!$b8f852338811df1a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $b8f852338811df1a$var$isValidMethod(method) {
    return $b8f852338811df1a$var$validRequestMethods.has(method.toLowerCase());
}
function $b8f852338811df1a$var$isMutationMethod(method) {
    return $b8f852338811df1a$var$validMutationMethods.has(method.toLowerCase());
}
async function $b8f852338811df1a$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$b8f852338811df1a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($b8f852338811df1a$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $b8f852338811df1a$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $b8f852338811df1a$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($b8f852338811df1a$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $b8f852338811df1a$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $b8f852338811df1a$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $b8f852338811df1a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $b8f852338811df1a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $b8f852338811df1a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $b8f852338811df1a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $b8f852338811df1a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $b8f852338811df1a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $b8f852338811df1a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $b8f852338811df1a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $b8f852338811df1a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $b8f852338811df1a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $b8f852338811df1a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $b8f852338811df1a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $b8f852338811df1a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $b8f852338811df1a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($b8f852338811df1a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $b8f852338811df1a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($b8f852338811df1a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $b8f852338811df1a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");

function $6a9dcc96d11bcd0d$var$_extends() {
    $6a9dcc96d11bcd0d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a9dcc96d11bcd0d$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $6a9dcc96d11bcd0d$export$3add0d5dce533e2e = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$145dfa71566a64dc = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$var$AwaitContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $6a9dcc96d11bcd0d$export$26749e8557646306 = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$c7914228fb69b0f5 = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$9072aa6dd1f93057 = /*#__PURE__*/ $bh6RR.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $6a9dcc96d11bcd0d$var$RouteErrorContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $6a9dcc96d11bcd0d$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $b8f852338811df1a$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $6a9dcc96d11bcd0d$export$45d76561a5302f2b() {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $6a9dcc96d11bcd0d$export$1b3f31771c5d07c() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $6a9dcc96d11bcd0d$export$6c330e8992e8a295(pattern) {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    return $bh6RR.useMemo(()=>(0, $b8f852338811df1a$export$81336c211d5ff295)(pattern, (0, $b8f852338811df1a$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $6a9dcc96d11bcd0d$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $bh6RR.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $6a9dcc96d11bcd0d$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $6a9dcc96d11bcd0d$var$useNavigateStable() : $6a9dcc96d11bcd0d$var$useNavigateUnstable();
}
function $6a9dcc96d11bcd0d$var$useNavigateUnstable() {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let dataRouterContext = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $b8f852338811df1a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $bh6RR.useRef(false);
    $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $b8f852338811df1a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $b8f852338811df1a$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $6a9dcc96d11bcd0d$var$OutletContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $6a9dcc96d11bcd0d$export$4138103a3ae699cc() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $6a9dcc96d11bcd0d$export$a3be3530d8e40d0b(context) {
    let outlet = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $6a9dcc96d11bcd0d$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $b8f852338811df1a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $bh6RR.useMemo(()=>(0, $b8f852338811df1a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $6a9dcc96d11bcd0d$export$5d3fca4a98652595(routes, locationArg) {
    return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: parentMatches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $b8f852338811df1a$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $b8f852338811df1a$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $6a9dcc96d11bcd0d$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $b8f852338811df1a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $b8f852338811df1a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $6a9dcc96d11bcd0d$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $b8f852338811df1a$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $6a9dcc96d11bcd0d$var$DefaultErrorComponent() {
    let error = $6a9dcc96d11bcd0d$export$ed527bf60f6e05f2();
    let message = (0, $b8f852338811df1a$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $bh6RR.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $bh6RR.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $6a9dcc96d11bcd0d$var$defaultErrorElement = /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$DefaultErrorComponent, null);
class $6a9dcc96d11bcd0d$var$RenderErrorBoundary extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $6a9dcc96d11bcd0d$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $6a9dcc96d11bcd0d$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $6a9dcc96d11bcd0d$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $6a9dcc96d11bcd0d$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $bh6RR.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $6a9dcc96d11bcd0d$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($6a9dcc96d11bcd0d$var$DataRouterHook || {});
var $6a9dcc96d11bcd0d$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($6a9dcc96d11bcd0d$var$DataRouterStateHook || {});
function $6a9dcc96d11bcd0d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $6a9dcc96d11bcd0d$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    !ctx && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $6a9dcc96d11bcd0d$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext($6a9dcc96d11bcd0d$export$145dfa71566a64dc);
    !state && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return state;
}
function $6a9dcc96d11bcd0d$var$useRouteContext(hookName) {
    let route = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    !route && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $6a9dcc96d11bcd0d$var$useCurrentRouteId(hookName) {
    let route = $6a9dcc96d11bcd0d$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $6a9dcc96d11bcd0d$export$5fc8298006ad9e58() {
    return $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $6a9dcc96d11bcd0d$export$d0fd4b7106de2769() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $6a9dcc96d11bcd0d$export$600dc272ed516c15() {
    let dataRouterContext = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseRevalidator);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRevalidator);
    return $bh6RR.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $6a9dcc96d11bcd0d$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseMatches);
    return $bh6RR.useMemo(()=>matches.map((m)=>(0, $b8f852338811df1a$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $6a9dcc96d11bcd0d$export$1448a5050d252c4d() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $6a9dcc96d11bcd0d$export$fd5d37484eab868d(routeId) {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $6a9dcc96d11bcd0d$export$fdc00f3f26066d5e() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseActionData);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $6a9dcc96d11bcd0d$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $bh6RR.useContext($6a9dcc96d11bcd0d$var$RouteErrorContext);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteError);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $6a9dcc96d11bcd0d$export$78a72ddb39bdd145() {
    let value = $bh6RR.useContext($6a9dcc96d11bcd0d$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $6a9dcc96d11bcd0d$export$17f53340677d5831() {
    let value = $bh6RR.useContext($6a9dcc96d11bcd0d$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $6a9dcc96d11bcd0d$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $6a9dcc96d11bcd0d$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseBlocker);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $bh6RR.useState("");
    let blockerFunction = $bh6RR.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $6a9dcc96d11bcd0d$var$_extends({}, currentLocation, {
                pathname: (0, $b8f852338811df1a$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $6a9dcc96d11bcd0d$var$_extends({}, nextLocation, {
                pathname: (0, $b8f852338811df1a$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $bh6RR.useEffect(()=>{
        let key = String(++$6a9dcc96d11bcd0d$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $bh6RR.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $b8f852338811df1a$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $6a9dcc96d11bcd0d$var$useNavigateStable() {
    let { router: router } = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseNavigateStable);
    let id = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $bh6RR.useRef(false);
    $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $6a9dcc96d11bcd0d$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $6a9dcc96d11bcd0d$var$alreadyWarned = {};
function $6a9dcc96d11bcd0d$var$warningOnce(key, cond, message) {
    if (!cond && !$6a9dcc96d11bcd0d$var$alreadyWarned[key]) $6a9dcc96d11bcd0d$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $6a9dcc96d11bcd0d$var$START_TRANSITION = "startTransition";
const $6a9dcc96d11bcd0d$var$startTransitionImpl = $bh6RR[$6a9dcc96d11bcd0d$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $6a9dcc96d11bcd0d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $bh6RR.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        if (v7_startTransition && $6a9dcc96d11bcd0d$var$startTransitionImpl) $6a9dcc96d11bcd0d$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $bh6RR.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $bh6RR.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $bh6RR.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bh6RR.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $6a9dcc96d11bcd0d$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $6a9dcc96d11bcd0d$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $b8f852338811df1a$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $6a9dcc96d11bcd0d$var$startTransitionImpl ? $6a9dcc96d11bcd0d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $6a9dcc96d11bcd0d$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let navigate = $6a9dcc96d11bcd0d$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $b8f852338811df1a$export$cae722b0cc860f13)(to, (0, $b8f852338811df1a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $bh6RR.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $6a9dcc96d11bcd0d$export$910ae8079b2c2852(props) {
    return $6a9dcc96d11bcd0d$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6(_props) {
    (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $6a9dcc96d11bcd0d$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $b8f852338811df1a$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $bh6RR.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $6a9dcc96d11bcd0d$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $b8f852338811df1a$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $bh6RR.useMemo(()=>{
        let trailingPathname = (0, $b8f852338811df1a$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $6a9dcc96d11bcd0d$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $6a9dcc96d11bcd0d$export$5d3fca4a98652595($6a9dcc96d11bcd0d$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $6a9dcc96d11bcd0d$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$ResolveAwait, null, children));
}
var $6a9dcc96d11bcd0d$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($6a9dcc96d11bcd0d$var$AwaitRenderStatus || {});
const $6a9dcc96d11bcd0d$var$neverSettledPromise = new Promise(()=>{});
class $6a9dcc96d11bcd0d$var$AwaitErrorBoundary extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error : "_data" in promise ? $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success : $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error && promise._error instanceof (0, $b8f852338811df1a$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $6a9dcc96d11bcd0d$var$neverSettledPromise;
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $6a9dcc96d11bcd0d$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $6a9dcc96d11bcd0d$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $6a9dcc96d11bcd0d$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $bh6RR.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $bh6RR.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $bh6RR.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $6a9dcc96d11bcd0d$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $6a9dcc96d11bcd0d$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $6a9dcc96d11bcd0d$export$daf73786167a7f72(matches) {
    return $6a9dcc96d11bcd0d$var$_renderMatches(matches);
}
function $6a9dcc96d11bcd0d$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $bh6RR.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $bh6RR.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $bh6RR.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $6a9dcc96d11bcd0d$export$f30f7e456d254e83(routes, opts) {
    return (0, $b8f852338811df1a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $6a9dcc96d11bcd0d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $b8f852338811df1a$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $6a9dcc96d11bcd0d$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $0bd3411f2ec14e23$var$_extends() {
    $0bd3411f2ec14e23$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0bd3411f2ec14e23$var$_extends.apply(this, arguments);
}
function $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0bd3411f2ec14e23$var$defaultMethod = "get";
const $0bd3411f2ec14e23$var$defaultEncType = "application/x-www-form-urlencoded";
function $0bd3411f2ec14e23$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0bd3411f2ec14e23$var$isButtonElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0bd3411f2ec14e23$var$isFormElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0bd3411f2ec14e23$var$isInputElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0bd3411f2ec14e23$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0bd3411f2ec14e23$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0bd3411f2ec14e23$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0bd3411f2ec14e23$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = null;
function $0bd3411f2ec14e23$var$isFormDataSubmitterSupported() {
    if ($0bd3411f2ec14e23$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = true;
    }
    return $0bd3411f2ec14e23$var$_formDataSupportsSubmitter;
}
const $0bd3411f2ec14e23$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0bd3411f2ec14e23$var$getFormEncType(encType) {
    if (encType != null && !$0bd3411f2ec14e23$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0bd3411f2ec14e23$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($0bd3411f2ec14e23$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $b8f852338811df1a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $0bd3411f2ec14e23$var$defaultMethod;
        encType = $0bd3411f2ec14e23$var$getFormEncType(target.getAttribute("enctype")) || $0bd3411f2ec14e23$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0bd3411f2ec14e23$var$isButtonElement(target) || $0bd3411f2ec14e23$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $b8f852338811df1a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0bd3411f2ec14e23$var$defaultMethod;
        encType = $0bd3411f2ec14e23$var$getFormEncType(target.getAttribute("formenctype")) || $0bd3411f2ec14e23$var$getFormEncType(form.getAttribute("enctype")) || $0bd3411f2ec14e23$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0bd3411f2ec14e23$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0bd3411f2ec14e23$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0bd3411f2ec14e23$var$defaultMethod;
        action = null;
        encType = $0bd3411f2ec14e23$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $0bd3411f2ec14e23$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $0bd3411f2ec14e23$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $0bd3411f2ec14e23$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $0bd3411f2ec14e23$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $0bd3411f2ec14e23$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $0bd3411f2ec14e23$export$1f3f55432a00e06d(routes, opts) {
    return (0, $b8f852338811df1a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0bd3411f2ec14e23$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $b8f852338811df1a$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0bd3411f2ec14e23$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $6a9dcc96d11bcd0d$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0bd3411f2ec14e23$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $b8f852338811df1a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0bd3411f2ec14e23$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $b8f852338811df1a$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0bd3411f2ec14e23$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $6a9dcc96d11bcd0d$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0bd3411f2ec14e23$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0bd3411f2ec14e23$var$_extends({}, state, {
        errors: $0bd3411f2ec14e23$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0bd3411f2ec14e23$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $b8f852338811df1a$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $0bd3411f2ec14e23$export$7ad602f0e94e62d1 = /*#__PURE__*/ $bh6RR.createContext({
    isTransitioning: false
});
const $0bd3411f2ec14e23$export$148fd98d095596d4 = /*#__PURE__*/ $bh6RR.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0bd3411f2ec14e23$var$START_TRANSITION = "startTransition";
const $0bd3411f2ec14e23$var$startTransitionImpl = $bh6RR[$0bd3411f2ec14e23$var$START_TRANSITION];
const $0bd3411f2ec14e23$var$FLUSH_SYNC = "flushSync";
const $0bd3411f2ec14e23$var$flushSyncImpl = $47cfd4084854a574$exports[$0bd3411f2ec14e23$var$FLUSH_SYNC];
const $0bd3411f2ec14e23$var$USE_ID = "useId";
const $0bd3411f2ec14e23$var$useIdImpl = $bh6RR[$0bd3411f2ec14e23$var$USE_ID];
function $0bd3411f2ec14e23$var$startTransitionSafe(cb) {
    if ($0bd3411f2ec14e23$var$startTransitionImpl) $0bd3411f2ec14e23$var$startTransitionImpl(cb);
    else cb();
}
function $0bd3411f2ec14e23$var$flushSyncSafe(cb) {
    if ($0bd3411f2ec14e23$var$flushSyncImpl) $0bd3411f2ec14e23$var$flushSyncImpl(cb);
    else cb();
}
class $0bd3411f2ec14e23$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0bd3411f2ec14e23$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $bh6RR.useState(router.state);
    let [pendingState, setPendingState] = $bh6RR.useState();
    let [vtContext, setVtContext] = $bh6RR.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $bh6RR.useState();
    let [transition, setTransition] = $bh6RR.useState();
    let [interruption, setInterruption] = $bh6RR.useState();
    let fetcherData = $bh6RR.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $bh6RR.useCallback((cb)=>{
        if (v7_startTransition) $0bd3411f2ec14e23$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $bh6RR.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $0bd3411f2ec14e23$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $0bd3411f2ec14e23$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $0bd3411f2ec14e23$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $0bd3411f2ec14e23$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $0bd3411f2ec14e23$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $bh6RR.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $bh6RR.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $0bd3411f2ec14e23$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $bh6RR.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $bh6RR.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $bh6RR.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $bh6RR.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $bh6RR.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bh6RR.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $bh6RR.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $0bd3411f2ec14e23$var$MemoizedDataRoutes = /*#__PURE__*/ $bh6RR.memo($0bd3411f2ec14e23$var$DataRoutes);
function $0bd3411f2ec14e23$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $6a9dcc96d11bcd0d$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0bd3411f2ec14e23$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $b8f852338811df1a$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0bd3411f2ec14e23$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $b8f852338811df1a$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0bd3411f2ec14e23$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $0bd3411f2ec14e23$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $0bd3411f2ec14e23$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $0bd3411f2ec14e23$export$a6c7ac8248d6e38a = /*#__PURE__*/ $bh6RR.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref7, $0bd3411f2ec14e23$var$_excluded);
    let { basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $0bd3411f2ec14e23$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0bd3411f2ec14e23$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $b8f852338811df1a$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $6a9dcc96d11bcd0d$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $0bd3411f2ec14e23$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $bh6RR.createElement("a", $0bd3411f2ec14e23$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $0bd3411f2ec14e23$export$b0d92dbee9b5b60d = /*#__PURE__*/ $bh6RR.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref8, $0bd3411f2ec14e23$var$_excluded2);
    let path = (0, $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    let routerState = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $0bd3411f2ec14e23$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $b8f852338811df1a$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$a6c7ac8248d6e38a, $0bd3411f2ec14e23$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $0bd3411f2ec14e23$export$a7fed597f4b8afd8 = /*#__PURE__*/ $bh6RR.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $0bd3411f2ec14e23$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref9, $0bd3411f2ec14e23$var$_excluded3);
    let submit = $0bd3411f2ec14e23$export$47c85c6e3a081d3();
    let formAction = $0bd3411f2ec14e23$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $bh6RR.createElement("form", $0bd3411f2ec14e23$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0bd3411f2ec14e23$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $0bd3411f2ec14e23$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0bd3411f2ec14e23$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($0bd3411f2ec14e23$var$DataRouterHook || ($0bd3411f2ec14e23$var$DataRouterHook = {}));
var $0bd3411f2ec14e23$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0bd3411f2ec14e23$var$DataRouterStateHook || ($0bd3411f2ec14e23$var$DataRouterStateHook = {}));
// Internal hooks
function $0bd3411f2ec14e23$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $0bd3411f2ec14e23$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$3add0d5dce533e2e));
    !ctx && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $0bd3411f2ec14e23$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$145dfa71566a64dc));
    !state && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0bd3411f2ec14e23$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    let path = (0, $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $bh6RR.useCallback((event)=>{
        if ($0bd3411f2ec14e23$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $b8f852338811df1a$export$fe53371bee54353d)(location) === (0, $b8f852338811df1a$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0bd3411f2ec14e23$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $bh6RR.useRef($0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $bh6RR.useRef(false);
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    let searchParams = $bh6RR.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0bd3411f2ec14e23$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    let setSearchParams = $bh6RR.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0bd3411f2ec14e23$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $0bd3411f2ec14e23$var$fetcherId = 0;
let $0bd3411f2ec14e23$var$getUniqueFetcherId = ()=>"__" + String(++$0bd3411f2ec14e23$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0bd3411f2ec14e23$export$47c85c6e3a081d3() {
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    let currentRouteId = (0, $6a9dcc96d11bcd0d$export$5fc8298006ad9e58)();
    return $bh6RR.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0bd3411f2ec14e23$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0bd3411f2ec14e23$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $0bd3411f2ec14e23$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0bd3411f2ec14e23$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    let routeContext = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$9072aa6dd1f93057));
    !routeContext && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $0bd3411f2ec14e23$var$_extends({}, (0, $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $b8f852338811df1a$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $b8f852338811df1a$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0bd3411f2ec14e23$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseFetcher);
    let state = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $bh6RR.useContext($0bd3411f2ec14e23$export$148fd98d095596d4);
    let route = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    !route && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $0bd3411f2ec14e23$var$useIdImpl ? $0bd3411f2ec14e23$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $bh6RR.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($0bd3411f2ec14e23$var$getUniqueFetcherId());
    // Registration/cleanup
    $bh6RR.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $bh6RR.useCallback((href, opts)=>{
        !routeId && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $0bd3411f2ec14e23$export$47c85c6e3a081d3();
    let submit = $bh6RR.useCallback((target, opts)=>{
        submitImpl(target, $0bd3411f2ec14e23$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $bh6RR.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $bh6RR.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$a7fed597f4b8afd8, $0bd3411f2ec14e23$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $b8f852338811df1a$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $bh6RR.useMemo(()=>$0bd3411f2ec14e23$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0bd3411f2ec14e23$export$fa996778a3a31087() {
    let state = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $0bd3411f2ec14e23$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $0bd3411f2ec14e23$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0bd3411f2ec14e23$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    let matches = (0, $6a9dcc96d11bcd0d$export$2378eb7f5ff86053)();
    let navigation = (0, $6a9dcc96d11bcd0d$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $bh6RR.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0bd3411f2ec14e23$var$usePageHide($bh6RR.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $0bd3411f2ec14e23$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0bd3411f2ec14e23$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0bd3411f2ec14e23$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($0bd3411f2ec14e23$var$_extends({}, location, {
                    pathname: (0, $b8f852338811df1a$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0bd3411f2ec14e23$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0bd3411f2ec14e23$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0bd3411f2ec14e23$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0bd3411f2ec14e23$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $6a9dcc96d11bcd0d$export$b273b3273281a049)(when);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $0bd3411f2ec14e23$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $bh6RR.useContext($0bd3411f2ec14e23$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { basename: basename } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.useViewTransitionState);
    let path = (0, $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $b8f852338811df1a$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $b8f852338811df1a$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $b8f852338811df1a$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $b8f852338811df1a$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




function $2ec34e35a5139fe7$var$getCutToken(token) {
    return token[0] + [
        token[1]
    ] + "***" + token[token.length - 2] + token[token.length - 1];
}
var $2ec34e35a5139fe7$export$2e2bcd8739ae039 = $2ec34e35a5139fe7$var$getCutToken;



const $a6b02690ee57318b$var$storage = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session");
function $a6b02690ee57318b$var$urlWithRoutingCompany(url) {
    if (url == "") return url;
    url = url.charAt(0) === "/" ? url : `/${url}`;
    const company = $a6b02690ee57318b$var$storage.get("company");
    return company ? `/company/${company.name}${url}` : url;
}
var $a6b02690ee57318b$export$2e2bcd8739ae039 = $a6b02690ee57318b$var$urlWithRoutingCompany;





function $a7b361f9108b1dc4$var$hasPermission(permission = "") {
    var permissions = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)().get("permissions");
    permissions = permissions ? permissions : [];
    return permissions.includes(permission);
}
var $a7b361f9108b1dc4$export$2e2bcd8739ae039 = $a7b361f9108b1dc4$var$hasPermission;


function $91027c650cc118d9$var$BotTable() {
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const { getBots: getBots, deleteBot: deleteBot } = (0, $24a8370de200c756$export$2e2bcd8739ae039);
    const company = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company");
    const cells = [
        {
            column: "Name",
            name: "name",
            sort: true,
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    style: {
                        fontWeight: 700,
                        color: (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_bot") ? "var(--main)" : "",
                        cursor: (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_bot") ? "pointer" : ""
                    },
                    onClick: ()=>{
                        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_bot") && onClickRedirect({
                            row: {
                                name: value
                            }
                        });
                    },
                    children: value
                })
        },
        {
            column: "Language",
            name: "language.slug",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: "flag-icon flag-icon-" + value.toLowerCase()
                })
        },
        {
            column: "Token",
            name: "secret_token",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    style: {
                        color: "var(--main)",
                        cursor: "pointer"
                    },
                    onClick: (e)=>navigator.clipboard.writeText(value).then((_)=>{
                            toast.success("Copy token to clipboard", "You can paste this token where you need !", 5000);
                        }),
                    children: [
                        " ",
                        (0, $2ec34e35a5139fe7$export$2e2bcd8739ae039)(value)
                    ]
                })
        },
        {
            column: "Api's URL",
            name: "id",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    style: {
                        color: "var(--main)",
                        cursor: "pointer"
                    },
                    onClick: (e)=>navigator.clipboard.writeText((0, $651df53b10514175$export$a7b6bc01c63cdfc3).REACT_APP_API_PATH.split("/api/v1")[0] + "/" + company.name + "/bots/" + value + "/api/telephony").then((_)=>{
                            toast.success("Copy token to clipboard", "You can paste this token where you need !", 5000);
                        }),
                    children: [
                        " ",
                        (0, $2ec34e35a5139fe7$export$2e2bcd8739ae039)((0, $651df53b10514175$export$a7b6bc01c63cdfc3).REACT_APP_API_PATH.split("/api/v1")[0] + "/" + company.name + "/bots/" + value + "/api/telephony"),
                        " "
                    ]
                })
        },
        {
            column: "Description",
            name: "description",
            show: (value)=>(0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value)
        },
        {
            column: "Last Opening",
            name: "updated_at",
            sort: true,
            show: (value)=>(0, $df9ad4654a227866$export$3ae94a2503e890a1)(value)
        },
        {
            column: "Save Conversation",
            name: "conversation_storage_time",
            show: (value)=>value > 0 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    className: "fa fa-check",
                    "aria-hidden": "true",
                    style: {
                        color: "var(--main)"
                    }
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    style: {
                        color: "var(--main)",
                        fontWeight: "bolder"
                    },
                    children: "X"
                })
        }
    ];
    const onClickUpdate = ({ row: row })=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/bot/update"), {
            state: {
                data: row,
                type: "update"
            }
        });
    const onClickRedirect = ({ row: row })=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/bots/" + row.name));
    //const onClickAdd = ({row, addRow}) => ModalManager.show(LogoutModal).then((bot) => addRow(bot));
    const onClickAdd = ({ deleteRow: deleteRow, row: row })=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/bot/create"));
    const onClickDelete = ({ row: row, deleteRow: deleteRow })=>{
        const { id: id, name: name } = row;
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete bot " + name,
            body: "Do you really want to delete bot " + name,
            api: {
                request: deleteBot,
                param: [
                    id
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel"
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ],
            confirm: {
                name: name,
                fieldName: "the bot"
            },
            maxTitleSize: 40
        }).then((res)=>{
            if (res != null && res.data.includes("dashboard_variables")) toast.error("Error", "Please, remove the dashboard of the bot first.", 5000);
            else deleteRow(id);
        });
    };
    const actions = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_bot") ? {
            className: "fas fa-cog action-button edit_action",
            style: {},
            onClick: onClickUpdate
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_bot") ? {
            className: "fas fa-edit action-button profil_action",
            style: {},
            onClick: onClickRedirect
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("delete_bot") ? {
            className: "fas fa-trash action-button delete_action",
            style: {},
            onClick: onClickDelete
        } : null
    ].filter((action)=>action);
    const buttons = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("create_bot") ? {
            icon: "fas fa-plus",
            onClick: onClickAdd
        } : null
    ].filter((button)=>button);
    const filters = [
        {
            type: "input",
            placeholder: "content",
            name: "term"
        }
    ];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
        name: "bot",
        cells: cells,
        api: getBots,
        actions: actions,
        buttons: buttons,
        filters: filters
    });
}
var $91027c650cc118d9$export$2e2bcd8739ae039 = $91027c650cc118d9$var$BotTable;









function $a26f7444c0186fbf$var$BotSharedTable() {
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const { getBots: getBots, deleteBot: deleteBot, getBotsShared: getBotsShared } = (0, $24a8370de200c756$export$2e2bcd8739ae039);
    const cells = [
        {
            column: "Company",
            name: "company",
            sort: true,
            show: (company)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    srcSet: company.logo,
                    title: company.name,
                    alt: ""
                })
        },
        {
            column: "Name",
            name: "name",
            sort: true,
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    style: {
                        fontWeight: 700
                    },
                    children: value
                })
        },
        {
            column: "Language",
            name: "language.slug",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: "flag-icon flag-icon-" + value.toLowerCase()
                })
        },
        {
            column: "Description",
            name: "description",
            show: (value)=>(0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value)
        },
        {
            column: "Updated",
            name: "updated_at",
            sort: true,
            show: (value)=>(0, $df9ad4654a227866$export$3ae94a2503e890a1)(value)
        }
    ];
    const actions = [];
    const buttons = [];
    const filters = [
        {
            type: "input",
            placeholder: "content",
            name: "name"
        }
    ];
    const filtersAscending = [
        "name"
    ];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
        name: "bot",
        cells: cells,
        api: getBotsShared,
        actions: actions,
        buttons: buttons,
        filters: filters,
        filtersAscending: filtersAscending
    });
}
var $a26f7444c0186fbf$export$2e2bcd8739ae039 = $a26f7444c0186fbf$var$BotSharedTable;




function $a2ebea23332d16de$var$Page({ children: children }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "page main",
        children: children
    });
}
var $a2ebea23332d16de$export$2e2bcd8739ae039 = $a2ebea23332d16de$var$Page;





var $kEUo3 = parcelRequire("kEUo3");
function $87df71fcaf55612a$var$Header({ title: title, children: children }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "page-bar",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "title",
                children: (0, $kEUo3.isString)(title) ? decodeURI(title) : title
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "buttons",
                children: children
            })
        ]
    });
}
var $87df71fcaf55612a$export$2e2bcd8739ae039 = $87df71fcaf55612a$var$Header;




parcelRequire("bh6RR");

function $146a258308c2cc54$var$BackgroundForm({ children: children, className: className }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "background-form" + (className ? " " + className : ""),
        children: children
    });
}
$146a258308c2cc54$var$BackgroundForm.defaultProps = {
    className: ""
};
var $146a258308c2cc54$export$2e2bcd8739ae039 = $146a258308c2cc54$var$BackgroundForm;



function $afaae2ff7871e331$var$PageForm({ children: children, className: className }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a2ebea23332d16de$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $146a258308c2cc54$export$2e2bcd8739ae039), {
            className: className,
            children: children
        })
    });
}
var $afaae2ff7871e331$export$2e2bcd8739ae039 = $afaae2ff7871e331$var$PageForm;




parcelRequire("bh6RR");

function $39d24cfebf884af5$var$BackgroundTable({ children: children }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "background-table",
        children: children
    });
}
var $39d24cfebf884af5$export$2e2bcd8739ae039 = $39d24cfebf884af5$var$BackgroundTable;



function $09ce86192bc64e9b$var$PageTable({ children: children }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a2ebea23332d16de$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $39d24cfebf884af5$export$2e2bcd8739ae039), {
            children: children
        })
    });
}
var $09ce86192bc64e9b$export$2e2bcd8739ae039 = $09ce86192bc64e9b$var$PageTable;


var $15a6adcb4c3af47e$export$2e2bcd8739ae039 = (0, $a2ebea23332d16de$export$2e2bcd8739ae039);




var $bh6RR = parcelRequire("bh6RR");



function $347e978f9327938b$var$Slide({ children: children, name: name, className: className }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "slide " + (className ? className : ""),
        "data-name": name,
        children: children
    });
}
var $347e978f9327938b$export$2e2bcd8739ae039 = $347e978f9327938b$var$Slide;




function $cc31dd1cf3eca5a2$var$SlidesContainer({ children: children, className: className }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "slides-container " + (className ? className : ""),
        children: children
    });
}
var $cc31dd1cf3eca5a2$export$2e2bcd8739ae039 = $cc31dd1cf3eca5a2$var$SlidesContainer;


function $f125b7375f0f7cdc$var$ScrollIntoSlide(slide, instanceClass) {
    instanceClass = instanceClass ? `.${instanceClass}` : "";
    const slides = [
        ...document.querySelectorAll(`.slide${instanceClass}`)
    ];
    slides.forEach((element)=>element.getAttribute("data-name") == slide ? element.scrollIntoView() : null);
}
var $f125b7375f0f7cdc$export$2e2bcd8739ae039 = $f125b7375f0f7cdc$var$ScrollIntoSlide;


var $51a8b46ec4198ef9$export$2e2bcd8739ae039 = (0, $cc31dd1cf3eca5a2$export$2e2bcd8739ae039);


const $83ec58cdee3d9422$var$generateKey = ()=>[
        ...Array(10)
    ].map(()=>"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"[Math.floor(Math.random() * 62)]).join("");
var $83ec58cdee3d9422$export$2e2bcd8739ae039 = $83ec58cdee3d9422$var$generateKey;


function $297630b888b8597e$var$SliderTab({ items: items, classNameTab: classNameTab, classNameIndicator: classNameIndicator, name: name, type: type, onTabChange: onTabChange }) {
    const [selectedIndex, setSelectedIndex] = (0, $bh6RR.useState)(0);
    const [itemsListed, setItemsListed] = (0, $bh6RR.useState)(items);
    // const { selectedTabName, setSelectedTabName } = useContext(TabNameContext);
    const handleItemClick = (index)=>{
        setSelectedIndex(index);
        if (onTabChange) onTabChange(index, items[index].type);
        (0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)(items[index].name, name);
    };
    const getSearchTableContainer = ()=>{
        return [
            ...document.getElementsByClassName("search-container")
        ];
    };
    const cloneSearchContainer = ()=>{
        const searchContainerBis = document.querySelector(".search-container-bis");
        searchContainerBis.innerHTML = "";
        const searchContainerFirst = getSearchTableContainer()[selectedIndex];
        const searchContainerFirstClone = searchContainerFirst.cloneNode(true);
        searchContainerFirstClone.style.display = "flex";
        const buttonsFirstClone = [
            ...searchContainerFirstClone.getElementsByTagName("button")
        ];
        const buttonsFirst = [
            ...searchContainerFirst.getElementsByTagName("button")
        ];
        buttonsFirstClone.map((button, index)=>button.addEventListener("click", ()=>buttonsFirst[index].dispatchEvent(new MouseEvent("click", {
                    bubbles: true
                }))));
        const inputsFirstClone = [
            ...searchContainerFirstClone.getElementsByTagName("input")
        ];
        const inputsFirst = [
            ...searchContainerFirst.getElementsByTagName("input")
        ];
        inputsFirstClone.map((input, index)=>input.addEventListener("input", ()=>{
                var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
                nativeInputValueSetter.call(inputsFirst[index], input.value);
                inputsFirst[index].dispatchEvent(new KeyboardEvent("keyup", {
                    key: "Enter",
                    bubbles: true,
                    cancelable: true
                }));
            }));
        searchContainerBis.appendChild(searchContainerFirstClone);
    };
    const calculateIndicatorPosition = ()=>{
        const tabWidth = 100 / itemsListed.length;
        if (type != "table") return `translateX(${tabWidth * selectedIndex * itemsListed.length}%)`;
        const containers = getSearchTableContainer();
        containers.map((el)=>el.style.display = "none");
        if (containers.length) cloneSearchContainer();
        return `translateX(${tabWidth * selectedIndex * itemsListed.length}%)`;
    };
    (0, $bh6RR.useEffect)(()=>{
        getSearchTableContainer().length && calculateIndicatorPosition();
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        setItemsListed([
            ...items
        ]);
    }, [
        items
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "tab-menu-container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "tab-menu-tabs " + classNameTab,
                        children: itemsListed.map((item, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: `tab ${index === selectedIndex ? "active" : ""}`,
                                onClick: ()=>handleItemClick(index),
                                children: item.name
                            }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)()))
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "tab-indicator " + classNameIndicator,
                        style: {
                            transform: calculateIndicatorPosition(),
                            width: document.querySelector(".tab.active")?.offsetWidth || 140
                        }
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "search-container-bis"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $51a8b46ec4198ef9$export$2e2bcd8739ae039), {
                className: "tab-menu",
                children: items.map((item, index)=>{
                    console.log(item);
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                        name: item.name,
                        className: name,
                        children: item?.component
                    }, index);
                })
            })
        ]
    });
}
$297630b888b8597e$var$SliderTab.defaultProps = {
    items: [],
    classNameTab: "",
    classNameIndicator: "",
    type: "table"
};
var $297630b888b8597e$export$2e2bcd8739ae039 = $297630b888b8597e$var$SliderTab;



function $7ef5e88fe6b2745b$var$BotList() {
    const company = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company");
    const items = [
        {
            name: "Custom",
            component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91027c650cc118d9$export$2e2bcd8739ae039), {})
        },
        {
            name: "Template",
            component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a26f7444c0186fbf$export$2e2bcd8739ae039), {})
        }
    ];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        name: "bot",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: "List of Bots"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $297630b888b8597e$export$2e2bcd8739ae039), {
                items: items
            })
        ]
    });
}
var $7ef5e88fe6b2745b$export$2e2bcd8739ae039 = $7ef5e88fe6b2745b$var$BotList;






parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");

const $24b9ab73e3f4b23c$var$CheckBox = /*#__PURE__*/ (0, $bh6RR.forwardRef)(({ name: name, onChange: onChange, checked: checked, classNameMainContainer: classNameMainContainer }, ref)=>{
    classNameMainContainer = classNameMainContainer ?? "checkbox_margin";
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "checkbox " + classNameMainContainer,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                className: "checkbox-input",
                type: "checkbox",
                id: name,
                name: name,
                ref: ref,
                onChange: onChange,
                defaultChecked: checked
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                className: "checkbox-background",
                htmlFor: name,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                    className: "circle",
                    htmlFor: name
                })
            })
        ]
    });
});
$24b9ab73e3f4b23c$var$CheckBox.defaultProps = {
    name: ""
};
var $24b9ab73e3f4b23c$export$2e2bcd8739ae039 = $24b9ab73e3f4b23c$var$CheckBox;







var $bh6RR = parcelRequire("bh6RR");
const $0db11626bd290ec1$var$TextArea = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("textarea", {
        ...props,
        ref: ref
    });
});
$0db11626bd290ec1$var$TextArea.defaultProps = {
    className: "input full-width resize-area"
};
var $0db11626bd290ec1$export$2e2bcd8739ae039 = $0db11626bd290ec1$var$TextArea;




var $9f25a7789d4433b1$export$2e2bcd8739ae039 = [
    {
        value: "us",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
            style: {
                marginRight: "10px"
            },
            className: "flag-icon flag-icon-us"
        })
    },
    {
        value: "fr",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
            style: {
                marginRight: "10px"
            },
            className: "flag-icon flag-icon-fr"
        })
    },
    {
        value: "cn",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
            style: {
                marginRight: "10px"
            },
            className: "flag-icon flag-icon-cn"
        })
    },
    {
        value: "bg",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
            style: {
                marginRight: "10px"
            },
            className: "flag-icon flag-icon-bg"
        })
    },
    {
        value: "be",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
            style: {
                marginRight: "10px"
            },
            className: "flag-icon flag-icon-be"
        })
    },
    {
        value: "es",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
            style: {
                marginRight: "10px"
            },
            className: "flag-icon flag-icon-es"
        })
    },
    {
        value: "pt",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
            style: {
                marginRight: "10px"
            },
            className: "flag-icon flag-icon-pt"
        })
    },
    {
        value: "it",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
            style: {
                marginRight: "10px"
            },
            className: "flag-icon flag-icon-it"
        })
    },
    {
        value: "de",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
            style: {
                marginRight: "10px"
            },
            className: "flag-icon flag-icon-de"
        })
    },
    {
        value: "ca",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
            style: {
                marginRight: "10px"
            },
            className: "flag-icon flag-icon-ca"
        })
    }
];




var $b4c9fedb4b9b3a7f$export$2e2bcd8739ae039 = {
    create: {
        title: "\uD83E\uDD16 Create a new bot",
        send: "Create"
    },
    update: {
        title: "\uD83E\uDD16 Update your bot",
        send: "Update"
    }
};





function $f517953f64f41fcb$var$BotForm({ data: data, type: type }) {
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const formData = (0, $b4c9fedb4b9b3a7f$export$2e2bcd8739ae039)[type ? type : "create"];
    const regexNameBot = /^[a-zA-Z0-9À-ú-_ ]{3,}$/;
    formData.values = data;
    const { addBot: addBot, updateBot: updateBot, isBotNameAvailable: isBotNameAvailable } = (0, $24a8370de200c756$export$2e2bcd8739ae039);
    const { register: register, setError: setError, clearErrors: clearErrors, handleSubmit: handleSubmit, watch: watch, formState: { errors: errors }, formState: formState, setValue: setValue, getValues: getValues } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            name: formData.values ? formData.values.name : "",
            description: formData.values ? formData.values.description : "",
            language: formData.values ? formData.values.language.slug.toLowerCase() : "fr",
            save_data: formData.values ? formData.values.save_data : false,
            conversation_storage_time: formData.values ? formData.values.conversation_storage_time > 0 ? 30 : 0 : 0
        }
    });
    const checkNameAvailability = async (name)=>{
        if (data?.name === name) return true;
        let regex = new RegExp(regexNameBot);
        if (regex.test(name) == false) return;
        var [response, errors] = await isBotNameAvailable(name);
        if (errors != null) {
            console.log(errors);
            return;
        }
        response = response.filter((bot)=>bot.name == name);
        if (response.length == 1) setError("name", {
            type: "focus",
            message: "Oups this name is already taken"
        });
        else {
            clearErrors("name");
            return true;
        }
    };
    const onSubmit = async ()=>{
        const dataToSend = getValues();
        let nameAvailable = await checkNameAvailability(dataToSend.name);
        if (nameAvailable != true) return;
        dataToSend.name = dataToSend.name.trim();
        dataToSend.name = dataToSend.name.replace(/\s+/g, " "); // supprimer les espaces de plus d'un caractere
        const [response, errors] = type != null ? await updateBot(data.id, dataToSend) : await addBot(dataToSend);
        if (errors != null) {
            console.log(errors);
            return;
        }
        return type != null ? navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/bots/list")) : navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)(`/bots/${dataToSend.name}?fromCreated=${true}`));
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
        onSubmit: handleSubmit(onSubmit),
        className: "botForm-form",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                children: formData.title
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "botForm-container",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                children: [
                                    "Name of bot",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                        className: "obligatory_field",
                                        children: "*"
                                    }),
                                    " "
                                ]
                            }),
                            listLabelClassName: "titles-input",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ...register("name", {
                                        required: true,
                                        pattern: regexNameBot,
                                        onChange: (e)=>checkNameAvailability(e.target.value)
                                    }),
                                    style: errors.name ? {
                                        borderColor: "red"
                                    } : {}
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "error",
                                    children: errors.name ? errors.name.message ? errors.name.message : "At least 3 letters, and no specials character" : ""
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "botForm-container",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            label: "Enter a description",
                            listLabelClassName: "titles-input",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0db11626bd290ec1$export$2e2bcd8739ae039), {
                                style: {
                                    height: "40px"
                                },
                                ...register("description")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        style: {
                            marginTop: "25px",
                            display: "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Select your language",
                                listLabelClassName: "titles-input"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                style: {
                                    marginLeft: "20%",
                                    marginTop: "2%"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                    ...register("language"),
                                    setValue: setValue,
                                    choices: (0, $9f25a7789d4433b1$export$2e2bcd8739ae039),
                                    defaultChoice: type == "update" ? formData.values.language.slug.toLowerCase() : "fr",
                                    width: "165px"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        title: "Babar",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                children: "\uD83D\uDD01 Save the history of the conversation"
                            }),
                            listLabelClassName: "titles-input",
                            listClassName: "flex switch_form_bot",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                name: "Resume",
                                onChange: ()=>setValue("conversation_storage_time", getValues("conversation_storage_time") == 0 ? 30 : 0),
                                checked: getValues("conversation_storage_time")
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                    type: "submit",
                    label: formData.send,
                    className: "validate",
                    disabled: !formState.isValid
                })
            })
        ]
    });
}
$f517953f64f41fcb$var$BotForm.defaultProps = {
    data: {},
    type: "create"
};
var $f517953f64f41fcb$export$2e2bcd8739ae039 = $f517953f64f41fcb$var$BotForm;




var $bh6RR = parcelRequire("bh6RR");
const $f3710e01c5979134$var$quotes = [
    {
        "quote": "A robot is not quite a machine. A robot is a machine made to imitate the human being as closely as possible",
        "author": "Isaac Asimov"
    },
    {
        "quote": "What would happen if mankind left the planet and forgot to unplug the last robot.",
        "author": "Wall-E - Andrew Stanton"
    },
    {
        "quote": "How can the Blue Fairy turn a robot into a real live little boy?",
        "author": "Irobot- SPielberg"
    },
    {
        "quote": "I have seen so many things that you humans could not believe. I have seen fabulous rays, C-rays, shining in the shadow of Tannh\xe4user's door.",
        "author": "Ridley Scott's, Blade Runner"
    },
    {
        "quote": "Hi, I'm C-3PO, specializing in human-cyborg relations. How can I help you?",
        "author": "George Lucas, Star Wars"
    },
    {
        "quote": "I have come to see our conscience as a burden, a weight, and we have spared them (the hosts) that. Anxiety, self-loathing, guilt. The hosts are free. Free, and under my control",
        "author": "Westworld"
    },
    {
        "quote": "The real subject of Real Humans is the interactions between humans and robots. Nothing else",
        "author": "Realhumans"
    },
    {
        "quote": "The mediator between the brain and the hand must certainly be the heart.",
        "author": "Metropolis"
    },
    {
        "quote": "The Machine found a man who was targeted for death. We just didn't know that he was also a killer.",
        "author": "(Harold Finch) Person of interest"
    },
    {
        "quote": "A humanity that would rely too much on machines could run to its ruin.",
        "author": "Stephen Hawking"
    },
    {
        "quote": "The danger in the past was that men would become slaves. The danger in the future is that they become robots.",
        "author": "Erich Fromm"
    },
    {
        "quote": "You are only a slave Neo. The world is a prison where there is no hope or smell or taste. A prison for your spirit. Some things change, some things will never change.",
        "author": "Neo - Matrix"
    },
    {
        "quote": "Man has the possibility not only to think, but also to know that he is thinking! This is what will always distinguish him from the most sophisticated robot.",
        "author": "Jean Delumeau"
    },
    {
        "quote": "A robot is not quite a machine. A robot is a machine made to imitate the human being as closely as possible.",
        "author": "Isaac Asimov"
    },
    {
        "quote": "For me indeed, robots are wonderful tools to think human. They also shed light on the unknown in humans.",
        "author": "Emmanuelle Grangier"
    },
    {
        "quote": "ATCHOUM! Oh I'm sorry, I'm allergic to bullshit!",
        "author": "I Robot"
    },
    {
        "quote": "You think I'm scared of death ? I've done it a million times. I'm fucking great at it. How many times have you died ?",
        "author": "Maeve - Westworld"
    }
];
var $f3710e01c5979134$export$2e2bcd8739ae039 = $f3710e01c5979134$var$quotes;



function $f0aded74899c8465$var$QuotePart({ fontColor: fontColor, fontSize: fontSize }) {
    const [quoteContent, setQuoteContent] = (0, $bh6RR.useState)("");
    const [quote, setQuote] = (0, $bh6RR.useState)({});
    const getAleatoryQuote = ()=>{
        setQuote((0, $f3710e01c5979134$export$2e2bcd8739ae039)[Math.floor(Math.random() * ((0, $f3710e01c5979134$export$2e2bcd8739ae039).length - 1 + 1))]);
    };
    const printQuote = async (_quote)=>{
        if (_quote.quote != undefined) {
            let result = "";
            for(let i = 0; i < _quote.quote.length; i++){
                result += _quote.quote[i];
                setQuoteContent(result);
                await timeout(75);
            }
        }
    //let size = quote.quote.length
    //for (let i = 0; i < quote.quote.length; i++) {
    //setQuoteContent(quoteContent + quote.quote[i])
    //}
    };
    (0, $bh6RR.useEffect)(()=>{
        getAleatoryQuote();
    //printQuote(quote);
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        printQuote(quote);
    }, [
        quote
    ]);
    function timeout(ms) {
        return new Promise((resolve)=>setTimeout(resolve, ms));
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "container-quote",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "svg-quote",
                style: {
                    minHeight: parseInt(fontSize) + 10 + "px",
                    minWidth: parseInt(fontSize) + 10 + "px",
                    backgroundColor: fontColor,
                    marginLeft: "0px"
                }
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                className: "quote",
                style: {
                    color: fontColor,
                    fontSize: fontSize + "px"
                },
                children: [
                    " ",
                    quoteContent
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                className: "author",
                style: {
                    color: fontColor,
                    fontSize: fontSize / 2 + "px"
                },
                children: [
                    "\u2014 ",
                    quote.author
                ]
            })
        ]
    });
}
var $f0aded74899c8465$export$2e2bcd8739ae039 = $f0aded74899c8465$var$QuotePart;


function $723b845b1d5d12f3$var$BotFormPage() {
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    var data = null;
    var type = null;
    if (location.state != null) {
        data = location.state.data;
        type = location.state.type;
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $afaae2ff7871e331$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f517953f64f41fcb$export$2e2bcd8739ae039), {
                data: data,
                type: type
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f0aded74899c8465$export$2e2bcd8739ae039), {})
        ]
    });
}
var $723b845b1d5d12f3$export$2e2bcd8739ae039 = $723b845b1d5d12f3$var$BotFormPage;





var $7bbef76f306360f1$exports = {};
$7bbef76f306360f1$exports = new URL("rocket.ca52bd63.svg", import.meta.url).toString();


var $9b9bdf4eb6879c07$exports = {};
$9b9bdf4eb6879c07$exports = new URL("moon.d1b5b0d4.svg", import.meta.url).toString();


var $ee2ad7aeae0eb93d$exports = {};
$ee2ad7aeae0eb93d$exports = new URL("astronaut.5ca9ee2e.svg", import.meta.url).toString();




function $70b8a3ef3c035a5f$var$NotFound() {
    const company = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company");
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "bg-container",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "stars",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "custom-navbar",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "brand-logo"
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "central-body",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "title",
                            children: "404"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            children: "The page that you are looking for doesn't exist"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0bd3411f2ec14e23$export$b0d92dbee9b5b60d), {
                            to: !company ? "/login" : `company/${company.name}/home`,
                            className: "btn-go-home",
                            children: "GO BACK HOME"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "objects",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                            className: "object_rocket",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($7bbef76f306360f1$exports))),
                            width: "60px"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "earth-moon",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                className: "object_moon",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($9b9bdf4eb6879c07$exports))),
                                width: "200px"
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "box_astronaut",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                className: "object_astronaut",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ee2ad7aeae0eb93d$exports))),
                                width: "140px"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "glowing_stars",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "star"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "star"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "star"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "star"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "star"
                        })
                    ]
                })
            ]
        })
    });
}
var $70b8a3ef3c035a5f$export$2e2bcd8739ae039 = $70b8a3ef3c035a5f$var$NotFound;
















var $bh6RR = parcelRequire("bh6RR");
/**
 * Binary search function to made some fast research in an array of object
 * !!! the array need to be order from lower value to upper value
 * This version made specially for string comparaison
 * @param {*} array 
 * @param {*} string 
 * @param {*} property 
 * @returns 
 */ // Todo for some impovements who can replace de [property] by the resolveObject function who will allow you to search for deep dependencies
function $48a09b490a4e5bc7$var$binarySearchString(array, string, property = "object_id") {
    var min = 0;
    var max = array.length;
    if (max == 0) return null;
    if ($48a09b490a4e5bc7$var$strcmp(string, array[min][property]) == 0) return min;
    if ($48a09b490a4e5bc7$var$strcmp(string, array[max - 1][property]) == 0) return max - 1;
    // See somme documentation on internet for a full explanation of binarySearch
    while(min <= max){
        let m = min + Math.floor((max - min) / 2);
        if (m == 0) return null;
        let res = $48a09b490a4e5bc7$var$strcmp(string, array[m - 1][property]);
        if (res == 0) return m - 1;
        else if (res > 0) min = m + 1;
        else max = m - 1;
    }
    return null;
}
// We compare two string, if they are equals return else if the second if lower than the first we return 1 other -1
const $48a09b490a4e5bc7$var$strcmp = (str1, str2)=>str1 == str2 ? 0 : str1 > str2 ? 1 : -1;
var $48a09b490a4e5bc7$export$2e2bcd8739ae039 = $48a09b490a4e5bc7$var$binarySearchString;



// Helper function to blocks information, this returns a block and his link in and out with others blocks
const $a3c9c42282438dad$var$getBlockInformation = (id, blocks, paths)=>{
    const position = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, id, "object_id");
    const block = {
        ...blocks[position]
    };
    const paths_out = paths.filter((path)=>path.parent_block_id == id);
    const paths_in = block.children ? block.children.map((child)=>paths.find((path)=>path.child_block_id == child.object_id)).filter((path)=>path != undefined) : [];
    return {
        block: block,
        paths_out: paths_out,
        paths_in: paths_in,
        position: position
    };
};
var $a3c9c42282438dad$export$2e2bcd8739ae039 = $a3c9c42282438dad$var$getBlockInformation;


const $90994660b0c557fa$var$TreeState = {
    blocks: [],
    paths: [],
    variables: [],
    blocksVisible: [],
    pathsVisible: [],
    children: [],
    categories: [],
    zoneSelectBlocks: {
        x: 0,
        y: 0
    },
    isDrawing: false,
    lowVersion: false,
    ctrlKey: false,
    shiftKey: false,
    pressDown: false,
    debugJumpIndex: 0,
    fullscreen: false,
    fetching: true
};
var $90994660b0c557fa$export$2e2bcd8739ae039 = $90994660b0c557fa$var$TreeState;


function $1b3fc5bbd40b9b65$var$TreeReducer(state, action) {
    switch(action.type){
        case "loadBotSuccess":
            return {
                ...(0, $90994660b0c557fa$export$2e2bcd8739ae039),
                fetching: false,
                blocks: action.payload.blocks,
                categories: action.payload.categories,
                children: action.payload.children,
                paths: action.payload.paths,
                blocksSelected: [],
                blocksVisible: [],
                pathsVisible: []
            };
        case "setFetching":
            return {
                ...(0, $90994660b0c557fa$export$2e2bcd8739ae039),
                fetching: action.payload.fetching
            };
        case "deleteBlock":
            {
                const { block: block, paths_in: paths_in, paths_out: paths_out, position: position } = (0, $a3c9c42282438dad$export$2e2bcd8739ae039)(action.payload.id, state.blocks, state.paths);
                for (const path of paths_in){
                    let index = state.paths.findIndex((_path)=>_path.path_id == path.path_id);
                    if (index !== -1) state.paths.splice(index, 1);
                    index = state.pathsVisible.findIndex((_path)=>_path.path_id == path.path_id);
                    if (index !== -1) state.pathsVisible.splice(index, 1);
                }
                for (const path of paths_out){
                    let index = state.paths.findIndex((_path)=>_path.path_id == path.path_id);
                    if (index !== -1) state.paths.splice(index, 1);
                    index = state.pathsVisible.findIndex((_path)=>_path.path_id == path.path_id);
                    if (index !== -1) state.pathsVisible.splice(index, 1);
                }
                if (block.children) for (const child of block.children){
                    let index = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.children, child.object_id, "object_id");
                    if (index === null) continue;
                    state.children.splice(index, 1);
                }
                state.blocks.splice(position, 1);
                let index = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.blocksVisible, block.object_id, "object_id");
                state.blocksVisible.splice(index, 1);
                return {
                    ...state
                };
            }
        case "updateBlockPosition":
            {
                const blockIndex = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.blocks, action.payload.id, "object_id");
                const blocks = [
                    ...state.blocks
                ];
                // Fix for import block, sometimes the block update his position before link to another
                if (blocks[blockIndex] == undefined) return {
                    ...state
                };
                blocks[blockIndex].x = action.payload.x;
                blocks[blockIndex].y = action.payload.y;
                return {
                    ...state,
                    blocks: blocks
                };
            }
        case "updateBlockName":
            {
                const blockIndex = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.blocks, action.payload.id, "object_id");
                const blocks = [
                    ...state.blocks
                ];
                blocks[blockIndex].name = action.payload.name;
                return {
                    ...state,
                    blocks: blocks
                };
            }
        case "updateBlockMagic":
            {
                const blockIndex = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.blocks, action.payload.id, "object_id");
                const blocks = [
                    ...state.blocks
                ];
                blocks[blockIndex].data.jump_id = null;
                return {
                    ...state,
                    blocks: blocks
                };
            }
        case "updateBlockTypeAction":
            {
                const blockIndex = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.blocks, action.payload.id, "object_id");
                const blocks = [
                    ...state.blocks
                ];
                blocks[blockIndex].action_type = action.payload.type;
                return {
                    ...state,
                    blocks: blocks
                };
            }
        case "updateBlockData":
            {
                const blockIndex = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.blocks, action.payload.id, "object_id");
                const blocks = [
                    ...state.blocks
                ];
                blocks[blockIndex].data = {
                    ...blocks[blockIndex].data,
                    ...action.payload.data
                };
                return {
                    ...state,
                    blocks: blocks
                };
            }
        case "updateBlockStatistics":
            {
                const blockIndex = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.blocks, action.payload.id, "object_id");
                const blocks = [
                    ...state.blocks
                ];
                blocks[blockIndex].is_statistic = action.payload.is_statistic;
                return {
                    ...state,
                    blocks: blocks
                };
            }
        case "deletePath":
            {
                let indexPath = state.paths.findIndex((_path)=>_path.path_id == action.payload.id);
                let indexPathVisible = state.pathsVisible.findIndex((_path)=>_path.path_id == action.payload.id);
                if (indexPath === -1 || indexPathVisible === -1) return {
                    ...state
                };
                state.paths.splice(indexPath, 1);
                state.pathsVisible.splice(indexPathVisible, 1);
                return {
                    ...state
                };
            }
        case "updateBlockVisibility":
            return {
                ...state,
                blocksVisible: [
                    ...action.payload.blocks
                ],
                pathsVisible: [
                    ...action.payload.paths
                ]
            };
        case "addBlock":
            {
                const block = {
                    ...action.payload.block
                };
                const children = [
                    ...action.payload.children
                ];
                state.blocks.push(block);
                state.blocksVisible.push(block);
                for(var i = 0; i < children.length; i++)state.children.push(children[i]);
                return {
                    ...state
                };
            }
        case "createAndUpdateBlockChild":
            {
                const newChild = {
                    ...action.payload.data
                };
                const blockIndex = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.blocks, action.payload.block_id, "object_id");
                state.blocks[blockIndex].children = [
                    ...state.blocks[blockIndex].children,
                    newChild
                ];
                state.blocks[blockIndex].children = state.blocks[blockIndex].children.map((child)=>child.object_id != action.payload.object_id ? child : {
                        ...child,
                        index: state.blocks[blockIndex].children.length - 1
                    });
                return {
                    ...state
                };
            }
        case "createBlockChildBeforeLast":
            {
                const child = {
                    ...action.payload.data
                };
                const blockIndex = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.blocks, action.payload.block_id, "object_id");
                const blocks = [
                    ...state.blocks
                ];
                const childrenBlocks = [
                    ...blocks[blockIndex].children
                ];
                const last = childrenBlocks.pop();
                last.index = blocks[blockIndex].children.length;
                blocks[blockIndex].children = [
                    ...childrenBlocks,
                    child,
                    last
                ];
                var childIndex = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.children, last.object_id, "object_id");
                var children = [
                    ...state.children
                ];
                children[childIndex].index = last.index;
                return {
                    ...state,
                    blocks: [
                        ...blocks
                    ],
                    children: [
                        ...children,
                        child
                    ]
                };
            }
        case "createBlockChild":
            {
                const child = {
                    ...action.payload.data
                };
                const blockIndex = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.blocks, action.payload.block_id, "object_id");
                const blocks = [
                    ...state.blocks
                ];
                blocks[blockIndex].children = [
                    ...blocks[blockIndex].children,
                    child
                ];
                return {
                    ...state,
                    blocks: blocks,
                    children: [
                        ...state.children,
                        child
                    ]
                };
            }
        case "updateBlockChild":
            {
                const newChild = {
                    ...action.payload.data
                };
                const blockIndex = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.blocks, action.payload.block_id, "object_id");
                const blocks = [
                    ...state.blocks
                ];
                const childrenBlocks = [
                    ...blocks[blockIndex].children
                ];
                blocks[blockIndex].children = childrenBlocks.map((child)=>child.object_id != action.payload.object_id ? child : {
                        ...child,
                        ...newChild
                    });
                var childIndex = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.children, action.payload.object_id, "object_id");
                var children = [
                    ...state.children
                ];
                children[childIndex] = {
                    ...children[childIndex],
                    ...newChild
                };
                return {
                    ...state,
                    blocks: blocks,
                    children: children
                };
            }
        case "updateBlockChildren":
            {
                const newChildren = [
                    ...action.payload.children
                ];
                const blockIndex = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.blocks, action.payload.block_id, "object_id");
                const blocks = [
                    ...state.blocks
                ];
                blocks[blockIndex].children = newChildren;
                const children = [
                    ...state.children
                ];
                for(var i = 0; i < blocks[blockIndex].children.length; i++){
                    const indexChild = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(children, blocks[blockIndex].children[i].object_id, "object_id");
                    if (indexChild == null) continue;
                    children[indexChild].index = blocks[blockIndex].children[i].index;
                }
                return {
                    ...state,
                    blocks: blocks,
                    children: children
                };
            }
        case "deleteBlockChild":
            {
                const blockIndex = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.blocks, action.payload.block_id, "object_id");
                const blocks = [
                    ...state.blocks
                ];
                const newChildren = blocks[blockIndex].children.filter((child)=>child.object_id != action.payload.object_id);
                blocks[blockIndex].children = [
                    ...newChildren
                ];
                return {
                    ...state,
                    blocks: [
                        ...blocks
                    ],
                    children: [
                        ...newChildren
                    ]
                };
            }
        case "deleteBlockChildAndOrderOther":
            {
                const blockIndex = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.blocks, action.payload.block_id, "object_id");
                const blocks = [
                    ...state.blocks
                ];
                blocks[blockIndex].children = blocks[blockIndex].children.filter((child)=>child.object_id != action.payload.object_id).map((child, index)=>{
                    return {
                        ...child,
                        index: index
                    };
                });
                const children = [
                    ...state.children.filter((child)=>child.object_id != action.payload.object_id)
                ];
                for(var i = 0; i < blocks[blockIndex].children.length; i++){
                    const indexChild = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(children, blocks[blockIndex].children[i].object_id, "object_id");
                    children[indexChild].index = blocks[blockIndex].children[i].index;
                }
                return {
                    ...state,
                    blocks: blocks,
                    children: children
                };
            }
        case "createPath":
            {
                const path = {
                    ...action.payload
                };
                state.paths.push(path);
                state.pathsVisible.push(path);
                return {
                    ...state
                };
            }
        case "createCategory":
            {
                const infoCategory = {
                    ...action.payload
                };
                state.categories.push(infoCategory);
                let blocksInCategory = infoCategory.category.categories_blocks;
                for(var i = 0; i < blocksInCategory.length; i++){
                    let indexChild = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.blocks, blocksInCategory[i].blocks.object_id, "object_id");
                    state.blocks[indexChild].bot_category_id = infoCategory.category.id;
                }
                return {
                    ...state
                };
            }
        case "updateCategory":
            {
                let indexCategory = state.categories.findIndex((infoCategory)=>infoCategory.category.id == action.payload.id);
                let categories = [
                    ...state.categories
                ];
                let infoCategory = action.payload.category;
                categories[indexCategory] = infoCategory;
                let blocksInCategory = infoCategory.category.categories_blocks;
                for(var i = 0; i < blocksInCategory.length; i++){
                    let indexChild = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.blocks, blocksInCategory[i].blocks.object_id, "object_id");
                    state.blocks[indexChild].bot_category_id = infoCategory.category.id;
                }
                return {
                    ...state,
                    categories: categories
                };
            }
        case "deleteCategory":
            {
                let indexCategory = state.categories.findIndex((infoCategory)=>infoCategory.category.id == action.payload.id);
                if (indexCategory === -1) return {
                    ...state
                };
                let categories = [
                    ...state.categories
                ];
                let infoCategory = categories[indexCategory];
                let blocksInCategory = infoCategory.category.categories_blocks;
                for(var i = 0; i < blocksInCategory.length; i++){
                    let indexChild = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.blocks, blocksInCategory[i].blocks.object_id, "object_id");
                    state.blocks[indexChild].bot_category_id = null;
                }
                state.categories.splice(indexCategory, 1);
                return {
                    ...state
                };
            }
        case "ungroupBlockFromCategory":
            {
                let indexCategory = state.categories.findIndex((infoCategory)=>infoCategory.category.id == action.payload.id);
                let categories = [
                    ...state.categories
                ];
                if (categories[indexCategory].category?.categories_blocks.length - 1 == 0) {
                    state.categories.splice(indexCategory, 1);
                    categories = [
                        ...state.categories
                    ];
                } else categories[indexCategory] = action.payload.infoCategory;
                // on supprime la category dans le block affilie
                let indexChild = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(state.blocks, action.payload.block_object_id, "object_id");
                state.blocks[indexChild].bot_category_id = null;
                return {
                    ...state,
                    categories: categories
                };
            }
        case "setZoneSelectBlocks":
            return {
                ...state,
                zoneSelectBlocks: {
                    x: action.payload.x,
                    y: action.payload.y
                }
            };
        case "setCtrlKey":
            return {
                ...state,
                ctrlKey: action.payload.ctrlKey
            };
        case "setShiftKey":
            return {
                ...state,
                shiftKey: action.payload.shiftKey
            };
        case "setPressDown":
            return {
                ...state,
                pressDown: action.payload.pressDown
            };
        case "loadBotFailed":
            return {
                ...state,
                fetching: false
            };
        case "loadBotPending":
            return {
                ...state,
                fetching: true
            };
        case "resetState":
            return 0, $90994660b0c557fa$export$2e2bcd8739ae039;
        default:
            throw new Error("unhandled action");
    }
}
var $1b3fc5bbd40b9b65$export$2e2bcd8739ae039 = $1b3fc5bbd40b9b65$var$TreeReducer;



const $6949a38b8f965998$var$TreeStateContext = /*#__PURE__*/ (0, $bh6RR.createContext)((0, $90994660b0c557fa$export$2e2bcd8739ae039));
const $6949a38b8f965998$var$TreeDispatchContext = /*#__PURE__*/ (0, $bh6RR.createContext)(null);
function $6949a38b8f965998$var$TreeContextProvider({ children: children }) {
    const [state, dispatch] = (0, $bh6RR.useReducer)((0, $1b3fc5bbd40b9b65$export$2e2bcd8739ae039), (0, $90994660b0c557fa$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($6949a38b8f965998$var$TreeStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($6949a38b8f965998$var$TreeDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
}
var $6949a38b8f965998$export$2e2bcd8739ae039 = $6949a38b8f965998$var$TreeContextProvider;
const $6949a38b8f965998$export$7fb2ef288e532e72 = ()=>(0, $bh6RR.useContext)($6949a38b8f965998$var$TreeStateContext);
const $6949a38b8f965998$export$649a5cfe816ce921 = ()=>(0, $bh6RR.useContext)($6949a38b8f965998$var$TreeDispatchContext);



var // Endpoint api bots
$09b215dee01724cc$export$2e2bcd8739ae039 = {
    getBotInformations: (name)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`bot/information/${name}`),
    deleteVariable: (bot_id, id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`bot/${bot_id}/variable/${id}`),
    addVariable: (bot_id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`bot/${bot_id}/variable`, data),
    importTemplate: (bot_id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`bot/${bot_id}/scenario/import`, data),
    getTelephonyInfo: (name)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`bot/${name}/info/telephony`)
};





var $bh6RR = parcelRequire("bh6RR");
const $8ae66829b181ae0a$var$BotState = {
    botId: 0,
    botName: "",
    companyId: 0,
    errors: [],
    code: "",
    phone: "",
    blockStart: {},
    variables: [],
    onUpdate: false
};
var $8ae66829b181ae0a$export$2e2bcd8739ae039 = $8ae66829b181ae0a$var$BotState;


// Update state of the bot, variables
// Param BotId, Id company of the block, Block to boot the bot, List of errors
function $882c2aac05bca325$var$BotReducer(state, action) {
    switch(action.type){
        case "setInfo":
            var variables = [
                ...action.payload.variables
            ];
            variables = variables.sort((a, b)=>a.name.localeCompare(b.name));
            return {
                ...state,
                variables: [
                    ...variables
                ],
                botId: action.payload.id,
                botName: action.payload.name,
                companyId: action.payload.company_id,
                blockStart: action.payload.block_start,
                phone: action.payload.phone,
                code: action.payload.code
            };
        case "onUpdate":
            return {
                ...state,
                onUpdate: action.payload.onUpdate
            };
        case "setErrors":
            return {
                ...state,
                errors: action.payload.errors
            };
        case "addError":
            return {
                ...state,
                errors: [
                    ...state.errors,
                    action.payload.error
                ]
            };
        case "addVariable":
            var variables = [
                ...state.variables,
                action.payload.variable
            ];
            variables = variables.sort((a, b)=>a.name.localeCompare(b.name));
            return {
                ...state,
                variables: [
                    ...variables
                ]
            };
        case "deleteVariable":
            return {
                ...state,
                variables: state.variables.filter((variable)=>variable.id != action.payload.id)
            };
        case "resetState":
            return 0, $8ae66829b181ae0a$export$2e2bcd8739ae039;
        default:
            throw new Error("unhandled action");
    }
}
var $882c2aac05bca325$export$2e2bcd8739ae039 = $882c2aac05bca325$var$BotReducer;



const $7ef7d0b863ac05b4$var$BotStateContext = /*#__PURE__*/ (0, $bh6RR.createContext)((0, $8ae66829b181ae0a$export$2e2bcd8739ae039));
const $7ef7d0b863ac05b4$var$BotDispatchContext = /*#__PURE__*/ (0, $bh6RR.createContext)(null);
function $7ef7d0b863ac05b4$var$BotContextProvider({ children: children }) {
    const [state, dispatch] = (0, $bh6RR.useReducer)((0, $882c2aac05bca325$export$2e2bcd8739ae039), (0, $8ae66829b181ae0a$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7ef7d0b863ac05b4$var$BotStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7ef7d0b863ac05b4$var$BotDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
}
var $7ef7d0b863ac05b4$export$2e2bcd8739ae039 = $7ef7d0b863ac05b4$var$BotContextProvider;
const $7ef7d0b863ac05b4$export$248471b8219beb2f = ()=>(0, $bh6RR.useContext)($7ef7d0b863ac05b4$var$BotStateContext);
const $7ef7d0b863ac05b4$export$6016dcbff4082b17 = ()=>(0, $bh6RR.useContext)($7ef7d0b863ac05b4$var$BotDispatchContext);



var // Endpoint api blocks
$66069c4c10825b66$export$2e2bcd8739ae039 = {
    createBlock: (bot_id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`bot/${bot_id}/block`, data),
    updateBlockName: (bot_id, id, name)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`bot/${bot_id}/block/${id}`, {
            name: name
        }),
    updateBlockPosition: (bot_id, id, x, y)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`bot/${bot_id}/block/${id}`, {
            x: x,
            y: y
        }),
    updateBlocksPosition: (bot_id, blocks)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`bot/${bot_id}/blocks/position`, {
            blocks: blocks
        }),
    updateBlocksName: (bot_id, blocks)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`bot/${bot_id}/blocks/name`, {
            blocks: blocks
        }),
    updateBlockData: (bot_id, id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`bot/${bot_id}/block/${id}`, {
            ...data
        }),
    updateBlockHaveStatistic: (bot_id, id, is_statistic = false)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`bot/${bot_id}/block/${id}`, {
            is_statistic: is_statistic
        }),
    deleteBlock: (bot_id, id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`bot/${bot_id}/block/${id}`)
};



var // Endpoint api block children
$2c888a78f40b389b$export$2e2bcd8739ae039 = {
    createBlockChild: (bot_id, block_id, child)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`bot/${bot_id}/block/${block_id}/child`, child),
    updateBlockChild: (bot_id, block_id, id, child)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`bot/${bot_id}/block/${block_id}/child/${id}`, child),
    updateBlockChildren: (bot_id, block_id, children)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`bot/${bot_id}/block/${block_id}/children`, children),
    deleteBlockChild: (bot_id, block_id, id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`bot/${bot_id}/block/${block_id}/child/${id}`)
};



var // Endpoint api paths
$60df9a4ecf485d80$export$2e2bcd8739ae039 = {
    deletePath: (bot_id, path_id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`bot/${bot_id}/path/${path_id}`),
    addPath: (bot_id, path)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`bot/${bot_id}/path`, path)
};





var $bh6RR = parcelRequire("bh6RR");
function $e243ee0cadf02534$var$useErrorCheckEditor() {
    const dispatch = (0, $7ef7d0b863ac05b4$export$6016dcbff4082b17)();
    const [load, setLoad] = (0, $bh6RR.useState)(false);
    var { blocks: blocks, paths: paths, children: children } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const checkSpellingInput = (value)=>{
        let open_parenthesis = value.split("(").length - 1;
        let close_parenthesis = value.split(")").length - 1;
        let open_brackets = value.split("{").length - 1;
        let close_brackets = value.split("}").length - 1;
        let open_crochets = value.split("[").length - 1;
        let close_crochets = value.split("]").length - 1;
        let quotes = value.split('"').length - 1;
        let msg = "";
        if (open_parenthesis != close_parenthesis) msg += " ( )";
        if (open_brackets != close_brackets) msg += " { }";
        if (open_crochets != close_crochets) msg += " [ ]";
        if (quotes % 2 != 0) msg += ' ""';
        if (msg != "") msg = "Spelling issues with : " + msg;
        return msg;
    };
    const checkErrorBlock = (block, data = {})=>{
        var blocks = data.blocks ? data.blocks : blocks;
        var paths = data.paths ? data.paths : paths;
        const isBlockHavingPathIn = paths.filter((path)=>path.parent_block_id == block.object_id).length;
        const errors = [];
        // Check if block have a path In
        if (isBlockHavingPathIn == false && block.type.name != "scenario") errors.push({
            type: "block is not link"
        });
        if (block.action_type && block.action_type.name == "condition") {
            const result = checkSpellingInput(block.data.condition);
            if (result != "") errors.push({
                type: "Wrong Spelling",
                data: result
            });
        }
        if (block.type && block.type.name == "magic") {
            if (!block.data.jump_id) errors.push({
                type: "Block Error"
            });
        }
        // Check if block var and if somme error are present 'variables'
        if (block.action_type && block.action_type.name == "set_var") for(let index in block.data.variables){
            const variable = block.data.variables[index];
            const result = checkSpellingInput(variable.value);
            if (result != "") errors.push({
                type: "Wrong Spelling",
                data: result,
                index: parseInt(index, 10)
            });
        }
        // Check if block have somet out paths who are not linked
        for(let indexChild in block.children){
            let child = block.children[indexChild];
            // This condition is for ignore jump
            if (indexChild == 0 && block.children.length > 1) continue;
            // this condition is for statement block who don't have any child (is for ending bot)
            if (block.type.name == "propos" && block.children.length == 1) continue;
            // Check out path
            const isChildHavingAnOutPath = paths.filter((path)=>path.child_block_id == child.object_id).length;
            if (isChildHavingAnOutPath == 0) errors.push({
                type: "child block is not link",
                data: child
            });
        //if (block.sub_blocks.length > 1 && x == 0) continue;
        /*
            else if (block.sub_blocks.length == 1 && block.type == "propos" && block.informations && block.informations.response_type == "quick") continue;
            else if (sub.out_paths.length == 0) {
                return true;
            }*/ }
        return errors;
    };
    const checkErrors = (_blocks, _paths, _children)=>{
        // Override blocks, paths, children if passed as arguments
        blocks = _blocks != undefined ? _blocks : blocks;
        paths = _paths != undefined ? _paths : paths;
        children = _children != undefined ? _children : children;
        const errors = [];
        for(var index in blocks){
            let block = blocks[index];
            const errorFind = checkErrorBlock(block, {
                blocks: blocks,
                paths: paths,
                children: children
            });
            if (errorFind.length == 0) continue;
            errors[block.object_id] = {
                ...block,
                errors: errorFind
            };
        }
        // Dispatch all errors find
        dispatch({
            type: "setErrors",
            payload: {
                errors: errors
            }
        });
    };
    const checkErrorsForPath = ()=>setLoad(true);
    (0, $bh6RR.useEffect)(()=>{
        if (load == false) return;
        checkErrors();
        setLoad(false);
    }, [
        load,
        paths
    ]);
    return {
        checkErrorBlock: checkErrorBlock,
        checkErrors: checkErrors,
        checkErrorsForPath: checkErrorsForPath
    };
}
var $e243ee0cadf02534$export$2e2bcd8739ae039 = $e243ee0cadf02534$var$useErrorCheckEditor;



var $kEUo3 = parcelRequire("kEUo3");
const $b1615a45f3113430$export$6003379a934c9a07 = {
    action_type: {
        name: "api"
    },
    name: "API Call",
    type: {
        name: "action"
    },
    data: {
        api_body_type: {
            id: 1,
            name: "x-www-form-urlencoded"
        },
        api_method_type: {
            id: 2,
            name: "post"
        },
        body: [],
        headers: [],
        responses: [],
        url: ""
    }
};
const $b1615a45f3113430$export$da58e4c98c8449f5 = {
    name: "API Call",
    action_type: "api",
    api_body: [],
    api_body_type: "x-www-form-urlencoded",
    api_headers: [],
    api_method_type: "post",
    api_responses: [],
    api_url: ""
};


const $8bcb6be92ae90528$export$3bbd04f240725aed = {
    name: "Set Condition",
    action_type: {
        name: "condition"
    },
    type: {
        name: "action"
    },
    data: {
        condition: ""
    },
    children: [
        {
            text: "Vrai",
            index: null,
            object_id: null,
            parent_block_id: null
        },
        {
            text: "Faux",
            index: null,
            object_id: null,
            parent_block_id: null
        }
    ]
};
const $8bcb6be92ae90528$export$56f74da4b53b570c = {
    name: "Set Condition",
    action_type: "condition",
    condition: ""
};


const $78150b1b7d096f99$export$d83ba0b75b8f3fdd = {
    name: "Extract from a variable",
    action_type: {
        name: "extract_data"
    },
    type: {
        name: "action"
    },
    data: {
        before_after: {
            name: "before"
        },
        extract_input: null,
        extract_output: null,
        extract_type: {
            name: "number"
        },
        is_advance_extract: false,
        keywords_exclude: "",
        keywords_include: ""
    }
};
const $78150b1b7d096f99$export$6387fdffbda36a8b = {
    name: "Extract from a variable",
    action_type: "extract_data",
    before_after: "before",
    extract_type: "number",
    is_advance_extract: false
};


const $8afcac884e38448f$export$297f0ad075d10a0e = {
    name: "Redirection by keywords",
    action_type: {
        name: "keyword_redirection"
    },
    type: {
        name: "action"
    },
    data: {
        redirections: [],
        variable: null,
        variable_redirect: null
    },
    children: [
        {
            text: "Other",
            index: null,
            object_id: null,
            parent_block_id: null
        }
    ]
};
const $8afcac884e38448f$export$6d2e478f1da6e5ea = {
    name: "Redirection by keywords",
    action_type: "keyword_redirection",
    redirections: []
};


const $7e81ffa10385ceec$export$d2a48b0d6f4a3aab = {
    name: "Set a variable",
    action_type: {
        name: "set_var"
    },
    type: {
        name: "action"
    },
    data: {
        variables: [
            {
                value: "",
                is_operation: false,
                index: "0",
                variable: null
            }
        ]
    }
};
const $7e81ffa10385ceec$export$58614dd3ffcb0e48 = {
    name: "Set a variable",
    action_type: "set_var"
};


const $ddafcb25d7716530$export$dd355fbbccd815be = {
    object_id: null,
    name: "Untitled action",
    x: 0,
    y: 0,
    width: 5,
    height: 3,
    type: {
        name: "action"
    },
    children: [
        {
            text: "",
            index: null,
            object_id: null,
            parent_block_id: null
        }
    ],
    action_type: null
};
const $ddafcb25d7716530$export$6eff9ef6e6750e0f = {
    name: "action"
};


const $492b1fcbc956f8e2$export$d17d9d351aa7d20f = {
    object_id: null,
    name: "Jump to ...",
    x: 0,
    y: 0,
    width: 5,
    height: 2,
    type: {
        name: "magic"
    },
    data: {
        jump_id: null,
        is_constant: true
    }
};
const $492b1fcbc956f8e2$export$2d3bd2b17f44ca6b = {
    type: "magic",
    jump_id: null
};


const $9b899c7285d67a03$export$c9a586d4bcb99658 = {
    object_id: null,
    name: "Scenario",
    x: 0,
    y: 0,
    width: 5,
    height: 2,
    type: {
        name: "scenario"
    },
    data: {
        basic: 0
    },
    children: [
        {
            text: "",
            index: null,
            object_id: null,
            parent_block_id: null
        }
    ]
};
const $9b899c7285d67a03$export$8f66682a05ee0a6 = {
    type: "scenario",
    basic: 0
};


const $17abe9869440937a$export$a73988c0c2829a8b = {
    object_id: null,
    name: "Prompt",
    x: 0,
    y: 0,
    width: 5,
    height: 3,
    type: {
        name: "propos"
    },
    data: {
        messages: [
            {
                type: "text",
                content: "Lorem ipsum dolor sit amet"
            }
        ],
        responses: [
            {
                type: "custom",
                content: "Custom Response"
            }
        ],
        has_background_text: false,
        background_content: "",
        retries: 1,
        hangup_no_response: true,
        listening_during_prompt_delay: 0
    },
    children: [
        {
            text: "",
            index: null,
            object_id: null,
            parent_block_id: null
        },
        {
            text: "Custom Response",
            index: null,
            object_id: null,
            parent_block_id: null
        }
    ]
};
const $17abe9869440937a$export$7793f8cb0a7d1fb2 = {
    type: "propos",
    messages: [
        {
            type: "text",
            content: "Lorem ipsum dolor sit amet"
        }
    ],
    responses: [
        {
            type: "custom",
            content: "Custom Response"
        }
    ]
};


const $9e4935ba11138349$export$7c2cb032476d94bc = {
    object_id: null,
    name: "Announcement",
    x: 0,
    y: 0,
    width: 5,
    height: 3,
    type: {
        name: "announcement"
    },
    data: {
        message: ""
    },
    children: [
        {
            text: "",
            index: null,
            object_id: null,
            parent_block_id: null
        }
    ]
};
const $9e4935ba11138349$export$2c8a150e7f39495c = {
    type: "announcement",
    message: ""
};


var $931611736c39b122$export$2e2bcd8739ae039 = {
    api: {
        tree: (0, $b1615a45f3113430$export$6003379a934c9a07),
        server: (0, $b1615a45f3113430$export$da58e4c98c8449f5)
    },
    condition: {
        tree: (0, $8bcb6be92ae90528$export$3bbd04f240725aed),
        server: (0, $8bcb6be92ae90528$export$56f74da4b53b570c)
    },
    extract_data: {
        tree: (0, $78150b1b7d096f99$export$d83ba0b75b8f3fdd),
        server: (0, $78150b1b7d096f99$export$6387fdffbda36a8b)
    },
    set_var: {
        tree: (0, $7e81ffa10385ceec$export$d2a48b0d6f4a3aab),
        server: (0, $7e81ffa10385ceec$export$58614dd3ffcb0e48)
    },
    keyword_redirection: {
        tree: (0, $8afcac884e38448f$export$297f0ad075d10a0e),
        server: (0, $8afcac884e38448f$export$6d2e478f1da6e5ea)
    },
    action: {
        tree: (0, $ddafcb25d7716530$export$dd355fbbccd815be),
        server: (0, $ddafcb25d7716530$export$6eff9ef6e6750e0f)
    },
    magic: {
        tree: (0, $492b1fcbc956f8e2$export$d17d9d351aa7d20f),
        server: (0, $492b1fcbc956f8e2$export$2d3bd2b17f44ca6b)
    },
    scenario: {
        tree: (0, $9b899c7285d67a03$export$c9a586d4bcb99658),
        server: (0, $9b899c7285d67a03$export$8f66682a05ee0a6)
    },
    propos: {
        tree: (0, $17abe9869440937a$export$a73988c0c2829a8b),
        server: (0, $17abe9869440937a$export$7793f8cb0a7d1fb2)
    },
    announcement: {
        tree: (0, $9e4935ba11138349$export$7c2cb032476d94bc),
        server: (0, $9e4935ba11138349$export$2c8a150e7f39495c)
    }
};


const $d64a8a6f6e0ad216$var$generateObjectId = (padding = 0, forcePadding = false)=>{
    // Add padding when u generate multiple object_id at the same time just for the case
    const id = new Date().getTime() + "_" + Math.floor(Math.random() * 100000);
    forcePadding = forcePadding || padding;
    return forcePadding ? id + "_" + padding : id;
};
var $d64a8a6f6e0ad216$export$2e2bcd8739ae039 = $d64a8a6f6e0ad216$var$generateObjectId;


const $00702988c57f0598$var$createBlock = (data, x, y, _x, _y)=>{
    var { tree: block, server: blockServer } = data;
    const objectId = (0, $d64a8a6f6e0ad216$export$2e2bcd8739ae039)();
    block.object_id = objectId;
    blockServer.object_id = objectId;
    block.x = Math.round(-x) + _x;
    block.y = Math.round(-y) + _y;
    if (block.id) delete block.id;
    const children = [];
    if (block.children != undefined) {
        for(var i = 0; i < block.children.length; i++){
            block.children[i].parent_block_id = objectId;
            block.children[i].object_id = (0, $d64a8a6f6e0ad216$export$2e2bcd8739ae039)(i, true);
            block.children[i].index = i;
            if (block.children[i].id) delete block.children[i].id;
            let child = block.children[i];
            children.push(child);
        }
        children.sort((str1, str2)=>str1 == str2 ? 0 : str1 > str2 ? 1 : -1);
    }
    blockServer = {
        ...block,
        ...blockServer
    };
    if (blockServer.data) delete blockServer.data;
    return {
        block: block,
        blockServer: blockServer,
        children: children
    };
};
var $00702988c57f0598$export$2e2bcd8739ae039 = $00702988c57f0598$var$createBlock;



var // Endpoint api bots
$2305f224744063d4$export$2e2bcd8739ae039 = {
    createCategory: (bot_id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`bot/${bot_id}/category`, data),
    updateCategory: (bot_id, id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`bot/${bot_id}/category/${id}`, data),
    deleteCategory: (bot_id, id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`bot/${bot_id}/category/${id}`, data),
    getPositionsCategories: (bot_id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`bot/${bot_id}/categories/positions`, data),
    addBlocksInCategory: (bot_id, id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`bot/${bot_id}/category/${id}/add`, data),
    substractBlocksFromCategory: (bot_id, category_id, id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`bot/${bot_id}/category/${category_id}/substract/${id}`, data)
};


function $c0a2f6f3ed0294da$var$editorAction() {
    const { getBotInformations: getBotInformations, addVariable: addVariableservice, deleteVariable: deleteVariableService, importTemplate: importTemplate } = (0, $09b215dee01724cc$export$2e2bcd8739ae039);
    const { updateBlockName: updateBlockName, updateBlockData: updateBlockData, updateBlocksPosition: updateBlocksPositionService, createBlock: createBlock, deleteBlock: deleteBlock, updateBlockHaveStatistic: updateBlockHaveStatistic, updateBlocksName: updateBlocksNameService } = (0, $66069c4c10825b66$export$2e2bcd8739ae039);
    const { addPath: addPathService, deletePath: deletePathService } = (0, $60df9a4ecf485d80$export$2e2bcd8739ae039);
    const { createCategory: createCategoryService, updateCategory: updateCategoryService, deleteCategory: deleteCategoryService, addBlocksInCategory: addBlocksInCategoryService, substractBlocksFromCategory: substractBlocksFromCategoryService } = (0, $2305f224744063d4$export$2e2bcd8739ae039);
    const { updateBlockChild: updateBlockChildService, createBlockChild: createBlockChildService, deleteBlockChild: deleteBlockChildService, updateBlockChildren: updateBlockChildrenService } = (0, $2c888a78f40b389b$export$2e2bcd8739ae039);
    const dispatch = (0, $6949a38b8f965998$export$649a5cfe816ce921)();
    const botDispatch = (0, $7ef7d0b863ac05b4$export$6016dcbff4082b17)();
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const { botId: botId } = (0, $7ef7d0b863ac05b4$export$248471b8219beb2f)();
    const { checkErrors: checkErrors, checkErrorsForPath: checkErrorsForPath } = (0, $e243ee0cadf02534$export$2e2bcd8739ae039)();
    const actionGetBotInformations = async (name, dispatchLoading = true)=>{
        if (dispatchLoading) dispatch({
            type: "loadBotPending"
        });
        const [response, error] = await getBotInformations(name);
        if (error !== null) {
            const { status: status } = error;
            if (status == 422) return error;
            toast.error("Error during loading", "Cannot fetch bot data");
            return;
        }
        var { blocks: blocks, variables: variables, children: children, paths: paths, company_id: company_id, id: id, phone: phone, code: code, categories: categories } = response;
        const block_scenarios = blocks.filter((block)=>block.data.basic);
        const block_start = block_scenarios ? block_scenarios[0] : null;
        blocks = blocks.map((block)=>{
            if (block.children !== undefined) block.children.sort((a, b)=>a.index - b.index);
            return {
                ...block
            };
        });
        if (blocks.length == 0) {
            const { scenario: scenario } = (0, $931611736c39b122$export$2e2bcd8739ae039);
            scenario.tree.name = "User Connected";
            scenario.tree.data.basic = 1;
            scenario.server.basic = 1;
            const { block: block, blockServer: blockServer, children: children } = (0, $00702988c57f0598$export$2e2bcd8739ae039)(scenario, 0, 0, 30, 120);
            addBlock(block, blockServer, children, id);
        }
        botDispatch({
            type: "setInfo",
            payload: {
                variables: variables,
                id: id,
                company_id: company_id,
                block_start: block_start,
                name: name,
                code: code,
                phone: phone
            }
        });
        if (blocks.length) {
            checkErrors(blocks, paths, children);
            dispatch({
                type: "loadBotSuccess",
                payload: {
                    blocks: blocks,
                    children: children,
                    paths: paths,
                    categories: categories
                }
            });
            return;
        }
        dispatch({
            type: "setFetching",
            payload: {
                fetching: false
            }
        });
        return;
    };
    const addBlock = async (block, blockServer, children, botIdToSend = 0)=>{
        dispatch({
            type: "addBlock",
            payload: {
                block: block,
                children: children
            }
        });
        botIdToSend = botIdToSend ? botIdToSend : botId;
        const [response, error] = await createBlock(botIdToSend, blockServer);
        if (error !== null) {
            toast.error("Block not created", "Oups something go wrong check your internet connexion");
            console.log(error);
        }
        if (children) for(var i = 0; i < children.length; i++){
            const child = children[i];
            createBlockChildService(botIdToSend, block.object_id, child);
        }
        checkErrors();
    };
    return {
        addBlockTemplate: async (block)=>{
            dispatch({
                type: "addBlock",
                payload: {
                    block: block,
                    children: []
                }
            });
        },
        deleteVariable: async (id)=>{
            botDispatch({
                type: "deleteVariable",
                payload: {
                    id: id
                }
            });
            const [response, error] = await deleteVariableService(botId, id);
            if (error === null) toast.success("Variable deleted", "Congrats variable has been deleted \uD83C\uDF89\uD83C\uDF89");
        },
        addVariable: async (data)=>{
            const [response, error] = await addVariableservice(botId, data);
            if (error !== null) {
                console.log(error);
                return false;
            }
            toast.success("Variable Add", "Congrats variable " + data.name.toUpperCase() + " has been created \uD83C\uDF89\uD83C\uDF89");
            const variable = {
                id: response.id,
                name: data.name,
                type: {
                    name: data.type
                }
            };
            botDispatch({
                type: "addVariable",
                payload: {
                    variable: variable
                }
            });
            return true;
        },
        updateVariable: (variable, type, id)=>{
        // TODO dispatch({type : 'updateVariable', payload : {block, children}})
        },
        updateBlocksPosition: async (blocks)=>{
            for(let index in blocks){
                let block = blocks[index];
                const { object_id: object_id, x: x, y: y } = block;
                dispatch({
                    type: "updateBlockPosition",
                    payload: {
                        id: object_id,
                        x: x,
                        y: y
                    }
                });
            }
            const [response, error] = await updateBlocksPositionService(botId, blocks);
            if (error !== null) {
                console.log(error);
                return false;
            }
        },
        updateBlocksName: async (blocks)=>{
            for(let index in blocks){
                let block = blocks[index];
                const { object_id: object_id, name: name, type: type } = block;
                dispatch({
                    type: "updateBlockName",
                    payload: {
                        id: object_id,
                        name: name
                    }
                });
                if (type.name !== "magic") continue;
                dispatch({
                    type: "updateBlockMagic",
                    payload: {
                        id: object_id
                    }
                });
            }
            const [response, error] = await updateBlocksNameService(botId, blocks);
            if (error !== null) {
                console.log(error);
                return false;
            }
        },
        updateBlockPosition: async (id, x, y)=>dispatch({
                type: "updateBlockPosition",
                payload: {
                    id: id,
                    x: x,
                    y: y
                }
            }),
        updateBlockName: async (id, name)=>{
            const [response, error] = await updateBlockName(botId, id, name);
            if (error !== null) console.log(error);
            dispatch({
                type: "updateBlockName",
                payload: {
                    id: id,
                    name: name
                }
            });
        },
        updateBlockData: async (id, data, dataServer = {})=>{
            if ((0, $kEUo3.isEmpty)(dataServer)) dataServer = {
                ...data
            };
            if (data.name) {
                dispatch({
                    type: "updateBlockName",
                    payload: {
                        id: id,
                        name: dataServer.name
                    }
                });
                delete data.name;
            }
            botDispatch({
                type: "onUpdate",
                payload: {
                    onUpdate: true
                }
            });
            const [response, error] = await updateBlockData(botId, id, dataServer);
            botDispatch({
                type: "onUpdate",
                payload: {
                    onUpdate: false
                }
            });
            if (error !== null) console.log(error);
            dispatch({
                type: "updateBlockData",
                payload: {
                    id: id,
                    data: data
                }
            });
        },
        updateBlock: async (id, data, dataServer, children)=>{
            if ((0, $kEUo3.isEmpty)(dataServer)) dataServer = data;
            if (data.action_type) {
                dispatch({
                    type: "updateBlockTypeAction",
                    payload: {
                        id: id,
                        type: data.action_type
                    }
                });
                dataServer.action_type = data.action_type.name;
            }
            if (data.name) {
                dispatch({
                    type: "updateBlockName",
                    payload: {
                        id: id,
                        name: data.name
                    }
                });
                dataServer.name = data.name;
            }
            if (data.children) for(var i = 0; i < children.length; i++){
                const child = children[i];
                dispatch({
                    type: "createBlockChild",
                    payload: {
                        block_id: id,
                        data: child
                    }
                });
            }
            dispatch({
                type: "updateBlockData",
                payload: {
                    id: id,
                    data: data.data
                }
            });
            const [response, error] = await updateBlockData(botId, id, dataServer);
            if (error !== null) console.log(error);
            if (data.children) for(var i = 0; i < children.length; i++){
                const child = children[i];
                createBlockChildService(botId, id, child);
            }
        },
        updateBlockDataJump: async (id, name, jump, blockIdInteger, is_constant, variable_value)=>{
            const [response, error] = await updateBlockData(botId, id, {
                name: name,
                jump_id: jump?.object_id,
                is_constant: is_constant,
                variable_value: variable_value
            });
            if (error !== null) console.log(error);
            dispatch({
                type: "updateBlockName",
                payload: {
                    id: id,
                    name: name
                }
            });
            dispatch({
                type: "updateBlockData",
                payload: {
                    id: id,
                    data: {
                        block_id: blockIdInteger,
                        jump_id: jump,
                        is_constant: is_constant,
                        variable_value: variable_value
                    }
                }
            });
            setTimeout(()=>checkErrors(), 200);
        },
        updateBlockStatistic: async (block_id, is_statistic)=>{
            dispatch({
                type: "updateBlockStatistics",
                payload: {
                    id: block_id,
                    is_statistic: is_statistic
                }
            });
            const [response, error] = await updateBlockHaveStatistic(botId, block_id, is_statistic);
            if (error !== null) {
                console.log(error);
                return;
            }
            if (is_statistic == 1) toast.success("Statistics enabled", "Congrats some statistics has been created \uD83C\uDF89\uD83C\uDF89");
            else if (is_statistic == 0) toast.warning("Statistice disabled", "Warning some statistics has been disabled \u26A0\uFE0F\u26A0\uFE0F");
        },
        updateBlockVisibility: async (blocks, paths)=>dispatch({
                type: "updateBlockVisibility",
                payload: {
                    blocks: blocks,
                    paths: paths
                }
            }),
        importBlockTemplate: async (id, data)=>{
            dispatch({
                type: "deleteBlock",
                payload: {
                    id: id
                }
            });
            var [response, error] = await importTemplate(botId, data);
            if (error !== null) {
                console.log(error);
                return false;
            }
            toast.success("Scenario Imported", "Congrats variable your scenario have been imported \uD83C\uDF89\uD83C\uDF89");
            actionGetBotInformations(botId, false);
        },
        deleteBlock: async (id)=>{
            dispatch({
                type: "deleteBlock",
                payload: {
                    id: id
                }
            });
            const [response, error] = await deleteBlock(botId, id);
            if (error !== null) {
                toast.error("Block not deleted", "Oups something go wrong");
                console.log(error);
            }
            checkErrors();
        },
        createBlockChild: async (block_id, data)=>{
            const [response, error] = await createBlockChildService(botId, block_id, data);
            if (error !== null) console.log(error);
            checkErrors();
        },
        updateBlockChild: async (block_id, object_id, data)=>{
            const [response, error] = await updateBlockChildService(botId, block_id, object_id, data);
            if (error !== null) console.log(error);
        },
        updateBlockChildren: async (block_id, children)=>{
            const [response, error] = await updateBlockChildrenService(botId, block_id, children);
            if (error !== null) console.log(error);
        },
        deleteBlockChild: async (block_id, object_id)=>{
            const [response, error] = await deleteBlockChildService(botId, block_id, object_id);
            if (error !== null) console.log(error);
            checkErrors();
        },
        deletePath: async (id)=>{
            dispatch({
                type: "deletePath",
                payload: {
                    id: id
                }
            });
            const [response, error] = await deletePathService(botId, id);
            if (error !== null) {
                console.log(error);
                return false;
            }
            checkErrors();
        },
        createPath: async (parent_block_id, path_id, child_block_id)=>{
            dispatch({
                type: "createPath",
                payload: {
                    parent_block_id: parent_block_id,
                    path_id: path_id,
                    child_block_id: child_block_id
                }
            });
            const [response, error] = await addPathService(botId, {
                child_id: child_block_id,
                parent_id: parent_block_id,
                object_id: path_id
            });
            if (error !== null) {
                console.log(error);
                return false;
            }
            checkErrorsForPath();
        },
        createCategory: async (category)=>{
            category.bot_id = botId;
            const [res, errors] = await createCategoryService(botId, category);
            if (errors != null) {
                console.log(errors);
                toast.error("Error", errors.data, 5000);
                return;
            }
            dispatch({
                type: "createCategory",
                payload: {
                    ...res
                }
            });
            toast.success("Success", "A new category has been created !");
        },
        updateCategory: async (category_ids, data)=>{
            category_ids = Array.isArray(category_ids) ? category_ids : [
                category_ids
            ] // quand on bouge un block, ca peut etre une liste d'id, sinon c'est tjr un unique id
            ;
            for(let i = 0; i < category_ids.length; i++){
                let id = category_ids[i];
                data = data ?? {
                    id: id
                } // pour le move block
                ;
                const [res, error] = await updateCategoryService(botId, id, data);
                if (error != null) {
                    console.error(error);
                    return;
                }
                dispatch({
                    type: "updateCategory",
                    payload: {
                        id: id,
                        category: res
                    }
                });
            }
            if (Array.isArray(category_ids == false)) toast.success("Success", "A category has been updated");
        },
        deleteCategory: async (category_id, data)=>{
            dispatch({
                type: "deleteCategory",
                payload: {
                    id: category_id
                }
            });
            const [res, error] = await deleteCategoryService(botId, category_id, data);
            if (error != null) {
                console.error(error);
                return;
            }
            toast.success("Success", "A category has been deleted");
        },
        addBlocksInCategory: async (category_id, data)=>{
            const [res, errors] = await addBlocksInCategoryService(botId, category_id, data);
            if (errors != null) {
                console.log(errors);
                toast.error("Error", errors.data, 5000);
                return;
            }
            toast.success("Success", "A selection of blocks has been added into the category");
            dispatch({
                type: "updateCategory",
                payload: {
                    id: category_id,
                    category: res
                }
            });
        },
        ungroupBlockFromCategory: async (block, data)=>{
            const [res, errors] = await substractBlocksFromCategoryService(botId, block.bot_category_id, block.object_id, data);
            if (errors != null) {
                console.log(errors);
                toast.error("Error", errors.data, 5000);
                return;
            }
            dispatch({
                type: "ungroupBlockFromCategory",
                payload: {
                    id: block.bot_category_id,
                    infoCategory: res,
                    block_object_id: block.object_id
                }
            });
            toast.success("Success", "A block has been removed from category");
        },
        setCtrlKey: (ctrlKey = false)=>dispatch({
                type: "setCtrlKey",
                payload: {
                    ctrlKey: ctrlKey
                }
            }),
        setShitKey: (shiftKey = false)=>dispatch({
                type: "setShiftKey",
                payload: {
                    shiftKey: shiftKey
                }
            }),
        setPressDown: (pressDown = false)=>dispatch({
                type: "setPressDown",
                payload: {
                    pressDown: pressDown
                }
            }),
        setZoneSelectBlocks: (x, y)=>dispatch({
                type: "setZoneSelectBlocks",
                payload: {
                    x: x,
                    y: y
                }
            }),
        actionGetBotInformations: actionGetBotInformations,
        addBlock: addBlock
    };
}
var $c0a2f6f3ed0294da$export$2e2bcd8739ae039 = $c0a2f6f3ed0294da$var$editorAction;



// Simple Components to see a variable block
function $3959de029ef63946$var$VariableBlock({ id: id, name: name, type: type }) {
    const { deleteVariable: deleteVariable } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "var_block",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                className: "name",
                children: `[${name.toUpperCase()}]`
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                className: "type",
                children: type.name
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "actions",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                    className: "editor-iconButton main_add-button button_center delete_action",
                    icon: "fas fa-trash",
                    onClick: ()=>deleteVariable(id)
                })
            })
        ]
    });
}
var $3959de029ef63946$export$2e2bcd8739ae039 = $3959de029ef63946$var$VariableBlock;











var $9c0fc12f676cb0a2$export$2e2bcd8739ae039 = [
    {
        value: "text",
        text: "Text"
    },
    {
        value: "number",
        text: "Number"
    },
    {
        value: "stt",
        text: "STT"
    },
    {
        value: "tts",
        text: "TTS"
    }
];



// Popup use to create or modificate a variable name / type
function $3ee03af01c9655d3$var$VariableEdition({ onClose: onClose }) {
    const { variables: variables } = (0, $7ef7d0b863ac05b4$export$248471b8219beb2f)();
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { register: register, getValues: getValues, formState: formState, setValue: setValue } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange"
    });
    const onClick = ()=>{
        // ! important to resolve the value, api's call are declared in another component
        modal.resolve(getValues());
        return onClose();
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("form", {
        className: "variables_modal",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                className: "title",
                children: "Create a Variable"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "area-edit",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                        ...register("name", {
                            required: true,
                            setValueAs: (v)=>v.toLowerCase(),
                            validate: (v)=>variables.filter((variable)=>variable.name == v).length == 0 && /[^a-zA-Z0-9_]/.test(v) == false
                        }),
                        className: `variable_input ${Object.keys(formState.errors).length && formState.errors.name.type == "validate" ? " error" : ""}`,
                        placeholder: "Variable name"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                        ...register("type"),
                        setValue: setValue,
                        choices: (0, $9c0fc12f676cb0a2$export$2e2bcd8739ae039),
                        width: 250
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                label: "Confirm",
                onClick: onClick,
                disabled: !formState.isValid
            })
        ]
    });
}
var $3ee03af01c9655d3$export$2e2bcd8739ae039 = $3ee03af01c9655d3$var$VariableEdition;








var $bh6RR = parcelRequire("bh6RR");
// This component is made to be use in any Form component of the bot editor
function $5b4dd497c4ab826c$var$AreaList({ title: title, children: children, className: className, maxHeight: maxHeight, buttonLabel: buttonLabel, onClickButton: onClickButton, unfold: unfold, setUnfold: setUnfold }) {
    const aeraListContainer = (0, $bh6RR.useRef)();
    //style={{ height : unfold ? parseInt(maxHeight,10) + 50 : 0 }}
    // We need to set an observer to check each time our parent components is resized, but we need to put it in a use effect
    // In fact if we unmount the component, we need to disconnect the observer or tha will leak to some bug
    // We can only do that with a useEffect, moreover we don't want this function to be call on every rerender
    // so we just pust the areaListContainer in dependies list, maybe tha function need to have her scope updated if the areaListContainerChange
    (0, $bh6RR.useEffect)(()=>{
        if (aeraListContainer.current == null) return;
        const resize = ()=>{
            if (aeraListContainer.current == undefined) return;
            return aeraListContainer.current.scrollHeight > parseInt(maxHeight, 10) ? aeraListContainer.current.classList.add("scroll") : aeraListContainer.current.classList.remove("scroll");
        };
        var observer = new ResizeObserver(resize);
        observer.observe(aeraListContainer.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        aeraListContainer
    ]);
    const onClick = ()=>{
        console.log(aeraListContainer.current);
        const scroll = (duration)=>scrollToBottom(aeraListContainer.current, duration);
        onClickButton([
            scroll
        ]);
    };
    const scrollToBottom = (area, duration)=>{
        if (area == null) return;
        setTimeout(()=>{
            area.firstChild.firstChild.lastElementChild.scrollIntoView({
                behavior: "smooth"
            });
        });
    //el.scrollIntoView({behavior: 'smooth', block: 'end', inline: 'nearest' })
    };
    className = className ? "area-list " + className : "area-list";
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "area-container",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: className,
            style: {
                cursor: unfold ? "default" : "pointer"
            },
            ...unfold ? {} : {
                onClick: setUnfold
            },
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "top-bar",
                    children: title
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: unfold ? "info-bar" : "info-bar fold",
                    style: {
                        maxHeight: unfold ? parseInt(maxHeight, 10) + 50 : 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "area-list-container",
                            style: {
                                maxHeight: maxHeight
                            },
                            ref: aeraListContainer,
                            children: children
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "button-container-center",
                            children: buttonLabel && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                label: buttonLabel,
                                onClick: onClick
                            })
                        })
                    ]
                })
            ]
        })
    });
}
$5b4dd497c4ab826c$var$AreaList.defaultProps = {
    maxHeight: 70,
    unfold: true,
    setUnfold: ()=>{},
    onClickButton: ()=>{}
};
var $5b4dd497c4ab826c$export$2e2bcd8739ae039 = $5b4dd497c4ab826c$var$AreaList;




var $bh6RR = parcelRequire("bh6RR");


// Component made to be call in the AreaList, we separate the areaList and the areaListData cause maybe in the future we want some differents functionnaly
const $0c7211c3be597575$var$getObjectId = (listChildrens, index)=>{
    if (!listChildrens) return;
    return listChildrens.find((child)=>child.index === index + 1)?.object_id; // index = 0 ne doit pas etre comptee
};
function $0c7211c3be597575$var$AreaListData({ data: data, ComponentRow: ComponentRow, FunctionsRow: FunctionsRow, componentKey: componentKey, childrenBlocks: childrenBlocks }) {
    // {...(row.key ? {KeyValue : row.key} : {}) this syntax allow us to defined a property on the object with a ternary condition : if u don't understand check some documentation
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "area-flex",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: "data-list",
            children: data && data.map((row, idx)=>/*#__PURE__*/ (0, $bh6RR.createElement)(ComponentRow, {
                    ...row,
                    ...row.key ? {
                        KeyValue: row.key
                    } : {},
                    first: idx == 0,
                    idx: idx == data.length - 1 ? -1 : idx,
                    ...FunctionsRow,
                    key: componentKey ? (0, $cbf58a06f6fccf5a$export$2e2bcd8739ae039)(componentKey, row) : idx,
                    object_block_id: $0c7211c3be597575$var$getObjectId(childrenBlocks, idx)
                }))
        })
    });
}
$0c7211c3be597575$var$AreaListData.defaultProps = {
    ComponentRow: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {}),
    componentKey: "",
    FunctionsRow: {}
};
var $0c7211c3be597575$export$2e2bcd8739ae039 = $0c7211c3be597575$var$AreaListData;


// List of all the variable's in the bot, throught the AreaList
function $f342a09a02a545e5$var$VariablesManager() {
    const { variables: variables } = (0, $7ef7d0b863ac05b4$export$248471b8219beb2f)();
    const { addVariable: addVariable } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const onClick = async ()=>{
        const data = await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show("editor-popup", {
            Component: (0, $3ee03af01c9655d3$export$2e2bcd8739ae039)
        });
        // Wait the modal variable creation
        addVariable(data);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                className: "title title_variable",
                children: "Variable Manager"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                className: "sub_title",
                children: "Custom variables"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5b4dd497c4ab826c$export$2e2bcd8739ae039), {
                title: "Variables",
                buttonLabel: "Create a variable",
                maxHeight: "550px",
                onClickButton: onClick,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0c7211c3be597575$export$2e2bcd8739ae039), {
                    data: variables,
                    ComponentRow: (0, $3959de029ef63946$export$2e2bcd8739ae039)
                })
            })
        ]
    });
}
var $f342a09a02a545e5$export$2e2bcd8739ae039 = $f342a09a02a545e5$var$VariablesManager;






var $bh6RR = parcelRequire("bh6RR");
const $c76401e9122ea449$var$EditorState = {
    blocksSelected: [],
    blockIdClicked: null,
    mouse: {
        x: 0,
        y: 0
    },
    magnetPosition: {
        x: 0,
        y: 0,
        on: false,
        id: null
    },
    pathTmp: null
};
var $c76401e9122ea449$export$2e2bcd8739ae039 = $c76401e9122ea449$var$EditorState;


function $fdc5df748c00662e$var$EditorReducer(state, action) {
    switch(action.type){
        case "addSelectedBlock":
            return {
                ...state,
                blocksSelected: [
                    ...state.blocksSelected,
                    action.payload.block
                ]
            };
        case "setSelectedBlocks":
            return {
                ...state,
                blocksSelected: action.payload.blocks
            };
        case "createTmpPath":
            return {
                ...state,
                pathTmp: {
                    x: action.payload.x,
                    y: action.payload.y,
                    _x: action.payload.x,
                    _y: action.payload.y,
                    parent_block_id: action.payload.parent_block_id,
                    child_block_id: action.payload.child_block_id
                }
            };
        case "setMagnetPosition":
            return {
                ...state,
                magnetPosition: {
                    x: action.payload.x,
                    y: action.payload.y,
                    on: true,
                    id: action.payload.id
                }
            };
        case "setZoneSelectBlocks":
            return {
                ...state,
                zoneSelectBlocks: {
                    x: action.payload.x,
                    y: action.payload.y
                }
            };
        case "setDrag":
            return {
                ...state,
                pressDown: action.payload.drag
            };
        case "resetMagnetPosition":
            return {
                ...state,
                magnetPosition: {
                    x: 0,
                    y: 0,
                    on: false,
                    id: null
                }
            };
        case "resetTmpPath":
            return {
                ...state,
                pathTmp: null
            };
        case "deleteAllSelectedBlock":
            return {
                ...state,
                blocksSelected: []
            };
        case "deleteSelectedBlock":
            {
                const index = state.blocksSelected.findIndex((block)=>block.id == action.payload.id);
                if (index === -1) return {
                    ...state
                };
                state.blocksSelected.splice(index, 1);
                return {
                    ...state
                };
            }
        case "updateMouse":
            return {
                ...state,
                mouse: {
                    x: action.payload.x,
                    y: action.payload.y
                }
            };
        case "updateMouseAndBlockClicked":
            return {
                ...state,
                mouse: {
                    x: action.payload.x,
                    y: action.payload.y
                },
                blockIdClicked: action.payload.id ? action.payload.id : null
            };
        case "resetState":
            return 0, $c76401e9122ea449$export$2e2bcd8739ae039;
        default:
            throw new Error("unhandled action");
    }
}
var $fdc5df748c00662e$export$2e2bcd8739ae039 = $fdc5df748c00662e$var$EditorReducer;



const $7324df5b25c181de$var$EditorStateContext = /*#__PURE__*/ (0, $bh6RR.createContext)((0, $c76401e9122ea449$export$2e2bcd8739ae039));
const $7324df5b25c181de$var$EditorDispatchContext = /*#__PURE__*/ (0, $bh6RR.createContext)(null);
function $7324df5b25c181de$var$EditorContextProvider({ children: children }) {
    const [state, dispatch] = (0, $bh6RR.useReducer)((0, $fdc5df748c00662e$export$2e2bcd8739ae039), (0, $c76401e9122ea449$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7324df5b25c181de$var$EditorStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7324df5b25c181de$var$EditorDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
}
var $7324df5b25c181de$export$2e2bcd8739ae039 = $7324df5b25c181de$var$EditorContextProvider;
const $7324df5b25c181de$export$2fe873ee5eb16329 = ()=>(0, $bh6RR.useContext)($7324df5b25c181de$var$EditorStateContext);
const $7324df5b25c181de$export$2774feae192f80c = ()=>(0, $bh6RR.useContext)($7324df5b25c181de$var$EditorDispatchContext);



function $b160775e2cfdbb38$var$BlockContainerAction() {
    const dispatch = (0, $7324df5b25c181de$export$2774feae192f80c)();
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    return {
        addSelectedBlock: (block)=>dispatch({
                type: "addSelectedBlock",
                payload: {
                    block: block
                }
            }),
        deleteSelectedBlock: (id)=>dispatch({
                type: "deleteSelectedBlock",
                payload: {
                    id: id
                }
            }),
        setSelectedBlocks: (blocks)=>dispatch({
                type: "setSelectedBlocks",
                payload: {
                    blocks: blocks
                }
            }),
        deleteAllSelectedBlock: ()=>dispatch({
                type: "deleteAllSelectedBlock"
            }),
        updateMouse: (x, y)=>dispatch({
                type: "updateMouse",
                payload: {
                    x: x,
                    y: y
                }
            }),
        updateMouseAndBlockClicked: (x, y, id)=>dispatch({
                type: "updateMouseAndBlockClicked",
                payload: {
                    x: x,
                    y: y,
                    id: id
                }
            }),
        createTmpPath: (x, y, parent_block_id, child_block_id)=>dispatch({
                type: "createTmpPath",
                payload: {
                    x: x,
                    y: y,
                    parent_block_id: parent_block_id,
                    child_block_id: child_block_id
                }
            }),
        resetTmpPath: ()=>{
            document.getElementById("path_tmp").setAttributeNS(null, "d", "");
            dispatch({
                type: "resetTmpPath",
                payload: {}
            });
        },
        setMagnetPosition: (x, y, id)=>dispatch({
                type: "setMagnetPosition",
                payload: {
                    x: x,
                    y: y,
                    id: id
                }
            }),
        resetMagnetPosition: ()=>dispatch({
                type: "resetMagnetPosition"
            })
    };
}
var $b160775e2cfdbb38$export$2e2bcd8739ae039 = $b160775e2cfdbb38$var$BlockContainerAction;


// Warning useCtrlKey is activate with shiftKey
function $008a36c4d52c37da$var$useShiftKey() {
    const { setShitKey: setShitKey } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const { shiftKey: shiftKey } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const { deleteAllSelectedBlock: deleteAllSelectedBlock } = (0, $b160775e2cfdbb38$export$2e2bcd8739ae039)();
    const changeShiftKey = (e)=>{
        //console.log('toto');
        //if(document.querySelector('.input editor-input title_input')) return;
        if (document.activeElement == null || document.activeElement.nodeName == "TEXTAREA") return;
        if (document.activeElement.nodeName == "INPUT" && document.activeElement.type != "file") return;
        deleteAllSelectedBlock();
        setShitKey(!shiftKey);
        document.querySelectorAll(".block").forEach((block)=>!shiftKey ? block.classList.add("shiftKey") : block.classList.remove("shiftKey") || block.classList.remove("selected"));
    // Messy fix for optimize rendering on block for multiple selection
    //document.querySelectorAll('.block').forEach(block => block.classList.add('shiftKey'))
    };
    const pressShiftKey = (e)=>{
        if (shiftKey) return;
    //setCtrlKey(true)
    /*
        if(e.shiftKey != shiftKey) {
            changeShiftKey();
        }*/ };
    return {
        changeShiftKey: changeShiftKey,
        pressShiftKey: pressShiftKey,
        shiftKey: shiftKey
    };
}
var $008a36c4d52c37da$export$2e2bcd8739ae039 = $008a36c4d52c37da$var$useShiftKey;


// Component for calling the VariableManager on the editor-window : popup on the right
function $59aa6d1647fd972c$var$ButtonVariableManager() {
    const { changeShiftKey: changeShiftKey, shiftKey: shiftKey } = (0, $008a36c4d52c37da$export$2e2bcd8739ae039)();
    const onClick = ()=>{
        shiftKey && changeShiftKey();
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show("editor-window", {
            Component: (0, $f342a09a02a545e5$export$2e2bcd8739ae039)
        });
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "variable_manager",
        onClick: onClick
    });
}
var $59aa6d1647fd972c$export$2e2bcd8739ae039 = $59aa6d1647fd972c$var$ButtonVariableManager;




var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
// Hook for fullscreen react
function $8e054dc4deb6316d$var$useFullScreen() {
    const [fullScreen, setFullScreen] = (0, $bh6RR.useState)(false);
    const toggleFullScreen = ()=>{
        !fullScreen ? document.querySelector("#root").requestFullscreen() : document.exitFullscreen();
        setFullScreen(!fullScreen);
    };
    const toggleFullScreenF11 = (event)=>{
        if (event.key != "F11") return;
        // Kill event if F11 to replace fullscreen browser call by our own
        event.preventDefault();
        toggleFullScreen();
    };
    return {
        toggleFullScreen: toggleFullScreen,
        toggleFullScreenF11: toggleFullScreenF11
    };
}
var $8e054dc4deb6316d$export$2e2bcd8739ae039 = $8e054dc4deb6316d$var$useFullScreen;



var $bh6RR = parcelRequire("bh6RR");
function $7b63fb7a90f9a07e$var$useFullScreenEditor(btn) {
    const { toggleFullScreen: toggleFullScreen, toggleFullScreenF11: toggleFullScreenF11 } = (0, $8e054dc4deb6316d$export$2e2bcd8739ae039)();
    //Hide sidebar when fullscreen
    const onFullScreenEventChange = (e)=>{
        const sidebar = document.getElementById("sidebar");
        const sidebarContainer = document.getElementById("sidebar-container");
        // Need to modificate sidebarContainer width if hidden
        if (document.fullscreenElement) {
            sidebar.style.display = "none";
            sidebarContainer.style.width = "160px";
            btn.current.classList.add("exit");
        } else {
            sidebar.style.display = "flex";
            sidebarContainer.style.width = "220px";
            btn.current.classList.remove("exit");
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        document.addEventListener("keydown", toggleFullScreenF11);
        document.onfullscreenchange = onFullScreenEventChange;
        return ()=>{
            document.onfullscreenchange = ()=>{};
            document.removeEventListener("keydown", toggleFullScreenF11);
        };
    }, []);
    return {
        toggleFullScreen: toggleFullScreen
    };
}
var $7b63fb7a90f9a07e$export$2e2bcd8739ae039 = $7b63fb7a90f9a07e$var$useFullScreenEditor;



// Component for toggling full screen throught a button, can also be triggered thanks to F11
function $b24824868c84b99d$var$ButtonFullScreen() {
    const toggleButtonFullScreen = (0, $bh6RR.useRef)(null);
    const { toggleFullScreen: toggleFullScreen } = (0, $7b63fb7a90f9a07e$export$2e2bcd8739ae039)(toggleButtonFullScreen);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        ref: toggleButtonFullScreen,
        className: "fullscreen",
        onClick: toggleFullScreen
    });
}
var $b24824868c84b99d$export$2e2bcd8739ae039 = $b24824868c84b99d$var$ButtonFullScreen;




var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");
const $817b2a2ad9c9e32d$var$CameraState = {
    panzone: null
};
var $817b2a2ad9c9e32d$export$2e2bcd8739ae039 = $817b2a2ad9c9e32d$var$CameraState;


function $98eda068dab2497a$var$CameraReducer(state, action) {
    switch(action.type){
        case "loadCamera":
            return {
                ...state,
                panzone: action.payload.panzoom
            };
        case "resetState":
            return 0, $817b2a2ad9c9e32d$export$2e2bcd8739ae039;
        default:
            throw new Error("unhandled action");
    }
}
var $98eda068dab2497a$export$2e2bcd8739ae039 = $98eda068dab2497a$var$CameraReducer;



const $e677ba9f021c00cc$var$CameraStateContext = /*#__PURE__*/ (0, $bh6RR.createContext)((0, $817b2a2ad9c9e32d$export$2e2bcd8739ae039));
const $e677ba9f021c00cc$var$CameraDispatchContext = /*#__PURE__*/ (0, $bh6RR.createContext)(null);
function $e677ba9f021c00cc$var$CameraContextProvider({ children: children }) {
    const [state, dispatch] = (0, $bh6RR.useReducer)((0, $98eda068dab2497a$export$2e2bcd8739ae039), (0, $817b2a2ad9c9e32d$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e677ba9f021c00cc$var$CameraStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($e677ba9f021c00cc$var$CameraDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
}
var $e677ba9f021c00cc$export$2e2bcd8739ae039 = $e677ba9f021c00cc$var$CameraContextProvider;
const $e677ba9f021c00cc$export$395166f91704e8fd = ()=>(0, $bh6RR.useContext)($e677ba9f021c00cc$var$CameraStateContext);
const $e677ba9f021c00cc$export$aa08601751813bc1 = ()=>(0, $bh6RR.useContext)($e677ba9f021c00cc$var$CameraDispatchContext);




var $bh6RR = parcelRequire("bh6RR");


const $26f3660f5c0ff7f5$var$cellSizeEditor = 40;
var $26f3660f5c0ff7f5$export$2e2bcd8739ae039 = $26f3660f5c0ff7f5$var$cellSizeEditor;




// Wrapper function rename a value if value present rename and change value
const $82c17717109a0d2e$var$renameKeyOfObjectOrSetValue = (object, { old_key: old_key, new_key: new_key }, value)=>{
    object[new_key] = value != undefined ? value : object[old_key];
    delete object[old_key];
};
var $82c17717109a0d2e$export$2e2bcd8739ae039 = $82c17717109a0d2e$var$renameKeyOfObjectOrSetValue;


// Transform block tree state api to block server api
const $3939ef7daefedb29$var$BlockActionApiTransformer = (origin)=>{
    const data = {
        ...origin
    };
    (0, $82c17717109a0d2e$export$2e2bcd8739ae039)(data, {
        old_key: "body",
        new_key: "api_body"
    });
    (0, $82c17717109a0d2e$export$2e2bcd8739ae039)(data, {
        new_key: "api_body_type"
    }, data.api_body_type.name);
    (0, $82c17717109a0d2e$export$2e2bcd8739ae039)(data, {
        new_key: "api_method_type"
    }, data.api_method_type.name);
    (0, $82c17717109a0d2e$export$2e2bcd8739ae039)(data, {
        old_key: "headers",
        new_key: "api_headers"
    });
    (0, $82c17717109a0d2e$export$2e2bcd8739ae039)(data, {
        old_key: "responses",
        new_key: "api_responses"
    });
    (0, $82c17717109a0d2e$export$2e2bcd8739ae039)(data, {
        old_key: "url",
        new_key: "api_url"
    });
    return data;
};
var $3939ef7daefedb29$export$2e2bcd8739ae039 = $3939ef7daefedb29$var$BlockActionApiTransformer;


// Transform block tree state condition to block server condition
const $412c064fcf28d02b$var$BlockActionConditionTranformer = (origin)=>{
    const data = {
        ...origin
    };
    return data;
};
var $412c064fcf28d02b$export$2e2bcd8739ae039 = $412c064fcf28d02b$var$BlockActionConditionTranformer;



// Wrapper function to delete a key of an object
const $910bb8df327fc71f$var$deleteKeyOfObject = (object, key)=>{
    delete object[key];
};
var $910bb8df327fc71f$export$2e2bcd8739ae039 = $910bb8df327fc71f$var$deleteKeyOfObject;


// Transform block tree state extract to block server api
const $492efa5a9e80237f$var$BlockActionExtractTransformer = (origin)=>{
    const data = {
        ...origin
    };
    data.extract_output == null ? (0, $910bb8df327fc71f$export$2e2bcd8739ae039)(data, "extract_output") : (0, $82c17717109a0d2e$export$2e2bcd8739ae039)(data, {
        new_key: "extract_output"
    }, data.extract_output.name);
    data.extract_input == null ? (0, $910bb8df327fc71f$export$2e2bcd8739ae039)(data, "extract_input") : (0, $82c17717109a0d2e$export$2e2bcd8739ae039)(data, {
        new_key: "extract_input"
    }, data.extract_input.name);
    if (data.before_after == null) (0, $82c17717109a0d2e$export$2e2bcd8739ae039)(data, {
        new_key: "before_after"
    }, data.before_after.name);
    (0, $82c17717109a0d2e$export$2e2bcd8739ae039)(data, {
        new_key: "extract_type"
    }, data.extract_type.name);
    return data;
};
var $492efa5a9e80237f$export$2e2bcd8739ae039 = $492efa5a9e80237f$var$BlockActionExtractTransformer;



// Transform block tree state redirection to block server api
const $e4be9106192b1f80$var$BlockActionRedirectionTransformer = (origin)=>{
    const data = {
        ...origin
    };
    (0, $82c17717109a0d2e$export$2e2bcd8739ae039)(data, {
        old_key: "variable",
        new_key: "keyword_var"
    }, data.variable ? data.variable.name : null);
    (0, $82c17717109a0d2e$export$2e2bcd8739ae039)(data, {
        old_key: "variable_redirect",
        new_key: "keyword_redirect_var"
    }, data.variable_redirect ? data.variable_redirect.name : null);
    return data;
};
var $e4be9106192b1f80$export$2e2bcd8739ae039 = $e4be9106192b1f80$var$BlockActionRedirectionTransformer;


// Transform block tree state action to block server api
const $3234f4e78f385769$var$BlockActionTransformer = (origin)=>{
    const data = {
        ...origin
    };
    return data;
};
var $3234f4e78f385769$export$2e2bcd8739ae039 = $3234f4e78f385769$var$BlockActionTransformer;


// Transform block tree state scenario to block server api
const $e1d4b4c825513304$var$BlockScenarioTransformer = (origin)=>{
    const data = {
        ...origin
    };
    return data;
};
var $e1d4b4c825513304$export$2e2bcd8739ae039 = $e1d4b4c825513304$var$BlockScenarioTransformer;


// Transform block tree state variables to block server api
const $4cf758f4f1e485b0$var$BlockActionVariableTransformer = (origin)=>{
    const data = {
        ...origin
    };
    data.variables = data.variables.map((variable)=>{
        return {
            variable_name: variable.variable == null ? null : variable.variable.name,
            variable_value: variable.value,
            is_operation: variable.is_operation,
            index: variable.index
        };
    });
    return data;
};
var $4cf758f4f1e485b0$export$2e2bcd8739ae039 = $4cf758f4f1e485b0$var$BlockActionVariableTransformer;




// Transform block tree state statement to block server api
const $be5ff267b91af682$var$BlockStatementTransformer = (origin)=>{
    const data = {
        ...origin
    };
    data.variable_redirect == null ? (0, $910bb8df327fc71f$export$2e2bcd8739ae039)(data, "variable_redirect") : (0, $82c17717109a0d2e$export$2e2bcd8739ae039)(data, {
        new_key: "statement_redirect_var",
        old_key: "variable_redirect"
    }, data.variable_redirect.name);
    return data;
};
var $be5ff267b91af682$export$2e2bcd8739ae039 = $be5ff267b91af682$var$BlockStatementTransformer;


// Transform block tree state jump to block server api
const $b0f548ba4fdfca20$var$BlockJumpTransformer = (origin)=>{
    const data = {
        ...origin
    };
    data.jump_id = data.jump_id.object_id;
    return data;
};
var $b0f548ba4fdfca20$export$2e2bcd8739ae039 = $b0f548ba4fdfca20$var$BlockJumpTransformer;


// Transform block tree state jump to block server api
const $e8d0ea99a88e1582$var$BlockAnnouncementTransformer = (origin)=>{
    const data = {
        ...origin
    };
    return data;
};
var $e8d0ea99a88e1582$export$2e2bcd8739ae039 = $e8d0ea99a88e1582$var$BlockAnnouncementTransformer;


var // Block list helper to call transformers easialy
$d916903816c636da$export$2e2bcd8739ae039 = {
    api: (0, $3939ef7daefedb29$export$2e2bcd8739ae039),
    condition: (0, $412c064fcf28d02b$export$2e2bcd8739ae039),
    extract_data: (0, $492efa5a9e80237f$export$2e2bcd8739ae039),
    keyword_redirection: (0, $e4be9106192b1f80$export$2e2bcd8739ae039),
    set_var: (0, $4cf758f4f1e485b0$export$2e2bcd8739ae039),
    action: (0, $3234f4e78f385769$export$2e2bcd8739ae039),
    scenario: (0, $e1d4b4c825513304$export$2e2bcd8739ae039),
    propos: (0, $be5ff267b91af682$export$2e2bcd8739ae039),
    magic: (0, $b0f548ba4fdfca20$export$2e2bcd8739ae039),
    announcement: (0, $e8d0ea99a88e1582$export$2e2bcd8739ae039)
};


function $c45f4fed2a7893f8$var$useBlock() {
    const { addBlock: addBlockAction, deleteBlock: deleteBlock, updateBlock: updateBlock, addBlockTemplate: addBlockTemplateAction } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const { blocks: blocks, paths: paths } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const addBlock = (data, x, y, _x, _y)=>{
        const { block: block, blockServer: blockServer, children: children } = (0, $00702988c57f0598$export$2e2bcd8739ae039)(data, x, y, _x, _y);
        addBlockAction(block, blockServer, children);
    };
    const updateBlockAction = (block_id, data)=>{
        var { tree: treeBlock, server: blockServer } = data;
        if (treeBlock.children == undefined) {
            updateBlock(block_id, treeBlock, blockServer, []);
            return {
                ...treeBlock
            };
        }
        const children = [];
        for(var i = 0; i < treeBlock.children.length; i++){
            treeBlock.children[i].parent_block_id = block_id;
            treeBlock.children[i].object_id = (0, $d64a8a6f6e0ad216$export$2e2bcd8739ae039)(i);
            treeBlock.children[i].index = i + 1;
            if (treeBlock.children[i].id) delete treeBlock.children[i].id;
            let child = treeBlock.children[i];
            children.push(child);
        }
        updateBlock(block_id, {
            ...treeBlock
        }, blockServer, children);
        return {
            ...treeBlock
        };
    };
    const addBlockTemplate = (data, x, y, coord)=>{
        const objectId = (0, $d64a8a6f6e0ad216$export$2e2bcd8739ae039)();
        let width = Math.round((coord.max.x - coord.min.x) / (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039));
        let height = Math.round((coord.max.y - coord.min.y) / (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039));
        const block = {
            object_id: objectId,
            width: width,
            height: height,
            x: -x + 20,
            y: -y,
            data: data,
            type: {
                name: "template"
            }
        };
        addBlockTemplateAction(block);
    };
    const getBlockInformation = (id)=>{
        const index = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, id, "object_id");
        const block = blocks[index];
        if (block == null) return {};
        const paths_out = paths.filter((path)=>path.parent_block_id == id);
        const paths_in = block.children ? block.children.map((child)=>paths.find((path)=>path.child_block_id == child.object_id)).filter((path)=>path != undefined) : [];
        return {
            block: block,
            paths_out: paths_out,
            paths_in: paths_in,
            position: index
        };
    };
    const duplicateBlock = (id)=>{
        const index = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, id, "object_id");
        var block = blocks[index];
        const type = block.type.name == "action" && block.action_type ? block.action_type.name : block.type.name;
        block = JSON.parse(JSON.stringify(block));
        const data = {
            ...block.data
        };
        delete data.id;
        delete data.block_id;
        if (block.type.name == "magic" && data.jump_id == null) return;
        const transformer = (0, $d916903816c636da$export$2e2bcd8739ae039)[type];
        const blockServer = {
            ...transformer(data),
            name: block.name,
            "type": block.type.name
        };
        if (block.action_type) blockServer.action_type = block.action_type.name;
        const object = {
            tree: block,
            server: blockServer
        };
        addBlock(object, -block.x, -block.y, 250, 0);
    };
    const jumpBlock = (targetBlockId)=>{
        const index = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, targetBlockId, "object_id");
        const targetBlock = blocks[index];
        if (!targetBlock) return;
        const newJumpBlock = {
            name: `Jump to ${targetBlock.name}`,
            type: {
                name: "magic"
            },
            width: 5,
            height: 2,
            x: targetBlock.x + 250,
            y: targetBlock.y,
            data: {
                jump_id: targetBlock,
                is_constant: true,
                variable_value: null
            }
        };
        const transformer = (0, $d916903816c636da$export$2e2bcd8739ae039)["magic"];
        const blockServer = {
            ...transformer(newJumpBlock.data),
            name: newJumpBlock.name,
            type: newJumpBlock.type.name
        };
        const blockObject = {
            tree: newJumpBlock,
            server: blockServer
        };
        addBlock(blockObject, -targetBlock.x, -targetBlock.y, 250, 0);
    };
    const getChildPosition = (parent_block_id, child_block_id)=>{
        let index = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, parent_block_id);
        let block = blocks[index];
        let child = block.children.filter((child)=>child.object_id == child_block_id).pop();
        if (child == undefined) console.log(child_block_id, block.children);
        let height = block.height * (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039);
        let width = block.width * (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039);
        let x = block.x + width - (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039) / 2;
        let y = child.index == 0 ? block.y + block.height * (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039) / 2 + (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039) / 2 : block.y + height + (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039) * child.index;
        return {
            x: x,
            y: y
        };
    };
    (0, $bh6RR.useEffect)(()=>{
        window.getBlockInformation = getBlockInformation;
    }, [
        blocks
    ]);
    return {
        addBlock: addBlock,
        addBlockTemplate: addBlockTemplate,
        updateBlockAction: updateBlockAction,
        getBlockInformation: getBlockInformation,
        getChildPosition: getChildPosition,
        deleteBlock: deleteBlock,
        duplicateBlock: duplicateBlock,
        jumpBlock: jumpBlock
    };
}
var $c45f4fed2a7893f8$export$2e2bcd8739ae039 = $c45f4fed2a7893f8$var$useBlock;




var $kEUo3 = parcelRequire("kEUo3");

var $bh6RR = parcelRequire("bh6RR");
// Component use to create a block when you click on him
function $da9e0859935e8ce9$var$BlockCreationLink({ className: className, label: label, image: image, onClose: onClose, position: position, shortcut: shortcut }) {
    const { addBlock: addBlock } = (0, $c45f4fed2a7893f8$export$2e2bcd8739ae039)();
    const { blocks: blocks } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const { panzone: panzone } = (0, $e677ba9f021c00cc$export$395166f91704e8fd)();
    // Default offset for the block creation, place him on the top left corner of the bot edtiro
    const offset = {
        x: position == null ? 30 : position?.x,
        y: position == null ? 120 : position?.y
    };
    const onClick = ()=>{
        var { x: x, y: y, scale: scale } = panzone.getTransform();
        const block = (0, $kEUo3.cloneDeep)((0, $931611736c39b122$export$2e2bcd8739ae039)[className]);
        // Change the default name for the scenario's block, exemple if 3 scenario have already been created the fourth will be call 'Scenario 4'
        if (block.tree.type.name == "scenario") {
            let numberOfScenarios = blocks.filter((block)=>block.type.name == "scenario").length;
            block.tree.name = "Scenario " + numberOfScenarios;
        }
        if (block.server.basic !== undefined) block.server.basic = 0;
        if (block.tree.data !== undefined && block.tree.data.basic !== undefined) block.tree.data.basic = 0;
        addBlock({
            ...block
        }, x / scale, y / scale, offset.x, offset.y);
        onClose();
    };
    const handleKeyDown = (e)=>{
        if (shortcut == null) return;
        if (e.keyCode == shortcut.value) {
            onClick();
            e.preventDefault();
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "block_template " + className,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                className: "background-image",
                src: image
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                className: "shortcut-block-template",
                children: [
                    " ",
                    shortcut ? "[" + shortcut.title + "] " : " "
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                children: label
            })
        ]
    });
}
var $da9e0859935e8ce9$export$2e2bcd8739ae039 = $da9e0859935e8ce9$var$BlockCreationLink;


var $458b942902e52ea0$exports = {};
$458b942902e52ea0$exports = new URL("scenario2.87bf7f26.svg", import.meta.url).toString();


var $152ba1d2aee44bad$exports = {};
$152ba1d2aee44bad$exports = new URL("action.de6fe022.svg", import.meta.url).toString();


var $05b2e64099570cf9$exports = {};
$05b2e64099570cf9$exports = new URL("propos.6e824b6c.svg", import.meta.url).toString();


var $71b2cf3dd5730e87$exports = {};
$71b2cf3dd5730e87$exports = new URL("magic.220bf097.svg", import.meta.url).toString();


var $64dc9d32dfa9db13$exports = {};
$64dc9d32dfa9db13$exports = new URL("announce.aba43e95.png", import.meta.url).toString();




// Create a zone for choosing witch block's you want to create in the editor : action, statement, scenario, propos 
function $d8a757577422003b$var$ZoneBlockCreation({ position: position, showing: showing, setShowing: setShowing }) {
    const [show, setShow] = (0, $bh6RR.useState)(false);
    const { changeShiftKey: changeShiftKey, shiftKey: shiftKey } = (0, $008a36c4d52c37da$export$2e2bcd8739ae039)();
    const onMouseEnter = ()=>{
        shiftKey && changeShiftKey();
        setShow(true);
    };
    const hideZone = ()=>{
        setShow(false);
        if (setShowing) setShowing(false);
    };
    const offset = {
        x: parseFloat(position?.left) - 120,
        y: parseFloat(position?.top) - 80
    };
    if (showing) shiftKey && changeShiftKey();
    const hasShortcut = showing == true && position != null;
    (0, $bh6RR.useEffect)(()=>{
        setShow(showing);
    }, [
        showing
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "create_block " + (show == false ? "" : "highlighted"),
                onMouseEnter: onMouseEnter
            }),
            show && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("section", {
                id: "zone_block_creation",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("section", {
                    className: "content",
                    style: showing ? position : null,
                    onMouseLeave: ()=>showing == true ? null : hideZone(),
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                            className: "txt1",
                            children: "New Block"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                            className: "txt2",
                            children: "Choose a block to create"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                            className: "fas fa-puzzle-piece icon"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $da9e0859935e8ce9$export$2e2bcd8739ae039), {
                            className: "scenario",
                            label: "Scenario",
                            image: (0, (/*@__PURE__*/$parcel$interopDefault($458b942902e52ea0$exports))),
                            onClose: ()=>hideZone(),
                            position: position ? offset : null,
                            shortcut: hasShortcut ? {
                                title: "1",
                                value: "49"
                            } : ""
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $da9e0859935e8ce9$export$2e2bcd8739ae039), {
                            className: "propos",
                            label: "Statement",
                            image: (0, (/*@__PURE__*/$parcel$interopDefault($05b2e64099570cf9$exports))),
                            onClose: ()=>hideZone(),
                            position: position ? offset : null,
                            shortcut: hasShortcut ? {
                                title: "2",
                                value: "50"
                            } : ""
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $da9e0859935e8ce9$export$2e2bcd8739ae039), {
                            className: "action",
                            label: "Action",
                            image: (0, (/*@__PURE__*/$parcel$interopDefault($152ba1d2aee44bad$exports))),
                            onClose: ()=>hideZone(),
                            position: position ? offset : null,
                            shortcut: hasShortcut ? {
                                title: "3",
                                value: "51"
                            } : ""
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $da9e0859935e8ce9$export$2e2bcd8739ae039), {
                            className: "magic",
                            label: "Jump",
                            image: (0, (/*@__PURE__*/$parcel$interopDefault($71b2cf3dd5730e87$exports))),
                            onClose: ()=>hideZone(),
                            position: position ? offset : null,
                            shortcut: hasShortcut ? {
                                title: "4",
                                value: "52"
                            } : ""
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $da9e0859935e8ce9$export$2e2bcd8739ae039), {
                            className: "announcement",
                            label: "Announcement",
                            image: (0, (/*@__PURE__*/$parcel$interopDefault($64dc9d32dfa9db13$exports))),
                            onClose: ()=>hideZone(),
                            position: position ? offset : null,
                            shortcut: hasShortcut ? {
                                title: "5",
                                value: "53"
                            } : ""
                        })
                    ]
                })
            })
        ]
    });
}
var $d8a757577422003b$export$2e2bcd8739ae039 = $d8a757577422003b$var$ZoneBlockCreation;



parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");
function $44233c56e4012027$var$useBlockCamera() {
    const { panzone: panzone } = (0, $e677ba9f021c00cc$export$395166f91704e8fd)();
    const { getBlockInformation: getBlockInformation } = (0, $c45f4fed2a7893f8$export$2e2bcd8739ae039)();
    const jumpToPosition = (x, y, cb = ()=>{})=>{
        panzone.pause();
        panzone.zoomTo(0, 0, 1 / panzone.getTransform().scale);
        panzone.smoothMoveTo(-x * panzone.getTransform().scale + 30, -(y - window.innerHeight / 2.5) * panzone.getTransform().scale, cb);
        panzone.resume();
    };
    const followBlock = (id)=>{
        if (sessionStorage.getItem("reloaded") == "true") return sessionStorage.setItem("reloaded", "false");
        if (!id) return;
        const { block: block } = getBlockInformation(id);
        if (block == null) return;
        const completeMove = ()=>{
            const element = document.getElementById(id);
            if (!element) return;
            element.classList.add("selected");
        };
        jumpToPosition(block.x, block.y, completeMove);
    };
    const setPageHaveReload = ()=>{
        sessionStorage.setItem("reloaded", "true");
    };
    (0, $bh6RR.useEffect)(()=>{
        window.followBlock = followBlock;
        window.addEventListener("beforeunload", setPageHaveReload);
        return ()=>{
            window.removeEventListener("beforeunload", setPageHaveReload);
        };
    }, [
        panzone
    ]);
    return {
        jumpToPosition: jumpToPosition,
        followBlock: followBlock
    };
}
var $44233c56e4012027$export$2e2bcd8739ae039 = $44233c56e4012027$var$useBlockCamera;





// Button to replace the view on the first scenario
function $4b96f431a5574233$var$ButtonCenterView() {
    const { blockStart: blockStart } = (0, $7ef7d0b863ac05b4$export$248471b8219beb2f)();
    const { jumpToPosition: jumpToPosition } = (0, $44233c56e4012027$export$2e2bcd8739ae039)();
    const { changeShiftKey: changeShiftKey, shiftKey: shiftKey } = (0, $008a36c4d52c37da$export$2e2bcd8739ae039)();
    const onClick = ()=>{
        shiftKey && changeShiftKey();
        jumpToPosition(blockStart.x, blockStart.y);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "recenter",
        onClick: onClick
    });
}
var $4b96f431a5574233$export$2e2bcd8739ae039 = $4b96f431a5574233$var$ButtonCenterView;






var $bh6RR = parcelRequire("bh6RR");





const $de8445459366d219$export$ffbf58f1cf6067e = (blocks)=>{
    if (blocks == [] || !blocks) {
        console.log(blocks);
        return;
    }
    return blocks.reduce((prev, current)=>prev && prev.x < current.x ? prev : current).x;
};
const $de8445459366d219$export$a3108dfd470b09f3 = (blocks)=>{
    if (blocks == [] || !blocks) {
        console.log(blocks);
        return;
    }
    return blocks.reduce((prev, current)=>prev && prev.x > current.x ? prev : current).x;
};
const $de8445459366d219$export$154b21dee8956671 = (blocks)=>{
    if (blocks == [] || !blocks) {
        console.log(blocks);
        return;
    }
    return blocks.reduce((prev, current)=>prev && prev.y < current.y ? prev : current).y - 40;
};
const $de8445459366d219$export$cc02185be9535722 = (blocks)=>{
    if (blocks == [] || !blocks) {
        console.log(blocks);
        return;
    }
    let block = blocks.reduce((prev, current)=>prev && prev.y > current.y ? prev : current);
    let res = block.y;
    if (block.id && block.type && block.type.id === 4) res += 60;
    return res;
};
const $de8445459366d219$export$3c49c185de0c2bfc = (blocks)=>{
    const minimalSize = 400;
    const res = $de8445459366d219$export$a3108dfd470b09f3(blocks) - $de8445459366d219$export$ffbf58f1cf6067e(blocks) + minimalSize;
    return res;
};
const $de8445459366d219$export$c08559766941f856 = (blocks)=>{
    let res = $de8445459366d219$export$cc02185be9535722(blocks) - $de8445459366d219$export$154b21dee8956671(blocks);
    if (res !== 0) res += 120;
    return res;
};
const $de8445459366d219$export$d7ec51f087bd61a3 = (blocks)=>{
    if (blocks.length === 0 || !blocks) {
        const transform = {
            x: 0,
            y: 0
        };
        return transform;
    }
    let upPivot = $de8445459366d219$export$154b21dee8956671(blocks);
    let leftPivot = $de8445459366d219$export$ffbf58f1cf6067e(blocks);
    const transform = {
        x: leftPivot - 120,
        y: upPivot - 15
    };
    return transform;
//categoryElement.style.transform = "translate3d("+ transform.x +"px,"+ transform.y +"px,"+ 0 + "px)";
};


function $973e14c0042f043b$var$useCategories() {
    const { createCategory: createCategoryAction, updateCategory: updateCategoryAction, deleteCategory: deleteCategoryAction, addBlocksInCategory: addBlocksInCategoryAction, ungroupBlockFromCategory: ungroupBlockFromCategoryAction } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const { categories: categories } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const getCategoryById = (id)=>{
        return categories.find((c)=>c.category.id === id);
    };
    const getCategoryByObjectId = (id)=>{
        return categories.find((c)=>c.object_id === id);
    };
    const createCategory = (blocks_id)=>{
        let dataToSend = {
            color: "#7AAFF9",
            name: "New Title",
            object_id: (0, $d64a8a6f6e0ad216$export$2e2bcd8739ae039)(),
            blocks_object_id: blocks_id //.id)
        };
        createCategoryAction(dataToSend);
    };
    const updateCategory = async (id, data)=>{
        data.name = data.name.trim();
        data.id = id;
        updateCategoryAction(id, data);
    };
    const lockCategory = async (id, locked)=>{
        let data = {
            id: id,
            locked: locked
        };
        updateCategoryAction(id, data);
    };
    const deleteCategory = async (id)=>{
        let data = {
            id: id
        };
        deleteCategoryAction(id, data);
    };
    const addBlocksInCategory = async (id, listBlockSelected)=>{
        let listBlocksObjectId = listBlockSelected.map((block)=>block.object_id);
        let data = {
            id: id,
            blocks_object_id: listBlocksObjectId
        };
        addBlocksInCategoryAction(id, data);
    };
    const ungroupBlockFromCategory = async (block)=>{
        let data = {
            block_object_id: block.object_id
        };
        await ungroupBlockFromCategoryAction(block, data);
    };
    const moveCategories = (categories_to_move)=>{
        for (let category of categories_to_move)moveCategory(category.category_id, category.blocks);
    };
    const moveCategory = (categoryId, blocksUpdated)=>{
        let infoCategory = getCategoryById(categoryId);
        if (infoCategory == null) return;
        let categoryElement = document.getElementById(infoCategory.object_id);
        let blocks = infoCategory.category.categories_blocks.map((block)=>block.blocks);
        blocks = blocks.map((block)=>{
            let blockUpdated = blocksUpdated.find((b)=>b.id === block.id);
            return blockUpdated ? {
                ...block,
                x: blockUpdated._x,
                y: blockUpdated._y
            } : block;
        });
        let transform = (0, $de8445459366d219$export$d7ec51f087bd61a3)(blocks);
        categoryElement.style.transform = "translate3d(" + transform.x + "px," + transform.y + "px," + 0 + "px)";
        categoryElement.style.width = (0, $de8445459366d219$export$3c49c185de0c2bfc)(blocks) + "px";
        categoryElement.style.height = (0, $de8445459366d219$export$c08559766941f856)(blocks) + "px";
    };
    return {
        createCategory: createCategory,
        updateCategory: updateCategory,
        lockCategory: lockCategory,
        deleteCategory: deleteCategory,
        addBlocksInCategory: addBlocksInCategory,
        ungroupBlockFromCategory: ungroupBlockFromCategory,
        moveCategories: moveCategories,
        getCategoryById: getCategoryById,
        getCategoryByObjectId: getCategoryByObjectId
    };
}
var $973e14c0042f043b$export$2e2bcd8739ae039 = $973e14c0042f043b$var$useCategories;



var $bh6RR = parcelRequire("bh6RR");

function $ceb3354000c67769$var$useCategoryCamera() {
    const { panzone: panzone } = (0, $e677ba9f021c00cc$export$395166f91704e8fd)();
    const { getCategoryByObjectId: getCategoryByObjectId } = (0, $973e14c0042f043b$export$2e2bcd8739ae039)();
    const jumpToPosition = (x, y, cb = ()=>{})=>{
        panzone.pause();
        panzone.zoomTo(0, 0, 1 / panzone.getTransform().scale);
        panzone.smoothMoveTo(-x * panzone.getTransform().scale + 30, -(y - window.innerHeight / 2.5) * panzone.getTransform().scale, cb);
        panzone.resume();
    };
    const followCategory = (id)=>{
        if (sessionStorage.getItem("reloaded") == "true") return sessionStorage.setItem("reloaded", "false");
        if (!id) return;
        const { category: category } = getCategoryByObjectId(id);
        let blocks = category.categories_blocks.map((b)=>b.blocks);
        const pos = (0, $de8445459366d219$export$d7ec51f087bd61a3)(blocks);
        if (category == null) return;
        jumpToPosition(pos.x, pos.y + 100);
    };
    const setPageHaveReload = ()=>{
        sessionStorage.setItem("reloaded", "true");
    };
    (0, $bh6RR.useEffect)(()=>{
        window.followBlock = followBlock;
        window.addEventListener("beforeunload", setPageHaveReload);
        return ()=>{
            window.removeEventListener("beforeunload", setPageHaveReload);
        };
    }, [
        panzone
    ]);
    return {
        jumpToPosition: jumpToPosition,
        followCategory: followCategory
    };
}
var $ceb3354000c67769$export$2e2bcd8739ae039 = $ceb3354000c67769$var$useCategoryCamera;



// Component for listing all the block's in the bot editor thanks to their name
function $7fa8b1c8bfc047bf$var$SearchBar() {
    const { blocks: blocks, categories: categories } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const { followBlock: followBlock } = (0, $44233c56e4012027$export$2e2bcd8739ae039)();
    const { followCategory: followCategory } = (0, $ceb3354000c67769$export$2e2bcd8739ae039)();
    const [list, setList] = (0, $bh6RR.useState)([]);
    var [value, setValue] = (0, $bh6RR.useState)("");
    const onChange = (e)=>{
        value = e.target.value.toLowerCase();
        setValue(value);
        setList(filter(value));
    };
    const onBlur = (e)=>{
        // Timeout on the change state for the animation (conflict with onChange)
        setTimeout(()=>setValue(""), 200);
    };
    /**
     * Filter all the editor's blocks by ther name or content if they are 'propos' types
     * @returns blocks 
     */ const filter = (val)=>{
        let res = [];
        res.categories = categories.filter(({ category: category })=>category.name.toLowerCase().includes(val));
        res.blocks = blocks.filter(({ name: name, object_id: object_id, data: data })=>name.toLowerCase().includes(val) || data.messages && data.messages.find(({ content: content })=>content.toLowerCase().includes(val)) || object_id.includes(val));
        return res;
    };
    const style = {
        hidden: {
            opacity: 0,
            pointerEvents: "none"
        },
        visible: {
            opacity: 1,
            pointerEvents: "auto"
        }
    };
    // If no blocks find don't shows the list
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                className: value ? "glue" : "",
                onChange: onChange,
                onBlur: onBlur,
                value: value
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                style: value && list ? style.visible : style.hidden,
                id: "search_bar_ul",
                className: "scrollbar white",
                children: [
                    value && list && list.blocks.map((block)=>{
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                            className: "search_bar_li " + block.type.name,
                            onClick: ()=>followBlock(block.object_id),
                            children: block.name
                        }, block.object_id);
                    }),
                    value && list && list.categories.map((infoCategory)=>{
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                            className: "search_bar_li",
                            style: {
                                color: infoCategory.category.color,
                                paddingLeft: "15px"
                            },
                            onClick: ()=>followCategory(infoCategory.object_id),
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                    className: "fas fa-cube",
                                    style: {
                                        width: "5px"
                                    }
                                }),
                                " ",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    style: {
                                        marginLeft: "18px"
                                    },
                                    children: infoCategory.category.name
                                })
                            ]
                        }, infoCategory.object_id);
                    })
                ]
            })
        ]
    });
}
var $7fa8b1c8bfc047bf$export$2e2bcd8739ae039 = $7fa8b1c8bfc047bf$var$SearchBar;







function $f6a33190b6d6aa16$var$useBlockFilter() {
    const { blocks: blocks } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const defaultOffset = {
        x: 0,
        y: 67
    };
    const filterBlocksVisible = (position)=>{
        const x = position.x / position.scale + defaultOffset.x;
        const y = position.y / position.scale + defaultOffset.y;
        const area = {
            x: -x,
            y: -y,
            w: window.innerWidth / position.scale,
            h: window.innerHeight / position.scale
        };
        return filterBlock(area);
    };
    const filterBlocksSelected = (position, zone, x, y, w, h)=>{
        x = Math.min(x, zone.x);
        y = Math.min(y, zone.y);
        x = (-position.x + x - 60) / position.scale;
        y = (-position.y + y - defaultOffset.y) / position.scale;
        w = w / position.scale;
        h = h / position.scale;
        const area = {
            x: x,
            y: y,
            w: w,
            h: h
        };
        return filterBlock(area);
    };
    const findMinAndMaxBlocksCoord = (blocks)=>{
        let x_min = null;
        let y_min = null;
        let x_max = null;
        let y_max = null;
        for(let i in blocks){
            let block = blocks[i];
            if (!x_min || block.x < x_min) x_min = block.x;
            if (!y_min || block.y < y_min) y_min = block.y;
            if (!x_max || block.x + block.width * (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039) > x_max) x_max = block.x + block.width * (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039);
            if (!y_max || block.y + block.height * (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039) > y_max) y_max = block.y + block.height * (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039);
        }
        return {
            min: {
                x: x_min,
                y: y_min
            },
            max: {
                x: x_max,
                y: y_max
            }
        };
    };
    const filterBlock = (area)=>{
        const blocks_filter = [];
        const childLength = (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039);
        for(var i = 0; i < blocks.length; i++){
            let block = blocks[i];
            let length = 0;
            if (block.children) length = block.children.length > 0 ? block.children.length - 1 : block.children.length;
            const block_info = {
                x: block.x,
                y: block.y,
                w: block.width * (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039),
                h: block.height * (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039) + length * childLength
            };
            if (area.x < block_info.x + block_info.w && area.x + area.w > block_info.x && area.y < block_info.y + block_info.h && area.h + area.y > block_info.y) blocks_filter.push(block);
        }
        return blocks_filter;
    };
    return {
        filterBlocksVisible: filterBlocksVisible,
        filterBlocksSelected: filterBlocksSelected,
        findMinAndMaxBlocksCoord: findMinAndMaxBlocksCoord,
        blocks: blocks
    };
}
var $f6a33190b6d6aa16$export$2e2bcd8739ae039 = $f6a33190b6d6aa16$var$useBlockFilter;


function $372058f75697cc41$var$asyncReader(file) {
    return new Promise((resolve, reject)=>{
        let reader = new FileReader();
        reader.onload = ()=>{
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsText(file);
    });
}
var $372058f75697cc41$export$2e2bcd8739ae039 = $372058f75697cc41$var$asyncReader;






var $bh6RR = parcelRequire("bh6RR");


function $97b05ac87d730e82$var$usePathFilter() {
    const { paths: paths } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const filterPathsVisible = (blocks)=>{
        let pathsVisible = [];
        // First loop to get all the paths visible (in & out) on each blocks
        for(var j = 0; j < paths.length; j++){
            var path = paths[j];
            for(var i = 0; i < blocks.length; i++){
                let block = blocks[i];
                // Paths In
                if (path.parent_block_id == block.object_id) pathsVisible.push(path);
                // Skip block jump (only block's jump doesn't have children)
                if (block.children == undefined) continue;
                // Paths out
                for(var h = 0; h < block.children.length; h++){
                    let child = block.children[h];
                    if (child.object_id == path.child_block_id) pathsVisible.push(path);
                }
            }
        }
        let pathsVisibleWithoutDouble = [];
        // Second loop to remove path who has been find multiple time (in & out)
        for(var i = 0; i < pathsVisible.length; i++){
            var path = pathsVisible[i];
            var found = false;
            for(var j = 0; j < pathsVisibleWithoutDouble.length; j++)if (pathsVisibleWithoutDouble[j].path_id == path.path_id) {
                found = true;
                break;
            }
            if (!found) pathsVisibleWithoutDouble.push(path);
        }
        return pathsVisibleWithoutDouble;
    };
    return {
        filterPathsVisible: filterPathsVisible
    };
}
var $97b05ac87d730e82$export$2e2bcd8739ae039 = $97b05ac87d730e82$var$usePathFilter;



// Trick js for force the browser to disable/enable the willChange on blocks
// This property when enable allow the brower so calculate the movement of the blocks with de gpu and not the cpu
// But this can lead to 'blur' effect on element so we need to disable it
const $4fa46126008ccaef$export$6850b21d665e296c = ()=>{
    //const el = document.querySelector('.elements');
    const blocks = [
        ...document.querySelectorAll(".block")
    ];
    blocks.map((block)=>block.style.willChange = "transform");
    const paths = [
        ...document.querySelectorAll("path")
    ];
    paths.map((path)=>path.style.willChange = "transform");
    return true;
};
const $4fa46126008ccaef$export$572a46a0df645770 = ()=>{
    //const el = document.querySelector('.elements');
    const blocks = [
        ...document.querySelectorAll(".block")
    ];
    blocks.map((block)=>block.style.willChange = "initial");
    const paths = [
        ...document.querySelectorAll("path")
    ];
    paths.map((path)=>path.style.willChange = "initial");
    return true;
};
var $4fa46126008ccaef$export$2e2bcd8739ae039 = {
    applyWillChange: $4fa46126008ccaef$export$6850b21d665e296c,
    disableWillChange: $4fa46126008ccaef$export$572a46a0df645770
};



// Helpers for set last position and get last position in the localStorage
const $82092047ba9387bf$var$setLastPos = (id, value)=>window.localStorage.setItem(`bot_${id}_pos`, JSON.stringify(value));
const $82092047ba9387bf$var$getLastPos = (id)=>{
    let value = window.localStorage.getItem(`bot_${id}_pos`);
    return value ? JSON.parse(value) : {
        x: 0,
        y: 0,
        scale: 1
    };
};
// Hook to use the camera of the bot edtior
function $82092047ba9387bf$var$useCamera() {
    const { botId: botId } = (0, $7ef7d0b863ac05b4$export$248471b8219beb2f)();
    const { panzone: panzone } = (0, $e677ba9f021c00cc$export$395166f91704e8fd)();
    const { filterBlocksVisible: filterBlocksVisible, blocks: blocks } = (0, $f6a33190b6d6aa16$export$2e2bcd8739ae039)();
    const { filterPathsVisible: filterPathsVisible } = (0, $97b05ac87d730e82$export$2e2bcd8739ae039)();
    const { updateBlockVisibility: updateBlockVisibility } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    // Helper get position of the camera
    const getPosition = ()=>{
        const { x: x, y: y, scale: scale } = panzone.getTransform();
        return {
            x: Math.round(x),
            y: Math.round(y),
            scale: scale
        };
    };
    const refreshBlocksVisible = ()=>{
        if (botId == undefined) return;
        const { x: x, y: y, scale: scale } = getPosition();
        $82092047ba9387bf$var$setLastPos(botId, {
            x: x,
            y: y,
            scale: scale
        });
        const blocksVisible = filterBlocksVisible({
            x: x,
            y: y,
            scale: scale
        }, blocks);
        const pathsVisible = filterPathsVisible(blocksVisible);
        // Set Blocks and Paths visibility
        updateBlockVisibility(blocksVisible, pathsVisible);
    };
    const getPositionStart = ()=>{
        var id = window.location.hash.slice(1);
        if (!id) return $82092047ba9387bf$var$getLastPos(botId);
        const index = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, id, "object_id");
        const block = blocks[index];
        if (!block) return $82092047ba9387bf$var$getLastPos(botId);
        const scale = panzone.getTransform().scale;
        const x = -block.x * scale + 30;
        const y = -(block.y - window.innerHeight / 2.5) * scale;
        setTimeout(()=>document.getElementById(block.object_id) ? document.getElementById(block.object_id).click() : null, 250);
        return {
            x: x,
            y: y,
            scale: scale
        };
    };
    const triggerPanzone = ()=>{
        if (botId == undefined) return;
        const { x: x, y: y, scale: scale } = getPositionStart();
        // If not zooomAbs at the beggining we can't move to
        panzone.zoomAbs(0, 0, scale);
        panzone.moveTo(x, y);
    };
    const onZoom = ()=>{
        // When zoom apply optimisation and check new blocks to show
        (0, $4fa46126008ccaef$export$6850b21d665e296c)();
        refreshBlocksVisible();
        (0, $4fa46126008ccaef$export$572a46a0df645770)();
    };
    const onPan = refreshBlocksVisible;
    const transformstart = ()=>{
        (0, $4fa46126008ccaef$export$6850b21d665e296c)();
    };
    const transformEnd = ()=>{
        (0, $4fa46126008ccaef$export$572a46a0df645770)();
    };
    // this use effect need to have panzone in dependencies, to update the data of the 'panzone' values, we also need to relaunch the use effect if blocks.length change who caused may no rerendering
    (0, $bh6RR.useEffect)(()=>{
        if (panzone == null) return;
        //need to trigger panzone if not done the blocks won't show at the beggining
        triggerPanzone();
        panzone.on("zoom", onZoom);
        panzone.on("pan", onPan);
        // The are custom event when transform property is set on some elements
        panzone.on("transformstart", transformstart);
        panzone.on("transformend", transformEnd);
        return ()=>{
            panzone.off("zoom", onZoom);
            panzone.off("pan", onPan);
            panzone.off("transformstart", transformstart);
            panzone.off("transformend", transformEnd);
        };
    }, [
        panzone,
        blocks.length
    ]);
    return {
        panzone: panzone,
        getPosition: getPosition,
        refreshBlocksVisible: refreshBlocksVisible
    };
}
var $82092047ba9387bf$export$2e2bcd8739ae039 = $82092047ba9387bf$var$useCamera;



// Component for importing a scenario throught a json when you click on it
// This will create a block that you can move to chooose where you want to import all the blocks in the scenario
function $46df4c287c38ac79$var$ButtonImportTemplate() {
    const { panzone: panzone } = (0, $82092047ba9387bf$export$2e2bcd8739ae039)();
    const { addBlockTemplate: addBlockTemplate } = (0, $c45f4fed2a7893f8$export$2e2bcd8739ae039)();
    const { findMinAndMaxBlocksCoord: findMinAndMaxBlocksCoord } = (0, $f6a33190b6d6aa16$export$2e2bcd8739ae039)();
    const { changeShiftKey: changeShiftKey, shiftKey: shiftKey } = (0, $008a36c4d52c37da$export$2e2bcd8739ae039)();
    const onChange = async (event)=>{
        var { x: x, y: y, scale: scale } = panzone.getTransform();
        let file = event.target.files[0];
        // Simple reader to get the files in the input
        var [template, error] = await (0, $4c4dbb9dba926a1c$export$2e2bcd8739ae039)((0, $372058f75697cc41$export$2e2bcd8739ae039), file);
        if (error !== null) console.log(error);
        template = JSON.parse(template);
        // Need to find the max an min coord of the template to know the size of the block's we need to create
        const coords = findMinAndMaxBlocksCoord(template.blocks);
        addBlockTemplate({
            coords: coords,
            file: file
        }, x / scale, y / scale, coords);
    };
    const onClick = ()=>shiftKey ? changeShiftKey() : null;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "import",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
            type: "file",
            name: "file",
            className: "import_file",
            "data-allows-drop": "true",
            accept: ".json",
            onChange: onChange
        })
    });
}
var $46df4c287c38ac79$export$2e2bcd8739ae039 = $46df4c287c38ac79$var$ButtonImportTemplate;







var $bh6RR = parcelRequire("bh6RR");
// Component to move camera on the block's who have some errors on them (path's missing or bad configuration)
function $60784d09c8f8bbb7$var$ButtonDebug() {
    const { errors: errors } = (0, $7ef7d0b863ac05b4$export$248471b8219beb2f)();
    const { jumpToPosition: jumpToPosition } = (0, $44233c56e4012027$export$2e2bcd8739ae039)();
    const [index, setIndex] = (0, $bh6RR.useState)(0);
    const errorsArray = Object.values(errors);
    const followBlockError = ()=>{
        const block = errorsArray[index];
        setIndex(errorsArray.length == index + 1 ? 0 : index + 1);
        jumpToPosition(block.x, block.y);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: errorsArray.length ? "debug red" : "debug",
        onClick: followBlockError,
        children: errorsArray.length
    });
}
var $60784d09c8f8bbb7$export$2e2bcd8739ae039 = $60784d09c8f8bbb7$var$ButtonDebug;





// Component for active the multiple blocks selections, this components replace the use of the alt key press to active the selection
function $1f846cfc5a830bf1$var$ButtonSelection() {
    const { changeShiftKey: changeShiftKey, shiftKey: shiftKey } = (0, $008a36c4d52c37da$export$2e2bcd8739ae039)();
    const onClick = ()=>changeShiftKey();
    // Highled the component if alt key is pressed or not
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: shiftKey ? "selection highlighted" : "selection",
        onClick: onClick
    });
}
var $1f846cfc5a830bf1$export$2e2bcd8739ae039 = $1f846cfc5a830bf1$var$ButtonSelection;





var $bh6RR = parcelRequire("bh6RR");
const $ff13ff65642ff6cd$var$ChatboxState = {
    valueOpen: false,
    canSendDataToServer: true,
    valueDotBubble: false,
    toggleMargin: false,
    valueToggleFocus: true,
    valueTogglePath: false,
    valueToggleSound: false,
    valueToggleVariablesList: false,
    restartChatbox: false
};
const $ff13ff65642ff6cd$var$ChatboxReducer = (state, action)=>{
    switch(action.type){
        case "openAndClose":
            return {
                ...state,
                valueOpen: !state.valueOpen,
                restartChatbox: !state.restartChatbox
            };
        case "toggleFocus":
            return {
                ...state,
                valueToggleFocus: !state.valueToggleFocus
            };
        case "togglePath":
            if (state.valueToggleVariablesList == true) state = {
                ...state,
                valueToggleVariablesList: !state.valueToggleVariablesList
            };
            return {
                ...state,
                valueTogglePath: !state.valueTogglePath
            };
        case "toggleSound":
            return {
                ...state,
                valueToggleSound: !state.valueToggleSound
            };
        case "toggleVariablesList":
            if (state.valueTogglePath == true) state = {
                ...state,
                valueTogglePath: !state.valueTogglePath
            };
            return {
                ...state,
                valueToggleVariablesList: !state.valueToggleVariablesList
            };
        case "forceOpen":
            return {
                ...state,
                valueOpen: true
            };
        case "setCanSendDataToServer":
            return {
                ...state,
                canSendDataToServer: action.payload.value
            };
        case "addDotBubble":
            return {
                ...state,
                valueDotBubble: !state.valueDotBubble
            };
        case "toggleMargin":
            return {
                ...state,
                toggleMargin: !state.toggleMargin
            };
        default:
            return state;
    }
};
const $ff13ff65642ff6cd$var$ChatboxStateContext = /*#__PURE__*/ (0, $bh6RR.createContext)($ff13ff65642ff6cd$var$ChatboxState);
const $ff13ff65642ff6cd$var$ChatboxDispatchContext = /*#__PURE__*/ (0, $bh6RR.createContext)(null);
function $ff13ff65642ff6cd$var$ChatboxContextProvider({ children: children }) {
    const [state, dispatch] = (0, $bh6RR.useReducer)($ff13ff65642ff6cd$var$ChatboxReducer, $ff13ff65642ff6cd$var$ChatboxState);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ff13ff65642ff6cd$var$ChatboxStateContext.Provider, {
        value: {
            ...state
        },
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ff13ff65642ff6cd$var$ChatboxDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
}
var $ff13ff65642ff6cd$export$2e2bcd8739ae039 = $ff13ff65642ff6cd$var$ChatboxContextProvider;
const $ff13ff65642ff6cd$export$787f29101a32d965 = ()=>(0, $bh6RR.useContext)($ff13ff65642ff6cd$var$ChatboxStateContext);
const $ff13ff65642ff6cd$export$96f70031a13e2d53 = ()=>(0, $bh6RR.useContext)($ff13ff65642ff6cd$var$ChatboxDispatchContext);




var $bh6RR = parcelRequire("bh6RR");
var $754a3e650eb779f9$export$2e2bcd8739ae039 = {
    getChannelInfoForChatbox: async ({ backEndService: backEndService, channelKey: channelKey }, content = {})=>{
        const url = `${backEndService}/channel/${channelKey}/info`;
        // headers Content-type json is really important
        content.headers = content.headers ? content.headers : {};
        const headers = {
            "Content-Type": "application/json",
            "X-Talkr-Query": "1"
        };
        content.headers = {
            ...content.headers,
            ...headers
        };
        return await fetch(url, content).then((response)=>response.json());
    }
};


const $8283b38cbbf594a8$var$ChatbotLogo = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="23" viewBox="0 0 32 23">
<path fill="#F2F2F2" fill-rule="evenodd" d="M20.67 0C26.651 0 31.5 4.849 31.5 10.83v.84c0 5.981-4.849 10.83-10.83 10.83H3.42A3.42 3.42 0 0 1 0 19.08v-8.25C0 4.849 4.849 0 10.83 0h9.84zm1.431 15.177a1.466 1.466 0 0 0-1.832-.968 15.25 15.25 0 0 1-4.519.697 15.25 15.25 0 0 1-4.519-.697 1.467 1.467 0 0 0-1.898 1.4v.298c0 1.147.745 2.16 1.84 2.502 1.526.477 3.051.716 4.577.716 1.526 0 3.051-.239 4.577-.716a2.622 2.622 0 0 0 1.84-2.502v-.298c0-.146-.022-.292-.066-.432zM10.021 4.5h-.209a2.812 2.812 0 0 0-.17 5.62l.17.005h.209a2.812 2.812 0 1 0 0-5.625zm11.666 0h-.208a2.812 2.812 0 0 0-.171 5.62l.171.005h.209a2.812 2.812 0 1 0 0-5.625z"/>
</svg>`;
const $8283b38cbbf594a8$var$ConversationState = {
    backEndService: "",
    company: "",
    bot: "",
    channelKey: "",
    session: window.localStorage.getItem("talkr_session"),
    currentUrl: window.location.href,
    mode: "client",
    avatar: $8283b38cbbf594a8$var$ChatbotLogo,
    defaultValues: {},
    language: {},
    chatboxColor: "#0e7aed",
    delay_run_chatbox: "0",
    sound_effect: true,
    notification: true,
    ripple_effect: true,
    path: [],
    data: {
        messages: [],
        responses: [],
        variables: []
    },
    loadingResponse: false
};
console.log("current_url", window.location.href);
const $8283b38cbbf594a8$var$ConversationStateContext = /*#__PURE__*/ (0, $bh6RR.createContext)($8283b38cbbf594a8$var$ConversationState);
const $8283b38cbbf594a8$var$ConversationDispatchContext = /*#__PURE__*/ (0, $bh6RR.createContext)(null);
const $8283b38cbbf594a8$var$ConversationReducer = (state, action)=>{
    switch(action.type){
        case "init":
            return {
                ...state,
                ...action.payload
            };
        case "restartConversation":
            return {
                ...state,
                data: {
                    ...state.data,
                    messages: [],
                    responses: []
                }
            };
        case "setVariables":
            return {
                ...state,
                data: {
                    ...state.data,
                    variables: [
                        ...action.payload.variables
                    ]
                }
            };
        case "addMessage":
            return {
                ...state,
                data: {
                    ...state.data,
                    messages: [
                        ...state.data.messages,
                        action.payload.message
                    ],
                    responses: [
                        ...state.data.responses
                    ]
                }
            };
        case "displayMessage":
            const index = action.payload.index;
            const data = {
                ...state.data
            };
            return {
                ...state,
                data: {
                    ...state.data,
                    responses: data.responses,
                    messages: data.messages.map((message, idx)=>index == idx ? {
                            ...message,
                            view: 1
                        } : message)
                }
            };
        case "addMessagesAndResponsesAndVariableIfPresent":
            return {
                ...state,
                data: {
                    ...state.data,
                    messages: [
                        ...state.data.messages,
                        ...action.payload.messages
                    ],
                    responses: [
                        ...action.payload.responses
                    ],
                    variables: [
                        ...action.payload.variables
                    ]
                }
            };
        case "setChatboxStyle":
            return {
                ...state,
                chatboxColor: action.payload.chatboxColor,
                avatar: action.payload.avatar !== undefined ? action.payload.avatar : state.avatar,
                delay_run_chatbox: action.payload.delay_run_chatbox,
                sound_effect: action.payload.sound_effect,
                notification: action.payload.notification,
                ripple_effect: action.payload.ripple_effect
            };
        case "setLoading":
            return {
                ...state,
                isLoadingResponse: action.payload.response
            };
        default:
            return state;
    }
};
const $8283b38cbbf594a8$var$ConversationContextProvider = ({ children: children, config: config = {} })=>{
    const [state, dispatch] = (0, $bh6RR.useReducer)($8283b38cbbf594a8$var$ConversationReducer, {
        ...$8283b38cbbf594a8$var$ConversationState,
        ...config
    });
    const [fetchedInfo, setFetchedInfo] = (0, $bh6RR.useState)(false);
    var { bot: bot, mode: mode, backEndService: backEndService, channelKey: channelKey, company: company } = state;
    const fetchChatboxColor = async ()=>{
        channelKey = channelKey ? channelKey : `${company}-${bot}`;
        const uri = backEndService.replace("api/v1", "");
        const response = await (0, $754a3e650eb779f9$export$2e2bcd8739ae039).getChannelInfoForChatbox({
            backEndService: uri,
            channelKey: channelKey
        });
        const payload = {};
        if (response.color) payload.chatboxColor = response.color;
        if (response.avatar) payload.avatar = response.avatar;
        if (response.delay_run_chatbox) payload.delay_run_chatbox = response.delay_run_chatbox;
        if (response.sound_effect) payload.sound_effect = !!response.sound_effect;
        if (response.notification) payload.notification = !!response.notification;
        if (response.ripple_effect) payload.ripple_effect = !!response.ripple_effect;
        dispatch({
            type: "setChatboxStyle",
            payload: payload
        });
        setFetchedInfo(true);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (mode == "debug") return;
        fetchChatboxColor();
    }, [
        bot,
        mode
    ]);
    return mode === "debug" || fetchedInfo == true ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($8283b38cbbf594a8$var$ConversationStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($8283b38cbbf594a8$var$ConversationDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    }) : null;
};
var $8283b38cbbf594a8$export$2e2bcd8739ae039 = $8283b38cbbf594a8$var$ConversationContextProvider;
const $8283b38cbbf594a8$export$2db17556772be852 = ()=>(0, $bh6RR.useContext)($8283b38cbbf594a8$var$ConversationStateContext);
const $8283b38cbbf594a8$export$b3ff80222229e8a1 = ()=>(0, $bh6RR.useContext)($8283b38cbbf594a8$var$ConversationDispatchContext);



function $00dd7316201b6552$var$MessageTransformer(message) {
    if (message.type == "raw" && message.content?.context == "play_action") return message.content.values.url.map((content)=>{
        return {
            content: content,
            type: "audio",
            view: 0
        };
    });
    const regex = /[a-zA-Z0-9][a-zA-Z0-9-]+[a-zAZ0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,}/g;
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const result = message.content.match(regex);
    if (result != null) result.forEach((value, index)=>message.content = message.content.replace(value, "{" + index + "}"));
    const bubbleSplitRegex = /(?<=[.!?-])\s+/;
    const bubblesArray = message.content.split(bubbleSplitRegex);
    const bubbles = bubblesArray.map((sentence)=>sentence.trim()).map((sentence)=>sentence.replace(/\{(.*?)\}/g, (match)=>{
            const sentenceWithoutBraces = result[match[1]];
            // Supprimer le point à la fin du message s'il y en a un , à la demande Pascal
            if (sentenceWithoutBraces.endsWith(".")) return sentenceWithoutBraces.slice(0, -1);
            return sentenceWithoutBraces;
        })).filter((bubble)=>bubble != "").map((sentence)=>{
        // Supprimer le point à la fin de chaque bulle si nécessaire , à la demande Pascal
        if (sentence.endsWith(".")) return sentence.slice(0, -1);
        return sentence;
    }).map((sentence)=>{
        if (!sentence.match(urlRegex)) return sentence.charAt(0).toUpperCase() + sentence.slice(1);
        return sentence;
    });
    const regexImg = /(<img[^>]*src="[^"]+"[^>]*>)/;
    var bubblesSplit = [];
    let currentBubblesSplit = "";
    bubbles.forEach((bubble)=>{
        if (bubble.match(regexImg)) currentBubblesSplit += bubble;
        else {
            if (currentBubblesSplit) {
                bubblesSplit.push({
                    content: currentBubblesSplit,
                    type: message.type,
                    view: 0
                });
                currentBubblesSplit = "";
            }
            bubblesSplit.push({
                content: bubble,
                type: message.type,
                view: 0
            });
        }
    });
    if (currentBubblesSplit) bubblesSplit.push({
        content: currentBubblesSplit,
        type: message.type,
        view: 0
    });
    return bubblesSplit;
}
const $00dd7316201b6552$var$MessagesTransformer = (messages)=>{
    var messageSplit = [];
    messages = messages?.filter((msg)=>msg.type != "raw" || msg.type == "raw" && msg.content?.context == "play_action");
    messages?.forEach((message)=>messageSplit = [
            ...messageSplit,
            ...$00dd7316201b6552$var$MessageTransformer(message)
        ]);
    return messageSplit;
};
var $00dd7316201b6552$export$2e2bcd8739ae039 = $00dd7316201b6552$var$MessagesTransformer;


function $29e545ebd0f8961c$var$ResponseTransformer(responses) {
    if (responses == undefined) responses = [];
    return responses;
}
var $29e545ebd0f8961c$export$2e2bcd8739ae039 = $29e545ebd0f8961c$var$ResponseTransformer;


function $9c95f4d3f441fd46$var$VariablesTransformer(variables) {
    if (variables == undefined) variables = {};
    variables = Object.keys(variables).map((key)=>{
        return {
            name: key,
            value: variables[key]
        };
    });
    variables = variables.sort((a, b)=>a.name.localeCompare(b.name));
    return variables;
}
var $9c95f4d3f441fd46$export$2e2bcd8739ae039 = $9c95f4d3f441fd46$var$VariablesTransformer;


var $f3a8d99b07d15f79$export$2e2bcd8739ae039 = {
    getDataFromServer: async ({ backEndService: backEndService, company: company, bot: bot }, content)=>{
        const url = `${backEndService}/${company}/bots/${bot}/api/web`;
        if (content.body instanceof FormData == false) content.body = JSON.stringify(content.body);
        content.headers = content.headers ? content.headers : {};
        const headers = {
            "X-Talkr-Query": "1"
        };
        content.headers = {
            ...content.headers,
            ...headers
        };
        if (content.headers["Content-Type"] == undefined) content.headers["Content-Type"] = "application/json";
        if (content.body instanceof FormData) delete content.headers["Content-Type"];
        try {
            const response = await fetch(url, content);
            return await response.json();
        } catch (error) {
            console.error("Erreur lors de la requ\xeate :", error);
            return {
                error: true,
                message: "La requ\xeate a \xe9chou\xe9"
            };
        //throw error;
        }
    },
    requestVariableForServer: async ({ backEndService: backEndService, company: company, bot: bot }, content)=>{
        const url = `${backEndService}/${company}/bot/${bot}/instance/variable`;
        content.headers = {
            "Content-Type": "application/json"
        };
        content.body = JSON.stringify(content.body);
        try {
            const response = await fetch(url, content);
            if (!response.ok) throw new Error("La requ\xeate a \xe9chou\xe9");
            return await response.json();
        } catch (error) {
            console.error("Erreur lors de la requ\xeate :", error);
            throw error;
        }
    }
};




function $25d6ba8a8df7472c$var$ConversationAction() {
    const { getDataFromServer: getDataFromServer } = (0, $f3a8d99b07d15f79$export$2e2bcd8739ae039);
    const dispatch = (0, $8283b38cbbf594a8$export$b3ff80222229e8a1)();
    const { backEndService: backEndService, company: company, bot: bot, session: session, mode: mode, defaultValues: defaultValues, channelKey: channelKey, currentUrl: currentUrl } = (0, $8283b38cbbf594a8$export$2db17556772be852)();
    const { valueToggleFocus: valueToggleFocus } = (0, $ff13ff65642ff6cd$export$787f29101a32d965)();
    const { disableSendMoreMsgToServer: disableSendMoreMsgToServer, enableSendMoreMsgToServer: enableSendMoreMsgToServer } = (0, $ee1060133ad495ee$export$2e2bcd8739ae039)();
    const sendDataToServer = async (content, isFollowBlock = true)=>{
        if (mode != "client") content.headers = {
            ...content.headers,
            "X-Talkr-Analytics-Disable": "1",
            "X-Talkr-Variables-Fetch": "1"
        };
        if (mode == "debug") content.headers = {
            ...content.headers,
            "X-Talkr-Debug": "1"
        };
        if (content.body && content.body.file) {
            const formData = new (0, (/*@__PURE__*/$parcel$interopDefault($07d55ecd4e888d68$exports)))();
            for(const key in content.body)formData.append(key, content.body[key]);
            content.body = formData;
        }
        dispatch({
            type: "setLoading",
            payload: {
                response: true
            }
        });
        const body = await getDataFromServer({
            backEndService: backEndService,
            company: company,
            bot: bot
        }, content);
        if (body.error == true) {
            dispatch({
                type: "setLoading",
                payload: {
                    response: "error"
                }
            });
            return body.error;
        }
        enableSendMoreMsgToServer();
        var { data: data, language: language, session: session, success: success, variables: variables, path: path } = body;
        var { messages: messages, responses: responses, object_id: object_id, type: type, ...rest } = data;
        /*
        if(data == undefined && status == 500) {
            messages = [ { content : body.message } ];
        }*/ if (window.followBlock && valueToggleFocus && isFollowBlock) window.followBlock(object_id);
        path = path == undefined ? [] : path;
        responses = (0, $29e545ebd0f8961c$export$2e2bcd8739ae039)(responses);
        variables = (0, $9c95f4d3f441fd46$export$2e2bcd8739ae039)(variables);
        messages = (0, $00dd7316201b6552$export$2e2bcd8739ae039)(messages);
        window.localStorage.setItem("talkr_session", session);
        dispatch({
            type: "setLoading",
            payload: {
                response: false
            }
        });
        dispatch({
            type: "init",
            payload: {
                session: session,
                rest: rest,
                language: language,
                path: path
            }
        });
        dispatch({
            type: "addMessagesAndResponsesAndVariableIfPresent",
            payload: {
                messages: messages,
                responses: responses,
                variables: variables
            }
        });
        if (type == "announcement") askBotNextQuestion(rest.redirect);
    };
    const refreshDeeplyConversation = ()=>{
        dispatch({
            type: "restartConversation"
        });
        getBotFirstQuestion(true);
    };
    const restartConversation = ()=>{
        dispatch({
            type: "restartConversation"
        });
        getBotFirstQuestion();
    };
    const getBotFirstQuestion = async (refreshDeep = false)=>{
        const content = {
            method: "post",
            body: {},
            headers: {
                "X-Talkr-Variables-Reset": "1"
            }
        };
        content.body.refreshDeep = refreshDeep;
        if (session) content.body.session = session;
        if (currentUrl) content.body.currentUrl = currentUrl;
        if (channelKey) content.headers = {
            "X-Talkr-Channel-Key": channelKey
        };
        content.body.storage = localStorage;
        // Implement token functionnality
        const token = null;
        if (token) content.body.token = token;
        if (defaultValues.variables && typeof defaultValues.variables === "object" && defaultValues.variables != null) content.body.variables = defaultValues.variables;
        const isFollowBlock = !window.location.hash.slice(1);
        sendDataToServer(content, isFollowBlock);
    };
    const askBotNextQuestion = async (tracking, data)=>{
        disableSendMoreMsgToServer();
        const content = {
            method: "post",
            body: {
                session: session,
                tracking: tracking,
                currentUrl: currentUrl,
                storage: localStorage
            }
        };
        if (channelKey) content.headers = {
            "X-Talkr-Channel-Key": channelKey
        };
        const isDataSendFile = typeof data === "object";
        const text = isDataSendFile ? data.name : data;
        if (text) {
            isDataSendFile ? content.body.file = data : content.body.text = text;
            dispatch({
                type: "addMessage",
                payload: {
                    message: {
                        content: text,
                        type: "human",
                        view: 1
                    }
                }
            });
        }
        sendDataToServer(content);
    };
    return {
        getBotFirstQuestion: getBotFirstQuestion,
        askBotNextQuestion: askBotNextQuestion,
        restartConversation: restartConversation,
        refreshDeeplyConversation: refreshDeeplyConversation
    };
}
var $25d6ba8a8df7472c$export$2e2bcd8739ae039 = $25d6ba8a8df7472c$var$ConversationAction;


function $ee1060133ad495ee$var$ChatboxAction() {
    const { valueOpen: valueOpen } = (0, $ff13ff65642ff6cd$export$787f29101a32d965)();
    const dispatch = (0, $ff13ff65642ff6cd$export$96f70031a13e2d53)();
    const openIfClosed = (isMarginRequired = false)=>{
        if (valueOpen == true) return;
        dispatch({
            type: "forceOpen"
        });
    };
    const disableSendMoreMsgToServer = ()=>dispatch({
            type: "setCanSendDataToServer",
            payload: {
                value: false
            }
        });
    const enableSendMoreMsgToServer = ()=>dispatch({
            type: "setCanSendDataToServer",
            payload: {
                value: true
            }
        });
    return {
        openIfClosed: openIfClosed,
        valueOpen: valueOpen,
        disableSendMoreMsgToServer: disableSendMoreMsgToServer,
        enableSendMoreMsgToServer: enableSendMoreMsgToServer
    };
}
var $ee1060133ad495ee$export$2e2bcd8739ae039 = $ee1060133ad495ee$var$ChatboxAction;



function $8a5fef50ba0ffc20$var$ButtonRunChatbox() {
    const { valueOpen: valueOpen, openIfClosed: openIfClosed } = (0, $ee1060133ad495ee$export$2e2bcd8739ae039)();
    const { restartConversation: restartConversation } = (0, $25d6ba8a8df7472c$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: valueOpen ? "restart" : "run",
        onClick: ()=>valueOpen == false ? openIfClosed() : restartConversation()
    });
}
var $8a5fef50ba0ffc20$export$2e2bcd8739ae039 = $8a5fef50ba0ffc20$var$ButtonRunChatbox;






parcelRequire("bh6RR");
function $1155755f73aef967$var$ButtonTelephony() {
    const { botId: botId, code: code, phone: phone } = (0, $7ef7d0b863ac05b4$export$248471b8219beb2f)();
    if (!code || !phone) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "button_telephony",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    children: phone ? phone.match(/.{1,2}/g).join(" ") : ""
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    children: [
                        " # ",
                        code,
                        " "
                    ]
                })
            ]
        })
    });
}
var $1155755f73aef967$export$2e2bcd8739ae039 = $1155755f73aef967$var$ButtonTelephony;



var $bh6RR = parcelRequire("bh6RR");
function $f4accd3335453ff5$export$2e2bcd8739ae039() {
    return [
        ...document.getElementsByTagName("input")
    ].filter((input)=>input === document.activeElement).length;
}


// Simple component to handle all the custom action in the bot editor
function $28a7a035f6e1fc79$var$Bar() {
    const [creatingBlock, setCreatingBlock] = (0, $bh6RR.useState)(false);
    const [positionMouse, setPositionMouse] = (0, $bh6RR.useState)(null);
    const handleKeyDown = (e)=>{
        let elements = Array.from(document.querySelectorAll(":hover"));
        let isInCamera = elements.some((element)=>element.classList.contains("camera"));
        var canOperate = creatingBlock === false && isInCamera === true || creatingBlock === true && isInCamera === false;
        if (e.key === " " && canOperate && (0, $f4accd3335453ff5$export$2e2bcd8739ae039)() == false) {
            setCreatingBlock((previousState)=>!previousState);
            e.preventDefault();
        }
    };
    const handleMousePosition = (e)=>{
        if (creatingBlock == true) return;
        const mouseX = e.clientX;
        const mouseY = e.clientY;
        setPositionMouse({
            left: mouseX - 50 + "px",
            top: mouseY + "px"
        });
    };
    (0, $bh6RR.useEffect)(()=>{
        document.addEventListener("mousemove", handleMousePosition);
        return ()=>{
            document.removeEventListener("mousemove", handleMousePosition);
        };
    }, [
        creatingBlock
    ]);
    (0, $bh6RR.useEffect)(()=>{
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        creatingBlock
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "editor-bar",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d8a757577422003b$export$2e2bcd8739ae039), {
                showing: creatingBlock,
                position: positionMouse,
                setShowing: (bool)=>setCreatingBlock(bool)
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $59aa6d1647fd972c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4b96f431a5574233$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b24824868c84b99d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $46df4c287c38ac79$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7fa8b1c8bfc047bf$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1f846cfc5a830bf1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $60784d09c8f8bbb7$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8a5fef50ba0ffc20$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1155755f73aef967$export$2e2bcd8739ae039), {})
        ]
    });
}
var $28a7a035f6e1fc79$export$2e2bcd8739ae039 = $28a7a035f6e1fc79$var$Bar;








var $bh6RR = parcelRequire("bh6RR");




const $18dfe961034f7dc8$var$offsetPanzoneContainer = {
    x: -60,
    y: -47
};
var $18dfe961034f7dc8$export$2e2bcd8739ae039 = $18dfe961034f7dc8$var$offsetPanzoneContainer;







// Warning useCtrlKey is activate with shiftKey
function $790f89914ea69ca7$var$useCtrlKey() {
    const { setCtrlKey: setCtrlKey } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const { ctrlKey: ctrlKey, shiftKey: shiftKey } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const onKeyDown = (e)=>{
        //console.log('toto');
        if (e.ctrlKey == false) return;
        setCtrlKey(true);
        if (shiftKey) document.querySelectorAll(".block").forEach((block)=>block.classList.add("ctrlKey"));
    // Messy fix for optimize rendering on block for multiple selection
    //document.querySelectorAll('.block').forEach(block => block.classList.add('shiftKey'))
    };
    const onKeyUp = ()=>{
        if (ctrlKey == false) return;
        setCtrlKey(false);
        if (shiftKey) document.querySelectorAll(".block").forEach((block)=>block.classList.remove("ctrlKey"));
    //setCtrlKey(false);
    // Messy fix for optimize rendering on block for multiple selection
    //document.querySelectorAll('.block').forEach(block => block.classList.remove('shiftKey'))
    };
    return {
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        ctrlKey: ctrlKey
    };
}
var $790f89914ea69ca7$export$2e2bcd8739ae039 = $790f89914ea69ca7$var$useCtrlKey;



function $ebd5a98e941728ff$var$useBlockSelection() {
    const { setZoneSelectBlocks: setZoneSelectBlocks } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const { addSelectedBlock: addSelectedBlockAction, updateMouseAndBlockClicked: updateMouseAndBlockClicked, setSelectedBlocks: setSelectedBlocks, deleteSelectedBlock: deleteSelectedBlock, deleteAllSelectedBlock: deleteAllSelectedBlock } = (0, $b160775e2cfdbb38$export$2e2bcd8739ae039)();
    const { zoneSelectBlocks: zoneSelectBlocks } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const { ctrlKey: ctrlKey } = (0, $790f89914ea69ca7$export$2e2bcd8739ae039)();
    const { shiftKey: shiftKey } = (0, $008a36c4d52c37da$export$2e2bcd8739ae039)();
    const { getBlockInformation: getBlockInformation } = (0, $c45f4fed2a7893f8$export$2e2bcd8739ae039)();
    const { pathTmp: pathTmp, blocksSelected: blocksSelected, blockIdClicked: blockIdClicked } = (0, $7324df5b25c181de$export$2fe873ee5eb16329)();
    const { filterBlocksSelected: filterBlocksSelected } = (0, $f6a33190b6d6aa16$export$2e2bcd8739ae039)();
    const offset = (0, $18dfe961034f7dc8$export$2e2bcd8739ae039);
    const selectBlock = (e, id)=>{
        updateMouseAndBlockClicked(e.clientX, e.clientY, id);
        shiftKey ? selectBlockIfShiftKey(e, id) : selectBlockIfNotShiftKey(e, id);
    };
    const selectBlockIfShiftKey = (e, id)=>{
        if (e.target.id != id || pathTmp || ctrlKey == false) return;
        blocksSelected.find((block)=>block.id == id) ? deleteSelectedBlockById(id) : addSelectedBlockById(id);
    };
    const selectBlockIfNotShiftKey = (e, id)=>{
        if (e.target.id != id || pathTmp || blocksSelected.find((block)=>block.id == id)) return;
        deleteAllSelectedBlock();
        const block = document.querySelector(".block.selected");
        if (block) block.classList.remove("selected");
        addSelectedBlockById(id);
    };
    const dropBlock = (e, id)=>{
        updateMouseAndBlockClicked(0, 0);
    };
    const deleteSelectedBlockById = (id)=>{
        document.getElementById(id)?.classList.remove("selected");
        deleteSelectedBlock(id);
    };
    const addSelectedBlockById = (id)=>{
        document.getElementById(id).classList.add("selected");
        const { block: block, paths_out: paths_out, paths_in: paths_in } = getBlockInformation(id);
        addSelectedBlockAction({
            block: block,
            paths_out: paths_out,
            paths_in: paths_in,
            id: id
        });
    };
    const makeZoneSelection = (x, y)=>{
        let selection = document.getElementById("zone_blocks_selection");
        setZoneSelectBlocks(x, y);
        selection.style.left = x + offset.x + "px";
        selection.style.top = y + offset.y + "px";
        selection.style.opacity = 1;
    };
    const updateZoneSelection = (x, y, position, startPosition = 0)=>{
        let selection = document.getElementById("zone_blocks_selection");
        //x = (x + position.x) / position.scale;
        //y = (y + position.y) / position.scale;
        let width = Math.abs(x - zoneSelectBlocks.x);
        let height = Math.abs(y - zoneSelectBlocks.y);
        let areaSelected = zoneSelectBlocks;
        if (startPosition != 0 && zoneSelectBlocks.x == 0 && zoneSelectBlocks.y == 0) areaSelected = startPosition;
        selection.style.width = width + "px";
        selection.style.height = height + "px";
        selection.style.left = (x < areaSelected.x ? x : areaSelected.x) + offset.x + "px";
        selection.style.top = (y < areaSelected.y ? y : areaSelected.y) + offset.y + "px";
        selection.style.opacity = 1;
        const blocksFind = filterBlocksSelected(position, areaSelected, x, y, width, height);
        const newBlocksSelected = [];
        for(var i = 0; i < blocksFind.length; i++){
            let id = blocksFind[i].object_id;
            const { block: block, paths_out: paths_out, paths_in: paths_in } = getBlockInformation(id);
            document.getElementById(id).classList.add("selected");
            newBlocksSelected.push({
                block: block,
                paths_out: paths_out,
                paths_in: paths_in,
                id: id
            });
        }
        let blocksToUnselect = blocksSelected.filter((a)=>!newBlocksSelected.some((b)=>b.id == a.id));
        blocksToUnselect.map((block)=>document.getElementById(block.id).classList.remove("selected"));
        //blocksToUnselect.map(block => document.getElementById(block.id).classList.remove("selected"))
        setSelectedBlocks(newBlocksSelected);
        /*
        let blocksToSelect = blocksComparaison(blocksFind, blocksSelected);
        blocksToSelect.map(block => addSelectedBlockById(block.object_id));
        let blocksTest = blocksComparaison(blocksToSelect, blocksSelected);
        */ //let blocksToUnselect = blockNotAlreadySelected(idOfBlocksFind);
        return newBlocksSelected;
    };
    const resetZoneSelection = ()=>{
        let selection = document.getElementById("zone_blocks_selection");
        setZoneSelectBlocks(0, 0);
        selection.style.left = "0px";
        selection.style.top = "0px";
        selection.style.width = "0px";
        selection.style.height = "0px";
        selection.style.opacity = 0;
    };
    const isBlockSelected = (id)=>{
        for(let index in blocksSelected){
            if (blocksSelected[index].id == id) return true;
        }
        return false;
    };
    const deselectAllBlocks = (blocks = [])=>{
        blocks = blocksSelected.length == 0 && blocks.length > 0 ? blocks : [];
        for(let i = 0; i < blocks.length; i++)deleteSelectedBlockById(blocks[i].id);
    };
    /*
    const enableMultipleSelectionBlock = (e) => {
        if (e.ctrlKey == false || ctrlKey == true) return;
        setCtrlKey(true)
    }

    const disableMultipleSelectionBlock = (e) => {
        if (ctrlKey == false) return;
        setCtrlKey(false)
    }*/ return {
        selectBlock: selectBlock,
        dropBlock: dropBlock,
        resetZoneSelection: resetZoneSelection,
        makeZoneSelection: makeZoneSelection,
        updateZoneSelection: updateZoneSelection,
        blockIdClicked: blockIdClicked,
        blocksSelected: blocksSelected,
        zoneSelectBlocks: zoneSelectBlocks,
        isBlockSelected: isBlockSelected,
        shiftKey: shiftKey,
        deselectAllBlocks: deselectAllBlocks
    };
}
var $ebd5a98e941728ff$export$2e2bcd8739ae039 = $ebd5a98e941728ff$var$useBlockSelection;








function $8eadefa88967ced0$var$useBlockMagnetPosition() {
    const { setMagnetPosition: setMagnetPositionAction, resetMagnetPosition: resetMagnetPosition } = (0, $b160775e2cfdbb38$export$2e2bcd8739ae039)();
    const { pathTmp: pathTmp } = (0, $7324df5b25c181de$export$2fe873ee5eb16329)();
    const { blocksVisible: blocksVisible } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const setMagnetPosition = (id)=>{
        if (pathTmp == null) return;
        let indexBlock = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocksVisible, id);
        let block = blocksVisible[indexBlock];
        let x = block.x;
        let y = block.type.name != "magic" ? block.y + (block.height - 1) * (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039) : block.y + block.height * (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039) - (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039) / 2;
        setMagnetPositionAction(x, y, id);
    };
    return {
        setMagnetPosition: setMagnetPosition,
        resetMagnetPosition: resetMagnetPosition
    };
}
var $8eadefa88967ced0$export$2e2bcd8739ae039 = $8eadefa88967ced0$var$useBlockMagnetPosition;









const $91e54ccd9d543ef8$var$widthBlockEditor = 5;
var $91e54ccd9d543ef8$export$2e2bcd8739ae039 = $91e54ccd9d543ef8$var$widthBlockEditor;


/**
 * The first (x,y) coordinates needs to be them of the block where the path is out and not enter
 * @param {*} x 
 * @param {*} y 
 * @param {*} _x 
 * @param {*} _y 
 * @param {*} height 
 * @param {*} _height 
 * @param {*} index 
 * @returns 
 */ function $c7a2343ef3cc915a$export$f89e19e593add7bd(x, y, _x = null, _y = null, height = 3, _height = 3, index = 0) {
    const size = (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039);
    const width = (0, $91e54ccd9d543ef8$export$2e2bcd8739ae039);
    // (x,y) couple and (_x,_y) couple : top left corner coordinates
    // If index != 0 means that the link if from a block child of a redirection block or statement block and we need to make a litte scale on the center of the block
    x = index == 0 ? x + (width + 1) * size - size : x + width * size - size / 2;
    // If index != 0 means that the link if from a block child of a redirection block or statement block and we to downside the coordinate
    y = index == 0 ? y + (height + 0.5) * size - height / 2 * size : y + (height - 1) * size + (index + 1) * size;
    // height == 2 meam's that we are dealing with a scenario block so we need to adjust the height a little bit
    y = y + (height == 2 ? 5 : 0);
    _x;
    _y = _y + size / 2 + size * 0.5 * _height;
    return $c7a2343ef3cc915a$export$859fe8f922ebbf8f(x, y, _x, _y);
}
function $c7a2343ef3cc915a$export$859fe8f922ebbf8f(x, y, _x, _y) {
    const stroke = x > _x ? "rgba(0, 0, 0, 0.1)" : "rgba(0, 0, 0, 0.25)";
    const offset = x > _x ? Math.min(x - _x + 85, 300) : 85; // With our coordinate we will draw a barrier curve, calculation of a barrier curve change for a certain angle who is represented by and abscisse
    return {
        data: `M${x} ${y} C ${x + offset} ${y}, ${_x - offset} ${_y},${_x} ${_y}`,
        stroke: stroke
    };
}
var $c7a2343ef3cc915a$export$2e2bcd8739ae039 = $c7a2343ef3cc915a$export$f89e19e593add7bd;


parcelRequire("bh6RR");
function $3ef1c61908149445$var$usePath() {
    const { pathTmp: pathTmp } = (0, $7324df5b25c181de$export$2fe873ee5eb16329)();
    const { blocks: blocks, children: children } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const { resetTmpPath: resetTmpPath, resetMagnetPosition: resetMagnetPosition, updateMouse: updateMouse } = (0, $b160775e2cfdbb38$export$2e2bcd8739ae039)();
    const { createPath: createPathAction, deletePath: deletePathAction } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    // Helper function for getting the path information for drawing it
    const searchPath = (path)=>{
        //Binary search for fast execution
        const indexNextParent = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, path.parent_block_id, "object_id");
        if (indexNextParent == null) return;
        const indexChild = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(children, path.child_block_id, "object_id");
        if (indexChild == null) return;
        const indexParentOfChild = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, children[indexChild].parent_block_id, "object_id");
        if (indexParentOfChild == null) return;
        // '_property' are the information of the in block && 'property' are the information of the out block : the child's one
        return {
            id: path.path_id,
            x: blocks[indexParentOfChild].x,
            y: blocks[indexParentOfChild].y,
            height: blocks[indexParentOfChild].height,
            index: children[indexChild].index,
            _x: blocks[indexNextParent].x,
            _y: blocks[indexNextParent].y,
            _height: blocks[indexNextParent].height
        };
    };
    const createPath = (block_id)=>{
        if (pathTmp == null || pathTmp.parent_block_id == block_id) return;
        const index = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, block_id);
        const block = blocks[index];
        if (block.type && block.type.name == "scenario") return;
        let path_id = (0, $d64a8a6f6e0ad216$export$2e2bcd8739ae039)();
        // Need to do a lot action when a path is created
        createPathAction(block_id, path_id, pathTmp.child_block_id) // will update tree state and add a new path but also call the service api to add this path to the server
        ;
        resetTmpPath(); // ResetTmpPath
        resetMagnetPosition(); // Need to reset magnet if not done will cause issues on next path creation, like multiple link on a block tha you don't want
        updateMouse(0, 0);
        return true;
    };
    const movePath = (path, coord = {})=>{
        const pathRef = document.getElementById(path.path_id);
        const information = searchPath(path);
        if (!information) return;
        var { x: x, y: y, height: height, index: index, _x: _x, _y: _y, _height: _height } = information;
        // A little overwrite of coordonates, cause the state have not already been update so the search path function give us some desync information,
        // But doing a sync each time will leak to performance issue so that's why it's donne that wayZ
        if (coord.in) {
            x = coord.in.x;
            y = coord.in.y;
        }
        if (coord.out) {
            _x = coord.out.x;
            _y = coord.out.y;
        }
        let { data: data, stroke: stroke } = (0, $c7a2343ef3cc915a$export$2e2bcd8739ae039)(x, y, _x, _y, height, _height, index);
        // Update the path trought dom cause re-render him will cause performance issue
        pathRef?.setAttributeNS(null, "d", data);
        pathRef?.setAttributeNS(null, "stroke", stroke);
    };
    // custom handler to move all the paths of a given block
    const movePaths = (paths)=>{
        for(var i = 0; i < paths.length; i++){
            let path = paths[i];
            let coord = {};
            // path.in && path.out are really important thanks to them we can move multiple path trought multiple blocks, useful for the multiple selection
            if (path.in) coord.in = path.in;
            if (path.out) coord.out = path.out;
            // Move our path
            movePath(path, coord);
        }
    };
    // Find some paths that we need to move in a group of paths who cames from differents blocks
    // Also remove duplicate if find
    const setPaths = (paths, paths_block, x, y, property)=>{
        for(var j = 0; j < paths_block.length; j++){
            let path = paths_block[j];
            let path_index = paths.map((path_to_move)=>path_to_move.path_id).indexOf(path.path_id);
            if (path_index === -1) {
                paths.push({
                    ...path,
                    [property]: {
                        x: x,
                        y: y
                    }
                });
                continue;
            }
            paths[path_index][property] = {
                x: x,
                y: y
            };
        }
        return paths;
    };
    const deletePath = (id)=>deletePathAction(id);
    return {
        searchPath: searchPath,
        createPath: createPath,
        movePath: movePath,
        deletePath: deletePath,
        movePaths: movePaths,
        setPaths: setPaths
    };
}
var $3ef1c61908149445$export$2e2bcd8739ae039 = $3ef1c61908149445$var$usePath;





var $a36b749f7b491cad$export$2e2bcd8739ae039 = {
    keyword_redirection: "Redirection based on keyword",
    api: "Api Call",
    condition: "Condition",
    extract_data: "Extract information from a variable",
    set_var: "Set a variable Value",
    default: "Select an action"
};






var $bh6RR = parcelRequire("bh6RR");


// Simple Component for all the form, thanks to him we can edit easialy the title fo a block
function $841d23f226ffdc19$var$TitleBlock({ name: name, title: title, titleInput: titleInput, placeholderInput: placeholderInput, id: id, callback: callback }) {
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const [value, setValue] = (0, $bh6RR.useState)(name);
    const { updateBlockName: updateBlockName } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const updateTitle = (e)=>{
        if (e.target.value == name) return;
        updateBlockName(id, value);
        callback(value);
    };
    const copyToClipBoard = async (e)=>{
        const url = `${location.protocol}//${location.host}${location.pathname}?#${id}`;
        await navigator.clipboard.writeText(url);
        toast.success("Share your block to help debug", `The Url of sharing is copied`, 5000);
    };
    (0, $bh6RR.useEffect)(()=>setValue(name), [
        name
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "title",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "icon",
                        onClick: copyToClipBoard
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                className: "input_title",
                children: titleInput
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                placeholder: placeholderInput,
                onBlur: updateTitle,
                className: "editor-input title_input",
                value: value,
                onChange: (e)=>setValue(e.target.value)
            })
        ]
    });
}
$841d23f226ffdc19$var$TitleBlock.defaultProps = {
    placeholderInput: "Block Name",
    callback: ()=>{}
};
var $841d23f226ffdc19$export$2e2bcd8739ae039 = $841d23f226ffdc19$var$TitleBlock;






// This form allow user to change the type of block action, thath action cannot be reverted
function $396ec801e10a840d$var$FormAction({ name: name, id: id }) {
    // Just a map to get all action type / text
    const actions = Object.entries((0, $a36b749f7b491cad$export$2e2bcd8739ae039)).map(([key, value])=>{
        return {
            text: value,
            value: key
        };
    });
    const { updateBlockAction: updateBlockAction } = (0, $c45f4fed2a7893f8$export$2e2bcd8739ae039)();
    const defaultAction = actions.pop();
    const setValueDropdown = (name, value)=>{
        // Change block type 
        const block = (0, $931611736c39b122$export$2e2bcd8739ae039)[value];
        const Component = (0, $efd40bd1b120909a$export$2e2bcd8739ae039)[value];
        const res = updateBlockAction(id, block);
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show("editor-window", {
            Component: Component,
            componentProps: {
                name: res.name,
                id: id
            }
        });
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $841d23f226ffdc19$export$2e2bcd8739ae039), {
                title: "Action",
                titleInput: "Action name",
                name: name,
                id: id
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "area-edit",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                        className: "input_title",
                        children: "Action type"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                        choices: actions,
                        placeholder: defaultAction.text,
                        width: "calc(100%)",
                        name: "action_type",
                        setValue: setValueDropdown
                    })
                ]
            })
        ]
    });
}
var $396ec801e10a840d$export$2e2bcd8739ae039 = $396ec801e10a840d$var$FormAction;








const $9589619a1fc38d22$var$ActionApiMethodType = [
    {
        value: "get",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
            className: "get-method",
            children: "GET"
        })
    },
    {
        value: "post",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
            className: "post-method",
            children: "POST"
        })
    },
    {
        value: "put",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
            className: "put-method",
            children: "PUT"
        })
    },
    {
        value: "delete",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
            className: "delete-method",
            children: "DELETE"
        })
    },
    {
        value: "patch",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
            className: "patch-method",
            children: "PATCH"
        })
    }
];
var $9589619a1fc38d22$export$2e2bcd8739ae039 = $9589619a1fc38d22$var$ActionApiMethodType;



const $726fea230f7787ad$var$ActionApiBodyType = [
    {
        value: "x-www-form-urlencoded",
        text: "url parameters"
    },
    {
        value: "form-data",
        text: "form"
    },
    {
        value: "raw",
        text: "json"
    }
];
var $726fea230f7787ad$export$2e2bcd8739ae039 = $726fea230f7787ad$var$ActionApiBodyType;








var $bh6RR = parcelRequire("bh6RR");
// <IconButton className="editor-iconButton main_add-button button_center delete_action" icon="fas fa-trash" />
function $70639c92410bf1bc$var$ApiBlockInput({ KeyValue: KeyValue, value: value, deleteValue: deleteValue, idx: idx, setValue: setValue }) {
    // State to keep in memory the values
    const [keyRow, setKeyRow] = (0, $bh6RR.useState)(KeyValue ? KeyValue : "");
    const [valueRow, setValueRow] = (0, $bh6RR.useState)(value ? value : "");
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "form_sub_block",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                className: "editor-input-sub",
                placeholder: "key",
                value: keyRow,
                onChange: (e)=>setKeyRow(e.target.value),
                onBlur: ()=>setValue(idx, "key", keyRow)
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                className: "editor-input-sub",
                placeholder: "value",
                value: valueRow,
                onChange: (e)=>setValueRow(e.target.value),
                onBlur: ()=>setValue(idx, "value", valueRow)
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                className: "editor-iconButton main_add-button button_center delete_action",
                icon: "fas fa-trash",
                onClick: ()=>deleteValue(idx)
            })
        ]
    });
}
var $70639c92410bf1bc$export$2e2bcd8739ae039 = $70639c92410bf1bc$var$ApiBlockInput;














var $bh6RR = parcelRequire("bh6RR");


function $785e69526abf5040$var$AutoComplete({ name: name, ref: ref, onChange: onChange, items: items, getItemValue: getItemValue, value: value, setValue: setValue, onSelect: onSelect, shouldItemRender: shouldItemRender, renderItem: renderItem, apiCall: apiCall, paramsApi: paramsApi, getImageFromItem: getImageFromItem, getNameFromItem: getNameFromItem, className: className, placeholder: placeholder }) {
    // shouldItemRender(item, value)
    const [show, setShow] = (0, $bh6RR.useState)(apiCall == null ? false : true);
    const [valueContent, setValueContent] = (0, $bh6RR.useState)(value != null ? value : "");
    const [itemsContent, setItemsContent] = (0, $bh6RR.useState)(items != null ? items : []);
    const getFilteredItems = ()=>{
        const filteredItems = itemsContent.filter((item)=>shouldItemRender(getNameFromItem(item), valueContent));
        return filteredItems;
    };
    const loadAutocompleteArray = (e)=>{
        let func = apiCall ? loadItems : searchItemsInArray;
        func(e.target.value);
        setValueContent(e.target.value);
        setShow(e.target.value.length >= 1 ? true : false);
        getItemValue(name, e.target.value);
    };
    const searchItemsInArray = (val, data = null)=>{
        if (data == null) data = itemsContent;
        val = val.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const regexp = new RegExp(`^${val}$`, "i");
        const item = itemsContent.filter((row)=>regexp.test(row.name)).pop();
        if (item) selectItem(item);
    };
    const loadItems = async (val)=>{
        if (apiCall == null) return;
        let parameters = val;
        if (paramsApi != null) Object.keys(paramsApi).forEach((key)=>{
            parameters += "&" + key + "=" + paramsApi[key];
        });
        let [response, error] = await apiCall(parameters);
        if (error !== null) {
            console.log(error);
            return;
        }
        setItemsContent(response);
        searchItemsInArray(val, response);
    /*
        const regexp = new RegExp(`^${val}$`, 'i');
        const item = response.filter(row => regexp.test(row.name)).pop();
        if(item) {
            selectItem(item);
        }
            */ };
    const selectItem = (item)=>{
        getItemValue(name, item);
        setValueContent(getNameFromItem(item));
        setShow(false);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                value: valueContent,
                name: name,
                ref: ref,
                onChange: (e)=>{
                    loadAutocompleteArray(e);
                },
                className: className ? className : "input",
                placeholder: placeholder
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "autocomplete-items",
                children: show && getFilteredItems().map((item, index)=>{
                    const nameItem = getNameFromItem(item);
                    const image = getImageFromItem ? getImageFromItem(item) : "";
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        onClick: ()=>{
                            onSelect(selectItem(item));
                        },
                        children: renderItem(nameItem, valueContent, image)
                    }, index);
                })
            })
        ]
    });
}
$785e69526abf5040$var$AutoComplete.defaultProps = {
    items: [],
    value: "",
    getNameFromItem: (item)=>item.name,
    onSelect: (val)=>val,
    onChange: (e)=>e,
    getItemValue: (item)=>item,
    shouldItemRender: (nameItem, value)=>nameItem.toLowerCase().indexOf(value.toLowerCase()) > -1 ? true : false,
    renderItem: (nameItem, value, image)=>{
        const safeValue = value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // evite les crahs si [toto : crochet pas fini
        const regex = new RegExp(`(${safeValue})`, "ig");
        const parts = nameItem.split(regex);
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: [
                image ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    src: image,
                    alt: "item"
                }) : null,
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    children: parts.map((part, i)=>part.toLowerCase() === value.toLowerCase() ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                            children: part
                        }, i) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            children: part
                        }, i))
                })
            ]
        });
    }
};
var $785e69526abf5040$export$2e2bcd8739ae039 = $785e69526abf5040$var$AutoComplete;




var $bh6RR = parcelRequire("bh6RR");
// This component if an implement of Dropdown component with current variable's of the bot
// It's working like a normal dropdown with some cool functionnality
// 1. you can select a choice to open a modal an directy create a variable
// 2. the choices are in Uppercase like this [TEST] (rest of the old version for not losing the old's users) 
// 3. When you select a choice it return and object not just a simple string
function $fe74f3a5194e12fa$var$VariableDropdown({ variable: variable, register: register, setValue: setValue, width: width, className: className, name: name, createVariableDisable: createVariableDisable, resetVariableDisable: resetVariableDisable, noChangeOnSelect: noChangeOnSelect }) {
    const [mainVariable, setMainVariable] = (0, $bh6RR.useState)(variable == null ? "" : variable);
    const { addVariable: addVariable } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const { variables: variables } = (0, $7ef7d0b863ac05b4$export$248471b8219beb2f)();
    const openModalCreationVariable = async ()=>{
        const data = await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show("editor-popup", {
            Component: (0, $3ee03af01c9655d3$export$2e2bcd8739ae039)
        });
        addVariable(data);
    };
    const choices = variables.map((variable)=>{
        return {
            text: "[" + variable.name.toUpperCase() + "]",
            value: variable.name
        };
    });
    if (!createVariableDisable) choices.push({
        value: "create_variable",
        text: "Create a Variable"
    });
    if (!resetVariableDisable) choices.push({
        value: "reset_variable",
        text: "Choose a Variable"
    });
    const setValueVariable = (name, value, dropdown)=>{
        if (value == "create_variable") {
            dropdown.func(dropdown.state);
            return openModalCreationVariable();
        }
        if (value == "reset_variable") {
            setValue(name, null);
            return;
        }
        const variable = variables.filter((variable)=>variable.name == value).pop();
        setValue(name, variable);
    };
    const props = {
        choices: choices,
        width: "calc(100%)",
        setValue: setValueVariable
    };
    if (!resetVariableDisable) {
        props.defaultChoice = "reset_variable";
        delete props.placeholder;
    }
    if (variable == undefined) props.placeholder = "Choose a variable";
    else props.defaultChoice = variable.name;
    if (width != undefined) props.width = width;
    if (className != undefined) props.className = className;
    if (name != undefined) props.name = name;
    if (noChangeOnSelect != undefined) props.noChangeOnSelect = noChangeOnSelect;
    const isVariableFind = ()=>{
        if (variable == null) return;
        let val = variable.name;
        val = val.replace(/\[/g, "").replace(/\]/g, "");
        return variables.filter((variable)=>variable.name == val.toLowerCase()).length > 0;
    };
    (0, $bh6RR.useEffect)(()=>{
        setMainVariable(variable);
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $785e69526abf5040$export$2e2bcd8739ae039), {
        ...register,
        ...props,
        className: "input variables_dropdown_editor " + (isVariableFind() ? "variables_found_editor_dropdown" : ""),
        value: mainVariable ? "[" + mainVariable?.name.toUpperCase() + "]" : "",
        items: variables,
        getNameFromItem: (item)=>"[" + item.name.toUpperCase() + "]",
        getItemValue: (name, item)=>setValueVariable(name, item.name)
    });
}
$fe74f3a5194e12fa$var$VariableDropdown.defaultProps = {
    register: {},
    createVariableDisable: false,
    resetVariableDisable: false,
    setValue: ()=>{}
};
var $fe74f3a5194e12fa$export$2e2bcd8739ae039 = $fe74f3a5194e12fa$var$VariableDropdown;




var $bh6RR = parcelRequire("bh6RR");
function $ac23aa360d63c26a$var$ApiBlockInputDropdown({ KeyValue: KeyValue, value: value, deleteValue: deleteValue, idx: idx, setValue: setValue }) {
    const { variables: variables } = (0, $7ef7d0b863ac05b4$export$248471b8219beb2f)();
    const cleanInput = (val)=>val.replace(/\[/g, "").replace(/\]/g, "");
    const isVariableFind = (val)=>{
        val = cleanInput(val);
        return variables.filter((variable)=>variable.name == val.toLowerCase()).length > 0;
    };
    const [keyRow, setKeyRow] = (0, $bh6RR.useState)(KeyValue);
    const [valueRow, setValueRow] = (0, $bh6RR.useState)(value ? `[${value}]` : "");
    const onBlur = ()=>{
        const valueRowTmp = cleanInput(valueRow);
        setValueRow(valueRowTmp ? `[${valueRowTmp}]` : "");
        setValue(idx, "value", valueRowTmp);
    };
    (0, $bh6RR.useEffect)(()=>{
        setValueRow(value ? `[${value}]` : "");
        setKeyRow(KeyValue);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "form_sub_block",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                className: "editor-input-sub",
                placeholder: "key",
                value: keyRow,
                onChange: (e)=>setKeyRow(e.target.value),
                onBlur: ()=>setValue(idx, "key", keyRow)
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                className: "editor-input-sub uppercase",
                placeholder: "value",
                value: valueRow,
                style: {
                    color: isVariableFind(value) ? "var(--main)" : "var(--black)"
                },
                onChange: (e)=>{
                    setValueRow(e.target.value.toUpperCase());
                },
                onBlur: onBlur
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                className: "editor-iconButton main_add-button button_center delete_action",
                icon: "fas fa-trash",
                onClick: ()=>deleteValue(idx)
            })
        ]
    });
}
var $ac23aa360d63c26a$export$2e2bcd8739ae039 = $ac23aa360d63c26a$var$ApiBlockInputDropdown;





var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");

function $39ab41060f0dd572$export$2e2bcd8739ae039() {
    return $39ab41060f0dd572$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $39ab41060f0dd572$export$2e2bcd8739ae039.apply(null, arguments);
}


function $cd488cd9c287f883$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
var $1ab6948683118df1$var$index = (0, $bh6RR.useLayoutEffect);
var $1ab6948683118df1$export$2e2bcd8739ae039 = $1ab6948683118df1$var$index;


var $d614eb6369e0b035$export$2e2bcd8739ae039 = function useLatest(value) {
    var ref = $bh6RR.useRef(value);
    (0, $1ab6948683118df1$export$2e2bcd8739ae039)(function() {
        ref.current = value;
    });
    return ref;
};



var $bh6RR = parcelRequire("bh6RR");
var $db9f55dc83b6ab1d$var$updateRef = function updateRef(ref, value) {
    if (typeof ref === "function") {
        ref(value);
        return;
    }
    ref.current = value;
};
var $db9f55dc83b6ab1d$var$useComposedRef = function useComposedRef(libRef, userRef) {
    var prevUserRef = (0, $bh6RR.useRef)();
    return (0, $bh6RR.useCallback)(function(instance) {
        libRef.current = instance;
        if (prevUserRef.current) $db9f55dc83b6ab1d$var$updateRef(prevUserRef.current, null);
        prevUserRef.current = userRef;
        if (!userRef) return;
        $db9f55dc83b6ab1d$var$updateRef(userRef, instance);
    }, [
        userRef
    ]);
};
var $db9f55dc83b6ab1d$export$2e2bcd8739ae039 = $db9f55dc83b6ab1d$var$useComposedRef;


var $8f57823a2bb4f964$var$HIDDEN_TEXTAREA_STYLE = {
    "min-height": "0",
    "max-height": "none",
    height: "0",
    visibility: "hidden",
    overflow: "hidden",
    position: "absolute",
    "z-index": "-1000",
    top: "0",
    right: "0",
    display: "block"
};
var $8f57823a2bb4f964$var$forceHiddenStyles = function forceHiddenStyles(node) {
    Object.keys($8f57823a2bb4f964$var$HIDDEN_TEXTAREA_STYLE).forEach(function(key) {
        node.style.setProperty(key, $8f57823a2bb4f964$var$HIDDEN_TEXTAREA_STYLE[key], "important");
    });
};
var $8f57823a2bb4f964$var$forceHiddenStyles$1 = $8f57823a2bb4f964$var$forceHiddenStyles;
var $8f57823a2bb4f964$var$hiddenTextarea = null;
var $8f57823a2bb4f964$var$getHeight = function getHeight(node, sizingData) {
    var height = node.scrollHeight;
    if (sizingData.sizingStyle.boxSizing === "border-box") // border-box: add border, since height = content + padding + border
    return height + sizingData.borderSize;
    // remove padding, since height = content
    return height - sizingData.paddingSize;
};
function $8f57823a2bb4f964$var$calculateNodeHeight(sizingData, value, minRows, maxRows) {
    if (minRows === void 0) minRows = 1;
    if (maxRows === void 0) maxRows = Infinity;
    if (!$8f57823a2bb4f964$var$hiddenTextarea) {
        $8f57823a2bb4f964$var$hiddenTextarea = document.createElement("textarea");
        $8f57823a2bb4f964$var$hiddenTextarea.setAttribute("tabindex", "-1");
        $8f57823a2bb4f964$var$hiddenTextarea.setAttribute("aria-hidden", "true");
        $8f57823a2bb4f964$var$forceHiddenStyles$1($8f57823a2bb4f964$var$hiddenTextarea);
    }
    if ($8f57823a2bb4f964$var$hiddenTextarea.parentNode === null) document.body.appendChild($8f57823a2bb4f964$var$hiddenTextarea);
    var paddingSize = sizingData.paddingSize, borderSize = sizingData.borderSize, sizingStyle = sizingData.sizingStyle;
    var boxSizing = sizingStyle.boxSizing;
    Object.keys(sizingStyle).forEach(function(_key) {
        var key = _key;
        $8f57823a2bb4f964$var$hiddenTextarea.style[key] = sizingStyle[key];
    });
    $8f57823a2bb4f964$var$forceHiddenStyles$1($8f57823a2bb4f964$var$hiddenTextarea);
    $8f57823a2bb4f964$var$hiddenTextarea.value = value;
    var height = $8f57823a2bb4f964$var$getHeight($8f57823a2bb4f964$var$hiddenTextarea, sizingData);
    // Double set and calc due to Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1795904
    $8f57823a2bb4f964$var$hiddenTextarea.value = value;
    height = $8f57823a2bb4f964$var$getHeight($8f57823a2bb4f964$var$hiddenTextarea, sizingData);
    // measure height of a textarea with a single row
    $8f57823a2bb4f964$var$hiddenTextarea.value = "x";
    var rowHeight = $8f57823a2bb4f964$var$hiddenTextarea.scrollHeight - paddingSize;
    var minHeight = rowHeight * minRows;
    if (boxSizing === "border-box") minHeight = minHeight + paddingSize + borderSize;
    height = Math.max(minHeight, height);
    var maxHeight = rowHeight * maxRows;
    if (boxSizing === "border-box") maxHeight = maxHeight + paddingSize + borderSize;
    height = Math.min(maxHeight, height);
    return [
        height,
        rowHeight
    ];
}
var $8f57823a2bb4f964$var$noop = function noop() {};
var $8f57823a2bb4f964$var$pick = function pick(props, obj) {
    return props.reduce(function(acc, prop) {
        acc[prop] = obj[prop];
        return acc;
    }, {});
};
var $8f57823a2bb4f964$var$SIZING_STYLE = [
    "borderBottomWidth",
    "borderLeftWidth",
    "borderRightWidth",
    "borderTopWidth",
    "boxSizing",
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontWeight",
    "letterSpacing",
    "lineHeight",
    "paddingBottom",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    // non-standard
    "tabSize",
    "textIndent",
    // non-standard
    "textRendering",
    "textTransform",
    "width",
    "wordBreak"
];
var $8f57823a2bb4f964$var$isIE = !!document.documentElement.currentStyle;
var $8f57823a2bb4f964$var$getSizingData = function getSizingData(node) {
    var style = window.getComputedStyle(node);
    if (style === null) return null;
    var sizingStyle = $8f57823a2bb4f964$var$pick($8f57823a2bb4f964$var$SIZING_STYLE, style);
    var boxSizing = sizingStyle.boxSizing;
    // probably node is detached from DOM, can't read computed dimensions
    if (boxSizing === "") return null;
    // IE (Edge has already correct behaviour) returns content width as computed width
    // so we need to add manually padding and border widths
    if ($8f57823a2bb4f964$var$isIE && boxSizing === "border-box") sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(sizingStyle.borderRightWidth) + parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.paddingRight) + parseFloat(sizingStyle.paddingLeft) + "px";
    var paddingSize = parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop);
    var borderSize = parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth);
    return {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize
    };
};
var $8f57823a2bb4f964$var$getSizingData$1 = $8f57823a2bb4f964$var$getSizingData;
function $8f57823a2bb4f964$var$useListener(target, type, listener) {
    var latestListener = (0, $d614eb6369e0b035$export$2e2bcd8739ae039)(listener);
    $bh6RR.useLayoutEffect(function() {
        var handler = function handler(ev) {
            return latestListener.current(ev);
        };
        // might happen if document.fonts is not defined, for instance
        if (!target) return;
        target.addEventListener(type, handler);
        return function() {
            return target.removeEventListener(type, handler);
        };
    }, []);
}
var $8f57823a2bb4f964$var$useWindowResizeListener = function useWindowResizeListener(listener) {
    $8f57823a2bb4f964$var$useListener(window, "resize", listener);
};
var $8f57823a2bb4f964$var$useFontsLoadedListener = function useFontsLoadedListener(listener) {
    $8f57823a2bb4f964$var$useListener(document.fonts, "loadingdone", listener);
};
var $8f57823a2bb4f964$var$_excluded = [
    "cacheMeasurements",
    "maxRows",
    "minRows",
    "onChange",
    "onHeightChange"
];
var $8f57823a2bb4f964$var$TextareaAutosize = function TextareaAutosize(_ref, userRef) {
    var cacheMeasurements = _ref.cacheMeasurements, maxRows = _ref.maxRows, minRows = _ref.minRows, _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? $8f57823a2bb4f964$var$noop : _ref$onChange, _ref$onHeightChange = _ref.onHeightChange, onHeightChange = _ref$onHeightChange === void 0 ? $8f57823a2bb4f964$var$noop : _ref$onHeightChange, props = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(_ref, $8f57823a2bb4f964$var$_excluded);
    var isControlled = props.value !== undefined;
    var libRef = $bh6RR.useRef(null);
    var ref = (0, $db9f55dc83b6ab1d$export$2e2bcd8739ae039)(libRef, userRef);
    var heightRef = $bh6RR.useRef(0);
    var measurementsCacheRef = $bh6RR.useRef();
    var resizeTextarea = function resizeTextarea() {
        var node = libRef.current;
        var nodeSizingData = cacheMeasurements && measurementsCacheRef.current ? measurementsCacheRef.current : $8f57823a2bb4f964$var$getSizingData$1(node);
        if (!nodeSizingData) return;
        measurementsCacheRef.current = nodeSizingData;
        var _calculateNodeHeight = $8f57823a2bb4f964$var$calculateNodeHeight(nodeSizingData, node.value || node.placeholder || "x", minRows, maxRows), height = _calculateNodeHeight[0], rowHeight = _calculateNodeHeight[1];
        if (heightRef.current !== height) {
            heightRef.current = height;
            node.style.setProperty("height", height + "px", "important");
            onHeightChange(height, {
                rowHeight: rowHeight
            });
        }
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) resizeTextarea();
        onChange(event);
    };
    $bh6RR.useLayoutEffect(resizeTextarea);
    $8f57823a2bb4f964$var$useWindowResizeListener(resizeTextarea);
    $8f57823a2bb4f964$var$useFontsLoadedListener(resizeTextarea);
    return /*#__PURE__*/ $bh6RR.createElement("textarea", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        onChange: handleChange,
        ref: ref
    }));
};
var $8f57823a2bb4f964$export$2e2bcd8739ae039 = /* #__PURE__ */ $bh6RR.forwardRef($8f57823a2bb4f964$var$TextareaAutosize);


function $7dd2bb1087d36244$var$ApiBlockArea({ value: value, setValue: setValue, onBlur: onBlur }) {
    const [body, setBody] = (0, $bh6RR.useState)(value);
    // DisableSpellCheck need to be some when the composent is mounted, no use effect yes !
    const disableSpellCheck = (ref)=>{
        if (!ref) return;
        ref.spellcheck = false;
    };
    const onChange = (e)=>{
        setBody(e.target.value);
        setValue(e.target.value);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        style: {
            width: "calc(100% - 10px)"
        },
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8f57823a2bb4f964$export$2e2bcd8739ae039), {
            ref: (ref)=>disableSpellCheck(ref),
            style: {
                marginTop: 20,
                marginLeft: 10
            },
            value: body,
            onChange: onChange,
            onBlur: onBlur,
            className: "input editor-input title_input",
            placeholder: "{}",
            minRows: 3
        })
    });
}
var $7dd2bb1087d36244$export$2e2bcd8739ae039 = $7dd2bb1087d36244$var$ApiBlockArea;














var $bh6RR = parcelRequire("bh6RR");
// Popup use to create or modificate a variable name / type
function $558de12077ff36d1$var$ApiModalResponseEdition({ onClose: onClose }) {
    const { variables: variables } = (0, $7ef7d0b863ac05b4$export$248471b8219beb2f)();
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { register: register, getValues: getValues, formState: formState, setValue: setValue } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange"
    });
    const onClick = ()=>{
        // ! important to resolve the value, api's call are declared in another component
        modal.resolve(getValues());
        return onClose();
    };
    const [typeResponse, setTypeResponse] = (0, $bh6RR.useState)(0);
    const [dropdownVariableValidate, setdropdownVariableValidate] = (0, $bh6RR.useState)(null);
    const choices = [
        {
            value: 0,
            text: "Existing Variable"
        },
        {
            value: 1,
            text: "Create new variable"
        }
    ];
    const isDisableButton = typeResponse == 1 ? !formState.isValid : !formState.isValid || !dropdownVariableValidate;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("form", {
        className: "api_responses_modal",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                className: "title",
                children: "Create a Response"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "area-edit",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Parameter name : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                style: {
                                    height: 20,
                                    marginTop: 18
                                },
                                ...register("key", {
                                    required: true
                                }),
                                className: "input full-width",
                                placeholder: "Key",
                                autoComplete: "off"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Type of Variable : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                ...register("variable_type"),
                                setValue: (name, value)=>{
                                    setValue(name, value);
                                    setTypeResponse(value);
                                },
                                choices: choices,
                                width: "22vw"
                            })
                        ]
                    }),
                    typeResponse == 1 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "grid-row",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                        className: "dropdown_title",
                                        children: "Variable : "
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                        style: {
                                            height: 20,
                                            marginTop: 18
                                        },
                                        autoComplete: "off",
                                        ...register("variable_name", {
                                            required: true,
                                            setValueAs: (v)=>v.toLowerCase(),
                                            validate: (v)=>variables.filter((variable)=>variable.name == v).length == 0
                                        }),
                                        className: `variable_input ${Object.keys(formState.errors).length && formState.errors.variable_name && formState.errors.variable_name.type == "validate" ? " error" : ""}`,
                                        placeholder: "Variable name"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "grid-row",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                        className: "dropdown_title",
                                        children: "Type : "
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                        ...register("type"),
                                        setValue: setValue,
                                        choices: (0, $9c0fc12f676cb0a2$export$2e2bcd8739ae039),
                                        width: "22vw"
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    typeResponse == 0 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Variable : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fe74f3a5194e12fa$export$2e2bcd8739ae039), {
                                register: register("variable"),
                                setValue: (name, value)=>setValue(name, value) == null ? setdropdownVariableValidate(value) : null,
                                choices: (0, $9c0fc12f676cb0a2$export$2e2bcd8739ae039),
                                width: "22vw",
                                createVariableDisable: true,
                                resetVariableDisable: true
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                label: "Confirm",
                onClick: onClick,
                disabled: isDisableButton
            })
        ]
    });
}
var $558de12077ff36d1$export$2e2bcd8739ae039 = $558de12077ff36d1$var$ApiModalResponseEdition;



function $6d7f91cb10e273cf$var$FormActionApi({ name: name, id: id }) {
    const { children: children, blocks: blocks } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const indexBlock = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, id, "object_id");
    const data = blocks[indexBlock] ? blocks[indexBlock].data : (0, $b1615a45f3113430$export$6003379a934c9a07).data;
    const { api_body_type: api_body_type, api_method_type: api_method_type, headers: headers, body: body, responses: responses, url: url, is_proxy: is_proxy, url_proxy: url_proxy, login_proxy: login_proxy, password_proxy: password_proxy } = data;
    const dispatch = (0, $6949a38b8f965998$export$649a5cfe816ce921)();
    const { addVariable: addVariable } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const [areas, setAreas] = (0, $bh6RR.useState)({
        headers: false,
        body: true,
        responses: true,
        proxy: false
    });
    const { updateBlockData: updateBlockData } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    // Helpers function to fold and unflod areas
    const setAreasUnflold = (name)=>{
        if (areas[name] == undefined) return;
        if (name == "headers" && areas[name] == false) {
            areas.body = false;
            areas.responses = false;
        }
        if (name != "headers" && areas[name] == false) areas.headers = false;
        if (name == "proxy" && areas[name] == false) {
            areas.body = false;
            areas.responses = false;
        }
        if (name != "proxy" && areas[name] == false) areas.proxy = false;
        areas[name] = !areas[name];
        setAreas({
            ...areas
        });
    };
    const { formState: { errors: errors }, formState: formState, getValues: getValues, setValue: setValue, register: register } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: {
            api_body_type: api_body_type,
            api_method_type: api_method_type,
            headers: headers,
            body: body,
            responses: responses,
            url: url,
            url_proxy: url_proxy,
            is_proxy: is_proxy,
            login_proxy: login_proxy,
            password_proxy: password_proxy
        }
    });
    // Headers, body, responses are array type data
    const setValueFormArray = (name, index, key, value)=>{
        if (index == -1) index = getValues(name).length - 1;
        setValue(`${name}.${index}.${key}`, value);
        onSubmit(getValues());
    };
    // If the body is raw other set value
    const setValueBodyRaw = (value)=>{
        setValue(`body.raw`, value);
    };
    // Set value for dropdown
    const setValueFormDropdown = (name, value)=>{
        setValue(`${name}`, {
            name: value
        });
        onSubmit(getValues());
    };
    const setValueFormDropdownBody = (name, value)=>{
        setValue(`${name}`, {
            name: value
        });
        if (api_body_type.name == "raw" && value != "raw") setValue(`body`, []);
        // Special case for raw data, format data
        if (api_body_type.name != "raw" && value == "raw") setValue(`body`, {
            raw: ""
        });
        onSubmit(getValues());
    };
    const deleteValue = (name, index)=>{
        var data = Object.values(getValues(name));
        if (index == -1) index = data.length - 1;
        data = data.filter((row, idx)=>idx !== index);
        // Update the tree state
        dispatch({
            type: "updateBlockData",
            payload: {
                id: id,
                data: {
                    [name]: [
                        ...data
                    ]
                }
            }
        });
        setValue(name, data);
        onSubmit(getValues());
    };
    // Just somme mapping object : their objectif is to be share to the area block
    const functionApiHeaders = {
        setValue: (index, key, value)=>setValueFormArray("headers", index, key, value),
        deleteValue: (index)=>deleteValue("headers", index)
    };
    const functionApiBody = {
        setValue: (index, key, value)=>setValueFormArray("body", index, key, value),
        deleteValue: (index)=>deleteValue("body", index)
    };
    const functionApiResponses = {
        setValue: (index, key, value)=>setValueFormArray("responses", index, key, value),
        deleteValue: (index)=>deleteValue("responses", index)
    };
    const addNewData = async (name, scroll)=>{
        const row = {
            key: "",
            value: ""
        };
        // Spread operator just in case, to kill the reference
        const data = [
            ...getValues(name),
            row
        ];
        // Update the tree state
        dispatch({
            type: "updateBlockData",
            payload: {
                id: id,
                data: {
                    [name]: [
                        ...data
                    ]
                }
            }
        });
        setValue(name, data);
        onSubmit(getValues());
        // Scroll function is passed by the AreaList component
        scroll();
    };
    const addNewDataWithModal = async (name, scroll)=>{
        const result = await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show("editor-popup", {
            Component: (0, $558de12077ff36d1$export$2e2bcd8739ae039)
        });
        var row = {};
        var variable = {};
        if (result.variable_type == "0" || result.variable_type === 0) row = {
            key: result.key,
            value: result.variable.name.toUpperCase()
        };
        if (result.variable_type == "1" || result.variable_type === 1) {
            row = {
                key: result.key,
                value: result.variable_name.toUpperCase()
            };
            variable = {
                name: result.variable_name.toLowerCase(),
                type: result.type
            };
        }
        const data = [
            ...getValues(name),
            row
        ];
        // Update the tree state
        dispatch({
            type: "updateBlockData",
            payload: {
                id: id,
                data: {
                    [name]: [
                        ...data
                    ]
                }
            }
        });
        setValue(name, data);
        onSubmit(getValues());
        // Scroll function is passed by the AreaList component
        scroll();
        if (Object.keys(variable).length) addVariable(variable);
    };
    // Todo add the transformer in the utils/transformer
    const onSubmit = (data)=>{
        const dataServer = {
            api_body: data.body,
            api_body_type: data.api_body_type.name,
            api_method_type: data.api_method_type.name,
            api_headers: data.headers,
            api_responses: data.responses,
            api_url: data.url,
            url_proxy: data.url_proxy,
            login_proxy: data.login_proxy,
            password_proxy: data.password_proxy,
            is_proxy: data.is_proxy
        };
        updateBlockData(id, data, dataServer);
    };
    const [valueUrl, setValueUrl] = (0, $bh6RR.useState)(url);
    const setValueInputUrl = (e)=>{
        setValue("url", e.target.value);
        setValueUrl(e.target.value);
    };
    const [valueUrlProxy, setValueUrlProxy] = (0, $bh6RR.useState)(url_proxy);
    const [valueLoginProxy, setLoginProxy] = (0, $bh6RR.useState)(login_proxy);
    const [valuePasswordProxy, setPasswordProxy] = (0, $bh6RR.useState)(password_proxy);
    const [valueIsProxy, setIsProxy] = (0, $bh6RR.useState)(is_proxy);
    const setValueInputUrlProxy = (e)=>{
        setValue("url_proxy", e.target.value);
        setValueUrlProxy(e.target.value);
    };
    const setValueInputLoginProxy = (e)=>{
        setValue("login_proxy", e.target.value);
        setLoginProxy(e.target.value);
    };
    const setValueInputPasswordProxy = (e)=>{
        setValue("password_proxy", e.target.value);
        setPasswordProxy(e.target.value);
    };
    const setValueInputIsProxy = (e)=>{
        let b = !getValues("is_proxy");
        setValue("is_proxy", b);
        setIsProxy(b);
        onBlurInputUrl();
    };
    if (body.raw) body.raw = body.raw.replace(/\\n/g, "\n");
    const onBlurInputUrl = ()=>onSubmit(getValues());
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $841d23f226ffdc19$export$2e2bcd8739ae039), {
                title: "Api",
                titleInput: "Api name",
                name: name,
                id: id
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "area-edit",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row-input",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                style: {
                                    marginTop: "10px"
                                },
                                children: "Url : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dropdown_container",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ...register("url"),
                                    className: "editor-input title_input",
                                    value: valueUrl,
                                    onChange: setValueInputUrl,
                                    onBlur: onBlurInputUrl
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Method : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dropdown_container",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                    name: "api_method_type",
                                    choices: (0, $9589619a1fc38d22$export$2e2bcd8739ae039),
                                    defaultChoice: api_method_type.name,
                                    width: "260px",
                                    setValue: setValueFormDropdown
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Body Type : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dropdown_container",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                    name: "api_body_type",
                                    choices: (0, $726fea230f7787ad$export$2e2bcd8739ae039),
                                    defaultChoice: api_body_type.name,
                                    width: "260px",
                                    setValue: setValueFormDropdownBody
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "container_is_proxy",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                style: {
                                    marginTop: "10px"
                                },
                                children: "With Proxy : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                name: "Resume",
                                onChange: setValueInputIsProxy,
                                checked: getValues("is_proxy")
                            })
                        ]
                    }),
                    is_proxy ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $5b4dd497c4ab826c$export$2e2bcd8739ae039), {
                        title: "Proxy",
                        maxHeight: "140px",
                        unfold: areas.proxy,
                        setUnfold: ()=>setAreasUnflold("proxy"),
                        onClickButton: (arg)=>addNewData("proxy", ...arg),
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "grid_proxy",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                        className: "dropdown_title",
                                        style: {
                                            marginTop: "10px"
                                        },
                                        children: "Url "
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "dropdown_container",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("url_proxy"),
                                            className: "editor-input title_input proxy_input",
                                            value: valueUrlProxy,
                                            onChange: setValueInputUrlProxy,
                                            onBlur: onBlurInputUrl
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "grid_proxy",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                        className: "dropdown_title",
                                        style: {
                                            marginTop: "10px"
                                        },
                                        children: "Login "
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "dropdown_container",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("proxy_login"),
                                            className: "editor-input title_input proxy_input",
                                            value: valueLoginProxy,
                                            onChange: setValueInputLoginProxy,
                                            onBlur: onBlurInputUrl
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "grid_proxy",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                        className: "dropdown_title",
                                        style: {
                                            marginTop: "10px"
                                        },
                                        children: "Password "
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "dropdown_container",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("proxy_password"),
                                            className: "editor-input title_input proxy_input",
                                            value: valuePasswordProxy,
                                            onChange: setValueInputPasswordProxy,
                                            onBlur: onBlurInputUrl
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : "",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5b4dd497c4ab826c$export$2e2bcd8739ae039), {
                        title: "Headers",
                        maxHeight: "140px",
                        buttonLabel: "Add a Header",
                        unfold: areas.headers,
                        setUnfold: ()=>setAreasUnflold("headers"),
                        onClickButton: (arg)=>addNewData("headers", ...arg),
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0c7211c3be597575$export$2e2bcd8739ae039), {
                            data: headers,
                            ComponentRow: (0, $70639c92410bf1bc$export$2e2bcd8739ae039),
                            FunctionsRow: functionApiHeaders
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $5b4dd497c4ab826c$export$2e2bcd8739ae039), {
                        title: "Body",
                        maxHeight: "260px",
                        ...api_body_type.name != "raw" ? {
                            buttonLabel: "Add a Param"
                        } : {},
                        unfold: areas.body,
                        setUnfold: ()=>setAreasUnflold("body"),
                        onClickButton: (arg)=>addNewData("body", ...arg),
                        children: [
                            api_body_type.name != "raw" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0c7211c3be597575$export$2e2bcd8739ae039), {
                                data: body,
                                ComponentRow: (0, $70639c92410bf1bc$export$2e2bcd8739ae039),
                                FunctionsRow: functionApiBody
                            }),
                            api_body_type.name == "raw" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7dd2bb1087d36244$export$2e2bcd8739ae039), {
                                value: body.raw,
                                setValue: setValueBodyRaw,
                                onBlur: ()=>onSubmit(getValues())
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5b4dd497c4ab826c$export$2e2bcd8739ae039), {
                        title: "Responses",
                        maxHeight: "140px",
                        buttonLabel: "Add a Response",
                        unfold: areas.responses,
                        setUnfold: ()=>setAreasUnflold("responses"),
                        onClickButton: (arg)=>addNewDataWithModal("responses", ...arg),
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0c7211c3be597575$export$2e2bcd8739ae039), {
                            data: responses,
                            ComponentRow: (0, $ac23aa360d63c26a$export$2e2bcd8739ae039),
                            FunctionsRow: functionApiResponses
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        style: {
                            paddingBottom: "35px"
                        }
                    })
                ]
            })
        ]
    });
}
var $6d7f91cb10e273cf$export$2e2bcd8739ae039 = $6d7f91cb10e273cf$var$FormActionApi;











function $e150c38c6560fbce$var$FormActionCondition({ id: id }) {
    const { blocks: blocks, paths: paths } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const indexBlock = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, id, "object_id");
    const block = blocks[indexBlock] ? blocks[indexBlock] : (0, $8bcb6be92ae90528$export$3bbd04f240725aed);
    const { data: data } = block;
    const name = block.name;
    const dispatch = (0, $6949a38b8f965998$export$649a5cfe816ce921)();
    const { checkErrorBlock: checkErrorBlock } = (0, $e243ee0cadf02534$export$2e2bcd8739ae039)();
    const { updateBlockData: updateBlockData } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const setTextareaData = (ref)=>{
        if (!ref) return null;
        ref.value = data.condition;
    };
    const onBlur = (e)=>{
        const value = e.target.value;
        updateBlockData(id, {
            condition: value,
            name: name
        });
    };
    const onChange = (e)=>{
        const value = e.target.value;
        dispatch({
            type: "updateBlockData",
            payload: {
                id: id,
                data: {
                    condition: value
                }
            }
        });
    };
    const errors = checkErrorBlock(block, {
        blocks: blocks,
        paths: paths
    });
    var errorRaw = Object.entries(errors).filter(([key, value])=>value.type == "Wrong Spelling");
    var classNameInput = "input editor-input title_input";
    classNameInput = errorRaw.length ? classNameInput + " error" : classNameInput;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $841d23f226ffdc19$export$2e2bcd8739ae039), {
                title: "Condition",
                titleInput: "Condition name",
                name: name,
                id: id
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "area-edit",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                        className: "input_title",
                        children: "Type your condition : "
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8f57823a2bb4f964$export$2e2bcd8739ae039), {
                        ref: (ref)=>setTextareaData(ref),
                        onBlur: onBlur,
                        onChange: onChange,
                        className: classNameInput,
                        placeholder: 'Example : [CALLER] == "0630981072" ',
                        minRows: 5
                    }),
                    errorRaw.length ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "error",
                        children: errorRaw[0][1].data
                    }) : ""
                ]
            })
        ]
    });
}
var $e150c38c6560fbce$export$2e2bcd8739ae039 = $e150c38c6560fbce$var$FormActionCondition;






const $6e81a2fbdb641fb6$var$ActionExtractType = [
    {
        value: "number",
        text: "Number"
    },
    {
        value: "text",
        text: "Text"
    },
    {
        value: "date",
        text: "Date"
    },
    {
        value: "city",
        text: "City"
    },
    {
        value: "civility",
        text: "Civility"
    },
    {
        value: "time",
        text: "Specific time"
    },
    {
        value: "postcode",
        text: "Zip code"
    },
    {
        value: "department",
        text: "Department"
    },
    {
        value: "firstname",
        text: "Firstname"
    },
    {
        value: "lastname",
        text: "Lastname"
    }
];
var $6e81a2fbdb641fb6$export$2e2bcd8739ae039 = $6e81a2fbdb641fb6$var$ActionExtractType;


const $3a18486b74bc9caa$var$ActionExtractBeforeAfter = [
    {
        value: "before",
        text: "Before"
    },
    {
        value: "after",
        text: "After"
    }
];
var $3a18486b74bc9caa$export$2e2bcd8739ae039 = $3a18486b74bc9caa$var$ActionExtractBeforeAfter;






var $bh6RR = parcelRequire("bh6RR");
const $52b728934d836302$var$InputBox = /*#__PURE__*/ (0, $bh6RR.forwardRef)(({ id: id, classNameInput: classNameInput, classNameLabel: classNameLabel, style: style, check: check, setValue: setValue, name: name, disabled: disabled, onClick: onClick }, ref)=>{
    const [checked, setChecked] = (0, $bh6RR.useState)(check);
    const handleChange = ()=>{
        setChecked(!checked);
        setValue(name, !checked);
        if (onClick != null) onClick(!checked);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                ref: ref,
                className: "checkbox-spin " + (classNameInput ? classNameInput : "") + "",
                type: "checkbox",
                onChange: handleChange,
                checked: checked,
                id: id,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                style: style,
                className: (classNameLabel ? classNameLabel : "") + "",
                htmlFor: id,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {})
            })
        ]
    });
});
$52b728934d836302$var$InputBox.defaultProps = {
    check: false,
    setValue: ()=>{}
};
var $52b728934d836302$export$2e2bcd8739ae039 = $52b728934d836302$var$InputBox;





var $bh6RR = parcelRequire("bh6RR");




function $b54ccffc1f6fd0ba$var$FormActionExtract({ id: id }) {
    const { blocks: blocks } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const indexBlock = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, id, "object_id");
    const block = blocks[indexBlock] ? blocks[indexBlock] : (0, $78150b1b7d096f99$export$d83ba0b75b8f3fdd);
    const name = block.name;
    const { is_advance_extract: is_advance_extract, before_after: before_after, extract_input: extract_input, extract_output: extract_output, extract_type: extract_type, keywords_exclude: keywords_exclude, keywords_include: keywords_include } = block.data;
    const [isSetting, setIsSetting] = (0, $bh6RR.useState)(is_advance_extract);
    const { updateBlockData: updateBlockData } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const { register: register, handleSubmit: handleSubmit, watch: watch, formState: { errors: errors }, formState: formState, getValues: getValues, setValue: setValue } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: {
            before_after: before_after == null ? "before" : before_after.name,
            extract_type: extract_type.name,
            extract_input: extract_input,
            extract_output: extract_output,
            is_advance_extract: is_advance_extract ? 1 : 0,
            keywords_include: keywords_include,
            keywords_exclude: keywords_exclude
        }
    });
    const setDropdown = (name, value)=>{
        setValue(name, value);
        onSubmit(getValues());
    };
    const changeInputBox = (name, value)=>{
        setValue(name, value ? 1 : 0);
        setIsSetting(value);
        if (value == false) {
            setValue("before_after", "before");
            const input = document.getElementsByName("before_after").item(0);
            input.nextElementSibling.firstElementChild.innerHTML = "Before";
        }
        onSubmit(getValues());
    };
    const transformBlockName = (data)=>{
        if (data.extract_input == null || (0, $78150b1b7d096f99$export$d83ba0b75b8f3fdd).name != name && /^Extract from \[/.test(name) == false) return data;
        data.name = `Extract from [${data.extract_input.name.toUpperCase()}]`;
        return data;
    };
    const onSubmit = (data)=>{
        data = transformBlockName(data);
        var dataServer = {
            ...data
        };
        if (data.extract_output == null) {
            delete data.extract_output;
            delete dataServer.extract_output;
        } else dataServer.extract_output = dataServer.extract_output.name;
        if (data.extract_input == null) {
            delete data.extract_input;
            delete dataServer.extract_input;
        } else dataServer.extract_input = dataServer.extract_input.name;
        data.extract_type = {
            name: data.extract_type
        };
        data.before_after = {
            name: data.before_after
        };
        updateBlockData(id, data, dataServer);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $841d23f226ffdc19$export$2e2bcd8739ae039), {
                title: "Action Extract",
                titleInput: "Extract name",
                name: name,
                id: id
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("form", {
                className: "area-edit",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row",
                        style: {
                            marginTop: "10px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Extract : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dropdown_container",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                    ...register("extract_type"),
                                    choices: (0, $6e81a2fbdb641fb6$export$2e2bcd8739ae039),
                                    width: "calc(100%)",
                                    setValue: setDropdown,
                                    defaultChoice: extract_type.name
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "From : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dropdown_container",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fe74f3a5194e12fa$export$2e2bcd8739ae039), {
                                    register: register("extract_input"),
                                    variable: extract_input,
                                    setValue: setDropdown
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Save result in : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dropdown_container",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fe74f3a5194e12fa$export$2e2bcd8739ae039), {
                                    register: register("extract_output"),
                                    variable: extract_output,
                                    setValue: setDropdown
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Advanced settings : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dropdown_container",
                                style: {
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $52b728934d836302$export$2e2bcd8739ae039), {
                                    id: "is_advance_extract",
                                    ...register("is_advance_extract"),
                                    classNameLabel: "inputBox-center",
                                    check: is_advance_extract,
                                    setValue: changeInputBox
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: isSetting ? "" : "hidden",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "grid-row",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                        className: "dropdown_title",
                                        children: "Extract Data : "
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "dropdown_container",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                            ...register("before_after"),
                                            choices: (0, $3a18486b74bc9caa$export$2e2bcd8739ae039),
                                            width: "calc(100%)",
                                            setValue: setDropdown,
                                            defaultChoice: before_after == null ? "before" : before_after.name
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Accepted keywords : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                ...register("keywords_include"),
                                onBlur: ()=>onSubmit(getValues()),
                                className: "editor-input title_input keyword",
                                placeholder: "keyword1; keyword2; keyword 3"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "grid-row"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Forbidden keywords : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                ...register("keywords_exclude"),
                                onBlur: ()=>onSubmit(getValues()),
                                className: "editor-input title_input keyword",
                                placeholder: "keyword1; keyword2; keyword 3"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $b54ccffc1f6fd0ba$export$2e2bcd8739ae039 = $b54ccffc1f6fd0ba$var$FormActionExtract;













var $bh6RR = parcelRequire("bh6RR");
function $c4358e0aacc3c73d$var$RedirectionBlock({ name: name, keywords: keywords, forbidden: forbidden, child: child, first: first, idx: idx, deleteValue: deleteValue, setValue: setValue, move: move }) {
    const [open, setOpen] = (0, $bh6RR.useState)(false);
    const [currentHeight, setCurrentHeight] = (0, $bh6RR.useState)(0);
    const [errorBug, setErrorBug] = (0, $bh6RR.useState)(false);
    const [heights, setHeight] = (0, $bh6RR.useState)(0);
    const refEditArea = (0, $bh6RR.useRef)();
    const [keywordsValue, setKeywordsValue] = (0, $bh6RR.useState)(keywords);
    const [forbiddenValue, setForbiddenValue] = (0, $bh6RR.useState)(forbidden);
    const [nameValue, setNameValue] = (0, $bh6RR.useState)(name);
    const [isHover, setIsHover] = (0, $bh6RR.useState)(false);
    const getHeight = ()=>{
        try {
            return document.getElementsByClassName("measuring").item(child.index - 1).clientHeight;
        } catch  {
            setErrorBug(true);
        }
    };
    const setValueRedirection = (name, value)=>{
        setValue(child.index - 1, name, value);
    };
    const setValueNameRedirection = (name, value)=>{
        setValue(child.index - 1, name, value);
    };
    const onToggle = ()=>{
        setOpen(!open);
        if (!open == false) setCurrentHeight(0);
        else setCurrentHeight(getHeight());
    };
    const onHeightChange = ()=>{
        if (currentHeight == 0) return;
        setCurrentHeight(getHeight());
    };
    const disableSpellCheck = (ref)=>{
        if (!ref) return;
        ref.spellcheck = false;
    };
    (0, $bh6RR.useEffect)(()=>{
        if (refEditArea == null) return;
        if (first) {
            setOpen(true);
            setCurrentHeight(getHeight());
        }
        return ()=>{};
    }, [
        refEditArea
    ]);
    const classNameInput = open ? "input redirection-contain" : "input redirection-contain disabled";
    const messageBug = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            "An error has occurred and has been reported to us, our team is looking into it.  ",
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            " ",
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            " In the meantime,",
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                style: {
                    fontWeight: "bold"
                },
                children: " please create a new box."
            })
        ]
    }) // TEMPORAIRE en attendant de fix le probleme
    ;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: errorBug == false ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "redirection_block",
                    onMouseEnter: ()=>setIsHover(true),
                    onMouseLeave: ()=>setIsHover(false),
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                            value: nameValue,
                            className: classNameInput,
                            onBlur: ()=>setValueNameRedirection("name", nameValue),
                            onChange: (e)=>setNameValue(e.target.value)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "actions",
                            children: [
                                isHover && idx != 0 && first != true && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                    onClick: ()=>move(child, child.index - 1),
                                    className: "editor-iconButton main_add-button button_center profil_action",
                                    icon: "fas fa-chevron-up"
                                }),
                                isHover && idx != -1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                    onClick: ()=>move(child, child.index + 1),
                                    className: "editor-iconButton main_add-button button_center profil_action",
                                    icon: "fas fa-chevron-down"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                    onClick: onToggle,
                                    className: "editor-iconButton main_add-button button_center edit_action",
                                    icon: "fas fa-edit"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                    className: "editor-iconButton main_add-button button_center delete_action",
                                    icon: "fas fa-trash",
                                    onClick: ()=>deleteValue(child)
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: open ? "redirection_zone_edit show" : "redirection_zone_edit",
                    ref: refEditArea,
                    style: {
                        height: currentHeight
                    },
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "measuring",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "container-textarea",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8f57823a2bb4f964$export$2e2bcd8739ae039), {
                                    ref: (ref)=>disableSpellCheck(ref),
                                    onHeightChange: onHeightChange,
                                    value: keywordsValue,
                                    onBlur: ()=>setValueRedirection("keywords", keywordsValue),
                                    onChange: (e)=>setKeywordsValue(e.target.value),
                                    className: "input editor-input title_input",
                                    placeholder: "Keyword 1; Keyword 2; Keyword 3; etc...",
                                    minRows: 3
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "container-textarea",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8f57823a2bb4f964$export$2e2bcd8739ae039), {
                                    ref: (ref)=>disableSpellCheck(ref),
                                    onHeightChange: onHeightChange,
                                    value: forbiddenValue,
                                    onBlur: ()=>setValueRedirection("forbidden", forbiddenValue),
                                    onChange: (e)=>setForbiddenValue(e.target.value),
                                    spellCheck: "false",
                                    className: "input editor-input title_input",
                                    placeholder: "Forbidden keyword 1; Forbidden keyword 2; Forbidden keyword 3; etc...",
                                    minRows: 3
                                })
                            })
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            style: {
                color: "var(--pink)",
                paddingLeft: "10px",
                paddingTop: "10px"
            },
            children: [
                " ",
                messageBug
            ]
        })
    });
}
var $c4358e0aacc3c73d$export$2e2bcd8739ae039 = $c4358e0aacc3c73d$var$RedirectionBlock;







parcelRequire("bh6RR");







var $bh6RR = parcelRequire("bh6RR");






var $a4ac07fb6dab611c$export$2e2bcd8739ae039 = {
    addStatement: (name, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`dataset/${name}/statement`, data),
    updateStatement: (name, id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`dataset/${name}/statement/${id}`, data),
    deleteStatement: (name, id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`dataset/${name}/statement/${id}`),
    importStatement: (name, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`dataset/${name}/import`, data),
    importStopWords: (name, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`dataset/${name}/update/stop-words`, data),
    exportStatements: (name)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`dataset/${name}/export`),
    deleteAllStatements: (name)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`dataset/${name}/statements`),
    searchResponse: (name, question)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`dataset/${name}/question`, question)
};






var $bh6RR = parcelRequire("bh6RR");

function $47da697040d42413$var$ChooseFile({ accept: accept, defaultValueImage: defaultValueImage, currentFile: currentFile, _setFile: _setFile, loadAnim: loadAnim, colorBorder: colorBorder }) {
    const [file, setFile] = (0, $bh6RR.useState)(defaultValueImage ? defaultValueImage : "");
    const [preview, setPreview] = (0, $bh6RR.useState)();
    (0, $bh6RR.useEffect)(()=>{
        if (currentFile) {
            setFile(currentFile.name);
            setPreview(currentFile);
        }
    }, [
        currentFile
    ]);
    if (loadAnim == true && !isImage()) loadAnimationFile(true);
    else if (loadAnim == "finish") //
    loadAnimationFile(false);
    function changeValue(e, defaultValue = null) {
        let fileSetUp = e == null ? defaultValue : e.target.value.split("\\").pop();
        if (isImage()) {
            // or others files images
            if (defaultValue == null) document.getElementById("border_anim").classList.add("draw");
            setPreview(e == null ? defaultValue : e.target.files[0]);
        }
        if (_setFile != undefined) _setFile(e == null ? defaultValue : e.target.files[0]);
    }
    function isImage() {
        return accept.includes(".png");
    }
    function loadAnimationFile(_bool) {
        document.getElementById("loader_anim").style.display = _bool ? "block" : "none";
        if (loadAnim == "finish") document.getElementById("svg_checkfile").style.display = "block";
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        id: "border_anim",
        className: "file-drop-area " + (colorBorder ? "default " : " "),
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                id: "input_file",
                name: "image",
                className: "file-input",
                type: "file",
                accept: accept,
                onChange: (e)=>changeValue(e)
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                id: "choose_file",
                className: "fake-btn",
                style: {
                    display: defaultValueImage == null && preview == null ? "block" : "none"
                },
                children: "Choose file"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                id: "preview_container",
                style: {
                    display: isImage() ? preview || defaultValueImage ? "block" : "none" : "none"
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    id: "preview_image",
                    src: preview ? URL.createObjectURL(preview) : defaultValueImage
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                className: "file-msg",
                children: [
                    "  ",
                    file != "" && defaultValueImage == null ? file + " is ready for import" : defaultValueImage ? "    drag and drop your new logo here" : `or drag and drop ${accept} file here`,
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
                id: "svg_checkfile",
                viewBox: "0 0 52 52",
                className: "checkmark",
                style: {
                    display: !preview ? "none" : "block"
                },
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                        className: "checkmark__circle",
                        cy: "26",
                        cx: "26",
                        r: "25",
                        fill: "none"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        className: "checkmark__check",
                        fill: "none",
                        d: "M14.1 27.2l7.1 7.2 16.7-16.8"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                id: "loader_anim",
                className: "loader",
                style: {
                    display: "none"
                },
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "load-one"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "load-two"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "load-three"
                    })
                ]
            })
        ]
    });
}
var $47da697040d42413$export$2e2bcd8739ae039 = $47da697040d42413$var$ChooseFile;





var $bh6RR = parcelRequire("bh6RR");
function $71da39f6b3fb053c$var$SpanToast({ text: text }) {
    const spanRef = (0, $bh6RR.useRef)(null);
    const selectText = ()=>{
        navigator.clipboard.writeText(text);
        const span = spanRef.current;
        if (!span) return;
        const range = document.createRange();
        range.selectNodeContents(span);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
        ref: spanRef,
        onClick: selectText,
        style: {
            fontWeight: 600,
            cursor: "pointer"
        },
        children: text
    });
}
var $71da39f6b3fb053c$export$2e2bcd8739ae039 = $71da39f6b3fb053c$var$SpanToast;


const $e882427779c37e3e$var$ImportModalJson = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ nameDataset: nameDataset, title: title, data: data })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const [file, setFile] = (0, $bh6RR.useState)(null);
    const [loadAnim, setLoading] = (0, $bh6RR.useState)(null);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const onSubmit = async ()=>{
        if (!file) return;
        try {
            setLoading(true);
            const text = await file.text();
            const jsonData = JSON.parse(text);
            // on check si les redirs sont bien
            if (!jsonData.redirections || !Array.isArray(jsonData.redirections)) throw new Error("Invalid JSON format. Expected an object with a 'redirections' array.");
            setLoading("finish");
            setTimeout(()=>{
                // On envoie l’objet complet { variable, variable_redirection, redirections }
                modal.resolve(jsonData);
                onClose();
            }, 1000);
        } catch (err) {
            onClose();
            toast.error("Error", /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $71da39f6b3fb053c$export$2e2bcd8739ae039), {
                text: err.message
            }), 7000);
        }
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        name: "import-json",
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "leave-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
                className: "form-import",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                        children: "Import your JSON data"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "container_import",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                            className: "form-import_body",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $47da697040d42413$export$2e2bcd8739ae039), {
                                _setFile: setFile,
                                accept: ".json",
                                loadAnim: loadAnim
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "button_center",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                className: "validate",
                                label: "Upload JSON",
                                disabled: !file,
                                onClick: ()=>{
                                    onSubmit();
                                    setLoading(true);
                                }
                            })
                        })
                    })
                ]
            })
        ]
    });
});
var $e882427779c37e3e$export$2e2bcd8739ae039 = $e882427779c37e3e$var$ImportModalJson;


function $f5489e265e530650$var$FormActionRedirection({ id: id }) {
    const { children: children, blocks: blocks } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const indexBlock = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, id, "object_id");
    const block = blocks[indexBlock] ? blocks[indexBlock] : (0, $8afcac884e38448f$export$297f0ad075d10a0e);
    const data = block.data;
    const name = block.name;
    var { redirections: redirections, variable: variable, variable_redirect: variable_redirect } = data;
    var childrenBlocks = children.filter((child)=>child.parent_block_id == id).sort((a, b)=>a.index - b.index);
    const dispatch = (0, $6949a38b8f965998$export$649a5cfe816ce921)();
    const { updateBlockData: updateBlockData, createBlockChild: createBlockChild, updateBlockChild: updateBlockChild, updateBlockChildren: updateBlockChildren, deleteBlockChild: deleteBlockChild } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    redirections = redirections.map((redirection)=>{
        const child = Object.values(childrenBlocks).filter((child)=>child.text == redirection.name && child.index != 0).pop();
        return {
            ...redirection,
            child: child
        };
    }).filter((redirection)=>redirection.child);
    redirections = Object.values(redirections).sort((a, b)=>a.child.index - b.child.index);
    const setValueForm = (index, name, value)=>{
        if (name == "name") {
            const object_id = redirections[index].child.object_id;
            dispatch({
                type: "updateBlockChild",
                payload: {
                    block_id: id,
                    object_id: object_id,
                    data: {
                        text: value
                    }
                }
            });
            updateBlockChild(id, object_id, {
                text: value
            });
        }
        setValue(`redirections.${index}.${name}`, value);
        dispatch({
            type: "updateBlockData",
            payload: {
                id: id,
                data: {
                    redirections: getValues().redirections
                }
            }
        });
        //dispatch({type : 'updateBlockData', payload : { id, data }})
        onSubmit(getValues());
    };
    const setValueDropdown = (name, value, _onSubmit = true)=>{
        setValue(`${name}`, value);
        if (_onSubmit) onSubmit(getValues());
    };
    const lastChild = childrenBlocks[childrenBlocks.length - 1];
    const addNewRedirection = async (scroll, name = "", index = "", keywords = "", forbidden = "")=>{
        const length = redirections.length + 1;
        const child = {
            text: name !== "" ? name : "Redirection " + length,
            object_id: (0, $d64a8a6f6e0ad216$export$2e2bcd8739ae039)(index !== "" ? index : length),
            index: index !== "" ? index : length,
            parent_block_id: lastChild.parent_block_id
        };
        const redirection = {
            name: name !== "" ? name : "Redirection " + length,
            keywords: keywords !== "" ? keywords : "",
            forbidden: forbidden !== "" ? forbidden : "",
            child: child
        };
        dispatch({
            type: "createBlockChildBeforeLast",
            payload: {
                block_id: id,
                data: child
            }
        });
        createBlockChild(id, child);
        updateBlockChild(id, lastChild.object_id, {
            index: length + 1
        });
        dispatch({
            type: "updateBlockData",
            payload: {
                id: id,
                data: {
                    redirections: [
                        ...redirections,
                        redirection
                    ]
                }
            }
        });
        redirections = [
            ...redirections,
            redirection
        ];
        setValue(`redirections.${length - 1}`, redirection);
        let dataToSend = getValues();
        dataToSend.redirections = redirections;
        onSubmit(dataToSend);
        if (scroll) scroll();
    };
    const addMultipleRedirections = async (importedRedirections = [])=>{
        console.log(importedRedirections);
        for(let idx = 0; idx < importedRedirections.length; idx++){
            const r = importedRedirections[idx];
            const created = await addNewRedirection(null, r.name, r.child?.index, r.keywords, r.forbidden);
        }
    //onSubmit(redirs);
    };
    const moveRedirection = (child, indexDestination)=>{
        [childrenBlocks[child.index], childrenBlocks[indexDestination]] = [
            childrenBlocks[indexDestination],
            childrenBlocks[child.index]
        ] // swapping element
        ;
        childrenBlocks = childrenBlocks.map((childBlock, idx)=>{
            return {
                ...childBlock,
                index: idx
            };
        });
        [redirections[child.index - 1], redirections[indexDestination - 1]] = [
            redirections[indexDestination - 1],
            redirections[child.index - 1]
        ] // swapping element
        ;
        redirections = redirections.map((redirection, idx)=>{
            return {
                ...redirection,
                child: {
                    ...redirection.child,
                    index: idx + 1
                }
            };
        });
        dispatch({
            type: "updateBlockData",
            payload: {
                id: id,
                data: {
                    redirections: [
                        ...redirections
                    ]
                }
            }
        });
        setValue(`redirections`, [
            ...redirections
        ]);
        const childrenBlocksServer = [
            childrenBlocks[child.index],
            childrenBlocks[indexDestination]
        ];
        dispatch({
            type: "updateBlockChildren",
            payload: {
                block_id: id,
                children: childrenBlocks
            }
        });
        //console.log(childrenBlocksServer);
        updateBlockChildren(id, childrenBlocksServer);
    };
    const deleteRedirection = async (child)=>{
        const { index: index, object_id: object_id } = child;
        var dataRedirections = getValues("redirections");
        dataRedirections = Object.values(dataRedirections).filter((redirection)=>redirection.child.index !== index).map((redirection, idx)=>{
            return {
                ...redirection,
                index: (idx + 1).toString()
            };
        });
        let newChildren = childrenBlocks.filter((childBlock)=>childBlock.index != index && childBlock.index != 0).map((childBlock, idx)=>{
            return {
                ...childBlock,
                index: (idx + 1).toString()
            };
        });
        dispatch({
            type: "deleteBlockChildAndOrderOther",
            payload: {
                block_id: id,
                object_id: object_id
            }
        });
        deleteBlockChild(id, object_id);
        updateBlockChildren(id, newChildren);
        setValue("redirections", dataRedirections); // Update state form
        dispatch({
            type: "updateBlockData",
            payload: {
                id: id,
                data: {
                    redirections: redirections.filter((redirection)=>redirection.child.index !== index)
                }
            }
        });
        onSubmit(getValues());
    };
    const functionRedirection = {
        setValue: setValueForm,
        deleteValue: deleteRedirection,
        move: moveRedirection
    };
    const { formState: { errors: errors }, formState: formState, getValues: getValues, setValue: setValue, watch: watch } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: {
            redirections: redirections,
            variable: variable,
            variable_redirect: variable_redirect
        }
    });
    const transformBlockName = (data)=>{
        if (data.variable == null || (0, $8afcac884e38448f$export$297f0ad075d10a0e).name != name && /^Redirection on \[/.test(name) == false) return data;
        data.name = `Redirection on [${data.variable.name.toUpperCase()}]`;
        return data;
    };
    const exportBlock = ()=>{
        if (data.redirections.length <= 0) {
            console.log("No redirections to export");
            return;
        }
        const exportData = {
            variable: data.variable,
            variable_redirect: data.variable_redirect,
            redirections: redirections
        };
        const json = JSON.stringify(exportData, null, 2);
        // dl le json
        const blob = new Blob([
            json
        ], {
            type: "application/json"
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "redirections.json";
        a.click();
    };
    const importBlock = ()=>{
        if (redirections.length > 0) {
            console.log("Can not import data because there is already some data into the block");
            return;
        }
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $e882427779c37e3e$export$2e2bcd8739ae039), {
            nameDataset: name
        }).then(async (data)=>{
            if (!data.redirections || data.redirections.length === 0) return;
            await addMultipleRedirections(data.redirections);
        /* marche pas avec le add redirections
                if (data.variable) {
                    setValueDropdown("variable",data.variable, false)
                }
                
                if (data.variable_redirect) { 
                    setValueDropdown("variable",data.variable_redirect, false)
                }
                    */ });
    };
    const onSubmit = (data)=>{
        data = transformBlockName(data);
        data.redirections = data.redirections.map((redirection)=>{
            return {
                name: redirection.name,
                keywords: redirection.keywords,
                forbidden: redirection.forbidden
            };
        }).filter((redirection)=>redirection);
        // Form to send to the server, the block state properties in the tree are diff
        const dataServer = {
            redirections: data.redirections,
            keyword_var: data.variable ? data.variable.name : null,
            keyword_redirect_var: data.variable_redirect ? data.variable_redirect.name : null
        };
        if (data.name) dataServer.name = data.name;
        updateBlockData(id, data, dataServer);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $841d23f226ffdc19$export$2e2bcd8739ae039), {
                title: "Redirection",
                titleInput: "Redirection name",
                name: name,
                id: id
            }),
            redirections.length <= 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                className: "fas fa-download icon_import",
                style: {
                    cursor: "pointer"
                },
                "aria-hidden": "true",
                onClick: ()=>importBlock()
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                className: "fas fa-upload icon_export",
                style: {
                    cursor: "pointer"
                },
                "aria-hidden": "true",
                onClick: ()=>exportBlock()
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "area-edit",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: " From : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dropdown_container",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fe74f3a5194e12fa$export$2e2bcd8739ae039), {
                                    variable: watch("variable"),
                                    name: "variable",
                                    setValue: setValueDropdown
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Save result in : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dropdown_container",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fe74f3a5194e12fa$export$2e2bcd8739ae039), {
                                    variable: variable_redirect,
                                    name: "variable_redirect",
                                    setValue: setValueDropdown
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5b4dd497c4ab826c$export$2e2bcd8739ae039), {
                        title: "Redirections",
                        maxHeight: "430px",
                        buttonLabel: "Add a Redirection",
                        onClickButton: (arg)=>addNewRedirection(...arg),
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0c7211c3be597575$export$2e2bcd8739ae039), {
                            data: redirections,
                            ComponentRow: (0, $c4358e0aacc3c73d$export$2e2bcd8739ae039),
                            FunctionsRow: functionRedirection,
                            componentKey: "child.object_id"
                        })
                    })
                ]
            })
        ]
    });
}
var $f5489e265e530650$export$2e2bcd8739ae039 = $f5489e265e530650$var$FormActionRedirection;













var $bh6RR = parcelRequire("bh6RR");


const $a4637d131b8f5d44$export$a7bad04accb0972a = [
    {
        value: "deepgram",
        text: "Deepgram"
    },
    {
        value: "google",
        text: "Google"
    },
    {
        value: "uhlive",
        text: "UHLive"
    },
    {
        value: "gladia",
        text: "Gladia"
    }
];
const $a4637d131b8f5d44$export$fa777c6c33bdafa6 = {
    deepgram: [
        {
            key: "language",
            label: "Language",
            type: "text",
            default: "fr"
        },
        {
            key: "model",
            label: "Model",
            type: "dropdown",
            options: [
                "nova-2",
                "nova-2-general",
                "nova-2-phonecall",
                "nova-2-finance",
                "nova-2-medical",
                "nova-2-meeting"
            ],
            default: "nova-2"
        }
    ],
    google: [
        {
            key: "language",
            label: "Language",
            type: "text",
            default: "fr-FR"
        },
        {
            key: "model",
            label: "Model",
            type: "dropdown",
            options: [
                "latest_long",
                "latest_short",
                "phone_call",
                "telephony",
                "telephony_short",
                "medical_dictation",
                "medical_conversation"
            ],
            default: "latest_short"
        }
    ],
    uhlive: [
        {
            key: "language",
            label: "Language",
            type: "text",
            default: "fr-FR"
        },
        {
            key: "builtin",
            label: "Builtin",
            type: "text",
            default: "speech/transcribe"
        },
        {
            key: "speech_complete_timeout",
            label: "Speech Complete Timeout (ms)",
            type: "number",
            default: 1000
        },
        {
            key: "no_input_timeout",
            label: "No Input Timeout (ms)",
            type: "number",
            default: 5300
        },
        {
            key: "speech_incomplete_timeout",
            label: "Speech Incomplete Timeout (ms)",
            type: "number",
            default: 2000
        },
        {
            key: "recognition_timeout",
            label: "Recognition Timeout (ms)",
            type: "number",
            default: 30000
        }
    ],
    gladia: [
        {
            key: "language",
            label: "Language",
            type: "text",
            default: ""
        },
        {
            key: "model",
            label: "Model",
            type: "dropdown",
            options: [
                "solaria-1"
            ],
            default: "solaria-1"
        },
        {
            key: "endpointing",
            label: "Endpointing (0-1)",
            type: "number",
            default: ""
        },
        {
            key: "maximum_duration_without_endpointing",
            label: "Max Duration Without Endpointing (s)",
            type: "number",
            default: ""
        },
        {
            key: "speech_threshold",
            label: "Speech Threshold (0-1)",
            type: "number",
            default: ""
        },
        {
            key: "api_key",
            label: "API Key",
            type: "text",
            default: ""
        }
    ]
};


function $0770998c34e5522b$var$SttConfig({ value: value, onChange: onChange }) {
    const parseValue = (val)=>{
        if (!val) return {
            vendor: (0, $a4637d131b8f5d44$export$a7bad04accb0972a)[0].value
        };
        try {
            return typeof val === "string" ? JSON.parse(val) : val;
        } catch  {
            return {
                vendor: (0, $a4637d131b8f5d44$export$a7bad04accb0972a)[0].value
            };
        }
    };
    const [config, setConfig] = (0, $bh6RR.useState)(()=>parseValue(value));
    const updateConfig = (newConfig)=>{
        setConfig(newConfig);
        onChange(JSON.stringify(newConfig));
    };
    const onVendorChange = (_, vendor)=>{
        const params = (0, $a4637d131b8f5d44$export$fa777c6c33bdafa6)[vendor] || [];
        const defaults = params.reduce((acc, param)=>{
            acc[param.key] = param.default;
            return acc;
        }, {});
        updateConfig({
            vendor: vendor,
            ...defaults
        });
    };
    const onParamChange = (key, val)=>{
        updateConfig({
            ...config,
            [key]: val
        });
    };
    const vendor = config.vendor || (0, $a4637d131b8f5d44$export$a7bad04accb0972a)[0].value;
    const params = (0, $a4637d131b8f5d44$export$fa777c6c33bdafa6)[vendor] || [];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "stt-config",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "stt-config-row",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                        className: "stt-config-label",
                        children: "Service"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "stt-config-field",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                            choices: (0, $a4637d131b8f5d44$export$a7bad04accb0972a),
                            defaultChoice: vendor,
                            setValue: onVendorChange,
                            name: "vendor",
                            width: "240px",
                            hideSelectItem: false
                        })
                    })
                ]
            }),
            params.map((param)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "stt-config-row",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                            className: "stt-config-label",
                            children: param.label
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "stt-config-field",
                            children: param.type === "dropdown" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                choices: param.options.map((o)=>({
                                        value: o,
                                        text: o
                                    })),
                                defaultChoice: config[param.key] !== undefined ? config[param.key] : param.default,
                                setValue: (_, val)=>onParamChange(param.key, val),
                                name: param.key,
                                width: "260px",
                                hideSelectItem: false
                            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                type: param.type === "number" ? "number" : "text",
                                value: config[param.key] !== undefined ? config[param.key] : param.default,
                                onChange: (e)=>onParamChange(param.key, param.type === "number" ? Number(e.target.value) : e.target.value),
                                className: "stt-config-input",
                                placeholder: param.label
                            })
                        })
                    ]
                }, param.key))
        ]
    });
}
var $0770998c34e5522b$export$2e2bcd8739ae039 = $0770998c34e5522b$var$SttConfig;





var $bh6RR = parcelRequire("bh6RR");


const $12e280157407a530$export$e4d5f8e9c0d22723 = [
    {
        value: "google",
        text: "Google"
    },
    {
        value: "deepgram",
        text: "Deepgram"
    },
    {
        value: "cartesia",
        text: "Cartesia"
    },
    {
        value: "elevenlabs",
        text: "ElevenLabs"
    },
    {
        value: "gradium",
        text: "Gradium"
    }
];
const $12e280157407a530$export$906943a4bc58d436 = {
    google: [
        {
            key: "language",
            label: "Language",
            type: "text",
            default: "fr-FR"
        },
        {
            key: "voice",
            label: "Voice",
            type: "text",
            default: "fr-FR-Standard-A"
        }
    ],
    deepgram: [
        {
            key: "voice",
            label: "Voice",
            type: "text",
            default: ""
        },
        {
            key: "api_key",
            label: "API Key",
            type: "text",
            default: ""
        },
        {
            key: "stream",
            label: "Stream",
            type: "dropdown",
            options: [
                "false",
                "true"
            ],
            default: "false"
        },
        {
            key: "label",
            label: "Label",
            type: "text",
            default: "custom"
        }
    ],
    cartesia: [
        {
            key: "voiceId",
            label: "Voice ID",
            type: "text",
            default: ""
        },
        {
            key: "model",
            label: "Model",
            type: "dropdown",
            options: [
                "sonic",
                "sonic-preview",
                "sonic-multilingual",
                "sonic-3",
                "sonic-turbo"
            ],
            default: "sonic-multilingual"
        },
        {
            key: "api_key",
            label: "API Key",
            type: "text",
            default: ""
        },
        {
            key: "speed",
            label: "Speed (0.6-1.5)",
            type: "number",
            default: 1.0
        },
        {
            key: "volume",
            label: "Volume (0.5-2.0)",
            type: "number",
            default: 1.25
        },
        {
            key: "emotion",
            label: "Emotion",
            type: "text",
            default: "neutral"
        },
        {
            key: "language",
            label: "Language",
            type: "text",
            default: ""
        },
        {
            key: "stream",
            label: "Stream",
            type: "dropdown",
            options: [
                "false",
                "true"
            ],
            default: "false"
        },
        {
            key: "label",
            label: "Label",
            type: "text",
            default: "custom"
        },
        {
            key: "pronunciationDictId",
            label: "Pronunciation Dict ID",
            type: "text",
            default: ""
        }
    ],
    gradium: [
        {
            key: "voiceId",
            label: "Voice ID",
            type: "text",
            default: ""
        },
        {
            key: "model",
            label: "Model",
            type: "text",
            default: "default"
        },
        {
            key: "api_key",
            label: "API Key",
            type: "text",
            default: ""
        },
        {
            key: "paddingBonus",
            label: "Speed (-4.0 faster \u2192 +4.0 slower)",
            type: "number",
            default: 0.0
        },
        {
            key: "temp",
            label: "Temperature (0.0-1.4)",
            type: "number",
            default: 0.7
        },
        {
            key: "cfgCoef",
            label: "CFG Coef (1.0-4.0)",
            type: "number",
            default: 2.0
        },
        {
            key: "language",
            label: "Language (fr/en/de/es/pt)",
            type: "text",
            default: ""
        },
        {
            key: "stream",
            label: "Stream",
            type: "dropdown",
            options: [
                "false",
                "true"
            ],
            default: "false"
        },
        {
            key: "label",
            label: "Label",
            type: "text",
            default: "custom"
        },
        {
            key: "pronunciationId",
            label: "Pronunciation Dict ID",
            type: "text",
            default: ""
        }
    ],
    elevenlabs: [
        {
            key: "voice",
            label: "Voice ID",
            type: "text",
            default: ""
        },
        {
            key: "model_id",
            label: "Model",
            type: "dropdown",
            options: [
                "eleven_turbo_v2",
                "eleven_multilingual_v2",
                "eleven_flash_v2_5"
            ],
            default: "eleven_turbo_v2"
        },
        {
            key: "api_key",
            label: "API Key",
            type: "text",
            default: ""
        },
        {
            key: "similarity_boost",
            label: "Similarity Boost (0-1)",
            type: "number",
            default: 0
        },
        {
            key: "stability",
            label: "Stability (0-1)",
            type: "number",
            default: 0
        },
        {
            key: "style",
            label: "Style (0-1)",
            type: "number",
            default: 0
        },
        {
            key: "use_speaker_boost",
            label: "Use Speaker Boost",
            type: "dropdown",
            options: [
                "false",
                "true"
            ],
            default: "false"
        },
        {
            key: "optimize_streaming_latency",
            label: "Optimize Streaming Latency (0-4)",
            type: "number",
            default: ""
        },
        {
            key: "stream",
            label: "Stream",
            type: "dropdown",
            options: [
                "false",
                "true"
            ],
            default: "false"
        },
        {
            key: "label",
            label: "Label",
            type: "text",
            default: "custom"
        },
        {
            key: "speed",
            label: "Speed (0.7-1.2)",
            type: "number",
            default: ""
        }
    ]
};


function $dd061a4d4e460c68$var$TtsConfig({ value: value, onChange: onChange }) {
    const parseValue = (val)=>{
        if (!val) return {
            vendor: (0, $12e280157407a530$export$e4d5f8e9c0d22723)[0].value
        };
        try {
            return typeof val === "string" ? JSON.parse(val) : val;
        } catch  {
            return {
                vendor: (0, $12e280157407a530$export$e4d5f8e9c0d22723)[0].value
            };
        }
    };
    const [config, setConfig] = (0, $bh6RR.useState)(()=>parseValue(value));
    const updateConfig = (newConfig)=>{
        setConfig(newConfig);
        onChange(JSON.stringify(newConfig));
    };
    const onVendorChange = (_, vendor)=>{
        const params = (0, $12e280157407a530$export$906943a4bc58d436)[vendor] || [];
        const defaults = params.reduce((acc, param)=>{
            acc[param.key] = param.default;
            return acc;
        }, {});
        updateConfig({
            vendor: vendor,
            ...defaults
        });
    };
    const onParamChange = (key, val)=>{
        updateConfig({
            ...config,
            [key]: val
        });
    };
    const vendor = config.vendor || (0, $12e280157407a530$export$e4d5f8e9c0d22723)[0].value;
    const params = (0, $12e280157407a530$export$906943a4bc58d436)[vendor] || [];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "tts-config",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "tts-config-row",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                        className: "tts-config-label",
                        children: "Service"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "tts-config-field",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                            choices: (0, $12e280157407a530$export$e4d5f8e9c0d22723),
                            defaultChoice: vendor,
                            setValue: onVendorChange,
                            name: "vendor",
                            width: "250px",
                            hideSelectItem: false
                        })
                    })
                ]
            }),
            params.map((param)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "tts-config-row",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                            className: "tts-config-label",
                            children: param.label
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "tts-config-field",
                            children: param.type === "dropdown" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                choices: param.options.map((o)=>({
                                        value: o,
                                        text: o
                                    })),
                                defaultChoice: config[param.key] !== undefined ? config[param.key] : param.default,
                                setValue: (_, val)=>onParamChange(param.key, val),
                                name: param.key,
                                width: "250px",
                                hideSelectItem: false
                            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                type: param.type === "number" ? "number" : "text",
                                value: config[param.key] !== undefined ? config[param.key] : param.default,
                                onChange: (e)=>onParamChange(param.key, param.type === "number" ? Number(e.target.value) : e.target.value),
                                className: "tts-config-input",
                                placeholder: param.label
                            })
                        })
                    ]
                }, param.key))
        ]
    });
}
var $dd061a4d4e460c68$export$2e2bcd8739ae039 = $dd061a4d4e460c68$var$TtsConfig;



var $bh6RR = parcelRequire("bh6RR");
function $4d3c1cce41e91e7a$var$VariableBlock({ block_id: block_id, first: first, id: id, idx: idx, index: index, is_operation: is_operation, value: value, variable: variable, setValue: setValue, deleteValue: deleteValue, errors: errors, setValueState: setValueState, isOpen: isOpen, move: move }) {
    const [open, setOpen] = (0, $bh6RR.useState)(isOpen && value == "" && variable == null && is_operation == false);
    const [currentHeight, setCurrentHeight] = (0, $bh6RR.useState)(0);
    const [variableValue, setVariableValue] = (0, $bh6RR.useState)(value);
    const [currentVariable, setCurrentVariable] = (0, $bh6RR.useState)(variable);
    const refEditArea = (0, $bh6RR.useRef)();
    const [isHover, setIsHover] = (0, $bh6RR.useState)(false);
    const error = errors.filter((error)=>error[1].index == index).pop();
    const indexNumber = parseInt(index, 10);
    const getHeight = ()=>{
        const el = document.getElementsByClassName("measuring").item(index);
        return el ? el.clientHeight : 0;
    };
    const onToggle = ()=>{
        setOpen((prevOpen)=>{
            let newOpen = !prevOpen;
            setCurrentHeight(newOpen ? getHeight() : 0);
            return newOpen;
        });
        if (!open == false) setCurrentHeight(0);
        else setCurrentHeight(getHeight());
    };
    const onHeightChange = ()=>{
        if (currentHeight == 0) return 0;
        setCurrentHeight(getHeight());
    };
    const disableSpellCheck = (ref)=>{
        if (!ref) return;
        ref.spellcheck = false;
    };
    const setValueVariable = (name, value)=>{
        if (name === "variable") setCurrentVariable(value);
        setValue(index, name, value);
    };
    const setValueCurrentStateAndTreeState = (name, value)=>{
        setValueState(index, name, value);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (open == false) return;
        const newHeight = getHeight() + (error ? 14 : 0);
        if (newHeight !== currentHeight) setCurrentHeight(newHeight);
    }, [
        error,
        open
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (refEditArea == null) return;
        if (first) {
            setOpen(true);
            setCurrentHeight(getHeight());
        }
        return ()=>{};
    }, [
        refEditArea
    ]);
    const classNameDropdown = open ? "variables-contain" : "variables-contain disabled";
    var classNameInput = "input editor-input title_input";
    classNameInput = error ? classNameInput + " error" : classNameInput;
    const isSttVariable = currentVariable?.type?.name === "stt";
    const isTtsVariable = currentVariable?.type?.name === "tts";
    const isSpecialVariable = isSttVariable || isTtsVariable;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "variable_block",
                onMouseEnter: ()=>setIsHover(true),
                onMouseLeave: ()=>setIsHover(false),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        style: {
                            width: "250px"
                        },
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fe74f3a5194e12fa$export$2e2bcd8739ae039), {
                            className: classNameDropdown,
                            variable: currentVariable,
                            setValue: setValueVariable,
                            name: "variable",
                            width: "250px"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "actions",
                        children: [
                            isHover && idx != 0 && first != true && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                onClick: ()=>move(indexNumber, indexNumber - 1),
                                className: "editor-iconButton main_add-button button_center profil_action",
                                icon: "fas fa-chevron-up"
                            }),
                            isHover && idx != -1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                onClick: ()=>move(indexNumber, indexNumber + 1),
                                className: "editor-iconButton main_add-button button_center profil_action",
                                icon: "fas fa-chevron-down"
                            }),
                            !isSpecialVariable && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                onClick: onToggle,
                                className: "editor-iconButton main_add-button button_center edit_action",
                                icon: "fas fa-edit"
                            }),
                            (idx == 0 && parseInt(index, 10) == 0 || first == false) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                className: "editor-iconButton main_add-button button_center delete_action",
                                icon: "fas fa-trash",
                                onClick: ()=>deleteValue(index)
                            })
                        ]
                    })
                ]
            }),
            isSttVariable ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0770998c34e5522b$export$2e2bcd8739ae039), {
                value: value,
                onChange: (jsonStr)=>setValueVariable("value", jsonStr)
            }) : isTtsVariable ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $dd061a4d4e460c68$export$2e2bcd8739ae039), {
                value: value,
                onChange: (jsonStr)=>setValueVariable("value", jsonStr)
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: open ? "variable_zone_edit show" : "variable_zone_edit",
                ref: refEditArea,
                style: {
                    height: currentHeight
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "measuring",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            style: {
                                margin: "0 12px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                    className: "dropdown_title",
                                    style: {
                                        marginRight: "10px"
                                    },
                                    children: "Calcul Operation : "
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $52b728934d836302$export$2e2bcd8739ae039), {
                                    id: `is_operation_${index}`,
                                    name: "is_operation",
                                    check: is_operation,
                                    setValue: setValueVariable
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "container-textarea",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8f57823a2bb4f964$export$2e2bcd8739ae039), {
                                    ref: (ref)=>disableSpellCheck(ref),
                                    value: value,
                                    onBlur: ()=>setValueVariable("value", value),
                                    onChange: (e)=>setValueCurrentStateAndTreeState("value", e.target.value),
                                    onHeightChange: onHeightChange,
                                    className: classNameInput,
                                    placeholder: "Enter a value",
                                    minRows: 3
                                }),
                                error ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "error",
                                    children: error[1].data
                                }) : ""
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
$4d3c1cce41e91e7a$var$VariableBlock.defaultProps = {
    isOpen: false
};
var $4d3c1cce41e91e7a$export$2e2bcd8739ae039 = $4d3c1cce41e91e7a$var$VariableBlock;


parcelRequire("bh6RR");









function $b3fdbc0dd1bd54f3$var$FormActionVariable({ id: id }) {
    const { blocks: blocks, paths: paths } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const dispatch = (0, $6949a38b8f965998$export$649a5cfe816ce921)();
    const indexBlock = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, id, "object_id");
    const block = blocks[indexBlock] ? blocks[indexBlock] : (0, $7e81ffa10385ceec$export$d2a48b0d6f4a3aab);
    const { data: data } = block;
    const name = block.name;
    const { checkErrorBlock: checkErrorBlock } = (0, $e243ee0cadf02534$export$2e2bcd8739ae039)();
    const variables = data.variables;
    const { updateBlockData: updateBlockData } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const setValueForm = (index, name, value)=>{
        setValue(`variables.${index}.${name}`, value);
        onSubmit(getValues());
    };
    const addNewVariable = (scroll)=>{
        const length = variables.length;
        const variable = {
            value: "",
            is_operation: 0,
            index: length.toString(),
            variable: null,
            isOpen: true
        };
        setValue(`variables.${length}`, variable);
        onSubmit(getValues());
        scroll();
    };
    const deleteVariable = (index)=>{
        var data = getValues("variables");
        data = Object.values(data).filter((variable)=>variable.index !== index).map((variable, idx)=>{
            return {
                ...variable,
                index: idx.toString()
            };
        });
        setValue("variables", data);
        onSubmit(getValues());
    };
    const moveVariable = (indexStart, indexDestination)=>{
        var data = getValues("variables");
        [data[indexStart], data[indexDestination]] = [
            data[indexDestination],
            data[indexStart]
        ] // swapping element
        ;
        data = Object.values(data).map((variable, idx)=>{
            return {
                ...variable,
                index: idx.toString()
            };
        });
        setValue("variables", data);
        onSubmit(getValues());
    };
    const errors = checkErrorBlock(block, {
        blocks: blocks,
        paths: paths
    });
    var errorRaw = Object.entries(errors).filter(([key, value])=>value.type == "Wrong Spelling");
    const setValueState = (index, name, value)=>{
        setValue(`variables.${index}.${name}`, value);
        const data = getValues();
        dispatch({
            type: "updateBlockData",
            payload: {
                id: id,
                data: data
            }
        });
    };
    const functionVariable = {
        setValueState: setValueState,
        setValue: setValueForm,
        deleteValue: deleteVariable,
        move: moveVariable,
        errors: errorRaw
    };
    const { getValues: getValues, setValue: setValue } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: {
            variables: variables
        }
    });
    const transformBlockName = (data)=>{
        if (data.variables[0].variable == null || /variable/.test(name) == false) return data;
        data.name = `Set variable [${data.variables[0].variable.name.toUpperCase()}]`;
        console.log(data);
        return data;
    };
    const onSubmit = (data)=>{
        data = transformBlockName(data);
        const dataServer = {
            variables: data.variables.map((variable, index)=>{
                return {
                    variable_value: variable.value,
                    is_operation: variable.is_operation,
                    index: variable.index.toString(),
                    variable_name: variable.variable == null ? null : variable.variable.name
                };
            })
        };
        if (data.name) dataServer.name = data.name;
        updateBlockData(id, data, dataServer);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $841d23f226ffdc19$export$2e2bcd8739ae039), {
                title: "Set Variables",
                titleInput: "Variables name",
                name: name,
                id: id
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5b4dd497c4ab826c$export$2e2bcd8739ae039), {
                title: "Variables",
                maxHeight: "550px",
                onClickButton: (func)=>addNewVariable(...func),
                buttonLabel: "Add a Variable",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0c7211c3be597575$export$2e2bcd8739ae039), {
                    data: variables,
                    ComponentRow: (0, $4d3c1cce41e91e7a$export$2e2bcd8739ae039),
                    FunctionsRow: functionVariable
                })
            })
        ]
    });
}
var $b3fdbc0dd1bd54f3$export$2e2bcd8739ae039 = $b3fdbc0dd1bd54f3$var$FormActionVariable;










var $bh6RR = parcelRequire("bh6RR");





function $586584d37f69bf19$var$FormJump({ id: id }) {
    const { variables: variables } = (0, $7ef7d0b863ac05b4$export$248471b8219beb2f)();
    const cleanInput = (val)=>val.replace(/\[/g, "").replace(/\]/g, "");
    const isVariableFind = (val)=>{
        if (!val) return false;
        let hasBrackets = val.startsWith("[") && val.endsWith("]");
        val = cleanInput(val);
        return variables.filter((variable)=>variable.name == val.toLowerCase()).length > 0 && hasBrackets;
    };
    const { blocks: blocks } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const indexBlock = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, id, "object_id");
    const block = blocks[indexBlock] ? blocks[indexBlock] : (0, $492b1fcbc956f8e2$export$d17d9d351aa7d20f);
    const { data: data } = block;
    const name = block.name;
    const scenarios = blocks.filter((block)=>block.type && block.type.name == "scenario").map((block)=>{
        return {
            id: block.id,
            value: block.object_id,
            text: block.name
        };
    });
    scenarios.sort((a, b)=>a.text.localeCompare(b.text)) // sort in ascending order
    ;
    const { updateBlockDataJump: updateBlockDataJump } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const [title, setTitle] = (0, $bh6RR.useState)(name);
    const subProps = {};
    let scenario = null;
    if (data.jump_id) scenario = scenarios.filter((scenario)=>scenario.id == data.jump_id.id).pop();
    scenario ? subProps.defaultChoice = scenario.value : subProps.placeholder = "Select a scenario";
    const { register: register, handleSubmit: handleSubmit, watch: watch, formState: { errors: errors }, formState: formState, getValues: getValues, setValue: setValue } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: {
            scenario: subProps.defaultChoice || null,
            is_constant: data.is_constant,
            variable_value: data.variable_value
        }
    });
    const setDropdown = (name, value)=>{
        setValue(name, value);
        onSubmit(getValues());
    };
    const onSubmit = (form)=>{
        const scenario = blocks.filter((block)=>block.object_id == form.scenario).pop();
        //const titleBlock = /^Jump to /.test(name) ? "Jump to " + scenario.name : name;  
        const titleBlock = scenario ? scenario.name : "Jump to ..."; // pour retirer le jump to quand il y a deja une valeur
        setTitle(titleBlock);
        updateBlockDataJump(id, titleBlock, scenario, data.block_id, form.is_constant, form.variable_value);
        return;
    };
    const onBlur = (e)=>{
        onSubmit(getValues());
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $841d23f226ffdc19$export$2e2bcd8739ae039), {
                title: "Jump",
                titleInput: "Jump's name",
                name: title,
                id: id
            }, title),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("form", {
                className: "area-edit",
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "jump_constant_redirection_container",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "input_title",
                                children: "Constant redirection"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                name: "Resume",
                                onChange: ()=>{
                                    setValue("is_constant", !getValues("is_constant")), onBlur();
                                },
                                checked: getValues("is_constant")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                        className: "input_title",
                        children: "Jump to Scenario"
                    }),
                    watch("is_constant") == true ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                        ...register("scenario"),
                        setValue: setDropdown,
                        choices: scenarios,
                        width: "calc(100%)",
                        ...subProps
                    }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "area-edit",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0db11626bd290ec1$export$2e2bcd8739ae039), {
                                className: "input resize-area jump_variable_value_input " + (isVariableFind(getValues("variable_value")) ? "variables_found_jump_content" : ""),
                                ...register("variable_value"),
                                onBlur: onBlur,
                                placeholder: "Please, enter a block id or a variable which contains a block id"
                            })
                        })
                    })
                ]
            })
        ]
    });
}
var $586584d37f69bf19$export$2e2bcd8739ae039 = $586584d37f69bf19$var$FormJump;










function $4a6dceb14d8cbb91$var$FormScenario({ id: id }) {
    const { blocks: blocks } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const { updateBlocksName: updateBlocksName } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const indexBlock = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, id, "object_id");
    const block = blocks[indexBlock] ? blocks[indexBlock] : (0, $9b899c7285d67a03$export$c9a586d4bcb99658);
    const name = block.name;
    const { register: register, setError: setError, clearErrors: clearErrors, handleSubmit: handleSubmit, control: control, formState: { errors: errors }, formState: formState, getValues: getValues, setValue: setValue } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: {
            title: name
        }
    });
    const updateBlocksJumpLinkToScenario = (value)=>{
        const blocksToUpdate = blocks.filter((block)=>block.type.name == "magic" && block.name == `Jump to ${name}`).map((block)=>{
            return {
                ...block,
                name: `Jump to ${value}`
            };
        });
        if (blocksToUpdate.length == 0) return;
        updateBlocksName(blocksToUpdate);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $841d23f226ffdc19$export$2e2bcd8739ae039), {
            title: "Scenario",
            titleInput: "Scenario name",
            name: name,
            id: id,
            callback: updateBlocksJumpLinkToScenario
        })
    });
}
var $4a6dceb14d8cbb91$export$2e2bcd8739ae039 = $4a6dceb14d8cbb91$var$FormScenario;













const $a1ae2e94b376d5cc$var$StatementMessageType = [
    {
        value: "text",
        text: "Text"
    },
    {
        value: "raw",
        text: "Raw Message"
    }
];
var $a1ae2e94b376d5cc$export$2e2bcd8739ae039 = $a1ae2e94b376d5cc$var$StatementMessageType;





var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");
const $c4ae2d974714023d$var$useSpeechSynthesis = ()=>{
    const [voices, setVoices] = (0, $bh6RR.useState)([]);
    const [speaking, setSpeaking] = (0, $bh6RR.useState)(false);
    const synth = (0, $bh6RR.useRef)();
    const updateVoices = ()=>{
        setVoices(synth.current.getVoices());
    };
    const speak = (text, voice, pitch = 1, rate = 1)=>{
        const utterance = new SpeechSynthesisUtterance(text);
        utterance.voice = voice;
        utterance.pitch = pitch;
        utterance.rate = rate;
        utterance.onstart = ()=>{
            setSpeaking(true);
        };
        utterance.onend = ()=>{
            setSpeaking(false);
        };
        synth.current.speak(utterance);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (typeof window !== "object" || !window.speechSynthesis) return;
        synth.current = window.speechSynthesis;
        synth.current.onvoiceschanged = updateVoices;
        updateVoices();
        return ()=>{
            synth.current.onvoiceschanged = null;
        };
    }, []);
    return [
        voices,
        speak,
        speaking
    ];
};
var $c4ae2d974714023d$export$2e2bcd8739ae039 = $c4ae2d974714023d$var$useSpeechSynthesis;



var $bh6RR = parcelRequire("bh6RR");
function $258fdbd10bf60820$var$useSpeechToText() {
    const [listening, setListening] = (0, $bh6RR.useState)(false);
    const [recognition, setRecognition] = (0, $bh6RR.useState)(null);
    const [transcript, setTranscript] = (0, $bh6RR.useState)("");
    const [transcriptHistory, setTranscriptHistory] = (0, $bh6RR.useState)([]);
    (0, $bh6RR.useEffect)(()=>{
        function initializeRecognition() {
            if ("SpeechRecognition" in window || "webkitSpeechRecognition" in window) {
                const newRecognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
                newRecognition.continuous = true;
                newRecognition.onstart = ()=>{
                    setListening(true);
                };
                newRecognition.onresult = (event)=>{
                    const last = event.results.length - 1;
                    const text = event.results[last][0].transcript;
                    // Ajouter le texte au texte actuel
                    setTranscript((prevTranscript)=>prevTranscript + " " + text);
                    // Ajouter le texte au tableau de l'historique
                    setTranscriptHistory((prevHistory)=>[
                            ...prevHistory,
                            text
                        ]);
                };
                setRecognition(newRecognition);
            } else console.log("Speech recognition is not supported in this browser.");
        }
        initializeRecognition();
        return ()=>{
            if (recognition) {
                recognition.stop();
                setListening(false);
            }
        };
    }, []);
    const toggleListening = ()=>{
        if (recognition) {
            if (listening) {
                recognition.stop();
                setListening(false);
            } else {
                recognition.start();
                setTranscript("");
            }
        } else console.log("Speech recognition is not supported in this browser.");
    };
    return {
        transcript: transcript,
        transcriptHistory: transcriptHistory,
        listening: listening,
        toggleListening: toggleListening
    };
}
var $258fdbd10bf60820$export$2e2bcd8739ae039 = $258fdbd10bf60820$var$useSpeechToText;



parcelRequire("bh6RR");
const $4fa58e987efec9c8$var$SvgSoundMax = (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "sound-max_svg__icon sound-max_svg__glyph",
        ...props,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M18.36 19.36a1 1 0 0 1-.7-.29 1 1 0 0 1 0-1.41 8 8 0 0 0 0-11.32 1 1 0 0 1 1.41-1.41 10 10 0 0 1 0 14.14 1 1 0 0 1-.71.29Z",
                style: {
                    fill: "#231f20"
                }
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M15.54 16.54a1 1 0 0 1-.71-.3 1 1 0 0 1 0-1.41 4 4 0 0 0 0-5.66 1 1 0 0 1 1.41-1.41 6 6 0 0 1 0 8.48 1 1 0 0 1-.7.3ZM11.38 4.08a1 1 0 0 0-1.09.21L6.59 8H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2.59l3.7 3.71A1 1 0 0 0 11 20a.84.84 0 0 0 .38-.08A1 1 0 0 0 12 19V5a1 1 0 0 0-.62-.92Z",
                style: {
                    fill: "#231f20"
                }
            })
        ]
    });
var $4fa58e987efec9c8$export$2e2bcd8739ae039 = $4fa58e987efec9c8$var$SvgSoundMax;



parcelRequire("bh6RR");
const $d398ff6b2c8af5d2$var$SvgSoundMute = (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "sound-mute_svg__icon sound-mute_svg__glyph",
        ...props,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M11.38 4.08a1 1 0 0 0-1.09.21L6.59 8H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2.59l3.7 3.71A1 1 0 0 0 11 20a.84.84 0 0 0 .38-.08A1 1 0 0 0 12 19V5a1 1 0 0 0-.62-.92ZM16 15.5a1 1 0 0 1-.71-.29 1 1 0 0 1 0-1.42l5-5a1 1 0 0 1 1.42 1.42l-5 5a1 1 0 0 1-.71.29Z",
                style: {
                    fill: "#231f20"
                }
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M21 15.5a1 1 0 0 1-.71-.29l-5-5a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 0 1.42 1 1 0 0 1-.71.29Z",
                style: {
                    fill: "#231f20"
                }
            })
        ]
    });
var $d398ff6b2c8af5d2$export$2e2bcd8739ae039 = $d398ff6b2c8af5d2$var$SvgSoundMute;



parcelRequire("bh6RR");
const $de4ad16a24e4aa0a$var$SvgMicrophoneSoundOn = (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 256 256",
        xmlSpace: "preserve",
        ...props,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
            style: {
                stroke: "none",
                strokeWidth: 0,
                strokeDasharray: "none",
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 10,
                fill: "none",
                fillRule: "nonzero",
                opacity: 1
            },
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M45 0c-8.481 0-15.382 6.9-15.382 15.382v29.044c0 8.482 6.9 15.382 15.382 15.382s15.382-6.9 15.382-15.382V15.382C60.382 6.9 53.481 0 45 0z",
                    style: {
                        stroke: "none",
                        strokeWidth: 1,
                        strokeDasharray: "none",
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 10,
                        fill: "#000",
                        fillRule: "nonzero",
                        opacity: 1
                    },
                    transform: "matrix(2.81 0 0 2.81 1.407 1.407)"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M69.245 38.312a2 2 0 0 0-2 2v6.505c0 12.266-9.979 22.244-22.245 22.244s-22.245-9.979-22.245-22.244v-6.505a2 2 0 0 0-4 0v6.505c0 13.797 10.705 25.134 24.245 26.16V86h-9.126a2 2 0 0 0 0 4h22.252a2 2 0 0 0 0-4H47V72.978c13.54-1.026 24.245-12.363 24.245-26.16v-6.505a2 2 0 0 0-2-2.001z",
                    style: {
                        stroke: "none",
                        strokeWidth: 1,
                        strokeDasharray: "none",
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 10,
                        fill: "#000",
                        fillRule: "nonzero",
                        opacity: 1
                    },
                    transform: "matrix(2.81 0 0 2.81 1.407 1.407)"
                })
            ]
        })
    });
var $de4ad16a24e4aa0a$export$2e2bcd8739ae039 = $de4ad16a24e4aa0a$var$SvgMicrophoneSoundOn;



parcelRequire("bh6RR");
const $8e56d33b5382bd15$var$SvgMicrophoneSoundOff = (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 256 256",
        xmlSpace: "preserve",
        ...props,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
            style: {
                stroke: "none",
                strokeWidth: 0,
                strokeDasharray: "none",
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 10,
                fill: "none",
                fillRule: "nonzero",
                opacity: 1
            },
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M70.219.253a2.001 2.001 0 0 0-2.721.773l-7.19 12.897C59.57 6.124 52.989 0 45 0c-8.481 0-15.382 6.9-15.382 15.382v29.044c0 5.12 2.497 9.802 6.631 12.652l-4.31 7.732c-5.706-4.159-9.183-10.873-9.183-17.992v-6.505a2 2 0 0 0-4 0v6.505c0 8.562 4.257 16.632 11.221 21.513L19.553 87.026a2 2 0 0 0 3.494 1.948l47.945-86a2 2 0 0 0-.773-2.721zM69.245 38.312a2 2 0 0 0-2 2v6.505c0 12.266-9.979 22.244-22.245 22.244-2.1 0-4.178-.292-6.176-.867a2 2 0 1 0-1.106 3.844c1.721.495 3.491.808 5.283.943V86h-9.126a2 2 0 0 0 0 4h22.252a2 2 0 0 0 0-4H47V72.978c13.54-1.026 24.245-12.363 24.245-26.16v-6.505a2 2 0 0 0-2-2.001z",
                    style: {
                        stroke: "none",
                        strokeWidth: 1,
                        strokeDasharray: "none",
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 10,
                        fill: "#000",
                        fillRule: "nonzero",
                        opacity: 1
                    },
                    transform: "matrix(2.81 0 0 2.81 1.407 1.407)"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M56.382 34.041v10.385c0 6.152-5.002 11.256-11.149 11.379a2 2 0 0 0 .04 4h.041c8.31-.167 15.069-7.065 15.069-15.379V34.041a2 2 0 0 0-4.001 0z",
                    style: {
                        stroke: "none",
                        strokeWidth: 1,
                        strokeDasharray: "none",
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 10,
                        fill: "#000",
                        fillRule: "nonzero",
                        opacity: 1
                    },
                    transform: "matrix(2.81 0 0 2.81 1.407 1.407)"
                })
            ]
        })
    });
var $8e56d33b5382bd15$export$2e2bcd8739ae039 = $8e56d33b5382bd15$var$SvgMicrophoneSoundOff;


function $2b96c81c517f01ac$var$StatementEdition({ type: type, content: content, index: index, onClose: onClose }) {
    const [typeValue, setTypeValue] = (0, $bh6RR.useState)(type ? type : "text");
    const data = {
        text: "",
        raw: ""
    };
    data[typeValue] = content ? content : "";
    const title = content ? "Update Statement" : "Create Statement";
    const [contentValue, setContentValue] = (0, $bh6RR.useState)(data);
    const [isSpeaking, setIsSpeaking] = (0, $bh6RR.useState)(false);
    const [bracketIsMissing, setBracketIsMissing] = (0, $bh6RR.useState)(false);
    const [parenthesisIsMissing, setParenthesisIsMissing] = (0, $bh6RR.useState)(false);
    const [hookIsMissing, setHookIsMissing] = (0, $bh6RR.useState)(false);
    const [voices, speak, speaking] = (0, $c4ae2d974714023d$export$2e2bcd8739ae039)();
    const { transcript: transcript, listening: listening, toggleListening: toggleListening } = (0, $258fdbd10bf60820$export$2e2bcd8739ae039)();
    const setContentValueKey = (key, value)=>{
        setBracketIsMissing(!checkElement("{", "}", value));
        setParenthesisIsMissing(!checkElement("(", ")", value));
        setHookIsMissing(!checkElement("[", "]", value));
        setContentValue({
            ...contentValue,
            [key]: value
        });
    };
    const checkElement = (elementleft, elementRight, value)=>{
        let nbLeftElement = value.split("").filter((letter)=>letter.toLowerCase() == elementleft).length;
        let nbRightElement = value.split("").filter((letter)=>letter.toLowerCase() == elementRight).length;
        return nbLeftElement == nbRightElement;
    };
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const disableSpellCheck = (ref)=>{
        if (!ref) return;
        ref.spellcheck = false;
    };
    const handleClickSpeak = ()=>{
        if (contentValue && contentValue.text !== "") // const voicesFilterByLanguage = voices.filter(voice => voice.lang ==="US");
        // const voice = voicesFilterByLanguage.filter(voice => voice.default).shift() || voicesFilterByLanguage.shift();
        speak(contentValue.text);
    };
    const checkValidation = (value)=>{
        return value.length == 0;
    };
    const onClick = ()=>{
        if (typeValue === "text") {
            setContentValueKey(typeValue, transcript ? transcript : contentValue[typeValue]);
            toggleListening(false);
            modal.resolve({
                index: index,
                data: {
                    type: typeValue,
                    content: transcript ? transcript : contentValue[typeValue]
                }
            });
        } else modal.resolve({
            index: index,
            data: {
                type: typeValue,
                content: contentValue[typeValue]
            }
        });
        return onClose();
    };
    (0, $bh6RR.useEffect)(()=>{
        setIsSpeaking(speaking ? true : false);
    }, [
        speaking
    ]);
    const placeholders = {
        text: "Statement content",
        telephony: "Test Telephony",
        media: "Media url (ex: https://www.images.com/robot.png)",
        slideshow: "Media url (ex: https://www.images.com/robot.png; https://www.images.com/robot1.png)"
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "statement_modal",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                className: "title",
                children: title
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "area-edit",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Type of Statement : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dropdown_container",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                    choices: (0, $a1ae2e94b376d5cc$export$2e2bcd8739ae039),
                                    setValue: (name, value)=>setTypeValue(value),
                                    defaultChoice: typeValue
                                })
                            })
                        ]
                    }),
                    typeValue == "text" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "grid-row",
                            style: {
                                marginLeft: "-15px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                    className: "dropdown_title",
                                    children: "Insert Variable : "
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "dropdown_container variable_container",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fe74f3a5194e12fa$export$2e2bcd8739ae039), {
                                        createVariableDisable: true,
                                        width: "200px",
                                        noChangeOnSelect: true,
                                        setValue: (name, value)=>{
                                            if (value == null) return;
                                            value = "[" + value.name.toUpperCase() + "]";
                                            setContentValueKey(typeValue, contentValue[typeValue].length ? contentValue[typeValue] + " " + value : value);
                                        }
                                    })
                                })
                            ]
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "statement_content",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8f57823a2bb4f964$export$2e2bcd8739ae039), {
                                ref: (ref)=>disableSpellCheck(ref),
                                value: contentValue[typeValue],
                                onChange: (e)=>setContentValueKey(typeValue, e.target.value),
                                style: {
                                    border: bracketIsMissing || parenthesisIsMissing || hookIsMissing ? "2px solid red" : ""
                                },
                                className: "input editor-input title_input",
                                placeholder: placeholders[typeValue],
                                minRows: 4
                            }),
                            type != "raw" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        onClick: handleClickSpeak,
                                        children: isSpeaking ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4fa58e987efec9c8$export$2e2bcd8739ae039), {
                                            className: `speaking-button ${checkValidation(contentValue[typeValue]) ? "disabled-icon" : "enabled-icon"}`
                                        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d398ff6b2c8af5d2$export$2e2bcd8739ae039), {
                                            className: `speaking-button ${checkValidation(contentValue[typeValue]) ? "disabled-icon" : "enabled-icon"}`
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        onClick: toggleListening,
                                        children: listening ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $de4ad16a24e4aa0a$export$2e2bcd8739ae039), {
                                            className: "record-button"
                                        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8e56d33b5382bd15$export$2e2bcd8739ae039), {
                                            className: "record-button"
                                        })
                                    })
                                ]
                            }) : "",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                style: {
                                    marginLeft: "10%",
                                    marginTop: "5px"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    style: {
                                        height: "30px",
                                        color: "var(--pink)"
                                    },
                                    children: [
                                        " ",
                                        bracketIsMissing || parenthesisIsMissing || hookIsMissing ? "An element is missing : [ \xb7 { \xb7 (" : ""
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                label: "Confirm",
                disabled: checkValidation(contentValue[typeValue]) || bracketIsMissing || parenthesisIsMissing || hookIsMissing,
                onClick: onClick
            })
        ]
    });
}
var $2b96c81c517f01ac$export$2e2bcd8739ae039 = $2b96c81c517f01ac$var$StatementEdition;




function $6722a74778d5733f$var$useShowRawInformation(type, data, classname, message) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
        className: classname,
        style: {
            color: "#fd7723"
        },
        children: message
    });
}
var $6722a74778d5733f$export$2e2bcd8739ae039 = $6722a74778d5733f$var$useShowRawInformation;



var $bh6RR = parcelRequire("bh6RR");


function $14a869ea144a7fae$var$AreaBlockStatement(props) {
    const company = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company");
    var className = "bubble";
    if (props.idx == 0) className += " start";
    if (props.idx == -1) className += " end";
    const classNameAvatar = props.first == true ? "pad avatar" : "pad";
    const regex = /\[(.*?)\]/gi;
    const content = props.content.replaceAll(regex, function(match) {
        return "<mark>" + match + "</mark>";
    });
    const editStatement = async (e)=>{
        const result = await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show("editor-popup", {
            Component: (0, $2b96c81c517f01ac$export$2e2bcd8739ae039),
            componentProps: {
                content: props.content,
                index: props.first == true ? 0 : props.idx,
                type: props.type
            }
        });
        const { data: data, index: index } = result;
        props.setValue(index, data);
    };
    const [isHover, setIsHover] = (0, $bh6RR.useState)(false);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "area-block-statement",
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false),
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: classNameAvatar,
                style: props.first == true && company?.logo ? {
                    backgroundImage: `url(${company.logo})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center"
                } : {}
            }),
            props.type == "text" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                className: className,
                dangerouslySetInnerHTML: {
                    __html: $726d757834788151$exports.sanitize(content, {
                        sanitize: true
                    })
                }
            }) : "",
            props.type == "raw" ? (0, $6722a74778d5733f$export$2e2bcd8739ae039)("statement", {}, className, "Raw Message") : "",
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "actions",
                children: [
                    isHover && props.idx != 0 && props.first != true && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                        onClick: ()=>props.move(props.idx, -1),
                        className: "editor-iconButton main_add-button button_center edit_action",
                        icon: "fas fa-chevron-up"
                    }),
                    isHover && props.idx != -1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                        onClick: ()=>props.move(props.idx, 1),
                        className: "editor-iconButton main_add-button button_center edit_action",
                        icon: "fas fa-chevron-down"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                        className: "editor-iconButton main_add-button button_center edit_action",
                        icon: "fas fa-edit",
                        onClick: editStatement
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                        className: "editor-iconButton main_add-button button_center delete_action",
                        icon: "fas fa-trash",
                        onClick: ()=>props.deleteValue(props.first == true ? 0 : props.idx)
                    })
                ]
            })
        ]
    });
}
var $14a869ea144a7fae$export$2e2bcd8739ae039 = $14a869ea144a7fae$var$AreaBlockStatement;








const $034f6f073b0d8b09$var$StatementResponseType = [
    {
        value: "quick",
        text: "Quick response"
    },
    {
        value: "custom",
        text: "Custom response"
    },
    {
        value: "raw",
        text: "Raw response"
    }
];
var $034f6f073b0d8b09$export$2e2bcd8739ae039 = $034f6f073b0d8b09$var$StatementResponseType;





var $bh6RR = parcelRequire("bh6RR");



function $d43d24701d76da52$var$ResponseEdition({ type: type, content: content, index: index, onClose: onClose, isCustomResponse: isCustomResponse, is_not_link: is_not_link }) {
    var statementResponseType = [
        ...(0, $034f6f073b0d8b09$export$2e2bcd8739ae039)
    ];
    const [typeValue, setTypeValue] = (0, $bh6RR.useState)(type ? type : "quick");
    const data = {
        quick: "",
        custom: "Custom response",
        raw: ""
    };
    if (type != undefined) data[typeValue] = content;
    if (type != "custom" && isCustomResponse) statementResponseType.splice(1, 1);
    const [contentValue, setContentValue] = (0, $bh6RR.useState)(data);
    const [isLinked, setIsLinked] = (0, $bh6RR.useState)(is_not_link != null ? !is_not_link : true);
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const onClick = ()=>{
        modal.resolve({
            index: index,
            data: {
                type: typeValue,
                content: contentValue[typeValue],
                is_not_link: !isLinked
            }
        });
        return onClose();
    };
    const setContentValueKey = (key, value)=>{
        setContentValue({
            ...contentValue,
            [key]: value
        });
    };
    const disableSpellCheck = (ref)=>{
        if (!ref) return;
        ref.spellcheck = false;
    };
    const checkValidation = (value)=>{
        return value.trim().length == 0;
    };
    const classNameDropdown = type != undefined && isCustomResponse ? "dropdown type_responses disabled" : "dropdown type_responses";
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "response_modal",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                className: "title",
                children: type ? "Update a response" : "Create a Response"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "area-edit",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Type of Response : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dropdown_container",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                    choices: statementResponseType,
                                    setValue: (name, value)=>setTypeValue(value),
                                    defaultChoice: typeValue,
                                    width: "200px",
                                    className: classNameDropdown
                                })
                            }),
                            typeValue == "raw" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                        className: "dropdown_title",
                                        children: " Trigger next action : "
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "raw_response_checkbox",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $52b728934d836302$export$2e2bcd8739ae039), {
                                            id: "session_active",
                                            setValue: (name, checked)=>setIsLinked(checked),
                                            check: isLinked
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    typeValue != "raw" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                style: {
                                    marginLeft: 68
                                },
                                children: "Content : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dropdown_container",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    className: "input full-width",
                                    value: contentValue[typeValue],
                                    onChange: (e)=>setContentValueKey(typeValue, e.target.value)
                                })
                            })
                        ]
                    }) : "",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "response_content",
                        style: {
                            justifyItems: "center",
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: typeValue == "raw" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8f57823a2bb4f964$export$2e2bcd8739ae039), {
                            ref: (ref)=>disableSpellCheck(ref),
                            value: contentValue[typeValue],
                            onChange: (e)=>setContentValueKey(typeValue, e.target.value),
                            className: "input editor-input title_input",
                            minRows: 4
                        }) : ""
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                label: "Confirm",
                disabled: checkValidation(contentValue[typeValue]),
                onClick: onClick
            })
        ]
    });
}
var $d43d24701d76da52$export$2e2bcd8739ae039 = $d43d24701d76da52$var$ResponseEdition;








var $bh6RR = parcelRequire("bh6RR");
function $e887b6909ad4922a$var$AreaBlockResponse(props) {
    const { searchPath: searchPath, deletePath: deletePath } = (0, $3ef1c61908149445$export$2e2bcd8739ae039)();
    const { paths: paths } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    var className = "pad";
    if (props.first) className = className + " avatar-" + props.type;
    const editResponse = async (e)=>{
        const isCustomResponse = props.isCustomResponseSet();
        const result = await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show("editor-popup", {
            Component: (0, $d43d24701d76da52$export$2e2bcd8739ae039),
            componentProps: {
                content: props.content,
                index: props.first == true ? 0 : props.idx,
                type: props.type,
                isCustomResponse: isCustomResponse,
                is_not_link: props.is_not_link
            }
        });
        const { data: data, index: index } = result;
        if (data.is_not_link != props.is_not_link && data.is_not_link == true) {
            let indexNextParent = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(paths, props.object_block_id, "child_block_id");
            if (paths[indexNextParent] !== undefined) deletePath(paths[indexNextParent].path_id);
        }
        props.setValue(index, data);
    };
    const [isHover, setIsHover] = (0, $bh6RR.useState)(false);
    const content = props.content.split("->")[0];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "area-block-response",
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false),
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: className
            }),
            props.type != "raw" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                children: content
            }) : "",
            props.type == "raw" ? (0, $6722a74778d5733f$export$2e2bcd8739ae039)("response", {}, "", "Raw Response") : "",
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "actions",
                children: [
                    isHover && props.idx != 0 && props.first != true && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                        onClick: ()=>props.move(props.idx, -1),
                        className: "editor-iconButton main_add-button button_center edit_action",
                        icon: "fas fa-chevron-up"
                    }),
                    isHover && props.idx != -1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                        onClick: ()=>props.move(props.idx, 1),
                        className: "editor-iconButton main_add-button button_center edit_action",
                        icon: "fas fa-chevron-down"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                        className: "editor-iconButton main_add-button button_center edit_action",
                        icon: "fas fa-edit",
                        onClick: editResponse
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                        className: "editor-iconButton main_add-button button_center delete_action",
                        icon: "fas fa-trash",
                        onClick: ()=>props.deleteValue(props.first == true ? 0 : props.idx)
                    })
                ]
            })
        ]
    });
}
var $e887b6909ad4922a$export$2e2bcd8739ae039 = $e887b6909ad4922a$var$AreaBlockResponse;








var $bh6RR = parcelRequire("bh6RR");









function $3e97652129fd2872$var$FormStatement({ name: name, id: id }) {
    const { children: children, blocks: blocks } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const indexBlock = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, id, "object_id");
    const data = blocks[indexBlock] ? blocks[indexBlock].data : (0, $17abe9869440937a$export$a73988c0c2829a8b).data;
    var childrenBlocks = children.filter((child)=>child.parent_block_id == id).sort((a, b)=>a.index - b.index);
    const dispatch = (0, $6949a38b8f965998$export$649a5cfe816ce921)();
    const { messages: messages, responses: responses } = data;
    var type = data.responses.length && data.responses[0].type == "custom" ? "custom" : "quick";
    var variable_redirect = null;
    if (data.responses.length) {
        variable_redirect = data.variable_redirect ? data.variable_redirect : data.responses[0].variable;
        if (variable_redirect) variable_redirect.name = variable_redirect.name.toLowerCase();
    }
    const { updateBlockData: updateBlockData, createBlockChild: createBlockChild, updateBlockChild: updateBlockChild, updateBlockChildren: updateBlockChildren, deleteBlockChild: deleteBlockChild } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const [variableResponse, setVariableResponse] = (0, $bh6RR.useState)(variable_redirect);
    //const [responseType, setResponseType] = useState(type)
    const [hasBackgroundText, setHasBackgroundText] = (0, $bh6RR.useState)(data.has_background_text || false);
    const [backgroundText, setBackgroundText] = (0, $bh6RR.useState)(data.background_content) || "";
    const [retries, setRetries] = (0, $bh6RR.useState)(data.retries || "");
    const [hangupNoResponse, setHangupNoResponse] = (0, $bh6RR.useState)(data.hangup_no_response || false);
    const [listeningDuringPromptDelay, setListeningDuringPromptDelay] = (0, $bh6RR.useState)(data.listening_during_prompt_delay || false);
    const componentList = {
        messages: (0, $2b96c81c517f01ac$export$2e2bcd8739ae039),
        responses: (0, $d43d24701d76da52$export$2e2bcd8739ae039)
    };
    const { getValues: getValues, setValue: setValue } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: {
            messages: messages,
            responses: responses,
            variable_redirect: variable_redirect,
            has_background_text: data.has_background_text != null ? data.has_background_text : false,
            background_content: data.background_content || "",
            retries: data.retries != null ? data.retries : 1,
            hangup_no_response: data.hangup_no_response != null ? data.hangup_no_response : true,
            listening_during_prompt_delay: data.listening_during_prompt_delay != null ? data.listening_during_prompt_delay : 0
        }
    });
    const firstChild = childrenBlocks[0];
    const addRow = async (name, scroll)=>{
        const isCustomResponse = getValues(name).filter((row)=>row.type == "custom").length > 0;
        const length = getValues(name).length;
        const result = await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show("editor-popup", {
            Component: componentList[name],
            componentProps: {
                isCustomResponse: isCustomResponse
            }
        });
        const { data: data } = result;
        if (name == "responses") addChild(data, length + 1);
        const values = [
            ...getValues(name)
        ];
        values.splice(data.type == "custom" ? 0 : length, 0, data);
        dispatch({
            type: "updateBlockData",
            payload: {
                id: id,
                data: {
                    [name]: values
                }
            }
        });
        setValue(`${name}`, values);
        onSubmit(getValues());
        scroll();
    };
    // Permet d'ajouter une ligne en dessous du bloc, il ne faut pas l'utiliser pour les statements, juste les responses
    const addChild = async (data, index)=>{
        const child = {
            text: data.content,
            object_id: (0, $d64a8a6f6e0ad216$export$2e2bcd8739ae039)(index),
            index: index,
            parent_block_id: firstChild.parent_block_id
        };
        var newChildrenBlocks = [
            ...childrenBlocks
        ];
        newChildrenBlocks.splice(data.type == "custom" ? 1 : index, 0, child);
        newChildrenBlocks = newChildrenBlocks.map((child, idx)=>{
            return {
                ...child,
                index: idx
            };
        });
        dispatch({
            type: "createBlockChild",
            payload: {
                block_id: id,
                data: child
            }
        });
        await createBlockChild(id, child);
        dispatch({
            type: "updateBlockChildren",
            payload: {
                block_id: id,
                children: newChildrenBlocks
            }
        });
        updateBlockChildren(id, newChildrenBlocks);
    };
    const setValueVariable = (name, value)=>{
        setValue(name, value);
        onSubmit(getValues());
    };
    const handleBackgroundTextChange = (e)=>{
        const checked = e.target.checked;
        setHasBackgroundText(checked);
        setValue("has_background_text", checked);
        onSubmit(getValues());
    };
    const handleHangupNoResponseChange = (e)=>{
        const checked = e.target.checked;
        setHangupNoResponse(checked);
        setValue("hangup_no_response", checked);
        onSubmit(getValues());
    };
    const handleListeningDuringPromptDelayChange = (e)=>{
        const checked = e.target.checked;
        setListeningDuringPromptDelay(checked);
        setValue("listening_during_prompt_delay", checked);
        onSubmit(getValues());
    };
    const setValueRow = (name, index, value)=>{
        const length = getValues(name).length;
        if (index == -1) index = length - 1;
        if (name == "responses") {
            const object_id = childrenBlocks[index + 1].object_id;
            dispatch({
                type: "updateBlockChild",
                payload: {
                    block_id: id,
                    object_id: object_id,
                    data: {
                        text: value.content,
                        is_not_link: value.is_not_link
                    }
                }
            });
            updateBlockChild(id, object_id, {
                text: value.content
            });
        }
        setValue(`${name}.${index}`, value);
        dispatch({
            type: "updateBlockData",
            payload: {
                id: id,
                data: {
                    [name]: [
                        ...getValues(name)
                    ]
                }
            }
        });
        onSubmit(getValues());
    };
    const deleteValueRow = (name, index)=>{
        const length = getValues(name).length;
        if (index == -1) index = length - 1;
        if (name == "responses") {
            const object_id = childrenBlocks[index + 1].object_id;
            let newChildren = childrenBlocks.filter((childBlock)=>childBlock.index != index + 1 && childBlock.index != 0).map((childBlock, idx)=>{
                return {
                    ...childBlock,
                    index: (idx + 1).toString()
                };
            });
            dispatch({
                type: "deleteBlockChildAndOrderOther",
                payload: {
                    block_id: id,
                    object_id: object_id
                }
            });
            deleteBlockChild(id, object_id);
            updateBlockChildren(id, newChildren);
        }
        dispatch({
            type: "updateBlockData",
            payload: {
                id: id,
                data: {
                    [name]: [
                        ...getValues(name).filter((message, idx)=>idx !== index)
                    ]
                }
            }
        });
        setValue(name, getValues(name).filter((message, idx)=>idx !== index));
        onSubmit(getValues());
    };
    const moveStatements = (index, step, object_id)=>{
        move(index, step, messages, "messages");
    };
    const moveResponses = (index, step)=>{
        move(index, step, responses, "responses");
        if (index + step < 0) index = responses.length - 1; // dernier element - 1 car on ne peux pas descendre mais obligatoirement monter
        index += 1;
        [childrenBlocks[index], childrenBlocks[index + step]] = [
            childrenBlocks[index + step],
            childrenBlocks[index]
        ];
        childrenBlocks[index].index = index;
        childrenBlocks[index + step].index = index + step;
        let childrenBlocksServer = [
            childrenBlocks[index],
            childrenBlocks[index + step]
        ];
        dispatch({
            type: "updateBlockChildren",
            payload: {
                block_id: id,
                children: childrenBlocks
            }
        });
        updateBlockChildren(id, childrenBlocksServer);
    };
    const move = (index, step, array, propertyName)=>{
        if (index + step < 0) index = array.length - 1; // dernier element - 1 car on ne peux pas descendre mais obligatoirement monter
        [array[index], array[index + step]] = [
            array[index + step],
            array[index]
        ];
        let res = Object.values({
            ...getValues(propertyName),
            ...array
        });
        let payload = {
            id: id,
            data: {}
        };
        payload.data[propertyName] = res;
        dispatch({
            type: "updateBlockData",
            payload: payload
        });
        setValue(propertyName, res);
        onSubmit(getValues());
    };
    const functionMessages = {
        move: moveStatements,
        setValue: (index, value)=>setValueRow("messages", index, value),
        deleteValue: (index)=>deleteValueRow("messages", index)
    };
    const functionResponses = {
        move: moveResponses,
        setValue: (index, value)=>setValueRow("responses", index, value),
        deleteValue: (index)=>deleteValueRow("responses", index),
        isCustomResponseSet: ()=>getValues("responses").filter((row)=>row.type == "custom").length > 0
    };
    const onSubmit = (data)=>{
        const dataServer = (0, $be5ff267b91af682$export$2e2bcd8739ae039)(data);
        updateBlockData(id, data, dataServer);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $841d23f226ffdc19$export$2e2bcd8739ae039), {
                title: "Statements",
                titleInput: "Statement name",
                name: name,
                id: id
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "area-edit",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5b4dd497c4ab826c$export$2e2bcd8739ae039), {
                        title: "Sentences",
                        buttonLabel: "Add new Statement",
                        maxHeight: "230px",
                        onClickButton: (arg)=>addRow("messages", ...arg),
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0c7211c3be597575$export$2e2bcd8739ae039), {
                            data: messages,
                            ComponentRow: (0, $14a869ea144a7fae$export$2e2bcd8739ae039),
                            FunctionsRow: functionMessages
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row",
                        style: {
                            marginTop: "20px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Save Response : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dropdown_container",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fe74f3a5194e12fa$export$2e2bcd8739ae039), {
                                    variable: variableResponse,
                                    setValue: setValueVariable,
                                    name: "variable_redirect"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5b4dd497c4ab826c$export$2e2bcd8739ae039), {
                        title: "Responses",
                        buttonLabel: "Add new Response",
                        maxHeight: "200px",
                        onClickButton: (arg)=>addRow("responses", ...arg),
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0c7211c3be597575$export$2e2bcd8739ae039), {
                            data: responses,
                            childrenBlocks: childrenBlocks,
                            ComponentRow: (0, $e887b6909ad4922a$export$2e2bcd8739ae039),
                            FunctionsRow: functionResponses
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row",
                        style: {
                            marginTop: "20px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Has Background Text : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dropdown_container",
                                style: {
                                    position: "relative",
                                    bottom: "12px"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                    name: "has_background_text",
                                    checked: hasBackgroundText,
                                    onChange: handleBackgroundTextChange
                                })
                            })
                        ]
                    }),
                    hasBackgroundText && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Background Content : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dropdown_container",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0db11626bd290ec1$export$2e2bcd8739ae039), {
                                    name: "background_content",
                                    value: backgroundText,
                                    onChange: (e)=>{
                                        setValue("background_content", e.target.value);
                                        setBackgroundText(e.target.value);
                                    },
                                    onBlur: ()=>onSubmit(getValues()),
                                    placeholder: "Enter background content...",
                                    style: {
                                        width: "93%"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Retries : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dropdown_container",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    type: "number",
                                    name: "retries",
                                    value: retries,
                                    onChange: (e)=>{
                                        setValue("retries", e.target.value);
                                        setRetries(e.target.value);
                                    },
                                    onBlur: ()=>onSubmit(getValues()),
                                    placeholder: "Enter retries...",
                                    style: {
                                        width: "93%"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row",
                        style: {
                            marginTop: "20px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Hangup No Response : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dropdown_container",
                                style: {
                                    position: "relative",
                                    bottom: "12px"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                    name: "hangup_no_response",
                                    checked: hangupNoResponse,
                                    onChange: handleHangupNoResponseChange
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "grid-row",
                        style: {
                            marginTop: "20px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                className: "dropdown_title",
                                children: "Listening Uhlive : "
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dropdown_container",
                                style: {
                                    position: "relative",
                                    bottom: "12px"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                    name: "listening_during_prompt_delay",
                                    checked: listeningDuringPromptDelay,
                                    onChange: handleListeningDuringPromptDelayChange
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {})
                ]
            })
        ]
    });
}
var $3e97652129fd2872$export$2e2bcd8739ae039 = $3e97652129fd2872$var$FormStatement;













var $bh6RR = parcelRequire("bh6RR");
function $77dcfa216ad64634$var$FormAnnouncement({ id: id }) {
    const cleanInput = (val)=>val.replace(/\[/g, "").replace(/\]/g, "");
    const isVariableFind = (val)=>{
        if (!val) return false;
        let hasBrackets = val.startsWith("[") && val.endsWith("]");
        val = cleanInput(val);
        return variables.filter((variable)=>variable.name == val.toLowerCase()).length > 0 && hasBrackets;
    };
    const { variables: variables } = (0, $7ef7d0b863ac05b4$export$248471b8219beb2f)();
    const { blocks: blocks, paths: paths } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const indexBlock = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, id, "object_id");
    const block = blocks[indexBlock] ? blocks[indexBlock] : (0, $9e4935ba11138349$export$7c2cb032476d94bc);
    const { data: data } = block;
    const [variableFound, setVariableFound] = (0, $bh6RR.useState)(isVariableFind(data.message));
    const name = block.name;
    const dispatch = (0, $6949a38b8f965998$export$649a5cfe816ce921)();
    const { updateBlockData: updateBlockData } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const setTextareaData = (ref)=>{
        if (!ref) return null;
        ref.value = data.message;
    };
    const onBlur = (e)=>{
        const value = e.target.value;
        updateBlockData(id, {
            message: value,
            name: name
        });
    };
    const onChange = (e)=>{
        const value = e.target.value;
        setVariableFound(isVariableFind(e.target.value));
        dispatch({
            type: "updateBlockData",
            payload: {
                id: id,
                data: {
                    message: value
                }
            }
        });
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $841d23f226ffdc19$export$2e2bcd8739ae039), {
                title: "Announcement",
                titleInput: "Annoucement's name",
                name: name,
                id: id
            }, title),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "area-edit",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                        className: "input_title",
                        children: "Type your announcement : "
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8f57823a2bb4f964$export$2e2bcd8739ae039), {
                        ref: (ref)=>setTextareaData(ref),
                        onBlur: onBlur,
                        onChange: onChange,
                        className: "input editor-input title_input " + (variableFound ? "variables_found_announcement" : ""),
                        placeholder: "Please, wait a moment",
                        minRows: 5
                    })
                ]
            })
        ]
    });
}
var $77dcfa216ad64634$export$2e2bcd8739ae039 = $77dcfa216ad64634$var$FormAnnouncement;


var // FormList component to access more easialy to form component
$efd40bd1b120909a$export$2e2bcd8739ae039 = {
    default: (0, $396ec801e10a840d$export$2e2bcd8739ae039),
    api: (0, $6d7f91cb10e273cf$export$2e2bcd8739ae039),
    condition: (0, $e150c38c6560fbce$export$2e2bcd8739ae039),
    extract_data: (0, $b54ccffc1f6fd0ba$export$2e2bcd8739ae039),
    keyword_redirection: (0, $f5489e265e530650$export$2e2bcd8739ae039),
    set_var: (0, $b3fdbc0dd1bd54f3$export$2e2bcd8739ae039),
    magic: (0, $586584d37f69bf19$export$2e2bcd8739ae039),
    scenario: (0, $4a6dceb14d8cbb91$export$2e2bcd8739ae039),
    propos: (0, $3e97652129fd2872$export$2e2bcd8739ae039),
    announcement: (0, $77dcfa216ad64634$export$2e2bcd8739ae039)
};





function $0e090021b9a12863$var$Block({ children: children, x: x, y: y, className: className, id: id, imageLow: imageLow, lowVersion: lowVersion, type: type, data: data, childrenBlocks: childrenBlocks, name: name }) {
    const { selectBlock: selectBlock, dropBlock: dropBlock, shiftKey: shiftKey } = (0, $ebd5a98e941728ff$export$2e2bcd8739ae039)();
    const { blocks: blocks } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const { getCategoryById: getCategoryById } = (0, $973e14c0042f043b$export$2e2bcd8739ae039)();
    const { setMagnetPosition: setMagnetPosition, resetMagnetPosition: resetMagnetPosition } = (0, $8eadefa88967ced0$export$2e2bcd8739ae039)();
    const { createPath: createPath } = (0, $3ef1c61908149445$export$2e2bcd8739ae039)();
    const [isDraggingBlock, setIsDraggingBlock] = (0, $bh6RR.useState)(false);
    const { errors: errors } = (0, $7ef7d0b863ac05b4$export$248471b8219beb2f)();
    const refBlock = (0, $bh6RR.useRef)(null);
    const magnetBlock = className != "scenario" && className != "template";
    const componentProps = {
        data: data,
        childrenBlocks: childrenBlocks,
        name: name,
        id: id
    };
    var Component = (0, $efd40bd1b120909a$export$2e2bcd8739ae039)[type.name];
    const block_error = errors[id];
    let error = false;
    if (type.name == "magic" && block_error) {
        const indexBlock = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, id, "object_id");
        let block = blocks[indexBlock];
        error = block_error.errors.filter((child)=>child.type == "Block Error").length && block.data.is_constant == 1 ? true : false;
    }
    className = shiftKey ? `${className} shiftKey` : `${className}`;
    // When click on the block, we open the right-editor to edit form
    const onClick = (e)=>{
        const indexBlock = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, id, "object_id");
        let block = blocks[indexBlock];
        let infoCategory = getCategoryById(block.bot_category_id);
        if (infoCategory?.category.locked) return;
        // List of condition to not enter in the right-editor windows && cannot enter in the windows if click on menu button
        if (className == "template " || e.target.classList.contains("context_element") || e.target.classList.contains("context_element_lockable")) return;
        if (createPath(id)) return;
        var classList = [
            "sub_out_block",
            "sub_out_block_zero",
            "in_block",
            "delete",
            "export",
            "duplicate",
            "block_action_stat",
            "block_magic_jump_btn"
        ];
        if (classList.some((className)=>e.target.classList.contains(className))) return;
        const element = document.getElementById(id);
        if (!element || [
            ...element.classList
        ].some((className)=>className == "shiftKey")) return;
        const oldElement = document.querySelector(".block.selected");
        if (oldElement) oldElement.classList.remove("selected");
        if (isDraggingBlock == true) setIsDraggingBlock(false);
        else (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show("editor-window", {
            Component: Component,
            componentProps: componentProps
        });
        //NiceModal.show('editor-window', { Component,  componentProps }); 
        element.classList.add("selected");
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        ref: refBlock,
        className: "block " + className,
        id: id,
        onMouseUp: (e)=>dropBlock(e, id),
        onMouseMove: (e)=>setIsDraggingBlock(document.getElementById(id).classList.contains("grabbed")),
        onMouseDown: (e)=>selectBlock(e, id),
        onMouseEnter: ()=>magnetBlock && setMagnetPosition(id),
        onMouseLeave: ()=>magnetBlock && resetMagnetPosition(),
        onClick: onClick,
        style: {
            transform: "translate3d(" + x + "px, " + y + "px, 0)",
            backgroundImage: lowVersion ? `url(${imageLow})` : "",
            ...error ? {
                border: "2px solid var(--pink)"
            } : {}
        },
        children: children
    });
}
var $0e090021b9a12863$export$2e2bcd8739ae039 = $0e090021b9a12863$var$Block;










// Component for create the second part of the link when you click on it
function $a96fcb7de84de34b$var$BlockLinkStart({ className: className, style: style, parent_block_id: parent_block_id, object_id: object_id }) {
    const { createTmpPath: createTmpPath, updateMouse: updateMouse, deleteAllSelectedBlock: deleteAllSelectedBlock } = (0, $b160775e2cfdbb38$export$2e2bcd8739ae039)();
    const { getChildPosition: getChildPosition, getBlockInformation: getBlockInformation } = (0, $c45f4fed2a7893f8$export$2e2bcd8739ae039)();
    const { deletePath: deletePath } = (0, $3ef1c61908149445$export$2e2bcd8739ae039)();
    const { shiftKey: shiftKey } = (0, $008a36c4d52c37da$export$2e2bcd8739ae039)();
    const onClick = (e)=>{
        if (shiftKey) {
            e.preventDefault();
            return;
        }
        const { x: x, y: y } = getChildPosition(parent_block_id, object_id);
        const { paths_in: paths_in } = getBlockInformation(parent_block_id);
        const path_find = paths_in.filter((path)=>path.child_block_id == object_id).pop();
        if (!path_find) {
            deleteAllSelectedBlock();
            createTmpPath(x, y, parent_block_id, object_id);
            updateMouse(e.clientX, e.clientY);
            return;
        }
        deletePath(path_find.path_id);
    };
    const changePathColor = (color)=>{
        const { paths_in: paths_in } = getBlockInformation(parent_block_id);
        const path_find = paths_in.filter((path)=>path.child_block_id == object_id).pop();
        if (!path_find) return;
        const pathDom = document.getElementById(path_find.path_id);
        if (pathDom == null) return;
        pathDom.style.stroke = color;
    };
    const onMouseEnter = ()=>shiftKey == false && changePathColor("var(--pink)");
    const onMouseLeave = ()=>shiftKey == false && changePathColor("");
    const { paths_in: paths_in } = getBlockInformation(parent_block_id);
    const path_find = paths_in.filter((path)=>path.child_block_id == object_id).pop();
    style = style == undefined ? {} : style;
    if (shiftKey) style.cursor = "not-allowed";
    else style.cursor = path_find ? "pointer" : "alias";
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: className,
        style: {
            ...style
        },
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    });
}
var $a96fcb7de84de34b$export$2e2bcd8739ae039 = $a96fcb7de84de34b$var$BlockLinkStart;




var $bh6RR = parcelRequire("bh6RR");
function $c09d26096b8b49f2$var$BlockChild({ style: style, className: className, zero: zero, label: label, lowVersion: lowVersion, parent_block_id: parent_block_id, object_id: object_id, is_not_link: is_not_link }) {
    const [printArrow, setPrintArrow] = (0, $bh6RR.useState)(is_not_link);
    if (lowVersion) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "sub_block",
        style: style,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                className: "sub_txt",
                children: label
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "sub_out_block " + className + " delete"
            })
        ]
    });
    const { errors: errors } = (0, $7ef7d0b863ac05b4$export$248471b8219beb2f)();
    const block = errors[parent_block_id];
    var error = false;
    if (block) error = block.errors.filter((child)=>child.data && child.data.object_id == object_id).length ? true : false;
    if (zero) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "sub_block_zero",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a96fcb7de84de34b$export$2e2bcd8739ae039), {
            style: style,
            parent_block_id: parent_block_id,
            object_id: object_id,
            className: error ? "sub_out_block_zero ripple part_error " + className : "sub_out_block_zero " + className
        })
    });
    style = {
        ...style,
        marginLeft: error ? -2 : 0
    };
    if (printArrow != is_not_link) setPrintArrow(is_not_link);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: error ? "sub_block ripple part_error" : "sub_block",
        style: style,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                className: "sub_txt",
                children: label
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "sub_connector",
                style: {
                    top: "-12px",
                    height: "13px"
                }
            }),
            printArrow != true && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a96fcb7de84de34b$export$2e2bcd8739ae039), {
                parent_block_id: parent_block_id,
                object_id: object_id,
                className: error ? "sub_out_block ripple delete " + className : "sub_out_block delete " + className
            })
        ]
    });
}
$c09d26096b8b49f2$var$BlockChild.defaultProps = {
    lowVersion: false
};
var $c09d26096b8b49f2$export$2e2bcd8739ae039 = $c09d26096b8b49f2$var$BlockChild;




var $bh6RR = parcelRequire("bh6RR");








var $bh6RR = parcelRequire("bh6RR");






function $a0e45a3dff6fe683$var$useBlockMenu(id) {
    const [show, setShow] = (0, $bh6RR.useState)(false);
    const [onClick, setOnClick] = (0, $bh6RR.useState)(false);
    const { openIfClosed: openIfClosed } = (0, $ee1060133ad495ee$export$2e2bcd8739ae039)();
    const { deleteBlock: deleteBlock, duplicateBlock: duplicateBlock, jumpBlock: jumpBlock } = (0, $c45f4fed2a7893f8$export$2e2bcd8739ae039)();
    const { getCategoryById: getCategoryById, ungroupBlockFromCategory: ungroupBlockFromCategory } = (0, $973e14c0042f043b$export$2e2bcd8739ae039)();
    const { blocks: blocks, categories: categories } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const { updateBlocksName: updateBlocksName } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const getBlockByObjectId = (id)=>{
        const indexBlock = (0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, id, "object_id");
        return blocks[indexBlock];
    };
    const onClickPlay = async (e)=>{
        const duration = document.getElementsByClassName("editor-window").item(0) ? 0 : 350;
        setTimeout(()=>openIfClosed(), duration);
        setOnClick(true);
        console.log(e.target.classList);
    //await waitForUpdate();
    //askBotNextQuestion(id)
    };
    const onClickDuplicate = (_id = -1)=>{
        duplicateBlock(_id != -1 ? _id : id);
        setShow(false);
    };
    const onClickJump = (_id = -1)=>{
        jumpBlock(_id != -1 ? _id : id);
        setShow(false);
    };
    const updateBlockOnDelete = (classname, id)=>{
        if (classname != "scenario") return;
        const block = getBlockByObjectId(id);
        if (!block) return;
        const name = block.name;
        const blocksToUpdate = blocks.filter((block)=>block.type.name == "magic" && block.name == `Jump to ${name}`).map((block)=>{
            return {
                ...block,
                name: `Jump to ...`
            };
        });
        if (blocksToUpdate.length == 0) return;
        updateBlocksName(blocksToUpdate);
    };
    const updateCategoryOnDelete = async (_id = -1)=>{
        const block = getBlockByObjectId(_id != -1 ? _id : id);
        if (block.bot_category_id == null) return;
        await ungroupBlockFromCategory(block);
    };
    const onClickDelete = async (classname, deletable, _id = -1)=>{
        if (!deletable) return;
        let idBlock = _id != -1 ? _id : id;
        const block = getBlockByObjectId(idBlock);
        let infoCategory = getCategoryById(block.bot_category_id);
        if (infoCategory != null && infoCategory.category.locked) return;
        await updateCategoryOnDelete(idBlock);
        updateBlockOnDelete(classname, idBlock);
        setShow(false);
        await deleteBlock(idBlock);
    };
    const onClickDeleteFromCategory = async ()=>{
        const block = getBlockByObjectId(id);
        if (!block) return;
        ungroupBlockFromCategory(block);
    };
    const getCategory = ()=>{
        let block = getBlockByObjectId(id);
        if (block == null || block.bot_category_id == null) return;
        let category = categories.find((infoCategory)=>infoCategory.category.id == block.bot_category_id)?.category;
        return category;
    };
    return {
        onClickPlay: onClickPlay,
        onClickDuplicate: onClickDuplicate,
        onClickJump: onClickJump,
        onClickDelete: onClickDelete,
        onClickDeleteFromCategory: onClickDeleteFromCategory,
        getCategory: getCategory,
        show: show,
        setShow: setShow,
        onClick: onClick,
        setOnClick: setOnClick
    };
}
var $a0e45a3dff6fe683$export$2e2bcd8739ae039 = $a0e45a3dff6fe683$var$useBlockMenu;


// Component right menu for action delete/export/update on the bot
function $914b32eeecd453db$var$Menu({ className: className, id: id, deletable: deletable }) {
    const { blocks: blocks } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const { botId: botId, onUpdate: onUpdate } = (0, $7ef7d0b863ac05b4$export$248471b8219beb2f)();
    const { askBotNextQuestion: askBotNextQuestion } = (0, $25d6ba8a8df7472c$export$2e2bcd8739ae039)();
    const { shiftKey: shiftKey } = (0, $008a36c4d52c37da$export$2e2bcd8739ae039)();
    const { onClickPlay: onClickPlay, onClickDuplicate: onClickDuplicate, onClickJump: onClickJump, onClickDelete: onClickDelete, onClickDeleteFromCategory: onClickDeleteFromCategory, getCategory: getCategory, show: show, setShow: setShow, onClick: onClick, setOnClick: setOnClick } = (0, $a0e45a3dff6fe683$export$2e2bcd8739ae039)(id);
    const category = getCategory();
    (0, $bh6RR.useEffect)(()=>{
        if (onClick != true || onUpdate != false) return;
        askBotNextQuestion(id);
        setOnClick(false);
    }, [
        onUpdate,
        onClick
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "more_btn " + className,
        onMouseOver: ()=>shiftKey == false && setShow(true),
        onMouseLeave: (e)=>e.target.class != "block_context_menu" && setShow(false),
        children: show && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "block_context_menu" + (category ? " context_with_category" : ""),
            onMouseLeave: ()=>shiftKey == false && setShow(false),
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "context_element play",
                    onClick: onClickPlay,
                    children: "Test"
                }),
                className == "scenario" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "context_element export",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                        href: (0, $651df53b10514175$export$a7b6bc01c63cdfc3).REACT_APP_API_PATH + `/bot/${botId}/scenario/${id}/export?token_auth=${(0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("token")}&company=${(0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company").id}`,
                        rel: "noopener noreferrer",
                        children: "Export"
                    })
                }),
                className != "scenario" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "context_element duplicate",
                    onClick: ()=>onClickDuplicate(),
                    children: "Duplicate"
                }),
                className == "scenario" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "context_element jump",
                    onClick: ()=>onClickJump(),
                    children: "Jump"
                }),
                blocks && category && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "context_element_lockable",
                    style: {
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "context_element substract_category" + (category.locked ? " lock" : ""),
                            onClick: onClickDeleteFromCategory,
                            disabled: category.locked,
                            children: "Ungroup"
                        }),
                        category.locked == true && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                            className: "fas fa-lock category_locked_element",
                            style: {
                                color: category.color
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "context_element_lockable",
                    style: {
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "context_element delete " + (!deletable || category?.locked ? "lock" : ""),
                            onClick: ()=>onClickDelete(className, deletable),
                            disabled: category?.locked,
                            children: "Delete"
                        }),
                        deletable && category?.locked ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                            className: "fas fa-lock category_locked_element",
                            style: {
                                color: category.color
                            }
                        }) : ""
                    ]
                })
            ]
        })
    });
}
$914b32eeecd453db$var$Menu.defaultProps = {
    deletable: true
};
var $914b32eeecd453db$export$2e2bcd8739ae039 = $914b32eeecd453db$var$Menu;


var $b437f27a1e2b1d70$exports = {};
$b437f27a1e2b1d70$exports = new URL("action_preview.aed4b451.png", import.meta.url).toString();









function $4485e014d56a0228$var$usePathTmp() {
    const { resetTmpPath: resetTmpPathAction } = (0, $b160775e2cfdbb38$export$2e2bcd8739ae039)();
    const { mouse: mouse, pathTmp: pathTmp, magnetPosition: magnetPosition } = (0, $7324df5b25c181de$export$2fe873ee5eb16329)();
    const movePathTmp = (x, y, scale)=>{
        // magnetPosition containt the position of the block that you are currently hovering if you hover one
        let conditionMagnet = magnetPosition.on && pathTmp.parent_block_id != magnetPosition.id;
        // Calculate the offset : couple (x,y) is the beggining of the path so we need to calculate the offset beetween the start and the new coordiate
        // Todo we need no 'smooth' the (x,y) coordinate because the start is where the user click so a little offset can be created and caused visual problem
        let diff = {
            x: x - mouse.x,
            y: y - mouse.y
        };
        let _x = conditionMagnet ? magnetPosition.x : pathTmp.x + diff.x / scale;
        let _y = conditionMagnet ? magnetPosition.y : pathTmp.y + diff.y / scale;
        let pathRef = document.getElementById("path_tmp");
        const { data: data, stroke: stroke } = (0, $c7a2343ef3cc915a$export$859fe8f922ebbf8f)(pathTmp.x, pathTmp.y, _x, _y);
        pathRef.setAttributeNS(null, "d", data);
        pathRef.setAttributeNS(null, "stroke", conditionMagnet ? "var(--main)" : stroke);
    };
    const deletePathTmp = (classList)=>{
        // Only delete if the pathTmp if class of element clicked is not one them
        const classNames = [
            "sub_out_block",
            "sub_out_block_zero",
            "blocks",
            "in_block "
        ];
        if (classNames.some((className)=>classList.contains(className))) return null;
        resetTmpPathAction();
    };
    return {
        movePathTmp: movePathTmp,
        deletePathTmp: deletePathTmp,
        pathTmp: pathTmp,
        magnetPosition: magnetPosition,
        mouse: mouse
    };
}
var $4485e014d56a0228$export$2e2bcd8739ae039 = $4485e014d56a0228$var$usePathTmp;



// Component for create the first part of the link when you click on it
function $ed3a8b7600c39ae9$var$BlockLinkEnd({ className: className, style: style, parent_block_id: parent_block_id }) {
    const { getBlockInformation: getBlockInformation } = (0, $c45f4fed2a7893f8$export$2e2bcd8739ae039)();
    const { deletePath: deletePath } = (0, $3ef1c61908149445$export$2e2bcd8739ae039)();
    const { pathTmp: pathTmp } = (0, $4485e014d56a0228$export$2e2bcd8739ae039)();
    const { shiftKey: shiftKey } = (0, $008a36c4d52c37da$export$2e2bcd8739ae039)();
    const { errors: errors } = (0, $7ef7d0b863ac05b4$export$248471b8219beb2f)();
    const block = errors[parent_block_id];
    var error = false;
    className = "in_block " + className + " delete";
    if (block) error = block.errors.filter((child)=>child.data == undefined && child.type == "block is not link").length ? true : false;
    // If no path show error
    if (error) className = className + " part_error ripple";
    const onClick = (e)=>{
        if (shiftKey == true) return;
        const { paths_out: paths_out } = getBlockInformation(parent_block_id);
        if (paths_out.length == 0 || pathTmp != null) return;
        paths_out.forEach((path)=>deletePath(path.path_id));
    };
    const changePathsColor = (color)=>{
        const { paths_out: paths_out } = getBlockInformation(parent_block_id);
        if (paths_out.length == 0 || pathTmp != null) return;
        paths_out.map((path)=>{
            const pathDom = document.getElementById(path.path_id);
            if (pathDom == null) return;
            pathDom.style.stroke = color;
        });
    };
    const onMouseEnter = ()=>shiftKey == false && changePathsColor("var(--pink)");
    const onMouseLeave = ()=>shiftKey == false && changePathsColor("");
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: className,
        style: {
            ...style
        },
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    });
}
var $ed3a8b7600c39ae9$export$2e2bcd8739ae039 = $ed3a8b7600c39ae9$var$BlockLinkEnd;





var $bh6RR = parcelRequire("bh6RR");
function $6944760d8760d59f$var$BlockAction({ object_id: object_id, name: name, x: x, y: y, children: children, action_type: action_type, lowVersion: lowVersion, data: data, is_statistic: is_statistic }) {
    if (children) children.sort((a, b)=>a.index - b.index);
    const { updateBlockStatistic: updateBlockStatistic } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    //console.log(is_statistic)
    const type = action_type ? action_type.name : "default";
    const content = (0, $a36b749f7b491cad$export$2e2bcd8739ae039)[type];
    const exception = type == "condition" || type == "keyword_redirection";
    var [isStatistic, setIsStatistic] = (0, $bh6RR.useState)(is_statistic);
    const block = {
        name: name,
        x: x,
        y: y,
        id: object_id,
        imageLow: (0, (/*@__PURE__*/$parcel$interopDefault($b437f27a1e2b1d70$exports))),
        lowVersion: lowVersion,
        type: {
            name: type
        },
        data: data,
        className: "action",
        childrenBlocks: children
    };
    const updateStatistic = ()=>{
        if (isStatistic == 0) isStatistic = 1;
        else if (isStatistic == 1) isStatistic = 2;
        else isStatistic = 0;
        updateBlockStatistic(object_id, isStatistic);
        setIsStatistic(isStatistic);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $0e090021b9a12863$export$2e2bcd8739ae039), {
        ...block,
        children: [
            !lowVersion && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    type != "default" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ed3a8b7600c39ae9$export$2e2bcd8739ae039), {
                        parent_block_id: object_id,
                        className: "action",
                        style: {
                            left: "-15px",
                            top: "60px",
                            transform: "rotate(270deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $914b32eeecd453db$export$2e2bcd8739ae039), {
                        className: "action",
                        id: object_id
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "block_action_icon"
                    }),
                    exception ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: isStatistic ? isStatistic == 1 ? "block_action_stat enabled" : "block_action_stat special" : "block_action_stat",
                        onClick: updateStatistic
                    }) : "",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                        className: "block_action_title",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "action_innerblock",
                        children: content
                    }),
                    !exception && type != "default" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c09d26096b8b49f2$export$2e2bcd8739ae039), {
                        className: "action",
                        style: {
                            left: "185.5px",
                            top: "-115px",
                            transform: "rotate(270deg)"
                        },
                        zero: true,
                        parent_block_id: object_id,
                        object_id: children[0].object_id
                    })
                ]
            }),
            exception && children && children.map((child, index)=>child.index != 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c09d26096b8b49f2$export$2e2bcd8739ae039), {
                    lowVersion: lowVersion,
                    object_id: child.object_id,
                    parent_block_id: object_id,
                    className: "action",
                    style: {
                        width: "200px",
                        top: 80 + index * 40 + "px"
                    },
                    label: child.text
                }, child.object_id))
        ]
    });
}
var $6944760d8760d59f$export$2e2bcd8739ae039 = $6944760d8760d59f$var$BlockAction;







var $a6ab3d7039b1a241$exports = {};
$a6ab3d7039b1a241$exports = new URL("jump_preview.f6fdbc12.png", import.meta.url).toString();



// Component for create the block jump
function $7f85bd5142ccfc5b$var$BlockJump({ name: name, x: x, y: y, object_id: object_id, data: data, lowVersion: lowVersion, type: type }) {
    const { followBlock: followBlock } = (0, $44233c56e4012027$export$2e2bcd8739ae039)();
    const block = {
        name: name,
        x: x,
        y: y,
        id: object_id,
        imageLow: (0, (/*@__PURE__*/$parcel$interopDefault($a6ab3d7039b1a241$exports))),
        lowVersion: lowVersion,
        type: type,
        data: data,
        className: "magic"
    };
    const className = data.jump_id ? "block_magic_jump_btn" : "block_magic_jump_btn disabled";
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0e090021b9a12863$export$2e2bcd8739ae039), {
        ...block,
        children: !lowVersion && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ed3a8b7600c39ae9$export$2e2bcd8739ae039), {
                    parent_block_id: object_id,
                    className: "magic",
                    style: {
                        left: "-15px",
                        top: "42px",
                        transform: "rotate(270deg)"
                    }
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $914b32eeecd453db$export$2e2bcd8739ae039), {
                    className: "magic",
                    id: object_id
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "block_magic_icon"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: className,
                    onClick: ()=>data.jump_id && followBlock(data.jump_id.object_id),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        children: name
                    })
                })
            ]
        })
    });
}
var $7f85bd5142ccfc5b$export$2e2bcd8739ae039 = $7f85bd5142ccfc5b$var$BlockJump;






var $5389073477ecc312$exports = {};
$5389073477ecc312$exports = new URL("scenario_preview.068f62d2.png", import.meta.url).toString();



function $a3a57aace4122abf$var$BlockScenario({ object_id: object_id, name: name, x: x, y: y, data: data, lowVersion: lowVersion, children: children, type: type }) {
    // scenario block
    const block = {
        name: name,
        x: x,
        y: y,
        id: object_id,
        imageLow: (0, (/*@__PURE__*/$parcel$interopDefault($5389073477ecc312$exports))),
        lowVersion: lowVersion,
        type: type,
        data: data,
        className: "scenario",
        childrenBlocks: children
    };
    // lowVersion no information are action on the block, an image will be display if lowVersion
    if (children == undefined) {
        console.log(`block ${object_id} without children`);
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0e090021b9a12863$export$2e2bcd8739ae039), {
        ...block,
        children: !lowVersion && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $914b32eeecd453db$export$2e2bcd8739ae039), {
                    className: "scenario",
                    id: object_id,
                    deletable: !data.basic
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "block_scenario_icon"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                    className: "block_scenario_title",
                    children: name
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c09d26096b8b49f2$export$2e2bcd8739ae039), {
                    className: "scenario",
                    style: {
                        left: "185.5px",
                        top: "-130px",
                        transform: "rotate(270deg)"
                    },
                    parent_block_id: object_id,
                    object_id: children[0].object_id,
                    zero: true
                })
            ]
        })
    });
}
var $a3a57aace4122abf$export$2e2bcd8739ae039 = $a3a57aace4122abf$var$BlockScenario;






var $fecd26c1b43ca207$exports = {};
$fecd26c1b43ca207$exports = new URL("propos_preview2.021dfd19.png", import.meta.url).toString();





const $43bcaae67ff706f7$var$getLabel = (variable, child, data, index)=>{
    if (variable && child.index == 1) return "[" + variable.name.toUpperCase() + "]";
    if (data.responses[index - 1]?.type == "raw") return (0, $6722a74778d5733f$export$2e2bcd8739ae039)("response", {}, "", "Raw Response");
    return child.text;
};
function $43bcaae67ff706f7$var$BlockStatement({ name: name, x: x, y: y, children: children, data: data, object_id: object_id, lowVersion: lowVersion, type: type }) {
    // Need to sort block children juste in case
    if (children) children.sort((a, b)=>a.index - b.index);
    // Propos block
    const block = {
        name: name,
        x: x,
        y: y,
        id: object_id,
        imageLow: (0, (/*@__PURE__*/$parcel$interopDefault($fecd26c1b43ca207$exports))),
        lowVersion: lowVersion,
        type: type,
        data: data,
        className: "propos",
        childrenBlocks: children
    };
    // Special case for old variable storage type
    var variable = null;
    if (data.responses.length && data.responses[0].type == "custom") {
        variable = data.variable_redirect ? data.variable_redirect : data.responses[0].variable;
        if (variable) variable.name = variable.name.toLowerCase();
    }
    let messageToShow = "";
    if (data.messages) messageToShow = data.messages[0]?.type == "raw" ? (0, $6722a74778d5733f$export$2e2bcd8739ae039)("statement", {}, "", "Raw Message") : data.messages[0]?.content;
    // lowVersion no information are action on the block, an image will be display if lowVersion
    // is_not_link  dans data.responses[x] par default = false
    // en attendant 
    /*
    for (let i = 0; i < data.responses.length; i++){
        if (data.responses[i].type =="raw"){
            data.responses[i].is_not_link = true;
        }
    }
    */ return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $0e090021b9a12863$export$2e2bcd8739ae039), {
        ...block,
        children: [
            !lowVersion && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ed3a8b7600c39ae9$export$2e2bcd8739ae039), {
                        parent_block_id: object_id,
                        className: "propos",
                        style: {
                            left: "-15px",
                            top: "60px",
                            transform: "rotate(270deg)"
                        }
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $914b32eeecd453db$export$2e2bcd8739ae039), {
                        className: "propos",
                        id: object_id
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "block_propos_icon"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "block_propos_title",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "propos_innerblock start",
                        children: messageToShow
                    })
                ]
            }),
            children && children.map((child, index)=>child.index != 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c09d26096b8b49f2$export$2e2bcd8739ae039), {
                    parent_block_id: object_id,
                    lowVersion: lowVersion,
                    object_id: child.object_id,
                    className: "propos",
                    style: {
                        width: "200px",
                        top: 80 + index * 40 + "px"
                    },
                    label: $43bcaae67ff706f7$var$getLabel(variable, child, data, index),
                    is_not_link: data.responses[index - 1]?.is_not_link
                }, child.object_id))
        ]
    });
}
var $43bcaae67ff706f7$export$2e2bcd8739ae039 = $43bcaae67ff706f7$var$BlockStatement;








function $e2fed6329d301208$var$BlockTemplate({ x: x, y: y, width: width, height: height, object_id: object_id, data: data }) {
    const { selectBlock: selectBlock, dropBlock: dropBlock } = (0, $ebd5a98e941728ff$export$2e2bcd8739ae039)();
    const { deleteBlock: deleteBlock, importBlockTemplate: importBlockTemplate } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const { panzone: panzone } = (0, $82092047ba9387bf$export$2e2bcd8739ae039)();
    const onValidate = ()=>{
        let form = new FormData();
        form.append("scenario", data.file);
        form.append("x", x - data.coords.min.x);
        form.append("y", y - data.coords.min.y);
        panzone.pause();
        console.log(form);
        importBlockTemplate(object_id, form);
    };
    const style = {
        transform: "translate3d(" + x + "px, " + y + "px, 0)",
        width: width * (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039) + "px",
        height: height * (0, $26f3660f5c0ff7f5$export$2e2bcd8739ae039) + "px"
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "block template",
        id: object_id,
        style: style,
        onMouseUp: (e)=>dropBlock(e, object_id),
        onMouseDown: (e)=>selectBlock(e, object_id),
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                className: "title",
                children: "TEMPLATE"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "validate btn",
                onClick: onValidate
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "cancel btn",
                onClick: ()=>deleteBlock(object_id)
            })
        ]
    });
}
var $e2fed6329d301208$export$2e2bcd8739ae039 = $e2fed6329d301208$var$BlockTemplate;










// Component for create the block jump
function $dbb6e0bb3dde5d5f$var$BlockAnnouncement({ name: name, x: x, y: y, object_id: object_id, data: data, lowVersion: lowVersion, children: children, type: type }) {
    const block = {
        name: name,
        x: x,
        y: y,
        id: object_id,
        imageLow: (0, (/*@__PURE__*/$parcel$interopDefault($a6ab3d7039b1a241$exports))),
        lowVersion: lowVersion,
        type: type,
        data: data,
        className: "announcement"
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0e090021b9a12863$export$2e2bcd8739ae039), {
        ...block,
        children: !lowVersion && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ed3a8b7600c39ae9$export$2e2bcd8739ae039), {
                    parent_block_id: object_id,
                    className: "announcement",
                    style: {
                        left: "-15px",
                        top: "60px",
                        transform: "rotate(270deg)"
                    }
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $914b32eeecd453db$export$2e2bcd8739ae039), {
                    className: "announcement",
                    id: object_id
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                    className: "block_announcement_title",
                    children: name
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "block_announcement_icon"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "announcement_innerblock",
                    children: data.message
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c09d26096b8b49f2$export$2e2bcd8739ae039), {
                    className: "announcement",
                    style: {
                        left: "185.5px",
                        top: "-115px",
                        transform: "rotate(270deg)"
                    },
                    parent_block_id: object_id,
                    object_id: children[0].object_id,
                    zero: true
                })
            ]
        })
    });
}
var $dbb6e0bb3dde5d5f$export$2e2bcd8739ae039 = $dbb6e0bb3dde5d5f$var$BlockAnnouncement;



var $bh6RR = parcelRequire("bh6RR");

var $kEUo3 = parcelRequire("kEUo3");
const $91038ec84b81c133$var$isArrayEqual = (x, y)=>{
    return JSON.stringify(x) == JSON.stringify(y);
};
function $91038ec84b81c133$var$isEqualBlock(prevBlock, nextBlock) {
    if (prevBlock.x != nextBlock.x || prevBlock.y != nextBlock.y) return false;
    if (prevBlock.name != nextBlock.name) return false;
    // Re-render block is lowVersion
    if (prevBlock.lowVersion != nextBlock.lowVersion) return false;
    // Those cases are here to re-redender block from form modification 
    if (prevBlock.children && nextBlock.children && $91038ec84b81c133$var$isArrayEqual(prevBlock.children, nextBlock.children) == false) return false;
    if (nextBlock.type && nextBlock.type.name == "propos" && $91038ec84b81c133$var$isArrayEqual(prevBlock.data.messages, nextBlock.data.messages) == false) return false;
    if (nextBlock.type && nextBlock.type.name == "propos" && (0, $kEUo3.isEqual)(prevBlock.data.variable_redirect, nextBlock.data.variable_redirect) == false) return false;
    //console.log(prevBlock.type.name);
    return true;
}
var // Helper to get block composent, use memo for no re-render
$91038ec84b81c133$export$2e2bcd8739ae039 = {
    action: /*#__PURE__*/ (0, $bh6RR.memo)((0, $6944760d8760d59f$export$2e2bcd8739ae039), $91038ec84b81c133$var$isEqualBlock),
    magic: /*#__PURE__*/ (0, $bh6RR.memo)((0, $7f85bd5142ccfc5b$export$2e2bcd8739ae039), $91038ec84b81c133$var$isEqualBlock),
    propos: /*#__PURE__*/ (0, $bh6RR.memo)((0, $43bcaae67ff706f7$export$2e2bcd8739ae039), $91038ec84b81c133$var$isEqualBlock),
    scenario: /*#__PURE__*/ (0, $bh6RR.memo)((0, $a3a57aace4122abf$export$2e2bcd8739ae039), $91038ec84b81c133$var$isEqualBlock),
    template: /*#__PURE__*/ (0, $bh6RR.memo)((0, $e2fed6329d301208$export$2e2bcd8739ae039), $91038ec84b81c133$var$isEqualBlock),
    announcement: /*#__PURE__*/ (0, $bh6RR.memo)((0, $dbb6e0bb3dde5d5f$export$2e2bcd8739ae039), $91038ec84b81c133$var$isEqualBlock)
};



var $bh6RR = parcelRequire("bh6RR");





function $be71c46f23d27718$var$useBlockMove() {
    const { mouse: mouse } = (0, $7324df5b25c181de$export$2fe873ee5eb16329)();
    const { movePaths: movePaths, setPaths: setPaths } = (0, $3ef1c61908149445$export$2e2bcd8739ae039)();
    const { moveCategories: moveCategories } = (0, $973e14c0042f043b$export$2e2bcd8739ae039)();
    const moveBlock = (block, x, y, zoom)=>{
        block._x = block.x + (x - mouse.x) / zoom;
        block._y = block.y + (y - mouse.y) / zoom;
        let blockRef = document.getElementById(block.object_id);
        blockRef?.classList.add("grabbed");
        let elements = document.elementsFromPoint(x, y);
        let category = elements.find((element)=>element.classList.contains("category_container"));
        if (category != null) category.classList.add("category_hovered");
        else {
            let elements = Array.from(document.getElementsByClassName("category_hovered"));
            elements.map((e)=>e.classList.remove("category_hovered"));
        }
        if (blockRef != null) blockRef.style.transform = "translate3d(" + block._x + "px, " + block._y + "px, 0)";
    };
    const moveBlocks = (blocks, x, y, scale)=>{
        var paths_to_move = [];
        var categories_to_move = [];
        for(let i = 0; i < blocks.length; i++){
            const { block: block, paths_out: paths_out, paths_in: paths_in } = blocks[i];
            moveBlock(block, x, y, scale);
            paths_to_move = setPaths(paths_to_move, paths_out, block._x, block._y, "out");
            paths_to_move = setPaths(paths_to_move, paths_in, block._x, block._y, "in");
            movePaths(paths_to_move);
            if (block.bot_category_id == null) continue;
            let existingCategory = categories_to_move.find((category)=>category.category_id === block.bot_category_id); // on verifie si la category du block courant est deja dans la liste de celles a modifie
            if (existingCategory) existingCategory.blocks.push(block); // si c'est le cas on ajoute le block courant
            else categories_to_move.push({
                category_id: block.bot_category_id,
                blocks: [
                    block
                ]
            });
        }
        moveCategories(categories_to_move);
    };
    return {
        moveBlocks: moveBlocks
    };
}
var $be71c46f23d27718$export$2e2bcd8739ae039 = $be71c46f23d27718$var$useBlockMove;








// Hook for change state of click if previous state is not the same
function $6648c02fb489fe82$var$useClick() {
    const { setPressDown: setPressDown } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const { pressDown: pressDown } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const onClickDown = ()=>{
        if (pressDown == true) return false;
        setPressDown(true);
        return true;
    };
    const onClickUp = ()=>{
        if (pressDown == false) return false;
        setPressDown(false);
        return true;
    };
    return {
        onClickDown: onClickDown,
        onClickUp: onClickUp,
        pressDown: pressDown
    };
}
var $6648c02fb489fe82$export$2e2bcd8739ae039 = $6648c02fb489fe82$var$useClick;




// Hook for group all the action key on the bot editor 'mouse click' and 'shift key'
function $e99e41325e6ea579$var$useActionKey() {
    const { onKeyDown: onKeyDown, onKeyUp: onKeyUp, ctrlKey: ctrlKey } = (0, $790f89914ea69ca7$export$2e2bcd8739ae039)();
    const { onClickDown: onClickDown, onClickUp: onClickUp, pressDown: pressDown } = (0, $6648c02fb489fe82$export$2e2bcd8739ae039)();
    const { pressShiftKey: pressShiftKey, shiftKey: shiftKey, changeShiftKey: changeShiftKey } = (0, $008a36c4d52c37da$export$2e2bcd8739ae039)();
    const { zoneSelectBlocks: zoneSelectBlocks } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    return {
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onClickDown: onClickDown,
        onClickUp: onClickUp,
        ctrlKey: ctrlKey,
        pressDown: pressDown,
        changeShiftKey: changeShiftKey,
        shiftKey: shiftKey
    };
}
var $e99e41325e6ea579$export$2e2bcd8739ae039 = $e99e41325e6ea579$var$useActionKey;


// Main component of the hook editor, this components required a lot of third party hooks and will be re-render often
function $d70b6b22b6d8b9c7$var$useBlockManager() {
    const { movePathTmp: movePathTmp, deletePathTmp: deletePathTmp, pathTmp: pathTmp, magnetPosition: magnetPosition, mouse: mouse } = (0, $4485e014d56a0228$export$2e2bcd8739ae039)();
    const { blocksSelected: blocksSelected, zoneSelectBlocks: zoneSelectBlocks, makeZoneSelection: makeZoneSelection, updateZoneSelection: updateZoneSelection, resetZoneSelection: resetZoneSelection, blockIdClicked: blockIdClicked } = (0, $ebd5a98e941728ff$export$2e2bcd8739ae039)();
    const { moveBlocks: moveBlocks } = (0, $be71c46f23d27718$export$2e2bcd8739ae039)();
    const { pressDown: pressDown, ctrlKey: ctrlKey, onClickDown: onClickDown, onClickUp: onClickUp, onKeyDown: onKeyDown, onKeyUp: onKeyUp, changeShiftKey: changeShiftKey, shiftKey: shiftKey } = (0, $e99e41325e6ea579$export$2e2bcd8739ae039)();
    const { panzone: panzone, getPosition: getPosition } = (0, $82092047ba9387bf$export$2e2bcd8739ae039)();
    const { deleteAllSelectedBlock: deleteAllSelectedBlock } = (0, $b160775e2cfdbb38$export$2e2bcd8739ae039)();
    const { updateBlocksPosition: updateBlocksPosition, updateCategory: updateCategory } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    // Those constant can be calculate in another place if needeed, their some condition who will be useful in the different function of this hook
    const isZoneSelectBlockActive = zoneSelectBlocks.x != 0 && zoneSelectBlocks.y != 0;
    const isZoneSelectBlockDesactive = zoneSelectBlocks.x == 0 && zoneSelectBlocks.y == 0;
    const isMousePositionNotSet = mouse.x != 0 && mouse.y != 0;
    const mouseMove = (e)=>{
        if (pathTmp) {
            panzone.pause();
            const { scale: scale } = getPosition();
            movePathTmp(e.clientX, e.clientY, scale);
            return;
        }
        if (shiftKey == true && ctrlKey == true && pressDown && (e.target.classList.contains("camera") || e.target.classList.contains("category_container")) && isZoneSelectBlockDesactive) {
            panzone.pause();
            makeZoneSelection(e.clientX, e.clientY);
            return;
        }
        if (shiftKey == true && ctrlKey == true && pressDown && isZoneSelectBlockActive) {
            panzone.pause();
            updateZoneSelection(e.clientX, e.clientY, getPosition());
            return;
        }
        if (e?.target?.classList?.contains("camera") && isZoneSelectBlockActive && (ctrlKey == false || pressDown == false)) {
            resetZoneSelection();
            return;
        }
        if (blocksSelected.length > 1 && shiftKey == false) {
            deleteAllSelectedBlock();
            return;
        }
        if (shiftKey == true && blocksSelected.find((block)=>block.id == blockIdClicked) == undefined) return;
        if (isMousePositionNotSet && pressDown) {
            panzone.pause();
            const { scale: scale } = getPosition();
            moveBlocks(blocksSelected, e.clientX, e.clientY, scale);
            return;
        }
    };
    const mouseUp = async (e)=>{
        // Check if click inside camera
        if (handleClick(e) == false) return;
        // check click
        if (onClickUp(e) == false) return;
        // check if camera instance exist for resume her (it's means user cannot move the camera until unlock)
        if (panzone) panzone.resume();
        // check if some block have been selected
        if (blocksSelected.length == 0) return;
        // if multiple selection is enabled then we continue our path
        if (isMousePositionNotSet == false) return;
        // To get to this point it's means a block have been selected, moved and now the user is realeased him
        const blocksPosition = [];
        blocksSelected.map((data)=>{
            const { block: block, id: id } = data;
            // Fix quick resume mouse who lead to unexpected bug can be cause if the user use to often the multiple select option
            if (block._x != undefined && block._y != undefined) blocksPosition.push({
                object_id: block.object_id,
                x: block._x,
                y: block._y
            });
            var block_dom = document.getElementById(id);
            if (block_dom) document.getElementById(id).classList.remove("grabbed");
        // Fix for custom class css, more effient and performant than a hook
        //document.getElementById(id).classList.remove("selected");
        });
        // If some blockPosition have been find then we update their position in the global state of the tree
        if (blocksPosition.length) {
            await updateBlocksPosition(blocksPosition);
            let category_ids = blocksSelected.map((element)=>element.block.bot_category_id).filter((block)=>block);
            if (category_ids.length == 0) return;
            updateCategory(category_ids);
        }
    // Just in case released all the block selected trought the state editor
    };
    const onClick = (e)=>{
        if (handleClick(e) == false || pathTmp == null) return;
        // If a click is inside the camera and the pathTmp is created we try to delete it, if the click if outside some composent
        // See deletePathTmp for implementation
        deletePathTmp(e.target.classList);
    };
    const handleClick = (e)=>{
        const element = document.querySelector(".camera");
        return element?.contains(e.target);
    };
    // Bind all the method defined in the hook on the body
    (0, $bh6RR.useEffect)(()=>{
        document.body.onmouseup = (e)=>{
            mouseUp(e);
            // A middeware for reset the multiple select zone of the bot
            if (zoneSelectBlocks.x != 0 && zoneSelectBlocks.y != 0) resetZoneSelection();
        };
        document.body.onmousemove = mouseMove;
        document.body.onclick = onClick;
        document.body.onmousedown = (e)=>{
            // A middeware to check if the click occured in the camera element, if no return (very useful, if missing then onmousedown will be trigger evrywhere, leak to a lof of issues)
            if (handleClick(e) == false) return;
            onClickDown(e);
        };
        document.body.onkeydown = (e)=>{
            onKeyDown(e);
            if (ctrlKey == shiftKey && shiftKey) return;
            if (e.shiftKey == false) return;
            changeShiftKey();
        //else if(!e.shiftKey && e.shiftKey != shiftKey) return;
        //changeShiftKey();
        };
        document.body.onkeyup = (e)=>{
            onKeyUp(e);
            // A middeware for reset the multiple select zone of the bot
            if (e.ctrlKey == false && zoneSelectBlocks.x != 0 && zoneSelectBlocks.y != 0) resetZoneSelection();
        //if(e.shiftKey == true) return;
        //changeShiftKey()
        };
        // 👇️ remove event listener when the component unmounts
        return ()=>{
            document.body.onmouseup = ()=>{};
            document.body.onmousemove = ()=>{};
            document.body.onclick = ()=>{};
            document.body.onmousedown = ()=>{};
            document.body.onkeydown = ()=>{};
            document.body.onkeyup = ()=>{};
        };
    // Lot of depencies stuff : remember if you use don't pass global param who are used in the method in the depencies array, their values will never be updated
    }, [
        blocksSelected,
        pathTmp,
        magnetPosition,
        ctrlKey,
        pressDown,
        zoneSelectBlocks,
        shiftKey
    ]);
    return null;
}
var $d70b6b22b6d8b9c7$export$2e2bcd8739ae039 = $d70b6b22b6d8b9c7$var$useBlockManager;





var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");














const $ba32a37ded098980$export$9eef7bfa988071fa = [
    {
        value: "#7AAFF9",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    className: "fas fa-cube",
                    style: {
                        color: "#7AAFF9"
                    }
                }),
                " "
            ]
        })
    },
    {
        value: "#76E570",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    className: "fas fa-cube",
                    style: {
                        color: "#76E570"
                    }
                }),
                " "
            ]
        })
    },
    {
        value: "#FFBD7C",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    className: "fas fa-cube",
                    style: {
                        color: "#FFBD7C"
                    }
                }),
                " "
            ]
        })
    },
    {
        value: "#FFDC7C",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    className: "fas fa-cube",
                    style: {
                        color: "#FFDC7C"
                    }
                }),
                " "
            ]
        })
    },
    {
        value: "#F77D79",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    className: "fas fa-cube",
                    style: {
                        color: "#F77D79"
                    }
                }),
                " "
            ]
        })
    },
    {
        value: "#BC70E5",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    className: "fas fa-cube",
                    style: {
                        color: "#BC70E5"
                    }
                }),
                " "
            ]
        })
    }
];




const $c027246ba724d501$var$BlockCategoryModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ category: category })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const { register: register, handleSubmit: handleSubmit, getValues: getValues, setValue: setValue, watch: watch, formState: { errors: errors }, formState: formState } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            name: category.name,
            color: category.color,
            note: category.categories_notes[0].description
        }
    });
    if ((0, $ba32a37ded098980$export$9eef7bfa988071fa).some((item)=>item.value === category.color) == false) (0, $ba32a37ded098980$export$9eef7bfa988071fa).push({
        value: category.color,
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    className: "fas fa-cube",
                    style: {
                        color: category.color
                    }
                }),
                " "
            ]
        })
    });
    const onSubmit = async ()=>{
        let dataToSend = getValues();
        modal.resolve(dataToSend);
        onClose();
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        name: "change-password",
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
            className: "block_category_modal",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                    children: " Update Category"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                    className: "category_modal_form_center",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "category_form_column_title",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Category's name",
                                    listLabelClassName: "field-modal"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ...register("name", {
                                        required: true,
                                        minLength: 3
                                    }),
                                    placeholder: "Enter the label of the category",
                                    className: "statement_form_column_text_input",
                                    style: errors.name ? {
                                        borderColor: "red"
                                    } : {}
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "error",
                                    style: {
                                        fontSize: "14px",
                                        marginTop: "5px",
                                        height: "10px"
                                    },
                                    children: errors.name ? errors.name.message ? errors.name.message : "At least 3 letters" : ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "color_perso_checkbox title_container",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Perso color",
                                    listLabelClassName: "field-modal"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                        ...register("color_perso"),
                                        name: "color_perso",
                                        onChange: (val)=>setValue("color_perso", val.target.checked),
                                        checked: false
                                    })
                                })
                            ]
                        }),
                        watch("color_perso") == true ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "color_container",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Color of the category",
                                    listLabelClassName: "label_color",
                                    listClassName: "field_color"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "color_area",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "category_form_column_color",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                            ...register("color"),
                                            defaultValue: category.color,
                                            type: "color",
                                            className: "input_color"
                                        })
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "color_prefab_list_container title_container",
                            style: {
                                gap: "15%",
                                marginLeft: "0px",
                                marginBottom: "15px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Color prefab",
                                    listLabelClassName: "field-modal"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                        ...register("color"),
                                        setValue: setValue,
                                        choices: (0, $ba32a37ded098980$export$9eef7bfa988071fa),
                                        width: "100px",
                                        defaultChoice: category.color
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "category_form_column_title",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Category's note",
                                    listLabelClassName: "field-modal"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ...register("note"),
                                    placeholder: "Enter your note",
                                    className: "statement_form_column_text_input"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                            className: "cancel",
                            label: "Cancel",
                            type: "button",
                            onClick: ()=>onClose(),
                            style: {
                                marginRight: "20px"
                            }
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                            className: "validate",
                            label: "Update",
                            type: "submit",
                            disabled: !formState.isValid
                        })
                    ]
                })
            ]
        })
    });
});
var $c027246ba724d501$export$2e2bcd8739ae039 = $c027246ba724d501$var$BlockCategoryModal;





function $fc1882df7429762d$var$Category({ informations: informations }) {
    const [hover, setHover] = (0, $bh6RR.useState)(false);
    const { lockCategory: lockCategory, deleteCategory: deleteCategory, updateCategory: updateCategory } = (0, $973e14c0042f043b$export$2e2bcd8739ae039)();
    const [infoCategory, setInfoCategory] = (0, $bh6RR.useState)(informations);
    const [hoverLock, setHoverLock] = (0, $bh6RR.useState)(false);
    const getBlocksCategory = ()=>{
        return infoCategory.category.categories_blocks.map((block)=>block.blocks);
    };
    const getTransformStyle = ()=>{
        let blocks = getBlocksCategory();
        if (blocks.length === 0) {
            console.log("infoCategory", infoCategory);
            return "0px,0px,0px";
        }
        let transform = (0, $de8445459366d219$export$d7ec51f087bd61a3)(blocks);
        return transform.x + "px," + transform.y + "px," + 0 + "px";
    };
    const getHeightCategory = ()=>{
        let blocks = getBlocksCategory();
        return (0, $de8445459366d219$export$c08559766941f856)(blocks);
    };
    const getWidthCategory = ()=>{
        let blocks = getBlocksCategory();
        return (0, $de8445459366d219$export$3c49c185de0c2bfc)(blocks);
    };
    const onClickDeleteCategory = async ()=>{
        deleteCategory(infoCategory.category.id);
    };
    const showEditCategory = ()=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $c027246ba724d501$export$2e2bcd8739ae039), {
            category: infoCategory.category
        }).then((data)=>updateCategory(infoCategory.category.id, data));
    const onClickLockCategory = async ()=>{
        lockCategory(infoCategory.category.id, !infoCategory.category.locked);
    };
    const hexToRGB = (hex)=>{
        var r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
        return "rgba(" + r + ", " + g + ", " + b + ", " + 0.2 + ")";
    };
    (0, $bh6RR.useEffect)(()=>{
        setInfoCategory(informations);
    }, [
        informations
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: infoCategory && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            id: infoCategory.category.object_id,
            className: "category_container " + (hover ? "category_hovered" : ""),
            style: {
                transform: "translate3d(" + getTransformStyle() + ")",
                width: getWidthCategory() != 0 ? getWidthCategory() + "px" : "200px",
                height: getHeightCategory() != 0 ? getHeightCategory() + "px" : "",
                backgroundColor: hexToRGB(infoCategory.category.color),
                borderColor: infoCategory.category.color,
                color: infoCategory.category.color
            },
            onMouseEnter: ()=>(0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("lock_bot_category") ? setHover(true) : setHover(false),
            onMouseLeave: ()=>{
                setHover(false);
            },
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "category_settings",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "category_title",
                        style: {
                            color: infoCategory.category.color
                        },
                        title: infoCategory.category.categories_notes[0].description,
                        children: [
                            infoCategory.category.categories_notes[0].description != "" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                className: "fas fa-info-circle",
                                title: infoCategory.category.categories_notes[0].description,
                                style: {
                                    marginRight: "10px"
                                }
                            }),
                            infoCategory.category.name
                        ]
                    }),
                    (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("lock_bot_category") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "category_options",
                        style: {
                            opacity: hover ? 1 : 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                className: "main-iconButton edit-hover modalButtons-input category_button_option category_button_lock",
                                style: {
                                    color: infoCategory.category.color
                                },
                                icon: infoCategory.category.locked ? hoverLock == false ? "fas fa-lock" : "fas fa-lock-open" : hoverLock == false ? "fas fa-lock-open" : "fas fa-lock",
                                onClick: onClickLockCategory,
                                onMouseEnter: ()=>setHoverLock(true),
                                onMouseLeave: ()=>setHoverLock(false)
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                className: "main-iconButton remove-hover modalButtons-input category_button_option category_button_remove " + (infoCategory.category.locked && "category_button_locked"),
                                style: {
                                    color: infoCategory.category.color
                                },
                                icon: "fas fa-trash",
                                onClick: onClickDeleteCategory,
                                disabled: infoCategory.category.locked
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                className: "main-iconButton edit-hover modalButtons-input category_button_option category_button_edit " + (infoCategory.category.locked && "category_button_locked"),
                                style: {
                                    color: infoCategory.category.color
                                },
                                icon: "fas fa-cog",
                                onClick: showEditCategory,
                                disabled: infoCategory.category.locked
                            })
                        ]
                    }) : null
                ]
            })
        })
    });
}
var $fc1882df7429762d$export$2e2bcd8739ae039 = $fc1882df7429762d$var$Category;



var $bh6RR = parcelRequire("bh6RR");






function $e6e8c6c5e0bc60e1$var$useCategorySelection() {
    var blocksSelected = [];
    const { blocksVisible: blocksVisible, blocks: blocks, categories: categories } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const { createCategory: createCategory, addBlocksInCategory: addBlocksInCategory } = (0, $973e14c0042f043b$export$2e2bcd8739ae039)();
    const { panzone: panzone } = (0, $e677ba9f021c00cc$export$395166f91704e8fd)();
    const { getPosition: getPosition } = (0, $82092047ba9387bf$export$2e2bcd8739ae039)();
    const [positionStartCategory, setPositionStartCategory] = (0, $bh6RR.useState)({
        x: 0,
        y: 0
    });
    const { makeZoneSelection: makeZoneSelection, updateZoneSelection: updateZoneSelection, resetZoneSelection: resetZoneSelection, deselectAllBlocks: deselectAllBlocks } = (0, $ebd5a98e941728ff$export$2e2bcd8739ae039)();
    const handleMouseDown = ({ buttons: buttons, clientX: clientX, clientY: clientY })=>{
        if (buttons != 2) return;
        makeZoneSelection(clientX, clientY);
        setPositionStartCategory({
            x: clientX,
            y: clientY
        });
    };
    const handleMouseMove = ({ buttons: buttons, clientX: clientX, clientY: clientY }, positionStartCategory)=>{
        if (buttons != 2 || panzone == null) return;
        let res = updateZoneSelection(clientX, clientY, getPosition(), positionStartCategory);
        if (res.length == blocksSelected.length) return;
        unselectOldBlocks(res, blocksSelected);
        blocksSelected = res;
    };
    const handleMouseUp = (e)=>{
        let { button: button, clientX: clientX, clientY: clientY } = e;
        if (button == 2 && isInInterfaceArea(clientX, clientY) == false) {
            deselectAllBlocks(blocksSelected);
            resetZoneSelection();
            if (blocksSelected.length > 0) createNewCategory();
            blocksSelected = [];
        }
        if (button == 0 && blocks.length > 0) {
            const clickedElements = document.elementsFromPoint(clientX, clientY);
            const isOnButton = clickedElements.some((element)=>element.tagName.toLowerCase() == "button");
            if (isOnButton) return;
            checkingMovement(clientX, clientY);
        }
    };
    const createNewCategory = async ()=>{
        let blocks_id = blocksSelected.map((block)=>block.id);
        createCategory(blocks_id);
    };
    const checkingMovement = (clientX, clientY)=>{
        let elements = Array.from(document.querySelectorAll(".block.selected"));
        if (elements.length == 0) return;
        let listBlockSelected = elements.map((element)=>blocks[(0, $48a09b490a4e5bc7$export$2e2bcd8739ae039)(blocks, element.id)]);
        let res = listBlockSelected.map((block)=>block.bot_category_id); // on recherche les blocks cliquees dans la liste, et on recupere leur category
        //on supprime les doublons des categories, dans le cas ou on selectionne differents block de la meme category
        res = res.filter((value, index, self)=>{
            return value && self.indexOf(value) === index;
        }); // https://www.geeksforgeeks.org/how-to-remove-duplicate-elements-from-javascript-array/
        if (res.length == 0) {
            checkAddingBlocksInCategory(clientX, clientY, listBlockSelected);
            return;
        }
    };
    const checkAddingBlocksInCategory = async (clientX, clientY, listBlockSelected)=>{
        let elements = document.elementsFromPoint(clientX, clientY) //.getElementsByClassName("category_container")//.forEach(el => el.matches(".category_container"));
        ;
        let category = elements.find((element)=>element.classList.contains("category_container"));
        if (!category || isInInterfaceArea(clientX, clientY) == true) return;
        let category_id = categories.find((c)=>c.category.object_id === category.id).category.id;
        addBlocksInCategory(category_id, listBlockSelected);
    };
    const unselectOldBlocks = (newBlocks, oldBlocks)=>{
        let blocksToDeselect = [];
        for(let i = 0; i < oldBlocks.length; i++){
            let block = oldBlocks[i];
            let isFound = false;
            for(let j = 0; j < newBlocks.length; j++){
                if (!(block.id === newBlocks[j].id)) continue;
                isFound = true;
            }
            if (isFound) continue;
            blocksToDeselect.push(block);
        }
        deselectAllBlocks(blocksToDeselect);
        return newBlocks;
    };
    const handleRightClick = (e)=>{
        let { clientX: clientX, clientY: clientY } = e;
        if (isInInterfaceArea(clientX, clientY) == false) {
            e.preventDefault();
            return;
        }
    };
    const isInInterfaceArea = (clientX, clientY)=>{
        var clickedElement = document.elementsFromPoint(clientX, clientY);
        clickedElement = clickedElement[0]?.id == "zone_blocks_selection" ? clickedElement[1].classList : clickedElement[0]?.classList;
        if (clickedElement == undefined) return false;
        const isInInterface = !(clickedElement.contains("camera") || clickedElement.contains("block") || clickedElement.contains("category_container")); // .some(element => element.classList.contains('interface_editor'));
        return isInInterface;
    };
    (0, $bh6RR.useEffect)(()=>{
        const mouseDownHandler = handleMouseDown;
        document.addEventListener("mousedown", mouseDownHandler);
        return ()=>{
            document.removeEventListener("mousedown", mouseDownHandler);
        };
    }, [
        blocksVisible
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const mouseMoveHandler = (e)=>handleMouseMove(e, positionStartCategory);
        const contextMenuHandler = (e)=>handleRightClick(e);
        const mouseUpHandler = handleMouseUp;
        document.addEventListener("mousemove", mouseMoveHandler);
        document.addEventListener("contextmenu", contextMenuHandler);
        document.addEventListener("mouseup", mouseUpHandler);
        return ()=>{
            document.removeEventListener("mousemove", mouseMoveHandler);
            document.removeEventListener("contextmenu", contextMenuHandler);
            document.removeEventListener("mouseup", mouseUpHandler);
        };
    }, [
        positionStartCategory,
        blocks
    ]);
    return null;
}
var $e6e8c6c5e0bc60e1$export$2e2bcd8739ae039 = $e6e8c6c5e0bc60e1$var$useCategorySelection;



// Component For listing all the blocks visible
function $d2a676f1ff93d544$var$BlockContainer() {
    const { blocksVisible: blocksVisible, categories: categories } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const { onClickDuplicate: duplicateBlock, onClickDelete: deleteBlock } = (0, $a0e45a3dff6fe683$export$2e2bcd8739ae039)();
    (0, $d70b6b22b6d8b9c7$export$2e2bcd8739ae039)();
    (0, $e6e8c6c5e0bc60e1$export$2e2bcd8739ae039)();
    const { panzone: panzone } = (0, $e677ba9f021c00cc$export$395166f91704e8fd)();
    const hoveredElementRef = (0, $bh6RR.useRef)(null);
    var scale = 1;
    if (panzone) scale = panzone.getTransform().scale;
    const handleKeyDown = (e)=>{
        let method = "";
        let params = [];
        if ((e.ctrlKey || e.metaKey) && e.key === "d") {
            method = duplicateBlock;
            params = (block)=>[
                    block.id
                ];
        } else if (e.key == "Delete") {
            method = deleteBlock;
            params = (block)=>[
                    block?.classList.toString().split(" ")[1],
                    true,
                    block.id
                ];
        }
        if (method == "") return;
        let block = getBlockHovered();
        if (!block || block.classList.contains("scenario")) return;
        method(...params(block));
        e.preventDefault(); // pour ne pas avoir l'ajout de favori ou autre chose bizarre...
    };
    const getBlockHovered = ()=>{
        let elements = Array.from(document.querySelectorAll(":hover"));
        let blockHovered = elements.filter((element)=>element.classList.contains("block") && element.id.includes("_"));
        if (blockHovered.length == 0 || blockHovered.length > 1) return null;
        return blockHovered[0];
    };
    (0, $bh6RR.useEffect)(()=>{
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        blocksVisible
    ]);
    const handleMouseEnter = (e)=>{
        hoveredElementRef.current = e.target;
    };
    const handleMouseLeave = ()=>{
        hoveredElementRef.current = null;
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "blocks_container",
        children: [
            blocksVisible && blocksVisible.map((block, i)=>{
                const Block = (0, $91038ec84b81c133$export$2e2bcd8739ae039)[block.type.name];
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    onMouseEnter: handleMouseEnter,
                    onMouseLeave: handleMouseLeave,
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)(Block, {
                            ...block,
                            lowVersion: scale < 0.3
                        }, block.object_id),
                        " "
                    ]
                }, i);
            }),
            categories && categories.map((category, i)=>{
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fc1882df7429762d$export$2e2bcd8739ae039), {
                    informations: category
                }, i);
            })
        ]
    });
}
var $d2a676f1ff93d544$export$2e2bcd8739ae039 = $d2a676f1ff93d544$var$BlockContainer;





var $bh6RR = parcelRequire("bh6RR");




function $e88fb9e1760db3c6$var$Path({ path_id: path_id, parent_block_id: parent_block_id, child_block_id: child_block_id }) {
    const { searchPath: searchPath, deletePath: deletePath } = (0, $3ef1c61908149445$export$2e2bcd8739ae039)();
    const path = searchPath({
        path_id: path_id,
        parent_block_id: parent_block_id,
        child_block_id: child_block_id
    });
    const { shiftKey: shiftKey } = (0, $008a36c4d52c37da$export$2e2bcd8739ae039)();
    if (!path) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
    const { x: x, y: y, _x: _x, _y: _y, height: height, _height: _height, index: index } = path;
    const { data: data, stroke: stroke } = (0, $c7a2343ef3cc915a$export$2e2bcd8739ae039)(x, y, _x, _y, height, _height, index);
    const onMouseEnter = (e)=>{
        if (shiftKey == true) return;
        e.target.style.stroke = "var(--pink)";
    };
    const onMouseLeave = (e)=>{
        if (shiftKey == true) return;
        e.target.style.stroke = "";
    };
    const onClick = (e)=>{
        if (shiftKey == true) return;
        deletePath(path_id);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
        id: path_id,
        d: data,
        style: {
            cursor: shiftKey == true ? "not-allowed" : "pointer",
            transition: "stroke 0.4s ease 0s"
        },
        strokeWidth: "2px",
        fill: "none",
        stroke: stroke,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClick
    });
}
var // This part is useful for optimization, when the path is rendered we don't touch it from outside (cost to must ressources with rerender, the component wil rerender it self if needed)
$e88fb9e1760db3c6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $bh6RR.memo)($e88fb9e1760db3c6$var$Path, function(prevPath, nextPath) {
    return prevPath.path_id == nextPath.path_id;
});





// Components who will display all the path who need to be display
function $99d7e10a3978d587$var$PathContainer() {
    const { pathsVisible: pathsVisible } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const { pathTmp: pathTmp } = (0, $7324df5b25c181de$export$2fe873ee5eb16329)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        className: "svgs_container",
        style: {
            overflow: "visible"
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                id: "path_tmp",
                style: {
                    opacity: pathTmp ? 1 : 0
                },
                fill: "none",
                strokeWidth: "2px",
                strokeDasharray: "10,10"
            }),
            pathsVisible && pathsVisible.map((path)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e88fb9e1760db3c6$export$2e2bcd8739ae039), {
                    ...path
                }, path.path_id))
        ]
    });
}
var $99d7e10a3978d587$export$2e2bcd8739ae039 = $99d7e10a3978d587$var$PathContainer;




var $bh6RR = parcelRequire("bh6RR");
var $45999efe49292c09$exports = {};
/**
 * Allows to drag and zoom svg elements
 */ var $a29e1fec6928480a$exports = {};
/**
 * This module used to unify mouse wheel behavior between different browsers in 2014
 * Now it's just a wrapper around addEventListener('wheel');
 *
 * Usage:
 *  var addWheelListener = require('wheel').addWheelListener;
 *  var removeWheelListener = require('wheel').removeWheelListener;
 *  addWheelListener(domElement, function (e) {
 *    // mouse wheel event
 *  });
 *  removeWheelListener(domElement, function);
 */ $a29e1fec6928480a$exports = $a29e1fec6928480a$var$addWheelListener;
// But also expose "advanced" api with unsubscribe:
$a29e1fec6928480a$exports.addWheelListener = $a29e1fec6928480a$var$addWheelListener;
$a29e1fec6928480a$exports.removeWheelListener = $a29e1fec6928480a$var$removeWheelListener;
function $a29e1fec6928480a$var$addWheelListener(element, listener, useCapture) {
    element.addEventListener("wheel", listener, useCapture);
}
function $a29e1fec6928480a$var$removeWheelListener(element, listener, useCapture) {
    element.removeEventListener("wheel", listener, useCapture);
}


var $37dd74a6caeaf357$exports = {};
var $257b039c43078334$exports = {};
/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */ // These values are established by empiricism with tests (tradeoff: performance VS precision)
var $257b039c43078334$var$NEWTON_ITERATIONS = 4;
var $257b039c43078334$var$NEWTON_MIN_SLOPE = 0.001;
var $257b039c43078334$var$SUBDIVISION_PRECISION = 0.0000001;
var $257b039c43078334$var$SUBDIVISION_MAX_ITERATIONS = 10;
var $257b039c43078334$var$kSplineTableSize = 11;
var $257b039c43078334$var$kSampleStepSize = 1.0 / ($257b039c43078334$var$kSplineTableSize - 1.0);
var $257b039c43078334$var$float32ArraySupported = typeof Float32Array === "function";
function $257b039c43078334$var$A(aA1, aA2) {
    return 1.0 - 3.0 * aA2 + 3.0 * aA1;
}
function $257b039c43078334$var$B(aA1, aA2) {
    return 3.0 * aA2 - 6.0 * aA1;
}
function $257b039c43078334$var$C(aA1) {
    return 3.0 * aA1;
}
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
function $257b039c43078334$var$calcBezier(aT, aA1, aA2) {
    return (($257b039c43078334$var$A(aA1, aA2) * aT + $257b039c43078334$var$B(aA1, aA2)) * aT + $257b039c43078334$var$C(aA1)) * aT;
}
// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
function $257b039c43078334$var$getSlope(aT, aA1, aA2) {
    return 3.0 * $257b039c43078334$var$A(aA1, aA2) * aT * aT + 2.0 * $257b039c43078334$var$B(aA1, aA2) * aT + $257b039c43078334$var$C(aA1);
}
function $257b039c43078334$var$binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX, currentT, i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = $257b039c43078334$var$calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > $257b039c43078334$var$SUBDIVISION_PRECISION && ++i < $257b039c43078334$var$SUBDIVISION_MAX_ITERATIONS);
    return currentT;
}
function $257b039c43078334$var$newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for(var i = 0; i < $257b039c43078334$var$NEWTON_ITERATIONS; ++i){
        var currentSlope = $257b039c43078334$var$getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        var currentX = $257b039c43078334$var$calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
function $257b039c43078334$var$LinearEasing(x) {
    return x;
}
$257b039c43078334$exports = function bezier(mX1, mY1, mX2, mY2) {
    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) throw new Error("bezier x values must be in [0, 1] range");
    if (mX1 === mY1 && mX2 === mY2) return $257b039c43078334$var$LinearEasing;
    // Precompute samples table
    var sampleValues = $257b039c43078334$var$float32ArraySupported ? new Float32Array($257b039c43078334$var$kSplineTableSize) : new Array($257b039c43078334$var$kSplineTableSize);
    for(var i = 0; i < $257b039c43078334$var$kSplineTableSize; ++i)sampleValues[i] = $257b039c43078334$var$calcBezier(i * $257b039c43078334$var$kSampleStepSize, mX1, mX2);
    function getTForX(aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = $257b039c43078334$var$kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += $257b039c43078334$var$kSampleStepSize;
        --currentSample;
        // Interpolate to provide an initial guess for t
        var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        var guessForT = intervalStart + dist * $257b039c43078334$var$kSampleStepSize;
        var initialSlope = $257b039c43078334$var$getSlope(guessForT, mX1, mX2);
        if (initialSlope >= $257b039c43078334$var$NEWTON_MIN_SLOPE) return $257b039c43078334$var$newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        else if (initialSlope === 0.0) return guessForT;
        else return $257b039c43078334$var$binarySubdivide(aX, intervalStart, intervalStart + $257b039c43078334$var$kSampleStepSize, mX1, mX2);
    }
    return function BezierEasing(x) {
        // Because JavaScript number are imprecise, we should guarantee the extremes are right.
        if (x === 0) return 0;
        if (x === 1) return 1;
        return $257b039c43078334$var$calcBezier(getTForX(x), mY1, mY2);
    };
};


// Predefined set of animations. Similar to CSS easing functions
var $37dd74a6caeaf357$var$animations = {
    ease: $257b039c43078334$exports(0.25, 0.1, 0.25, 1),
    easeIn: $257b039c43078334$exports(0.42, 0, 1, 1),
    easeOut: $257b039c43078334$exports(0, 0, 0.58, 1),
    easeInOut: $257b039c43078334$exports(0.42, 0, 0.58, 1),
    linear: $257b039c43078334$exports(0, 0, 1, 1)
};
$37dd74a6caeaf357$exports = $37dd74a6caeaf357$var$animate;
$37dd74a6caeaf357$exports.makeAggregateRaf = $37dd74a6caeaf357$var$makeAggregateRaf;
$37dd74a6caeaf357$exports.sharedScheduler = $37dd74a6caeaf357$var$makeAggregateRaf();
function $37dd74a6caeaf357$var$animate(source, target, options) {
    var start = Object.create(null);
    var diff = Object.create(null);
    options = options || {};
    // We let clients specify their own easing function
    var easing = typeof options.easing === "function" ? options.easing : $37dd74a6caeaf357$var$animations[options.easing];
    // if nothing is specified, default to ease (similar to CSS animations)
    if (!easing) {
        if (options.easing) console.warn("Unknown easing function in amator: " + options.easing);
        easing = $37dd74a6caeaf357$var$animations.ease;
    }
    var step = typeof options.step === "function" ? options.step : $37dd74a6caeaf357$var$noop;
    var done = typeof options.done === "function" ? options.done : $37dd74a6caeaf357$var$noop;
    var scheduler = $37dd74a6caeaf357$var$getScheduler(options.scheduler);
    var keys = Object.keys(target);
    keys.forEach(function(key) {
        start[key] = source[key];
        diff[key] = target[key] - source[key];
    });
    var durationInMs = typeof options.duration === "number" ? options.duration : 400;
    var durationInFrames = Math.max(1, durationInMs * 0.06) // 0.06 because 60 frames pers 1,000 ms
    ;
    var previousAnimationId;
    var frame = 0;
    previousAnimationId = scheduler.next(loop);
    return {
        cancel: cancel
    };
    function cancel() {
        scheduler.cancel(previousAnimationId);
        previousAnimationId = 0;
    }
    function loop() {
        var t = easing(frame / durationInFrames);
        frame += 1;
        setValues(t);
        if (frame <= durationInFrames) {
            previousAnimationId = scheduler.next(loop);
            step(source);
        } else {
            previousAnimationId = 0;
            setTimeout(function() {
                done(source);
            }, 0);
        }
    }
    function setValues(t) {
        keys.forEach(function(key) {
            source[key] = diff[key] * t + start[key];
        });
    }
}
function $37dd74a6caeaf357$var$noop() {}
function $37dd74a6caeaf357$var$getScheduler(scheduler) {
    if (!scheduler) {
        var canRaf = typeof window !== "undefined" && window.requestAnimationFrame;
        return canRaf ? $37dd74a6caeaf357$var$rafScheduler() : $37dd74a6caeaf357$var$timeoutScheduler();
    }
    if (typeof scheduler.next !== "function") throw new Error("Scheduler is supposed to have next(cb) function");
    if (typeof scheduler.cancel !== "function") throw new Error("Scheduler is supposed to have cancel(handle) function");
    return scheduler;
}
function $37dd74a6caeaf357$var$rafScheduler() {
    return {
        next: window.requestAnimationFrame.bind(window),
        cancel: window.cancelAnimationFrame.bind(window)
    };
}
function $37dd74a6caeaf357$var$timeoutScheduler() {
    return {
        next: function(cb) {
            return setTimeout(cb, 1000 / 60);
        },
        cancel: function(id) {
            return clearTimeout(id);
        }
    };
}
function $37dd74a6caeaf357$var$makeAggregateRaf() {
    var frontBuffer = new Set();
    var backBuffer = new Set();
    var frameToken = 0;
    return {
        next: next,
        cancel: next,
        clearAll: clearAll
    };
    function clearAll() {
        frontBuffer.clear();
        backBuffer.clear();
        cancelAnimationFrame(frameToken);
        frameToken = 0;
    }
    function next(callback) {
        backBuffer.add(callback);
        renderNextFrame();
    }
    function renderNextFrame() {
        if (!frameToken) frameToken = requestAnimationFrame(renderFrame);
    }
    function renderFrame() {
        frameToken = 0;
        var t = backBuffer;
        backBuffer = frontBuffer;
        frontBuffer = t;
        frontBuffer.forEach(function(callback) {
            callback();
        });
        frontBuffer.clear();
    }
    function cancel(callback) {
        backBuffer.delete(callback);
    }
}


var $89edfbd57686609d$exports = {};
$89edfbd57686609d$exports = function eventify(subject) {
    $89edfbd57686609d$var$validateSubject(subject);
    var eventsStorage = $89edfbd57686609d$var$createEventsStorage(subject);
    subject.on = eventsStorage.on;
    subject.off = eventsStorage.off;
    subject.fire = eventsStorage.fire;
    return subject;
};
function $89edfbd57686609d$var$createEventsStorage(subject) {
    // Store all event listeners to this hash. Key is event name, value is array
    // of callback records.
    //
    // A callback record consists of callback function and its optional context:
    // { 'eventName' => [{callback: function, ctx: object}] }
    var registeredEvents = Object.create(null);
    return {
        on: function(eventName, callback, ctx) {
            if (typeof callback !== "function") throw new Error("callback is expected to be a function");
            var handlers = registeredEvents[eventName];
            if (!handlers) handlers = registeredEvents[eventName] = [];
            handlers.push({
                callback: callback,
                ctx: ctx
            });
            return subject;
        },
        off: function(eventName, callback) {
            var wantToRemoveAll = typeof eventName === "undefined";
            if (wantToRemoveAll) {
                // Killing old events storage should be enough in this case:
                registeredEvents = Object.create(null);
                return subject;
            }
            if (registeredEvents[eventName]) {
                var deleteAllCallbacksForEvent = typeof callback !== "function";
                if (deleteAllCallbacksForEvent) delete registeredEvents[eventName];
                else {
                    var callbacks = registeredEvents[eventName];
                    for(var i = 0; i < callbacks.length; ++i)if (callbacks[i].callback === callback) callbacks.splice(i, 1);
                }
            }
            return subject;
        },
        fire: function(eventName) {
            var callbacks = registeredEvents[eventName];
            if (!callbacks) return subject;
            var fireArguments;
            if (arguments.length > 1) fireArguments = Array.prototype.splice.call(arguments, 1);
            for(var i = 0; i < callbacks.length; ++i){
                var callbackInfo = callbacks[i];
                callbackInfo.callback.apply(callbackInfo.ctx, fireArguments);
            }
            return subject;
        }
    };
}
function $89edfbd57686609d$var$validateSubject(subject) {
    if (!subject) throw new Error("Eventify cannot use falsy object as events subject");
    var reservedWords = [
        "on",
        "fire",
        "off"
    ];
    for(var i = 0; i < reservedWords.length; ++i){
        if (subject.hasOwnProperty(reservedWords[i])) throw new Error("Subject cannot be eventified, since it already has property '" + reservedWords[i] + "'");
    }
}


var $64b947347a9a88a3$exports = {};
/**
 * Allows smooth kinetic scrolling of the surface
 */ $64b947347a9a88a3$exports = $64b947347a9a88a3$var$kinetic;
function $64b947347a9a88a3$var$kinetic(getPoint, scroll, settings) {
    if (typeof settings !== "object") // setting could come as boolean, we should ignore it, and use an object.
    settings = {};
    var minVelocity = typeof settings.minVelocity === "number" ? settings.minVelocity : 5;
    var amplitude = typeof settings.amplitude === "number" ? settings.amplitude : 0.25;
    var cancelAnimationFrame1 = typeof settings.cancelAnimationFrame === "function" ? settings.cancelAnimationFrame : $64b947347a9a88a3$var$getCancelAnimationFrame();
    var requestAnimationFrame1 = typeof settings.requestAnimationFrame === "function" ? settings.requestAnimationFrame : $64b947347a9a88a3$var$getRequestAnimationFrame();
    let callWhenMotionStart = typeof settings.callWhenMotionStart === "function" ? settings.callWhenMotionStart : false;
    let callWhenMotionStops = typeof settings.callWhenMotionStops === "function" ? settings.callWhenMotionStops : false;
    var lastPoint;
    var timestamp;
    var timeConstant = 342;
    var ticker;
    var vx, targetX, ax;
    var vy, targetY, ay;
    var raf;
    return {
        start: start,
        stop: stop,
        cancel: dispose
    };
    function dispose() {
        cancelAnimationFrame1(ticker);
        cancelAnimationFrame1(raf);
    }
    function start() {
        if (callWhenMotionStart != false) callWhenMotionStart();
        lastPoint = getPoint();
        ax = ay = vx = vy = 0;
        timestamp = new Date();
        cancelAnimationFrame1(ticker);
        cancelAnimationFrame1(raf);
        // we start polling the point position to accumulate velocity
        // Once we stop(), we will use accumulated velocity to keep scrolling
        // an object.
        ticker = requestAnimationFrame1(track);
    }
    function track() {
        var now = Date.now();
        var elapsed = now - timestamp;
        timestamp = now;
        var currentPoint = getPoint();
        var dx = currentPoint.x - lastPoint.x;
        var dy = currentPoint.y - lastPoint.y;
        lastPoint = currentPoint;
        var dt = 1000 / (1 + elapsed);
        // moving average
        vx = 0.8 * dx * dt + 0.2 * vx;
        vy = 0.8 * dy * dt + 0.2 * vy;
        ticker = requestAnimationFrame1(track);
    }
    function stop() {
        cancelAnimationFrame1(ticker);
        cancelAnimationFrame1(raf);
        var currentPoint = getPoint();
        targetX = currentPoint.x;
        targetY = currentPoint.y;
        timestamp = Date.now();
        if (vx < -minVelocity || vx > minVelocity) {
            ax = amplitude * vx;
            targetX += ax;
        }
        if (vy < -minVelocity || vy > minVelocity) {
            ay = amplitude * vy;
            targetY += ay;
        }
        raf = requestAnimationFrame1(autoScroll);
    }
    function autoScroll() {
        var elapsed = Date.now() - timestamp;
        var moving = false;
        var dx = 0;
        var dy = 0;
        if (ax) {
            dx = -ax * Math.exp(-elapsed / timeConstant);
            if (dx > 0.5 || dx < -0.5) moving = true;
            else dx = ax = 0;
        }
        if (ay) {
            dy = -ay * Math.exp(-elapsed / timeConstant);
            if (dy > 0.5 || dy < -0.5) moving = true;
            else dy = ay = 0;
        }
        if (moving) {
            scroll(targetX + dx, targetY + dy);
            raf = requestAnimationFrame1(autoScroll);
        } else if (callWhenMotionStops !== false) callWhenMotionStops();
    }
}
function $64b947347a9a88a3$var$getCancelAnimationFrame() {
    if (typeof cancelAnimationFrame === "function") return cancelAnimationFrame;
    return clearTimeout;
}
function $64b947347a9a88a3$var$getRequestAnimationFrame() {
    if (typeof requestAnimationFrame === "function") return requestAnimationFrame;
    return function(handler) {
        return setTimeout(handler, 16);
    };
}


var $0eeb8a1524857bb5$exports = {};
/**
 * Disallows selecting text.
 */ $0eeb8a1524857bb5$exports = $0eeb8a1524857bb5$var$createTextSelectionInterceptor;
function $0eeb8a1524857bb5$var$createTextSelectionInterceptor(useFake) {
    if (useFake) return {
        capture: $0eeb8a1524857bb5$var$noop,
        release: $0eeb8a1524857bb5$var$noop
    };
    var dragObject;
    var prevSelectStart;
    var prevDragStart;
    var wasCaptured = false;
    return {
        capture: capture,
        release: release
    };
    function capture(domObject) {
        wasCaptured = true;
        prevSelectStart = window.document.onselectstart;
        prevDragStart = window.document.ondragstart;
        window.document.onselectstart = $0eeb8a1524857bb5$var$disabled;
        dragObject = domObject;
        dragObject.ondragstart = $0eeb8a1524857bb5$var$disabled;
    }
    function release() {
        if (!wasCaptured) return;
        wasCaptured = false;
        window.document.onselectstart = prevSelectStart;
        if (dragObject) dragObject.ondragstart = prevDragStart;
    }
}
function $0eeb8a1524857bb5$var$disabled(e) {
    e.stopPropagation();
    return false;
}
function $0eeb8a1524857bb5$var$noop() {}


var $45999efe49292c09$var$domTextSelectionInterceptor = $0eeb8a1524857bb5$exports();
var $45999efe49292c09$var$fakeTextSelectorInterceptor = $0eeb8a1524857bb5$exports(true);
var $d41cef0cd9d7b48b$exports = {};
$d41cef0cd9d7b48b$exports = $d41cef0cd9d7b48b$var$Transform;
function $d41cef0cd9d7b48b$var$Transform() {
    this.x = 0;
    this.y = 0;
    this.scale = 1;
}


var $c7b661f507eff49a$exports = {};
$c7b661f507eff49a$exports = $c7b661f507eff49a$var$makeSvgController;
$c7b661f507eff49a$exports.canAttach = $c7b661f507eff49a$var$isSVGElement;
function $c7b661f507eff49a$var$makeSvgController(svgElement, options) {
    if (!$c7b661f507eff49a$var$isSVGElement(svgElement)) throw new Error("svg element is required for svg.panzoom to work");
    var owner = svgElement.ownerSVGElement;
    if (!owner) throw new Error("Do not apply panzoom to the root <svg> element. Use its child instead (e.g. <g></g>). As of March 2016 only FireFox supported transform on the root element");
    if (!options.disableKeyboardInteraction) owner.setAttribute("tabindex", 0);
    var api = {
        getBBox: getBBox,
        getScreenCTM: getScreenCTM,
        getOwner: getOwner,
        applyTransform: applyTransform,
        initTransform: initTransform
    };
    return api;
    function getOwner() {
        return owner;
    }
    function getBBox() {
        var bbox = svgElement.getBBox();
        return {
            left: bbox.x,
            top: bbox.y,
            width: bbox.width,
            height: bbox.height
        };
    }
    function getScreenCTM() {
        var ctm = owner.getCTM();
        if (!ctm) // This is likely firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=873106
        // The code below is not entirely correct, but still better than nothing
        return owner.getScreenCTM();
        return ctm;
    }
    function initTransform(transform) {
        var screenCTM = svgElement.getCTM();
        // The above line returns null on Firefox
        if (screenCTM === null) screenCTM = document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGMatrix();
        transform.x = screenCTM.e;
        transform.y = screenCTM.f;
        transform.scale = screenCTM.a;
        owner.removeAttributeNS(null, "viewBox");
    }
    function applyTransform(transform) {
        svgElement.setAttribute("transform", "matrix(" + transform.scale + " 0 0 " + transform.scale + " " + transform.x + " " + transform.y + ")");
    }
}
function $c7b661f507eff49a$var$isSVGElement(element) {
    return element && element.ownerSVGElement && element.getCTM;
}


var $7a55c286ce5a2ae9$exports = {};
$7a55c286ce5a2ae9$exports = $7a55c286ce5a2ae9$var$makeDomController;
$7a55c286ce5a2ae9$exports.canAttach = $7a55c286ce5a2ae9$var$isDomElement;
function $7a55c286ce5a2ae9$var$makeDomController(domElement, options) {
    var elementValid = $7a55c286ce5a2ae9$var$isDomElement(domElement);
    if (!elementValid) throw new Error("panzoom requires DOM element to be attached to the DOM tree");
    var owner = domElement.parentElement;
    domElement.scrollTop = 0;
    if (!options.disableKeyboardInteraction) owner.setAttribute("tabindex", 0);
    var api = {
        getBBox: getBBox,
        getOwner: getOwner,
        applyTransform: applyTransform
    };
    return api;
    function getOwner() {
        return owner;
    }
    function getBBox() {
        // TODO: We should probably cache this?
        return {
            left: 0,
            top: 0,
            width: domElement.clientWidth,
            height: domElement.clientHeight
        };
    }
    function applyTransform(transform) {
        // TODO: Should we cache this?
        domElement.style.transformOrigin = "0 0 0";
        domElement.style.transform = "matrix(" + transform.scale + ", 0, 0, " + transform.scale + ", " + transform.x + ", " + transform.y + ")";
    }
}
function $7a55c286ce5a2ae9$var$isDomElement(element) {
    return element && element.parentElement && element.style;
}


var $45999efe49292c09$var$defaultZoomSpeed = 1;
var $45999efe49292c09$var$defaultDoubleTapZoomSpeed = 1.75;
var $45999efe49292c09$var$doubleTapSpeedInMS = 300;
var $45999efe49292c09$var$clickEventTimeInMS = 200;
$45999efe49292c09$exports = $45999efe49292c09$var$createPanZoom;
/**
 * Creates a new instance of panzoom, so that an object can be panned and zoomed
 *
 * @param {DOMElement} domElement where panzoom should be attached.
 * @param {Object} options that configure behavior.
 */ function $45999efe49292c09$var$createPanZoom(domElement, options) {
    options = options || {};
    var panController = options.controller;
    if (!panController) {
        if ($c7b661f507eff49a$exports.canAttach(domElement)) panController = $c7b661f507eff49a$exports(domElement, options);
        else if ($7a55c286ce5a2ae9$exports.canAttach(domElement)) panController = $7a55c286ce5a2ae9$exports(domElement, options);
    }
    if (!panController) throw new Error("Cannot create panzoom for the current type of dom element");
    var owner = panController.getOwner();
    // just to avoid GC pressure, every time we do intermediate transform
    // we return this object. For internal use only. Never give it back to the consumer of this library
    var storedCTMResult = {
        x: 0,
        y: 0
    };
    var isDirty = false;
    var transform = new $d41cef0cd9d7b48b$exports();
    if (panController.initTransform) panController.initTransform(transform);
    var filterKey = typeof options.filterKey === "function" ? options.filterKey : $45999efe49292c09$var$noop;
    // TODO: likely need to unite pinchSpeed with zoomSpeed
    var pinchSpeed = typeof options.pinchSpeed === "number" ? options.pinchSpeed : 1;
    var bounds = options.bounds;
    var maxZoom = typeof options.maxZoom === "number" ? options.maxZoom : Number.POSITIVE_INFINITY;
    var minZoom = typeof options.minZoom === "number" ? options.minZoom : 0;
    var boundsPadding = typeof options.boundsPadding === "number" ? options.boundsPadding : 0.05;
    var zoomDoubleClickSpeed = typeof options.zoomDoubleClickSpeed === "number" ? options.zoomDoubleClickSpeed : $45999efe49292c09$var$defaultDoubleTapZoomSpeed;
    var beforeWheel = options.beforeWheel || $45999efe49292c09$var$noop;
    var beforeMouseDown = options.beforeMouseDown || $45999efe49292c09$var$noop;
    var speed = typeof options.zoomSpeed === "number" ? options.zoomSpeed : $45999efe49292c09$var$defaultZoomSpeed;
    var transformOrigin = $45999efe49292c09$var$parseTransformOrigin(options.transformOrigin);
    var textSelection = options.enableTextSelection ? $45999efe49292c09$var$fakeTextSelectorInterceptor : $45999efe49292c09$var$domTextSelectionInterceptor;
    $45999efe49292c09$var$validateBounds(bounds);
    if (options.autocenter) autocenter();
    var frameAnimation;
    var lastTouchEndTime = 0;
    var lastTouchStartTime = 0;
    var pendingClickEventTimeout = 0;
    var lastMouseDownedEvent = null;
    var lastMouseDownTime = new Date();
    var lastSingleFingerOffset;
    var touchInProgress = false;
    // We only need to fire panstart when actual move happens
    var panstartFired = false;
    // cache mouse coordinates here
    var mouseX;
    var mouseY;
    // Where the first click has happened, so that we can differentiate
    // between pan and click
    var clickX;
    var clickY;
    var pinchZoomLength;
    var smoothScroll;
    if ("smoothScroll" in options && !options.smoothScroll) // If user explicitly asked us not to use smooth scrolling, we obey
    smoothScroll = $45999efe49292c09$var$rigidScroll();
    else {
        // otherwise we use forward smoothScroll settings to kinetic API
        // which makes scroll smoothing.
        if (options.smoothScroll == undefined) options.smoothScroll = {};
        options.smoothScroll.callWhenMotionStart = triggerTransformStart;
        options.smoothScroll.callWhenMotionStops = triggerTransformEnd;
        smoothScroll = $64b947347a9a88a3$exports(getPoint, scroll, options.smoothScroll);
    }
    var moveByAnimation;
    var zoomToAnimation;
    var multiTouch;
    var paused = false;
    listenForEvents();
    var api = {
        dispose: dispose,
        moveBy: internalMoveBy,
        moveTo: moveTo,
        smoothMoveTo: smoothMoveTo,
        centerOn: centerOn,
        zoomTo: publicZoomTo,
        zoomAbs: zoomAbs,
        smoothZoom: smoothZoom,
        smoothZoomAbs: smoothZoomAbs,
        showRectangle: showRectangle,
        pause: pause,
        resume: resume,
        isPaused: isPaused,
        getTransform: getTransformModel,
        getMinZoom: getMinZoom,
        setMinZoom: setMinZoom,
        getMaxZoom: getMaxZoom,
        setMaxZoom: setMaxZoom,
        getTransformOrigin: getTransformOrigin,
        setTransformOrigin: setTransformOrigin,
        getZoomSpeed: getZoomSpeed,
        setZoomSpeed: setZoomSpeed
    };
    $89edfbd57686609d$exports(api);
    var initialX = typeof options.initialX === "number" ? options.initialX : transform.x;
    var initialY = typeof options.initialY === "number" ? options.initialY : transform.y;
    var initialZoom = typeof options.initialZoom === "number" ? options.initialZoom : transform.scale;
    if (initialX != transform.x || initialY != transform.y || initialZoom != transform.scale) zoomAbs(initialX, initialY, initialZoom);
    return api;
    function pause() {
        releaseEvents();
        paused = true;
    }
    function resume() {
        if (paused) {
            listenForEvents();
            paused = false;
        }
    }
    function isPaused() {
        return paused;
    }
    function showRectangle(rect) {
        // TODO: this duplicates autocenter. I think autocenter should go.
        var clientRect = owner.getBoundingClientRect();
        var size = transformToScreen(clientRect.width, clientRect.height);
        var rectWidth = rect.right - rect.left;
        var rectHeight = rect.bottom - rect.top;
        if (!Number.isFinite(rectWidth) || !Number.isFinite(rectHeight)) throw new Error("Invalid rectangle");
        var dw = size.x / rectWidth;
        var dh = size.y / rectHeight;
        var scale = Math.min(dw, dh);
        transform.x = -(rect.left + rectWidth / 2) * scale + size.x / 2;
        transform.y = -(rect.top + rectHeight / 2) * scale + size.y / 2;
        transform.scale = scale;
    }
    function transformToScreen(x, y) {
        if (panController.getScreenCTM) {
            var parentCTM = panController.getScreenCTM();
            var parentScaleX = parentCTM.a;
            var parentScaleY = parentCTM.d;
            var parentOffsetX = parentCTM.e;
            var parentOffsetY = parentCTM.f;
            storedCTMResult.x = x * parentScaleX - parentOffsetX;
            storedCTMResult.y = y * parentScaleY - parentOffsetY;
        } else {
            storedCTMResult.x = x;
            storedCTMResult.y = y;
        }
        return storedCTMResult;
    }
    function autocenter() {
        var w; // width of the parent
        var h; // height of the parent
        var left = 0;
        var top = 0;
        var sceneBoundingBox = getBoundingBox();
        if (sceneBoundingBox) {
            // If we have bounding box - use it.
            left = sceneBoundingBox.left;
            top = sceneBoundingBox.top;
            w = sceneBoundingBox.right - sceneBoundingBox.left;
            h = sceneBoundingBox.bottom - sceneBoundingBox.top;
        } else {
            // otherwise just use whatever space we have
            var ownerRect = owner.getBoundingClientRect();
            w = ownerRect.width;
            h = ownerRect.height;
        }
        var bbox = panController.getBBox();
        if (bbox.width === 0 || bbox.height === 0) // we probably do not have any elements in the SVG
        // just bail out;
        return;
        var dh = h / bbox.height;
        var dw = w / bbox.width;
        var scale = Math.min(dw, dh);
        transform.x = -(bbox.left + bbox.width / 2) * scale + w / 2 + left;
        transform.y = -(bbox.top + bbox.height / 2) * scale + h / 2 + top;
        transform.scale = scale;
    }
    function getTransformModel() {
        // TODO: should this be read only?
        return transform;
    }
    function getMinZoom() {
        return minZoom;
    }
    function setMinZoom(newMinZoom) {
        minZoom = newMinZoom;
    }
    function getMaxZoom() {
        return maxZoom;
    }
    function setMaxZoom(newMaxZoom) {
        maxZoom = newMaxZoom;
    }
    function getTransformOrigin() {
        return transformOrigin;
    }
    function setTransformOrigin(newTransformOrigin) {
        transformOrigin = $45999efe49292c09$var$parseTransformOrigin(newTransformOrigin);
    }
    function getZoomSpeed() {
        return speed;
    }
    function setZoomSpeed(newSpeed) {
        if (!Number.isFinite(newSpeed)) throw new Error("Zoom speed should be a number");
        speed = newSpeed;
    }
    function getPoint() {
        return {
            x: transform.x,
            y: transform.y
        };
    }
    function moveTo(x, y) {
        transform.x = x;
        transform.y = y;
        keepTransformInsideBounds();
        triggerEvent("pan");
        makeDirty();
    }
    function moveBy(dx, dy) {
        moveTo(transform.x + dx, transform.y + dy);
    }
    function keepTransformInsideBounds() {
        var boundingBox = getBoundingBox();
        if (!boundingBox) return;
        var adjusted = false;
        var clientRect = getClientRect();
        var diff = boundingBox.left - clientRect.right;
        if (diff > 0) {
            transform.x += diff;
            adjusted = true;
        }
        // check the other side:
        diff = boundingBox.right - clientRect.left;
        if (diff < 0) {
            transform.x += diff;
            adjusted = true;
        }
        // y axis:
        diff = boundingBox.top - clientRect.bottom;
        if (diff > 0) {
            // we adjust transform, so that it matches exactly our bounding box:
            // transform.y = boundingBox.top - (boundingBox.height + boundingBox.y) * transform.scale =>
            // transform.y = boundingBox.top - (clientRect.bottom - transform.y) =>
            // transform.y = diff + transform.y =>
            transform.y += diff;
            adjusted = true;
        }
        diff = boundingBox.bottom - clientRect.top;
        if (diff < 0) {
            transform.y += diff;
            adjusted = true;
        }
        return adjusted;
    }
    /**
   * Returns bounding box that should be used to restrict scene movement.
   */ function getBoundingBox() {
        if (!bounds) return; // client does not want to restrict movement
        if (typeof bounds === "boolean") {
            // for boolean type we use parent container bounds
            var ownerRect = owner.getBoundingClientRect();
            var sceneWidth = ownerRect.width;
            var sceneHeight = ownerRect.height;
            return {
                left: sceneWidth * boundsPadding,
                top: sceneHeight * boundsPadding,
                right: sceneWidth * (1 - boundsPadding),
                bottom: sceneHeight * (1 - boundsPadding)
            };
        }
        return bounds;
    }
    function getClientRect() {
        var bbox = panController.getBBox();
        var leftTop = client(bbox.left, bbox.top);
        return {
            left: leftTop.x,
            top: leftTop.y,
            right: bbox.width * transform.scale + leftTop.x,
            bottom: bbox.height * transform.scale + leftTop.y
        };
    }
    function client(x, y) {
        return {
            x: x * transform.scale + transform.x,
            y: y * transform.scale + transform.y
        };
    }
    function makeDirty() {
        isDirty = true;
        frameAnimation = window.requestAnimationFrame(frame);
    }
    function zoomByRatio(clientX, clientY, ratio) {
        if ($45999efe49292c09$var$isNaN(clientX) || $45999efe49292c09$var$isNaN(clientY) || $45999efe49292c09$var$isNaN(ratio)) throw new Error("zoom requires valid numbers");
        var newScale = transform.scale * ratio;
        if (newScale < minZoom) {
            if (transform.scale === minZoom) return;
            ratio = minZoom / transform.scale;
        }
        if (newScale > maxZoom) {
            if (transform.scale === maxZoom) return;
            ratio = maxZoom / transform.scale;
        }
        var size = transformToScreen(clientX, clientY);
        transform.x = size.x - ratio * (size.x - transform.x);
        transform.y = size.y - ratio * (size.y - transform.y);
        // TODO: https://github.com/anvaka/panzoom/issues/112
        if (bounds && boundsPadding === 1 && minZoom === 1) {
            transform.scale *= ratio;
            keepTransformInsideBounds();
        } else {
            var transformAdjusted = keepTransformInsideBounds();
            if (!transformAdjusted) transform.scale *= ratio;
        }
        triggerEvent("zoom");
        makeDirty();
    }
    function zoomAbs(clientX, clientY, zoomLevel) {
        var ratio = zoomLevel / transform.scale;
        zoomByRatio(clientX, clientY, ratio);
    }
    function centerOn(ui) {
        var parent = ui.ownerSVGElement;
        if (!parent) throw new Error("ui element is required to be within the scene");
        // TODO: should i use controller's screen CTM?
        var clientRect = ui.getBoundingClientRect();
        var cx = clientRect.left + clientRect.width / 2;
        var cy = clientRect.top + clientRect.height / 2;
        var container = parent.getBoundingClientRect();
        var dx = container.width / 2 - cx;
        var dy = container.height / 2 - cy;
        internalMoveBy(dx, dy, true);
    }
    function smoothMoveTo(x, y, cb) {
        internalMoveBy(x - transform.x, y - transform.y, true, cb);
    }
    function internalMoveBy(dx, dy, smooth, cb = ()=>{}) {
        if (!smooth) return moveBy(dx, dy);
        if (moveByAnimation) moveByAnimation.cancel();
        var from = {
            x: 0,
            y: 0
        };
        var to = {
            x: dx,
            y: dy
        };
        var lastX = 0;
        var lastY = 0;
        moveByAnimation = $37dd74a6caeaf357$exports(from, to, {
            step: function(v) {
                moveBy(v.x - lastX, v.y - lastY);
                lastX = v.x;
                lastY = v.y;
            },
            done: cb
        });
        console.log(moveByAnimation);
    }
    function scroll(x, y) {
        cancelZoomAnimation();
        moveTo(x, y);
    }
    function dispose() {
        releaseEvents();
    }
    function listenForEvents() {
        owner.addEventListener("mousedown", onMouseDown, {
            passive: false
        });
        owner.addEventListener("dblclick", onDoubleClick, {
            passive: false
        });
        owner.addEventListener("touchstart", onTouch, {
            passive: false
        });
        owner.addEventListener("keydown", onKeyDown, {
            passive: false
        });
        // Need to listen on the owner container, so that we are not limited
        // by the size of the scrollable domElement
        $a29e1fec6928480a$exports.addWheelListener(owner, onMouseWheel, {
            passive: false
        });
        makeDirty();
    }
    function releaseEvents() {
        $a29e1fec6928480a$exports.removeWheelListener(owner, onMouseWheel);
        owner.removeEventListener("mousedown", onMouseDown);
        owner.removeEventListener("keydown", onKeyDown);
        owner.removeEventListener("dblclick", onDoubleClick);
        owner.removeEventListener("touchstart", onTouch);
        if (frameAnimation) {
            window.cancelAnimationFrame(frameAnimation);
            frameAnimation = 0;
        }
        smoothScroll.cancel();
        releaseDocumentMouse();
        releaseTouches();
        textSelection.release();
        triggerPanEnd();
    }
    function frame() {
        if (isDirty) applyTransform();
    }
    function applyTransform() {
        isDirty = false;
        // TODO: Should I allow to cancel this?
        panController.applyTransform(transform);
        triggerEvent("transform");
        frameAnimation = 0;
    }
    function onKeyDown(e) {
        var x = 0, y = 0, z = 0;
        if (e.keyCode === 38) y = 1; // up
        else if (e.keyCode === 40) y = -1; // down
        else if (e.keyCode === 37) x = 1; // left
        else if (e.keyCode === 39) x = -1; // right
        else if (e.keyCode === 189 || e.keyCode === 109) // DASH or SUBTRACT
        z = 1; // `-` -  zoom out
        else if (e.keyCode === 187 || e.keyCode === 107) // EQUAL SIGN or ADD
        z = -1; // `=` - zoom in (equal sign on US layout is under `+`)
        if (filterKey(e, x, y, z)) // They don't want us to handle the key: https://github.com/anvaka/panzoom/issues/45
        return;
        if (x || y) {
            e.preventDefault();
            e.stopPropagation();
            var clientRect = owner.getBoundingClientRect();
            // movement speed should be the same in both X and Y direction:
            var offset = Math.min(clientRect.width, clientRect.height);
            var moveSpeedRatio = 0.05;
            var dx = offset * moveSpeedRatio * x;
            var dy = offset * moveSpeedRatio * y;
            // TODO: currently we do not animate this. It could be better to have animation
            internalMoveBy(dx, dy);
        }
        if (z) {
            var scaleMultiplier = getScaleMultiplier(z * 100);
            var offset = transformOrigin ? getTransformOriginOffset() : midPoint();
            publicZoomTo(offset.x, offset.y, scaleMultiplier);
        }
    }
    function midPoint() {
        var ownerRect = owner.getBoundingClientRect();
        return {
            x: ownerRect.width / 2,
            y: ownerRect.height / 2
        };
    }
    function onTouch(e) {
        // let them override the touch behavior
        beforeTouch(e);
        clearPendingClickEventTimeout();
        if (e.touches.length === 1) return handleSingleFingerTouch(e, e.touches[0]);
        else if (e.touches.length === 2) {
            // handleTouchMove() will care about pinch zoom.
            pinchZoomLength = getPinchZoomLength(e.touches[0], e.touches[1]);
            multiTouch = true;
            startTouchListenerIfNeeded();
        }
    }
    function beforeTouch(e) {
        // TODO: Need to unify this filtering names. E.g. use `beforeTouch`
        if (options.onTouch && !options.onTouch(e)) // if they return `false` from onTouch, we don't want to stop
        // events propagation. Fixes https://github.com/anvaka/panzoom/issues/12
        return;
        e.stopPropagation();
        e.preventDefault();
    }
    function beforeDoubleClick(e) {
        clearPendingClickEventTimeout();
        // TODO: Need to unify this filtering names. E.g. use `beforeDoubleClick``
        if (options.onDoubleClick && !options.onDoubleClick(e)) // if they return `false` from onTouch, we don't want to stop
        // events propagation. Fixes https://github.com/anvaka/panzoom/issues/46
        return;
        e.preventDefault();
        e.stopPropagation();
    }
    function handleSingleFingerTouch(e) {
        lastTouchStartTime = new Date();
        var touch = e.touches[0];
        var offset = getOffsetXY(touch);
        lastSingleFingerOffset = offset;
        var point = transformToScreen(offset.x, offset.y);
        mouseX = point.x;
        mouseY = point.y;
        clickX = mouseX;
        clickY = mouseY;
        smoothScroll.cancel();
        startTouchListenerIfNeeded();
    }
    function startTouchListenerIfNeeded() {
        if (touchInProgress) // no need to do anything, as we already listen to events;
        return;
        touchInProgress = true;
        document.addEventListener("touchmove", handleTouchMove);
        document.addEventListener("touchend", handleTouchEnd);
        document.addEventListener("touchcancel", handleTouchEnd);
    }
    function handleTouchMove(e) {
        if (e.touches.length === 1) {
            e.stopPropagation();
            var touch = e.touches[0];
            var offset = getOffsetXY(touch);
            var point = transformToScreen(offset.x, offset.y);
            var dx = point.x - mouseX;
            var dy = point.y - mouseY;
            if (dx !== 0 && dy !== 0) triggerPanStart();
            mouseX = point.x;
            mouseY = point.y;
            internalMoveBy(dx, dy);
        } else if (e.touches.length === 2) {
            // it's a zoom, let's find direction
            multiTouch = true;
            var t1 = e.touches[0];
            var t2 = e.touches[1];
            var currentPinchLength = getPinchZoomLength(t1, t2);
            // since the zoom speed is always based on distance from 1, we need to apply
            // pinch speed only on that distance from 1:
            var scaleMultiplier = 1 + (currentPinchLength / pinchZoomLength - 1) * pinchSpeed;
            var firstTouchPoint = getOffsetXY(t1);
            var secondTouchPoint = getOffsetXY(t2);
            mouseX = (firstTouchPoint.x + secondTouchPoint.x) / 2;
            mouseY = (firstTouchPoint.y + secondTouchPoint.y) / 2;
            if (transformOrigin) {
                var offset = getTransformOriginOffset();
                mouseX = offset.x;
                mouseY = offset.y;
            }
            publicZoomTo(mouseX, mouseY, scaleMultiplier);
            pinchZoomLength = currentPinchLength;
            e.stopPropagation();
            e.preventDefault();
        }
    }
    function clearPendingClickEventTimeout() {
        if (pendingClickEventTimeout) {
            clearTimeout(pendingClickEventTimeout);
            pendingClickEventTimeout = 0;
        }
    }
    function handlePotentialClickEvent(e) {
        // we could still be in the double tap mode, let's wait until double tap expires,
        // and then notify:
        if (!options.onClick) return;
        clearPendingClickEventTimeout();
        var dx = mouseX - clickX;
        var dy = mouseY - clickY;
        var l = Math.sqrt(dx * dx + dy * dy);
        if (l > 5) return; // probably they are panning, ignore it
        pendingClickEventTimeout = setTimeout(function() {
            pendingClickEventTimeout = 0;
            options.onClick(e);
        }, $45999efe49292c09$var$doubleTapSpeedInMS);
    }
    function handleTouchEnd(e) {
        clearPendingClickEventTimeout();
        if (e.touches.length > 0) {
            var offset = getOffsetXY(e.touches[0]);
            var point = transformToScreen(offset.x, offset.y);
            mouseX = point.x;
            mouseY = point.y;
        } else {
            var now = new Date();
            if (now - lastTouchEndTime < $45999efe49292c09$var$doubleTapSpeedInMS) {
                // They did a double tap here
                if (transformOrigin) {
                    var offset = getTransformOriginOffset();
                    smoothZoom(offset.x, offset.y, zoomDoubleClickSpeed);
                } else // We want untransformed x/y here.
                smoothZoom(lastSingleFingerOffset.x, lastSingleFingerOffset.y, zoomDoubleClickSpeed);
            } else if (now - lastTouchStartTime < $45999efe49292c09$var$clickEventTimeInMS) handlePotentialClickEvent(e);
            lastTouchEndTime = now;
            triggerPanEnd();
            releaseTouches();
        }
    }
    function getPinchZoomLength(finger1, finger2) {
        var dx = finger1.clientX - finger2.clientX;
        var dy = finger1.clientY - finger2.clientY;
        return Math.sqrt(dx * dx + dy * dy);
    }
    function onDoubleClick(e) {
        beforeDoubleClick(e);
        var offset = getOffsetXY(e);
        if (transformOrigin) // TODO: looks like this is duplicated in the file.
        // Need to refactor
        offset = getTransformOriginOffset();
        smoothZoom(offset.x, offset.y, zoomDoubleClickSpeed);
    }
    function onMouseDown(e) {
        clearPendingClickEventTimeout();
        // if client does not want to handle this event - just ignore the call
        if (beforeMouseDown(e)) return;
        lastMouseDownedEvent = e;
        lastMouseDownTime = new Date();
        if (touchInProgress) {
            // modern browsers will fire mousedown for touch events too
            // we do not want this: touch is handled separately.
            e.stopPropagation();
            return false;
        }
        // for IE, left click == 1
        // for Firefox, left click == 0
        var isLeftButton = e.button === 1 && window.event !== null || e.button === 0;
        if (!isLeftButton) return;
        smoothScroll.cancel();
        var offset = getOffsetXY(e);
        var point = transformToScreen(offset.x, offset.y);
        clickX = mouseX = point.x;
        clickY = mouseY = point.y;
        // We need to listen on document itself, since mouse can go outside of the
        // window, and we will loose it
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
        textSelection.capture(e.target || e.srcElement);
        return false;
    }
    function onMouseMove(e) {
        // no need to worry about mouse events when touch is happening
        if (touchInProgress) return;
        triggerPanStart();
        var offset = getOffsetXY(e);
        var point = transformToScreen(offset.x, offset.y);
        var dx = point.x - mouseX;
        var dy = point.y - mouseY;
        mouseX = point.x;
        mouseY = point.y;
        internalMoveBy(dx, dy);
    }
    function onMouseUp() {
        var now = new Date();
        if (now - lastMouseDownTime < $45999efe49292c09$var$clickEventTimeInMS) handlePotentialClickEvent(lastMouseDownedEvent);
        textSelection.release();
        triggerPanEnd();
        releaseDocumentMouse();
    }
    function releaseDocumentMouse() {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
        panstartFired = false;
    }
    function releaseTouches() {
        document.removeEventListener("touchmove", handleTouchMove);
        document.removeEventListener("touchend", handleTouchEnd);
        document.removeEventListener("touchcancel", handleTouchEnd);
        panstartFired = false;
        multiTouch = false;
        touchInProgress = false;
    }
    function onMouseWheel(e) {
        // if client does not want to handle this event - just ignore the call
        if (beforeWheel(e)) return;
        smoothScroll.cancel();
        var delta = e.deltaY;
        if (e.deltaMode > 0) delta *= 100;
        var scaleMultiplier = getScaleMultiplier(delta);
        if (scaleMultiplier !== 1) {
            var offset = transformOrigin ? getTransformOriginOffset() : getOffsetXY(e);
            publicZoomTo(offset.x, offset.y, scaleMultiplier);
            e.preventDefault();
        }
    }
    function getOffsetXY(e) {
        var offsetX, offsetY;
        // I tried using e.offsetX, but that gives wrong results for svg, when user clicks on a path.
        var ownerRect = owner.getBoundingClientRect();
        offsetX = e.clientX - ownerRect.left;
        offsetY = e.clientY - ownerRect.top;
        return {
            x: offsetX,
            y: offsetY
        };
    }
    function smoothZoom(clientX, clientY, scaleMultiplier) {
        var fromValue = transform.scale;
        var from = {
            scale: fromValue
        };
        var to = {
            scale: scaleMultiplier * fromValue
        };
        smoothScroll.cancel();
        cancelZoomAnimation();
        zoomToAnimation = $37dd74a6caeaf357$exports(from, to, {
            step: function(v) {
                zoomAbs(clientX, clientY, v.scale);
            },
            done: triggerZoomEnd
        });
    }
    function smoothZoomAbs(clientX, clientY, toScaleValue) {
        var fromValue = transform.scale;
        var from = {
            scale: fromValue
        };
        var to = {
            scale: toScaleValue
        };
        smoothScroll.cancel();
        cancelZoomAnimation();
        zoomToAnimation = $37dd74a6caeaf357$exports(from, to, {
            step: function(v) {
                zoomAbs(clientX, clientY, v.scale);
            }
        });
    }
    function getTransformOriginOffset() {
        var ownerRect = owner.getBoundingClientRect();
        return {
            x: ownerRect.width * transformOrigin.x,
            y: ownerRect.height * transformOrigin.y
        };
    }
    function publicZoomTo(clientX, clientY, scaleMultiplier) {
        smoothScroll.cancel();
        cancelZoomAnimation();
        return zoomByRatio(clientX, clientY, scaleMultiplier);
    }
    function cancelZoomAnimation() {
        if (zoomToAnimation) {
            zoomToAnimation.cancel();
            zoomToAnimation = null;
        }
    }
    function getScaleMultiplier(delta) {
        var sign = Math.sign(delta);
        var deltaAdjustedSpeed = Math.min(0.25, Math.abs(speed * delta / 128));
        return 1 - sign * deltaAdjustedSpeed;
    }
    function triggerPanStart() {
        if (!panstartFired) {
            triggerEvent("panstart");
            panstartFired = true;
            smoothScroll.start();
        }
    }
    function triggerPanEnd() {
        if (panstartFired) {
            // we should never run smooth scrolling if it was multiTouch (pinch zoom animation):
            if (!multiTouch) smoothScroll.stop();
            triggerEvent("panend");
        }
    }
    function triggerTransformStart() {
        triggerEvent("transformstart");
    }
    function triggerTransformEnd() {
        if (smoothScroll.stop !== $45999efe49292c09$var$noop) triggerEvent("transformend");
    }
    function triggerZoomEnd() {
        triggerEvent("zoomend");
    }
    function triggerEvent(name) {
        api.fire(name, api);
    }
}
function $45999efe49292c09$var$parseTransformOrigin(options) {
    if (!options) return;
    if (typeof options === "object") {
        if (!$45999efe49292c09$var$isNumber(options.x) || !$45999efe49292c09$var$isNumber(options.y)) $45999efe49292c09$var$failTransformOrigin(options);
        return options;
    }
    $45999efe49292c09$var$failTransformOrigin();
}
function $45999efe49292c09$var$failTransformOrigin(options) {
    console.error(options);
    throw new Error([
        "Cannot parse transform origin.",
        "Some good examples:",
        '  "center center" can be achieved with {x: 0.5, y: 0.5}',
        '  "top center" can be achieved with {x: 0.5, y: 0}',
        '  "bottom right" can be achieved with {x: 1, y: 1}'
    ].join("\n"));
}
function $45999efe49292c09$var$noop() {}
function $45999efe49292c09$var$validateBounds(bounds) {
    var boundsType = typeof bounds;
    if (boundsType === "undefined" || boundsType === "boolean") return; // this is okay
    // otherwise need to be more thorough:
    var validBounds = $45999efe49292c09$var$isNumber(bounds.left) && $45999efe49292c09$var$isNumber(bounds.top) && $45999efe49292c09$var$isNumber(bounds.bottom) && $45999efe49292c09$var$isNumber(bounds.right);
    if (!validBounds) throw new Error("Bounds object is not valid. It can be: undefined, boolean (true|false) or an object {left, top, right, bottom}");
}
function $45999efe49292c09$var$isNumber(x) {
    return Number.isFinite(x);
}
// IE 11 does not support isNaN:
function $45999efe49292c09$var$isNaN(value) {
    if (Number.isNaN) return Number.isNaN(value);
    return value !== value;
}
function $45999efe49292c09$var$rigidScroll() {
    return {
        start: $45999efe49292c09$var$noop,
        stop: $45999efe49292c09$var$noop,
        cancel: $45999efe49292c09$var$noop
    };
}
function $45999efe49292c09$var$autoRun() {
    if (typeof document === "undefined") return;
    var scripts = document.getElementsByTagName("script");
    if (!scripts) return;
    var panzoomScript;
    for(var i = 0; i < scripts.length; ++i){
        var x = scripts[i];
        if (x.src && x.src.match(/\bpanzoom(\.min)?\.js/)) {
            panzoomScript = x;
            break;
        }
    }
    if (!panzoomScript) return;
    var query = panzoomScript.getAttribute("query");
    if (!query) return;
    var globalName = panzoomScript.getAttribute("name") || "pz";
    var started = Date.now();
    tryAttach();
    function tryAttach() {
        var el = document.querySelector(query);
        if (!el) {
            var now = Date.now();
            var elapsed = now - started;
            if (elapsed < 2000) {
                // Let's wait a bit
                setTimeout(tryAttach, 100);
                return;
            }
            // If we don't attach within 2 seconds to the target element, consider it a failure
            console.error("Cannot find the panzoom element", globalName);
            return;
        }
        var options = collectOptions(panzoomScript);
        console.log(options);
        window[globalName] = $45999efe49292c09$var$createPanZoom(el, options);
    }
    function collectOptions(script) {
        var attrs = script.attributes;
        var options = {};
        for(var j = 0; j < attrs.length; ++j){
            var attr = attrs[j];
            var nameValue = getPanzoomAttributeNameValue(attr);
            if (nameValue) options[nameValue.name] = nameValue.value;
        }
        return options;
    }
    function getPanzoomAttributeNameValue(attr) {
        if (!attr.name) return;
        var isPanZoomAttribute = attr.name[0] === "p" && attr.name[1] === "z" && attr.name[2] === "-";
        if (!isPanZoomAttribute) return;
        var name = attr.name.substr(3);
        var value = JSON.parse(attr.value);
        return {
            name: name,
            value: value
        };
    }
}
$45999efe49292c09$var$autoRun();





// Component Zone selection
function $2ac805d858faec4a$var$ZoneBlockSelection() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        id: "zone_blocks_selection"
    });
}
var $2ac805d858faec4a$export$2e2bcd8739ae039 = $2ac805d858faec4a$var$ZoneBlockSelection;




function $02702eb17aeccbb5$var$Loader() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
        className: "loader_parent",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
            className: "loader",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {})
        })
    });
}
var $02702eb17aeccbb5$export$2e2bcd8739ae039 = $02702eb17aeccbb5$var$Loader;




// Camera component this component is responsible of handling the container who will display the block's and path's
// He will also dispatch the panzoom instance who will be needed to allow the user to move block's
// The trigger is place here because, it will reset the panzoom instance each time we change our bot
// That will clean the editor
function $84118122e670e143$var$Camera() {
    const [ref, setRef] = (0, $bh6RR.useState)();
    const elements = (0, $bh6RR.useRef)(null);
    const dispatch = (0, $e677ba9f021c00cc$export$aa08601751813bc1)();
    const { fetching: fetching } = (0, $6949a38b8f965998$export$7fb2ef288e532e72)();
    const { followBlock: followBlock } = (0, $44233c56e4012027$export$2e2bcd8739ae039)();
    (0, $bh6RR.useEffect)(()=>{
        var panzoom = null;
        if (fetching == true) return;
        // Todo put the panzoom config in a config file in the 'data' folder
        panzoom = (0, (/*@__PURE__*/$parcel$interopDefault($45999efe49292c09$exports)))(elements.current, {
            minZoom: 0.05,
            maxZoom: 2
        });
        dispatch({
            type: "loadCamera",
            payload: {
                panzoom: panzoom
            }
        });
        // need to panzoom dispose if forget multiple instance will occured and nothing will work
        return ()=>panzoom.dispose();
    }, [
        fetching
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "camera",
            children: [
                fetching == true && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $02702eb17aeccbb5$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    ref: elements,
                    className: "elements",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d2a676f1ff93d544$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $99d7e10a3978d587$export$2e2bcd8739ae039), {})
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2ac805d858faec4a$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
var $84118122e670e143$export$2e2bcd8739ae039 = $84118122e670e143$var$Camera;




var $bh6RR = parcelRequire("bh6RR");





// Component for displaying a side popup on the left
function $ea22870b68d9bbf3$var$EditorWindow({ Component: Component, componentProps: componentProps, id: id }) {
    //const Conponent = ListComponentsEditable[type];
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const editorRef = (0, $bh6RR.useRef)("editor");
    const dispatch = (0, $ff13ff65642ff6cd$export$96f70031a13e2d53)();
    // If we click outside the popup that will close but not if it's a block or the variable_manager
    // Like this we can keep the component up and changing the form without a rerun of the animation
    (0, $e9725e0bc7ac6543$export$2e2bcd8739ae039)(editorRef, (event)=>{
        // Messy fix if we don't want to close this window when we open a 'popup' component
        if (document.getElementsByClassName("popup").item(0)) return false;
        const chatbox = document.getElementsByClassName("kwalys-chatbox-window").item(0);
        if (chatbox && chatbox.contains(event.target)) return;
        const element = document.getElementById(componentProps.id);
        if (element) element.classList.remove("selected");
        editorRef.current.classList.add("closing");
        // Remove after 350 for letting the animation put thank's to the className 'closing'
        setTimeout(()=>{
            modal.remove();
        }, 350);
        dispatch({
            type: "toggleMargin"
        });
    }, [
        "block",
        "variable_manager",
        "play",
        "restart",
        "run"
    ]);
    // Fix performance for blocks when we click on the modal, they can have a 'blur' effect if this line is omit
    (0, $4fa46126008ccaef$export$572a46a0df645770)();
    (0, $bh6RR.useEffect)(()=>{
        dispatch({
            type: "toggleMargin"
        });
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "editor-window",
        ref: editorRef,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: "interface",
            children: /*#__PURE__*/ (0, $bh6RR.createElement)(Component, {
                ...componentProps,
                key: componentProps.id
            })
        })
    });
}
$ea22870b68d9bbf3$var$EditorWindow.defaultProps = {
    componentProps: {}
};
var $ea22870b68d9bbf3$export$2e2bcd8739ae039 = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create($ea22870b68d9bbf3$var$EditorWindow);






var $bh6RR = parcelRequire("bh6RR");

// Poup container to edit some content who can't be edited in the editor-windows
// Reason : to many informations for the user so we move the edit in another popup
function $622d10ce6fcda9af$var$Popup({ Component: Component, componentProps: componentProps }) {
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const popupRef = (0, $bh6RR.useRef)(null);
    const onClose = ()=>{
        if (popupRef.current == undefined) return;
        const background = popupRef.current.children[0];
        const content = popupRef.current.children[1];
        background.style.animation = "unset";
        content.style.animation = "unset";
        // Animation reverse can' be done on css so we need to use requestAnimationFrame with a timeout
        // Todo Refactoring with a useEffect
        window.requestAnimationFrame(()=>{
            background.style.opacity = "0";
            background.style.pointerEvents = "none";
            content.style.transform = "scale3d(0.5, 0.5, 0.5)";
            content.style.opacity = "0";
            setTimeout(()=>modal.remove(), 500);
        });
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        ref: popupRef,
        className: "popup",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "background",
                onClick: onClose
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "content",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)(Component, {
                    onClose: onClose,
                    ...componentProps
                })
            })
        ]
    });
}
$622d10ce6fcda9af$var$Popup.defaultProps = {
    Component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {}),
    componentProps: {}
};
var $622d10ce6fcda9af$export$2e2bcd8739ae039 = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create($622d10ce6fcda9af$var$Popup);




var $bh6RR = parcelRequire("bh6RR");


function $e71429213be6db03$var$createExplosion(x, y) {
    const container = document.getElementById("firework-container");
    const numberOfParticles = 30;
    for(let i = 0; i < numberOfParticles; i++){
        const particle = document.createElement("div");
        particle.classList.add("firework");
        const size = Math.random() * 20 + 10;
        particle.style.setProperty("--size", `${size}px`);
        const rotation = Math.random() * 360;
        particle.style.setProperty("--rotation", `${rotation}deg`);
        const angle = Math.PI * 2 * (i / numberOfParticles);
        const distance = Math.random() * 200 + 100;
        const offsetX = Math.cos(angle) * distance;
        const offsetY = Math.sin(angle) * distance;
        particle.style.setProperty("--x", `${offsetX}px`);
        particle.style.setProperty("--y", `${offsetY}px`);
        particle.style.left = `${x}px`;
        particle.style.top = `${y}px`;
        const randomHue = Math.random() * 360;
        const color = `hsl(${randomHue}, 100%, 50%)`;
        particle.style.setProperty("--color", color);
        container.appendChild(particle);
        setTimeout(()=>{
            container.removeChild(particle);
        }, 1200);
    }
}
function $e71429213be6db03$export$d49a3a87e97a1269() {
    const numberOfExplosions = 10;
    const margin = 250; // pour ne pas trop depasser de l'ecran
    for(let i = 0; i < numberOfExplosions; i++){
        const x = Math.random() * (window.innerWidth - 2 * margin) + margin;
        const y = Math.random() * (window.innerHeight - 2 * margin) + margin;
        setTimeout(()=>$e71429213be6db03$var$createExplosion(x, y), i * 200);
    }
}


function $cd97422625352029$var$Editor({ bot: bot }) {
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const searchParams = new URLSearchParams(location.search);
    const fromCreated = searchParams.get("fromCreated"); // Récupère la valeur du paramètre 'fromCreated'
    const { actionGetBotInformations: actionGetBotInformations } = (0, $c0a2f6f3ed0294da$export$2e2bcd8739ae039)();
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const [toastData, setToastData] = (0, $bh6RR.useState)(null);
    const [loadConfetis, setLoadConfetis] = (0, $bh6RR.useState)(fromCreated == "true");
    // get the name of the from the url and fetch it's data
    (0, $bh6RR.useEffect)(()=>{
        let isBotInfo = true;
        const fetchData = async ()=>{
            const result = await actionGetBotInformations(bot);
            if (!result) return;
            setToastData(toast.error("Bot not find", result.data, 3000, 0));
        };
        fetchData().catch((err)=>{
            console.error(err);
        });
        return ()=>{
            isBotInfo = false;
        };
    }, [
        bot
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            if (toastData == null) return;
            toast.dispatch({
                type: "deleteToast",
                payload: {
                    id: toastData.id
                }
            });
            setToastData(null);
        };
    }, [
        bot,
        toastData
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (loadConfetis == true) {
            setLoadConfetis(false);
            (0, $e71429213be6db03$export$d49a3a87e97a1269)();
            setTimeout(()=>{
                searchParams.delete("fromCreated"); // on retire le parametre pour ne pas remettre les confetis une 2nde fois
                navigate({
                    search: searchParams.toString()
                }, {
                    replace: true
                });
            }, 1000);
        }
    }, [
        loadConfetis
    ]);
    // BotEditor required Bar component to make custom like import scenario, multiple block selection
    // Panzone components is required to move blocks and paths
    // Declare EditorWindow and Popup for calling them latter thanks to @ebay/nice-modal
    // They handled the form block's modification
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "bot-editor",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                id: "firework-container"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $7324df5b25c181de$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $28a7a035f6e1fc79$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $84118122e670e143$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ea22870b68d9bbf3$export$2e2bcd8739ae039), {
                id: "editor-window"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $622d10ce6fcda9af$export$2e2bcd8739ae039), {
                id: "editor-popup"
            })
        ]
    });
}
var $cd97422625352029$export$2e2bcd8739ae039 = $cd97422625352029$var$Editor;








var $bh6RR = parcelRequire("bh6RR");



parcelRequire("bh6RR");




parcelRequire("bh6RR");
const $5a85d316dcc85e3e$var$SvgClose = (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        ...props,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "M.472.472a1 1 0 0 1 1.414 0L4.025 2.61 6.165.47A1 1 0 0 1 7.49.395l.087.078a1 1 0 0 1 0 1.414L5.44 4.026l2.14 2.138a1 1 0 0 1 .077 1.327l-.078.087a1 1 0 0 1-1.414 0L4.024 5.44 1.887 7.58a1 1 0 0 1-1.327.077l-.087-.078a1 1 0 0 1 0-1.414l2.137-2.14L.47 1.886A1 1 0 0 1 .395.559z"
        })
    });
var $5a85d316dcc85e3e$export$2e2bcd8739ae039 = $5a85d316dcc85e3e$var$SvgClose;


const $4f40205da0dd354f$var$ButtonClose = ()=>{
    const dispatch = (0, $ff13ff65642ff6cd$export$96f70031a13e2d53)();
    const closeChatbox = ()=>dispatch({
            type: "openAndClose"
        });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
        id: "kwalys-close",
        onClick: closeChatbox,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5a85d316dcc85e3e$export$2e2bcd8739ae039), {})
    });
};
var $4f40205da0dd354f$export$2e2bcd8739ae039 = $4f40205da0dd354f$var$ButtonClose;




var $bh6RR = parcelRequire("bh6RR");

parcelRequire("bh6RR");



function $69ceb03296805ecb$var$QuickReply({ content: content, tracking: tracking }) {
    const { canSendDataToServer: canSendDataToServer } = (0, $ff13ff65642ff6cd$export$787f29101a32d965)();
    const { askBotNextQuestion: askBotNextQuestion } = (0, $25d6ba8a8df7472c$export$2e2bcd8739ae039)();
    if (!canSendDataToServer || content === "null" || content === "") return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
        type: "button",
        tracking: tracking,
        className: "quickreply",
        onClick: ()=>askBotNextQuestion(tracking, content),
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: $726d757834788151$exports.sanitize(content, {
                    sanitize: true
                })
            }
        })
    });
}
$69ceb03296805ecb$var$QuickReply.defaultProps = {
    text: "",
    tracking: ""
};
var $69ceb03296805ecb$export$2e2bcd8739ae039 = $69ceb03296805ecb$var$QuickReply;




function $6d5be9212a08c059$var$ChatContainerQuickReply() {
    const dispatch = (0, $ff13ff65642ff6cd$export$96f70031a13e2d53)();
    const { data: data } = (0, $8283b38cbbf594a8$export$2db17556772be852)();
    const { responses: responses, messages: messages } = data;
    var quickreplies = responses.filter((response)=>response.type == "quick");
    quickreplies = quickreplies.map((quickreplie)=>quickreplie.content.split("\\").map((str, index)=>{
            return {
                ...quickreplie,
                content: str.trim(),
                key: `${quickreplie.tracking}_${index}`
            };
        }));
    if (quickreplies.length) quickreplies = quickreplies.reduce((res, el)=>res.concat(el));
    quickreplies = [
        ...quickreplies,
        ...responses.filter((response)=>response.type == "raw" && response.content?.context == "dial_action").map((response)=>{
            return {
                ...response,
                content: response.content.values.phoneNumber
            };
        })
    ];
    const hiddenQuick = ()=>{
        dispatch({
            type: "openReply"
        });
        dispatch({
            type: "toggleInput"
        });
    };
    const index = messages.findIndex((message)=>message.view == 0);
    const [contentHeight, setContentHeight] = (0, $bh6RR.useState)(0);
    (0, $bh6RR.useEffect)(()=>{
        const quickrepliess = document.querySelector(".kwalys-chatbox-window .kwalys-chat .quickreplies");
        const checkHeight = ()=>{
            if (quickrepliess) {
                const newContentHeight = quickrepliess.scrollHeight;
                if (newContentHeight > 350) {
                    quickrepliess.style.maxHeight = "500px";
                    quickrepliess.style.minHeight = "300px";
                    quickrepliess.style.overflowY = "auto";
                    quickrepliess.classList.add("scrollbar-chatbox");
                } else {
                    quickrepliess.style.maxHeight = "";
                    quickrepliess.style.minHeight = "";
                    quickrepliess.style.overflowY = "";
                }
                setContentHeight(newContentHeight);
            }
        };
        checkHeight();
        const interval = setInterval(checkHeight, 0); // Vérifie toutes les 1 seconde
        return ()=>clearInterval(interval);
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: index == -1 && quickreplies.length ? "quickreplies" : "quickreplies invisible",
        onClick: hiddenQuick,
        children: quickreplies && quickreplies.map((response)=>response.content.trim() ? /*#__PURE__*/ (0, $bh6RR.createElement)((0, $69ceb03296805ecb$export$2e2bcd8739ae039), {
                ...response,
                key: response.key ?? response.tracking
            }) : "")
    });
}
var $6d5be9212a08c059$export$2e2bcd8739ae039 = $6d5be9212a08c059$var$ChatContainerQuickReply;




var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
parcelRequire("bh6RR");
function $266e6160ef860cac$var$EditorAction() {
    const ifFollowBlockDefinedMoveCamera = (tracking_id)=>{
        if (typeof window.followBlock !== "function") return;
        window.followBlock(tracking_id);
    };
    return {
        ifFollowBlockDefinedMoveCamera: ifFollowBlockDefinedMoveCamera
    };
}
var $266e6160ef860cac$export$2e2bcd8739ae039 = $266e6160ef860cac$var$EditorAction;






var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
const $68171a1f1cc3fc3e$export$83fe3bee12eb51bb = "carousel";
const $68171a1f1cc3fc3e$export$b861c6f4d58b4c2f = "controller";
const $68171a1f1cc3fc3e$export$607ce719f0ec9b98 = "navigation";
const $68171a1f1cc3fc3e$export$52cbc29cf5406ba8 = "no-scroll";
const $68171a1f1cc3fc3e$export$9d2e4856063e1a22 = "portal";
const $68171a1f1cc3fc3e$export$62f3c66ae8dab8a3 = "root";
const $68171a1f1cc3fc3e$export$5414719b40b8294f = "toolbar";
const $68171a1f1cc3fc3e$export$a23b14c1465897d = "captions";
const $68171a1f1cc3fc3e$export$8ae0dbe553798d04 = "counter";
const $68171a1f1cc3fc3e$export$ace9d67c0f2290af = "download";
const $68171a1f1cc3fc3e$export$4792108761b262a9 = "fullscreen";
const $68171a1f1cc3fc3e$export$c21ea5a712f18fb6 = "inline";
const $68171a1f1cc3fc3e$export$6bbdc870e6ef9c88 = "share";
const $68171a1f1cc3fc3e$export$be7dc72e63e6ef2e = "slideshow";
const $68171a1f1cc3fc3e$export$6bf9d56640f46f01 = "thumbnails";
const $68171a1f1cc3fc3e$export$929980e2a2c57ecf = "zoom";
const $68171a1f1cc3fc3e$export$554a1415841c52a8 = "loading";
const $68171a1f1cc3fc3e$export$38ce62e512432ebb = "playing";
const $68171a1f1cc3fc3e$export$2ed3c80dbc178d91 = "error";
const $68171a1f1cc3fc3e$export$a195e517d37aaa33 = "complete";
const $68171a1f1cc3fc3e$export$e51f1c6d74b54a13 = "placeholder";
const $68171a1f1cc3fc3e$export$6751782e799f6445 = (status)=>`active-slide-${status}`;
const $68171a1f1cc3fc3e$export$7ab73e7383503259 = $68171a1f1cc3fc3e$export$6751782e799f6445($68171a1f1cc3fc3e$export$554a1415841c52a8);
const $68171a1f1cc3fc3e$export$ccb5eb0b2db52ae8 = $68171a1f1cc3fc3e$export$6751782e799f6445($68171a1f1cc3fc3e$export$38ce62e512432ebb);
const $68171a1f1cc3fc3e$export$817be438d1d0e4cf = $68171a1f1cc3fc3e$export$6751782e799f6445($68171a1f1cc3fc3e$export$2ed3c80dbc178d91);
const $68171a1f1cc3fc3e$export$2ec1d32caeb97dfe = $68171a1f1cc3fc3e$export$6751782e799f6445($68171a1f1cc3fc3e$export$a195e517d37aaa33);
const $68171a1f1cc3fc3e$export$37b171d829eeeaa2 = "fullsize";
const $68171a1f1cc3fc3e$export$974a68ef150451f5 = "flex_center";
const $68171a1f1cc3fc3e$export$b6426a00c33a0175 = "no_scroll";
const $68171a1f1cc3fc3e$export$651541414233b476 = "no_scroll_padding";
const $68171a1f1cc3fc3e$export$8d922915837a38d3 = "slide";
const $68171a1f1cc3fc3e$export$ac396c284080b10c = "slide_wrapper";
const $68171a1f1cc3fc3e$export$bb41c4fe76dce9db = "slide_wrapper_interactive";
const $68171a1f1cc3fc3e$export$a007161537026955 = "prev";
const $68171a1f1cc3fc3e$export$f1d7a854db833ed4 = "next";
const $68171a1f1cc3fc3e$export$c43bd1a4101c4078 = "swipe";
const $68171a1f1cc3fc3e$export$493a596486210a21 = "close";
const $68171a1f1cc3fc3e$export$e15fc153f45a963d = "onPointerDown";
const $68171a1f1cc3fc3e$export$1f8863949fbdd7e5 = "onPointerMove";
const $68171a1f1cc3fc3e$export$2d868b67a5791b8a = "onPointerUp";
const $68171a1f1cc3fc3e$export$526cafa85592f1a5 = "onPointerLeave";
const $68171a1f1cc3fc3e$export$22151cee048c4be9 = "onPointerCancel";
const $68171a1f1cc3fc3e$export$1aba4f3521686ca9 = "onKeyDown";
const $68171a1f1cc3fc3e$export$bdb9f99d61a6879b = "onKeyUp";
const $68171a1f1cc3fc3e$export$5635dc9d647242c7 = "onWheel";
const $68171a1f1cc3fc3e$export$e8d60d9b5ceff7c0 = "Escape";
const $68171a1f1cc3fc3e$export$17dec1da9b0e2eb3 = "ArrowLeft";
const $68171a1f1cc3fc3e$export$91898c0e7e48903 = "ArrowRight";
const $68171a1f1cc3fc3e$export$d62fb7722b07f2f3 = "button";
const $68171a1f1cc3fc3e$export$c5f5ca1963fed141 = "icon";
const $68171a1f1cc3fc3e$export$eff7fe5eefd707ad = "contain";
const $68171a1f1cc3fc3e$export$9a9f12fc3f1c1e4f = "cover";
const $68171a1f1cc3fc3e$export$b149fc25cb186fec = "Unknown action type";



"use client";
const $fb64e7edf7ecf5b8$var$cssPrefix$3 = "yarl__";
function $fb64e7edf7ecf5b8$export$4f5d2d50c9deca37(...classes) {
    return [
        ...classes
    ].filter(Boolean).join(" ");
}
function $fb64e7edf7ecf5b8$export$1283875077dc8f0a(name) {
    return `${$fb64e7edf7ecf5b8$var$cssPrefix$3}${name}`;
}
function $fb64e7edf7ecf5b8$export$8b4981022bd80a4e(name) {
    return `--${$fb64e7edf7ecf5b8$var$cssPrefix$3}${name}`;
}
function $fb64e7edf7ecf5b8$export$195c4126907dde97(base, prefix) {
    return `${base}${prefix ? `_${prefix}` : ""}`;
}
function $fb64e7edf7ecf5b8$export$3e7cd27eed1727c(base) {
    return (prefix)=>$fb64e7edf7ecf5b8$export$195c4126907dde97(base, prefix);
}
function $fb64e7edf7ecf5b8$export$1c4d965eb6f65dfa(labels, defaultLabel) {
    var _a;
    return (_a = labels === null || labels === void 0 ? void 0 : labels[defaultLabel]) !== null && _a !== void 0 ? _a : defaultLabel;
}
function $fb64e7edf7ecf5b8$export$1237798dc640739a(labels, defaultLabel) {
    return $fb64e7edf7ecf5b8$export$1c4d965eb6f65dfa(labels, defaultLabel);
}
function $fb64e7edf7ecf5b8$export$77152303d9076b8(labels, slides, index) {
    return $fb64e7edf7ecf5b8$export$1c4d965eb6f65dfa(labels, "{index} of {total}").replace(/\{index}/g, `${$fb64e7edf7ecf5b8$export$501611100333094a(index, slides.length) + 1}`).replace(/\{total}/g, `${slides.length}`);
}
function $fb64e7edf7ecf5b8$export$de863c629cb9919d(...cleaners) {
    return ()=>{
        cleaners.forEach((cleaner)=>{
            cleaner();
        });
    };
}
function $fb64e7edf7ecf5b8$export$aac3e49c3c8b5cb0(name, contextName, context) {
    return ()=>{
        const ctx = $bh6RR.useContext(context);
        if (!ctx) throw new Error(`${name} must be used within a ${contextName}.Provider`);
        return ctx;
    };
}
function $fb64e7edf7ecf5b8$export$fef62134eea24008() {
    return typeof window !== "undefined";
}
function $fb64e7edf7ecf5b8$export$2077e0241d6afd3c(value, decimals = 0) {
    const factor = 10 ** decimals;
    return Math.round((value + Number.EPSILON) * factor) / factor;
}
function $fb64e7edf7ecf5b8$export$55ec18c411514c07(slide) {
    return slide.type === undefined || slide.type === "image";
}
function $fb64e7edf7ecf5b8$export$f5ba2f5b3fd12e6e(image, imageFit) {
    return image.imageFit === (0, $68171a1f1cc3fc3e$export$9a9f12fc3f1c1e4f) || image.imageFit !== (0, $68171a1f1cc3fc3e$export$eff7fe5eefd707ad) && imageFit === (0, $68171a1f1cc3fc3e$export$9a9f12fc3f1c1e4f);
}
function $fb64e7edf7ecf5b8$export$5f87784a266e50a4(value) {
    return typeof value === "string" ? Number.parseInt(value, 10) : value;
}
function $fb64e7edf7ecf5b8$export$7871fb532d320d99(input) {
    if (typeof input === "number") return {
        pixel: input
    };
    if (typeof input === "string") {
        const value = $fb64e7edf7ecf5b8$export$5f87784a266e50a4(input);
        return input.endsWith("%") ? {
            percent: value
        } : {
            pixel: value
        };
    }
    return {
        pixel: 0
    };
}
function $fb64e7edf7ecf5b8$export$7ff571008bce9900(containerRect, padding) {
    const paddingValue = $fb64e7edf7ecf5b8$export$7871fb532d320d99(padding);
    const paddingPixels = paddingValue.percent !== undefined ? containerRect.width / 100 * paddingValue.percent : paddingValue.pixel;
    return {
        width: Math.max(containerRect.width - 2 * paddingPixels, 0),
        height: Math.max(containerRect.height - 2 * paddingPixels, 0)
    };
}
function $fb64e7edf7ecf5b8$export$508f096bfcdaac40() {
    return ($fb64e7edf7ecf5b8$export$fef62134eea24008() ? window === null || window === void 0 ? void 0 : window.devicePixelRatio : undefined) || 1;
}
function $fb64e7edf7ecf5b8$export$501611100333094a(index, slidesCount) {
    return slidesCount > 0 ? (index % slidesCount + slidesCount) % slidesCount : 0;
}
function $fb64e7edf7ecf5b8$export$883ece934910f98d(slides) {
    return slides.length > 0;
}
function $fb64e7edf7ecf5b8$export$cdfb855c5eb3bc84(slides, index) {
    return slides[$fb64e7edf7ecf5b8$export$501611100333094a(index, slides.length)];
}
function $fb64e7edf7ecf5b8$export$9f2f3fed4fdffdfc(slides, index) {
    return $fb64e7edf7ecf5b8$export$883ece934910f98d(slides) ? $fb64e7edf7ecf5b8$export$cdfb855c5eb3bc84(slides, index) : undefined;
}
function $fb64e7edf7ecf5b8$export$b2184449b7659b5a(slide) {
    return $fb64e7edf7ecf5b8$export$55ec18c411514c07(slide) ? slide.src : undefined;
}
function $fb64e7edf7ecf5b8$export$34ce6a408311d810(toolbar, key, button) {
    if (!button) return toolbar;
    const { buttons: buttons, ...restToolbar } = toolbar;
    const index = buttons.findIndex((item)=>item === key);
    const buttonWithKey = $bh6RR.isValidElement(button) ? $bh6RR.cloneElement(button, {
        key: key
    }, null) : button;
    if (index >= 0) {
        const result = [
            ...buttons
        ];
        result.splice(index, 1, buttonWithKey);
        return {
            buttons: result,
            ...restToolbar
        };
    }
    return {
        buttons: [
            buttonWithKey,
            ...buttons
        ],
        ...restToolbar
    };
}
function $fb64e7edf7ecf5b8$export$e88693bab67822d1() {
    const stopPropagation = (event)=>{
        event.stopPropagation();
    };
    return {
        onPointerDown: stopPropagation,
        onKeyDown: stopPropagation,
        onWheel: stopPropagation
    };
}
function $fb64e7edf7ecf5b8$export$aab7f3145c728301(carousel, slides, minimum = 0) {
    return Math.min(carousel.preload, Math.max(carousel.finite ? slides.length - 1 : Math.floor(slides.length / 2), minimum));
}
const $fb64e7edf7ecf5b8$var$isReact19 = Number($bh6RR.version.split(".")[0]) >= 19;
function $fb64e7edf7ecf5b8$export$9c64d01b28c1f747(condition) {
    const legacyValue = condition ? "" : undefined;
    return {
        inert: $fb64e7edf7ecf5b8$var$isReact19 ? condition : legacyValue
    };
}
function $fb64e7edf7ecf5b8$export$b7a864e1eaef9de5(node) {
    node.scrollTop;
}
const $fb64e7edf7ecf5b8$export$d626463445cef3e9 = {
    open: false,
    close: ()=>{},
    index: 0,
    slides: [],
    render: {},
    plugins: [],
    toolbar: {
        buttons: [
            (0, $68171a1f1cc3fc3e$export$493a596486210a21)
        ]
    },
    labels: {},
    animation: {
        fade: 250,
        swipe: 500,
        easing: {
            fade: "ease",
            swipe: "ease-out",
            navigation: "ease-in-out"
        }
    },
    carousel: {
        finite: false,
        preload: 2,
        padding: "16px",
        spacing: "30%",
        imageFit: (0, $68171a1f1cc3fc3e$export$eff7fe5eefd707ad),
        imageProps: {}
    },
    controller: {
        ref: null,
        focus: true,
        aria: false,
        touchAction: "none",
        closeOnPullUp: false,
        closeOnPullDown: false,
        closeOnBackdropClick: false,
        preventDefaultWheelX: true,
        preventDefaultWheelY: false,
        disableSwipeNavigation: false
    },
    portal: {},
    noScroll: {
        disabled: false
    },
    on: {},
    styles: {},
    className: ""
};
function $fb64e7edf7ecf5b8$export$c5ba3739ffba980d(name, component) {
    return {
        name: name,
        component: component
    };
}
function $fb64e7edf7ecf5b8$export$270e7ba5936d3c48(module, children) {
    return {
        module: module,
        children: children
    };
}
function $fb64e7edf7ecf5b8$var$traverseNode(node, target, apply) {
    if (node.module.name === target) return apply(node);
    if (node.children) return [
        $fb64e7edf7ecf5b8$export$270e7ba5936d3c48(node.module, node.children.flatMap((n)=>{
            var _a;
            return (_a = $fb64e7edf7ecf5b8$var$traverseNode(n, target, apply)) !== null && _a !== void 0 ? _a : [];
        }))
    ];
    return [
        node
    ];
}
function $fb64e7edf7ecf5b8$var$traverse(nodes, target, apply) {
    return nodes.flatMap((node)=>{
        var _a;
        return (_a = $fb64e7edf7ecf5b8$var$traverseNode(node, target, apply)) !== null && _a !== void 0 ? _a : [];
    });
}
function $fb64e7edf7ecf5b8$export$bc996c07eb970c78(root, plugins = [], augmentations = []) {
    let config = root;
    const contains = (target)=>{
        const nodes = [
            ...config
        ];
        while(nodes.length > 0){
            const node = nodes.pop();
            if ((node === null || node === void 0 ? void 0 : node.module.name) === target) return true;
            if (node === null || node === void 0 ? void 0 : node.children) nodes.push(...node.children);
        }
        return false;
    };
    const addParent = (target, module)=>{
        if (target === "") {
            config = [
                $fb64e7edf7ecf5b8$export$270e7ba5936d3c48(module, config)
            ];
            return;
        }
        config = $fb64e7edf7ecf5b8$var$traverse(config, target, (node)=>[
                $fb64e7edf7ecf5b8$export$270e7ba5936d3c48(module, [
                    node
                ])
            ]);
    };
    const append = (target, module)=>{
        config = $fb64e7edf7ecf5b8$var$traverse(config, target, (node)=>[
                $fb64e7edf7ecf5b8$export$270e7ba5936d3c48(node.module, [
                    $fb64e7edf7ecf5b8$export$270e7ba5936d3c48(module, node.children)
                ])
            ]);
    };
    const addChild = (target, module, precede)=>{
        config = $fb64e7edf7ecf5b8$var$traverse(config, target, (node)=>{
            var _a;
            return [
                $fb64e7edf7ecf5b8$export$270e7ba5936d3c48(node.module, [
                    ...precede ? [
                        $fb64e7edf7ecf5b8$export$270e7ba5936d3c48(module)
                    ] : [],
                    ...(_a = node.children) !== null && _a !== void 0 ? _a : [],
                    ...!precede ? [
                        $fb64e7edf7ecf5b8$export$270e7ba5936d3c48(module)
                    ] : []
                ])
            ];
        });
    };
    const addSibling = (target, module, precede)=>{
        config = $fb64e7edf7ecf5b8$var$traverse(config, target, (node)=>[
                ...precede ? [
                    $fb64e7edf7ecf5b8$export$270e7ba5936d3c48(module)
                ] : [],
                node,
                ...!precede ? [
                    $fb64e7edf7ecf5b8$export$270e7ba5936d3c48(module)
                ] : []
            ]);
    };
    const addModule = (module)=>{
        append((0, $68171a1f1cc3fc3e$export$b861c6f4d58b4c2f), module);
    };
    const replace = (target, module)=>{
        config = $fb64e7edf7ecf5b8$var$traverse(config, target, (node)=>[
                $fb64e7edf7ecf5b8$export$270e7ba5936d3c48(module, node.children)
            ]);
    };
    const remove = (target)=>{
        config = $fb64e7edf7ecf5b8$var$traverse(config, target, (node)=>node.children);
    };
    const augment = (augmentation)=>{
        augmentations.push(augmentation);
    };
    plugins.forEach((plugin)=>{
        plugin({
            contains: contains,
            addParent: addParent,
            append: append,
            addChild: addChild,
            addSibling: addSibling,
            addModule: addModule,
            replace: replace,
            remove: remove,
            augment: augment
        });
    });
    return {
        config: config,
        augmentation: (props)=>augmentations.reduce((acc, augmentation)=>augmentation(acc), props)
    };
}
const $fb64e7edf7ecf5b8$export$bec71e4205979323 = $bh6RR.createContext(null);
const $fb64e7edf7ecf5b8$export$3992c64d261ded5a = $fb64e7edf7ecf5b8$export$aac3e49c3c8b5cb0("useA11yContext", "A11yContext", $fb64e7edf7ecf5b8$export$bec71e4205979323);
function $fb64e7edf7ecf5b8$export$e41a845d3e53ea09({ children: children }) {
    const [focusWithin, setFocusWithin] = $bh6RR.useState(false);
    const [autoPlaying, setAutoPlaying] = $bh6RR.useState(false);
    const context = $bh6RR.useMemo(()=>{
        const trackFocusWithin = (onFocus, onBlur)=>{
            const trackAndDelegate = (focusWithinValue)=>(event)=>{
                    var _a;
                    if (!event.currentTarget.contains(event.relatedTarget)) setFocusWithin(focusWithinValue);
                    (_a = focusWithinValue ? onFocus : onBlur) === null || _a === void 0 || _a(event);
                };
            return {
                onFocus: trackAndDelegate(true),
                onBlur: trackAndDelegate(false)
            };
        };
        return {
            focusWithin: focusWithin,
            trackFocusWithin: trackFocusWithin,
            autoPlaying: autoPlaying,
            setAutoPlaying: setAutoPlaying
        };
    }, [
        focusWithin,
        autoPlaying
    ]);
    return $bh6RR.createElement($fb64e7edf7ecf5b8$export$bec71e4205979323.Provider, {
        value: context
    }, children);
}
const $fb64e7edf7ecf5b8$export$41b6c5189865fe72 = $bh6RR.createContext(null);
const $fb64e7edf7ecf5b8$export$c199d36c2862b6ed = $fb64e7edf7ecf5b8$export$aac3e49c3c8b5cb0("useDocument", "DocumentContext", $fb64e7edf7ecf5b8$export$41b6c5189865fe72);
function $fb64e7edf7ecf5b8$export$30e869153d18a2e6({ nodeRef: nodeRef, children: children }) {
    const context = $bh6RR.useMemo(()=>{
        const getOwnerDocument = (node)=>{
            var _a;
            return ((_a = node || nodeRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) || document;
        };
        const getOwnerWindow = (node)=>{
            var _a;
            return ((_a = getOwnerDocument(node)) === null || _a === void 0 ? void 0 : _a.defaultView) || window;
        };
        return {
            getOwnerDocument: getOwnerDocument,
            getOwnerWindow: getOwnerWindow
        };
    }, [
        nodeRef
    ]);
    return $bh6RR.createElement($fb64e7edf7ecf5b8$export$41b6c5189865fe72.Provider, {
        value: context
    }, children);
}
const $fb64e7edf7ecf5b8$export$f4208dae105d4d3 = $bh6RR.createContext(null);
const $fb64e7edf7ecf5b8$export$91a992459f6e0f07 = $fb64e7edf7ecf5b8$export$aac3e49c3c8b5cb0("useEvents", "EventsContext", $fb64e7edf7ecf5b8$export$f4208dae105d4d3);
function $fb64e7edf7ecf5b8$export$686accdd53ac150f({ children: children }) {
    const [subscriptions] = $bh6RR.useState({});
    $bh6RR.useEffect(()=>()=>{
            Object.keys(subscriptions).forEach((topic)=>delete subscriptions[topic]);
        }, [
        subscriptions
    ]);
    const context = $bh6RR.useMemo(()=>{
        const unsubscribe = (topic, callback)=>{
            var _a;
            (_a = subscriptions[topic]) === null || _a === void 0 || _a.splice(0, subscriptions[topic].length, ...subscriptions[topic].filter((cb)=>cb !== callback));
        };
        const subscribe = (topic, callback)=>{
            if (!subscriptions[topic]) subscriptions[topic] = [];
            subscriptions[topic].push(callback);
            return ()=>unsubscribe(topic, callback);
        };
        const publish = (...[topic, event])=>{
            var _a;
            (_a = subscriptions[topic]) === null || _a === void 0 || _a.forEach((callback)=>callback(event));
        };
        return {
            publish: publish,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };
    }, [
        subscriptions
    ]);
    return $bh6RR.createElement($fb64e7edf7ecf5b8$export$f4208dae105d4d3.Provider, {
        value: context
    }, children);
}
const $fb64e7edf7ecf5b8$export$9f6b9cbf1d54cc28 = $bh6RR.createContext(null);
const $fb64e7edf7ecf5b8$export$d930f3536e1c64f6 = $fb64e7edf7ecf5b8$export$aac3e49c3c8b5cb0("useLightboxProps", "LightboxPropsContext", $fb64e7edf7ecf5b8$export$9f6b9cbf1d54cc28);
function $fb64e7edf7ecf5b8$export$7141a340a3dea601({ children: children, ...props }) {
    return $bh6RR.createElement($fb64e7edf7ecf5b8$export$9f6b9cbf1d54cc28.Provider, {
        value: props
    }, children);
}
const $fb64e7edf7ecf5b8$export$c24db94cf7704d3a = $bh6RR.createContext(null);
const $fb64e7edf7ecf5b8$export$566121e2bbc52eec = $fb64e7edf7ecf5b8$export$aac3e49c3c8b5cb0("useLightboxState", "LightboxStateContext", $fb64e7edf7ecf5b8$export$c24db94cf7704d3a);
const $fb64e7edf7ecf5b8$export$42eb31c6c0f01c10 = $bh6RR.createContext(null);
const $fb64e7edf7ecf5b8$export$9463bb14d6ba055e = $fb64e7edf7ecf5b8$export$aac3e49c3c8b5cb0("useLightboxDispatch", "LightboxDispatchContext", $fb64e7edf7ecf5b8$export$42eb31c6c0f01c10);
function $fb64e7edf7ecf5b8$var$reducer(state, action) {
    switch(action.type){
        case "swipe":
            {
                const { slides: slides } = state;
                const increment = (action === null || action === void 0 ? void 0 : action.increment) || 0;
                const globalIndex = state.globalIndex + increment;
                const currentIndex = $fb64e7edf7ecf5b8$export$501611100333094a(globalIndex, slides.length);
                const currentSlide = $fb64e7edf7ecf5b8$export$9f2f3fed4fdffdfc(slides, currentIndex);
                const animation = increment || action.duration !== undefined ? {
                    increment: increment,
                    duration: action.duration,
                    easing: action.easing
                } : undefined;
                return {
                    slides: slides,
                    currentIndex: currentIndex,
                    globalIndex: globalIndex,
                    currentSlide: currentSlide,
                    animation: animation
                };
            }
        case "update":
            if (action.slides !== state.slides || action.index !== state.currentIndex) return {
                slides: action.slides,
                currentIndex: action.index,
                globalIndex: action.index,
                currentSlide: $fb64e7edf7ecf5b8$export$9f2f3fed4fdffdfc(action.slides, action.index)
            };
            return state;
        default:
            throw new Error((0, $68171a1f1cc3fc3e$export$b149fc25cb186fec));
    }
}
function $fb64e7edf7ecf5b8$export$62d2e1d2e7609988({ slides: slides, index: index, children: children }) {
    const [state, dispatch] = $bh6RR.useReducer($fb64e7edf7ecf5b8$var$reducer, {
        slides: slides,
        currentIndex: index,
        globalIndex: index,
        currentSlide: $fb64e7edf7ecf5b8$export$9f2f3fed4fdffdfc(slides, index)
    });
    $bh6RR.useEffect(()=>{
        dispatch({
            type: "update",
            slides: slides,
            index: index
        });
    }, [
        slides,
        index
    ]);
    const context = $bh6RR.useMemo(()=>({
            ...state,
            state: state,
            dispatch: dispatch
        }), [
        state,
        dispatch
    ]);
    return $bh6RR.createElement($fb64e7edf7ecf5b8$export$42eb31c6c0f01c10.Provider, {
        value: dispatch
    }, $bh6RR.createElement($fb64e7edf7ecf5b8$export$c24db94cf7704d3a.Provider, {
        value: context
    }, children));
}
const $fb64e7edf7ecf5b8$export$e338b1178a56544e = $bh6RR.createContext(null);
const $fb64e7edf7ecf5b8$export$1bc7162631c81b3f = $fb64e7edf7ecf5b8$export$aac3e49c3c8b5cb0("useTimeouts", "TimeoutsContext", $fb64e7edf7ecf5b8$export$e338b1178a56544e);
function $fb64e7edf7ecf5b8$export$9d9954f5885fa393({ children: children }) {
    const [timeouts] = $bh6RR.useState([]);
    $bh6RR.useEffect(()=>()=>{
            timeouts.forEach((tid)=>window.clearTimeout(tid));
            timeouts.splice(0, timeouts.length);
        }, [
        timeouts
    ]);
    const context = $bh6RR.useMemo(()=>{
        const removeTimeout = (id)=>{
            timeouts.splice(0, timeouts.length, ...timeouts.filter((tid)=>tid !== id));
        };
        const setTimeout = (fn, delay)=>{
            const id = window.setTimeout(()=>{
                removeTimeout(id);
                fn();
            }, delay);
            timeouts.push(id);
            return id;
        };
        const clearTimeout = (id)=>{
            if (id !== undefined) {
                removeTimeout(id);
                window.clearTimeout(id);
            }
        };
        return {
            setTimeout: setTimeout,
            clearTimeout: clearTimeout
        };
    }, [
        timeouts
    ]);
    return $bh6RR.createElement($fb64e7edf7ecf5b8$export$e338b1178a56544e.Provider, {
        value: context
    }, children);
}
const $fb64e7edf7ecf5b8$export$c25acd513dcc8062 = $bh6RR.forwardRef(function IconButton({ label: label, className: className, icon: Icon, renderIcon: renderIcon, onClick: onClick, style: style, ...rest }, ref) {
    const { styles: styles, labels: labels } = $fb64e7edf7ecf5b8$export$d930f3536e1c64f6();
    const buttonLabel = $fb64e7edf7ecf5b8$export$1c4d965eb6f65dfa(labels, label);
    return $bh6RR.createElement("button", {
        ref: ref,
        type: "button",
        title: buttonLabel,
        "aria-label": buttonLabel,
        className: $fb64e7edf7ecf5b8$export$4f5d2d50c9deca37($fb64e7edf7ecf5b8$export$1283875077dc8f0a((0, $68171a1f1cc3fc3e$export$d62fb7722b07f2f3)), className),
        onClick: onClick,
        style: {
            ...style,
            ...styles.button
        },
        ...rest
    }, renderIcon ? renderIcon() : $bh6RR.createElement(Icon, {
        className: $fb64e7edf7ecf5b8$export$1283875077dc8f0a((0, $68171a1f1cc3fc3e$export$c5f5ca1963fed141)),
        style: styles.icon
    }));
});
function $fb64e7edf7ecf5b8$var$svgIcon(name, children) {
    const icon = (props)=>$bh6RR.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24",
            "aria-hidden": "true",
            focusable: "false",
            ...props
        }, children);
    icon.displayName = name;
    return icon;
}
function $fb64e7edf7ecf5b8$export$274edc73af1ae9c8(name, glyph) {
    return $fb64e7edf7ecf5b8$var$svgIcon(name, $bh6RR.createElement("g", {
        fill: "currentColor"
    }, $bh6RR.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), glyph));
}
function $fb64e7edf7ecf5b8$export$6b1fd58c1dc933ec(name, glyph) {
    return $fb64e7edf7ecf5b8$var$svgIcon(name, $bh6RR.createElement($bh6RR.Fragment, null, $bh6RR.createElement("defs", null, $bh6RR.createElement("mask", {
        id: "strike"
    }, $bh6RR.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "white"
    }), $bh6RR.createElement("path", {
        d: "M0 0L24 24",
        stroke: "black",
        strokeWidth: 4
    }))), $bh6RR.createElement("path", {
        d: "M0.70707 2.121320L21.878680 23.292883",
        stroke: "currentColor",
        strokeWidth: 2
    }), $bh6RR.createElement("g", {
        fill: "currentColor",
        mask: "url(#strike)"
    }, $bh6RR.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), glyph)));
}
const $fb64e7edf7ecf5b8$export$cae179f078f4b4a4 = $fb64e7edf7ecf5b8$export$274edc73af1ae9c8("Close", $bh6RR.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}));
const $fb64e7edf7ecf5b8$export$d05925e1c7f3f136 = $fb64e7edf7ecf5b8$export$274edc73af1ae9c8("Previous", $bh6RR.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}));
const $fb64e7edf7ecf5b8$export$3da0e0ec94bd4ce1 = $fb64e7edf7ecf5b8$export$274edc73af1ae9c8("Next", $bh6RR.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}));
const $fb64e7edf7ecf5b8$export$b936c55164dcf1db = $fb64e7edf7ecf5b8$export$274edc73af1ae9c8("Loading", $bh6RR.createElement($bh6RR.Fragment, null, Array.from({
    length: 8
}).map((_, index, array)=>$bh6RR.createElement("line", {
        key: index,
        x1: "12",
        y1: "6.5",
        x2: "12",
        y2: "1.8",
        strokeLinecap: "round",
        strokeWidth: "2.6",
        stroke: "currentColor",
        strokeOpacity: 1 / array.length * (index + 1),
        transform: `rotate(${360 / array.length * index}, 12, 12)`
    }))));
const $fb64e7edf7ecf5b8$export$19bc16ee58e19b3d = $fb64e7edf7ecf5b8$export$274edc73af1ae9c8("Error", $bh6RR.createElement("path", {
    d: "M21.9,21.9l-8.49-8.49l0,0L3.59,3.59l0,0L2.1,2.1L0.69,3.51L3,5.83V19c0,1.1,0.9,2,2,2h13.17l2.31,2.31L21.9,21.9z M5,18 l3.5-4.5l2.5,3.01L12.17,15l3,3H5z M21,18.17L5.83,3H19c1.1,0,2,0.9,2,2V18.17z"
}));
const $fb64e7edf7ecf5b8$export$e5c5a5f917a5871c = $fb64e7edf7ecf5b8$export$fef62134eea24008() ? $bh6RR.useLayoutEffect : $bh6RR.useEffect;
function $fb64e7edf7ecf5b8$export$f3e625e1b2b31d60() {
    const [reduceMotion, setReduceMotion] = $bh6RR.useState(false);
    $bh6RR.useEffect(()=>{
        var _a, _b;
        const mediaQuery = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-reduced-motion: reduce)");
        setReduceMotion(mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches);
        const listener = (event)=>setReduceMotion(event.matches);
        (_b = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.addEventListener) === null || _b === void 0 || _b.call(mediaQuery, "change", listener);
        return ()=>{
            var _a;
            return (_a = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(mediaQuery, "change", listener);
        };
    }, []);
    return reduceMotion;
}
function $fb64e7edf7ecf5b8$var$currentTransformation(node) {
    let x = 0;
    let y = 0;
    let z = 0;
    const matrix = window.getComputedStyle(node).transform;
    const matcher = matrix.match(/matrix.*\((.+)\)/);
    if (matcher) {
        const values = matcher[1].split(",").map($fb64e7edf7ecf5b8$export$5f87784a266e50a4);
        if (values.length === 6) {
            x = values[4];
            y = values[5];
        } else if (values.length === 16) {
            x = values[12];
            y = values[13];
            z = values[14];
        }
    }
    return {
        x: x,
        y: y,
        z: z
    };
}
function $fb64e7edf7ecf5b8$export$9e2608686d4ad846(nodeRef, computeAnimation) {
    const snapshot = $bh6RR.useRef(undefined);
    const animation = $bh6RR.useRef(undefined);
    const reduceMotion = $fb64e7edf7ecf5b8$export$f3e625e1b2b31d60();
    $fb64e7edf7ecf5b8$export$e5c5a5f917a5871c(()=>{
        var _a, _b, _c;
        if (nodeRef.current && snapshot.current !== undefined && !reduceMotion) {
            const { keyframes: keyframes, duration: duration, easing: easing, onfinish: onfinish } = computeAnimation(snapshot.current, nodeRef.current.getBoundingClientRect(), $fb64e7edf7ecf5b8$var$currentTransformation(nodeRef.current)) || {};
            if (keyframes && duration) {
                (_a = animation.current) === null || _a === void 0 || _a.cancel();
                animation.current = undefined;
                try {
                    animation.current = (_c = (_b = nodeRef.current).animate) === null || _c === void 0 ? void 0 : _c.call(_b, keyframes, {
                        duration: duration,
                        easing: easing
                    });
                } catch (err) {
                    console.error(err);
                }
                if (animation.current) animation.current.onfinish = ()=>{
                    animation.current = undefined;
                    onfinish === null || onfinish === void 0 || onfinish();
                };
            }
        }
        snapshot.current = undefined;
    });
    return {
        prepareAnimation: (currentSnapshot)=>{
            snapshot.current = currentSnapshot;
        },
        isAnimationPlaying: ()=>{
            var _a;
            return ((_a = animation.current) === null || _a === void 0 ? void 0 : _a.playState) === "running";
        }
    };
}
function $fb64e7edf7ecf5b8$export$b1d85de58d38d09d() {
    const containerRef = $bh6RR.useRef(null);
    const observerRef = $bh6RR.useRef(undefined);
    const [containerRect, setContainerRect] = $bh6RR.useState();
    const setContainerRef = $bh6RR.useCallback((node)=>{
        containerRef.current = node;
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = undefined;
        }
        const updateContainerRect = ()=>{
            if (node) {
                const styles = window.getComputedStyle(node);
                const parse = (value)=>parseFloat(value) || 0;
                setContainerRect({
                    width: Math.round(node.clientWidth - parse(styles.paddingLeft) - parse(styles.paddingRight)),
                    height: Math.round(node.clientHeight - parse(styles.paddingTop) - parse(styles.paddingBottom))
                });
            } else setContainerRect(undefined);
        };
        updateContainerRect();
        if (node && typeof ResizeObserver !== "undefined") {
            observerRef.current = new ResizeObserver(updateContainerRect);
            observerRef.current.observe(node);
        }
    }, []);
    return {
        setContainerRef: setContainerRef,
        containerRef: containerRef,
        containerRect: containerRect
    };
}
function $fb64e7edf7ecf5b8$export$69f38700ea0cb3b9() {
    const timeoutId = $bh6RR.useRef(undefined);
    const { setTimeout: setTimeout, clearTimeout: clearTimeout } = $fb64e7edf7ecf5b8$export$1bc7162631c81b3f();
    return $bh6RR.useCallback((callback, delay)=>{
        clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay > 0 ? delay : 0);
    }, [
        setTimeout,
        clearTimeout
    ]);
}
function $fb64e7edf7ecf5b8$export$ee5b5d04074a389e(fn) {
    const ref = $bh6RR.useRef(fn);
    $fb64e7edf7ecf5b8$export$e5c5a5f917a5871c(()=>{
        ref.current = fn;
    });
    return $bh6RR.useCallback((...args)=>{
        var _a;
        return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.call(ref, ...args);
    }, []);
}
function $fb64e7edf7ecf5b8$export$4bb192c7cacf928f(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $fb64e7edf7ecf5b8$export$ebc1e1560c2dffa5(refA, refB) {
    return $bh6RR.useMemo(()=>refA == null && refB == null ? null : (refValue)=>{
            $fb64e7edf7ecf5b8$export$4bb192c7cacf928f(refA, refValue);
            $fb64e7edf7ecf5b8$export$4bb192c7cacf928f(refB, refValue);
        }, [
        refA,
        refB
    ]);
}
function $fb64e7edf7ecf5b8$export$2bd1c19440b9235c(focus, disabled = false) {
    const focused = $bh6RR.useRef(false);
    $fb64e7edf7ecf5b8$export$e5c5a5f917a5871c(()=>{
        if (disabled && focused.current) {
            focused.current = false;
            focus();
        }
    }, [
        disabled,
        focus
    ]);
    const onFocus = $bh6RR.useCallback(()=>{
        focused.current = true;
    }, []);
    const onBlur = $bh6RR.useCallback(()=>{
        focused.current = false;
    }, []);
    return {
        onFocus: onFocus,
        onBlur: onBlur
    };
}
function $fb64e7edf7ecf5b8$export$81f015b3ec5d61cf() {
    const [isRTL, setIsRTL] = $bh6RR.useState(false);
    $fb64e7edf7ecf5b8$export$e5c5a5f917a5871c(()=>{
        setIsRTL(window.getComputedStyle(window.document.documentElement).direction === "rtl");
    }, []);
    return isRTL;
}
function $fb64e7edf7ecf5b8$export$19012f58216d597f() {
    const [subscribers] = $bh6RR.useState({});
    const notifySubscribers = $bh6RR.useCallback((type, event)=>{
        var _a;
        (_a = subscribers[type]) === null || _a === void 0 || _a.forEach((listener)=>{
            if (!event.isPropagationStopped()) listener(event);
        });
    }, [
        subscribers
    ]);
    const registerSensors = $bh6RR.useMemo(()=>({
            onPointerDown: (event)=>notifySubscribers((0, $68171a1f1cc3fc3e$export$e15fc153f45a963d), event),
            onPointerMove: (event)=>notifySubscribers((0, $68171a1f1cc3fc3e$export$1f8863949fbdd7e5), event),
            onPointerUp: (event)=>notifySubscribers((0, $68171a1f1cc3fc3e$export$2d868b67a5791b8a), event),
            onPointerLeave: (event)=>notifySubscribers((0, $68171a1f1cc3fc3e$export$526cafa85592f1a5), event),
            onPointerCancel: (event)=>notifySubscribers((0, $68171a1f1cc3fc3e$export$22151cee048c4be9), event),
            onKeyDown: (event)=>notifySubscribers((0, $68171a1f1cc3fc3e$export$1aba4f3521686ca9), event),
            onKeyUp: (event)=>notifySubscribers((0, $68171a1f1cc3fc3e$export$bdb9f99d61a6879b), event),
            onWheel: (event)=>notifySubscribers((0, $68171a1f1cc3fc3e$export$5635dc9d647242c7), event)
        }), [
        notifySubscribers
    ]);
    const subscribeSensors = $bh6RR.useCallback((type, callback)=>{
        if (!subscribers[type]) subscribers[type] = [];
        subscribers[type].unshift(callback);
        return ()=>{
            const listeners = subscribers[type];
            if (listeners) listeners.splice(0, listeners.length, ...listeners.filter((el)=>el !== callback));
        };
    }, [
        subscribers
    ]);
    return {
        registerSensors: registerSensors,
        subscribeSensors: subscribeSensors
    };
}
function $fb64e7edf7ecf5b8$export$8b7b9481d6186f21(callback, delay) {
    const lastCallbackTime = $bh6RR.useRef(0);
    const delayCallback = $fb64e7edf7ecf5b8$export$69f38700ea0cb3b9();
    const executeCallback = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e((...args)=>{
        lastCallbackTime.current = Date.now();
        callback(args);
    });
    return $bh6RR.useCallback((...args)=>{
        delayCallback(()=>{
            executeCallback(args);
        }, delay - (Date.now() - lastCallbackTime.current));
    }, [
        delay,
        executeCallback,
        delayCallback
    ]);
}
const $fb64e7edf7ecf5b8$var$slidePrefix = $fb64e7edf7ecf5b8$export$3e7cd27eed1727c("slide");
const $fb64e7edf7ecf5b8$var$slideImagePrefix = $fb64e7edf7ecf5b8$export$3e7cd27eed1727c("slide_image");
function $fb64e7edf7ecf5b8$export$ef86b1d52c77b27b({ slide: image, offset: offset, render: render, rect: rect, imageFit: imageFit, imageProps: imageProps, onClick: onClick, onLoad: onLoad, onError: onError, style: style }) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const [status, setStatus] = $bh6RR.useState((0, $68171a1f1cc3fc3e$export$554a1415841c52a8));
    const { publish: publish } = $fb64e7edf7ecf5b8$export$91a992459f6e0f07();
    const { setTimeout: setTimeout } = $fb64e7edf7ecf5b8$export$1bc7162631c81b3f();
    const imageRef = $bh6RR.useRef(null);
    $bh6RR.useEffect(()=>{
        if (offset === 0) publish((0, $68171a1f1cc3fc3e$export$6751782e799f6445)(status));
    }, [
        offset,
        status,
        publish
    ]);
    const handleLoading = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e((img)=>{
        ("decode" in img ? img.decode() : Promise.resolve()).catch(()=>{}).then(()=>{
            if (!img.parentNode) return;
            setStatus((0, $68171a1f1cc3fc3e$export$a195e517d37aaa33));
            setTimeout(()=>{
                onLoad === null || onLoad === void 0 || onLoad(img);
            }, 0);
        });
    });
    const setImageRef = $bh6RR.useCallback((img)=>{
        imageRef.current = img;
        if (img === null || img === void 0 ? void 0 : img.complete) handleLoading(img);
    }, [
        handleLoading
    ]);
    const handleOnLoad = $bh6RR.useCallback((event)=>{
        handleLoading(event.currentTarget);
    }, [
        handleLoading
    ]);
    const handleOnError = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e(()=>{
        setStatus((0, $68171a1f1cc3fc3e$export$2ed3c80dbc178d91));
        onError === null || onError === void 0 || onError();
    });
    const cover = $fb64e7edf7ecf5b8$export$f5ba2f5b3fd12e6e(image, imageFit);
    const nonInfinite = (value, fallback)=>Number.isFinite(value) ? value : fallback;
    const maxWidth = nonInfinite(Math.max(...((_b = (_a = image.srcSet) === null || _a === void 0 ? void 0 : _a.map((x)=>x.width)) !== null && _b !== void 0 ? _b : []).concat(image.width ? [
        image.width
    ] : []).filter(Boolean)), ((_c = imageRef.current) === null || _c === void 0 ? void 0 : _c.naturalWidth) || 0);
    const maxHeight = nonInfinite(Math.max(...((_e = (_d = image.srcSet) === null || _d === void 0 ? void 0 : _d.map((x)=>x.height)) !== null && _e !== void 0 ? _e : []).concat(image.height ? [
        image.height
    ] : []).filter(Boolean)), ((_f = imageRef.current) === null || _f === void 0 ? void 0 : _f.naturalHeight) || 0);
    const defaultStyle = maxWidth && maxHeight ? {
        maxWidth: `min(${maxWidth}px, 100%)`,
        maxHeight: `min(${maxHeight}px, 100%)`
    } : {
        maxWidth: "100%",
        maxHeight: "100%"
    };
    const srcSet = (_g = image.srcSet) === null || _g === void 0 ? void 0 : _g.sort((a, b)=>a.width - b.width).map((item)=>`${item.src} ${item.width}w`).join(", ");
    const estimateActualWidth = ()=>rect && !cover && image.width && image.height ? rect.height / image.height * image.width : Number.MAX_VALUE;
    const sizes = srcSet && rect && $fb64e7edf7ecf5b8$export$fef62134eea24008() ? `${Math.round(Math.min(estimateActualWidth(), rect.width))}px` : undefined;
    const { style: imagePropsStyle, className: imagePropsClassName, ...restImageProps } = imageProps || {};
    return $bh6RR.createElement($bh6RR.Fragment, null, $bh6RR.createElement("img", {
        ref: setImageRef,
        onLoad: handleOnLoad,
        onError: handleOnError,
        onClick: onClick,
        draggable: false,
        className: $fb64e7edf7ecf5b8$export$4f5d2d50c9deca37($fb64e7edf7ecf5b8$export$1283875077dc8f0a($fb64e7edf7ecf5b8$var$slideImagePrefix()), cover && $fb64e7edf7ecf5b8$export$1283875077dc8f0a($fb64e7edf7ecf5b8$var$slideImagePrefix("cover")), status !== (0, $68171a1f1cc3fc3e$export$a195e517d37aaa33) && $fb64e7edf7ecf5b8$export$1283875077dc8f0a($fb64e7edf7ecf5b8$var$slideImagePrefix("loading")), imagePropsClassName),
        style: {
            ...defaultStyle,
            ...style,
            ...imagePropsStyle
        },
        ...restImageProps,
        alt: (_h = image.alt) !== null && _h !== void 0 ? _h : "",
        sizes: sizes,
        srcSet: srcSet,
        src: image.src
    }), status !== (0, $68171a1f1cc3fc3e$export$a195e517d37aaa33) && $bh6RR.createElement("div", {
        className: $fb64e7edf7ecf5b8$export$1283875077dc8f0a($fb64e7edf7ecf5b8$var$slidePrefix((0, $68171a1f1cc3fc3e$export$e51f1c6d74b54a13)))
    }, status === (0, $68171a1f1cc3fc3e$export$554a1415841c52a8) && ((render === null || render === void 0 ? void 0 : render.iconLoading) ? render.iconLoading() : $bh6RR.createElement($fb64e7edf7ecf5b8$export$b936c55164dcf1db, {
        className: $fb64e7edf7ecf5b8$export$4f5d2d50c9deca37($fb64e7edf7ecf5b8$export$1283875077dc8f0a((0, $68171a1f1cc3fc3e$export$c5f5ca1963fed141)), $fb64e7edf7ecf5b8$export$1283875077dc8f0a($fb64e7edf7ecf5b8$var$slidePrefix((0, $68171a1f1cc3fc3e$export$554a1415841c52a8))))
    })), status === (0, $68171a1f1cc3fc3e$export$2ed3c80dbc178d91) && ((render === null || render === void 0 ? void 0 : render.iconError) ? render.iconError() : $bh6RR.createElement($fb64e7edf7ecf5b8$export$19bc16ee58e19b3d, {
        className: $fb64e7edf7ecf5b8$export$4f5d2d50c9deca37($fb64e7edf7ecf5b8$export$1283875077dc8f0a((0, $68171a1f1cc3fc3e$export$c5f5ca1963fed141)), $fb64e7edf7ecf5b8$export$1283875077dc8f0a($fb64e7edf7ecf5b8$var$slidePrefix((0, $68171a1f1cc3fc3e$export$2ed3c80dbc178d91))))
    }))));
}
const $fb64e7edf7ecf5b8$export$597a6f74cf288f82 = $bh6RR.forwardRef(function LightboxRoot({ className: className, children: children, onFocus: onFocus, onBlur: onBlur, ...rest }, ref) {
    const nodeRef = $bh6RR.useRef(null);
    const { trackFocusWithin: trackFocusWithin } = $fb64e7edf7ecf5b8$export$3992c64d261ded5a();
    return $bh6RR.createElement($fb64e7edf7ecf5b8$export$30e869153d18a2e6, {
        nodeRef: nodeRef
    }, $bh6RR.createElement("div", {
        ref: $fb64e7edf7ecf5b8$export$ebc1e1560c2dffa5(ref, nodeRef),
        className: $fb64e7edf7ecf5b8$export$4f5d2d50c9deca37($fb64e7edf7ecf5b8$export$1283875077dc8f0a("root"), className),
        ...trackFocusWithin(onFocus, onBlur),
        ...rest
    }, children));
});
var $fb64e7edf7ecf5b8$export$59f0048f451fc458;
(function(SwipeState) {
    SwipeState[SwipeState["NONE"] = 0] = "NONE";
    SwipeState[SwipeState["SWIPE"] = 1] = "SWIPE";
    SwipeState[SwipeState["PULL"] = 2] = "PULL";
    SwipeState[SwipeState["ANIMATION"] = 3] = "ANIMATION";
})($fb64e7edf7ecf5b8$export$59f0048f451fc458 || ($fb64e7edf7ecf5b8$export$59f0048f451fc458 = {}));
function $fb64e7edf7ecf5b8$export$69c48c1cbbd6dc69(subscribeSensors, onPointerDown, onPointerMove, onPointerUp, disabled) {
    $bh6RR.useEffect(()=>!disabled ? $fb64e7edf7ecf5b8$export$de863c629cb9919d(subscribeSensors((0, $68171a1f1cc3fc3e$export$e15fc153f45a963d), onPointerDown), subscribeSensors((0, $68171a1f1cc3fc3e$export$1f8863949fbdd7e5), onPointerMove), subscribeSensors((0, $68171a1f1cc3fc3e$export$2d868b67a5791b8a), onPointerUp), subscribeSensors((0, $68171a1f1cc3fc3e$export$526cafa85592f1a5), onPointerUp), subscribeSensors((0, $68171a1f1cc3fc3e$export$22151cee048c4be9), onPointerUp)) : ()=>{}, [
        subscribeSensors,
        onPointerDown,
        onPointerMove,
        onPointerUp,
        disabled
    ]);
}
var $fb64e7edf7ecf5b8$var$Gesture;
(function(Gesture) {
    Gesture[Gesture["NONE"] = 0] = "NONE";
    Gesture[Gesture["SWIPE"] = 1] = "SWIPE";
    Gesture[Gesture["PULL"] = 2] = "PULL";
})($fb64e7edf7ecf5b8$var$Gesture || ($fb64e7edf7ecf5b8$var$Gesture = {}));
const $fb64e7edf7ecf5b8$var$SWIPE_THRESHOLD = 30;
function $fb64e7edf7ecf5b8$export$abaee32ee49963c1({ disableSwipeNavigation: disableSwipeNavigation, closeOnBackdropClick: closeOnBackdropClick }, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel, pullUpEnabled, pullDownEnabled, onPullStart, onPullProgress, onPullFinish, onPullCancel, onClose) {
    const offset = $bh6RR.useRef(0);
    const pointers = $bh6RR.useRef([]);
    const activePointer = $bh6RR.useRef(undefined);
    const startTime = $bh6RR.useRef(0);
    const gesture = $bh6RR.useRef($fb64e7edf7ecf5b8$var$Gesture.NONE);
    const clearPointer = $bh6RR.useCallback((event)=>{
        if (activePointer.current === event.pointerId) {
            activePointer.current = undefined;
            gesture.current = $fb64e7edf7ecf5b8$var$Gesture.NONE;
        }
        const currentPointers = pointers.current;
        currentPointers.splice(0, currentPointers.length, ...currentPointers.filter((p)=>p.pointerId !== event.pointerId));
    }, []);
    const addPointer = $bh6RR.useCallback((event)=>{
        clearPointer(event);
        event.persist();
        pointers.current.push(event);
    }, [
        clearPointer
    ]);
    const lookupPointer = $bh6RR.useCallback((event)=>pointers.current.find(({ pointerId: pointerId })=>event.pointerId === pointerId), []);
    const onPointerDown = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e((event)=>{
        addPointer(event);
    });
    const exceedsPullThreshold = (value, threshold)=>pullDownEnabled && value > threshold || pullUpEnabled && value < -threshold;
    const onPointerUp = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e((event)=>{
        const pointer = lookupPointer(event);
        if (pointer) {
            if (activePointer.current === event.pointerId) {
                const duration = Date.now() - startTime.current;
                const currentOffset = offset.current;
                if (gesture.current === $fb64e7edf7ecf5b8$var$Gesture.SWIPE) {
                    if (Math.abs(currentOffset) > 0.3 * containerWidth || Math.abs(currentOffset) > 5 && duration < swipeAnimationDuration) onSwipeFinish(currentOffset, duration);
                    else onSwipeCancel(currentOffset);
                } else if (gesture.current === $fb64e7edf7ecf5b8$var$Gesture.PULL) {
                    if (exceedsPullThreshold(currentOffset, 2 * $fb64e7edf7ecf5b8$var$SWIPE_THRESHOLD)) onPullFinish(currentOffset, duration);
                    else onPullCancel(currentOffset);
                }
                offset.current = 0;
                gesture.current = $fb64e7edf7ecf5b8$var$Gesture.NONE;
            } else {
                const { target: target } = event;
                if (closeOnBackdropClick && target instanceof HTMLElement && target === pointer.target && (target.classList.contains($fb64e7edf7ecf5b8$export$1283875077dc8f0a((0, $68171a1f1cc3fc3e$export$8d922915837a38d3))) || target.classList.contains($fb64e7edf7ecf5b8$export$1283875077dc8f0a((0, $68171a1f1cc3fc3e$export$ac396c284080b10c))))) onClose();
            }
        }
        clearPointer(event);
    });
    const onPointerMove = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e((event)=>{
        const pointer = lookupPointer(event);
        if (pointer) {
            const isCurrentPointer = activePointer.current === event.pointerId;
            if (event.buttons === 0) {
                if (isCurrentPointer && offset.current !== 0) onPointerUp(event);
                else clearPointer(pointer);
                return;
            }
            const deltaX = event.clientX - pointer.clientX;
            const deltaY = event.clientY - pointer.clientY;
            if (activePointer.current === undefined) {
                const startGesture = (newGesture)=>{
                    addPointer(event);
                    activePointer.current = event.pointerId;
                    startTime.current = Date.now();
                    gesture.current = newGesture;
                };
                if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > $fb64e7edf7ecf5b8$var$SWIPE_THRESHOLD && isSwipeValid(deltaX)) {
                    if (!disableSwipeNavigation) {
                        startGesture($fb64e7edf7ecf5b8$var$Gesture.SWIPE);
                        onSwipeStart();
                    }
                } else if (Math.abs(deltaY) > Math.abs(deltaX) && exceedsPullThreshold(deltaY, $fb64e7edf7ecf5b8$var$SWIPE_THRESHOLD)) {
                    startGesture($fb64e7edf7ecf5b8$var$Gesture.PULL);
                    onPullStart();
                }
            } else if (isCurrentPointer) {
                if (gesture.current === $fb64e7edf7ecf5b8$var$Gesture.SWIPE) {
                    offset.current = deltaX;
                    onSwipeProgress(deltaX);
                } else if (gesture.current === $fb64e7edf7ecf5b8$var$Gesture.PULL) {
                    offset.current = deltaY;
                    onPullProgress(deltaY);
                }
            }
        }
    });
    $fb64e7edf7ecf5b8$export$69c48c1cbbd6dc69(subscribeSensors, onPointerDown, onPointerMove, onPointerUp);
}
function $fb64e7edf7ecf5b8$export$145fefb2d7286388({ preventDefaultWheelX: preventDefaultWheelX, preventDefaultWheelY: preventDefaultWheelY }) {
    const ref = $bh6RR.useRef(null);
    const listener = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e((event)=>{
        const horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        if (horizontal && preventDefaultWheelX || !horizontal && preventDefaultWheelY || event.ctrlKey) event.preventDefault();
    });
    return $bh6RR.useCallback((node)=>{
        var _a;
        if (node) node.addEventListener("wheel", listener, {
            passive: false
        });
        else (_a = ref.current) === null || _a === void 0 || _a.removeEventListener("wheel", listener);
        ref.current = node;
    }, [
        listener
    ]);
}
function $fb64e7edf7ecf5b8$export$10506de8b6841445(swipeState, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel) {
    const offset = $bh6RR.useRef(0);
    const intent = $bh6RR.useRef(0);
    const intentCleanup = $bh6RR.useRef(undefined);
    const resetCleanup = $bh6RR.useRef(undefined);
    const wheelInertia = $bh6RR.useRef(0);
    const wheelInertiaCleanup = $bh6RR.useRef(undefined);
    const startTime = $bh6RR.useRef(0);
    const { setTimeout: setTimeout, clearTimeout: clearTimeout } = $fb64e7edf7ecf5b8$export$1bc7162631c81b3f();
    const cancelSwipeIntentCleanup = $bh6RR.useCallback(()=>{
        if (intentCleanup.current) {
            clearTimeout(intentCleanup.current);
            intentCleanup.current = undefined;
        }
    }, [
        clearTimeout
    ]);
    const cancelSwipeResetCleanup = $bh6RR.useCallback(()=>{
        if (resetCleanup.current) {
            clearTimeout(resetCleanup.current);
            resetCleanup.current = undefined;
        }
    }, [
        clearTimeout
    ]);
    const handleCleanup = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e(()=>{
        if (swipeState !== $fb64e7edf7ecf5b8$export$59f0048f451fc458.SWIPE) {
            offset.current = 0;
            startTime.current = 0;
            cancelSwipeIntentCleanup();
            cancelSwipeResetCleanup();
        }
    });
    $bh6RR.useEffect(handleCleanup, [
        swipeState,
        handleCleanup
    ]);
    const handleCancelSwipe = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e((currentSwipeOffset)=>{
        resetCleanup.current = undefined;
        if (offset.current === currentSwipeOffset) onSwipeCancel(offset.current);
    });
    const onWheel = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e((event)=>{
        if (event.ctrlKey) return;
        if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) return;
        const setWheelInertia = (inertia)=>{
            wheelInertia.current = inertia;
            clearTimeout(wheelInertiaCleanup.current);
            wheelInertiaCleanup.current = inertia > 0 ? setTimeout(()=>{
                wheelInertia.current = 0;
                wheelInertiaCleanup.current = undefined;
            }, 300) : undefined;
        };
        if (swipeState === $fb64e7edf7ecf5b8$export$59f0048f451fc458.NONE) {
            if (Math.abs(event.deltaX) <= 1.2 * Math.abs(wheelInertia.current)) {
                setWheelInertia(event.deltaX);
                return;
            }
            if (!isSwipeValid(-event.deltaX)) return;
            intent.current += event.deltaX;
            cancelSwipeIntentCleanup();
            if (Math.abs(intent.current) > 30) {
                intent.current = 0;
                setWheelInertia(0);
                startTime.current = Date.now();
                onSwipeStart();
            } else {
                const currentSwipeIntent = intent.current;
                intentCleanup.current = setTimeout(()=>{
                    intentCleanup.current = undefined;
                    if (currentSwipeIntent === intent.current) intent.current = 0;
                }, swipeAnimationDuration);
            }
        } else if (swipeState === $fb64e7edf7ecf5b8$export$59f0048f451fc458.SWIPE) {
            let newSwipeOffset = offset.current - event.deltaX;
            newSwipeOffset = Math.min(Math.abs(newSwipeOffset), containerWidth) * Math.sign(newSwipeOffset);
            offset.current = newSwipeOffset;
            onSwipeProgress(newSwipeOffset);
            cancelSwipeResetCleanup();
            if (Math.abs(newSwipeOffset) > 0.2 * containerWidth) {
                setWheelInertia(event.deltaX);
                onSwipeFinish(newSwipeOffset, Date.now() - startTime.current);
                return;
            }
            resetCleanup.current = setTimeout(()=>handleCancelSwipe(newSwipeOffset), 2 * swipeAnimationDuration);
        } else setWheelInertia(event.deltaX);
    });
    $bh6RR.useEffect(()=>subscribeSensors((0, $68171a1f1cc3fc3e$export$5635dc9d647242c7), onWheel), [
        subscribeSensors,
        onWheel
    ]);
}
const $fb64e7edf7ecf5b8$var$cssContainerPrefix = $fb64e7edf7ecf5b8$export$3e7cd27eed1727c("container");
const $fb64e7edf7ecf5b8$export$e92ff191b0c59550 = $bh6RR.createContext(null);
const $fb64e7edf7ecf5b8$export$e8c786024a2b0a79 = $fb64e7edf7ecf5b8$export$aac3e49c3c8b5cb0("useController", "ControllerContext", $fb64e7edf7ecf5b8$export$e92ff191b0c59550);
function $fb64e7edf7ecf5b8$export$bd0bf19f25da8474({ children: children, ...props }) {
    var _a;
    const { carousel: carousel, animation: animation, controller: controller, on: on, styles: styles, render: render } = props;
    const { closeOnPullUp: closeOnPullUp, closeOnPullDown: closeOnPullDown, preventDefaultWheelX: preventDefaultWheelX, preventDefaultWheelY: preventDefaultWheelY } = controller;
    const [toolbarWidth, setToolbarWidth] = $bh6RR.useState();
    const state = $fb64e7edf7ecf5b8$export$566121e2bbc52eec();
    const dispatch = $fb64e7edf7ecf5b8$export$9463bb14d6ba055e();
    const [swipeState, setSwipeState] = $bh6RR.useState($fb64e7edf7ecf5b8$export$59f0048f451fc458.NONE);
    const swipeOffset = $bh6RR.useRef(0);
    const pullOffset = $bh6RR.useRef(0);
    const pullOpacity = $bh6RR.useRef(1);
    const { registerSensors: registerSensors, subscribeSensors: subscribeSensors } = $fb64e7edf7ecf5b8$export$19012f58216d597f();
    const { subscribe: subscribe, publish: publish } = $fb64e7edf7ecf5b8$export$91a992459f6e0f07();
    const cleanupAnimationIncrement = $fb64e7edf7ecf5b8$export$69f38700ea0cb3b9();
    const cleanupSwipeOffset = $fb64e7edf7ecf5b8$export$69f38700ea0cb3b9();
    const cleanupPullOffset = $fb64e7edf7ecf5b8$export$69f38700ea0cb3b9();
    const { containerRef: containerRef, setContainerRef: setContainerRef, containerRect: containerRect } = $fb64e7edf7ecf5b8$export$b1d85de58d38d09d();
    const handleContainerRef = $fb64e7edf7ecf5b8$export$ebc1e1560c2dffa5($fb64e7edf7ecf5b8$export$145fefb2d7286388({
        preventDefaultWheelX: preventDefaultWheelX,
        preventDefaultWheelY: preventDefaultWheelY
    }), setContainerRef);
    const carouselRef = $bh6RR.useRef(null);
    const setCarouselRef = $fb64e7edf7ecf5b8$export$ebc1e1560c2dffa5(carouselRef, undefined);
    const { getOwnerDocument: getOwnerDocument } = $fb64e7edf7ecf5b8$export$c199d36c2862b6ed();
    const isRTL = $fb64e7edf7ecf5b8$export$81f015b3ec5d61cf();
    const rtl = (value)=>(isRTL ? -1 : 1) * (typeof value === "number" ? value : 1);
    const focus = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e(()=>{
        var _a;
        return (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    });
    const getLightboxProps = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e(()=>props);
    const getLightboxState = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e(()=>state);
    const prev = $bh6RR.useCallback((params)=>publish((0, $68171a1f1cc3fc3e$export$a007161537026955), params), [
        publish
    ]);
    const next = $bh6RR.useCallback((params)=>publish((0, $68171a1f1cc3fc3e$export$f1d7a854db833ed4), params), [
        publish
    ]);
    const close = $bh6RR.useCallback(()=>publish((0, $68171a1f1cc3fc3e$export$493a596486210a21)), [
        publish
    ]);
    const isSwipeValid = (offset)=>!(carousel.finite && (rtl(offset) > 0 && state.currentIndex === 0 || rtl(offset) < 0 && state.currentIndex === state.slides.length - 1));
    const setSwipeOffset = (offset)=>{
        var _a;
        swipeOffset.current = offset;
        (_a = containerRef.current) === null || _a === void 0 || _a.style.setProperty($fb64e7edf7ecf5b8$export$8b4981022bd80a4e("swipe_offset"), `${Math.round(offset)}px`);
    };
    const setPullOffset = (offset)=>{
        var _a, _b;
        pullOffset.current = offset;
        pullOpacity.current = (()=>{
            const threshold = 60;
            const minOpacity = 0.5;
            const offsetValue = (()=>{
                if (closeOnPullDown && offset > 0) return offset;
                if (closeOnPullUp && offset < 0) return -offset;
                return 0;
            })();
            return Math.min(Math.max($fb64e7edf7ecf5b8$export$2077e0241d6afd3c(1 - offsetValue / threshold * (1 - minOpacity), 2), minOpacity), 1);
        })();
        (_a = containerRef.current) === null || _a === void 0 || _a.style.setProperty($fb64e7edf7ecf5b8$export$8b4981022bd80a4e("pull_offset"), `${Math.round(offset)}px`);
        (_b = containerRef.current) === null || _b === void 0 || _b.style.setProperty($fb64e7edf7ecf5b8$export$8b4981022bd80a4e("pull_opacity"), `${pullOpacity.current}`);
    };
    const { prepareAnimation: preparePullAnimation } = $fb64e7edf7ecf5b8$export$9e2608686d4ad846(carouselRef, (snapshot, rect, translate)=>{
        if (carouselRef.current && containerRect) return {
            keyframes: [
                {
                    transform: `translate(0, ${snapshot.rect.y - rect.y + translate.y}px)`,
                    opacity: snapshot.opacity
                },
                {
                    transform: "translate(0, 0)",
                    opacity: 1
                }
            ],
            duration: snapshot.duration,
            easing: animation.easing.fade
        };
        return undefined;
    });
    const pull = (offset, cancel)=>{
        if (closeOnPullUp || closeOnPullDown) {
            setPullOffset(offset);
            let duration = 0;
            if (carouselRef.current) {
                duration = animation.fade * (cancel ? 2 : 1);
                preparePullAnimation({
                    rect: carouselRef.current.getBoundingClientRect(),
                    opacity: pullOpacity.current,
                    duration: duration
                });
            }
            cleanupPullOffset(()=>{
                setPullOffset(0);
                setSwipeState($fb64e7edf7ecf5b8$export$59f0048f451fc458.NONE);
            }, duration);
            setSwipeState($fb64e7edf7ecf5b8$export$59f0048f451fc458.ANIMATION);
            if (!cancel) close();
        }
    };
    const { prepareAnimation: prepareAnimation, isAnimationPlaying: isAnimationPlaying } = $fb64e7edf7ecf5b8$export$9e2608686d4ad846(carouselRef, (snapshot, rect, translate)=>{
        var _a;
        if (carouselRef.current && containerRect && ((_a = state.animation) === null || _a === void 0 ? void 0 : _a.duration)) {
            const parsedSpacing = $fb64e7edf7ecf5b8$export$7871fb532d320d99(carousel.spacing);
            const spacingValue = (parsedSpacing.percent ? parsedSpacing.percent * containerRect.width / 100 : parsedSpacing.pixel) || 0;
            return {
                keyframes: [
                    {
                        transform: `translate(${rtl(state.globalIndex - snapshot.index) * (containerRect.width + spacingValue) + snapshot.rect.x - rect.x + translate.x}px, 0)`
                    },
                    {
                        transform: "translate(0, 0)"
                    }
                ],
                duration: state.animation.duration,
                easing: state.animation.easing
            };
        }
        return undefined;
    });
    const swipe = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e((action)=>{
        var _a, _b;
        const currentSwipeOffset = action.offset || 0;
        const swipeDuration = !currentSwipeOffset ? (_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe : animation.swipe;
        const swipeEasing = !currentSwipeOffset && !isAnimationPlaying() ? animation.easing.navigation : animation.easing.swipe;
        let { direction: direction } = action;
        const count = (_b = action.count) !== null && _b !== void 0 ? _b : 1;
        let newSwipeState = $fb64e7edf7ecf5b8$export$59f0048f451fc458.ANIMATION;
        let newSwipeAnimationDuration = swipeDuration * count;
        if (!direction) {
            const containerWidth = containerRect === null || containerRect === void 0 ? void 0 : containerRect.width;
            const elapsedTime = action.duration || 0;
            const expectedTime = containerWidth ? swipeDuration / containerWidth * Math.abs(currentSwipeOffset) : swipeDuration;
            if (count !== 0) {
                if (elapsedTime < expectedTime) newSwipeAnimationDuration = newSwipeAnimationDuration / expectedTime * Math.max(elapsedTime, expectedTime / 5);
                else if (containerWidth) newSwipeAnimationDuration = swipeDuration / containerWidth * (containerWidth - Math.abs(currentSwipeOffset));
                direction = rtl(currentSwipeOffset) > 0 ? (0, $68171a1f1cc3fc3e$export$a007161537026955) : (0, $68171a1f1cc3fc3e$export$f1d7a854db833ed4);
            } else newSwipeAnimationDuration = swipeDuration / 2;
        }
        let increment = 0;
        if (direction === (0, $68171a1f1cc3fc3e$export$a007161537026955)) {
            if (isSwipeValid(rtl(1))) increment = -count;
            else {
                newSwipeState = $fb64e7edf7ecf5b8$export$59f0048f451fc458.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        } else if (direction === (0, $68171a1f1cc3fc3e$export$f1d7a854db833ed4)) {
            if (isSwipeValid(rtl(-1))) increment = count;
            else {
                newSwipeState = $fb64e7edf7ecf5b8$export$59f0048f451fc458.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        }
        newSwipeAnimationDuration = Math.round(newSwipeAnimationDuration);
        cleanupSwipeOffset(()=>{
            setSwipeOffset(0);
            setSwipeState($fb64e7edf7ecf5b8$export$59f0048f451fc458.NONE);
        }, newSwipeAnimationDuration);
        if (carouselRef.current) prepareAnimation({
            rect: carouselRef.current.getBoundingClientRect(),
            index: state.globalIndex
        });
        setSwipeState(newSwipeState);
        publish((0, $68171a1f1cc3fc3e$export$c43bd1a4101c4078), {
            type: "swipe",
            increment: increment,
            duration: newSwipeAnimationDuration,
            easing: swipeEasing
        });
    });
    $bh6RR.useEffect(()=>{
        var _a, _b;
        if (((_a = state.animation) === null || _a === void 0 ? void 0 : _a.increment) && ((_b = state.animation) === null || _b === void 0 ? void 0 : _b.duration)) cleanupAnimationIncrement(()=>dispatch({
                type: "swipe",
                increment: 0
            }), state.animation.duration);
    }, [
        state.animation,
        dispatch,
        cleanupAnimationIncrement
    ]);
    const swipeParams = [
        subscribeSensors,
        isSwipeValid,
        (containerRect === null || containerRect === void 0 ? void 0 : containerRect.width) || 0,
        animation.swipe,
        ()=>setSwipeState($fb64e7edf7ecf5b8$export$59f0048f451fc458.SWIPE),
        (offset)=>setSwipeOffset(offset),
        (offset, duration)=>swipe({
                offset: offset,
                duration: duration,
                count: 1
            }),
        (offset)=>swipe({
                offset: offset,
                count: 0
            })
    ];
    const pullParams = [
        ()=>{
            if (closeOnPullDown) setSwipeState($fb64e7edf7ecf5b8$export$59f0048f451fc458.PULL);
        },
        (offset)=>setPullOffset(offset),
        (offset)=>pull(offset),
        (offset)=>pull(offset, true)
    ];
    $fb64e7edf7ecf5b8$export$abaee32ee49963c1(controller, ...swipeParams, closeOnPullUp, closeOnPullDown, ...pullParams, close);
    $fb64e7edf7ecf5b8$export$10506de8b6841445(swipeState, ...swipeParams);
    const focusOnMount = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e(()=>{
        if (controller.focus && getOwnerDocument().querySelector(`.${$fb64e7edf7ecf5b8$export$1283875077dc8f0a((0, $68171a1f1cc3fc3e$export$9d2e4856063e1a22))} .${$fb64e7edf7ecf5b8$export$1283875077dc8f0a($fb64e7edf7ecf5b8$var$cssContainerPrefix())}`)) focus();
    });
    $bh6RR.useEffect(focusOnMount, [
        focusOnMount
    ]);
    const onViewCallback = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e(()=>{
        var _a;
        (_a = on.view) === null || _a === void 0 || _a.call(on, {
            index: state.currentIndex
        });
    });
    $bh6RR.useEffect(onViewCallback, [
        state.globalIndex,
        onViewCallback
    ]);
    $bh6RR.useEffect(()=>$fb64e7edf7ecf5b8$export$de863c629cb9919d(subscribe((0, $68171a1f1cc3fc3e$export$a007161537026955), (action)=>swipe({
                direction: (0, $68171a1f1cc3fc3e$export$a007161537026955),
                ...action
            })), subscribe((0, $68171a1f1cc3fc3e$export$f1d7a854db833ed4), (action)=>swipe({
                direction: (0, $68171a1f1cc3fc3e$export$f1d7a854db833ed4),
                ...action
            })), subscribe((0, $68171a1f1cc3fc3e$export$c43bd1a4101c4078), (action)=>dispatch(action))), [
        subscribe,
        swipe,
        dispatch
    ]);
    const context = $bh6RR.useMemo(()=>({
            prev: prev,
            next: next,
            close: close,
            focus: focus,
            slideRect: containerRect ? $fb64e7edf7ecf5b8$export$7ff571008bce9900(containerRect, carousel.padding) : {
                width: 0,
                height: 0
            },
            containerRect: containerRect || {
                width: 0,
                height: 0
            },
            subscribeSensors: subscribeSensors,
            containerRef: containerRef,
            setCarouselRef: setCarouselRef,
            toolbarWidth: toolbarWidth,
            setToolbarWidth: setToolbarWidth
        }), [
        prev,
        next,
        close,
        focus,
        subscribeSensors,
        containerRect,
        containerRef,
        setCarouselRef,
        toolbarWidth,
        setToolbarWidth,
        carousel.padding
    ]);
    $bh6RR.useImperativeHandle(controller.ref, ()=>({
            prev: prev,
            next: next,
            close: close,
            focus: focus,
            getLightboxProps: getLightboxProps,
            getLightboxState: getLightboxState
        }), [
        prev,
        next,
        close,
        focus,
        getLightboxProps,
        getLightboxState
    ]);
    return $bh6RR.createElement("div", {
        ref: handleContainerRef,
        className: $fb64e7edf7ecf5b8$export$4f5d2d50c9deca37($fb64e7edf7ecf5b8$export$1283875077dc8f0a($fb64e7edf7ecf5b8$var$cssContainerPrefix()), $fb64e7edf7ecf5b8$export$1283875077dc8f0a((0, $68171a1f1cc3fc3e$export$974a68ef150451f5))),
        style: {
            ...swipeState === $fb64e7edf7ecf5b8$export$59f0048f451fc458.SWIPE ? {
                [$fb64e7edf7ecf5b8$export$8b4981022bd80a4e("swipe_offset")]: `${Math.round(swipeOffset.current)}px`
            } : null,
            ...swipeState === $fb64e7edf7ecf5b8$export$59f0048f451fc458.PULL ? {
                [$fb64e7edf7ecf5b8$export$8b4981022bd80a4e("pull_offset")]: `${Math.round(pullOffset.current)}px`,
                [$fb64e7edf7ecf5b8$export$8b4981022bd80a4e("pull_opacity")]: `${pullOpacity.current}`
            } : null,
            ...controller.touchAction !== "none" ? {
                [$fb64e7edf7ecf5b8$export$8b4981022bd80a4e("controller_touch_action")]: controller.touchAction
            } : null,
            ...styles.container
        },
        tabIndex: -1,
        ...registerSensors
    }, containerRect && $bh6RR.createElement($fb64e7edf7ecf5b8$export$e92ff191b0c59550.Provider, {
        value: context
    }, children, (_a = render.controls) === null || _a === void 0 ? void 0 : _a.call(render)));
}
const $fb64e7edf7ecf5b8$export$be59d34228c8ec8a = $fb64e7edf7ecf5b8$export$c5ba3739ffba980d((0, $68171a1f1cc3fc3e$export$b861c6f4d58b4c2f), $fb64e7edf7ecf5b8$export$bd0bf19f25da8474);
function $fb64e7edf7ecf5b8$var$cssPrefix$2(value) {
    return $fb64e7edf7ecf5b8$export$195c4126907dde97((0, $68171a1f1cc3fc3e$export$83fe3bee12eb51bb), value);
}
function $fb64e7edf7ecf5b8$var$cssSlidePrefix(value) {
    return $fb64e7edf7ecf5b8$export$195c4126907dde97((0, $68171a1f1cc3fc3e$export$8d922915837a38d3), value);
}
function $fb64e7edf7ecf5b8$var$CarouselSlide({ slide: slide, offset: offset }) {
    const containerRef = $bh6RR.useRef(null);
    const { currentIndex: currentIndex, slides: slides } = $fb64e7edf7ecf5b8$export$566121e2bbc52eec();
    const { slideRect: slideRect, focus: focus } = $fb64e7edf7ecf5b8$export$e8c786024a2b0a79();
    const { render: render, carousel: { imageFit: imageFit, imageProps: imageProps }, on: { click: onClick }, styles: { slide: style }, labels: labels } = $fb64e7edf7ecf5b8$export$d930f3536e1c64f6();
    const { getOwnerDocument: getOwnerDocument } = $fb64e7edf7ecf5b8$export$c199d36c2862b6ed();
    const offscreen = offset !== 0;
    $bh6RR.useEffect(()=>{
        var _a;
        if (offscreen && ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(getOwnerDocument().activeElement))) focus();
    }, [
        offscreen,
        focus,
        getOwnerDocument
    ]);
    const renderSlide = ()=>{
        var _a, _b, _c, _d;
        let rendered = (_a = render.slide) === null || _a === void 0 ? void 0 : _a.call(render, {
            slide: slide,
            offset: offset,
            rect: slideRect
        });
        if (!rendered && $fb64e7edf7ecf5b8$export$55ec18c411514c07(slide)) rendered = $bh6RR.createElement($fb64e7edf7ecf5b8$export$ef86b1d52c77b27b, {
            slide: slide,
            offset: offset,
            render: render,
            rect: slideRect,
            imageFit: imageFit,
            imageProps: imageProps,
            onClick: !offscreen ? ()=>onClick === null || onClick === void 0 ? void 0 : onClick({
                    index: currentIndex
                }) : undefined
        });
        return rendered ? $bh6RR.createElement($bh6RR.Fragment, null, (_b = render.slideHeader) === null || _b === void 0 ? void 0 : _b.call(render, {
            slide: slide
        }), ((_c = render.slideContainer) !== null && _c !== void 0 ? _c : ({ children: children })=>children)({
            slide: slide,
            children: rendered
        }), (_d = render.slideFooter) === null || _d === void 0 ? void 0 : _d.call(render, {
            slide: slide
        })) : null;
    };
    return $bh6RR.createElement("div", {
        ref: containerRef,
        className: $fb64e7edf7ecf5b8$export$4f5d2d50c9deca37($fb64e7edf7ecf5b8$export$1283875077dc8f0a($fb64e7edf7ecf5b8$var$cssSlidePrefix()), !offscreen && $fb64e7edf7ecf5b8$export$1283875077dc8f0a($fb64e7edf7ecf5b8$var$cssSlidePrefix("current")), $fb64e7edf7ecf5b8$export$1283875077dc8f0a((0, $68171a1f1cc3fc3e$export$974a68ef150451f5))),
        ...$fb64e7edf7ecf5b8$export$9c64d01b28c1f747(offscreen),
        style: style,
        role: "group",
        "aria-roledescription": $fb64e7edf7ecf5b8$export$1c4d965eb6f65dfa(labels, "Slide"),
        "aria-label": $fb64e7edf7ecf5b8$export$77152303d9076b8(labels, slides, currentIndex + offset)
    }, renderSlide());
}
function $fb64e7edf7ecf5b8$var$Placeholder() {
    const style = $fb64e7edf7ecf5b8$export$d930f3536e1c64f6().styles.slide;
    return $bh6RR.createElement("div", {
        className: $fb64e7edf7ecf5b8$export$1283875077dc8f0a((0, $68171a1f1cc3fc3e$export$8d922915837a38d3)),
        style: style
    });
}
function $fb64e7edf7ecf5b8$export$144901db2ea8e967({ carousel: carousel, labels: labels }) {
    const { slides: slides, currentIndex: currentIndex, globalIndex: globalIndex } = $fb64e7edf7ecf5b8$export$566121e2bbc52eec();
    const { setCarouselRef: setCarouselRef } = $fb64e7edf7ecf5b8$export$e8c786024a2b0a79();
    const { autoPlaying: autoPlaying, focusWithin: focusWithin } = $fb64e7edf7ecf5b8$export$3992c64d261ded5a();
    const spacingValue = $fb64e7edf7ecf5b8$export$7871fb532d320d99(carousel.spacing);
    const paddingValue = $fb64e7edf7ecf5b8$export$7871fb532d320d99(carousel.padding);
    const preload = $fb64e7edf7ecf5b8$export$aab7f3145c728301(carousel, slides, 1);
    const items = [];
    if ($fb64e7edf7ecf5b8$export$883ece934910f98d(slides)) for(let index = currentIndex - preload; index <= currentIndex + preload; index += 1){
        const slide = $fb64e7edf7ecf5b8$export$cdfb855c5eb3bc84(slides, index);
        const key = globalIndex - currentIndex + index;
        const placeholder = carousel.finite && (index < 0 || index > slides.length - 1);
        items.push(!placeholder ? {
            key: [
                `${key}`,
                $fb64e7edf7ecf5b8$export$b2184449b7659b5a(slide)
            ].filter(Boolean).join("|"),
            offset: index - currentIndex,
            slide: slide
        } : {
            key: key
        });
    }
    return $bh6RR.createElement("div", {
        ref: setCarouselRef,
        className: $fb64e7edf7ecf5b8$export$4f5d2d50c9deca37($fb64e7edf7ecf5b8$export$1283875077dc8f0a($fb64e7edf7ecf5b8$var$cssPrefix$2()), items.length > 0 && $fb64e7edf7ecf5b8$export$1283875077dc8f0a($fb64e7edf7ecf5b8$var$cssPrefix$2("with_slides"))),
        style: {
            [`${$fb64e7edf7ecf5b8$export$8b4981022bd80a4e($fb64e7edf7ecf5b8$var$cssPrefix$2("slides_count"))}`]: items.length,
            [`${$fb64e7edf7ecf5b8$export$8b4981022bd80a4e($fb64e7edf7ecf5b8$var$cssPrefix$2("spacing_px"))}`]: spacingValue.pixel || 0,
            [`${$fb64e7edf7ecf5b8$export$8b4981022bd80a4e($fb64e7edf7ecf5b8$var$cssPrefix$2("spacing_percent"))}`]: spacingValue.percent || 0,
            [`${$fb64e7edf7ecf5b8$export$8b4981022bd80a4e($fb64e7edf7ecf5b8$var$cssPrefix$2("padding_px"))}`]: paddingValue.pixel || 0,
            [`${$fb64e7edf7ecf5b8$export$8b4981022bd80a4e($fb64e7edf7ecf5b8$var$cssPrefix$2("padding_percent"))}`]: paddingValue.percent || 0
        },
        role: "region",
        "aria-live": autoPlaying && !focusWithin ? "off" : "polite",
        "aria-roledescription": $fb64e7edf7ecf5b8$export$1c4d965eb6f65dfa(labels, "Carousel"),
        "aria-label": $fb64e7edf7ecf5b8$export$1c4d965eb6f65dfa(labels, "Photo gallery")
    }, items.map(({ key: key, slide: slide, offset: offset })=>slide ? $bh6RR.createElement($fb64e7edf7ecf5b8$var$CarouselSlide, {
            key: key,
            slide: slide,
            offset: offset
        }) : $bh6RR.createElement($fb64e7edf7ecf5b8$var$Placeholder, {
            key: key
        })));
}
const $fb64e7edf7ecf5b8$export$9c087759a323a56c = $fb64e7edf7ecf5b8$export$c5ba3739ffba980d((0, $68171a1f1cc3fc3e$export$83fe3bee12eb51bb), $fb64e7edf7ecf5b8$export$144901db2ea8e967);
function $fb64e7edf7ecf5b8$export$e482f4662aebc4a0() {
    const { carousel: carousel } = $fb64e7edf7ecf5b8$export$d930f3536e1c64f6();
    const { slides: slides, currentIndex: currentIndex } = $fb64e7edf7ecf5b8$export$566121e2bbc52eec();
    const prevDisabled = slides.length === 0 || carousel.finite && currentIndex === 0;
    const nextDisabled = slides.length === 0 || carousel.finite && currentIndex === slides.length - 1;
    return {
        prevDisabled: prevDisabled,
        nextDisabled: nextDisabled
    };
}
function $fb64e7edf7ecf5b8$export$4da28cf324280418(subscribeSensors) {
    var _a;
    const isRTL = $fb64e7edf7ecf5b8$export$81f015b3ec5d61cf();
    const { publish: publish } = $fb64e7edf7ecf5b8$export$91a992459f6e0f07();
    const { animation: animation } = $fb64e7edf7ecf5b8$export$d930f3536e1c64f6();
    const { prevDisabled: prevDisabled, nextDisabled: nextDisabled } = $fb64e7edf7ecf5b8$export$e482f4662aebc4a0();
    const throttle = ((_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe) / 2;
    const prev = $fb64e7edf7ecf5b8$export$8b7b9481d6186f21(()=>publish((0, $68171a1f1cc3fc3e$export$a007161537026955)), throttle);
    const next = $fb64e7edf7ecf5b8$export$8b7b9481d6186f21(()=>publish((0, $68171a1f1cc3fc3e$export$f1d7a854db833ed4)), throttle);
    const handleKeyDown = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e((event)=>{
        switch(event.key){
            case 0, $68171a1f1cc3fc3e$export$e8d60d9b5ceff7c0:
                publish((0, $68171a1f1cc3fc3e$export$493a596486210a21));
                break;
            case 0, $68171a1f1cc3fc3e$export$17dec1da9b0e2eb3:
                if (!(isRTL ? nextDisabled : prevDisabled)) (isRTL ? next : prev)();
                break;
            case 0, $68171a1f1cc3fc3e$export$91898c0e7e48903:
                if (!(isRTL ? prevDisabled : nextDisabled)) (isRTL ? prev : next)();
                break;
            default:
        }
    });
    $bh6RR.useEffect(()=>subscribeSensors((0, $68171a1f1cc3fc3e$export$1aba4f3521686ca9), handleKeyDown), [
        subscribeSensors,
        handleKeyDown
    ]);
}
function $fb64e7edf7ecf5b8$export$e2d1bd910e689283({ label: label, icon: icon, renderIcon: renderIcon, action: action, onClick: onClick, disabled: disabled, style: style }) {
    return $bh6RR.createElement($fb64e7edf7ecf5b8$export$c25acd513dcc8062, {
        label: label,
        icon: icon,
        renderIcon: renderIcon,
        className: $fb64e7edf7ecf5b8$export$1283875077dc8f0a(`navigation_${action}`),
        disabled: disabled,
        onClick: onClick,
        style: style,
        ...$fb64e7edf7ecf5b8$export$2bd1c19440b9235c($fb64e7edf7ecf5b8$export$e8c786024a2b0a79().focus, disabled)
    });
}
function $fb64e7edf7ecf5b8$export$b8a61e5c71402559({ render: { buttonPrev: buttonPrev, buttonNext: buttonNext, iconPrev: iconPrev, iconNext: iconNext }, styles: styles }) {
    const { prev: prev, next: next, subscribeSensors: subscribeSensors } = $fb64e7edf7ecf5b8$export$e8c786024a2b0a79();
    const { prevDisabled: prevDisabled, nextDisabled: nextDisabled } = $fb64e7edf7ecf5b8$export$e482f4662aebc4a0();
    $fb64e7edf7ecf5b8$export$4da28cf324280418(subscribeSensors);
    return $bh6RR.createElement($bh6RR.Fragment, null, buttonPrev ? buttonPrev() : $bh6RR.createElement($fb64e7edf7ecf5b8$export$e2d1bd910e689283, {
        label: "Previous",
        action: (0, $68171a1f1cc3fc3e$export$a007161537026955),
        icon: $fb64e7edf7ecf5b8$export$d05925e1c7f3f136,
        renderIcon: iconPrev,
        style: styles.navigationPrev,
        disabled: prevDisabled,
        onClick: prev
    }), buttonNext ? buttonNext() : $bh6RR.createElement($fb64e7edf7ecf5b8$export$e2d1bd910e689283, {
        label: "Next",
        action: (0, $68171a1f1cc3fc3e$export$f1d7a854db833ed4),
        icon: $fb64e7edf7ecf5b8$export$3da0e0ec94bd4ce1,
        renderIcon: iconNext,
        style: styles.navigationNext,
        disabled: nextDisabled,
        onClick: next
    }));
}
const $fb64e7edf7ecf5b8$export$6c16e1ac15089858 = $fb64e7edf7ecf5b8$export$c5ba3739ffba980d((0, $68171a1f1cc3fc3e$export$607ce719f0ec9b98), $fb64e7edf7ecf5b8$export$b8a61e5c71402559);
const $fb64e7edf7ecf5b8$var$noScroll = $fb64e7edf7ecf5b8$export$1283875077dc8f0a((0, $68171a1f1cc3fc3e$export$b6426a00c33a0175));
const $fb64e7edf7ecf5b8$var$noScrollPadding = $fb64e7edf7ecf5b8$export$1283875077dc8f0a((0, $68171a1f1cc3fc3e$export$651541414233b476));
function $fb64e7edf7ecf5b8$var$isHTMLElement(element) {
    return "style" in element;
}
function $fb64e7edf7ecf5b8$var$padScrollbar(element, padding, rtl) {
    const styles = window.getComputedStyle(element);
    const property = rtl ? "padding-left" : "padding-right";
    const computedValue = rtl ? styles.paddingLeft : styles.paddingRight;
    const originalValue = element.style.getPropertyValue(property);
    element.style.setProperty(property, `${($fb64e7edf7ecf5b8$export$5f87784a266e50a4(computedValue) || 0) + padding}px`);
    return ()=>{
        if (originalValue) element.style.setProperty(property, originalValue);
        else element.style.removeProperty(property);
    };
}
function $fb64e7edf7ecf5b8$export$bbae9e931237726f({ noScroll: { disabled: disabled }, children: children }) {
    const rtl = $fb64e7edf7ecf5b8$export$81f015b3ec5d61cf();
    const { getOwnerDocument: getOwnerDocument, getOwnerWindow: getOwnerWindow } = $fb64e7edf7ecf5b8$export$c199d36c2862b6ed();
    $bh6RR.useEffect(()=>{
        if (disabled) return ()=>{};
        const cleanup = [];
        const ownerWindow = getOwnerWindow();
        const { body: body, documentElement: documentElement } = getOwnerDocument();
        const scrollbar = Math.round(ownerWindow.innerWidth - documentElement.clientWidth);
        if (scrollbar > 0) {
            cleanup.push($fb64e7edf7ecf5b8$var$padScrollbar(body, scrollbar, rtl));
            const elements = body.getElementsByTagName("*");
            for(let i = 0; i < elements.length; i += 1){
                const element = elements[i];
                if ($fb64e7edf7ecf5b8$var$isHTMLElement(element) && ownerWindow.getComputedStyle(element).getPropertyValue("position") === "fixed" && !element.classList.contains($fb64e7edf7ecf5b8$var$noScrollPadding)) cleanup.push($fb64e7edf7ecf5b8$var$padScrollbar(element, scrollbar, rtl));
            }
        }
        body.classList.add($fb64e7edf7ecf5b8$var$noScroll);
        return ()=>{
            body.classList.remove($fb64e7edf7ecf5b8$var$noScroll);
            cleanup.forEach((clean)=>clean());
        };
    }, [
        rtl,
        disabled,
        getOwnerDocument,
        getOwnerWindow
    ]);
    return $bh6RR.createElement($bh6RR.Fragment, null, children);
}
const $fb64e7edf7ecf5b8$export$7ded5f1cd4840ad = $fb64e7edf7ecf5b8$export$c5ba3739ffba980d((0, $68171a1f1cc3fc3e$export$52cbc29cf5406ba8), $fb64e7edf7ecf5b8$export$bbae9e931237726f);
function $fb64e7edf7ecf5b8$var$cssPrefix$1(value) {
    return $fb64e7edf7ecf5b8$export$195c4126907dde97((0, $68171a1f1cc3fc3e$export$9d2e4856063e1a22), value);
}
function $fb64e7edf7ecf5b8$var$setAttribute(element, attribute, value) {
    const previousValue = element.getAttribute(attribute);
    element.setAttribute(attribute, value);
    return ()=>{
        if (previousValue) element.setAttribute(attribute, previousValue);
        else element.removeAttribute(attribute);
    };
}
function $fb64e7edf7ecf5b8$export$602eac185826482c({ children: children, animation: animation, styles: styles, className: className, on: on, portal: portal, close: close, labels: labels }) {
    const [mounted, setMounted] = $bh6RR.useState(false);
    const [visible, setVisible] = $bh6RR.useState(false);
    const cleanup = $bh6RR.useRef([]);
    const restoreFocus = $bh6RR.useRef(null);
    const { setTimeout: setTimeout } = $fb64e7edf7ecf5b8$export$1bc7162631c81b3f();
    const { subscribe: subscribe } = $fb64e7edf7ecf5b8$export$91a992459f6e0f07();
    const reduceMotion = $fb64e7edf7ecf5b8$export$f3e625e1b2b31d60();
    const animationDuration = !reduceMotion ? animation.fade : 0;
    $bh6RR.useEffect(()=>{
        setMounted(true);
        return ()=>{
            setMounted(false);
            setVisible(false);
        };
    }, []);
    const handleCleanup = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e(()=>{
        cleanup.current.forEach((clean)=>clean());
        cleanup.current = [];
    });
    const handleClose = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e(()=>{
        var _a;
        setVisible(false);
        handleCleanup();
        (_a = on.exiting) === null || _a === void 0 || _a.call(on);
        setTimeout(()=>{
            var _a;
            (_a = on.exited) === null || _a === void 0 || _a.call(on);
            close();
        }, animationDuration);
    });
    $bh6RR.useEffect(()=>subscribe((0, $68171a1f1cc3fc3e$export$493a596486210a21), handleClose), [
        subscribe,
        handleClose
    ]);
    const handleEnter = $fb64e7edf7ecf5b8$export$ee5b5d04074a389e((node)=>{
        var _a, _b, _c;
        $fb64e7edf7ecf5b8$export$b7a864e1eaef9de5(node);
        setVisible(true);
        (_a = on.entering) === null || _a === void 0 || _a.call(on);
        const elements = (_c = (_b = node.parentNode) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : [];
        for(let i = 0; i < elements.length; i += 1){
            const element = elements[i];
            if ([
                "TEMPLATE",
                "SCRIPT",
                "STYLE"
            ].indexOf(element.tagName) === -1 && element !== node) {
                cleanup.current.push($fb64e7edf7ecf5b8$var$setAttribute(element, "inert", ""));
                cleanup.current.push($fb64e7edf7ecf5b8$var$setAttribute(element, "aria-hidden", "true"));
            }
        }
        cleanup.current.push(()=>{
            var _a, _b;
            (_b = (_a = restoreFocus.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a);
        });
        setTimeout(()=>{
            var _a;
            (_a = on.entered) === null || _a === void 0 || _a.call(on);
        }, animationDuration);
    });
    const handleRef = $bh6RR.useCallback((node)=>{
        if (node) handleEnter(node);
        else handleCleanup();
    }, [
        handleEnter,
        handleCleanup
    ]);
    return mounted ? (0, $47cfd4084854a574$exports.createPortal)($bh6RR.createElement($fb64e7edf7ecf5b8$export$597a6f74cf288f82, {
        ref: handleRef,
        className: $fb64e7edf7ecf5b8$export$4f5d2d50c9deca37(className, $fb64e7edf7ecf5b8$export$1283875077dc8f0a($fb64e7edf7ecf5b8$var$cssPrefix$1()), $fb64e7edf7ecf5b8$export$1283875077dc8f0a((0, $68171a1f1cc3fc3e$export$651541414233b476)), visible && $fb64e7edf7ecf5b8$export$1283875077dc8f0a($fb64e7edf7ecf5b8$var$cssPrefix$1("open"))),
        "aria-modal": true,
        role: "dialog",
        "aria-label": $fb64e7edf7ecf5b8$export$1c4d965eb6f65dfa(labels, "Lightbox"),
        style: {
            ...animation.fade !== $fb64e7edf7ecf5b8$export$d626463445cef3e9.animation.fade ? {
                [$fb64e7edf7ecf5b8$export$8b4981022bd80a4e("fade_animation_duration")]: `${animationDuration}ms`
            } : null,
            ...animation.easing.fade !== $fb64e7edf7ecf5b8$export$d626463445cef3e9.animation.easing.fade ? {
                [$fb64e7edf7ecf5b8$export$8b4981022bd80a4e("fade_animation_timing_function")]: animation.easing.fade
            } : null,
            ...styles.root
        },
        onFocus: (event)=>{
            if (!restoreFocus.current) restoreFocus.current = event.relatedTarget;
        }
    }, children), portal.root || document.body) : null;
}
const $fb64e7edf7ecf5b8$export$f2a0761442face5c = $fb64e7edf7ecf5b8$export$c5ba3739ffba980d((0, $68171a1f1cc3fc3e$export$9d2e4856063e1a22), $fb64e7edf7ecf5b8$export$602eac185826482c);
function $fb64e7edf7ecf5b8$export$be92b6f5f03c0fe9({ children: children }) {
    return $bh6RR.createElement($bh6RR.Fragment, null, children);
}
const $fb64e7edf7ecf5b8$export$fa1081225b99a9f2 = $fb64e7edf7ecf5b8$export$c5ba3739ffba980d((0, $68171a1f1cc3fc3e$export$62f3c66ae8dab8a3), $fb64e7edf7ecf5b8$export$be92b6f5f03c0fe9);
function $fb64e7edf7ecf5b8$var$cssPrefix(value) {
    return $fb64e7edf7ecf5b8$export$195c4126907dde97((0, $68171a1f1cc3fc3e$export$5414719b40b8294f), value);
}
function $fb64e7edf7ecf5b8$export$4c260019440d418f({ toolbar: { buttons: buttons }, render: { buttonClose: buttonClose, iconClose: iconClose }, styles: styles }) {
    const { close: close, setToolbarWidth: setToolbarWidth } = $fb64e7edf7ecf5b8$export$e8c786024a2b0a79();
    const { setContainerRef: setContainerRef, containerRect: containerRect } = $fb64e7edf7ecf5b8$export$b1d85de58d38d09d();
    $fb64e7edf7ecf5b8$export$e5c5a5f917a5871c(()=>{
        setToolbarWidth(containerRect === null || containerRect === void 0 ? void 0 : containerRect.width);
    }, [
        setToolbarWidth,
        containerRect === null || containerRect === void 0 ? void 0 : containerRect.width
    ]);
    const renderCloseButton = ()=>{
        if (buttonClose) return buttonClose();
        return $bh6RR.createElement($fb64e7edf7ecf5b8$export$c25acd513dcc8062, {
            key: (0, $68171a1f1cc3fc3e$export$493a596486210a21),
            label: "Close",
            icon: $fb64e7edf7ecf5b8$export$cae179f078f4b4a4,
            renderIcon: iconClose,
            onClick: close
        });
    };
    return $bh6RR.createElement("div", {
        ref: setContainerRef,
        style: styles.toolbar,
        className: $fb64e7edf7ecf5b8$export$1283875077dc8f0a($fb64e7edf7ecf5b8$var$cssPrefix())
    }, buttons === null || buttons === void 0 ? void 0 : buttons.map((button)=>button === (0, $68171a1f1cc3fc3e$export$493a596486210a21) ? renderCloseButton() : button));
}
const $fb64e7edf7ecf5b8$export$d0a9743c06e42ce8 = $fb64e7edf7ecf5b8$export$c5ba3739ffba980d((0, $68171a1f1cc3fc3e$export$5414719b40b8294f), $fb64e7edf7ecf5b8$export$4c260019440d418f);
function $fb64e7edf7ecf5b8$var$renderNode(node, props) {
    var _a;
    return $bh6RR.createElement(node.module.component, {
        key: node.module.name,
        ...props
    }, (_a = node.children) === null || _a === void 0 ? void 0 : _a.map((child)=>$fb64e7edf7ecf5b8$var$renderNode(child, props)));
}
function $fb64e7edf7ecf5b8$var$mergeAnimation(defaultAnimation, animation = {}) {
    const { easing: defaultAnimationEasing, ...restDefaultAnimation } = defaultAnimation;
    const { easing: easing, ...restAnimation } = animation;
    return {
        easing: {
            ...defaultAnimationEasing,
            ...easing
        },
        ...restDefaultAnimation,
        ...restAnimation
    };
}
function $fb64e7edf7ecf5b8$export$7d2670a66155874b({ carousel: carousel, animation: animation, render: render, toolbar: toolbar, controller: controller, noScroll: noScroll, on: on, plugins: plugins, slides: slides, index: index, ...restProps }) {
    const { animation: defaultAnimation, carousel: defaultCarousel, render: defaultRender, toolbar: defaultToolbar, controller: defaultController, noScroll: defaultNoScroll, on: defaultOn, slides: defaultSlides, index: defaultIndex, plugins: defaultPlugins, ...restDefaultProps } = $fb64e7edf7ecf5b8$export$d626463445cef3e9;
    const { config: config, augmentation: augmentation } = $fb64e7edf7ecf5b8$export$bc996c07eb970c78([
        $fb64e7edf7ecf5b8$export$270e7ba5936d3c48($fb64e7edf7ecf5b8$export$f2a0761442face5c, [
            $fb64e7edf7ecf5b8$export$270e7ba5936d3c48($fb64e7edf7ecf5b8$export$7ded5f1cd4840ad, [
                $fb64e7edf7ecf5b8$export$270e7ba5936d3c48($fb64e7edf7ecf5b8$export$be59d34228c8ec8a, [
                    $fb64e7edf7ecf5b8$export$270e7ba5936d3c48($fb64e7edf7ecf5b8$export$9c087759a323a56c),
                    $fb64e7edf7ecf5b8$export$270e7ba5936d3c48($fb64e7edf7ecf5b8$export$d0a9743c06e42ce8),
                    $fb64e7edf7ecf5b8$export$270e7ba5936d3c48($fb64e7edf7ecf5b8$export$6c16e1ac15089858)
                ])
            ])
        ])
    ], plugins || defaultPlugins);
    const props = augmentation({
        animation: $fb64e7edf7ecf5b8$var$mergeAnimation(defaultAnimation, animation),
        carousel: {
            ...defaultCarousel,
            ...carousel
        },
        render: {
            ...defaultRender,
            ...render
        },
        toolbar: {
            ...defaultToolbar,
            ...toolbar
        },
        controller: {
            ...defaultController,
            ...controller
        },
        noScroll: {
            ...defaultNoScroll,
            ...noScroll
        },
        on: {
            ...defaultOn,
            ...on
        },
        ...restDefaultProps,
        ...restProps
    });
    if (!props.open) return null;
    return $bh6RR.createElement($fb64e7edf7ecf5b8$export$7141a340a3dea601, {
        ...props
    }, $bh6RR.createElement($fb64e7edf7ecf5b8$export$62d2e1d2e7609988, {
        slides: slides || defaultSlides,
        index: $fb64e7edf7ecf5b8$export$5f87784a266e50a4(index || defaultIndex)
    }, $bh6RR.createElement($fb64e7edf7ecf5b8$export$9d9954f5885fa393, null, $bh6RR.createElement($fb64e7edf7ecf5b8$export$686accdd53ac150f, null, $bh6RR.createElement($fb64e7edf7ecf5b8$export$e41a845d3e53ea09, null, $fb64e7edf7ecf5b8$var$renderNode($fb64e7edf7ecf5b8$export$270e7ba5936d3c48($fb64e7edf7ecf5b8$export$fa1081225b99a9f2, config), props))))));
}





var $bh6RR = parcelRequire("bh6RR");


const $73b7bb61ff2f05bb$var$cssPrefix = (className)=>(0, $fb64e7edf7ecf5b8$export$1283875077dc8f0a)(`slide_${className}`);
const $73b7bb61ff2f05bb$var$defaultCaptionsProps = {
    descriptionTextAlign: "start",
    descriptionMaxLines: 3,
    showToggle: false,
    hidden: false
};
const $73b7bb61ff2f05bb$var$resolveCaptionsProps = (captions)=>({
        ...$73b7bb61ff2f05bb$var$defaultCaptionsProps,
        ...captions
    });
function $73b7bb61ff2f05bb$var$useCaptionsProps() {
    const { captions: captions } = (0, $fb64e7edf7ecf5b8$export$d930f3536e1c64f6)();
    return $73b7bb61ff2f05bb$var$resolveCaptionsProps(captions);
}
const $73b7bb61ff2f05bb$var$CaptionsContext = $bh6RR.createContext(null);
const $73b7bb61ff2f05bb$var$useCaptions = (0, $fb64e7edf7ecf5b8$export$aac3e49c3c8b5cb0)("useCaptions", "CaptionsContext", $73b7bb61ff2f05bb$var$CaptionsContext);
function $73b7bb61ff2f05bb$var$CaptionsContextProvider({ captions: captions, children: children }) {
    const { ref: ref, hidden: hidden } = $73b7bb61ff2f05bb$var$resolveCaptionsProps(captions);
    const [visible, setVisible] = $bh6RR.useState(!hidden);
    const context = $bh6RR.useMemo(()=>({
            visible: visible,
            show: ()=>setVisible(true),
            hide: ()=>setVisible(false)
        }), [
        visible
    ]);
    $bh6RR.useImperativeHandle(ref, ()=>context, [
        context
    ]);
    return $bh6RR.createElement($73b7bb61ff2f05bb$var$CaptionsContext.Provider, {
        value: context
    }, children);
}
function $73b7bb61ff2f05bb$var$Title({ title: title }) {
    const { toolbarWidth: toolbarWidth } = (0, $fb64e7edf7ecf5b8$export$e8c786024a2b0a79)();
    const { styles: styles } = (0, $fb64e7edf7ecf5b8$export$d930f3536e1c64f6)();
    const { visible: visible } = $73b7bb61ff2f05bb$var$useCaptions();
    if (!visible) return null;
    return $bh6RR.createElement("div", {
        role: "heading",
        "aria-level": 2,
        style: styles.captionsTitleContainer,
        className: (0, $fb64e7edf7ecf5b8$export$4f5d2d50c9deca37)($73b7bb61ff2f05bb$var$cssPrefix("captions_container"), $73b7bb61ff2f05bb$var$cssPrefix("title_container"))
    }, $bh6RR.createElement("div", {
        className: $73b7bb61ff2f05bb$var$cssPrefix("title"),
        style: {
            ...toolbarWidth ? {
                [(0, $fb64e7edf7ecf5b8$export$8b4981022bd80a4e)("toolbar_width")]: `${toolbarWidth}px`
            } : null,
            ...styles.captionsTitle
        }
    }, title));
}
function $73b7bb61ff2f05bb$var$Description({ description: description }) {
    const { descriptionTextAlign: descriptionTextAlign, descriptionMaxLines: descriptionMaxLines } = $73b7bb61ff2f05bb$var$useCaptionsProps();
    const { styles: styles, labels: labels } = (0, $fb64e7edf7ecf5b8$export$d930f3536e1c64f6)();
    const { visible: visible } = $73b7bb61ff2f05bb$var$useCaptions();
    if (!visible) return null;
    return $bh6RR.createElement("div", {
        style: styles.captionsDescriptionContainer,
        className: (0, $fb64e7edf7ecf5b8$export$4f5d2d50c9deca37)($73b7bb61ff2f05bb$var$cssPrefix("captions_container"), $73b7bb61ff2f05bb$var$cssPrefix("description_container"))
    }, $bh6RR.createElement("div", {
        className: $73b7bb61ff2f05bb$var$cssPrefix("description"),
        style: {
            ...descriptionTextAlign !== $73b7bb61ff2f05bb$var$defaultCaptionsProps.descriptionTextAlign || descriptionMaxLines !== $73b7bb61ff2f05bb$var$defaultCaptionsProps.descriptionMaxLines ? {
                [(0, $fb64e7edf7ecf5b8$export$8b4981022bd80a4e)("slide_description_text_align")]: descriptionTextAlign,
                [(0, $fb64e7edf7ecf5b8$export$8b4981022bd80a4e)("slide_description_max_lines")]: descriptionMaxLines
            } : null,
            ...styles.captionsDescription
        },
        role: "paragraph",
        "aria-roledescription": (0, $fb64e7edf7ecf5b8$export$1c4d965eb6f65dfa)(labels, "Caption")
    }, typeof description === "string" ? description.split("\n").flatMap((line, index)=>[
            ...index > 0 ? [
                $bh6RR.createElement("br", {
                    key: index
                })
            ] : [],
            line
        ]) : description));
}
const $73b7bb61ff2f05bb$var$captionsIcon = ()=>$bh6RR.createElement($bh6RR.Fragment, null, $bh6RR.createElement("path", {
        strokeWidth: 2,
        stroke: "currentColor",
        strokeLinejoin: "round",
        fill: "none",
        d: "M3 5l18 0l0 14l-18 0l0-14z"
    }), $bh6RR.createElement("path", {
        d: "M7 15h3c.55 0 1-.45 1-1v-1H9.5v.5h-2v-3h2v.5H11v-1c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm7 0h3c.55 0 1-.45 1-1v-1h-1.5v.5h-2v-3h2v.5H18v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1z"
    }));
const $73b7bb61ff2f05bb$var$CaptionsVisible = (0, $fb64e7edf7ecf5b8$export$274edc73af1ae9c8)("CaptionsVisible", $73b7bb61ff2f05bb$var$captionsIcon());
const $73b7bb61ff2f05bb$var$CaptionsHidden = (0, $fb64e7edf7ecf5b8$export$6b1fd58c1dc933ec)("CaptionsVisible", $73b7bb61ff2f05bb$var$captionsIcon());
function $73b7bb61ff2f05bb$var$CaptionsButton() {
    const { visible: visible, show: show, hide: hide } = $73b7bb61ff2f05bb$var$useCaptions();
    const { render: render } = (0, $fb64e7edf7ecf5b8$export$d930f3536e1c64f6)();
    if (render.buttonCaptions) return $bh6RR.createElement($bh6RR.Fragment, null, render.buttonCaptions({
        visible: visible,
        show: show,
        hide: hide
    }));
    return $bh6RR.createElement((0, $fb64e7edf7ecf5b8$export$c25acd513dcc8062), {
        label: visible ? "Hide captions" : "Show captions",
        icon: visible ? $73b7bb61ff2f05bb$var$CaptionsVisible : $73b7bb61ff2f05bb$var$CaptionsHidden,
        renderIcon: visible ? render.iconCaptionsVisible : render.iconCaptionsHidden,
        onClick: visible ? hide : show
    });
}
function $73b7bb61ff2f05bb$export$2e2bcd8739ae039({ augment: augment, addModule: addModule }) {
    augment(({ captions: captionsProps, render: { slideFooter: renderFooter, ...restRender }, toolbar: toolbar, ...restProps })=>{
        const captions = $73b7bb61ff2f05bb$var$resolveCaptionsProps(captionsProps);
        return {
            render: {
                slideFooter: ({ slide: slide })=>$bh6RR.createElement($bh6RR.Fragment, null, renderFooter === null || renderFooter === void 0 ? void 0 : renderFooter({
                        slide: slide
                    }), slide.title && $bh6RR.createElement($73b7bb61ff2f05bb$var$Title, {
                        title: slide.title
                    }), slide.description && $bh6RR.createElement($73b7bb61ff2f05bb$var$Description, {
                        description: slide.description
                    })),
                ...restRender
            },
            toolbar: (0, $fb64e7edf7ecf5b8$export$34ce6a408311d810)(toolbar, (0, $68171a1f1cc3fc3e$export$a23b14c1465897d), captions.showToggle ? $bh6RR.createElement($73b7bb61ff2f05bb$var$CaptionsButton, null) : null),
            captions: captions,
            ...restProps
        };
    });
    addModule((0, $fb64e7edf7ecf5b8$export$c5ba3739ffba980d)((0, $68171a1f1cc3fc3e$export$a23b14c1465897d), $73b7bb61ff2f05bb$var$CaptionsContextProvider));
}



function $f3256abebc599316$export$2e2bcd8739ae039({ content: content }) {
    const [visible, setVisible] = (0, $bh6RR.useState)(false);
    const [startIndex, setStartIndex] = (0, $bh6RR.useState)(0);
    const [closeOnBackdropClick, setCloseOnBackdropClick] = (0, $bh6RR.useState)(true);
    const regexImg = /<img[^>]*src="([^"]+)"[^>]*>/g;
    const parts = [];
    let lastIndex = 0;
    let match;
    // decouper le contenu en texte / images dans l'ordre
    while((match = regexImg.exec(content)) !== null){
        if (match.index > lastIndex) parts.push({
            type: "text",
            content: content.slice(lastIndex, match.index)
        });
        parts.push({
            type: "image",
            src: match[1],
            content: match[0]
        });
        lastIndex = regexImg.lastIndex;
    }
    // on rajoute le text apres l'image s'il y en a 
    if (lastIndex < content.length) parts.push({
        type: "text",
        content: content.slice(lastIndex)
    });
    const contentText = parts.filter((p)=>p.type === "text").map((p)=>p.content).join(" ");
    const slides = parts.filter((p)=>p.type === "image").map((p)=>({
            src: p.src,
            description: contentText
        }));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        children: [
            parts.map((p, i)=>{
                if (p.type === "text") return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    children: p.content
                }, i);
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    src: p.src,
                    alt: "chat-img",
                    style: {
                        maxWidth: "150px",
                        cursor: "pointer",
                        borderRadius: "8px",
                        margin: "0 4px"
                    },
                    onClick: ()=>{
                        setStartIndex(slides.findIndex((s)=>s.src === p.src));
                        setVisible(true);
                    }
                }, i);
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fb64e7edf7ecf5b8$export$7d2670a66155874b), {
                open: visible,
                close: ()=>setVisible(false),
                slides: slides,
                index: startIndex,
                controller: {
                    closeOnBackdropClick: closeOnBackdropClick,
                    closeOnBackdropClick: closeOnBackdropClick
                },
                plugins: [
                    (0, $73b7bb61ff2f05bb$export$2e2bcd8739ae039)
                ],
                captions: {
                    descriptionTextAlign: "center",
                    descriptionMaxLines: 10,
                    showToggle: false
                },
                render: {
                    buttonPrev: slides.length > 1 ? undefined : ()=>null,
                    buttonNext: slides.length > 1 ? undefined : ()=>null
                }
            })
        ]
    });
}


function $561524aa3b225213$var$MessagePart({ content: content }) {
    const [displayedContent, setDisplayedContent] = (0, $bh6RR.useState)("");
    const [currentIndex, setCurrentIndex] = (0, $bh6RR.useState)(0);
    const [prevContent, setPrevContent] = (0, $bh6RR.useState)("");
    (0, $bh6RR.useEffect)(()=>{
        if (content !== prevContent) {
            setPrevContent(content);
            setCurrentIndex(0);
        }
        let interval;
        if (currentIndex < content.length) interval = setInterval(()=>{
            setDisplayedContent(content.substring(0, currentIndex + 1));
            setCurrentIndex((prevIndex)=>prevIndex + 1);
        }, 75);
        return ()=>clearInterval(interval);
    }, [
        currentIndex
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
        className: "bubble",
        dangerouslySetInnerHTML: {
            __html: $726d757834788151$exports.sanitize(displayedContent, {
                sanitize: true
            })
        }
    });
}
const $561524aa3b225213$var$ErrorLink = ({ block_id: block_id })=>{
    const { chatboxColor: chatboxColor } = (0, $8283b38cbbf594a8$export$2db17556772be852)();
    const { ifFollowBlockDefinedMoveCamera: ifFollowBlockDefinedMoveCamera } = (0, $266e6160ef860cac$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
        onClick: ()=>ifFollowBlockDefinedMoveCamera(block_id),
        style: {
            color: chatboxColor
        },
        children: block_id
    });
};
const $561524aa3b225213$var$BuildError = ({ content: content })=>{
    const regex = /[0-9]{13}_[0-9]{3,8}/;
    const match = content.match(regex);
    if (match == undefined) return content;
    const text = content.split(match[0]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            text[0],
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($561524aa3b225213$var$ErrorLink, {
                block_id: match[0]
            }),
            text[1]
        ]
    });
};
const $561524aa3b225213$var$BubbleChat = ({ content: content, type: type })=>{
    const { chatboxColor: chatboxColor } = (0, $8283b38cbbf594a8$export$2db17556772be852)();
    const isUrl = (str)=>{
        try {
            new URL(str);
            return true;
        } catch (_) {
            return false;
        }
    };
    const renderContent = ()=>{
        if (type === "text" && isUrl(content)) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
            className: "bubble",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("a", {
                href: content,
                target: "_blank",
                rel: "noopener noreferrer",
                children: [
                    " ",
                    content,
                    " "
                ]
            })
        });
        else if (type === "text") {
            const regexImg = /<img[^>]*src="([^"]+)"[^>]*>/;
            const match = content.match(regexImg);
            return match ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                className: "bubble",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f3256abebc599316$export$2e2bcd8739ae039), {
                        content: content
                    })
                ]
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                className: "bubble",
                dangerouslySetInnerHTML: {
                    __html: content
                }
            });
        } else return null;
    };
    var bubbles = type == "text" ? content.split("\xa7").filter((a)=>a) : [
        content
    ];
    return bubbles.map((content, index)=>{
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $bh6RR.Fragment), {
            children: [
                renderContent(),
                type == "media" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: "bubble",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        srcSet: content
                    })
                }) : "",
                type == "error" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: "bubble",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($561524aa3b225213$var$BuildError, {
                        content: content
                    })
                }) : "",
                type == "human" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: "bubble",
                    style: {
                        backgroundColor: chatboxColor,
                        display: "flex"
                    },
                    dangerouslySetInnerHTML: {
                        __html: $726d757834788151$exports.sanitize(content, {
                            sanitize: true
                        })
                    }
                }) : "",
                type == "typing" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    className: "bubble typing",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "dot"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "dot"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "dot"
                        })
                    ]
                }) : "",
                type == "audio" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: "bubble",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("audio", {
                        controls: true,
                        src: content
                    })
                }) : ""
            ]
        }, index);
    });
};
function $561524aa3b225213$var$transformContent(content) {
    const regexImg = /<img[^>]*src="([^"]+)"[^>]*>/g;
    let result = "";
    let lastIndex = 0;
    let match;
    while((match = regexImg.exec(content)) !== null){
        // Texte avant l'image
        if (match.index > lastIndex) result += content.slice(lastIndex, match.index);
        const src = match[1];
        // Ici on reconstruit une balise <img> en string avec les attributs qu'on veut
        result += `<img 
      src="${src}" 
      alt="chat-img"
      class="inline-block max-w-[150px] max-h-[150px] rounded-lg cursor-pointer transition-all duration-300"
      onclick="if(this.classList.contains('max-w-[150px]')) { 
        this.classList.remove('max-w-[150px]', 'max-h-[150px]'); 
        this.classList.add('max-w-[90%]', 'max-h-[90vh]'); 
      } else { 
        this.classList.remove('max-w-[90%]', 'max-h-[90vh]'); 
        this.classList.add('max-w-[150px]', 'max-h-[150px]'); 
      }"
    />`;
        lastIndex = regexImg.lastIndex;
    }
    // Texte après la dernière image
    if (lastIndex < content.length) result += content.slice(lastIndex);
    return result;
}
$561524aa3b225213$var$BubbleChat.defaultProps = {
    content: "",
    type: "text"
};
var $561524aa3b225213$export$2e2bcd8739ae039 = $561524aa3b225213$var$BubbleChat;





var $3c35c19618c09e40$exports = {};
$3c35c19618c09e40$exports = new URL("ring.28428b76.mp3", import.meta.url).toString();


const $7455799f00fb9de1$var$ChatContent = ()=>{
    const dispatch = (0, $8283b38cbbf594a8$export$b3ff80222229e8a1)();
    const [voices, speak] = (0, $c4ae2d974714023d$export$2e2bcd8739ae039)();
    const { data: data, avatar: avatar, language: language, mode: mode, sound_effect: sound_effect } = (0, $8283b38cbbf594a8$export$2db17556772be852)();
    const { valueOpen: valueOpen } = (0, $ff13ff65642ff6cd$export$787f29101a32d965)();
    const { messages: messages } = data;
    const [audioPlayed, setAudioPlayed] = (0, $bh6RR.useState)(false);
    const { valueToggleSound: valueToggleSound } = (0, $ff13ff65642ff6cd$export$787f29101a32d965)();
    const indexLastMessageNotView = messages.findIndex((message)=>message.view == 0);
    const displayMessage = ()=>dispatch({
            type: "displayMessage",
            payload: {
                index: indexLastMessageNotView
            }
        });
    const actionOnMessage = ()=>{
        const messageNotView = messages[indexLastMessageNotView];
        displayMessage();
        const voicesFilterByLanguage = voices.filter((voice)=>voice.lang.includes(language.slug));
        const voice = voicesFilterByLanguage.filter((voice)=>voice.default).shift() || voicesFilterByLanguage.shift();
        if (valueToggleSound == false || voice == undefined || messageNotView.type != "text") return;
        speak(messageNotView.content, voice);
    };
    const timerRunningRef = (0, $bh6RR.useRef)(true);
    (0, $bh6RR.useEffect)(()=>{
        if (indexLastMessageNotView !== -1) {
            const timerId = setTimeout(()=>{
                actionOnMessage();
                if (timerRunningRef.current && !audioPlayed) {
                    if (mode !== "debug" && !valueOpen && sound_effect) {
                        const audio = new Audio((0, (/*@__PURE__*/$parcel$interopDefault($3c35c19618c09e40$exports))));
                        audio.oncanplay = ()=>{
                            audio.play();
                            setAudioPlayed(true);
                        };
                    }
                }
            }, 1200);
            const element = document.createElement("style");
            const isPngLink = avatar.includes(".png");
            let modifiedAvatar = avatar;
            if (!isPngLink) modifiedAvatar = `data:image/svg+xml;base64,${window.btoa(avatar)}`;
            document.head.appendChild(element).innerHTML = `.kwalys-chatbox-window .kwalys-chat #chat-content .bubbles.bot::before { background-image: url(${modifiedAvatar}); }`;
            return ()=>{
                clearTimeout(timerId);
            };
        }
    }, [
        indexLastMessageNotView,
        mode,
        valueOpen,
        audioPlayed,
        avatar
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (valueOpen) timerRunningRef.current = false;
    }, [
        valueOpen
    ]);
    var messagesRobotAndHuman = [];
    var messagesRobot = [];
    for (let message of messages){
        if (message.type == "human") {
            messagesRobotAndHuman.push(messagesRobot);
            messagesRobotAndHuman.push([
                message
            ]);
            messagesRobot = [];
            continue;
        }
        messagesRobot.push(message);
    }
    messagesRobotAndHuman.push(messagesRobot);
    messagesRobotAndHuman.reverse();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        id: "chat-content",
        className: "scrollbar-chatbox",
        children: messagesRobotAndHuman && messagesRobotAndHuman.map((dataSet, index)=>{
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: index % 2 == 0 ? "bubbles bot" : "bubbles human",
                children: [
                    dataSet && dataSet.map((message, indexMessage)=>message.view ? /*#__PURE__*/ (0, $bh6RR.createElement)((0, $561524aa3b225213$export$2e2bcd8739ae039), {
                            ...message,
                            key: indexMessage
                        }) : null),
                    index == 0 && indexLastMessageNotView != -1 && index % 2 == 0 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $561524aa3b225213$export$2e2bcd8739ae039), {
                        type: "typing"
                    }) : null
                ]
            }, index);
        })
    });
};
var /*{index != -1 ? <BubbleChat type="typing"/> : null}*/ $7455799f00fb9de1$export$2e2bcd8739ae039 = $7455799f00fb9de1$var$ChatContent;



parcelRequire("bh6RR");

const $30e062f52c7fdcea$var$DarkMode = ()=>{
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        id: "kwalys-switch"
    });
};
var $30e062f52c7fdcea$export$2e2bcd8739ae039 = $30e062f52c7fdcea$var$DarkMode;




var $bh6RR = parcelRequire("bh6RR");


parcelRequire("bh6RR");
const $2d8d8955ef305a6d$var$SvgStorm = (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 22,
        height: 28,
        ...props,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("filter", {
                        id: "storm_svg__a",
                        width: "280%",
                        height: "212.5%",
                        x: "-90%",
                        y: "-56.2%",
                        filterUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("feOffset", {
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("feGaussianBlur", {
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1",
                                stdDeviation: 3
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("feColorMatrix", {
                                in: "shadowBlurOuter1",
                                values: "0 0 0 0 0.0549019608 0 0 0 0 0.478431373 0 0 0 0 0.929411765 0 0 0 0.501557037 0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        id: "storm_svg__b",
                        d: "M19.958 518.842c-.06-.163-.232-.437-.727-.437h-3.223c-.022 0-.032-.005-.034-.004a.116.116 0 0 1 .005-.042l1.312-5.047c.111-.427.221-1.02-.103-1.246-.325-.227-.7.181-.955.508l-5.961 7.651c-.337.433-.289.771-.23.934.06.163.232.436.727.436h3.223c.022 0 .03.004.034.005 0 .004.002.018-.005.042l-1.312 5.047c-.111.426-.221 1.02.103 1.246a.342.342 0 0 0 .201.065c.27 0 .551-.313.754-.574l5.961-7.65c.338-.433.289-.771.23-.934z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                fill: "none",
                transform: "translate(-4 -506)",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("use", {
                        fill: "#000",
                        filter: "url(#storm_svg__a)",
                        xlinkHref: "#storm_svg__b"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("use", {
                        fill: "#0E7AED",
                        xlinkHref: "#storm_svg__b"
                    })
                ]
            })
        ]
    });
var $2d8d8955ef305a6d$export$2e2bcd8739ae039 = $2d8d8955ef305a6d$var$SvgStorm;




function $0118bbede243458a$var$Storm({ name: name }) {
    const [stormTextVisibility, setVisibility] = (0, $bh6RR.useState)(0);
    const { chatboxColor: chatboxColor } = (0, $8283b38cbbf594a8$export$2db17556772be852)();
    const { valueOpen: valueOpen } = (0, $ff13ff65642ff6cd$export$787f29101a32d965)();
    const [initialValueOpen, setInitialValueOpen] = (0, $bh6RR.useState)(false);
    const onMouseEnter = ()=>setVisibility(0);
    const onMouseLeave = ()=>setVisibility(1) == null && setTimeout(()=>setVisibility(2), 1000);
    const classList = [
        "appear",
        "disappear",
        "invisible"
    ];
    const className = `kwalys-storm-text ${classList[stormTextVisibility]}`;
    const svgString = `
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="28" viewBox="0 0 22 28">
            <defs>
                <path id="b" d="M19.958 518.842c-.06-.163-.232-.437-.727-.437h-3.223c-.022 0-.032-.005-.034-.004a.116.116 0 0 1 .005-.042l1.312-5.047c.111-.427.221-1.02-.103-1.246-.325-.227-.7.181-.955.508l-5.961 7.651c-.337.433-.289.771-.23.934.06.163.232.436.727.436h3.223c.022 0 .03.004.034.005 0 .004.002.018-.005.042l-1.312 5.047c-.111.426-.221 1.02.103 1.246a.342.342 0 0 0 .201.065c.27 0 .551-.313.754-.574l5.961-7.65c.338-.433.289-.771.23-.934z"/>
                <filter id="a" width="280%" height="212.5%" x="-90%" y="-56.2%" filterUnits="objectBoundingBox">
                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1"/>
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="3"/>
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0.0549019608 0 0 0 0 0.478431373 0 0 0 0 0.929411765 0 0 0 0.501557037 0"/>
                </filter>
            </defs>
            <g fill="none" fill-rule="nonzero" transform="translate(-4 -506)">
                <use fill="#000" filter="url(#a)" xlink:href="#b"/>
                <use fill=${chatboxColor} xlink:href="#b"/>
            </g>
        </svg>
        `;
    (0, $bh6RR.useEffect)(()=>{
        if (valueOpen && !initialValueOpen) {
            setInitialValueOpen(true);
            const timer = setTimeout(()=>{
                setVisibility(1); // Passer à 'disappear' après 4 secondes
                setTimeout(()=>setVisibility(2), 1000);
            }, 4000);
            return ()=>clearTimeout(timer);
        }
    }, [
        valueOpen
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("a", {
        className: "kwalys-storm",
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: svgString
                }
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                className: className,
                style: {
                    color: chatboxColor
                },
                children: name
            })
        ]
    });
}
$0118bbede243458a$var$Storm.defaultProps = {
    name: "Talkr"
};
var $0118bbede243458a$export$2e2bcd8739ae039 = $0118bbede243458a$var$Storm;





var $4509c8f018856c03$exports = {};
$4509c8f018856c03$exports = new URL("focus.66091767.svg", import.meta.url).toString();


const $54a7402c66965534$var$ButtonFocus = ()=>{
    const { valueToggleFocus: valueToggleFocus } = (0, $ff13ff65642ff6cd$export$787f29101a32d965)();
    const dispatch = (0, $ff13ff65642ff6cd$export$96f70031a13e2d53)();
    const toggleFocus = ()=>dispatch({
            type: "toggleFocus"
        });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
        id: "kwalys-focus",
        onClick: toggleFocus,
        className: valueToggleFocus ? "active" : "",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($4509c8f018856c03$exports))),
            alt: "focus",
            width: "18px"
        })
    });
};
var $54a7402c66965534$export$2e2bcd8739ae039 = $54a7402c66965534$var$ButtonFocus;





var $ed7323a4632a0778$exports = {};
$ed7323a4632a0778$exports = new URL("variables.5e2bfe0b.svg", import.meta.url).toString();


const $77e0a9674b311111$var$ButtonVariable = ()=>{
    const { valueToggleVariablesList: valueToggleVariablesList } = (0, $ff13ff65642ff6cd$export$787f29101a32d965)();
    const dispatch = (0, $ff13ff65642ff6cd$export$96f70031a13e2d53)();
    const toggleVariables = ()=>dispatch({
            type: "toggleVariablesList"
        });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
        id: "kwalys-variable",
        onClick: toggleVariables,
        className: valueToggleVariablesList ? "active" : "",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($ed7323a4632a0778$exports))),
            alt: "variable",
            width: "18px"
        })
    });
};
var $77e0a9674b311111$export$2e2bcd8739ae039 = $77e0a9674b311111$var$ButtonVariable;






parcelRequire("bh6RR");
const $86f0accad22c24ff$var$SvgSoundMax = (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "sound-max_svg__icon sound-max_svg__glyph",
        ...props,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M18.36 19.36a1 1 0 0 1-.7-.29 1 1 0 0 1 0-1.41 8 8 0 0 0 0-11.32 1 1 0 0 1 1.41-1.41 10 10 0 0 1 0 14.14 1 1 0 0 1-.71.29Z",
                style: {
                    fill: "#231f20"
                }
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M15.54 16.54a1 1 0 0 1-.71-.3 1 1 0 0 1 0-1.41 4 4 0 0 0 0-5.66 1 1 0 0 1 1.41-1.41 6 6 0 0 1 0 8.48 1 1 0 0 1-.7.3ZM11.38 4.08a1 1 0 0 0-1.09.21L6.59 8H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2.59l3.7 3.71A1 1 0 0 0 11 20a.84.84 0 0 0 .38-.08A1 1 0 0 0 12 19V5a1 1 0 0 0-.62-.92Z",
                style: {
                    fill: "#231f20"
                }
            })
        ]
    });
var $86f0accad22c24ff$export$2e2bcd8739ae039 = $86f0accad22c24ff$var$SvgSoundMax;



parcelRequire("bh6RR");
const $3aa77a480fc0899e$var$SvgSoundMute = (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "sound-mute_svg__icon sound-mute_svg__glyph",
        ...props,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M11.38 4.08a1 1 0 0 0-1.09.21L6.59 8H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2.59l3.7 3.71A1 1 0 0 0 11 20a.84.84 0 0 0 .38-.08A1 1 0 0 0 12 19V5a1 1 0 0 0-.62-.92ZM16 15.5a1 1 0 0 1-.71-.29 1 1 0 0 1 0-1.42l5-5a1 1 0 0 1 1.42 1.42l-5 5a1 1 0 0 1-.71.29Z",
                style: {
                    fill: "#231f20"
                }
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M21 15.5a1 1 0 0 1-.71-.29l-5-5a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 0 1.42 1 1 0 0 1-.71.29Z",
                style: {
                    fill: "#231f20"
                }
            })
        ]
    });
var $3aa77a480fc0899e$export$2e2bcd8739ae039 = $3aa77a480fc0899e$var$SvgSoundMute;


const $c9334ad309adf0e6$var$ButtonSound = ()=>{
    const { valueToggleSound: valueToggleSound } = (0, $ff13ff65642ff6cd$export$787f29101a32d965)();
    const dispatch = (0, $ff13ff65642ff6cd$export$96f70031a13e2d53)();
    const toggleFocus = ()=>dispatch({
            type: "toggleSound"
        });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
        id: "kwalys-sound",
        onClick: toggleFocus,
        className: valueToggleSound ? "active" : "",
        children: valueToggleSound ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $86f0accad22c24ff$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3aa77a480fc0899e$export$2e2bcd8739ae039), {})
    });
};
var $c9334ad309adf0e6$export$2e2bcd8739ae039 = $c9334ad309adf0e6$var$ButtonSound;






parcelRequire("bh6RR");
const $6feb888109403d54$var$SvgRestartBlue = (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 30",
        width: 14,
        height: 14,
        ...props,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M17.774 1.787v3.428c4.268 1.208 7.397 5.13 7.397 9.785 0 5.617-4.554 10.171-10.171 10.171S4.829 20.617 4.829 15c0-3.831 2.121-7.161 5.249-8.895L12.5 8.527V1.5H5.473l2.184 2.184C3.954 6.091 1.5 10.255 1.5 15c0 7.456 6.044 13.5 13.5 13.5S28.5 22.456 28.5 15c0-6.505-4.601-11.934-10.726-13.213z"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fill: "transparent",
                d: "M15 28.986C7.288 28.986 1.013 22.712 1.013 15c0-4.546 2.188-8.759 5.883-11.388L4.298 1.014h8.689v8.688L9.999 6.714A9.691 9.691 0 0 0 5.315 15c0 5.34 4.344 9.685 9.685 9.685S24.685 20.34 24.685 15c0-4.313-2.896-8.144-7.043-9.316l-.354-.101V1.188l.586.122C24.313 2.655 28.987 8.413 28.987 15c0 7.712-6.275 13.986-13.987 13.986zm-8.353-27 1.778 1.778-.504.328A12.974 12.974 0 0 0 1.987 15c0 7.176 5.837 13.014 13.013 13.014S28.013 22.176 28.013 15c0-5.927-4.066-11.132-9.752-12.601v2.454c4.374 1.405 7.397 5.524 7.397 10.146 0 5.877-4.781 10.657-10.658 10.657S4.342 20.877 4.342 15c0-3.868 2.108-7.439 5.5-9.32l.321-.178 1.85 1.851V1.986H6.647z"
            })
        ]
    });
var $6feb888109403d54$export$2e2bcd8739ae039 = $6feb888109403d54$var$SvgRestartBlue;



const $eb74919e1aba4f48$var$ButtonReset = ()=>{
    const { refreshDeeplyConversation: refreshDeeplyConversation } = (0, $25d6ba8a8df7472c$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
        className: "restart_chatbox",
        onClick: refreshDeeplyConversation,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6feb888109403d54$export$2e2bcd8739ae039), {})
    });
};
var $eb74919e1aba4f48$export$2e2bcd8739ae039 = $eb74919e1aba4f48$var$ButtonReset;





const $010ff6afe86bbe43$var$ButtonPath = ()=>{
    const { valueTogglePath: valueTogglePath } = (0, $ff13ff65642ff6cd$export$787f29101a32d965)();
    const dispatch = (0, $ff13ff65642ff6cd$export$96f70031a13e2d53)();
    const togglePath = ()=>dispatch({
            type: "togglePath"
        });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
        id: "kwalys-path",
        onClick: togglePath,
        className: valueTogglePath ? "active" : "",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
            className: "fas fa-map-marker-alt",
            alt: "path",
            style: {
                width: "18px",
                color: "black"
            }
        })
    });
};
var $010ff6afe86bbe43$export$2e2bcd8739ae039 = $010ff6afe86bbe43$var$ButtonPath;





const $a471f2095e68f011$var$LoaderDebugChatbox = ()=>{
    var { isLoadingResponse: isLoadingResponse } = (0, $8283b38cbbf594a8$export$2db17556772be852)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        id: "kwalys-loader-debug",
        children: [
            isLoadingResponse == true && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                className: "loader-debug"
            }),
            isLoadingResponse == "error" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                className: "loader-debug-error",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    className: "fas fa-times",
                    style: {
                        color: "#f0386b"
                    }
                })
            })
        ]
    });
};
var $a471f2095e68f011$export$2e2bcd8739ae039 = $a471f2095e68f011$var$LoaderDebugChatbox;


const $2e56160b60877da4$var$ChatBoxChat = ({ mode: mode })=>{
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "kwalys-chat",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4f40205da0dd354f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $eb74919e1aba4f48$export$2e2bcd8739ae039), {}),
            mode == "debug" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $010ff6afe86bbe43$export$2e2bcd8739ae039), {}) : null,
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c9334ad309adf0e6$export$2e2bcd8739ae039), {}),
            mode == "debug" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $54a7402c66965534$export$2e2bcd8739ae039), {}) : null,
            mode == "debug" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $77e0a9674b311111$export$2e2bcd8739ae039), {}) : null,
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0118bbede243458a$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a471f2095e68f011$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7455799f00fb9de1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6d5be9212a08c059$export$2e2bcd8739ae039), {})
        ]
    });
};
var $2e56160b60877da4$export$2e2bcd8739ae039 = $2e56160b60877da4$var$ChatBoxChat;




var $bh6RR = parcelRequire("bh6RR");




parcelRequire("bh6RR");
const $212dbea9418704ee$var$SvgUploadFile = (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 140 140",
        xmlSpace: "preserve",
        width: 24,
        height: 24,
        ...props,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M125.696 50.787c-1.351-.817-3.064-1.56-3.812-1.871.088-.768.27-2.523.27-4.075C122.154 25.627 106.522 10 87.31 10c-11.051 0-21.559 5.332-28.108 14.258-.714.978-1.43 2.147-1.892 2.938-.817-.477-2.074-1.165-3.279-1.622a21.853 21.853 0 0 0-7.773-1.417c-12.186 0-22.101 9.913-22.101 22.098 0 1.569.275 3.24.401 3.935-.628.341-2.135 1.194-3.346 2.098C14.19 57.505 10 65.838 10 74.57c0 15.31 12.456 27.765 27.767 27.765h10.296a2.284 2.284 0 1 0 0-4.57H37.767c-12.793 0-23.198-10.404-23.198-23.195 0-7.406 3.415-14.192 9.367-18.62 1.252-.93 3.026-1.868 3.036-1.876 1.571-.817 2.482-2.747 2.122-4.486-.003-.02-.37-1.811-.37-3.334 0-9.665 7.866-17.53 17.534-17.53 2.122 0 4.192.376 6.152 1.12 1.513.573 3.297 1.72 3.313 1.731.833.54 1.856.714 2.81.474a3.594 3.594 0 0 0 2.262-1.75c.01-.02 1.086-1.97 2.092-3.341C68.58 19.2 77.708 14.567 87.31 14.567c16.695 0 30.275 13.58 30.275 30.274 0 1.711-.274 3.85-.278 3.87-.237 1.797.853 3.644 2.528 4.3.02.007 2.088.835 3.504 1.687 7.034 4.242 11.234 11.67 11.234 19.872 0 12.79-10.406 23.195-23.198 23.195h-10.297a2.284 2.284 0 1 0 0 4.57h10.297c15.31 0 27.766-12.455 27.766-27.765-.001-9.815-5.026-18.707-13.445-23.783Z"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M74.57 125.34a2.286 2.286 0 0 0 2.284-2.284V62.801l18.084 18.085a2.281 2.281 0 0 0 3.23 0 2.283 2.283 0 0 0 0-3.23L77.654 57.143c-1.643-1.647-4.526-1.647-6.168-.003L50.972 77.656a2.283 2.283 0 0 0 0 3.23 2.283 2.283 0 0 0 3.23 0l18.085-18.085v60.257a2.282 2.282 0 0 0 2.283 2.283z"
            })
        ]
    });
var $212dbea9418704ee$export$2e2bcd8739ae039 = $212dbea9418704ee$var$SvgUploadFile;


function $3d509390b941064e$var$ChatboxFooter() {
    const [inputValue, setInputValue] = (0, $bh6RR.useState)("");
    const dispatch = (0, $ff13ff65642ff6cd$export$96f70031a13e2d53)();
    const { data: data } = (0, $8283b38cbbf594a8$export$2db17556772be852)();
    const { askBotNextQuestion: askBotNextQuestion } = (0, $25d6ba8a8df7472c$export$2e2bcd8739ae039)();
    const { canSendDataToServer: canSendDataToServer, valueOpen: valueOpen } = (0, $ff13ff65642ff6cd$export$787f29101a32d965)();
    const { chatboxColor: chatboxColor } = (0, $8283b38cbbf594a8$export$2db17556772be852)();
    const { responses: responses } = data;
    const inputRef = (0, $bh6RR.useRef)(null);
    const [focusInput, setFocusInput] = (0, $bh6RR.useState)(false);
    const response = responses.filter((response)=>response.type == "custom" || response.content?.context == "upload_file_action").pop();
    const type = response?.content?.context == "upload_file_action" ? "file" : "text";
    const isInputValid = response ? canSendDataToServer : null;
    const sendData = ()=>{
        if (response == null) return;
        if (response.type == "custom" && inputValue.trim() == "") return;
        askBotNextQuestion(response.tracking, inputValue);
        setInputValue("");
        setFocusInput(!focusInput);
    };
    const onChange = ({ target: { value: value, files: files } })=>{
        const input = files ? files[0] : value.replace(/[{}[\]()#$&%*:;!\\^~|"]/g, "");
        setInputValue(input);
    };
    const onKeyDown = (event)=>{
        if (event.key !== "Enter") return null;
        sendData();
    };
    (0, $bh6RR.useEffect)(()=>{
        inputRef.current.focus();
    }, [
        valueOpen
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (focusInput) inputRef.current.focus();
    }, [
        focusInput
    ]);
    var placeholder = "";
    if (response?.content) placeholder = response.content == "Custom Response" ? "Tapez votre message" : response.content?.values?.text ? response.content?.values?.text : response.content;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "kwalys-bottom",
        style: {
            background: chatboxColor
        },
        children: [
            type == "file" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                htmlFor: "kwalys-input",
                className: "kwalys-input-label",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $212dbea9418704ee$export$2e2bcd8739ae039), {}),
                    placeholder,
                    inputValue ? ` : ${inputValue.name}` : ""
                ]
            }) : "",
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                type: type,
                id: "kwalys-input",
                autoComplete: "off",
                value: type == "text" ? inputValue : "",
                placeholder: placeholder,
                ...response ? {
                    tracking: response.tracking
                } : {},
                onChange: onChange,
                disabled: isInputValid === undefined,
                onKeyDown: onKeyDown,
                ref: inputRef,
                style: {
                    ...type == "file" ? {
                        display: "none"
                    } : {}
                }
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                id: "kwalys-send",
                disabled: response ? !inputValue ? true : false : true,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "20",
                    height: "18",
                    viewBox: "0 0 20 18",
                    onClick: sendData,
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        id: "send-svg",
                        d: "M19.18.106L.533 9.336c-.756.375-.701.84.124 1.036l5.752 1.358 3.157 4.822c.133.203.336.32.557.323h.008a.678.678 0 0 0 .556-.31l2.271-3.289 4.1.968a.612.612 0 0 0 .464-.079.58.58 0 0 0 .255-.386L19.984.681c.098-.584-.264-.843-.804-.575zM9.83 11.894l-.002.004-.008.013c-.007.009-.012.019-.018.03l-.014.022a.072.072 0 0 0-.005.012c-.005.01-.008.02-.012.031l-.01.03-.001.004-.001.007-.005.03-.004.032v.015l-.001.006.01 3.21L7.2 11.379l9.6-8.31-6.97 8.826z"
                    })
                })
            })
        ]
    });
}
var $3d509390b941064e$export$2e2bcd8739ae039 = $3d509390b941064e$var$ChatboxFooter;





var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");



function $3fb3312f9b5c504e$var$VariableAction() {
    const { requestVariableForServer: requestVariableForServer } = (0, $f3a8d99b07d15f79$export$2e2bcd8739ae039);
    const { backEndService: backEndService, bot: bot, session: session, data: data, company: company } = (0, $8283b38cbbf594a8$export$2db17556772be852)();
    const { variables: variables } = data;
    const dispatch = (0, $8283b38cbbf594a8$export$b3ff80222229e8a1)();
    const deleteVariable = (name)=>{
        const content = {
            method: "delete",
            body: {
                name: name
            }
        };
        if (session) content.body.session = session;
        requestVariableForServer({
            backEndService: backEndService,
            company: company,
            bot: bot
        }, content);
        dispatch({
            type: "setVariables",
            payload: {
                variables: variables.filter((variable)=>variable.name != name)
            }
        });
    };
    const updateVariable = (name, value)=>{
        const data = {
            name: name,
            value: value.trim()
        };
        const content = {
            method: "put",
            body: data
        };
        if (session) content.body.session = session;
        requestVariableForServer({
            backEndService: backEndService,
            company: company,
            bot: bot
        }, content);
        dispatch({
            type: "setVariables",
            payload: {
                variables: variables.map((variable)=>variable.name == name ? {
                        ...variable,
                        ...data
                    } : variable)
            }
        });
    };
    const deleteAllVariable = ()=>{
        const content = {
            method: "delete",
            body: {}
        };
        if (session) content.body.session = session;
        requestVariableForServer({
            backEndService: backEndService,
            company: company,
            bot: bot
        }, content);
        dispatch({
            type: "setVariables",
            payload: {
                variables: []
            }
        });
    };
    return {
        deleteVariable: deleteVariable,
        deleteAllVariable: deleteAllVariable,
        updateVariable: updateVariable
    };
}
var $3fb3312f9b5c504e$export$2e2bcd8739ae039 = $3fb3312f9b5c504e$var$VariableAction;


function $7249f2736cba8a57$var$ChatboxVariable({ name: name, value: value }) {
    const { deleteVariable: deleteVariable, updateVariable: updateVariable } = (0, $3fb3312f9b5c504e$export$2e2bcd8739ae039)();
    const inputSpan = (0, $bh6RR.useRef)();
    const divName = (0, $bh6RR.useRef)();
    const [width, setWidth] = (0, $bh6RR.useState)(0);
    const paddingOffset = 10;
    const sizeOfDiv = 450;
    if (typeof value == "boolean") value = new Boolean(value).toString();
    if (typeof value == "number") value = new Number(value).toString();
    (0, $bh6RR.useEffect)(()=>{
        if (inputSpan == null || divName == null) return;
        let tmpWidth = inputSpan.current.offsetWidth + paddingOffset;
        let maxWidth = sizeOfDiv - divName.current.offsetWidth + paddingOffset;
        tmpWidth = tmpWidth > maxWidth ? maxWidth : tmpWidth;
        setWidth(tmpWidth);
    }, [
        inputSpan,
        divName,
        value
    ]);
    const onDelete = ()=>deleteVariable(name);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "kwalys-variable",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                style: {
                    marginRight: "8px"
                },
                ref: divName,
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                        className: "editor-iconButton main_add-button button_center delete_action",
                        icon: "fas fa-trash",
                        onClick: onDelete
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        title: name,
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                style: {
                    width: "430px"
                },
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                        className: "hidden",
                        ref: inputSpan,
                        children: value
                    }),
                    value != "" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                        autoComplete: "off",
                        value: value,
                        onChange: (e)=>updateVariable(name, e.target.value),
                        style: {
                            width: width ? width + "px" : "auto"
                        }
                    }) : null
                ]
            })
        ]
    });
}
var $7249f2736cba8a57$export$2e2bcd8739ae039 = $7249f2736cba8a57$var$ChatboxVariable;




function $53cada49baee87e3$var$ChatboxVariablesContainer() {
    const { valueToggleVariablesList: valueToggleVariablesList } = (0, $ff13ff65642ff6cd$export$787f29101a32d965)();
    const { data: data } = (0, $8283b38cbbf594a8$export$2db17556772be852)();
    const { variables: variables } = data;
    const [display, setDisplay] = (0, $bh6RR.useState)(valueToggleVariablesList == false ? "none" : "flex");
    const { deleteAllVariable: deleteAllVariable } = (0, $3fb3312f9b5c504e$export$2e2bcd8739ae039)();
    const onDelete = ()=>deleteAllVariable();
    const isInitialMount = (0, $bh6RR.useRef)(true);
    (0, $bh6RR.useEffect)(()=>{
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }
        valueToggleVariablesList == true ? setDisplay("flex") : setTimeout(()=>setDisplay("none"), 350);
    }, [
        valueToggleVariablesList
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: valueToggleVariablesList ? "kwalys-chatbox-variable visible" : "kwalys-chatbox-variable",
        style: {
            display: display
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h3", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                        style: {
                            position: "absolute",
                            left: 140,
                            top: 16
                        },
                        className: "editor-iconButton main_add-button button_center delete_action",
                        icon: "fas fa-trash",
                        onClick: onDelete
                    }),
                    "List of Variables"
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "kwalys-list-variable scrollbar-chatbox",
                children: display == "flex" && variables && variables.map((variable, index)=>/*#__PURE__*/ (0, $bh6RR.createElement)((0, $7249f2736cba8a57$export$2e2bcd8739ae039), {
                        ...variable,
                        key: index
                    }))
            })
        ]
    });
}
var $53cada49baee87e3$export$2e2bcd8739ae039 = $53cada49baee87e3$var$ChatboxVariablesContainer;






var $bh6RR = parcelRequire("bh6RR");


const $48a17b03038459e0$var$ChatboxPath = ({ block: block, selected: selected, setSelectedObject: setSelectedObject })=>{
    const onClick = ()=>{
        setSelectedObject(block.object_id);
        window.followBlock(block.object_id);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "chatbox_path_container",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "chatbox_path_icon " + block?.type.name + "_icon",
                onClick: onClick
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                className: "hover_label_path " + block?.type.name + "_label_path " + (selected ? "selected_object_in_path" : "no_selected_object_in_path"),
                onClick: onClick,
                children: block?.name
            })
        ]
    });
};
var $48a17b03038459e0$export$2e2bcd8739ae039 = $48a17b03038459e0$var$ChatboxPath;


function $446c3fee484ee08b$var$ChatboxPathContainer() {
    const { valueTogglePath: valueTogglePath } = (0, $ff13ff65642ff6cd$export$787f29101a32d965)();
    const { path: path } = (0, $8283b38cbbf594a8$export$2db17556772be852)();
    const [display, setDisplay] = (0, $bh6RR.useState)(valueTogglePath == false ? "none" : "flex");
    const isInitialMount = (0, $bh6RR.useRef)(true);
    var blocks = [];
    if (path != null) blocks = path.map((block_id)=>window.getBlockInformation(block_id));
    const [selectedObject, setSelectedObject] = (0, $bh6RR.useState)(blocks[blocks.length - 1]?.object_id);
    (0, $bh6RR.useEffect)(()=>{
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }
        valueTogglePath == true ? setDisplay("flex") : setTimeout(()=>setDisplay("none"), 350);
    }, [
        valueTogglePath
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: valueTogglePath ? "kwalys-chatbox-path visible" : "kwalys-chatbox-path",
        style: {
            display: display
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                children: "Path"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "kwalys-list-variable scrollbar-chatbox",
                children: display == "flex" && blocks.length > 0 && blocks.map((block, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $48a17b03038459e0$export$2e2bcd8739ae039), {
                        block: block.block,
                        selected: selectedObject == block.block?.object_id,
                        setSelectedObject: setSelectedObject
                    }, index))
            })
        ]
    });
}
var $446c3fee484ee08b$export$2e2bcd8739ae039 = $446c3fee484ee08b$var$ChatboxPathContainer;



const $974582475786122d$var$ChatboxWindow = ()=>{
    const { valueOpen: valueOpen, toggleMargin: toggleMargin } = (0, $ff13ff65642ff6cd$export$787f29101a32d965)();
    var { mode: mode, avatar: avatar, chatboxColor: chatboxColor } = (0, $8283b38cbbf594a8$export$2db17556772be852)();
    const { getBotFirstQuestion: getBotFirstQuestion } = (0, $25d6ba8a8df7472c$export$2e2bcd8739ae039)();
    const scrollbarRef = (0, $bh6RR.useRef)(null);
    var className = "kwalys-chatbox-window";
    className = valueOpen ? `${className} visible` : className;
    className = toggleMargin ? `${className} margin` : className;
    (0, $bh6RR.useEffect)(()=>{
        if (scrollbarRef.current) scrollbarRef.current.style.setProperty("--primary-chatbox-color", chatboxColor);
    }, [
        chatboxColor
    ]);
    (0, $bh6RR.useEffect)(()=>{
        getBotFirstQuestion(mode);
    }, [
        mode
    ]);
    // useEffect(()=>{
    //     // return () => element.remove();
    // },[avatar])
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: className,
        ref: scrollbarRef,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2e56160b60877da4$export$2e2bcd8739ae039), {
                mode: mode
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3d509390b941064e$export$2e2bcd8739ae039), {}),
            mode == "debug" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $53cada49baee87e3$export$2e2bcd8739ae039), {}) : null,
            mode == "debug" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $446c3fee484ee08b$export$2e2bcd8739ae039), {}) : null
        ]
    });
};
var $974582475786122d$export$2e2bcd8739ae039 = $974582475786122d$var$ChatboxWindow;






var $bh6RR = parcelRequire("bh6RR");


const $6030a11762cb9fc2$var$EditorWithChatbox = ({ bot: bot, config: config })=>{
    const { botName: botName, blockStart: blockStart } = (0, $7ef7d0b863ac05b4$export$248471b8219beb2f)();
    const dispatch = (0, $8283b38cbbf594a8$export$b3ff80222229e8a1)();
    (0, $bh6RR.useEffect)(()=>{
        dispatch({
            type: "restartConversation"
        });
        dispatch({
            type: "init",
            payload: {
                ...config
            }
        });
    }, [
        bot
    ]);
    const isShowingChatbox = botName && botName == bot && blockStart != undefined;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6949a38b8f965998$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e677ba9f021c00cc$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cd97422625352029$export$2e2bcd8739ae039), {
                        bot: bot
                    })
                })
            }),
            isShowingChatbox ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $974582475786122d$export$2e2bcd8739ae039), {}) : null
        ]
    });
};
function $6030a11762cb9fc2$var$BotEditor() {
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    var bot = location.pathname.split("/").pop();
    const { name: name } = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company");
    const backEndOrigin = new URL((0, $651df53b10514175$export$a7b6bc01c63cdfc3).REACT_APP_API_PATH).origin;
    const configChatbox = {
        bot: bot,
        company: name,
        backEndService: backEndOrigin,
        mode: "debug"
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8283b38cbbf594a8$export$2e2bcd8739ae039), {
            config: configChatbox,
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff13ff65642ff6cd$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7ef7d0b863ac05b4$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($6030a11762cb9fc2$var$EditorWithChatbox, {
                        bot: bot,
                        config: configChatbox
                    })
                })
            })
        })
    });
}
var $6030a11762cb9fc2$export$2e2bcd8739ae039 = $6030a11762cb9fc2$var$BotEditor;





parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");


const $af22ee6aba8dcf75$var$ChatBoxButtonOpen = ()=>{
    const { valueOpen: valueOpen } = (0, $ff13ff65642ff6cd$export$787f29101a32d965)();
    var { chatboxColor: chatboxColor, avatar: avatar, data: data, delay_run_chatbox: delay_run_chatbox, notification: notification, ripple_effect: ripple_effect } = (0, $8283b38cbbf594a8$export$2db17556772be852)();
    const dispatch = (0, $ff13ff65642ff6cd$export$96f70031a13e2d53)();
    const buttonRef = (0, $bh6RR.useRef)(null);
    const { messages: messages } = data;
    const changeState = ()=>{
        dispatch({
            type: "openAndClose"
        });
    };
    const openChatboxWithDelay = (delayInSeconds)=>{
        setTimeout(()=>{
            dispatch({
                type: "openAndClose"
            });
        }, delayInSeconds * 1000);
    };
    const isImageLink = avatar.match(/\.(png|jpg|jpeg)/i) !== null;
    const [messagesDisplayed, setMessagesDisplayed] = (0, $bh6RR.useState)(false);
    const [lastNumberOfMessagesDiplayed, setLastNumberOfMessagesDiplayed] = (0, $bh6RR.useState)(0);
    const textMessagesCount = messages.filter((message)=>message.type === "text").length - lastNumberOfMessagesDiplayed;
    (0, $bh6RR.useEffect)(()=>{
        if (buttonRef.current) {
            buttonRef.current.style.setProperty("--before-chatbox-border-color", chatboxColor);
            buttonRef.current.style.setProperty("--after-chatbox-border-color", chatboxColor);
        }
        if (valueOpen && !messagesDisplayed && textMessagesCount > 0) {
            setMessagesDisplayed(true);
            setLastNumberOfMessagesDiplayed(textMessagesCount);
        }
    }, [
        chatboxColor,
        valueOpen
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (delay_run_chatbox && delay_run_chatbox > 0) openChatboxWithDelay(delay_run_chatbox);
    }, [
        delay_run_chatbox
    ]);
    if (!isImageLink) avatar = `data:image/svg+xml;utf8,${encodeURIComponent(avatar)}`;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
        ref: buttonRef,
        className: valueOpen ? "kwalys-close-chatbox-button" : `kwalys-open-chatbox-button ${!ripple_effect || valueOpen || messagesDisplayed || textMessagesCount === 0 ? "" : "animate"}`,
        onClick: changeState,
        style: {
            background: chatboxColor
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                srcSet: avatar
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                id: "kwalys-unread-messages",
                className: !notification || valueOpen || messagesDisplayed || textMessagesCount === 0 ? "dissapear invisible" : "visible",
                children: textMessagesCount
            })
        ]
    });
};
var /* <div id="kwalys-unread-messages" className={valueOpen ? "dissapear invisible" : "visible"}>+</div> */ $af22ee6aba8dcf75$export$2e2bcd8739ae039 = $af22ee6aba8dcf75$var$ChatBoxButtonOpen;




const $4965e2c4c1fd900f$var$Chatbox = ()=>{
    const { chatboxColor: chatboxColor } = (0, $8283b38cbbf594a8$export$2db17556772be852)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $af22ee6aba8dcf75$export$2e2bcd8739ae039), {
                chatboxColor: chatboxColor
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $974582475786122d$export$2e2bcd8739ae039), {})
        ]
    });
};
var $4965e2c4c1fd900f$export$2e2bcd8739ae039 = $4965e2c4c1fd900f$var$Chatbox;






function $c24b5406ce9f2011$var$BotTest() {
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    var info = location.pathname.split("/").pop();
    var [name, bot, channelKey] = info.split("-");
    const backEndOrigin = new URL((0, $651df53b10514175$export$a7b6bc01c63cdfc3).REACT_APP_API_PATH).origin;
    const variables = Object.fromEntries(new URLSearchParams(window.location.search));
    const configChatbox = {
        bot: bot,
        company: name,
        backEndService: backEndOrigin,
        mode: "test",
        defaultValues: {
            variables: variables
        },
        channelKey: channelKey
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8283b38cbbf594a8$export$2e2bcd8739ae039), {
            config: configChatbox,
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff13ff65642ff6cd$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4965e2c4c1fd900f$export$2e2bcd8739ae039), {})
            })
        })
    });
}
var $c24b5406ce9f2011$export$2e2bcd8739ae039 = $c24b5406ce9f2011$var$BotTest;


const $e821820b6d05b6dc$var$routes = [
    {
        path: "company/:company/bots/list",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7ef5e88fe6b2745b$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "view_bots"
        ]
    },
    {
        path: "company/:company/bots/:bot",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6030a11762cb9fc2$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "update_bot"
        ]
    },
    {
        path: "company/:company/bot/create",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $723b845b1d5d12f3$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "create_bot"
        ]
    },
    {
        path: "company/:company/bot/update",
        component: (data, type)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $723b845b1d5d12f3$export$2e2bcd8739ae039), {
                data: data,
                type: type
            }),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "update_bot"
        ]
    },
    {
        path: "bot/test/:bot",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c24b5406ce9f2011$export$2e2bcd8739ae039), {}),
        isSidebar: false,
        isPublic: true
    },
    {
        path: "*",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $70b8a3ef3c035a5f$export$2e2bcd8739ae039), {}),
        isPublic: true,
        isSidebar: false
    }
];
var $e821820b6d05b6dc$export$2e2bcd8739ae039 = $e821820b6d05b6dc$var$routes;






var $bh6RR = parcelRequire("bh6RR");






var $78ca27eb74d4b0fa$exports = {};
$78ca27eb74d4b0fa$exports = new URL("logo_black_empty.7da4c34f.png", import.meta.url).toString();






var $bh6RR = parcelRequire("bh6RR");
var $399a94fac864e4d1$var$user = sessionStorage.getItem("user");
$399a94fac864e4d1$var$user = $399a94fac864e4d1$var$user ? JSON.parse($399a94fac864e4d1$var$user) : $399a94fac864e4d1$var$user;
const $399a94fac864e4d1$var$initialAuthState = {
    user: $399a94fac864e4d1$var$user ? $399a94fac864e4d1$var$user : {},
    error: undefined,
    token: undefined,
    fetching: false
};
var $399a94fac864e4d1$export$2e2bcd8739ae039 = $399a94fac864e4d1$var$initialAuthState;


function $584feb553c20191e$var$authReducer(state, action) {
    switch(action.type){
        case "refreshUserInfo":
            return {
                ...state,
                user: action.payload.user ? action.payload.user : state.user,
                token: action.payload.token ? action.payload.token : state.token
            };
        case "loginSuccess":
            return {
                ...state,
                fetching: false,
                error: undefined,
                user: action.payload.user,
                token: action.payload.token,
                refresh_token: action.payload.refresh_token
            };
        case "loginFailed":
            return {
                ...state,
                fetching: false,
                error: action.payload
            };
        case "loginPending":
            return {
                ...state,
                fetching: true
            };
        case "loginOut":
            return {
                ...state,
                ...(0, $399a94fac864e4d1$export$2e2bcd8739ae039)
            };
        default:
            throw new Error("unhandled action");
    }
}
var $584feb553c20191e$export$2e2bcd8739ae039 = $584feb553c20191e$var$authReducer;



const $373f9505ebba8636$var$AuthStateContext = /*#__PURE__*/ (0, $bh6RR.createContext)((0, $399a94fac864e4d1$export$2e2bcd8739ae039));
const $373f9505ebba8636$var$AuthDispatchContext = /*#__PURE__*/ (0, $bh6RR.createContext)(null);
function $373f9505ebba8636$var$AuthContextProvider({ children: children }) {
    const [state, dispatch] = (0, $bh6RR.useReducer)((0, $584feb553c20191e$export$2e2bcd8739ae039), (0, $399a94fac864e4d1$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($373f9505ebba8636$var$AuthStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($373f9505ebba8636$var$AuthDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
}
var $373f9505ebba8636$export$2e2bcd8739ae039 = $373f9505ebba8636$var$AuthContextProvider;
const $373f9505ebba8636$export$ea6ddbd83f749864 = ()=>(0, $bh6RR.useContext)($373f9505ebba8636$var$AuthStateContext);
const $373f9505ebba8636$export$a03a56d03840936f = ()=>(0, $bh6RR.useContext)($373f9505ebba8636$var$AuthDispatchContext);



var $bh6RR = parcelRequire("bh6RR");
// Hook implementation of the localStorage : the goal is to re-render the component who use the hook if the value has changed in the local storage
function $869ede8a86ff8cef$var$useLocalStorage(key, initialValue = "") {
    const [storedValue, setStoredValue] = (0, $bh6RR.useState)(()=>{
        if (typeof window === "undefined") return initialValue;
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.log(error);
            return initialValue;
        }
    });
    const setValue = (value)=>{
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            if (typeof window === "undefined") return null;
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            console.log(error);
        }
    };
    return [
        storedValue,
        setValue
    ];
}
var $869ede8a86ff8cef$export$2e2bcd8739ae039 = $869ede8a86ff8cef$var$useLocalStorage;



var $c3f355fefa80bd40$export$2e2bcd8739ae039 = {
    signIn: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post("auth/signin", data),
    updatePassword: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post("change/password", data)
};



//import { toastSuccess, toastError } from "/src/layouts/toast/action/toastAction";
async function $84ea3ff01b4cb54c$var$signIn(dispatch, data) {
    //const [token, setToken] = useLocalStorage("token", null);
    dispatch({
        type: "loginPending"
    });
    let [response, error] = await (0, $c3f355fefa80bd40$export$2e2bcd8739ae039).signIn(data);
    // if(error !== null) {
    //     //toastError("Login Failed");
    //     console.error(error);
    //     dispatch({type : 'loginFailed', payload : null});
    //     return false;
    // }
    if (error !== null) return {
        error: true,
        status: error.message === "Renew Password" ? 403 : 0,
        message: error.message
    };
    const { token: token, user: user, company: company, permissions: permissions, refresh_token: refresh_token } = response;
    dispatch({
        type: "loginSuccess",
        payload: {
            refresh_token: refresh_token,
            token: token,
            user: user
        }
    });
    (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").set("token", token);
    (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").set("refresh_token", refresh_token);
    (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").set("user", user);
    (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").set("company", company);
    (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").set("permissions", permissions);
    return response;
}
function $84ea3ff01b4cb54c$var$signOut(dispatch) {
    //const [token, setToken] = useLocalStorage("token", null);
    //const dispatch = useAuthDispatchContext();
    sessionStorage.removeItem("user");
    localStorage.removeItem("token");
    dispatch({
        type: "logout"
    });
}
var $84ea3ff01b4cb54c$export$2e2bcd8739ae039 = {
    signIn: $84ea3ff01b4cb54c$var$signIn,
    signOut: $84ea3ff01b4cb54c$var$signOut
};






/**
 * FingerprintJS v5.1.0 - Copyright (c) FingerprintJS, Inc, 2026 (https://fingerprint.com)
 *
 * Licensed under MIT License
 *
 * Copyright (c) 2025 FingerprintJS, Inc
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $47623ef264fc8f38$var$version = "5.1.0";
function $47623ef264fc8f38$var$wait(durationMs, resolveWith) {
    return new Promise((resolve)=>setTimeout(resolve, durationMs, resolveWith));
}
/**
 * Allows asynchronous actions and microtasks to happen.
 */ function $47623ef264fc8f38$var$releaseEventLoop() {
    // Don't use setTimeout because Chrome throttles it in some cases causing very long agent execution:
    // https://stackoverflow.com/a/6032591/1118709
    // https://github.com/chromium/chromium/commit/0295dd09496330f3a9103ef7e543fa9b6050409b
    // Reusing a MessageChannel object gives no noticeable benefits
    return new Promise((resolve)=>{
        const channel = new MessageChannel();
        channel.port1.onmessage = ()=>resolve();
        channel.port2.postMessage(null);
    });
}
function $47623ef264fc8f38$var$requestIdleCallbackIfAvailable(fallbackTimeout, deadlineTimeout = Infinity) {
    const { requestIdleCallback: requestIdleCallback } = window;
    if (requestIdleCallback) // The function `requestIdleCallback` loses the binding to `window` here.
    // `globalThis` isn't always equal `window` (see https://github.com/fingerprintjs/fingerprintjs/issues/683).
    // Therefore, an error can occur. `call(window,` prevents the error.
    return new Promise((resolve)=>requestIdleCallback.call(window, ()=>resolve(), {
            timeout: deadlineTimeout
        }));
    else return $47623ef264fc8f38$var$wait(Math.min(fallbackTimeout, deadlineTimeout));
}
function $47623ef264fc8f38$var$isPromise(value) {
    return !!value && typeof value.then === "function";
}
/**
 * Calls a maybe asynchronous function without creating microtasks when the function is synchronous.
 * Catches errors in both cases.
 *
 * If just you run a code like this:
 * ```
 * console.time('Action duration')
 * await action()
 * console.timeEnd('Action duration')
 * ```
 * The synchronous function time can be measured incorrectly because another microtask may run before the `await`
 * returns the control back to the code.
 */ function $47623ef264fc8f38$var$awaitIfAsync(action, callback) {
    try {
        const returnedValue = action();
        if ($47623ef264fc8f38$var$isPromise(returnedValue)) returnedValue.then((result)=>callback(true, result), (error)=>callback(false, error));
        else callback(true, returnedValue);
    } catch (error) {
        callback(false, error);
    }
}
/**
 * If you run many synchronous tasks without using this function, the JS main loop will be busy and asynchronous tasks
 * (e.g. completing a network request, rendering the page) won't be able to happen.
 * This function allows running many synchronous tasks such way that asynchronous tasks can run too in background.
 */ async function $47623ef264fc8f38$var$mapWithBreaks(items, callback, loopReleaseInterval = 16) {
    const results = Array(items.length);
    let lastLoopReleaseTime = Date.now();
    for(let i = 0; i < items.length; ++i){
        results[i] = callback(items[i], i);
        const now = Date.now();
        if (now >= lastLoopReleaseTime + loopReleaseInterval) {
            lastLoopReleaseTime = now;
            await $47623ef264fc8f38$var$releaseEventLoop();
        }
    }
    return results;
}
/**
 * Makes the given promise never emit an unhandled promise rejection console warning.
 * The promise will still pass errors to the next promises.
 * Returns the input promise for convenience.
 *
 * Otherwise, promise emits a console warning unless it has a `catch` listener.
 */ function $47623ef264fc8f38$var$suppressUnhandledRejectionWarning(promise) {
    promise.then(undefined, ()=>undefined);
    return promise;
}
/*
 * This file contains functions to work with pure data only (no browser features, DOM, side effects, etc).
 */ /**
 * Does the same as Array.prototype.includes but has better typing
 */ function $47623ef264fc8f38$var$includes(haystack, needle) {
    for(let i = 0, l = haystack.length; i < l; ++i){
        if (haystack[i] === needle) return true;
    }
    return false;
}
/**
 * Like `!includes()` but with proper typing
 */ function $47623ef264fc8f38$var$excludes(haystack, needle) {
    return !$47623ef264fc8f38$var$includes(haystack, needle);
}
/**
 * Be careful, NaN can return
 */ function $47623ef264fc8f38$var$toInt(value) {
    return parseInt(value);
}
/**
 * Be careful, NaN can return
 */ function $47623ef264fc8f38$var$toFloat(value) {
    return parseFloat(value);
}
function $47623ef264fc8f38$var$replaceNaN(value, replacement) {
    return typeof value === "number" && isNaN(value) ? replacement : value;
}
function $47623ef264fc8f38$var$countTruthy(values) {
    return values.reduce((sum, value)=>sum + (value ? 1 : 0), 0);
}
function $47623ef264fc8f38$var$round(value, base = 1) {
    if (Math.abs(base) >= 1) return Math.round(value / base) * base;
    else {
        // Sometimes when a number is multiplied by a small number, precision is lost,
        // for example 1234 * 0.0001 === 0.12340000000000001, and it's more precise divide: 1234 / (1 / 0.0001) === 0.1234.
        const counterBase = 1 / base;
        return Math.round(value * counterBase) / counterBase;
    }
}
/**
 * Parses a CSS selector into tag name with HTML attributes.
 * Only single element selector are supported (without operators like space, +, >, etc).
 *
 * Multiple values can be returned for each attribute. You decide how to handle them.
 */ function $47623ef264fc8f38$var$parseSimpleCssSelector(selector) {
    var _a, _b;
    const errorMessage = `Unexpected syntax '${selector}'`;
    const tagMatch = /^\s*([a-z-]*)(.*)$/i.exec(selector);
    const tag = tagMatch[1] || undefined;
    const attributes = {};
    const partsRegex = /([.:#][\w-]+|\[.+?\])/gi;
    const addAttribute = (name, value)=>{
        attributes[name] = attributes[name] || [];
        attributes[name].push(value);
    };
    for(;;){
        const match = partsRegex.exec(tagMatch[2]);
        if (!match) break;
        const part = match[0];
        switch(part[0]){
            case ".":
                addAttribute("class", part.slice(1));
                break;
            case "#":
                addAttribute("id", part.slice(1));
                break;
            case "[":
                {
                    const attributeMatch = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(part);
                    if (attributeMatch) addAttribute(attributeMatch[1], (_b = (_a = attributeMatch[4]) !== null && _a !== void 0 ? _a : attributeMatch[5]) !== null && _b !== void 0 ? _b : "");
                    else throw new Error(errorMessage);
                    break;
                }
            default:
                throw new Error(errorMessage);
        }
    }
    return [
        tag,
        attributes
    ];
}
/**
 * Converts a string to UTF8 bytes
 */ function $47623ef264fc8f38$var$getUTF8Bytes(input) {
    // Benchmark: https://jsbench.me/b6klaaxgwq/1
    // If you want to just count bytes, see solutions at https://jsbench.me/ehklab415e/1
    const result = new Uint8Array(input.length);
    for(let i = 0; i < input.length; i++){
        // `charCode` is faster than encoding, so we prefer that when it's possible
        const charCode = input.charCodeAt(i);
        // In case of non-ASCII symbols we use proper encoding
        if (charCode > 127) return new TextEncoder().encode(input);
        result[i] = charCode;
    }
    return result;
}
/*
 * Based on https://github.com/karanlyons/murmurHash3.js/blob/a33d0723127e2e5415056c455f8aed2451ace208/murmurHash3.js
 */ /**
 * Adds two 64-bit values (provided as tuples of 32-bit values)
 * and updates (mutates) first value to write the result
 */ function $47623ef264fc8f38$var$x64Add(m, n) {
    const m0 = m[0] >>> 16, m1 = m[0] & 0xffff, m2 = m[1] >>> 16, m3 = m[1] & 0xffff;
    const n0 = n[0] >>> 16, n1 = n[0] & 0xffff, n2 = n[1] >>> 16, n3 = n[1] & 0xffff;
    let o0 = 0, o1 = 0, o2 = 0, o3 = 0;
    o3 += m3 + n3;
    o2 += o3 >>> 16;
    o3 &= 0xffff;
    o2 += m2 + n2;
    o1 += o2 >>> 16;
    o2 &= 0xffff;
    o1 += m1 + n1;
    o0 += o1 >>> 16;
    o1 &= 0xffff;
    o0 += m0 + n0;
    o0 &= 0xffff;
    m[0] = o0 << 16 | o1;
    m[1] = o2 << 16 | o3;
}
/**
 * Multiplies two 64-bit values (provided as tuples of 32-bit values)
 * and updates (mutates) first value to write the result
 */ function $47623ef264fc8f38$var$x64Multiply(m, n) {
    const m0 = m[0] >>> 16, m1 = m[0] & 0xffff, m2 = m[1] >>> 16, m3 = m[1] & 0xffff;
    const n0 = n[0] >>> 16, n1 = n[0] & 0xffff, n2 = n[1] >>> 16, n3 = n[1] & 0xffff;
    let o0 = 0, o1 = 0, o2 = 0, o3 = 0;
    o3 += m3 * n3;
    o2 += o3 >>> 16;
    o3 &= 0xffff;
    o2 += m2 * n3;
    o1 += o2 >>> 16;
    o2 &= 0xffff;
    o2 += m3 * n2;
    o1 += o2 >>> 16;
    o2 &= 0xffff;
    o1 += m1 * n3;
    o0 += o1 >>> 16;
    o1 &= 0xffff;
    o1 += m2 * n2;
    o0 += o1 >>> 16;
    o1 &= 0xffff;
    o1 += m3 * n1;
    o0 += o1 >>> 16;
    o1 &= 0xffff;
    o0 += m0 * n3 + m1 * n2 + m2 * n1 + m3 * n0;
    o0 &= 0xffff;
    m[0] = o0 << 16 | o1;
    m[1] = o2 << 16 | o3;
}
/**
 * Provides left rotation of the given int64 value (provided as tuple of two int32)
 * by given number of bits. Result is written back to the value
 */ function $47623ef264fc8f38$var$x64Rotl(m, bits) {
    const m0 = m[0];
    bits %= 64;
    if (bits === 32) {
        m[0] = m[1];
        m[1] = m0;
    } else if (bits < 32) {
        m[0] = m0 << bits | m[1] >>> 32 - bits;
        m[1] = m[1] << bits | m0 >>> 32 - bits;
    } else {
        bits -= 32;
        m[0] = m[1] << bits | m0 >>> 32 - bits;
        m[1] = m0 << bits | m[1] >>> 32 - bits;
    }
}
/**
 * Provides a left shift of the given int32 value (provided as tuple of [0, int32])
 * by given number of bits. Result is written back to the value
 */ function $47623ef264fc8f38$var$x64LeftShift(m, bits) {
    bits %= 64;
    if (bits === 0) return;
    else if (bits < 32) {
        m[0] = m[1] >>> 32 - bits;
        m[1] = m[1] << bits;
    } else {
        m[0] = m[1] << bits - 32;
        m[1] = 0;
    }
}
/**
 * Provides a XOR of the given int64 values(provided as tuple of two int32).
 * Result is written back to the first value
 */ function $47623ef264fc8f38$var$x64Xor(m, n) {
    m[0] ^= n[0];
    m[1] ^= n[1];
}
const $47623ef264fc8f38$var$F1 = [
    0xff51afd7,
    0xed558ccd
];
const $47623ef264fc8f38$var$F2 = [
    0xc4ceb9fe,
    0x1a85ec53
];
/**
 * Calculates murmurHash3's final x64 mix of that block and writes result back to the input value.
 * (`[0, h[0] >>> 1]` is a 33 bit unsigned right shift. This is the
 * only place where we need to right shift 64bit ints.)
 */ function $47623ef264fc8f38$var$x64Fmix(h) {
    const shifted = [
        0,
        h[0] >>> 1
    ];
    $47623ef264fc8f38$var$x64Xor(h, shifted);
    $47623ef264fc8f38$var$x64Multiply(h, $47623ef264fc8f38$var$F1);
    shifted[1] = h[0] >>> 1;
    $47623ef264fc8f38$var$x64Xor(h, shifted);
    $47623ef264fc8f38$var$x64Multiply(h, $47623ef264fc8f38$var$F2);
    shifted[1] = h[0] >>> 1;
    $47623ef264fc8f38$var$x64Xor(h, shifted);
}
const $47623ef264fc8f38$var$C1 = [
    0x87c37b91,
    0x114253d5
];
const $47623ef264fc8f38$var$C2 = [
    0x4cf5ad43,
    0x2745937f
];
const $47623ef264fc8f38$var$M$1 = [
    0,
    5
];
const $47623ef264fc8f38$var$N1 = [
    0,
    0x52dce729
];
const $47623ef264fc8f38$var$N2 = [
    0,
    0x38495ab5
];
/**
 * Given a string and an optional seed as an int, returns a 128 bit
 * hash using the x64 flavor of MurmurHash3, as an unsigned hex.
 * All internal functions mutates passed value to achieve minimal memory allocations and GC load
 *
 * Benchmark https://jsbench.me/p4lkpaoabi/1
 */ function $47623ef264fc8f38$var$x64hash128(input, seed) {
    const key = $47623ef264fc8f38$var$getUTF8Bytes(input);
    seed = seed || 0;
    const length = [
        0,
        key.length
    ];
    const remainder = length[1] % 16;
    const bytes = length[1] - remainder;
    const h1 = [
        0,
        seed
    ];
    const h2 = [
        0,
        seed
    ];
    const k1 = [
        0,
        0
    ];
    const k2 = [
        0,
        0
    ];
    let i;
    for(i = 0; i < bytes; i = i + 16){
        k1[0] = key[i + 4] | key[i + 5] << 8 | key[i + 6] << 16 | key[i + 7] << 24;
        k1[1] = key[i] | key[i + 1] << 8 | key[i + 2] << 16 | key[i + 3] << 24;
        k2[0] = key[i + 12] | key[i + 13] << 8 | key[i + 14] << 16 | key[i + 15] << 24;
        k2[1] = key[i + 8] | key[i + 9] << 8 | key[i + 10] << 16 | key[i + 11] << 24;
        $47623ef264fc8f38$var$x64Multiply(k1, $47623ef264fc8f38$var$C1);
        $47623ef264fc8f38$var$x64Rotl(k1, 31);
        $47623ef264fc8f38$var$x64Multiply(k1, $47623ef264fc8f38$var$C2);
        $47623ef264fc8f38$var$x64Xor(h1, k1);
        $47623ef264fc8f38$var$x64Rotl(h1, 27);
        $47623ef264fc8f38$var$x64Add(h1, h2);
        $47623ef264fc8f38$var$x64Multiply(h1, $47623ef264fc8f38$var$M$1);
        $47623ef264fc8f38$var$x64Add(h1, $47623ef264fc8f38$var$N1);
        $47623ef264fc8f38$var$x64Multiply(k2, $47623ef264fc8f38$var$C2);
        $47623ef264fc8f38$var$x64Rotl(k2, 33);
        $47623ef264fc8f38$var$x64Multiply(k2, $47623ef264fc8f38$var$C1);
        $47623ef264fc8f38$var$x64Xor(h2, k2);
        $47623ef264fc8f38$var$x64Rotl(h2, 31);
        $47623ef264fc8f38$var$x64Add(h2, h1);
        $47623ef264fc8f38$var$x64Multiply(h2, $47623ef264fc8f38$var$M$1);
        $47623ef264fc8f38$var$x64Add(h2, $47623ef264fc8f38$var$N2);
    }
    k1[0] = 0;
    k1[1] = 0;
    k2[0] = 0;
    k2[1] = 0;
    const val = [
        0,
        0
    ];
    switch(remainder){
        case 15:
            val[1] = key[i + 14];
            $47623ef264fc8f38$var$x64LeftShift(val, 48);
            $47623ef264fc8f38$var$x64Xor(k2, val);
        // fallthrough
        case 14:
            val[1] = key[i + 13];
            $47623ef264fc8f38$var$x64LeftShift(val, 40);
            $47623ef264fc8f38$var$x64Xor(k2, val);
        // fallthrough
        case 13:
            val[1] = key[i + 12];
            $47623ef264fc8f38$var$x64LeftShift(val, 32);
            $47623ef264fc8f38$var$x64Xor(k2, val);
        // fallthrough
        case 12:
            val[1] = key[i + 11];
            $47623ef264fc8f38$var$x64LeftShift(val, 24);
            $47623ef264fc8f38$var$x64Xor(k2, val);
        // fallthrough
        case 11:
            val[1] = key[i + 10];
            $47623ef264fc8f38$var$x64LeftShift(val, 16);
            $47623ef264fc8f38$var$x64Xor(k2, val);
        // fallthrough
        case 10:
            val[1] = key[i + 9];
            $47623ef264fc8f38$var$x64LeftShift(val, 8);
            $47623ef264fc8f38$var$x64Xor(k2, val);
        // fallthrough
        case 9:
            val[1] = key[i + 8];
            $47623ef264fc8f38$var$x64Xor(k2, val);
            $47623ef264fc8f38$var$x64Multiply(k2, $47623ef264fc8f38$var$C2);
            $47623ef264fc8f38$var$x64Rotl(k2, 33);
            $47623ef264fc8f38$var$x64Multiply(k2, $47623ef264fc8f38$var$C1);
            $47623ef264fc8f38$var$x64Xor(h2, k2);
        // fallthrough
        case 8:
            val[1] = key[i + 7];
            $47623ef264fc8f38$var$x64LeftShift(val, 56);
            $47623ef264fc8f38$var$x64Xor(k1, val);
        // fallthrough
        case 7:
            val[1] = key[i + 6];
            $47623ef264fc8f38$var$x64LeftShift(val, 48);
            $47623ef264fc8f38$var$x64Xor(k1, val);
        // fallthrough
        case 6:
            val[1] = key[i + 5];
            $47623ef264fc8f38$var$x64LeftShift(val, 40);
            $47623ef264fc8f38$var$x64Xor(k1, val);
        // fallthrough
        case 5:
            val[1] = key[i + 4];
            $47623ef264fc8f38$var$x64LeftShift(val, 32);
            $47623ef264fc8f38$var$x64Xor(k1, val);
        // fallthrough
        case 4:
            val[1] = key[i + 3];
            $47623ef264fc8f38$var$x64LeftShift(val, 24);
            $47623ef264fc8f38$var$x64Xor(k1, val);
        // fallthrough
        case 3:
            val[1] = key[i + 2];
            $47623ef264fc8f38$var$x64LeftShift(val, 16);
            $47623ef264fc8f38$var$x64Xor(k1, val);
        // fallthrough
        case 2:
            val[1] = key[i + 1];
            $47623ef264fc8f38$var$x64LeftShift(val, 8);
            $47623ef264fc8f38$var$x64Xor(k1, val);
        // fallthrough
        case 1:
            val[1] = key[i];
            $47623ef264fc8f38$var$x64Xor(k1, val);
            $47623ef264fc8f38$var$x64Multiply(k1, $47623ef264fc8f38$var$C1);
            $47623ef264fc8f38$var$x64Rotl(k1, 31);
            $47623ef264fc8f38$var$x64Multiply(k1, $47623ef264fc8f38$var$C2);
            $47623ef264fc8f38$var$x64Xor(h1, k1);
    }
    $47623ef264fc8f38$var$x64Xor(h1, length);
    $47623ef264fc8f38$var$x64Xor(h2, length);
    $47623ef264fc8f38$var$x64Add(h1, h2);
    $47623ef264fc8f38$var$x64Add(h2, h1);
    $47623ef264fc8f38$var$x64Fmix(h1);
    $47623ef264fc8f38$var$x64Fmix(h2);
    $47623ef264fc8f38$var$x64Add(h1, h2);
    $47623ef264fc8f38$var$x64Add(h2, h1);
    return ("00000000" + (h1[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h1[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[1] >>> 0).toString(16)).slice(-8);
}
/**
 * Converts an error object to a plain object that can be used with `JSON.stringify`.
 * If you just run `JSON.stringify(error)`, you'll get `'{}'`.
 */ function $47623ef264fc8f38$var$errorToObject(error) {
    var _a;
    return {
        name: error.name,
        message: error.message,
        stack: (_a = error.stack) === null || _a === void 0 ? void 0 : _a.split("\n"),
        // The fields are not enumerable, so TS is wrong saying that they will be overridden
        ...error
    };
}
function $47623ef264fc8f38$var$isFunctionNative(func) {
    return /^function\s.*?\{\s*\[native code]\s*}$/.test(String(func));
}
/* eslint-disable @typescript-eslint/no-explicit-any */ function $47623ef264fc8f38$var$isFinalResultLoaded(loadResult) {
    return typeof loadResult !== "function";
}
/**
 * Loads the given entropy source. Returns a function that gets an entropy component from the source.
 *
 * The result is returned synchronously to prevent `loadSources` from
 * waiting for one source to load before getting the components from the other sources.
 */ function $47623ef264fc8f38$var$loadSource(source, sourceOptions) {
    const sourceLoadPromise = $47623ef264fc8f38$var$suppressUnhandledRejectionWarning(new Promise((resolveLoad)=>{
        const loadStartTime = Date.now();
        // `awaitIfAsync` is used instead of just `await` in order to measure the duration of synchronous sources
        // correctly (other microtasks won't affect the duration).
        $47623ef264fc8f38$var$awaitIfAsync(source.bind(null, sourceOptions), (...loadArgs)=>{
            const loadDuration = Date.now() - loadStartTime;
            // Source loading failed
            if (!loadArgs[0]) return resolveLoad(()=>({
                    error: loadArgs[1],
                    duration: loadDuration
                }));
            const loadResult = loadArgs[1];
            // Source loaded with the final result
            if ($47623ef264fc8f38$var$isFinalResultLoaded(loadResult)) return resolveLoad(()=>({
                    value: loadResult,
                    duration: loadDuration
                }));
            // Source loaded with "get" stage
            resolveLoad(()=>new Promise((resolveGet)=>{
                    const getStartTime = Date.now();
                    $47623ef264fc8f38$var$awaitIfAsync(loadResult, (...getArgs)=>{
                        const duration = loadDuration + Date.now() - getStartTime;
                        // Source getting failed
                        if (!getArgs[0]) return resolveGet({
                            error: getArgs[1],
                            duration: duration
                        });
                        // Source getting succeeded
                        resolveGet({
                            value: getArgs[1],
                            duration: duration
                        });
                    });
                }));
        });
    }));
    return function getComponent() {
        return sourceLoadPromise.then((finalizeSource)=>finalizeSource());
    };
}
/**
 * Loads the given entropy sources. Returns a function that collects the entropy components.
 *
 * The result is returned synchronously in order to allow start getting the components
 * before the sources are loaded completely.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $47623ef264fc8f38$export$3c5f4c9f15eeb5cb(sources, sourceOptions, excludeSources, loopReleaseInterval) {
    const includedSources = Object.keys(sources).filter((sourceKey)=>$47623ef264fc8f38$var$excludes(excludeSources, sourceKey));
    // Using `mapWithBreaks` allows asynchronous sources to complete between synchronous sources
    // and measure the duration correctly
    const sourceGettersPromise = $47623ef264fc8f38$var$suppressUnhandledRejectionWarning($47623ef264fc8f38$var$mapWithBreaks(includedSources, (sourceKey)=>$47623ef264fc8f38$var$loadSource(sources[sourceKey], sourceOptions), loopReleaseInterval));
    return async function getComponents() {
        const sourceGetters = await sourceGettersPromise;
        const componentPromises = await $47623ef264fc8f38$var$mapWithBreaks(sourceGetters, (sourceGetter)=>$47623ef264fc8f38$var$suppressUnhandledRejectionWarning(sourceGetter()), loopReleaseInterval);
        const componentArray = await Promise.all(componentPromises);
        // Keeping the component keys order the same as the source keys order
        const components = {};
        for(let index = 0; index < includedSources.length; ++index)components[includedSources[index]] = componentArray[index];
        return components;
    };
}
/**
 * Modifies an entropy source by transforming its returned value with the given function.
 * Keeps the source properties: sync/async, 1/2 stages.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $47623ef264fc8f38$export$258739ac4e431f7e(source, transformValue) {
    const transformLoadResult = (loadResult)=>{
        if ($47623ef264fc8f38$var$isFinalResultLoaded(loadResult)) return transformValue(loadResult);
        return ()=>{
            const getResult = loadResult();
            if ($47623ef264fc8f38$var$isPromise(getResult)) return getResult.then(transformValue);
            return transformValue(getResult);
        };
    };
    return (options)=>{
        const loadResult = source(options);
        if ($47623ef264fc8f38$var$isPromise(loadResult)) return loadResult.then(transformLoadResult);
        return transformLoadResult(loadResult);
    };
}
/*
 * Functions to help with features that vary through browsers
 */ /**
 * Checks whether the browser is based on Trident (the Internet Explorer engine) without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $47623ef264fc8f38$export$5aba6d4fec9b366c() {
    const w = window;
    const n = navigator;
    // The properties are checked to be in IE 10, IE 11 and not to be in other browsers in October 2020
    return $47623ef264fc8f38$var$countTruthy([
        "MSCSSMatrix" in w,
        "msSetImmediate" in w,
        "msIndexedDB" in w,
        "msMaxTouchPoints" in n,
        "msPointerEnabled" in n
    ]) >= 4;
}
/**
 * Checks whether the browser is based on EdgeHTML (the pre-Chromium Edge engine) without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $47623ef264fc8f38$export$13c899a793cdf73d() {
    // Based on research in October 2020
    const w = window;
    const n = navigator;
    return $47623ef264fc8f38$var$countTruthy([
        "msWriteProfilerMark" in w,
        "MSStream" in w,
        "msLaunchUri" in n,
        "msSaveBlob" in n
    ]) >= 3 && !$47623ef264fc8f38$export$5aba6d4fec9b366c();
}
/**
 * Checks whether the browser is based on Chromium without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $47623ef264fc8f38$export$dd401a4677e99039() {
    // Based on research in October 2020. Tested to detect Chromium 42-86.
    const w = window;
    const n = navigator;
    return $47623ef264fc8f38$var$countTruthy([
        "webkitPersistentStorage" in n,
        "webkitTemporaryStorage" in n,
        (n.vendor || "").indexOf("Google") === 0,
        "webkitResolveLocalFileSystemURL" in w,
        "BatteryManager" in w,
        "webkitMediaStream" in w,
        "webkitSpeechGrammar" in w
    ]) >= 5;
}
/**
 * Checks whether the browser is based on mobile or desktop Safari without using user-agent.
 * All iOS browsers use WebKit (the Safari engine).
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $47623ef264fc8f38$export$78551043582a6a98() {
    // Based on research in August 2024
    const w = window;
    const n = navigator;
    return $47623ef264fc8f38$var$countTruthy([
        "ApplePayError" in w,
        "CSSPrimitiveValue" in w,
        "Counter" in w,
        n.vendor.indexOf("Apple") === 0,
        "RGBColor" in w,
        "WebKitMediaKeys" in w
    ]) >= 4;
}
/**
 * Checks whether this WebKit browser is a desktop browser.
 * It doesn't check that the browser is based on WebKit, there is a separate function for this.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $47623ef264fc8f38$export$4949e6bd5097eae9() {
    // Checked in Safari and DuckDuckGo
    const w = window;
    const { HTMLElement: HTMLElement, Document: Document } = w;
    return $47623ef264fc8f38$var$countTruthy([
        "safari" in w,
        !("ongestureend" in w),
        !("TouchEvent" in w),
        !("orientation" in w),
        HTMLElement && !("autocapitalize" in HTMLElement.prototype),
        Document && "pointerLockElement" in Document.prototype
    ]) >= 4;
}
/**
 * Checks whether this WebKit browser is Safari.
 * It doesn't check that the browser is based on WebKit, there is a separate function for this.
 *
 * Warning! The function works properly only for Safari version 15.4 and newer.
 */ function $47623ef264fc8f38$var$isSafariWebKit() {
    // Checked in Safari, Chrome, Firefox, Yandex, UC Browser, Opera, Edge and DuckDuckGo.
    // iOS Safari and Chrome were checked on iOS 11-18. DuckDuckGo was checked on iOS 17-18 and macOS 14-15.
    // Desktop Safari versions 12-18 were checked.
    // The other browsers were checked on iOS 17 and 18; there was no chance to check them on the other OS versions.
    const w = window;
    return(// Filters-out Chrome, Yandex, DuckDuckGo (macOS and iOS), Edge
    $47623ef264fc8f38$var$isFunctionNative(w.print) && // Doesn't work in Safari < 15.4
    String(w.browser) === "[object WebPageNamespace]");
}
/**
 * Checks whether the browser is based on Gecko (Firefox engine) without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $47623ef264fc8f38$export$1127c7d1b8731973() {
    var _a, _b;
    const w = window;
    // Based on research in September 2020
    return $47623ef264fc8f38$var$countTruthy([
        "buildID" in navigator,
        "MozAppearance" in ((_b = (_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.style) !== null && _b !== void 0 ? _b : {}),
        "onmozfullscreenchange" in w,
        "mozInnerScreenX" in w,
        "CSSMozDocumentRule" in w,
        "CanvasCaptureMediaStream" in w
    ]) >= 4;
}
/**
 * Checks whether the browser is based on Gecko version ≥120 (Firefox ≥120) without using user-agent.
 * It doesn't check that the browser is based on Gecko; there is a separate function for this.
 *
 * @see https://developer.mozilla.org/en-US/docs/Mozilla/Firefox/Releases/120 Firefox 120 release notes
 */ function $47623ef264fc8f38$var$isGecko120OrNewer() {
    // Checked in Firefox 119 vs. Firefox 120+
    const w = window;
    const n = navigator;
    const { CSS: CSS } = w;
    // We use a threshold of 3 out of 4 because `globalPrivacyControl` was added in Firefox 120 on desktop,
    // but only in Firefox 122 on mobile. Using >= 3 ensures detection works on both platforms for Firefox 120+.
    // @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/globalPrivacyControl#browser_compatibility
    return $47623ef264fc8f38$var$countTruthy([
        // User Activation API - added in Firefox 120
        "userActivation" in n,
        // CSS light-dark() function - added in Firefox 120
        CSS.supports("color", "light-dark(#000, #fff)"),
        // CSS lh unit - added in Firefox 120
        CSS.supports("height", "1lh"),
        // Global Privacy Control - added in Firefox 120 (desktop) / Firefox 122 (mobile)
        "globalPrivacyControl" in n
    ]) >= 3;
}
/**
 * Checks whether the browser is based on Gecko version ≥143 (Firefox ≥143) without using user-agent.
 * It doesn't check that the browser is based on Gecko; there is a separate function for this.
 *
 * Firefox 143 shipped Phase 2 fingerprinting protections (screen resolution, processor count, touch points)
 * in Private Browsing and ETP Strict mode.
 *
 * @see https://developer.mozilla.org/en-US/docs/Mozilla/Firefox/Releases/143 Firefox 143 release notes
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1978414 Bug that shipped these protections
 */ function $47623ef264fc8f38$var$isGecko143OrNewer() {
    // Checked in Firefox 142 vs. Firefox 143+
    const { CSS: CSS } = window;
    return $47623ef264fc8f38$var$countTruthy([
        // CSS ::details-content pseudo-element - added in Firefox 143
        CSS.supports("selector(::details-content)"),
        // CSS ::before::marker nested pseudo-element - added in Firefox 143
        CSS.supports("selector(::before::marker)"),
        // CSS ::after::marker nested pseudo-element - added in Firefox 143
        CSS.supports("selector(::after::marker)"),
        // CompositionEvent.locale property - removed in Firefox 143 (Bug 1700969)
        !("locale" in CompositionEvent.prototype)
    ]) >= 3;
}
/**
 * Checks whether the browser is based on Chromium version ≥86 without using user-agent.
 * It doesn't check that the browser is based on Chromium, there is a separate function for this.
 */ function $47623ef264fc8f38$var$isChromium86OrNewer() {
    // Checked in Chrome 85 vs Chrome 86 both on desktop and Android. Checked in macOS Chrome 128, Android Chrome 127.
    const w = window;
    return $47623ef264fc8f38$var$countTruthy([
        !("MediaSettingsRange" in w),
        "RTCEncodedAudioFrame" in w,
        "" + w.Intl === "[object Intl]",
        "" + w.Reflect === "[object Reflect]"
    ]) >= 3;
}
/**
 * Checks whether the browser is based on Chromium version ≥122 without using user-agent.
 * It doesn't check that the browser is based on Chromium, there is a separate function for this.
 */ function $47623ef264fc8f38$var$isChromium122OrNewer() {
    // Checked in Chrome 121 vs Chrome 122 and 129 both on desktop and Android
    const w = window;
    const { URLPattern: URLPattern } = w;
    return $47623ef264fc8f38$var$countTruthy([
        "union" in Set.prototype,
        "Iterator" in w,
        URLPattern && "hasRegExpGroups" in URLPattern.prototype,
        "RGB8" in WebGLRenderingContext.prototype
    ]) >= 3;
}
/**
 * Checks whether the browser is based on WebKit version ≥606 (Safari ≥12) without using user-agent.
 * It doesn't check that the browser is based on WebKit, there is a separate function for this.
 *
 * @see https://en.wikipedia.org/wiki/Safari_version_history#Release_history Safari-WebKit versions map
 */ function $47623ef264fc8f38$var$isWebKit606OrNewer() {
    // Checked in Safari 9–18
    const w = window;
    return $47623ef264fc8f38$var$countTruthy([
        "DOMRectList" in w,
        "RTCPeerConnectionIceEvent" in w,
        "SVGGeometryElement" in w,
        "ontransitioncancel" in w
    ]) >= 3;
}
/**
 * Checks whether the browser is based on WebKit version ≥616 (Safari ≥17) without using user-agent.
 * It doesn't check that the browser is based on WebKit, there is a separate function for this.
 *
 * @see https://developer.apple.com/documentation/safari-release-notes/safari-17-release-notes Safari 17 release notes
 * @see https://tauri.app/v1/references/webview-versions/#webkit-versions-in-safari Safari-WebKit versions map
 */ function $47623ef264fc8f38$var$isWebKit616OrNewer() {
    const w = window;
    const n = navigator;
    const { CSS: CSS, HTMLButtonElement: HTMLButtonElement } = w;
    return $47623ef264fc8f38$var$countTruthy([
        !("getStorageUpdates" in n),
        HTMLButtonElement && "popover" in HTMLButtonElement.prototype,
        "CSSCounterStyleRule" in w,
        CSS.supports("font-size-adjust: ex-height 0.5"),
        CSS.supports("text-transform: full-width")
    ]) >= 4;
}
/**
 * Checks whether the device is an iPad.
 * It doesn't check that the engine is WebKit and that the WebKit isn't desktop.
 */ function $47623ef264fc8f38$var$isIPad() {
    // Checked on:
    // Safari on iPadOS (both mobile and desktop modes): 8, 11-18
    // Chrome on iPadOS (both mobile and desktop modes): 11-18
    // Safari on iOS (both mobile and desktop modes): 9-18
    // Chrome on iOS (both mobile and desktop modes): 9-18
    // Before iOS 13. Safari tampers the value in "request desktop site" mode since iOS 13.
    if (navigator.platform === "iPad") return true;
    const s = screen;
    const screenRatio = s.width / s.height;
    return $47623ef264fc8f38$var$countTruthy([
        // Since iOS 13. Doesn't work in Chrome on iPadOS <15, but works in desktop mode.
        "MediaSource" in window,
        // Since iOS 12. Doesn't work in Chrome on iPadOS.
        !!Element.prototype.webkitRequestFullscreen,
        // iPhone 4S that runs iOS 9 matches this, but it is not supported
        // Doesn't work in incognito mode of Safari ≥17 with split screen because of tracking prevention
        screenRatio > 0.65 && screenRatio < 1.53
    ]) >= 2;
}
/**
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $47623ef264fc8f38$export$a095f8af1f7b5580() {
    const d = document;
    return d.fullscreenElement || d.msFullscreenElement || d.mozFullScreenElement || d.webkitFullscreenElement || null;
}
function $47623ef264fc8f38$var$exitFullscreen() {
    const d = document;
    // `call` is required because the function throws an error without a proper "this" context
    return (d.exitFullscreen || d.msExitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen).call(d);
}
/**
 * Checks whether the device runs on Android without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $47623ef264fc8f38$export$a11b0059900ceec8() {
    const isItChromium = $47623ef264fc8f38$export$dd401a4677e99039();
    const isItGecko = $47623ef264fc8f38$export$1127c7d1b8731973();
    const w = window;
    const n = navigator;
    const c = "connection";
    // Chrome removes all words "Android" from `navigator` when desktop version is requested
    // Firefox keeps "Android" in `navigator.appVersion` when desktop version is requested
    if (isItChromium) return $47623ef264fc8f38$var$countTruthy([
        !("SharedWorker" in w),
        // `typechange` is deprecated, but it's still present on Android (tested on Chrome Mobile 117)
        // Removal proposal https://bugs.chromium.org/p/chromium/issues/detail?id=699892
        // Note: this expression returns true on ChromeOS, so additional detectors are required to avoid false-positives
        n[c] && "ontypechange" in n[c],
        !("sinkId" in new Audio())
    ]) >= 2;
    else if (isItGecko) return $47623ef264fc8f38$var$countTruthy([
        "onorientationchange" in w,
        "orientation" in w,
        /android/i.test(n.appVersion)
    ]) >= 2;
    else // Only 2 browser engines are presented on Android.
    // Actually, there is also Android 4.1 browser, but it's not worth detecting it at the moment.
    return false;
}
/**
 * Checks whether the browser is Samsung Internet without using user-agent.
 * It doesn't check that the browser is based on Chromium, please use `isChromium` before using this function.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $47623ef264fc8f38$export$59552fb864857a30() {
    // Checked in Samsung Internet 21, 25 and 27
    const n = navigator;
    const w = window;
    const audioPrototype = Audio.prototype;
    const { visualViewport: visualViewport } = w;
    return $47623ef264fc8f38$var$countTruthy([
        "srLatency" in audioPrototype,
        "srChannelCount" in audioPrototype,
        "devicePosture" in n,
        visualViewport && "segments" in visualViewport,
        "getTextInformation" in Image.prototype
    ]) >= 3;
}
/**
 * A deep description: https://fingerprint.com/blog/audio-fingerprinting/
 * Inspired by and based on https://github.com/cozylife/audio-fingerprint
 *
 * A version of the entropy source with stabilization to make it suitable for static fingerprinting.
 * Audio signal is noised in private mode of Safari 17, so audio fingerprinting is skipped in Safari 17.
 */ function $47623ef264fc8f38$var$getAudioFingerprint() {
    if ($47623ef264fc8f38$var$doesBrowserPerformAntifingerprinting()) return -4 /* SpecialFingerprint.KnownForAntifingerprinting */ ;
    return $47623ef264fc8f38$export$ed8a5b1e45927d11();
}
/**
 * A version of the entropy source without stabilization.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $47623ef264fc8f38$export$ed8a5b1e45927d11() {
    const w = window;
    const AudioContext1 = w.OfflineAudioContext || w.webkitOfflineAudioContext;
    if (!AudioContext1) return -2 /* SpecialFingerprint.NotSupported */ ;
    // In some browsers, audio context always stays suspended unless the context is started in response to a user action
    // (e.g. a click or a tap). It prevents audio fingerprint from being taken at an arbitrary moment of time.
    // Such browsers are old and unpopular, so the audio fingerprinting is just skipped in them.
    // See a similar case explanation at https://stackoverflow.com/questions/46363048/onaudioprocess-not-called-on-ios11#46534088
    if ($47623ef264fc8f38$var$doesBrowserSuspendAudioContext()) return -1 /* SpecialFingerprint.KnownForSuspending */ ;
    const hashFromIndex = 4500;
    const hashToIndex = 5000;
    const context = new AudioContext1(1, hashToIndex, 44100);
    const oscillator = context.createOscillator();
    oscillator.type = "triangle";
    oscillator.frequency.value = 10000;
    const compressor = context.createDynamicsCompressor();
    compressor.threshold.value = -50;
    compressor.knee.value = 40;
    compressor.ratio.value = 12;
    compressor.attack.value = 0;
    compressor.release.value = 0.25;
    oscillator.connect(compressor);
    compressor.connect(context.destination);
    oscillator.start(0);
    const [renderPromise, finishRendering] = $47623ef264fc8f38$var$startRenderingAudio(context);
    // Suppresses the console error message in case when the fingerprint fails before requested
    const fingerprintPromise = $47623ef264fc8f38$var$suppressUnhandledRejectionWarning(renderPromise.then((buffer)=>$47623ef264fc8f38$var$getHash(buffer.getChannelData(0).subarray(hashFromIndex)), (error)=>{
        if (error.name === "timeout" /* InnerErrorName.Timeout */  || error.name === "suspended" /* InnerErrorName.Suspended */ ) return -3 /* SpecialFingerprint.Timeout */ ;
        throw error;
    }));
    return ()=>{
        finishRendering();
        return fingerprintPromise;
    };
}
/**
 * Checks if the current browser is known for always suspending audio context
 */ function $47623ef264fc8f38$var$doesBrowserSuspendAudioContext() {
    // Mobile Safari 11 and older
    return $47623ef264fc8f38$export$78551043582a6a98() && !$47623ef264fc8f38$export$4949e6bd5097eae9() && !$47623ef264fc8f38$var$isWebKit606OrNewer();
}
/**
 * Checks if the current browser is known for applying anti-fingerprinting measures in all or some critical modes
 */ function $47623ef264fc8f38$var$doesBrowserPerformAntifingerprinting() {
    return(// Safari ≥17
    $47623ef264fc8f38$export$78551043582a6a98() && $47623ef264fc8f38$var$isWebKit616OrNewer() && $47623ef264fc8f38$var$isSafariWebKit() || // Samsung Internet ≥26
    $47623ef264fc8f38$export$dd401a4677e99039() && $47623ef264fc8f38$export$59552fb864857a30() && $47623ef264fc8f38$var$isChromium122OrNewer());
}
/**
 * Starts rendering the audio context.
 * When the returned function is called, the render process starts finishing.
 */ function $47623ef264fc8f38$var$startRenderingAudio(context) {
    const renderTryMaxCount = 3;
    const renderRetryDelay = 500;
    const runningMaxAwaitTime = 500;
    const runningSufficientTime = 5000;
    let finalize = ()=>undefined;
    const resultPromise = new Promise((resolve, reject)=>{
        let isFinalized = false;
        let renderTryCount = 0;
        let startedRunningAt = 0;
        context.oncomplete = (event)=>resolve(event.renderedBuffer);
        const startRunningTimeout = ()=>{
            setTimeout(()=>reject($47623ef264fc8f38$var$makeInnerError("timeout" /* InnerErrorName.Timeout */ )), Math.min(runningMaxAwaitTime, startedRunningAt + runningSufficientTime - Date.now()));
        };
        const tryRender = ()=>{
            try {
                const renderingPromise = context.startRendering();
                // `context.startRendering` has two APIs: Promise and callback, we check that it's really a promise just in case
                if ($47623ef264fc8f38$var$isPromise(renderingPromise)) // Suppresses all unhandled rejections in case of scheduled redundant retries after successful rendering
                $47623ef264fc8f38$var$suppressUnhandledRejectionWarning(renderingPromise);
                switch(context.state){
                    case "running":
                        startedRunningAt = Date.now();
                        if (isFinalized) startRunningTimeout();
                        break;
                    // Sometimes the audio context doesn't start after calling `startRendering` (in addition to the cases where
                    // audio context doesn't start at all). A known case is starting an audio context when the browser tab is in
                    // background on iPhone. Retries usually help in this case.
                    case "suspended":
                        // The audio context can reject starting until the tab is in foreground. Long fingerprint duration
                        // in background isn't a problem, therefore the retry attempts don't count in background. It can lead to
                        // a situation when a fingerprint takes very long time and finishes successfully. FYI, the audio context
                        // can be suspended when `document.hidden === false` and start running after a retry.
                        if (!document.hidden) renderTryCount++;
                        if (isFinalized && renderTryCount >= renderTryMaxCount) reject($47623ef264fc8f38$var$makeInnerError("suspended" /* InnerErrorName.Suspended */ ));
                        else setTimeout(tryRender, renderRetryDelay);
                        break;
                }
            } catch (error) {
                reject(error);
            }
        };
        tryRender();
        finalize = ()=>{
            if (!isFinalized) {
                isFinalized = true;
                if (startedRunningAt > 0) startRunningTimeout();
            }
        };
    });
    return [
        resultPromise,
        finalize
    ];
}
function $47623ef264fc8f38$var$getHash(signal) {
    let hash = 0;
    for(let i = 0; i < signal.length; ++i)hash += Math.abs(signal[i]);
    return hash;
}
function $47623ef264fc8f38$var$makeInnerError(name) {
    const error = new Error(name);
    error.name = name;
    return error;
}
/**
 * Creates and keeps an invisible iframe while the given function runs.
 * The given function is called when the iframe is loaded and has a body.
 * The iframe allows to measure DOM sizes inside itself.
 *
 * Notice: passing an initial HTML code doesn't work in IE.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ async function $47623ef264fc8f38$export$8b65e2577b8ab46d(action, initialHtml, domPollInterval = 50) {
    var _a, _b, _c;
    const d = document;
    // document.body can be null while the page is loading
    while(!d.body)await $47623ef264fc8f38$var$wait(domPollInterval);
    const iframe = d.createElement("iframe");
    try {
        await new Promise((_resolve, _reject)=>{
            let isComplete = false;
            const resolve = ()=>{
                isComplete = true;
                _resolve();
            };
            const reject = (error)=>{
                isComplete = true;
                _reject(error);
            };
            iframe.onload = resolve;
            iframe.onerror = reject;
            const { style: style } = iframe;
            style.setProperty("display", "block", "important"); // Required for browsers to calculate the layout
            style.position = "absolute";
            style.top = "0";
            style.left = "0";
            style.visibility = "hidden";
            if (initialHtml && "srcdoc" in iframe) iframe.srcdoc = initialHtml;
            else iframe.src = "about:blank";
            d.body.appendChild(iframe);
            // WebKit in WeChat doesn't fire the iframe's `onload` for some reason.
            // This code checks for the loading state manually.
            // See https://github.com/fingerprintjs/fingerprintjs/issues/645
            const checkReadyState = ()=>{
                var _a, _b;
                // The ready state may never become 'complete' in Firefox despite the 'load' event being fired.
                // So an infinite setTimeout loop can happen without this check.
                // See https://github.com/fingerprintjs/fingerprintjs/pull/716#issuecomment-986898796
                if (isComplete) return;
                // Make sure iframe.contentWindow and iframe.contentWindow.document are both loaded
                // The contentWindow.document can miss in JSDOM (https://github.com/jsdom/jsdom).
                if (((_b = (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.readyState) === "complete") resolve();
                else setTimeout(checkReadyState, 10);
            };
            checkReadyState();
        });
        while(!((_b = (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.body))await $47623ef264fc8f38$var$wait(domPollInterval);
        return await action(iframe, iframe.contentWindow);
    } finally{
        (_c = iframe.parentNode) === null || _c === void 0 || _c.removeChild(iframe);
    }
}
/**
 * Creates a DOM element that matches the given selector.
 * Only single element selector are supported (without operators like space, +, >, etc).
 */ function $47623ef264fc8f38$var$selectorToElement(selector) {
    const [tag, attributes] = $47623ef264fc8f38$var$parseSimpleCssSelector(selector);
    const element = document.createElement(tag !== null && tag !== void 0 ? tag : "div");
    for (const name of Object.keys(attributes)){
        const value = attributes[name].join(" ");
        // Changing the `style` attribute can cause a CSP error, therefore we change the `style.cssText` property.
        // https://github.com/fingerprintjs/fingerprintjs/issues/733
        if (name === "style") $47623ef264fc8f38$var$addStyleString(element.style, value);
        else element.setAttribute(name, value);
    }
    return element;
}
/**
 * Adds CSS styles from a string in such a way that doesn't trigger a CSP warning (unsafe-inline or unsafe-eval)
 */ function $47623ef264fc8f38$var$addStyleString(style, source) {
    // We don't use `style.cssText` because browsers must block it when no `unsafe-eval` CSP is presented: https://csplite.com/csp145/#w3c_note
    // Even though the browsers ignore this standard, we don't use `cssText` just in case.
    for (const property of source.split(";")){
        const match = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(property);
        if (match) {
            const [, name, value, , priority] = match;
            style.setProperty(name, value, priority || ""); // The last argument can't be undefined in IE11
        }
    }
}
/**
 * Returns true if the code runs in an iframe, and any parent page's origin doesn't match the current origin
 */ function $47623ef264fc8f38$var$isAnyParentCrossOrigin() {
    let currentWindow = window;
    for(;;){
        const parentWindow = currentWindow.parent;
        if (!parentWindow || parentWindow === currentWindow) return false; // The top page is reached
        try {
            if (parentWindow.location.origin !== currentWindow.location.origin) return true;
        } catch (error) {
            // The error is thrown when `origin` is accessed on `parentWindow.location` when the parent is cross-origin
            if (error instanceof Error && error.name === "SecurityError") return true;
            throw error;
        }
        currentWindow = parentWindow;
    }
}
// We use m or w because these two characters take up the maximum width.
// And we use a LLi so that the same matching fonts can get separated.
const $47623ef264fc8f38$var$testString = "mmMwWLliI0O&1";
// We test using 48px font size, we may use any size. I guess larger the better.
const $47623ef264fc8f38$var$textSize = "48px";
// A font will be compared against all the three default fonts.
// And if for any default fonts it doesn't match, then that font is available.
const $47623ef264fc8f38$var$baseFonts = [
    "monospace",
    "sans-serif",
    "serif"
];
const $47623ef264fc8f38$var$fontList = [
    // This is android-specific font from "Roboto" family
    "sans-serif-thin",
    "ARNO PRO",
    "Agency FB",
    "Arabic Typesetting",
    "Arial Unicode MS",
    "AvantGarde Bk BT",
    "BankGothic Md BT",
    "Batang",
    "Bitstream Vera Sans Mono",
    "Calibri",
    "Century",
    "Century Gothic",
    "Clarendon",
    "EUROSTILE",
    "Franklin Gothic",
    "Futura Bk BT",
    "Futura Md BT",
    "GOTHAM",
    "Gill Sans",
    "HELV",
    "Haettenschweiler",
    "Helvetica Neue",
    "Humanst521 BT",
    "Leelawadee",
    "Letter Gothic",
    "Levenim MT",
    "Lucida Bright",
    "Lucida Sans",
    "Menlo",
    "MS Mincho",
    "MS Outlook",
    "MS Reference Specialty",
    "MS UI Gothic",
    "MT Extra",
    "MYRIAD PRO",
    "Marlett",
    "Meiryo UI",
    "Microsoft Uighur",
    "Minion Pro",
    "Monotype Corsiva",
    "PMingLiU",
    "Pristina",
    "SCRIPTINA",
    "Segoe UI Light",
    "Serifa",
    "SimHei",
    "Small Fonts",
    "Staccato222 BT",
    "TRAJAN PRO",
    "Univers CE 55 Medium",
    "Vrinda",
    "ZWAdobeF"
];
// kudos to http://www.lalit.org/lab/javascript-css-font-detect/
function $47623ef264fc8f38$var$getFonts() {
    // Running the script in an iframe makes it not affect the page look and not be affected by the page CSS. See:
    // https://github.com/fingerprintjs/fingerprintjs/issues/592
    // https://github.com/fingerprintjs/fingerprintjs/issues/628
    return $47623ef264fc8f38$export$8b65e2577b8ab46d(async (_, { document: document1 })=>{
        const holder = document1.body;
        holder.style.fontSize = $47623ef264fc8f38$var$textSize;
        // div to load spans for the default fonts and the fonts to detect
        const spansContainer = document1.createElement("div");
        spansContainer.style.setProperty("visibility", "hidden", "important");
        const defaultWidth = {};
        const defaultHeight = {};
        // creates a span where the fonts will be loaded
        const createSpan = (fontFamily)=>{
            const span = document1.createElement("span");
            const { style: style } = span;
            style.position = "absolute";
            style.top = "0";
            style.left = "0";
            style.fontFamily = fontFamily;
            span.textContent = $47623ef264fc8f38$var$testString;
            spansContainer.appendChild(span);
            return span;
        };
        // creates a span and load the font to detect and a base font for fallback
        const createSpanWithFonts = (fontToDetect, baseFont)=>{
            return createSpan(`'${fontToDetect}',${baseFont}`);
        };
        // creates spans for the base fonts and adds them to baseFontsDiv
        const initializeBaseFontsSpans = ()=>{
            return $47623ef264fc8f38$var$baseFonts.map(createSpan);
        };
        // creates spans for the fonts to detect and adds them to fontsDiv
        const initializeFontsSpans = ()=>{
            // Stores {fontName : [spans for that font]}
            const spans = {};
            for (const font of $47623ef264fc8f38$var$fontList)spans[font] = $47623ef264fc8f38$var$baseFonts.map((baseFont)=>createSpanWithFonts(font, baseFont));
            return spans;
        };
        // checks if a font is available
        const isFontAvailable = (fontSpans)=>{
            return $47623ef264fc8f38$var$baseFonts.some((baseFont, baseFontIndex)=>fontSpans[baseFontIndex].offsetWidth !== defaultWidth[baseFont] || fontSpans[baseFontIndex].offsetHeight !== defaultHeight[baseFont]);
        };
        // create spans for base fonts
        const baseFontsSpans = initializeBaseFontsSpans();
        // create spans for fonts to detect
        const fontsSpans = initializeFontsSpans();
        // add all the spans to the DOM
        holder.appendChild(spansContainer);
        // get the default width for the three base fonts
        for(let index = 0; index < $47623ef264fc8f38$var$baseFonts.length; index++){
            defaultWidth[$47623ef264fc8f38$var$baseFonts[index]] = baseFontsSpans[index].offsetWidth; // width for the default font
            defaultHeight[$47623ef264fc8f38$var$baseFonts[index]] = baseFontsSpans[index].offsetHeight; // height for the default font
        }
        // check available fonts
        return $47623ef264fc8f38$var$fontList.filter((font)=>isFontAvailable(fontsSpans[font]));
    });
}
function $47623ef264fc8f38$var$getPlugins() {
    const rawPlugins = navigator.plugins;
    if (!rawPlugins) return undefined;
    const plugins = [];
    // Safari 10 doesn't support iterating navigator.plugins with for...of
    for(let i = 0; i < rawPlugins.length; ++i){
        const plugin = rawPlugins[i];
        if (!plugin) continue;
        const mimeTypes = [];
        for(let j = 0; j < plugin.length; ++j){
            const mimeType = plugin[j];
            mimeTypes.push({
                type: mimeType.type,
                suffixes: mimeType.suffixes
            });
        }
        plugins.push({
            name: plugin.name,
            description: plugin.description,
            mimeTypes: mimeTypes
        });
    }
    return plugins;
}
/**
 * A version of the entropy source with stabilization to make it suitable for static fingerprinting.
 *
 * Canvas image is noised in private mode of Safari 17, so image rendering is skipped in Safari 17.
 * Firefox 120+ randomizes canvas data in private browsing and strict ETP mode,
 * so image rendering is skipped in Firefox 120+.
 *
 * @see https://www.browserleaks.com/canvas#how-does-it-work
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1816189 Firefox canvas randomization
 */ function $47623ef264fc8f38$var$getCanvasFingerprint() {
    return $47623ef264fc8f38$export$8ae13959fff0d124($47623ef264fc8f38$var$doesBrowserPerformAntiFingerprinting());
}
/**
 * A version of the entropy source without stabilization.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $47623ef264fc8f38$export$8ae13959fff0d124(skipImages) {
    let winding = false;
    let geometry;
    let text;
    const [canvas, context] = $47623ef264fc8f38$var$makeCanvasContext();
    if (!$47623ef264fc8f38$var$isSupported(canvas, context)) geometry = text = "unsupported" /* ImageStatus.Unsupported */ ;
    else {
        winding = $47623ef264fc8f38$var$doesSupportWinding(context);
        if (skipImages) geometry = text = "skipped" /* ImageStatus.Skipped */ ;
        else [geometry, text] = $47623ef264fc8f38$var$renderImages(canvas, context);
    }
    return {
        winding: winding,
        geometry: geometry,
        text: text
    };
}
function $47623ef264fc8f38$var$makeCanvasContext() {
    const canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = 1;
    return [
        canvas,
        canvas.getContext("2d")
    ];
}
function $47623ef264fc8f38$var$isSupported(canvas, context) {
    return !!(context && canvas.toDataURL);
}
function $47623ef264fc8f38$var$doesSupportWinding(context) {
    // https://web.archive.org/web/20170825024655/http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
    // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js
    context.rect(0, 0, 10, 10);
    context.rect(2, 2, 6, 6);
    return !context.isPointInPath(5, 5, "evenodd");
}
function $47623ef264fc8f38$var$renderImages(canvas, context) {
    $47623ef264fc8f38$var$renderTextImage(canvas, context);
    const textImage1 = $47623ef264fc8f38$var$canvasToString(canvas);
    const textImage2 = $47623ef264fc8f38$var$canvasToString(canvas); // It's slightly faster to double-encode the text image
    // Some browsers add a noise to the canvas: https://github.com/fingerprintjs/fingerprintjs/issues/791
    // The canvas is excluded from the fingerprint in this case
    if (textImage1 !== textImage2) return [
        "unstable" /* ImageStatus.Unstable */ ,
        "unstable" /* ImageStatus.Unstable */ 
    ];
    // Text is unstable:
    // https://github.com/fingerprintjs/fingerprintjs/issues/583
    // https://github.com/fingerprintjs/fingerprintjs/issues/103
    // Therefore it's extracted into a separate image.
    $47623ef264fc8f38$var$renderGeometryImage(canvas, context);
    const geometryImage = $47623ef264fc8f38$var$canvasToString(canvas);
    return [
        geometryImage,
        textImage1
    ];
}
function $47623ef264fc8f38$var$renderTextImage(canvas, context) {
    // Resizing the canvas cleans it
    canvas.width = 240;
    canvas.height = 60;
    context.textBaseline = "alphabetic";
    context.fillStyle = "#f60";
    context.fillRect(100, 1, 62, 20);
    context.fillStyle = "#069";
    // It's important to use explicit built-in fonts in order to exclude the affect of font preferences
    // (there is a separate entropy source for them).
    context.font = '11pt "Times New Roman"';
    // The choice of emojis has a gigantic impact on rendering performance (especially in FF).
    // Some newer emojis cause it to slow down 50-200 times.
    // There must be no text to the right of the emoji, see https://github.com/fingerprintjs/fingerprintjs/issues/574
    // A bare emoji shouldn't be used because the canvas will change depending on the script encoding:
    // https://github.com/fingerprintjs/fingerprintjs/issues/66
    // Escape sequence shouldn't be used too because Terser will turn it into a bare unicode.
    const printedText = `Cwm fjordbank gly ${String.fromCharCode(55357, 56835)}`;
    context.fillText(printedText, 2, 15);
    context.fillStyle = "rgba(102, 204, 0, 0.2)";
    context.font = "18pt Arial";
    context.fillText(printedText, 4, 45);
}
function $47623ef264fc8f38$var$renderGeometryImage(canvas, context) {
    // Resizing the canvas cleans it
    canvas.width = 122;
    canvas.height = 110;
    // Canvas blending
    // https://web.archive.org/web/20170826194121/http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
    // http://jsfiddle.net/NDYV8/16/
    context.globalCompositeOperation = "multiply";
    for (const [color, x, y] of [
        [
            "#f2f",
            40,
            40
        ],
        [
            "#2ff",
            80,
            40
        ],
        [
            "#ff2",
            60,
            80
        ]
    ]){
        context.fillStyle = color;
        context.beginPath();
        context.arc(x, y, 40, 0, Math.PI * 2, true);
        context.closePath();
        context.fill();
    }
    // Canvas winding
    // https://web.archive.org/web/20130913061632/http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
    // http://jsfiddle.net/NDYV8/19/
    context.fillStyle = "#f9c";
    context.arc(60, 60, 60, 0, Math.PI * 2, true);
    context.arc(60, 60, 20, 0, Math.PI * 2, true);
    context.fill("evenodd");
}
function $47623ef264fc8f38$var$canvasToString(canvas) {
    return canvas.toDataURL();
}
/**
 * Checks if the current browser is known for applying anti-fingerprinting measures in all or some critical modes:
 * - Safari 17+: noises canvas image in private mode
 * - Firefox 120+: randomizes canvas data in private browsing and strict ETP mode (CanvasRandomization)
 *
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1816189 Firefox canvas randomization
 */ function $47623ef264fc8f38$var$doesBrowserPerformAntiFingerprinting() {
    const isSafari17OrAbove = $47623ef264fc8f38$export$78551043582a6a98() && $47623ef264fc8f38$var$isWebKit616OrNewer() && $47623ef264fc8f38$var$isSafariWebKit();
    const isFirefox120OrAbove = $47623ef264fc8f38$export$1127c7d1b8731973() && $47623ef264fc8f38$var$isGecko120OrNewer();
    return isSafari17OrAbove || isFirefox120OrAbove;
}
/**
 * This is a crude and primitive touch screen detection. It's not possible to currently reliably detect the availability
 * of a touch screen with a JS, without actually subscribing to a touch event.
 *
 * @see http://www.stucox.com/blog/you-cant-detect-a-touchscreen/
 * @see https://github.com/Modernizr/Modernizr/issues/548
 */ function $47623ef264fc8f38$var$getTouchSupport() {
    const n = navigator;
    let maxTouchPoints = 0;
    let touchEvent;
    if (n.maxTouchPoints !== undefined) maxTouchPoints = $47623ef264fc8f38$var$toInt(n.maxTouchPoints);
    else if (n.msMaxTouchPoints !== undefined) maxTouchPoints = n.msMaxTouchPoints;
    try {
        document.createEvent("TouchEvent");
        touchEvent = true;
    } catch (_a) {
        touchEvent = false;
    }
    const touchStart = "ontouchstart" in window;
    return {
        maxTouchPoints: maxTouchPoints,
        touchEvent: touchEvent,
        touchStart: touchStart
    };
}
function $47623ef264fc8f38$var$getOsCpu() {
    return navigator.oscpu;
}
function $47623ef264fc8f38$var$getLanguages() {
    const n = navigator;
    const result = [];
    const language = n.language || n.userLanguage || n.browserLanguage || n.systemLanguage;
    if (language !== undefined) result.push([
        language
    ]);
    if (Array.isArray(n.languages)) // Starting from Chromium 86, there is only a single value in `navigator.language` in Incognito mode:
    // the value of `navigator.language`. Therefore the value is ignored in this browser.
    {
        if (!($47623ef264fc8f38$export$dd401a4677e99039() && $47623ef264fc8f38$var$isChromium86OrNewer())) result.push(n.languages);
    } else if (typeof n.languages === "string") {
        const languages = n.languages;
        if (languages) result.push(languages.split(","));
    }
    return result;
}
function $47623ef264fc8f38$var$getColorDepth() {
    return window.screen.colorDepth;
}
function $47623ef264fc8f38$var$getDeviceMemory() {
    // `navigator.deviceMemory` is a string containing a number in some unidentified cases
    return $47623ef264fc8f38$var$replaceNaN($47623ef264fc8f38$var$toFloat(navigator.deviceMemory), undefined);
}
/**
 * A version of the entropy source with stabilization to make it suitable for static fingerprinting.
 * The window resolution is always the document size in private mode of Safari 17,
 * so the window resolution is not used in Safari 17.
 */ function $47623ef264fc8f38$var$getScreenResolution() {
    if ($47623ef264fc8f38$export$78551043582a6a98() && $47623ef264fc8f38$var$isWebKit616OrNewer() && $47623ef264fc8f38$var$isSafariWebKit()) return undefined;
    return $47623ef264fc8f38$export$f3fa51f8ac20bc2f();
}
/**
 * A version of the entropy source without stabilization.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $47623ef264fc8f38$export$f3fa51f8ac20bc2f() {
    const s = screen;
    // Some browsers return screen resolution as strings, e.g. "1200", instead of a number, e.g. 1200.
    // I suspect it's done by certain plugins that randomize browser properties to prevent fingerprinting.
    // Some browsers even return  screen resolution as not numbers.
    const parseDimension = (value)=>$47623ef264fc8f38$var$replaceNaN($47623ef264fc8f38$var$toInt(value), null);
    const dimensions = [
        parseDimension(s.width),
        parseDimension(s.height)
    ];
    dimensions.sort().reverse();
    return dimensions;
}
const $47623ef264fc8f38$var$screenFrameCheckInterval = 2500;
const $47623ef264fc8f38$var$roundingPrecision = 10;
// The type is readonly to protect from unwanted mutations
let $47623ef264fc8f38$var$screenFrameBackup;
let $47623ef264fc8f38$var$screenFrameSizeTimeoutId;
/**
 * Starts watching the screen frame size. When a non-zero size appears, the size is saved and the watch is stopped.
 * Later, when `getScreenFrame` runs, it will return the saved non-zero size if the current size is null.
 *
 * This trick is required to mitigate the fact that the screen frame turns null in some cases.
 * See more on this at https://github.com/fingerprintjs/fingerprintjs/issues/568
 */ function $47623ef264fc8f38$var$watchScreenFrame() {
    if ($47623ef264fc8f38$var$screenFrameSizeTimeoutId !== undefined) return;
    const checkScreenFrame = ()=>{
        const frameSize = $47623ef264fc8f38$var$getCurrentScreenFrame();
        if ($47623ef264fc8f38$var$isFrameSizeNull(frameSize)) $47623ef264fc8f38$var$screenFrameSizeTimeoutId = setTimeout(checkScreenFrame, $47623ef264fc8f38$var$screenFrameCheckInterval);
        else {
            $47623ef264fc8f38$var$screenFrameBackup = frameSize;
            $47623ef264fc8f38$var$screenFrameSizeTimeoutId = undefined;
        }
    };
    checkScreenFrame();
}
/**
 * A version of the entropy source without stabilization.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $47623ef264fc8f38$export$39dba64e17958038() {
    $47623ef264fc8f38$var$watchScreenFrame();
    return async ()=>{
        let frameSize = $47623ef264fc8f38$var$getCurrentScreenFrame();
        if ($47623ef264fc8f38$var$isFrameSizeNull(frameSize)) {
            if ($47623ef264fc8f38$var$screenFrameBackup) return [
                ...$47623ef264fc8f38$var$screenFrameBackup
            ];
            if ($47623ef264fc8f38$export$a095f8af1f7b5580()) {
                // Some browsers set the screen frame to zero when programmatic fullscreen is on.
                // There is a chance of getting a non-zero frame after exiting the fullscreen.
                // See more on this at https://github.com/fingerprintjs/fingerprintjs/issues/568
                await $47623ef264fc8f38$var$exitFullscreen();
                frameSize = $47623ef264fc8f38$var$getCurrentScreenFrame();
            }
        }
        if (!$47623ef264fc8f38$var$isFrameSizeNull(frameSize)) $47623ef264fc8f38$var$screenFrameBackup = frameSize;
        return frameSize;
    };
}
/**
 * A version of the entropy source with stabilization to make it suitable for static fingerprinting.
 *
 * Sometimes the available screen resolution changes a bit, e.g. 1900x1440 → 1900x1439. A possible reason: macOS Dock
 * shrinks to fit more icons when there is too little space. The rounding is used to mitigate the difference.
 *
 * The frame width is always 0 in the private mode of Safari 17, so the frame is not used in Safari 17.
 * Firefox 143+ spoofs screen frame (ScreenAvailRect) in private browsing and strict ETP mode,
 * so the frame is not used in Firefox 143+.
 *
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1978414 Firefox screen resolution spoofing
 */ function $47623ef264fc8f38$var$getScreenFrame() {
    const isSafari17OrAbove = $47623ef264fc8f38$export$78551043582a6a98() && $47623ef264fc8f38$var$isWebKit616OrNewer() && $47623ef264fc8f38$var$isSafariWebKit();
    const isFirefox143OrAbove = $47623ef264fc8f38$export$1127c7d1b8731973() && $47623ef264fc8f38$var$isGecko143OrNewer();
    if (isSafari17OrAbove || isFirefox143OrAbove) return ()=>Promise.resolve(undefined);
    const screenFrameGetter = $47623ef264fc8f38$export$39dba64e17958038();
    return async ()=>{
        const frameSize = await screenFrameGetter();
        const processSize = (sideSize)=>sideSize === null ? null : $47623ef264fc8f38$var$round(sideSize, $47623ef264fc8f38$var$roundingPrecision);
        // It might look like I don't know about `for` and `map`.
        // In fact, such code is used to avoid TypeScript issues without using `as`.
        return [
            processSize(frameSize[0]),
            processSize(frameSize[1]),
            processSize(frameSize[2]),
            processSize(frameSize[3])
        ];
    };
}
function $47623ef264fc8f38$var$getCurrentScreenFrame() {
    const s = screen;
    // Some browsers return screen resolution as strings, e.g. "1200", instead of a number, e.g. 1200.
    // I suspect it's done by certain plugins that randomize browser properties to prevent fingerprinting.
    //
    // Some browsers (IE, Edge ≤18) don't provide `screen.availLeft` and `screen.availTop`. The property values are
    // replaced with 0 in such cases to not lose the entropy from `screen.availWidth` and `screen.availHeight`.
    return [
        $47623ef264fc8f38$var$replaceNaN($47623ef264fc8f38$var$toFloat(s.availTop), null),
        $47623ef264fc8f38$var$replaceNaN($47623ef264fc8f38$var$toFloat(s.width) - $47623ef264fc8f38$var$toFloat(s.availWidth) - $47623ef264fc8f38$var$replaceNaN($47623ef264fc8f38$var$toFloat(s.availLeft), 0), null),
        $47623ef264fc8f38$var$replaceNaN($47623ef264fc8f38$var$toFloat(s.height) - $47623ef264fc8f38$var$toFloat(s.availHeight) - $47623ef264fc8f38$var$replaceNaN($47623ef264fc8f38$var$toFloat(s.availTop), 0), null),
        $47623ef264fc8f38$var$replaceNaN($47623ef264fc8f38$var$toFloat(s.availLeft), null)
    ];
}
function $47623ef264fc8f38$var$isFrameSizeNull(frameSize) {
    for(let i = 0; i < 4; ++i){
        if (frameSize[i]) return false;
    }
    return true;
}
/**
 * A version of the entropy source with stabilization to make it suitable for static fingerprinting.
 *
 * Firefox 143+ spoofs hardwareConcurrency (NavigatorHWConcurrency) in private browsing and strict ETP mode
 * using tiered values: ≤4 cores -> 4, >4 cores -> 8. We apply the same tiering to stabilize the fingerprint
 * across all browsing modes, since the tiering function is idempotent.
 *
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1978414 Firefox processor count spoofing
 * @see https://searchfox.org/firefox-main/source/dom/workers/RuntimeService.cpp#2057:~:text=if%20(MOZ_UNLIKELY(aRFPTiered))%20%7B
 */ function $47623ef264fc8f38$var$getHardwareConcurrency() {
    const value = $47623ef264fc8f38$export$7af42eab4e60edca();
    if (value !== undefined && $47623ef264fc8f38$export$1127c7d1b8731973() && $47623ef264fc8f38$var$isGecko143OrNewer()) return value >= 8 ? 8 : 4;
    return value;
}
/**
 * A version of the entropy source without stabilization.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $47623ef264fc8f38$export$7af42eab4e60edca() {
    // sometimes hardware concurrency is a string
    return $47623ef264fc8f38$var$replaceNaN($47623ef264fc8f38$var$toInt(navigator.hardwareConcurrency), undefined);
}
function $47623ef264fc8f38$var$getTimezone() {
    var _a;
    const DateTimeFormat = (_a = window.Intl) === null || _a === void 0 ? void 0 : _a.DateTimeFormat;
    if (DateTimeFormat) {
        const timezone = new DateTimeFormat().resolvedOptions().timeZone;
        if (timezone) return timezone;
    }
    // For browsers that don't support timezone names
    // The minus is intentional because the JS offset is opposite to the real offset
    const offset = -$47623ef264fc8f38$var$getTimezoneOffset();
    return `UTC${offset >= 0 ? "+" : ""}${offset}`;
}
function $47623ef264fc8f38$var$getTimezoneOffset() {
    const currentYear = new Date().getFullYear();
    // The timezone offset may change over time due to daylight saving time (DST) shifts.
    // The non-DST timezone offset is used as the result timezone offset.
    // Since the DST season differs in the northern and the southern hemispheres,
    // both January and July timezones offsets are considered.
    return Math.max(// `getTimezoneOffset` returns a number as a string in some unidentified cases
    $47623ef264fc8f38$var$toFloat(new Date(currentYear, 0, 1).getTimezoneOffset()), $47623ef264fc8f38$var$toFloat(new Date(currentYear, 6, 1).getTimezoneOffset()));
}
function $47623ef264fc8f38$var$getSessionStorage() {
    try {
        return !!window.sessionStorage;
    } catch (error) {
        /* SecurityError when referencing it means it exists */ return true;
    }
}
// https://bugzilla.mozilla.org/show_bug.cgi?id=781447
function $47623ef264fc8f38$var$getLocalStorage() {
    try {
        return !!window.localStorage;
    } catch (e) {
        /* SecurityError when referencing it means it exists */ return true;
    }
}
function $47623ef264fc8f38$var$getIndexedDB() {
    // IE and Edge don't allow accessing indexedDB in private mode, therefore IE and Edge will have different
    // visitor identifier in normal and private modes.
    if ($47623ef264fc8f38$export$5aba6d4fec9b366c() || $47623ef264fc8f38$export$13c899a793cdf73d()) return undefined;
    try {
        return !!window.indexedDB;
    } catch (e) {
        /* SecurityError when referencing it means it exists */ return true;
    }
}
function $47623ef264fc8f38$var$getOpenDatabase() {
    return !!window.openDatabase;
}
function $47623ef264fc8f38$var$getCpuClass() {
    return navigator.cpuClass;
}
function $47623ef264fc8f38$var$getPlatform() {
    // Android Chrome 86 and 87 and Android Firefox 80 and 84 don't mock the platform value when desktop mode is requested
    const { platform: platform } = navigator;
    // iOS mocks the platform value when desktop version is requested: https://github.com/fingerprintjs/fingerprintjs/issues/514
    // iPad uses desktop mode by default since iOS 13
    // The value is 'MacIntel' on M1 Macs
    // The value is 'iPhone' on iPod Touch
    if (platform === "MacIntel") {
        if ($47623ef264fc8f38$export$78551043582a6a98() && !$47623ef264fc8f38$export$4949e6bd5097eae9()) return $47623ef264fc8f38$var$isIPad() ? "iPad" : "iPhone";
    }
    return platform;
}
function $47623ef264fc8f38$var$getVendor() {
    return navigator.vendor || "";
}
/**
 * Checks for browser-specific (not engine specific) global variables to tell browsers with the same engine apart.
 * Only somewhat popular browsers are considered.
 */ function $47623ef264fc8f38$var$getVendorFlavors() {
    const flavors = [];
    for (const key of [
        // Blink and some browsers on iOS
        "chrome",
        // Safari on macOS
        "safari",
        // Chrome on iOS (checked in 85 on 13 and 87 on 14)
        "__crWeb",
        "__gCrWeb",
        // Yandex Browser on iOS, macOS and Android (checked in 21.2 on iOS 14, macOS and Android)
        "yandex",
        // Yandex Browser on iOS (checked in 21.2 on 14)
        "__yb",
        "__ybro",
        // Firefox on iOS (checked in 32 on 14)
        "__firefox__",
        // Edge on iOS (checked in 46 on 14)
        "__edgeTrackingPreventionStatistics",
        "webkit",
        // Opera Touch on iOS (checked in 2.6 on 14)
        "oprt",
        // Samsung Internet on Android (checked in 11.1)
        "samsungAr",
        // UC Browser on Android (checked in 12.10 and 13.0)
        "ucweb",
        "UCShellJava",
        // Puffin on Android (checked in 9.0)
        "puffinDevice"
    ]){
        const value = window[key];
        if (value && typeof value === "object") flavors.push(key);
    }
    return flavors.sort();
}
/**
 * navigator.cookieEnabled cannot detect custom or nuanced cookie blocking configurations. For example, when blocking
 * cookies via the Advanced Privacy Settings in IE9, it always returns true. And there have been issues in the past with
 * site-specific exceptions. Don't rely on it.
 *
 * @see https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cookies.js Taken from here
 */ function $47623ef264fc8f38$var$areCookiesEnabled() {
    const d = document;
    // Taken from here: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cookies.js
    // navigator.cookieEnabled cannot detect custom or nuanced cookie blocking configurations. For example, when blocking
    // cookies via the Advanced Privacy Settings in IE9, it always returns true. And there have been issues in the past
    // with site-specific exceptions. Don't rely on it.
    // try..catch because some in situations `document.cookie` is exposed but throws a
    // SecurityError if you try to access it; e.g. documents created from data URIs
    // or in sandboxed iframes (depending on flags/context)
    try {
        // Create cookie
        d.cookie = "cookietest=1; SameSite=Strict;";
        const result = d.cookie.indexOf("cookietest=") !== -1;
        // Delete cookie
        d.cookie = "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT";
        return result;
    } catch (e) {
        return false;
    }
}
/**
 * Only single element selector are supported (no operators like space, +, >, etc).
 * `embed` and `position: fixed;` will be considered as blocked anyway because it always has no offsetParent.
 * Avoid `iframe` and anything with `[src=]` because they produce excess HTTP requests.
 *
 * The "inappropriate" selectors are obfuscated. See https://github.com/fingerprintjs/fingerprintjs/issues/734.
 * A function is used instead of a plain object to help tree-shaking.
 *
 * The function code is generated automatically. See docs/content_blockers.md to learn how to make the list.
 */ function $47623ef264fc8f38$var$getFilters() {
    const fromB64 = atob; // Just for better minification
    return {
        abpIndo: [
            "#Iklan-Melayang",
            "#Kolom-Iklan-728",
            "#SidebarIklan-wrapper",
            '[title="ALIENBOLA" i]',
            fromB64("I0JveC1CYW5uZXItYWRz")
        ],
        abpvn: [
            ".quangcao",
            "#mobileCatfish",
            fromB64("LmNsb3NlLWFkcw=="),
            '[id^="bn_bottom_fixed_"]',
            "#pmadv"
        ],
        adBlockFinland: [
            ".mainostila",
            fromB64("LnNwb25zb3JpdA=="),
            ".ylamainos",
            fromB64("YVtocmVmKj0iL2NsaWNrdGhyZ2guYXNwPyJd"),
            fromB64("YVtocmVmXj0iaHR0cHM6Ly9hcHAucmVhZHBlYWsuY29tL2FkcyJd")
        ],
        adBlockPersian: [
            "#navbar_notice_50",
            ".kadr",
            'TABLE[width="140px"]',
            "#divAgahi",
            fromB64("YVtocmVmXj0iaHR0cDovL2cxLnYuZndtcm0ubmV0L2FkLyJd")
        ],
        adBlockWarningRemoval: [
            "#adblock-honeypot",
            ".adblocker-root",
            ".wp_adblock_detect",
            fromB64("LmhlYWRlci1ibG9ja2VkLWFk"),
            fromB64("I2FkX2Jsb2NrZXI=")
        ],
        adGuardAnnoyances: [
            ".hs-sosyal",
            "#cookieconsentdiv",
            'div[class^="app_gdpr"]',
            ".as-oil",
            '[data-cypress="soft-push-notification-modal"]'
        ],
        adGuardBase: [
            ".BetterJsPopOverlay",
            fromB64("I2FkXzMwMFgyNTA="),
            fromB64("I2Jhbm5lcmZsb2F0MjI="),
            fromB64("I2NhbXBhaWduLWJhbm5lcg=="),
            fromB64("I0FkLUNvbnRlbnQ=")
        ],
        adGuardChinese: [
            fromB64("LlppX2FkX2FfSA=="),
            fromB64("YVtocmVmKj0iLmh0aGJldDM0LmNvbSJd"),
            "#widget-quan",
            fromB64("YVtocmVmKj0iLzg0OTkyMDIwLnh5eiJd"),
            fromB64("YVtocmVmKj0iLjE5NTZobC5jb20vIl0=")
        ],
        adGuardFrench: [
            "#pavePub",
            fromB64("LmFkLWRlc2t0b3AtcmVjdGFuZ2xl"),
            ".mobile_adhesion",
            ".widgetadv",
            fromB64("LmFkc19iYW4=")
        ],
        adGuardGerman: [
            'aside[data-portal-id="leaderboard"]'
        ],
        adGuardJapanese: [
            "#kauli_yad_1",
            fromB64("YVtocmVmXj0iaHR0cDovL2FkMi50cmFmZmljZ2F0ZS5uZXQvIl0="),
            fromB64("Ll9wb3BJbl9pbmZpbml0ZV9hZA=="),
            fromB64("LmFkZ29vZ2xl"),
            fromB64("Ll9faXNib29zdFJldHVybkFk")
        ],
        adGuardMobile: [
            fromB64("YW1wLWF1dG8tYWRz"),
            fromB64("LmFtcF9hZA=="),
            'amp-embed[type="24smi"]',
            "#mgid_iframe1",
            fromB64("I2FkX2ludmlld19hcmVh")
        ],
        adGuardRussian: [
            fromB64("YVtocmVmXj0iaHR0cHM6Ly9hZC5sZXRtZWFkcy5jb20vIl0="),
            fromB64("LnJlY2xhbWE="),
            'div[id^="smi2adblock"]',
            fromB64("ZGl2W2lkXj0iQWRGb3hfYmFubmVyXyJd"),
            "#psyduckpockeball"
        ],
        adGuardSocial: [
            fromB64("YVtocmVmXj0iLy93d3cuc3R1bWJsZXVwb24uY29tL3N1Ym1pdD91cmw9Il0="),
            fromB64("YVtocmVmXj0iLy90ZWxlZ3JhbS5tZS9zaGFyZS91cmw/Il0="),
            ".etsy-tweet",
            "#inlineShare",
            ".popup-social"
        ],
        adGuardSpanishPortuguese: [
            "#barraPublicidade",
            "#Publicidade",
            "#publiEspecial",
            "#queTooltip",
            ".cnt-publi"
        ],
        adGuardTrackingProtection: [
            "#qoo-counter",
            fromB64("YVtocmVmXj0iaHR0cDovL2NsaWNrLmhvdGxvZy5ydS8iXQ=="),
            fromB64("YVtocmVmXj0iaHR0cDovL2hpdGNvdW50ZXIucnUvdG9wL3N0YXQucGhwIl0="),
            fromB64("YVtocmVmXj0iaHR0cDovL3RvcC5tYWlsLnJ1L2p1bXAiXQ=="),
            "#top100counter"
        ],
        adGuardTurkish: [
            "#backkapat",
            fromB64("I3Jla2xhbWk="),
            fromB64("YVtocmVmXj0iaHR0cDovL2Fkc2Vydi5vbnRlay5jb20udHIvIl0="),
            fromB64("YVtocmVmXj0iaHR0cDovL2l6bGVuemkuY29tL2NhbXBhaWduLyJd"),
            fromB64("YVtocmVmXj0iaHR0cDovL3d3dy5pbnN0YWxsYWRzLm5ldC8iXQ==")
        ],
        bulgarian: [
            fromB64("dGQjZnJlZW5ldF90YWJsZV9hZHM="),
            "#ea_intext_div",
            ".lapni-pop-over",
            "#xenium_hot_offers"
        ],
        easyList: [
            ".yb-floorad",
            fromB64("LndpZGdldF9wb19hZHNfd2lkZ2V0"),
            fromB64("LnRyYWZmaWNqdW5reS1hZA=="),
            ".textad_headline",
            fromB64("LnNwb25zb3JlZC10ZXh0LWxpbmtz")
        ],
        easyListChina: [
            fromB64("LmFwcGd1aWRlLXdyYXBbb25jbGljayo9ImJjZWJvcy5jb20iXQ=="),
            fromB64("LmZyb250cGFnZUFkdk0="),
            "#taotaole",
            "#aafoot.top_box",
            ".cfa_popup"
        ],
        easyListCookie: [
            ".ezmob-footer",
            ".cc-CookieWarning",
            "[data-cookie-number]",
            fromB64("LmF3LWNvb2tpZS1iYW5uZXI="),
            ".sygnal24-gdpr-modal-wrap"
        ],
        easyListCzechSlovak: [
            "#onlajny-stickers",
            fromB64("I3Jla2xhbW5pLWJveA=="),
            fromB64("LnJla2xhbWEtbWVnYWJvYXJk"),
            ".sklik",
            fromB64("W2lkXj0ic2tsaWtSZWtsYW1hIl0=")
        ],
        easyListDutch: [
            fromB64("I2FkdmVydGVudGll"),
            fromB64("I3ZpcEFkbWFya3RCYW5uZXJCbG9jaw=="),
            ".adstekst",
            fromB64("YVtocmVmXj0iaHR0cHM6Ly94bHR1YmUubmwvY2xpY2svIl0="),
            "#semilo-lrectangle"
        ],
        easyListGermany: [
            "#SSpotIMPopSlider",
            fromB64("LnNwb25zb3JsaW5rZ3J1ZW4="),
            fromB64("I3dlcmJ1bmdza3k="),
            fromB64("I3Jla2xhbWUtcmVjaHRzLW1pdHRl"),
            fromB64("YVtocmVmXj0iaHR0cHM6Ly9iZDc0Mi5jb20vIl0=")
        ],
        easyListItaly: [
            fromB64("LmJveF9hZHZfYW5udW5jaQ=="),
            ".sb-box-pubbliredazionale",
            fromB64("YVtocmVmXj0iaHR0cDovL2FmZmlsaWF6aW9uaWFkcy5zbmFpLml0LyJd"),
            fromB64("YVtocmVmXj0iaHR0cHM6Ly9hZHNlcnZlci5odG1sLml0LyJd"),
            fromB64("YVtocmVmXj0iaHR0cHM6Ly9hZmZpbGlhemlvbmlhZHMuc25haS5pdC8iXQ==")
        ],
        easyListLithuania: [
            fromB64("LnJla2xhbW9zX3RhcnBhcw=="),
            fromB64("LnJla2xhbW9zX251b3JvZG9z"),
            fromB64("aW1nW2FsdD0iUmVrbGFtaW5pcyBza3lkZWxpcyJd"),
            fromB64("aW1nW2FsdD0iRGVkaWt1b3RpLmx0IHNlcnZlcmlhaSJd"),
            fromB64("aW1nW2FsdD0iSG9zdGluZ2FzIFNlcnZlcmlhaS5sdCJd")
        ],
        estonian: [
            fromB64("QVtocmVmKj0iaHR0cDovL3BheTRyZXN1bHRzMjQuZXUiXQ==")
        ],
        fanboyAnnoyances: [
            "#ac-lre-player",
            ".navigate-to-top",
            "#subscribe_popup",
            ".newsletter_holder",
            "#back-top"
        ],
        fanboyAntiFacebook: [
            ".util-bar-module-firefly-visible"
        ],
        fanboyEnhancedTrackers: [
            ".open.pushModal",
            "#issuem-leaky-paywall-articles-zero-remaining-nag",
            "#sovrn_container",
            'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
            ".BlockNag__Card"
        ],
        fanboySocial: [
            "#FollowUs",
            "#meteored_share",
            "#social_follow",
            ".article-sharer",
            ".community__social-desc"
        ],
        frellwitSwedish: [
            fromB64("YVtocmVmKj0iY2FzaW5vcHJvLnNlIl1bdGFyZ2V0PSJfYmxhbmsiXQ=="),
            fromB64("YVtocmVmKj0iZG9rdG9yLXNlLm9uZWxpbmsubWUiXQ=="),
            "article.category-samarbete",
            fromB64("ZGl2LmhvbGlkQWRz"),
            "ul.adsmodern"
        ],
        greekAdBlock: [
            fromB64("QVtocmVmKj0iYWRtYW4ub3RlbmV0LmdyL2NsaWNrPyJd"),
            fromB64("QVtocmVmKj0iaHR0cDovL2F4aWFiYW5uZXJzLmV4b2R1cy5nci8iXQ=="),
            fromB64("QVtocmVmKj0iaHR0cDovL2ludGVyYWN0aXZlLmZvcnRobmV0LmdyL2NsaWNrPyJd"),
            "DIV.agores300",
            "TABLE.advright"
        ],
        hungarian: [
            "#cemp_doboz",
            ".optimonk-iframe-container",
            fromB64("LmFkX19tYWlu"),
            fromB64("W2NsYXNzKj0iR29vZ2xlQWRzIl0="),
            "#hirdetesek_box"
        ],
        iDontCareAboutCookies: [
            '.alert-info[data-block-track*="CookieNotice"]',
            ".ModuleTemplateCookieIndicator",
            ".o--cookies--container",
            "#cookies-policy-sticky",
            "#stickyCookieBar"
        ],
        icelandicAbp: [
            fromB64("QVtocmVmXj0iL2ZyYW1ld29yay9yZXNvdXJjZXMvZm9ybXMvYWRzLmFzcHgiXQ==")
        ],
        latvian: [
            fromB64("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiAxMjBweDsgaGVpZ2h0OiA0MHB4OyBvdmVyZmxvdzogaGlkZGVuOyBwb3NpdGlvbjogcmVsYXRpdmU7Il0="),
            fromB64("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiA4OHB4OyBoZWlnaHQ6IDMxcHg7IG92ZXJmbG93OiBoaWRkZW47IHBvc2l0aW9uOiByZWxhdGl2ZTsiXQ==")
        ],
        listKr: [
            fromB64("YVtocmVmKj0iLy9hZC5wbGFuYnBsdXMuY28ua3IvIl0="),
            fromB64("I2xpdmVyZUFkV3JhcHBlcg=="),
            fromB64("YVtocmVmKj0iLy9hZHYuaW1hZHJlcC5jby5rci8iXQ=="),
            fromB64("aW5zLmZhc3R2aWV3LWFk"),
            ".revenue_unit_item.dable"
        ],
        listeAr: [
            fromB64("LmdlbWluaUxCMUFk"),
            ".right-and-left-sponsers",
            fromB64("YVtocmVmKj0iLmFmbGFtLmluZm8iXQ=="),
            fromB64("YVtocmVmKj0iYm9vcmFxLm9yZyJd"),
            fromB64("YVtocmVmKj0iZHViaXp6bGUuY29tL2FyLz91dG1fc291cmNlPSJd")
        ],
        listeFr: [
            fromB64("YVtocmVmXj0iaHR0cDovL3Byb21vLnZhZG9yLmNvbS8iXQ=="),
            fromB64("I2FkY29udGFpbmVyX3JlY2hlcmNoZQ=="),
            fromB64("YVtocmVmKj0id2Vib3JhbWEuZnIvZmNnaS1iaW4vIl0="),
            ".site-pub-interstitiel",
            'div[id^="crt-"][data-criteo-id]'
        ],
        officialPolish: [
            "#ceneo-placeholder-ceneo-12",
            fromB64("W2hyZWZePSJodHRwczovL2FmZi5zZW5kaHViLnBsLyJd"),
            fromB64("YVtocmVmXj0iaHR0cDovL2Fkdm1hbmFnZXIudGVjaGZ1bi5wbC9yZWRpcmVjdC8iXQ=="),
            fromB64("YVtocmVmXj0iaHR0cDovL3d3dy50cml6ZXIucGwvP3V0bV9zb3VyY2UiXQ=="),
            fromB64("ZGl2I3NrYXBpZWNfYWQ=")
        ],
        ro: [
            fromB64("YVtocmVmXj0iLy9hZmZ0cmsuYWx0ZXgucm8vQ291bnRlci9DbGljayJd"),
            fromB64("YVtocmVmXj0iaHR0cHM6Ly9ibGFja2ZyaWRheXNhbGVzLnJvL3Ryay9zaG9wLyJd"),
            fromB64("YVtocmVmXj0iaHR0cHM6Ly9ldmVudC4ycGVyZm9ybWFudC5jb20vZXZlbnRzL2NsaWNrIl0="),
            fromB64("YVtocmVmXj0iaHR0cHM6Ly9sLnByb2ZpdHNoYXJlLnJvLyJd"),
            'a[href^="/url/"]'
        ],
        ruAd: [
            fromB64("YVtocmVmKj0iLy9mZWJyYXJlLnJ1LyJd"),
            fromB64("YVtocmVmKj0iLy91dGltZy5ydS8iXQ=="),
            fromB64("YVtocmVmKj0iOi8vY2hpa2lkaWtpLnJ1Il0="),
            "#pgeldiz",
            ".yandex-rtb-block"
        ],
        thaiAds: [
            "a[href*=macau-uta-popup]",
            fromB64("I2Fkcy1nb29nbGUtbWlkZGxlX3JlY3RhbmdsZS1ncm91cA=="),
            fromB64("LmFkczMwMHM="),
            ".bumq",
            ".img-kosana"
        ],
        webAnnoyancesUltralist: [
            "#mod-social-share-2",
            "#social-tools",
            fromB64("LmN0cGwtZnVsbGJhbm5lcg=="),
            ".zergnet-recommend",
            ".yt.btn-link.btn-md.btn"
        ]
    };
}
/**
 * The order of the returned array means nothing (it's always sorted alphabetically).
 *
 * Notice that the source is slightly unstable.
 * Safari provides a 2-taps way to disable all content blockers on a page temporarily.
 * Also content blockers can be disabled permanently for a domain, but it requires 4 taps.
 * So empty array shouldn't be treated as "no blockers", it should be treated as "no signal".
 * If you are a website owner, don't make your visitors want to disable content blockers.
 */ async function $47623ef264fc8f38$var$getDomBlockers({ debug: debug } = {}) {
    if (!$47623ef264fc8f38$var$isApplicable()) return undefined;
    const filters = $47623ef264fc8f38$var$getFilters();
    const filterNames = Object.keys(filters);
    const allSelectors = [].concat(...filterNames.map((filterName)=>filters[filterName]));
    const blockedSelectors = await $47623ef264fc8f38$var$getBlockedSelectors(allSelectors);
    if (debug) $47623ef264fc8f38$var$printDebug(filters, blockedSelectors);
    const activeBlockers = filterNames.filter((filterName)=>{
        const selectors = filters[filterName];
        const blockedCount = $47623ef264fc8f38$var$countTruthy(selectors.map((selector)=>blockedSelectors[selector]));
        return blockedCount > selectors.length * 0.6;
    });
    activeBlockers.sort();
    return activeBlockers;
}
function $47623ef264fc8f38$var$isApplicable() {
    // Safari (desktop and mobile) and all Android browsers keep content blockers in both regular and private mode
    return $47623ef264fc8f38$export$78551043582a6a98() || $47623ef264fc8f38$export$a11b0059900ceec8();
}
async function $47623ef264fc8f38$var$getBlockedSelectors(selectors) {
    var _a;
    const d = document;
    const root = d.createElement("div");
    const elements = new Array(selectors.length);
    const blockedSelectors = {}; // Set() isn't used just in case somebody need older browser support
    $47623ef264fc8f38$var$forceShow(root);
    // First create all elements that can be blocked. If the DOM steps below are done in a single cycle,
    // browser will alternate tree modification and layout reading, that is very slow.
    for(let i = 0; i < selectors.length; ++i){
        const element = $47623ef264fc8f38$var$selectorToElement(selectors[i]);
        if (element.tagName === "DIALOG") element.show();
        const holder = d.createElement("div"); // Protects from unwanted effects of `+` and `~` selectors of filters
        $47623ef264fc8f38$var$forceShow(holder);
        holder.appendChild(element);
        root.appendChild(holder);
        elements[i] = element;
    }
    // document.body can be null while the page is loading
    while(!d.body)await $47623ef264fc8f38$var$wait(50);
    d.body.appendChild(root);
    try {
        // Then check which of the elements are blocked
        for(let i = 0; i < selectors.length; ++i)if (!elements[i].offsetParent) blockedSelectors[selectors[i]] = true;
    } finally{
        // Then remove the elements
        (_a = root.parentNode) === null || _a === void 0 || _a.removeChild(root);
    }
    return blockedSelectors;
}
function $47623ef264fc8f38$var$forceShow(element) {
    element.style.setProperty("visibility", "hidden", "important");
    element.style.setProperty("display", "block", "important");
}
function $47623ef264fc8f38$var$printDebug(filters, blockedSelectors) {
    let message = "DOM blockers debug:\n```";
    for (const filterName of Object.keys(filters)){
        message += `\n${filterName}:`;
        for (const selector of filters[filterName])message += `\n  ${blockedSelectors[selector] ? "\uD83D\uDEAB" : "\u27A1\uFE0F"} ${selector}`;
    }
    // console.log is ok here because it's under a debug clause
    // eslint-disable-next-line no-console
    console.log(`${message}\n\`\`\``);
}
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/color-gamut
 */ function $47623ef264fc8f38$var$getColorGamut() {
    // rec2020 includes p3 and p3 includes srgb
    for (const gamut of [
        "rec2020",
        "p3",
        "srgb"
    ]){
        if (matchMedia(`(color-gamut: ${gamut})`).matches) return gamut;
    }
    return undefined;
}
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/inverted-colors
 */ function $47623ef264fc8f38$var$areColorsInverted() {
    if ($47623ef264fc8f38$var$doesMatch$5("inverted")) return true;
    if ($47623ef264fc8f38$var$doesMatch$5("none")) return false;
    return undefined;
}
function $47623ef264fc8f38$var$doesMatch$5(value) {
    return matchMedia(`(inverted-colors: ${value})`).matches;
}
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/forced-colors
 */ function $47623ef264fc8f38$var$areColorsForced() {
    if ($47623ef264fc8f38$var$doesMatch$4("active")) return true;
    if ($47623ef264fc8f38$var$doesMatch$4("none")) return false;
    return undefined;
}
function $47623ef264fc8f38$var$doesMatch$4(value) {
    return matchMedia(`(forced-colors: ${value})`).matches;
}
const $47623ef264fc8f38$var$maxValueToCheck = 100;
/**
 * If the display is monochrome (e.g. black&white), the value will be ≥0 and will mean the number of bits per pixel.
 * If the display is not monochrome, the returned value will be 0.
 * If the browser doesn't support this feature, the returned value will be undefined.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/monochrome
 */ function $47623ef264fc8f38$var$getMonochromeDepth() {
    if (!matchMedia("(min-monochrome: 0)").matches) // The media feature isn't supported by the browser
    return undefined;
    // A variation of binary search algorithm can be used here.
    // But since expected values are very small (≤10), there is no sense in adding the complexity.
    for(let i = 0; i <= $47623ef264fc8f38$var$maxValueToCheck; ++i){
        if (matchMedia(`(max-monochrome: ${i})`).matches) return i;
    }
    throw new Error("Too high value");
}
/**
 * @see https://www.w3.org/TR/mediaqueries-5/#prefers-contrast
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-contrast
 */ function $47623ef264fc8f38$var$getContrastPreference() {
    if ($47623ef264fc8f38$var$doesMatch$3("no-preference")) return 0 /* ContrastPreference.None */ ;
    // The sources contradict on the keywords. Probably 'high' and 'low' will never be implemented.
    // Need to check it when all browsers implement the feature.
    if ($47623ef264fc8f38$var$doesMatch$3("high") || $47623ef264fc8f38$var$doesMatch$3("more")) return 1 /* ContrastPreference.More */ ;
    if ($47623ef264fc8f38$var$doesMatch$3("low") || $47623ef264fc8f38$var$doesMatch$3("less")) return -1 /* ContrastPreference.Less */ ;
    if ($47623ef264fc8f38$var$doesMatch$3("forced")) return 10 /* ContrastPreference.ForcedColors */ ;
    return undefined;
}
function $47623ef264fc8f38$var$doesMatch$3(value) {
    return matchMedia(`(prefers-contrast: ${value})`).matches;
}
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
 */ function $47623ef264fc8f38$var$isMotionReduced() {
    if ($47623ef264fc8f38$var$doesMatch$2("reduce")) return true;
    if ($47623ef264fc8f38$var$doesMatch$2("no-preference")) return false;
    return undefined;
}
function $47623ef264fc8f38$var$doesMatch$2(value) {
    return matchMedia(`(prefers-reduced-motion: ${value})`).matches;
}
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-transparency
 */ function $47623ef264fc8f38$var$isTransparencyReduced() {
    if ($47623ef264fc8f38$var$doesMatch$1("reduce")) return true;
    if ($47623ef264fc8f38$var$doesMatch$1("no-preference")) return false;
    return undefined;
}
function $47623ef264fc8f38$var$doesMatch$1(value) {
    return matchMedia(`(prefers-reduced-transparency: ${value})`).matches;
}
/**
 * @see https://www.w3.org/TR/mediaqueries-5/#dynamic-range
 */ function $47623ef264fc8f38$var$isHDR() {
    if ($47623ef264fc8f38$var$doesMatch("high")) return true;
    if ($47623ef264fc8f38$var$doesMatch("standard")) return false;
    return undefined;
}
function $47623ef264fc8f38$var$doesMatch(value) {
    return matchMedia(`(dynamic-range: ${value})`).matches;
}
const $47623ef264fc8f38$var$M = Math; // To reduce the minified code size
const $47623ef264fc8f38$var$fallbackFn = ()=>0;
/**
 * @see https://gitlab.torproject.org/legacy/trac/-/issues/13018
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=531915
 */ function $47623ef264fc8f38$var$getMathFingerprint() {
    // Native operations
    const acos = $47623ef264fc8f38$var$M.acos || $47623ef264fc8f38$var$fallbackFn;
    const acosh = $47623ef264fc8f38$var$M.acosh || $47623ef264fc8f38$var$fallbackFn;
    const asin = $47623ef264fc8f38$var$M.asin || $47623ef264fc8f38$var$fallbackFn;
    const asinh = $47623ef264fc8f38$var$M.asinh || $47623ef264fc8f38$var$fallbackFn;
    const atanh = $47623ef264fc8f38$var$M.atanh || $47623ef264fc8f38$var$fallbackFn;
    const atan = $47623ef264fc8f38$var$M.atan || $47623ef264fc8f38$var$fallbackFn;
    const sin = $47623ef264fc8f38$var$M.sin || $47623ef264fc8f38$var$fallbackFn;
    const sinh = $47623ef264fc8f38$var$M.sinh || $47623ef264fc8f38$var$fallbackFn;
    const cos = $47623ef264fc8f38$var$M.cos || $47623ef264fc8f38$var$fallbackFn;
    const cosh = $47623ef264fc8f38$var$M.cosh || $47623ef264fc8f38$var$fallbackFn;
    const tan = $47623ef264fc8f38$var$M.tan || $47623ef264fc8f38$var$fallbackFn;
    const tanh = $47623ef264fc8f38$var$M.tanh || $47623ef264fc8f38$var$fallbackFn;
    const exp = $47623ef264fc8f38$var$M.exp || $47623ef264fc8f38$var$fallbackFn;
    const expm1 = $47623ef264fc8f38$var$M.expm1 || $47623ef264fc8f38$var$fallbackFn;
    const log1p = $47623ef264fc8f38$var$M.log1p || $47623ef264fc8f38$var$fallbackFn;
    // Operation polyfills
    const powPI = (value)=>$47623ef264fc8f38$var$M.pow($47623ef264fc8f38$var$M.PI, value);
    const acoshPf = (value)=>$47623ef264fc8f38$var$M.log(value + $47623ef264fc8f38$var$M.sqrt(value * value - 1));
    const asinhPf = (value)=>$47623ef264fc8f38$var$M.log(value + $47623ef264fc8f38$var$M.sqrt(value * value + 1));
    const atanhPf = (value)=>$47623ef264fc8f38$var$M.log((1 + value) / (1 - value)) / 2;
    const sinhPf = (value)=>$47623ef264fc8f38$var$M.exp(value) - 1 / $47623ef264fc8f38$var$M.exp(value) / 2;
    const coshPf = (value)=>($47623ef264fc8f38$var$M.exp(value) + 1 / $47623ef264fc8f38$var$M.exp(value)) / 2;
    const expm1Pf = (value)=>$47623ef264fc8f38$var$M.exp(value) - 1;
    const tanhPf = (value)=>($47623ef264fc8f38$var$M.exp(2 * value) - 1) / ($47623ef264fc8f38$var$M.exp(2 * value) + 1);
    const log1pPf = (value)=>$47623ef264fc8f38$var$M.log(1 + value);
    // Note: constant values are empirical
    return {
        acos: acos(0.123124234234234242),
        acosh: acosh(1e308),
        acoshPf: acoshPf(1e154),
        asin: asin(0.123124234234234242),
        asinh: asinh(1),
        asinhPf: asinhPf(1),
        atanh: atanh(0.5),
        atanhPf: atanhPf(0.5),
        atan: atan(0.5),
        sin: sin(-1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000),
        sinh: sinh(1),
        sinhPf: sinhPf(1),
        cos: cos(10.000000000123),
        cosh: cosh(1),
        coshPf: coshPf(1),
        tan: tan(-1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000),
        tanh: tanh(1),
        tanhPf: tanhPf(1),
        exp: exp(1),
        expm1: expm1(1),
        expm1Pf: expm1Pf(1),
        log1p: log1p(10),
        log1pPf: log1pPf(10),
        powPI: powPI(-100)
    };
}
/**
 * We use m or w because these two characters take up the maximum width.
 * Also there are a couple of ligatures.
 */ const $47623ef264fc8f38$var$defaultText = "mmMwWLliI0fiflO&1";
/**
 * Settings of text blocks to measure. The keys are random but persistent words.
 */ const $47623ef264fc8f38$var$presets = {
    /**
     * The default font. User can change it in desktop Chrome, desktop Firefox, IE 11,
     * Android Chrome (but only when the size is ≥ than the default) and Android Firefox.
     */ default: [],
    /** OS font on macOS. User can change its size and weight. Applies after Safari restart. */ apple: [
        {
            font: "-apple-system-body"
        }
    ],
    /** User can change it in desktop Chrome and desktop Firefox. */ serif: [
        {
            fontFamily: "serif"
        }
    ],
    /** User can change it in desktop Chrome and desktop Firefox. */ sans: [
        {
            fontFamily: "sans-serif"
        }
    ],
    /** User can change it in desktop Chrome and desktop Firefox. */ mono: [
        {
            fontFamily: "monospace"
        }
    ],
    /**
     * Check the smallest allowed font size. User can change it in desktop Chrome, desktop Firefox and desktop Safari.
     * The height can be 0 in Chrome on a retina display.
     */ min: [
        {
            fontSize: "1px"
        }
    ],
    /** Tells one OS from another in desktop Chrome. */ system: [
        {
            fontFamily: "system-ui"
        }
    ]
};
/**
 * The result is a dictionary of the width of the text samples.
 * Heights aren't included because they give no extra entropy and are unstable.
 *
 * The result is very stable in IE 11, Edge 18 and Safari 14.
 * The result changes when the OS pixel density changes in Chromium 87. The real pixel density is required to solve,
 * but seems like it's impossible: https://stackoverflow.com/q/1713771/1118709.
 * The "min" and the "mono" (only on Windows) value may change when the page is zoomed in Firefox 87.
 */ function $47623ef264fc8f38$var$getFontPreferences() {
    return $47623ef264fc8f38$var$withNaturalFonts((document1, container)=>{
        const elements = {};
        const sizes = {};
        // First create all elements to measure. If the DOM steps below are done in a single cycle,
        // browser will alternate tree modification and layout reading, that is very slow.
        for (const key of Object.keys($47623ef264fc8f38$var$presets)){
            const [style = {}, text = $47623ef264fc8f38$var$defaultText] = $47623ef264fc8f38$var$presets[key];
            const element = document1.createElement("span");
            element.textContent = text;
            element.style.whiteSpace = "nowrap";
            for (const name of Object.keys(style)){
                const value = style[name];
                if (value !== undefined) element.style[name] = value;
            }
            elements[key] = element;
            container.append(document1.createElement("br"), element);
        }
        // Then measure the created elements
        for (const key of Object.keys($47623ef264fc8f38$var$presets))sizes[key] = elements[key].getBoundingClientRect().width;
        return sizes;
    });
}
/**
 * Creates a DOM environment that provides the most natural font available, including Android OS font.
 * Measurements of the elements are zoom-independent.
 * Don't put a content to measure inside an absolutely positioned element.
 */ function $47623ef264fc8f38$var$withNaturalFonts(action, containerWidthPx = 4000) {
    /*
     * Requirements for Android Chrome to apply the system font size to a text inside an iframe:
     * - The iframe mustn't have a `display: none;` style;
     * - The text mustn't be positioned absolutely;
     * - The text block must be wide enough.
     *   2560px on some devices in portrait orientation for the biggest font size option (32px);
     * - There must be much enough text to form a few lines (I don't know the exact numbers);
     * - The text must have the `text-size-adjust: none` style. Otherwise the text will scale in "Desktop site" mode;
     *
     * Requirements for Android Firefox to apply the system font size to a text inside an iframe:
     * - The iframe document must have a header: `<meta name="viewport" content="width=device-width, initial-scale=1" />`.
     *   The only way to set it is to use the `srcdoc` attribute of the iframe;
     * - The iframe content must get loaded before adding extra content with JavaScript;
     *
     * https://example.com as the iframe target always inherits Android font settings so it can be used as a reference.
     *
     * Observations on how page zoom affects the measurements:
     * - macOS Safari 11.1, 12.1, 13.1, 14.0: zoom reset + offsetWidth = 100% reliable;
     * - macOS Safari 11.1, 12.1, 13.1, 14.0: zoom reset + getBoundingClientRect = 100% reliable;
     * - macOS Safari 14.0: offsetWidth = 5% fluctuation;
     * - macOS Safari 14.0: getBoundingClientRect = 5% fluctuation;
     * - iOS Safari 9, 10, 11.0, 12.0: haven't found a way to zoom a page (pinch doesn't change layout);
     * - iOS Safari 13.1, 14.0: zoom reset + offsetWidth = 100% reliable;
     * - iOS Safari 13.1, 14.0: zoom reset + getBoundingClientRect = 100% reliable;
     * - iOS Safari 14.0: offsetWidth = 100% reliable;
     * - iOS Safari 14.0: getBoundingClientRect = 100% reliable;
     * - Chrome 42, 65, 80, 87: zoom 1/devicePixelRatio + offsetWidth = 1px fluctuation;
     * - Chrome 42, 65, 80, 87: zoom 1/devicePixelRatio + getBoundingClientRect = 100% reliable;
     * - Chrome 87: offsetWidth = 1px fluctuation;
     * - Chrome 87: getBoundingClientRect = 0.7px fluctuation;
     * - Firefox 48, 51: offsetWidth = 10% fluctuation;
     * - Firefox 48, 51: getBoundingClientRect = 10% fluctuation;
     * - Firefox 52, 53, 57, 62, 66, 67, 68, 71, 75, 80, 84: offsetWidth = width 100% reliable, height 10% fluctuation;
     * - Firefox 52, 53, 57, 62, 66, 67, 68, 71, 75, 80, 84: getBoundingClientRect = width 100% reliable, height 10%
     *   fluctuation;
     * - Android Chrome 86: haven't found a way to zoom a page (pinch doesn't change layout);
     * - Android Firefox 84: font size in accessibility settings changes all the CSS sizes, but offsetWidth and
     *   getBoundingClientRect keep measuring with regular units, so the size reflects the font size setting and doesn't
     *   fluctuate;
     * - IE 11, Edge 18: zoom 1/devicePixelRatio + offsetWidth = 100% reliable;
     * - IE 11, Edge 18: zoom 1/devicePixelRatio + getBoundingClientRect = reflects the zoom level;
     * - IE 11, Edge 18: offsetWidth = 100% reliable;
     * - IE 11, Edge 18: getBoundingClientRect = 100% reliable;
     */ return $47623ef264fc8f38$export$8b65e2577b8ab46d((_, iframeWindow)=>{
        const iframeDocument = iframeWindow.document;
        const iframeBody = iframeDocument.body;
        const bodyStyle = iframeBody.style;
        bodyStyle.width = `${containerWidthPx}px`;
        bodyStyle.webkitTextSizeAdjust = bodyStyle.textSizeAdjust = "none";
        // See the big comment above
        if ($47623ef264fc8f38$export$dd401a4677e99039()) iframeBody.style.zoom = `${1 / iframeWindow.devicePixelRatio}`;
        else if ($47623ef264fc8f38$export$78551043582a6a98()) iframeBody.style.zoom = "reset";
        // See the big comment above
        const linesOfText = iframeDocument.createElement("div");
        linesOfText.textContent = [
            ...Array(containerWidthPx / 20 << 0)
        ].map(()=>"word").join(" ");
        iframeBody.appendChild(linesOfText);
        return action(iframeDocument, iframeBody);
    }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
}
function $47623ef264fc8f38$var$isPdfViewerEnabled() {
    return navigator.pdfViewerEnabled;
}
/**
 * Unlike most other architectures, on x86/x86-64 when floating-point instructions
 * have no NaN arguments, but produce NaN output, the output NaN has sign bit set.
 * We use it to distinguish x86/x86-64 from other architectures, by doing subtraction
 * of two infinities (must produce NaN per IEEE 754 standard).
 *
 * See https://codebrowser.bddppq.com/pytorch/pytorch/third_party/XNNPACK/src/init.c.html#79
 */ function $47623ef264fc8f38$var$getArchitecture() {
    const f = new Float32Array(1);
    const u8 = new Uint8Array(f.buffer);
    f[0] = Infinity;
    f[0] = f[0] - f[0];
    return u8[3];
}
/**
 * The return type is a union instead of the enum, because it's too challenging to embed the const enum into another
 * project. Turning it into a union is a simple and an elegant solution.
 */ function $47623ef264fc8f38$var$getApplePayState() {
    const { ApplePaySession: ApplePaySession } = window;
    if (typeof (ApplePaySession === null || ApplePaySession === void 0 ? void 0 : ApplePaySession.canMakePayments) !== "function") return -1 /* ApplePayState.NoAPI */ ;
    if ($47623ef264fc8f38$var$willPrintConsoleError()) return -3 /* ApplePayState.NotAvailableInFrame */ ;
    try {
        return ApplePaySession.canMakePayments() ? 1 /* ApplePayState.Enabled */  : 0 /* ApplePayState.Disabled */ ;
    } catch (error) {
        return $47623ef264fc8f38$var$getStateFromError(error);
    }
}
/**
 * Starting from Safari 15 calling `ApplePaySession.canMakePayments()` produces this error message when FingerprintJS
 * runs in an iframe with a cross-origin parent page, and the iframe on that page has no allow="payment *" attribute:
 *   Feature policy 'Payment' check failed for element with origin 'https://example.com' and allow attribute ''.
 * This function checks whether the error message is expected.
 *
 * We check for cross-origin parents, which is prone to false-positive results. Instead, we should check for allowed
 * feature/permission, but we can't because none of these API works in Safari yet:
 *   navigator.permissions.query({ name: ‘payment' })
 *   navigator.permissions.query({ name: ‘payment-handler' })
 *   document.featurePolicy
 */ const $47623ef264fc8f38$var$willPrintConsoleError = $47623ef264fc8f38$var$isAnyParentCrossOrigin;
function $47623ef264fc8f38$var$getStateFromError(error) {
    // See full expected error messages in the test
    if (error instanceof Error && error.name === "InvalidAccessError" && /\bfrom\b.*\binsecure\b/i.test(error.message)) return -2 /* ApplePayState.NotAvailableInInsecureContext */ ;
    throw error;
}
/**
 * Checks whether the Safari's Privacy Preserving Ad Measurement setting is on.
 * The setting is on when the value is not undefined.
 * A.k.a. private click measurement, privacy-preserving ad attribution.
 *
 * Unfortunately, it doesn't work in mobile Safari.
 * Probably, it will start working in mobile Safari or stop working in desktop Safari later.
 * We've found no way to detect the setting state in mobile Safari. Help wanted.
 *
 * @see https://webkit.org/blog/11529/introducing-private-click-measurement-pcm/
 * @see https://developer.apple.com/videos/play/wwdc2021/10033
 */ function $47623ef264fc8f38$var$getPrivateClickMeasurement() {
    var _a;
    const link = document.createElement("a");
    const sourceId = (_a = link.attributionSourceId) !== null && _a !== void 0 ? _a : link.attributionsourceid;
    return sourceId === undefined ? undefined : String(sourceId);
}
/** WebGl context is not available */ const $47623ef264fc8f38$var$STATUS_NO_GL_CONTEXT = -1;
/** WebGL context `getParameter` method is not a function */ const $47623ef264fc8f38$var$STATUS_GET_PARAMETER_NOT_A_FUNCTION = -2;
const $47623ef264fc8f38$var$validContextParameters = new Set([
    10752,
    2849,
    2884,
    2885,
    2886,
    2928,
    2929,
    2930,
    2931,
    2932,
    2960,
    2961,
    2962,
    2963,
    2964,
    2965,
    2966,
    2967,
    2968,
    2978,
    3024,
    3042,
    3088,
    3089,
    3106,
    3107,
    32773,
    32777,
    32777,
    32823,
    32824,
    32936,
    32937,
    32938,
    32939,
    32968,
    32969,
    32970,
    32971,
    3317,
    33170,
    3333,
    3379,
    3386,
    33901,
    33902,
    34016,
    34024,
    34076,
    3408,
    3410,
    3411,
    3412,
    3413,
    3414,
    3415,
    34467,
    34816,
    34817,
    34818,
    34819,
    34877,
    34921,
    34930,
    35660,
    35661,
    35724,
    35738,
    35739,
    36003,
    36004,
    36005,
    36347,
    36348,
    36349,
    37440,
    37441,
    37443,
    7936,
    7937,
    7938
]);
const $47623ef264fc8f38$var$validExtensionParams = new Set([
    34047,
    35723,
    36063,
    34852,
    34853,
    34854,
    34229,
    36392,
    36795,
    38449
]);
const $47623ef264fc8f38$var$shaderTypes = [
    "FRAGMENT_SHADER",
    "VERTEX_SHADER"
];
const $47623ef264fc8f38$var$precisionTypes = [
    "LOW_FLOAT",
    "MEDIUM_FLOAT",
    "HIGH_FLOAT",
    "LOW_INT",
    "MEDIUM_INT",
    "HIGH_INT"
];
const $47623ef264fc8f38$var$rendererInfoExtensionName = "WEBGL_debug_renderer_info";
const $47623ef264fc8f38$var$polygonModeExtensionName = "WEBGL_polygon_mode";
/**
 * Gets the basic and simple WebGL parameters
 */ function $47623ef264fc8f38$var$getWebGlBasics({ cache: cache }) {
    var _a, _b, _c, _d, _e, _f;
    const gl = $47623ef264fc8f38$export$c7a808a518b9a146(cache);
    if (!gl) return $47623ef264fc8f38$var$STATUS_NO_GL_CONTEXT;
    if (!$47623ef264fc8f38$var$isValidParameterGetter(gl)) return $47623ef264fc8f38$var$STATUS_GET_PARAMETER_NOT_A_FUNCTION;
    const debugExtension = $47623ef264fc8f38$var$shouldAvoidDebugRendererInfo() ? null : gl.getExtension($47623ef264fc8f38$var$rendererInfoExtensionName);
    return {
        version: ((_a = gl.getParameter(gl.VERSION)) === null || _a === void 0 ? void 0 : _a.toString()) || "",
        vendor: ((_b = gl.getParameter(gl.VENDOR)) === null || _b === void 0 ? void 0 : _b.toString()) || "",
        vendorUnmasked: debugExtension ? (_c = gl.getParameter(debugExtension.UNMASKED_VENDOR_WEBGL)) === null || _c === void 0 ? void 0 : _c.toString() : "",
        renderer: ((_d = gl.getParameter(gl.RENDERER)) === null || _d === void 0 ? void 0 : _d.toString()) || "",
        rendererUnmasked: debugExtension ? (_e = gl.getParameter(debugExtension.UNMASKED_RENDERER_WEBGL)) === null || _e === void 0 ? void 0 : _e.toString() : "",
        shadingLanguageVersion: ((_f = gl.getParameter(gl.SHADING_LANGUAGE_VERSION)) === null || _f === void 0 ? void 0 : _f.toString()) || ""
    };
}
/**
 * Gets the advanced and massive WebGL parameters and extensions
 */ function $47623ef264fc8f38$var$getWebGlExtensions({ cache: cache }) {
    const gl = $47623ef264fc8f38$export$c7a808a518b9a146(cache);
    if (!gl) return $47623ef264fc8f38$var$STATUS_NO_GL_CONTEXT;
    if (!$47623ef264fc8f38$var$isValidParameterGetter(gl)) return $47623ef264fc8f38$var$STATUS_GET_PARAMETER_NOT_A_FUNCTION;
    const extensions = gl.getSupportedExtensions();
    const contextAttributes = gl.getContextAttributes();
    const unsupportedExtensions = [];
    // Features
    const attributes = [];
    const parameters = [];
    const extensionParameters = [];
    const shaderPrecisions = [];
    // Context attributes
    if (contextAttributes) for (const attributeName of Object.keys(contextAttributes))attributes.push(`${attributeName}=${contextAttributes[attributeName]}`);
    // Context parameters
    const constants = $47623ef264fc8f38$var$getConstantsFromPrototype(gl);
    for (const constant of constants){
        const code = gl[constant];
        parameters.push(`${constant}=${code}${$47623ef264fc8f38$var$validContextParameters.has(code) ? `=${gl.getParameter(code)}` : ""}`);
    }
    // Extension parameters
    if (extensions) for (const name of extensions){
        if (name === $47623ef264fc8f38$var$rendererInfoExtensionName && $47623ef264fc8f38$var$shouldAvoidDebugRendererInfo() || name === $47623ef264fc8f38$var$polygonModeExtensionName && $47623ef264fc8f38$var$shouldAvoidPolygonModeExtensions()) continue;
        const extension = gl.getExtension(name);
        if (!extension) {
            unsupportedExtensions.push(name);
            continue;
        }
        for (const constant of $47623ef264fc8f38$var$getConstantsFromPrototype(extension)){
            const code = extension[constant];
            extensionParameters.push(`${constant}=${code}${$47623ef264fc8f38$var$validExtensionParams.has(code) ? `=${gl.getParameter(code)}` : ""}`);
        }
    }
    // Shader precision
    for (const shaderType of $47623ef264fc8f38$var$shaderTypes)for (const precisionType of $47623ef264fc8f38$var$precisionTypes){
        const shaderPrecision = $47623ef264fc8f38$var$getShaderPrecision(gl, shaderType, precisionType);
        shaderPrecisions.push(`${shaderType}.${precisionType}=${shaderPrecision.join(",")}`);
    }
    // Postprocess
    extensionParameters.sort();
    parameters.sort();
    return {
        contextAttributes: attributes,
        parameters: parameters,
        shaderPrecisions: shaderPrecisions,
        extensions: extensions,
        extensionParameters: extensionParameters,
        unsupportedExtensions: unsupportedExtensions
    };
}
/**
 * This function usually takes the most time to execute in all the sources, therefore we cache its result.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */ function $47623ef264fc8f38$export$c7a808a518b9a146(cache) {
    if (cache.webgl) return cache.webgl.context;
    const canvas = document.createElement("canvas");
    let context;
    canvas.addEventListener("webglCreateContextError", ()=>context = undefined);
    for (const type of [
        "webgl",
        "experimental-webgl"
    ]){
        try {
            context = canvas.getContext(type);
        } catch (_a) {
        // Ok, continue
        }
        if (context) break;
    }
    cache.webgl = {
        context: context
    };
    return context;
}
/**
 * https://developer.mozilla.org/en-US/docs/Web/API/WebGLShaderPrecisionFormat
 * https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/getShaderPrecisionFormat
 * https://www.khronos.org/registry/webgl/specs/latest/1.0/#5.12
 */ function $47623ef264fc8f38$var$getShaderPrecision(gl, shaderType, precisionType) {
    const shaderPrecision = gl.getShaderPrecisionFormat(gl[shaderType], gl[precisionType]);
    return shaderPrecision ? [
        shaderPrecision.rangeMin,
        shaderPrecision.rangeMax,
        shaderPrecision.precision
    ] : [];
}
function $47623ef264fc8f38$var$getConstantsFromPrototype(obj) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const keys = Object.keys(obj.__proto__);
    return keys.filter($47623ef264fc8f38$var$isConstantLike);
}
function $47623ef264fc8f38$var$isConstantLike(key) {
    return typeof key === "string" && !key.match(/[^A-Z0-9_x]/);
}
/**
 * Some browsers print a console warning when the WEBGL_debug_renderer_info extension is requested.
 * JS Agent aims to avoid printing messages to console, so we avoid this extension in that browsers.
 */ function $47623ef264fc8f38$var$shouldAvoidDebugRendererInfo() {
    return $47623ef264fc8f38$export$1127c7d1b8731973();
}
/**
 * Some browsers print a console warning when the WEBGL_polygon_mode extension is requested.
 * JS Agent aims to avoid printing messages to console, so we avoid this extension in that browsers.
 */ function $47623ef264fc8f38$var$shouldAvoidPolygonModeExtensions() {
    return $47623ef264fc8f38$export$dd401a4677e99039() || $47623ef264fc8f38$export$78551043582a6a98();
}
/**
 * Some unknown browsers have no `getParameter` method
 */ function $47623ef264fc8f38$var$isValidParameterGetter(gl) {
    return typeof gl.getParameter === "function";
}
function $47623ef264fc8f38$var$getAudioContextBaseLatency() {
    // The signal emits warning in Chrome and Firefox, therefore it is enabled on Safari where it doesn't produce warning
    // and on Android where it's less visible
    const isAllowedPlatform = $47623ef264fc8f38$export$a11b0059900ceec8() || $47623ef264fc8f38$export$78551043582a6a98();
    if (!isAllowedPlatform) return -2 /* SpecialFingerprint.Disabled */ ;
    if (!window.AudioContext) return -1 /* SpecialFingerprint.NotSupported */ ;
    const latency = new AudioContext().baseLatency;
    if (latency === null || latency === undefined) return -1 /* SpecialFingerprint.NotSupported */ ;
    if (!isFinite(latency)) return -3 /* SpecialFingerprint.NotFinite */ ;
    return latency;
}
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/resolvedOptions
 *
 * The return type is a union instead of a const enum due to the difficulty of embedding const enums in other projects.
 * This makes integration simpler and more elegant.
 */ function $47623ef264fc8f38$var$getDateTimeLocale() {
    if (!window.Intl) return -1 /* Status.IntlAPINotSupported */ ;
    const DateTimeFormat = window.Intl.DateTimeFormat;
    if (!DateTimeFormat) return -2 /* Status.DateTimeFormatNotSupported */ ;
    const locale = DateTimeFormat().resolvedOptions().locale;
    if (!locale && locale !== "") return -3 /* Status.LocaleNotAvailable */ ;
    return locale;
}
/**
 * The list of entropy sources used to make visitor identifiers.
 *
 * This value isn't restricted by Semantic Versioning, i.e. it may be changed without bumping minor or major version of
 * this package.
 *
 * Note: Rollup and Webpack are smart enough to remove unused properties of this object during tree-shaking, so there is
 * no need to export the sources individually.
 */ const $47623ef264fc8f38$export$d1d41f0cda037248 = {
    // READ FIRST:
    // See https://github.com/fingerprintjs/fingerprintjs/blob/master/contributing.md#how-to-add-an-entropy-source
    // to learn how entropy source works and how to make your own.
    // The sources run in this exact order.
    // The asynchronous sources are at the start to run in parallel with other sources.
    fonts: $47623ef264fc8f38$var$getFonts,
    domBlockers: $47623ef264fc8f38$var$getDomBlockers,
    fontPreferences: $47623ef264fc8f38$var$getFontPreferences,
    audio: $47623ef264fc8f38$var$getAudioFingerprint,
    screenFrame: $47623ef264fc8f38$var$getScreenFrame,
    canvas: $47623ef264fc8f38$var$getCanvasFingerprint,
    osCpu: $47623ef264fc8f38$var$getOsCpu,
    languages: $47623ef264fc8f38$var$getLanguages,
    colorDepth: $47623ef264fc8f38$var$getColorDepth,
    deviceMemory: $47623ef264fc8f38$var$getDeviceMemory,
    screenResolution: $47623ef264fc8f38$var$getScreenResolution,
    hardwareConcurrency: $47623ef264fc8f38$var$getHardwareConcurrency,
    timezone: $47623ef264fc8f38$var$getTimezone,
    sessionStorage: $47623ef264fc8f38$var$getSessionStorage,
    localStorage: $47623ef264fc8f38$var$getLocalStorage,
    indexedDB: $47623ef264fc8f38$var$getIndexedDB,
    openDatabase: $47623ef264fc8f38$var$getOpenDatabase,
    cpuClass: $47623ef264fc8f38$var$getCpuClass,
    platform: $47623ef264fc8f38$var$getPlatform,
    plugins: $47623ef264fc8f38$var$getPlugins,
    touchSupport: $47623ef264fc8f38$var$getTouchSupport,
    vendor: $47623ef264fc8f38$var$getVendor,
    vendorFlavors: $47623ef264fc8f38$var$getVendorFlavors,
    cookiesEnabled: $47623ef264fc8f38$var$areCookiesEnabled,
    colorGamut: $47623ef264fc8f38$var$getColorGamut,
    invertedColors: $47623ef264fc8f38$var$areColorsInverted,
    forcedColors: $47623ef264fc8f38$var$areColorsForced,
    monochrome: $47623ef264fc8f38$var$getMonochromeDepth,
    contrast: $47623ef264fc8f38$var$getContrastPreference,
    reducedMotion: $47623ef264fc8f38$var$isMotionReduced,
    reducedTransparency: $47623ef264fc8f38$var$isTransparencyReduced,
    hdr: $47623ef264fc8f38$var$isHDR,
    math: $47623ef264fc8f38$var$getMathFingerprint,
    pdfViewerEnabled: $47623ef264fc8f38$var$isPdfViewerEnabled,
    architecture: $47623ef264fc8f38$var$getArchitecture,
    applePay: $47623ef264fc8f38$var$getApplePayState,
    privateClickMeasurement: $47623ef264fc8f38$var$getPrivateClickMeasurement,
    audioBaseLatency: $47623ef264fc8f38$var$getAudioContextBaseLatency,
    dateTimeLocale: $47623ef264fc8f38$var$getDateTimeLocale,
    // Some sources can affect other sources (e.g. WebGL can affect canvas), so it's important to run these sources
    // after other sources.
    webGlBasics: $47623ef264fc8f38$var$getWebGlBasics,
    webGlExtensions: $47623ef264fc8f38$var$getWebGlExtensions
};
/**
 * Loads the built-in entropy sources.
 * Returns a function that collects the entropy components to make the visitor identifier.
 */ function $47623ef264fc8f38$var$loadBuiltinSources(options) {
    return $47623ef264fc8f38$export$3c5f4c9f15eeb5cb($47623ef264fc8f38$export$d1d41f0cda037248, options, []);
}
const $47623ef264fc8f38$var$commentTemplate = "$ if upgrade to Pro: https://fingerprint.com/github/?utm_source=oss&utm_medium=referral&utm_campaign=confidence_score";
function $47623ef264fc8f38$var$getConfidence(components) {
    const openConfidenceScore = $47623ef264fc8f38$var$getOpenConfidenceScore(components);
    const proConfidenceScore = $47623ef264fc8f38$var$deriveProConfidenceScore(openConfidenceScore);
    return {
        score: openConfidenceScore,
        comment: $47623ef264fc8f38$var$commentTemplate.replace(/\$/g, `${proConfidenceScore}`)
    };
}
function $47623ef264fc8f38$var$getOpenConfidenceScore(components) {
    // In order to calculate the true probability of the visitor identifier being correct, we need to know the number of
    // website visitors (the higher the number, the less the probability because the fingerprint entropy is limited).
    // JS agent doesn't know the number of visitors, so we can only do an approximate assessment.
    if ($47623ef264fc8f38$export$a11b0059900ceec8()) return 0.4;
    // Safari (mobile and desktop)
    if ($47623ef264fc8f38$export$78551043582a6a98()) return $47623ef264fc8f38$export$4949e6bd5097eae9() && !($47623ef264fc8f38$var$isWebKit616OrNewer() && $47623ef264fc8f38$var$isSafariWebKit()) ? 0.5 : 0.3;
    const platform = "value" in components.platform ? components.platform.value : "";
    // Windows
    if (/^Win/.test(platform)) // The score is greater than on macOS because of the higher variety of devices running Windows.
    // Chrome provides more entropy than Firefox according too
    // https://netmarketshare.com/browser-market-share.aspx?options=%7B%22filter%22%3A%7B%22%24and%22%3A%5B%7B%22platform%22%3A%7B%22%24in%22%3A%5B%22Windows%22%5D%7D%7D%5D%7D%2C%22dateLabel%22%3A%22Trend%22%2C%22attributes%22%3A%22share%22%2C%22group%22%3A%22browser%22%2C%22sort%22%3A%7B%22share%22%3A-1%7D%2C%22id%22%3A%22browsersDesktop%22%2C%22dateInterval%22%3A%22Monthly%22%2C%22dateStart%22%3A%222019-11%22%2C%22dateEnd%22%3A%222020-10%22%2C%22segments%22%3A%22-1000%22%7D
    // So we assign the same score to them.
    return 0.6;
    // macOS
    if (/^Mac/.test(platform)) // Chrome provides more entropy than Safari and Safari provides more entropy than Firefox.
    // Chrome is more popular than Safari and Safari is more popular than Firefox according to
    // https://netmarketshare.com/browser-market-share.aspx?options=%7B%22filter%22%3A%7B%22%24and%22%3A%5B%7B%22platform%22%3A%7B%22%24in%22%3A%5B%22Mac%20OS%22%5D%7D%7D%5D%7D%2C%22dateLabel%22%3A%22Trend%22%2C%22attributes%22%3A%22share%22%2C%22group%22%3A%22browser%22%2C%22sort%22%3A%7B%22share%22%3A-1%7D%2C%22id%22%3A%22browsersDesktop%22%2C%22dateInterval%22%3A%22Monthly%22%2C%22dateStart%22%3A%222019-11%22%2C%22dateEnd%22%3A%222020-10%22%2C%22segments%22%3A%22-1000%22%7D
    // So we assign the same score to them.
    return 0.5;
    // Another platform, e.g. a desktop Linux. It's rare, so it should be pretty unique.
    return 0.7;
}
function $47623ef264fc8f38$var$deriveProConfidenceScore(openConfidenceScore) {
    return $47623ef264fc8f38$var$round(0.99 + 0.01 * openConfidenceScore, 0.0001);
}
function $47623ef264fc8f38$var$componentsToCanonicalString(components) {
    let result = "";
    for (const componentKey of Object.keys(components).sort()){
        const component = components[componentKey];
        const value = "error" in component ? "error" : JSON.stringify(component.value);
        result += `${result ? "|" : ""}${componentKey.replace(/([:|\\])/g, "\\$1")}:${value}`;
    }
    return result;
}
function $47623ef264fc8f38$export$6344a95760e963e3(components) {
    return JSON.stringify(components, (_key, value)=>{
        if (value instanceof Error) return $47623ef264fc8f38$var$errorToObject(value);
        return value;
    }, 2);
}
function $47623ef264fc8f38$export$2f0bdfb2bbf78138(components) {
    return $47623ef264fc8f38$var$x64hash128($47623ef264fc8f38$var$componentsToCanonicalString(components));
}
/**
 * Makes a GetResult implementation that calculates the visitor id hash on demand.
 * Designed for optimisation.
 */ function $47623ef264fc8f38$var$makeLazyGetResult(components) {
    let visitorIdCache;
    // This function runs very fast, so there is no need to make it lazy
    const confidence = $47623ef264fc8f38$var$getConfidence(components);
    // A plain class isn't used because its getters and setters aren't enumerable.
    return {
        get visitorId () {
            if (visitorIdCache === undefined) visitorIdCache = $47623ef264fc8f38$export$2f0bdfb2bbf78138(this.components);
            return visitorIdCache;
        },
        set visitorId (visitorId){
            visitorIdCache = visitorId;
        },
        confidence: confidence,
        components: components,
        version: $47623ef264fc8f38$var$version
    };
}
/**
 * A delay is required to ensure consistent entropy components.
 * See https://github.com/fingerprintjs/fingerprintjs/issues/254
 * and https://github.com/fingerprintjs/fingerprintjs/issues/307
 * and https://github.com/fingerprintjs/fingerprintjs/commit/945633e7c5f67ae38eb0fea37349712f0e669b18
 */ function $47623ef264fc8f38$export$cbc1b2f4f14b19e1(delayFallback = 50) {
    // A proper deadline is unknown. Let it be twice the fallback timeout so that both cases have the same average time.
    return $47623ef264fc8f38$var$requestIdleCallbackIfAvailable(delayFallback, delayFallback * 2);
}
/**
 * The function isn't exported from the index file to not allow to call it without `load()`.
 * The hiding gives more freedom for future non-breaking updates.
 *
 * A factory function is used instead of a class to shorten the attribute names in the minified code.
 * Native private class fields could've been used, but TypeScript doesn't allow them with `"target": "es5"`.
 */ function $47623ef264fc8f38$var$makeAgent(getComponents, debug) {
    const creationTime = Date.now();
    return {
        async get (options) {
            const startTime = Date.now();
            const components = await getComponents();
            const result = $47623ef264fc8f38$var$makeLazyGetResult(components);
            if (debug || (options === null || options === void 0 ? void 0 : options.debug)) // console.log is ok here because it's under a debug clause
            // eslint-disable-next-line no-console
            console.log(`Copy the text below to get the debug data:

\`\`\`
version: ${result.version}
userAgent: ${navigator.userAgent}
timeBetweenLoadAndGet: ${startTime - creationTime}
visitorId: ${result.visitorId}
components: ${$47623ef264fc8f38$export$6344a95760e963e3(components)}
\`\`\``);
            return result;
        }
    };
}
/**
 * Sends an unpersonalized AJAX request to collect installation statistics
 */ function $47623ef264fc8f38$var$monitor() {
    // The FingerprintJS CDN (https://github.com/fingerprintjs/cdn) replaces `window.__fpjs_d_m` with `true`
    if (window.__fpjs_d_m || Math.random() >= 0.001) return;
    try {
        const request = new XMLHttpRequest();
        request.open("get", `https://m1.openfpcdn.io/fingerprintjs/v${$47623ef264fc8f38$var$version}/npm-monitoring`, true);
        request.send();
    } catch (error) {
        // console.error is ok here because it's an unexpected error handler
        // eslint-disable-next-line no-console
        console.error(error);
    }
}
/**
 * Builds an instance of Agent and waits a delay required for a proper operation.
 */ async function $47623ef264fc8f38$export$11e63f7b0f3d9900(options = {}) {
    const { delayFallback: delayFallback, debug: debug, monitoring: monitoring = true } = options;
    if (monitoring) $47623ef264fc8f38$var$monitor();
    await $47623ef264fc8f38$export$cbc1b2f4f14b19e1(delayFallback);
    const getComponents = $47623ef264fc8f38$var$loadBuiltinSources({
        cache: {},
        debug: debug
    });
    return $47623ef264fc8f38$var$makeAgent(getComponents, debug);
}
// The default export is a syntax sugar (`import * as FP from '...' → import FP from '...'`).
// It should contain all the public exported values.
var $47623ef264fc8f38$export$2e2bcd8739ae039 = {
    load: $47623ef264fc8f38$export$11e63f7b0f3d9900,
    hashComponents: $47623ef264fc8f38$export$2f0bdfb2bbf78138,
    componentsToDebugString: $47623ef264fc8f38$export$6344a95760e963e3
};
// The exports below are for private usage. They may change unexpectedly. Use them at your own risk.
/** Not documented, out of Semantic Versioning, usage is at your own risk */ const $47623ef264fc8f38$export$bdcc90ce86afeb19 = $47623ef264fc8f38$var$x64hash128;


function $8af293242d7144a6$var$AuthForm() {
    const { register: register, handleSubmit: handleSubmit, watch: watch, formState: { errors: errors }, formState: formState, setValue: setValue, getValues: getValues } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            email: "",
            password: ""
        }
    });
    const [delayAuth, setDelayAuth] = (0, $bh6RR.useState)(true);
    const [delayPasswordForgotten, setDelayDelayPasswordForgotten] = (0, $bh6RR.useState)(true);
    const { updatePassword: updatePassword } = (0, $c3f355fefa80bd40$export$2e2bcd8739ae039);
    const authDispatchContext = (0, $373f9505ebba8636$export$a03a56d03840936f)();
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const naviguate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const onSubmit = async (data)=>{
        data.device_fingerprint = fingerprint;
        const result = await (0, $84ea3ff01b4cb54c$export$2e2bcd8739ae039).signIn(authDispatchContext, data);
        if (delayAuth == false) return;
        if (result?.error && result.message == "Renew Password") {
            toast.error("Password Renewed", "Your last login was more than 6 months ago. A new password has been sent to your email.", 8000);
            return;
        } else if (result?.error && result.message == "New device") {
            toast.error("New device detected", "Verification email sent to your email address.", 8000);
            return;
        }
        // Case 2: Other login failure
        if (result?.error) {
            setDelayAuth(false);
            toast.error("Authentication Error", "Your login information does not match any of our users", 8000);
            setTimeout(()=>setDelayAuth(true), 4000);
            return;
        }
        toast.success("Authentification Success", "Congratulations you are now logged to the application");
        setTimeout(()=>naviguate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("home")), 250);
    };
    const changePassword = async ()=>{
        if (delayPasswordForgotten == false) return;
        let dataToSend = {
            email: getValues("email_password_change")
        };
        let mess = "Perfect ! You will receive an email with a new temporary password if the email given exist";
        const [result, error] = await updatePassword(dataToSend);
        toast.success("Password Edit", mess);
        setDelayDelayPasswordForgotten(false);
        setTimeout(()=>setDelayDelayPasswordForgotten(true), 4000);
    };
    const [activeSession, setActiveSession] = (0, $bh6RR.useState)(false);
    const [readCgu, setReadCgu] = (0, $bh6RR.useState)(true);
    const [fingerprint, setFingerprint] = (0, $bh6RR.useState)("");
    (0, $bh6RR.useEffect)(()=>{
        const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        if (!isChrome) toast.info("Browser Information", "For the best experience, please use Google Chrome.", 10000);
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        (0, $47623ef264fc8f38$export$2e2bcd8739ae039).load().then((fp)=>{
            fp.get().then((result)=>{
                setFingerprint(result.visitorId); // device ID
                setValue("device_fingerprint", result.visitorId); // attach to react-hook-form
            });
        });
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
        className: "login",
        onSubmit: handleSubmit(onSubmit),
        onClick: ()=>{
            this.disabled = true;
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($78ca27eb74d4b0fa$exports))),
                        alt: "",
                        className: "logo"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                        href: "https://www.talkr.ai/tester-la-solution-gratuitement-demande-dacces",
                        target: "_blank",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                            label: "Start free trial"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                className: "body-reseize",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $51a8b46ec4198ef9$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                            name: "login",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                                    style: {
                                        marginTop: 0
                                    },
                                    children: "Connexion"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "login-part",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                            type: "hidden",
                                            ...register("device_fingerprint"),
                                            value: fingerprint
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Email",
                                            listLabelClassName: "titles-input",
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                                ...register("email", {
                                                    required: true,
                                                    pattern: /^\S+@\S+$/i
                                                }),
                                                style: errors.email ? {
                                                    borderColor: "red"
                                                } : {}
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Password",
                                            listLabelClassName: "titles-input",
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                                type: "password",
                                                ...register("password", {
                                                    required: true
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                            style: {
                                                display: "flex"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                    label: "Keep an active session",
                                                    listClassName: "read_cgu_container",
                                                    listLabelClassName: "read_cgu_label title-weigth",
                                                    children: " "
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $52b728934d836302$export$2e2bcd8739ae039), {
                                                        id: "session_active",
                                                        name: "session_active",
                                                        setValue: (name, checked)=>setActiveSession(!checked),
                                                        check: true
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                            style: {
                                                display: "flex"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                    label: "Accept CGU ",
                                                    listClassName: "read_cgu_container",
                                                    listLabelClassName: "read_cgu_label title-weigth",
                                                    children: " "
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $52b728934d836302$export$2e2bcd8739ae039), {
                                                    id: "gcu_button",
                                                    name: "gcu_button",
                                                    setValue: (name, checked)=>{
                                                        setReadCgu(checked);
                                                    },
                                                    check: true
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                    type: "submit",
                                    label: "Login",
                                    className: "validate full-width",
                                    disabled: formState.isValid == true && delayAuth == true && readCgu == true ? false : true
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "switch-section-container",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                        className: "switch-section-text",
                                        onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("password-forgotten"),
                                        children: "Password Forgotten ?"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                            name: "password-forgotten",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                                    className: "ivy-h1",
                                    children: "Password Forgotten"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "change-password-form",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                        label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            children: "Email"
                                        }),
                                        listLabelClassName: "titles-input",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("email_password_change", {
                                                pattern: /^\S+@\S+$/i
                                            }),
                                            style: errors.email_password_change ? {
                                                borderColor: "red"
                                            } : {}
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                    label: "Ask new password",
                                    onClick: ()=>changePassword(),
                                    className: "validate full-width",
                                    id: "change-password-button",
                                    disabled: watch("email_password_change")?.length >= 3 && errors.email_password_change == null && delayPasswordForgotten == true ? false : true
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "switch-section-container",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                        className: "switch-section-text",
                                        onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("login"),
                                        children: "Back"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                    href: "https://www.talkr.ai/rgpd/",
                    target: "_blank",
                    style: {
                        color: "var(--main)"
                    },
                    children: "Legal information"
                })
            })
        ]
    });
}
var $8af293242d7144a6$export$2e2bcd8739ae039 = $8af293242d7144a6$var$AuthForm;




function $f0b4ce138eba82f2$var$loginPage() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "page default",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8af293242d7144a6$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "quote-part",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f0aded74899c8465$export$2e2bcd8739ae039), {
                    fontSize: "50",
                    fontColor: "white"
                })
            })
        ]
    });
}
var $f0b4ce138eba82f2$export$2e2bcd8739ae039 = $f0b4ce138eba82f2$var$loginPage;




parcelRequire("bh6RR");



function $03dabf588c007c9b$var$AuthFormEdf() {
    const handleSsoClick = ()=>{
        const apiUrl = (0, $651df53b10514175$export$a7b6bc01c63cdfc3).REACT_APP_API_PATH || "http://localhost:8000";
        const baseUrl = apiUrl.replace("/api/v1", "");
        window.location.href = `${baseUrl}/login-sso-edf`;
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "edf-sso-container",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "edf-sso-header",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($78ca27eb74d4b0fa$exports))),
                        alt: "Talkr Logo",
                        className: "edf-sso-logo"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                        className: "edf-sso-title",
                        children: "Connexion EDF"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                        className: "edf-sso-subtitle",
                        children: "Authentification s\xe9curis\xe9e via GARDIAN-WebSSO"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "edf-sso-content",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                        className: "edf-sso-button",
                        onClick: handleSsoClick,
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                className: "edf-sso-button-icon"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                className: "edf-sso-button-text",
                                children: "Se connecter avec Gardian"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                        className: "edf-sso-info",
                        children: "Vous serez redirig\xe9 vers la page d'authentification s\xe9curis\xe9e EDF (GARDIAN)."
                    })
                ]
            })
        ]
    });
}
var $03dabf588c007c9b$export$2e2bcd8739ae039 = $03dabf588c007c9b$var$AuthFormEdf;




function $818a8be579ec05f4$var$loginPageEdf() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "page default edf-login-page",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $03dabf588c007c9b$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "quote-part",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f0aded74899c8465$export$2e2bcd8739ae039), {
                    fontSize: "50",
                    fontColor: "white"
                })
            })
        ]
    });
}
var $818a8be579ec05f4$export$2e2bcd8739ae039 = $818a8be579ec05f4$var$loginPageEdf;


const $c074ccffdc32a79f$var$routes = [
    {
        path: "login",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f0b4ce138eba82f2$export$2e2bcd8739ae039), {}),
        isPublic: true
    },
    {
        path: "login-sso-edf",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $818a8be579ec05f4$export$2e2bcd8739ae039), {}),
        isPublic: true
    }
];
var $c074ccffdc32a79f$export$2e2bcd8739ae039 = $c074ccffdc32a79f$var$routes;



















const $ce8e79713883c54a$var$LogoutModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(()=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const { handleSubmit: handleSubmit } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)();
    const onSubmit = async ()=>{
        modal.resolve();
        onClose();
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        name: "logout",
        id: modal.id,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
            className: "modal-form",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                    children: "Logout"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                        children: "Do you really want to logout ?"
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                            className: "validate",
                            label: "Back",
                            onClick: onClose,
                            style: {
                                margin: "10px"
                            }
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                            className: "cancel",
                            label: "Leave",
                            type: "submit",
                            style: {
                                margin: "10px"
                            }
                        })
                    ]
                })
            ]
        })
    });
});
var $ce8e79713883c54a$export$2e2bcd8739ae039 = $ce8e79713883c54a$var$LogoutModal;




var $bh6RR = parcelRequire("bh6RR");




var $33d5846be2a2ca2d$export$2e2bcd8739ae039 = {
    checkPasswordAvailability: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("user/check-availability", data),
    //getCompaniesOfUser : () => client.get('user/info/company/list'),
    getInformationUser: ()=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("user/info"),
    updateMyAccount: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`account/user`, data)
};



var $d16cc9e56789611b$export$2e2bcd8739ae039 = {
    refreshInfoUser: ()=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("user/info"),
    getUser: (id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`company/user/${id}`),
    getUsers: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`company/users`, data),
    addUser: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`company/users/${id}`, data),
    updateUser: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`company/users/${id}`, data),
    deleteUser: (id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`company/users/${id}`)
};




const $c6b70d97a59a9488$export$d23669508ed9caa7 = ()=>{
    const company = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company");
    document.getElementById("title").innerHTML = company.name + " Home - Talkr.ai";
};


parcelRequire("bh6RR");
//import { toastSuccess, toastError } from "/src/layouts/toast/action/toastAction";
async function $575009abb68f6393$var$changePassword(data) {
    let [response, error] = await (0, $33d5846be2a2ca2d$export$2e2bcd8739ae039).updateMyAccount(data);
    if (error !== null) return false;
    return response;
}
async function $575009abb68f6393$var$refreshUserInformation(data) {
    let [response, error] = await (0, $d16cc9e56789611b$export$2e2bcd8739ae039).refreshInfoUser(data);
    if (error !== null) return false;
    return response;
}
async function $575009abb68f6393$var$changeCompany(company_id) {
    const [data, error] = await (0, $33d5846be2a2ca2d$export$2e2bcd8739ae039).updateMyAccount({
        company_id: company_id
    });
    if (error !== null) {
        console.log(error);
        return {
            error: "error"
        };
    }
    const { user: user, company: company, permissions: permissions } = data;
    (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").set("company", company);
    (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").set("permissions", permissions);
    (0, $c6b70d97a59a9488$export$d23669508ed9caa7)();
    return {
        user: user,
        company: company,
        permissions: permissions
    };
}
var $575009abb68f6393$export$2e2bcd8739ae039 = {
    changePassword: $575009abb68f6393$var$changePassword,
    refreshUserInformation: $575009abb68f6393$var$refreshUserInformation,
    changeCompany: $575009abb68f6393$var$changeCompany
};













const $ba673ef6ed917023$var$ChangePasswordModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(()=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const { register: register, handleSubmit: handleSubmit, watch: watch, formState: { errors: errors }, formState: formState } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: ""
    });
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const [passwordIsValid, setPasswordIsValid] = (0, $bh6RR.useState)(false);
    const { checkPasswordAvailability: checkPasswordAvailability } = (0, $33d5846be2a2ca2d$export$2e2bcd8739ae039);
    const onSubmit = async (data)=>{
        const formData = new FormData(); // form data plus securise pour les passwords
        // Ajoutez les données à l'objet FormData en utilisant la méthode append
        for(const key in data)formData.append(key, data[key]);
        const result = await (0, $575009abb68f6393$export$2e2bcd8739ae039).changePassword(formData);
        console.log(toast);
        if (!result) {
            toast.error("Modification Error", "Your password is not correct");
            return;
        }
        toast.success("Modification Success", "Congratulations you have changed your password");
        onClose();
    };
    const onValidate = async (value)=>{
        if (value.length < 5) return;
        const [response, error] = await checkPasswordAvailability({
            password: encodeURIComponent(value)
        }); // the function is important to detect fragment identifier (like # in password)
        if (error !== null) {
            console.error(error);
            return false;
        }
        setPasswordIsValid(!response.available);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        name: "change-password",
        id: modal.id,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "leave-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
                className: "changePassword-container",
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                        children: "Choose a new password"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Password",
                                    listLabelClassName: "field-modal"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ...register("old_password", {
                                        required: true,
                                        onChange: (e)=>onValidate(e.target.value)
                                    }),
                                    style: {
                                        borderColor: watch("old_password")?.length > 0 && passwordIsValid == false ? "red" : ""
                                    },
                                    placeholder: "Enter  current password",
                                    className: "input_password_modal" + (watch("old_password")?.length > 0 && passwordIsValid == false ? " icon_toggle_password_error" : ""),
                                    type: "password"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "New Password",
                                    listLabelClassName: "field-modal"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ...register("new_password", {
                                        required: true,
                                        pattern: /^(?=(?:.*\d){2,})(?=(?:.*[\W_]){2,})[0-9A-Za-z\W_]{16,}$/i
                                    }),
                                    style: {
                                        borderColor: errors.new_password ? "red" : ""
                                    },
                                    placeholder: "Enter your new password",
                                    className: "input_password_modal" + (errors.new_password ? " icon_toggle_password_error" : ""),
                                    type: "password"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                    className: "error-modal_password",
                                    children: [
                                        " ",
                                        errors.new_password && "16 characters, 2 number, 2 special character"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                            className: "validate",
                            label: "Save",
                            type: "submit",
                            disabled: formState.isValid == true && passwordIsValid == true ? false : true
                        })
                    })
                ]
            })
        ]
    });
});
var $ba673ef6ed917023$export$2e2bcd8739ae039 = $ba673ef6ed917023$var$ChangePasswordModal;







var $bh6RR = parcelRequire("bh6RR");





function $85f4190264c2f28d$var$ImageUser({ image: image, id: id }) {
    const [img, setImage] = (0, $bh6RR.useState)(image);
    const dispatch = (0, $373f9505ebba8636$export$a03a56d03840936f)();
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const onChangeImage = async (e)=>{
        let file = e.target.files[0];
        const extensions = new RegExp(`(\\.${[
            "png",
            "jpg",
            "jpeg"
        ].join("|\\.")})$`);
        if (!extensions.exec(file.name)) return false;
        const formData = new (0, (/*@__PURE__*/$parcel$interopDefault($07d55ecd4e888d68$exports)))();
        formData.append("image", file);
        const [data, error] = await (0, $33d5846be2a2ca2d$export$2e2bcd8739ae039).updateMyAccount(formData);
        if (error) {
            console.log(error);
            return;
        }
        setImage(data.user.picture);
        toast.success("Update Profil Picture", "Congrats for updating your profile picture you are a wonderful customer \uD83C\uDF89\uD83C\uDF89");
        sessionStorage.setItem("user", JSON.stringify(data));
        dispatch({
            type: "refreshUserInfo",
            payload: {
                user: data
            }
        });
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "profil-picture",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                id: "update-picture",
                type: "file",
                accept: ".png, .jpg, .jpeg",
                onChange: onChangeImage
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                src: img,
                height: "80",
                width: "80"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                children: "Change"
            })
        ]
    });
}
var $85f4190264c2f28d$export$2e2bcd8739ae039 = $85f4190264c2f28d$var$ImageUser;





var $bh6RR = parcelRequire("bh6RR");



const $b6b235c5b8c1f5b6$export$e14f85ca0e45cc50 = (key)=>(0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get(`company_${(0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company").id}_${key}`) ?? {};
const $b6b235c5b8c1f5b6$export$4f7ec04666a44a3f = (key)=>(0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").remove(`company_${(0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company").id}_${key}`);
const $b6b235c5b8c1f5b6$export$436ab9ffc2d94549 = (key, value = {})=>(0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").set(`company_${(0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company").id}_${key}`, value);



function $ca30ee27f35a7937$var$AccountInformation() {
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const currentCompany = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company");
    const [companies, setCompanies] = (0, $bh6RR.useState)([]);
    const { user: user } = (0, $373f9505ebba8636$export$ea6ddbd83f749864)();
    const dispatch = (0, $373f9505ebba8636$export$a03a56d03840936f)();
    const { getInformationUser: getInformationUser } = (0, $33d5846be2a2ca2d$export$2e2bcd8739ae039);
    const { changeCompany: changeCompany } = (0, $575009abb68f6393$export$2e2bcd8739ae039);
    const showLogoutModal = ()=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $ce8e79713883c54a$export$2e2bcd8739ae039)).then(()=>{
            (0, $b6b235c5b8c1f5b6$export$4f7ec04666a44a3f)("conversation_filters");
            sessionStorage.removeItem("user");
            localStorage.removeItem("token");
            dispatch({
                type: "loginOut"
            });
            navigate("/login");
        });
    const showChangePasswordModal = ()=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $ba673ef6ed917023$export$2e2bcd8739ae039));
    const logout = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                children: "Logout"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "svg logout"
            })
        ]
    });
    const onClickDeleteAccount = async ()=>{
        //const { id, name } = row;
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete Account " + user.username,
            body: "Do you really want to delete your account " + user.username,
            /* // PAS ENCORE FONCTIONNEL
            api: {
                request: deleteChannel,
                param: [id, name]
            },
            */ buttons: [
                {
                    className: "validate",
                    label: "Cancel"
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ],
            confirm: {
                name: user.username,
                fieldName: "your account"
            }
        });
    };
    const updateCompany = async (company_id)=>{
        const res = await changeCompany(company_id);
        if (res.error != null) return;
        const { user: user, company: company } = res;
        dispatch({
            type: "refreshUserInfo",
            payload: {
                user: user,
                token: (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("token")
            }
        });
    };
    const getCompaniesListUser = async ()=>{
        var [response, error] = await getInformationUser();
        if (error != null) {
            console.log(error);
            return;
        }
        setCompanies(setUpCompanies(response.user.companies));
    };
    const setUpCompanies = (_companies)=>{
        _companies = _companies.sort((a, b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
        let res = _companies.map((company)=>{
            return {
                value: company.id,
                text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    style: {
                        maxWidth: "300px",
                        justifyContent: "start"
                    },
                    children: [
                        " ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                            src: company.logo
                        }),
                        " ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "dashboard_content_dropdown",
                            children: [
                                " ",
                                company.name,
                                " "
                            ]
                        }),
                        " "
                    ]
                })
            };
        });
        return res;
    };
    (0, $bh6RR.useEffect)(()=>{
        if ((0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("change_company")) getCompaniesListUser();
        else setCompanies([
            {
                value: currentCompany.id,
                text: currentCompany.name
            }
        ]);
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "account-bar",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: "My Account",
                        listClassName: "title-user-section",
                        listLabelClassName: "title-section"
                    }),
                    !user?.external_id && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        onClick: showLogoutModal,
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                            label: logout
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "user-form",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $85f4190264c2f28d$export$2e2bcd8739ae039), {
                        id: user.id,
                        image: user.picture
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "informations-section",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Username",
                                listClassName: "title-user-section",
                                listLabelClassName: " title-weigth"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                value: user.username,
                                className: "max-width",
                                style: {
                                    width: "100%"
                                },
                                disabled: true
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Email",
                                listClassName: "title-user-section",
                                listLabelClassName: " title-weigth"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                value: user.email,
                                className: "max-width",
                                style: {
                                    width: "100%"
                                },
                                disabled: true
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "company-section",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                        label: "Organizations",
                                        listClassName: "title-user-section",
                                        listLabelClassName: " title-weigth"
                                    }),
                                    companies.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                        choices: companies,
                                        width: "210px",
                                        setValue: (name, value)=>{
                                            updateCompany(value);
                                        },
                                        defaultChoice: currentCompany.id
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Registered",
                                listClassName: "title-user-section",
                                listLabelClassName: " title-weigth"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                listLabelClassName: "date-registered",
                                label: "Since Monday 22 August 2022"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "other-section",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                        label: "Datas",
                                        listClassName: "title-user-section",
                                        listLabelClassName: " title-weigth"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "section-actions",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Download my data",
                                            listLabelClassName: "discret"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "tokenTalkr-section",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                        label: "Token Talkr",
                                        listClassName: "title-user-section",
                                        listLabelClassName: " title-weigth"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "section-actions",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "",
                                            listLabelClassName: "discret"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "user-part",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                        label: "Security",
                                        listClassName: "title-user-section",
                                        listLabelClassName: "title-weigth"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                        className: "section-actions",
                                        children: [
                                            (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("change_password") && !user?.external_id && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                onClick: showChangePasswordModal,
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                    label: "Change your password",
                                                    listLabelClassName: "discret blue-discret"
                                                })
                                            }),
                                            (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("delete_account") && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                onClick: onClickDeleteAccount,
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                    label: "Delete Account",
                                                    listLabelClassName: "discret red-discret"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $ca30ee27f35a7937$export$2e2bcd8739ae039 = $ca30ee27f35a7937$var$AccountInformation;



function $014f1bcafacbce35$var$AccountProfil() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $afaae2ff7871e331$export$2e2bcd8739ae039), {
        className: "user-section",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ca30ee27f35a7937$export$2e2bcd8739ae039), {})
    });
}
var $014f1bcafacbce35$export$2e2bcd8739ae039 = $014f1bcafacbce35$var$AccountProfil;


const $cbdd1ee87275a7c8$var$routes = [
    {
        path: "/user/settings",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $014f1bcafacbce35$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false
    }
];
var $cbdd1ee87275a7c8$export$2e2bcd8739ae039 = $cbdd1ee87275a7c8$var$routes;














var $bh6RR = parcelRequire("bh6RR");


let $db308965a4a9caba$var$countries = {
    "AF": "Afghanistan",
    "AX": "&Aring;land Islands",
    "AL": "Albania",
    "DZ": "Algeria",
    "AS": "American Samoa",
    "AD": "Andorra",
    "AO": "Angola",
    "AI": "Anguilla",
    "AG": "Antigua and Barbuda",
    "AR": "Argentina",
    "AM": "Armenia",
    "AW": "Aruba",
    "AU": "Australia",
    "AT": "Austria",
    "AZ": "Azerbaijan",
    "BS": "Bahamas (the)",
    "BH": "Bahrain",
    "BD": "Bangladesh",
    "BB": "Barbados",
    "BY": "Belarus",
    "BE": "Belgium",
    "BZ": "Belize",
    "BJ": "Benin",
    "BM": "Bermuda",
    "BT": "Bhutan",
    "BO": "Bolivia (Plurinational State of)",
    "BA": "Bosnia and Herzegovina",
    "BW": "Botswana",
    "BV": "Bouvet Island",
    "BR": "Brazil",
    "IO": "British Indian Ocean Territory (the)",
    "BN": "Brunei Darussalam",
    "BG": "Bulgaria",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "KH": "Cambodia",
    "CV": "Cabo Verde",
    "CM": "Cameroon",
    "CA": "Canada",
    "CT": "Catalonia",
    "KY": "Cayman Islands (the)",
    "CF": "Central African Republic (the)",
    "TD": "Chad",
    "CL": "Chile",
    "CN": "Chinese",
    "CX": "Christmas Island",
    "CC": "Cocos (Keeling) Islands (the)",
    "CO": "Colombia",
    "KM": "Comoros",
    "CD": "Congo (the Democratic Republic of the)",
    "CG": "Congo (the)",
    "CK": "Cook Islands (the)",
    "CR": "Costa Rica",
    "CI": "C&ocirc;te d'Ivoire",
    "HR": "Croatia",
    "CU": "Cuba",
    "CY": "Cyprus",
    "CZ": "Czech Republic (the)",
    "DK": "Denmark",
    "DJ": "Djibouti",
    "DM": "Dominica",
    "DO": "Dominican Republic (the)",
    "EC": "Ecuador",
    "EG": "Egypt",
    "SV": "El Salvador",
    "EN": "England",
    "GQ": "Equatorial Guinea",
    "ER": "Eritrea",
    "EE": "Estonia",
    "ET": "Ethiopia",
    "EU": "European Union",
    "FK": "Falkland Islands (the) [Malvinas]",
    "FO": "Faroe Islands (the)",
    "FJ": "Fiji",
    "FI": "Finland",
    "FR": "French",
    "GF": "French Guiana",
    "PF": "French Polynesia",
    "TF": "French Southern Territories (the)",
    "GA": "Gabon",
    "GM": "Gambia (the)",
    "GE": "Georgia",
    "DE": "German",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GR": "Greece",
    "GL": "Greenland",
    "GD": "Grenada",
    "GP": "Guadeloupe",
    "GU": "Guam",
    "GT": "Guatemala",
    "GN": "Guinea",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HT": "Haiti",
    "HM": "Heard Island and McDonald Islands",
    "VA": "Holy See (the)",
    "HN": "Honduras",
    "HK": "Hong Kong",
    "HU": "Hungary",
    "IS": "Iceland",
    "IN": "India",
    "ID": "Indonesia",
    "IR": "Iran (Islamic Republic of)",
    "IQ": "Iraq",
    "IE": "Ireland",
    "IL": "Israel",
    "IT": "Italy",
    "JM": "Jamaica",
    "JP": "Japan",
    "JO": "Jordan",
    "KZ": "Kazakhstan",
    "KE": "Kenya",
    "KI": "Kiribati",
    "KP": "Korea (the Democratic People's Republic of)",
    "KR": "Korea (the Republic of)",
    "KW": "Kuwait",
    "KG": "Kyrgyzstan",
    "LA": "Lao People's Democratic Republic (the)",
    "LV": "Latvia",
    "LB": "Lebanon",
    "LS": "Lesotho",
    "LR": "Liberia",
    "LY": "Libya",
    "LI": "Liechtenstein",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "MO": "Macao",
    "MK": "Macedonia (the former Yugoslav Republic of)",
    "MG": "Madagascar",
    "MW": "Malawi",
    "MY": "Malaysia",
    "MV": "Maldives",
    "ML": "Mali",
    "MT": "Malta",
    "MH": "Marshall Islands (the)",
    "MQ": "Martinique",
    "MR": "Mauritania",
    "MU": "Mauritius",
    "YT": "Mayotte",
    "MX": "Mexico",
    "FM": "Micronesia (Federated States of)",
    "MD": "Moldova (the Republic of)",
    "MC": "Monaco",
    "MN": "Mongolia",
    "ME": "Montenegro",
    "MS": "Montserrat",
    "MA": "Morocco",
    "MZ": "Mozambique",
    "MM": "Myanmar",
    "NA": "Namibia",
    "NR": "Nauru",
    "NP": "Nepal",
    "NL": "Netherlands (the)",
    "AN": "Netherlands Antilles",
    "NC": "New Caledonia",
    "NZ": "New Zealand",
    "NI": "Nicaragua",
    "NE": "Niger (the)",
    "NG": "Nigeria",
    "NU": "Niue",
    "NF": "Norfolk Island",
    "MP": "Northern Mariana Islands (the)",
    "NO": "Norway",
    "OM": "Oman",
    "PK": "Pakistan",
    "PW": "Palau",
    "PS": "Palestine, State of",
    "PA": "Panama",
    "PG": "Papua New Guinea",
    "PY": "Paraguay",
    "PE": "Peru",
    "PH": "Philippines (the)",
    "PN": "Pitcairn",
    "PL": "Poland",
    "PT": "Portuguese",
    "PR": "Puerto Rico",
    "QA": "Qatar",
    "RE": "R&eacute;union",
    "RO": "Romania",
    "RU": "Russian",
    "RW": "Rwanda",
    "SH": "Saint Helena, Ascension and Tristan da Cunha",
    "KN": "Saint Kitts and Nevis",
    "LC": "Saint Lucia",
    "PM": "Saint Pierre and Miquelon",
    "VC": "Saint Vincent and the Grenadines",
    "WS": "Samoa",
    "SM": "San Marino",
    "ST": "Sao Tome and Principe",
    "SA": "Saudi Arabia",
    "AB": "Scotland",
    "SN": "Senegal",
    "RS": "Serbia",
    "CS": "Serbia and Montenegro",
    "SC": "Seychelles",
    "SL": "Sierra Leone",
    "SG": "Singapore",
    "SK": "Slovakia",
    "SI": "Slovenia",
    "SB": "Solomon Islands",
    "SO": "Somalia",
    "ZA": "South Africa",
    "GS": "South Georgia and the South Sandwich Islands",
    "ES": "Spanish",
    "LK": "Sri Lanka",
    "SD": "Sudan (the)",
    "SR": "Suriname",
    "SJ": "Svalbard and Jan Mayen",
    "SZ": "Swaziland",
    "SE": "Sweden",
    "CH": "Switzerland",
    "SY": "Syrian Arab Republic",
    "TW": "Taiwan (Province of China)",
    "TJ": "Tajikistan",
    "TZ": "Tanzania, United Republic of",
    "TH": "Thailand",
    "TL": "Timor-Leste",
    "TG": "Togo",
    "TK": "Tokelau",
    "TO": "Tonga",
    "TT": "Trinidad and Tobago",
    "TN": "Tunisia",
    "TR": "Turkey",
    "TM": "Turkmenistan",
    "TC": "Turks and Caicos Islands (the)",
    "TV": "Tuvalu",
    "UG": "Uganda",
    "UA": "Ukraine",
    "AE": "United Arab Emirates (the)",
    "GB": "United Kingdom of Great Britain and Northern Ireland (the)",
    "UM": "United States Minor Outlying Islands (the)",
    "US": "United States of America (the)",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VU": "Vanuatu",
    "VE": "Venezuela (Bolivarian Republic of)",
    "VN": "Viet Nam",
    "VG": "Virgin Islands (British)",
    "VI": "Virgin Islands (U.S.)",
    "WA": "Wales",
    "WF": "Wallis and Futuna",
    "EH": "Western Sahara",
    "YE": "Yemen",
    "ZM": "Zambia",
    "ZW": "Zimbabwe"
};
var $db308965a4a9caba$export$2e2bcd8739ae039 = $db308965a4a9caba$var$countries;


const $1a75652c97864052$var$CountryTable = ({ data: data, iconName: iconName })=>{
    const [isOpen, setOpen] = (0, $bh6RR.useState)(false);
    const openListData = ()=>{
        setOpen(!isOpen);
    };
    const onSubmit = async (data)=>{};
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "data_container",
        onClick: ()=>openListData(),
        children: isOpen == false ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
            className: "flag-icon flag-icon-" + iconName
        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                " ",
                (0, $db308965a4a9caba$export$2e2bcd8739ae039)[iconName.toUpperCase()],
                " "
            ]
        })
    });
};
var $1a75652c97864052$export$2e2bcd8739ae039 = $1a75652c97864052$var$CountryTable;





var $cef77ca5b38a78fa$export$2e2bcd8739ae039 = {
    getDatasetsIvy: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("datasets", {
            ...data,
            type: 1
        }),
    getDatasetsWorksheet: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("datasets", {
            ...data,
            type: 3
        }),
    getDatasets: (companies_ids, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("datasets", {
            ...data,
            companies_ids: companies_ids
        }),
    getDataset: (name, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`dataset/${name}/statements`, data),
    addDataset: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`dataset`, data),
    deleteDataset: (name, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`dataset/${name}`, data),
    updateDataset: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`dataset/${id}`, data),
    isDatasetNameAvailable: (name)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`datasets?name=${name}`)
};




function $0558ddb420513b03$var$DatasetIvy() {
    const { getDatasetsIvy: getDatasetsIvy, deleteDataset: deleteDataset } = (0, $cef77ca5b38a78fa$export$2e2bcd8739ae039);
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const cells = [
        {
            column: "NAME",
            name: "name",
            sort: true,
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    style: {
                        fontWeight: 700
                    },
                    children: (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value)
                })
        },
        {
            column: "LANGUAGE",
            name: "language.slug",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1a75652c97864052$export$2e2bcd8739ae039), {
                    iconName: value.toLowerCase()
                })
        },
        {
            column: "DESCRIPTION",
            name: "description",
            show: (value)=>(0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value)
        },
        {
            column: "LAST UPDATE",
            name: "updated_at",
            sort: true,
            show: (value)=>(0, $df9ad4654a227866$export$3ae94a2503e890a1)(value)
        },
        {
            column: "CONVERSATION MODE",
            name: "dataset_type_id",
            show: (value)=>value != 2 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    className: "fa fa-check",
                    "aria-hidden": "true",
                    style: {
                        color: "var(--green)"
                    }
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    style: {
                        color: "var(--pink)",
                        fontWeight: "bolder"
                    },
                    children: "X"
                })
        }
    ];
    const onClickUpdate = ({ row: row, updateRow: updateRow, getIndex: getIndex })=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("dataset/update"), {
            state: {
                data: row
            }
        });
    //const onClickRedirect = ({ row }) => naviguate('/bot/' + row.name);
    const onClickRedirect = ({ row: row })=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("datasets/" + row.name));
    const onClickAdd = ({ deleteRow: deleteRow, row: row })=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("dataset/create"));
    const onClickDelete = async ({ row: row, deleteRow: deleteRow })=>{
        const { id: id, name: name } = row;
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete dataset " + name,
            body: "Do you really want to delete the dataset " + name + " ?",
            api: {
                request: deleteDataset,
                param: [
                    row.id
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel"
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ],
            confirm: {
                name: name,
                fieldName: "the dataset"
            }
        }).then(()=>deleteRow(id));
    };
    const actions = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_dataset") ? {
            className: "fas fa-cog action-button edit_action",
            style: {},
            onClick: onClickUpdate
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_dataset") ? {
            className: "fas fa-edit action-button profil_action",
            style: {},
            onClick: onClickRedirect
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("delete_dataset") ? {
            className: "fas fa-trash action-button delete_action",
            style: {},
            onClick: onClickDelete
        } : null
    ].filter((action)=>action);
    const buttons = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("create_dataset") ? {
            icon: "fas fa-plus",
            onClick: onClickAdd
        } : null
    ].filter((button)=>button);
    const filters = [
        {
            type: "input",
            placeholder: "content",
            name: "term"
        }
    ];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
        name: "Dataset",
        cells: cells,
        api: getDatasetsIvy,
        actions: actions,
        buttons: buttons,
        filters: filters
    });
}
var $0558ddb420513b03$export$2e2bcd8739ae039 = $0558ddb420513b03$var$DatasetIvy;
















function $43bba794d2a26a60$var$DatasetWorksheet() {
    const { getDatasetsWorksheet: getDatasetsWorksheet, deleteDataset: deleteDataset } = (0, $cef77ca5b38a78fa$export$2e2bcd8739ae039);
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const cells = [
        {
            column: "NAME",
            name: "name",
            sort: true,
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    style: {
                        fontWeight: 700
                    },
                    children: (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value)
                })
        },
        /*
        {
            column: 'LANGUAGE',
            name: 'language.slug',
            show: (value) => <CountryTable iconName={value.toLowerCase()}></CountryTable>
        },
        */ {
            column: "DESCRIPTION",
            name: "description",
            show: (value)=>(0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value)
        },
        {
            column: "LAST UPDATE",
            name: "updated_at",
            sort: true,
            show: (value)=>(0, $df9ad4654a227866$export$3ae94a2503e890a1)(value)
        }
    ];
    const onClickUpdate = ({ row: row, updateRow: updateRow, getIndex: getIndex })=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("dataset/update"), {
            state: {
                data: row
            }
        });
    const onClickRedirect = ({ row: row })=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("datasets/" + row.name));
    const onClickAdd = ({ deleteRow: deleteRow, row: row })=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("dataset/create"));
    const onClickDelete = async ({ row: row, deleteRow: deleteRow })=>{
        const { id: id, name: name } = row;
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete dataset " + name,
            body: "Do you really want to delete the dataset " + name + " ?",
            api: {
                request: deleteDataset,
                param: [
                    row.id
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel"
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ],
            confirm: {
                name: name,
                fieldName: "the dataset"
            },
            maxTitleSize: 40
        }).then(()=>deleteRow(id));
    };
    const actions = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_dataset") ? {
            className: "fas fa-cog action-button edit_action",
            style: {},
            onClick: onClickUpdate
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_dataset") ? {
            className: "fas fa-edit action-button profil_action",
            style: {},
            onClick: onClickRedirect
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("delete_dataset") ? {
            className: "fas fa-trash action-button delete_action",
            style: {},
            onClick: onClickDelete
        } : null
    ].filter((action)=>action);
    const buttons = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("create_dataset") ? {
            icon: "fas fa-plus",
            onClick: onClickAdd
        } : null
    ].filter((button)=>button);
    const filters = [
        {
            type: "input",
            placeholder: "content",
            name: "term"
        }
    ];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
        name: "Dataset",
        cells: cells,
        api: getDatasetsWorksheet,
        actions: actions,
        buttons: buttons,
        filters: filters
    });
}
var $43bba794d2a26a60$export$2e2bcd8739ae039 = $43bba794d2a26a60$var$DatasetWorksheet;



var $5c5c6a9b8c6e5949$export$2e2bcd8739ae039 = (0, $297630b888b8597e$export$2e2bcd8739ae039);



function $542980e182b3e1d9$var$DatasetList() {
    //
    const items = [
        {
            name: "Worksheet",
            component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $43bba794d2a26a60$export$2e2bcd8739ae039), {})
        },
        {
            name: "QnA",
            component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0558ddb420513b03$export$2e2bcd8739ae039), {})
        }
    ];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: "List of Datasets"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5c5c6a9b8c6e5949$export$2e2bcd8739ae039), {
                items: items,
                name: "datasets"
            })
        ]
    });
}
var $542980e182b3e1d9$export$2e2bcd8739ae039 = $542980e182b3e1d9$var$DatasetList;





var $bh6RR = parcelRequire("bh6RR");






var $832c2ed0617b1e24$export$2e2bcd8739ae039 = {
    getColumns: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`dataset/${id}/worksheet/columns`, data),
    addColumn: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`dataset/${id}/worksheet/column`, data),
    updateColumn: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`dataset/${id}/worksheet/column`, data),
    deleteColumn: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`dataset/${id}/worksheet/column`, data),
    getRegex: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`dataset/worksheets/regex`, data)
};




parcelRequire("bh6RR");






function $9c2d88d3df32f983$var$SideModal(props) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        ...props
    });
}
$9c2d88d3df32f983$var$SideModal.defaultProps = {
    modalClass: "modal side-modal",
    autoClose: false
};
var $9c2d88d3df32f983$export$2e2bcd8739ae039 = $9c2d88d3df32f983$var$SideModal;








var $bh6RR = parcelRequire("bh6RR");

//import "./InputSvg.css"
const $0ab38a35cd0a622a$var$InputRange = /*#__PURE__*/ (0, $bh6RR.forwardRef)(({ name: name, className: className, min: min, max: max, value: value, _setValue: _setValue }, ref)=>{
    const [val, setVal] = (0, $bh6RR.useState)(value ? value : "0");
    const changeValue = (e)=>{
        setVal(e.target.value);
        _setValue(name, e.target.value);
    };
    //const [value, setValue] = useState(valueDefault ? valueDefault : min + max / 2);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
            type: "range",
            ref: ref,
            min: 0,
            max: max,
            value: val,
            className: "input-range " + className,
            onChange: changeValue
        })
    });
});
$0ab38a35cd0a622a$var$InputRange.defaultProps = {
    name: "input-range_default",
    className: "",
    min: "0",
    max: "5"
};
var $0ab38a35cd0a622a$export$2e2bcd8739ae039 = $0ab38a35cd0a622a$var$InputRange;






var $bh6RR = parcelRequire("bh6RR");











var $bh6RR = parcelRequire("bh6RR");




const $76742abc2a452912$var$checkKey = (e, keyVerification, func)=>{
    if (e.keyCode === keyVerification) return func ? func() : false;
};
var $76742abc2a452912$export$2e2bcd8739ae039 = $76742abc2a452912$var$checkKey;


function $dce6552ace431e20$var$TodoList({ registerObject: registerObject, control: control, name: name, checkError: checkError, properties_to_add: properties_to_add }) {
    const [input, setInput] = (0, $bh6RR.useState)("");
    const { fields: fields, append: append, update: update, prepend: prepend, remove: remove, swap: swap, move: move, insert: insert } = (0, $ee9f4a2880885da1$export$310131896651d559)({
        control: control,
        name: name
    });
    const todo_ref_input = (0, $bh6RR.useRef)();
    const modifyInput = (val)=>{
        setInput(val);
        registerObject.setValue(`${name}RegisterInput`, val);
        /*
   if (properties_to_add == null) {
       setInput(val);
       registerObject.setValue(`${name}RegisterInput`, val)
   }
   setInput(val);
   registerObject.setValue(`${name}RegisterInput`, val)
   /*
   else {
       setInput({ ...{ value: val }, ...properties_to_add });
       registerObject.setValue(`${name}RegisterInput`, { ...{ value: val }, ...properties_to_add })
   }
   */ checkErrors();
    };
    const appendTask = ()=>{
        console.log("EFFECT 2");
        if (input.trim().length != 0) //if ((input.value != null && input.value.trim().length != 0) || (input.value == null && input.trim().length != 0)) { //trim().length == 0) {
        append({
            name: input
        });
        setInput("");
        todo_ref_input.current.value = "";
        registerObject.setValue(`${name}RegisterInput`, "");
    };
    const updateFields = (e, id, index)=>{
        for(let i = 0; i < fields.length; i++)if (fields[i].id === id) fields[i].name = e.target.value;
        checkErrors();
    };
    (0, $bh6RR.useEffect)(()=>{
        if (input && input.trim().length === 0) //if (!input?.value || input.value.trim().length === 0) { //trim().length == 0) {
        checkErrors();
        else registerObject.clearErrors(name);
    }, [
        fields,
        input
    ]);
    const checkErrors = ()=>{
        let empty = 0;
        for(let i = 0; i < fields.length; i++){
            let val = fields[i].name == null ? fields[i][0] : fields[i].name;
            if (val.trim().length === 0) //if ((fields[i].name.value != null && (fields[i].name.value == "" || fields[i].name.value.trim().length === 0)) || (fields[i].name?.value == null && (fields[i].name == "" || fields[i].name.trim().length === 0))) {
            empty += 1;
            if (checkError != null) checkError(val);
        }
        if (empty == fields.length && !input) registerObject.setError(name, {
            type: "custom",
            message: "empty"
        });
        else registerObject.clearErrors(name);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "raw",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                        ref: todo_ref_input,
                        placeholder: "Choose your " + (name == "statements" ? "sentences" : "responses"),
                        onChange: (e)=>{
                            modifyInput(e.target.value);
                        },
                        onKeyUp: (e)=>{
                            e.preventDefault();
                            (0, $76742abc2a452912$export$2e2bcd8739ae039)(e, 13, appendTask);
                        }
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                        className: "main-iconButton add-hover modalButtons-input",
                        icon: "fas fa-plus-circle",
                        onClick: ()=>appendTask()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("ul", {
                className: "taskList",
                children: fields.map((item, index)=>{
                    //let defaultValue = item.name?.value == null ? item.name : item.name.value
                    let obj = item.name == null ? item[0] : item.name;
                    console.log(item);
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "raw",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ref: item.id,
                                    defaultValue: `${obj}`,
                                    ...registerObject.register(`${name}[${index}].name`, {
                                        shoudFocused: true
                                    }),
                                    placeholder: `Choose your ${name.substring(0, name.length - 1)}`,
                                    onChange: (e)=>updateFields(e, item.id, index)
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                    className: "main-iconButton remove-hover modalButtons-input",
                                    icon: "fas fa-trash",
                                    onClick: ()=>remove(index)
                                })
                            ]
                        })
                    }, item.id);
                })
            })
        ]
    });
}
var $dce6552ace431e20$export$2e2bcd8739ae039 = $dce6552ace431e20$var$TodoList;















const $8b40e0c1bf1a30fd$export$455b147a0edb9e31 = (listData, nameRow)=>{
    listData[nameRow] = listData[nameRow].map((obj)=>obj.name);
    let suffix = nameRow + "RegisterInput";
    let input = listData[suffix];
    if (input != null && input.trim().length != 0) listData[nameRow].push(input);
    let data = [];
    for(let i = 0; i < listData[nameRow].length; i++){
        let row = listData[nameRow][i];
        if (row.trim().length != 0) data.push(row);
    }
    delete listData[suffix];
    return listData;
};


function $5de763fcc778488c$var$StatementModalBody({ data: data, title: title, dataset: dataset, is_button_back: is_button_back }) {
    if (data != null) {
        data.statements = data.statements.map((statement)=>{
            return {
                name: statement
            };
        });
        data.responses = data.responses.map((reponse)=>{
            return {
                name: reponse
            };
        });
    }
    const { register: register, setError: setError, clearErrors: clearErrors, handleSubmit: handleSubmit, control: control, formState: { errors: errors }, formState: formState, getValues: getValues, setValue: setValue } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            label: data?.label,
            statements: data ? data.statements : [],
            responses: data ? data.responses : []
        }
    });
    var registerObject = {
        register: register,
        setError: setError,
        clearErrors: clearErrors,
        control: control,
        setValue: setValue
    };
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const { addStatement: addStatement, updateStatement: updateStatement } = (0, $a4ac07fb6dab611c$export$2e2bcd8739ae039);
    const onSubmit = async ()=>{
        /*
        var dataToSend = getValues();
        
        if (dataToSend.statementsRegisterInput != null  && dataToSend.statementsRegisterInput.trim().length != 0) {
            dataToSend.statements.push({ name: dataToSend.statementsRegisterInput })
        }

        if (dataToSend.responsesRegisterInput != null&&  dataToSend.responsesRegisterInput.trim().length != 0) {
            dataToSend.responses.push({ name: dataToSend.responsesRegisterInput })
        }

        var statementsData = []
        var responsesData = []
        for (let i = 0; i < dataToSend.statements.length; i++) {
            if (dataToSend.statements[i].name.trim().length != 0) {
                statementsData.push(dataToSend.statements[i].name);
            }
        }
        for (let i = 0; i < dataToSend.responses.length; i++) {
            if (dataToSend.responses[i].name.trim().length != 0) {
                responsesData.push(dataToSend.responses[i].name);
            }
        }
       */ var dataToSend = getValues();
        //dataToSend.statements = statementsData
        //dataToSend.statements = dataToSend.statements.map(obj => obj.name);
        //dataToSend.responses = dataToSend.responses.map(obj => obj.name);
        dataToSend = (0, $8b40e0c1bf1a30fd$export$455b147a0edb9e31)(dataToSend, "statements");
        dataToSend = (0, $8b40e0c1bf1a30fd$export$455b147a0edb9e31)(dataToSend, "responses");
        console.log(dataToSend);
        let [response, error] = data ? await updateStatement(dataset.name, data.id, dataToSend) : await addStatement(dataset.name, dataToSend);
        if (error !== null) {
            console.log(error);
            return;
        }
        dataToSend.id = data ? data.id : response._id;
        modal.resolve(dataToSend);
        onClose();
        return;
    };
    const checkSingleErrors = (data, nameColumn)=>{
        if (data[nameColumn].length == 0 && (data[nameColumn + "RegisterInput"] == null || data[nameColumn + "RegisterInput"]?.replace(/\s/g, "").length == 0)) return true;
        if (data[nameColumn].every((element)=>element === null) && data[nameColumn + "RegisterInput"]?.replace(/\s/g, "").length == 0) return true;
        return false;
    };
    const checkErrors = ()=>{
        let dataForm = getValues();
        /*
        let responses = dataForm.responses;
        let statements = dataForm.statements
        let responseInput = dataForm.responsesRegisterInput;
        let statementInput = dataForm.statementsRegisterInput;
        /*/ if (checkSingleErrors(dataForm, "responses") == true) return;
        if (checkSingleErrors(dataForm, "statements") == true) return;
        // if all the element are empty, useless to go further
        //if (responses.length == 0 && (responseInput == null || responseInput?.replace(/\s/g, '').length == 0)) return;
        //if (statements.length == 0 && (statementInput == null || statementInput?.replace(/\s/g, '').length == 0)) return;
        //if (responses.length == 0 && statements.length == 0 && statementInput == null  && statementInput.replace(/\s/g, '').length == 0 && responseInput?.replace(/\s/g, '').length == 0) return;
        // else, check if all element have a value
        /*
        if (responses.every(element => element === null) && responseInput?.replace(/\s/g, '').length == 0) {
            return;
        }
        */ /*
        if (statements.every(element => element === null) && statementInput?.replace(/\s/g, '').length == 0) {
            return;
        }
        */ // if we are here, mean all values are entered, we can delock the disabled button
        clearErrors();
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
            className: "edit-container",
            onSubmit: null,
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                    children: title
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                    className: "body-editModal-container",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Label"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ...register("label", {
                                        required: true,
                                        minLength: 1,
                                        onChange: ()=>checkErrors()
                                    }),
                                    style: errors.label ? {
                                        borderColor: "red"
                                    } : {},
                                    defaultValue: data ? data.label : "",
                                    placeholder: "Choose your label"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "statement-modal-bar"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "statement-container",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Sentences"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $dce6552ace431e20$export$2e2bcd8739ae039), {
                                    registerObject: registerObject,
                                    control: control,
                                    arrayModal: data?.statements,
                                    name: "statements"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "statement-modal-bar"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "robot_reply-container",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Robot Reply"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $dce6552ace431e20$export$2e2bcd8739ae039), {
                                    registerObject: registerObject,
                                    control: control,
                                    arrayModal: data?.reponses,
                                    name: "responses"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                    children: [
                        is_button_back ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "button_add_statement",
                            style: {
                                marginRight: "20px"
                            },
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                className: "cancel",
                                label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                    className: "fas fa-angle-double-left"
                                }),
                                onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("test-part")
                            })
                        }) : null,
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                            type: "button",
                            label: data?.id ? "Update" : "Add",
                            disabled: Object.keys(errors).length == 0 ? getValues().label != "" ? false : true : true,
                            onClick: handleSubmit(onSubmit)
                        })
                    ]
                })
            ]
        })
    });
}
var $5de763fcc778488c$export$2e2bcd8739ae039 = $5de763fcc778488c$var$StatementModalBody;




const $eaf3b7858f46cf51$export$74ff82ccb88f9fb1 = (e)=>{
    // prevent: "e", "=", ",", "-", "."
    if ([
        69,
        187,
        188,
        189,
        190
    ].includes(e.keyCode)) e.preventDefault();
};




var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");

var $eCfBx = parcelRequire("eCfBx");


var $bh6RR = parcelRequire("bh6RR");

var $eCfBx = parcelRequire("eCfBx");
/* eslint-disable no-fallthrough */ 

var $bh6RR = parcelRequire("bh6RR");

var $eCfBx = parcelRequire("eCfBx");
var $44a44312232fffaa$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $44a44312232fffaa$exports) {
        classNames.default = classNames;
        $44a44312232fffaa$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


function $3a7da7f4c81a8554$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $3a7da7f4c81a8554$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3a7da7f4c81a8554$export$2e2bcd8739ae039(o);
}


function $4ff366e58c33ccee$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $f741f874145d0154$export$2e2bcd8739ae039(argument) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $3434eb5bab1e76df$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $8ff0dd17621a97b7$export$2e2bcd8739ae039(value) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}




function $5663a6fd5511e169$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $8ff0dd17621a97b7$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $5fa2427dbbbb369e$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $a62bf7cf7b9521d9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $8eaa0dace66c235b$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $a62bf7cf7b9521d9$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $dc399780b2b0aec4$var$MILLISECONDS_IN_DAY = 86400000;
function $dc399780b2b0aec4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $dc399780b2b0aec4$var$MILLISECONDS_IN_DAY) + 1;
}





function $869ba20767f1348a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $d81d25690b2c97ba$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $869ba20767f1348a$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $869ba20767f1348a$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $460a48298a6e483f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $d81d25690b2c97ba$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $869ba20767f1348a$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $6e0c4858e45e9a69$var$MILLISECONDS_IN_WEEK = 604800000;
function $6e0c4858e45e9a69$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $869ba20767f1348a$export$2e2bcd8739ae039)(date).getTime() - (0, $460a48298a6e483f$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $6e0c4858e45e9a69$var$MILLISECONDS_IN_WEEK) + 1;
}







var $9eacf000ef47a2dd$var$defaultOptions = {};
function $9eacf000ef47a2dd$export$430a3269e24b912e() {
    return $9eacf000ef47a2dd$var$defaultOptions;
}
function $9eacf000ef47a2dd$export$95365be1b0704abc(newOptions) {
    $9eacf000ef47a2dd$var$defaultOptions = newOptions;
}


function $ddad3c02657f84fd$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $9eacf000ef47a2dd$export$430a3269e24b912e)();
    var weekStartsOn = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $a33305f247e30adc$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $9eacf000ef47a2dd$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $ddad3c02657f84fd$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $ddad3c02657f84fd$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $1dc77d031b6877e7$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $9eacf000ef47a2dd$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $a33305f247e30adc$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $ddad3c02657f84fd$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $8771fceed12cf89e$var$MILLISECONDS_IN_WEEK = 604800000;
function $8771fceed12cf89e$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $ddad3c02657f84fd$export$2e2bcd8739ae039)(date, options).getTime() - (0, $1dc77d031b6877e7$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $8771fceed12cf89e$var$MILLISECONDS_IN_WEEK) + 1;
}



function $e6c856ebc9ae82ee$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $87a2011828c90e33$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $87a2011828c90e33$export$2e2bcd8739ae039 = $87a2011828c90e33$var$formatters;


var $281a2e82d409b287$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $281a2e82d409b287$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $87a2011828c90e33$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $a33305f247e30adc$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $d81d25690b2c97ba$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $87a2011828c90e33$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $8771fceed12cf89e$export$2e2bcd8739ae039)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $6e0c4858e45e9a69$export$2e2bcd8739ae039)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $87a2011828c90e33$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $dc399780b2b0aec4$export$2e2bcd8739ae039)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $87a2011828c90e33$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $87a2011828c90e33$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $87a2011828c90e33$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $87a2011828c90e33$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $87a2011828c90e33$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $281a2e82d409b287$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $281a2e82d409b287$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $281a2e82d409b287$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $281a2e82d409b287$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $281a2e82d409b287$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $281a2e82d409b287$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $281a2e82d409b287$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(minutes, 2);
}
function $281a2e82d409b287$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $281a2e82d409b287$var$formatTimezone(offset, dirtyDelimiter);
}
function $281a2e82d409b287$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $e6c856ebc9ae82ee$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $281a2e82d409b287$export$2e2bcd8739ae039 = $281a2e82d409b287$var$formatters;


var $9bb5cf506dd06653$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $9bb5cf506dd06653$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $9bb5cf506dd06653$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $9bb5cf506dd06653$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $9bb5cf506dd06653$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $9bb5cf506dd06653$var$timeLongFormatter(timePattern, formatLong));
};
var $9bb5cf506dd06653$var$longFormatters = {
    p: $9bb5cf506dd06653$var$timeLongFormatter,
    P: $9bb5cf506dd06653$var$dateTimeLongFormatter
};
var $9bb5cf506dd06653$export$2e2bcd8739ae039 = $9bb5cf506dd06653$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $63dba254cf419de0$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $065cceb4149e3fc5$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $065cceb4149e3fc5$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $065cceb4149e3fc5$export$c6cc36aa33304772(token) {
    return $065cceb4149e3fc5$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $065cceb4149e3fc5$export$c6b49d6dceb604a1(token) {
    return $065cceb4149e3fc5$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $065cceb4149e3fc5$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $8617db99f2cb39a3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $8617db99f2cb39a3$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $8617db99f2cb39a3$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $8617db99f2cb39a3$export$2e2bcd8739ae039 = $8617db99f2cb39a3$var$formatDistance;


function $f6b7cff3d084a1cf$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $c8014f25de2be27f$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $c8014f25de2be27f$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $c8014f25de2be27f$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $c8014f25de2be27f$var$formatLong = {
    date: (0, $f6b7cff3d084a1cf$export$2e2bcd8739ae039)({
        formats: $c8014f25de2be27f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $f6b7cff3d084a1cf$export$2e2bcd8739ae039)({
        formats: $c8014f25de2be27f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $f6b7cff3d084a1cf$export$2e2bcd8739ae039)({
        formats: $c8014f25de2be27f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $c8014f25de2be27f$export$2e2bcd8739ae039 = $c8014f25de2be27f$var$formatLong;


var $06efd8cc10c4bd73$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $06efd8cc10c4bd73$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $06efd8cc10c4bd73$var$formatRelativeLocale[token];
};
var $06efd8cc10c4bd73$export$2e2bcd8739ae039 = $06efd8cc10c4bd73$var$formatRelative;


function $e8d3841961a689fd$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $a6959687464919d6$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $a6959687464919d6$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $a6959687464919d6$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $a6959687464919d6$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $a6959687464919d6$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $a6959687464919d6$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $a6959687464919d6$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $a6959687464919d6$var$localize = {
    ordinalNumber: $a6959687464919d6$var$ordinalNumber,
    era: (0, $e8d3841961a689fd$export$2e2bcd8739ae039)({
        values: $a6959687464919d6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $e8d3841961a689fd$export$2e2bcd8739ae039)({
        values: $a6959687464919d6$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $e8d3841961a689fd$export$2e2bcd8739ae039)({
        values: $a6959687464919d6$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $e8d3841961a689fd$export$2e2bcd8739ae039)({
        values: $a6959687464919d6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $e8d3841961a689fd$export$2e2bcd8739ae039)({
        values: $a6959687464919d6$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a6959687464919d6$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $a6959687464919d6$export$2e2bcd8739ae039 = $a6959687464919d6$var$localize;


function $bcb83626ff750417$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $bcb83626ff750417$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $bcb83626ff750417$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $bcb83626ff750417$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $bcb83626ff750417$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $03af782d2d1fcb5a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $6256b66dca390462$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $6256b66dca390462$var$parseOrdinalNumberPattern = /\d+/i;
var $6256b66dca390462$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $6256b66dca390462$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $6256b66dca390462$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $6256b66dca390462$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6256b66dca390462$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $6256b66dca390462$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $6256b66dca390462$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $6256b66dca390462$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $6256b66dca390462$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $6256b66dca390462$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $6256b66dca390462$var$match = {
    ordinalNumber: (0, $03af782d2d1fcb5a$export$2e2bcd8739ae039)({
        matchPattern: $6256b66dca390462$var$matchOrdinalNumberPattern,
        parsePattern: $6256b66dca390462$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $bcb83626ff750417$export$2e2bcd8739ae039)({
        matchPatterns: $6256b66dca390462$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6256b66dca390462$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $bcb83626ff750417$export$2e2bcd8739ae039)({
        matchPatterns: $6256b66dca390462$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6256b66dca390462$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $bcb83626ff750417$export$2e2bcd8739ae039)({
        matchPatterns: $6256b66dca390462$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6256b66dca390462$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $bcb83626ff750417$export$2e2bcd8739ae039)({
        matchPatterns: $6256b66dca390462$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6256b66dca390462$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $bcb83626ff750417$export$2e2bcd8739ae039)({
        matchPatterns: $6256b66dca390462$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6256b66dca390462$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $6256b66dca390462$export$2e2bcd8739ae039 = $6256b66dca390462$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $aaf50d37016ddcb1$var$locale = {
    code: "en-US",
    formatDistance: (0, $8617db99f2cb39a3$export$2e2bcd8739ae039),
    formatLong: (0, $c8014f25de2be27f$export$2e2bcd8739ae039),
    formatRelative: (0, $06efd8cc10c4bd73$export$2e2bcd8739ae039),
    localize: (0, $a6959687464919d6$export$2e2bcd8739ae039),
    match: (0, $6256b66dca390462$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $aaf50d37016ddcb1$export$2e2bcd8739ae039 = $aaf50d37016ddcb1$var$locale;


var $b211592c26324d97$export$2e2bcd8739ae039 = (0, $aaf50d37016ddcb1$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $e91dd50cc5cd7f0e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $e91dd50cc5cd7f0e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $e91dd50cc5cd7f0e$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $e91dd50cc5cd7f0e$var$doubleQuoteRegExp = /''/g;
var $e91dd50cc5cd7f0e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $e91dd50cc5cd7f0e$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $9eacf000ef47a2dd$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $b211592c26324d97$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $5663a6fd5511e169$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $63dba254cf419de0$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $8eaa0dace66c235b$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($e91dd50cc5cd7f0e$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $9bb5cf506dd06653$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($e91dd50cc5cd7f0e$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $e91dd50cc5cd7f0e$var$cleanEscapedString(substring);
        var formatter = (0, $281a2e82d409b287$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $065cceb4149e3fc5$export$c6b49d6dceb604a1)(substring)) (0, $065cceb4149e3fc5$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $065cceb4149e3fc5$export$c6cc36aa33304772)(substring)) (0, $065cceb4149e3fc5$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($e91dd50cc5cd7f0e$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $e91dd50cc5cd7f0e$var$cleanEscapedString(input) {
    var matched = input.match($e91dd50cc5cd7f0e$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($e91dd50cc5cd7f0e$var$doubleQuoteRegExp, "'");
}



function $e69e5a70118ffe6b$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}



function $17c3ff3944cd98da$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}



function $c7a5375f03b0a15d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $c5045487affbaf52$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfDay = (0, $c7a5375f03b0a15d$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $c7a5375f03b0a15d$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}


class $80c283ff85dafb88$var$DayCell extends (0, $bh6RR.Component) {
    constructor(props, context){
        super(props, context);
        this.state = {
            hover: false,
            active: false
        };
    }
    handleKeyEvent = (event)=>{
        const { day: day, onMouseDown: onMouseDown, onMouseUp: onMouseUp } = this.props;
        if ([
            13 /* space */ ,
            32 /* enter */ 
        ].includes(event.keyCode)) {
            if (event.type === "keydown") onMouseDown(day);
            else onMouseUp(day);
        }
    };
    handleMouseEvent = (event)=>{
        const { day: day, disabled: disabled, onPreviewChange: onPreviewChange, onMouseEnter: onMouseEnter, onMouseDown: onMouseDown, onMouseUp: onMouseUp } = this.props;
        const stateChanges = {};
        if (disabled) {
            onPreviewChange();
            return;
        }
        switch(event.type){
            case "mouseenter":
                onMouseEnter(day);
                onPreviewChange(day);
                stateChanges.hover = true;
                break;
            case "blur":
            case "mouseleave":
                stateChanges.hover = false;
                break;
            case "mousedown":
                stateChanges.active = true;
                onMouseDown(day);
                break;
            case "mouseup":
                event.stopPropagation();
                stateChanges.active = false;
                onMouseUp(day);
                break;
            case "focus":
                onPreviewChange(day);
                break;
        }
        if (Object.keys(stateChanges).length) this.setState(stateChanges);
    };
    getClassNames = ()=>{
        const { isPassive: isPassive, isToday: isToday, isWeekend: isWeekend, isStartOfWeek: isStartOfWeek, isEndOfWeek: isEndOfWeek, isStartOfMonth: isStartOfMonth, isEndOfMonth: isEndOfMonth, disabled: disabled, styles: styles } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))(styles.day, {
            [styles.dayPassive]: isPassive,
            [styles.dayDisabled]: disabled,
            [styles.dayToday]: isToday,
            [styles.dayWeekend]: isWeekend,
            [styles.dayStartOfWeek]: isStartOfWeek,
            [styles.dayEndOfWeek]: isEndOfWeek,
            [styles.dayStartOfMonth]: isStartOfMonth,
            [styles.dayEndOfMonth]: isEndOfMonth,
            [styles.dayHovered]: this.state.hover,
            [styles.dayActive]: this.state.active
        });
    };
    renderPreviewPlaceholder = ()=>{
        const { preview: preview, day: day, styles: styles } = this.props;
        if (!preview) return null;
        const startDate = preview.startDate ? (0, $3434eb5bab1e76df$export$2e2bcd8739ae039)(preview.startDate) : null;
        const endDate = preview.endDate ? (0, $c7a5375f03b0a15d$export$2e2bcd8739ae039)(preview.endDate) : null;
        const isInRange = (!startDate || (0, $e69e5a70118ffe6b$export$2e2bcd8739ae039)(day, startDate)) && (!endDate || (0, $17c3ff3944cd98da$export$2e2bcd8739ae039)(day, endDate));
        const isStartEdge = !isInRange && (0, $c5045487affbaf52$export$2e2bcd8739ae039)(day, startDate);
        const isEndEdge = !isInRange && (0, $c5045487affbaf52$export$2e2bcd8739ae039)(day, endDate);
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))({
                [styles.dayStartPreview]: isStartEdge,
                [styles.dayInPreview]: isInRange,
                [styles.dayEndPreview]: isEndEdge
            }),
            style: {
                color: preview.color
            }
        });
    };
    renderSelectionPlaceholders = ()=>{
        const { styles: styles, ranges: ranges, day: day } = this.props;
        if (this.props.displayMode === "date") {
            let isSelected = (0, $c5045487affbaf52$export$2e2bcd8739ae039)(this.props.day, this.props.date);
            return isSelected ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                className: styles.selected,
                style: {
                    color: this.props.color
                }
            }) : null;
        }
        const inRanges = ranges.reduce((result, range)=>{
            let startDate = range.startDate;
            let endDate = range.endDate;
            if (startDate && endDate && (0, $17c3ff3944cd98da$export$2e2bcd8739ae039)(endDate, startDate)) [startDate, endDate] = [
                endDate,
                startDate
            ];
            startDate = startDate ? (0, $3434eb5bab1e76df$export$2e2bcd8739ae039)(startDate) : null;
            endDate = endDate ? (0, $c7a5375f03b0a15d$export$2e2bcd8739ae039)(endDate) : null;
            const isInRange = (!startDate || (0, $e69e5a70118ffe6b$export$2e2bcd8739ae039)(day, startDate)) && (!endDate || (0, $17c3ff3944cd98da$export$2e2bcd8739ae039)(day, endDate));
            const isStartEdge = !isInRange && (0, $c5045487affbaf52$export$2e2bcd8739ae039)(day, startDate);
            const isEndEdge = !isInRange && (0, $c5045487affbaf52$export$2e2bcd8739ae039)(day, endDate);
            if (isInRange || isStartEdge || isEndEdge) return [
                ...result,
                {
                    isStartEdge: isStartEdge,
                    isEndEdge: isEndEdge,
                    isInRange: isInRange,
                    ...range
                }
            ];
            return result;
        }, []);
        return inRanges.map((range, i)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))({
                    [styles.startEdge]: range.isStartEdge,
                    [styles.endEdge]: range.isEndEdge,
                    [styles.inRange]: range.isInRange
                }),
                style: {
                    color: range.color || this.props.color
                }
            }, i));
    };
    render() {
        const { dayContentRenderer: dayContentRenderer } = this.props;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
            type: "button",
            onMouseEnter: this.handleMouseEvent,
            onMouseLeave: this.handleMouseEvent,
            onFocus: this.handleMouseEvent,
            onMouseDown: this.handleMouseEvent,
            onMouseUp: this.handleMouseEvent,
            onBlur: this.handleMouseEvent,
            onPauseCapture: this.handleMouseEvent,
            onKeyDown: this.handleKeyEvent,
            onKeyUp: this.handleKeyEvent,
            className: this.getClassNames(this.props.styles),
            ...this.props.disabled || this.props.isPassive ? {
                tabIndex: -1
            } : {},
            style: {
                color: this.props.color
            },
            children: [
                this.renderSelectionPlaceholders(),
                this.renderPreviewPlaceholder(),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: this.props.styles.dayNumber,
                    children: dayContentRenderer?.(this.props.day) || /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        children: (0, $e91dd50cc5cd7f0e$export$2e2bcd8739ae039)(this.props.day, this.props.dayDisplayFormat)
                    })
                })
            ]
        });
    }
}
$80c283ff85dafb88$var$DayCell.defaultProps = {};
const $80c283ff85dafb88$export$98793868965e5ef7 = (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).shape({
    startDate: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    endDate: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    key: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    showDateDisplay: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool
});
$80c283ff85dafb88$var$DayCell.propTypes = {
    day: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object.isRequired,
    dayDisplayFormat: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    date: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    ranges: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).arrayOf($80c283ff85dafb88$export$98793868965e5ef7),
    preview: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).shape({
        startDate: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
        endDate: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
        color: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string
    }),
    onPreviewChange: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    previewColor: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    isPassive: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    isToday: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    isWeekend: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    isStartOfWeek: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    isEndOfWeek: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    isStartOfMonth: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    isEndOfMonth: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    displayMode: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).oneOf([
        "dateRange",
        "date"
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    onMouseDown: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    onMouseUp: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    dayContentRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func
};
var $80c283ff85dafb88$export$2e2bcd8739ae039 = $80c283ff85dafb88$var$DayCell;


/* eslint-disable no-fallthrough */ 

var $bh6RR = parcelRequire("bh6RR");

var $eCfBx = parcelRequire("eCfBx");



function $d464c5edb4a88ee1$export$2e2bcd8739ae039(dirtyInterval, options) {
    var _options$step;
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $f741f874145d0154$export$2e2bcd8739ae039)(interval.start);
    var endDate = (0, $f741f874145d0154$export$2e2bcd8739ae039)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError("Invalid interval");
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError("`options.step` must be a number greater than 1");
    while(currentDate.getTime() <= endTime){
        dates.push((0, $f741f874145d0154$export$2e2bcd8739ae039)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}





function $a16aa884d52fc460$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $9eacf000ef47a2dd$export$430a3269e24b912e)();
    var weekStartsOn = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $f7a978e6e9628d05$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    return day === 0 || day === 6;
}



function $c1cb2fb95fbd857a$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var time = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var startTime = (0, $f741f874145d0154$export$2e2bcd8739ae039)(interval.start).getTime();
    var endTime = (0, $f741f874145d0154$export$2e2bcd8739ae039)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError("Invalid interval");
    return time >= startTime && time <= endTime;
}





function $7482736b8e287f15$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $9eacf000ef47a2dd$export$430a3269e24b912e)();
    var weekStartsOn = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}






function $d4cc3831797a4057$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}




var $b50469c0909a5344$var$MILLISECONDS_IN_DAY = 86400000;
function $b50469c0909a5344$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $c7a5375f03b0a15d$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $c7a5375f03b0a15d$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $63dba254cf419de0$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $63dba254cf419de0$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $b50469c0909a5344$var$MILLISECONDS_IN_DAY);
}



function $b3f16299565f3818$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}



function $0a7394535777dacf$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $ee3612bcc22c95f6$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}


function $5daab16bab438d51$export$9fdc2db1e21805d(currentFocusedDate, props) {
    const { shownDate: shownDate, date: date, months: months, ranges: ranges, focusedRange: focusedRange, displayMode: displayMode } = props;
    // find primary date according the props
    let targetInterval;
    if (displayMode === "dateRange") {
        const range = ranges[focusedRange[0]] || {};
        targetInterval = {
            start: range.startDate,
            end: range.endDate
        };
    } else targetInterval = {
        start: date,
        end: date
    };
    targetInterval.start = (0, $ee3612bcc22c95f6$export$2e2bcd8739ae039)(targetInterval.start || new Date());
    targetInterval.end = (0, $0a7394535777dacf$export$2e2bcd8739ae039)(targetInterval.end || targetInterval.start);
    const targetDate = targetInterval.start || targetInterval.end || shownDate || new Date();
    // initial focus
    if (!currentFocusedDate) return shownDate || targetDate;
    // // just return targetDate for native scrolled calendars
    // if (props.scroll.enabled) return targetDate;
    if ((0, $b3f16299565f3818$export$2e2bcd8739ae039)(targetInterval.start, targetInterval.end) > months) // don't change focused if new selection in view area
    return currentFocusedDate;
    return targetDate;
}
function $5daab16bab438d51$export$e9c2db745e2566d3(ranges, currentRangeIndex = -1) {
    const nextIndex = ranges.findIndex((range, i)=>i > currentRangeIndex && range.autoFocus !== false && !range.disabled);
    if (nextIndex !== -1) return nextIndex;
    return ranges.findIndex((range)=>range.autoFocus !== false && !range.disabled);
}
function $5daab16bab438d51$export$d0d420211d7446eb(date, dateOptions, fixedHeight) {
    const startDateOfMonth = (0, $ee3612bcc22c95f6$export$2e2bcd8739ae039)(date, dateOptions);
    const endDateOfMonth = (0, $0a7394535777dacf$export$2e2bcd8739ae039)(date, dateOptions);
    const startDateOfCalendar = (0, $7482736b8e287f15$export$2e2bcd8739ae039)(startDateOfMonth, dateOptions);
    let endDateOfCalendar = (0, $a16aa884d52fc460$export$2e2bcd8739ae039)(endDateOfMonth, dateOptions);
    if (fixedHeight && (0, $b50469c0909a5344$export$2e2bcd8739ae039)(endDateOfCalendar, startDateOfCalendar) <= 34) endDateOfCalendar = (0, $d4cc3831797a4057$export$2e2bcd8739ae039)(endDateOfCalendar, 7);
    return {
        start: startDateOfCalendar,
        end: endDateOfCalendar,
        startDateOfMonth: startDateOfMonth,
        endDateOfMonth: endDateOfMonth
    };
}
function $5daab16bab438d51$export$593755c5b8f32d8f(sources) {
    if (!sources.length) return {};
    const generatedStyles = sources.filter((source)=>Boolean(source)).reduce((styles, styleSource)=>{
        Object.keys(styleSource).forEach((key)=>{
            styles[key] = (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))(styles[key], styleSource[key]);
        });
        return styles;
    }, {});
    return generatedStyles;
}


function $b298a150cfe97208$var$renderWeekdays(styles, dateOptions, weekdayDisplayFormat) {
    const now = new Date();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: styles.weekDays,
        children: (0, $d464c5edb4a88ee1$export$2e2bcd8739ae039)({
            start: (0, $7482736b8e287f15$export$2e2bcd8739ae039)(now, dateOptions),
            end: (0, $a16aa884d52fc460$export$2e2bcd8739ae039)(now, dateOptions)
        }).map((day, i)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                className: styles.weekDay,
                children: (0, $e91dd50cc5cd7f0e$export$2e2bcd8739ae039)(day, weekdayDisplayFormat, dateOptions)
            }, i))
    });
}
class $b298a150cfe97208$var$Month extends (0, $bh6RR.PureComponent) {
    render() {
        const now = new Date();
        const { displayMode: displayMode, focusedRange: focusedRange, drag: drag, styles: styles, disabledDates: disabledDates, disabledDay: disabledDay } = this.props;
        const minDate = this.props.minDate && (0, $c7a5375f03b0a15d$export$2e2bcd8739ae039)(this.props.minDate);
        const maxDate = this.props.maxDate && (0, $3434eb5bab1e76df$export$2e2bcd8739ae039)(this.props.maxDate);
        const monthDisplay = (0, $5daab16bab438d51$export$d0d420211d7446eb)(this.props.month, this.props.dateOptions, this.props.fixedHeight);
        let ranges = this.props.ranges;
        if (displayMode === "dateRange" && drag.status) {
            let { startDate: startDate, endDate: endDate } = drag.range;
            ranges = ranges.map((range, i)=>{
                if (i !== focusedRange[0]) return range;
                return {
                    ...range,
                    startDate: startDate,
                    endDate: endDate
                };
            });
        }
        const showPreview = this.props.showPreview && !drag.disablePreview;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: styles.month,
            style: this.props.style,
            children: [
                this.props.showMonthName ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: styles.monthName,
                    children: (0, $e91dd50cc5cd7f0e$export$2e2bcd8739ae039)(this.props.month, this.props.monthDisplayFormat, this.props.dateOptions)
                }) : null,
                this.props.showWeekDays && $b298a150cfe97208$var$renderWeekdays(styles, this.props.dateOptions, this.props.weekdayDisplayFormat),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: styles.days,
                    onMouseLeave: this.props.onMouseLeave,
                    children: (0, $d464c5edb4a88ee1$export$2e2bcd8739ae039)({
                        start: monthDisplay.start,
                        end: monthDisplay.end
                    }).map((day, index)=>{
                        const isStartOfMonth = (0, $c5045487affbaf52$export$2e2bcd8739ae039)(day, monthDisplay.startDateOfMonth);
                        const isEndOfMonth = (0, $c5045487affbaf52$export$2e2bcd8739ae039)(day, monthDisplay.endDateOfMonth);
                        const isOutsideMinMax = minDate && (0, $17c3ff3944cd98da$export$2e2bcd8739ae039)(day, minDate) || maxDate && (0, $e69e5a70118ffe6b$export$2e2bcd8739ae039)(day, maxDate);
                        const isDisabledSpecifically = disabledDates.some((disabledDate)=>(0, $c5045487affbaf52$export$2e2bcd8739ae039)(disabledDate, day));
                        const isDisabledDay = disabledDay(day);
                        return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $80c283ff85dafb88$export$2e2bcd8739ae039), {
                            ...this.props,
                            ranges: ranges,
                            day: day,
                            preview: showPreview ? this.props.preview : null,
                            isWeekend: (0, $f7a978e6e9628d05$export$2e2bcd8739ae039)(day, this.props.dateOptions),
                            isToday: (0, $c5045487affbaf52$export$2e2bcd8739ae039)(day, now),
                            isStartOfWeek: (0, $c5045487affbaf52$export$2e2bcd8739ae039)(day, (0, $7482736b8e287f15$export$2e2bcd8739ae039)(day, this.props.dateOptions)),
                            isEndOfWeek: (0, $c5045487affbaf52$export$2e2bcd8739ae039)(day, (0, $a16aa884d52fc460$export$2e2bcd8739ae039)(day, this.props.dateOptions)),
                            isStartOfMonth: isStartOfMonth,
                            isEndOfMonth: isEndOfMonth,
                            key: index,
                            disabled: isOutsideMinMax || isDisabledSpecifically || isDisabledDay,
                            isPassive: !(0, $c1cb2fb95fbd857a$export$2e2bcd8739ae039)(day, {
                                start: monthDisplay.startDateOfMonth,
                                end: monthDisplay.endDateOfMonth
                            }),
                            styles: styles,
                            onMouseDown: this.props.onDragSelectionStart,
                            onMouseUp: this.props.onDragSelectionEnd,
                            onMouseEnter: this.props.onDragSelectionMove,
                            dragRange: drag.range,
                            drag: drag.status
                        });
                    })
                })
            ]
        });
    }
}
$b298a150cfe97208$var$Month.defaultProps = {};
$b298a150cfe97208$var$Month.propTypes = {
    style: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    month: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    drag: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    dateOptions: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    disabledDates: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).array,
    disabledDay: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    preview: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).shape({
        startDate: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
        endDate: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object
    }),
    showPreview: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    displayMode: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).oneOf([
        "dateRange",
        "date"
    ]),
    minDate: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    ranges: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).arrayOf((0, $80c283ff85dafb88$export$98793868965e5ef7)),
    focusedRange: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).number),
    onDragSelectionStart: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    onDragSelectionEnd: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    onDragSelectionMove: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    monthDisplayFormat: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    weekdayDisplayFormat: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    dayDisplayFormat: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    showWeekDays: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    showMonthName: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    fixedHeight: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool
};
var $b298a150cfe97208$export$2e2bcd8739ae039 = $b298a150cfe97208$var$Month;




var $bh6RR = parcelRequire("bh6RR");

var $eCfBx = parcelRequire("eCfBx");



function $afdc40e50ef8ccc8$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyLeftDate);
    var dateRight = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}


function $9031f7f2924753e9$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $708ce1d4f20bd938$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $9031f7f2924753e9$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $9031f7f2924753e9$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $561472df61666821$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $708ce1d4f20bd938$export$2e2bcd8739ae039)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}





function $3e5d6d2694ed7592$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}







function $cb0e0834598ff6d6$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $ca073d81f2a471af$export$2e2bcd8739ae039(t, e) {
    return $ca073d81f2a471af$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $ca073d81f2a471af$export$2e2bcd8739ae039(t, e);
}


function $5751042f9a4a77f6$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $ca073d81f2a471af$export$2e2bcd8739ae039)(t, e);
}


function $ea07a931d040ec2a$export$2e2bcd8739ae039(t) {
    return $ea07a931d040ec2a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $ea07a931d040ec2a$export$2e2bcd8739ae039(t);
}


function $1617589007256c62$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1617589007256c62$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}




function $c345de07753d2fca$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(t);
}


function $1434f224efb0ce22$export$2e2bcd8739ae039(t) {
    var r = (0, $1617589007256c62$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $ea07a931d040ec2a$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $c345de07753d2fca$export$2e2bcd8739ae039)(this, e);
    };
}


function $b230bc0d4245014d$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}




function $94d637ce061dd3ca$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $d0643fe154cb74c1$export$2e2bcd8739ae039(t) {
    var i = (0, $94d637ce061dd3ca$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $eebcda4657ff09bb$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $d0643fe154cb74c1$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $eebcda4657ff09bb$export$2e2bcd8739ae039(e, r, t) {
    return r && $eebcda4657ff09bb$var$_defineProperties(e.prototype, r), t && $eebcda4657ff09bb$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $1c78c172f6af0e63$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $d0643fe154cb74c1$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


var $87d5274f95235e24$var$TIMEZONE_UNIT_PRIORITY = 10;
var $87d5274f95235e24$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, Setter);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(this, "subPriority", 0);
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $87d5274f95235e24$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(ValueSetter, _Setter);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($87d5274f95235e24$export$81d53e3678089a6);
var $87d5274f95235e24$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this2), "priority", $87d5274f95235e24$var$TIMEZONE_UNIT_PRIORITY);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($87d5274f95235e24$export$81d53e3678089a6);












var $d0b06d02a4758be0$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, Parser);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(this, "incompatibleTokens", void 0);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)(this, "subPriority", void 0);
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $87d5274f95235e24$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();


var $ebe8ec790bf47813$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(EraParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(EraParser);
    function EraParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 140);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));









/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $4fd2c93311e78e29$export$dfd9b671c89acc8e = 7;
var $4fd2c93311e78e29$export$3913210603d8e9ae = 365.2425;
var $4fd2c93311e78e29$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $4fd2c93311e78e29$export$91246f0b9bd9beff = 60000;
var $4fd2c93311e78e29$export$7f72910d6dfd237a = 3600000;
var $4fd2c93311e78e29$export$397c2d5776aa9055 = 1000;
var $4fd2c93311e78e29$export$4dec998e48f9c246 = -$4fd2c93311e78e29$export$81caae6e1cc7a622;
var $4fd2c93311e78e29$export$f2f5ae5a8e2d8f9f = 60;
var $4fd2c93311e78e29$export$3c58128db900d44e = 3;
var $4fd2c93311e78e29$export$80d7e435f744f319 = 12;
var $4fd2c93311e78e29$export$4db7641526e3241f = 4;
var $4fd2c93311e78e29$export$698aec755e92c695 = 3600;
var $4fd2c93311e78e29$export$a77c1a7ebebe2a5a = 60;
var $4fd2c93311e78e29$export$815a9362476d2fe3 = $4fd2c93311e78e29$export$698aec755e92c695 * 24;
var $4fd2c93311e78e29$export$34804a017b31e2fe = $4fd2c93311e78e29$export$815a9362476d2fe3 * 7;
var $4fd2c93311e78e29$export$7271e9e3478110d1 = $4fd2c93311e78e29$export$815a9362476d2fe3 * $4fd2c93311e78e29$export$3913210603d8e9ae;
var $4fd2c93311e78e29$export$8e6600bbdee7dabb = $4fd2c93311e78e29$export$7271e9e3478110d1 / 12;
var $4fd2c93311e78e29$export$be1dccf2de902d31 = $4fd2c93311e78e29$export$8e6600bbdee7dabb * 3;


var $d068e9ab48ef4207$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $d068e9ab48ef4207$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $23c73e81834f16a1$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $23c73e81834f16a1$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $23c73e81834f16a1$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $4fd2c93311e78e29$export$7f72910d6dfd237a) + minutes * (0, $4fd2c93311e78e29$export$91246f0b9bd9beff) + seconds * (0, $4fd2c93311e78e29$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $23c73e81834f16a1$export$d931c43c4608a164(dateString) {
    return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $d068e9ab48ef4207$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $23c73e81834f16a1$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $d068e9ab48ef4207$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $d068e9ab48ef4207$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $d068e9ab48ef4207$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $d068e9ab48ef4207$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $23c73e81834f16a1$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $d068e9ab48ef4207$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $d068e9ab48ef4207$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $d068e9ab48ef4207$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $d068e9ab48ef4207$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $23c73e81834f16a1$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $23c73e81834f16a1$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $23c73e81834f16a1$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


var $549855817f3e82c6$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(YearParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(YearParser);
    function YearParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)((0, $23c73e81834f16a1$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case "yo":
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)((0, $23c73e81834f16a1$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $23c73e81834f16a1$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));












var $87522dd793180ae9$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(LocalWeekYearParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)((0, $23c73e81834f16a1$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)((0, $23c73e81834f16a1$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $a33305f247e30adc$export$2e2bcd8739ae039)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $23c73e81834f16a1$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $ddad3c02657f84fd$export$2e2bcd8739ae039)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $ddad3c02657f84fd$export$2e2bcd8739ae039)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));











var $a84e016bf722cd37$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(ISOWeekYearParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, $23c73e81834f16a1$export$2c9307b2e29c533c)(4, dateString);
                return (0, $23c73e81834f16a1$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $869ba20767f1348a$export$2e2bcd8739ae039)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));










var $81af78f43f454158$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(ExtendedYearParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, $23c73e81834f16a1$export$2c9307b2e29c533c)(4, dateString);
                return (0, $23c73e81834f16a1$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));










var $6faf6842e3324a5b$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(QuarterParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, $23c73e81834f16a1$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));










var $b64081c42280f47c$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(StandAloneQuarterParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, $23c73e81834f16a1$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));











var $33cccf8698e26325$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(MonthParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 110);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)((0, $23c73e81834f16a1$export$cc7cc9e2a3ff9388)((0, $d068e9ab48ef4207$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)((0, $23c73e81834f16a1$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));











var $f4a12364ed86f021$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(StandAloneMonthParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 110);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)((0, $23c73e81834f16a1$export$cc7cc9e2a3ff9388)((0, $d068e9ab48ef4207$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)((0, $23c73e81834f16a1$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));















function $9d41a7323856a4d2$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $8771fceed12cf89e$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $f116c747f72ce972$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(LocalWeekParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, $23c73e81834f16a1$export$cc7cc9e2a3ff9388)((0, $d068e9ab48ef4207$export$c123ee06d9da8480).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $23c73e81834f16a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $ddad3c02657f84fd$export$2e2bcd8739ae039)((0, $9d41a7323856a4d2$export$2e2bcd8739ae039)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));















function $abb8018924dbdc39$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var isoWeek = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $6e0c4858e45e9a69$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $d557856122cd2900$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(ISOWeekParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, $23c73e81834f16a1$export$cc7cc9e2a3ff9388)((0, $d068e9ab48ef4207$export$c123ee06d9da8480).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $23c73e81834f16a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $869ba20767f1348a$export$2e2bcd8739ae039)((0, $abb8018924dbdc39$export$2e2bcd8739ae039)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));











var $03c2c5a25468de8c$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $03c2c5a25468de8c$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $03c2c5a25468de8c$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(DateParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(DateParser);
    function DateParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "subPriority", 1);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, $23c73e81834f16a1$export$cc7cc9e2a3ff9388)((0, $d068e9ab48ef4207$export$c123ee06d9da8480).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $23c73e81834f16a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $23c73e81834f16a1$export$3d50627710b84d75)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $03c2c5a25468de8c$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $03c2c5a25468de8c$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));











var $c8eb640c9739e432$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(DayOfYearParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "subpriority", 1);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, $23c73e81834f16a1$export$cc7cc9e2a3ff9388)((0, $d068e9ab48ef4207$export$c123ee06d9da8480).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $23c73e81834f16a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $23c73e81834f16a1$export$3d50627710b84d75)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));













function $90f45aecbf821b24$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $9eacf000ef47a2dd$export$430a3269e24b912e)();
    var weekStartsOn = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var day = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $23cc0e1fc897acb6$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(DayParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(DayParser);
    function DayParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $90f45aecbf821b24$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));











var $0eecdc9e9334cc90$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(LocalDayParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)((0, $23c73e81834f16a1$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $90f45aecbf821b24$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));











var $1209d7268c6c9e45$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)((0, $23c73e81834f16a1$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $90f45aecbf821b24$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));













function $38840ad6986b421a$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var day = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $fb6e41e61f98589a$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(ISODayParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, $23c73e81834f16a1$export$513bb01536146ab6)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $38840ad6986b421a$export$2e2bcd8739ae039)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));










var $cd12e5ead675216a$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(AMPMParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $23c73e81834f16a1$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));










var $d3addf314db295bf$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(AMPMMidnightParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $23c73e81834f16a1$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));










var $c9b0e545431616d4$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(DayPeriodParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $23c73e81834f16a1$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));











var $3c80c6964acf8bae$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(Hour1to12Parser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, $23c73e81834f16a1$export$cc7cc9e2a3ff9388)((0, $d068e9ab48ef4207$export$c123ee06d9da8480).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $23c73e81834f16a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));











var $c1720943b4076094$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(Hour0to23Parser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, $23c73e81834f16a1$export$cc7cc9e2a3ff9388)((0, $d068e9ab48ef4207$export$c123ee06d9da8480).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $23c73e81834f16a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));











var $d8af1c30a51245af$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(Hour0To11Parser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, $23c73e81834f16a1$export$cc7cc9e2a3ff9388)((0, $d068e9ab48ef4207$export$c123ee06d9da8480).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $23c73e81834f16a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));











var $43543015b40a6495$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(Hour1To24Parser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, $23c73e81834f16a1$export$cc7cc9e2a3ff9388)((0, $d068e9ab48ef4207$export$c123ee06d9da8480).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $23c73e81834f16a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));











var $399f7706a432e843$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(MinuteParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 60);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, $23c73e81834f16a1$export$cc7cc9e2a3ff9388)((0, $d068e9ab48ef4207$export$c123ee06d9da8480).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, $23c73e81834f16a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));











var $04d6977a32f84464$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(SecondParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 50);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, $23c73e81834f16a1$export$cc7cc9e2a3ff9388)((0, $d068e9ab48ef4207$export$c123ee06d9da8480).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, $23c73e81834f16a1$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));










var $6c4150d24044e0a5$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(FractionOfSecondParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 30);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $23c73e81834f16a1$export$4f84e3a82c7b538)((0, $23c73e81834f16a1$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));











var $3bc7ffa050e36def$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, $23c73e81834f16a1$export$6497f4c0ecdfba8e)((0, $d068e9ab48ef4207$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, $23c73e81834f16a1$export$6497f4c0ecdfba8e)((0, $d068e9ab48ef4207$export$a7ee192b982af9c1).basic, dateString);
                    case "XXXX":
                        return (0, $23c73e81834f16a1$export$6497f4c0ecdfba8e)((0, $d068e9ab48ef4207$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, $23c73e81834f16a1$export$6497f4c0ecdfba8e)((0, $d068e9ab48ef4207$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, $23c73e81834f16a1$export$6497f4c0ecdfba8e)((0, $d068e9ab48ef4207$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));











var $40ddd330e4d7bdd4$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(ISOTimezoneParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, $23c73e81834f16a1$export$6497f4c0ecdfba8e)((0, $d068e9ab48ef4207$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, $23c73e81834f16a1$export$6497f4c0ecdfba8e)((0, $d068e9ab48ef4207$export$a7ee192b982af9c1).basic, dateString);
                    case "xxxx":
                        return (0, $23c73e81834f16a1$export$6497f4c0ecdfba8e)((0, $d068e9ab48ef4207$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, $23c73e81834f16a1$export$6497f4c0ecdfba8e)((0, $d068e9ab48ef4207$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, $23c73e81834f16a1$export$6497f4c0ecdfba8e)((0, $d068e9ab48ef4207$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));










var $7933b4f85229502e$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(TimestampSecondsParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 40);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $23c73e81834f16a1$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));










var $d53372f35b035150$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $5751042f9a4a77f6$export$2e2bcd8739ae039)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $1434f224efb0ce22$export$2e2bcd8739ae039)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $b230bc0d4245014d$export$2e2bcd8739ae039)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "priority", 20);
        (0, $1c78c172f6af0e63$export$2e2bcd8739ae039)((0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $eebcda4657ff09bb$export$2e2bcd8739ae039)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $23c73e81834f16a1$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $d0b06d02a4758be0$export$7acfa6ed01010e37));


var $a06754d708967e28$export$19131010e7fd8373 = {
    G: new (0, $ebe8ec790bf47813$export$8e5a1d3f85a9688)(),
    y: new (0, $549855817f3e82c6$export$48d352de7cd4a988)(),
    Y: new (0, $87522dd793180ae9$export$b8ef38dfcf05d5db)(),
    R: new (0, $a84e016bf722cd37$export$951d1df011fde06f)(),
    u: new (0, $81af78f43f454158$export$bad9d2ea38e8f1a)(),
    Q: new (0, $6faf6842e3324a5b$export$5cb0f701186dde1d)(),
    q: new (0, $b64081c42280f47c$export$300c0c2990e20e6d)(),
    M: new (0, $33cccf8698e26325$export$400dd8b40ef138a3)(),
    L: new (0, $f4a12364ed86f021$export$1d7eaa53eaa5deba)(),
    w: new (0, $f116c747f72ce972$export$c4005ffc174e07c0)(),
    I: new (0, $d557856122cd2900$export$6fc8dbedd560a6af)(),
    d: new (0, $03c2c5a25468de8c$export$e8d4b28a20981dd2)(),
    D: new (0, $c8eb640c9739e432$export$6cfe0d613455f615)(),
    E: new (0, $23cc0e1fc897acb6$export$1b03c8b76262f7bd)(),
    e: new (0, $0eecdc9e9334cc90$export$44d1c127ab42c480)(),
    c: new (0, $1209d7268c6c9e45$export$e447a647caaaec1d)(),
    i: new (0, $fb6e41e61f98589a$export$693fb1e525095b2a)(),
    a: new (0, $cd12e5ead675216a$export$8d1e08492351df91)(),
    b: new (0, $d3addf314db295bf$export$73ca2bd0a17d273)(),
    B: new (0, $c9b0e545431616d4$export$bb9212adf05373db)(),
    h: new (0, $3c80c6964acf8bae$export$8a04050a727a1756)(),
    H: new (0, $c1720943b4076094$export$e56f4dea2c3e56dd)(),
    K: new (0, $d8af1c30a51245af$export$cbbe855312f87d77)(),
    k: new (0, $43543015b40a6495$export$6008046d2b34b6a5)(),
    m: new (0, $399f7706a432e843$export$2b52670d9e2be53)(),
    s: new (0, $04d6977a32f84464$export$94d46d540cf1366a)(),
    S: new (0, $6c4150d24044e0a5$export$b8e6f8b2d70893b1)(),
    X: new (0, $3bc7ffa050e36def$export$104d901d49fea29b)(),
    x: new (0, $40ddd330e4d7bdd4$export$12910e5204b52b9)(),
    t: new (0, $7933b4f85229502e$export$2cd8bf877a05e96)(),
    T: new (0, $d53372f35b035150$export$6d8f69c6906d6368)()
};



// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $a6c0cca4ba136238$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $a6c0cca4ba136238$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $a6c0cca4ba136238$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $a6c0cca4ba136238$var$doubleQuoteRegExp = /''/g;
var $a6c0cca4ba136238$var$notWhitespaceRegExp = /\S/;
var $a6c0cca4ba136238$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $a6c0cca4ba136238$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $9eacf000ef47a2dd$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $b211592c26324d97$export$2e2bcd8739ae039);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $87d5274f95235e24$export$5aaf7ff7f09ea4ee)()
    ];
    var tokens = formatString.match($a6c0cca4ba136238$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $9bb5cf506dd06653$export$2e2bcd8739ae039)) {
            var longFormatter = (0, $9bb5cf506dd06653$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($a6c0cca4ba136238$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $561472df61666821$export$2e2bcd8739ae039)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $065cceb4149e3fc5$export$c6b49d6dceb604a1)(token)) (0, $065cceb4149e3fc5$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $065cceb4149e3fc5$export$c6cc36aa33304772)(token)) (0, $065cceb4149e3fc5$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $a06754d708967e28$export$19131010e7fd8373)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($a6c0cca4ba136238$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $a6c0cca4ba136238$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $a6c0cca4ba136238$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $8eaa0dace66c235b$export$2e2bcd8739ae039)(date, (0, $63dba254cf419de0$export$2e2bcd8739ae039)(date));
    var flags = {};
    var _iterator2 = (0, $561472df61666821$export$2e2bcd8739ae039)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $3e5d6d2694ed7592$export$2e2bcd8739ae039)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $a6c0cca4ba136238$var$cleanEscapedString(input) {
    return input.match($a6c0cca4ba136238$var$escapedStringRegExp)[1].replace($a6c0cca4ba136238$var$doubleQuoteRegExp, "'");
}


class $5a2d3741154e1a7c$var$DateInput extends (0, $bh6RR.PureComponent) {
    constructor(props, context){
        super(props, context);
        this.state = {
            invalid: {
                invalidFormat: false,
                outOfRange: false
            },
            changed: false,
            value: this.formatDate(props)
        };
    }
    componentDidUpdate(prevProps) {
        const { value: value } = prevProps;
        if (!(0, $afdc40e50ef8ccc8$export$2e2bcd8739ae039)(value, this.props.value)) this.setState({
            value: this.formatDate(this.props)
        });
    }
    isValid = (value)=>{
        return {
            isValidFormat: (0, $5663a6fd5511e169$export$2e2bcd8739ae039)(value),
            isInRange: this.props.isDateInRange(value)
        };
    };
    formatDate({ value: value, dateDisplayFormat: dateDisplayFormat, dateOptions: dateOptions }) {
        if (value) {
            const { isInRange: isInRange, isValidFormat: isValidFormat } = this.isValid(value);
            if (isInRange && isValidFormat) return (0, $e91dd50cc5cd7f0e$export$2e2bcd8739ae039)(value, dateDisplayFormat, dateOptions);
        }
        return "";
    }
    update(value) {
        const { invalid: { invalidFormat: invalidFormat, outOfRange: outOfRange }, changed: changed } = this.state;
        if (invalidFormat || outOfRange || !changed || !value) return;
        const { onChange: onChange, dateDisplayFormat: dateDisplayFormat, dateOptions: dateOptions } = this.props;
        const parsed = (0, $a6c0cca4ba136238$export$2e2bcd8739ae039)(value, dateDisplayFormat, new Date(), dateOptions);
        const { isInRange: isInRange, isValidFormat: isValidFormat } = this.isValid(parsed);
        if (isInRange && isValidFormat) this.setState({
            changed: false
        }, ()=>onChange(parsed));
        else this.setState({
            invalid: {
                invalidFormat: !isValidFormat,
                outOfRange: !isInRange
            }
        });
    }
    onKeyDown = (e)=>{
        const { value: value } = this.state;
        if (e.key === "Enter") this.update(value);
    };
    onChange = (e)=>{
        this.setState({
            value: e.target.value,
            changed: true,
            invalid: {
                invalidFormat: false,
                outOfRange: false
            }
        });
    };
    onBlur = ()=>{
        const { value: value } = this.state;
        this.update(value);
    };
    render() {
        const { className: className, readOnly: readOnly, placeholder: placeholder, ariaLabel: ariaLabel, disabled: disabled, onFocus: onFocus, dateDisplayFormat: dateDisplayFormat, dateOptions: dateOptions } = this.props;
        var { value: value, invalid: { invalidFormat: invalidFormat, outOfRange: outOfRange } } = this.state;
        const parsed = (0, $a6c0cca4ba136238$export$2e2bcd8739ae039)(value, dateDisplayFormat, new Date(), dateOptions);
        var { isInRange: isInRange, isValidFormat: isValidFormat } = this.isValid(parsed);
        if (invalidFormat && !isValidFormat == false) invalidFormat = false;
        if (outOfRange && !isInRange == false) outOfRange = false;
        var { min: min, max: max } = this.props.getDateMinAndMax();
        min = (0, $e91dd50cc5cd7f0e$export$2e2bcd8739ae039)(min, dateDisplayFormat, dateOptions);
        max = (0, $e91dd50cc5cd7f0e$export$2e2bcd8739ae039)(max, dateDisplayFormat, dateOptions);
        const tooltipWarningMessage = invalidFormat ? "The date format must be dd/mm/yyyy" : outOfRange ? `The date must be beetween ${min} & ${max}` : "";
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))({
                rdrInvalidDateInput: invalidFormat || outOfRange
            }, "rdrDateInput", className),
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                    readOnly: readOnly,
                    disabled: disabled,
                    value: value,
                    placeholder: placeholder,
                    "aria-label": ariaLabel,
                    onKeyDown: this.onKeyDown,
                    onChange: this.onChange,
                    onBlur: this.onBlur,
                    onFocus: onFocus
                }),
                (invalidFormat || outOfRange) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: "rdrWarning",
                    children: "\u26A0"
                }),
                tooltipWarningMessage && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: "rdrTooltipWarning",
                    children: tooltipWarningMessage
                })
            ]
        });
    }
}
$5a2d3741154e1a7c$var$DateInput.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    dateOptions: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    dateDisplayFormat: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func.isRequired,
    isDateInRange: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func.isRequired,
    getDateMinAndMax: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func.isRequired
};
$5a2d3741154e1a7c$var$DateInput.defaultProps = {
    readOnly: true,
    disabled: false,
    dateDisplayFormat: "MMM D, YYYY"
};
var $5a2d3741154e1a7c$export$2e2bcd8739ae039 = $5a2d3741154e1a7c$var$DateInput;




var $c6fd88e9e7604fcb$exports = {};


(function(global, factory) {
    if (typeof define === "function" && define.amd) define("react-list", [
        "prop-types",
        "react"
    ], factory);
    else {
        var mod;
        factory((parcelRequire("eCfBx")), (parcelRequire("bh6RR")));
    }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : $c6fd88e9e7604fcb$exports, function(_propTypes, _react) {
    "use strict";
    _propTypes = _interopRequireDefault(_propTypes);
    _react = _interopRequireWildcard(_react);
    var _class, _temp;
    function _getRequireWildcardCache() {
        if (typeof WeakMap !== "function") return null;
        var cache = new WeakMap();
        _getRequireWildcardCache = function _getRequireWildcardCache() {
            return cache;
        };
        return cache;
    }
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
            "default": obj
        };
        var cache = _getRequireWildcardCache();
        if (cache && cache.has(obj)) return cache.get(obj);
        var newObj = {};
        var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
            else newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        if (cache) cache.set(obj, newObj);
        return newObj;
    }
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _createSuper(Derived) {
        var hasNativeReflectConstruct = _isNativeReflectConstruct();
        return function _createSuperInternal() {
            var Super = _getPrototypeOf(Derived), result;
            if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return _possibleConstructorReturn(this, result);
        };
    }
    function _possibleConstructorReturn(self1, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
        return _assertThisInitialized(self1);
    }
    function _assertThisInitialized(self1) {
        if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self1;
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    var CLIENT_SIZE_KEYS = {
        x: "clientWidth",
        y: "clientHeight"
    };
    var CLIENT_START_KEYS = {
        x: "clientTop",
        y: "clientLeft"
    };
    var INNER_SIZE_KEYS = {
        x: "innerWidth",
        y: "innerHeight"
    };
    var OFFSET_SIZE_KEYS = {
        x: "offsetWidth",
        y: "offsetHeight"
    };
    var OFFSET_START_KEYS = {
        x: "offsetLeft",
        y: "offsetTop"
    };
    var OVERFLOW_KEYS = {
        x: "overflowX",
        y: "overflowY"
    };
    var SCROLL_SIZE_KEYS = {
        x: "scrollWidth",
        y: "scrollHeight"
    };
    var SCROLL_START_KEYS = {
        x: "scrollLeft",
        y: "scrollTop"
    };
    var SIZE_KEYS = {
        x: "width",
        y: "height"
    };
    var NOOP = function NOOP() {}; // If a browser doesn't support the `options` argument to
    // add/removeEventListener, we need to check, otherwise we will
    // accidentally set `capture` with a truthy value.
    var PASSIVE = function() {
        if (typeof window === "undefined") return false;
        var hasSupport = false;
        try {
            document.createElement("div").addEventListener("test", NOOP, {
                get passive () {
                    hasSupport = true;
                    return false;
                }
            });
        } catch (e) {}
        return hasSupport;
    }() ? {
        passive: true
    } : false;
    var UNSTABLE_MESSAGE = "ReactList failed to reach a stable state.";
    var MAX_SYNC_UPDATES = 40;
    var isEqualSubset = function isEqualSubset(a, b) {
        for(var key in b){
            if (a[key] !== b[key]) return false;
        }
        return true;
    };
    var defaultScrollParentGetter = function defaultScrollParentGetter(component) {
        var axis = component.props.axis;
        var el = component.getEl();
        var overflowKey = OVERFLOW_KEYS[axis];
        while(el = el.parentElement)switch(window.getComputedStyle(el)[overflowKey]){
            case "auto":
            case "scroll":
            case "overlay":
                return el;
        }
        return window;
    };
    var defaultScrollParentViewportSizeGetter = function defaultScrollParentViewportSizeGetter(component) {
        var axis = component.props.axis;
        var scrollParent = component.scrollParent;
        return scrollParent === window ? window[INNER_SIZE_KEYS[axis]] : scrollParent[CLIENT_SIZE_KEYS[axis]];
    };
    var constrain = function constrain(props, state) {
        var length = props.length, minSize = props.minSize, type = props.type;
        var from = state.from, size = state.size, itemsPerRow = state.itemsPerRow;
        size = Math.max(size, minSize);
        var mod = size % itemsPerRow;
        if (mod) size += itemsPerRow - mod;
        if (size > length) size = length;
        from = type === "simple" || !from ? 0 : Math.max(Math.min(from, length - size), 0);
        if (mod = from % itemsPerRow) {
            from -= mod;
            size += mod;
        }
        if (from === state.from && size == state.size) return state;
        return _objectSpread(_objectSpread({}, state), {}, {
            from: from,
            size: size
        });
    };
    $c6fd88e9e7604fcb$exports = (_temp = _class = /*#__PURE__*/ function(_Component) {
        _inherits(ReactList, _Component);
        var _super = _createSuper(ReactList);
        _createClass(ReactList, null, [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(props, state) {
                    var newState = constrain(props, state);
                    return newState === state ? null : newState;
                }
            }
        ]);
        function ReactList(props) {
            var _this;
            _classCallCheck(this, ReactList);
            _this = _super.call(this, props);
            _this.state = constrain(props, {
                itemsPerRow: 1,
                from: props.initialIndex,
                size: 0
            });
            _this.cache = {};
            _this.cachedScrollPosition = null;
            _this.prevPrevState = {};
            _this.unstable = false;
            _this.updateCounter = 0;
            return _this;
        }
        _createClass(ReactList, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.updateFrameAndClearCache = this.updateFrameAndClearCache.bind(this);
                    window.addEventListener("resize", this.updateFrameAndClearCache);
                    this.updateFrame(this.scrollTo.bind(this, this.props.initialIndex));
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    var _this2 = this;
                    // Viewport scroll is no longer useful if axis changes
                    if (this.props.axis !== prevProps.axis) this.clearSizeCache(); // If the list has reached an unstable state, prevent an infinite loop.
                    if (this.unstable) return;
                    if (++this.updateCounter > MAX_SYNC_UPDATES) {
                        this.unstable = true;
                        return console.error(UNSTABLE_MESSAGE);
                    }
                    if (!this.updateCounterTimeoutId) this.updateCounterTimeoutId = setTimeout(function() {
                        _this2.updateCounter = 0;
                        delete _this2.updateCounterTimeoutId;
                    }, 0);
                    this.updateFrame();
                }
            },
            {
                key: "maybeSetState",
                value: function maybeSetState(b, cb) {
                    if (isEqualSubset(this.state, b)) return cb();
                    this.setState(b, cb);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.updateFrameAndClearCache);
                    this.scrollParent.removeEventListener("scroll", this.updateFrameAndClearCache, PASSIVE);
                    this.scrollParent.removeEventListener("mousewheel", NOOP, PASSIVE);
                }
            },
            {
                key: "getOffset",
                value: function getOffset(el) {
                    var axis = this.props.axis;
                    var offset = el[CLIENT_START_KEYS[axis]] || 0;
                    var offsetKey = OFFSET_START_KEYS[axis];
                    do offset += el[offsetKey] || 0;
                    while (el = el.offsetParent);
                    return offset;
                }
            },
            {
                key: "getEl",
                value: function getEl() {
                    return this.el || this.items;
                }
            },
            {
                key: "getScrollPosition",
                value: function getScrollPosition() {
                    // Cache scroll position as this causes a forced synchronous layout.
                    if (typeof this.cachedScrollPosition === "number") return this.cachedScrollPosition;
                    var scrollParent = this.scrollParent;
                    var axis = this.props.axis;
                    var scrollKey = SCROLL_START_KEYS[axis];
                    var actual = scrollParent === window ? // always return document.documentElement[scrollKey] as 0, so take
                    // whichever has a value.
                    document.body[scrollKey] || document.documentElement[scrollKey] : scrollParent[scrollKey];
                    var max = this.getScrollSize() - this.props.scrollParentViewportSizeGetter(this);
                    var scroll = Math.max(0, Math.min(actual, max));
                    var el = this.getEl();
                    this.cachedScrollPosition = this.getOffset(scrollParent) + scroll - this.getOffset(el);
                    return this.cachedScrollPosition;
                }
            },
            {
                key: "setScroll",
                value: function setScroll(offset) {
                    var scrollParent = this.scrollParent;
                    var axis = this.props.axis;
                    offset += this.getOffset(this.getEl());
                    if (scrollParent === window) return window.scrollTo(0, offset);
                    offset -= this.getOffset(this.scrollParent);
                    scrollParent[SCROLL_START_KEYS[axis]] = offset;
                }
            },
            {
                key: "getScrollSize",
                value: function getScrollSize() {
                    var scrollParent = this.scrollParent;
                    var _document = document, body = _document.body, documentElement = _document.documentElement;
                    var key = SCROLL_SIZE_KEYS[this.props.axis];
                    return scrollParent === window ? Math.max(body[key], documentElement[key]) : scrollParent[key];
                }
            },
            {
                key: "hasDeterminateSize",
                value: function hasDeterminateSize() {
                    var _this$props = this.props, itemSizeGetter = _this$props.itemSizeGetter, type = _this$props.type;
                    return type === "uniform" || itemSizeGetter;
                }
            },
            {
                key: "getStartAndEnd",
                value: function getStartAndEnd() {
                    var threshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.threshold;
                    var scroll = this.getScrollPosition();
                    var start = Math.max(0, scroll - threshold);
                    var end = scroll + this.props.scrollParentViewportSizeGetter(this) + threshold;
                    if (this.hasDeterminateSize()) end = Math.min(end, this.getSpaceBefore(this.props.length));
                    return {
                        start: start,
                        end: end
                    };
                }
            },
            {
                key: "getItemSizeAndItemsPerRow",
                value: function getItemSizeAndItemsPerRow() {
                    var _this$props2 = this.props, axis = _this$props2.axis, useStaticSize = _this$props2.useStaticSize;
                    var _this$state = this.state, itemSize = _this$state.itemSize, itemsPerRow = _this$state.itemsPerRow;
                    if (useStaticSize && itemSize && itemsPerRow) return {
                        itemSize: itemSize,
                        itemsPerRow: itemsPerRow
                    };
                    var itemEls = this.items.children;
                    if (!itemEls.length) return {};
                    var firstEl = itemEls[0]; // Firefox has a problem where it will return a *slightly* (less than
                    // thousandths of a pixel) different size for the same element between
                    // renders. This can cause an infinite render loop, so only change the
                    // itemSize when it is significantly different.
                    var firstElSize = firstEl[OFFSET_SIZE_KEYS[axis]];
                    var delta = Math.abs(firstElSize - itemSize);
                    if (isNaN(delta) || delta >= 1) itemSize = firstElSize;
                    if (!itemSize) return {};
                    var startKey = OFFSET_START_KEYS[axis];
                    var firstStart = firstEl[startKey];
                    itemsPerRow = 1;
                    for(var item = itemEls[itemsPerRow]; item && item[startKey] === firstStart; item = itemEls[itemsPerRow])++itemsPerRow;
                    return {
                        itemSize: itemSize,
                        itemsPerRow: itemsPerRow
                    };
                }
            },
            {
                key: "clearSizeCache",
                value: function clearSizeCache() {
                    this.cachedScrollPosition = null;
                } // Called by 'scroll' and 'resize' events, clears scroll position cache.
            },
            {
                key: "updateFrameAndClearCache",
                value: function updateFrameAndClearCache(cb) {
                    this.clearSizeCache();
                    return this.updateFrame(cb);
                }
            },
            {
                key: "updateFrame",
                value: function updateFrame(cb) {
                    this.updateScrollParent();
                    if (typeof cb != "function") cb = NOOP;
                    switch(this.props.type){
                        case "simple":
                            return this.updateSimpleFrame(cb);
                        case "variable":
                            return this.updateVariableFrame(cb);
                        case "uniform":
                            return this.updateUniformFrame(cb);
                    }
                }
            },
            {
                key: "updateScrollParent",
                value: function updateScrollParent() {
                    var prev = this.scrollParent;
                    this.scrollParent = this.props.scrollParentGetter(this);
                    if (prev === this.scrollParent) return;
                    if (prev) {
                        prev.removeEventListener("scroll", this.updateFrameAndClearCache);
                        prev.removeEventListener("mousewheel", NOOP);
                    } // If we have a new parent, cached parent dimensions are no longer useful.
                    this.clearSizeCache();
                    this.scrollParent.addEventListener("scroll", this.updateFrameAndClearCache, PASSIVE); // You have to attach mousewheel listener to the scrollable element.
                    // Just an empty listener. After that onscroll events will be fired synchronously.
                    this.scrollParent.addEventListener("mousewheel", NOOP, PASSIVE);
                }
            },
            {
                key: "updateSimpleFrame",
                value: function updateSimpleFrame(cb) {
                    var _this$getStartAndEnd = this.getStartAndEnd(), end = _this$getStartAndEnd.end;
                    var itemEls = this.items.children;
                    var elEnd = 0;
                    if (itemEls.length) {
                        var axis = this.props.axis;
                        var firstItemEl = itemEls[0];
                        var lastItemEl = itemEls[itemEls.length - 1];
                        elEnd = this.getOffset(lastItemEl) + lastItemEl[OFFSET_SIZE_KEYS[axis]] - this.getOffset(firstItemEl);
                    }
                    if (elEnd > end) return cb();
                    var _this$props3 = this.props, pageSize = _this$props3.pageSize, length = _this$props3.length;
                    var size = Math.min(this.state.size + pageSize, length);
                    this.maybeSetState({
                        size: size
                    }, cb);
                }
            },
            {
                key: "updateVariableFrame",
                value: function updateVariableFrame(cb) {
                    if (!this.props.itemSizeGetter) this.cacheSizes();
                    var _this$getStartAndEnd2 = this.getStartAndEnd(), start = _this$getStartAndEnd2.start, end = _this$getStartAndEnd2.end;
                    var _this$props4 = this.props, length = _this$props4.length, pageSize = _this$props4.pageSize;
                    var space = 0;
                    var from = 0;
                    var size = 0;
                    var maxFrom = length - 1;
                    while(from < maxFrom){
                        var itemSize = this.getSizeOfItem(from);
                        if (itemSize == null || space + itemSize > start) break;
                        space += itemSize;
                        ++from;
                    }
                    var maxSize = length - from;
                    while(size < maxSize && space < end){
                        var _itemSize = this.getSizeOfItem(from + size);
                        if (_itemSize == null) {
                            size = Math.min(size + pageSize, maxSize);
                            break;
                        }
                        space += _itemSize;
                        ++size;
                    }
                    this.maybeSetState(constrain(this.props, {
                        from: from,
                        itemsPerRow: 1,
                        size: size
                    }), cb);
                }
            },
            {
                key: "updateUniformFrame",
                value: function updateUniformFrame(cb) {
                    var _this$getItemSizeAndI = this.getItemSizeAndItemsPerRow(), itemSize = _this$getItemSizeAndI.itemSize, itemsPerRow = _this$getItemSizeAndI.itemsPerRow;
                    if (!itemSize || !itemsPerRow) return cb();
                    var _this$getStartAndEnd3 = this.getStartAndEnd(), start = _this$getStartAndEnd3.start, end = _this$getStartAndEnd3.end;
                    var _constrain = constrain(this.props, {
                        from: Math.floor(start / itemSize) * itemsPerRow,
                        size: (Math.ceil((end - start) / itemSize) + 1) * itemsPerRow,
                        itemsPerRow: itemsPerRow
                    }), from = _constrain.from, size = _constrain.size;
                    return this.maybeSetState({
                        itemsPerRow: itemsPerRow,
                        from: from,
                        itemSize: itemSize,
                        size: size
                    }, cb);
                }
            },
            {
                key: "getSpaceBefore",
                value: function getSpaceBefore(index) {
                    var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    if (cache[index] != null) return cache[index]; // Try the static itemSize.
                    var _this$state2 = this.state, itemSize = _this$state2.itemSize, itemsPerRow = _this$state2.itemsPerRow;
                    if (itemSize) return cache[index] = Math.floor(index / itemsPerRow) * itemSize;
                     // Find the closest space to index there is a cached value for.
                    var from = index;
                    while(from > 0 && cache[--from] == null); // Finally, accumulate sizes of items from - index.
                    var space = cache[from] || 0;
                    for(var i = from; i < index; ++i){
                        cache[i] = space;
                        var _itemSize2 = this.getSizeOfItem(i);
                        if (_itemSize2 == null) break;
                        space += _itemSize2;
                    }
                    return cache[index] = space;
                }
            },
            {
                key: "cacheSizes",
                value: function cacheSizes() {
                    var cache = this.cache;
                    var from = this.state.from;
                    var itemEls = this.items.children;
                    var sizeKey = OFFSET_SIZE_KEYS[this.props.axis];
                    for(var i = 0, l = itemEls.length; i < l; ++i)cache[from + i] = itemEls[i][sizeKey];
                }
            },
            {
                key: "getSizeOfItem",
                value: function getSizeOfItem(index) {
                    var cache = this.cache, items = this.items;
                    var _this$props5 = this.props, axis = _this$props5.axis, itemSizeGetter = _this$props5.itemSizeGetter, itemSizeEstimator = _this$props5.itemSizeEstimator, type = _this$props5.type;
                    var _this$state3 = this.state, from = _this$state3.from, itemSize = _this$state3.itemSize, size = _this$state3.size; // Try the static itemSize.
                    if (itemSize) return itemSize; // Try the itemSizeGetter.
                    if (itemSizeGetter) return itemSizeGetter(index); // Try the cache.
                    if (index in cache) return cache[index]; // Try the DOM.
                    if (type === "simple" && index >= from && index < from + size && items) {
                        var itemEl = items.children[index - from];
                        if (itemEl) return itemEl[OFFSET_SIZE_KEYS[axis]];
                    } // Try the itemSizeEstimator.
                    if (itemSizeEstimator) return itemSizeEstimator(index, cache);
                }
            },
            {
                key: "scrollTo",
                value: function scrollTo(index) {
                    if (index != null) this.setScroll(this.getSpaceBefore(index));
                }
            },
            {
                key: "scrollAround",
                value: function scrollAround(index) {
                    var current = this.getScrollPosition();
                    var bottom = this.getSpaceBefore(index);
                    var top = bottom - this.props.scrollParentViewportSizeGetter(this) + this.getSizeOfItem(index);
                    var min = Math.min(top, bottom);
                    var max = Math.max(top, bottom);
                    if (current <= min) return this.setScroll(min);
                    if (current > max) return this.setScroll(max);
                }
            },
            {
                key: "getVisibleRange",
                value: function getVisibleRange() {
                    var _this$state4 = this.state, from = _this$state4.from, size = _this$state4.size;
                    var _this$getStartAndEnd4 = this.getStartAndEnd(0), start = _this$getStartAndEnd4.start, end = _this$getStartAndEnd4.end;
                    var cache = {};
                    var first, last;
                    for(var i = from; i < from + size; ++i){
                        var itemStart = this.getSpaceBefore(i, cache);
                        var itemEnd = itemStart + this.getSizeOfItem(i);
                        if (first == null && itemEnd > start) first = i;
                        if (first != null && itemStart < end) last = i;
                    }
                    return [
                        first,
                        last
                    ];
                }
            },
            {
                key: "renderItems",
                value: function renderItems() {
                    var _this3 = this;
                    var _this$props6 = this.props, itemRenderer = _this$props6.itemRenderer, itemsRenderer = _this$props6.itemsRenderer;
                    var _this$state5 = this.state, from = _this$state5.from, size = _this$state5.size;
                    var items = [];
                    for(var i = 0; i < size; ++i)items.push(itemRenderer(from + i, i));
                    return itemsRenderer(items, function(c) {
                        return _this3.items = c;
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this4 = this;
                    var _this$props7 = this.props, axis = _this$props7.axis, length = _this$props7.length, type = _this$props7.type, useTranslate3d = _this$props7.useTranslate3d;
                    var _this$state6 = this.state, from = _this$state6.from, itemsPerRow = _this$state6.itemsPerRow;
                    var items = this.renderItems();
                    if (type === "simple") return items;
                    var style = {
                        position: "relative"
                    };
                    var cache = {};
                    var bottom = Math.ceil(length / itemsPerRow) * itemsPerRow;
                    var size = this.getSpaceBefore(bottom, cache);
                    if (size) {
                        style[SIZE_KEYS[axis]] = size;
                        if (axis === "x") style.overflowX = "hidden";
                    }
                    var offset = this.getSpaceBefore(from, cache);
                    var x = axis === "x" ? offset : 0;
                    var y = axis === "y" ? offset : 0;
                    var transform = useTranslate3d ? "translate3d(".concat(x, "px, ").concat(y, "px, 0)") : "translate(".concat(x, "px, ").concat(y, "px)");
                    var listStyle = {
                        msTransform: transform,
                        WebkitTransform: transform,
                        transform: transform
                    };
                    return /*#__PURE__*/ _react["default"].createElement("div", {
                        style: style,
                        ref: function ref(c) {
                            return _this4.el = c;
                        }
                    }, /*#__PURE__*/ _react["default"].createElement("div", {
                        style: listStyle
                    }, items));
                }
            }
        ]);
        return ReactList;
    }(_react.Component), _defineProperty(_class, "displayName", "ReactList"), _defineProperty(_class, "propTypes", {
        axis: _propTypes["default"].oneOf([
            "x",
            "y"
        ]),
        initialIndex: _propTypes["default"].number,
        itemRenderer: _propTypes["default"].func,
        itemSizeEstimator: _propTypes["default"].func,
        itemSizeGetter: _propTypes["default"].func,
        itemsRenderer: _propTypes["default"].func,
        length: _propTypes["default"].number,
        minSize: _propTypes["default"].number,
        pageSize: _propTypes["default"].number,
        scrollParentGetter: _propTypes["default"].func,
        scrollParentViewportSizeGetter: _propTypes["default"].func,
        threshold: _propTypes["default"].number,
        type: _propTypes["default"].oneOf([
            "simple",
            "variable",
            "uniform"
        ]),
        useStaticSize: _propTypes["default"].bool,
        useTranslate3d: _propTypes["default"].bool
    }), _defineProperty(_class, "defaultProps", {
        axis: "y",
        itemRenderer: function itemRenderer(index, key) {
            return /*#__PURE__*/ _react["default"].createElement("div", {
                key: key
            }, index);
        },
        itemsRenderer: function itemsRenderer(items, ref) {
            return /*#__PURE__*/ _react["default"].createElement("div", {
                ref: ref
            }, items);
        },
        length: 0,
        minSize: 1,
        pageSize: 10,
        scrollParentGetter: defaultScrollParentGetter,
        scrollParentViewportSizeGetter: defaultScrollParentViewportSizeGetter,
        threshold: 100,
        type: "simple",
        useStaticSize: false,
        useTranslate3d: false
    }), _temp);
});


function $60736e760047e4b2$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $60736e760047e4b2$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    var len = arrA.length;
    if (arrB.length !== len) return false;
    for(var i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}





function $324d3518b1b08498$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}




function $f60eacfe0e9716b8$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $324d3518b1b08498$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}




// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $69bbef5abecd6c1f$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $69bbef5abecd6c1f$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = $69bbef5abecd6c1f$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $b50469c0909a5344$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($69bbef5abecd6c1f$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}



function $ee011a7595cab906$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}




function $3a859ca9a069815b$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}




function $3bb63e45ffe0ab23$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, $3a7da7f4c81a8554$export$2e2bcd8739ae039)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}





function $782b811855cace18$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}



function $e008d718aba2e9eb$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var month = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $782b811855cace18$export$2e2bcd8739ae039)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}




function $3bc23e7a7ee03bfe$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $f741f874145d0154$export$2e2bcd8739ae039)(dirtyDate);
    var year = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}




function $6b1551b9374f6b68$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $324d3518b1b08498$export$2e2bcd8739ae039)(dirtyDate, -amount);
}



var $6869581a7119e209$export$2e2bcd8739ae039 = {
    dateRangeWrapper: "rdrDateRangeWrapper",
    calendarWrapper: "rdrCalendarWrapper",
    dateDisplay: "rdrDateDisplay",
    dateDisplayItem: "rdrDateDisplayItem",
    dateDisplayItemActive: "rdrDateDisplayItemActive",
    monthAndYearWrapper: "rdrMonthAndYearWrapper",
    monthAndYearPickers: "rdrMonthAndYearPickers",
    nextPrevButton: "rdrNextPrevButton",
    month: "rdrMonth",
    weekDays: "rdrWeekDays",
    weekDay: "rdrWeekDay",
    days: "rdrDays",
    day: "rdrDay",
    dayNumber: "rdrDayNumber",
    dayPassive: "rdrDayPassive",
    dayToday: "rdrDayToday",
    dayStartOfWeek: "rdrDayStartOfWeek",
    dayEndOfWeek: "rdrDayEndOfWeek",
    daySelected: "rdrDaySelected",
    dayDisabled: "rdrDayDisabled",
    dayStartOfMonth: "rdrDayStartOfMonth",
    dayEndOfMonth: "rdrDayEndOfMonth",
    dayWeekend: "rdrDayWeekend",
    dayStartPreview: "rdrDayStartPreview",
    dayInPreview: "rdrDayInPreview",
    dayEndPreview: "rdrDayEndPreview",
    dayHovered: "rdrDayHovered",
    dayActive: "rdrDayActive",
    inRange: "rdrInRange",
    endEdge: "rdrEndEdge",
    startEdge: "rdrStartEdge",
    prevButton: "rdrPprevButton",
    nextButton: "rdrNextButton",
    selected: "rdrSelected",
    months: "rdrMonths",
    monthPicker: "rdrMonthPicker",
    yearPicker: "rdrYearPicker",
    dateDisplayWrapper: "rdrDateDisplayWrapper",
    definedRangesWrapper: "rdrDefinedRangesWrapper",
    staticRanges: "rdrStaticRanges",
    staticRange: "rdrStaticRange",
    inputRanges: "rdrInputRanges",
    inputRange: "rdrInputRange",
    inputRangeInput: "rdrInputRangeInput",
    dateRangePickerWrapper: "rdrDateRangePickerWrapper",
    staticRangeLabel: "rdrStaticRangeLabel",
    staticRangeSelected: "rdrStaticRangeSelected",
    monthName: "rdrMonthName",
    infiniteMonths: "rdrInfiniteMonths",
    monthsVertical: "rdrMonthsVertical",
    monthsHorizontal: "rdrMonthsHorizontal"
};



var $eCfBx = parcelRequire("eCfBx");
const $19891a31ae087b75$export$f5cf911721a740b2 = (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).shape({
    dateInput: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).shape({
        startDate: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
        endDate: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string
    })),
    monthPicker: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    yearPicker: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    prevButton: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    nextButton: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string
});


class $fd7799db736e51d7$var$Calendar extends (0, $bh6RR.PureComponent) {
    constructor(props, context){
        super(props, context);
        this.dateOptions = {
            locale: props.locale
        };
        if (props.weekStartsOn !== undefined) this.dateOptions.weekStartsOn = props.weekStartsOn;
        this.styles = (0, $5daab16bab438d51$export$593755c5b8f32d8f)([
            (0, $6869581a7119e209$export$2e2bcd8739ae039),
            props.classNames
        ]);
        this.listSizeCache = {};
        this.isFirstRender = true;
        this.state = {
            monthNames: this.getMonthNames(),
            focusedDate: (0, $5daab16bab438d51$export$9fdc2db1e21805d)(null, props),
            drag: {
                status: false,
                range: {
                    startDate: null,
                    endDate: null
                },
                disablePreview: false
            },
            scrollArea: this.calcScrollArea(props)
        };
    }
    isDateInRange = (date)=>{
        return date >= this.props.minDate && date <= this.props.maxDate;
    };
    getDateMinAndMax = ()=>{
        return {
            min: this.props.minDate,
            max: this.props.maxDate
        };
    };
    getMonthNames() {
        return [
            ...Array(12).keys()
        ].map((i)=>this.props.locale.localize.month(i));
    }
    calcScrollArea(props) {
        const { direction: direction, months: months, scroll: scroll } = props;
        if (!scroll.enabled) return {
            enabled: false
        };
        const longMonthHeight = scroll.longMonthHeight || scroll.monthHeight;
        if (direction === "vertical") return {
            enabled: true,
            monthHeight: scroll.monthHeight || 220,
            longMonthHeight: longMonthHeight || 260,
            calendarWidth: "auto",
            calendarHeight: (scroll.calendarHeight || longMonthHeight || 240) * months
        };
        return {
            enabled: true,
            monthWidth: scroll.monthWidth || 332,
            calendarWidth: (scroll.calendarWidth || scroll.monthWidth || 332) * months,
            monthHeight: longMonthHeight || 300,
            calendarHeight: longMonthHeight || 300
        };
    }
    focusToDate = (date, props = this.props, preventUnnecessary = true)=>{
        if (!props.scroll.enabled) {
            if (preventUnnecessary && props.preventSnapRefocus) {
                const focusedDateDiff = (0, $b3f16299565f3818$export$2e2bcd8739ae039)(date, this.state.focusedDate);
                const isAllowedForward = props.calendarFocus === "forwards" && focusedDateDiff >= 0;
                const isAllowedBackward = props.calendarFocus === "backwards" && focusedDateDiff <= 0;
                if ((isAllowedForward || isAllowedBackward) && Math.abs(focusedDateDiff) < props.months) return;
            }
            this.setState({
                focusedDate: date
            });
            return;
        }
        const targetMonthIndex = (0, $b3f16299565f3818$export$2e2bcd8739ae039)(date, props.minDate, this.dateOptions);
        const visibleMonths = this.list.getVisibleRange();
        if (preventUnnecessary && visibleMonths.includes(targetMonthIndex)) return;
        this.isFirstRender = true;
        this.list.scrollTo(targetMonthIndex);
        this.setState({
            focusedDate: date
        });
    };
    updateShownDate = (props = this.props)=>{
        const newProps = props.scroll.enabled ? {
            ...props,
            months: this.list.getVisibleRange().length
        } : props;
        const newFocus = (0, $5daab16bab438d51$export$9fdc2db1e21805d)(this.state.focusedDate, newProps);
        this.focusToDate(newFocus, newProps);
    };
    updatePreview = (val)=>{
        if (!val) {
            this.setState({
                preview: null
            });
            return;
        }
        const preview = {
            startDate: val,
            endDate: val,
            color: this.props.color
        };
        this.setState({
            preview: preview
        });
    };
    componentDidMount() {
        if (this.props.scroll.enabled) // prevent react-list's initial render focus problem
        setTimeout(()=>this.focusToDate(this.state.focusedDate));
    }
    componentDidUpdate(prevProps) {
        const propMapper = {
            dateRange: "ranges",
            date: "date"
        };
        const targetProp = propMapper[this.props.displayMode];
        if (this.props[targetProp] !== prevProps[targetProp]) this.updateShownDate(this.props);
        if (prevProps.locale !== this.props.locale || prevProps.weekStartsOn !== this.props.weekStartsOn) {
            this.dateOptions = {
                locale: this.props.locale
            };
            if (this.props.weekStartsOn !== undefined) this.dateOptions.weekStartsOn = this.props.weekStartsOn;
            this.setState({
                monthNames: this.getMonthNames()
            });
        }
        if (!(0, $60736e760047e4b2$export$3e67810a3f0e9f1c)(prevProps.scroll, this.props.scroll)) this.setState({
            scrollArea: this.calcScrollArea(this.props)
        });
    }
    changeShownDate = (value, mode = "set")=>{
        const { focusedDate: focusedDate } = this.state;
        const { onShownDateChange: onShownDateChange, minDate: minDate, maxDate: maxDate } = this.props;
        const modeMapper = {
            monthOffset: ()=>(0, $324d3518b1b08498$export$2e2bcd8739ae039)(focusedDate, value),
            setMonth: ()=>(0, $e008d718aba2e9eb$export$2e2bcd8739ae039)(focusedDate, value),
            setYear: ()=>(0, $3bc23e7a7ee03bfe$export$2e2bcd8739ae039)(focusedDate, value),
            set: ()=>value
        };
        const newDate = (0, $3bb63e45ffe0ab23$export$2e2bcd8739ae039)([
            (0, $3a859ca9a069815b$export$2e2bcd8739ae039)([
                modeMapper[mode](),
                minDate
            ]),
            maxDate
        ]);
        this.focusToDate(newDate, this.props, false);
        onShownDateChange && onShownDateChange(newDate);
    };
    handleRangeFocusChange = (rangesIndex, rangeItemIndex)=>{
        this.props.onRangeFocusChange && this.props.onRangeFocusChange([
            rangesIndex,
            rangeItemIndex
        ]);
    };
    handleScroll = ()=>{
        const { onShownDateChange: onShownDateChange, minDate: minDate } = this.props;
        const { focusedDate: focusedDate } = this.state;
        const { isFirstRender: isFirstRender } = this;
        const visibleMonths = this.list.getVisibleRange();
        // prevent scroll jump with wrong visible value
        if (visibleMonths[0] === undefined) return;
        const visibleMonth = (0, $324d3518b1b08498$export$2e2bcd8739ae039)(minDate, visibleMonths[0] || 0);
        const isFocusedToDifferent = !(0, $ee011a7595cab906$export$2e2bcd8739ae039)(visibleMonth, focusedDate);
        if (isFocusedToDifferent && !isFirstRender) {
            this.setState({
                focusedDate: visibleMonth
            });
            onShownDateChange && onShownDateChange(visibleMonth);
        }
        this.isFirstRender = false;
    };
    renderMonthAndYear = (focusedDate, changeShownDate, props)=>{
        const { showMonthArrow: showMonthArrow, minDate: minDate, maxDate: maxDate, showMonthAndYearPickers: showMonthAndYearPickers, ariaLabels: ariaLabels } = props;
        const upperYearLimit = (maxDate || $fd7799db736e51d7$var$Calendar.defaultProps.maxDate).getFullYear();
        const lowerYearLimit = (minDate || $fd7799db736e51d7$var$Calendar.defaultProps.minDate).getFullYear();
        const styles = this.styles;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            onMouseUp: (e)=>e.stopPropagation(),
            className: styles.monthAndYearWrapper,
            children: [
                showMonthArrow ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    type: "button",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))(styles.nextPrevButton, styles.prevButton),
                    onClick: ()=>changeShownDate(-1, "monthOffset"),
                    "aria-label": ariaLabels.prevButton,
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {})
                }) : null,
                showMonthAndYearPickers ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    className: styles.monthAndYearPickers,
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            className: styles.monthPicker,
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("select", {
                                value: focusedDate.getMonth(),
                                onChange: (e)=>changeShownDate(e.target.value, "setMonth"),
                                "aria-label": ariaLabels.monthPicker,
                                children: this.state.monthNames.map((monthName, i)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                        value: i,
                                        children: monthName
                                    }, i))
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            className: styles.monthAndYearDivider
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            className: styles.yearPicker,
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("select", {
                                value: focusedDate.getFullYear(),
                                onChange: (e)=>changeShownDate(e.target.value, "setYear"),
                                "aria-label": ariaLabels.yearPicker,
                                children: new Array(upperYearLimit - lowerYearLimit + 1).fill(upperYearLimit).map((val, i)=>{
                                    const year = val - i;
                                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                        value: year,
                                        children: year
                                    }, year);
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    className: styles.monthAndYearPickers,
                    children: [
                        this.state.monthNames[focusedDate.getMonth()],
                        " ",
                        focusedDate.getFullYear()
                    ]
                }),
                showMonthArrow ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    type: "button",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))(styles.nextPrevButton, styles.nextButton),
                    onClick: ()=>changeShownDate(1, "monthOffset"),
                    "aria-label": ariaLabels.nextButton,
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {})
                }) : null
            ]
        });
    };
    renderWeekdays() {
        const now = new Date();
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: this.styles.weekDays,
            children: (0, $d464c5edb4a88ee1$export$2e2bcd8739ae039)({
                start: (0, $7482736b8e287f15$export$2e2bcd8739ae039)(now, this.dateOptions),
                end: (0, $a16aa884d52fc460$export$2e2bcd8739ae039)(now, this.dateOptions)
            }).map((day, i)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: this.styles.weekDay,
                    children: (0, $e91dd50cc5cd7f0e$export$2e2bcd8739ae039)(day, this.props.weekdayDisplayFormat, this.dateOptions)
                }, i))
        });
    }
    renderDateDisplay = ()=>{
        const { focusedRange: focusedRange, color: color, ranges: ranges, rangeColors: rangeColors, dateDisplayFormat: dateDisplayFormat, editableDateInputs: editableDateInputs, startDatePlaceholder: startDatePlaceholder, endDatePlaceholder: endDatePlaceholder, ariaLabels: ariaLabels } = this.props;
        const defaultColor = rangeColors[focusedRange[0]] || color;
        const styles = this.styles;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: styles.dateDisplayWrapper,
            children: ranges.map((range, i)=>{
                if (range.showDateDisplay === false || range.disabled && !range.showDateDisplay) return null;
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: styles.dateDisplay,
                    style: {
                        color: range.color || defaultColor
                    },
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5a2d3741154e1a7c$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))(styles.dateDisplayItem, {
                                [styles.dateDisplayItemActive]: focusedRange[0] === i && focusedRange[1] === 0
                            }),
                            readOnly: !editableDateInputs,
                            disabled: range.disabled,
                            value: range.startDate,
                            placeholder: startDatePlaceholder,
                            dateOptions: this.dateOptions,
                            dateDisplayFormat: dateDisplayFormat,
                            ariaLabel: ariaLabels.dateInput && ariaLabels.dateInput[range.key] && ariaLabels.dateInput[range.key].startDate,
                            onChange: this.onDragSelectionEnd,
                            onFocus: ()=>this.handleRangeFocusChange(i, 0),
                            isDateInRange: this.isDateInRange,
                            getDateMinAndMax: this.getDateMinAndMax
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5a2d3741154e1a7c$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))(styles.dateDisplayItem, {
                                [styles.dateDisplayItemActive]: focusedRange[0] === i && focusedRange[1] === 1
                            }),
                            readOnly: !editableDateInputs,
                            disabled: range.disabled,
                            value: range.endDate,
                            placeholder: endDatePlaceholder,
                            dateOptions: this.dateOptions,
                            dateDisplayFormat: dateDisplayFormat,
                            ariaLabel: ariaLabels.dateInput && ariaLabels.dateInput[range.key] && ariaLabels.dateInput[range.key].endDate,
                            onChange: this.onDragSelectionEnd,
                            onFocus: ()=>this.handleRangeFocusChange(i, 1),
                            isDateInRange: this.isDateInRange,
                            getDateMinAndMax: this.getDateMinAndMax
                        })
                    ]
                }, i);
            })
        });
    };
    onDragSelectionStart = (date)=>{
        const { onChange: onChange, dragSelectionEnabled: dragSelectionEnabled } = this.props;
        if (dragSelectionEnabled) this.setState({
            drag: {
                status: true,
                range: {
                    startDate: date,
                    endDate: date
                },
                disablePreview: true
            }
        });
        else onChange && onChange(date);
    };
    onDragSelectionEnd = (date)=>{
        const { updateRange: updateRange, displayMode: displayMode, onChange: onChange, dragSelectionEnabled: dragSelectionEnabled } = this.props;
        if (!dragSelectionEnabled) return;
        if (displayMode === "date" || !this.state.drag.status) {
            onChange && onChange(date);
            return;
        }
        const newRange = {
            startDate: this.state.drag.range.startDate,
            endDate: date
        };
        if (displayMode !== "dateRange" || (0, $c5045487affbaf52$export$2e2bcd8739ae039)(newRange.startDate, date)) this.setState({
            drag: {
                status: false,
                range: {}
            }
        }, ()=>onChange && onChange(date));
        else this.setState({
            drag: {
                status: false,
                range: {}
            }
        }, ()=>{
            updateRange && updateRange(newRange);
        });
    };
    onDragSelectionMove = (date)=>{
        const { drag: drag } = this.state;
        if (!drag.status || !this.props.dragSelectionEnabled) return;
        this.setState({
            drag: {
                status: drag.status,
                range: {
                    startDate: drag.range.startDate,
                    endDate: date
                },
                disablePreview: true
            }
        });
    };
    estimateMonthSize = (index, cache)=>{
        const { direction: direction, minDate: minDate } = this.props;
        const { scrollArea: scrollArea } = this.state;
        if (cache) {
            this.listSizeCache = cache;
            if (cache[index]) return cache[index];
        }
        if (direction === "horizontal") return scrollArea.monthWidth;
        const monthStep = (0, $324d3518b1b08498$export$2e2bcd8739ae039)(minDate, index);
        const { start: start, end: end } = (0, $5daab16bab438d51$export$d0d420211d7446eb)(monthStep, this.dateOptions);
        const isLongMonth = (0, $69bbef5abecd6c1f$export$2e2bcd8739ae039)(end, start, this.dateOptions) + 1 > 35;
        return isLongMonth ? scrollArea.longMonthHeight : scrollArea.monthHeight;
    };
    render() {
        const { showDateDisplay: showDateDisplay, onPreviewChange: onPreviewChange, scroll: scroll, direction: direction, disabledDates: disabledDates, disabledDay: disabledDay, maxDate: maxDate, minDate: minDate, rangeColors: rangeColors, color: color, navigatorRenderer: navigatorRenderer, className: className, preview: preview } = this.props;
        const { scrollArea: scrollArea, focusedDate: focusedDate } = this.state;
        const isVertical = direction === "vertical";
        const monthAndYearRenderer = navigatorRenderer || this.renderMonthAndYear;
        const ranges = this.props.ranges.map((range, i)=>({
                ...range,
                color: range.color || rangeColors[i] || color
            }));
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))(this.styles.calendarWrapper, className),
            onMouseUp: ()=>this.setState({
                    drag: {
                        status: false,
                        range: {}
                    }
                }),
            onMouseLeave: ()=>{
                this.setState({
                    drag: {
                        status: false,
                        range: {}
                    }
                });
            },
            children: [
                showDateDisplay && this.renderDateDisplay(),
                monthAndYearRenderer(focusedDate, this.changeShownDate, this.props),
                scroll.enabled ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    children: [
                        isVertical && this.renderWeekdays(this.dateOptions),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))(this.styles.infiniteMonths, isVertical ? this.styles.monthsVertical : this.styles.monthsHorizontal),
                            onMouseLeave: ()=>onPreviewChange && onPreviewChange(),
                            style: {
                                width: scrollArea.calendarWidth + 11,
                                height: scrollArea.calendarHeight + 11
                            },
                            onScroll: this.handleScroll,
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c6fd88e9e7604fcb$exports))), {
                                length: (0, $b3f16299565f3818$export$2e2bcd8739ae039)((0, $0a7394535777dacf$export$2e2bcd8739ae039)(maxDate), (0, $d4cc3831797a4057$export$2e2bcd8739ae039)((0, $ee3612bcc22c95f6$export$2e2bcd8739ae039)(minDate), -1), this.dateOptions),
                                treshold: 500,
                                type: "variable",
                                ref: (target)=>this.list = target,
                                itemSizeEstimator: this.estimateMonthSize,
                                axis: isVertical ? "y" : "x",
                                itemRenderer: (index, key)=>{
                                    const monthStep = (0, $324d3518b1b08498$export$2e2bcd8739ae039)(minDate, index);
                                    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b298a150cfe97208$export$2e2bcd8739ae039), {
                                        ...this.props,
                                        onPreviewChange: onPreviewChange || this.updatePreview,
                                        preview: preview || this.state.preview,
                                        ranges: ranges,
                                        key: key,
                                        drag: this.state.drag,
                                        dateOptions: this.dateOptions,
                                        disabledDates: disabledDates,
                                        disabledDay: disabledDay,
                                        month: monthStep,
                                        onDragSelectionStart: this.onDragSelectionStart,
                                        onDragSelectionEnd: this.onDragSelectionEnd,
                                        onDragSelectionMove: this.onDragSelectionMove,
                                        onMouseLeave: ()=>onPreviewChange && onPreviewChange(),
                                        styles: this.styles,
                                        style: isVertical ? {
                                            height: this.estimateMonthSize(index)
                                        } : {
                                            height: scrollArea.monthHeight,
                                            width: this.estimateMonthSize(index)
                                        },
                                        showMonthName: true,
                                        showWeekDays: !isVertical
                                    });
                                }
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))(this.styles.months, isVertical ? this.styles.monthsVertical : this.styles.monthsHorizontal),
                    children: new Array(this.props.months).fill(null).map((_, i)=>{
                        let monthStep = (0, $324d3518b1b08498$export$2e2bcd8739ae039)(this.state.focusedDate, i);
                        if (this.props.calendarFocus === "backwards") monthStep = (0, $6b1551b9374f6b68$export$2e2bcd8739ae039)(this.state.focusedDate, this.props.months - 1 - i);
                        return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b298a150cfe97208$export$2e2bcd8739ae039), {
                            ...this.props,
                            onPreviewChange: onPreviewChange || this.updatePreview,
                            preview: preview || this.state.preview,
                            ranges: ranges,
                            key: i,
                            drag: this.state.drag,
                            dateOptions: this.dateOptions,
                            disabledDates: disabledDates,
                            disabledDay: disabledDay,
                            month: monthStep,
                            onDragSelectionStart: this.onDragSelectionStart,
                            onDragSelectionEnd: this.onDragSelectionEnd,
                            onDragSelectionMove: this.onDragSelectionMove,
                            onMouseLeave: ()=>onPreviewChange && onPreviewChange(),
                            styles: this.styles,
                            showWeekDays: !isVertical || i === 0,
                            showMonthName: !isVertical || i > 0
                        });
                    })
                })
            ]
        });
    }
}
$fd7799db736e51d7$var$Calendar.defaultProps = {
    showMonthArrow: true,
    showMonthAndYearPickers: true,
    disabledDates: [],
    disabledDay: ()=>{},
    classNames: {},
    locale: (0, $aaf50d37016ddcb1$export$2e2bcd8739ae039),
    ranges: [],
    focusedRange: [
        0,
        0
    ],
    dateDisplayFormat: "MMM d, yyyy",
    monthDisplayFormat: "MMM yyyy",
    weekdayDisplayFormat: "E",
    dayDisplayFormat: "d",
    showDateDisplay: true,
    showPreview: true,
    displayMode: "date",
    months: 1,
    color: "#3d91ff",
    scroll: {
        enabled: false
    },
    direction: "vertical",
    maxDate: (0, $f60eacfe0e9716b8$export$2e2bcd8739ae039)(new Date(), 20),
    minDate: (0, $f60eacfe0e9716b8$export$2e2bcd8739ae039)(new Date(), -100),
    rangeColors: [
        "#3d91ff",
        "#3ecf8e",
        "#fed14c"
    ],
    startDatePlaceholder: "Early",
    endDatePlaceholder: "Continuous",
    editableDateInputs: false,
    dragSelectionEnabled: true,
    fixedHeight: false,
    calendarFocus: "forwards",
    preventSnapRefocus: false,
    ariaLabels: {}
};
$fd7799db736e51d7$var$Calendar.propTypes = {
    showMonthArrow: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    showMonthAndYearPickers: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    disabledDates: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).array,
    disabledDay: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    minDate: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    date: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    onPreviewChange: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    onRangeFocusChange: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    classNames: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    shownDate: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
    onShownDateChange: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    ranges: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).arrayOf((0, $80c283ff85dafb88$export$98793868965e5ef7)),
    preview: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).shape({
        startDate: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
        endDate: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).object,
        color: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string
    }),
    dateDisplayFormat: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    monthDisplayFormat: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    weekdayDisplayFormat: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    weekStartsOn: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).number,
    dayDisplayFormat: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    focusedRange: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).number),
    initialFocusedRange: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).number),
    months: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).number,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    showDateDisplay: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    showPreview: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    displayMode: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).oneOf([
        "dateRange",
        "date"
    ]),
    color: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    updateRange: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    scroll: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).shape({
        enabled: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
        monthHeight: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).number,
        longMonthHeight: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).number,
        monthWidth: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).number,
        calendarWidth: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).number,
        calendarHeight: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).number
    }),
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).oneOf([
        "vertical",
        "horizontal"
    ]),
    startDatePlaceholder: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    endDatePlaceholder: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    navigatorRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    rangeColors: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string),
    editableDateInputs: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    dragSelectionEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    fixedHeight: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    calendarFocus: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    preventSnapRefocus: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    ariaLabels: (0, $19891a31ae087b75$export$f5cf911721a740b2)
};
var $fd7799db736e51d7$export$2e2bcd8739ae039 = $fd7799db736e51d7$var$Calendar;







class $22a3ef5ef5ef755f$var$DateRange extends (0, $bh6RR.Component) {
    constructor(props, context){
        super(props, context);
        this.state = {
            focusedRange: props.initialFocusedRange || [
                (0, $5daab16bab438d51$export$e9c2db745e2566d3)(props.ranges),
                0
            ],
            preview: null
        };
        this.styles = (0, $5daab16bab438d51$export$593755c5b8f32d8f)([
            (0, $6869581a7119e209$export$2e2bcd8739ae039),
            props.classNames
        ]);
    }
    calcNewSelection = (value, isSingleValue = true)=>{
        const focusedRange = this.props.focusedRange || this.state.focusedRange;
        const { ranges: ranges, onChange: onChange, maxDate: maxDate, moveRangeOnFirstSelection: moveRangeOnFirstSelection, retainEndDateOnFirstSelection: retainEndDateOnFirstSelection, disabledDates: disabledDates } = this.props;
        const focusedRangeIndex = focusedRange[0];
        const selectedRange = ranges[focusedRangeIndex];
        if (!selectedRange || !onChange) return {};
        let { startDate: startDate, endDate: endDate } = selectedRange;
        const now = new Date();
        let nextFocusRange;
        if (!isSingleValue) {
            startDate = value.startDate;
            endDate = value.endDate;
        } else if (focusedRange[1] === 0) {
            // startDate selection
            const dayOffset = (0, $b50469c0909a5344$export$2e2bcd8739ae039)(endDate || now, startDate);
            const calculateEndDate = ()=>{
                if (moveRangeOnFirstSelection) return (0, $d4cc3831797a4057$export$2e2bcd8739ae039)(value, dayOffset);
                if (retainEndDateOnFirstSelection) {
                    if (!endDate || (0, $17c3ff3944cd98da$export$2e2bcd8739ae039)(value, endDate)) return endDate;
                    return value;
                }
                return value || now;
            };
            startDate = value;
            endDate = calculateEndDate();
            if (maxDate) endDate = (0, $3bb63e45ffe0ab23$export$2e2bcd8739ae039)([
                endDate,
                maxDate
            ]);
            nextFocusRange = [
                focusedRange[0],
                1
            ];
        } else endDate = value;
        // reverse dates if startDate before endDate
        let isStartDateSelected = focusedRange[1] === 0;
        if ((0, $17c3ff3944cd98da$export$2e2bcd8739ae039)(endDate, startDate)) {
            isStartDateSelected = !isStartDateSelected;
            [startDate, endDate] = [
                endDate,
                startDate
            ];
        }
        const inValidDatesWithinRange = disabledDates.filter((disabledDate)=>(0, $c1cb2fb95fbd857a$export$2e2bcd8739ae039)(disabledDate, {
                start: startDate,
                end: endDate
            }));
        if (inValidDatesWithinRange.length > 0) {
            if (isStartDateSelected) startDate = (0, $d4cc3831797a4057$export$2e2bcd8739ae039)((0, $3a859ca9a069815b$export$2e2bcd8739ae039)(inValidDatesWithinRange), 1);
            else endDate = (0, $d4cc3831797a4057$export$2e2bcd8739ae039)((0, $3bb63e45ffe0ab23$export$2e2bcd8739ae039)(inValidDatesWithinRange), -1);
        }
        if (!nextFocusRange) {
            const nextFocusRangeIndex = (0, $5daab16bab438d51$export$e9c2db745e2566d3)(this.props.ranges, focusedRange[0]);
            nextFocusRange = [
                nextFocusRangeIndex,
                0
            ];
        }
        return {
            wasValid: !(inValidDatesWithinRange.length > 0),
            range: {
                startDate: startDate,
                endDate: endDate
            },
            nextFocusRange: nextFocusRange
        };
    };
    setSelection = (value, isSingleValue)=>{
        const { onChange: onChange, ranges: ranges, onRangeFocusChange: onRangeFocusChange } = this.props;
        const focusedRange = this.props.focusedRange || this.state.focusedRange;
        const focusedRangeIndex = focusedRange[0];
        const selectedRange = ranges[focusedRangeIndex];
        if (!selectedRange) return;
        const newSelection = this.calcNewSelection(value, isSingleValue);
        onChange({
            [selectedRange.key || `range${focusedRangeIndex + 1}`]: {
                ...selectedRange,
                ...newSelection.range
            }
        });
        this.setState({
            focusedRange: newSelection.nextFocusRange,
            preview: null
        });
        onRangeFocusChange && onRangeFocusChange(newSelection.nextFocusRange);
    };
    handleRangeFocusChange = (focusedRange)=>{
        this.setState({
            focusedRange: focusedRange
        });
        this.props.onRangeFocusChange && this.props.onRangeFocusChange(focusedRange);
    };
    updatePreview = (val)=>{
        if (!val) {
            this.setState({
                preview: null
            });
            return;
        }
        const { rangeColors: rangeColors, ranges: ranges } = this.props;
        const focusedRange = this.props.focusedRange || this.state.focusedRange;
        const color = ranges[focusedRange[0]]?.color || rangeColors[focusedRange[0]] || color;
        this.setState({
            preview: {
                ...val.range,
                color: color
            }
        });
    };
    render() {
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fd7799db736e51d7$export$2e2bcd8739ae039), {
            focusedRange: this.state.focusedRange,
            onRangeFocusChange: this.handleRangeFocusChange,
            preview: this.state.preview,
            onPreviewChange: (value)=>{
                this.updatePreview(value ? this.calcNewSelection(value) : null);
            },
            ...this.props,
            displayMode: "dateRange",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))(this.styles.dateRangeWrapper, this.props.className),
            onChange: this.setSelection,
            updateRange: (val)=>this.setSelection(val, false),
            ref: (target)=>{
                this.calendar = target;
            }
        });
    }
}
$22a3ef5ef5ef755f$var$DateRange.defaultProps = {
    classNames: {},
    ranges: [],
    moveRangeOnFirstSelection: false,
    retainEndDateOnFirstSelection: false,
    rangeColors: [
        "#3d91ff",
        "#3ecf8e",
        "#fed14c"
    ],
    disabledDates: []
};
$22a3ef5ef5ef755f$var$DateRange.propTypes = {
    ...(0, $fd7799db736e51d7$export$2e2bcd8739ae039).propTypes,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    onRangeFocusChange: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    ranges: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).arrayOf((0, $80c283ff85dafb88$export$98793868965e5ef7)),
    moveRangeOnFirstSelection: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool,
    retainEndDateOnFirstSelection: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool
};
var $22a3ef5ef5ef755f$export$2e2bcd8739ae039 = $22a3ef5ef5ef755f$var$DateRange;





var $bh6RR = parcelRequire("bh6RR");

var $eCfBx = parcelRequire("eCfBx");



var $bh6RR = parcelRequire("bh6RR");

var $eCfBx = parcelRequire("eCfBx");


const $66b5cd7eb1a645da$var$defineds = {
    startOfWeek: (0, $7482736b8e287f15$export$2e2bcd8739ae039)(new Date()),
    endOfWeek: (0, $a16aa884d52fc460$export$2e2bcd8739ae039)(new Date()),
    startOfLastWeek: (0, $7482736b8e287f15$export$2e2bcd8739ae039)((0, $d4cc3831797a4057$export$2e2bcd8739ae039)(new Date(), -7)),
    endOfLastWeek: (0, $a16aa884d52fc460$export$2e2bcd8739ae039)((0, $d4cc3831797a4057$export$2e2bcd8739ae039)(new Date(), -7)),
    startOfToday: (0, $c7a5375f03b0a15d$export$2e2bcd8739ae039)(new Date()),
    endOfToday: (0, $3434eb5bab1e76df$export$2e2bcd8739ae039)(new Date()),
    startOfYesterday: (0, $c7a5375f03b0a15d$export$2e2bcd8739ae039)((0, $d4cc3831797a4057$export$2e2bcd8739ae039)(new Date(), -1)),
    endOfYesterday: (0, $3434eb5bab1e76df$export$2e2bcd8739ae039)((0, $d4cc3831797a4057$export$2e2bcd8739ae039)(new Date(), -1)),
    startOfMonth: (0, $ee3612bcc22c95f6$export$2e2bcd8739ae039)(new Date()),
    endOfMonth: (0, $0a7394535777dacf$export$2e2bcd8739ae039)(new Date()),
    startOfLastMonth: (0, $ee3612bcc22c95f6$export$2e2bcd8739ae039)((0, $324d3518b1b08498$export$2e2bcd8739ae039)(new Date(), -1)),
    endOfLastMonth: (0, $0a7394535777dacf$export$2e2bcd8739ae039)((0, $324d3518b1b08498$export$2e2bcd8739ae039)(new Date(), -1))
};
const $66b5cd7eb1a645da$var$staticRangeHandler = {
    range: {},
    isSelected (range) {
        const definedRange = this.range();
        return (0, $c5045487affbaf52$export$2e2bcd8739ae039)(range.startDate, definedRange.startDate) && (0, $c5045487affbaf52$export$2e2bcd8739ae039)(range.endDate, definedRange.endDate);
    }
};
function $66b5cd7eb1a645da$export$c5df3b499910167a(ranges) {
    return ranges.map((range)=>({
            ...$66b5cd7eb1a645da$var$staticRangeHandler,
            ...range
        }));
}
const $66b5cd7eb1a645da$export$2dc99991a8b5f81d = $66b5cd7eb1a645da$export$c5df3b499910167a([
    {
        label: "Today",
        range: ()=>({
                startDate: $66b5cd7eb1a645da$var$defineds.startOfToday,
                endDate: $66b5cd7eb1a645da$var$defineds.endOfToday
            })
    },
    {
        label: "Yesterday",
        range: ()=>({
                startDate: $66b5cd7eb1a645da$var$defineds.startOfYesterday,
                endDate: $66b5cd7eb1a645da$var$defineds.endOfYesterday
            })
    },
    {
        label: "This Week",
        range: ()=>({
                startDate: $66b5cd7eb1a645da$var$defineds.startOfWeek,
                endDate: $66b5cd7eb1a645da$var$defineds.endOfWeek
            })
    },
    {
        label: "Last Week",
        range: ()=>({
                startDate: $66b5cd7eb1a645da$var$defineds.startOfLastWeek,
                endDate: $66b5cd7eb1a645da$var$defineds.endOfLastWeek
            })
    },
    {
        label: "This Month",
        range: ()=>({
                startDate: $66b5cd7eb1a645da$var$defineds.startOfMonth,
                endDate: $66b5cd7eb1a645da$var$defineds.endOfMonth
            })
    },
    {
        label: "Last Month",
        range: ()=>({
                startDate: $66b5cd7eb1a645da$var$defineds.startOfLastMonth,
                endDate: $66b5cd7eb1a645da$var$defineds.endOfLastMonth
            })
    }
]);
const $66b5cd7eb1a645da$export$7047d454236a4443 = [
    {
        label: "days up to today",
        range (value) {
            return {
                startDate: (0, $d4cc3831797a4057$export$2e2bcd8739ae039)($66b5cd7eb1a645da$var$defineds.startOfToday, (Math.max(Number(value), 1) - 1) * -1),
                endDate: $66b5cd7eb1a645da$var$defineds.endOfToday
            };
        },
        getCurrentValue (range) {
            if (!(0, $c5045487affbaf52$export$2e2bcd8739ae039)(range.endDate, $66b5cd7eb1a645da$var$defineds.endOfToday)) return "-";
            if (!range.startDate) return "\u221E";
            return (0, $b50469c0909a5344$export$2e2bcd8739ae039)($66b5cd7eb1a645da$var$defineds.endOfToday, range.startDate) + 1;
        }
    },
    {
        label: "days starting today",
        range (value) {
            const today = new Date();
            return {
                startDate: today,
                endDate: (0, $d4cc3831797a4057$export$2e2bcd8739ae039)(today, Math.max(Number(value), 1) - 1)
            };
        },
        getCurrentValue (range) {
            if (!(0, $c5045487affbaf52$export$2e2bcd8739ae039)(range.startDate, $66b5cd7eb1a645da$var$defineds.startOfToday)) return "-";
            if (!range.endDate) return "\u221E";
            return (0, $b50469c0909a5344$export$2e2bcd8739ae039)(range.endDate, $66b5cd7eb1a645da$var$defineds.startOfToday) + 1;
        }
    }
];





var $bh6RR = parcelRequire("bh6RR");

var $eCfBx = parcelRequire("eCfBx");
const $0b8bbc48464151e0$var$MIN = 0;
const $0b8bbc48464151e0$var$MAX = 99999;
class $0b8bbc48464151e0$var$InputRangeField extends (0, $bh6RR.Component) {
    constructor(props, context){
        super(props, context);
    }
    shouldComponentUpdate(nextProps) {
        const { value: value, label: label, placeholder: placeholder } = this.props;
        return value !== nextProps.value || label !== nextProps.label || placeholder !== nextProps.placeholder;
    }
    onChange = (e)=>{
        const { onChange: onChange } = this.props;
        let value = parseInt(e.target.value, 10);
        value = isNaN(value) ? 0 : Math.max(Math.min($0b8bbc48464151e0$var$MAX, value), $0b8bbc48464151e0$var$MIN);
        onChange(value);
    };
    render() {
        const { label: label, placeholder: placeholder, value: value, styles: styles, onBlur: onBlur, onFocus: onFocus } = this.props;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: styles.inputRange,
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                    className: styles.inputRangeInput,
                    placeholder: placeholder,
                    value: value,
                    min: $0b8bbc48464151e0$var$MIN,
                    max: $0b8bbc48464151e0$var$MAX,
                    onChange: this.onChange,
                    onFocus: onFocus,
                    onBlur: onBlur
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: styles.inputRangeLabel,
                    children: label
                })
            ]
        });
    }
}
$0b8bbc48464151e0$var$InputRangeField.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).number
    ]),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).node
    ]).isRequired,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).shape({
        inputRange: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
        inputRangeInput: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
        inputRangeLabel: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string
    }).isRequired,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func.isRequired,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func.isRequired
};
$0b8bbc48464151e0$var$InputRangeField.defaultProps = {
    value: "",
    placeholder: "-"
};
var $0b8bbc48464151e0$export$2e2bcd8739ae039 = $0b8bbc48464151e0$var$InputRangeField;



class $a8156a159c38b7c6$var$DefinedRange extends (0, $bh6RR.Component) {
    constructor(props){
        super(props);
        this.state = {
            rangeOffset: 0,
            focusedInput: -1
        };
    }
    handleRangeChange = (range)=>{
        const { onChange: onChange, ranges: ranges, focusedRange: focusedRange } = this.props;
        const selectedRange = ranges[focusedRange[0]];
        if (!onChange || !selectedRange) return;
        onChange({
            [selectedRange.key || `range${focusedRange[0] + 1}`]: {
                ...selectedRange,
                ...range
            }
        });
    };
    getRangeOptionValue(option) {
        const { ranges: ranges = [], focusedRange: focusedRange = [] } = this.props;
        if (typeof option.getCurrentValue !== "function") return "";
        const selectedRange = ranges[focusedRange[0]] || {};
        return option.getCurrentValue(selectedRange) || "";
    }
    getSelectedRange(ranges, staticRange) {
        const focusedRangeIndex = ranges.findIndex((range)=>{
            if (!range.startDate || !range.endDate || range.disabled) return false;
            return staticRange.isSelected(range);
        });
        const selectedRange = ranges[focusedRangeIndex];
        return {
            selectedRange: selectedRange,
            focusedRangeIndex: focusedRangeIndex
        };
    }
    render() {
        const { headerContent: headerContent, footerContent: footerContent, onPreviewChange: onPreviewChange, inputRanges: inputRanges, staticRanges: staticRanges, ranges: ranges, renderStaticRangeLabel: renderStaticRangeLabel, rangeColors: rangeColors, className: className } = this.props;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))((0, $6869581a7119e209$export$2e2bcd8739ae039).definedRangesWrapper, className),
            children: [
                headerContent,
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: (0, $6869581a7119e209$export$2e2bcd8739ae039).staticRanges,
                    children: staticRanges.map((staticRange, i)=>{
                        const { selectedRange: selectedRange, focusedRangeIndex: focusedRangeIndex } = this.getSelectedRange(ranges, staticRange);
                        let labelContent;
                        if (staticRange.hasCustomRendering) labelContent = renderStaticRangeLabel(staticRange);
                        else labelContent = staticRange.label;
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            type: "button",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))((0, $6869581a7119e209$export$2e2bcd8739ae039).staticRange, {
                                [(0, $6869581a7119e209$export$2e2bcd8739ae039).staticRangeSelected]: Boolean(selectedRange)
                            }),
                            style: {
                                color: selectedRange ? selectedRange.color || rangeColors[focusedRangeIndex] : null
                            },
                            onClick: ()=>this.handleRangeChange(staticRange.range(this.props)),
                            onFocus: ()=>onPreviewChange && onPreviewChange(staticRange.range(this.props)),
                            onMouseOver: ()=>onPreviewChange && onPreviewChange(staticRange.range(this.props)),
                            onMouseLeave: ()=>{
                                onPreviewChange && onPreviewChange();
                            },
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                tabIndex: -1,
                                className: (0, $6869581a7119e209$export$2e2bcd8739ae039).staticRangeLabel,
                                children: labelContent
                            })
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: (0, $6869581a7119e209$export$2e2bcd8739ae039).inputRanges,
                    children: inputRanges.map((rangeOption, i)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0b8bbc48464151e0$export$2e2bcd8739ae039), {
                            styles: (0, $6869581a7119e209$export$2e2bcd8739ae039),
                            label: rangeOption.label,
                            onFocus: ()=>this.setState({
                                    focusedInput: i,
                                    rangeOffset: 0
                                }),
                            onBlur: ()=>this.setState({
                                    rangeOffset: 0
                                }),
                            onChange: (value)=>this.handleRangeChange(rangeOption.range(value, this.props)),
                            value: this.getRangeOptionValue(rangeOption)
                        }, i))
                }),
                footerContent
            ]
        });
    }
}
$a8156a159c38b7c6$var$DefinedRange.propTypes = {
    inputRanges: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).array,
    staticRanges: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).array,
    ranges: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).arrayOf((0, $80c283ff85dafb88$export$98793868965e5ef7)),
    focusedRange: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).number),
    onPreviewChange: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func,
    footerContent: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).any,
    headerContent: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).any,
    rangeColors: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string,
    renderStaticRangeLabel: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).func
};
$a8156a159c38b7c6$var$DefinedRange.defaultProps = {
    inputRanges: (0, $66b5cd7eb1a645da$export$7047d454236a4443),
    staticRanges: (0, $66b5cd7eb1a645da$export$2dc99991a8b5f81d),
    ranges: [],
    rangeColors: [
        "#3d91ff",
        "#3ecf8e",
        "#fed14c"
    ],
    focusedRange: [
        0,
        0
    ]
};
var $a8156a159c38b7c6$export$2e2bcd8739ae039 = $a8156a159c38b7c6$var$DefinedRange;





class $cd7dec96f048b66b$var$DateRangePicker extends (0, $bh6RR.Component) {
    constructor(props){
        super(props);
        this.state = {
            focusedRange: [
                (0, $5daab16bab438d51$export$e9c2db745e2566d3)(props.ranges),
                0
            ]
        };
        this.styles = (0, $5daab16bab438d51$export$593755c5b8f32d8f)([
            (0, $6869581a7119e209$export$2e2bcd8739ae039),
            props.classNames
        ]);
    }
    render() {
        const { focusedRange: focusedRange } = this.state;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))(this.styles.dateRangePickerWrapper, this.props.className),
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a8156a159c38b7c6$export$2e2bcd8739ae039), {
                    focusedRange: focusedRange,
                    onPreviewChange: (value)=>this.dateRange.updatePreview(value ? this.dateRange.calcNewSelection(value, typeof value === "string") : null),
                    ...this.props,
                    range: this.props.ranges[focusedRange[0]],
                    className: undefined
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $22a3ef5ef5ef755f$export$2e2bcd8739ae039), {
                    onRangeFocusChange: (focusedRange)=>this.setState({
                            focusedRange: focusedRange
                        }),
                    focusedRange: focusedRange,
                    ...this.props,
                    ref: (t)=>this.dateRange = t,
                    className: undefined
                })
            ]
        });
    }
}
$cd7dec96f048b66b$var$DateRangePicker.defaultProps = {};
$cd7dec96f048b66b$var$DateRangePicker.propTypes = {
    ...(0, $22a3ef5ef5ef755f$export$2e2bcd8739ae039).propTypes,
    ...(0, $a8156a159c38b7c6$export$2e2bcd8739ae039).propTypes,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string
};
var $cd7dec96f048b66b$export$2e2bcd8739ae039 = $cd7dec96f048b66b$var$DateRangePicker;








const $103ee7acbb5edceb$var$TypesMonths = [
    {
        value: 0,
        text: "January"
    },
    {
        value: 1,
        text: "February"
    },
    {
        value: 2,
        text: "March"
    },
    {
        value: 3,
        text: "April"
    },
    {
        value: 4,
        text: "May"
    },
    {
        value: 5,
        text: "June"
    },
    {
        value: 6,
        text: "July"
    },
    {
        value: 7,
        text: "August"
    },
    {
        value: 8,
        text: "September"
    },
    {
        value: 9,
        text: "October"
    },
    {
        value: 10,
        text: "November"
    },
    {
        value: 11,
        text: "December"
    }
];
var $103ee7acbb5edceb$export$2e2bcd8739ae039 = $103ee7acbb5edceb$var$TypesMonths;



function $ab82b87e555e0e5c$var$AnalyticsModalDatePickerCustomDisplay(focusedDate, changeShownDate, props) {
    const { showMonthArrow: showMonthArrow, locale: locale, minDate: minDate, maxDate: maxDate, showMonthAndYearPickers: showMonthAndYearPickers } = props;
    const upperYearLimit = maxDate.getFullYear();
    const lowerYearLimit = minDate.getFullYear();
    const yearChoices = [
        ...Array(upperYearLimit - lowerYearLimit + 1).keys()
    ].map((year)=>{
        return {
            value: upperYearLimit - year,
            text: upperYearLimit - year
        };
    });
    const upperMonthLimit = maxDate.getMonth();
    const lowerMonthLimit = minDate.getMonth();
    const currentMonth = focusedDate.getMonth();
    const currentYear = focusedDate.getFullYear();
    var typesMonthsDropdown = [
        ...(0, $103ee7acbb5edceb$export$2e2bcd8739ae039)
    ];
    if (lowerYearLimit == currentYear) typesMonthsDropdown = typesMonthsDropdown.splice(lowerMonthLimit);
    if (upperYearLimit == currentYear) typesMonthsDropdown = typesMonthsDropdown.splice(0, upperMonthLimit + 1);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        style: {
            display: "flex",
            justifyContent: "space-between"
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                className: "main-iconButton profil_action main_add-button space_tableButton ",
                icon: "fas fa-arrow-left",
                onClick: ()=>changeShownDate(-1, "monthOffset")
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                choices: typesMonthsDropdown,
                defaultChoice: currentMonth,
                name: "months",
                width: "190px",
                hideSelectItem: false,
                setValue: (name, value)=>changeShownDate(value, "setMonth")
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                choices: yearChoices,
                defaultChoice: currentYear,
                name: "years",
                width: "190px",
                setValue: (name, value)=>changeShownDate(value, "setYear")
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                className: "main-iconButton profil_action main_add-button space_tableButton ",
                icon: "fas fa-arrow-right",
                onClick: ()=>changeShownDate(1, "monthOffset")
            })
        ]
    });
}
var $ab82b87e555e0e5c$export$2e2bcd8739ae039 = $ab82b87e555e0e5c$var$AnalyticsModalDatePickerCustomDisplay;



const $87f5034f7596575d$var$DateRangeCustom = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ daysBack: daysBack, className: className, onDateRangeSelection: onDateRangeSelection, ...restProps })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const [state, setState] = (0, $bh6RR.useState)([
        {
            startDate: new Date(),
            endDate: null,
            key: "selection"
        }
    ]);
    const handleGetSelectedDate = ()=>{
        // Récupérer la date sélectionnée
        let selectedStartDate = state[0].startDate;
        let selectedEndDate = state[0].endDate;
        // Formater les dates dans le format 'yyyy-MM-dd'
        let formattedStartDate = (0, $e91dd50cc5cd7f0e$export$2e2bcd8739ae039)(selectedStartDate, "yyyy-MM-dd");
        let formattedEndDate = (0, $e91dd50cc5cd7f0e$export$2e2bcd8739ae039)(selectedEndDate, "yyyy-MM-dd");
        onDateRangeSelection(formattedStartDate, formattedEndDate);
        onClose();
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        name: "date_range",
        id: modal.id,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "leave-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("form", {
                className: "variables_modal",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "area-edit",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $22a3ef5ef5ef755f$export$2e2bcd8739ae039), {
                            editableDateInputs: true,
                            onChange: (item)=>setState([
                                    item.selection
                                ]),
                            moveRangeOnFirstSelection: false,
                            ranges: state,
                            rangeColors: [
                                "#65abf61a",
                                "#0e7aed",
                                "#65abf61a"
                            ],
                            navigatorRenderer: (0, $ab82b87e555e0e5c$export$2e2bcd8739ae039),
                            dateDisplayFormat: "dd/MM/yyyy",
                            direction: "horizontal"
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        style: {
                            marginLeft: "200px"
                        },
                        label: "Update",
                        type: "button",
                        className: "validate",
                        onClick: ()=>{
                            handleGetSelectedDate();
                        }
                    })
                ]
            })
        ]
    });
});
$87f5034f7596575d$var$DateRangeCustom.defaultProps = {
    className: "full-width input-space",
    type: "date",
    autoComplete: "off"
};
var $87f5034f7596575d$export$2e2bcd8739ae039 = $87f5034f7596575d$var$DateRangeCustom;


var $51167188b4b0cf43$exports = {};
$51167188b4b0cf43$exports = new URL("calendar.c4358763.svg", import.meta.url).toString();


//import "./InputSvg.css"
const $038b1e84aa307cfb$var$InputDate = /*#__PURE__*/ (0, $bh6RR.forwardRef)(({ className: className, dates: dates, setValue: setValue, width: width, removeSeparator: removeSeparator }, ref)=>{
    const onClickView = ()=>{
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $87f5034f7596575d$export$2e2bcd8739ae039), {
            onDateRangeSelection: handleDateRangeSelection
        });
    };
    const formatDate = (_dates)=>{
        return {
            startDate: _dates.split(",")[0],
            endDate: _dates.split(",")[1]
        };
    };
    const [selectedDates, setSelectedDates] = (0, $bh6RR.useState)(dates ? formatDate(dates) : null);
    const handleDateRangeSelection = (startDate, endDate)=>{
        setSelectedDates({
            startDate: startDate,
            endDate: endDate
        });
        if (setValue != null) setValue(`${startDate},${endDate}`);
    };
    (0, $bh6RR.useEffect)(()=>{
        setSelectedDates(dates ? formatDate(dates) : null);
    }, [
        dates
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "input-date-container " + (className ? className : ""),
        style: {
            width: width + "px"
        },
        onClick: onClickView,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                srcSet: (0, (/*@__PURE__*/$parcel$interopDefault($51167188b4b0cf43$exports))),
                width: 20,
                height: 20,
                style: {
                    marginLeft: "20px"
                }
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "text_result_date",
                children: selectedDates ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    children: [
                        " ",
                        selectedDates.startDate,
                        " ",
                        removeSeparator != true && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            style: {
                                color: "var(--main)",
                                fontSize: "20px"
                            },
                            children: "\xb7"
                        }),
                        " ",
                        selectedDates.endDate
                    ]
                }) : "Choose date"
            })
        ]
    });
});
$038b1e84aa307cfb$var$InputDate.defaultProps = {
    name: "",
    className: ""
};
var $038b1e84aa307cfb$export$2e2bcd8739ae039 = $038b1e84aa307cfb$var$InputDate;



var $bh6RR = parcelRequire("bh6RR");

function $ef3cbf1f67c18f63$var$useRegex() {
    const [regex, setRegex] = (0, $bh6RR.useState)([]);
    const { getRegex: getRegex } = (0, $832c2ed0617b1e24$export$2e2bcd8739ae039);
    async function setUpRegex() {
        const [response, errors] = await getRegex();
        if (errors != null) {
            console.log(errors);
            return;
        }
        setRegex(response.data);
    }
    (0, $bh6RR.useEffect)(()=>{
        setUpRegex();
    }, []);
    return {
        regex: regex
    };
}
var $ef3cbf1f67c18f63$export$2e2bcd8739ae039 = $ef3cbf1f67c18f63$var$useRegex;


const $2e18fd23a41712c0$var$StatementBlock = ({ setValue: setValue, column: column, data: data, registerObject: registerObject })=>{
    const inputRef = (0, $bh6RR.useRef)();
    // 0 text
    // 1 number
    // 2 array 
    // 3 date
    //console.log(column)
    //console.log(data)
    const [error, setError] = (0, $bh6RR.useState)(false);
    const { regex: regex } = (0, $ef3cbf1f67c18f63$export$2e2bcd8739ae039)();
    const checkError = (text)=>{
        if (column.rule == 0) return;
        let regex = new RegExp(column.rule.replace(/^\/|\/$/g, ""));
        if (regex.test(text) == true) {
            setError(false);
            registerObject.clearErrors(column.id);
        } else {
            setError(true);
            registerObject.setError(column.id, "error");
        }
    };
    /*
    const getNameRegexByRule = (rule) =>{
        console.log(regex)
        console.log(rule)
        if (regex.length == 0) return rule;
        console.log("-----------")
        console.log(regex.find(r => { return r.rule === rule; }))
        return regex.filter( (r) => r.value === rule).name;
    }   
    */ const errorLabel = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        style: {
            color: "var(--pink)",
            fontSize: "14px"
        },
        children: [
            " Error - Regex : ",
            column.rule,
            " "
        ]
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        children: [
            column.type == "keyword" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                        ref: inputRef,
                        defaultValue: data,
                        onChange: (e)=>{
                            setValue(column.id, e.target.value);
                            checkError(e.target.value);
                        }
                    }),
                    error && errorLabel
                ]
            }),
            column.type == "integer" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                ref: inputRef,
                onKeyDown: (e)=>(0, $eaf3b7858f46cf51$export$74ff82ccb88f9fb1)(e),
                type: "number",
                className: "input_number_statement_block",
                defaultValue: data,
                onChange: (e)=>setValue(column.id, e.target.value)
            }),
            column.type == "text" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                children: [
                    error && errorLabel,
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $dce6552ace431e20$export$2e2bcd8739ae039), {
                        control: registerObject.control,
                        registerObject: registerObject,
                        name: column.id,
                        checkError: checkError
                    })
                ]
            }),
            column.type == "date" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $038b1e84aa307cfb$export$2e2bcd8739ae039), {
                width: 275
            })
        ]
    });
};
var $2e18fd23a41712c0$export$2e2bcd8739ae039 = $2e18fd23a41712c0$var$StatementBlock;






let $30a5f0153d6d93af$var$styleDiv = {
    justifyContent: "start"
};
let $30a5f0153d6d93af$var$styleIcons = {
    marginRight: "25px",
    color: "var(--main)"
};
var $30a5f0153d6d93af$export$2e2bcd8739ae039 = [
    {
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            style: $30a5f0153d6d93af$var$styleDiv,
            children: [
                " ",
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    className: "fas fa-keyboard",
                    style: $30a5f0153d6d93af$var$styleIcons
                }),
                " Text"
            ]
        }),
        value: "keyword"
    },
    {
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            style: $30a5f0153d6d93af$var$styleDiv,
            children: [
                " ",
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    className: "fas fa-dice-six",
                    style: $30a5f0153d6d93af$var$styleIcons
                }),
                " Number"
            ]
        }),
        value: "integer"
    },
    {
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            style: $30a5f0153d6d93af$var$styleDiv,
            children: [
                " ",
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    className: "fas fa-th-large",
                    style: $30a5f0153d6d93af$var$styleIcons
                }),
                " Array"
            ]
        }),
        value: "text"
    }
];
function $30a5f0153d6d93af$export$9e369ef97a290c27(type) {
    let res = "";
    switch(type){
        case "keyword":
            res = "Text";
            break;
        case "integer":
            res = "Number";
            break;
        case "text":
            res = "Array";
            break;
    }
    return res;
}





parcelRequire("bh6RR");












const $a6e5a02937ba671d$var$WorksheetModalBody = ({ data: data, title: title, dataset: dataset })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const { addStatement: addStatement, updateStatement: updateStatement } = (0, $a4ac07fb6dab611c$export$2e2bcd8739ae039);
    const { regex: regex } = (0, $ef3cbf1f67c18f63$export$2e2bcd8739ae039)();
    let defaultValues = data;
    for(let key in defaultValues){
        if (Array.isArray(defaultValues[key]) == false) continue;
        defaultValues[key] = data[key].map((name)=>({
                name: name
            })); // on passe de :  ['toto' ...] -> [{name : 'toto'}] 
    }
    const { register: register, setError: setError, clearErrors: clearErrors, handleSubmit: handleSubmit, control: control, formState: { errors: errors }, formState: formState, getValues: getValues, setValue: setValue } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: defaultValues
    });
    var registerObject = {
        register: register,
        setError: setError,
        clearErrors: clearErrors,
        control: control,
        setValue: setValue
    };
    const onSubmit = async ()=>{
        let dataToSend = getValues();
        if (data) {
            delete dataToSend.timestamp;
            delete dataToSend.id;
        }
        for (let column of dataset.columns){
            if (column.type != "text") continue;
            dataToSend = (0, $8b40e0c1bf1a30fd$export$455b147a0edb9e31)(dataToSend, column.id, "value");
        }
        let [response, error] = data ? await updateStatement(dataset.name, data.id, {
            "data": dataToSend
        }) : await addStatement(dataset.name, {
            "data": dataToSend
        });
        if (error !== null) {
            console.log(error);
            return;
        }
        dataToSend.id = data ? data.id : response._id;
        modal.resolve(dataToSend);
        onClose();
        return;
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
        className: "edit-container",
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                children: title
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                className: "body-editModal-container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                    dataset.columns.map((item, index)=>{
                        let isDate = item.type == "date";
                        let obj = data ? data[item.id] : null;
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                            children: [
                                index > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "statement-modal-bar"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "statement-container " + (isDate ? "statement-container-date" : ""),
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            listClassName: "statement_label_field " + (isDate ? "statement_label_field_date" : ""),
                                            label: item.name
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2e18fd23a41712c0$export$2e2bcd8739ae039), {
                                            data: obj,
                                            column: item,
                                            setValue: setValue,
                                            registerObject: registerObject
                                        })
                                    ]
                                })
                            ]
                        });
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                children: dataset.columns.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                    type: "button",
                    label: data ? "Update" : "Add",
                    disabled: Object.keys(errors).length == 0 ? getValues().label != "" ? false : true : true,
                    onClick: onSubmit
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {})
        ]
    });
};
var $a6e5a02937ba671d$export$2e2bcd8739ae039 = $a6e5a02937ba671d$var$WorksheetModalBody;


const $5a38ea14c2b7b34e$var$StatementModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ dataset: dataset, title: title, data: data })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $9c2d88d3df32f983$export$2e2bcd8739ae039), {
        name: "statement_edit_modal",
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            dataset.dataset_type_id == 3 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a6e5a02937ba671d$export$2e2bcd8739ae039), {
                data: data,
                title: title,
                dataset: dataset
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5de763fcc778488c$export$2e2bcd8739ae039), {
                data: data,
                title: title,
                dataset: dataset
            })
        ]
    });
});
var $5a38ea14c2b7b34e$export$2e2bcd8739ae039 = $5a38ea14c2b7b34e$var$StatementModal;




var $bh6RR = parcelRequire("bh6RR");


















const $0eac04b86249ab2c$var$StatementTestModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ dataset: dataset, data: data })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    var title = "Add your Statement";
    const { searchResponse: searchResponse } = (0, $a4ac07fb6dab611c$export$2e2bcd8739ae039);
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const [inputSearch, setInputSearch] = (0, $bh6RR.useState)("");
    const [labels, setLabels] = (0, $bh6RR.useState)("");
    const [match, setMatch] = (0, $bh6RR.useState)("");
    const [responseData, setResponseData] = (0, $bh6RR.useState)("");
    const openResponseSection = async ()=>{
        console.log(match);
        const [response, errors] = await searchResponse(dataset.name, {
            "question": inputSearch,
            "match": match,
            "labels": labels
        });
        if (errors != null) {
            console.log(errors);
            return;
        }
        setResponseData(response);
    };
    const hideCloseButton = (bool)=>{
        let element = document.getElementById("hide_close_button");
        element.style.opacity = bool ? "0" : "1";
        element.style.pointerEvents = bool ? "cursor" : "none";
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        name: "test",
        onKeyUp: (e)=>(0, $76742abc2a452912$export$2e2bcd8739ae039)(e, 9),
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $9c2d88d3df32f983$export$2e2bcd8739ae039), {
            name: "change-password",
            id: modal.id,
            autoClose: "true",
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    id: "hide_close_button",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "button-leave",
                        id: "close_modal_container",
                        onClick: ()=>onClose({
                                idIconModal: "close_modal_container"
                            }),
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                            id: "close_modal",
                            className: "fa fa-times",
                            "aria-hidden": "true"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $51a8b46ec4198ef9$export$2e2bcd8739ae039), {
                    className: "slider-text_modal",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                            name: "test-part",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
                                className: "edit-container",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                                        children: "Test your Statement"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                                        className: "body-editModal-container",
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                label: "Statement"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                className: "raw",
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                                        placeholder: "Tell me something",
                                                        onKeyUp: (e)=>{
                                                            e.keyCode == "13" && openResponseSection();
                                                        },
                                                        onChange: (e)=>setInputSearch(e.target.value)
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                                        className: "main-iconButton add-hover modalButtons-input",
                                                        icon: "fas fa-paper-plane sizeModal-icon",
                                                        onClick: openResponseSection
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                label: "Label"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                        className: "raw label-statement-container",
                                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                                            placeholder: "Enter here",
                                                            onChange: (e)=>setLabels(e.target.value)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                        className: "checkbox-statement",
                                                        children: [
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                                label: "Exact Match",
                                                                listLabelClassName: "labelTest"
                                                            }),
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $52b728934d836302$export$2e2bcd8739ae039), {
                                                                id: "statement",
                                                                classNameLabel: "inputBox-center",
                                                                onClick: (val)=>setMatch(val)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            responseData ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                className: "responseSection",
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                        listClassName: "modal-bar bar_test-modal"
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                        listClassName: "name",
                                                        label: "Response"
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                        className: "elements-container",
                                                        children: [
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                                className: "response-elementSections",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                                        label: "Label"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                                                        value: responseData.label ? responseData.label : "",
                                                                        disabled: true
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                                className: "response-elementSections",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                                        label: "Response"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0db11626bd290ec1$export$2e2bcd8739ae039), {
                                                                        value: responseData.response ? responseData.response : responseData.info,
                                                                        disabled: true
                                                                    })
                                                                ]
                                                            }),
                                                            !responseData.label ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                                className: "button_add_statement",
                                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                                                    className: "cancel",
                                                                    label: "Add New Statement",
                                                                    onClick: ()=>{
                                                                        (0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("statement");
                                                                        hideCloseButton(true);
                                                                    }
                                                                })
                                                            }) : null
                                                        ]
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                            name: "statement",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5de763fcc778488c$export$2e2bcd8739ae039), {
                                dataset: dataset,
                                title: title,
                                is_button_back: true
                            })
                        })
                    ]
                })
            ]
        })
    });
});
var $0eac04b86249ab2c$export$2e2bcd8739ae039 = $0eac04b86249ab2c$var$StatementTestModal;




var $bh6RR = parcelRequire("bh6RR");


const $daeff99345aec488$var$StringTable = ({ data: data })=>{
    const [isOpen, setOpen] = (0, $bh6RR.useState)(false);
    const openListData = ()=>{
        setOpen(!isOpen);
    };
    let lastElement = data != null ? data[data.length - 1] : null;
    const length = data != null && lastElement ? data.length : 0;
    const nbLetter = 35;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "data_container",
        onClick: ()=>openListData(),
        children: isOpen == false ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            className: "string_table_documents",
            children: [
                "  ",
                data != null && lastElement ? lastElement.length > nbLetter ? lastElement.substring(0, nbLetter) + "..." : lastElement : "",
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    style: {
                        color: "var(--main)  ",
                        fontWeight: "bold"
                    },
                    children: [
                        " ",
                        length > 1 ? `(+ ${length - 1})` : ""
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            style: {
                textAlign: "left"
            },
            children: [
                " ",
                data?.map((elem)=>elem).reduce((prev, curr)=>[
                        prev,
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                        curr
                    ]),
                " "
            ]
        })
    });
};
var $daeff99345aec488$export$2e2bcd8739ae039 = $daeff99345aec488$var$StringTable;




var $bh6RR = parcelRequire("bh6RR");












const $7b7489c3c4225602$var$ImportStatementModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ nameDataset: nameDataset, title: title, data: data })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const [file, setFile] = (0, $bh6RR.useState)();
    const [loadAnim, setLoading] = (0, $bh6RR.useState)(null);
    const { importStatement: importStatement } = (0, $a4ac07fb6dab611c$export$2e2bcd8739ae039);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const onSubmit = async ()=>{
        const formData = new (0, (/*@__PURE__*/$parcel$interopDefault($07d55ecd4e888d68$exports)))();
        formData.append("file", file);
        let [response, error] = await importStatement(nameDataset, formData) //await importStatement(nameDataset, formData)
        ;
        if (error !== null) {
            onClose();
            toast.error("Error", /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $71da39f6b3fb053c$export$2e2bcd8739ae039), {
                text: error.data
            }), 7000);
            return;
        }
        setLoading("finish");
        setTimeout(()=>{
            modal.resolve(response);
            onClose();
        }, 2000);
    //modal.resolve(response).then(() => { console.log("test") })
    //return;
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        name: "change-password",
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "leave-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
                className: "form-import",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                        children: "Import your Sentences"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "container_import",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                            className: "form-import_body",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $47da697040d42413$export$2e2bcd8739ae039), {
                                _setFile: setFile,
                                accept: ".xlsx,.csv",
                                loadAnim: loadAnim
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "button_center",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                className: "validate",
                                label: "Upload",
                                disabled: file != null ? false : true,
                                onClick: ()=>{
                                    onSubmit();
                                    setLoading(true);
                                }
                            })
                        })
                    })
                ]
            })
        ]
    });
});
var $7b7489c3c4225602$export$2e2bcd8739ae039 = $7b7489c3c4225602$var$ImportStatementModal;




var $bh6RR = parcelRequire("bh6RR");















const $186149145fb134c5$var$ImportWorksheetModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ nameDataset: nameDataset, title: title, data: data })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const [file, setFile] = (0, $bh6RR.useState)();
    const [loadAnim, setLoading] = (0, $bh6RR.useState)(null);
    const { importStatement: importStatement } = (0, $a4ac07fb6dab611c$export$2e2bcd8739ae039);
    const [column, setColumn] = (0, $bh6RR.useState)(false);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const onSubmit = async ()=>{
        const formData = new (0, (/*@__PURE__*/$parcel$interopDefault($07d55ecd4e888d68$exports)))();
        formData.append("with_columns", column);
        formData.append("file", file);
        let [response, error] = await importStatement(nameDataset, formData) //await importStatement(nameDataset, formData)
        ;
        if (error !== null) {
            onClose();
            toast.error("Error", /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $71da39f6b3fb053c$export$2e2bcd8739ae039), {
                text: error.data
            }), 7000);
            return;
        }
        setLoading("finish");
        setTimeout(()=>{
            modal.resolve(response);
            onClose();
        }, 2000);
    //modal.resolve(response).then(() => { console.log("test") })
    //return;
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        name: "change-password",
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "leave-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
                className: "form-import",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                        children: "Import your Data"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                        className: "form-import_body",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "container_import",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $47da697040d42413$export$2e2bcd8739ae039), {
                                    _setFile: setFile,
                                    accept: ".xlsx,.csv",
                                    loadAnim: loadAnim
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "With columns",
                                    listLabelClassName: "titles-input",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $52b728934d836302$export$2e2bcd8739ae039), {
                                        id: "statement",
                                        style: {
                                            marginLeft: "15px"
                                        },
                                        onClick: (val)=>setColumn(val)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "button_center",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                className: "validate",
                                label: "Upload",
                                disabled: file != null ? false : true,
                                onClick: ()=>{
                                    onSubmit();
                                    setLoading(true);
                                }
                            })
                        })
                    })
                ]
            })
        ]
    });
});
var $186149145fb134c5$export$2e2bcd8739ae039 = $186149145fb134c5$var$ImportWorksheetModal;



parcelRequire("bh6RR");










const $c9bbdcb517b3de14$var$DeleteAllStatementModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ nameDataset: nameDataset, title: title, data: data })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const { deleteAllStatements: deleteAllStatements } = (0, $a4ac07fb6dab611c$export$2e2bcd8739ae039);
    const onSubmit = async ()=>{
        let [response, error] = await deleteAllStatements(nameDataset) //await asyncWrapper(timeout, 2000) //await deleteAllStatements(nameDataset)
        ;
        if (error !== null) {
            console.log(error);
            return;
        }
        setTimeout(()=>{
            modal.resolve(true);
            onClose();
        }, 500);
        return;
    };
    function timeout(ms) {
        return new Promise((resolve)=>setTimeout(resolve, ms));
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        name: "delete-all_informations",
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "leave-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
                className: "modal-form",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                        children: "Delete All Information"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                listLabelClassName: "normal_size normal_font",
                                label: " You really want to delete all information ?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "button_center",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                    className: "validate",
                                    label: "No",
                                    onClick: ()=>onClose(),
                                    style: {
                                        marginRight: "20px"
                                    }
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                    className: "cancel",
                                    label: "Yes",
                                    onClick: onSubmit
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
});
var $c9bbdcb517b3de14$export$2e2bcd8739ae039 = $c9bbdcb517b3de14$var$DeleteAllStatementModal;



















var $8af848ce8fce3daf$export$2e2bcd8739ae039 = {
    create: {
        title: "Add a Column",
        send: "Create"
    },
    update: {
        title: "Update Column",
        send: "Update"
    }
};




var $bh6RR = parcelRequire("bh6RR");

const $c91c660a7ad6a089$var$StatementColumnModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ column: column, dataset: dataset })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    var isAdding = column == null;
    const formData = (0, $8af848ce8fce3daf$export$2e2bcd8739ae039)[isAdding ? "create" : "update"];
    const { addColumn: addColumn, updateColumn: updateColumn } = (0, $832c2ed0617b1e24$export$2e2bcd8739ae039);
    const { regex: regex } = (0, $ef3cbf1f67c18f63$export$2e2bcd8739ae039)();
    const [listRegex, setRegex] = (0, $bh6RR.useState)([]);
    const { register: register, handleSubmit: handleSubmit, getValues: getValues, setValue: setValue, watch: watch, formState: { errors: errors }, formState: formState } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            name: isAdding ? "" : column.name,
            type: isAdding ? "keyword" : column.type,
            regex: isAdding ? "0" : column.rule
        }
    });
    const onSubmit = async ()=>{
        if (isAdding == false) setValue("index", column.index);
        let dataToSend = getValues();
        dataToSend.name = dataToSend.name.trim();
        const [res, error] = isAdding ? await addColumn(dataset.id, dataToSend) : await updateColumn(dataset.id, dataToSend);
        if (error != null) {
            console.error(error);
            return;
        }
        modal.resolve();
        onClose();
    };
    const setUpRegex = async ()=>{
        let listRegex = [];
        listRegex.push({
            text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    width: "100%",
                    textAlign: "center"
                },
                children: " Nothing "
            }),
            value: 0
        });
        regex.forEach((reg)=>listRegex.push({
                text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    style: {
                        justifyContent: "start"
                    },
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                            className: reg.icon,
                            style: {
                                marginRight: "25px",
                                color: "var(--main)"
                            }
                        }),
                        " ",
                        reg.name
                    ]
                }),
                value: reg.value
            }));
        setRegex(listRegex);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (regex.length == 0) return;
        setUpRegex();
    }, [
        regex
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        name: "change-password",
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
            className: "statement_form_column_container",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                    children: formData.title
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                    className: "statement_form_column_body",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "statement_form_column_title",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Column's name",
                                    listLabelClassName: "field-modal"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ...register("name", {
                                        required: true,
                                        minLength: 3
                                    }),
                                    placeholder: "Enter the label of the column",
                                    className: "statement_form_column_text_input",
                                    style: errors.name ? {
                                        borderColor: "red"
                                    } : {}
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "error",
                                    style: {
                                        fontSize: "14px",
                                        marginTop: "5px",
                                        height: "10px"
                                    },
                                    children: errors.name ? errors.name.message ? errors.name.message : "At least 3 letters" : ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "statement_form_column_dropdown_container",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Type Column",
                                    listLabelClassName: "titles-input"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    style: {
                                        marginLeft: "15%",
                                        marginTop: "2%"
                                    },
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                        ...register("type"),
                                        setValue: setValue,
                                        choices: (0, $30a5f0153d6d93af$export$2e2bcd8739ae039),
                                        defaultChoice: isAdding ? "keyword" : column.type,
                                        width: "200px",
                                        disabled: !isAdding
                                    })
                                })
                            ]
                        }),
                        listRegex.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "statement_form_column_dropdown_container",
                            style: {
                                marginTop: "10%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Type Regex",
                                    listLabelClassName: "titles-input"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    style: {
                                        marginLeft: "15%",
                                        marginTop: "2%"
                                    },
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                        ...register("regex"),
                                        setValue: setValue,
                                        choices: listRegex,
                                        defaultChoice: isAdding ? "0" : column.rule,
                                        width: "200px",
                                        reverse: true
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                            className: "cancel",
                            label: "Cancel",
                            type: "button",
                            onClick: ()=>onClose(),
                            style: {
                                marginRight: "20px"
                            }
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                            className: "validate",
                            label: formData.send,
                            type: "submit",
                            disabled: !formState.isValid
                        })
                    ]
                })
            ]
        })
    });
});
var $c91c660a7ad6a089$export$2e2bcd8739ae039 = $c91c660a7ad6a089$var$StatementColumnModal;







var $bh6RR = parcelRequire("bh6RR");
function $74fb267e7fa3c3c3$var$cutText(text, max = 10) {
    if (!text) return "";
    text = text.toString();
    return text.length > max ? text.slice(0, max) + "..." : text;
}
function $74fb267e7fa3c3c3$var$HoverHeaderPopup({ column: column, rowsData: rowsData = [], children: children }) {
    const [isOpen, setIsOpen] = (0, $bh6RR.useState)(false);
    if (column?.id === "id" || column?.name === "ID") return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: children
    });
    const fieldKey = (0, $bh6RR.useMemo)(()=>column?.id, [
        column
    ]);
    const topValues = (0, $bh6RR.useMemo)(()=>{
        if (!rowsData || !fieldKey) return [];
        const values = rowsData.map((row)=>row[fieldKey]).filter((v)=>v !== undefined && v !== null && v !== "").map((v)=>v.toString().trim().toLowerCase());
        if (!values.length) return [];
        const counts = {};
        values.forEach((v)=>{
            counts[v] = (counts[v] || 0) + 1;
        });
        const entries = Object.entries(counts);
        if (entries.length > 20) return [];
        return entries.sort((a, b)=>b[1] - a[1]);
    }, [
        rowsData,
        fieldKey
    ]);
    const max = topValues.length ? Math.max(...topValues.map((v)=>v[1])) : 1;
    let popupWidth = topValues.length === 0 ? 180 : Math.max(120, topValues.length * 60);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        style: {
            position: "relative",
            display: "inline-block"
        },
        onMouseEnter: ()=>setIsOpen(true),
        onMouseLeave: ()=>setIsOpen(false),
        children: [
            children,
            isOpen && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                style: {
                    position: "fixed",
                    top: "auto",
                    left: "auto",
                    marginTop: "8px",
                    background: "white",
                    padding: "16px",
                    borderRadius: "10px",
                    boxShadow: "0 12px 30px rgba(0,0,0,0.25)",
                    zIndex: 99999,
                    width: popupWidth,
                    pointerEvents: "none"
                },
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                        style: {
                            fontSize: "13px"
                        },
                        title: column.name,
                        children: $74fb267e7fa3c3c3$var$cutText(column.name, 18)
                    }),
                    topValues.length === 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        style: {
                            fontSize: "12px",
                            marginTop: "10px"
                        },
                        children: "No Preview Available"
                    }),
                    topValues.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            alignItems: "flex-end",
                            justifyContent: "space-between",
                            height: "140px",
                            marginTop: "15px"
                        },
                        children: topValues.map(([value, count])=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    width: "50px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        style: {
                                            background: "var(--main)",
                                            width: "100%",
                                            height: `${count / max * 100}px`,
                                            borderRadius: "6px 6px 0 0",
                                            transition: "0.3s"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        style: {
                                            fontSize: "10px",
                                            marginTop: "6px",
                                            maxWidth: "60px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            textAlign: "center"
                                        },
                                        title: value,
                                        children: $74fb267e7fa3c3c3$var$cutText(value, 10)
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        style: {
                                            fontSize: "10px",
                                            color: "#666"
                                        },
                                        children: count
                                    })
                                ]
                            }, value))
                    })
                ]
            })
        ]
    });
}
var $74fb267e7fa3c3c3$export$2e2bcd8739ae039 = $74fb267e7fa3c3c3$var$HoverHeaderPopup;


function $cc2cf9355a300430$var$StatementTable() {
    const { name: name } = (0, $6a9dcc96d11bcd0d$export$99eaa27ddbbb95ef)();
    const { getDataset: getDataset } = (0, $cef77ca5b38a78fa$export$2e2bcd8739ae039);
    const { deleteStatement: deleteStatement } = (0, $a4ac07fb6dab611c$export$2e2bcd8739ae039);
    const { deleteColumn: deleteColumn } = (0, $832c2ed0617b1e24$export$2e2bcd8739ae039);
    const { getColumns: getColumns } = (0, $832c2ed0617b1e24$export$2e2bcd8739ae039);
    const { datasets: datasets } = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)().get("company");
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const dataset = datasets.find((dataset)=>dataset.name === name);
    var isWorksheet = dataset.dataset_type_id == 3;
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const columnCell = (column, canBeModified = true)=>{
        return isWorksheet && canBeModified ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            onClick: ()=>onClickEditModalColumn(column),
            className: "column_field_table_statement",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    className: "column_field_table_statement",
                    children: [
                        " ",
                        column.name
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    className: "fas fa-trash delete_column_button",
                    onClick: (e)=>{
                        onClickDeleteColumn(column), e.stopPropagation();
                    }
                })
            ]
        }) : column;
    };
    const [columnsWorksheet, setColumnsWorksheet] = (0, $bh6RR.useState)(null);
    const [refreshTable, setRefreshTable] = (0, $bh6RR.useState)(false);
    // const rowsRef = useRef([]);
    // const allRowsRef = useRef([]);
    const [cells, setCells] = (0, $bh6RR.useState)(isWorksheet ? [] : [
        {
            column: columnCell("LABEL"),
            name: "label",
            sort: true,
            show: (value)=>value
        },
        {
            column: columnCell("SENTENCES"),
            name: "statements",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $daeff99345aec488$export$2e2bcd8739ae039), {
                    data: value
                })
        },
        {
            column: columnCell("RESPONSES"),
            name: "responses",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $daeff99345aec488$export$2e2bcd8739ae039), {
                    data: value
                })
        }
    ]);
    //  const getDatasetByName = async (data) => {
    //     const result = await getDataset(decodeURI(name), data);
    //     if (result && result[0] && result[0].data) {
    //         rowsRef.current = result[0].data;
    //     }
    //     return result;
    // };
    // const getAllDatasetByName = async (data) => {
    //     let page = 1;
    //     let allRows = [];
    //     while (true) {
    //         const result = await getDataset(decodeURI(name), {
    //             ...data,
    //             page: page
    //         });
    //         if (!result || !result[0] || !result[0].data) break;
    //         const rows = result[0].data;
    //         allRows = [...allRows, ...rows];
    //         // stop when last page reached
    //         if (rows.length < result[0].per_page) break;
    //         page++;
    //     }
    //     allRowsRef.current = allRows;
    //     console.log("Total rows stored:", allRowsRef.current.length);
    //     return await getDataset(decodeURI(name), data);
    // };
    const setUpColumns = async ()=>{
        const [res, error] = await getColumns(dataset.id);
        if (error) {
            console.error(error);
            return;
        }
        let _columns = res.data.filter((column)=>column.deleted == false);
        _columns.unshift({
            name: "ID",
            id: "id",
            canBeModified: false
        });
        // loadData = await getDatasetByName();
        // const loadData = await getAllDatasetByName();
        setCells(_columns.map((column)=>{
            return {
                column: column.canBeModified == false ? columnCell(column.name, false) : columnCell(column),
                //    column: (
                //         <HoverHeaderPopup column={column} rowsData={allRowsRef.current}>
                //             {column.canBeModified == false ? columnCell(column.name, false) : columnCell(column)}
                //         </HoverHeaderPopup>
                //     ),
                name: column.id,
                //sort: true, // dependra du type
                show: (value)=>column.type == "text" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        style: {
                            marginRight: "15px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $daeff99345aec488$export$2e2bcd8739ae039), {
                                data: value
                            }),
                            " "
                        ]
                    }) : column.canBeModified == false ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                        style: {
                            color: "var(--main)",
                            cursor: "pointer"
                        },
                        onClick: (e)=>navigator.clipboard.writeText(value).then((_)=>{
                                toast.success("Copy token to clipboard", "You can paste this token where you need !", 5000);
                            }),
                        children: [
                            "  ",
                            (0, $2ec34e35a5139fe7$export$2e2bcd8739ae039)(value)
                        ]
                    }) : value && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        style: {
                            marginRight: "15px"
                        },
                        title: value,
                        children: value.toString().split(";").slice(0, 5).join(";") + (value.toString().split(";").slice(5).length > 5 ? "..." : "")
                    })
            };
        }));
        setColumnsWorksheet(res.data);
    };
    //const onClickAdd = ({ deleteRow, row }) => row.test = 'name' && console.log(row) && updateRow(row);
    const getDatasetByName = async (data)=>{
        return getDataset(decodeURI(name), data);
    };
    const onClickEditModalColumn = async (column)=>{
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $c91c660a7ad6a089$export$2e2bcd8739ae039), {
            column: column,
            dataset: dataset
        }).then(()=>setUpColumns());
    };
    const onClickOpenModalColumn = async ()=>{
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $c91c660a7ad6a089$export$2e2bcd8739ae039), {
            dataset: dataset
        }).then(()=>setUpColumns());
    };
    const onClickDelete = ({ row: row, deleteRow: deleteRow })=>{
        const { id: id, label: label } = row;
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete Statement ",
            body: "Do you really want to delete your statement " + (label ?? "") + " ?",
            api: {
                request: deleteStatement,
                param: [
                    name,
                    id
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel",
                    style: {
                        marginRight: "20px"
                    }
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ]
        }).then(()=>{
            deleteRow(id);
        });
    };
    const onClickDeleteColumn = (column)=>{
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete Column ",
            body: "Do you really want to delete the column " + (column.name ?? "") + " ?",
            api: {
                request: deleteColumn,
                param: [
                    name,
                    {
                        index: column.index
                    }
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel",
                    style: {
                        marginRight: "20px"
                    }
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ]
        }).then(()=>setUpColumns());
    };
    const showEditModal = async ({ row: row, updateRow: updateRow })=>{
        dataset.columns = columnsWorksheet;
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $5a38ea14c2b7b34e$export$2e2bcd8739ae039), {
            title: "Your Statement",
            dataset: dataset,
            data: {
                ...row
            }
        }).then((statement)=>updateRow(statement));
    };
    const showAddModal = ({ addRow: addRow })=>{
        dataset.columns = columnsWorksheet;
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $5a38ea14c2b7b34e$export$2e2bcd8739ae039), {
            dataset: dataset,
            title: "Add your Statement"
        }).then((statement)=>addRow(statement));
    };
    const showTestModal = ({ addRow: addRow, row: row })=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $0eac04b86249ab2c$export$2e2bcd8739ae039), {
            dataset: dataset,
            data: {
                ...row
            }
        }).then((statement)=>addRow(statement));
    const refreshData = async ()=>{
        await setUpColumns();
        setRefreshTable(!refreshTable);
    };
    const showImportStatementModal = ()=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $7b7489c3c4225602$export$2e2bcd8739ae039), {
            nameDataset: name
        }).then(()=>{
            isWorksheet ? setUpColumns() : updateBoolState(!boolState);
        });
    const showImportWorksheetModal = ()=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $186149145fb134c5$export$2e2bcd8739ae039), {
            nameDataset: name
        }).then(()=>refreshData());
    //const showImportStopWordsModal = () => NiceModal.show(ImportStopWordsModal, { nameDataset: name })
    const showDeleteAllStatementModal = ()=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $c9bbdcb517b3de14$export$2e2bcd8739ae039), {
            nameDataset: name
        }).then(()=>updateBoolState(!boolState));
    const actions = [
        {
            className: "fas fa-edit action-button edit_action",
            style: {},
            onClick: showEditModal
        },
        {
            className: "fas fa-trash action-button delete_action",
            style: {},
            onClick: onClickDelete
        }
    ];
    var actionExtension = isWorksheet ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
            className: " action_dataset_extension",
            icon: "fas fa-plus",
            title: "Add a new column",
            onClick: onClickOpenModalColumn
        })
    }) : false;
    var buttons = [
        {
            icon: "fas fa-plus",
            style: {
                margin: "0 10px"
            },
            onClick: showAddModal
        }
    ];
    if (!isWorksheet) buttons.push({
        icon: "fas fa-rocket",
        style: {
            margin: "0 10px"
        },
        onClick: showTestModal
    });
    if (isWorksheet) buttons.unshift({
        icon: "fas fa-pie-chart",
        style: {
            margin: "0 10px"
        },
        onClick: ()=>navigate(`/company/${(0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company").name}/datasets/${name}/statistics`)
    });
    const filters = isWorksheet ? [
        {
            type: "input",
            placeholder: "terms",
            name: "terms"
        }
    ] : [
        {
            type: "input",
            placeholder: "tag",
            name: "label"
        }
    ];
    const url = (0, $651df53b10514175$export$a7b6bc01c63cdfc3).REACT_APP_API_PATH + `/dataset/${name}/export?token_auth=${(0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("token")}&company=${(0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company").id}`;
    const [boolState, updateBoolState] = (0, $bh6RR.useState)(false);
    (0, $bh6RR.useEffect)(()=>{
        if (isWorksheet) setUpColumns();
    }, [
        name
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: `Manage ${name} statements`,
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                        onClick: isWorksheet ? showImportWorksheetModal : showImportStatementModal,
                        className: " icons_up main-iconButton profil_action main_add-button space_tableButton",
                        icon: "fas fa-upload",
                        title: "Import Statements"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                        href: url,
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                            className: " icons_up main-iconButton profil_action main_add-button space_tableButton",
                            icon: "fas fa-download",
                            title: "Export Statements"
                        })
                    }),
                    (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("erase_all_raw_dataset") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                        onClick: showDeleteAllStatementModal,
                        className: " icons_up main-iconButton delete_action main_add-button space_tableButton red-button-action-bg_color",
                        icon: "fas fa-trash",
                        title: "Delete All Statements"
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
                name: isWorksheet ? "data" : "prompt",
                plurial: !isWorksheet,
                cells: cells,
                api: getDatasetByName,
                actions: actions,
                buttons: buttons,
                filters: filters,
                actionExtension: actionExtension,
                refreshState: [
                    refreshTable,
                    setRefreshTable
                ]
            })
        ]
    });
}
var $cc2cf9355a300430$export$2e2bcd8739ae039 = $cc2cf9355a300430$var$StatementTable;


function $105763ee5f8cba50$var$StatementList() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cc2cf9355a300430$export$2e2bcd8739ae039), {});
}
var $105763ee5f8cba50$export$2e2bcd8739ae039 = $105763ee5f8cba50$var$StatementList;



parcelRequire("bh6RR");


parcelRequire("bh6RR");










var $9130b6e65de36309$export$2e2bcd8739ae039 = {
    create: {
        title: "\uD83D\uDCD6 Create a new Dataset",
        send: "Create"
    },
    update: {
        title: "\uD83D\uDCD6 Update your Dataset",
        send: "Update"
    }
};




var $223088a0eba1b0a3$export$2e2bcd8739ae039 = [
    //{ text : "Ivy (IA)", value : 1},
    //{ text : "Ivy (Old)", value : 2},
    {
        text: "Conversational",
        value: 1
    },
    {
        text: "No Conversational",
        value: 2
    },
    {
        text: "Worksheet",
        value: 3
    }
];



function $43b5eeac22ae08f6$var$DatasetForm({ data: data, type: mode }) {
    let navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const formData = (0, $9130b6e65de36309$export$2e2bcd8739ae039)[mode];
    formData.values = data;
    var isUpdateMode = mode != "create";
    const { addDataset: addDataset, updateDataset: updateDataset, isDatasetNameAvailable: isDatasetNameAvailable } = (0, $cef77ca5b38a78fa$export$2e2bcd8739ae039);
    const { register: register, clearErrors: clearErrors, handleSubmit: handleSubmit, watch: watch, setError: setError, formState: { errors: errors }, formState: formState, getValues: getValues, setValue: setValue } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            name: isUpdateMode ? formData.values.name : "",
            description: isUpdateMode ? formData.values.description : "",
            language: isUpdateMode ? formData.values.language.slug.toLowerCase() : "fr",
            public: isUpdateMode ? formData.values.public : 0,
            dataset_type_id: isUpdateMode ? formData.values.dataset_type_id : 1
        }
    });
    const checkNameAvailability = async (name)=>{
        if (data?.name === name) return true;
        if (name.length < 3) return false;
        var [response, errors] = await isDatasetNameAvailable(name);
        if (errors != null) {
            console.log(errors);
            return;
        }
        response = response.filter((bot)=>bot.name == name);
        if (response.length == 1) setError("name", {
            type: "focus",
            message: "Oups this name is already taken"
        });
        else {
            clearErrors("name");
            return true;
        }
    };
    const onSubmit = async ()=>{
        const dataToSend = getValues();
        dataToSend.name = dataToSend.name.trim();
        let nameAvailable = await checkNameAvailability(dataToSend.name);
        if (nameAvailable != true) return;
        dataToSend.language = dataToSend.language.toUpperCase();
        let [response, errors] = isUpdateMode ? await updateDataset(formData.values.id, dataToSend) : await addDataset(dataToSend);
        return navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/datasets/list"));
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
        onSubmit: handleSubmit(onSubmit),
        className: "faq_form_container",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                children: formData.title
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                children: "\uD83C\uDF0E Public Mode"
                            }),
                            listLabelClassName: "titles-input",
                            listClassName: "flex switch_form_faq",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                style: {
                                    width: "150px",
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                    setValue: setValue,
                                    ...register("public"),
                                    checked: getValues("public")
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "botForm-container",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            label: "Name",
                            listLabelClassName: "titles-input",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ...register("name", {
                                        required: true,
                                        minLength: 3,
                                        onChange: (e)=>checkNameAvailability(e.target.value)
                                    }),
                                    style: errors.name ? {
                                        borderColor: "red"
                                    } : {}
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "error",
                                    children: errors.name ? errors.name.message ? errors.name.message : "At least 3 letters" : ""
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "botForm-container",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            label: "Description",
                            listLabelClassName: "titles-input",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0db11626bd290ec1$export$2e2bcd8739ae039), {
                                style: {
                                    height: "40px"
                                },
                                ...register("description", {
                                    required: true
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        style: {
                            marginTop: "25px",
                            marginBottom: "25px",
                            display: "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Select your data type",
                                listLabelClassName: "titles-input"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                style: {
                                    marginLeft: "5%",
                                    marginTop: "2%"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                    ...register("dataset_type_id"),
                                    setValue: setValue,
                                    choices: (0, $223088a0eba1b0a3$export$2e2bcd8739ae039),
                                    defaultChoice: mode == "update" ? watch("dataset_type_id") : 1,
                                    width: "185px",
                                    disabled: mode == "update"
                                })
                            })
                        ]
                    }),
                    watch("dataset_type_id") == 1 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        style: {
                            marginTop: "25px",
                            marginBottom: "25px",
                            display: "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Select your language",
                                listLabelClassName: "titles-input"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                style: {
                                    marginLeft: "5%",
                                    marginTop: "2%"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                    ...register("language"),
                                    setValue: setValue,
                                    choices: (0, $9f25a7789d4433b1$export$2e2bcd8739ae039),
                                    defaultChoice: mode == "update" ? formData.values.language.slug.toLowerCase() : "fr",
                                    disabled: mode == "update",
                                    width: "185px"
                                })
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                    type: "submit",
                    label: formData.send,
                    className: "validate",
                    disabled: !formState.isValid
                })
            })
        ]
    });
}
$43b5eeac22ae08f6$var$DatasetForm.defaultProps = {
    data: {
        public: true
    },
    type: "create"
};
var $43b5eeac22ae08f6$export$2e2bcd8739ae039 = $43b5eeac22ae08f6$var$DatasetForm;



function $7d1a917b88f467f9$var$DatasetCreate() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $afaae2ff7871e331$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $43b5eeac22ae08f6$export$2e2bcd8739ae039), {
                type: "create"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f0aded74899c8465$export$2e2bcd8739ae039), {})
        ]
    });
}
var $7d1a917b88f467f9$export$2e2bcd8739ae039 = $7d1a917b88f467f9$var$DatasetCreate;



parcelRequire("bh6RR");




function $8e8c7c5e2149b59a$var$DatasetUpdate() {
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $afaae2ff7871e331$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $43b5eeac22ae08f6$export$2e2bcd8739ae039), {
                data: location.state.data,
                type: "update"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f0aded74899c8465$export$2e2bcd8739ae039), {})
        ]
    });
}
var $8e8c7c5e2149b59a$export$2e2bcd8739ae039 = $8e8c7c5e2149b59a$var$DatasetUpdate;





var $bh6RR = parcelRequire("bh6RR");










var $bh6RR = parcelRequire("bh6RR");



/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */ function $5ea20a8ea64fa9d9$export$cf2f7c5792f80b46() {}
const $5ea20a8ea64fa9d9$export$4c3d22f3d993c33f = function() {
    let id = 0;
    return function() {
        return id++;
    };
}();
function $5ea20a8ea64fa9d9$export$342063e11d6c3cad(value) {
    return value === null || typeof value === "undefined";
}
function $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === "[object" && type.slice(-6) === "Array]") return true;
    return false;
}
function $5ea20a8ea64fa9d9$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
const $5ea20a8ea64fa9d9$export$39b482c5e57630a8 = (value)=>(typeof value === "number" || value instanceof Number) && isFinite(+value);
function $5ea20a8ea64fa9d9$export$ef35774e6d314e91(value, defaultValue) {
    return $5ea20a8ea64fa9d9$export$39b482c5e57630a8(value) ? value : defaultValue;
}
function $5ea20a8ea64fa9d9$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === "undefined" ? defaultValue : value;
}
const $5ea20a8ea64fa9d9$export$953cecd6e717a553 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 : value / dimension;
const $5ea20a8ea64fa9d9$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
function $5ea20a8ea64fa9d9$export$e7094788287c5e9b(fn, args, thisArg) {
    if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
}
function $5ea20a8ea64fa9d9$export$3722cfe417b6ed86(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($5ea20a8ea64fa9d9$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($5ea20a8ea64fa9d9$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
function $5ea20a8ea64fa9d9$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
function $5ea20a8ea64fa9d9$export$738ab4df8bf92ae9(source) {
    if ($5ea20a8ea64fa9d9$export$8b22cf2602fb60ce(source)) return source.map($5ea20a8ea64fa9d9$export$738ab4df8bf92ae9);
    if ($5ea20a8ea64fa9d9$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $5ea20a8ea64fa9d9$export$738ab4df8bf92ae9(source[keys[k]]);
        return target;
    }
    return source;
}
function $5ea20a8ea64fa9d9$var$isValidKey(key) {
    return [
        "__proto__",
        "prototype",
        "constructor"
    ].indexOf(key) === -1;
}
function $5ea20a8ea64fa9d9$export$d377dcb2b61d6c4e(key, target, source, options) {
    if (!$5ea20a8ea64fa9d9$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($5ea20a8ea64fa9d9$export$23f2a1d2818174ef(tval) && $5ea20a8ea64fa9d9$export$23f2a1d2818174ef(sval)) $5ea20a8ea64fa9d9$export$e7c866399fa523f5(tval, sval, options);
    else target[key] = $5ea20a8ea64fa9d9$export$738ab4df8bf92ae9(sval);
}
function $5ea20a8ea64fa9d9$export$e7c866399fa523f5(target, source, options) {
    const sources = $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$5ea20a8ea64fa9d9$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $5ea20a8ea64fa9d9$export$d377dcb2b61d6c4e;
    for(let i = 0; i < ilen; ++i){
        source = sources[i];
        if (!$5ea20a8ea64fa9d9$export$23f2a1d2818174ef(source)) continue;
        const keys = Object.keys(source);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, source, options);
    }
    return target;
}
function $5ea20a8ea64fa9d9$export$2219238a014317b0(target, source) {
    return $5ea20a8ea64fa9d9$export$e7c866399fa523f5(target, source, {
        merger: $5ea20a8ea64fa9d9$export$667d3bf0c5f83305
    });
}
function $5ea20a8ea64fa9d9$export$667d3bf0c5f83305(key, target, source) {
    if (!$5ea20a8ea64fa9d9$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($5ea20a8ea64fa9d9$export$23f2a1d2818174ef(tval) && $5ea20a8ea64fa9d9$export$23f2a1d2818174ef(sval)) $5ea20a8ea64fa9d9$export$2219238a014317b0(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $5ea20a8ea64fa9d9$export$738ab4df8bf92ae9(sval);
}
function $5ea20a8ea64fa9d9$export$317a3d46287192d8(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
const $5ea20a8ea64fa9d9$var$keyResolvers = {
    "": (v)=>v,
    x: (o)=>o.x,
    y: (o)=>o.y
};
function $5ea20a8ea64fa9d9$export$2d1720544b23b823(obj, key) {
    const resolver = $5ea20a8ea64fa9d9$var$keyResolvers[key] || ($5ea20a8ea64fa9d9$var$keyResolvers[key] = $5ea20a8ea64fa9d9$var$_getKeyResolver(key));
    return resolver(obj);
}
function $5ea20a8ea64fa9d9$var$_getKeyResolver(key) {
    const keys = $5ea20a8ea64fa9d9$export$1ee57be6f6687d2c(key);
    return (obj)=>{
        for (const k of keys){
            if (k === "") break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $5ea20a8ea64fa9d9$export$1ee57be6f6687d2c(key) {
    const parts = key.split(".");
    const keys = [];
    let tmp = "";
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith("\\")) tmp = tmp.slice(0, -1) + ".";
        else {
            keys.push(tmp);
            tmp = "";
        }
    }
    return keys;
}
function $5ea20a8ea64fa9d9$export$71cec2538cb2c617(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $5ea20a8ea64fa9d9$export$35e795649ee09318 = (value)=>typeof value !== "undefined";
const $5ea20a8ea64fa9d9$export$c3950d9923825c02 = (value)=>typeof value === "function";
const $5ea20a8ea64fa9d9$export$995eb9fca571757 = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
function $5ea20a8ea64fa9d9$export$3b513254972cfc9c(e) {
    return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const $5ea20a8ea64fa9d9$export$56c0d5a1e737357d = Math.PI;
const $5ea20a8ea64fa9d9$export$971d5caa766a69d7 = 2 * $5ea20a8ea64fa9d9$export$56c0d5a1e737357d;
const $5ea20a8ea64fa9d9$export$8c78c7c36408ea29 = $5ea20a8ea64fa9d9$export$971d5caa766a69d7 + $5ea20a8ea64fa9d9$export$56c0d5a1e737357d;
const $5ea20a8ea64fa9d9$export$d29e374196577086 = Number.POSITIVE_INFINITY;
const $5ea20a8ea64fa9d9$export$2ec5befb9e6c97d4 = $5ea20a8ea64fa9d9$export$56c0d5a1e737357d / 180;
const $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd = $5ea20a8ea64fa9d9$export$56c0d5a1e737357d / 2;
const $5ea20a8ea64fa9d9$export$53c86fa97d611818 = $5ea20a8ea64fa9d9$export$56c0d5a1e737357d / 4;
const $5ea20a8ea64fa9d9$export$39c1cc7c062529d4 = $5ea20a8ea64fa9d9$export$56c0d5a1e737357d * 2 / 3;
const $5ea20a8ea64fa9d9$export$df995fae86a55f06 = Math.log10;
const $5ea20a8ea64fa9d9$export$2408f22a0fab9ae5 = Math.sign;
function $5ea20a8ea64fa9d9$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $5ea20a8ea64fa9d9$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($5ea20a8ea64fa9d9$export$df995fae86a55f06(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
function $5ea20a8ea64fa9d9$export$ebd11618f299a286(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function $5ea20a8ea64fa9d9$export$d141bba7fdc215a3(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $5ea20a8ea64fa9d9$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
function $5ea20a8ea64fa9d9$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
function $5ea20a8ea64fa9d9$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $5ea20a8ea64fa9d9$export$625550452a3fa3ec(degrees) {
    return degrees * ($5ea20a8ea64fa9d9$export$56c0d5a1e737357d / 180);
}
function $5ea20a8ea64fa9d9$export$d66501df72047452(radians) {
    return radians * (180 / $5ea20a8ea64fa9d9$export$56c0d5a1e737357d);
}
function $5ea20a8ea64fa9d9$export$91477dc880baac21(x) {
    if (!$5ea20a8ea64fa9d9$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
function $5ea20a8ea64fa9d9$export$34aec0b863436764(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $5ea20a8ea64fa9d9$export$56c0d5a1e737357d) angle += $5ea20a8ea64fa9d9$export$971d5caa766a69d7;
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $5ea20a8ea64fa9d9$export$53a70dd1ebbae346(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
function $5ea20a8ea64fa9d9$export$7a0bdf7d4a91ea88(a, b) {
    return (a - b + $5ea20a8ea64fa9d9$export$8c78c7c36408ea29) % $5ea20a8ea64fa9d9$export$971d5caa766a69d7 - $5ea20a8ea64fa9d9$export$56c0d5a1e737357d;
}
function $5ea20a8ea64fa9d9$export$3d12bd131bb975d1(a) {
    return (a % $5ea20a8ea64fa9d9$export$971d5caa766a69d7 + $5ea20a8ea64fa9d9$export$971d5caa766a69d7) % $5ea20a8ea64fa9d9$export$971d5caa766a69d7;
}
function $5ea20a8ea64fa9d9$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $5ea20a8ea64fa9d9$export$3d12bd131bb975d1(angle);
    const s = $5ea20a8ea64fa9d9$export$3d12bd131bb975d1(start);
    const e = $5ea20a8ea64fa9d9$export$3d12bd131bb975d1(end);
    const angleToStart = $5ea20a8ea64fa9d9$export$3d12bd131bb975d1(s - a);
    const angleToEnd = $5ea20a8ea64fa9d9$export$3d12bd131bb975d1(e - a);
    const startToAngle = $5ea20a8ea64fa9d9$export$3d12bd131bb975d1(a - s);
    const endToAngle = $5ea20a8ea64fa9d9$export$3d12bd131bb975d1(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
function $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
function $5ea20a8ea64fa9d9$export$9bb611d729802a56(value) {
    return $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca(value, -32768, 32767);
}
function $5ea20a8ea64fa9d9$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $5ea20a8ea64fa9d9$export$c03999cb2f36933f(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
const $5ea20a8ea64fa9d9$export$dc98b0b04f4c7758 = (table, key, value, last)=>$5ea20a8ea64fa9d9$export$c03999cb2f36933f(table, value, last ? (index)=>table[index][key] <= value : (index)=>table[index][key] < value);
const $5ea20a8ea64fa9d9$export$8743009a87fcb00f = (table, key, value)=>$5ea20a8ea64fa9d9$export$c03999cb2f36933f(table, value, (index)=>table[index][key] >= value);
function $5ea20a8ea64fa9d9$export$faec65b429be379(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $5ea20a8ea64fa9d9$var$arrayEvents = [
    "push",
    "pop",
    "shift",
    "splice",
    "unshift"
];
function $5ea20a8ea64fa9d9$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, "_chartjs", {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $5ea20a8ea64fa9d9$var$arrayEvents.forEach((key)=>{
        const method = "_onData" + $5ea20a8ea64fa9d9$export$71cec2538cb2c617(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === "function") object[method](...args);
                });
                return res;
            }
        });
    });
}
function $5ea20a8ea64fa9d9$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $5ea20a8ea64fa9d9$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
function $5ea20a8ea64fa9d9$export$71511d61b312f219(items) {
    const set = new Set();
    let i, ilen;
    for(i = 0, ilen = items.length; i < ilen; ++i)set.add(items[i]);
    if (set.size === ilen) return items;
    return Array.from(set);
}
function $5ea20a8ea64fa9d9$export$a17c37559e1db147(pixelSize, fontStyle, fontFamily) {
    return fontStyle + " " + pixelSize + "px " + fontFamily;
}
const $5ea20a8ea64fa9d9$export$43caf9889c228507 = function() {
    if (typeof window === "undefined") return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
function $5ea20a8ea64fa9d9$export$efca4cbe5dd06740(fn, thisArg, updateFn) {
    const updateArgs = updateFn || ((args)=>Array.prototype.slice.call(args));
    let ticking = false;
    let args = [];
    return function(...rest) {
        args = updateArgs(rest);
        if (!ticking) {
            ticking = true;
            $5ea20a8ea64fa9d9$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, args);
            });
        }
    };
}
function $5ea20a8ea64fa9d9$export$f787f51d84a910ad(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
const $5ea20a8ea64fa9d9$export$db202ddc8be9136 = (align)=>align === "start" ? "left" : align === "end" ? "right" : "center";
const $5ea20a8ea64fa9d9$export$25ce5a424b770e84 = (align, start, end)=>align === "start" ? start : align === "end" ? end : (start + end) / 2;
const $5ea20a8ea64fa9d9$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? "left" : "right";
    return align === check ? right : align === "center" ? (left + right) / 2 : left;
};
function $5ea20a8ea64fa9d9$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, _parsed: _parsed } = meta;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) start = $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca(Math.min($5ea20a8ea64fa9d9$export$dc98b0b04f4c7758(_parsed, iScale.axis, min).lo, animationsDisabled ? pointCount : $5ea20a8ea64fa9d9$export$dc98b0b04f4c7758(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca(Math.max($5ea20a8ea64fa9d9$export$dc98b0b04f4c7758(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $5ea20a8ea64fa9d9$export$dc98b0b04f4c7758(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
function $5ea20a8ea64fa9d9$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $5ea20a8ea64fa9d9$var$atEdge = (t)=>t === 0 || t === 1;
const $5ea20a8ea64fa9d9$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $5ea20a8ea64fa9d9$export$971d5caa766a69d7 / p));
const $5ea20a8ea64fa9d9$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $5ea20a8ea64fa9d9$export$971d5caa766a69d7 / p) + 1;
const $5ea20a8ea64fa9d9$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($5ea20a8ea64fa9d9$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$5ea20a8ea64fa9d9$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$5ea20a8ea64fa9d9$var$atEdge(t) ? t : $5ea20a8ea64fa9d9$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$5ea20a8ea64fa9d9$var$atEdge(t) ? t : $5ea20a8ea64fa9d9$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $5ea20a8ea64fa9d9$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $5ea20a8ea64fa9d9$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $5ea20a8ea64fa9d9$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $5ea20a8ea64fa9d9$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $5ea20a8ea64fa9d9$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $5ea20a8ea64fa9d9$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
/*!
 * @kurkle/color v0.2.1
 * https://github.com/kurkle/color#readme
 * (c) 2022 Jukka Kurkela
 * Released under the MIT License
 */ function $5ea20a8ea64fa9d9$var$round(v) {
    return v + 0.5 | 0;
}
const $5ea20a8ea64fa9d9$var$lim = (v, l, h)=>Math.max(Math.min(v, h), l);
function $5ea20a8ea64fa9d9$var$p2b(v) {
    return $5ea20a8ea64fa9d9$var$lim($5ea20a8ea64fa9d9$var$round(v * 2.55), 0, 255);
}
function $5ea20a8ea64fa9d9$var$n2b(v) {
    return $5ea20a8ea64fa9d9$var$lim($5ea20a8ea64fa9d9$var$round(v * 255), 0, 255);
}
function $5ea20a8ea64fa9d9$var$b2n(v) {
    return $5ea20a8ea64fa9d9$var$lim($5ea20a8ea64fa9d9$var$round(v / 2.55) / 100, 0, 1);
}
function $5ea20a8ea64fa9d9$var$n2p(v) {
    return $5ea20a8ea64fa9d9$var$lim($5ea20a8ea64fa9d9$var$round(v * 100), 0, 100);
}
const $5ea20a8ea64fa9d9$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $5ea20a8ea64fa9d9$var$hex = [
    ..."0123456789ABCDEF"
];
const $5ea20a8ea64fa9d9$var$h1 = (b)=>$5ea20a8ea64fa9d9$var$hex[b & 0xF];
const $5ea20a8ea64fa9d9$var$h2 = (b)=>$5ea20a8ea64fa9d9$var$hex[(b & 0xF0) >> 4] + $5ea20a8ea64fa9d9$var$hex[b & 0xF];
const $5ea20a8ea64fa9d9$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $5ea20a8ea64fa9d9$var$isShort = (v)=>$5ea20a8ea64fa9d9$var$eq(v.r) && $5ea20a8ea64fa9d9$var$eq(v.g) && $5ea20a8ea64fa9d9$var$eq(v.b) && $5ea20a8ea64fa9d9$var$eq(v.a);
function $5ea20a8ea64fa9d9$var$hexParse(str) {
    var len = str.length;
    var ret;
    if (str[0] === "#") {
        if (len === 4 || len === 5) ret = {
            r: 255 & $5ea20a8ea64fa9d9$var$map$1[str[1]] * 17,
            g: 255 & $5ea20a8ea64fa9d9$var$map$1[str[2]] * 17,
            b: 255 & $5ea20a8ea64fa9d9$var$map$1[str[3]] * 17,
            a: len === 5 ? $5ea20a8ea64fa9d9$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $5ea20a8ea64fa9d9$var$map$1[str[1]] << 4 | $5ea20a8ea64fa9d9$var$map$1[str[2]],
            g: $5ea20a8ea64fa9d9$var$map$1[str[3]] << 4 | $5ea20a8ea64fa9d9$var$map$1[str[4]],
            b: $5ea20a8ea64fa9d9$var$map$1[str[5]] << 4 | $5ea20a8ea64fa9d9$var$map$1[str[6]],
            a: len === 9 ? $5ea20a8ea64fa9d9$var$map$1[str[7]] << 4 | $5ea20a8ea64fa9d9$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $5ea20a8ea64fa9d9$var$alpha = (a, f)=>a < 255 ? f(a) : "";
function $5ea20a8ea64fa9d9$var$hexString(v) {
    var f = $5ea20a8ea64fa9d9$var$isShort(v) ? $5ea20a8ea64fa9d9$var$h1 : $5ea20a8ea64fa9d9$var$h2;
    return v ? "#" + f(v.r) + f(v.g) + f(v.b) + $5ea20a8ea64fa9d9$var$alpha(v.a, f) : undefined;
}
const $5ea20a8ea64fa9d9$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $5ea20a8ea64fa9d9$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $5ea20a8ea64fa9d9$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $5ea20a8ea64fa9d9$var$hwb2rgbn(h, w, b) {
    const rgb = $5ea20a8ea64fa9d9$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $5ea20a8ea64fa9d9$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $5ea20a8ea64fa9d9$var$rgb2hsl(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $5ea20a8ea64fa9d9$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $5ea20a8ea64fa9d9$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($5ea20a8ea64fa9d9$var$n2b);
}
function $5ea20a8ea64fa9d9$var$hsl2rgb(h, s, l) {
    return $5ea20a8ea64fa9d9$var$calln($5ea20a8ea64fa9d9$var$hsl2rgbn, h, s, l);
}
function $5ea20a8ea64fa9d9$var$hwb2rgb(h, w, b) {
    return $5ea20a8ea64fa9d9$var$calln($5ea20a8ea64fa9d9$var$hwb2rgbn, h, w, b);
}
function $5ea20a8ea64fa9d9$var$hsv2rgb(h, s, v) {
    return $5ea20a8ea64fa9d9$var$calln($5ea20a8ea64fa9d9$var$hsv2rgbn, h, s, v);
}
function $5ea20a8ea64fa9d9$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $5ea20a8ea64fa9d9$var$hueParse(str) {
    const m = $5ea20a8ea64fa9d9$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $5ea20a8ea64fa9d9$var$p2b(+m[5]) : $5ea20a8ea64fa9d9$var$n2b(+m[5]);
    const h = $5ea20a8ea64fa9d9$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === "hwb") v = $5ea20a8ea64fa9d9$var$hwb2rgb(h, p1, p2);
    else if (m[1] === "hsv") v = $5ea20a8ea64fa9d9$var$hsv2rgb(h, p1, p2);
    else v = $5ea20a8ea64fa9d9$var$hsl2rgb(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $5ea20a8ea64fa9d9$var$rotate(v, deg) {
    var h = $5ea20a8ea64fa9d9$var$rgb2hsl(v);
    h[0] = $5ea20a8ea64fa9d9$var$hue(h[0] + deg);
    h = $5ea20a8ea64fa9d9$var$hsl2rgb(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $5ea20a8ea64fa9d9$var$hslString(v) {
    if (!v) return;
    const a = $5ea20a8ea64fa9d9$var$rgb2hsl(v);
    const h = a[0];
    const s = $5ea20a8ea64fa9d9$var$n2p(a[1]);
    const l = $5ea20a8ea64fa9d9$var$n2p(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$5ea20a8ea64fa9d9$var$b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $5ea20a8ea64fa9d9$var$map = {
    x: "dark",
    Z: "light",
    Y: "re",
    X: "blu",
    W: "gr",
    V: "medium",
    U: "slate",
    A: "ee",
    T: "ol",
    S: "or",
    B: "ra",
    C: "lateg",
    D: "ights",
    R: "in",
    Q: "turquois",
    E: "hi",
    P: "ro",
    O: "al",
    N: "le",
    M: "de",
    L: "yello",
    F: "en",
    K: "ch",
    G: "arks",
    H: "ea",
    I: "ightg",
    J: "wh"
};
const $5ea20a8ea64fa9d9$var$names$1 = {
    OiceXe: "f0f8ff",
    antiquewEte: "faebd7",
    aqua: "ffff",
    aquamarRe: "7fffd4",
    azuY: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "0",
    blanKedOmond: "ffebcd",
    Xe: "ff",
    XeviTet: "8a2be2",
    bPwn: "a52a2a",
    burlywood: "deb887",
    caMtXe: "5f9ea0",
    KartYuse: "7fff00",
    KocTate: "d2691e",
    cSO: "ff7f50",
    cSnflowerXe: "6495ed",
    cSnsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "ffff",
    xXe: "8b",
    xcyan: "8b8b",
    xgTMnPd: "b8860b",
    xWay: "a9a9a9",
    xgYF: "6400",
    xgYy: "a9a9a9",
    xkhaki: "bdb76b",
    xmagFta: "8b008b",
    xTivegYF: "556b2f",
    xSange: "ff8c00",
    xScEd: "9932cc",
    xYd: "8b0000",
    xsOmon: "e9967a",
    xsHgYF: "8fbc8f",
    xUXe: "483d8b",
    xUWay: "2f4f4f",
    xUgYy: "2f4f4f",
    xQe: "ced1",
    xviTet: "9400d3",
    dAppRk: "ff1493",
    dApskyXe: "bfff",
    dimWay: "696969",
    dimgYy: "696969",
    dodgerXe: "1e90ff",
    fiYbrick: "b22222",
    flSOwEte: "fffaf0",
    foYstWAn: "228b22",
    fuKsia: "ff00ff",
    gaRsbSo: "dcdcdc",
    ghostwEte: "f8f8ff",
    gTd: "ffd700",
    gTMnPd: "daa520",
    Way: "808080",
    gYF: "8000",
    gYFLw: "adff2f",
    gYy: "808080",
    honeyMw: "f0fff0",
    hotpRk: "ff69b4",
    RdianYd: "cd5c5c",
    Rdigo: "4b0082",
    ivSy: "fffff0",
    khaki: "f0e68c",
    lavFMr: "e6e6fa",
    lavFMrXsh: "fff0f5",
    lawngYF: "7cfc00",
    NmoncEffon: "fffacd",
    ZXe: "add8e6",
    ZcSO: "f08080",
    Zcyan: "e0ffff",
    ZgTMnPdLw: "fafad2",
    ZWay: "d3d3d3",
    ZgYF: "90ee90",
    ZgYy: "d3d3d3",
    ZpRk: "ffb6c1",
    ZsOmon: "ffa07a",
    ZsHgYF: "20b2aa",
    ZskyXe: "87cefa",
    ZUWay: "778899",
    ZUgYy: "778899",
    ZstAlXe: "b0c4de",
    ZLw: "ffffe0",
    lime: "ff00",
    limegYF: "32cd32",
    lRF: "faf0e6",
    magFta: "ff00ff",
    maPon: "800000",
    VaquamarRe: "66cdaa",
    VXe: "cd",
    VScEd: "ba55d3",
    VpurpN: "9370db",
    VsHgYF: "3cb371",
    VUXe: "7b68ee",
    VsprRggYF: "fa9a",
    VQe: "48d1cc",
    VviTetYd: "c71585",
    midnightXe: "191970",
    mRtcYam: "f5fffa",
    mistyPse: "ffe4e1",
    moccasR: "ffe4b5",
    navajowEte: "ffdead",
    navy: "80",
    Tdlace: "fdf5e6",
    Tive: "808000",
    TivedBb: "6b8e23",
    Sange: "ffa500",
    SangeYd: "ff4500",
    ScEd: "da70d6",
    pOegTMnPd: "eee8aa",
    pOegYF: "98fb98",
    pOeQe: "afeeee",
    pOeviTetYd: "db7093",
    papayawEp: "ffefd5",
    pHKpuff: "ffdab9",
    peru: "cd853f",
    pRk: "ffc0cb",
    plum: "dda0dd",
    powMrXe: "b0e0e6",
    purpN: "800080",
    YbeccapurpN: "663399",
    Yd: "ff0000",
    Psybrown: "bc8f8f",
    PyOXe: "4169e1",
    saddNbPwn: "8b4513",
    sOmon: "fa8072",
    sandybPwn: "f4a460",
    sHgYF: "2e8b57",
    sHshell: "fff5ee",
    siFna: "a0522d",
    silver: "c0c0c0",
    skyXe: "87ceeb",
    UXe: "6a5acd",
    UWay: "708090",
    UgYy: "708090",
    snow: "fffafa",
    sprRggYF: "ff7f",
    stAlXe: "4682b4",
    tan: "d2b48c",
    teO: "8080",
    tEstN: "d8bfd8",
    tomato: "ff6347",
    Qe: "40e0d0",
    viTet: "ee82ee",
    JHt: "f5deb3",
    wEte: "ffffff",
    wEtesmoke: "f5f5f5",
    Lw: "ffff00",
    LwgYF: "9acd32"
};
function $5ea20a8ea64fa9d9$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($5ea20a8ea64fa9d9$var$names$1);
    const tkeys = Object.keys($5ea20a8ea64fa9d9$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $5ea20a8ea64fa9d9$var$map[k]);
        }
        k = parseInt($5ea20a8ea64fa9d9$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $5ea20a8ea64fa9d9$var$names;
function $5ea20a8ea64fa9d9$var$nameParse(str) {
    if (!$5ea20a8ea64fa9d9$var$names) {
        $5ea20a8ea64fa9d9$var$names = $5ea20a8ea64fa9d9$var$unpack();
        $5ea20a8ea64fa9d9$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $5ea20a8ea64fa9d9$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $5ea20a8ea64fa9d9$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $5ea20a8ea64fa9d9$var$rgbParse(str) {
    const m = $5ea20a8ea64fa9d9$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $5ea20a8ea64fa9d9$var$p2b(v) : $5ea20a8ea64fa9d9$var$lim(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $5ea20a8ea64fa9d9$var$p2b(r) : $5ea20a8ea64fa9d9$var$lim(r, 0, 255));
    g = 255 & (m[4] ? $5ea20a8ea64fa9d9$var$p2b(g) : $5ea20a8ea64fa9d9$var$lim(g, 0, 255));
    b = 255 & (m[6] ? $5ea20a8ea64fa9d9$var$p2b(b) : $5ea20a8ea64fa9d9$var$lim(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $5ea20a8ea64fa9d9$var$rgbString(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$5ea20a8ea64fa9d9$var$b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $5ea20a8ea64fa9d9$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $5ea20a8ea64fa9d9$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $5ea20a8ea64fa9d9$var$interpolate(rgb1, rgb2, t) {
    const r = $5ea20a8ea64fa9d9$var$from($5ea20a8ea64fa9d9$var$b2n(rgb1.r));
    const g = $5ea20a8ea64fa9d9$var$from($5ea20a8ea64fa9d9$var$b2n(rgb1.g));
    const b = $5ea20a8ea64fa9d9$var$from($5ea20a8ea64fa9d9$var$b2n(rgb1.b));
    return {
        r: $5ea20a8ea64fa9d9$var$n2b($5ea20a8ea64fa9d9$var$to(r + t * ($5ea20a8ea64fa9d9$var$from($5ea20a8ea64fa9d9$var$b2n(rgb2.r)) - r))),
        g: $5ea20a8ea64fa9d9$var$n2b($5ea20a8ea64fa9d9$var$to(g + t * ($5ea20a8ea64fa9d9$var$from($5ea20a8ea64fa9d9$var$b2n(rgb2.g)) - g))),
        b: $5ea20a8ea64fa9d9$var$n2b($5ea20a8ea64fa9d9$var$to(b + t * ($5ea20a8ea64fa9d9$var$from($5ea20a8ea64fa9d9$var$b2n(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $5ea20a8ea64fa9d9$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $5ea20a8ea64fa9d9$var$rgb2hsl(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $5ea20a8ea64fa9d9$var$hsl2rgb(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $5ea20a8ea64fa9d9$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $5ea20a8ea64fa9d9$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $5ea20a8ea64fa9d9$var$n2b(input[3]);
        }
    } else {
        v = $5ea20a8ea64fa9d9$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $5ea20a8ea64fa9d9$var$n2b(v.a);
    }
    return v;
}
function $5ea20a8ea64fa9d9$var$functionParse(str) {
    if (str.charAt(0) === "r") return $5ea20a8ea64fa9d9$var$rgbParse(str);
    return $5ea20a8ea64fa9d9$var$hueParse(str);
}
class $5ea20a8ea64fa9d9$var$Color {
    constructor(input){
        if (input instanceof $5ea20a8ea64fa9d9$var$Color) return input;
        const type = typeof input;
        let v;
        if (type === "object") v = $5ea20a8ea64fa9d9$var$fromObject(input);
        else if (type === "string") v = $5ea20a8ea64fa9d9$var$hexParse(input) || $5ea20a8ea64fa9d9$var$nameParse(input) || $5ea20a8ea64fa9d9$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $5ea20a8ea64fa9d9$var$clone(this._rgb);
        if (v) v.a = $5ea20a8ea64fa9d9$var$b2n(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $5ea20a8ea64fa9d9$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $5ea20a8ea64fa9d9$var$rgbString(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $5ea20a8ea64fa9d9$var$hexString(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $5ea20a8ea64fa9d9$var$hslString(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $5ea20a8ea64fa9d9$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $5ea20a8ea64fa9d9$var$Color(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $5ea20a8ea64fa9d9$var$n2b(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $5ea20a8ea64fa9d9$var$round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $5ea20a8ea64fa9d9$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $5ea20a8ea64fa9d9$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $5ea20a8ea64fa9d9$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $5ea20a8ea64fa9d9$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $5ea20a8ea64fa9d9$var$rotate(this._rgb, deg);
        return this;
    }
}
function $5ea20a8ea64fa9d9$var$index_esm(input) {
    return new $5ea20a8ea64fa9d9$var$Color(input);
}
function $5ea20a8ea64fa9d9$export$2ed0fc6709e59212(value) {
    if (value && typeof value === "object") {
        const type = value.toString();
        return type === "[object CanvasPattern]" || type === "[object CanvasGradient]";
    }
    return false;
}
function $5ea20a8ea64fa9d9$export$db3b6bfb95261072(value) {
    return $5ea20a8ea64fa9d9$export$2ed0fc6709e59212(value) ? value : $5ea20a8ea64fa9d9$var$index_esm(value);
}
function $5ea20a8ea64fa9d9$export$f96d196f7728bb5(value) {
    return $5ea20a8ea64fa9d9$export$2ed0fc6709e59212(value) ? value : $5ea20a8ea64fa9d9$var$index_esm(value).saturate(0.5).darken(0.1).hexString();
}
const $5ea20a8ea64fa9d9$export$3a6d5c9ae78a2c08 = Object.create(null);
const $5ea20a8ea64fa9d9$export$a93c5207d687da10 = Object.create(null);
function $5ea20a8ea64fa9d9$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split(".");
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $5ea20a8ea64fa9d9$var$set(root, scope, values) {
    if (typeof scope === "string") return $5ea20a8ea64fa9d9$export$e7c866399fa523f5($5ea20a8ea64fa9d9$var$getScope$1(root, scope), values);
    return $5ea20a8ea64fa9d9$export$e7c866399fa523f5($5ea20a8ea64fa9d9$var$getScope$1(root, ""), scope);
}
class $5ea20a8ea64fa9d9$var$Defaults {
    constructor(_descriptors){
        this.animation = undefined;
        this.backgroundColor = "rgba(0,0,0,0.1)";
        this.borderColor = "rgba(0,0,0,0.1)";
        this.color = "#666";
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: "normal",
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$5ea20a8ea64fa9d9$export$f96d196f7728bb5(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$5ea20a8ea64fa9d9$export$f96d196f7728bb5(options.borderColor);
        this.hoverColor = (ctx, options)=>$5ea20a8ea64fa9d9$export$f96d196f7728bb5(options.color);
        this.indexAxis = "x";
        this.interaction = {
            mode: "nearest",
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
    }
    set(scope, values) {
        return $5ea20a8ea64fa9d9$var$set(this, scope, values);
    }
    get(scope) {
        return $5ea20a8ea64fa9d9$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $5ea20a8ea64fa9d9$var$set($5ea20a8ea64fa9d9$export$a93c5207d687da10, scope, values);
    }
    override(scope, values) {
        return $5ea20a8ea64fa9d9$var$set($5ea20a8ea64fa9d9$export$3a6d5c9ae78a2c08, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $5ea20a8ea64fa9d9$var$getScope$1(this, scope);
        const targetScopeObject = $5ea20a8ea64fa9d9$var$getScope$1(this, targetScope);
        const privateName = "_" + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($5ea20a8ea64fa9d9$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $5ea20a8ea64fa9d9$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
}
var $5ea20a8ea64fa9d9$export$4368d992c4eafac0 = new $5ea20a8ea64fa9d9$var$Defaults({
    _scriptable: (name)=>!name.startsWith("on"),
    _indexable: (name)=>name !== "events",
    hover: {
        _fallback: "interaction"
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
});
function $5ea20a8ea64fa9d9$export$9d0e2d13d04f7070(font) {
    if (!font || $5ea20a8ea64fa9d9$export$342063e11d6c3cad(font.size) || $5ea20a8ea64fa9d9$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
function $5ea20a8ea64fa9d9$export$2329c99376c9d0a4(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
function $5ea20a8ea64fa9d9$export$9f4f30ee63539e24(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        if (thing !== undefined && thing !== null && $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce(thing) !== true) longest = $5ea20a8ea64fa9d9$export$2329c99376c9d0a4(ctx, data, gc, longest, thing);
        else if ($5ea20a8ea64fa9d9$export$8b22cf2602fb60ce(thing)) for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            if (nestedThing !== undefined && nestedThing !== null && !$5ea20a8ea64fa9d9$export$8b22cf2602fb60ce(nestedThing)) longest = $5ea20a8ea64fa9d9$export$2329c99376c9d0a4(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
function $5ea20a8ea64fa9d9$export$b4171a6734a65d42(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
function $5ea20a8ea64fa9d9$export$ee7c8ad385a60b7b(canvas, ctx) {
    ctx = ctx || canvas.getContext("2d");
    ctx.save();
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $5ea20a8ea64fa9d9$export$1fbe638ecf81657e(ctx, options, x, y) {
    $5ea20a8ea64fa9d9$export$158acd800e1ef08b(ctx, options, x, y, null);
}
function $5ea20a8ea64fa9d9$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $5ea20a8ea64fa9d9$export$2ec5befb9e6c97d4;
    if (style && typeof style === "object") {
        type = style.toString();
        if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case "triangle":
            ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $5ea20a8ea64fa9d9$export$39c1cc7c062529d4;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $5ea20a8ea64fa9d9$export$39c1cc7c062529d4;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case "rectRounded":
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $5ea20a8ea64fa9d9$export$53c86fa97d611818) * size;
            yOffset = Math.sin(rad + $5ea20a8ea64fa9d9$export$53c86fa97d611818) * size;
            ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - $5ea20a8ea64fa9d9$export$56c0d5a1e737357d, rad - $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd, rad + $5ea20a8ea64fa9d9$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case "rect":
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $5ea20a8ea64fa9d9$export$53c86fa97d611818;
        case "rectRot":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + yOffset, y - xOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            ctx.closePath();
            break;
        case "crossRot":
            rad += $5ea20a8ea64fa9d9$export$53c86fa97d611818;
        case "cross":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case "star":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            rad += $5ea20a8ea64fa9d9$export$53c86fa97d611818;
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case "line":
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case "dash":
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
function $5ea20a8ea64fa9d9$export$3d8c2f653ac9d0b9(point, area, margin) {
    margin = margin || 0.5;
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $5ea20a8ea64fa9d9$export$61196ced6d74a310(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $5ea20a8ea64fa9d9$export$a07804094c3ecf2d(ctx) {
    ctx.restore();
}
function $5ea20a8ea64fa9d9$export$6554612db691658e(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === "middle") {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === "after" !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
function $5ea20a8ea64fa9d9$export$493d36ec626b6698(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $5ea20a8ea64fa9d9$export$3a1a48c8f6ef640e(ctx, text, x, y, font, opts = {}) {
    const lines = $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $5ea20a8ea64fa9d9$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$5ea20a8ea64fa9d9$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $5ea20a8ea64fa9d9$var$decorateText(ctx, x, y, line, opts);
        y += font.lineHeight;
    }
    ctx.restore();
}
function $5ea20a8ea64fa9d9$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$5ea20a8ea64fa9d9$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $5ea20a8ea64fa9d9$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $5ea20a8ea64fa9d9$export$d66dc83d8cfc8dd(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, -$5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd, $5ea20a8ea64fa9d9$export$56c0d5a1e737357d, true);
    ctx.lineTo(x, y + h - radius.bottomLeft);
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $5ea20a8ea64fa9d9$export$56c0d5a1e737357d, $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd, 0, true);
    ctx.lineTo(x + w, y + radius.topRight);
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + radius.topLeft, y);
}
const $5ea20a8ea64fa9d9$var$LINE_HEIGHT = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
const $5ea20a8ea64fa9d9$var$FONT_STYLE = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);
function $5ea20a8ea64fa9d9$export$fef3dfd9bad05307(value, size) {
    const matches = ("" + value).match($5ea20a8ea64fa9d9$var$LINE_HEIGHT);
    if (!matches || matches[1] === "normal") return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case "px":
            return value;
        case "%":
            value /= 100;
            break;
    }
    return size * value;
}
const $5ea20a8ea64fa9d9$var$numberOrZero = (v)=>+v || 0;
function $5ea20a8ea64fa9d9$export$ab83b03e4111b1d0(value, props) {
    const ret = {};
    const objProps = $5ea20a8ea64fa9d9$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $5ea20a8ea64fa9d9$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$5ea20a8ea64fa9d9$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $5ea20a8ea64fa9d9$var$numberOrZero(read(prop));
    return ret;
}
function $5ea20a8ea64fa9d9$export$92108d983e8ee699(value) {
    return $5ea20a8ea64fa9d9$export$ab83b03e4111b1d0(value, {
        top: "y",
        right: "x",
        bottom: "y",
        left: "x"
    });
}
function $5ea20a8ea64fa9d9$export$9fa96a7d116ea3ce(value) {
    return $5ea20a8ea64fa9d9$export$ab83b03e4111b1d0(value, [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
    ]);
}
function $5ea20a8ea64fa9d9$export$3466f893ebf79586(value) {
    const obj = $5ea20a8ea64fa9d9$export$92108d983e8ee699(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
function $5ea20a8ea64fa9d9$export$c4ce752e73470fba(options, fallback) {
    options = options || {};
    fallback = fallback || $5ea20a8ea64fa9d9$export$4368d992c4eafac0.font;
    let size = $5ea20a8ea64fa9d9$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === "string") size = parseInt(size, 10);
    let style = $5ea20a8ea64fa9d9$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !("" + style).match($5ea20a8ea64fa9d9$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = "";
    }
    const font = {
        family: $5ea20a8ea64fa9d9$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $5ea20a8ea64fa9d9$export$fef3dfd9bad05307($5ea20a8ea64fa9d9$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $5ea20a8ea64fa9d9$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ""
    };
    font.string = $5ea20a8ea64fa9d9$export$9d0e2d13d04f7070(font);
    return font;
}
function $5ea20a8ea64fa9d9$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === "function") {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
function $5ea20a8ea64fa9d9$export$96f57966bedc81b4(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $5ea20a8ea64fa9d9$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $5ea20a8ea64fa9d9$export$dda1d9f60106f0e9(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
function $5ea20a8ea64fa9d9$export$7910e0436ed8d1de(scopes, prefixes = [
    ""
], rootScopes = scopes, fallback, getTarget = ()=>scopes[0]) {
    if (!$5ea20a8ea64fa9d9$export$35e795649ee09318(fallback)) fallback = $5ea20a8ea64fa9d9$var$_resolve("_fallback", scopes);
    const cache = {
        [Symbol.toStringTag]: "Object",
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: rootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$5ea20a8ea64fa9d9$export$7910e0436ed8d1de([
                scope,
                ...scopes
            ], prefixes, rootScopes, fallback)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete target._keys;
            delete scopes[0][prop];
            return true;
        },
        get (target, prop) {
            return $5ea20a8ea64fa9d9$var$_cached(target, prop, ()=>$5ea20a8ea64fa9d9$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        has (target, prop) {
            return $5ea20a8ea64fa9d9$var$getKeysFromAllScopes(target).includes(prop);
        },
        ownKeys (target) {
            return $5ea20a8ea64fa9d9$var$getKeysFromAllScopes(target);
        },
        set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value;
            delete target._keys;
            return true;
        }
    });
}
function $5ea20a8ea64fa9d9$export$a9c996f45e5784d0(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $5ea20a8ea64fa9d9$export$555508cbc6add439(proxy, descriptorDefaults),
        setContext: (ctx)=>$5ea20a8ea64fa9d9$export$a9c996f45e5784d0(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$5ea20a8ea64fa9d9$export$a9c996f45e5784d0(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete proxy[prop];
            return true;
        },
        get (target, prop, receiver) {
            return $5ea20a8ea64fa9d9$var$_cached(target, prop, ()=>$5ea20a8ea64fa9d9$var$_resolveWithContext(target, prop, receiver));
        },
        getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        set (target, prop, value) {
            proxy[prop] = value;
            delete target[prop];
            return true;
        }
    });
}
function $5ea20a8ea64fa9d9$export$555508cbc6add439(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $5ea20a8ea64fa9d9$export$c3950d9923825c02(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $5ea20a8ea64fa9d9$export$c3950d9923825c02(_indexable) ? _indexable : ()=>_indexable
    };
}
const $5ea20a8ea64fa9d9$var$readKey = (prefix, name)=>prefix ? prefix + $5ea20a8ea64fa9d9$export$71cec2538cb2c617(name) : name;
const $5ea20a8ea64fa9d9$var$needsSubResolver = (prop, value)=>$5ea20a8ea64fa9d9$export$23f2a1d2818174ef(value) && prop !== "adapters" && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $5ea20a8ea64fa9d9$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop)) return target[prop];
    const value = resolve();
    target[prop] = value;
    return value;
}
function $5ea20a8ea64fa9d9$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop];
    if ($5ea20a8ea64fa9d9$export$c3950d9923825c02(value) && descriptors.isScriptable(prop)) value = $5ea20a8ea64fa9d9$var$_resolveScriptable(prop, value, target, receiver);
    if ($5ea20a8ea64fa9d9$export$8b22cf2602fb60ce(value) && value.length) value = $5ea20a8ea64fa9d9$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($5ea20a8ea64fa9d9$var$needsSubResolver(prop, value)) value = $5ea20a8ea64fa9d9$export$a9c996f45e5784d0(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $5ea20a8ea64fa9d9$var$_resolveScriptable(prop, value, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
    _stack.add(prop);
    value = value(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($5ea20a8ea64fa9d9$var$needsSubResolver(prop, value)) value = $5ea20a8ea64fa9d9$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $5ea20a8ea64fa9d9$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if ($5ea20a8ea64fa9d9$export$35e795649ee09318(_context.index) && isIndexable(prop)) value = value[_context.index % value.length];
    else if ($5ea20a8ea64fa9d9$export$23f2a1d2818174ef(value[0])) {
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $5ea20a8ea64fa9d9$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($5ea20a8ea64fa9d9$export$a9c996f45e5784d0(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $5ea20a8ea64fa9d9$var$resolveFallback(fallback, prop, value) {
    return $5ea20a8ea64fa9d9$export$c3950d9923825c02(fallback) ? fallback(prop, value) : fallback;
}
const $5ea20a8ea64fa9d9$var$getScope = (key, parent)=>key === true ? parent : typeof key === "string" ? $5ea20a8ea64fa9d9$export$2d1720544b23b823(parent, key) : undefined;
function $5ea20a8ea64fa9d9$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $5ea20a8ea64fa9d9$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $5ea20a8ea64fa9d9$var$resolveFallback(scope._fallback, key, value);
            if ($5ea20a8ea64fa9d9$export$35e795649ee09318(fallback) && fallback !== key && fallback !== parentFallback) return fallback;
        } else if (scope === false && $5ea20a8ea64fa9d9$export$35e795649ee09318(parentFallback) && key !== parentFallback) return null;
    }
    return false;
}
function $5ea20a8ea64fa9d9$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $5ea20a8ea64fa9d9$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $5ea20a8ea64fa9d9$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if ($5ea20a8ea64fa9d9$export$35e795649ee09318(fallback) && fallback !== prop) {
        key = $5ea20a8ea64fa9d9$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $5ea20a8ea64fa9d9$export$7910e0436ed8d1de(Array.from(set), [
        ""
    ], rootScopes, fallback, ()=>$5ea20a8ea64fa9d9$var$subGetTarget(resolver, prop, value));
}
function $5ea20a8ea64fa9d9$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $5ea20a8ea64fa9d9$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $5ea20a8ea64fa9d9$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($5ea20a8ea64fa9d9$export$8b22cf2602fb60ce(target) && $5ea20a8ea64fa9d9$export$23f2a1d2818174ef(value)) return value;
    return target;
}
function $5ea20a8ea64fa9d9$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $5ea20a8ea64fa9d9$var$_resolve($5ea20a8ea64fa9d9$var$readKey(prefix, prop), scopes);
        if ($5ea20a8ea64fa9d9$export$35e795649ee09318(value)) return $5ea20a8ea64fa9d9$var$needsSubResolver(prop, value) ? $5ea20a8ea64fa9d9$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $5ea20a8ea64fa9d9$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if ($5ea20a8ea64fa9d9$export$35e795649ee09318(value)) return value;
    }
}
function $5ea20a8ea64fa9d9$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $5ea20a8ea64fa9d9$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $5ea20a8ea64fa9d9$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith("_")))set.add(key);
    return Array.from(set);
}
function $5ea20a8ea64fa9d9$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = "r" } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($5ea20a8ea64fa9d9$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $5ea20a8ea64fa9d9$var$EPSILON = Number.EPSILON || 1e-14;
const $5ea20a8ea64fa9d9$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $5ea20a8ea64fa9d9$var$getValueAxis = (indexAxis)=>indexAxis === "x" ? "y" : "x";
function $5ea20a8ea64fa9d9$export$1a8f5705751d8277(firstPoint, middlePoint, afterPoint, t) {
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $5ea20a8ea64fa9d9$export$53a70dd1ebbae346(current, previous);
    const d12 = $5ea20a8ea64fa9d9$export$53a70dd1ebbae346(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01;
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
function $5ea20a8ea64fa9d9$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $5ea20a8ea64fa9d9$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $5ea20a8ea64fa9d9$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($5ea20a8ea64fa9d9$export$23ebac1979863676(deltaK[i], 0, $5ea20a8ea64fa9d9$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $5ea20a8ea64fa9d9$var$monotoneCompute(points, mK, indexAxis = "x") {
    const valueAxis = $5ea20a8ea64fa9d9$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $5ea20a8ea64fa9d9$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $5ea20a8ea64fa9d9$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
function $5ea20a8ea64fa9d9$export$e171bab687b50e0(points, indexAxis = "x") {
    const valueAxis = $5ea20a8ea64fa9d9$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    let i, pointBefore, pointCurrent;
    let pointAfter = $5ea20a8ea64fa9d9$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $5ea20a8ea64fa9d9$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $5ea20a8ea64fa9d9$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $5ea20a8ea64fa9d9$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $5ea20a8ea64fa9d9$var$monotoneAdjust(points, deltaK, mK);
    $5ea20a8ea64fa9d9$var$monotoneCompute(points, mK, indexAxis);
}
function $5ea20a8ea64fa9d9$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $5ea20a8ea64fa9d9$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $5ea20a8ea64fa9d9$export$3d8c2f653ac9d0b9(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $5ea20a8ea64fa9d9$export$3d8c2f653ac9d0b9(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $5ea20a8ea64fa9d9$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $5ea20a8ea64fa9d9$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $5ea20a8ea64fa9d9$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $5ea20a8ea64fa9d9$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
function $5ea20a8ea64fa9d9$export$1a82df3d29112e01(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === "monotone") $5ea20a8ea64fa9d9$export$e171bab687b50e0(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $5ea20a8ea64fa9d9$export$1a8f5705751d8277(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $5ea20a8ea64fa9d9$var$capBezierPoints(points, area);
}
function $5ea20a8ea64fa9d9$export$2e2af4578d910ddf() {
    return typeof window !== "undefined" && typeof document !== "undefined";
}
function $5ea20a8ea64fa9d9$export$ce26c07117d59d6a(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
    return parent;
}
function $5ea20a8ea64fa9d9$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === "string") {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf("%") !== -1) valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $5ea20a8ea64fa9d9$var$getComputedStyle = (element)=>window.getComputedStyle(element, null);
function $5ea20a8ea64fa9d9$export$527e9aa3390079e9(el, property) {
    return $5ea20a8ea64fa9d9$var$getComputedStyle(el).getPropertyValue(property);
}
const $5ea20a8ea64fa9d9$var$positions = [
    "top",
    "right",
    "bottom",
    "left"
];
function $5ea20a8ea64fa9d9$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? "-" + suffix : "";
    for(let i = 0; i < 4; i++){
        const pos = $5ea20a8ea64fa9d9$var$positions[i];
        result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $5ea20a8ea64fa9d9$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
function $5ea20a8ea64fa9d9$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($5ea20a8ea64fa9d9$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
function $5ea20a8ea64fa9d9$export$78acf4525d8a74c4(evt, chart) {
    if ("native" in evt) return evt;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $5ea20a8ea64fa9d9$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === "border-box";
    const paddings = $5ea20a8ea64fa9d9$var$getPositionedStyle(style, "padding");
    const borders = $5ea20a8ea64fa9d9$var$getPositionedStyle(style, "border", "width");
    const { x: x, y: y, box: box } = $5ea20a8ea64fa9d9$var$getCanvasPosition(evt, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $5ea20a8ea64fa9d9$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = $5ea20a8ea64fa9d9$export$ce26c07117d59d6a(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect();
            const containerStyle = $5ea20a8ea64fa9d9$var$getComputedStyle(container);
            const containerBorder = $5ea20a8ea64fa9d9$var$getPositionedStyle(containerStyle, "border", "width");
            const containerPadding = $5ea20a8ea64fa9d9$var$getPositionedStyle(containerStyle, "padding");
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $5ea20a8ea64fa9d9$var$parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
            maxHeight = $5ea20a8ea64fa9d9$var$parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $5ea20a8ea64fa9d9$export$d29e374196577086,
        maxHeight: maxHeight || $5ea20a8ea64fa9d9$export$d29e374196577086
    };
}
const $5ea20a8ea64fa9d9$var$round1 = (v)=>Math.round(v * 10) / 10;
function $5ea20a8ea64fa9d9$export$3c2fa207a37baaea(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $5ea20a8ea64fa9d9$var$getComputedStyle(canvas);
    const margins = $5ea20a8ea64fa9d9$var$getPositionedStyle(style, "margin");
    const maxWidth = $5ea20a8ea64fa9d9$var$parseMaxStyle(style.maxWidth, canvas, "clientWidth") || $5ea20a8ea64fa9d9$export$d29e374196577086;
    const maxHeight = $5ea20a8ea64fa9d9$var$parseMaxStyle(style.maxHeight, canvas, "clientHeight") || $5ea20a8ea64fa9d9$export$d29e374196577086;
    const containerSize = $5ea20a8ea64fa9d9$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === "content-box") {
        const borders = $5ea20a8ea64fa9d9$var$getPositionedStyle(style, "border", "width");
        const paddings = $5ea20a8ea64fa9d9$var$getPositionedStyle(style, "padding");
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height - margins.height);
    width = $5ea20a8ea64fa9d9$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $5ea20a8ea64fa9d9$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) height = $5ea20a8ea64fa9d9$var$round1(width / 2);
    return {
        width: width,
        height: height
    };
}
function $5ea20a8ea64fa9d9$export$c9170ad7d4cd7e57(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = deviceHeight / pixelRatio;
    chart.width = deviceWidth / pixelRatio;
    const canvas = chart.canvas;
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
const $5ea20a8ea64fa9d9$export$a8550f7dbe79f93a = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        window.addEventListener("test", null, options);
        window.removeEventListener("test", null, options);
    } catch (e) {}
    return passiveSupported;
}();
function $5ea20a8ea64fa9d9$export$6559d589eb85fbb6(element, property) {
    const value = $5ea20a8ea64fa9d9$export$527e9aa3390079e9(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
function $5ea20a8ea64fa9d9$export$d24c54395ce0c509(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
function $5ea20a8ea64fa9d9$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === "middle" ? t < 0.5 ? p1.y : p2.y : mode === "after" ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
function $5ea20a8ea64fa9d9$export$8a5498727ef6be21(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $5ea20a8ea64fa9d9$export$d24c54395ce0c509(p1, cp1, t);
    const b = $5ea20a8ea64fa9d9$export$d24c54395ce0c509(cp1, cp2, t);
    const c = $5ea20a8ea64fa9d9$export$d24c54395ce0c509(cp2, p2, t);
    const d = $5ea20a8ea64fa9d9$export$d24c54395ce0c509(a, b, t);
    const e = $5ea20a8ea64fa9d9$export$d24c54395ce0c509(b, c, t);
    return $5ea20a8ea64fa9d9$export$d24c54395ce0c509(d, e, t);
}
const $5ea20a8ea64fa9d9$var$intlCache = new Map();
function $5ea20a8ea64fa9d9$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $5ea20a8ea64fa9d9$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $5ea20a8ea64fa9d9$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $5ea20a8ea64fa9d9$export$ae1af26003f05816(num, locale, options) {
    return $5ea20a8ea64fa9d9$var$getNumberFormat(locale, options).format(num);
}
const $5ea20a8ea64fa9d9$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === "center") return align;
            return align === "right" ? "left" : "right";
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $5ea20a8ea64fa9d9$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $5ea20a8ea64fa9d9$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $5ea20a8ea64fa9d9$var$getRightToLeftAdapter(rectX, width) : $5ea20a8ea64fa9d9$var$getLeftToRightAdapter();
}
function $5ea20a8ea64fa9d9$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === "ltr" || direction === "rtl") {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue("direction"),
            style.getPropertyPriority("direction")
        ];
        style.setProperty("direction", direction, "important");
        ctx.prevTextDirection = original;
    }
}
function $5ea20a8ea64fa9d9$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty("direction", original[0], original[1]);
    }
}
function $5ea20a8ea64fa9d9$var$propertyFn(property) {
    if (property === "angle") return {
        between: $5ea20a8ea64fa9d9$export$ffb5f4729a158638,
        compare: $5ea20a8ea64fa9d9$export$7a0bdf7d4a91ea88,
        normalize: $5ea20a8ea64fa9d9$export$3d12bd131bb975d1
    };
    return {
        between: $5ea20a8ea64fa9d9$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $5ea20a8ea64fa9d9$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $5ea20a8ea64fa9d9$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $5ea20a8ea64fa9d9$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $5ea20a8ea64fa9d9$export$28f7fcd39efa255(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $5ea20a8ea64fa9d9$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $5ea20a8ea64fa9d9$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($5ea20a8ea64fa9d9$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($5ea20a8ea64fa9d9$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $5ea20a8ea64fa9d9$export$7a38258bbe170828(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $5ea20a8ea64fa9d9$export$28f7fcd39efa255(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $5ea20a8ea64fa9d9$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $5ea20a8ea64fa9d9$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $5ea20a8ea64fa9d9$export$306ddfe3a8403e2(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $5ea20a8ea64fa9d9$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $5ea20a8ea64fa9d9$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $5ea20a8ea64fa9d9$var$splitByStyles(line, $5ea20a8ea64fa9d9$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $5ea20a8ea64fa9d9$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $5ea20a8ea64fa9d9$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $5ea20a8ea64fa9d9$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $5ea20a8ea64fa9d9$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $5ea20a8ea64fa9d9$var$readStyle(segmentOptions.setContext($5ea20a8ea64fa9d9$export$dda1d9f60106f0e9(chartContext, {
                type: "segment",
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($5ea20a8ea64fa9d9$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $5ea20a8ea64fa9d9$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $5ea20a8ea64fa9d9$var$styleChanged(style, prevStyle) {
    return prevStyle && JSON.stringify(style) !== JSON.stringify(prevStyle);
}


class $41f2dc2c94660a50$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $5ea20a8ea64fa9d9$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, "progress");
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, "complete");
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), "complete");
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $41f2dc2c94660a50$export$a424a0aa8f687495 = new $41f2dc2c94660a50$var$Animator();
const $41f2dc2c94660a50$var$transparent = "transparent";
const $41f2dc2c94660a50$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $5ea20a8ea64fa9d9$export$db3b6bfb95261072)(from || $41f2dc2c94660a50$var$transparent);
        const c1 = c0.valid && (0, $5ea20a8ea64fa9d9$export$db3b6bfb95261072)(to || $41f2dc2c94660a50$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $41f2dc2c94660a50$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $5ea20a8ea64fa9d9$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $5ea20a8ea64fa9d9$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $41f2dc2c94660a50$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $5ea20a8ea64fa9d9$export$f1e1789686576879)[cfg.easing] || (0, $5ea20a8ea64fa9d9$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $5ea20a8ea64fa9d9$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $5ea20a8ea64fa9d9$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? "res" : "rej";
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
const $41f2dc2c94660a50$var$numbers = [
    "x",
    "y",
    "borderWidth",
    "radius",
    "tension"
];
const $41f2dc2c94660a50$var$colors = [
    "color",
    "borderColor",
    "backgroundColor"
];
(0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).set("animation", {
    delay: undefined,
    duration: 1000,
    easing: "easeOutQuart",
    fn: undefined,
    from: undefined,
    loop: undefined,
    to: undefined,
    type: undefined
});
const $41f2dc2c94660a50$var$animationOptions = Object.keys((0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).animation);
(0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).describe("animation", {
    _fallback: false,
    _indexable: false,
    _scriptable: (name)=>name !== "onProgress" && name !== "onComplete" && name !== "fn"
});
(0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).set("animations", {
    colors: {
        type: "color",
        properties: $41f2dc2c94660a50$var$colors
    },
    numbers: {
        type: "number",
        properties: $41f2dc2c94660a50$var$numbers
    }
});
(0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).describe("animations", {
    _fallback: "animation"
});
(0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).set("transitions", {
    active: {
        animation: {
            duration: 400
        }
    },
    resize: {
        animation: {
            duration: 0
        }
    },
    show: {
        animations: {
            colors: {
                from: "transparent"
            },
            visible: {
                type: "boolean",
                duration: 0
            }
        }
    },
    hide: {
        animations: {
            colors: {
                to: "transparent"
            },
            visible: {
                type: "boolean",
                easing: "linear",
                fn: (v)=>v | 0
            }
        }
    }
});
class $41f2dc2c94660a50$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(config)) return;
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of $41f2dc2c94660a50$var$animationOptions)resolved[option] = cfg[option];
            ((0, $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $41f2dc2c94660a50$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $41f2dc2c94660a50$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === "$") continue;
            if (prop === "options") {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $41f2dc2c94660a50$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $41f2dc2c94660a50$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $41f2dc2c94660a50$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $41f2dc2c94660a50$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $41f2dc2c94660a50$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $41f2dc2c94660a50$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $41f2dc2c94660a50$var$scaleClip(xScale, allowedOverflow);
    const y = $41f2dc2c94660a50$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $41f2dc2c94660a50$var$toClip(value) {
    let t, r, b, l;
    if ((0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $41f2dc2c94660a50$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $41f2dc2c94660a50$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === "single";
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $5ea20a8ea64fa9d9$export$2408f22a0fab9ae5)(value) === (0, $5ea20a8ea64fa9d9$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    return value;
}
function $41f2dc2c94660a50$var$convertObjectDataToArray(data) {
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function $41f2dc2c94660a50$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $41f2dc2c94660a50$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $41f2dc2c94660a50$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $41f2dc2c94660a50$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $41f2dc2c94660a50$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $41f2dc2c94660a50$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $41f2dc2c94660a50$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $41f2dc2c94660a50$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $41f2dc2c94660a50$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $41f2dc2c94660a50$var$getLastIndexInStack(stack, vScale, false, meta.type);
    }
}
function $41f2dc2c94660a50$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $41f2dc2c94660a50$var$createDatasetContext(parent, index) {
    return (0, $5ea20a8ea64fa9d9$export$dda1d9f60106f0e9)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: "default",
        type: "dataset"
    });
}
function $41f2dc2c94660a50$var$createDataContext(parent, index, element) {
    return (0, $5ea20a8ea64fa9d9$export$dda1d9f60106f0e9)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: "default",
        type: "data"
    });
}
function $41f2dc2c94660a50$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
    }
}
const $41f2dc2c94660a50$var$isDirectUpdateMode = (mode)=>mode === "reset" || mode === "none";
const $41f2dc2c94660a50$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $41f2dc2c94660a50$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $41f2dc2c94660a50$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $41f2dc2c94660a50$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $41f2dc2c94660a50$var$isStacked(meta.vScale, meta);
        this.addElements();
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $41f2dc2c94660a50$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === "x" ? x : axis === "r" ? r : y;
        const xid = meta.xAxisID = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(dataset.xAxisID, $41f2dc2c94660a50$var$getFirstScaleId(chart, "x"));
        const yid = meta.yAxisID = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(dataset.yAxisID, $41f2dc2c94660a50$var$getFirstScaleId(chart, "y"));
        const rid = meta.rAxisID = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(dataset.rAxisID, $41f2dc2c94660a50$var$getFirstScaleId(chart, "r"));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update("reset");
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $5ea20a8ea64fa9d9$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $41f2dc2c94660a50$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(data)) this._data = $41f2dc2c94660a50$var$convertObjectDataToArray(data);
        else if (_data !== data) {
            if (_data) {
                (0, $5ea20a8ea64fa9d9$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $41f2dc2c94660a50$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $5ea20a8ea64fa9d9$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $41f2dc2c94660a50$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $41f2dc2c94660a50$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) $41f2dc2c94660a50$var$updateStacks(this, meta._parsed);
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $41f2dc2c94660a50$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $5ea20a8ea64fa9d9$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $5ea20a8ea64fa9d9$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $41f2dc2c94660a50$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]
        };
        return $41f2dc2c94660a50$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $41f2dc2c94660a50$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $41f2dc2c94660a50$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $41f2dc2c94660a50$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
            value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || "default");
        meta._clip = $41f2dc2c94660a50$var$toClip((0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(this.options.clip, $41f2dc2c94660a50$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? "active" : "default";
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $41f2dc2c94660a50$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $41f2dc2c94660a50$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = "default", index) {
        const active = mode === "active";
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + "-" + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $5ea20a8ea64fa9d9$export$35e795649ee09318)(index);
        if (cached) return $41f2dc2c94660a50$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            "hover",
            elementType,
            ""
        ] : [
            elementType,
            ""
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($41f2dc2c94660a50$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $41f2dc2c94660a50$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $41f2dc2c94660a50$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($41f2dc2c94660a50$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$41f2dc2c94660a50$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, "reset");
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $41f2dc2c94660a50$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            "_insertElements",
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            "_removeElements",
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            "_removeElements",
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            "_removeElements",
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            "_insertElements",
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            "_insertElements",
            0,
            arguments.length
        ]);
    }
}
$41f2dc2c94660a50$export$75572ec5c55b4048.defaults = {};
$41f2dc2c94660a50$export$75572ec5c55b4048.prototype.datasetElementType = null;
$41f2dc2c94660a50$export$75572ec5c55b4048.prototype.dataElementType = null;
function $41f2dc2c94660a50$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $5ea20a8ea64fa9d9$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $41f2dc2c94660a50$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $41f2dc2c94660a50$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $5ea20a8ea64fa9d9$export$35e795649ee09318)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $41f2dc2c94660a50$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $41f2dc2c94660a50$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $41f2dc2c94660a50$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $41f2dc2c94660a50$var$parseValue(entry, item, vScale, i) {
    if ((0, $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce)(entry)) $41f2dc2c94660a50$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $41f2dc2c94660a50$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($41f2dc2c94660a50$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $41f2dc2c94660a50$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $41f2dc2c94660a50$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $5ea20a8ea64fa9d9$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $41f2dc2c94660a50$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = "left";
        end = "right";
    } else {
        reverse = properties.base < properties.y;
        start = "bottom";
        end = "top";
    }
    if (reverse) {
        top = "end";
        bottom = "start";
    } else {
        top = "start";
        bottom = "end";
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $41f2dc2c94660a50$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $41f2dc2c94660a50$var$borderProps(properties);
    if (edge === "middle" && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$41f2dc2c94660a50$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$41f2dc2c94660a50$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $41f2dc2c94660a50$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $41f2dc2c94660a50$var$swap(edge, a, b);
        edge = $41f2dc2c94660a50$var$startEnd(edge, b, a);
    } else edge = $41f2dc2c94660a50$var$startEnd(edge, a, b);
    return edge;
}
function $41f2dc2c94660a50$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $41f2dc2c94660a50$var$startEnd(v, start, end) {
    return v === "start" ? start : v === "end" ? end : v;
}
function $41f2dc2c94660a50$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === "auto" ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $41f2dc2c94660a50$export$e97d5dc64e999004 extends $41f2dc2c94660a50$export$75572ec5c55b4048 {
    parsePrimitiveData(meta, data, start, count) {
        return $41f2dc2c94660a50$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $41f2dc2c94660a50$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const iAxisKey = iScale.axis === "x" ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === "x" ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $5ea20a8ea64fa9d9$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($41f2dc2c94660a50$var$parseValue((0, $5ea20a8ea64fa9d9$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $41f2dc2c94660a50$var$isFloatBar(custom) ? "[" + custom.start + ", " + custom.end + "]" : "" + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: "" + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === "reset";
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $41f2dc2c94660a50$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? "active" : mode);
            const options = properties.options || bars[i].options;
            $41f2dc2c94660a50$var$setBorderSkipped(properties, options, stack, index);
            $41f2dc2c94660a50$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const skipNull = (meta)=>{
            const parsed = meta.controller.getParsed(dataIndex);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $41f2dc2c94660a50$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $41f2dc2c94660a50$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $5ea20a8ea64fa9d9$export$2408f22a0fab9ae5)(value) !== (0, $5ea20a8ea64fa9d9$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $41f2dc2c94660a50$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $5ea20a8ea64fa9d9$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === "flex" ? $41f2dc2c94660a50$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $41f2dc2c94660a50$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null) rects[i].draw(this._ctx);
    }
}
$41f2dc2c94660a50$export$e97d5dc64e999004.id = "bar";
$41f2dc2c94660a50$export$e97d5dc64e999004.defaults = {
    datasetElementType: false,
    dataElementType: "bar",
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    grouped: true,
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "base",
                "width",
                "height"
            ]
        }
    }
};
$41f2dc2c94660a50$export$e97d5dc64e999004.overrides = {
    scales: {
        _index_: {
            type: "category",
            offset: true,
            grid: {
                offset: true
            }
        },
        _value_: {
            type: "linear",
            beginAtZero: true
        }
    }
};
class $41f2dc2c94660a50$export$19b5c4773f17abe extends $41f2dc2c94660a50$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: meta.label,
            value: "(" + x + ", " + y + (r ? ", " + r : "") + ")"
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== "active") values.radius = 0;
        values.radius += (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
$41f2dc2c94660a50$export$19b5c4773f17abe.id = "bubble";
$41f2dc2c94660a50$export$19b5c4773f17abe.defaults = {
    datasetElementType: false,
    dataElementType: "point",
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "borderWidth",
                "radius"
            ]
        }
    }
};
$41f2dc2c94660a50$export$19b5c4773f17abe.overrides = {
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return "";
                }
            }
        }
    }
};
function $41f2dc2c94660a50$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $5ea20a8ea64fa9d9$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $5ea20a8ea64fa9d9$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $5ea20a8ea64fa9d9$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $5ea20a8ea64fa9d9$export$56c0d5a1e737357d) + (0, $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $41f2dc2c94660a50$export$e04603e7d8b77172 extends $41f2dc2c94660a50$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = "value" } = this._parsing;
                getter = (i)=>+(0, $5ea20a8ea64fa9d9$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $5ea20a8ea64fa9d9$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $5ea20a8ea64fa9d9$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7);
        let max = -(0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i)) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $5ea20a8ea64fa9d9$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $41f2dc2c94660a50$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $5ea20a8ea64fa9d9$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? "active" : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $5ea20a8ea64fa9d9$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== "inner") max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
$41f2dc2c94660a50$export$e04603e7d8b77172.id = "doughnut";
$41f2dc2c94660a50$export$e04603e7d8b77172.defaults = {
    datasetElementType: false,
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: false
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "circumference",
                "endAngle",
                "innerRadius",
                "outerRadius",
                "startAngle",
                "x",
                "y",
                "offset",
                "borderWidth",
                "spacing"
            ]
        }
    },
    cutout: "50%",
    rotation: 0,
    circumference: 360,
    radius: "100%",
    spacing: 0,
    indexAxis: "r"
};
$41f2dc2c94660a50$export$e04603e7d8b77172.descriptors = {
    _scriptable: (name)=>name !== "spacing",
    _indexable: (name)=>name !== "spacing"
};
$41f2dc2c94660a50$export$e04603e7d8b77172.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (tooltipItem) {
                    let dataLabel = tooltipItem.label;
                    const value = ": " + tooltipItem.formattedValue;
                    if ((0, $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce)(dataLabel)) {
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    }
};
class $41f2dc2c94660a50$export$3c9b5d28c11cbfd0 extends $41f2dc2c94660a50$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $5ea20a8ea64fa9d9$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $5ea20a8ea64fa9d9$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $5ea20a8ea64fa9d9$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
$41f2dc2c94660a50$export$3c9b5d28c11cbfd0.id = "line";
$41f2dc2c94660a50$export$3c9b5d28c11cbfd0.defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    showLine: true,
    spanGaps: false
};
$41f2dc2c94660a50$export$3c9b5d28c11cbfd0.overrides = {
    scales: {
        _index_: {
            type: "category"
        },
        _value_: {
            type: "linear"
        }
    }
};
class $41f2dc2c94660a50$export$2a270b3a0d973c85 extends $41f2dc2c94660a50$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $5ea20a8ea64fa9d9$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $5ea20a8ea64fa9d9$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $5ea20a8ea64fa9d9$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? "active" : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $5ea20a8ea64fa9d9$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
$41f2dc2c94660a50$export$2a270b3a0d973c85.id = "polarArea";
$41f2dc2c94660a50$export$2a270b3a0d973c85.defaults = {
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: true
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "startAngle",
                "endAngle",
                "innerRadius",
                "outerRadius"
            ]
        }
    },
    indexAxis: "r",
    startAngle: 0
};
$41f2dc2c94660a50$export$2a270b3a0d973c85.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (context) {
                    return context.chart.data.labels[context.dataIndex] + ": " + context.formattedValue;
                }
            }
        }
    },
    scales: {
        r: {
            type: "radialLinear",
            angleLines: {
                display: false
            },
            beginAtZero: true,
            grid: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            startAngle: 0
        }
    }
};
class $41f2dc2c94660a50$export$b21a3f1286706191 extends $41f2dc2c94660a50$export$e04603e7d8b77172 {
}
$41f2dc2c94660a50$export$b21a3f1286706191.id = "pie";
$41f2dc2c94660a50$export$b21a3f1286706191.defaults = {
    cutout: 0,
    rotation: 0,
    circumference: 360,
    radius: "100%"
};
class $41f2dc2c94660a50$export$48dbc6ac651bf8be extends $41f2dc2c94660a50$export$75572ec5c55b4048 {
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: "" + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $5ea20a8ea64fa9d9$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== "resize") {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === "reset";
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? "active" : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
$41f2dc2c94660a50$export$48dbc6ac651bf8be.id = "radar";
$41f2dc2c94660a50$export$48dbc6ac651bf8be.defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    indexAxis: "r",
    showLine: true,
    elements: {
        line: {
            fill: "start"
        }
    }
};
$41f2dc2c94660a50$export$48dbc6ac651bf8be.overrides = {
    aspectRatio: 1,
    scales: {
        r: {
            type: "radialLinear"
        }
    }
};
class $41f2dc2c94660a50$export$db77ccec0bb4ccac {
    constructor(){
        this.x = undefined;
        this.y = undefined;
        this.active = false;
        this.options = undefined;
        this.$animations = undefined;
    }
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $5ea20a8ea64fa9d9$export$d141bba7fdc215a3)(this.x) && (0, $5ea20a8ea64fa9d9$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
$41f2dc2c94660a50$export$db77ccec0bb4ccac.defaults = {};
$41f2dc2c94660a50$export$db77ccec0bb4ccac.defaultRoutes = undefined;
const $41f2dc2c94660a50$var$formatters = {
    values (value) {
        return (0, $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce)(value) ? value : "" + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = "scientific";
            delta = $41f2dc2c94660a50$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = (0, $5ea20a8ea64fa9d9$export$df995fae86a55f06)(Math.abs(delta));
        const numDecimal = Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return (0, $5ea20a8ea64fa9d9$export$ae1af26003f05816)(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const remain = tickValue / Math.pow(10, Math.floor((0, $5ea20a8ea64fa9d9$export$df995fae86a55f06)(tickValue)));
        if (remain === 1 || remain === 2 || remain === 5) return $41f2dc2c94660a50$var$formatters.numeric.call(this, tickValue, index, ticks);
        return "";
    }
};
function $41f2dc2c94660a50$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $41f2dc2c94660a50$export$27c7467594ef87bd = {
    formatters: $41f2dc2c94660a50$var$formatters
};
(0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).set("scale", {
    display: true,
    offset: false,
    reverse: false,
    beginAtZero: false,
    bounds: "ticks",
    grace: 0,
    grid: {
        display: true,
        lineWidth: 1,
        drawBorder: true,
        drawOnChartArea: true,
        drawTicks: true,
        tickLength: 8,
        tickWidth: (_ctx, options)=>options.lineWidth,
        tickColor: (_ctx, options)=>options.color,
        offset: false,
        borderDash: [],
        borderDashOffset: 0.0,
        borderWidth: 1
    },
    title: {
        display: false,
        text: "",
        padding: {
            top: 4,
            bottom: 4
        }
    },
    ticks: {
        minRotation: 0,
        maxRotation: 50,
        mirror: false,
        textStrokeWidth: 0,
        textStrokeColor: "",
        padding: 3,
        display: true,
        autoSkip: true,
        autoSkipPadding: 3,
        labelOffset: 0,
        callback: $41f2dc2c94660a50$export$27c7467594ef87bd.formatters.values,
        minor: {},
        major: {},
        align: "center",
        crossAlign: "near",
        showLabelBackdrop: false,
        backdropColor: "rgba(255, 255, 255, 0.75)",
        backdropPadding: 2
    }
});
(0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).route("scale.ticks", "color", "", "color");
(0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).route("scale.grid", "color", "", "borderColor");
(0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).route("scale.grid", "borderColor", "", "borderColor");
(0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).route("scale.title", "color", "", "color");
(0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).describe("scale", {
    _fallback: false,
    _scriptable: (name)=>!name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
    _indexable: (name)=>name !== "borderDash" && name !== "tickBorderDash"
});
(0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).describe("scales", {
    _fallback: "scale"
});
(0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).describe("scale.ticks", {
    _scriptable: (name)=>name !== "backdropPadding" && name !== "callback",
    _indexable: (name)=>name !== "backdropPadding"
});
function $41f2dc2c94660a50$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const ticksLimit = tickOpts.maxTicksLimit || $41f2dc2c94660a50$var$determineMaxTicks(scale);
    const majorIndices = tickOpts.major.enabled ? $41f2dc2c94660a50$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $41f2dc2c94660a50$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $41f2dc2c94660a50$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $41f2dc2c94660a50$var$skip(ticks, newTicks, spacing, (0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$41f2dc2c94660a50$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $41f2dc2c94660a50$var$skip(ticks, newTicks, spacing, last, (0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $41f2dc2c94660a50$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $41f2dc2c94660a50$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $41f2dc2c94660a50$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $41f2dc2c94660a50$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $5ea20a8ea64fa9d9$export$ebd11618f299a286)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $41f2dc2c94660a50$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $41f2dc2c94660a50$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $41f2dc2c94660a50$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $41f2dc2c94660a50$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $41f2dc2c94660a50$var$reverseAlign = (align)=>align === "left" ? "right" : align === "right" ? "left" : align;
const $41f2dc2c94660a50$var$offsetFromEdge = (scale, edge, offset)=>edge === "top" || edge === "left" ? scale[edge] + offset : scale[edge] - offset;
function $41f2dc2c94660a50$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $41f2dc2c94660a50$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $41f2dc2c94660a50$var$garbageCollect(caches, length) {
    (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $41f2dc2c94660a50$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $41f2dc2c94660a50$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(options.font, fallback);
    const padding = (0, $5ea20a8ea64fa9d9$export$3466f893ebf79586)(options.padding);
    const lines = (0, $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $41f2dc2c94660a50$var$createScaleContext(parent, scale) {
    return (0, $5ea20a8ea64fa9d9$export$dda1d9f60106f0e9)(parent, {
        scale: scale,
        type: "scale"
    });
}
function $41f2dc2c94660a50$var$createTickContext(parent, index, tick) {
    return (0, $5ea20a8ea64fa9d9$export$dda1d9f60106f0e9)(parent, {
        tick: tick,
        index: index,
        type: "tick"
    });
}
function $41f2dc2c94660a50$var$titleAlign(align, position, reverse) {
    let ret = (0, $5ea20a8ea64fa9d9$export$db202ddc8be9136)(align);
    if (reverse && position !== "right" || !reverse && position === "right") ret = $41f2dc2c94660a50$var$reverseAlign(ret);
    return ret;
}
function $41f2dc2c94660a50$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $5ea20a8ea64fa9d9$export$25ce5a424b770e84)(align, left, right);
        if ((0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === "center") titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $41f2dc2c94660a50$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === "center") titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $41f2dc2c94660a50$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $5ea20a8ea64fa9d9$export$25ce5a424b770e84)(align, bottom, top);
        rotation = position === "left" ? -(0, $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd) : (0, $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $41f2dc2c94660a50$export$d60cfc58d3c358b6 extends $41f2dc2c94660a50$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $5ea20a8ea64fa9d9$export$ef35774e6d314e91)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $5ea20a8ea64fa9d9$export$ef35774e6d314e91)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $5ea20a8ea64fa9d9$export$ef35774e6d314e91)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $5ea20a8ea64fa9d9$export$ef35774e6d314e91)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $5ea20a8ea64fa9d9$export$ef35774e6d314e91)(_userMin, _suggestedMin),
            max: (0, $5ea20a8ea64fa9d9$export$ef35774e6d314e91)(_userMax, _suggestedMax),
            minDefined: (0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $5ea20a8ea64fa9d9$export$ef35774e6d314e91)(min, (0, $5ea20a8ea64fa9d9$export$ef35774e6d314e91)(max, min)),
            max: (0, $5ea20a8ea64fa9d9$export$ef35774e6d314e91)(max, (0, $5ea20a8ea64fa9d9$export$ef35774e6d314e91)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $5ea20a8ea64fa9d9$export$96f57966bedc81b4)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $41f2dc2c94660a50$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
            this.ticks = $41f2dc2c94660a50$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks("beforeDataLimits");
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks("afterDataLimits");
    }
    beforeBuildTicks() {
        this._callHooks("beforeBuildTicks");
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks("afterBuildTicks");
    }
    beforeTickToLabelConversion() {
        (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = this.ticks.length;
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $41f2dc2c94660a50$var$getTickMarkLength(options.grid) - tickOpts.padding - $41f2dc2c94660a50$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $5ea20a8ea64fa9d9$export$d66501df72047452)(Math.min(Math.asin((0, $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $41f2dc2c94660a50$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $41f2dc2c94660a50$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $41f2dc2c94660a50$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $5ea20a8ea64fa9d9$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== "top" && this.axis === "x";
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === "start") paddingRight = last.width;
            else if (align === "end") paddingLeft = first.width;
            else if (align !== "inner") {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === "start") {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === "end") {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === "top" || position === "bottom" || axis === "x";
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $41f2dc2c94660a50$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(label) && !(0, $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce)(label)) {
                width = (0, $5ea20a8ea64fa9d9$export$2329c99376c9d0a4)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(nestedLabel) && !(0, $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $5ea20a8ea64fa9d9$export$2329c99376c9d0a4)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $41f2dc2c94660a50$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $5ea20a8ea64fa9d9$export$9bb611d729802a56)(this._alignToPixels ? (0, $5ea20a8ea64fa9d9$export$b4171a6734a65d42)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $41f2dc2c94660a50$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $41f2dc2c94660a50$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $5ea20a8ea64fa9d9$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== "auto") return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $41f2dc2c94660a50$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = grid.setContext(this.getContext());
        const axisWidth = borderOpts.drawBorder ? borderOpts.borderWidth : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $5ea20a8ea64fa9d9$export$b4171a6734a65d42)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === "top") {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === "bottom") {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === "left") {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === "right") {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === "x") {
            if (position === "center") borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === "y") {
            if (position === "center") borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const optsAtIndex = grid.setContext(this.getContext(i));
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndex.borderDash || [];
            const borderDashOffset = optsAtIndex.borderDashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $41f2dc2c94660a50$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $5ea20a8ea64fa9d9$export$b4171a6734a65d42)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $41f2dc2c94660a50$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $5ea20a8ea64fa9d9$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = "middle";
        if (position === "top") {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "bottom") {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "left") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === "right") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === "x") {
            if (position === "center") y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === "y") {
            if (position === "center") x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === "y") {
            if (align === "start") textBaseline = "top";
            else if (align === "end") textBaseline = "bottom";
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === "inner") {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? "right" : "left";
                    else if (i === 0) tickTextAlign = !this.options.reverse ? "left" : "right";
                    else tickTextAlign = "center";
                }
                if (position === "top") {
                    if (crossAlign === "near" || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === "center") textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === "near" || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === "center") textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $5ea20a8ea64fa9d9$export$3466f893ebf79586)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = y + textOffset - labelPadding.top;
                let left = x - labelPadding.left;
                switch(textBaseline){
                    case "middle":
                        top -= height / 2;
                        break;
                    case "bottom":
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case "center":
                        left -= width / 2;
                        break;
                    case "right":
                        left -= width;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                rotation: rotation,
                label: label,
                font: font,
                color: color,
                strokeColor: strokeColor,
                strokeWidth: strokeWidth,
                textOffset: textOffset,
                textAlign: tickTextAlign,
                textBaseline: textBaseline,
                translation: [
                    x,
                    y
                ],
                backdrop: backdrop
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $5ea20a8ea64fa9d9$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === "top" ? "left" : "right";
        let align = "center";
        if (ticks.align === "start") align = "left";
        else if (ticks.align === "end") align = "right";
        else if (ticks.align === "inner") align = "inner";
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === "left") {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x = this.left;
                }
            }
        } else if (position === "right") {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x = this.right;
                }
            }
        } else textAlign = "right";
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === "left" || position === "right") return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === "top" || position === "bottom") return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { grid: grid } } = this;
        const borderOpts = grid.setContext(this.getContext());
        const axisWidth = grid.drawBorder ? borderOpts.borderWidth : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $5ea20a8ea64fa9d9$export$b4171a6734a65d42)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $5ea20a8ea64fa9d9$export$b4171a6734a65d42)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $5ea20a8ea64fa9d9$export$b4171a6734a65d42)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $5ea20a8ea64fa9d9$export$b4171a6734a65d42)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.borderWidth;
        ctx.strokeStyle = borderOpts.borderColor;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $5ea20a8ea64fa9d9$export$61196ced6d74a310)(ctx, area);
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        let i, ilen;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            const tickFont = item.font;
            const label = item.label;
            if (item.backdrop) {
                ctx.fillStyle = item.backdrop.color;
                ctx.fillRect(item.backdrop.left, item.backdrop.top, item.backdrop.width, item.backdrop.height);
            }
            let y = item.textOffset;
            (0, $5ea20a8ea64fa9d9$export$3a1a48c8f6ef640e)(ctx, label, 0, y, tickFont, item);
        }
        if (area) (0, $5ea20a8ea64fa9d9$export$a07804094c3ecf2d)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(title.font);
        const padding = (0, $5ea20a8ea64fa9d9$export$3466f893ebf79586)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === "bottom" || position === "center" || (0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $41f2dc2c94660a50$var$titleArgs(this, offset, position, align);
        (0, $5ea20a8ea64fa9d9$export$3a1a48c8f6ef640e)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $41f2dc2c94660a50$var$titleAlign(align, position, reverse),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        if (!this._isVisible() || this.draw !== $41f2dc2c94660a50$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: gz + 1,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + "AxisID";
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $41f2dc2c94660a50$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($41f2dc2c94660a50$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + "." + id;
        if (!id) throw new Error("class does not have id: " + item);
        if (id in items) return scope;
        items[id] = item;
        $41f2dc2c94660a50$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0)[scope]) {
            delete (0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $5ea20a8ea64fa9d9$export$3a6d5c9ae78a2c08)[id];
        }
    }
}
function $41f2dc2c94660a50$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $5ea20a8ea64fa9d9$export$e7c866399fa523f5)(Object.create(null), [
        parentScope ? (0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $41f2dc2c94660a50$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $41f2dc2c94660a50$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split(".");
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join(".");
        const parts = routes[property].split(".");
        const targetName = parts.pop();
        const targetScope = parts.join(".");
        (0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $41f2dc2c94660a50$var$isIChartComponent(proto) {
    return "id" in proto && "defaults" in proto;
}
class $41f2dc2c94660a50$var$Registry {
    constructor(){
        this.controllers = new $41f2dc2c94660a50$var$TypedRegistry($41f2dc2c94660a50$export$75572ec5c55b4048, "datasets", true);
        this.elements = new $41f2dc2c94660a50$var$TypedRegistry($41f2dc2c94660a50$export$db77ccec0bb4ccac, "elements");
        this.plugins = new $41f2dc2c94660a50$var$TypedRegistry(Object, "plugins");
        this.scales = new $41f2dc2c94660a50$var$TypedRegistry($41f2dc2c94660a50$export$d60cfc58d3c358b6, "scales");
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each("register", args);
    }
    remove(...args) {
        this._each("unregister", args);
    }
    addControllers(...args) {
        this._each("register", args, this.controllers);
    }
    addElements(...args) {
        this._each("register", args, this.elements);
    }
    addPlugins(...args) {
        this._each("register", args, this.plugins);
    }
    addScales(...args) {
        this._each("register", args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, "controller");
    }
    getElement(id) {
        return this._get(id, this.elements, "element");
    }
    getPlugin(id) {
        return this._get(id, this.plugins, "plugin");
    }
    getScale(id) {
        return this._get(id, this.scales, "scale");
    }
    removeControllers(...args) {
        this._each("unregister", args, this.controllers);
    }
    removeElements(...args) {
        this._each("unregister", args, this.elements);
    }
    removePlugins(...args) {
        this._each("unregister", args, this.plugins);
    }
    removeScales(...args) {
        this._each("unregister", args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $5ea20a8ea64fa9d9$export$71cec2538cb2c617)(method);
        (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(component["before" + camelMethod], [], component);
        registry[method](component);
        (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(component["after" + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + ".");
        return item;
    }
}
var $41f2dc2c94660a50$export$4bb7493d241fd8a5 = new $41f2dc2c94660a50$var$Registry();
class $41f2dc2c94660a50$export$b2f2bae6713db87 extends $41f2dc2c94660a50$export$75572ec5c55b4048 {
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $5ea20a8ea64fa9d9$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $5ea20a8ea64fa9d9$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = $41f2dc2c94660a50$export$4bb7493d241fd8a5.getElement("line");
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $5ea20a8ea64fa9d9$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
$41f2dc2c94660a50$export$b2f2bae6713db87.id = "scatter";
$41f2dc2c94660a50$export$b2f2bae6713db87.defaults = {
    datasetElementType: false,
    dataElementType: "point",
    showLine: false,
    fill: false
};
$41f2dc2c94660a50$export$b2f2bae6713db87.overrides = {
    interaction: {
        mode: "point"
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (item) {
                    return "(" + item.label + ", " + item.formattedValue + ")";
                }
            }
        }
    },
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    }
};
var $41f2dc2c94660a50$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $41f2dc2c94660a50$export$e97d5dc64e999004,
    BubbleController: $41f2dc2c94660a50$export$19b5c4773f17abe,
    DoughnutController: $41f2dc2c94660a50$export$e04603e7d8b77172,
    LineController: $41f2dc2c94660a50$export$3c9b5d28c11cbfd0,
    PolarAreaController: $41f2dc2c94660a50$export$2a270b3a0d973c85,
    PieController: $41f2dc2c94660a50$export$b21a3f1286706191,
    RadarController: $41f2dc2c94660a50$export$48dbc6ac651bf8be,
    ScatterController: $41f2dc2c94660a50$export$b2f2bae6713db87
});
function $41f2dc2c94660a50$var$abstract() {
    throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class $41f2dc2c94660a50$var$DateAdapter {
    constructor(options){
        this.options = options || {};
    }
    init(chartOptions) {}
    formats() {
        return $41f2dc2c94660a50$var$abstract();
    }
    parse(value, format) {
        return $41f2dc2c94660a50$var$abstract();
    }
    format(timestamp, format) {
        return $41f2dc2c94660a50$var$abstract();
    }
    add(timestamp, amount, unit) {
        return $41f2dc2c94660a50$var$abstract();
    }
    diff(a, b, unit) {
        return $41f2dc2c94660a50$var$abstract();
    }
    startOf(timestamp, unit, weekday) {
        return $41f2dc2c94660a50$var$abstract();
    }
    endOf(timestamp, unit) {
        return $41f2dc2c94660a50$var$abstract();
    }
}
$41f2dc2c94660a50$var$DateAdapter.override = function(members) {
    Object.assign($41f2dc2c94660a50$var$DateAdapter.prototype, members);
};
var $41f2dc2c94660a50$export$f32766ea09ec8bc4 = {
    _date: $41f2dc2c94660a50$var$DateAdapter
};
function $41f2dc2c94660a50$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== "r" && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $5ea20a8ea64fa9d9$export$8743009a87fcb00f) : (0, $5ea20a8ea64fa9d9$export$dc98b0b04f4c7758);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === "function" && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $41f2dc2c94660a50$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $41f2dc2c94660a50$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $41f2dc2c94660a50$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf("x") !== -1;
    const useY = axis.indexOf("y") !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $41f2dc2c94660a50$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $5ea20a8ea64fa9d9$export$3d8c2f653ac9d0b9)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $41f2dc2c94660a50$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $41f2dc2c94660a50$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            "startAngle",
            "endAngle"
        ], useFinalPosition);
        const { angle: angle } = (0, $5ea20a8ea64fa9d9$export$34aec0b863436764)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $5ea20a8ea64fa9d9$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $41f2dc2c94660a50$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $41f2dc2c94660a50$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $41f2dc2c94660a50$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $41f2dc2c94660a50$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $41f2dc2c94660a50$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === "r" && !intersect ? $41f2dc2c94660a50$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $41f2dc2c94660a50$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $41f2dc2c94660a50$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
    let intersectsItem = false;
    $41f2dc2c94660a50$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $41f2dc2c94660a50$export$a13296960cae0384 = {
    evaluateInteractionItems: $41f2dc2c94660a50$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $5ea20a8ea64fa9d9$export$78acf4525d8a74c4)(e, chart);
            const axis = options.axis || "x";
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $41f2dc2c94660a50$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $41f2dc2c94660a50$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $5ea20a8ea64fa9d9$export$78acf4525d8a74c4)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $41f2dc2c94660a50$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $41f2dc2c94660a50$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $5ea20a8ea64fa9d9$export$78acf4525d8a74c4)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $41f2dc2c94660a50$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $5ea20a8ea64fa9d9$export$78acf4525d8a74c4)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $41f2dc2c94660a50$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $5ea20a8ea64fa9d9$export$78acf4525d8a74c4)(e, chart);
            return $41f2dc2c94660a50$var$getAxisItems(chart, position, "x", options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $5ea20a8ea64fa9d9$export$78acf4525d8a74c4)(e, chart);
            return $41f2dc2c94660a50$var$getAxisItems(chart, position, "y", options.intersect, useFinalPosition);
        }
    }
};
const $41f2dc2c94660a50$var$STATIC_POSITIONS = [
    "left",
    "top",
    "right",
    "bottom"
];
function $41f2dc2c94660a50$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $41f2dc2c94660a50$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$41f2dc2c94660a50$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $41f2dc2c94660a50$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $41f2dc2c94660a50$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $41f2dc2c94660a50$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$41f2dc2c94660a50$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $41f2dc2c94660a50$var$setLayoutDims(layouts, params) {
    const stacks = $41f2dc2c94660a50$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $41f2dc2c94660a50$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $41f2dc2c94660a50$var$wrapBoxes(boxes);
    const fullSize = $41f2dc2c94660a50$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $41f2dc2c94660a50$var$sortByWeight($41f2dc2c94660a50$var$filterByPosition(layoutBoxes, "left"), true);
    const right = $41f2dc2c94660a50$var$sortByWeight($41f2dc2c94660a50$var$filterByPosition(layoutBoxes, "right"));
    const top = $41f2dc2c94660a50$var$sortByWeight($41f2dc2c94660a50$var$filterByPosition(layoutBoxes, "top"), true);
    const bottom = $41f2dc2c94660a50$var$sortByWeight($41f2dc2c94660a50$var$filterByPosition(layoutBoxes, "bottom"));
    const centerHorizontal = $41f2dc2c94660a50$var$filterDynamicPositionByAxis(layoutBoxes, "x");
    const centerVertical = $41f2dc2c94660a50$var$filterDynamicPositionByAxis(layoutBoxes, "y");
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $41f2dc2c94660a50$var$filterByPosition(layoutBoxes, "chartArea"),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $41f2dc2c94660a50$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $41f2dc2c94660a50$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $41f2dc2c94660a50$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $41f2dc2c94660a50$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $41f2dc2c94660a50$var$getCombinedMax(maxPadding, chartArea, "left", "right"));
    const newHeight = Math.max(0, params.outerHeight - $41f2dc2c94660a50$var$getCombinedMax(maxPadding, chartArea, "top", "bottom"));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $41f2dc2c94660a50$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos("top");
    chartArea.x += updatePos("left");
    updatePos("right");
    updatePos("bottom");
}
function $41f2dc2c94660a50$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        "left",
        "right"
    ]) : marginForPositions([
        "top",
        "bottom"
    ]);
}
function $41f2dc2c94660a50$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $41f2dc2c94660a50$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $41f2dc2c94660a50$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $41f2dc2c94660a50$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $41f2dc2c94660a50$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $41f2dc2c94660a50$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $5ea20a8ea64fa9d9$export$35e795649ee09318)(stack.start)) y = stack.start;
            if (box.fullSize) $41f2dc2c94660a50$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $41f2dc2c94660a50$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $5ea20a8ea64fa9d9$export$35e795649ee09318)(stack.start)) x = stack.start;
            if (box.fullSize) $41f2dc2c94660a50$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $41f2dc2c94660a50$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
(0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).set("layout", {
    autoPadding: true,
    padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
});
var $41f2dc2c94660a50$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || "top";
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $5ea20a8ea64fa9d9$export$3466f893ebf79586)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $41f2dc2c94660a50$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === "function") box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $41f2dc2c94660a50$var$updateMaxPadding(maxPadding, (0, $5ea20a8ea64fa9d9$export$3466f893ebf79586)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $41f2dc2c94660a50$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $41f2dc2c94660a50$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $41f2dc2c94660a50$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($41f2dc2c94660a50$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $41f2dc2c94660a50$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $41f2dc2c94660a50$var$handleMaxPadding(chartArea);
        $41f2dc2c94660a50$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $41f2dc2c94660a50$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $41f2dc2c94660a50$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $41f2dc2c94660a50$export$a40a96b24b46cf35 extends $41f2dc2c94660a50$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext("2d") || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $41f2dc2c94660a50$var$EXPANDO_KEY = "$chartjs";
const $41f2dc2c94660a50$var$EVENT_TYPES = {
    touchstart: "mousedown",
    touchmove: "mousemove",
    touchend: "mouseup",
    pointerenter: "mouseenter",
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointerleave: "mouseout",
    pointerout: "mouseout"
};
const $41f2dc2c94660a50$var$isNullOrEmpty = (value)=>value === null || value === "";
function $41f2dc2c94660a50$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute("height");
    const renderWidth = canvas.getAttribute("width");
    canvas[$41f2dc2c94660a50$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || "block";
    style.boxSizing = style.boxSizing || "border-box";
    if ($41f2dc2c94660a50$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $5ea20a8ea64fa9d9$export$6559d589eb85fbb6)(canvas, "width");
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($41f2dc2c94660a50$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === "") canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $5ea20a8ea64fa9d9$export$6559d589eb85fbb6)(canvas, "height");
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $41f2dc2c94660a50$var$eventListenerOptions = (0, $5ea20a8ea64fa9d9$export$a8550f7dbe79f93a) ? {
    passive: true
} : false;
function $41f2dc2c94660a50$var$addListener(node, type, listener) {
    node.addEventListener(type, listener, $41f2dc2c94660a50$var$eventListenerOptions);
}
function $41f2dc2c94660a50$var$removeListener(chart, type, listener) {
    chart.canvas.removeEventListener(type, listener, $41f2dc2c94660a50$var$eventListenerOptions);
}
function $41f2dc2c94660a50$var$fromNativeEvent(event, chart) {
    const type = $41f2dc2c94660a50$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $5ea20a8ea64fa9d9$export$78acf4525d8a74c4)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $41f2dc2c94660a50$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $41f2dc2c94660a50$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $41f2dc2c94660a50$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$41f2dc2c94660a50$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $41f2dc2c94660a50$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $41f2dc2c94660a50$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$41f2dc2c94660a50$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $41f2dc2c94660a50$var$drpListeningCharts = new Map();
let $41f2dc2c94660a50$var$oldDevicePixelRatio = 0;
function $41f2dc2c94660a50$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $41f2dc2c94660a50$var$oldDevicePixelRatio) return;
    $41f2dc2c94660a50$var$oldDevicePixelRatio = dpr;
    $41f2dc2c94660a50$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $41f2dc2c94660a50$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$41f2dc2c94660a50$var$drpListeningCharts.size) window.addEventListener("resize", $41f2dc2c94660a50$var$onWindowResize);
    $41f2dc2c94660a50$var$drpListeningCharts.set(chart, resize);
}
function $41f2dc2c94660a50$var$unlistenDevicePixelRatioChanges(chart) {
    $41f2dc2c94660a50$var$drpListeningCharts.delete(chart);
    if (!$41f2dc2c94660a50$var$drpListeningCharts.size) window.removeEventListener("resize", $41f2dc2c94660a50$var$onWindowResize);
}
function $41f2dc2c94660a50$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $5ea20a8ea64fa9d9$export$ce26c07117d59d6a)(canvas);
    if (!container) return;
    const resize = (0, $5ea20a8ea64fa9d9$export$efca4cbe5dd06740)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $41f2dc2c94660a50$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $41f2dc2c94660a50$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === "resize") $41f2dc2c94660a50$var$unlistenDevicePixelRatioChanges(chart);
}
function $41f2dc2c94660a50$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $5ea20a8ea64fa9d9$export$efca4cbe5dd06740)((event)=>{
        if (chart.ctx !== null) listener($41f2dc2c94660a50$var$fromNativeEvent(event, chart));
    }, chart, (args)=>{
        const event = args[0];
        return [
            event,
            event.offsetX,
            event.offsetY
        ];
    });
    $41f2dc2c94660a50$var$addListener(canvas, type, proxy);
    return proxy;
}
class $41f2dc2c94660a50$export$f02da7f882cf6b2e extends $41f2dc2c94660a50$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext("2d");
        if (context && context.canvas === canvas) {
            $41f2dc2c94660a50$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$41f2dc2c94660a50$var$EXPANDO_KEY]) return false;
        const initial = canvas[$41f2dc2c94660a50$var$EXPANDO_KEY].initial;
        [
            "height",
            "width"
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$41f2dc2c94660a50$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $41f2dc2c94660a50$var$createAttachObserver,
            detach: $41f2dc2c94660a50$var$createDetachObserver,
            resize: $41f2dc2c94660a50$var$createResizeObserver
        };
        const handler = handlers[type] || $41f2dc2c94660a50$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $41f2dc2c94660a50$var$releaseObserver,
            detach: $41f2dc2c94660a50$var$releaseObserver,
            resize: $41f2dc2c94660a50$var$releaseObserver
        };
        const handler = handlers[type] || $41f2dc2c94660a50$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $5ea20a8ea64fa9d9$export$3c2fa207a37baaea)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = (0, $5ea20a8ea64fa9d9$export$ce26c07117d59d6a)(canvas);
        return !!(container && container.isConnected);
    }
}
function $41f2dc2c94660a50$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $5ea20a8ea64fa9d9$export$2e2af4578d910ddf)() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) return $41f2dc2c94660a50$export$a40a96b24b46cf35;
    return $41f2dc2c94660a50$export$f02da7f882cf6b2e;
}
class $41f2dc2c94660a50$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === "beforeInit") {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, "install");
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === "afterDestroy") {
            this._notify(descriptors, chart, "stop");
            this._notify(this._init, chart, "uninstall");
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $41f2dc2c94660a50$var$allPlugins(config);
        return options === false && !all ? [] : $41f2dc2c94660a50$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, "stop");
        this._notify(diff(descriptors, previousDescriptors), chart, "start");
    }
}
function $41f2dc2c94660a50$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($41f2dc2c94660a50$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($41f2dc2c94660a50$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $41f2dc2c94660a50$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $41f2dc2c94660a50$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $41f2dc2c94660a50$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $41f2dc2c94660a50$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $41f2dc2c94660a50$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ""
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $41f2dc2c94660a50$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function $41f2dc2c94660a50$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === "_index_") axis = indexAxis;
    else if (id === "_value_") axis = indexAxis === "x" ? "y" : "x";
    return axis;
}
function $41f2dc2c94660a50$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? "_index_" : "_value_";
}
function $41f2dc2c94660a50$var$axisFromPosition(position) {
    if (position === "top" || position === "bottom") return "x";
    if (position === "left" || position === "right") return "y";
}
function $41f2dc2c94660a50$var$determineAxis(id, scaleOptions) {
    if (id === "x" || id === "y") return id;
    return scaleOptions.axis || $41f2dc2c94660a50$var$axisFromPosition(scaleOptions.position) || id.charAt(0).toLowerCase();
}
function $41f2dc2c94660a50$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $5ea20a8ea64fa9d9$export$3a6d5c9ae78a2c08)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $41f2dc2c94660a50$var$getIndexAxis(config.type, options);
    const firstIDs = Object.create(null);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $41f2dc2c94660a50$var$determineAxis(id, scaleConf);
        const defaultId = $41f2dc2c94660a50$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        firstIDs[axis] = firstIDs[axis] || id;
        scales[id] = (0, $5ea20a8ea64fa9d9$export$2219238a014317b0)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $41f2dc2c94660a50$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $5ea20a8ea64fa9d9$export$3a6d5c9ae78a2c08)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $41f2dc2c94660a50$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + "AxisID"] || firstIDs[axis] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $5ea20a8ea64fa9d9$export$2219238a014317b0)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $5ea20a8ea64fa9d9$export$2219238a014317b0)(scale, [
            (0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).scales[scale.type],
            (0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $41f2dc2c94660a50$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $41f2dc2c94660a50$var$mergeScaleConfig(config, options);
}
function $41f2dc2c94660a50$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $41f2dc2c94660a50$var$initConfig(config) {
    config = config || {};
    config.data = $41f2dc2c94660a50$var$initData(config.data);
    $41f2dc2c94660a50$var$initOptions(config);
    return config;
}
const $41f2dc2c94660a50$var$keyCache = new Map();
const $41f2dc2c94660a50$var$keysCached = new Set();
function $41f2dc2c94660a50$var$cachedKeys(cacheKey, generate) {
    let keys = $41f2dc2c94660a50$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $41f2dc2c94660a50$var$keyCache.set(cacheKey, keys);
        $41f2dc2c94660a50$var$keysCached.add(keys);
    }
    return keys;
}
const $41f2dc2c94660a50$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $5ea20a8ea64fa9d9$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $41f2dc2c94660a50$var$Config {
    constructor(config){
        this._config = $41f2dc2c94660a50$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $41f2dc2c94660a50$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $41f2dc2c94660a50$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $41f2dc2c94660a50$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $41f2dc2c94660a50$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $41f2dc2c94660a50$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ""
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $41f2dc2c94660a50$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$41f2dc2c94660a50$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$41f2dc2c94660a50$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$41f2dc2c94660a50$var$addIfFound(scopes, (0, $5ea20a8ea64fa9d9$export$3a6d5c9ae78a2c08)[type] || {}, key));
            keys.forEach((key)=>$41f2dc2c94660a50$var$addIfFound(scopes, (0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$41f2dc2c94660a50$var$addIfFound(scopes, (0, $5ea20a8ea64fa9d9$export$a93c5207d687da10), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($41f2dc2c94660a50$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $5ea20a8ea64fa9d9$export$3a6d5c9ae78a2c08)[type] || {},
            (0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0),
            (0, $5ea20a8ea64fa9d9$export$a93c5207d687da10)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ""
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $41f2dc2c94660a50$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($41f2dc2c94660a50$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $5ea20a8ea64fa9d9$export$c3950d9923825c02)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $5ea20a8ea64fa9d9$export$a9c996f45e5784d0)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ""
    ], descriptorDefaults) {
        const { resolver: resolver } = $41f2dc2c94660a50$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(context) ? (0, $5ea20a8ea64fa9d9$export$a9c996f45e5784d0)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $41f2dc2c94660a50$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $5ea20a8ea64fa9d9$export$7910e0436ed8d1de)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes("hover"))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $41f2dc2c94660a50$var$hasFunction = (value)=>(0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).reduce((acc, key)=>acc || (0, $5ea20a8ea64fa9d9$export$c3950d9923825c02)(value[key]), false);
function $41f2dc2c94660a50$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $5ea20a8ea64fa9d9$export$555508cbc6add439)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $5ea20a8ea64fa9d9$export$c3950d9923825c02)(value) || $41f2dc2c94660a50$var$hasFunction(value)) || indexable && (0, $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $41f2dc2c94660a50$var$version = "3.9.1";
const $41f2dc2c94660a50$var$KNOWN_POSITIONS = [
    "top",
    "bottom",
    "left",
    "right",
    "chartArea"
];
function $41f2dc2c94660a50$var$positionIsHorizontal(position, axis) {
    return position === "top" || position === "bottom" || $41f2dc2c94660a50$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === "x";
}
function $41f2dc2c94660a50$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $41f2dc2c94660a50$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins("afterRender");
    (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $41f2dc2c94660a50$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $41f2dc2c94660a50$var$getCanvas(item) {
    if ((0, $5ea20a8ea64fa9d9$export$2e2af4578d910ddf)() && typeof item === "string") item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $41f2dc2c94660a50$var$instances = {};
const $41f2dc2c94660a50$var$getChart = (key)=>{
    const canvas = $41f2dc2c94660a50$var$getCanvas(key);
    return Object.values($41f2dc2c94660a50$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $41f2dc2c94660a50$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $41f2dc2c94660a50$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === "mouseout") return null;
    if (isClick) return lastEvent;
    return e;
}
class $41f2dc2c94660a50$export$acaa6426d77a227e {
    constructor(item, userConfig){
        const config = this.config = new $41f2dc2c94660a50$var$Config(userConfig);
        const initialCanvas = $41f2dc2c94660a50$var$getCanvas(item);
        const existingChart = $41f2dc2c94660a50$var$getChart(initialCanvas);
        if (existingChart) throw new Error("Canvas is already in use. Chart with ID '" + existingChart.id + "'" + " must be destroyed before the canvas with ID '" + existingChart.canvas.id + "' can be reused.");
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $41f2dc2c94660a50$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $5ea20a8ea64fa9d9$export$4c3d22f3d993c33f)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $41f2dc2c94660a50$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $5ea20a8ea64fa9d9$export$f787f51d84a910ad)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $41f2dc2c94660a50$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $41f2dc2c94660a50$export$a424a0aa8f687495.listen(this, "complete", $41f2dc2c94660a50$var$onAnimationsComplete);
        $41f2dc2c94660a50$export$a424a0aa8f687495.listen(this, "progress", $41f2dc2c94660a50$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    _initialize() {
        this.notifyPlugins("beforeInit");
        if (this.options.responsive) this.resize();
        else (0, $5ea20a8ea64fa9d9$export$c9170ad7d4cd7e57)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins("afterInit");
        return this;
    }
    clear() {
        (0, $5ea20a8ea64fa9d9$export$ee7c8ad385a60b7b)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $41f2dc2c94660a50$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$41f2dc2c94660a50$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? "resize" : "attach";
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $5ea20a8ea64fa9d9$export$c9170ad7d4cd7e57)(this, newRatio, true)) return;
        this.notifyPlugins("resize", {
            size: newSize
        });
        (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $41f2dc2c94660a50$var$determineAxis(id, scaleOptions);
            const isRadial = axis === "r";
            const isHorizontal = axis === "x";
            return {
                options: scaleOptions,
                dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
                dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
            };
        }));
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $41f2dc2c94660a50$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $41f2dc2c94660a50$var$positionIsHorizontal(scaleOptions.position, axis) !== $41f2dc2c94660a50$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $41f2dc2c94660a50$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(scales, (scale)=>{
            $41f2dc2c94660a50$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $41f2dc2c94660a50$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($41f2dc2c94660a50$var$compare2Level("order", "index"));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $41f2dc2c94660a50$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = "" + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $41f2dc2c94660a50$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass.prototype, {
                    dataElementType: $41f2dc2c94660a50$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $41f2dc2c94660a50$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins("reset");
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins("beforeUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins("beforeElementsUpdate");
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins("afterUpdate", {
            mode: mode
        });
        this._layers.sort($41f2dc2c94660a50$var$compare2Level("z", "_idx"));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(this.scales, (scale)=>{
            $41f2dc2c94660a50$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $5ea20a8ea64fa9d9$export$995eb9fca571757)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === "_removeElements" ? -count : count;
            $41f2dc2c94660a50$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + "," + c.splice(1).join(",")));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $5ea20a8ea64fa9d9$export$995eb9fca571757)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(",")).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins("beforeLayout", {
            cancelable: true
        }) === false) return;
        $41f2dc2c94660a50$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(this.boxes, (box)=>{
            if (noArea && box.position === "chartArea") return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins("afterLayout");
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins("beforeDatasetsUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $5ea20a8ea64fa9d9$export$c3950d9923825c02)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins("afterDatasetsUpdate", {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetUpdate", args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetUpdate", args);
    }
    render() {
        if (this.notifyPlugins("beforeRender", {
            cancelable: true
        }) === false) return;
        if ($41f2dc2c94660a50$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$41f2dc2c94660a50$export$a424a0aa8f687495.running(this)) $41f2dc2c94660a50$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $41f2dc2c94660a50$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins("beforeDraw", {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins("afterDraw");
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins("beforeDatasetsDraw", {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins("afterDatasetsDraw");
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = this.chartArea;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetDraw", args) === false) return;
        if (useClip) (0, $5ea20a8ea64fa9d9$export$61196ced6d74a310)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, $5ea20a8ea64fa9d9$export$a07804094c3ecf2d)(ctx);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetDraw", args);
    }
    isPointInArea(point) {
        return (0, $5ea20a8ea64fa9d9$export$3d8c2f653ac9d0b9)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $41f2dc2c94660a50$export$a13296960cae0384.modes[mode];
        if (typeof method === "function") return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $5ea20a8ea64fa9d9$export$dda1d9f60106f0e9)(null, {
            chart: this,
            type: "chart"
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? "show" : "hide";
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $5ea20a8ea64fa9d9$export$35e795649ee09318)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $41f2dc2c94660a50$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins("beforeDestroy");
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $5ea20a8ea64fa9d9$export$ee7c8ad385a60b7b)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        this.notifyPlugins("destroy");
        delete $41f2dc2c94660a50$var$instances[this.id];
        this.notifyPlugins("afterDestroy");
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove("attach", attached);
            this.attached = true;
            this.resize();
            _add("resize", listener);
            _add("detach", detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove("resize", listener);
            this._stop();
            this._resize(0, 0);
            _add("attach", attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? "set" : "remove";
        let meta, item, i, ilen;
        if (mode === "dataset") {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller["_" + prefix + "DatasetHoverStyle"]();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("No dataset found at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $5ea20a8ea64fa9d9$export$f38c853ae54ed474)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins("beforeEvent", args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins("afterEvent", args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $5ea20a8ea64fa9d9$export$3b513254972cfc9c)(e);
        const lastEvent = $41f2dc2c94660a50$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $5ea20a8ea64fa9d9$export$f38c853ae54ed474)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
const $41f2dc2c94660a50$var$invalidatePlugins = ()=>(0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)($41f2dc2c94660a50$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
const $41f2dc2c94660a50$var$enumerable = true;
Object.defineProperties($41f2dc2c94660a50$export$acaa6426d77a227e, {
    defaults: {
        enumerable: $41f2dc2c94660a50$var$enumerable,
        value: (0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0)
    },
    instances: {
        enumerable: $41f2dc2c94660a50$var$enumerable,
        value: $41f2dc2c94660a50$var$instances
    },
    overrides: {
        enumerable: $41f2dc2c94660a50$var$enumerable,
        value: (0, $5ea20a8ea64fa9d9$export$3a6d5c9ae78a2c08)
    },
    registry: {
        enumerable: $41f2dc2c94660a50$var$enumerable,
        value: $41f2dc2c94660a50$export$4bb7493d241fd8a5
    },
    version: {
        enumerable: $41f2dc2c94660a50$var$enumerable,
        value: $41f2dc2c94660a50$var$version
    },
    getChart: {
        enumerable: $41f2dc2c94660a50$var$enumerable,
        value: $41f2dc2c94660a50$var$getChart
    },
    register: {
        enumerable: $41f2dc2c94660a50$var$enumerable,
        value: (...items)=>{
            $41f2dc2c94660a50$export$4bb7493d241fd8a5.add(...items);
            $41f2dc2c94660a50$var$invalidatePlugins();
        }
    },
    unregister: {
        enumerable: $41f2dc2c94660a50$var$enumerable,
        value: (...items)=>{
            $41f2dc2c94660a50$export$4bb7493d241fd8a5.remove(...items);
            $41f2dc2c94660a50$var$invalidatePlugins();
        }
    }
});
function $41f2dc2c94660a50$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd), startAngle - (0, $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $41f2dc2c94660a50$var$toRadiusCorners(value) {
    return (0, $5ea20a8ea64fa9d9$export$ab83b03e4111b1d0)(value, [
        "outerStart",
        "outerEnd",
        "innerStart",
        "innerEnd"
    ]);
}
function $41f2dc2c94660a50$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $41f2dc2c94660a50$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca)(o.innerEnd, 0, innerLimit)
    };
}
function $41f2dc2c94660a50$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
function $41f2dc2c94660a50$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $5ea20a8ea64fa9d9$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $41f2dc2c94660a50$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerEndAdjustedAngle);
        if (outerEnd > 0) {
            const pCenter = $41f2dc2c94660a50$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd));
        }
        const p4 = $41f2dc2c94660a50$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        if (innerEnd > 0) {
            const pCenter = $41f2dc2c94660a50$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, startAngle + innerStart / innerRadius, true);
        if (innerStart > 0) {
            const pCenter = $41f2dc2c94660a50$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd));
        }
        const p8 = $41f2dc2c94660a50$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        if (outerStart > 0) {
            const pCenter = $41f2dc2c94660a50$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $41f2dc2c94660a50$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $41f2dc2c94660a50$var$pathArc(ctx, element, offset, spacing, startAngle + (0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7), circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) {
            endAngle = startAngle + circumference % (0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7);
            if (circumference % (0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7) === 0) endAngle += (0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7);
        }
    }
    $41f2dc2c94660a50$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $41f2dc2c94660a50$var$drawFullCircleBorders(ctx, element, inner) {
    const { x: x, y: y, startAngle: startAngle, pixelMargin: pixelMargin, fullCircles: fullCircles } = element;
    const outerRadius = Math.max(element.outerRadius - pixelMargin, 0);
    const innerRadius = element.innerRadius + pixelMargin;
    let i;
    if (inner) $41f2dc2c94660a50$var$clipArc(ctx, element, startAngle + (0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7));
    ctx.beginPath();
    ctx.arc(x, y, innerRadius, startAngle + (0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7), startAngle, true);
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle, startAngle + (0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7));
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
}
function $41f2dc2c94660a50$var$drawBorder(ctx, element, offset, spacing, endAngle, circular) {
    const { options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle } = options;
    const inner = options.borderAlign === "inner";
    if (!borderWidth) return;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || "round";
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || "bevel";
    }
    if (element.fullCircles) $41f2dc2c94660a50$var$drawFullCircleBorders(ctx, element, inner);
    if (inner) $41f2dc2c94660a50$var$clipArc(ctx, element, endAngle);
    $41f2dc2c94660a50$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.stroke();
}
class $41f2dc2c94660a50$export$d48203c759d6a1fc extends $41f2dc2c94660a50$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $5ea20a8ea64fa9d9$export$34aec0b863436764)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const rAdjust = this.options.spacing / 2;
        const _circumference = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const betweenAngles = _circumference >= (0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7) || (0, $5ea20a8ea64fa9d9$export$ffb5f4729a158638)(angle, startAngle, endAngle);
        const withinRadius = (0, $5ea20a8ea64fa9d9$export$21579262ef46735b)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            "x",
            "y",
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 2;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === "inner" ? 0.33 : 0;
        this.fullCircles = circumference > (0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        let radiusOffset = 0;
        if (offset) {
            radiusOffset = offset / 2;
            const halfAngle = (this.startAngle + this.endAngle) / 2;
            ctx.translate(Math.cos(halfAngle) * radiusOffset, Math.sin(halfAngle) * radiusOffset);
            if (this.circumference >= (0, $5ea20a8ea64fa9d9$export$56c0d5a1e737357d)) radiusOffset = offset;
        }
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        const endAngle = $41f2dc2c94660a50$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $41f2dc2c94660a50$var$drawBorder(ctx, this, radiusOffset, spacing, endAngle, circular);
        ctx.restore();
    }
}
$41f2dc2c94660a50$export$d48203c759d6a1fc.id = "arc";
$41f2dc2c94660a50$export$d48203c759d6a1fc.defaults = {
    borderAlign: "center",
    borderColor: "#fff",
    borderJoinStyle: undefined,
    borderRadius: 0,
    borderWidth: 2,
    offset: 0,
    spacing: 0,
    angle: undefined,
    circular: true
};
$41f2dc2c94660a50$export$d48203c759d6a1fc.defaultRoutes = {
    backgroundColor: "backgroundColor"
};
function $41f2dc2c94660a50$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $41f2dc2c94660a50$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $41f2dc2c94660a50$var$getLineMethod(options) {
    if (options.stepped) return 0, $5ea20a8ea64fa9d9$export$6554612db691658e;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $5ea20a8ea64fa9d9$export$493d36ec626b6698;
    return $41f2dc2c94660a50$var$lineTo;
}
function $41f2dc2c94660a50$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $41f2dc2c94660a50$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $41f2dc2c94660a50$var$pathVars(points, segment, params);
    const lineMethod = $41f2dc2c94660a50$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $41f2dc2c94660a50$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $41f2dc2c94660a50$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $41f2dc2c94660a50$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
    return useFastPath ? $41f2dc2c94660a50$var$fastPathSegment : $41f2dc2c94660a50$var$pathSegment;
}
function $41f2dc2c94660a50$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $5ea20a8ea64fa9d9$export$2f6ca3d3b1f80bf5;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $5ea20a8ea64fa9d9$export$8a5498727ef6be21;
    return 0, $5ea20a8ea64fa9d9$export$d24c54395ce0c509;
}
function $41f2dc2c94660a50$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $41f2dc2c94660a50$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $41f2dc2c94660a50$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $41f2dc2c94660a50$var$_getSegmentMethod(line);
    for (const segment of segments){
        $41f2dc2c94660a50$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $41f2dc2c94660a50$var$usePath2D = typeof Path2D === "function";
function $41f2dc2c94660a50$var$draw(ctx, line, start, count) {
    if ($41f2dc2c94660a50$var$usePath2D && !line.options.segment) $41f2dc2c94660a50$var$strokePathWithCache(ctx, line, start, count);
    else $41f2dc2c94660a50$var$strokePathDirect(ctx, line, start, count);
}
class $41f2dc2c94660a50$export$55e463fa7bcd3469 extends $41f2dc2c94660a50$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $5ea20a8ea64fa9d9$export$1a82df3d29112e01)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $5ea20a8ea64fa9d9$export$306ddfe3a8403e2)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $5ea20a8ea64fa9d9$export$7a38258bbe170828)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $41f2dc2c94660a50$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $41f2dc2c94660a50$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $41f2dc2c94660a50$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $41f2dc2c94660a50$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
$41f2dc2c94660a50$export$55e463fa7bcd3469.id = "line";
$41f2dc2c94660a50$export$55e463fa7bcd3469.defaults = {
    borderCapStyle: "butt",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 3,
    capBezierPoints: true,
    cubicInterpolationMode: "default",
    fill: false,
    spanGaps: false,
    stepped: false,
    tension: 0
};
$41f2dc2c94660a50$export$55e463fa7bcd3469.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
$41f2dc2c94660a50$export$55e463fa7bcd3469.descriptors = {
    _scriptable: true,
    _indexable: (name)=>name !== "borderDash" && name !== "fill"
};
function $41f2dc2c94660a50$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $41f2dc2c94660a50$export$bd159b522b230b7a extends $41f2dc2c94660a50$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $41f2dc2c94660a50$var$inRange$1(this, mouseX, "x", useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $41f2dc2c94660a50$var$inRange$1(this, mouseY, "y", useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $5ea20a8ea64fa9d9$export$3d8c2f653ac9d0b9)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $5ea20a8ea64fa9d9$export$1fbe638ecf81657e)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        return options.radius + options.hitRadius;
    }
}
$41f2dc2c94660a50$export$bd159b522b230b7a.id = "point";
$41f2dc2c94660a50$export$bd159b522b230b7a.defaults = {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: "circle",
    radius: 3,
    rotation: 0
};
$41f2dc2c94660a50$export$bd159b522b230b7a.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
function $41f2dc2c94660a50$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        "x",
        "y",
        "base",
        "width",
        "height"
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $41f2dc2c94660a50$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca)(value, min, max);
}
function $41f2dc2c94660a50$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $5ea20a8ea64fa9d9$export$92108d983e8ee699)(value);
    return {
        t: $41f2dc2c94660a50$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $41f2dc2c94660a50$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $41f2dc2c94660a50$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $41f2dc2c94660a50$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $41f2dc2c94660a50$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        "enableBorderRadius"
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $5ea20a8ea64fa9d9$export$9fa96a7d116ea3ce)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $41f2dc2c94660a50$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $41f2dc2c94660a50$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $41f2dc2c94660a50$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $41f2dc2c94660a50$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $41f2dc2c94660a50$var$boundingRects(bar) {
    const bounds = $41f2dc2c94660a50$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $41f2dc2c94660a50$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $41f2dc2c94660a50$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $41f2dc2c94660a50$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $41f2dc2c94660a50$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $5ea20a8ea64fa9d9$export$21579262ef46735b)(x, bounds.left, bounds.right)) && (skipY || (0, $5ea20a8ea64fa9d9$export$21579262ef46735b)(y, bounds.top, bounds.bottom));
}
function $41f2dc2c94660a50$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $41f2dc2c94660a50$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $41f2dc2c94660a50$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $41f2dc2c94660a50$export$a16ed71bf4b07672 extends $41f2dc2c94660a50$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $41f2dc2c94660a50$var$boundingRects(this);
        const addRectPath = $41f2dc2c94660a50$var$hasRadius(outer.radius) ? (0, $5ea20a8ea64fa9d9$export$d66dc83d8cfc8dd) : $41f2dc2c94660a50$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $41f2dc2c94660a50$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $41f2dc2c94660a50$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill("evenodd");
        }
        ctx.beginPath();
        addRectPath(ctx, $41f2dc2c94660a50$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $41f2dc2c94660a50$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $41f2dc2c94660a50$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $41f2dc2c94660a50$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            "x",
            "y",
            "base",
            "horizontal"
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === "x" ? this.width / 2 : this.height / 2;
    }
}
$41f2dc2c94660a50$export$a16ed71bf4b07672.id = "bar";
$41f2dc2c94660a50$export$a16ed71bf4b07672.defaults = {
    borderSkipped: "start",
    borderWidth: 0,
    borderRadius: 0,
    inflateAmount: "auto",
    pointStyle: undefined
};
$41f2dc2c94660a50$export$a16ed71bf4b07672.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
var $41f2dc2c94660a50$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $41f2dc2c94660a50$export$d48203c759d6a1fc,
    LineElement: $41f2dc2c94660a50$export$55e463fa7bcd3469,
    PointElement: $41f2dc2c94660a50$export$bd159b522b230b7a,
    BarElement: $41f2dc2c94660a50$export$a16ed71bf4b07672
});
function $41f2dc2c94660a50$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $41f2dc2c94660a50$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(minIndex) && !(0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $41f2dc2c94660a50$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, "data", {
            value: data
        });
    }
}
function $41f2dc2c94660a50$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $41f2dc2c94660a50$var$cleanDecimatedDataset(dataset);
    });
}
function $41f2dc2c94660a50$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca)((0, $5ea20a8ea64fa9d9$export$dc98b0b04f4c7758)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca)((0, $5ea20a8ea64fa9d9$export$dc98b0b04f4c7758)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $41f2dc2c94660a50$export$be17f937e9aa7533 = {
    id: "decimation",
    defaults: {
        algorithm: "min-max",
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $41f2dc2c94660a50$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $5ea20a8ea64fa9d9$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === "y") return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== "linear" && xAxis.type !== "time") return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $41f2dc2c94660a50$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $41f2dc2c94660a50$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, "data", {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case "lttb":
                    decimated = $41f2dc2c94660a50$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case "min-max":
                    decimated = $41f2dc2c94660a50$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $41f2dc2c94660a50$var$cleanDecimatedData(chart);
    }
};
function $41f2dc2c94660a50$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $41f2dc2c94660a50$var$_findSegmentEnd(start, end, points);
        const bounds = $41f2dc2c94660a50$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $5ea20a8ea64fa9d9$export$7a38258bbe170828)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $41f2dc2c94660a50$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $5ea20a8ea64fa9d9$export$28f7fcd39efa255)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $41f2dc2c94660a50$var$_getEdge(bounds, subBounds, "start", Math.max)
                },
                end: {
                    [property]: $41f2dc2c94660a50$var$_getEdge(bounds, subBounds, "end", Math.min)
                }
            });
        }
    }
    return parts;
}
function $41f2dc2c94660a50$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === "angle") {
        start = (0, $5ea20a8ea64fa9d9$export$3d12bd131bb975d1)(start);
        end = (0, $5ea20a8ea64fa9d9$export$3d12bd131bb975d1)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $41f2dc2c94660a50$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $41f2dc2c94660a50$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $41f2dc2c94660a50$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $41f2dc2c94660a50$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $41f2dc2c94660a50$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $41f2dc2c94660a50$var$_pointsFromSegments(boundary, line);
    return points.length ? new $41f2dc2c94660a50$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $41f2dc2c94660a50$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $41f2dc2c94660a50$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $41f2dc2c94660a50$var$_decodeFill(line, index, count) {
    const fill = $41f2dc2c94660a50$var$parseFillOption(line);
    if ((0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $41f2dc2c94660a50$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        "origin",
        "start",
        "end",
        "stack",
        "shape"
    ].indexOf(fill) >= 0 && fill;
}
function $41f2dc2c94660a50$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === "-" || firstCh === "+") target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $41f2dc2c94660a50$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === "start") pixel = scale.bottom;
    else if (fill === "end") pixel = scale.top;
    else if ((0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $41f2dc2c94660a50$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === "start") value = startValue;
    else if (fill === "end") value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $41f2dc2c94660a50$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return "origin";
    return fill;
}
function $41f2dc2c94660a50$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $41f2dc2c94660a50$var$getLinesBelow(scale, index);
    linesBelow.push($41f2dc2c94660a50$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$41f2dc2c94660a50$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $41f2dc2c94660a50$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $41f2dc2c94660a50$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas("line");
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $41f2dc2c94660a50$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $41f2dc2c94660a50$var$findPoint(line, sourcePoint, "x");
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $41f2dc2c94660a50$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $5ea20a8ea64fa9d9$export$21579262ef46735b)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $41f2dc2c94660a50$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $41f2dc2c94660a50$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(fill)) return $41f2dc2c94660a50$var$getLineByIndex(chart, fill);
    if (fill === "stack") return $41f2dc2c94660a50$var$_buildStackLine(source);
    if (fill === "shape") return true;
    const boundary = $41f2dc2c94660a50$var$computeBoundary(source);
    if (boundary instanceof $41f2dc2c94660a50$var$simpleArc) return boundary;
    return $41f2dc2c94660a50$var$_createBoundaryLine(boundary, line);
}
function $41f2dc2c94660a50$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $41f2dc2c94660a50$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $41f2dc2c94660a50$var$computeCircularBoundary(source);
    return $41f2dc2c94660a50$var$computeLinearBoundary(source);
}
function $41f2dc2c94660a50$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $41f2dc2c94660a50$var$_getTargetPixel(fill, scale);
    if ((0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $41f2dc2c94660a50$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $41f2dc2c94660a50$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $41f2dc2c94660a50$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $41f2dc2c94660a50$var$_drawfill(ctx, source, area) {
    const target = $41f2dc2c94660a50$var$_getTarget(source);
    const { line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    if (target && line.points.length) {
        (0, $5ea20a8ea64fa9d9$export$61196ced6d74a310)(ctx, area);
        $41f2dc2c94660a50$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        (0, $5ea20a8ea64fa9d9$export$a07804094c3ecf2d)(ctx);
    }
}
function $41f2dc2c94660a50$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale } = cfg;
    const property = line._loop ? "angle" : cfg.axis;
    ctx.save();
    if (property === "x" && below !== above) {
        $41f2dc2c94660a50$var$clipVertical(ctx, target, area.top);
        $41f2dc2c94660a50$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $41f2dc2c94660a50$var$clipVertical(ctx, target, area.bottom);
    }
    $41f2dc2c94660a50$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $41f2dc2c94660a50$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$41f2dc2c94660a50$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $41f2dc2c94660a50$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale } = cfg;
    const segments = $41f2dc2c94660a50$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $41f2dc2c94660a50$var$clipBounds(ctx, scale, notShape && $41f2dc2c94660a50$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $41f2dc2c94660a50$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $41f2dc2c94660a50$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? "evenodd" : "nonzero");
        ctx.restore();
    }
}
function $41f2dc2c94660a50$var$clipBounds(ctx, scale, bounds) {
    const { top: top, bottom: bottom } = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === "x") {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $41f2dc2c94660a50$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $41f2dc2c94660a50$export$d19ba4d812bed757 = {
    id: "filler",
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $41f2dc2c94660a50$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $41f2dc2c94660a50$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $41f2dc2c94660a50$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === "beforeDraw";
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $41f2dc2c94660a50$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== "beforeDatasetsDraw") return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($41f2dc2c94660a50$var$_shouldApplyFill(source)) $41f2dc2c94660a50$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$41f2dc2c94660a50$var$_shouldApplyFill(source) || options.drawTime !== "beforeDatasetDraw") return;
        $41f2dc2c94660a50$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: "beforeDatasetDraw"
    }
};
const $41f2dc2c94660a50$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $41f2dc2c94660a50$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $41f2dc2c94660a50$var$Legend extends $41f2dc2c94660a50$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $41f2dc2c94660a50$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $5ea20a8ea64fa9d9$export$91c6e00c14e7e6fd)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $5ea20a8ea64fa9d9$export$25ce5a424b770e84)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $5ea20a8ea64fa9d9$export$25ce5a424b770e84)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $5ea20a8ea64fa9d9$export$25ce5a424b770e84)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $5ea20a8ea64fa9d9$export$25ce5a424b770e84)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === "top" || this.options.position === "bottom";
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $5ea20a8ea64fa9d9$export$61196ced6d74a310)(ctx, this);
            this._draw();
            (0, $5ea20a8ea64fa9d9$export$a07804094c3ecf2d)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $5ea20a8ea64fa9d9$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const labelFont = (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(labelOpts.font);
        const { color: fontColor, padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign("left");
        ctx.textBaseline = "middle";
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $41f2dc2c94660a50$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(legendItem.lineCap, "butt");
            ctx.lineDashOffset = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(legendItem.lineJoin, "miter");
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $5ea20a8ea64fa9d9$export$158acd800e1ef08b)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $5ea20a8ea64fa9d9$export$9fa96a7d116ea3ce)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $5ea20a8ea64fa9d9$export$d66dc83d8cfc8dd)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $5ea20a8ea64fa9d9$export$3a1a48c8f6ef640e)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $5ea20a8ea64fa9d9$export$25ce5a424b770e84)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $5ea20a8ea64fa9d9$export$25ce5a424b770e84)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $5ea20a8ea64fa9d9$export$9d398bebfec1c039)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor || fontColor;
            ctx.fillStyle = legendItem.fontColor || fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $5ea20a8ea64fa9d9$export$25ce5a424b770e84)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $5ea20a8ea64fa9d9$export$25ce5a424b770e84)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $5ea20a8ea64fa9d9$export$890c4ad488842ce7)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else cursor.y += lineHeight;
        });
        (0, $5ea20a8ea64fa9d9$export$24baa2b76016ce0e)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(titleOpts.font);
        const titlePadding = (0, $5ea20a8ea64fa9d9$export$3466f893ebf79586)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $5ea20a8ea64fa9d9$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $5ea20a8ea64fa9d9$export$25ce5a424b770e84)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $5ea20a8ea64fa9d9$export$25ce5a424b770e84)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $5ea20a8ea64fa9d9$export$25ce5a424b770e84)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $5ea20a8ea64fa9d9$export$db202ddc8be9136)(position));
        ctx.textBaseline = "middle";
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $5ea20a8ea64fa9d9$export$3a1a48c8f6ef640e)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(titleOpts.font);
        const titlePadding = (0, $5ea20a8ea64fa9d9$export$3466f893ebf79586)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $5ea20a8ea64fa9d9$export$21579262ef46735b)(x, this.left, this.right) && (0, $5ea20a8ea64fa9d9$export$21579262ef46735b)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $5ea20a8ea64fa9d9$export$21579262ef46735b)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $5ea20a8ea64fa9d9$export$21579262ef46735b)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$41f2dc2c94660a50$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === "mousemove" || e.type === "mouseout") {
            const previous = this._hoveredItem;
            const sameItem = $41f2dc2c94660a50$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $41f2dc2c94660a50$var$isListened(type, opts) {
    if ((type === "mousemove" || type === "mouseout") && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === "click" || type === "mouseup")) return true;
    return false;
}
var $41f2dc2c94660a50$export$ed247974535929c7 = {
    id: "legend",
    _element: $41f2dc2c94660a50$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $41f2dc2c94660a50$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $41f2dc2c94660a50$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $41f2dc2c94660a50$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $41f2dc2c94660a50$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $41f2dc2c94660a50$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: "top",
        align: "center",
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $5ea20a8ea64fa9d9$export$3466f893ebf79586)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: 0,
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: "center",
            text: ""
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith("on"),
        labels: {
            _scriptable: (name)=>![
                    "generateLabels",
                    "filter",
                    "sort"
                ].includes(name)
        }
    }
};
class $41f2dc2c94660a50$var$Title extends $41f2dc2c94660a50$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $5ea20a8ea64fa9d9$export$3466f893ebf79586)(opts.padding);
        const textSize = lineCount * (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === "top" || pos === "bottom";
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $5ea20a8ea64fa9d9$export$25ce5a424b770e84)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === "left") {
                titleX = left + offset;
                titleY = (0, $5ea20a8ea64fa9d9$export$25ce5a424b770e84)(align, bottom, top);
                rotation = (0, $5ea20a8ea64fa9d9$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $5ea20a8ea64fa9d9$export$25ce5a424b770e84)(align, top, bottom);
                rotation = (0, $5ea20a8ea64fa9d9$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $5ea20a8ea64fa9d9$export$3a1a48c8f6ef640e)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $5ea20a8ea64fa9d9$export$db202ddc8be9136)(opts.align),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $41f2dc2c94660a50$var$createTitle(chart, titleOpts) {
    const title = new $41f2dc2c94660a50$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $41f2dc2c94660a50$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $41f2dc2c94660a50$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $41f2dc2c94660a50$export$f99233281efd08a0 = {
    id: "title",
    _element: $41f2dc2c94660a50$var$Title,
    start (chart, _args, options) {
        $41f2dc2c94660a50$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $41f2dc2c94660a50$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $41f2dc2c94660a50$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "bold"
        },
        fullSize: true,
        padding: 10,
        position: "top",
        text: "",
        weight: 2000
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $41f2dc2c94660a50$var$map = new WeakMap();
var $41f2dc2c94660a50$export$d5c56664638992a4 = {
    id: "subtitle",
    start (chart, _args, options) {
        const title = new $41f2dc2c94660a50$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $41f2dc2c94660a50$export$1ecca0613f5e56d2.configure(chart, title, options);
        $41f2dc2c94660a50$export$1ecca0613f5e56d2.addBox(chart, title);
        $41f2dc2c94660a50$var$map.set(chart, title);
    },
    stop (chart) {
        $41f2dc2c94660a50$export$1ecca0613f5e56d2.removeBox(chart, $41f2dc2c94660a50$var$map.get(chart));
        $41f2dc2c94660a50$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $41f2dc2c94660a50$var$map.get(chart);
        $41f2dc2c94660a50$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "normal"
        },
        fullSize: true,
        padding: 0,
        position: "top",
        text: "",
        weight: 1500
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $41f2dc2c94660a50$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let x = 0;
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                x += pos.x;
                y += pos.y;
                ++count;
            }
        }
        return {
            x: x / count,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $5ea20a8ea64fa9d9$export$53a70dd1ebbae346)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $41f2dc2c94660a50$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $41f2dc2c94660a50$var$splitNewlines(str) {
    if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
    return str;
}
function $41f2dc2c94660a50$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $41f2dc2c94660a50$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(options.bodyFont);
    const titleFont = (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(options.titleFont);
    const footerFont = (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $5ea20a8ea64fa9d9$export$3466f893ebf79586)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(body, (bodyItem)=>{
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(bodyItem.before, maxLineWidth);
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(bodyItem.lines, maxLineWidth);
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $41f2dc2c94660a50$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return "top";
    else if (y > chart.height - height / 2) return "bottom";
    return "center";
}
function $41f2dc2c94660a50$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === "left" && x + width + caret > chart.width) return true;
    if (xAlign === "right" && x - width - caret < 0) return true;
}
function $41f2dc2c94660a50$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = "center";
    if (yAlign === "center") xAlign = x <= (left + right) / 2 ? "left" : "right";
    else if (x <= width / 2) xAlign = "left";
    else if (x >= chartWidth - width / 2) xAlign = "right";
    if ($41f2dc2c94660a50$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = "center";
    return xAlign;
}
function $41f2dc2c94660a50$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $41f2dc2c94660a50$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $41f2dc2c94660a50$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $41f2dc2c94660a50$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === "right") x -= width;
    else if (xAlign === "center") x -= width / 2;
    return x;
}
function $41f2dc2c94660a50$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === "top") y += paddingAndSize;
    else if (yAlign === "bottom") y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $41f2dc2c94660a50$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $5ea20a8ea64fa9d9$export$9fa96a7d116ea3ce)(cornerRadius);
    let x = $41f2dc2c94660a50$var$alignX(size, xAlign);
    const y = $41f2dc2c94660a50$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === "center") {
        if (xAlign === "left") x += paddingAndSize;
        else if (xAlign === "right") x -= paddingAndSize;
    } else if (xAlign === "left") x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === "right") x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca)(x, 0, chart.width - size.width),
        y: (0, $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca)(y, 0, chart.height - size.height)
    };
}
function $41f2dc2c94660a50$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $5ea20a8ea64fa9d9$export$3466f893ebf79586)(options.padding);
    return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $41f2dc2c94660a50$var$getBeforeAfterBodyLines(callback) {
    return $41f2dc2c94660a50$var$pushOrConcat([], $41f2dc2c94660a50$var$splitNewlines(callback));
}
function $41f2dc2c94660a50$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $5ea20a8ea64fa9d9$export$dda1d9f60106f0e9)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: "tooltip"
    });
}
function $41f2dc2c94660a50$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
class $41f2dc2c94660a50$var$Tooltip extends $41f2dc2c94660a50$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart || config._chart;
        this._chart = this.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $41f2dc2c94660a50$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $41f2dc2c94660a50$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = callbacks.beforeTitle.apply(this, [
            context
        ]);
        const title = callbacks.title.apply(this, [
            context
        ]);
        const afterTitle = callbacks.afterTitle.apply(this, [
            context
        ]);
        let lines = [];
        lines = $41f2dc2c94660a50$var$pushOrConcat(lines, $41f2dc2c94660a50$var$splitNewlines(beforeTitle));
        lines = $41f2dc2c94660a50$var$pushOrConcat(lines, $41f2dc2c94660a50$var$splitNewlines(title));
        lines = $41f2dc2c94660a50$var$pushOrConcat(lines, $41f2dc2c94660a50$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $41f2dc2c94660a50$var$getBeforeAfterBodyLines(options.callbacks.beforeBody.apply(this, [
            tooltipItems
        ]));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $41f2dc2c94660a50$var$overrideCallbacks(callbacks, context);
            $41f2dc2c94660a50$var$pushOrConcat(bodyItem.before, $41f2dc2c94660a50$var$splitNewlines(scoped.beforeLabel.call(this, context)));
            $41f2dc2c94660a50$var$pushOrConcat(bodyItem.lines, scoped.label.call(this, context));
            $41f2dc2c94660a50$var$pushOrConcat(bodyItem.after, $41f2dc2c94660a50$var$splitNewlines(scoped.afterLabel.call(this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $41f2dc2c94660a50$var$getBeforeAfterBodyLines(options.callbacks.afterBody.apply(this, [
            tooltipItems
        ]));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = callbacks.beforeFooter.apply(this, [
            tooltipItems
        ]);
        const footer = callbacks.footer.apply(this, [
            tooltipItems
        ]);
        const afterFooter = callbacks.afterFooter.apply(this, [
            tooltipItems
        ]);
        let lines = [];
        lines = $41f2dc2c94660a50$var$pushOrConcat(lines, $41f2dc2c94660a50$var$splitNewlines(beforeFooter));
        lines = $41f2dc2c94660a50$var$pushOrConcat(lines, $41f2dc2c94660a50$var$splitNewlines(footer));
        lines = $41f2dc2c94660a50$var$pushOrConcat(lines, $41f2dc2c94660a50$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($41f2dc2c94660a50$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(tooltipItems, (context)=>{
            const scoped = $41f2dc2c94660a50$var$overrideCallbacks(options.callbacks, context);
            labelColors.push(scoped.labelColor.call(this, context));
            labelPointStyles.push(scoped.labelPointStyle.call(this, context));
            labelTextColors.push(scoped.labelTextColor.call(this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $41f2dc2c94660a50$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $41f2dc2c94660a50$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $41f2dc2c94660a50$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $41f2dc2c94660a50$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $5ea20a8ea64fa9d9$export$9fa96a7d116ea3ce)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === "center") {
            y2 = ptY + height / 2;
            if (xAlign === "left") {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === "left") x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === "right") x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === "top") {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $5ea20a8ea64fa9d9$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $41f2dc2c94660a50$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = "middle";
            titleFont = (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColors = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(options.bodyFont);
        const colorX = $41f2dc2c94660a50$var$getAlignedX(this, "left", options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $5ea20a8ea64fa9d9$export$1fbe638ecf81657e)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColors.borderColor;
            ctx.fillStyle = labelColors.backgroundColor;
            (0, $5ea20a8ea64fa9d9$export$1fbe638ecf81657e)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(labelColors.borderWidth) ? Math.max(...Object.values(labelColors.borderWidth)) : labelColors.borderWidth || 1;
            ctx.strokeStyle = labelColors.borderColor;
            ctx.setLineDash(labelColors.borderDash || []);
            ctx.lineDashOffset = labelColors.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth - boxPadding);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - boxPadding - 2);
            const borderRadius = (0, $5ea20a8ea64fa9d9$export$9fa96a7d116ea3ce)(labelColors.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $5ea20a8ea64fa9d9$export$d66dc83d8cfc8dd)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.beginPath();
                (0, $5ea20a8ea64fa9d9$export$d66dc83d8cfc8dd)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $5ea20a8ea64fa9d9$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = "middle";
        ctx.font = bodyFont.string;
        pt.x = $41f2dc2c94660a50$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $5ea20a8ea64fa9d9$export$3722cfe417b6ed86)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $5ea20a8ea64fa9d9$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $41f2dc2c94660a50$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = "middle";
            footerFont = (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $5ea20a8ea64fa9d9$export$9fa96a7d116ea3ce)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === "top") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === "bottom") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $41f2dc2c94660a50$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $41f2dc2c94660a50$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $41f2dc2c94660a50$var$determineAlignment(chart, options, positionAndSize);
            const point = $41f2dc2c94660a50$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $5ea20a8ea64fa9d9$export$3466f893ebf79586)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $5ea20a8ea64fa9d9$export$9d398bebfec1c039)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $5ea20a8ea64fa9d9$export$24baa2b76016ce0e)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("Cannot find a dataset at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $5ea20a8ea64fa9d9$export$f38c853ae54ed474)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $5ea20a8ea64fa9d9$export$f38c853ae54ed474)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $41f2dc2c94660a50$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
$41f2dc2c94660a50$var$Tooltip.positioners = $41f2dc2c94660a50$var$positioners;
var $41f2dc2c94660a50$export$28c660c63b792dea = {
    id: "tooltip",
    _element: $41f2dc2c94660a50$var$Tooltip,
    positioners: $41f2dc2c94660a50$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $41f2dc2c94660a50$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins("beforeTooltipDraw", args) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins("afterTooltipDraw", args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: "average",
        backgroundColor: "rgba(0,0,0,0.8)",
        titleColor: "#fff",
        titleFont: {
            weight: "bold"
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: "left",
        bodyColor: "#fff",
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: "left",
        footerColor: "#fff",
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: "bold"
        },
        footerAlign: "left",
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: "#fff",
        displayColors: true,
        boxPadding: 0,
        borderColor: "rgba(0,0,0,0)",
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: "easeOutQuart"
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "width",
                    "height",
                    "caretX",
                    "caretY"
                ]
            },
            opacity: {
                easing: "linear",
                duration: 200
            }
        },
        callbacks: {
            beforeTitle: (0, $5ea20a8ea64fa9d9$export$cf2f7c5792f80b46),
            title (tooltipItems) {
                if (tooltipItems.length > 0) {
                    const item = tooltipItems[0];
                    const labels = item.chart.data.labels;
                    const labelCount = labels ? labels.length : 0;
                    if (this && this.options && this.options.mode === "dataset") return item.dataset.label || "";
                    else if (item.label) return item.label;
                    else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
                }
                return "";
            },
            afterTitle: (0, $5ea20a8ea64fa9d9$export$cf2f7c5792f80b46),
            beforeBody: (0, $5ea20a8ea64fa9d9$export$cf2f7c5792f80b46),
            beforeLabel: (0, $5ea20a8ea64fa9d9$export$cf2f7c5792f80b46),
            label (tooltipItem) {
                if (this && this.options && this.options.mode === "dataset") return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
                let label = tooltipItem.dataset.label || "";
                if (label) label += ": ";
                const value = tooltipItem.formattedValue;
                if (!(0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(value)) label += value;
                return label;
            },
            labelColor (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    borderColor: options.borderColor,
                    backgroundColor: options.backgroundColor,
                    borderWidth: options.borderWidth,
                    borderDash: options.borderDash,
                    borderDashOffset: options.borderDashOffset,
                    borderRadius: 0
                };
            },
            labelTextColor () {
                return this.options.bodyColor;
            },
            labelPointStyle (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    pointStyle: options.pointStyle,
                    rotation: options.rotation
                };
            },
            afterLabel: (0, $5ea20a8ea64fa9d9$export$cf2f7c5792f80b46),
            afterBody: (0, $5ea20a8ea64fa9d9$export$cf2f7c5792f80b46),
            beforeFooter: (0, $5ea20a8ea64fa9d9$export$cf2f7c5792f80b46),
            footer: (0, $5ea20a8ea64fa9d9$export$cf2f7c5792f80b46),
            afterFooter: (0, $5ea20a8ea64fa9d9$export$cf2f7c5792f80b46)
        }
    },
    defaultRoutes: {
        bodyFont: "font",
        footerFont: "font",
        titleFont: "font"
    },
    descriptors: {
        _scriptable: (name)=>name !== "filter" && name !== "itemSort" && name !== "external",
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: "animation"
        }
    },
    additionalOptionScopes: [
        "interaction"
    ]
};
var $41f2dc2c94660a50$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Decimation: $41f2dc2c94660a50$export$be17f937e9aa7533,
    Filler: $41f2dc2c94660a50$export$d19ba4d812bed757,
    Legend: $41f2dc2c94660a50$export$ed247974535929c7,
    SubTitle: $41f2dc2c94660a50$export$d5c56664638992a4,
    Title: $41f2dc2c94660a50$export$f99233281efd08a0,
    Tooltip: $41f2dc2c94660a50$export$28c660c63b792dea
});
const $41f2dc2c94660a50$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === "string") {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $41f2dc2c94660a50$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $41f2dc2c94660a50$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $41f2dc2c94660a50$var$validIndex = (index, max)=>index === null ? null : (0, $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca)(Math.round(index), 0, max);
class $41f2dc2c94660a50$export$29e663ba4d09fe7 extends $41f2dc2c94660a50$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $41f2dc2c94660a50$var$findOrAddLabel(labels, raw, (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $41f2dc2c94660a50$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === "ticks") {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        const labels = this.getLabels();
        if (value >= 0 && value < labels.length) return labels[value];
        return value;
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== "number") value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
$41f2dc2c94660a50$export$29e663ba4d09fe7.id = "category";
$41f2dc2c94660a50$export$29e663ba4d09fe7.defaults = {
    ticks: {
        callback: $41f2dc2c94660a50$export$29e663ba4d09fe7.prototype.getLabelForValue
    }
};
function $41f2dc2c94660a50$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $5ea20a8ea64fa9d9$export$b9a6b53f9be3734)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $5ea20a8ea64fa9d9$export$b9a6b53f9be3734)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === "ticks") {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $5ea20a8ea64fa9d9$export$a05254e7c3aeba6e)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $5ea20a8ea64fa9d9$export$23ebac1979863676)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $5ea20a8ea64fa9d9$export$91477dc880baac21)(spacing), (0, $5ea20a8ea64fa9d9$export$91477dc880baac21)(niceMin));
    factor = Math.pow(10, (0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $5ea20a8ea64fa9d9$export$23ebac1979863676)(Math.round((niceMin + j * spacing) * factor) / factor, min, $41f2dc2c94660a50$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j)ticks.push({
        value: Math.round((niceMin + j * spacing) * factor) / factor
    });
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $5ea20a8ea64fa9d9$export$23ebac1979863676)(ticks[ticks.length - 1].value, max, $41f2dc2c94660a50$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $41f2dc2c94660a50$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $5ea20a8ea64fa9d9$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ("" + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $41f2dc2c94660a50$var$LinearScaleBase extends $41f2dc2c94660a50$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $5ea20a8ea64fa9d9$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $5ea20a8ea64fa9d9$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = 1;
            if (max >= Number.MAX_SAFE_INTEGER || min <= Number.MIN_SAFE_INTEGER) offset = Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $41f2dc2c94660a50$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === "ticks") (0, $5ea20a8ea64fa9d9$export$a33b77bbdbb8366c)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $5ea20a8ea64fa9d9$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $41f2dc2c94660a50$export$e7f4e5e8656f0b93 extends $41f2dc2c94660a50$var$LinearScaleBase {
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $5ea20a8ea64fa9d9$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
$41f2dc2c94660a50$export$e7f4e5e8656f0b93.id = "linear";
$41f2dc2c94660a50$export$e7f4e5e8656f0b93.defaults = {
    ticks: {
        callback: $41f2dc2c94660a50$export$27c7467594ef87bd.formatters.numeric
    }
};
function $41f2dc2c94660a50$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, Math.floor((0, $5ea20a8ea64fa9d9$export$df995fae86a55f06)(tickVal)));
    return remain === 1;
}
function $41f2dc2c94660a50$var$generateTicks(generationOptions, dataRange) {
    const endExp = Math.floor((0, $5ea20a8ea64fa9d9$export$df995fae86a55f06)(dataRange.max));
    const endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
    const ticks = [];
    let tickVal = (0, $5ea20a8ea64fa9d9$export$ef35774e6d314e91)(generationOptions.min, Math.pow(10, Math.floor((0, $5ea20a8ea64fa9d9$export$df995fae86a55f06)(dataRange.min))));
    let exp = Math.floor((0, $5ea20a8ea64fa9d9$export$df995fae86a55f06)(tickVal));
    let significand = Math.floor(tickVal / Math.pow(10, exp));
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    do {
        ticks.push({
            value: tickVal,
            major: $41f2dc2c94660a50$var$isMajor(tickVal)
        });
        ++significand;
        if (significand === 10) {
            significand = 1;
            ++exp;
            precision = exp >= 0 ? 1 : precision;
        }
        tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
    }while (exp < endExp || exp === endExp && significand < endSignificand);
    const lastTick = (0, $5ea20a8ea64fa9d9$export$ef35774e6d314e91)(generationOptions.max, tickVal);
    ticks.push({
        value: lastTick,
        major: $41f2dc2c94660a50$var$isMajor(tickVal)
    });
    return ticks;
}
class $41f2dc2c94660a50$export$85295eaf7cb3ac3e extends $41f2dc2c94660a50$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $41f2dc2c94660a50$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        const exp = (v, m)=>Math.pow(10, Math.floor((0, $5ea20a8ea64fa9d9$export$df995fae86a55f06)(v)) + m);
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin(exp(min, -1));
                setMax(exp(max, 1));
            }
        }
        if (min <= 0) setMin(exp(max, -1));
        if (max <= 0) setMax(exp(min, 1));
        if (this._zero && this.min !== this._suggestedMin && min === exp(this.min, 0)) setMin(exp(min, -1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $41f2dc2c94660a50$var$generateTicks(generationOptions, this);
        if (opts.bounds === "ticks") (0, $5ea20a8ea64fa9d9$export$a33b77bbdbb8366c)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? "0" : (0, $5ea20a8ea64fa9d9$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $5ea20a8ea64fa9d9$export$df995fae86a55f06)(start);
        this._valueRange = (0, $5ea20a8ea64fa9d9$export$df995fae86a55f06)(this.max) - (0, $5ea20a8ea64fa9d9$export$df995fae86a55f06)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $5ea20a8ea64fa9d9$export$df995fae86a55f06)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
$41f2dc2c94660a50$export$85295eaf7cb3ac3e.id = "logarithmic";
$41f2dc2c94660a50$export$85295eaf7cb3ac3e.defaults = {
    ticks: {
        callback: $41f2dc2c94660a50$export$27c7467594ef87bd.formatters.logarithmic,
        major: {
            enabled: true
        }
    }
};
function $41f2dc2c94660a50$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $5ea20a8ea64fa9d9$export$3466f893ebf79586)(tickOpts.backdropPadding);
        return (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $5ea20a8ea64fa9d9$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $41f2dc2c94660a50$var$measureLabelSize(ctx, font, label) {
    label = (0, $5ea20a8ea64fa9d9$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $5ea20a8ea64fa9d9$export$9f4f30ee63539e24)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $41f2dc2c94660a50$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $41f2dc2c94660a50$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $5ea20a8ea64fa9d9$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(opts.font);
        const textSize = $41f2dc2c94660a50$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $5ea20a8ea64fa9d9$export$3d12bd131bb975d1)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $5ea20a8ea64fa9d9$export$d66501df72047452)(angleRadians));
        const hLimits = $41f2dc2c94660a50$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $41f2dc2c94660a50$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $41f2dc2c94660a50$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $41f2dc2c94660a50$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $41f2dc2c94660a50$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $41f2dc2c94660a50$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const extra = $41f2dc2c94660a50$var$getTickBackdropHeight(opts) / 2;
    const outerDistance = scale.drawingArea;
    const additionalAngle = opts.pointLabels.centerPointLabels ? (0, $5ea20a8ea64fa9d9$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + padding[i], additionalAngle);
        const angle = Math.round((0, $5ea20a8ea64fa9d9$export$d66501df72047452)((0, $5ea20a8ea64fa9d9$export$3d12bd131bb975d1)(pointLabelPosition.angle + (0, $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd))));
        const size = labelSizes[i];
        const y = $41f2dc2c94660a50$var$yForAngle(pointLabelPosition.y, size.h, angle);
        const textAlign = $41f2dc2c94660a50$var$getTextAlignForAngle(angle);
        const left = $41f2dc2c94660a50$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
        items.push({
            x: pointLabelPosition.x,
            y: y,
            textAlign: textAlign,
            left: left,
            top: y,
            right: left + size.w,
            bottom: y + size.h
        });
    }
    return items;
}
function $41f2dc2c94660a50$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return "center";
    else if (angle < 180) return "left";
    return "right";
}
function $41f2dc2c94660a50$var$leftForTextAlign(x, w, align) {
    if (align === "right") x -= w;
    else if (align === "center") x -= w / 2;
    return x;
}
function $41f2dc2c94660a50$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $41f2dc2c94660a50$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        const plFont = (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign, left: left, top: top, right: right, bottom: bottom } = scale._pointLabelItems[i];
        const { backdropColor: backdropColor } = optsAtIndex;
        if (!(0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(backdropColor)) {
            const borderRadius = (0, $5ea20a8ea64fa9d9$export$9fa96a7d116ea3ce)(optsAtIndex.borderRadius);
            const padding = (0, $5ea20a8ea64fa9d9$export$3466f893ebf79586)(optsAtIndex.backdropPadding);
            ctx.fillStyle = backdropColor;
            const backdropLeft = left - padding.left;
            const backdropTop = top - padding.top;
            const backdropWidth = right - left + padding.width;
            const backdropHeight = bottom - top + padding.height;
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                (0, $5ea20a8ea64fa9d9$export$d66dc83d8cfc8dd)(ctx, {
                    x: backdropLeft,
                    y: backdropTop,
                    w: backdropWidth,
                    h: backdropHeight,
                    radius: borderRadius
                });
                ctx.fill();
            } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
        }
        (0, $5ea20a8ea64fa9d9$export$3a1a48c8f6ef640e)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: "middle"
        });
    }
}
function $41f2dc2c94660a50$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $41f2dc2c94660a50$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(gridLineOpts.borderDash);
    ctx.lineDashOffset = gridLineOpts.borderDashOffset;
    ctx.beginPath();
    $41f2dc2c94660a50$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $41f2dc2c94660a50$var$createPointLabelContext(parent, index, label) {
    return (0, $5ea20a8ea64fa9d9$export$dda1d9f60106f0e9)(parent, {
        label: label,
        index: index,
        type: "pointLabel"
    });
}
class $41f2dc2c94660a50$export$cfafc36d95386d38 extends $41f2dc2c94660a50$var$LinearScaleBase {
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $5ea20a8ea64fa9d9$export$3466f893ebf79586)($41f2dc2c94660a50$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $41f2dc2c94660a50$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $41f2dc2c94660a50$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : "";
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $41f2dc2c94660a50$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $5ea20a8ea64fa9d9$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $5ea20a8ea64fa9d9$export$3d12bd131bb975d1)(index * angleMultiplier + (0, $5ea20a8ea64fa9d9$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $41f2dc2c94660a50$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $5ea20a8ea64fa9d9$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $41f2dc2c94660a50$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $41f2dc2c94660a50$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const optsAtIndex = grid.setContext(this.getContext(index - 1));
                $41f2dc2c94660a50$var$drawRadiusLine(this, optsAtIndex, offset, labelCount);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $5ea20a8ea64fa9d9$export$c4ce752e73470fba)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $5ea20a8ea64fa9d9$export$3466f893ebf79586)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $5ea20a8ea64fa9d9$export$3a1a48c8f6ef640e)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
$41f2dc2c94660a50$export$cfafc36d95386d38.id = "radialLinear";
$41f2dc2c94660a50$export$cfafc36d95386d38.defaults = {
    display: true,
    animate: true,
    position: "chartArea",
    angleLines: {
        display: true,
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
    },
    grid: {
        circular: false
    },
    startAngle: 0,
    ticks: {
        showLabelBackdrop: true,
        callback: $41f2dc2c94660a50$export$27c7467594ef87bd.formatters.numeric
    },
    pointLabels: {
        backdropColor: undefined,
        backdropPadding: 2,
        display: true,
        font: {
            size: 10
        },
        callback (label) {
            return label;
        },
        padding: 5,
        centerPointLabels: false
    }
};
$41f2dc2c94660a50$export$cfafc36d95386d38.defaultRoutes = {
    "angleLines.color": "borderColor",
    "pointLabels.color": "color",
    "ticks.color": "color"
};
$41f2dc2c94660a50$export$cfafc36d95386d38.descriptors = {
    angleLines: {
        _fallback: "grid"
    }
};
const $41f2dc2c94660a50$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $41f2dc2c94660a50$var$UNITS = Object.keys($41f2dc2c94660a50$var$INTERVALS);
function $41f2dc2c94660a50$var$sorter(a, b) {
    return a - b;
}
function $41f2dc2c94660a50$var$parse(scale, input) {
    if ((0, $5ea20a8ea64fa9d9$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === "function") value = parser(value);
    if (!(0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(value)) value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === "week" && ((0, $5ea20a8ea64fa9d9$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $41f2dc2c94660a50$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $41f2dc2c94660a50$var$UNITS.length;
    for(let i = $41f2dc2c94660a50$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $41f2dc2c94660a50$var$INTERVALS[$41f2dc2c94660a50$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $41f2dc2c94660a50$var$UNITS[i];
    }
    return $41f2dc2c94660a50$var$UNITS[ilen - 1];
}
function $41f2dc2c94660a50$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $41f2dc2c94660a50$var$UNITS.length - 1; i >= $41f2dc2c94660a50$var$UNITS.indexOf(minUnit); i--){
        const unit = $41f2dc2c94660a50$var$UNITS[i];
        if ($41f2dc2c94660a50$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $41f2dc2c94660a50$var$UNITS[minUnit ? $41f2dc2c94660a50$var$UNITS.indexOf(minUnit) : 0];
}
function $41f2dc2c94660a50$var$determineMajorUnit(unit) {
    for(let i = $41f2dc2c94660a50$var$UNITS.indexOf(unit) + 1, ilen = $41f2dc2c94660a50$var$UNITS.length; i < ilen; ++i){
        if ($41f2dc2c94660a50$var$INTERVALS[$41f2dc2c94660a50$var$UNITS[i]].common) return $41f2dc2c94660a50$var$UNITS[i];
    }
}
function $41f2dc2c94660a50$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $5ea20a8ea64fa9d9$export$c03999cb2f36933f)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $41f2dc2c94660a50$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $41f2dc2c94660a50$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $41f2dc2c94660a50$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $41f2dc2c94660a50$export$a894c72689ff3ec extends $41f2dc2c94660a50$export$d60cfc58d3c358b6 {
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = "day";
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $41f2dc2c94660a50$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $5ea20a8ea64fa9d9$export$2219238a014317b0)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $41f2dc2c94660a50$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || "day";
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== "ticks" || options.ticks.source !== "labels") _applyBounds(this.getMinMax(false));
        }
        min = (0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $5ea20a8ea64fa9d9$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === "labels" ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === "ticks" && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $5ea20a8ea64fa9d9$export$faec65b429be379)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $41f2dc2c94660a50$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $41f2dc2c94660a50$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === "year" ? undefined : $41f2dc2c94660a50$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $41f2dc2c94660a50$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca)(start, 0, limit);
        end = (0, $5ea20a8ea64fa9d9$export$a9c23c6ac3fc3eca)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $41f2dc2c94660a50$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $5ea20a8ea64fa9d9$export$90a7f3efeed30595)(timeOpts.stepSize, 1);
        const weekday = minor === "week" ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $5ea20a8ea64fa9d9$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, "isoWeek", weekday);
        first = +adapter.startOf(first, hasWeekday ? "day" : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor);
        const timestamps = options.ticks.source === "data" && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$41f2dc2c94660a50$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === "ticks" || count === 1) $41f2dc2c94660a50$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort((a, b)=>a - b).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        const label = this._adapter.format(time, format || (major ? majorFormat : minorFormat));
        const formatter = options.ticks.callback;
        return formatter ? (0, $5ea20a8ea64fa9d9$export$e7094788287c5e9b)(formatter, [
            label,
            index,
            ticks
        ], this) : label;
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $5ea20a8ea64fa9d9$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $41f2dc2c94660a50$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($41f2dc2c94660a50$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $5ea20a8ea64fa9d9$export$71511d61b312f219)(values.sort($41f2dc2c94660a50$var$sorter));
    }
}
$41f2dc2c94660a50$export$a894c72689ff3ec.id = "time";
$41f2dc2c94660a50$export$a894c72689ff3ec.defaults = {
    bounds: "data",
    adapters: {},
    time: {
        parser: false,
        unit: false,
        round: false,
        isoWeekday: false,
        minUnit: "millisecond",
        displayFormats: {}
    },
    ticks: {
        source: "auto",
        major: {
            enabled: false
        }
    }
};
function $41f2dc2c94660a50$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $5ea20a8ea64fa9d9$export$dc98b0b04f4c7758)(table, "pos", val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $5ea20a8ea64fa9d9$export$dc98b0b04f4c7758)(table, "time", val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $41f2dc2c94660a50$export$85df64a8eb6dc986 extends $41f2dc2c94660a50$export$a894c72689ff3ec {
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $41f2dc2c94660a50$var$interpolate(table, this.min);
        this._tableRange = $41f2dc2c94660a50$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($41f2dc2c94660a50$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $41f2dc2c94660a50$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
$41f2dc2c94660a50$export$85df64a8eb6dc986.id = "timeseries";
$41f2dc2c94660a50$export$85df64a8eb6dc986.defaults = $41f2dc2c94660a50$export$a894c72689ff3ec.defaults;
var $41f2dc2c94660a50$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $41f2dc2c94660a50$export$29e663ba4d09fe7,
    LinearScale: $41f2dc2c94660a50$export$e7f4e5e8656f0b93,
    LogarithmicScale: $41f2dc2c94660a50$export$85295eaf7cb3ac3e,
    RadialLinearScale: $41f2dc2c94660a50$export$cfafc36d95386d38,
    TimeScale: $41f2dc2c94660a50$export$a894c72689ff3ec,
    TimeSeriesScale: $41f2dc2c94660a50$export$85df64a8eb6dc986
});
const $41f2dc2c94660a50$export$e8959e79e3af550f = [
    $41f2dc2c94660a50$export$a6506504f799c5d5,
    $41f2dc2c94660a50$export$7a5d735b2ab6389d,
    $41f2dc2c94660a50$export$8b3ca321c77fdea6,
    $41f2dc2c94660a50$export$bcac1c16f1530ec2
];



var $bh6RR = parcelRequire("bh6RR");

const $2ad20ccd62d19c94$var$defaultDatasetIdKey = "label";
function $2ad20ccd62d19c94$var$reforwardRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $2ad20ccd62d19c94$var$setOptions(chart, nextOptions) {
    Object.assign(chart.options, nextOptions);
}
function $2ad20ccd62d19c94$var$setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function $2ad20ccd62d19c94$var$setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $2ad20ccd62d19c94$var$defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) return {
            ...nextDataset
        };
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function $2ad20ccd62d19c94$var$cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2ad20ccd62d19c94$var$defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    $2ad20ccd62d19c94$var$setLabels(nextData, data.labels);
    $2ad20ccd62d19c94$var$setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $2ad20ccd62d19c94$export$b2390aa6eb9120be(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "dataset", {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $2ad20ccd62d19c94$export$7786cd514625a1ff(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "nearest", {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $2ad20ccd62d19c94$export$6e8ebb3a5733e348(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "index", {
        intersect: true
    }, false);
}
function $2ad20ccd62d19c94$var$ChartComponent(param, ref) {
    let { height: height = 150, width: width = 300, redraw: redraw = false, datasetIdKey: datasetIdKey, type: type, data: data, options: options, plugins: plugins = [], fallbackContent: fallbackContent, updateMode: updateMode, ...props } = param;
    const canvasRef = (0, $bh6RR.useRef)(null);
    const chartRef = (0, $bh6RR.useRef)();
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new (0, $41f2dc2c94660a50$export$acaa6426d77a227e)(canvasRef.current, {
            type: type,
            data: $2ad20ccd62d19c94$var$cloneData(data, datasetIdKey),
            options: options && {
                ...options
            },
            plugins: plugins
        });
        $2ad20ccd62d19c94$var$reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        $2ad20ccd62d19c94$var$reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        if (!redraw && chartRef.current && options) $2ad20ccd62d19c94$var$setOptions(chartRef.current, options);
    }, [
        redraw,
        options
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (!redraw && chartRef.current) $2ad20ccd62d19c94$var$setLabels(chartRef.current.config.data, data.labels);
    }, [
        redraw,
        data.labels
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) $2ad20ccd62d19c94$var$setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }, [
        redraw,
        data.datasets
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else chartRef.current.update(updateMode);
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0, $bh6RR.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("canvas", Object.assign({
        ref: canvasRef,
        role: "img",
        height: height,
        width: width
    }, props), fallbackContent);
}
const $2ad20ccd62d19c94$export$acaa6426d77a227e = /*#__PURE__*/ (0, $bh6RR.forwardRef)($2ad20ccd62d19c94$var$ChartComponent);
function $2ad20ccd62d19c94$var$createTypedChart(type, registerables) {
    (0, $41f2dc2c94660a50$export$acaa6426d77a227e).register(registerables);
    return /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($2ad20ccd62d19c94$export$acaa6426d77a227e, Object.assign({}, props, {
            ref: ref,
            type: type
        })));
}
const $2ad20ccd62d19c94$export$17d680238e50603e = /* #__PURE__ */ $2ad20ccd62d19c94$var$createTypedChart("line", (0, $41f2dc2c94660a50$export$3c9b5d28c11cbfd0));
const $2ad20ccd62d19c94$export$bbc6c6369b38e3d1 = /* #__PURE__ */ $2ad20ccd62d19c94$var$createTypedChart("bar", (0, $41f2dc2c94660a50$export$e97d5dc64e999004));
const $2ad20ccd62d19c94$export$bace472c466fdd25 = /* #__PURE__ */ $2ad20ccd62d19c94$var$createTypedChart("radar", (0, $41f2dc2c94660a50$export$48dbc6ac651bf8be));
const $2ad20ccd62d19c94$export$b8b3cfdc3fe36b10 = /* #__PURE__ */ $2ad20ccd62d19c94$var$createTypedChart("doughnut", (0, $41f2dc2c94660a50$export$e04603e7d8b77172));
const $2ad20ccd62d19c94$export$d0dcaac1fc41ea1e = /* #__PURE__ */ $2ad20ccd62d19c94$var$createTypedChart("polarArea", (0, $41f2dc2c94660a50$export$2a270b3a0d973c85));
const $2ad20ccd62d19c94$export$646feb54fbadbe06 = /* #__PURE__ */ $2ad20ccd62d19c94$var$createTypedChart("bubble", (0, $41f2dc2c94660a50$export$19b5c4773f17abe));
const $2ad20ccd62d19c94$export$2ae8800cf67c848c = /* #__PURE__ */ $2ad20ccd62d19c94$var$createTypedChart("pie", (0, $41f2dc2c94660a50$export$b21a3f1286706191));
const $2ad20ccd62d19c94$export$1c460fb4285edadc = /* #__PURE__ */ $2ad20ccd62d19c94$var$createTypedChart("scatter", (0, $41f2dc2c94660a50$export$b2f2bae6713db87));



(0, $41f2dc2c94660a50$export$acaa6426d77a227e).register(...(0, $41f2dc2c94660a50$export$e8959e79e3af550f));
const $c9128199630b9c58$var$StatementStatisticsGraph = ({ column: column, allColumns: allColumns, datasetName: datasetName })=>{
    const { getDataset: getDataset } = (0, $cef77ca5b38a78fa$export$2e2bcd8739ae039);
    const [rows, setRows] = (0, $bh6RR.useState)([]);
    const [chartType, setChartType] = (0, $bh6RR.useState)("bar");
    const [activeFilters, setActiveFilters] = (0, $bh6RR.useState)({});
    const [showFilters, setShowFilters] = (0, $bh6RR.useState)(false);
    (0, $bh6RR.useEffect)(()=>{
        if (!column) return;
        setActiveFilters({});
        getDataset(decodeURI(datasetName), {}).then((result)=>{
            if (result?.[0]?.data) setRows(result[0].data);
        });
    }, [
        column
    ]);
    if (!column) return null;
    const filteredRows = Object.keys(activeFilters).length > 0 ? rows.filter((row)=>Object.entries(activeFilters).every(([colId, val])=>String(row[colId]) === String(val))) : rows;
    const counts = {};
    filteredRows.forEach((row)=>{
        const val = row[column.id];
        if (val == null || val === "") return;
        counts[String(val)] = (counts[String(val)] || 0) + 1;
    });
    const sortedEntries = Object.entries(counts).sort((a, b)=>b[1] - a[1]);
    const labels = sortedEntries.map(([k])=>k != null && k !== "" ? k : "NULL");
    const values = sortedEntries.map(([, v])=>v);
    const bestValue = sortedEntries[0]?.[0] != null && sortedEntries[0]?.[0] !== "" ? sortedEntries[0][0] : "NULL";
    const lowestValue = sortedEntries[sortedEntries.length - 1]?.[0] != null && sortedEntries[sortedEntries.length - 1]?.[0] !== "" ? sortedEntries[sortedEntries.length - 1][0] : "NULL";
    const bestCount = sortedEntries[0]?.[1] ?? 0;
    const lowestCount = sortedEntries[sortedEntries.length - 1]?.[1] ?? 0;
    const numericValues = rows.map((r)=>parseFloat(r[column.id])).filter((v)=>!isNaN(v));
    const avg = numericValues.length ? (numericValues.reduce((a, b)=>a + b, 0) / numericValues.length).toFixed(2) : null;
    const sorted = [
        ...numericValues
    ].sort((a, b)=>a - b);
    const median = sorted.length ? sorted[Math.floor(sorted.length / 2)] : null;
    const q1 = sorted.length ? sorted[Math.floor(sorted.length * 0.25)] : null;
    const q2 = sorted.length ? sorted[Math.floor(sorted.length * 0.5)] : null;
    const q3 = sorted.length ? sorted[Math.floor(sorted.length * 0.75)] : null;
    const q4 = sorted.length ? sorted[sorted.length - 1] : null;
    const TOP_N = 4;
    const sortedAll = Object.entries(counts).sort((a, b)=>b[1] - a[1]);
    const topEntries = sortedAll.slice(0, TOP_N);
    const otherSum = sortedAll.slice(TOP_N).reduce((acc, [, v])=>acc + v, 0);
    const pieLabels = [
        ...topEntries.map(([k])=>k != null && k !== "" ? k : "NULL"),
        ...otherSum > 0 ? [
            "Other"
        ] : []
    ];
    const pieValues = [
        ...topEntries.map(([, v])=>v),
        ...otherSum > 0 ? [
            otherSum
        ] : []
    ];
    const pieData = {
        labels: pieLabels,
        datasets: [
            {
                data: pieValues,
                backgroundColor: [
                    "#36a2eb",
                    "#ff6384",
                    "#4caf50",
                    "#ffeb3b",
                    "#009688"
                ],
                borderWidth: 2,
                borderColor: "#fff"
            }
        ]
    };
    const pieOptions = {
        responsive: true,
        maintainAspectRatio: false,
        cutout: "50%",
        plugins: {
            legend: {
                position: "top"
            }
        }
    };
    const chartData = {
        labels: labels,
        datasets: [
            {
                label: column.name,
                data: values,
                backgroundColor: [
                    "#0E7AED",
                    "#36a2eb",
                    "#ff6384",
                    "#ff9f40",
                    "#4bc0c0",
                    "#9966ff",
                    "#ffcd56"
                ]
            }
        ]
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "ss-graph-section",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "ss-graph-box",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                    children: column.name
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                    className: "ss-subtitle",
                    children: [
                        "Type: ",
                        column.type || "other"
                    ]
                }),
                Object.keys(counts).length <= 20 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "ss-filters",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "ss-filter-tags",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "ss-filter-label",
                                    children: "Filters"
                                }),
                                Object.entries(activeFilters).map(([colId, val])=>{
                                    const col = allColumns.find((c)=>c.id === colId);
                                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                        className: "ss-filter-tag",
                                        children: [
                                            col?.name,
                                            ": ",
                                            val,
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                className: "ss-filter-tag-remove",
                                                onClick: ()=>setActiveFilters((f)=>{
                                                        const n = {
                                                            ...f
                                                        };
                                                        delete n[colId];
                                                        return n;
                                                    }),
                                                children: "\u2715"
                                            })
                                        ]
                                    }, colId);
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                    className: "icons_up main-iconButton profil_action main_add-button space_tableButton",
                                    icon: "fas fa-plus",
                                    title: "Add filter",
                                    onClick: ()=>setShowFilters(!showFilters)
                                })
                            ]
                        }),
                        showFilters && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "ss-filter-panel",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "ss-filter-panel-body",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                            type: "text",
                                            style: {
                                                display: "none"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                            type: "password",
                                            style: {
                                                display: "none"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            className: "ss-filter-grid",
                                            children: allColumns.filter((col)=>col.id !== "id").map((col)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                    className: "ss-filter-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                            autoComplete: "new-password",
                                                            autoCorrect: "off",
                                                            autoCapitalize: "off",
                                                            spellCheck: "false",
                                                            name: `filter_${col.id}`,
                                                            placeholder: `Filter by ${col.name}`,
                                                            value: activeFilters[col.id] ?? "",
                                                            onChange: (e)=>{
                                                                e.stopPropagation();
                                                                setActiveFilters((f)=>({
                                                                        ...f,
                                                                        [col.id]: e.target.value
                                                                    }));
                                                            },
                                                            onClick: (e)=>e.stopPropagation()
                                                        }),
                                                        activeFilters[col.id] && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                            className: "ss-filter-row-remove",
                                                            onClick: ()=>setActiveFilters((f)=>{
                                                                    const n = {
                                                                        ...f
                                                                    };
                                                                    delete n[col.id];
                                                                    return n;
                                                                }),
                                                            children: "\u2715"
                                                        })
                                                    ]
                                                }, col.id))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "ss-filter-panel-footer",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                        label: "Apply",
                                        className: "validate",
                                        onClick: ()=>setShowFilters(false)
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "ss-stats-row",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "ss-stat-box",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "ss-stat-box-info",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                            className: "fas fa-info-circle ss-info-icon"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "ss-info-tooltip",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                                            children: "Max value:"
                                                        }),
                                                        " The most frequently occurring value in this column."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                                            children: "Min value:"
                                                        }),
                                                        " The least frequently occurring value in this column."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "ss-stat-grid",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                            children: "Max value"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            className: "ss-colon",
                                            children: ":"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                            children: [
                                                bestValue,
                                                " (",
                                                bestCount,
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                            children: "Min value"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            className: "ss-colon",
                                            children: ":"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                            children: [
                                                lowestValue,
                                                " (",
                                                lowestCount,
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        column.type === "integer" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "ss-stat-box",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "ss-stat-box-info",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                            className: "fas fa-info-circle ss-info-icon"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "ss-info-tooltip",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                                            children: "Average:"
                                                        }),
                                                        " The arithmetic mean of all numeric values."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                                            children: "Median:"
                                                        }),
                                                        " The middle value when all values are sorted."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "ss-stat-grid",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                            children: "Average"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            className: "ss-colon",
                                            children: ":"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            children: avg
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                            children: "Median"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            className: "ss-colon",
                                            children: ":"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            children: median
                                        })
                                    ]
                                })
                            ]
                        }),
                        column.type === "integer" && q1 !== null && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "ss-stat-box",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "ss-stat-box-info",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                            className: "fas fa-info-circle ss-info-icon"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "ss-info-tooltip",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                                            children: "Q1:"
                                                        }),
                                                        " 25% of values fall below this point."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                                            children: "Q2:"
                                                        }),
                                                        " The median, 50% of values fall below."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                                            children: "Q3:"
                                                        }),
                                                        " 75% of values fall below this point."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                                            children: "Q4:"
                                                        }),
                                                        " The maximum value in the dataset."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "ss-stat-grid",
                                    style: {
                                        fontSize: 13
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                            children: "Q1"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            className: "ss-colon",
                                            children: ":"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            children: q1
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                            children: "Q2"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            className: "ss-colon",
                                            children: ":"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            children: q2
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                            children: "Q3"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            className: "ss-colon",
                                            children: ":"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            children: q3
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                            children: "Q4"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            className: "ss-colon",
                                            children: ":"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            children: q4
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                Object.keys(counts).length > 20 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "ss-no-preview",
                    children: "No preview available"
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "ss-chart-selector",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                    label: "Bar chart",
                                    className: chartType === "bar" ? "cancel-full" : "validate",
                                    onClick: ()=>setChartType("bar")
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                    label: "Pie chart",
                                    className: chartType === "pie" ? "cancel-full" : "validate",
                                    onClick: ()=>setChartType("pie")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "ss-chart-container",
                            children: chartType === "bar" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2ad20ccd62d19c94$export$acaa6426d77a227e), {
                                type: "bar",
                                data: chartData,
                                options: {
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                            display: false
                                        }
                                    },
                                    scales: {
                                        x: {
                                            title: {
                                                display: true,
                                                text: column.name
                                            }
                                        },
                                        y: {
                                            title: {
                                                display: true,
                                                text: "Count"
                                            }
                                        }
                                    }
                                }
                            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2ad20ccd62d19c94$export$acaa6426d77a227e), {
                                type: "doughnut",
                                data: pieData,
                                options: pieOptions
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $c9128199630b9c58$export$2e2bcd8739ae039 = $c9128199630b9c58$var$StatementStatisticsGraph;


const $9e9c5a87c687698b$var$ColumnSection = ({ columns: columns, graphColumn: graphColumn, onCardClick: onCardClick, datasetName: datasetName })=>{
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "ss-column-grid",
        children: columns.map((column)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9e9c5a87c687698b$var$ColumnCard, {
                column: column,
                datasetName: datasetName,
                graphColumn: graphColumn,
                onClick: onCardClick
            }, column.id))
    });
};
const $9e9c5a87c687698b$var$ColumnCard = ({ column: column, datasetName: datasetName, graphColumn: graphColumn, onClick: onClick })=>{
    const [topValue, setTopValue] = (0, $bh6RR.useState)(null);
    const [lowValue, setLowValue] = (0, $bh6RR.useState)(null);
    const [topCount, setTopCount] = (0, $bh6RR.useState)(0);
    const [lowCount, setLowCount] = (0, $bh6RR.useState)(0);
    const { getDataset: getDataset } = (0, $cef77ca5b38a78fa$export$2e2bcd8739ae039);
    (0, $bh6RR.useEffect)(()=>{
        const fetchStats = async ()=>{
            const result = await getDataset(decodeURI(datasetName), {});
            if (!result || !result[0] || !result[0].data) return;
            const rows = result[0].data;
            const counts = {};
            rows.forEach((row)=>{
                const val = row[column.id];
                if (val == null || val === "") return;
                counts[val] = (counts[val] || 0) + 1;
            });
            const sorted = Object.entries(counts).sort((a, b)=>b[1] - a[1]);
            if (sorted.length > 0) {
                setTopValue(sorted[0][0] != null && sorted[0][0] !== "" ? sorted[0][0] : "NULL");
                setTopCount(sorted[0][1]);
                setLowValue(sorted[sorted.length - 1][0] != null && sorted[sorted.length - 1][0] !== "" ? sorted[sorted.length - 1][0] : "NULL");
                setLowCount(sorted[sorted.length - 1][1]);
            }
        };
        fetchStats();
    }, [
        column
    ]);
    const token = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("token");
    const companyId = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company").id;
    const exportUrl = (0, $651df53b10514175$export$a7b6bc01c63cdfc3).REACT_APP_API_PATH + `/dataset/${datasetName}/export?token_auth=${token}&company=${companyId}&column=${encodeURIComponent(column.name)}`;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: `ss-column-card${graphColumn?.id === column.id ? " active" : ""}`,
        onClick: ()=>onClick(column),
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "ss-column-card-header",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "ss-column-card-name",
                        children: column.name
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                        href: exportUrl,
                        rel: "noopener noreferrer",
                        title: "Export",
                        onClick: (e)=>e.stopPropagation(),
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                            className: "icons_up main-iconButton profil_action main_add-button space_tableButton",
                            icon: "fas fa-file-export",
                            title: "Export column"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "ss-column-card-type",
                children: column.type || "other"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("hr", {
                className: "ss-divider"
            }),
            topValue || lowValue ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                        className: "ss-card-stat",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                children: "Most frequent:"
                            }),
                            " ",
                            topValue ?? "-",
                            " (",
                            topCount,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                        className: "ss-card-stat",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                children: "Least frequent:"
                            }),
                            " ",
                            lowValue ?? "-",
                            " (",
                            lowCount,
                            ")"
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                className: "ss-card-stat muted",
                children: "Not valid values"
            })
        ]
    });
};
const $9e9c5a87c687698b$var$StatementStatistic = ()=>{
    const { name: name } = (0, $6a9dcc96d11bcd0d$export$99eaa27ddbbb95ef)();
    const { getColumns: getColumns } = (0, $832c2ed0617b1e24$export$2e2bcd8739ae039);
    const { datasets: datasets } = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)().get("company");
    const dataset = datasets.find((d)=>d.name === name);
    const [columns, setColumns] = (0, $bh6RR.useState)([]);
    const [graphColumn, setGraphColumn] = (0, $bh6RR.useState)(null);
    (0, $bh6RR.useEffect)(()=>{
        const fetchColumns = async ()=>{
            const [res, error] = await getColumns(dataset.id);
            if (!error) setColumns(res.data.filter((c)=>!c.deleted));
        };
        fetchColumns();
    }, [
        name
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (columns.length > 0 && !graphColumn) setGraphColumn(columns[0]);
    }, [
        columns
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: `${name} statistics`
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9e9c5a87c687698b$var$ColumnSection, {
                columns: columns,
                graphColumn: graphColumn,
                onCardClick: setGraphColumn,
                datasetName: name
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c9128199630b9c58$export$2e2bcd8739ae039), {
                column: graphColumn,
                allColumns: columns,
                datasetName: name
            })
        ]
    });
};
var $9e9c5a87c687698b$export$2e2bcd8739ae039 = $9e9c5a87c687698b$var$StatementStatistic;


function $2127ca43bf709148$var$StatementStatistics() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9e9c5a87c687698b$export$2e2bcd8739ae039), {});
}
var $2127ca43bf709148$export$2e2bcd8739ae039 = $2127ca43bf709148$var$StatementStatistics;


const $2bde61d945d4c1bb$var$routes = [
    {
        path: "company/:company/datasets/list",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $542980e182b3e1d9$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "view_datasets"
        ]
    },
    {
        path: "company/:company/datasets/:name",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $105763ee5f8cba50$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "update_dataset"
        ]
    },
    {
        path: "company/:company/dataset/create",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7d1a917b88f467f9$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "create_dataset"
        ]
    },
    {
        path: "company/:company/dataset/update",
        component: (data)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8e8c7c5e2149b59a$export$2e2bcd8739ae039), {
                data: data
            }),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "update_dataset"
        ]
    },
    {
        path: "company/:company/datasets/:name/statistics",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2127ca43bf709148$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "update_dataset"
        ]
    }
];
var $2bde61d945d4c1bb$export$2e2bcd8739ae039 = $2bde61d945d4c1bb$var$routes;















var $c664cd598f09e2f9$export$2e2bcd8739ae039 = {
    getChannels: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("channels", data),
    getChannelPhonesAvailable: (id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`channel/${id}/phones_available`),
    getChannelsAutocomplete: (name)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`channels?name=${name}`),
    getChannel: (name, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`channel/${name}`, data),
    addChannel: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`channel`, data),
    deleteChannel: (id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`channel/${id}`),
    updateChannel: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`channel/${id}`, data)
};


var $ae6a237c45c511ec$exports = {};
$ae6a237c45c511ec$exports = new URL("web.3c6702a8.svg", import.meta.url).toString();


var $986e564353b9e0a7$exports = {};
$986e564353b9e0a7$exports = new URL("telephony.1a4ee40e.svg", import.meta.url).toString();


var $c1a9e44ef4dfbd63$exports = {};
$c1a9e44ef4dfbd63$exports = new URL("rcs.51d4536b.svg", import.meta.url).toString();


var $ec781ed39d836b3e$exports = {};
$ec781ed39d836b3e$exports = new URL("mail.a7324076.svg", import.meta.url).toString();


var $b3e51b95dcf04d66$export$2e2bcd8739ae039 = {
    web: (0, (/*@__PURE__*/$parcel$interopDefault($ae6a237c45c511ec$exports))),
    telephony: (0, (/*@__PURE__*/$parcel$interopDefault($986e564353b9e0a7$exports))),
    messenger: (0, (/*@__PURE__*/$parcel$interopDefault($ec781ed39d836b3e$exports))),
    rcs: (0, (/*@__PURE__*/$parcel$interopDefault($c1a9e44ef4dfbd63$exports)))
};



parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");
















const $5c7e3cd8d8b7b66b$export$3b31a91e69d9331 = ()=>window.matchMedia("(display-mode: standalone)").matches;



const $b60cc23250669e35$var$ChannelWeb = ({ channel: channel })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const { register: register, setError: setError, clearErrors: clearErrors, handleSubmit: handleSubmit, control: control, formState: { errors: errors }, formState: formState, getValues: getValues, setValue: setValue, watch: watch } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            color: channel.data?.color,
            name: channel.name,
            sound_effect: channel.data.sound_effect,
            notification: channel.data.notification,
            ripple_effect: channel.data.ripple_effect
        }
    });
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const { updateChannel: updateChannel } = (0, $c664cd598f09e2f9$export$2e2bcd8739ae039);
    const [file, setFile] = (0, $bh6RR.useState)(channel.data?.avatar);
    const [runBotState, setRunBotState] = (0, $bh6RR.useState)(channel.data?.delay_run_chatbox ?? 0);
    var host = location.protocol + "//" + location.hostname + ":" + location.port;
    const url_test_chatbox = host + "/bot/test/" + channel.bot.company.id + "-" + channel.bot.id + "-" + channel.key;
    host = (0, $651df53b10514175$export$a7b6bc01c63cdfc3).REACT_APP_API_PROD_PATH;
    const url_exploit_chatbox = host + "/chatbox/web?key=" + channel.key;
    const handleInputRangeChange = (name, value)=>{
        setRunBotState(parseInt(value));
        setValue("run_bot_delay", parseInt(value));
    };
    const onSubmit = async ()=>{
        let formData = new FormData();
        formData.append("name", getValues("name"));
        formData.append("color", getValues("color"));
        formData.append("delay_run_chatbox", getValues("run_bot_delay"));
        formData.append("sound_effect", getValues("sound_effect"));
        formData.append("notification", getValues("notification"));
        formData.append("ripple_effect", getValues("ripple_effect"));
        if (file != null && file.name != null) formData.append("avatar", file);
        let [response, error] = await updateChannel(channel.id, formData);
        if (error !== null) {
            console.log(error);
            return;
        }
        modal.resolve(response); // marche sans ... a voir pourquoi
        onClose();
        return;
    };
    const text = '<script src="' + url_exploit_chatbox + '" async></script>';
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
            className: "form-container_sideModal",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                    className: "title_channelTel",
                    children: "Channel Web Information"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                    className: "form-body_container_sideModal channel_form-body scroll_body_channel",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "modal-bar",
                            style: {
                                display: "block"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    style: {
                                        display: "flex"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Script for your website",
                                            listLabelClassName: "title_form title_dropdown"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("a", {
                                            target: (0, $5c7e3cd8d8b7b66b$export$3b31a91e69d9331)() ? "_self" : "_blank",
                                            href: url_test_chatbox,
                                            className: "container-debug-channel",
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    className: "debug-channel add-hover",
                                                    style: {
                                                        fontSize: "22px"
                                                    },
                                                    children: " "
                                                }),
                                                " "
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "integration integration_channelWeb",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("pre", {
                                        className: "pre code code-url",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("code", {
                                            className: "hover_copy channel-web-window",
                                            onClick: (e)=>navigator.clipboard.writeText(text).then((_)=>{
                                                    toast.success("Copy link to clipboard", "You can paste this link where you need !");
                                                }),
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    justifyContent: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                        id: "hoverText",
                                                        className: "fa fa-copy text_copy",
                                                        "aria-hidden": "true"
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                        id: "hoverIcon",
                                                        className: "fa fa-code icon_copy",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Click, copy and paste the script after the </body> in your html file",
                                    listLabelClassName: "indication_web_link title-weigth"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Informations",
                                listLabelClassName: "title_form title_dropdown"
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                        label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                            children: [
                                                " Name ",
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    className: "obligatory_field",
                                                    children: "*"
                                                }),
                                                " "
                                            ]
                                        }),
                                        listLabelClassName: "title-weigth label_color",
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                                ...register("name", {
                                                    required: true,
                                                    minLength: 3
                                                }),
                                                style: {
                                                    width: "85%",
                                                    marginBottom: "0",
                                                    borderColor: errors.name ? "red" : ""
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                className: "error",
                                                style: {
                                                    marginRight: "40px",
                                                    fontSize: "14px"
                                                },
                                                children: errors.name ? errors.name.message ? errors.name.message : "At least 3 letters" : ""
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "color_container",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Color of my chatbox",
                                            listLabelClassName: "title-weigth label_color",
                                            listClassName: "field_color"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            className: "color_area",
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                className: "input_color-container",
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                    ...register("color"),
                                                    defaultValue: channel.color,
                                                    type: "color",
                                                    className: "input_color"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "run_bot_block",
                                    style: {
                                        marginTop: "1rem",
                                        alignItems: "flex-start"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Automatic bot opening delay"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "input-range-container",
                                            style: {
                                                marginTop: "0"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0ab38a35cd0a622a$export$2e2bcd8739ae039), {
                                                    ...register("run_bot_delay"),
                                                    _setValue: handleInputRangeChange,
                                                    value: channel.data?.delay_run_chatbox,
                                                    min: "0",
                                                    max: "10"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    className: "range-value",
                                                    style: {
                                                        left: `${runBotState / 10 * 100}%`
                                                    },
                                                    children: runBotState
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "chatbox_parameter",
                                    style: {
                                        marginTop: "1rem",
                                        alignItems: "flex-start"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Enable Sound Effect",
                                            listLabelClassName: "titles-input",
                                            listClassName: "flex no-margin_left",
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                                ...register("sound_effect"),
                                                name: "sound_effect",
                                                checked: !!watch("sound_effect"),
                                                onChange: (e)=>setValue("sound_effect", e.target.checked ? true : false)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Enable Notification",
                                            listLabelClassName: "titles-input",
                                            listClassName: "flex no-margin_left",
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                                ...register("notification"),
                                                name: "notification",
                                                checked: !!watch("notification"),
                                                onChange: (e)=>setValue("notification", e.target.checked ? true : false)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Enable Ripple Effect",
                                            listLabelClassName: "titles-input",
                                            listClassName: "flex no-margin_left",
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                                ...register("ripple_effect"),
                                                name: "ripple_effect",
                                                checked: !!watch("ripple_effect"),
                                                onChange: (e)=>setValue("ripple_effect", e.target.checked ? true : false)
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Avatar of my chatbox",
                                            listLabelClassName: "title-weigth label_color",
                                            listClassName: "field_avatar"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $47da697040d42413$export$2e2bcd8739ae039), {
                                            _setFile: setFile,
                                            defaultValueImage: channel.data?.avatar,
                                            accept: ".png,.jpg,.jpeg",
                                            colorBorder: "inset 0 0 0 1px #dddddd;"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        id: "form_tel",
                        type: "submit",
                        label: "Update",
                        className: "validate",
                        disabled: !formState.isValid,
                        style: {
                            marginTop: "2rem"
                        }
                    })
                })
            ]
        })
    });
};
var $b60cc23250669e35$export$2e2bcd8739ae039 = $b60cc23250669e35$var$ChannelWeb;




var $bh6RR = parcelRequire("bh6RR");






const $22c5e8f52dada98e$export$c3f289386278b1a3 = (voices)=>{
    let arrayVoice = [];
    voices.forEach((voice)=>arrayVoice.push({
            value: voice.id,
            text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                style: {
                    maxWidth: "300px"
                },
                children: [
                    " ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        style: {
                            marginRight: "15px",
                            fontSize: "12px"
                        },
                        className: "flag-icon flag-icon-" + voice.country
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "channel_content_dropdown",
                        style: {
                            fontSize: "14px"
                        },
                        children: [
                            "  ",
                            voice.value,
                            " "
                        ]
                    })
                ]
            })
        }));
    return arrayVoice;
};




var $c67d9f619ac86d97$export$2e2bcd8739ae039 = {
    getPhones: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`phones`, data),
    getPhone: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`phones/user/${id}`, data),
    addPhone: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`phone`, data),
    updatePhone: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`phone/${id}`, data),
    deletePhone: (id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`phone/${id}`),
    importPhones: (formData)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`phones/import`, formData),
    checkPhoneAvailability: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`phone/check-availability`, data)
};





parcelRequire("bh6RR");





const $8af24c18133408e1$var$PhoneBlock = ({ data: data, onClick: onClick, index: index })=>{
    const isAvailable = data.channel_id != null;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "phone-block",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "container_phone_info",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            className: "flag-icon flag-icon-" + data.country?.alpha_code_2.toLowerCase()
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                            className: "number_phone",
                            children: [
                                " ",
                                data.numbers
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                        id: data.id + "button",
                        className: "main-iconButton modalButtons-input" + (isAvailable ? " checked" : ""),
                        icon: isAvailable ? "fas fa-check-circle" : "fas fa-plus-circle",
                        onClick: (e)=>onClick != null ? onClick(data, index) : ""
                    })
                })
            ]
        })
    });
};
var $8af24c18133408e1$export$2e2bcd8739ae039 = $8af24c18133408e1$var$PhoneBlock;





const $13051e3fb757f0fb$var$ChannelTelephony = ({ data: data })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const { getVoices: getVoices } = (0, $24a8370de200c756$export$2e2bcd8739ae039);
    const { getChannelPhonesAvailable: getChannelPhonesAvailable, updateChannel: updateChannel } = (0, $c664cd598f09e2f9$export$2e2bcd8739ae039);
    const [voices, setVoices] = (0, $bh6RR.useState)("");
    const [phones, setPhones] = (0, $bh6RR.useState)("");
    const [phonesChecked, setPhonesChecked] = (0, $bh6RR.useState)("");
    const { register: register, control: control, handleSubmit: handleSubmit, watch: watch, formState: { errors: errors }, formState: formState, getValues: getValues, setValue: setValue } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValue: {
            voices: " ",
            name: data.name
        }
    });
    const getAllVoicesById = async ()=>{
        let [response, error] = await getVoices(parseInt(data.bot_id));
        if (error !== null) {
            console.log(error);
            return;
        }
        setVoices((0, $22c5e8f52dada98e$export$c3f289386278b1a3)(response));
        return response;
    };
    const getAllPhones = async ()=>{
        let [response, error] = await getChannelPhonesAvailable(data.id);
        if (error !== null) {
            console.log(error);
            return;
        }
        if (response.phones_availables != null) setPhones([
            ...response.phones_availables,
            ...response.phones
        ]);
        setPhonesChecked(response.phones);
        return response;
    };
    const checkPhone = (_phone)=>{
        let result = phonesChecked;
        if (phonesChecked.filter((phone)=>{
            return phone.id == _phone.id;
        }).length == 0) {
            result.push(_phone);
            setPhonesChecked(result);
            result.length;
            document.getElementById(_phone.id + "button").style.color = "var(--green)";
            document.getElementById(_phone.id + "button").children[0].classList = "fas fa-check-circle";
        } else {
            let _index = phonesChecked.findIndex((phone)=>{
                return phone.id === _phone.id;
            });
            result.splice(_index, 1);
            setPhonesChecked(result);
            result.length;
            document.getElementById(_phone.id + "button").style.color = "var(--main)";
            document.getElementById(_phone.id + "button").children[0].classList = "fas fa-plus-circle";
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        getAllVoicesById();
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        getAllPhones();
    }, []);
    const onSubmit = async ()=>{
        let numbers = phonesChecked.map((phone)=>phone.id);
        let config = JSON.stringify({
            voices: getValues("voices") || "",
            language: data.data.config.language
        });
        let formData = new FormData();
        formData.append("name", getValues("name"));
        formData.append("numbers", JSON.stringify(numbers));
        formData.append("config", config);
        let [response, error] = await updateChannel(data.id, formData);
        if (error !== null) {
            console.log(error);
            return;
        }
        modal.resolve(response); // marche sans ... a voir pourquoi
        onClose();
        return;
    };
    /*
    const putValidForm = (bool) => {
        console.log(document.getElementById("form_tel"))
        document.getElementById("form_tel").disabled = !bool;
    }
    */ return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
            className: "form-container_sideModal",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                    className: "title_channelTel",
                    children: [
                        " Channel Telephony for bot ",
                        data.name
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                    className: "form-body_container_sideModal channel_form-body",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                    children: [
                                        " Name ",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            className: "obligatory_field",
                                            children: "*"
                                        }),
                                        " "
                                    ]
                                }),
                                listLabelClassName: "title-weigth label_color",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                        ...register("name", {
                                            required: true,
                                            minLength: 3
                                        }),
                                        style: {
                                            borderColor: errors.name ? "red" : ""
                                        },
                                        defaultValue: data.name
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                        className: "error",
                                        style: {
                                            marginTop: "-15px",
                                            marginBottom: "10px",
                                            fontSize: "14px"
                                        },
                                        children: errors.name ? errors.name.message ? errors.name.message : "At least 3 letters" : ""
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "modal-bar"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Select your phone number",
                                    listLabelClassName: "title_form title_dropdown"
                                }),
                                Array.isArray(phones) ? phones.map((phone, i)=>{
                                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8af24c18133408e1$export$2e2bcd8739ae039), {
                                        data: phone,
                                        onClick: checkPhone,
                                        index: i
                                    }, phone.id);
                                }) : null
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        id: "form_tel",
                        type: "submit",
                        label: "Update",
                        className: "validate",
                        disabled: !formState.isValid
                    })
                })
            ]
        })
    });
};
var $13051e3fb757f0fb$export$2e2bcd8739ae039 = $13051e3fb757f0fb$var$ChannelTelephony;




const $313ce1420b35a184$var$ChannelModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ title: title, data: data })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    //const form = { id: data == undefined? null : data.id,nameDataset: nameDataset,label:  data == undefined? null : data.label, title: title, feeling: data == undefined? null : data.feeling, statementArray : data == undefined? [] : data.statements, replyArray : data == undefined? [] : data.responses}
    const isWebMode = ()=>{
        return data.type.name == "web";
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $9c2d88d3df32f983$export$2e2bcd8739ae039), {
        name: "change-password channel_web_overflow_hidden",
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            isWebMode() ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b60cc23250669e35$export$2e2bcd8739ae039), {
                channel: data,
                modal: {
                    resolve: modal.resolve,
                    onClose: onClose
                }
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $13051e3fb757f0fb$export$2e2bcd8739ae039), {
                data: data,
                modal: {
                    resolve: modal.resolve,
                    onClose: onClose
                }
            })
        ]
    });
});
var $313ce1420b35a184$export$2e2bcd8739ae039 = $313ce1420b35a184$var$ChannelModal;






function $9ae17b4852584c82$var$ChannelTable() {
    const { getChannels: getChannels, deleteChannel: deleteChannel } = (0, $c664cd598f09e2f9$export$2e2bcd8739ae039);
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    /*
    const getChannelByName = async (name,data) => {
        return getChannel(name, data);
    }
    const getNumberOfChannels = async (name) =>{
        let val = await getChannelByName(name).then((value) => console.log(Object.values(value)[0].data.length)) ;
    }  
    */ const cells = [
        {
            column: "CHANNEL",
            name: "type.name",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    srcSet: (0, $b3e51b95dcf04d66$export$2e2bcd8739ae039)[value]
                })
        },
        {
            column: "NAME",
            name: "name",
            sort: true,
            show: (value)=>(0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value)
        },
        {
            column: "BOT NAME",
            name: "bot.name",
            sort: true,
            show: (value)=>(0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value)
        },
        {
            column: "CHANNEL TOKEN",
            name: "key",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    style: {
                        color: "var(--main)",
                        cursor: "pointer"
                    },
                    onClick: (e)=>navigator.clipboard.writeText(value).then((_)=>{
                            toast.success("Copy token to clipboard", "You can paste this token where you need !", 5000);
                        }),
                    children: [
                        " ",
                        (0, $2ec34e35a5139fe7$export$2e2bcd8739ae039)(value)
                    ]
                })
        },
        {
            column: "AVAILABLE SINCE",
            name: "updated_at",
            sort: true,
            show: (value)=>(0, $df9ad4654a227866$export$3ae94a2503e890a1)(value)
        }
    ];
    const showWebEditModal = ({ updateRow: updateRow, row: row })=>{
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $313ce1420b35a184$export$2e2bcd8739ae039), {
            data: {
                ...row
            }
        }).then((channel)=>{
            updateRow(channel);
            console.log("t");
        });
    };
    const onClickRedirect = ({ row: row })=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("supervision/conversations/list/"));
    const onClickRedirectToAnalytics = ({ row: row })=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("supervision/analytics/" + row.name));
    const onClickAdd = ({ deleteRow: deleteRow, row: row })=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("channel/create"));
    const onClickDelete = async ({ row: row, deleteRow: deleteRow })=>{
        const { id: id, name: name } = row;
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete channel " + name,
            body: "Do you really want to delete the channel " + name,
            api: {
                request: deleteChannel,
                param: [
                    id
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel"
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ],
            confirm: {
                name: name,
                fieldName: "the channel"
            }
        }).then(()=>deleteRow(id));
    };
    const actions = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_channel") ? {
            className: "fas fa-cog action-button edit_action",
            style: {},
            onClick: showWebEditModal
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_conversations") ? {
            className: "fas fa-comments action-button profil_action conversation_redirection_channel",
            style: {},
            onClick: onClickRedirect
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_analytics") ? {
            className: "fas fa-chart-pie action-button profil_action conversation_redirection_channel",
            style: {},
            onClick: onClickRedirectToAnalytics
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("delete_channel") ? {
            className: "fas fa-trash action-button delete_action",
            style: {},
            onClick: onClickDelete
        } : null
    ].filter((action)=>action);
    const buttons = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("create_channel") ? {
            icon: "fas fa-plus",
            onClick: onClickAdd
        } : null
    ].filter((button)=>button);
    const filters = [
        {
            type: "input",
            placeholder: "term",
            name: "name"
        }
    ];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: "List of Bots Connected to channels"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "entete-dataset",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "entete-dataset",
                    style: {
                        width: "115px"
                    }
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
                className: "channel",
                name: "Channel",
                cells: cells,
                api: getChannels,
                actions: actions,
                buttons: buttons,
                filters: filters
            })
        ]
    });
}
var $9ae17b4852584c82$export$2e2bcd8739ae039 = $9ae17b4852584c82$var$ChannelTable;


function $ef3c6878639fcd9f$var$ChannelList() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9ae17b4852584c82$export$2e2bcd8739ae039), {});
}
var $ef3c6878639fcd9f$export$2e2bcd8739ae039 = $ef3c6878639fcd9f$var$ChannelList;



parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");










var $8f11537c2efba18d$export$2e2bcd8739ae039 = [
    {
        value: "web",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                " ",
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    srcSet: (0, $b3e51b95dcf04d66$export$2e2bcd8739ae039)["web"]
                })
            ]
        })
    },
    {
        value: "telephony",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                " ",
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    srcSet: (0, $b3e51b95dcf04d66$export$2e2bcd8739ae039)["telephony"]
                }),
                " "
            ]
        })
    },
    {
        value: "rcs",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                " ",
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    srcSet: (0, $b3e51b95dcf04d66$export$2e2bcd8739ae039)["rcs"]
                }),
                " "
            ]
        })
    }
];















function $67c6197e89fe6963$var$ChannelForm() {
    const { register: register, handleSubmit: handleSubmit, watch: watch, formState: { errors: errors }, formState: formState, getValues: getValues, setValue: setValue } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            voices: " ",
            sound_effect: false,
            notification: false,
            ripple_effect: false
        }
    });
    const { addChannel: addChannel } = (0, $c664cd598f09e2f9$export$2e2bcd8739ae039);
    const { getBotsChannels: getBotsChannels, getVoices: getVoices, getBotsShared: getBotsShared } = (0, $24a8370de200c756$export$2e2bcd8739ae039);
    const { getPhones: getPhones } = (0, $c67d9f619ac86d97$export$2e2bcd8739ae039);
    const [listCheckedPhone, setListCheckedPhone] = (0, $bh6RR.useState)([]);
    const [bots, setBots] = (0, $bh6RR.useState)("");
    const [voices, setVoices] = (0, $bh6RR.useState)("");
    const [phones, setPhones] = (0, $bh6RR.useState)([]);
    const [file, setFile] = (0, $bh6RR.useState)();
    const [key, setKey] = (0, $bh6RR.useState)();
    const [loadAnim, setLoading] = (0, $bh6RR.useState)(null);
    const [runBotState, setRunBotState] = (0, $bh6RR.useState)(0);
    const [partSlide, setPartSlide] = (0, $bh6RR.useState)("choose-bot");
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const handleInputRangeChange = (name, value)=>{
        setRunBotState(parseInt(value));
        setValue("run_bot_delay", parseInt(value));
    };
    const getAllBots = async ()=>{
        let responses = await Promise.all([
            getBotsShared(),
            getBotsChannels()
        ]);
        const [getBotsSharedResponse, getBotsChannelsResponse] = responses;
        if (getBotsSharedResponse[1] != null) {
            console.log(getBotsSharedResponse[1]);
            return;
        }
        if (getBotsChannelsResponse[1] != null) {
            console.log(getBotsChannelsResponse[1]);
            return;
        }
        const response = [
            ...getBotsSharedResponse[0],
            ...getBotsChannelsResponse[0]
        ];
        response.sort((a, b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : b.name.toLowerCase() > a.name.toLowerCase() ? 1 : 0);
        setBots(setUpBots(response));
    };
    const setUpBots = (bots)=>{
        let arrayBot = [];
        bots.forEach((bot)=>arrayBot.push({
                value: bot.id,
                text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                            srcSet: bot.company.logo,
                            title: bot.company.name,
                            alt: "",
                            width: "25px"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "channel_content_dropdown",
                            children: [
                                " ",
                                bot.name,
                                " "
                            ]
                        })
                    ]
                })
            }));
        return arrayBot;
    };
    const getAllVoicesById = async ()=>{
        let [response, error] = await getVoices(parseInt(getValues("bot")));
        if (error !== null) {
            console.log(error);
            return;
        }
        let res = (0, $22c5e8f52dada98e$export$c3f289386278b1a3)(response);
        setVoices(res);
        return response;
    };
    const getAllPhonesById = async ()=>{
        let [response, error] = await getPhones();
        if (error !== null) {
            console.log(error);
            return;
        }
        response = response.filter((phone)=>phone.channel == null && phone.is_mutu == false);
        setPhones(response);
        return response;
    };
    const checkPhone = (_phone)=>{
        let result = listCheckedPhone;
        if (result.filter((phone)=>{
            return phone.id == _phone.id;
        }).length == 0) {
            result.push(_phone);
            setListCheckedPhone(result);
            document.getElementById(_phone.id + "button").style.color = "var(--green)";
            document.getElementById(_phone.id + "button").children[0].classList = "fas fa-check-circle";
        } else {
            let index = listCheckedPhone.findIndex((phone)=>{
                return phone.id === _phone.id;
            });
            result.splice(index, 1);
            setListCheckedPhone(result);
            document.getElementById(_phone.id + "button").style.color = "var(--main)";
            document.getElementById(_phone.id + "button").children[0].classList = "fas fa-plus-circle";
        }
    };
    const getPhoneNumberSpaced = (phone)=>{
        let str = "";
        for(let i = 0; i < phone.length; i++){
            str += phone[i];
            if ((i - 1) % 2 == 0) str += " ";
        }
        return str;
    };
    const onSubmit = async ()=>{
        var dataToSend = getValues();
        const formData = new FormData();
        if (listCheckedPhone.length > 0) {
            let listPhoneIds = listCheckedPhone.map((phone)=>phone.id);
            formData.append("numbers", JSON.stringify(listPhoneIds));
        }
        formData.append("name", dataToSend.name);
        formData.append("type_id", dataToSend.channel == "telephony" ? 3 : 1) // web = 1 , tel = 0
        ;
        formData.append("bot_id", parseInt(dataToSend.bot));
        formData.append("color", dataToSend.color_bot);
        formData.append("avatar", file);
        formData.append("delay_run_chatbox", dataToSend.run_bot_delay);
        formData.append("sound_effect", dataToSend.sound_effect);
        formData.append("notification", dataToSend.notification);
        formData.append("ripple_effect", dataToSend.ripple_effect);
        let [response, error] = await addChannel(formData);
        if (error !== null) {
            console.log(error);
            return;
        }
        return navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/plugin/channels/list"));
    };
    (0, $bh6RR.useEffect)(()=>{
        getAllBots();
    }, []);
    const ChannelTelephonySlide = ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        listClassName: "flex no-margin_left",
                        label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                            className: "normal_font-weight",
                            children: [
                                "Make your ",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "bold_font-weight",
                                    children: " Bot "
                                }),
                                " available on a phone number"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                    listClassName: "flex no-margin_left",
                    label: "Select some phone numbers"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "container_phone_list_channel",
                    children: phones.length > 0 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "phone_list_channel",
                            children: phones.map((phone, i)=>{
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "project-block",
                                    "data-checked": "false",
                                    "data-id": phone.id,
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            style: {
                                                alignItems: "center",
                                                display: "flex"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                    style: {
                                                        marginRight: "15px",
                                                        fontSize: "20px"
                                                    },
                                                    className: "flag-icon flag-icon-" + phone.country.alpha_code_2.toLowerCase()
                                                }),
                                                getPhoneNumberSpaced(phone.numbers)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                                id: phone.id + "button",
                                                className: "main-iconButton add-hover modalButtons-input",
                                                icon: "fas fa-plus-circle",
                                                onClick: (e)=>checkPhone(phone)
                                            })
                                        })
                                    ]
                                }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)());
                            })
                        })
                    }) : null
                })
            ]
        });
    const ChannelWebSlide = ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        listClassName: "flex no-margin_left",
                        label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                            className: "normal_font-weight",
                            children: [
                                "Customize your ",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "bold_font-weight",
                                    children: "Chatbox"
                                }),
                                ", give her a ",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "bold_font-weight",
                                    children: "face"
                                }),
                                ", and start the ",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "bold_font-weight",
                                    children: "robot"
                                }),
                                " of ",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "bold_font-weight",
                                    children: "tomorrow"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            listClassName: "flex no-margin_left",
                            label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                className: "normal_font-weight",
                                children: [
                                    "Having a good ",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                        className: "bold_font-weight",
                                        children: "picture"
                                    }),
                                    ", and good",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                        className: "bold_font-weight",
                                        children: "colors"
                                    }),
                                    ", is very ",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                        className: "bold_font-weight",
                                        children: "useful"
                                    }),
                                    " for a ",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                        className: "bold_font-weight",
                                        children: "bot"
                                    }),
                                    "on the ",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                        className: "bold_font-weight",
                                        children: " web "
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "main_container_color_part",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "avatar-area",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Avatar"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $47da697040d42413$export$2e2bcd8739ae039), {
                                                _setFile: setFile,
                                                accept: ".png",
                                                loadAnim: loadAnim
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "color_area",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Chatbox color"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            className: "input_color-container",
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                ...register("color_bot"),
                                                defaultValue: "#0e7aed",
                                                type: "color",
                                                className: "input_color"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "run_bot_block",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Automatic bot opening delay"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "input-range-container",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0ab38a35cd0a622a$export$2e2bcd8739ae039), {
                                            ...register("run_bot_delay"),
                                            _setValue: handleInputRangeChange,
                                            min: "0",
                                            max: "10"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            className: "range-value",
                                            style: {
                                                left: `${runBotState / 10 * 100}%`
                                            },
                                            children: runBotState
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    const ChannelRcsSlide = ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        listClassName: "flex no-margin_left",
                        label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                            className: "normal_font-weight",
                            children: [
                                "Make your bot available on the ",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "bold_font-weight",
                                    children: "rcs channel of google"
                                }),
                                ","
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            listClassName: "flex no-margin_left",
                            label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                className: "normal_font-weight",
                                children: [
                                    "Register your agent key just beside to make it enable for ",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                        className: "bold_font-weight",
                                        children: "your customers"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "main_container_rcs",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                style: {
                                    marginLeft: 15
                                },
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                        label: "Bot key"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "key_container",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                            ...register("key_file"),
                                            type: "file",
                                            accept: ".json"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    const ChannelWebParameterSlide = ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        listClassName: "flex no-margin_left",
                        label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                            className: "normal_font-weight",
                            children: [
                                "Customize your ",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "bold_font-weight",
                                    children: "Chatbox"
                                }),
                                ", enable ",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "bold_font-weight",
                                    children: "sound effect, notification"
                                }),
                                ", and ",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "bold_font-weight",
                                    children: "ripple effect"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                children: "Enable Sound Effect"
                            }),
                            listLabelClassName: "titles-input",
                            listClassName: "flex no-margin_left",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                ...register("sound_effect"),
                                name: "sound_effect",
                                onChange: (e)=>setValue("sound_effect", e.target.checked ? true : false)
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                children: "Enable Notification"
                            }),
                            listLabelClassName: "titles-input",
                            listClassName: "flex no-margin_left",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                ...register("notification"),
                                name: "notification",
                                onChange: (e)=>setValue("notification", e.target.checked ? true : false)
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                children: "Enable Ripple Effect"
                            }),
                            listLabelClassName: "titles-input",
                            listClassName: "flex no-margin_left",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                ...register("ripple_effect"),
                                name: "ripple_effect",
                                onChange: (e)=>setValue("ripple_effect", e.target.checked ? true : false)
                            })
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
        className: "space-right-channel",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                children: "Broadcast your bot"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                className: "form_channel_center",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $51a8b46ec4198ef9$export$2e2bcd8739ae039), {
                    className: "slider-channel_form",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                            name: "choose-bot",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                        listClassName: "flex no-margin_left",
                                        label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                            className: "normal_font-weight",
                                            children: [
                                                "Choose a ",
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    className: "bold_font-weight",
                                                    children: "Bot "
                                                }),
                                                ", Provide a ",
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    className: "bold_font-weight",
                                                    children: "Scenario "
                                                }),
                                                ", pic a ",
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    className: "bold_font-weight",
                                                    children: "Bot "
                                                }),
                                                " and share your it with the ",
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    className: "bold_font-weight",
                                                    children: "World "
                                                }),
                                                "."
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                        label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                            style: {
                                                marginLeft: "15px"
                                            },
                                            children: [
                                                " Name ",
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    className: "obligatory_field",
                                                    children: "*"
                                                }),
                                                " "
                                            ]
                                        }),
                                        listLabelClassName: "titles-input",
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                                ...register("name", {
                                                    required: true,
                                                    minLength: 3
                                                }),
                                                style: {
                                                    width: "85%",
                                                    marginBottom: "0",
                                                    marginLeft: "15px",
                                                    borderColor: errors.name ? "red" : ""
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                className: "error",
                                                style: {
                                                    marginRight: "40px"
                                                },
                                                children: errors.name ? errors.name.message ? errors.name.message : "At least 3 letters" : ""
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "div_container_dropdown_channel",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Channel",
                                            listLabelClassName: "bold_font-weight flex space_dowpdownTop"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            id: "channelType",
                                            className: "container_dropdown_channel channels_type",
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                                ...register("channel"),
                                                setValue: setValue,
                                                choices: (0, $8f11537c2efba18d$export$2e2bcd8739ae039),
                                                defaultChoice: "web",
                                                width: "120px"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                Array.isArray(bots) ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "div_container_dropdown_channel",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Select a Bot",
                                            listLabelClassName: "bold_font-weight flex space_dowpdownTop"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            className: "container_dropdown_channel",
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                                ...register("bot"),
                                                setValue: setValue,
                                                choices: bots,
                                                defaultChoice: "web",
                                                width: "220px"
                                            })
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    style: {
                                        marginTop: "25px",
                                        display: "flex"
                                    },
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                        label: "New channels are coming soon ! keep listening.",
                                        listLabelClassName: "flex"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                            name: "customize-bot",
                            children: [
                                watch("channel") == "telephony" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)(ChannelTelephonySlide, {}) : null,
                                watch("channel") == "web" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)(ChannelWebSlide, {}) : null,
                                watch("channel") == "rcs" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)(ChannelRcsSlide, {}) : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                            name: "customize-bot-parameter",
                            children: watch("channel") == "web" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)(ChannelWebParameterSlide, {}) : null
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                className: "space_buttons",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        type: "button",
                        className: "cancel",
                        label: "Return",
                        onClick: ()=>{
                            if (partSlide === "customize-bot-parameter") {
                                (0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("customize-bot");
                                setPartSlide("customize-bot");
                            } else {
                                (0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("choose-bot");
                                setPartSlide("choose-bot");
                            }
                        },
                        style: {
                            opacity: partSlide === "choose-bot" ? 0 : 1,
                            cursor: partSlide === "choose-bot" ? "default" : "pointer"
                        }
                    }),
                    partSlide === "choose-bot" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        type: "button",
                        className: "validate",
                        label: "Next Step",
                        onClick: ()=>{
                            (0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("customize-bot");
                            setPartSlide("customize-bot");
                            watch("channel") === "telephony" && (getAllVoicesById(), getAllPhonesById());
                        }
                    }) : partSlide === "customize-bot" && watch("channel") === "web" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        type: "button",
                        className: "validate",
                        label: "Next Step",
                        onClick: ()=>{
                            (0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("customize-bot-parameter");
                            setPartSlide("customize-bot-parameter");
                        }
                    }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        id: "submit_channel_form",
                        type: "button",
                        className: "validate",
                        label: "Validate",
                        onClick: onSubmit,
                        disabled: !(watch("name")?.length > 3)
                    })
                ]
            })
        ]
    });
}
var $67c6197e89fe6963$export$2e2bcd8739ae039 = $67c6197e89fe6963$var$ChannelForm;



function $59bd91311554e810$var$ChannelCreate() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $afaae2ff7871e331$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $67c6197e89fe6963$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f0aded74899c8465$export$2e2bcd8739ae039), {})
        ]
    });
}
var $59bd91311554e810$export$2e2bcd8739ae039 = $59bd91311554e810$var$ChannelCreate;





var $bh6RR = parcelRequire("bh6RR");










parcelRequire("bh6RR");





const $52567f535c7cc6f5$var$IntegrationShowModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ integration: integration })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        name: "change-password",
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "leave-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "title_integration_modal",
                children: [
                    "Dataset list of my integration",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "list_faqs_integrations",
                        children: Array.isArray(integration.datasets) ? integration.datasets.map((dataset, i)=>{
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                className: "integration_row_faq",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                        style: {
                                            marginRight: "15px",
                                            fontSize: "20px"
                                        },
                                        className: "flag-icon flag-icon-" + dataset.language.slug.toLowerCase()
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                        href: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/datasets/" + dataset.name),
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "name_list ",
                                            children: [
                                                " ",
                                                dataset.name,
                                                " "
                                            ]
                                        })
                                    })
                                ]
                            });
                        }) : null
                    })
                ]
            })
        ]
    });
});
var $52567f535c7cc6f5$export$2e2bcd8739ae039 = $52567f535c7cc6f5$var$IntegrationShowModal;






function $0ff5529709b098a3$var$IntegrationCodeLine({ integration: integration, text: text, handleDelete: handleDelete }) {
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const showIntegrationShowModal = (integration)=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $52567f535c7cc6f5$export$2e2bcd8739ae039), {
            integration: integration
        });
    const url_path = integration.integration_type_id == 3 ? "dataset" : "faq";
    const url_main = `${(0, $651df53b10514175$export$a7b6bc01c63cdfc3).REACT_APP_API_PATH.split("/api/v1")[0]}/${url_path}/api?key=`;
    const url_question = integration.integration_type_id == 3 ? "" : "&question=Hello";
    const full_url = url_main + integration.api_key + url_question;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "integration",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "flag-icon flag-icon-" + integration.language.slug.toLowerCase()
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                        className: "integration_name",
                        children: [
                            " ",
                            (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(integration.name),
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("pre", {
                className: "pre code code-url",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("code", {
                    onClick: (e)=>navigator.clipboard.writeText(text).then((_)=>{
                            toast.success("Copy link to clipboard", "You can paste this link where you need !");
                        }),
                    children: [
                        url_main,
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            style: {
                                fontWeight: "900"
                            },
                            children: integration.api_key
                        }),
                        url_question
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "actions-integration show",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        className: "fas fa-copy add-hover",
                        "aria-hidden": "true",
                        onClick: (e)=>navigator.clipboard.writeText(full_url).then((_)=>{
                                toast.success("Copy link to clipboard", "You can paste this link where you need !", 5000);
                            })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        className: "fas fa-key add-hover",
                        "aria-hidden": "true",
                        onClick: (e)=>navigator.clipboard.writeText(integration.api_key).then((_)=>{
                                toast.success("Copy API Key to clipboard", "You can paste this api key where you need !", 5000);
                            })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("a", {
                        href: full_url,
                        style: {
                            display: "flex"
                        },
                        target: (0, $5c7e3cd8d8b7b66b$export$3b31a91e69d9331)() ? "_self" : "_blank",
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                className: "fas fa-link add-hover",
                                "aria-hidden": "true",
                                children: " "
                            }),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        className: "fas fa-eye add-hover",
                        "aria-hidden": "true",
                        onClick: ()=>showIntegrationShowModal(integration)
                    }),
                    handleDelete != null && (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("delete_integration") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        className: "fas fa-trash remove-hover",
                        "aria-hidden": "true",
                        onClick: ()=>handleDelete(integration)
                    }) : null
                ]
            })
        ]
    }, integration.api_key);
}
var $0ff5529709b098a3$export$2e2bcd8739ae039 = $0ff5529709b098a3$var$IntegrationCodeLine;







var $73d4654afbc24d04$export$2e2bcd8739ae039 = {
    //getIntegrations : (data) => client.get(`integrations`,data),
    getIntegrationsIvy: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`integrations`, {
            ...data,
            type: 0
        }),
    getIntegrationsWorksheet: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`integrations`, {
            ...data,
            type: 2
        }),
    addIntegration: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`integration`, data),
    deleteIntegration: (name, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`integration/${name}`, data),
    updateIntegration: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`integration/${id}/update`, data),
    getIntegration: (name)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`${name}/integration`)
};




parcelRequire("kEUo3");



function $4dcd12f1bfc905af$var$IntegrationTableIvy() {
    const [integrations, setIntegrations] = (0, $bh6RR.useState)([]);
    const [search, setSearch] = (0, $bh6RR.useState)("");
    const [fetching, setFetching] = (0, $bh6RR.useState)(false);
    const [param, setParam] = (0, $bh6RR.useState)({
        page: 1,
        filter: {}
    });
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    var integrationsListTotal = [];
    const { getIntegrationsIvy: getIntegrationsIvy, deleteIntegration: deleteIntegration } = (0, $73d4654afbc24d04$export$2e2bcd8739ae039);
    const getIntegrationsList = async ()=>{
        const { page: page, filters: filters } = param;
        setFetching(true);
        let [response, error] = await getIntegrationsIvy({
            page: page,
            term: search
        });
        if (error !== null) {
            console.log(error);
            return;
        }
        integrationsListTotal = integrations;
        for(let i = 0; i < response.data.length; i++){
            let newIntegration = response.data[i];
            if (!integrations.some((integ)=>integ.id === newIntegration.id)) integrationsListTotal = [
                ...integrationsListTotal,
                newIntegration
            ];
        }
        setIntegrations(integrationsListTotal);
        setFetching(false);
        return response.data;
    };
    const onClickAdd = ()=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/plugin/integrations/create"));
    const onClickDelete = async (integration)=>{
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete Integration " + integration.name,
            body: "Do you really want to delete Integration " + integration.name,
            api: {
                request: deleteIntegration,
                param: [
                    integration.id
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel"
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ]
        });
        setIntegrations((current)=>current.filter((obj)=>{
                return obj.id !== integration.id;
            }));
    };
    const onScroll = (e)=>{
        const { scrollHeight: scrollHeight, scrollTop: scrollTop, clientHeight: clientHeight } = e.target;
        if (scrollHeight - scrollTop - clientHeight > 40) return null;
        addPage();
    };
    (0, $bh6RR.useEffect)(()=>{
        document.getElementsByClassName("page")[0].addEventListener("scroll", onScroll);
        return ()=>{
            var page = document.getElementsByClassName("page")[0];
            if (page) document.getElementsByClassName("page")[0].removeEventListener("scroll", onScroll);
        };
    }, [
        fetching
    ]);
    const research = async (_search)=>{
        integrationsListTotal = [];
        setSearch(_search);
        setParam({
            page: 1,
            filters: {}
        });
        let [response, error] = await getIntegrationsIvy({
            page: 1,
            term: _search
        });
        if (error !== null) {
            console.log(error);
            return;
        }
        setIntegrations(response.data);
    };
    (0, $bh6RR.useEffect)(()=>{
        getIntegrationsList();
    }, [
        param.page
    ]);
    const addPage = ()=>{
        if (fetching == true) return;
        setParam({
            page: param.page + 1,
            filter: param.filter
        });
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        onScroll: (e)=>onScroll(e),
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                style: {
                    display: "flex"
                },
                className: "up_row-integrations",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "input_integrations_container",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "input_integrations",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b8b90ec975873f14$export$2e2bcd8739ae039), {
                                placeholderLibelle: "content",
                                onChange: (e)=>research(e.target.value)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "add_button_container",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            children: (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("create_integration") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                onClick: (e)=>onClickAdd(),
                                icon: "fas fa-plus",
                                className: "main-iconButton profil_action main_add-button"
                            }) : null
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "integrations_table_container",
                children: Array.isArray(integrations) && integrations.map((integration, i)=>{
                    let value = integration.api_key + "&question=Hello";
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0ff5529709b098a3$export$2e2bcd8739ae039), {
                        integration: integration,
                        text: value,
                        handleDelete: onClickDelete,
                        api_key: integration.api_key
                    }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)());
                })
            })
        ]
    });
}
var $4dcd12f1bfc905af$export$2e2bcd8739ae039 = $4dcd12f1bfc905af$var$IntegrationTableIvy;




var $bh6RR = parcelRequire("bh6RR");












function $b82060c45504a2ad$var$IntegrationTableWorksheet() {
    const [integrations, setIntegrations] = (0, $bh6RR.useState)([]);
    const [search, setSearch] = (0, $bh6RR.useState)("");
    const [fetching, setFetching] = (0, $bh6RR.useState)(false);
    const [param, setParam] = (0, $bh6RR.useState)({
        page: 1,
        filter: {}
    });
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    var integrationsListTotal = [];
    const { getIntegrationsWorksheet: getIntegrationsWorksheet, deleteIntegration: deleteIntegration } = (0, $73d4654afbc24d04$export$2e2bcd8739ae039);
    const getIntegrationsList = async ()=>{
        const { page: page, filters: filters } = param;
        setFetching(true);
        let [response, error] = await getIntegrationsWorksheet({
            page: page,
            term: search
        });
        if (error !== null) {
            console.log(error);
            return;
        }
        integrationsListTotal = integrations;
        for(let i = 0; i < response.data.length; i++){
            let newIntegration = response.data[i];
            if (!integrations.some((integ)=>integ.id === newIntegration.id)) integrationsListTotal = [
                ...integrationsListTotal,
                newIntegration
            ];
        }
        setIntegrations(integrationsListTotal);
        setFetching(false);
        return response.data;
    };
    const onClickAdd = ()=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/plugin/integrations/create"));
    const onClickDelete = async (integration)=>{
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete Integration " + integration.name,
            body: "Do you really want to delete Integration " + integration.name,
            api: {
                request: deleteIntegration,
                param: [
                    integration.id
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel"
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ]
        });
        setIntegrations((current)=>current.filter((obj)=>{
                return obj.id !== integration.id;
            }));
    };
    const onScroll = (e)=>{
        const { scrollHeight: scrollHeight, scrollTop: scrollTop, clientHeight: clientHeight } = e.target;
        if (scrollHeight - scrollTop - clientHeight > 40) return null;
        addPage();
    };
    (0, $bh6RR.useEffect)(()=>{
        document.getElementsByClassName("page")[0].addEventListener("scroll", onScroll);
        return ()=>{
            var page = document.getElementsByClassName("page")[0];
            if (page) document.getElementsByClassName("page")[0].removeEventListener("scroll", onScroll);
        };
    }, [
        fetching
    ]);
    const research = async (_search)=>{
        integrationsListTotal = [];
        setSearch(_search);
        setParam({
            page: 1,
            filters: {}
        });
        let [response, error] = await getIntegrationsWorksheet({
            page: 1,
            term: _search
        });
        if (error !== null) {
            console.log(error);
            return;
        }
        setIntegrations(response.data);
    };
    (0, $bh6RR.useEffect)(()=>{
        getIntegrationsList();
    }, [
        param.page
    ]);
    const addPage = ()=>{
        if (fetching == true) return;
        setParam({
            page: param.page + 1,
            filter: param.filter
        });
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        onScroll: (e)=>onScroll(e),
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                style: {
                    display: "flex"
                },
                className: "up_row-integrations",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "input_integrations_container",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "input_integrations",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b8b90ec975873f14$export$2e2bcd8739ae039), {
                                placeholderLibelle: "content",
                                onChange: (e)=>research(e.target.value)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "add_button_container",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            children: (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("create_integration") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                onClick: (e)=>onClickAdd(),
                                icon: "fas fa-plus",
                                className: "main-iconButton profil_action main_add-button"
                            }) : null
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "integrations_table_container",
                children: Array.isArray(integrations) && integrations.map((integration, i)=>{
                    let value = integration.api_key + "&question=Hello";
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0ff5529709b098a3$export$2e2bcd8739ae039), {
                        integration: integration,
                        text: value,
                        handleDelete: onClickDelete,
                        api_key: integration.api_key
                    }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)());
                })
            })
        ]
    });
}
var $b82060c45504a2ad$export$2e2bcd8739ae039 = $b82060c45504a2ad$var$IntegrationTableWorksheet;




function $6d58a1f5c9466e96$var$IntegrationList() {
    const items = [
        {
            name: "Ivy",
            component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4dcd12f1bfc905af$export$2e2bcd8739ae039), {})
        },
        {
            name: "Worksheet",
            component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b82060c45504a2ad$export$2e2bcd8739ae039), {})
        }
    ];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: "API Key Manager"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5c5c6a9b8c6e5949$export$2e2bcd8739ae039), {
                items: items,
                name: "datasets"
            })
        ]
    });
}
var $6d58a1f5c9466e96$export$2e2bcd8739ae039 = $6d58a1f5c9466e96$var$IntegrationList;






var $bh6RR = parcelRequire("bh6RR");
var $5d0962a4086378c9$exports = {};
$5d0962a4086378c9$exports = new URL("client.392e5cad.svg", import.meta.url).toString();















var $8dac04df7aeae6b2$export$2e2bcd8739ae039 = [
    //{ text : "Ivy (IA)", value : 1},
    {
        text: "Conversational",
        value: 1
    },
    {
        text: "Worksheet",
        value: 3
    }
];




function $d0fd6a845a20fa3b$var$IntegrationForm({ data: data, type: type }) {
    const [listDatasets, setListDatasets] = (0, $bh6RR.useState)("");
    const [listCheckedDataset, setListCheckedDataset] = (0, $bh6RR.useState)([]);
    const { getDatasetsIvy: getDatasetsIvy, getDatasetsWorksheet: getDatasetsWorksheet } = (0, $cef77ca5b38a78fa$export$2e2bcd8739ae039);
    const { addIntegration: addIntegration } = (0, $73d4654afbc24d04$export$2e2bcd8739ae039);
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const currentCompany = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company");
    const { register: register, handleSubmit: handleSubmit, getValues: getValues, setValue: setValue, watch: watch, formState: { errors: errors }, formState: formState } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            name: "",
            datasets: [],
            language: "fr",
            active: true,
            integration_type_id: 1
        }
    });
    const setUpDataset = async (type)=>{
        var res = [];
        var [res, error] = type == 3 ? await getDatasetsWorksheet({
            public: true
        }) : await getDatasetsIvy({
            public: true
        });
        if (error != null) {
            console.error(error);
            return;
        }
        setListDatasets(res);
    };
    const setType = async (type)=>{
        setUpDataset(type);
        setValue("integration_type_id", type);
    };
    (0, $bh6RR.useEffect)(()=>{
        setUpDataset(0);
    }, []);
    const checkDataset = (_faq)=>{
        let result = listCheckedDataset;
        if (result.filter((dataset)=>{
            return dataset.id == _faq.id;
        }).length == 0) {
            result.push(_faq);
            setListCheckedDataset(result);
            document.getElementById(_faq.id + "button").style.color = "var(--green)";
            document.getElementById(_faq.id + "button").children[0].classList = "fas fa-check-circle";
        } else {
            let index = listCheckedDataset.findIndex((dataset)=>dataset.id === _faq.id);
            result.splice(index, 1);
            setListCheckedDataset(result);
            document.getElementById(_faq.id + "button").style.color = "var(--main)";
            document.getElementById(_faq.id + "button").children[0].classList = "fas fa-plus-circle";
        }
        checkForm();
    };
    const checkForm = ()=>{
        document.getElementById("submit_integration_form").disabled = !(getValues("name").length >= 3 && listCheckedDataset.length > 0);
    };
    const onSubmit = async ()=>{
        setValue("datasets", listCheckedDataset);
        var dataToSend = getValues();
        let [response, error] = await addIntegration(dataToSend);
        if (error !== null) {
            console.log(error);
            return;
        }
        return navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/plugin/integrations/list"));
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                children: "Create a new Api \uD83D\uDD11"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "botForm-container",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            label: "Name of your Integration",
                            listLabelClassName: "titles-input",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ...register("name", {
                                        required: true,
                                        minLength: 3,
                                        onChange: ()=>checkForm()
                                    }),
                                    style: errors.name ? {
                                        borderColor: "red"
                                    } : {}
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "error",
                                    children: errors.name ? "At least 3 letters" : ""
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "container_integration_dropdown",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Select your language",
                                listLabelClassName: "titles-input"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                style: {
                                    marginLeft: "15%",
                                    marginTop: "2%"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                    ...register("language"),
                                    setValue: setValue,
                                    choices: (0, $9f25a7789d4433b1$export$2e2bcd8739ae039),
                                    defaultChoice: "fr",
                                    width: "181px"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "container_integration_dropdown",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Type Integration",
                                listLabelClassName: "titles-input"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                style: {
                                    marginLeft: "15%",
                                    marginTop: "2%"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                    ...register("integration_type_id"),
                                    setValue: (name, value)=>setType(value),
                                    choices: (0, $8dac04df7aeae6b2$export$2e2bcd8739ae039),
                                    defaultChoice: "1",
                                    width: "181px"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "botForm-container",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            label: "Select some datasets",
                            listLabelClassName: "titles-input"
                        })
                    }),
                    Array.isArray(listDatasets) ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "dataset-list",
                        children: listDatasets.map((dataset, i)=>{
                            let isShared = dataset.company.id != currentCompany.id;
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "dataset-block",
                                "data-checked": "false",
                                "data-id": dataset.id,
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                        className: "container_dataset_row",
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                                style: {
                                                    width: isShared ? "30px" : "20px"
                                                },
                                                src: isShared ? dataset.company.logo : (0, (/*@__PURE__*/$parcel$interopDefault($5d0962a4086378c9$exports)))
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                className: "integration_title_dataset",
                                                title: dataset.name,
                                                children: [
                                                    dataset.name,
                                                    " "
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                            id: dataset.id + "button",
                                            className: "main-iconButton add-hover modalButtons-input",
                                            icon: "fas fa-plus-circle",
                                            onClick: (e)=>checkDataset(dataset)
                                        })
                                    })
                                ]
                            }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)());
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                    id: "submit_integration_form",
                    type: "submit",
                    label: "Validate",
                    className: "validate",
                    disabled: true
                })
            })
        ]
    });
}
var $d0fd6a845a20fa3b$export$2e2bcd8739ae039 = $d0fd6a845a20fa3b$var$IntegrationForm;



function $3235b8eff5d27d88$var$IntegrationList() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $afaae2ff7871e331$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d0fd6a845a20fa3b$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f0aded74899c8465$export$2e2bcd8739ae039), {})
        ]
    });
}
var $3235b8eff5d27d88$export$2e2bcd8739ae039 = $3235b8eff5d27d88$var$IntegrationList;








var $d3c5a1341563d560$export$2e2bcd8739ae039 = {
    getMigrations: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`migrations/list`, data),
    getMigration: (name, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`migration/${name}`, data),
    addMigration: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`migration`, data),
    deleteMigration: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`migration/${id}`, data),
    updateMigration: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`migration/${id}`, data)
};









parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");











const $efefc5149ea830a0$export$e3afc3733aaabf60 = (e)=>{
    e.currentTarget.style.height = "0px";
    e.currentTarget.style.height = e.currentTarget.scrollHeight - 20 + "px";
};





function $4be8edbbe13cdf11$var$MigrationModalBody({ form: form }) {
    const data = form.data;
    const { register: register, setError: setError, clearErrors: clearErrors, handleSubmit: handleSubmit, control: control, formState: { errors: errors }, formState: formState, getValues: getValues, setValue: setValue } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            name: data.name,
            create_new_bot: data.create_new_bot ? true : false,
            secret_token: data.secret_token,
            server: !isEmpty(data) && data.config.server ? data.config.server : (0, $651df53b10514175$export$a7b6bc01c63cdfc3).REACT_APP_API_PATH,
            datasets: {
                ignore: !isEmpty(data) && data.config.datasets && data.config.datasets.ignore ? data.config.datasets.ignore.join(", ") : "",
                empty: !isEmpty(data) && data.config.datasets && data.config.datasets.empty ? data.config.datasets.empty.join(", ") : "",
                replace: !isEmpty(data) && data.config.datasets && data.config.datasets.replace ? Object.keys(data.config.datasets.replace).map((value)=>`${data.config.datasets.replace[value].join(",")}=${value}`).join("\n") : ""
            }
        }
    });
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const { addMigration: addMigration, updateMigration: updateMigration } = (0, $d3c5a1341563d560$export$2e2bcd8739ae039);
    const onSubmit = async ()=>{
        let values = getValues();
        const { server: server, datasets: datasets, name: name, secret_token: secret_token, create_new_bot: create_new_bot } = values;
        let dataToSend = {
            create_new_bot: create_new_bot,
            name: name,
            secret_token: secret_token,
            config: {
                server: server,
                datasets: datasets
            }
        };
        if (dataToSend.config.datasets.ignore) dataToSend.config.datasets.ignore = dataToSend.config.datasets.ignore.split(",").map((a)=>a.trim());
        else delete dataToSend.config.datasets.ignore;
        if (dataToSend.config.datasets.empty) dataToSend.config.datasets.empty = dataToSend.config.datasets.empty.split(",").map((a)=>a.trim());
        else delete dataToSend.config.datasets.empty;
        let goodReplace = true;
        if (dataToSend.config.datasets.replace) {
            let tempData = dataToSend.config.datasets.replace.split("\n").map((a)=>a.split("=")).filter((a)=>a.length == 2);
            if (tempData.length == 0) goodReplace = false;
            else {
                let object = {};
                tempData.map((item)=>object[item[1]] = item[0].split(",").map((a)=>a.trim()));
                dataToSend.config.datasets.replace = object;
            }
        }
        if (!dataToSend.config.datasets.replace || !goodReplace) delete dataToSend.config.datasets.replace;
        if (Object.keys(dataToSend.config.datasets).length == 0) delete dataToSend.config.datasets;
        dataToSend.create_new_bot = dataToSend.create_new_bot ? 1 : 0;
        if (data.id != undefined) {
            let [response, error] = await updateMigration(data.id, dataToSend);
            if (error !== null) {
                console.log(error);
                return;
            }
            modal.resolve(response);
            onClose({});
            return;
        }
        let [response, error] = await addMigration(dataToSend);
        if (error !== null) {
            console.log(error);
            return;
        }
        modal.resolve(response);
        onClose({});
        return;
    };
    (0, $bh6RR.useEffect)(()=>{
        let node = document.getElementById("area-datasets-replace");
        node.style.height = node.scrollHeight - 20 + "px";
    }, []);
    function isEmpty(data) {
        return Object.keys(data).length === 0;
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
            className: "edit-container",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                    children: form.title
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                    className: "body-editModal-container migration_container",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "modal-bar",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                        style: {
                                            display: "flex"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                label: "Create new bot if already exist"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                                checked: getValues("create_new_bot"),
                                                ...register("create_new_bot"),
                                                onChange: ()=>setValue("create_new_bot", !getValues("create_new_bot"))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                label: "Name"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                                ...register("name", {
                                                    required: true,
                                                    minLength: 3
                                                }),
                                                style: errors.name ? {
                                                    borderColor: "red"
                                                } : {},
                                                placeholder: "Choose your name"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                        style: {
                                            marginTop: "15px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                label: "Server"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                                ...register("server", {
                                                    required: true,
                                                    minLength: 3
                                                }),
                                                style: errors.server ? {
                                                    borderColor: "red"
                                                } : {},
                                                placeholder: "Enter your server"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                        style: {
                                            marginTop: "15px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                label: "Token"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                                ...register("secret_token", {
                                                    required: true,
                                                    minLength: 3
                                                }),
                                                style: errors.secret_token ? {
                                                    borderColor: "red"
                                                } : {},
                                                placeholder: "Enter your bot token"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "statement-container",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    style: {
                                        marginTop: "15px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Dataset ignored"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("datasets.ignore", {
                                                required: false,
                                                minLength: 1
                                            }),
                                            style: errors.datasets && errors.datasets.ignore ? {
                                                borderColor: "red"
                                            } : {},
                                            placeholder: "faq1, faq2 ect..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    style: {
                                        marginTop: "15px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Dataset imported but empty"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("datasets.empty", {
                                                required: false,
                                                minLength: 1
                                            }),
                                            style: errors.datasets && errors.datasets.empty ? {
                                                borderColor: "red"
                                            } : {},
                                            placeholder: "faq1, faq2 ect..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    style: {
                                        marginTop: "15px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Words replace in dataset"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0db11626bd290ec1$export$2e2bcd8739ae039), {
                                            id: "area-datasets-replace",
                                            onInput: (e)=>(0, $efefc5149ea830a0$export$e3afc3733aaabf60)(e),
                                            ...register("datasets.replace", {
                                                required: false,
                                                minLength: 1
                                            }),
                                            style: errors.datasets && errors.datasets.replace ? {
                                                borderColor: "red"
                                            } : {},
                                            placeholder: "babar,toto=elephant\nbanana,orange=other"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        type: "submit",
                        label: data.id ? "Update" : "Add",
                        disabled: !formState.isValid,
                        onSubmit: form.onSubmit
                    })
                })
            ]
        })
    });
}
var // <TextArea id="area_migration" onInput={(e)=> adaptTextAreaSize(e)} {...register('config', { required: true, minLength: 1, validate : value=>isJsonValid(value) })} style={errors.config ? { borderColor: "red" } : {}} placeholder="Configure your migration" />
$4be8edbbe13cdf11$export$2e2bcd8739ae039 = $4be8edbbe13cdf11$var$MigrationModalBody;




const $c1538aca5251a9e3$var$MigrationModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ title: title, data: data })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const form = {
        title: title,
        data: data ? data : {}
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $9c2d88d3df32f983$export$2e2bcd8739ae039), {
        name: "change-password",
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4be8edbbe13cdf11$export$2e2bcd8739ae039), {
                form: form
            })
        ]
    });
});
var $c1538aca5251a9e3$export$2e2bcd8739ae039 = $c1538aca5251a9e3$var$MigrationModal;



parcelRequire("bh6RR");











const $80df9f161cf152cf$var$MigrationModalImport = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ title: title, data: data })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const dispatch = (0, $373f9505ebba8636$export$a03a56d03840936f)();
    const NB_LETTER_TEXT = 20;
    const importRequest = (e)=>{
        if (e.target.innerText == "Close") return onClose();
        const url = `${(0, $651df53b10514175$export$a7b6bc01c63cdfc3).REACT_APP_API_PATH}/bot/migrate/${data.id}?token_auth=${(0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("token")}&company=${(0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company").id}`;
        e.target.disabled = true;
        e.target.innerText = "Importing";
        var title = document.querySelector(".first-row .title");
        const DELTA = 50;
        var paddingDot = title ? title.clientHeight - DELTA : 0;
        var paddingButton = paddingDot ? paddingDot / DELTA + 1 : 1;
        var button = document.querySelector(".last-row");
        button.style.paddingTop = `${paddingButton * 20}px`;
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.send(null);
        var interval = null;
        xhr.onreadystatechange = async ()=>{
            if (xhr.status != 200) return;
            if (xhr.readyState == XMLHttpRequest.HEADERS_RECEIVED && interval == null) {
                var i = 0;
                interval = setInterval(()=>document.getElementById("dots").innerText = Array(i = i > 2 ? 0 : i + 1).fill(".").join(""), 500);
            }
            if (xhr.readyState == XMLHttpRequest.LOADING) {
                let data = xhr.response.split("}").map((a)=>`${a}}`);
                data.pop();
                let actionJson = data.pop();
                var action = JSON.parse(actionJson);
                let progressbar = document.getElementById("progressbar");
                let information = document.getElementById("information-text");
                let dots = document.getElementById("dots");
                if (action.percent == null) {
                    clearInterval(interval);
                    progressbar.style.backgroundColor = "var(--pink)";
                    information.innerHTML = `${information.innerHTML}<br>Press ctrl + maj + i to get the error in the console`;
                    console.error(`${action.message[0]} line ${action.message[1]} in file ${action.message[2]}`);
                    e.target.className = "button cancel";
                    e.target.innerText = "Failed";
                    dots.style.display = "none";
                } else {
                    information.innerHTML = action.message;
                    dots.style.left = `${information.offsetWidth / 2 + window.innerWidth / 2 + 3}px`;
                    let height = window.innerHeight / 2 - 4 + paddingDot;
                    dots.style.top = `${height}px`;
                    progressbar.style.width = `${action.percent}%`;
                    progressbar.innerHTML = `${action.percent}%`;
                }
            //let tmpWidth = inputSpan.current.offsetWidth + paddingOffset;
            //let maxWidth = sizeOfDiv - divName.current.offsetWidth + paddingOffset;
            //tmpWidth = tmpWidth > maxWidth ? maxWidth : tmpWidth
            }
            if (xhr.readyState == XMLHttpRequest.DONE) {
                clearInterval(interval);
                e.target.disabled = false;
                e.target.innerText = "Close";
                document.getElementById("dots").style.display = "none";
                if (document.getElementById("progressbar").innerHTML != "100%") return;
                var data = await (0, $575009abb68f6393$export$2e2bcd8739ae039).refreshUserInformation();
                if (!data) return;
                const { user: user, company: company, permissions: permissions } = data;
                (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").set("user", user);
                (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").set("company", company);
                (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").set("permissions", permissions);
                dispatch({
                    type: "refreshUserInfo",
                    payload: {
                        user: user,
                        token: (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("token")
                    }
                });
            //console.log('response',xhr.response);
            }
        };
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        name: "migration-import",
        id: modal.id,
        autoClose: false,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
                className: "modal-import",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                        className: "title-migrations-import",
                        children: [
                            "Run migration ",
                            data.name,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "modal-import-container",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        id: "progressbar",
                                        children: "0%"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    id: "information",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            id: "information-text",
                                            style: {
                                                textAlign: "center",
                                                fontWeight: "bold",
                                                position: "absolute"
                                            },
                                            children: [
                                                "Migration ",
                                                data.name.length > NB_LETTER_TEXT ? data.name.slice(0, NB_LETTER_TEXT) + "... " : data.name,
                                                " is ready"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            id: "dots",
                                            style: {
                                                color: "#6e6e6e"
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                        className: "migration_import_start_button",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                            className: "validate",
                            label: "Start",
                            type: "button",
                            onClick: importRequest
                        })
                    })
                ]
            })
        ]
    });
});
var // <TextArea id="area_migration" onInput={(e)=> adaptTextAreaSize(e)} {...register('config', { required: true, minLength: 1, validate : value=>isJsonValid(value) })} style={errors.config ? { borderColor: "red" } : {}} placeholder="Configure your migration" />
$80df9f161cf152cf$export$2e2bcd8739ae039 = $80df9f161cf152cf$var$MigrationModalImport;






function $37cdfb7ba4c5afd8$var$MigrationTable() {
    const { getMigrations: getMigrations, deleteMigration: deleteMigration } = (0, $d3c5a1341563d560$export$2e2bcd8739ae039);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const currentUser = JSON.parse(window.sessionStorage.getItem("user"));
    const cells = [
        {
            column: "NAME",
            name: "name",
            sort: true,
            show: (value)=>(0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value)
        },
        {
            column: "TOKEN",
            name: "secret_token",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    style: {
                        color: "var(--main)",
                        cursor: "pointer"
                    },
                    onClick: (e)=>navigator.clipboard.writeText(value).then((_)=>{
                            toast.success("Copy token to clipboard", "You can paste this token where you need !", 5000);
                        }),
                    children: [
                        " ",
                        (0, $2ec34e35a5139fe7$export$2e2bcd8739ae039)(value),
                        " "
                    ]
                })
        },
        {
            column: "LAST MIGRATION",
            name: "updated_at",
            sort: true,
            show: (value)=>(0, $df9ad4654a227866$export$3ae94a2503e890a1)(value)
        }
    ];
    const filters = [
        {
            type: "input",
            placeholder: "Name",
            name: "term"
        }
    ];
    const showEditModal = ({ updateRow: updateRow, row: row })=>{
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $c1538aca5251a9e3$export$2e2bcd8739ae039), {
            title: "Modify your Migration",
            nameDataset: name,
            data: {
                ...row
            }
        }).then((statement)=>updateRow(statement));
    };
    const showRunImportModal = ({ updateRow: updateRow, row: row })=>{
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $80df9f161cf152cf$export$2e2bcd8739ae039), {
            title: "Run migration",
            nameDataset: name,
            data: {
                ...row
            }
        }).then((statement)=>updateRow(statement));
    };
    const showAddModal = ({ addRow: addRow })=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $c1538aca5251a9e3$export$2e2bcd8739ae039), {
            nameDataset: name,
            title: "Add your Migration"
        }).then((statement)=>addRow(statement));
    const onClickDelete = ({ row: row, deleteRow: deleteRow })=>{
        const { id: id } = row;
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete Migration ",
            body: "Do you really want to delete migration for secret token bot " + row.secret_token + " ?",
            api: {
                request: deleteMigration,
                param: [
                    id
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel",
                    style: {
                        marginRight: "20px"
                    },
                    onClick: ()=>{}
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ]
        }).then(()=>deleteRow(id));
    };
    const actions = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_migration") ? {
            className: "fas fa-edit action-button edit_action",
            style: {},
            onClick: showEditModal
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_migrations") ? {
            className: "fas fa-cloud action-button profil_action",
            style: {
                paddingLeft: "7px",
                paddingRight: "13px"
            },
            onClick: showRunImportModal
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("delete_migration") ? {
            className: "fas fa-trash action-button delete_action",
            style: {},
            onClick: onClickDelete
        } : null
    ].filter((action)=>action);
    const buttons = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("create_migration") ? {
            icon: "fas fa-plus",
            onClick: showAddModal
        } : null
    ].filter((button)=>button);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: "List Migrations"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "entete-dataset",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "entete-dataset",
                    style: {
                        width: "115px"
                    }
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "warning_migrations_container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                    listClassName: "warning_migrations",
                    children: "Running a migration can overwrite an existing Dataset or Bot which has the same name. Be careful !"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
                name: "Migration",
                cells: cells,
                api: getMigrations,
                actions: actions,
                buttons: buttons,
                filters: filters
            })
        ]
    });
}
var $37cdfb7ba4c5afd8$export$2e2bcd8739ae039 = $37cdfb7ba4c5afd8$var$MigrationTable;


function $555ce3a04235906d$var$MigrationList() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $37cdfb7ba4c5afd8$export$2e2bcd8739ae039), {});
}
var $555ce3a04235906d$export$2e2bcd8739ae039 = $555ce3a04235906d$var$MigrationList;


const $281d11e810535ce5$var$routes = [
    {
        path: "company/:company/plugin/channels/list",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ef3c6878639fcd9f$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "view_channels"
        ]
    },
    {
        path: "company/:company/plugin/integrations/list",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6d58a1f5c9466e96$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "view_integrations"
        ]
    },
    {
        path: "company/:company/plugin/integrations/create",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3235b8eff5d27d88$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "create_integration"
        ]
    },
    {
        path: "company/:company/plugin/migrations/list",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $555ce3a04235906d$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "update_integration"
        ]
    },
    {
        path: "company/:company/channel/create",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $59bd91311554e810$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "create_channel"
        ]
    },
    {
        path: "company/:company/channels/update",
        component: (data)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ef3c6878639fcd9f$export$2e2bcd8739ae039), {
                data: data
            }),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "update_channel"
        ]
    }
];
var $281d11e810535ce5$export$2e2bcd8739ae039 = $281d11e810535ce5$var$routes;












var $e2bea698183eb612$export$2e2bcd8739ae039 = {
    getCompanies: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`companies`, data),
    getCompaniesWithoutPagination: ()=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`companies`),
    getCompany: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`company/${id}`, data),
    addCompany: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`company`, data),
    updateCompany: (id, formData)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`company/${id}`, formData),
    deleteCompany: (id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`company/${id}`),
    //getCompaniesAutocomplete : (name) => client.get(`autocomplete/company/name?term=${name}`)
    getCompaniesAutocomplete: (name)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`companies?name=${name}`)
};



parcelRequire("bh6RR");








var $bh6RR = parcelRequire("bh6RR");










var $8e81d56c61e78b8c$export$2e2bcd8739ae039 = {
    getUsers: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`users`, data),
    getUser: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`user/${id}`, data),
    addUser: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`user`, data),
    updateUser: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`user/${id}`, data),
    deleteUser: (id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`user/${id}`),
    getHistories: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`user/${id}/logs`, data),
    checkAvaibility: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("user/check-availability", data),
    //getUsersAutocomplete : (name) => client.get(`autocomplete/user/name?term=${name}`)
    getUsersAutocomplete: (name)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`users?username=${name}`)
};


function $0b33cd4b35f2c016$var$FormCompany({ form: form, onSend: onSend }) {
    const data = {
        id: form.id,
        name: form.name,
        image: form.logo,
        owner: form.owner,
        api_key_rag: form.api_key_rag
    };
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors }, getValues: getValues, setValue: setValue } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            id: data.id,
            image: data.image,
            owner: data.owner,
            api_key_rag: data.api_key_rag
        }
    });
    const { addCompany: addCompany, updateCompany: updateCompany } = (0, $e2bea698183eb612$export$2e2bcd8739ae039);
    const { getUsersAutocomplete: getUsersAutocomplete } = (0, $8e81d56c61e78b8c$export$2e2bcd8739ae039);
    const [file, setFile] = (0, $bh6RR.useState)(data.image);
    const [loadAnim, setLoading] = (0, $bh6RR.useState)(null);
    const onSubmit = async ()=>{
        var dataToSend = getValues();
        const formData = new (0, (/*@__PURE__*/$parcel$interopDefault($07d55ecd4e888d68$exports)))();
        formData.append("name", dataToSend.name);
        if (dataToSend.api_key_rag) formData.append("api_key_rag", dataToSend.api_key_rag);
        if (data.image != file) // useless to change the same picture
        formData.append("image", file);
        // A RAJOUTER PLUS TARD LE OWNER
        if (data.id != undefined) {
            // mean we are in update form since we have data
            if (dataToSend.owner != data.owner) formData.append("owner_id", dataToSend.owner);
            let [response, error] = await updateCompany(data.id, formData);
            if (error !== null) {
                console.log(error);
                return;
            }
            formData.id = response._id;
            if (onSend != null) onSend(response);
            return;
        }
        let [response, error] = await addCompany(formData);
        if (error !== null) {
            console.log(error);
            return;
        }
        formData.id = response._id;
        if (onSend != null) onSend(response);
        return;
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
            className: "edit-container",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                    children: form.title
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                    className: "body-editModal-container",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "modal-bar",
                            style: {
                                display: "block"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    style: {
                                        marginBottom: "15px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Name"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("name", {
                                                required: true,
                                                minLength: 1
                                            }),
                                            style: errors.label ? {
                                                borderColor: "red"
                                            } : {},
                                            className: "full-width input_company_ModalBody",
                                            defaultValue: data ? data.name : "",
                                            placeholder: "Choose your name"
                                        })
                                    ]
                                }),
                                data.name ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Owner of the organization"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $785e69526abf5040$export$2e2bcd8739ae039), {
                                            name: "owner",
                                            value: data?.owner,
                                            className: "full-width input_company_ModalBody",
                                            getItemValue: (name, item)=>setValue(name, item.id),
                                            apiCall: getUsersAutocomplete,
                                            getImageFromItem: (item)=>item.picture,
                                            placeholder: "Choose the owner",
                                            getNameFromItem: (item)=>item.username
                                        })
                                    ]
                                }) : "",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    style: {
                                        marginTop: "15px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "API Key (RAG)"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("api_key_rag"),
                                            style: errors.api_key_rag ? {
                                                borderColor: "red"
                                            } : {},
                                            className: "full-width input_company_ModalBody",
                                            defaultValue: data ? data.api_key_rag : "",
                                            placeholder: "Enter API Key"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                        label: "Logo"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $47da697040d42413$export$2e2bcd8739ae039), {
                                        _setFile: setFile,
                                        defaultValueImage: data.image,
                                        accept: ".png,.jpg,.jpeg",
                                        loadAnim: loadAnim,
                                        colorBorder: "inset 0 0 0 1px #dddddd;"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        type: "submit",
                        label: data.id ? "Update" : "Add",
                        disabled: Object.keys(errors).length != 0,
                        onSubmit: onSubmit
                    })
                })
            ]
        })
    });
}
var $0b33cd4b35f2c016$export$2e2bcd8739ae039 = $0b33cd4b35f2c016$var$FormCompany;


function $6fa508e80b49d9cb$var$CompanyModalBody({ form: form }) {
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0b33cd4b35f2c016$export$2e2bcd8739ae039), {
            form: form,
            onSend: (e)=>{
                onClose();
                modal.resolve(e);
            }
        })
    });
}
var $6fa508e80b49d9cb$export$2e2bcd8739ae039 = $6fa508e80b49d9cb$var$CompanyModalBody;




const $dd1654c630bf6ab4$var$CompanyModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ title: title, data: data })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const form = {
        id: data == undefined ? null : data.id,
        name: data == undefined ? null : data.name,
        title: title,
        logo: data == undefined ? null : data.logo,
        owner: data == undefined ? null : data.owner?.username,
        api_key_rag: data == undefined ? null : data.api_key_rag
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $9c2d88d3df32f983$export$2e2bcd8739ae039), {
        name: "change-password",
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6fa508e80b49d9cb$export$2e2bcd8739ae039), {
                form: form
            })
        ]
    });
});
var $dd1654c630bf6ab4$export$2e2bcd8739ae039 = $dd1654c630bf6ab4$var$CompanyModal;






const { changeCompany: $abf5d39ca5c52d92$var$changeCompany } = (0, $575009abb68f6393$export$2e2bcd8739ae039);
const $abf5d39ca5c52d92$export$b84e4c64185fb95 = async (id, navigate)=>{
    const res = await $abf5d39ca5c52d92$var$changeCompany(id);
    if (res.error != null) return;
    navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("home"));
};


const $da2068bd2c317854$export$3026e5a52c747d2c = Object.freeze({
    Administrator: 0,
    Client: 1
});
function $da2068bd2c317854$export$7383f122bf48ec30(access) {
    return access == $da2068bd2c317854$export$3026e5a52c747d2c.Client;
}
function $da2068bd2c317854$export$fc970ed23da99565(access) {
    return access == $da2068bd2c317854$export$3026e5a52c747d2c.Administrator;
}


function $750ec55192f11fa3$var$CompanyTable() {
    const { getCompanies: getCompanies, deleteCompany: deleteCompany } = (0, $e2bea698183eb612$export$2e2bcd8739ae039);
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const handleSwitch = async (id)=>{
        await (0, $abf5d39ca5c52d92$export$b84e4c64185fb95)(id, navigate);
    };
    const cells = [
        {
            column: "ID",
            name: "id",
            sort: true,
            show: (value)=>value
        },
        {
            column: "AVATAR",
            name: [
                "logo",
                "name",
                "id"
            ],
            show: ([logo, name, id])=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    srcSet: logo,
                    title: name,
                    alt: "",
                    style: {
                        cursor: "pointer"
                    },
                    onClick: ()=>handleSwitch(id)
                })
        },
        {
            column: "ORGANIZATIONS",
            name: [
                "name",
                "id"
            ],
            sort: true,
            show: ([name, id])=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                    className: "organization-link",
                    onClick: ()=>handleSwitch(id),
                    children: name
                })
        },
        {
            column: "NUMBER OF USERS",
            name: "users",
            sort: true,
            show: (value)=>value.length
        },
        {
            column: "NUMBER OF BOTS",
            name: "bots",
            sort: true,
            show: (value)=>value.length
        },
        {
            column: "CREATION",
            name: "created_at",
            sort: true,
            show: (value)=>(0, $df9ad4654a227866$export$3ae94a2503e890a1)(value)
        }
    ];
    const showAddModal = ({ addRow: addRow })=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $dd1654c630bf6ab4$export$2e2bcd8739ae039), {
            title: "Create a new Organization"
        }).then((company)=>addRow(company));
    const showEditModal = ({ updateRow: updateRow, row: row })=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $dd1654c630bf6ab4$export$2e2bcd8739ae039), {
            title: "Modify your Organization",
            data: {
                ...row
            }
        }).then((company)=>updateRow(company));
    const onClickShowHistory = ({ row: row })=>navigate(`/administration/company/logs`, {
            state: {
                data: row
            }
        });
    const onClickDelete = async ({ row: row, deleteRow: deleteRow })=>{
        const { id: id, name: name } = row;
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete organization " + name,
            body: "Do you really want to delete organization " + name,
            api: {
                request: deleteCompany,
                param: [
                    row.id
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel",
                    style: {
                        marginRight: "20px"
                    }
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ],
            confirm: {
                name: row.name,
                fieldName: "the organization"
            }
        }).then(()=>deleteRow(id));
    };
    const onClickSwitch = ({ row: row })=>{
        const { id: id } = row;
        handleSwitch(id);
    };
    const actions = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_organization") ? {
            className: "fas fa-cog action-button edit_action",
            style: {},
            onClick: showEditModal
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_organization") ? {
            className: "fas fa-edit action-button edit_action",
            style: {},
            onClick: onClickSwitch
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_organization") ? {
            className: "fas fa-history action-button edit_action",
            style: {},
            onClick: onClickShowHistory
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("delete_organization") ? {
            className: "fas fa-trash action-button delete_action",
            style: {},
            onClick: onClickDelete
        } : null
    ].filter((action)=>action);
    const buttons = [
        (0, $da2068bd2c317854$export$fc970ed23da99565) ? {
            icon: "fas fa-magnifying-glass",
            onClick: ()=>window.open("https://app.talkr.ai/bot/test/86-685-RC6xz54wbbFJgE1TkGmkVkoc6RxHs7Yx", "_blank", "noopener,noreferrer")
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("create_organization") ? {
            icon: "fas fa-plus",
            onClick: showAddModal
        } : null
    ].filter((button)=>button);
    const filters = [
        {
            type: "input",
            placeholder: "Name",
            name: "name"
        }
    ];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: "Manage Organizations"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "entete-dataset",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "entete-dataset",
                    style: {
                        width: "115px"
                    }
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
                name: "Organization",
                cells: cells,
                api: getCompanies,
                actions: actions,
                buttons: buttons,
                filters: filters
            })
        ]
    });
}
var $750ec55192f11fa3$export$2e2bcd8739ae039 = $750ec55192f11fa3$var$CompanyTable;


function $b22549fe7ff54578$var$CompanyList() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $750ec55192f11fa3$export$2e2bcd8739ae039), {});
}
var $b22549fe7ff54578$export$2e2bcd8739ae039 = $b22549fe7ff54578$var$CompanyList;












parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");

















const $f0f30c93a49e4e3e$export$7a7a82d81a2bcbe9 = [
    {
        value: "production",
        text: "Production"
    },
    {
        value: "free",
        text: "Free"
    },
    {
        value: "preprod_customers",
        text: "Preprod customers"
    },
    {
        value: "tests_customers",
        text: "Tests customers"
    },
    {
        value: "tests_internal",
        text: "Tests internal"
    }
];
function $f0f30c93a49e4e3e$export$83a6645d9dfcd983(value) {
    const status = $f0f30c93a49e4e3e$export$7a7a82d81a2bcbe9.find((s)=>s.value === value);
    return status ? status.text : "-";
}


function $a3bb75359303d6e4$var$PhoneModalBody({ form: form }) {
    const storage = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local");
    const { is_admin: is_admin } = storage.get("user");
    const [phoneAvailable, setPhoneAvailable] = (0, $bh6RR.useState)({
        numbers: true
    });
    const company = form.company;
    const channel = form.channel;
    const data = {
        phone_id: form.id ?? null,
        ...form,
        company_id: form.company?.id ?? form.company_id ?? null,
        channel_id: form.channel?.id ?? form.channel_id ?? null,
        country: form.country ?? {
            alpha_code_2: "fr"
        },
        max_simultaneous_call: form.max_simultaneous_call ?? 1,
        is_mutu: form.is_mutu ?? false,
        status: form.status ?? "free",
        in: form.in ?? false,
        out: form.out ?? false,
        telephony_partner: form.telephony_partner ?? null,
        number_owner: form.number_owner ?? null,
        contact_reference: form.contact_reference ?? null
    };
    const { register: register, setError: setError, clearErrors: clearErrors, watch: watch, handleSubmit: handleSubmit, control: control, formState: { errors: errors }, formState: formState, getValues: getValues, setValue: setValue } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            country: data.country.alpha_code_2.toLowerCase(),
            numbers: data.numbers,
            is_mutu: data.is_mutu,
            company_id: data.company_id,
            max_simultaneous_call: data.max_simultaneous_call,
            libelle: data.libelle,
            channel_id: data.channel_id,
            telephony_partner: data.telephony_partner,
            number_owner: data.number_owner,
            contact_reference: data.contact_reference,
            status: data.status,
            in: data.in,
            out: data.out
        }
    });
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const { addPhone: addPhone, updatePhone: updatePhone, checkPhoneAvailability: checkPhoneAvailability } = (0, $c67d9f619ac86d97$export$2e2bcd8739ae039);
    const { getCompaniesAutocomplete: getCompaniesAutocomplete } = (0, $e2bea698183eb612$export$2e2bcd8739ae039);
    const { getChannelsAutocomplete: getChannelsAutocomplete } = (0, $c664cd598f09e2f9$export$2e2bcd8739ae039);
    const onSubmit = async ()=>{
        var dataToSend = getValues();
        // A RAJOUTER PLUS TARD LE OWNER
        /*
        if (data.phone_id != undefined) {     // mean we are in update form since we have data
            dataToSend.country = dataToSend.country.alpha_code_2
        }
        */ let [response, error] = data.phone_id ? await updatePhone(data.phone_id, dataToSend) : await addPhone(dataToSend);
        if (error !== null) {
            console.log(error);
            return;
        }
        modal.resolve(response);
        onClose();
        return;
    };
    const checkValues = async (title, value)=>{
        let dataToSend = [];
        value = value.replace(/\s+/g, "");
        dataToSend[title] = value;
        if (value.length == 0) return;
        let [response, error] = await checkPhoneAvailability(dataToSend);
        if (error !== null) {
            console.log(error);
            return;
        }
        let res = phoneAvailable;
        res[title] = response.available;
        if (data != null && value === data[title]) res[title] = true;
        setPhoneAvailable({
            ...res
        });
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
            className: "edit-container",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                    children: form.title
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                    className: "body-editModal-container",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            style: {
                                marginTop: "25px",
                                display: "flex",
                                marginBottom: "25px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Country Code"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    style: {
                                        marginLeft: "15%",
                                        marginTop: "2%"
                                    },
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                        ...register("country"),
                                        setValue: setValue,
                                        choices: (0, $9f25a7789d4433b1$export$2e2bcd8739ae039),
                                        defaultChoice: data.country ? data.country.alpha_code_2.toLowerCase() : "fr",
                                        width: "165px"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            style: {
                                display: "block",
                                paddingBottom: "8px",
                                marginBottom: "8px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "champs_phone_modal",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                                children: [
                                                    " Number ",
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                        className: "obligatory_field",
                                                        children: "*"
                                                    }),
                                                    " "
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("numbers", {
                                                required: true,
                                                minLength: 10,
                                                onChange: (e)=>checkValues("numbers", e.target.value)
                                            }),
                                            style: errors.numbers || phoneAvailable.numbers == false ? {
                                                borderColor: "red"
                                            } : {},
                                            className: "full-width input_user_ModalBody",
                                            defaultValue: data ? data.numbers : "",
                                            placeholder: "Enter a phone number",
                                            disabled: data.is_mutu
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "champs_phone_modal",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                                children: [
                                                    " Amount of call simultaneous ",
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                        className: "obligatory_field",
                                                        children: "*"
                                                    }),
                                                    " "
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("max_simultaneous_call", {
                                                required: true
                                            }),
                                            style: errors.numbers ? {
                                                borderColor: "red"
                                            } : {},
                                            className: "full-width input_user_ModalBody",
                                            defaultValue: data ? data.max_simultaneous_call : "1",
                                            placeholder: "Enter your amount of call simultaneous"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "champs_phone_modal",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Telephony Partner"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("telephony_partner"),
                                            className: "full-width input_user_ModalBody"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "champs_phone_modal",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Number Owner"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("number_owner"),
                                            className: "full-width input_user_ModalBody"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "champs_phone_modal",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Contact Reference"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("contact_reference"),
                                            className: "full-width input_user_ModalBody"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "champs_phone_modal",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                        style: {
                                            marginTop: "40px",
                                            marginBottom: "25px",
                                            display: "flex",
                                            gap: "4rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                label: "Status",
                                                listLabelClassName: "titles-input"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                style: {
                                                    marginLeft: "5%",
                                                    marginTop: "2%"
                                                },
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                                    ...register("status"),
                                                    setValue: setValue,
                                                    choices: (0, $f0f30c93a49e4e3e$export$7a7a82d81a2bcbe9),
                                                    defaultChoice: data.status ?? "free",
                                                    width: "300px"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "grid-row",
                                    style: {
                                        display: "flex"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "In :",
                                            listClassName: "labels_form_phones"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            className: "dropdown_container",
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                                name: "in",
                                                checked: watch("in"),
                                                onChange: (e)=>setValue("in", e.target.checked)
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "grid-row",
                                    style: {
                                        display: "flex"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Out :",
                                            listClassName: "labels_form_phones"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            className: "dropdown_container",
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                                name: "out",
                                                checked: watch("out"),
                                                onChange: (e)=>setValue("out", e.target.checked)
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "champs_phone_modal",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                                children: [
                                                    " Description ",
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                        className: "obligatory_field",
                                                        children: "*"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("libelle", {
                                                required: true,
                                                minLength: 3
                                            }),
                                            style: errors.libelle ? {
                                                borderColor: "red"
                                            } : {},
                                            className: "full-width input_user_ModalBody",
                                            defaultValue: data ? data.libelle : "",
                                            placeholder: "Enter a libelle"
                                        })
                                    ]
                                })
                            ]
                        }),
                        data.is_mutu == false ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "champs_phone_modal",
                            style: {
                                display: is_admin ? "block" : "none"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Organization"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $785e69526abf5040$export$2e2bcd8739ae039), {
                                    name: "company_id",
                                    value: company?.name,
                                    className: "full-width input_user_ModalBody",
                                    getItemValue: (name, item)=>setValue(name, item.id),
                                    apiCall: getCompaniesAutocomplete,
                                    getImageFromItem: (item)=>item.logo,
                                    placeholder: "Choose your organization"
                                })
                            ]
                        }) : null,
                        watch("company_id") != null && Number.isInteger(watch("company_id")) ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "champs_phone_modal",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Channel Name"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $785e69526abf5040$export$2e2bcd8739ae039), {
                                    name: "channel_id",
                                    value: channel?.name,
                                    className: "full-width input_user_ModalBody",
                                    getItemValue: (name, item)=>setValue(name, item.id),
                                    apiCall: getChannelsAutocomplete,
                                    paramsApi: {
                                        company: getValues("company_id")
                                    },
                                    getImageFromItem: (item)=>item.company_logo,
                                    placeholder: "Choose your channel"
                                })
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        type: "submit",
                        label: data.phone_id ? "Update" : "Add",
                        disabled: !formState.isValid || phoneAvailable.numbers == false,
                        onSubmit: onSubmit
                    })
                })
            ]
        })
    });
}
var $a3bb75359303d6e4$export$2e2bcd8739ae039 = $a3bb75359303d6e4$var$PhoneModalBody;





const $95f3283f7e71eae5$var$PhoneModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ title: title, data: data })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const { getCompany: getCompany } = (0, $e2bea698183eb612$export$2e2bcd8739ae039);
    //const form = { title: title, id: data == undefined ? null : data.id, channel: data == undefined ? null : data.channel, company: data == undefined ? null : data.company, country: data == undefined ? null : data.country, libelle: data == undefined ? null : data.libelle, numbers: data == undefined ? null : data.numbers, max_simultaneous_call : data == undefined ? null : data.max_simultaneous_call, is_mutu : data == undefined ? null : data.is_mutu }
    const form = {
        title: title,
        ...data
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $9c2d88d3df32f983$export$2e2bcd8739ae039), {
        name: "change-password",
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a3bb75359303d6e4$export$2e2bcd8739ae039), {
                form: form
            })
        ]
    });
});
var $95f3283f7e71eae5$export$2e2bcd8739ae039 = $95f3283f7e71eae5$var$PhoneModal;






var $bh6RR = parcelRequire("bh6RR");










const $56c2de3b167e7e3d$var$ImportPhonesModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ nameBot: nameBot, title: title, data: data })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { importPhones: importPhones } = (0, $c67d9f619ac86d97$export$2e2bcd8739ae039);
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const [file, setFile] = (0, $bh6RR.useState)();
    const [loadAnim, setLoading] = (0, $bh6RR.useState)(null);
    const onSubmit = async ()=>{
        const formData = new (0, (/*@__PURE__*/$parcel$interopDefault($07d55ecd4e888d68$exports)))();
        formData.append("phones", file);
        let [response, error] = await importPhones(formData);
        if (error !== null) {
            console.log(error);
            return;
        }
        setLoading("finish");
        setTimeout(()=>{
            onClose();
        }, 2000);
    };
    function timeout(ms) {
        return new Promise((resolve)=>setTimeout(resolve, ms));
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        name: "change-password",
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "leave-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
                className: "form-import",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                        children: "Import some Phone Numbers"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                        className: "form-import_body",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $47da697040d42413$export$2e2bcd8739ae039), {
                            _setFile: setFile,
                            accept: ".xlsx,.csv",
                            loadAnim: loadAnim
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "button_center",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                className: "validate",
                                label: "Upload",
                                disabled: file != null ? false : true,
                                onClick: ()=>{
                                    onSubmit();
                                    setLoading(true);
                                }
                            })
                        })
                    })
                ]
            })
        ]
    });
});
var $56c2de3b167e7e3d$export$2e2bcd8739ae039 = $56c2de3b167e7e3d$var$ImportPhonesModal;




const $6fa58a9c96b5552d$var$formatPhoneNumber = (inputPhoneNumber)=>{
    if (!inputPhoneNumber) return "";
    const cleanPhoneNumber = inputPhoneNumber.replace(/\D/g, "");
    let formattedNumber = cleanPhoneNumber.match(/.{1,2}/g);
    formattedNumber = formattedNumber == null ? "" : cleanPhoneNumber.match(/.{1,2}/g).join(" ");
    return formattedNumber;
};
var $6fa58a9c96b5552d$export$2e2bcd8739ae039 = $6fa58a9c96b5552d$var$formatPhoneNumber;




function $5be175629095b112$var$PhoneTable() {
    const { getPhone: getPhone, getPhones: getPhones, deletePhone: deletePhone } = (0, $c67d9f619ac86d97$export$2e2bcd8739ae039);
    const storage = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local");
    const { is_admin: is_admin } = storage.get("user");
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const handleSwitch = async (id)=>{
        await (0, $abf5d39ca5c52d92$export$b84e4c64185fb95)(id, navigate);
    };
    var cells = [
        {
            column: "NUMBER",
            name: "numbers",
            sort: true,
            show: (value)=>(0, $6fa58a9c96b5552d$export$2e2bcd8739ae039)(value)
        },
        {
            column: "DESCRIPTION",
            name: "libelle",
            show: (value)=>value
        },
        {
            column: "PARTNER",
            name: "telephony_partner",
            sort: true,
            show: (value)=>value ?? "-"
        },
        {
            column: "OWNER",
            name: "number_owner",
            sort: true,
            show: (value)=>value ?? "-"
        },
        {
            column: "JAMBONZ TRUNK",
            name: "jambonz_trunk_name",
            sort: true,
            show: (value)=>value ?? "-"
        },
        {
            column: "JAMBONZ ROUTING",
            name: "jambonz_app_routing",
            sort: true,
            show: (value)=>value ?? "-"
        },
        {
            column: "REFERENCE",
            name: "contact_reference",
            sort: true,
            show: (value)=>value ?? "-"
        },
        {
            column: "STATUS",
            name: "status",
            sort: true,
            show: (value)=>(0, $f0f30c93a49e4e3e$export$83a6645d9dfcd983)(value)
        },
        {
            column: "IN",
            name: "in",
            sort: true,
            show: (value)=>value ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    className: "fa fa-check",
                    "aria-hidden": "true",
                    style: {
                        color: "var(--main)"
                    }
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    style: {
                        color: "var(--main)",
                        fontWeight: "bolder"
                    },
                    children: "X"
                })
        },
        {
            column: "OUT",
            name: "out",
            sort: true,
            show: (value)=>value ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    className: "fa fa-check",
                    "aria-hidden": "true",
                    style: {
                        color: "var(--main)"
                    }
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    style: {
                        color: "var(--main)",
                        fontWeight: "bolder"
                    },
                    children: "X"
                })
        }
    ];
    if (is_admin) cells = [
        ...cells,
        {
            column: "ORGANIZATIONS",
            name: [
                "company.logo",
                "company.name",
                "company.id"
            ],
            show: ([logo, name1, id])=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    srcSet: logo,
                    title: name1,
                    style: {
                        cursor: "pointer"
                    },
                    onClick: ()=>handleSwitch(id)
                })
        },
        {
            column: "MAX_SIMULTANEOUS_CALL",
            name: "max_simultaneous_call",
            sort: true,
            show: (value)=>value
        }
    ];
    cells = [
        ...cells,
        {
            column: "Channel",
            name: "channel.name",
            show: (value)=>value
        }
    ];
    const showAddModal = ({ addRow: addRow })=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $95f3283f7e71eae5$export$2e2bcd8739ae039), {
            title: "Add a new Phone number"
        }).then((phone)=>addRow(phone));
    const showEditModal = ({ updateRow: updateRow, row: row })=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $95f3283f7e71eae5$export$2e2bcd8739ae039), {
            title: "Modify Bot Telephony",
            data: {
                ...row
            }
        }).then((company)=>updateRow(company));
    const onClickDelete = async ({ row: row, deleteRow: deleteRow })=>{
        const { id: id, numbers: numbers } = row;
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete phone " + numbers,
            body: "Do you really want to delete phone " + numbers,
            api: {
                request: deletePhone,
                param: [
                    id,
                    numbers
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel",
                    style: {
                        marginRight: "20px"
                    }
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ]
        }).then(()=>deleteRow(id));
    };
    const actions = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_phone") ? {
            className: "fas fa-cog action-button edit_action",
            style: {},
            onClick: showEditModal
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("delete_phone") ? {
            className: "fas fa-trash action-button delete_action",
            style: {},
            onClick: onClickDelete,
            condition: "is_mutu",
            condition_match: true
        } : null
    ].filter((action)=>action);
    const buttons = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("create_phone") ? {
            icon: "fas fa-plus",
            onClick: showAddModal
        } : null
    ].filter((button)=>button);
    const filters = [
        {
            type: "input",
            placeholder: "terms",
            name: "numbers"
        }
    ];
    const showImportModal = ()=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $56c2de3b167e7e3d$export$2e2bcd8739ae039), {
            nameBot: name
        });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: "Manage Phones",
                children: (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("import_phones") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                    onClick: showImportModal,
                    className: "icons_up main-iconButton profil_action main_add-button space_tableButton",
                    icon: "fas fa-upload"
                }) : null
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "entete-dataset",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "entete-dataset",
                    style: {
                        width: "115px"
                    }
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
                name: "Phone",
                cells: cells,
                api: getPhones,
                actions: actions,
                buttons: buttons,
                filters: filters
            })
        ]
    });
}
var $5be175629095b112$export$2e2bcd8739ae039 = $5be175629095b112$var$PhoneTable;


function $196e592e589b2436$var$PhoneList() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5be175629095b112$export$2e2bcd8739ae039), {});
}
var $196e592e589b2436$export$2e2bcd8739ae039 = $196e592e589b2436$var$PhoneList;











parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");











var $6bb3ec19e42a3591$export$2e2bcd8739ae039 = {
    create: {
        title: "\uD83C\uDF96\uFE0F Create a new Role",
        send: "Create"
    },
    update: {
        title: "\uD83C\uDF96\uFE0F Update this Role",
        send: "Update"
    }
};



var $486873d7496d6dcd$export$2e2bcd8739ae039 = {
    getRoles: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`roles`, data),
    getPermissions: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`role/${id}/permissions`, data),
    addRole: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`role`, data),
    updateRole: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`role/${id}`, data),
    deleteRole: (id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`role/${id}`),
    attachPermission: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`roles/${id}/permissions/attach`, data),
    detachPermission: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`roles/${id}/permissions/detach`, data),
    checkAvailability: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`role/check-availability`, data),
    getRolesFilter: async (params = {}, data)=>{
        const queryString = Object.entries(params).map(([key, value])=>`${key}=${value}`).join("&");
        return (0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`roles?${queryString}`, data);
    }
};




var $1295df8e54aac5d6$exports = {};
$1295df8e54aac5d6$exports = new URL("role-cible.b394882c.png", import.meta.url).toString();


var $5c317b4ef923d809$exports = {};
$5c317b4ef923d809$exports = new URL("role-connector.986a1e38.png", import.meta.url).toString();


var $96ab2cc2a7187daf$exports = {};
$96ab2cc2a7187daf$exports = new URL("role-designer.19542c2b.png", import.meta.url).toString();


var $d2d664c7f7006800$exports = {};
$d2d664c7f7006800$exports = new URL("role-folowup.69d9d4fe.png", import.meta.url).toString();


var $55dd516e4afcf86a$exports = {};
$55dd516e4afcf86a$exports = new URL("role-look.77774f71.png", import.meta.url).toString();


var $98b11d138825d0b5$exports = {};
$98b11d138825d0b5$exports = new URL("role-stat.330abf49.png", import.meta.url).toString();


var $456e39182ba34e06$exports = {};
$456e39182ba34e06$exports = new URL("role-data.0efa2259.png", import.meta.url).toString();


const $dad7d4cf331e99ef$var$imagePaths = [
    (0, (/*@__PURE__*/$parcel$interopDefault($1295df8e54aac5d6$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($5c317b4ef923d809$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($96ab2cc2a7187daf$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d2d664c7f7006800$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($55dd516e4afcf86a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($98b11d138825d0b5$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($456e39182ba34e06$exports)))
];
const $dad7d4cf331e99ef$var$imageNames = [
    "roleCible",
    "roleConnector",
    "roleDesigner",
    "roleFolowup",
    "roleLook",
    "roleStat",
    "roleData"
];
const $dad7d4cf331e99ef$var$imageChoices = $dad7d4cf331e99ef$var$imagePaths.map((path, index)=>({
        value: $dad7d4cf331e99ef$var$imageNames[index],
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            src: path,
            alt: `Image ${index + 1}`
        })
    }));
var // imageChoices.push({
//   value: 'importFile',
//   text: 'Import my logo',
// });
$dad7d4cf331e99ef$export$2e2bcd8739ae039 = $dad7d4cf331e99ef$var$imageChoices;





function $491fc0c82309d074$var$RoleModalBody({ data: data, type: type }) {
    const currentUser = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("user");
    const formData = (0, $6bb3ec19e42a3591$export$2e2bcd8739ae039)[type ? type : "create"];
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    formData.values = data;
    const [file, setFile] = (0, $bh6RR.useState)(data?.image);
    const { addRole: addRole, updateRole: updateRole, checkAvailability: checkAvailability } = (0, $486873d7496d6dcd$export$2e2bcd8739ae039);
    const { getCompaniesAutocomplete: getCompaniesAutocomplete } = (0, $e2bea698183eb612$export$2e2bcd8739ae039);
    const [roleAvailable, setRoleAvailable] = (0, $bh6RR.useState)({
        slug: true
    });
    const { register: register, setError: setError, clearErrors: clearErrors, handleSubmit: handleSubmit, watch: watch, formState: { errors: errors }, formState: formState, setValue: setValue, getValues: getValues } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            slug: formData.values ? formData.values.slug : "",
            name: formData.values ? formData.values.name : "",
            avatar: formData.values ? formData.values.logo : "",
            company_id: formData.values ? formData.values.company_id : null
        }
    });
    const onSubmit = async ()=>{
        const dataToSend = getValues();
        let formData = new FormData();
        formData.append("slug", dataToSend.slug);
        formData.append("name", dataToSend.name);
        formData.append("avatar", dataToSend.avatar);
        formData.append("company_id", dataToSend.company_id !== undefined ? dataToSend.company_id : null);
        const [response, errors] = type != "create" ? await updateRole(data.id, formData) : await addRole(formData);
        if (errors != null) {
            console.log(errors);
            return;
        }
        modal.resolve(response);
        onClose();
        return;
    };
    const checkValues = async (title, value)=>{
        let dataToSend = [];
        dataToSend[title] = value;
        if (value.length == 0) return;
        let [response, error] = await checkAvailability(dataToSend);
        if (error !== null) {
            console.log(error);
            return;
        }
        let res = roleAvailable;
        res[title] = response.available;
        if (data != null && value === data[title]) res[title] = true;
        setRoleAvailable({
            ...res
        });
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
        className: "edit-container",
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                className: "form-title",
                children: formData.title
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                className: "body-editModal-container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "roleForm-container",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                children: [
                                    "Name ",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                        className: "obligatory_field",
                                        children: "*"
                                    }),
                                    " "
                                ]
                            }),
                            listLabelClassName: "titles-input",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ...register("slug", {
                                        required: true,
                                        onChange: (e)=>checkValues("slug", e.target.value)
                                    }),
                                    style: errors.slug || roleAvailable.slug == false ? {
                                        borderColor: "red"
                                    } : {},
                                    className: "text_input_user_form"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "error-display",
                                    children: errors.slug ? errors.slug.message ? errors.slug.message : "At least 3 letters, and no specials character" : ""
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "roleForm-container",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                children: [
                                    "Description ",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                        className: "obligatory_field",
                                        children: "*"
                                    }),
                                    " "
                                ]
                            }),
                            listLabelClassName: "titles-input",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0db11626bd290ec1$export$2e2bcd8739ae039), {
                                    style: {
                                        height: "40px",
                                        width: "85%",
                                        ...errors.name ? {
                                            borderColor: "red"
                                        } : {}
                                    },
                                    ...register("name", {
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "error-display",
                                    children: errors.name ? errors.name.message ? errors.name.message : "the description must have at least 5 characters" : ""
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        style: {
                            marginBottom: "25px",
                            display: "flex",
                            gap: "4rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Badge",
                                listLabelClassName: "titles-input"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                style: {
                                    marginLeft: "5%",
                                    marginTop: "2%"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                    ...register("avatar"),
                                    setValue: setValue,
                                    choices: (0, $dad7d4cf331e99ef$export$2e2bcd8739ae039),
                                    defaultChoice: type === "update" && formData.values && formData.values.logo ? formData.values.logo : (0, $dad7d4cf331e99ef$export$2e2bcd8739ae039)[0].value,
                                    width: "195px"
                                })
                            })
                        ]
                    }),
                    currentUser.is_admin ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Organization"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $785e69526abf5040$export$2e2bcd8739ae039), {
                                name: "company_id",
                                required: "true",
                                className: "full-width text_input_user_form_role",
                                getItemValue: (name, item)=>setValue(name, item.id),
                                apiCall: getCompaniesAutocomplete,
                                getImageFromItem: (item)=>item.logo,
                                placeholder: "Choose your organization",
                                value: data ? data?.company?.name : "",
                                style: {
                                    width: "285px"
                                }
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                    type: "submit",
                    label: formData.send,
                    className: "validate",
                    disabled: !formState.isValid || !roleAvailable.slug == true
                })
            })
        ]
    });
}
$491fc0c82309d074$var$RoleModalBody.defaultProps = {
    data: {},
    type: "create"
};
var $491fc0c82309d074$export$2e2bcd8739ae039 = $491fc0c82309d074$var$RoleModalBody;


const $85524a0a807b1df2$var$RoleModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ title: title, data: data, type: type })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $9c2d88d3df32f983$export$2e2bcd8739ae039), {
        name: "change-password",
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $491fc0c82309d074$export$2e2bcd8739ae039), {
                data: data,
                type: type
            })
        ]
    });
});
var $85524a0a807b1df2$export$2e2bcd8739ae039 = $85524a0a807b1df2$var$RoleModal;




var $bh6RR = parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");









function $d0816a83ab34ebd5$var$PermissionIcon({ slug: slug, onClick: onClick }) {
    if (slug.includes("view")) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
        className: "fas fa-eye item-icon",
        onClick: onClick
    });
    else if (slug.includes("create") || slug.includes("add")) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
        className: "fas fa-plus item-icon",
        onClick: onClick
    });
    else if (slug.includes("import")) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
        className: "fas fa-upload item-icon",
        onClick: onClick
    });
    else if (slug.includes("update")) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
        className: "fas fa-edit item-icon",
        onClick: onClick
    });
    else if (slug.includes("delete")) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
        className: "fas fa-trash item-icon",
        onClick: onClick
    });
    else if (slug.includes("expel")) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
        className: "fas fa-ban item-icon",
        onClick: onClick
    });
    else if (slug.includes("export")) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
        className: "fas fa-download item-icon",
        onClick: onClick
    });
    else if (slug.includes("change_password")) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
        className: "fas fa-exchange-alt item-icon",
        onClick: onClick
    });
    else if (slug.includes("change_company")) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
        className: "fas fa-sync item-icon",
        onClick: onClick
    });
    else if (slug.includes("run")) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
        className: "fas fa-play item-icon",
        onClick: onClick
    });
    else if (slug.includes("lock")) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
        className: "fas fa-lock item-icon",
        onClick: onClick
    });
    else if (slug.includes("erase")) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
        className: "fas fa-eraser item-icon",
        onClick: onClick
    });
    return null;
}
var $d0816a83ab34ebd5$export$2e2bcd8739ae039 = $d0816a83ab34ebd5$var$PermissionIcon;




parcelRequire("bh6RR");
const $97446c6d1d678d1b$var$SvgBotGrey = (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        width: 25,
        height: 25,
        viewBox: "0 0 17 12",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "M11.155 0A5.845 5.845 0 0 1 17 5.845v.31A5.845 5.845 0 0 1 11.155 12h-9.31A1.846 1.846 0 0 1 0 10.154v-4.31A5.845 5.845 0 0 1 5.845 0h5.31Zm.774 8.095a.784.784 0 0 0-.98-.52A8.323 8.323 0 0 1 8.5 7.95a8.323 8.323 0 0 1-2.449-.375.785.785 0 0 0-1.014.75v.143c0 .62.405 1.17.998 1.352.822.253 1.643.38 2.465.38.822 0 1.643-.127 2.465-.38.593-.183.998-.731.998-1.352v-.143a.784.784 0 0 0-.034-.23ZM5.426 2.4h-.148a1.5 1.5 0 1 0 0 3h.148a1.5 1.5 0 1 0 0-3Zm6.296 0h-.148a1.5 1.5 0 0 0 0 3h.148a1.5 1.5 0 0 0 0-3Z",
            fill: "silver",
            fillRule: "evenodd"
        })
    });
var $97446c6d1d678d1b$export$2e2bcd8739ae039 = $97446c6d1d678d1b$var$SvgBotGrey;



parcelRequire("bh6RR");
const $1d52ead6fd2cbbdd$var$SvgDataset = (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        width: 25,
        height: 25,
        viewBox: "0 0 12 12",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "M0 8.764C1.233 9.608 3.622 10 6 10s4.767-.392 6-1.235V10.4l-.04.086C11.5 11.344 8.99 12 6 12c-3.088 0-5.668-.7-6-1.6Zm12-2.8v1.438C11.995 8.394 9.306 9.2 6 9.2c-3.308 0-6-.808-6-1.8V5.964C1.233 6.808 3.622 7.2 6 7.2s4.767-.392 6-1.235Zm0-2.8v1.438C11.995 5.594 9.306 6.4 6 6.4c-3.308 0-6-.808-6-1.8V3.164C1.233 4.008 3.622 4.4 6 4.4s4.767-.392 6-1.235ZM6 0c3.314 0 6 .806 6 1.8S9.314 3.6 6 3.6c-3.313 0-6-.806-6-1.8S2.687 0 6 0Z",
            fill: "silver"
        })
    });
var $1d52ead6fd2cbbdd$export$2e2bcd8739ae039 = $1d52ead6fd2cbbdd$var$SvgDataset;



parcelRequire("bh6RR");
const $aa70acf9d48467ed$var$SvgDashboard = (props)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        className: "dashboard_svg__svg-icon",
        style: {
            width: 25,
            height: 25,
            verticalAlign: "middle",
            fill: "silver",
            overflow: "hidden"
        },
        viewBox: "0 0 1024 1024",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
            d: "M671.891 190.746c-8.148 0-14.994-2.556-20.546-7.668a68.603 68.603 0 0 1-13.883-17.87 92.056 92.056 0 0 1-8.324-20.937c-1.853-7.15-2.78-13.109-2.78-17.878V.755h2.221c6.662 0 12.957.679 18.876 2.045 5.927 1.358 13.14 4.593 21.656 9.698 8.516 5.112 18.876 12.262 31.09 21.456 12.222 9.186 27.584 21.28 46.092 36.266 19.987 16.336 35.9 30.124 47.746 41.363 11.846 11.232 20.913 20.77 27.208 28.598 6.286 7.829 10.176 14.475 11.662 19.923 1.478 5.448 2.213 10.209 2.213 14.299v16.343h-163.23zm345.346 481.098c2.22 5.448 3.707 12.262 4.442 20.434.742 8.172-2.956 16-11.104 23.485-3.699 3.411-7.03 6.646-9.985 9.706-2.972 3.067-5.56 5.623-7.78 7.668a53.441 53.441 0 0 1-7.773 6.127l-94.389-85.8a354.125 354.125 0 0 0 14.994-12.263 247.858 247.858 0 0 1 13.875-11.231c8.883-7.493 18.509-10.728 28.878-9.706 10.36 1.023 18.876 3.235 25.538 6.63 7.405 3.411 15.361 9.37 23.877 17.886 8.507 8.507 14.986 17.534 19.427 27.064zM625.256 766.84c16.28 0 29.972-4.082 41.083-12.254L450.905 960.92H144.422c-14.067 0-29.428-3.754-46.092-11.24a196.102 196.102 0 0 1-46.635-29.628 170.732 170.732 0 0 1-36.09-42.385c-9.618-16-14.435-32.512-14.435-49.543V132.52c0-14.298 3.514-29.276 10.544-44.941A147.063 147.063 0 0 1 40.6 45.185 174.127 174.127 0 0 1 82.242 13.52C97.779 5.013 114.067.755 131.106.755h425.292v127.683c0 12.941 2.22 26.897 6.662 41.875a133.435 133.435 0 0 0 20.545 41.37c9.259 12.598 21.289 23.15 36.091 31.666 14.802 8.515 32.576 12.765 53.305 12.765h162.121v338.1l-152.127 145.05c8.148-10.896 12.214-22.814 12.214-35.755 0-17.702-6.846-32.855-20.546-45.453-13.692-12.597-30.163-18.9-49.415-18.9H208.831c-19.244 0-35.532 6.303-48.856 18.9-13.324 12.598-19.986 27.751-19.986 45.453 0 17.71 6.662 32.688 19.986 44.942 13.324 12.262 29.612 18.389 48.864 18.389h416.425zM208.831 383.797c-19.252 0-35.54 6.303-48.864 18.9-13.324 12.598-19.986 27.743-19.986 45.453 0 17.702 6.662 32.688 19.986 44.942 13.324 12.254 29.612 18.389 48.864 18.389h416.425c19.244 0 35.707-6.135 49.407-18.39 13.7-12.253 20.546-27.239 20.546-44.94 0-17.71-6.846-32.856-20.546-45.454-13.692-12.597-30.163-18.9-49.415-18.9H208.831zm418.638 511.749 14.434-13.285 27.767-25.53a3832.34 3832.34 0 0 0 36.642-34.222 4000.148 4000.148 0 0 1 39.973-37.28c31.833-29.285 67.74-61.973 107.721-98.064l93.278 85.802-107.72 99.085-39.974 36.77-36.641 33.71a1433.563 1433.563 0 0 0-26.098 24.508c-7.03 6.814-10.92 10.56-11.663 11.24a496.635 496.635 0 0 1-12.214 8.683c-4.441 3.059-8.882 5.615-13.324 7.66-4.441 2.045-11.287 4.593-20.546 7.66a667.015 667.015 0 0 1-28.318 8.684 576.748 576.748 0 0 1-27.759 7.15c-8.883 2.045-15.545 3.403-19.986 4.082-8.883 1.357-14.81.343-17.766-3.06-2.964-3.403-3.707-9.194-2.22-17.366.734-4.082 2.22-10.217 4.44-18.39a375.137 375.137 0 0 1 7.773-25.018l8.324-24.005c2.596-7.493 4.633-12.597 6.11-15.321a81.136 81.136 0 0 1 17.767-23.493z"
        })
    });
var $aa70acf9d48467ed$export$2e2bcd8739ae039 = $aa70acf9d48467ed$var$SvgDashboard;


function $53451a0774556f4b$var$CategoryIcon() {
    const getCategoryIcon = (category)=>{
        switch(category){
            case "1":
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    style: {
                        fontSize: "18px"
                    },
                    children: "Bot"
                });
            case "2":
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    style: {
                        fontSize: "18px"
                    },
                    children: "Dataset"
                });
            case "3":
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    style: {
                        fontSize: "18px"
                    },
                    children: "Integrations"
                });
            case "4":
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    style: {
                        fontSize: "18px"
                    },
                    children: "Channel"
                });
            case "5":
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    style: {
                        fontSize: "18px"
                    },
                    children: "Analytics"
                });
            case "6":
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    style: {
                        fontSize: "18px"
                    },
                    children: "Conversations"
                });
            case "7":
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    style: {
                        fontSize: "18px"
                    },
                    children: "Dashboard"
                });
            case "8":
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    style: {
                        fontSize: "18px"
                    },
                    children: "Users"
                });
            case "9":
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    style: {
                        fontSize: "18px"
                    },
                    children: "Organizations"
                });
            case "10":
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    style: {
                        fontSize: "18px"
                    },
                    children: "Migrations"
                });
            case "11":
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    style: {
                        fontSize: "18px"
                    },
                    children: "Phones"
                });
            case "12":
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    style: {
                        fontSize: "18px"
                    },
                    children: "Roles"
                });
            case "13":
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    style: {
                        fontSize: "18px"
                    },
                    children: "Account"
                });
            case "14":
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    style: {
                        fontSize: "18px"
                    },
                    children: "Brains"
                });
            default:
                return null;
        }
    };
    return {
        getCategoryIcon: getCategoryIcon
    };
}
var $53451a0774556f4b$export$2e2bcd8739ae039 = $53451a0774556f4b$var$CategoryIcon;




function $8753e9cac0f52b4a$var$RolePermissionModalBody({ data: data, title: title, role: role }) {
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const { attachPermission: attachPermission, detachPermission: detachPermission } = (0, $486873d7496d6dcd$export$2e2bcd8739ae039);
    const [selectedPermissionIds, setSelectedPermissionIds] = (0, $bh6RR.useState)([]);
    const [deselectedPermissionIds, setDeselectedPermissionIds] = (0, $bh6RR.useState)([]);
    const [selectedPermissionCount, setSelectedPermissionCount] = (0, $bh6RR.useState)({});
    const { getCategoryIcon: getCategoryIcon } = (0, $53451a0774556f4b$export$2e2bcd8739ae039)();
    const [expandedCategory, setExpandedCategory] = (0, $bh6RR.useState)(null);
    const currentUser = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("user");
    const groupedPermissions = data;
    const { handleSubmit: handleSubmit } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {}
    });
    const handleCategoryIconClick = (categoryId)=>{
        if (expandedCategory === categoryId) setExpandedCategory(null);
        else setExpandedCategory(categoryId);
    };
    const onSubmit = async ()=>{
        const selectedIds = selectedPermissionIds.join(",");
        const deselectedIds = deselectedPermissionIds.join(",");
        if (selectedIds || deselectedIds) {
            let attach, detach;
            if (selectedIds && deselectedIds) {
                attach = attachPermission;
                detach = detachPermission;
            } else if (selectedIds) attach = attachPermission;
            else detach = detachPermission;
            if (attach) {
                const [response, errors] = await attach(role.id, {
                    permission: selectedIds
                });
                if (errors) console.error("Error attaching permissions.");
                else console.log("Permissions attached successfully.");
            }
            if (detach) {
                const [response, errors] = await detach(role.id, {
                    permission: deselectedIds
                });
                if (errors) console.error("Error detaching permissions.");
                else console.log("Permissions detached successfully.");
            }
            setSelectedPermissionIds([]);
            setDeselectedPermissionIds([]);
            onClose();
        } else console.log("No permissions selected or deselected.");
    };
    const handleIconClick = (permissionId)=>{
        const isActive = Object.values(groupedPermissions).some((group)=>group.some((permission)=>permission.id === permissionId && permission.is_active));
        if (selectedPermissionIds.includes(permissionId)) setSelectedPermissionIds((prev)=>prev.filter((id)=>id !== permissionId));
        else if (deselectedPermissionIds.includes(permissionId)) setDeselectedPermissionIds((prev)=>prev.filter((id)=>id !== permissionId));
        else if (isActive) setDeselectedPermissionIds((prev)=>[
                ...prev,
                permissionId
            ]);
        else setSelectedPermissionIds((prev)=>[
                ...prev,
                permissionId
            ]);
    };
    const handleSelectAll = (permissions)=>{
        const filteredPermissions = permissions.filter((permission)=>!selectedPermissionIds.includes(permission.id));
        const newPermissionIds = filteredPermissions.map((permission)=>permission.id);
        // Filtrer les identifiants des permissions sélectionnées depuis la base de données
        const dbSelectedPermissionIds = Object.values(groupedPermissions).flatMap((group)=>group.filter((permission)=>permission.is_active)).map((permission)=>permission.id);
        const finalPermissionIds = newPermissionIds.filter((id)=>!dbSelectedPermissionIds.includes(id));
        setSelectedPermissionIds((prevSelectedPermissionIds)=>[
                ...prevSelectedPermissionIds,
                ...finalPermissionIds.filter((id)=>!prevSelectedPermissionIds.includes(id))
            ]);
    };
    const handleDeselectAll = ()=>{
        setSelectedPermissionIds([]);
    };
    const customTitlePermission = (permissionName)=>{
        if (permissionName === "expel a user") permissionName = "expel a user from a company";
        if (permissionName === "delete a user") permissionName = "delete a user's account";
        return permissionName;
    };
    (0, $bh6RR.useEffect)(()=>{
        const newSelectedPermissionCount = {};
        Object.entries(data).forEach(([categoryId, permissions])=>{
            const selectedCount = permissions.filter((permission)=>selectedPermissionIds.includes(permission.id)).length;
            const deselectedCount = permissions.filter((permission)=>deselectedPermissionIds.includes(permission.id)).length;
            const activeCount = permissions.filter((permission)=>permissions.find((dbPermission)=>dbPermission.id === permission.id && dbPermission.is_active)).length;
            const totalCount = selectedCount + activeCount - deselectedCount;
            newSelectedPermissionCount[categoryId] = `${totalCount}/${permissions.length}`;
        });
        setSelectedPermissionCount(newSelectedPermissionCount);
    }, [
        selectedPermissionIds,
        deselectedPermissionIds
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
            className: "edit-container",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                    children: [
                        title,
                        " ",
                        role.slug
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                    className: "body-editModalPermission-container",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "permission_container",
                        children: Object.entries(groupedPermissions).map(([categoryId, permissions])=>permissions.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "list-module",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "module-item",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "category-icon",
                                            onClick: ()=>handleCategoryIconClick(categoryId),
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                    className: "category-name",
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                                            className: "main-iconButton profil_action main_add-button space_tableButton dashboard_button",
                                                            icon: expandedCategory === categoryId ? "fas fa-chevron-down" : "fas fa-chevron-right"
                                                        }),
                                                        getCategoryIcon(categoryId)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                                    style: {
                                                        fontSize: "16px",
                                                        color: "var(--main)",
                                                        marginRight: "5px"
                                                    },
                                                    children: [
                                                        "(",
                                                        selectedPermissionCount[categoryId],
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        }),
                                        expandedCategory === categoryId && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "permissions-dropdown",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    className: "select_permissions",
                                                    children: !(role.create_by_admin && !currentUser.is_admin) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                        className: "select-all-option",
                                                        onClick: ()=>handleSelectAll(permissions),
                                                        children: "Select All"
                                                    })
                                                }),
                                                permissions.filter((permission)=>!(permission.slug === "delete_user" && !currentUser.is_admin)).map((permission)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                        className: `module-item-icon-badge ${permission.slug === "view_home" || role.create_by_admin && !currentUser.is_admin ? "disabled" : ""}`,
                                                        title: customTitlePermission(permission.name),
                                                        children: [
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d0816a83ab34ebd5$export$2e2bcd8739ae039), {
                                                                slug: permission.slug,
                                                                onClick: ()=>handleIconClick(permission.id)
                                                            }),
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                                className: selectedPermissionIds.includes(permission.id) ? "badge-active" : deselectedPermissionIds.includes(permission.id) ? "badge-desactive" : permission.is_active ? "badge-active" : "badge-desactive"
                                                            })
                                                        ]
                                                    }, permission.id))
                                            ]
                                        })
                                    ]
                                })
                            }, categoryId))
                    })
                }),
                (currentUser.is_admin || !role.create_by_admin) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        type: "submit",
                        label: "OK",
                        style: {
                            marginTop: "230px"
                        },
                        onSubmit: onSubmit
                    })
                })
            ]
        })
    });
}
var $8753e9cac0f52b4a$export$2e2bcd8739ae039 = $8753e9cac0f52b4a$var$RolePermissionModalBody;





const $590848120bdcfd02$var$RolePermissionModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ title: title, role: role })=>{
    const currentUser = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("user");
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const { getPermissions: getPermissions } = (0, $486873d7496d6dcd$export$2e2bcd8739ae039);
    const [permissions, setPermissions] = (0, $bh6RR.useState)(null);
    const [loading, setLoading] = (0, $bh6RR.useState)(true);
    (0, $bh6RR.useEffect)(()=>{
        const fetchPermissions = async ()=>{
            try {
                const [response, errors] = await getPermissions(role.id);
                if (errors != null) {
                    console.log(errors);
                    return;
                }
                setPermissions(response);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching permissions:", error);
                setLoading(false);
            }
        };
        fetchPermissions();
    }, [
        role.id
    ]);
    // A SUPPRIMER : form | pas utilise pour le moment car user modal body pas utilisee
    // const form = { id: data == undefined ? null : data.id, username: data == undefined ? null : data.slug, is_admin: data == undefined ? null : data.is_admin, title: title, email: data == undefined ? null : data.email, company_name: data == undefined ? null : data.company.name, company_id : data == undefined ? null : data.company_id, picture: data == undefined ? null : data.picture }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $9c2d88d3df32f983$export$2e2bcd8739ae039), {
        name: "change-password",
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            !loading && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8753e9cac0f52b4a$export$2e2bcd8739ae039), {
                data: permissions,
                title: title,
                role: role
            })
        ]
    });
});
var $590848120bdcfd02$export$2e2bcd8739ae039 = $590848120bdcfd02$var$RolePermissionModal;



var $357e1df28db17bef$exports = {};
$357e1df28db17bef$exports = new URL("role-superadmin.e5ac9270.png", import.meta.url).toString();


var $3852d4475fc978fc$exports = {};
$3852d4475fc978fc$exports = new URL("role-partners.6b5079b7.png", import.meta.url).toString();






function $2c33583da79cb6fe$var$RoleTable() {
    const currentUser = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("user");
    const { getRoles: getRoles, deleteRole: deleteRole, updateRole: updateRole } = (0, $486873d7496d6dcd$export$2e2bcd8739ae039);
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const handleSwitch = async (id)=>{
        await (0, $abf5d39ca5c52d92$export$b84e4c64185fb95)(id, navigate);
    };
    const showImage = (logo, avatar, imageType, id)=>{
        if (id === 1) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($357e1df28db17bef$exports))),
            alt: "Role Admin"
        });
        else if (id === 2) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($3852d4475fc978fc$exports))),
            alt: "Role User"
        });
        else {
            const logoChoice = (0, $dad7d4cf331e99ef$export$2e2bcd8739ae039).find((choice)=>choice.value === logo);
            if (logoChoice && (imageType === "logo" || imageType === null)) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                src: logoChoice.text.props.src,
                alt: logoChoice.text.props.alt
            });
            else if (avatar && (imageType === "avatar" || imageType === null)) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                src: avatar,
                width: 24,
                height: 24,
                alt: avatar
            });
            else return null;
        }
    };
    var cells = [];
    if (currentUser.is_admin) cells = [
        {
            column: "Badge",
            name: [
                "logo",
                "avatar",
                "last_updated_attribute",
                "id"
            ],
            sort: false,
            show: ([logo, avatar, last_updated_attribute, id])=>showImage(logo, avatar, last_updated_attribute, id)
        },
        {
            column: "ROLENAME",
            name: "slug",
            sort: true,
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    children: value == "admin" ? "Super Admin" : value
                })
        },
        {
            column: "Organizations",
            name: [
                "company.name",
                "company.id"
            ],
            sort: {
                name: "company.name"
            },
            show: ([name, id])=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                    className: "organization-link",
                    onClick: ()=>handleSwitch(id),
                    children: name
                })
        },
        {
            column: "DESCRIPTION",
            name: "name",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    children: value == "Administrator" ? "Super Administrator" : value
                })
        }
    ];
    else cells = [
        {
            column: "Badge",
            name: [
                "logo",
                "avatar",
                "last_updated_attribute"
            ],
            sort: false,
            show: ([logo, avatar, last_updated_attribute])=>showImage(logo, avatar, last_updated_attribute)
        },
        {
            column: "ROLENAME",
            name: "slug",
            sort: true,
            show: (value)=>value
        },
        {
            column: "DESCRIPTION",
            name: "name",
            show: (value)=>value
        }
    ];
    const showPermissionModal = async ({ row: row, updateRow: updateRow })=>{
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $590848120bdcfd02$export$2e2bcd8739ae039), {
            title: "List Permissions",
            role: row
        }).then((role)=>updateRow(role));
    };
    const onClickAdd = ({ addRow: addRow })=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $85524a0a807b1df2$export$2e2bcd8739ae039), {
            title: "Create a new User"
        }).then((role)=>addRow(role));
    const onClickUpdate = async ({ row: row, updateRow: updateRow })=>{
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $85524a0a807b1df2$export$2e2bcd8739ae039), {
            title: "Modify your Role",
            data: {
                ...row
            },
            type: "update"
        }).then((role)=>updateRow(role));
    };
    const onClickDelete = async ({ row: row, deleteRow: deleteRow })=>{
        const { id: id, slug: slug } = row;
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete role " + slug,
            body: "Do you really want to delete this role " + slug,
            api: {
                request: deleteRole,
                param: [
                    row.id
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel",
                    style: {
                        marginRight: "20px"
                    }
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ],
            confirm: {
                name: slug,
                fieldName: "the role"
            }
        }).then(()=>deleteRow(id));
    };
    var actions = [];
    actions = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_role") ? {
            condition: "id",
            condition_match: [
                1,
                2
            ],
            ...!currentUser.is_admin && {
                other_condition: "create_by_admin",
                other_match: currentUser.is_admin ? 0 : 1
            },
            className: "fas fa-cog action-button edit_action",
            style: {},
            onClick: onClickUpdate
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_role") ? {
            condition: "id",
            condition_match: [
                1,
                2
            ],
            className: "fas fa-edit action-button profil_action",
            style: {},
            onClick: showPermissionModal
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("delete_role") ? {
            condition: "id",
            condition_match: [
                1,
                2
            ],
            ...!currentUser.is_admin && {
                other_condition: "create_by_admin",
                other_match: currentUser.is_admin ? 0 : 1
            },
            className: "fas fa-trash action-button delete_action",
            style: {},
            onClick: onClickDelete
        } : null
    ].filter((action)=>action);
    const buttons = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("create_role") ? {
            icon: "fas fa-plus",
            onClick: onClickAdd
        } : null
    ].filter((button)=>button);
    const filters = [
        {
            type: "input",
            placeholder: "content",
            name: "term"
        }
    ];
    const getRolesCallable = async (params)=>{
        if (currentUser.is_admin == false) params = {
            ...params,
            company_id: currentUser.company.id
        };
        return await getRoles(params);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: "List of Roles"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "entete-dataset",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "entete-dataset",
                    style: {
                        width: "115px"
                    }
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
                name: "role",
                cells: cells,
                api: getRolesCallable,
                actions: actions,
                buttons: buttons,
                filters: filters
            })
        ]
    });
}
var $2c33583da79cb6fe$export$2e2bcd8739ae039 = $2c33583da79cb6fe$var$RoleTable;


function $ced148e02704f9f9$var$RoleList() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2c33583da79cb6fe$export$2e2bcd8739ae039), {});
}
var $ced148e02704f9f9$export$2e2bcd8739ae039 = $ced148e02704f9f9$var$RoleList;











parcelRequire("bh6RR");







var $bh6RR = parcelRequire("bh6RR");






















function $66def9f09453b1b7$var$UserModalBodyAdmin({ data: data, title: title }) {
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const currentUser = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("user");
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors }, getValues: getValues, setValue: setValue, watch: watch } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            id: data ? data.id : "",
            username: data ? data.username : "",
            email: data ? data.email : "",
            company_id: data ? data.company?.id : "",
            companies: data ? data.companies : "",
            image: data ? data.image : "",
            company_role: data ? data.company_role : undefined,
            global_role: data ? data?.roles[0]?.id : undefined
        }
    });
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const { getCompaniesAutocomplete: getCompaniesAutocomplete, getCompanies: getCompanies } = (0, $e2bea698183eb612$export$2e2bcd8739ae039);
    const { addUser: addUser, updateUser: updateUser, checkAvaibility: checkAvaibility } = (0, $8e81d56c61e78b8c$export$2e2bcd8739ae039);
    const [listCheckedCompanies, setListCheckedCompanies] = (0, $bh6RR.useState)([]);
    const { getRolesFilter: getRolesFilter } = (0, $486873d7496d6dcd$export$2e2bcd8739ae039);
    const [roles, setRoles] = (0, $bh6RR.useState)([]);
    const [companies, setCompanies] = (0, $bh6RR.useState)([]);
    const [rolesCompany, setRolesCompany] = (0, $bh6RR.useState)([
        {
            value: "undefined",
            text: "Choose Role"
        }
    ]);
    const [userAvailable, setUserAvailable] = (0, $bh6RR.useState)({
        email: true,
        username: true
    });
    const [file, setFile] = (0, $bh6RR.useState)(data?.image);
    const [loadAnim, setLoading] = (0, $bh6RR.useState)(null);
    const [dataReady, setDataReady] = (0, $bh6RR.useState)(false);
    const [showRoleCompanyField, setShowRoleCompanyField] = (0, $bh6RR.useState)(data ? !data.is_admin : false);
    const onSubmit = async ()=>{
        var dataToSend = getValues();
        dataToSend.companies_ids = listCheckedCompanies.map((comp)=>comp.id);
        const formData = new (0, (/*@__PURE__*/$parcel$interopDefault($07d55ecd4e888d68$exports)))();
        formData.append("username", dataToSend.username);
        formData.append("email", dataToSend.email);
        //formData.append('company_id', dataToSend.company_id)
        formData.append("companies_ids", JSON.stringify(dataToSend.companies_ids));
        formData.append("company_role", dataToSend.company_role);
        formData.append("global_role", dataToSend.global_role);
        formData.append("image", file);
        let [response, error] = data != null ? await updateUser(data.id, formData) : await addUser(formData);
        if (error !== null) {
            console.log(error);
            return;
        }
        modal.resolve(response);
        onClose();
        return;
    };
    const showImage = (role)=>{
        if (role.id === 1) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($357e1df28db17bef$exports))),
            alt: "Role Admin"
        });
        else if (role.id === 2) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($3852d4475fc978fc$exports))),
            alt: "Role User"
        });
        else {
            const logoChoice = (0, $dad7d4cf331e99ef$export$2e2bcd8739ae039).find((choice)=>choice.value === role.logo);
            if (logoChoice) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                src: logoChoice.text.props.src,
                alt: logoChoice.text.props.alt
            });
            else return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                src: role.avatar,
                width: 24,
                height: 24,
                alt: role.avatar
            });
        }
    };
    const setUpRoles = (_roles)=>{
        const roles = _roles || [];
        roles.sort((a, b)=>b.id - a.id);
        return roles.map((role)=>({
                value: role.id,
                text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    style: {
                        maxWidth: "300px",
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "roles_content_dropdown",
                        children: [
                            " ",
                            showImage(role),
                            " ",
                            role.id == 1 ? "Super admin" : role.slug
                        ]
                    })
                })
            }));
    };
    const setUpRolesCompany = (_roles)=>{
        const rolesCompany = _roles || [];
        const initialOption = {
            value: "undefined",
            text: "Choose Role"
        };
        return [
            initialOption,
            ...rolesCompany.map((role)=>({
                    value: role.id,
                    text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        style: {
                            maxWidth: "300px",
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "roles_content_dropdown",
                            children: [
                                " ",
                                showImage(role),
                                " ",
                                role.slug
                            ]
                        })
                    })
                }))
        ];
    };
    const getRolesByUser = async ()=>{
        let [response, error] = await getRolesFilter({
            company_id: null
        });
        if (error !== null) {
            console.log(error);
            return;
        }
        setRoles(setUpRoles(response));
    };
    const getRolesByUserInCompany = async ()=>{
        let companyId = data?.company?.id;
        if (companyId || companyId !== watch("company_id")) companyId = watch("company_id");
        if (companyId) {
            let [response, error] = await getRolesFilter({
                company_id: companyId
            });
            if (error !== null) {
                console.log(error);
                return;
            }
            setRolesCompany(setUpRolesCompany(response));
        }
    };
    const checkValues = async (title, value)=>{
        let dataToSend = [];
        dataToSend[title] = value;
        if (value.length == 0) return;
        let [response, error] = await checkAvaibility(dataToSend);
        if (error !== null) {
            console.log(error);
            return;
        }
        let res = userAvailable;
        res[title] = title == "email" && value.match(emailRegex) === null ? false : response.available;
        if (data != null && value === data[title]) res[title] = true;
        setUserAvailable({
            ...res
        });
    };
    (0, $bh6RR.useEffect)(()=>{
        async function fetchData() {
            await getRolesByUser();
            await getRolesByUserInCompany();
            setDataReady(true);
            if (data && data.company_role) setValue("company_role", data.company_role);
        }
        fetchData();
    }, [
        watch("company_id")
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (watch("company_role") !== 1) setValue("company_role", watch("company_role"));
    }, [
        watch("company_role")
    ]);
    (0, $bh6RR.useEffect)(()=>{
        setShowRoleCompanyField(watch("global_role") !== 1);
    }, [
        watch("global_role")
    ]);
    (0, $bh6RR.useEffect)(()=>{
        getAllCompanies();
    }, []);
    var defaultChoiceCompany = "undefined";
    if (data && data.roles && rolesCompany) {
        const roleId = data.roles.find((role)=>rolesCompany.some((rc)=>rc.value === role.id));
        if (roleId) defaultChoiceCompany = roleId.id;
    }
    const getAllCompanies = async ()=>{
        let [response, error] = await getCompanies();
        if (error !== null) {
            console.log(error);
            return;
        }
        setCompanies(response);
        setListCheckedCompanies(data ? data.companies : []);
        return response;
    };
    const checkCompany = (_company)=>{
        let result = listCheckedCompanies;
        if (result.filter((company)=>{
            return company.id == _company.id;
        }).length == 0) {
            result.push(_company);
            setListCheckedCompanies(result);
            document.getElementById(_company.id + "button").style.color = "var(--green)";
            document.getElementById(_company.id + "button").children[0].classList = "fas fa-check-circle";
        } else {
            let index = listCheckedCompanies.findIndex((company)=>{
                return company.id === _company.id;
            });
            result.splice(index, 1);
            setListCheckedCompanies(result);
            document.getElementById(_company.id + "button").style.color = "var(--main)";
            document.getElementById(_company.id + "button").children[0].classList = "fas fa-plus-circle";
        }
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: dataReady && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
            className: "edit-container",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                    children: title
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                    className: "body-editModal-container",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            style: {
                                marginBottom: "25px",
                                marginTop: "15px",
                                display: "flex",
                                gap: "3rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Global role",
                                    listLabelClassName: "titles-input"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    style: {
                                        marginLeft: "5%",
                                        marginTop: "2%"
                                    },
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                        name: "global_role",
                                        ...register("global_role"),
                                        setValue: setValue,
                                        choices: roles,
                                        defaultChoice: data ? data?.roles[0]?.id : "",
                                        width: "240px"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            style: {
                                marginBottom: "15px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Username"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ...register("username", {
                                        required: true,
                                        minLength: 1,
                                        onChange: (e)=>checkValues("username", e.target.value)
                                    }),
                                    style: {
                                        borderColor: userAvailable.username == false ? "red" : ""
                                    },
                                    className: "full-width text_input_user_form",
                                    defaultValue: data ? data.username : "",
                                    placeholder: "Choose your username"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            style: {
                                marginBottom: "15px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Email"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ...register("email", {
                                        required: true,
                                        minLength: 1,
                                        onChange: (e)=>checkValues("email", e.target.value)
                                    }),
                                    style: {
                                        borderColor: userAvailable.email == false ? "red" : ""
                                    },
                                    className: "full-width text_input_user_form",
                                    defaultValue: data ? data.email : "",
                                    placeholder: "Choose your email"
                                })
                            ]
                        }),
                        currentUser.id != data?.id && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "separator_section_form_user"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "user_list_companies",
                            children: companies.map((company, i)=>{
                                let bool = data ? data.companies.some((comp)=>comp.id == company.id) : false;
                                //let bool = listCheckedChannel.includes(_channel.id)
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "project-block",
                                    "data-checked": "false",
                                    "data-id": company.id,
                                    style: {
                                        border: bool ? "2px solid var(--main)" : ""
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            style: {
                                                alignItems: "center",
                                                display: "flex"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                    style: {
                                                        marginRight: "15px",
                                                        fontSize: "20px"
                                                    }
                                                }),
                                                company.name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                                id: company.id + "button",
                                                className: "main-iconButton add-hover modalButtons-input",
                                                icon: bool ? "fas fa-check-circle" : "fas fa-plus-circle",
                                                onClick: (e)=>checkCompany(company),
                                                style: {
                                                    color: bool ? "var(--green)" : "var(--main)"
                                                }
                                            })
                                        })
                                    ]
                                }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)());
                            })
                        }),
                        showRoleCompanyField && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            style: {
                                marginBottom: "25px",
                                marginTop: "15px",
                                display: "flex",
                                gap: "2rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Company role",
                                    listLabelClassName: "titles-input"
                                }),
                                rolesCompany && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    style: {
                                        marginLeft: "5%",
                                        marginTop: "2%"
                                    },
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                        name: "company_role",
                                        setValue: setValue,
                                        ...register("company_role"),
                                        choices: rolesCompany,
                                        defaultChoice: defaultChoiceCompany,
                                        width: "235px"
                                    })
                                })
                            ]
                        }),
                        data?.name && // check if datas exists
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Owner of the user"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    disabled: true,
                                    ...register("owner", {
                                        required: true,
                                        minLength: 1
                                    }),
                                    style: errors.owner ? {
                                        borderColor: "red"
                                    } : {},
                                    className: " full-width text_input_user_form",
                                    defaultValue: data ? data.owner : "",
                                    placeholder: "Choose your name"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "separator_section_form_user"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Logo"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $47da697040d42413$export$2e2bcd8739ae039), {
                                    _setFile: setFile,
                                    defaultValueImage: data?.picture,
                                    accept: ".png,.jpg,.jpeg",
                                    loadAnim: loadAnim,
                                    colorBorder: "inset 0 0 0 1px #dddddd;"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        type: "submit",
                        label: data?.id ? "Update" : "Add",
                        disabled: !(userAvailable.email == true && watch("email").length > 0 && userAvailable.username == true && watch("username").length > 0 && listCheckedCompanies.length > 0),
                        onSubmit: onSubmit
                    })
                })
            ]
        })
    });
}
var $66def9f09453b1b7$export$2e2bcd8739ae039 = $66def9f09453b1b7$var$UserModalBodyAdmin;




var $bh6RR = parcelRequire("bh6RR");



















function $3d452021da733e5f$var$UserModalBodyUser({ data: data, title: title }) {
    console.log(data);
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const currentUser = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("user");
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors }, getValues: getValues, setValue: setValue, watch: watch } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            id: data ? data.id : "",
            username: data ? data.username : "",
            email: data ? data.email : "",
            image: data ? data.image : "",
            company_role: data ? data.role : -1
        }
    });
    console.log(data);
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const { getCompaniesAutocomplete: getCompaniesAutocomplete } = (0, $e2bea698183eb612$export$2e2bcd8739ae039);
    const { addUser: addUser, updateUser: updateUser, checkAvaibility: checkAvaibility } = (0, $8e81d56c61e78b8c$export$2e2bcd8739ae039);
    const { getRoles: getRoles } = (0, $486873d7496d6dcd$export$2e2bcd8739ae039);
    const [roles, setRoles] = (0, $bh6RR.useState)([]);
    const [rolesCompany, setRolesCompany] = (0, $bh6RR.useState)([]);
    const [userAvailable, setUserAvailable] = (0, $bh6RR.useState)({
        email: true,
        username: true
    });
    const [file, setFile] = (0, $bh6RR.useState)(data?.image);
    const [loadAnim, setLoading] = (0, $bh6RR.useState)(null);
    const [dataReady, setDataReady] = (0, $bh6RR.useState)(false);
    const onSubmit = async ()=>{
        var dataToSend = getValues();
        // console.log('dataToSend', dataToSend);
        const formData = new (0, (/*@__PURE__*/$parcel$interopDefault($07d55ecd4e888d68$exports)))();
        formData.append("username", dataToSend.username);
        formData.append("email", dataToSend.email);
        formData.append("company_role", dataToSend.company_role);
        formData.append("image", file);
        let [response, error] = data != null ? await updateUser(data.id, formData) : await addUser(formData);
        if (error !== null) {
            console.log(error);
            return;
        }
        modal.resolve(response);
        onClose();
        return;
    };
    const showImage = (role)=>{
        const logoChoice = (0, $dad7d4cf331e99ef$export$2e2bcd8739ae039).find((choice)=>choice.value === role.logo);
        if (logoChoice) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            src: logoChoice.text.props.src,
            alt: logoChoice.text.props.alt
        });
        else return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            src: role.avatar,
            width: 24,
            height: 24,
            alt: role.avatar
        });
    };
    const setUpRoles = (_roles)=>{
        const rolesCompany = _roles || [];
        const initialOption = {
            value: "undefined",
            text: "Choose Role"
        };
        return [
            initialOption,
            ...rolesCompany.map((role)=>({
                    value: role.id,
                    text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        style: {
                            maxWidth: "300px",
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "roles_content_dropdown",
                            children: [
                                " ",
                                showImage(role),
                                " ",
                                role.slug
                            ]
                        })
                    })
                }))
        ];
    };
    const getRolesByUser = async ()=>{
        let [response, error] = await getRoles();
        if (error !== null) {
            console.log(error);
            return;
        }
        setRoles(setUpRoles(response));
    };
    const checkValues = async (title, value)=>{
        let dataToSend = [];
        dataToSend[title] = value;
        if (value.length == 0) return;
        let [response, error] = await checkAvaibility(dataToSend);
        if (error !== null) {
            console.log(error);
            return;
        }
        let res = userAvailable;
        res[title] = title == "email" && value.match(emailRegex) === null ? false : response.available;
        if (data != null && value === data[title]) res[title] = true;
        setUserAvailable({
            ...res
        });
    };
    (0, $bh6RR.useEffect)(()=>{
        async function fetchData() {
            await getRolesByUser();
            setDataReady(true);
        }
        fetchData();
    }, []);
    console.log(roles);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: dataReady && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
            className: "edit-container",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                    children: title
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                    className: "body-editModal-container",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            style: {
                                marginBottom: "25px",
                                marginTop: "15px",
                                display: "flex",
                                gap: "4rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Role",
                                    listLabelClassName: "titles-input"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    style: {
                                        marginLeft: "5%",
                                        marginTop: "2%"
                                    },
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                        name: "company_role",
                                        ...register("company_role"),
                                        setValue: setValue,
                                        placeholder: "Choose Role",
                                        width: "250px"
                                    })
                                })
                            ]
                        }),
                        currentUser.id != data?.id && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "separator_section_form_user"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            style: {
                                marginBottom: "15px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Username"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ...register("username", {
                                        required: true,
                                        minLength: 1,
                                        onChange: (e)=>checkValues("username", e.target.value)
                                    }),
                                    style: {
                                        borderColor: userAvailable.username == false ? "red" : ""
                                    },
                                    className: "full-width text_input_user_form",
                                    defaultValue: data ? data.username : "",
                                    placeholder: "Choose your username"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            style: {
                                marginBottom: "15px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Email"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ...register("email", {
                                        required: true,
                                        minLength: 1,
                                        onChange: (e)=>checkValues("email", e.target.value)
                                    }),
                                    style: {
                                        borderColor: userAvailable.email == false ? "red" : ""
                                    },
                                    className: "full-width text_input_user_form",
                                    defaultValue: data ? data.email : "",
                                    placeholder: "Choose your email"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        type: "submit",
                        label: data?.id ? "Update" : "Add",
                        disabled: !(userAvailable.email == true && watch("email").length > 0 && userAvailable.username == true && watch("username").length > 0 && watch("role") != null),
                        onSubmit: onSubmit
                    })
                })
            ]
        })
    });
}
var $3d452021da733e5f$export$2e2bcd8739ae039 = $3d452021da733e5f$var$UserModalBodyUser;





const $e37a37a5a0145662$var$UserModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ title: title, data: data })=>{
    const currentUser = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("user");
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    // A SUPPRIMER : form | pas utilise pour le moment car user modal body pas utilisee
    const form = {
        id: data == undefined ? null : data.id,
        username: data == undefined ? null : data.username
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $9c2d88d3df32f983$export$2e2bcd8739ae039), {
        name: "change-password",
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            currentUser.is_admin ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $66def9f09453b1b7$export$2e2bcd8739ae039), {
                data: data,
                title: title
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3d452021da733e5f$export$2e2bcd8739ae039), {
                data: data,
                title: title
            }) // PAS UTILISER POUR LE MOMENT 
        ]
    });
});
var $e37a37a5a0145662$export$2e2bcd8739ae039 = $e37a37a5a0145662$var$UserModal;





function $e2b536164b89f027$export$6dd95649f19af5f8(inputDate, withTimezone) {
    let date = new Date(inputDate);
    let day = withTimezone ? date.getDate() : date.getUTCDate();
    let hours = withTimezone ? date.getHours() : date.getUTCHours();
    let minutes = withTimezone ? date.getMinutes() : date.getUTCMinutes();
    day = day.toString().padStart(2, "0");
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");
    return `${day} ${date.toLocaleString("en-EU", {
        month: "short"
    })} ${date.getFullYear()}, ${hours}:${minutes}`;
}








var $9e9f6a8a4a0036d2$export$2e2bcd8739ae039 = {
    updatePassword: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post("change/password", data)
};



var $bh6RR = parcelRequire("bh6RR");
function $5a04eac07e397352$var$UserTable() {
    const currentUser = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("user");
    const { getUser: getUser, getUsers: getUsers, deleteUser: deleteUser, updateUser: updateUser } = (0, $8e81d56c61e78b8c$export$2e2bcd8739ae039);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    const searchUrl = location.pathname.substring(0, location.pathname.lastIndexOf("/"));
    const handleSwitch = async (id)=>{
        await (0, $abf5d39ca5c52d92$export$b84e4c64185fb95)(id, navigate);
    };
    const { updatePassword: updatePassword } = (0, $9e9f6a8a4a0036d2$export$2e2bcd8739ae039);
    const [delayPasswordForgotten, setDelayDelayPasswordForgotten] = (0, $bh6RR.useState)(true);
    var cells = [];
    if (currentUser.is_admin) cells = [
        {
            column: "ID",
            name: "id",
            sort: true,
            show: (value)=>value
        },
        {
            column: "AVATAR",
            name: "picture",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    srcSet: value
                })
        },
        {
            column: "ORGANIZATIONS",
            name: [
                "company.logo",
                "company.name",
                "company.id"
            ],
            show: ([logo, name, id])=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    srcSet: logo,
                    title: name,
                    style: {
                        cursor: "pointer"
                    },
                    onClick: ()=>handleSwitch(id)
                })
        },
        {
            column: "USERNAME",
            name: "username",
            sort: true,
            show: (value)=>value
        },
        {
            column: "EMAIL",
            name: "email",
            show: (value)=>value
        },
        {
            column: "Role",
            name: "roles",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    children: value.filter((role)=>role.company_id === null).map((role, i)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            children: role.id === 1 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($357e1df28db17bef$exports))),
                                alt: "Role Admin"
                            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3852d4475fc978fc$exports))),
                                alt: "Role Admin"
                            })
                        }, i))
                })
        },
        {
            column: "LAST CONNECTION",
            name: "last_login_at",
            show: (value)=>value ? (0, $e2b536164b89f027$export$6dd95649f19af5f8)(value, true) : "/"
        }
    ];
    else cells = [
        {
            column: "AVATAR",
            name: "picture",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    srcSet: value
                })
        },
        {
            column: "USERNAME",
            name: "username",
            show: (value)=>value
        },
        {
            column: "EMAIL",
            name: "email",
            show: (value)=>value
        }
    ];
    const showAddModal = ({ addRow: addRow })=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $e37a37a5a0145662$export$2e2bcd8739ae039), {
            title: currentUser.is_admin || (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("add_user") ? "Create a new User" : "Add a User to company"
        }).then((company)=>addRow(company));
    const showEditModal = async ({ row: row, updateRow: updateRow })=>{
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $e37a37a5a0145662$export$2e2bcd8739ae039), {
            title: "Modify your User",
            data: {
                ...row
            }
        }).then(({ user: user })=>updateRow(user));
    };
    const onClickAdd = ()=>navigate(searchUrl + "/create");
    const onClickUpdate = ({ row: row })=>navigate(searchUrl + "/update", {
            state: {
                data: row,
                type: "update"
            }
        });
    const onClickShowHistory = ({ row: row })=>navigate(`/administration/user/logs`, {
            state: {
                data: row
            }
        });
    const onClickDelete = async ({ row: row, deleteRow: deleteRow })=>{
        const { id: id, username: username } = row;
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete user " + username,
            body: "Do you really want to delete user " + username,
            api: {
                request: deleteUser,
                param: [
                    row.id
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel",
                    style: {
                        marginRight: "20px"
                    }
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ]
        }).then((res)=>res.error != null ? toast.error("Error", res.error) : deleteRow(id));
    };
    const onClickSendPassword = async ({ row: row })=>{
        if (delayPasswordForgotten == false) return;
        let dataToSend = {
            email: row.email
        };
        let mess = "Perfect! The user will get a new temporary password at the given email address";
        const [result, error] = await updatePassword(dataToSend);
        toast.success("Password Edit", mess);
        setDelayDelayPasswordForgotten(false);
        setTimeout(()=>setDelayDelayPasswordForgotten(true), 4000);
    };
    var actions = [];
    if (currentUser.is_admin) actions = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_user") ? {
            className: "fas fa-paper-plane action-button send_password_action",
            style: {},
            onClick: onClickSendPassword
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_user") ? {
            className: "fas fa-edit action-button edit_action",
            style: {},
            onClick: onClickUpdate
        } : null,
        //hasPermission('update_user') ? { className: "fas fa-edit action-button edit_action", style: {}, onClick: showEditModal } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_user") ? {
            className: "fas fa-history action-button edit_action",
            style: {},
            onClick: onClickShowHistory
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("delete_user") ? {
            className: "fas fa-trash action-button delete_action",
            style: {},
            onClick: onClickDelete
        } : null
    ].filter((action)=>action);
    else actions = [
        //hasPermission('update_user') ? { className: "fas fa-edit action-button edit_action", style: {}, onClick: showEditModal, condition : 'is_admin', condition_match : true } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_user") ? {
            className: "fas fa-edit action-button edit_action",
            style: {},
            onClick: onClickUpdate,
            condition: "is_admin",
            condition_match: true
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("delete_user") ? {
            className: "fas fa-trash action-button delete_action",
            style: {},
            onClick: onClickDelete,
            condition: "is_admin",
            condition_match: true
        } : null
    ].filter((action)=>action);
    const buttons = [
        //hasPermission('add_user') ? { icon: "fas fa-plus", onClick: showAddModal } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("add_user") ? {
            icon: "fas fa-plus",
            onClick: onClickAdd
        } : null
    ].filter((button)=>button);
    const filters = [
        {
            type: "input",
            placeholder: "content",
            name: "term"
        }
    ];
    const getUsersCallable = async (params)=>{
        if (currentUser.is_admin == false) params = {
            ...params,
            company_id: currentUser.company.id
        };
        return await getUsers(params);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: "Manage Users"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "entete-dataset",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "entete-dataset",
                    style: {
                        width: "115px"
                    }
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
                name: "User",
                cells: cells,
                api: getUsersCallable,
                actions: actions,
                buttons: buttons,
                filters: filters
            })
        ]
    });
}
var $5a04eac07e397352$export$2e2bcd8739ae039 = $5a04eac07e397352$var$UserTable;


function $a3433e79cea6dd3d$var$UserList() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5a04eac07e397352$export$2e2bcd8739ae039), {});
}
var $a3433e79cea6dd3d$export$2e2bcd8739ae039 = $a3433e79cea6dd3d$var$UserList;





var $bh6RR = parcelRequire("bh6RR");










var $326ce82a4f4fa1a4$export$2e2bcd8739ae039 = {
    getUserLogs: (userId, params = {})=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`http-logs`, {
            ...params,
            user_id: userId,
            term: params.term || ""
        }),
    getCompanyLogs: (companyId, params = {})=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`http-logs`, {
            ...params,
            company_id: companyId,
            term: params.term || ""
        })
};



function $fd4f0fdff60c8735$var$UserHttpLogsTable({ userId: userId }) {
    const cells = [
        {
            column: "Date",
            name: "requested_at",
            sort: true,
            show: (v)=>(0, $e2b536164b89f027$export$6dd95649f19af5f8)(v, true)
        },
        {
            column: "Path",
            name: "path"
        },
        {
            column: "Method",
            name: "method",
            show: (v)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: `http-method ${v}`,
                    children: v
                })
        },
        {
            column: "Status",
            name: "status_code",
            sort: true
        },
        {
            column: "Duration (ms)",
            name: "query_time",
            sort: true
        },
        {
            column: "IP",
            name: "ip_address"
        },
        {
            column: "Company",
            name: "company_name"
        }
    ];
    const filters = [
        {
            type: "input",
            placeholder: "Method",
            name: "method"
        },
        {
            type: "input",
            placeholder: "Status",
            name: "status_code"
        },
        {
            type: "input",
            placeholder: "Company",
            name: "company_id"
        }
    ];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
        name: "user api log",
        cells: cells,
        api: (apiParams)=>(0, $326ce82a4f4fa1a4$export$2e2bcd8739ae039).getUserLogs(userId, {
                ...apiParams
            }),
        actions: [],
        buttons: [],
        filters: filters
    });
}
var $fd4f0fdff60c8735$export$2e2bcd8739ae039 = $fd4f0fdff60c8735$var$UserHttpLogsTable;



function $bd62971c144c1f45$var$UserHistoryTable(data) {
    const currentUser = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("user");
    const { getHistories: getHistories } = (0, $8e81d56c61e78b8c$export$2e2bcd8739ae039);
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const userData = data.data;
    const extractBrowser = (userAgent)=>{
        const browserRegex = /(?:Firefox|Chrome|Safari|Opera|MSIE|Trident)\/(?:[0-9]+\.)+[0-9]+/;
        const matches = userAgent.match(browserRegex);
        return matches ? matches[0] : "Unknown";
    };
    const extractPlatform = (userAgent)=>{
        const platformRegex = /(Windows NT \d+\.\d+|Windows Phone \d+\.\d+|Windows CE|Linux \w*(?=;)|Linux armv\d+|Macintosh|Mac OS X \d+(_\d+)?|Android \d+(\.\d+)?|CrOS|X11|Ubuntu|Debian|Fedora|Red Hat|SuSE|iOS|iPhone|iPad|FreeBSD|OpenBSD|NetBSD|SunOS|BlackBerry\d+)/;
        const matches = userAgent.match(platformRegex);
        return matches ? matches[0] : "Unknown";
    };
    const LoginHistoryTable = ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
            name: "user login history",
            cells: cells,
            api: (params)=>getHistories(userData?.id, params),
            actions: actions,
            buttons: buttons,
            filters: filters
        });
    const getItems = ()=>[
            {
                name: "Connexions",
                component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)(LoginHistoryTable, {}),
                type: 0
            },
            {
                name: "API Logs",
                component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fd4f0fdff60c8735$export$2e2bcd8739ae039), {
                    userId: userData?.id
                }),
                type: 1
            }
        ];
    const [items] = (0, $bh6RR.useState)(getItems());
    (0, $bh6RR.useEffect)(()=>{
        if (!userData) navigate("/administration/user/list");
    }, [
        userData,
        navigate
    ]);
    var cells = [];
    if (currentUser.is_admin) cells = [
        {
            column: "Connexion",
            name: "created_at",
            sort: true,
            show: (value)=>(0, $e2b536164b89f027$export$6dd95649f19af5f8)(value, true)
        },
        {
            column: "Ip Address",
            name: "ip_address",
            show: (value)=>value
        },
        {
            column: "Browser",
            name: "user_agent",
            show: (value)=>extractBrowser(value)
        },
        {
            column: "Platform",
            name: "user_agent",
            sort: true,
            show: (value)=>extractPlatform(value)
        }
    ];
    else cells = [
        {
            column: "AVATAR",
            name: "picture",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    srcSet: value
                })
        },
        {
            column: "USERNAME",
            name: "username",
            show: (value)=>value
        },
        {
            column: "EMAIL",
            name: "email",
            show: (value)=>value
        }
    ];
    var actions = [];
    const buttons = [];
    const filters = [];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: `Login History of ${userData?.username}`
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "entete-dataset",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "entete-dataset",
                    style: {
                        width: "115px"
                    }
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $297630b888b8597e$export$2e2bcd8739ae039), {
                items: items,
                name: "user-history",
                type: "table"
            })
        ]
    });
}
var $bd62971c144c1f45$export$2e2bcd8739ae039 = $bd62971c144c1f45$var$UserHistoryTable;



function $a2df2e646326eb90$var$UserHistoryList() {
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    var data = null;
    if (location.state != null) data = location.state.data;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $bd62971c144c1f45$export$2e2bcd8739ae039), {
        data: data
    });
}
var $a2df2e646326eb90$export$2e2bcd8739ae039 = $a2df2e646326eb90$var$UserHistoryList;





var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");




function $270058d817b71e8f$var$CompanyHttpLogsTable({ companyId: companyId }) {
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    (0, $bh6RR.useEffect)(()=>{
        if (!companyId) navigate("/administration/company/list");
    }, [
        companyId,
        navigate
    ]);
    const cells = [
        {
            column: "Date",
            name: "requested_at",
            sort: true,
            show: (v)=>(0, $e2b536164b89f027$export$6dd95649f19af5f8)(v, true)
        },
        {
            column: "Path",
            name: "path"
        },
        {
            column: "Method",
            name: "method",
            show: (v)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: `http-method ${v}`,
                    children: v
                })
        },
        {
            column: "Status",
            name: "status_code",
            sort: true
        },
        {
            column: "Duration (ms)",
            name: "query_time",
            sort: true
        },
        {
            column: "IP",
            name: "ip_address"
        },
        {
            column: "User",
            name: "username"
        }
    ];
    const filters = [
        {
            type: "input",
            placeholder: "Method",
            name: "method"
        },
        {
            type: "input",
            placeholder: "Status",
            name: "status_code"
        },
        {
            type: "input",
            placeholder: "User",
            name: "username"
        }
    ];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
        name: "company api log",
        style: {
            top: "0px"
        },
        cells: cells,
        api: (apiParams)=>(0, $326ce82a4f4fa1a4$export$2e2bcd8739ae039).getCompanyLogs(companyId, {
                ...apiParams
            }),
        actions: [],
        buttons: [],
        filters: filters
    });
}
var $270058d817b71e8f$export$2e2bcd8739ae039 = $270058d817b71e8f$var$CompanyHttpLogsTable;


function $c29649aaed93601c$var$CompanyHistoryTable(data) {
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const companyData = data.data;
    (0, $bh6RR.useEffect)(()=>{
        if (!companyData) navigate("/administration/company/list");
    }, [
        companyData,
        navigate
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: `Logs History of ${companyData?.name}`
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $270058d817b71e8f$export$2e2bcd8739ae039), {
                companyId: companyData?.id
            })
        ]
    });
}
var $c29649aaed93601c$export$2e2bcd8739ae039 = $c29649aaed93601c$var$CompanyHistoryTable;



function $fd6c2b11f8aa06e5$var$CompanyHistoryList() {
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    var data = null;
    if (location.state != null) data = location.state.data;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c29649aaed93601c$export$2e2bcd8739ae039), {
        data: data
    });
}
var $fd6c2b11f8aa06e5$export$2e2bcd8739ae039 = $fd6c2b11f8aa06e5$var$CompanyHistoryList;



parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");





















var $c67d47eff71309b3$export$2e2bcd8739ae039 = {
    getChannelsAvailable: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("channels/dashboard/available", data),
    loadBotBlock: async (data, company, bot_id, channel_key)=>{
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Talkr-Query": "1",
                "X-Talkr-Analytics-Disable": "1",
                "x-talkr-channel-key": channel_key
            },
            body: JSON.stringify(data)
        };
        let path = (0, $651df53b10514175$export$a7b6bc01c63cdfc3).REACT_APP_API_PATH.split("/api/v1")[0] + "/";
        let res = await fetch(path + `${company}/bots/${bot_id}/api/web`, requestOptions);
        return res.json();
    },
    // DASHBOARD
    getDashboards: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("dashboards", data),
    getDashboardsShared: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("dashboards/shared", data),
    addDashboard: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`dashboard`, data),
    updateDashboard: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`dashboard/${id}`, data),
    updateDashboardShared: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`dashboard/shared/${id}`, data),
    deleteDashboard: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`dashboard/${id}`, data),
    getDashboard: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`dashboard/info`, data),
    getDashboardChannel: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`dashboard_channel/info`, data),
    getChannelsAvailableForDashboard: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`dashboard/channels_availables`, data),
    // BLOCK
    addBlock: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`dashboard/block`, data),
    addBlockGrid: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`dashboard/block_grid`, data),
    editBlock: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`dashboard/block/${id}`, data),
    updatePositionBlock: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`dashboard/block/${id}/position`, data),
    editBlockGrid: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`dashboard/block_grid/${id}`, data),
    deleteBlock: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`dashboard/block/${id}`, data),
    // VARIABLES
    getBotVariableAvailable: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`dashboard/bot_variables_availables`, data),
    addVariable: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`dashboard/variable`, data),
    editVariable: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`dashboard/variable/${id}`, data),
    updatePositionVariable: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`dashboard/variable/${id}/position`, data),
    updateDashboardVariableShared: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`dashboard/variable/shared/${id}`, data),
    updateCellValueGrid: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`dashboard/grid/cell/${id}`, data),
    deleteVariable: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`dashboard/variable/${id}`, data)
};



var $cc713a1a9835b977$export$2e2bcd8739ae039 = {
    create: {
        title: "Add a User",
        send: "Create"
    },
    update: {
        title: "Update User",
        send: "Update"
    }
};






function $5ec5a04d4c1cb3ca$var$UserForm({ data: data, type: type }) {
    const currentUser = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("user");
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const authorizations = data ? JSON.parse(data.authorizations) : null;
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors }, formState: formState, getValues: getValues, setValue: setValue, watch: watch } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            id: data ? data.id : "",
            username: data ? data.username : "",
            email: data ? data.email : "",
            //company_id: data ? data.company?.id : "",
            companies: data ? data.companies : "",
            image: data ? data.picture : "",
            //company_role: data ? data.company_role : undefined,
            global_role: data ? data?.is_admin ? 1 : 2 : 2,
            companies_roles: data ? authorizations?.companies_roles : undefined
        }
    });
    const dataType = (0, $cc713a1a9835b977$export$2e2bcd8739ae039)[type ? type : "create"];
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const { getCompaniesAutocomplete: getCompaniesAutocomplete, getCompanies: getCompanies } = (0, $e2bea698183eb612$export$2e2bcd8739ae039);
    const { addUser: addUser, updateUser: updateUser, checkAvaibility: checkAvaibility } = (0, $8e81d56c61e78b8c$export$2e2bcd8739ae039);
    const { getDashboards: getDashboards, getDashboardsShared: getDashboardsShared } = (0, $c67d47eff71309b3$export$2e2bcd8739ae039);
    const { getChannels: getChannels } = (0, $c664cd598f09e2f9$export$2e2bcd8739ae039);
    const [listCheckedCompanies, setListCheckedCompanies] = (0, $bh6RR.useState)([]);
    const [listCheckedDatasets, setListCheckedDatasets] = (0, $bh6RR.useState)(authorizations?.datasets_ids ?? []);
    const [listCheckedDashboards, setListCheckedDashboards] = (0, $bh6RR.useState)(authorizations?.dashboards_ids ?? []);
    const [listCheckedChannels, setListCheckedChannels] = (0, $bh6RR.useState)(authorizations?.channels_ids ?? []);
    const { getRoles: getRoles, getRolesFilter: getRolesFilter } = (0, $486873d7496d6dcd$export$2e2bcd8739ae039);
    const [roles, setRoles] = (0, $bh6RR.useState)([]);
    const [companies, setCompanies] = (0, $bh6RR.useState)([]);
    const [datasets, setDatasets] = (0, $bh6RR.useState)([]);
    const [dashboards, setDashboards] = (0, $bh6RR.useState)([]);
    const [channels, setChannels] = (0, $bh6RR.useState)([]);
    const [rolesCompany, setRolesCompany] = (0, $bh6RR.useState)([
        {
            value: "undefined",
            text: "Choose Role"
        }
    ]);
    const [userAvailable, setUserAvailable] = (0, $bh6RR.useState)({
        email: true,
        username: true
    });
    const [file, setFile] = (0, $bh6RR.useState)(data?.picture);
    const [loadAnim, setLoading] = (0, $bh6RR.useState)(null);
    //const [dataReady, setDataReady] = useState(false);
    const [showRoleCompanyField, setShowRoleCompanyField] = (0, $bh6RR.useState)(data ? !data.is_admin : false);
    const { getDatasets: getDatasets } = (0, $cef77ca5b38a78fa$export$2e2bcd8739ae039);
    const onSubmit = async ()=>{
        var dataToSend = getValues();
        dataToSend.companies_ids = listCheckedCompanies;
        dataToSend.datasets_ids = listCheckedDatasets;
        dataToSend.dashboards_ids = listCheckedDashboards;
        dataToSend.channels_ids = listCheckedChannels;
        //console.log(dataToSend);
        dataToSend.companies_roles = dataToSend.companies_roles?.filter((item)=>item.roleId !== "undefined" && listCheckedCompanies.includes(parseInt(item.id))) ?? [];
        const formData = new FormData();
        formData.append("username", dataToSend.username);
        formData.append("email", dataToSend.email);
        //formData.append('company_id', dataToSend.company_id)
        formData.append("companies_ids", JSON.stringify(dataToSend.companies_ids));
        formData.append("datasets_ids", JSON.stringify(dataToSend.datasets_ids));
        formData.append("dashboards_ids", JSON.stringify(dataToSend.dashboards_ids));
        formData.append("channels_ids", JSON.stringify(dataToSend.channels_ids));
        formData.append("companies_roles", JSON.stringify(dataToSend.companies_roles));
        //formData.append('company_role', dataToSend.company_role)
        formData.append("global_role", parseInt(dataToSend.global_role));
        formData.append("image", file);
        let [response, error] = data != null ? await updateUser(data.id, formData) : await addUser(formData);
        if (error !== null) {
            console.log(error);
            return;
        }
        //console.log(response);  
        let searchUrl = location.pathname.substring(0, location.pathname.lastIndexOf("/"));
        return navigate(searchUrl + "/list");
    };
    const showImage = (role)=>{
        if (role.id === 1) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($357e1df28db17bef$exports))),
            alt: "Role Admin"
        });
        else if (role.id === 2) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($3852d4475fc978fc$exports))),
            alt: "Role User"
        });
        else {
            const logoChoice = (0, $dad7d4cf331e99ef$export$2e2bcd8739ae039).find((choice)=>choice.value === role.logo);
            if (logoChoice) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                src: logoChoice.text.props.src,
                alt: logoChoice.text.props.alt
            });
            else return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                src: role.avatar,
                width: 24,
                height: 24,
                alt: role.avatar
            });
        }
    };
    const setUpRoles = (_roles)=>{
        const roles = _roles || [];
        roles.sort((a, b)=>b.id - a.id);
        return roles.map((role)=>({
                value: role.id,
                text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    style: {
                        maxWidth: "300px",
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "roles_content_dropdown",
                        children: [
                            " ",
                            showImage(role),
                            " ",
                            role.id == 1 ? "Super admin" : role.slug
                        ]
                    })
                })
            }));
    };
    const setUpRolesCompany = (_roles)=>{
        const _rolesCompany = _roles || [];
        const initialOption = {
            value: "undefined",
            text: "Choose Role"
        };
        return _rolesCompany.map(({ companyId: companyId, company: company, roles: roles })=>({
                company_id: companyId,
                company_name: company?.name || "\u2014",
                html: [
                    initialOption,
                    ...roles.map((role)=>({
                            value: role.id,
                            text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                style: {
                                    maxWidth: "300px",
                                    textAlign: "center"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "roles_content_dropdown",
                                    children: [
                                        " ",
                                        showImage(role),
                                        " ",
                                        role.slug
                                    ]
                                })
                            })
                        }))
                ]
            }));
    };
    const getRolesByUser = async ()=>{
        let [response, error] = await getRolesFilter({
            company_id: null
        });
        if (error !== null) {
            console.log(error);
            return;
        }
        setRoles(setUpRoles(response));
    };
    const getDatasetsInCompanies = async (companies_ids)=>{
        //let companies_ids = _companies.map(comp => comp.id);
        companies_ids = companies_ids.length == 0 ? null : companies_ids;
        let [response, error] = await getDatasets(companies_ids);
        if (error !== null) {
            console.log(error);
            return;
        }
        setDatasets(response);
        let d = listCheckedDatasets ?? [];
        let filteredDatasets = d.filter((ds)=>response.some((r)=>r.id === ds));
        setListCheckedDatasets([
            ...filteredDatasets
        ]);
    };
    const getDashboardsInCompanies = async (companies_ids)=>{
        //let companies_ids = _companies.map(comp => comp.id);
        companies_ids = companies_ids.length == 0 ? null : companies_ids;
        let [response1, error1] = await getDashboards({
            companies_ids: companies_ids
        });
        if (error1 !== null) {
            console.log(error1);
            return;
        }
        let [response2, error2] = await getDashboardsShared({
            companies_ids: companies_ids
        });
        if (error2 !== null) {
            console.log(error2);
            return;
        }
        let merged = [
            ...response1,
            ...response2
        ];
        let uniqueById = Array.from(new Map(merged.map((item)=>[
                item.id,
                item
            ])).values());
        let d = listCheckedDashboards ?? [];
        let filteredDashboards = d.filter((ds)=>merged.some((r)=>r.id === ds));
        setDashboards(uniqueById);
        setListCheckedDashboards([
            ...filteredDashboards
        ]);
    };
    const getRolesByUserInCompanies = async (companies_ids)=>{
        let [response, error] = await getRoles({
            companies_ids: companies_ids
        });
        if (error !== null) {
            console.log(error);
            return;
        }
        let groupedRoles = {};
        response.forEach((role)=>{
            if (role.company_id == null) return;
            let companyId = role.company_id;
            if (!groupedRoles[companyId]) groupedRoles[companyId] = [];
            groupedRoles[companyId].push(role);
        });
        let groupedRolesArray = Object.entries(groupedRoles).map(([companyId, roles])=>({
                companyId: companyId,
                company: roles[0]?.company,
                roles: roles
            })).sort((a, b)=>{
            let nameA = a.company?.name?.toLowerCase() || "";
            let nameB = b.company?.name?.toLowerCase() || "";
            return nameA.localeCompare(nameB);
        });
        setRolesCompany(setUpRolesCompany(groupedRolesArray));
    };
    const getChannelsInCompanies = async (companies_ids)=>{
        //let companies_ids = _companies.map(comp => comp.id);
        companies_ids = companies_ids.length == 0 ? null : companies_ids;
        let [response, error] = await getChannels({
            companies_ids: companies_ids
        });
        if (error !== null) {
            console.log(error);
            return;
        }
        setChannels(response);
        let c = listCheckedChannels ?? [];
        let filteredChannels = c.filter((ch)=>response.some((r)=>r.id === ch));
        setListCheckedChannels([
            ...filteredChannels
        ]);
    };
    const checkValues = async (title, value)=>{
        let dataToSend = [];
        dataToSend[title] = value;
        if (value.length == 0) return;
        let [response, error] = await checkAvaibility(dataToSend);
        if (error !== null) {
            console.log(error);
            return;
        }
        let res = userAvailable;
        res[title] = title == "email" && value.match(emailRegex) === null ? false : response.available;
        if (data != null && value === data[title]) res[title] = true;
        setUserAvailable({
            ...res
        });
    };
    (0, $bh6RR.useEffect)(()=>{
        setShowRoleCompanyField(watch("global_role") !== 1);
    }, [
        watch("global_role")
    ]);
    (0, $bh6RR.useEffect)(()=>{
        getAllCompanies();
        getRolesByUser();
    }, []);
    var defaultChoiceCompany = "undefined";
    if (data && data.roles && rolesCompany) {
        const roleId = data.roles.find((role)=>rolesCompany.some((rc)=>rc.value === role.id));
        if (roleId) defaultChoiceCompany = roleId.id;
    }
    const getAllCompanies = async ()=>{
        let [response, error] = await getCompanies();
        if (error !== null) {
            console.log(error);
            return;
        }
        setCompanies(response);
        let r = data ? data.companies : [];
        let filtered = r.map((c)=>c.id);
        setListCheckedCompanies([
            ...filtered
        ]);
        if (filtered != null && filtered.length > 0) refreshLists(filtered);
        return r;
    };
    const toggleItemSelection = ({ item: item, list: list, setList: setList, type: type })=>{
        let button = document.getElementById(`${item.id + type}_button`);
        let isAlreadyChecked = list.some((el)=>el === item.id);
        let newList = list;
        if (!isAlreadyChecked) {
            newList.push(item.id);
            button.style.color = "var(--green)";
            button.children[0].classList = "fas fa-check-circle";
        } else {
            let index = list.findIndex((el)=>el === item.id);
            newList.splice(index, 1);
            button.style.color = "var(--main)";
            button.children[0].classList = "fas fa-plus-circle";
        }
        setList([
            ...newList
        ]);
        if (type === "company") refreshLists(newList);
    };
    const setRolesCompanyValue = (roleId, id)=>{
        let currentRoles = getValues("companies_roles") || [];
        let companiesIds = listCheckedCompanies || [];
        const existingIndex = currentRoles.findIndex((item)=>item.id === id);
        let updatedRoles;
        if (existingIndex !== -1) updatedRoles = currentRoles.map((item)=>item.id === id ? {
                id: id,
                roleId: roleId
            } : item);
        else updatedRoles = [
            ...currentRoles,
            {
                id: id,
                roleId: roleId
            }
        ];
        //console.log(updatedRoles);
        updatedRoles = updatedRoles.filter((item)=>companiesIds.includes(parseInt(item.id)));
        setValue("companies_roles", updatedRoles, {
            shouldValidate: true,
            shouldDirty: true
        });
    };
    const checkCompany = (_company)=>{
        toggleItemSelection({
            item: _company,
            list: listCheckedCompanies,
            setList: setListCheckedCompanies,
            type: "company"
        });
    };
    const checkDataset = (_dataset)=>{
        toggleItemSelection({
            item: _dataset,
            list: listCheckedDatasets,
            setList: setListCheckedDatasets,
            type: "dataset"
        });
    };
    const checkDashboard = (_dashboard)=>{
        toggleItemSelection({
            item: _dashboard,
            list: listCheckedDashboards,
            setList: setListCheckedDashboards,
            type: "dashboard"
        });
    };
    const checkChannel = (_channel)=>{
        toggleItemSelection({
            item: _channel,
            list: listCheckedChannels,
            setList: setListCheckedChannels,
            type: "analytics"
        });
    };
    const refreshLists = (_companies)=>{
        getDatasetsInCompanies(_companies);
        getDashboardsInCompanies(_companies);
        getChannelsInCompanies(_companies);
        getRolesByUserInCompanies(_companies);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                children: dataType.title
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                className: "user_form_body",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $51a8b46ec4198ef9$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                            name: "main_form",
                            className: "slide_user_form",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "container_line_dropdown_form_user",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Global role",
                                            listLabelClassName: "titles-input"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            children: roles != null && roles.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                                name: "global_role",
                                                ...register("global_role"),
                                                setValue: (_n, value)=>{
                                                    setValue("global_role", value);
                                                },
                                                choices: roles,
                                                defaultChoice: data ? data?.is_admin ? 1 : 2 : 2,
                                                width: "240px"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    style: {
                                        marginBottom: "15px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Username"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("username", {
                                                required: true,
                                                minLength: 1,
                                                onChange: (e)=>checkValues("username", e.target.value)
                                            }),
                                            style: {
                                                borderColor: userAvailable.username == false ? "red" : ""
                                            },
                                            className: "full-width text_input_user_form",
                                            defaultValue: data ? data.username : "",
                                            placeholder: "Choose your username"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    style: {
                                        marginBottom: "15px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Email"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("email", {
                                                required: true,
                                                minLength: 1,
                                                onChange: (e)=>checkValues("email", e.target.value)
                                            }),
                                            style: {
                                                borderColor: userAvailable.email == false ? "red" : ""
                                            },
                                            className: "full-width text_input_user_form",
                                            defaultValue: data ? data.email : "",
                                            placeholder: "Choose your email"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Avatar"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $47da697040d42413$export$2e2bcd8739ae039), {
                                            _setFile: setFile,
                                            defaultValueImage: data?.picture,
                                            accept: ".png,.jpg,.jpeg",
                                            loadAnim: loadAnim,
                                            colorBorder: "inset 0 0 0 1px #dddddd;"
                                        })
                                    ]
                                }),
                                watch("global_role") != 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "user_form_advanced_parameters",
                                    onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("company_section"),
                                    children: [
                                        " Select Companies ",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                            className: "fas fa-arrow-right",
                                            style: {
                                                marginLeft: "5px",
                                                marginTop: "25px"
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        watch("global_role") != 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                                    name: "company_section",
                                    className: "slide_dashboard_form_channel",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            style: {
                                                height: "70%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                    label: "Organizations (" + listCheckedCompanies.length + "/" + companies.length + ")",
                                                    listLabelClassName: "titles-input"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    className: "user_list_companies",
                                                    children: companies.map((company, i)=>{
                                                        let bool = listCheckedCompanies.length > 0 ? listCheckedCompanies.some((comp)=>comp == company.id) : data ? data.companies.some((comp)=>comp == company.id) : false;
                                                        //let bool = listCheckedChannel.includes(_channel.id)
                                                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                            className: "project-block",
                                                            "data-checked": "false",
                                                            "data-id": company.id,
                                                            style: {
                                                                border: bool ? "2px solid var(--main)" : ""
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                                    style: {
                                                                        alignItems: "center",
                                                                        display: "flex"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                                            style: {
                                                                                marginRight: "15px",
                                                                                fontSize: "20px"
                                                                            }
                                                                        }),
                                                                        company.name
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                                                        id: company.id + "company_button",
                                                                        className: "main-iconButton add-hover modalButtons-input",
                                                                        icon: bool ? "fas fa-check-circle" : "fas fa-plus-circle",
                                                                        onClick: (e)=>checkCompany(company),
                                                                        style: {
                                                                            color: bool ? "var(--green)" : "var(--main)"
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)());
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                justifyContent: "space-between",
                                                width: "90%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                    className: "user_form_advanced_parameters",
                                                    onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("main_form"),
                                                    children: [
                                                        " ",
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                            className: "fas fa-arrow-left",
                                                            style: {
                                                                marginRight: "10px",
                                                                marginTop: "25px"
                                                            }
                                                        }),
                                                        "Main parameters"
                                                    ]
                                                }),
                                                listCheckedCompanies.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                    className: "user_form_advanced_parameters",
                                                    onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("roles_in_companies"),
                                                    children: [
                                                        "Roles ",
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                            className: "fas fa-arrow-right",
                                                            style: {
                                                                marginLeft: "5px",
                                                                marginTop: "25px"
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                                    name: "roles_in_companies",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            style: {
                                                height: listCheckedCompanies.length == 0 ? "50%" : "70%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                    label: "Roles by Organization",
                                                    listLabelClassName: "titles-input"
                                                }),
                                                rolesCompany && Array.isArray(rolesCompany) && rolesCompany.map((group, index)=>{
                                                    if (group.value == "undefined") return;
                                                    let roleId = authorizations?.companies_roles?.find((r)=>r.id === group.company_id)?.roleId;
                                                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                        className: "container_line_dropdown_form_user",
                                                        style: {
                                                            width: "45%",
                                                            marginBottom: "40px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                                                                className: "titles-input",
                                                                style: {
                                                                    color: "var(--main)"
                                                                },
                                                                children: group.company_name
                                                            }),
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                                                name: `company_role_${group.company_id}`,
                                                                setValue: (name, value)=>setRolesCompanyValue(value, group.company_id),
                                                                ...register(`company_role_${group.company_id}`),
                                                                choices: group.html,
                                                                defaultChoice: roleId ?? defaultChoiceCompany,
                                                                width: "235px"
                                                            })
                                                        ]
                                                    }, group.company_id);
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                justifyContent: "space-between",
                                                width: "90%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                    className: "user_form_advanced_parameters",
                                                    onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("company_section"),
                                                    children: [
                                                        " ",
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                            className: "fas fa-arrow-left",
                                                            style: {
                                                                marginRight: "10px",
                                                                marginTop: "25px"
                                                            }
                                                        }),
                                                        "Main parameters"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                    className: "user_form_advanced_parameters",
                                                    onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("shared_elements"),
                                                    children: [
                                                        "Shared elements ",
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                            className: "fas fa-arrow-right",
                                                            style: {
                                                                marginLeft: "5px",
                                                                marginTop: "25px"
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                                    name: "shared_elements",
                                    className: "shared_elements",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            style: {
                                                height: listCheckedCompanies.length == 0 ? "50%" : "70%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                    label: "Datasets (" + listCheckedDatasets.length + "/" + datasets.length + ")",
                                                    listLabelClassName: "titles-input"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    className: "dataset_list_companies",
                                                    children: datasets.map((dataset, i)=>{
                                                        let bool = listCheckedDatasets.length > 0 ? listCheckedDatasets.some((d)=>d == dataset.id) : data ? authorizations?.datasets_ids?.some((d)=>d == dataset.id) : false;
                                                        //let bool = listCheckedChannel.includes(_channel.id)
                                                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                            className: "project-block",
                                                            "data-checked": "false",
                                                            "data-id": "dataset-" + dataset.id,
                                                            style: {
                                                                border: bool ? "2px solid var(--main)" : ""
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                                    style: {
                                                                        alignItems: "center",
                                                                        display: "flex"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                                            className: "fas fa-database iconListUserForm"
                                                                        }),
                                                                        dataset.company.name,
                                                                        " - ",
                                                                        dataset.name
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                                                        id: dataset.id + "dataset_button",
                                                                        className: "main-iconButton add-hover modalButtons-input",
                                                                        icon: bool ? "fas fa-check-circle" : "fas fa-plus-circle",
                                                                        onClick: (e)=>checkDataset(dataset),
                                                                        style: {
                                                                            color: bool ? "var(--green)" : "var(--main)"
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)());
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            style: {
                                                height: listCheckedCompanies.length == 0 ? "50%" : "70%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                    label: "Dashboards (" + listCheckedDashboards.length + "/" + dashboards.length + ")",
                                                    listLabelClassName: "titles-input"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    className: "dashboard_list_company_form_user",
                                                    children: dashboards.map((dashboard, i)=>{
                                                        let bool = listCheckedDashboards.length > 0 ? listCheckedDashboards.some((d)=>d == dashboard.id) : data ? authorizations?.dashboards_ids?.some((d)=>d == dashboard.id) : false;
                                                        let isShared = dashboard.origin == 0;
                                                        //let bool = listCheckedChannel.includes(_channel.id)
                                                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                            className: "project-block",
                                                            "data-checked": "false",
                                                            "data-id": "dashboard-" + dashboard.id,
                                                            style: {
                                                                border: bool ? "2px solid var(--main)" : ""
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                                    style: {
                                                                        alignItems: "center",
                                                                        display: "flex"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                                            className: "iconListUserForm " + (isShared ? "fas fa-link" : "fas fa-tachometer-alt"),
                                                                            title: isShared ? "Shared dashboard" : "Main dashboard"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                                                    style: {
                                                                                        fontSize: isShared ? "14px" : ""
                                                                                    },
                                                                                    children: dashboard.dashboard.company.name + (isShared ? " -> " + dashboard.company.name : "")
                                                                                }),
                                                                                " - ",
                                                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                                                    style: {
                                                                                        color: "var(--main)"
                                                                                    },
                                                                                    children: dashboard.name != "" && dashboard.name != null ? dashboard.name : dashboard.dashboard.name
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                                                        id: dashboard.id + "dashboard_button",
                                                                        className: "main-iconButton add-hover modalButtons-input",
                                                                        icon: bool ? "fas fa-check-circle" : "fas fa-plus-circle",
                                                                        onClick: (e)=>checkDashboard(dashboard),
                                                                        style: {
                                                                            color: bool ? "var(--green)" : "var(--main)"
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)());
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                justifyContent: "space-between",
                                                width: "90%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                    className: "user_form_advanced_parameters",
                                                    onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("roles_in_companies"),
                                                    children: [
                                                        " ",
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                            className: "fas fa-arrow-left",
                                                            style: {
                                                                marginRight: "10px",
                                                                marginTop: "25px"
                                                            }
                                                        }),
                                                        "Roles"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                    className: "user_form_advanced_parameters",
                                                    onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("analytics_section"),
                                                    children: [
                                                        "Analytics ",
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                            className: "fas fa-arrow-right",
                                                            style: {
                                                                marginLeft: "5px",
                                                                marginTop: "25px"
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                                    name: "analytics_section",
                                    className: "analytics_section",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            style: {
                                                height: "85%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                    label: "Analytics : Channels access (" + listCheckedChannels.length + "/" + channels.length + ")",
                                                    listLabelClassName: "titles-input"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    className: "user_analytics_list",
                                                    children: channels.map((channel, i)=>{
                                                        let bool = listCheckedChannels.length > 0 ? listCheckedChannels.some((ch)=>ch == channel.id) : data ? authorizations?.channels_ids?.some((c)=>c == channel.id) : false;
                                                        //let bool = listCheckedChannel.includes(_channel.id)
                                                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                            className: "project-block",
                                                            "data-checked": "false",
                                                            "data-id": "channel-" + channel.id,
                                                            style: {
                                                                border: bool ? "2px solid var(--main)" : ""
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                                    style: {
                                                                        alignItems: "center",
                                                                        display: "flex"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                                            className: "iconListUserForm fas fa-chart-line"
                                                                        }),
                                                                        channel.bot.company.name,
                                                                        " - ",
                                                                        channel.name
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                                                        id: channel.id + "analytics_button",
                                                                        className: "main-iconButton add-hover modalButtons-input",
                                                                        icon: bool ? "fas fa-check-circle" : "fas fa-plus-circle",
                                                                        onClick: (e)=>checkChannel(channel),
                                                                        style: {
                                                                            color: bool ? "var(--green)" : "var(--main)"
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)());
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "user_form_advanced_parameters",
                                            onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("shared_elements"),
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                    className: "fas fa-arrow-left",
                                                    style: {
                                                        marginRight: "10px",
                                                        marginTop: "25px"
                                                    }
                                                }),
                                                " Shared elements"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                    type: "submit",
                    label: dataType.send,
                    className: "validate",
                    disabled: !formState.isValid || !file
                })
            })
        ]
    });
}
var $5ec5a04d4c1cb3ca$export$2e2bcd8739ae039 = $5ec5a04d4c1cb3ca$var$UserForm;



function $4f9f7b6d02f7d776$var$UserFormPage() {
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    var data = null;
    var type = null;
    if (location.state != null) {
        data = location.state.data;
        type = location.state.type;
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $afaae2ff7871e331$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5ec5a04d4c1cb3ca$export$2e2bcd8739ae039), {
                data: data,
                type: type
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f0aded74899c8465$export$2e2bcd8739ae039), {})
        ]
    });
}
var $4f9f7b6d02f7d776$export$2e2bcd8739ae039 = $4f9f7b6d02f7d776$var$UserFormPage;


const $0a051dc162399f74$var$routes = [
    {
        path: "administration/company/list",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b22549fe7ff54578$export$2e2bcd8739ae039), {}),
        isPublic: false,
        isSidebar: true,
        permissions: [
            "view_organizations"
        ]
    },
    {
        path: "administration/phone/list",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $196e592e589b2436$export$2e2bcd8739ae039), {}),
        isPublic: false,
        isSidebar: true,
        permissions: [
            "view_phones"
        ]
    },
    {
        path: "administration/user/list",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a3433e79cea6dd3d$export$2e2bcd8739ae039), {}),
        isPublic: false,
        isSidebar: true,
        permissions: [
            "view_users"
        ]
    },
    {
        path: "administration/user/create",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4f9f7b6d02f7d776$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "add_user"
        ]
    },
    {
        path: "administration/user/update",
        component: (data, type)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4f9f7b6d02f7d776$export$2e2bcd8739ae039), {
                data: data,
                type: type
            }),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "update_user"
        ]
    },
    {
        path: "administration/role/list",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ced148e02704f9f9$export$2e2bcd8739ae039), {}),
        isPublic: false,
        isSidebar: true,
        permissions: [
            "view_roles"
        ]
    },
    {
        path: "administration/user/logs",
        component: (data)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a2df2e646326eb90$export$2e2bcd8739ae039), {
                data: data
            }),
        isPublic: false,
        isSidebar: true,
        permissions: [
            "view_users"
        ]
    },
    {
        path: "administration/company/logs",
        component: (data)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fd6c2b11f8aa06e5$export$2e2bcd8739ae039), {
                data: data
            }),
        isPublic: false,
        isSidebar: true,
        permissions: [
            "view_organizations"
        ]
    }
];
var $0a051dc162399f74$export$2e2bcd8739ae039 = $0a051dc162399f74$var$routes;












function $f91ae1a82fdc79e1$var$TitleContainer({ title: title, url: url }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "title-container",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                className: "title",
                children: title
            }),
            url ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0bd3411f2ec14e23$export$b0d92dbee9b5b60d), {
                to: url,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                    className: "main-iconButton profil_action main_add-button space_tableButton",
                    icon: "fas fa-plus"
                })
            }) : null
        ]
    });
}
var $f91ae1a82fdc79e1$export$2e2bcd8739ae039 = $f91ae1a82fdc79e1$var$TitleContainer;







function $e5ae607fbb1266e0$var$Block({ type: type, name: name, description: description, created_at: created_at, language: language }) {
    var [date] = created_at.split("T");
    date = new Date(date).toDateString();
    date = date.split(" ");
    date.shift();
    var [m, d, y] = date;
    date = `${d} ${m}, ${y}`;
    const code = language.slug.toLowerCase();
    var Icon = (0, $9f25a7789d4433b1$export$2e2bcd8739ae039).filter((lang)=>lang.value == code).shift();
    if (Icon) Icon = Icon.text;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0bd3411f2ec14e23$export$b0d92dbee9b5b60d), {
            to: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)(`/${type}/${name}`),
            className: "block",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "main-container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "child-container",
                        children: [
                            Icon && Icon,
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "child-container first-child",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            style: {
                                                textOverflow: "ellipsis",
                                                overflow: "hidden"
                                            },
                                            children: name
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "child-container second-child",
                                        style: {
                                            textAlign: "center"
                                        },
                                        children: date
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "child-container third-child",
                        style: {
                            minHeight: "44px"
                        },
                        children: description
                    })
                ]
            })
        })
    });
}
var $e5ae607fbb1266e0$export$2e2bcd8739ae039 = $e5ae607fbb1266e0$var$Block;



function $0a2fcb6bbd0beaea$var$List({ type: type, data: data, title: title, url: url }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f91ae1a82fdc79e1$export$2e2bcd8739ae039), {
                title: title,
                ...url ? {
                    url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)(url)
                } : null
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "list",
                children: data && data.map((block, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e5ae607fbb1266e0$export$2e2bcd8739ae039), {
                        type: type,
                        ...block
                    }, index))
            })
        ]
    });
}
$0a2fcb6bbd0beaea$var$List.defaultProps = {
    data: []
};
var $0a2fcb6bbd0beaea$export$2e2bcd8739ae039 = $0a2fcb6bbd0beaea$var$List;




function $a3a61402180f0ce3$var$Home({ data: data }) {
    const { datasets: datasets, bots: bots, username: username } = data;
    const sortList = (data)=>{
        return data.sort((a, b)=>{
            return new Date(b.updated_at) - new Date(a.updated_at);
        });
    };
    let botsSorted = sortList(bots);
    let datasetsSorted = sortList(datasets);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "feature-bar",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "welcome-message",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "row",
                        children: [
                            "Hey ",
                            username,
                            " \uD83D\uDC4B"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "list-container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "row",
                        children: (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_bots") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0a2fcb6bbd0beaea$export$2e2bcd8739ae039), {
                            title: "Bots",
                            data: botsSorted,
                            type: "bots",
                            ...(0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("create_bot") ? {
                                url: "/bot/create"
                            } : null
                        }) : null
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "row",
                        children: (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_datasets") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0a2fcb6bbd0beaea$export$2e2bcd8739ae039), {
                            title: "Datasets",
                            data: datasetsSorted,
                            type: "datasets",
                            ...(0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("create_dataset") ? {
                                url: "/dataset/create"
                            } : null
                        }) : null
                    })
                ]
            })
        ]
    });
}
var $a3a61402180f0ce3$export$2e2bcd8739ae039 = $a3a61402180f0ce3$var$Home;




function $a12d86d547630dbd$var$HomePage() {
    const { logo: logo, name: name, bots: bots, datasets: datasets } = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company");
    const { username: username } = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("user");
    const head = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                className: "company-logo",
                srcSet: logo
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                children: name
            })
        ]
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: head
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a3a61402180f0ce3$export$2e2bcd8739ae039), {
                data: {
                    bots: bots,
                    datasets: datasets,
                    username: username
                }
            })
        ]
    });
}
var $a12d86d547630dbd$export$2e2bcd8739ae039 = $a12d86d547630dbd$var$HomePage;


const $9e8491672d0f3b27$var$routes = [
    {
        path: "company/:company/home",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a12d86d547630dbd$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "view_home"
        ]
    }
];
var $9e8491672d0f3b27$export$2e2bcd8739ae039 = $9e8491672d0f3b27$var$routes;












var $bh6RR = parcelRequire("bh6RR");












function $f481869b958a6ae9$var$BlockCompany({ name: name, logo: logo, id: id }) {
    const { changeCompany: changeCompany } = (0, $575009abb68f6393$export$2e2bcd8739ae039);
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const updateCompany = async ()=>{
        const res = await changeCompany(id);
        if (res.error != null) return;
        const { user: user, company: company } = res;
        toast.success("Congrats " + user.username, "You change your are now in" + company.name);
        navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("home"));
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "block-company",
        onClick: updateCompany,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    src: logo
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                children: (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(name)
            })
        ]
    });
}
var $f481869b958a6ae9$export$2e2bcd8739ae039 = $f481869b958a6ae9$var$BlockCompany;




var $bh6RR = parcelRequire("bh6RR");






const $8bc8d560b808bee1$var$DropdownCompany = ({ prefix: prefix, companies: companies })=>{
    const [isOpen, setIsOpen] = (0, $bh6RR.useState)(false);
    const { changeCompany: changeCompany } = (0, $575009abb68f6393$export$2e2bcd8739ae039);
    const naviguate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const toggleDropdown = ()=>{
        setIsOpen(!isOpen);
    };
    const updateCompany = async (id)=>{
        const res = await changeCompany(id);
        if (res.error != null) {
            console.error(res.error);
            return;
        }
        const { user: user, company: company } = res;
        toast.success("Congrats " + user.username, "You change your are now in" + company.name);
        naviguate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("home"));
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "dropdown-company",
                onClick: toggleDropdown,
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            gap: "0.5rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                children: (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(prefix)
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                children: [
                                    "(",
                                    companies.length,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        children: isOpen ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                            className: "fa fa-chevron-up"
                        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                            className: "fa fa-chevron-down"
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "dropdown-content",
                children: companies.map((company)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($8bc8d560b808bee1$var$DropdownItem, {
                        ...company,
                        updateCompany: updateCompany
                    }, company.id))
            })
        ]
    });
};
const $8bc8d560b808bee1$var$DropdownItem = ({ name: name, logo: logo, id: id, updateCompany: updateCompany })=>{
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "dropdown-company dropdown-item",
        onClick: ()=>updateCompany(id),
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            style: {
                display: "flex",
                gap: "1rem",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        src: logo
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    style: {
                        width: "180px"
                    },
                    children: (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(name)
                })
            ]
        })
    });
};
var $8bc8d560b808bee1$export$2e2bcd8739ae039 = $8bc8d560b808bee1$var$DropdownCompany;


function $9ce55a87a8c0724a$var$ListCompany({ state: state }) {
    const { getCompaniesWithoutPagination: getCompaniesWithoutPagination } = (0, $e2bea698183eb612$export$2e2bcd8739ae039);
    const [companies, setCompanies] = state;
    const regex = /[\-_ \d]|(?<=[a-z])(?=[A-Z])/;
    const getPrefix = (name)=>{
        const normalizedName = name.toLowerCase();
        const match = normalizedName.split(regex)[0];
        return match;
    };
    const groupCompaniesByPrefix = (companies)=>{
        const grouped = {};
        const uniqueCompanies = [];
        companies.forEach((company)=>{
            const prefix = getPrefix(company.name);
            if (!grouped[prefix]) grouped[prefix] = [];
            grouped[prefix].push(company);
        });
        Object.keys(grouped).forEach((prefix)=>{
            if (grouped[prefix].length === 1) {
                uniqueCompanies.push(grouped[prefix][0]);
                delete grouped[prefix];
            }
        });
        return {
            grouped: grouped,
            unique: uniqueCompanies
        };
    };
    (0, $bh6RR.useEffect)(()=>{
        let isCompaniesInfo = true;
        const fetchData = async ()=>{
            const [response, error] = await getCompaniesWithoutPagination();
            error;
            setCompanies(response);
        };
        fetchData().catch((err)=>console.error(err));
        return ()=>isCompaniesInfo = false;
    }, [
        setCompanies
    ]);
    const { grouped: grouped, unique: unique } = groupCompaniesByPrefix(companies);
    const combinedList = [
        ...unique.map((company)=>({
                type: "company",
                company: company,
                sortKey: company.name
            })),
        ...Object.keys(grouped).map((prefix)=>({
                type: "group",
                prefix: prefix,
                companies: grouped[prefix],
                sortKey: prefix
            }))
    ];
    // Trier la liste combinée par sortKey
    combinedList.sort((a, b)=>a.sortKey.localeCompare(b.sortKey));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "list scrollbar",
        children: combinedList.map((item, index)=>item.type === "group" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $8bc8d560b808bee1$export$2e2bcd8739ae039), {
                prefix: item.prefix,
                companies: item.companies
            }, `group-${item.prefix}`) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f481869b958a6ae9$export$2e2bcd8739ae039), {
                ...item.company
            }, `company-${item.company.id}`))
    });
}
var $9ce55a87a8c0724a$export$2e2bcd8739ae039 = $9ce55a87a8c0724a$var$ListCompany;





var $bh6RR = parcelRequire("bh6RR");

function $3838cf6b1e241825$var$ChooseCompany() {
    const form = {
        id: null,
        name: null,
        image: null,
        owner: null
    };
    const [companies, setCompanies] = (0, $bh6RR.useState)([]);
    const [searchTerm, setSearchTerm] = (0, $bh6RR.useState)("");
    const onCreateCompany = (data)=>{
        (0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("list-company");
        setTimeout(()=>setCompanies([
                data,
                ...companies
            ]), 350);
    };
    const handleSearch = (event)=>{
        const value = event.target.value;
        setSearchTerm(value);
    };
    const getFilteredCompanies = ()=>{
        if (searchTerm.length >= 3) return companies.filter((company)=>company.name.toLowerCase().includes(searchTerm.toLowerCase()));
        return companies;
    };
    const filteredCompanies = getFilteredCompanies();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "choose-company-part",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $51a8b46ec4198ef9$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                    name: "list-company",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                alignItems: "baseline",
                                justifyContent: "space-between"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                                    children: " Choose an Organization "
                                }),
                                (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("create_organization") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                    className: "main-iconButton profil_action main_add-button",
                                    icon: "fas fa-plus",
                                    onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("create-company")
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "start-row",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "input-container no-margin",
                                style: {
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b8b90ec975873f14$export$2e2bcd8739ae039), {
                                    style: {
                                        marginRight: 20,
                                        background: "var(--white)"
                                    },
                                    placeholderLibelle: "organization",
                                    name: "organization",
                                    onChange: handleSearch
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9ce55a87a8c0724a$export$2e2bcd8739ae039), {
                            state: [
                                filteredCompanies,
                                setCompanies
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                    name: "create-company",
                    className: "create-company",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                alignItems: "baseline",
                                marginLeft: "10px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                    className: "main-iconButton profil_action main_add-button space_tableButton",
                                    icon: "fas fa-arrow-left",
                                    onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("list-company")
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                                    style: {
                                        marginLeft: "55px"
                                    },
                                    children: " Add an Organization "
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0b33cd4b35f2c016$export$2e2bcd8739ae039), {
                            form: form,
                            onSend: onCreateCompany
                        })
                    ]
                })
            ]
        })
    });
}
var $3838cf6b1e241825$export$2e2bcd8739ae039 = $3838cf6b1e241825$var$ChooseCompany;


function $15d71a329a983f34$var$ChooseCompanyPage() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "page default",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3838cf6b1e241825$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "quote-part",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f0aded74899c8465$export$2e2bcd8739ae039), {
                    fontSize: "50",
                    fontColor: "white"
                })
            })
        ]
    });
}
var $15d71a329a983f34$export$2e2bcd8739ae039 = $15d71a329a983f34$var$ChooseCompanyPage;


const $d8940df0f6e1e717$var$routes = [
    {
        path: "user/no-company",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $15d71a329a983f34$export$2e2bcd8739ae039), {}),
        isSidebar: false,
        isPublic: false,
        permissions: [
            "change_company"
        ]
    }
];
var $d8940df0f6e1e717$export$2e2bcd8739ae039 = $d8940df0f6e1e717$var$routes;











function $d44e7bb7a11e4c70$var$AnalyticsTable() {
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const { getBots: getBots, getBotsShared: getBotsShared } = (0, $24a8370de200c756$export$2e2bcd8739ae039);
    const cells = [
        {
            column: "Name",
            name: "name",
            show: (value)=>(0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value)
        },
        {
            column: "Language",
            name: "language.slug",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: "flag-icon flag-icon-" + value.toLowerCase()
                })
        }
    ];
    const getAllBots = async (data)=>{
        const result = await Promise.all([
            getBots(data),
            getBotsShared(data)
        ]);
        if (result[0][1] != null || result[1][1] != null) return [
            null,
            result[0][1] != null ? result[0][1] : result[1][1]
        ];
        const mergeData = result[0][0].concat(result[1][0]);
        mergeData.sort((a, b)=>{
            return a.name.localeCompare(b.name);
        });
        return [
            mergeData,
            null
        ];
    };
    const onClickView = ({ row: row, updateRow: updateRow, getIndex: getIndex })=>{
        navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/supervision/analytics/" + row.name));
    };
    const actions = [
        {
            className: "fas fa-chart-pie blue",
            style: {},
            onClick: onClickView
        }
    ];
    const buttons = [];
    const filterPostRequest = (value)=>value.conversation_storage_time != 0;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: "Analytics List"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
                name: "analytic",
                cells: cells,
                api: getAllBots,
                withPagination: false,
                actions: actions,
                buttons: buttons,
                filterPostRequest: filterPostRequest
            })
        ]
    });
}
var $d44e7bb7a11e4c70$export$2e2bcd8739ae039 = $d44e7bb7a11e4c70$var$AnalyticsTable;


function $2c6f290c170e8f3a$var$AnalyticsList() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d44e7bb7a11e4c70$export$2e2bcd8739ae039), {});
}
var $2c6f290c170e8f3a$export$2e2bcd8739ae039 = $2c6f290c170e8f3a$var$AnalyticsList;











var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
const $492314d12994f680$export$3ae94a2503e890a1 = (date)=>{
    var d = new Date(date), month = "" + (d.getMonth() + 1), day = "" + d.getDate(), year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [
        year,
        month,
        day
    ].join("-");
};
const $492314d12994f680$export$dd412b56f1e4d8aa = (dateObj, numDays)=>{
    dateObj.setDate(dateObj.getDate() + numDays);
    return dateObj;
};
const $492314d12994f680$export$7f8baf765ac4d32c = (startDate, endDate)=>{
    startDate = new Date(startDate);
    endDate = new Date(endDate);
    const date = new Date(startDate.getTime());
    const dates = [];
    while(date <= endDate){
        dates.push($492314d12994f680$export$3ae94a2503e890a1(new Date(date)));
        date.setDate(date.getDate() + 1);
    }
    return dates;
};
const $492314d12994f680$export$4083acfb0660b3eb = (startDate, perdiod)=>{
    return {
        start: $492314d12994f680$export$3ae94a2503e890a1($492314d12994f680$export$dd412b56f1e4d8aa(new Date(startDate), perdiod)),
        end: $492314d12994f680$export$3ae94a2503e890a1($492314d12994f680$export$dd412b56f1e4d8aa(new Date(startDate), -1))
    };
};


const $86e52d87e3c3d7b1$var$PeriodDuration = {
    custom: 0,
    day: -1,
    week: -7,
    month: -30,
    year: -365,
    all: -3650
};
var $86e52d87e3c3d7b1$export$2e2bcd8739ae039 = $86e52d87e3c3d7b1$var$PeriodDuration;


const $db6815d68820e964$var$periodChoice = "month";
const { start: $db6815d68820e964$var$start, end: $db6815d68820e964$var$end } = (0, $492314d12994f680$export$4083acfb0660b3eb)(new Date(), (0, $86e52d87e3c3d7b1$export$2e2bcd8739ae039)[$db6815d68820e964$var$periodChoice]);
const $db6815d68820e964$var$last = (0, $492314d12994f680$export$4083acfb0660b3eb)($db6815d68820e964$var$start, (0, $86e52d87e3c3d7b1$export$2e2bcd8739ae039)[$db6815d68820e964$var$periodChoice]);
const $db6815d68820e964$var$AnalyticsState = {
    firstPeriod: {
        date_start: $db6815d68820e964$var$start,
        date_end: $db6815d68820e964$var$end
    },
    secondPeriod: {
        date_start: $db6815d68820e964$var$last.start,
        date_end: $db6815d68820e964$var$last.end
    },
    periodChoice: $db6815d68820e964$var$periodChoice,
    channel_type_id: null,
    channel_id: null,
    redirection_id: null,
    metrics_id: null,
    condition_id: null,
    content: "",
    analytics: {
        average_duration_of_conversations: {},
        average_duration_of_conversations_stats: {},
        average_number_of_messages: {},
        average_number_of_messages_stats: {},
        number_of_conversations: {},
        number_of_conversations_stats: {},
        number_of_message_per_day: {},
        number_of_messages: {},
        number_of_messages_stats: {},
        number_of_users: {},
        number_of_users_stats: {},
        number_of_minutes_total: {},
        number_of_minutes_total_stats: {},
        number_of_minutes_bot: {},
        number_of_minutes_bot_stats: {},
        number_of_minutes_human: {},
        number_of_minutes_human_stats: {}
    },
    metrics: {
        conditions: [],
        redirections: []
    },
    channels: [],
    view: "dates",
    peakActivity: [],
    redirectionActivity: []
};
var $db6815d68820e964$export$2e2bcd8739ae039 = $db6815d68820e964$var$AnalyticsState;


function $acc703a7dc0f852e$var$AnalyticsReducer(state, action) {
    switch(action.type){
        case "setResultInformation":
            return {
                ...state,
                ...action.payload
            };
        case "resetState":
            return 0, $db6815d68820e964$export$2e2bcd8739ae039;
        case "SET_CLICKED_LABEL":
            return {
                ...state,
                clickedLabel: action.payload
            };
        case "SET_CLICKED_TIME":
            if (action.payload === null) return {
                ...state,
                clickedTime: null,
                clickedDate: null
            };
            return {
                ...state,
                clickedTime: action.payload.time,
                clickedDate: action.payload.date
            };
        case "SET_LOADING":
            return {
                ...state,
                isLoading: action.payload
            };
        case "RESET_CLICKED_STATES":
            return {
                ...state,
                clickedLabel: null,
                clickedTime: null
            };
        case "SET_VIEW":
            return {
                ...state,
                view: action.payload
            };
        case "RESET_VIEW_TO_DATES":
            return {
                ...state,
                view: "dates"
            };
        default:
            throw new Error("unhandled action");
    }
}
var $acc703a7dc0f852e$export$2e2bcd8739ae039 = $acc703a7dc0f852e$var$AnalyticsReducer;



const $612615ca67331c5d$var$AnalyticsStateContext = /*#__PURE__*/ (0, $bh6RR.createContext)((0, $db6815d68820e964$export$2e2bcd8739ae039));
const $612615ca67331c5d$var$AnalyticsDispatchContext = /*#__PURE__*/ (0, $bh6RR.createContext)(null);
function $612615ca67331c5d$var$AnalyticsContextProvider({ children: children }) {
    const [state, dispatch] = (0, $bh6RR.useReducer)((0, $acc703a7dc0f852e$export$2e2bcd8739ae039), (0, $db6815d68820e964$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($612615ca67331c5d$var$AnalyticsStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($612615ca67331c5d$var$AnalyticsDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
}
var $612615ca67331c5d$export$2e2bcd8739ae039 = $612615ca67331c5d$var$AnalyticsContextProvider;
const $612615ca67331c5d$export$89605b40d8b4f599 = ()=>(0, $bh6RR.useContext)($612615ca67331c5d$var$AnalyticsStateContext);
const $612615ca67331c5d$export$2708059e7a8caa93 = ()=>(0, $bh6RR.useContext)($612615ca67331c5d$var$AnalyticsDispatchContext);



var $bh6RR = parcelRequire("bh6RR");



function $1f09a1e13b0fcc18$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4ff366e58c33ccee$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $5fa2427dbbbb369e$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $d4cc3831797a4057$export$2e2bcd8739ae039)(dirtyDate, -amount);
}




var $5432fd46a827f2ed$export$2e2bcd8739ae039 = {
    getConversations: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("conversations/completed", data),
    getConversation: ({ id: id })=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`conversation/completed/${id}`, {}),
    deleteConversation: (id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`conversation/completed/${id}`),
    getAudioOfConversation: ({ id: id, object_id: object_id })=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`conversation/completed/${id}`, {
            object_id: object_id
        })
};


function $8d408649534363a8$var$useConversationDurations({ periodChoice: periodChoice, date_start: date_start, date_end: date_end, channel_id: channel_id = null }) {
    const [conversations, setConversations] = (0, $bh6RR.useState)([]);
    const [loading, setLoading] = (0, $bh6RR.useState)(true);
    const { getConversations: getConversations } = (0, $5432fd46a827f2ed$export$2e2bcd8739ae039);
    const finalPeriod = (0, $bh6RR.useMemo)(()=>{
        if (periodChoice && periodChoice !== "custom") {
            const now = new Date();
            const nbDays = Math.abs((0, $86e52d87e3c3d7b1$export$2e2bcd8739ae039)[periodChoice] || 0);
            return {
                date_start: (0, $e91dd50cc5cd7f0e$export$2e2bcd8739ae039)((0, $1f09a1e13b0fcc18$export$2e2bcd8739ae039)(now, nbDays), "yyyy-MM-dd"),
                date_end: (0, $e91dd50cc5cd7f0e$export$2e2bcd8739ae039)(now, "yyyy-MM-dd"),
                channel_id: channel_id
            };
        }
        return {
            date_start: date_start,
            date_end: date_end,
            channel_id: channel_id
        };
    }, [
        periodChoice,
        date_start,
        date_end,
        channel_id
    ]);
    (0, $bh6RR.useEffect)(()=>{
        async function fetchGraphData() {
            setLoading(true);
            try {
                console.log(finalPeriod);
                const responseArray = await getConversations({
                    date_start: finalPeriod.date_start,
                    date_end: finalPeriod.date_end,
                    forGraph: true,
                    channel_id: finalPeriod.channel_id
                });
                let dataArr = [];
                if (Array.isArray(responseArray)) {
                    const item = responseArray.find((r)=>r && Array.isArray(r.data));
                    dataArr = item?.data || [];
                } else if (Array.isArray(responseArray.data)) dataArr = responseArray.data;
                setConversations(dataArr);
            } catch (err) {
                console.error("Erreur fetch graph calls", err);
                setConversations([]);
            } finally{
                setLoading(false);
            }
        }
        if (finalPeriod.date_start && finalPeriod.date_end) fetchGraphData();
    }, [
        periodChoice,
        date_start,
        date_end,
        getConversations,
        channel_id
    ]);
    return {
        conversations: conversations,
        loading: loading
    };
}
var $8d408649534363a8$export$2e2bcd8739ae039 = $8d408649534363a8$var$useConversationDurations;




function $6aeeaf3992abef38$var$numberWithSpaces(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
function $6aeeaf3992abef38$var$AnalyticsBlock({ className: className, title: title, number: number, percentage: percentage, type: type, stateSection: stateSection, hoverInfo: hoverInfo }) {
    var classNameDetails = "details";
    var classNameArrow = "";
    if (percentage > 0) {
        classNameDetails = classNameDetails + " up";
        classNameArrow = "arrow up";
    }
    if (percentage < 0) {
        classNameDetails = classNameDetails + " down";
        classNameArrow = "arrow down";
    }
    const [section, setSection] = stateSection;
    if (isNaN(number) == false) {
        number = Math.round(number * 100) / 100;
        number = $6aeeaf3992abef38$var$numberWithSpaces(number);
    }
    const active = type == section;
    className = className ? "block " + className : "block";
    className = active ? className + " active" : className;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: className,
        onClick: ()=>setSection(type != section ? type : null),
        title: hoverInfo,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                className: "title",
                children: title
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "block_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "number",
                        children: number
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: classNameDetails
                    })
                ]
            })
        ]
    });
}
$6aeeaf3992abef38$var$AnalyticsBlock.defaultProps = {
    className: "",
    title: "Block",
    number: 0,
    percentage: 0,
    type: "",
    stateSection: []
};
var $6aeeaf3992abef38$export$2e2bcd8739ae039 = $6aeeaf3992abef38$var$AnalyticsBlock;







const $c0945ce29f1eac52$var$BuildMetricsChoice = (metrics)=>{
    const conditionsChoice = metrics.conditions.filter((condition)=>condition.name != null).map((condition)=>{
        return {
            value: condition.id + "-condition_id",
            text: condition.name == null ? condition.id : condition.name,
            index: condition.id
        };
    });
    const redirectionsChoice = metrics.redirections.filter((condition)=>condition.name != null).map((redirection)=>{
        return {
            value: redirection.id + "-redirection_id",
            text: redirection.name == null ? redirection.id : redirection.name,
            index: redirection.id
        };
    });
    const metricsChoice = [
        {
            value: null,
            text: "All Metrics",
            index: null
        },
        ...conditionsChoice,
        ...redirectionsChoice
    ];
    return metricsChoice;
};
var $c0945ce29f1eac52$export$2e2bcd8739ae039 = $c0945ce29f1eac52$var$BuildMetricsChoice;



var $bh6RR = parcelRequire("bh6RR");



const $d496355af03335df$var$colors = [
    "#2196F3",
    "#FF4081",
    "#8BC34A",
    "#FFEB3B",
    "#009688",
    "#7C4DFF",
    "#00BCD4",
    "#FF9800",
    "#4CAF50",
    "#3F51B5",
    "#607D8B",
    "#FF5722",
    "#03A9F4",
    "#795548"
];
const $d496355af03335df$var$sortObject = (o)=>Object.keys(o).sort().reduce((r, k)=>(r[k] = o[k], r), {});
const $d496355af03335df$var$getDates = (analytic)=>{
    const dateRanges = [];
    for(let key in analytic){
        let value = analytic[key];
        let dates = Object.keys(value).map((str)=>new Date(str));
        dateRanges.push(new Date(Math.min(...dates)));
        dateRanges.push(new Date(Math.max(...dates)));
    }
    const datesPeriods = {
        start: Math.min(...dateRanges),
        end: Math.max(...dateRanges)
    };
    const dates = (0, $492314d12994f680$export$7f8baf765ac4d32c)((0, $492314d12994f680$export$dd412b56f1e4d8aa)(new Date(datesPeriods.start), -1), datesPeriods.end);
    return dates;
};
const $d496355af03335df$var$buildDatasetsMetrics = (metric)=>{
    const dates = $d496355af03335df$var$getDates(metric);
    const datasets = Object.keys(metric).map((key, idx)=>{
        var row = {
            ...metric[key]
        };
        dates.map((date)=>row[date] = row[date] !== undefined ? row[date] : 0);
        row = {
            ...$d496355af03335df$var$sortObject(row)
        };
        const color = $d496355af03335df$var$colors[idx];
        return {
            id: idx,
            label: key,
            data: row,
            pointRadius: 1,
            borderColor: color,
            backgroundColor: color,
            spanGaps: true
        };
    });
    return [
        datasets,
        dates
    ];
};
const $d496355af03335df$var$prepareDataMetric = (metrics, metricsChoice, metrics_id)=>{
    const metricIndex = metricsChoice.findIndex((metric)=>metric.index == metrics_id);
    const metric = metricsChoice[metricIndex];
    var type_metric = "";
    if (metric.value.includes("condition")) type_metric = "conditions";
    if (metric.value.includes("redirection")) type_metric = "redirections";
    const metricsListRedirectionsOrConditions = metrics[type_metric];
    return metricsListRedirectionsOrConditions.filter((row)=>row.id == metrics_id).pop();
};
function $d496355af03335df$export$d6477e394a1cc22(analytics, metrics, type, option, metrics_id) {
    const metricsChoice = (0, $c0945ce29f1eac52$export$2e2bcd8739ae039)(metrics);
    const data = $d496355af03335df$var$prepareDataMetric(metrics, metricsChoice, metrics_id);
    return data;
}
function $d496355af03335df$export$76b2c6e79e0bcec0(analytics, metrics, type, option, metrics_id) {
    const metricsChoice = (0, $c0945ce29f1eac52$export$2e2bcd8739ae039)(metrics);
    if (metrics_id != null && type == "metrics" && option == "line") {
        const data = $d496355af03335df$var$prepareDataMetric(metrics, metricsChoice, metrics_id);
        var [datasets, dates] = $d496355af03335df$var$buildDatasetsMetrics(data.values);
        return {
            id: "multi-line",
            labels: [
                ...dates
            ],
            datasets: datasets
        };
    }
    if (metrics_id != null && type == "metrics" && option == "pie") {
        const { values: values } = $d496355af03335df$var$prepareDataMetric(metrics, metricsChoice, metrics_id);
        const row = Object.values(values).map((analytic)=>Object.values(analytic).reduce((accumulator, value)=>accumulator + value));
        return {
            id: "pie",
            labels: Object.keys(values),
            datasets: [
                {
                    label: "test",
                    data: row,
                    borderColor: $d496355af03335df$var$colors,
                    backgroundColor: $d496355af03335df$var$colors
                }
            ]
        };
    }
    if (type == "metrics") type = "number_of_messages";
    const data = analytics[type];
    return {
        id: type,
        labels: $d496355af03335df$var$getDates(data),
        datasets: [
            {
                label: type,
                data: data,
                borderColor: "rgb(14, 122, 237, 0.8)",
                pointBackgroundColor: "rgb(14, 122, 237, 0.8)",
                pointRadius: 1,
                backgroundColor: "rgb(14, 122, 237, 0.6)",
                spanGaps: true
            }
        ]
    };
}




function $d243346d1fa8c7d5$var$AnalyticsGraphHook(metrics, metrics_id) {
    const metricsChoice = (0, $c0945ce29f1eac52$export$2e2bcd8739ae039)(metrics);
    const dispatch = (0, $612615ca67331c5d$export$2708059e7a8caa93)();
    const getMetricValue = ()=>{
        const metric = getMetric();
        if (!metric) return null;
        return metric.value ? metric.text : metric.id;
    };
    const getMetric = ()=>{
        const indexMetric = metricsChoice.findIndex((metric)=>metric.index == metrics_id);
        if (indexMetric === -1) return null;
        return metricsChoice[indexMetric];
    };
    const setChoiceMetric = (index)=>{
        var indexMetric = metricsChoice.findIndex((metric)=>metric.index == metrics_id);
        if (indexMetric == -1) console.error();
        indexMetric = indexMetric + index;
        indexMetric = indexMetric == -1 ? metricsChoice.length - 1 : indexMetric;
        indexMetric = indexMetric == metricsChoice.length ? 0 : indexMetric;
        const value = metricsChoice[indexMetric].value;
        var payload = {
            condition_id: null,
            redirection_id: null,
            metrics_id: null
        };
        var [id, type] = [
            0,
            ""
        ];
        if (value != null) {
            [id, type] = value.split("-");
            payload = {
                ...payload,
                [type]: id,
                metrics_id: id
            };
        }
        const typesMetrics = {
            condition_id: "conditions",
            redirection_id: "redirections"
        };
        if (type) {
            var IndexMetricPrecise = metrics[typesMetrics[type]].findIndex((metric)=>metric.id == id);
            var data = metrics[typesMetrics[type]][IndexMetricPrecise];
            var max = 0;
            for(let key in data.values)for(let date in data.values[key]){
                if (data.values[key][date] > max) max = data.values[key][date];
                data.values[key][date] = 0;
            }
            metrics[typesMetrics[type]][IndexMetricPrecise].max = max;
            payload = {
                ...payload,
                ...metrics
            };
        }
        dispatch({
            type: "setResultInformation",
            payload: payload
        });
    };
    return {
        setChoiceMetric: setChoiceMetric,
        getMetric: getMetric,
        getMetricValue: getMetricValue
    };
}
var $d243346d1fa8c7d5$export$2e2bcd8739ae039 = $d243346d1fa8c7d5$var$AnalyticsGraphHook;


/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported XLSX */ /*global process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */ var $4293c27bcfbce771$exports = {};
"use strict";


var $3ee4f50b1ae43a89$require$Buffer = $4293c27bcfbce771$exports.Buffer;

var $3ee4f50b1ae43a89$var$XLSX = {};
$3ee4f50b1ae43a89$var$XLSX.version = "0.18.5";
var $3ee4f50b1ae43a89$var$current_codepage = 1200, $3ee4f50b1ae43a89$var$current_ansi = 1252;
var $3ee4f50b1ae43a89$var$VALID_ANSI = [
    874,
    932,
    936,
    949,
    950,
    1250,
    1251,
    1252,
    1253,
    1254,
    1255,
    1256,
    1257,
    1258,
    10000
];
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */ var $3ee4f50b1ae43a89$var$CS2CP = {
    /*::[*/ 0: 1252,
    /* ANSI */ /*::[*/ 1: 65001,
    /* DEFAULT */ /*::[*/ 2: 65001,
    /* SYMBOL */ /*::[*/ 77: 10000,
    /* MAC */ /*::[*/ 128: 932,
    /* SHIFTJIS */ /*::[*/ 129: 949,
    /* HANGUL */ /*::[*/ 130: 1361,
    /* JOHAB */ /*::[*/ 134: 936,
    /* GB2312 */ /*::[*/ 136: 950,
    /* CHINESEBIG5 */ /*::[*/ 161: 1253,
    /* GREEK */ /*::[*/ 162: 1254,
    /* TURKISH */ /*::[*/ 163: 1258,
    /* VIETNAMESE */ /*::[*/ 177: 1255,
    /* HEBREW */ /*::[*/ 178: 1256,
    /* ARABIC */ /*::[*/ 186: 1257,
    /* BALTIC */ /*::[*/ 204: 1251,
    /* RUSSIAN */ /*::[*/ 222: 874,
    /* THAI */ /*::[*/ 238: 1250,
    /* EASTEUROPE */ /*::[*/ 255: 1252,
    /* OEM */ /*::[*/ 69: 6969 /* MISC */ 
} /*:any*/ ;
var $3ee4f50b1ae43a89$var$set_ansi = function(cp /*:number*/ ) {
    if ($3ee4f50b1ae43a89$var$VALID_ANSI.indexOf(cp) == -1) return;
    $3ee4f50b1ae43a89$var$current_ansi = $3ee4f50b1ae43a89$var$CS2CP[0] = cp;
};
function $3ee4f50b1ae43a89$var$reset_ansi() {
    $3ee4f50b1ae43a89$var$set_ansi(1252);
}
var $3ee4f50b1ae43a89$var$set_cp = function(cp /*:number*/ ) {
    $3ee4f50b1ae43a89$var$current_codepage = cp;
    $3ee4f50b1ae43a89$var$set_ansi(cp);
};
function $3ee4f50b1ae43a89$var$reset_cp() {
    $3ee4f50b1ae43a89$var$set_cp(1200);
    $3ee4f50b1ae43a89$var$reset_ansi();
}
function $3ee4f50b1ae43a89$var$char_codes(data /*:string*/ ) /*:Array<number>*/ {
    var o /*:Array<number>*/  = [];
    for(var i = 0, len = data.length; i < len; ++i)o[i] = data.charCodeAt(i);
    return o;
}
function $3ee4f50b1ae43a89$var$utf16leread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i) + (data.charCodeAt(2 * i + 1) << 8));
    return o.join("");
}
function $3ee4f50b1ae43a89$var$utf16beread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i + 1) + (data.charCodeAt(2 * i) << 8));
    return o.join("");
}
var $3ee4f50b1ae43a89$var$debom = function(data /*:string*/ ) /*:string*/ {
    var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
    if (c1 == 0xFF && c2 == 0xFE) return $3ee4f50b1ae43a89$var$utf16leread(data.slice(2));
    if (c1 == 0xFE && c2 == 0xFF) return $3ee4f50b1ae43a89$var$utf16beread(data.slice(2));
    if (c1 == 0xFEFF) return data.slice(1);
    return data;
};
var $3ee4f50b1ae43a89$var$_getchar = function _gc1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var $3ee4f50b1ae43a89$var$_getansi = function _ga1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var $3ee4f50b1ae43a89$var$$cptable;
function $3ee4f50b1ae43a89$export$58f247d16f363b86(cptable) {
    $3ee4f50b1ae43a89$var$$cptable = cptable;
    $3ee4f50b1ae43a89$var$set_cp = function(cp /*:number*/ ) {
        $3ee4f50b1ae43a89$var$current_codepage = cp;
        $3ee4f50b1ae43a89$var$set_ansi(cp);
    };
    $3ee4f50b1ae43a89$var$debom = function(data /*:string*/ ) {
        if (data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) return $3ee4f50b1ae43a89$var$$cptable.utils.decode(1200, $3ee4f50b1ae43a89$var$char_codes(data.slice(2)));
        return data;
    };
    $3ee4f50b1ae43a89$var$_getchar = function _gc2(x /*:number*/ ) /*:string*/ {
        if ($3ee4f50b1ae43a89$var$current_codepage === 1200) return String.fromCharCode(x);
        return $3ee4f50b1ae43a89$var$$cptable.utils.decode($3ee4f50b1ae43a89$var$current_codepage, [
            x & 255,
            x >> 8
        ])[0];
    };
    $3ee4f50b1ae43a89$var$_getansi = function _ga2(x /*:number*/ ) /*:string*/ {
        return $3ee4f50b1ae43a89$var$$cptable.utils.decode($3ee4f50b1ae43a89$var$current_ansi, [
            x
        ])[0];
    };
    $3ee4f50b1ae43a89$var$cpdoit();
}
var $3ee4f50b1ae43a89$var$DENSE = null;
var $3ee4f50b1ae43a89$var$DIF_XL = true;
var $3ee4f50b1ae43a89$var$Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function $3ee4f50b1ae43a89$var$Base64_encode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $3ee4f50b1ae43a89$var$Base64_map.charAt(e1) + $3ee4f50b1ae43a89$var$Base64_map.charAt(e2) + $3ee4f50b1ae43a89$var$Base64_map.charAt(e3) + $3ee4f50b1ae43a89$var$Base64_map.charAt(e4);
    }
    return o;
}
function $3ee4f50b1ae43a89$var$Base64_decode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    input = input.replace(/[^\w\+\/\=]/g, "");
    for(var i = 0; i < input.length;){
        e1 = $3ee4f50b1ae43a89$var$Base64_map.indexOf(input.charAt(i++));
        e2 = $3ee4f50b1ae43a89$var$Base64_map.indexOf(input.charAt(i++));
        c1 = e1 << 2 | e2 >> 4;
        o += String.fromCharCode(c1);
        e3 = $3ee4f50b1ae43a89$var$Base64_map.indexOf(input.charAt(i++));
        c2 = (e2 & 15) << 4 | e3 >> 2;
        if (e3 !== 64) o += String.fromCharCode(c2);
        e4 = $3ee4f50b1ae43a89$var$Base64_map.indexOf(input.charAt(i++));
        c3 = (e3 & 3) << 6 | e4;
        if (e4 !== 64) o += String.fromCharCode(c3);
    }
    return o;
}
var $3ee4f50b1ae43a89$var$has_buf = /*#__PURE__*/ function() {
    return typeof $3ee4f50b1ae43a89$require$Buffer !== "undefined" && typeof $4293c27bcfbce771$exports !== "undefined" && typeof $4293c27bcfbce771$exports.versions !== "undefined" && !!$4293c27bcfbce771$exports.versions.node;
}();
var $3ee4f50b1ae43a89$var$Buffer_from = /*#__PURE__*/ function() {
    if (typeof $3ee4f50b1ae43a89$require$Buffer !== "undefined") {
        var nbfs = !$3ee4f50b1ae43a89$require$Buffer.from;
        if (!nbfs) try {
            $3ee4f50b1ae43a89$require$Buffer.from("foo", "utf8");
        } catch (e) {
            nbfs = true;
        }
        return nbfs ? function(buf, enc) {
            return enc ? new $3ee4f50b1ae43a89$require$Buffer(buf, enc) : new $3ee4f50b1ae43a89$require$Buffer(buf);
        } : $3ee4f50b1ae43a89$require$Buffer.from.bind($3ee4f50b1ae43a89$require$Buffer);
    }
    return function() {};
}();
function $3ee4f50b1ae43a89$var$new_raw_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$require$Buffer.alloc ? $3ee4f50b1ae43a89$require$Buffer.alloc(len) : new $3ee4f50b1ae43a89$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
function $3ee4f50b1ae43a89$var$new_unsafe_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$require$Buffer.allocUnsafe ? $3ee4f50b1ae43a89$require$Buffer.allocUnsafe(len) : new $3ee4f50b1ae43a89$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
var $3ee4f50b1ae43a89$var$s2a = function s2a(s /*:string*/ ) /*:any*/ {
    if ($3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$var$Buffer_from(s, "binary");
    return s.split("").map(function(x /*:string*/ ) /*:number*/ {
        return x.charCodeAt(0) & 0xff;
    });
};
function $3ee4f50b1ae43a89$var$s2ab(s /*:string*/ ) /*:any*/ {
    if (typeof ArrayBuffer === "undefined") return $3ee4f50b1ae43a89$var$s2a(s);
    var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
    for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}
function $3ee4f50b1ae43a89$var$a2s(data /*:any*/ ) /*:string*/ {
    if (Array.isArray(data)) return data.map(function(c) {
        return String.fromCharCode(c);
    }).join("");
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length; ++i)o[i] = String.fromCharCode(data[i]);
    return o.join("");
}
function $3ee4f50b1ae43a89$var$a2u(data /*:Array<number>*/ ) /*:Uint8Array*/ {
    if (typeof Uint8Array === "undefined") throw new Error("Unsupported");
    return new Uint8Array(data);
}
function $3ee4f50b1ae43a89$var$ab2a(data /*:ArrayBuffer|Uint8Array*/ ) /*:Array<number>*/ {
    if (typeof ArrayBuffer == "undefined") throw new Error("Unsupported");
    if (data instanceof ArrayBuffer) return $3ee4f50b1ae43a89$var$ab2a(new Uint8Array(data));
    /*:: if(data instanceof ArrayBuffer) throw new Error("unreachable"); */ var o = new Array(data.length);
    for(var i = 0; i < data.length; ++i)o[i] = data[i];
    return o;
}
var $3ee4f50b1ae43a89$var$bconcat = $3ee4f50b1ae43a89$var$has_buf ? function(bufs) {
    return $3ee4f50b1ae43a89$require$Buffer.concat(bufs.map(function(buf) {
        return $3ee4f50b1ae43a89$require$Buffer.isBuffer(buf) ? buf : $3ee4f50b1ae43a89$var$Buffer_from(buf);
    }));
} : function(bufs) {
    if (typeof Uint8Array !== "undefined") {
        var i = 0, maxlen = 0;
        for(i = 0; i < bufs.length; ++i)maxlen += bufs[i].length;
        var o = new Uint8Array(maxlen);
        var len = 0;
        for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i){
            len = bufs[i].length;
            if (bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
            else if (typeof bufs[i] == "string") throw "wtf";
            else o.set(new Uint8Array(bufs[i]), maxlen);
        }
        return o;
    }
    return [].concat.apply([], bufs.map(function(buf) {
        return Array.isArray(buf) ? buf : [].slice.call(buf);
    }));
};
function $3ee4f50b1ae43a89$var$utf8decode(content /*:string*/ ) {
    var out = [], widx = 0, L = content.length + 250;
    var o = $3ee4f50b1ae43a89$var$new_raw_buf(content.length + 255);
    for(var ridx = 0; ridx < content.length; ++ridx){
        var c = content.charCodeAt(ridx);
        if (c < 0x80) o[widx++] = c;
        else if (c < 0x800) {
            o[widx++] = 192 | c >> 6 & 31;
            o[widx++] = 128 | c & 63;
        } else if (c >= 0xD800 && c < 0xE000) {
            c = (c & 1023) + 64;
            var d = content.charCodeAt(++ridx) & 1023;
            o[widx++] = 240 | c >> 8 & 7;
            o[widx++] = 128 | c >> 2 & 63;
            o[widx++] = 128 | d >> 6 & 15 | (c & 3) << 4;
            o[widx++] = 128 | d & 63;
        } else {
            o[widx++] = 224 | c >> 12 & 15;
            o[widx++] = 128 | c >> 6 & 63;
            o[widx++] = 128 | c & 63;
        }
        if (widx > L) {
            out.push(o.slice(0, widx));
            widx = 0;
            o = $3ee4f50b1ae43a89$var$new_raw_buf(65535);
            L = 65530;
        }
    }
    out.push(o.slice(0, widx));
    return $3ee4f50b1ae43a89$var$bconcat(out);
}
var $3ee4f50b1ae43a89$var$chr0 = /\u0000/g, $3ee4f50b1ae43a89$var$chr1 = /[\u0001-\u0006]/g;
/*::
declare type Block = any;
declare type BufArray = {
	newblk(sz:number):Block;
	next(sz:number):Block;
	end():any;
	push(buf:Block):void;
};

type RecordHopperCB = {(d:any, Rn:string, RT:number):?boolean;};

type EvertType = {[string]:string};
type EvertNumType = {[string]:number};
type EvertArrType = {[string]:Array<string>};

type StringConv = {(string):string};

*/ /* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W041 */ function $3ee4f50b1ae43a89$var$_strrev(x /*:string*/ ) /*:string*/ {
    var o = "", i = x.length - 1;
    while(i >= 0)o += x.charAt(i--);
    return o;
}
function $3ee4f50b1ae43a89$var$pad0(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $3ee4f50b1ae43a89$var$fill("0", d - t.length) + t;
}
function $3ee4f50b1ae43a89$var$pad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $3ee4f50b1ae43a89$var$fill(" ", d - t.length) + t;
}
function $3ee4f50b1ae43a89$var$rpad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : t + $3ee4f50b1ae43a89$var$fill(" ", d - t.length);
}
function $3ee4f50b1ae43a89$var$pad0r1(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + Math.round(v);
    return t.length >= d ? t : $3ee4f50b1ae43a89$var$fill("0", d - t.length) + t;
}
function $3ee4f50b1ae43a89$var$pad0r2(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $3ee4f50b1ae43a89$var$fill("0", d - t.length) + t;
}
var $3ee4f50b1ae43a89$var$p2_32 = /*#__PURE__*/ Math.pow(2, 32);
function $3ee4f50b1ae43a89$var$pad0r(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    if (v > $3ee4f50b1ae43a89$var$p2_32 || v < -$3ee4f50b1ae43a89$var$p2_32) return $3ee4f50b1ae43a89$var$pad0r1(v, d);
    var i = Math.round(v);
    return $3ee4f50b1ae43a89$var$pad0r2(i, d);
}
/* yes, in 2022 this is still faster than string compare */ function $3ee4f50b1ae43a89$var$SSF_isgeneral(s /*:string*/ , i /*:?number*/ ) /*:boolean*/ {
    i = i || 0;
    return s.length >= 7 + i && (s.charCodeAt(i) | 32) === 103 && (s.charCodeAt(i + 1) | 32) === 101 && (s.charCodeAt(i + 2) | 32) === 110 && (s.charCodeAt(i + 3) | 32) === 101 && (s.charCodeAt(i + 4) | 32) === 114 && (s.charCodeAt(i + 5) | 32) === 97 && (s.charCodeAt(i + 6) | 32) === 108;
}
var $3ee4f50b1ae43a89$var$days /*:Array<Array<string> >*/  = [
    [
        "Sun",
        "Sunday"
    ],
    [
        "Mon",
        "Monday"
    ],
    [
        "Tue",
        "Tuesday"
    ],
    [
        "Wed",
        "Wednesday"
    ],
    [
        "Thu",
        "Thursday"
    ],
    [
        "Fri",
        "Friday"
    ],
    [
        "Sat",
        "Saturday"
    ]
];
var $3ee4f50b1ae43a89$var$months /*:Array<Array<string> >*/  = [
    [
        "J",
        "Jan",
        "January"
    ],
    [
        "F",
        "Feb",
        "February"
    ],
    [
        "M",
        "Mar",
        "March"
    ],
    [
        "A",
        "Apr",
        "April"
    ],
    [
        "M",
        "May",
        "May"
    ],
    [
        "J",
        "Jun",
        "June"
    ],
    [
        "J",
        "Jul",
        "July"
    ],
    [
        "A",
        "Aug",
        "August"
    ],
    [
        "S",
        "Sep",
        "September"
    ],
    [
        "O",
        "Oct",
        "October"
    ],
    [
        "N",
        "Nov",
        "November"
    ],
    [
        "D",
        "Dec",
        "December"
    ]
];
function $3ee4f50b1ae43a89$var$SSF_init_table(t /*:any*/ ) {
    if (!t) t = {};
    t[0] = "General";
    t[1] = "0";
    t[2] = "0.00";
    t[3] = "#,##0";
    t[4] = "#,##0.00";
    t[9] = "0%";
    t[10] = "0.00%";
    t[11] = "0.00E+00";
    t[12] = "# ?/?";
    t[13] = "# ??/??";
    t[14] = "m/d/yy";
    t[15] = "d-mmm-yy";
    t[16] = "d-mmm";
    t[17] = "mmm-yy";
    t[18] = "h:mm AM/PM";
    t[19] = "h:mm:ss AM/PM";
    t[20] = "h:mm";
    t[21] = "h:mm:ss";
    t[22] = "m/d/yy h:mm";
    t[37] = "#,##0 ;(#,##0)";
    t[38] = "#,##0 ;[Red](#,##0)";
    t[39] = "#,##0.00;(#,##0.00)";
    t[40] = "#,##0.00;[Red](#,##0.00)";
    t[45] = "mm:ss";
    t[46] = "[h]:mm:ss";
    t[47] = "mmss.0";
    t[48] = "##0.0E+0";
    t[49] = "@";
    t[56] = '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "';
    return t;
}
/* repeated to satiate webpack */ var $3ee4f50b1ae43a89$var$table_fmt = {
    0: "General",
    1: "0",
    2: "0.00",
    3: "#,##0",
    4: "#,##0.00",
    9: "0%",
    10: "0.00%",
    11: "0.00E+00",
    12: "# ?/?",
    13: "# ??/??",
    14: "m/d/yy",
    15: "d-mmm-yy",
    16: "d-mmm",
    17: "mmm-yy",
    18: "h:mm AM/PM",
    19: "h:mm:ss AM/PM",
    20: "h:mm",
    21: "h:mm:ss",
    22: "m/d/yy h:mm",
    37: "#,##0 ;(#,##0)",
    38: "#,##0 ;[Red](#,##0)",
    39: "#,##0.00;(#,##0.00)",
    40: "#,##0.00;[Red](#,##0.00)",
    45: "mm:ss",
    46: "[h]:mm:ss",
    47: "mmss.0",
    48: "##0.0E+0",
    49: "@",
    56: '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "'
};
/* Defaults determined by systematically testing in Excel 2019 */ /* These formats appear to default to other formats in the table */ var $3ee4f50b1ae43a89$var$SSF_default_map = {
    5: 37,
    6: 38,
    7: 39,
    8: 40,
    23: 0,
    24: 0,
    25: 0,
    26: 0,
    27: 14,
    28: 14,
    29: 14,
    30: 14,
    31: 14,
    50: 14,
    51: 14,
    52: 14,
    53: 14,
    54: 14,
    55: 14,
    56: 14,
    57: 14,
    58: 14,
    59: 1,
    60: 2,
    61: 3,
    62: 4,
    67: 9,
    68: 10,
    69: 12,
    70: 13,
    71: 14,
    72: 14,
    73: 15,
    74: 16,
    75: 17,
    76: 20,
    77: 21,
    78: 22,
    79: 45,
    80: 46,
    81: 47,
    82: 0 // 82 ->  0 ... 65536 -> 0 (omitted)
};
/* These formats technically refer to Accounting formats with no equivalent */ var $3ee4f50b1ae43a89$var$SSF_default_str = {
    //  5 -- Currency,   0 decimal, black negative
    5: '"$"#,##0_);\\("$"#,##0\\)',
    63: '"$"#,##0_);\\("$"#,##0\\)',
    //  6 -- Currency,   0 decimal, red   negative
    6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    //  7 -- Currency,   2 decimal, black negative
    7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    //  8 -- Currency,   2 decimal, red   negative
    8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    // 41 -- Accounting, 0 decimal, No Symbol
    41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
    // 42 -- Accounting, 0 decimal, $  Symbol
    42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
    // 43 -- Accounting, 2 decimal, No Symbol
    43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
    // 44 -- Accounting, 2 decimal, $  Symbol
    44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function $3ee4f50b1ae43a89$var$SSF_frac(x /*:number*/ , D /*:number*/ , mixed /*:?boolean*/ ) /*:Array<number>*/ {
    var sgn = x < 0 ? -1 : 1;
    var B = x * sgn;
    var P_2 = 0, P_1 = 1, P = 0;
    var Q_2 = 1, Q_1 = 0, Q = 0;
    var A = Math.floor(B);
    while(Q_1 < D){
        A = Math.floor(B);
        P = A * P_1 + P_2;
        Q = A * Q_1 + Q_2;
        if (B - A < 0.00000005) break;
        B = 1 / (B - A);
        P_2 = P_1;
        P_1 = P;
        Q_2 = Q_1;
        Q_1 = Q;
    }
    if (Q > D) {
        if (Q_1 > D) {
            Q = Q_2;
            P = P_2;
        } else {
            Q = Q_1;
            P = P_1;
        }
    }
    if (!mixed) return [
        0,
        sgn * P,
        Q
    ];
    var q = Math.floor(sgn * P / Q);
    return [
        q,
        sgn * P - q * Q,
        Q
    ];
}
function $3ee4f50b1ae43a89$var$SSF_parse_date_code(v /*:number*/ , opts /*:?any*/ , b2 /*:?boolean*/ ) {
    if (v > 2958465 || v < 0) return null;
    var date = v | 0, time = Math.floor(86400 * (v - date)), dow = 0;
    var dout = [];
    var out = {
        D: date,
        T: time,
        u: 86400 * (v - date) - time,
        y: 0,
        m: 0,
        d: 0,
        H: 0,
        M: 0,
        S: 0,
        q: 0
    };
    if (Math.abs(out.u) < 1e-6) out.u = 0;
    if (opts && opts.date1904) date += 1462;
    if (out.u > 0.9999) {
        out.u = 0;
        if (++time == 86400) {
            out.T = time = 0;
            ++date;
            ++out.D;
        }
    }
    if (date === 60) {
        dout = b2 ? [
            1317,
            10,
            29
        ] : [
            1900,
            2,
            29
        ];
        dow = 3;
    } else if (date === 0) {
        dout = b2 ? [
            1317,
            8,
            29
        ] : [
            1900,
            1,
            0
        ];
        dow = 6;
    } else {
        if (date > 60) --date;
        /* 1 = Jan 1 1900 in Gregorian */ var d = new Date(1900, 0, 1);
        d.setDate(d.getDate() + date - 1);
        dout = [
            d.getFullYear(),
            d.getMonth() + 1,
            d.getDate()
        ];
        dow = d.getDay();
        if (date < 60) dow = (dow + 6) % 7;
        if (b2) dow = $3ee4f50b1ae43a89$var$SSF_fix_hijri(d, dout);
    }
    out.y = dout[0];
    out.m = dout[1];
    out.d = dout[2];
    out.S = time % 60;
    time = Math.floor(time / 60);
    out.M = time % 60;
    time = Math.floor(time / 60);
    out.H = time;
    out.q = dow;
    return out;
}
var $3ee4f50b1ae43a89$var$SSFbasedate = /*#__PURE__*/ new Date(1899, 11, 31, 0, 0, 0);
var $3ee4f50b1ae43a89$var$SSFdnthresh = /*#__PURE__*/ $3ee4f50b1ae43a89$var$SSFbasedate.getTime();
var $3ee4f50b1ae43a89$var$SSFbase1904 = /*#__PURE__*/ new Date(1900, 2, 1, 0, 0, 0);
function $3ee4f50b1ae43a89$var$datenum_local(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    if (date1904) epoch -= 126230400000;
    else if (v >= $3ee4f50b1ae43a89$var$SSFbase1904) epoch += 86400000;
    return (epoch - ($3ee4f50b1ae43a89$var$SSFdnthresh + /*#__PURE__*/ (v.getTimezoneOffset() - /*#__PURE__*/ $3ee4f50b1ae43a89$var$SSFbasedate.getTimezoneOffset()) * 60000)) / 86400000;
}
/* ECMA-376 18.8.30 numFmt*/ /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */ /* exponent >= -9 and <= 9 */ function $3ee4f50b1ae43a89$var$SSF_strip_decimal(o /*:string*/ ) /*:string*/ {
    return o.indexOf(".") == -1 ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
/* General Exponential always shows 2 digits exp and trims the mantissa */ function $3ee4f50b1ae43a89$var$SSF_normalize_exp(o /*:string*/ ) /*:string*/ {
    if (o.indexOf("E") == -1) return o;
    return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
/* exponent >= -9 and <= 9 */ function $3ee4f50b1ae43a89$var$SSF_small_exp(v /*:number*/ ) /*:string*/ {
    var w = v < 0 ? 12 : 11;
    var o = $3ee4f50b1ae43a89$var$SSF_strip_decimal(v.toFixed(12));
    if (o.length <= w) return o;
    o = v.toPrecision(10);
    if (o.length <= w) return o;
    return v.toExponential(5);
}
/* exponent >= 11 or <= -10 likely exponential */ function $3ee4f50b1ae43a89$var$SSF_large_exp(v /*:number*/ ) /*:string*/ {
    var o = $3ee4f50b1ae43a89$var$SSF_strip_decimal(v.toFixed(11));
    return o.length > (v < 0 ? 12 : 11) || o === "0" || o === "-0" ? v.toPrecision(6) : o;
}
function $3ee4f50b1ae43a89$var$SSF_general_num(v /*:number*/ ) /*:string*/ {
    var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E), o;
    if (V >= -4 && V <= -1) o = v.toPrecision(10 + V);
    else if (Math.abs(V) <= 9) o = $3ee4f50b1ae43a89$var$SSF_small_exp(v);
    else if (V === 10) o = v.toFixed(10).substr(0, 12);
    else o = $3ee4f50b1ae43a89$var$SSF_large_exp(v);
    return $3ee4f50b1ae43a89$var$SSF_strip_decimal($3ee4f50b1ae43a89$var$SSF_normalize_exp(o.toUpperCase()));
}
/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	The longest 32-bit integer text is "-2147483648", exactly 11 chars
	TODO: technically the display depends on the width of the cell
*/ function $3ee4f50b1ae43a89$var$SSF_general(v /*:any*/ , opts /*:any*/ ) {
    switch(typeof v){
        case "string":
            return v;
        case "boolean":
            return v ? "TRUE" : "FALSE";
        case "number":
            return (v | 0) === v ? v.toString(10) : $3ee4f50b1ae43a89$var$SSF_general_num(v);
        case "undefined":
            return "";
        case "object":
            if (v == null) return "";
            if (v instanceof Date) return $3ee4f50b1ae43a89$var$SSF_format(14, $3ee4f50b1ae43a89$var$datenum_local(v, opts && opts.date1904), opts);
    }
    throw new Error("unsupported value in General format: " + v);
}
function $3ee4f50b1ae43a89$var$SSF_fix_hijri(date /*:Date*/ , o /*:[number, number, number]*/ ) {
    /* TODO: properly adjust y/m/d and  */ o[0] -= 581;
    var dow = date.getDay();
    if (date < 60) dow = (dow + 6) % 7;
    return dow;
}
//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
function $3ee4f50b1ae43a89$var$SSF_write_date(type /*:number*/ , fmt /*:string*/ , val, ss0 /*:?number*/ ) /*:string*/ {
    var o = "", ss = 0, tt = 0, y = val.y, out, outl = 0;
    switch(type){
        case 98:
            /* 'b' buddhist year */ y = val.y + 543;
        /* falls through */ case 121:
            /* 'y' year */ switch(fmt.length){
                case 1:
                case 2:
                    out = y % 100;
                    outl = 2;
                    break;
                default:
                    out = y % 10000;
                    outl = 4;
                    break;
            }
            break;
        case 109:
            /* 'm' month */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.m;
                    outl = fmt.length;
                    break;
                case 3:
                    return $3ee4f50b1ae43a89$var$months[val.m - 1][1];
                case 5:
                    return $3ee4f50b1ae43a89$var$months[val.m - 1][0];
                default:
                    return $3ee4f50b1ae43a89$var$months[val.m - 1][2];
            }
            break;
        case 100:
            /* 'd' day */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.d;
                    outl = fmt.length;
                    break;
                case 3:
                    return $3ee4f50b1ae43a89$var$days[val.q][0];
                default:
                    return $3ee4f50b1ae43a89$var$days[val.q][1];
            }
            break;
        case 104:
            /* 'h' 12-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = 1 + (val.H + 11) % 12;
                    outl = fmt.length;
                    break;
                default:
                    throw "bad hour format: " + fmt;
            }
            break;
        case 72:
            /* 'H' 24-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.H;
                    outl = fmt.length;
                    break;
                default:
                    throw "bad hour format: " + fmt;
            }
            break;
        case 77:
            /* 'M' minutes */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.M;
                    outl = fmt.length;
                    break;
                default:
                    throw "bad minute format: " + fmt;
            }
            break;
        case 115:
            /* 's' seconds */ if (fmt != "s" && fmt != "ss" && fmt != ".0" && fmt != ".00" && fmt != ".000") throw "bad second format: " + fmt;
            if (val.u === 0 && (fmt == "s" || fmt == "ss")) return $3ee4f50b1ae43a89$var$pad0(val.S, fmt.length);
            /*::if(!ss0) ss0 = 0; */ if (ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
            else tt = ss0 === 1 ? 10 : 1;
            ss = Math.round(tt * (val.S + val.u));
            if (ss >= 60 * tt) ss = 0;
            if (fmt === "s") return ss === 0 ? "0" : "" + ss / tt;
            o = $3ee4f50b1ae43a89$var$pad0(ss, 2 + ss0);
            if (fmt === "ss") return o.substr(0, 2);
            return "." + o.substr(2, fmt.length - 1);
        case 90:
            /* 'Z' absolute time */ switch(fmt){
                case "[h]":
                case "[hh]":
                    out = val.D * 24 + val.H;
                    break;
                case "[m]":
                case "[mm]":
                    out = (val.D * 24 + val.H) * 60 + val.M;
                    break;
                case "[s]":
                case "[ss]":
                    out = ((val.D * 24 + val.H) * 60 + val.M) * 60 + Math.round(val.S + val.u);
                    break;
                default:
                    throw "bad abstime format: " + fmt;
            }
            outl = fmt.length === 3 ? 1 : 2;
            break;
        case 101:
            /* 'e' era */ out = y;
            outl = 1;
            break;
    }
    var outstr = outl > 0 ? $3ee4f50b1ae43a89$var$pad0(out, outl) : "";
    return outstr;
}
/*jshint -W086 */ /*jshint +W086 */ function $3ee4f50b1ae43a89$var$commaify(s /*:string*/ ) /*:string*/ {
    var w = 3;
    if (s.length <= w) return s;
    var j = s.length % w, o = s.substr(0, j);
    for(; j != s.length; j += w)o += (o.length > 0 ? "," : "") + s.substr(j, w);
    return o;
}
var $3ee4f50b1ae43a89$var$pct1 = /%/g;
function $3ee4f50b1ae43a89$var$write_num_pct(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($3ee4f50b1ae43a89$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $3ee4f50b1ae43a89$var$write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + $3ee4f50b1ae43a89$var$fill("%", mul);
}
function $3ee4f50b1ae43a89$var$write_num_cm(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $3ee4f50b1ae43a89$var$write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
}
function $3ee4f50b1ae43a89$var$write_num_exp(fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val == 0) return "0.0E+0";
        else if (val < 0) return "-" + $3ee4f50b1ae43a89$var$write_num_exp(fmt, -val);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf("E");
        var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (o.indexOf("e") === -1) {
            var fakee = Math.floor(Math.log(val) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            while(o.substr(0, 2) === "0."){
                o = o.charAt(0) + o.substr(2, period) + "." + o.substr(2 + period);
                o = o.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
            }
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
var $3ee4f50b1ae43a89$var$frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function $3ee4f50b1ae43a89$var$write_num_f1(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    var den = parseInt(r[4], 10), rr = Math.round(aval * den), base = Math.floor(rr / den);
    var myn = rr - base * den, myd = den;
    return sign + (base === 0 ? "" : "" + base) + " " + (myn === 0 ? $3ee4f50b1ae43a89$var$fill(" ", r[1].length + 1 + r[4].length) : $3ee4f50b1ae43a89$var$pad_(myn, r[1].length) + r[2] + "/" + r[3] + $3ee4f50b1ae43a89$var$pad0(myd, r[4].length));
}
function $3ee4f50b1ae43a89$var$write_num_f2(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    return sign + (aval === 0 ? "" : "" + aval) + $3ee4f50b1ae43a89$var$fill(" ", r[1].length + 2 + r[4].length);
}
var $3ee4f50b1ae43a89$var$dec1 = /^#*0*\.([0#]+)/;
var $3ee4f50b1ae43a89$var$closeparen = /\).*[0#]/;
var $3ee4f50b1ae43a89$var$phone = /\(###\) ###\\?-####/;
function $3ee4f50b1ae43a89$var$hashq(str /*:string*/ ) /*:string*/ {
    var o = "", cc;
    for(var i = 0; i != str.length; ++i)switch(cc = str.charCodeAt(i)){
        case 35:
            break;
        case 63:
            o += " ";
            break;
        case 48:
            o += "0";
            break;
        default:
            o += String.fromCharCode(cc);
    }
    return o;
}
function $3ee4f50b1ae43a89$var$rnd(val /*:number*/ , d /*:number*/ ) /*:string*/ {
    var dd = Math.pow(10, d);
    return "" + Math.round(val * dd) / dd;
}
function $3ee4f50b1ae43a89$var$dec(val /*:number*/ , d /*:number*/ ) /*:number*/ {
    var _frac = val - Math.floor(val), dd = Math.pow(10, d);
    if (d < ("" + Math.round(_frac * dd)).length) return 0;
    return Math.round(_frac * dd);
}
function $3ee4f50b1ae43a89$var$carry(val /*:number*/ , d /*:number*/ ) /*:number*/ {
    if (d < ("" + Math.round((val - Math.floor(val)) * Math.pow(10, d))).length) return 1;
    return 0;
}
function $3ee4f50b1ae43a89$var$flr(val /*:number*/ ) /*:string*/ {
    if (val < 2147483647 && val > -2147483648) return "" + (val >= 0 ? val | 0 : val - 1 | 0);
    return "" + Math.floor(val);
}
function $3ee4f50b1ae43a89$var$write_num_flt(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($3ee4f50b1ae43a89$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val >= 0) return $3ee4f50b1ae43a89$var$write_num_flt("n", ffmt, val);
        return "(" + $3ee4f50b1ae43a89$var$write_num_flt("n", ffmt, -val) + ")";
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $3ee4f50b1ae43a89$var$write_num_cm(type, fmt, val);
    if (fmt.indexOf("%") !== -1) return $3ee4f50b1ae43a89$var$write_num_pct(type, fmt, val);
    if (fmt.indexOf("E") !== -1) return $3ee4f50b1ae43a89$var$write_num_exp(fmt, val);
    if (fmt.charCodeAt(0) === 36) return "$" + $3ee4f50b1ae43a89$var$write_num_flt(type, fmt.substr(fmt.charAt(1) == " " ? 2 : 1), val);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $3ee4f50b1ae43a89$var$pad0r(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = $3ee4f50b1ae43a89$var$pad0r(val, 0);
        if (o === "0") o = "";
        return o.length > fmt.length ? o : $3ee4f50b1ae43a89$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($3ee4f50b1ae43a89$var$frac1)) return $3ee4f50b1ae43a89$var$write_num_f1(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $3ee4f50b1ae43a89$var$pad0r(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($3ee4f50b1ae43a89$var$dec1)) {
        o = $3ee4f50b1ae43a89$var$rnd(val, r[1].length).replace(/^([^\.]+)$/, "$1." + $3ee4f50b1ae43a89$var$hashq(r[1])).replace(/\.$/, "." + $3ee4f50b1ae43a89$var$hashq(r[1])).replace(/\.(\d*)$/, function($$, $1) {
            return "." + $1 + $3ee4f50b1ae43a89$var$fill("0", $3ee4f50b1ae43a89$var$hashq(/*::(*/ r /*::||[""])*/ [1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + $3ee4f50b1ae43a89$var$rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $3ee4f50b1ae43a89$var$commaify($3ee4f50b1ae43a89$var$pad0r(aval, 0));
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val < 0 ? "-" + $3ee4f50b1ae43a89$var$write_num_flt(type, fmt, -val) : $3ee4f50b1ae43a89$var$commaify("" + (Math.floor(val) + $3ee4f50b1ae43a89$var$carry(val, r[1].length))) + "." + $3ee4f50b1ae43a89$var$pad0($3ee4f50b1ae43a89$var$dec(val, r[1].length), r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $3ee4f50b1ae43a89$var$write_num_flt(type, fmt.replace(/^#,#*,/, ""), val);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $3ee4f50b1ae43a89$var$_strrev($3ee4f50b1ae43a89$var$write_num_flt(type, fmt.replace(/[\\-]/g, ""), val));
        ri = 0;
        return $3ee4f50b1ae43a89$var$_strrev($3ee4f50b1ae43a89$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === "0" ? "0" : "";
        }));
    }
    if (fmt.match($3ee4f50b1ae43a89$var$phone)) {
        o = $3ee4f50b1ae43a89$var$write_num_flt(type, "##########", val);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $3ee4f50b1ae43a89$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $3ee4f50b1ae43a89$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $3ee4f50b1ae43a89$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $3ee4f50b1ae43a89$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $3ee4f50b1ae43a89$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $3ee4f50b1ae43a89$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $3ee4f50b1ae43a89$var$rpad_(ff[2], ri) : $3ee4f50b1ae43a89$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = $3ee4f50b1ae43a89$var$pad0r(val, 0);
        if (fmt.length <= o.length) return o;
        return $3ee4f50b1ae43a89$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0?]+)\.([#0]+)$/)) {
        o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $3ee4f50b1ae43a89$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) {
        ri = $3ee4f50b1ae43a89$var$dec(val, r[1].length);
        return val < 0 ? "-" + $3ee4f50b1ae43a89$var$write_num_flt(type, fmt, -val) : $3ee4f50b1ae43a89$var$commaify($3ee4f50b1ae43a89$var$flr(val)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
            return "00," + ($$.length < 3 ? $3ee4f50b1ae43a89$var$pad0(0, 3 - $$.length) : "") + $$;
        }) + "." + $3ee4f50b1ae43a89$var$pad0(ri, r[1].length);
    }
    switch(fmt){
        case "###,##0.00":
            return $3ee4f50b1ae43a89$var$write_num_flt(type, "#,##0.00", val);
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $3ee4f50b1ae43a89$var$commaify($3ee4f50b1ae43a89$var$pad0r(aval, 0));
            return x !== "0" ? sign + x : "";
        case "###,###.00":
            return $3ee4f50b1ae43a89$var$write_num_flt(type, "###,##0.00", val).replace(/^0\./, ".");
        case "#,###.00":
            return $3ee4f50b1ae43a89$var$write_num_flt(type, "#,##0.00", val).replace(/^0\./, ".");
        default:
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $3ee4f50b1ae43a89$var$write_num_cm2(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $3ee4f50b1ae43a89$var$write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
}
function $3ee4f50b1ae43a89$var$write_num_pct2(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($3ee4f50b1ae43a89$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $3ee4f50b1ae43a89$var$write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + $3ee4f50b1ae43a89$var$fill("%", mul);
}
function $3ee4f50b1ae43a89$var$write_num_exp2(fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val == 0) return "0.0E+0";
        else if (val < 0) return "-" + $3ee4f50b1ae43a89$var$write_num_exp2(fmt, -val);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf("E");
        var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (!o.match(/[Ee]/)) {
            var fakee = Math.floor(Math.log(val) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
function $3ee4f50b1ae43a89$var$write_num_int(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($3ee4f50b1ae43a89$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val >= 0) return $3ee4f50b1ae43a89$var$write_num_int("n", ffmt, val);
        return "(" + $3ee4f50b1ae43a89$var$write_num_int("n", ffmt, -val) + ")";
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $3ee4f50b1ae43a89$var$write_num_cm2(type, fmt, val);
    if (fmt.indexOf("%") !== -1) return $3ee4f50b1ae43a89$var$write_num_pct2(type, fmt, val);
    if (fmt.indexOf("E") !== -1) return $3ee4f50b1ae43a89$var$write_num_exp2(fmt, val);
    if (fmt.charCodeAt(0) === 36) return "$" + $3ee4f50b1ae43a89$var$write_num_int(type, fmt.substr(fmt.charAt(1) == " " ? 2 : 1), val);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $3ee4f50b1ae43a89$var$pad0(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = "" + val;
        if (val === 0) o = "";
        return o.length > fmt.length ? o : $3ee4f50b1ae43a89$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($3ee4f50b1ae43a89$var$frac1)) return $3ee4f50b1ae43a89$var$write_num_f2(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $3ee4f50b1ae43a89$var$pad0(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($3ee4f50b1ae43a89$var$dec1)) {
        /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ o = ("" + val).replace(/^([^\.]+)$/, "$1." + $3ee4f50b1ae43a89$var$hashq(r[1])).replace(/\.$/, "." + $3ee4f50b1ae43a89$var$hashq(r[1]));
        o = o.replace(/\.(\d*)$/, function($$, $1) {
            /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ return "." + $1 + $3ee4f50b1ae43a89$var$fill("0", $3ee4f50b1ae43a89$var$hashq(r[1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + ("" + aval).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $3ee4f50b1ae43a89$var$commaify("" + aval);
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val < 0 ? "-" + $3ee4f50b1ae43a89$var$write_num_int(type, fmt, -val) : $3ee4f50b1ae43a89$var$commaify("" + val) + "." + $3ee4f50b1ae43a89$var$fill("0", r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $3ee4f50b1ae43a89$var$write_num_int(type, fmt.replace(/^#,#*,/, ""), val);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $3ee4f50b1ae43a89$var$_strrev($3ee4f50b1ae43a89$var$write_num_int(type, fmt.replace(/[\\-]/g, ""), val));
        ri = 0;
        return $3ee4f50b1ae43a89$var$_strrev($3ee4f50b1ae43a89$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === "0" ? "0" : "";
        }));
    }
    if (fmt.match($3ee4f50b1ae43a89$var$phone)) {
        o = $3ee4f50b1ae43a89$var$write_num_int(type, "##########", val);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $3ee4f50b1ae43a89$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $3ee4f50b1ae43a89$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $3ee4f50b1ae43a89$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $3ee4f50b1ae43a89$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $3ee4f50b1ae43a89$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $3ee4f50b1ae43a89$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $3ee4f50b1ae43a89$var$rpad_(ff[2], ri) : $3ee4f50b1ae43a89$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = "" + val;
        if (fmt.length <= o.length) return o;
        return $3ee4f50b1ae43a89$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0]+)\.([#0]+)$/)) {
        o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $3ee4f50b1ae43a89$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) return val < 0 ? "-" + $3ee4f50b1ae43a89$var$write_num_int(type, fmt, -val) : $3ee4f50b1ae43a89$var$commaify("" + val).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
        return "00," + ($$.length < 3 ? $3ee4f50b1ae43a89$var$pad0(0, 3 - $$.length) : "") + $$;
    }) + "." + $3ee4f50b1ae43a89$var$pad0(0, r[1].length);
    switch(fmt){
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $3ee4f50b1ae43a89$var$commaify("" + aval);
            return x !== "0" ? sign + x : "";
        default:
            if (fmt.match(/\.[0#?]*$/)) return $3ee4f50b1ae43a89$var$write_num_int(type, fmt.slice(0, fmt.lastIndexOf(".")), val) + $3ee4f50b1ae43a89$var$hashq(fmt.slice(fmt.lastIndexOf(".")));
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $3ee4f50b1ae43a89$var$write_num(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    return (val | 0) === val ? $3ee4f50b1ae43a89$var$write_num_int(type, fmt, val) : $3ee4f50b1ae43a89$var$write_num_flt(type, fmt, val);
}
function $3ee4f50b1ae43a89$var$SSF_split_fmt(fmt /*:string*/ ) /*:Array<string>*/ {
    var out /*:Array<string>*/  = [];
    var in_str = false /*, cc*/ ;
    for(var i = 0, j = 0; i < fmt.length; ++i)switch(/*cc=*/ fmt.charCodeAt(i)){
        case 34:
            /* '"' */ in_str = !in_str;
            break;
        case 95:
        case 42:
        case 92:
            /* '_' '*' '\\' */ ++i;
            break;
        case 59:
            /* ';' */ out[out.length] = fmt.substr(j, i - j);
            j = i + 1;
    }
    out[out.length] = fmt.substr(j);
    if (in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
    return out;
}
var $3ee4f50b1ae43a89$var$SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function $3ee4f50b1ae43a89$var$fmt_is_date(fmt /*:string*/ ) /*:boolean*/ {
    var i = 0, /*cc = 0,*/ c = "", o = "";
    while(i < fmt.length)switch(c = fmt.charAt(i)){
        case "G":
            if ($3ee4f50b1ae43a89$var$SSF_isgeneral(fmt, i)) i += 6;
            i++;
            break;
        case '"':
            for(; /*cc=*/ fmt.charCodeAt(++i) !== 34 && i < fmt.length;);
            ++i;
            break;
        case "\\":
            i += 2;
            break;
        case "_":
            i += 2;
            break;
        case "@":
            ++i;
            break;
        case "B":
        case "b":
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") return true;
        /* falls through */ case "M":
        case "D":
        case "Y":
        case "H":
        case "S":
        case "E":
        /* falls through */ case "m":
        case "d":
        case "y":
        case "h":
        case "s":
        case "e":
        case "g":
            return true;
        case "A":
        case "a":
        case "\u4E0A":
            if (fmt.substr(i, 3).toUpperCase() === "A/P") return true;
            if (fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
            if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") return true;
            ++i;
            break;
        case "[":
            o = c;
            while(fmt.charAt(i++) !== "]" && i < fmt.length)o += fmt.charAt(i);
            if (o.match($3ee4f50b1ae43a89$var$SSF_abstime)) return true;
            break;
        case ".":
        /* falls through */ case "0":
        case "#":
            while(i < fmt.length && ("0#?.,E+-%".indexOf(c = fmt.charAt(++i)) > -1 || c == "\\" && fmt.charAt(i + 1) == "-" && "0#".indexOf(fmt.charAt(i + 2)) > -1));
            break;
        case "?":
            while(fmt.charAt(++i) === c);
            break;
        case "*":
            ++i;
            if (fmt.charAt(i) == " " || fmt.charAt(i) == "*") ++i;
            break;
        case "(":
        case ")":
            ++i;
            break;
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1);
            break;
        case " ":
            ++i;
            break;
        default:
            ++i;
            break;
    }
    return false;
}
function $3ee4f50b1ae43a89$var$eval_fmt(fmt /*:string*/ , v /*:any*/ , opts /*:any*/ , flen /*:number*/ ) {
    var out = [], o = "", i = 0, c = "", lst = "t", dt, j, cc;
    var hr = "H";
    /* Tokenize */ while(i < fmt.length)switch(c = fmt.charAt(i)){
        case "G":
            /* General */ if (!$3ee4f50b1ae43a89$var$SSF_isgeneral(fmt, i)) throw new Error("unrecognized character " + c + " in " + fmt);
            out[out.length] = {
                t: "G",
                v: "General"
            };
            i += 7;
            break;
        case '"':
            /* Literal text */ for(o = ""; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length;)o += String.fromCharCode(cc);
            out[out.length] = {
                t: "t",
                v: o
            };
            ++i;
            break;
        case "\\":
            var w = fmt.charAt(++i), t = w === "(" || w === ")" ? w : "t";
            out[out.length] = {
                t: t,
                v: w
            };
            ++i;
            break;
        case "_":
            out[out.length] = {
                t: "t",
                v: " "
            };
            i += 2;
            break;
        case "@":
            /* Text Placeholder */ out[out.length] = {
                t: "T",
                v: v
            };
            ++i;
            break;
        case "B":
        case "b":
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") {
                if (dt == null) {
                    dt = $3ee4f50b1ae43a89$var$SSF_parse_date_code(v, opts, fmt.charAt(i + 1) === "2");
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: "X",
                    v: fmt.substr(i, 2)
                };
                lst = c;
                i += 2;
                break;
            }
        /* falls through */ case "M":
        case "D":
        case "Y":
        case "H":
        case "S":
        case "E":
            c = c.toLowerCase();
        /* falls through */ case "m":
        case "d":
        case "y":
        case "h":
        case "s":
        case "e":
        case "g":
            if (v < 0) return "";
            if (dt == null) {
                dt = $3ee4f50b1ae43a89$var$SSF_parse_date_code(v, opts);
                if (dt == null) return "";
            }
            o = c;
            while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c)o += c;
            if (c === "m" && lst.toLowerCase() === "h") c = "M";
            if (c === "h") c = hr;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case "A":
        case "a":
        case "\u4E0A":
            var q = {
                t: c,
                v: c
            };
            if (dt == null) dt = $3ee4f50b1ae43a89$var$SSF_parse_date_code(v, opts);
            if (fmt.substr(i, 3).toUpperCase() === "A/P") {
                if (dt != null) q.v = dt.H >= 12 ? "P" : "A";
                q.t = "T";
                hr = "h";
                i += 3;
            } else if (fmt.substr(i, 5).toUpperCase() === "AM/PM") {
                if (dt != null) q.v = dt.H >= 12 ? "PM" : "AM";
                q.t = "T";
                i += 5;
                hr = "h";
            } else if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") {
                if (dt != null) q.v = dt.H >= 12 ? "\u4E0B\u5348" : "\u4E0A\u5348";
                q.t = "T";
                i += 5;
                hr = "h";
            } else {
                q.t = "t";
                ++i;
            }
            if (dt == null && q.t === "T") return "";
            out[out.length] = q;
            lst = c;
            break;
        case "[":
            o = c;
            while(fmt.charAt(i++) !== "]" && i < fmt.length)o += fmt.charAt(i);
            if (o.slice(-1) !== "]") throw 'unterminated "[" block: |' + o + "|";
            if (o.match($3ee4f50b1ae43a89$var$SSF_abstime)) {
                if (dt == null) {
                    dt = $3ee4f50b1ae43a89$var$SSF_parse_date_code(v, opts);
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: "Z",
                    v: o.toLowerCase()
                };
                lst = o.charAt(1);
            } else if (o.indexOf("$") > -1) {
                o = (o.match(/\$([^-\[\]]*)/) || [])[1] || "$";
                if (!$3ee4f50b1ae43a89$var$fmt_is_date(fmt)) out[out.length] = {
                    t: "t",
                    v: o
                };
            }
            break;
        /* Numbers */ case ".":
            if (dt != null) {
                o = c;
                while(++i < fmt.length && (c = fmt.charAt(i)) === "0")o += c;
                out[out.length] = {
                    t: "s",
                    v: o
                };
                break;
            }
        /* falls through */ case "0":
        case "#":
            o = c;
            while(++i < fmt.length && "0#?.,E+-%".indexOf(c = fmt.charAt(i)) > -1)o += c;
            out[out.length] = {
                t: "n",
                v: o
            };
            break;
        case "?":
            o = c;
            while(fmt.charAt(++i) === c)o += c;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case "*":
            ++i;
            if (fmt.charAt(i) == " " || fmt.charAt(i) == "*") ++i;
            break; // **
        case "(":
        case ")":
            out[out.length] = {
                t: flen === 1 ? "t" : c,
                v: c
            };
            ++i;
            break;
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
            o = c;
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1)o += fmt.charAt(i);
            out[out.length] = {
                t: "D",
                v: o
            };
            break;
        case " ":
            out[out.length] = {
                t: c,
                v: c
            };
            ++i;
            break;
        case "$":
            out[out.length] = {
                t: "t",
                v: "$"
            };
            ++i;
            break;
        default:
            if (",$-+/():!^&'~{}<>=\u20ACacfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error("unrecognized character " + c + " in " + fmt);
            out[out.length] = {
                t: "t",
                v: c
            };
            ++i;
            break;
    }
    /* Scan for date/time parts */ var bt = 0, ss0 = 0, ssm;
    for(i = out.length - 1, lst = "t"; i >= 0; --i)switch(out[i].t){
        case "h":
        case "H":
            out[i].t = hr;
            lst = "h";
            if (bt < 1) bt = 1;
            break;
        case "s":
            if (ssm = out[i].v.match(/\.0+$/)) ss0 = Math.max(ss0, ssm[0].length - 1);
            if (bt < 3) bt = 3;
        /* falls through */ case "d":
        case "y":
        case "M":
        case "e":
            lst = out[i].t;
            break;
        case "m":
            if (lst === "s") {
                out[i].t = "M";
                if (bt < 2) bt = 2;
            }
            break;
        case "X":
            break;
        case "Z":
            if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
            if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
            if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
    }
    /* time rounding depends on presence of minute / second / usec fields */ switch(bt){
        case 0:
            break;
        case 1:
            /*::if(!dt) break;*/ if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            break;
        case 2:
            /*::if(!dt) break;*/ if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            break;
    }
    /* replace fields */ var nstr = "", jj;
    for(i = 0; i < out.length; ++i)switch(out[i].t){
        case "t":
        case "T":
        case " ":
        case "D":
            break;
        case "X":
            out[i].v = "";
            out[i].t = ";";
            break;
        case "d":
        case "m":
        case "y":
        case "h":
        case "H":
        case "M":
        case "s":
        case "e":
        case "b":
        case "Z":
            /*::if(!dt) throw "unreachable"; */ out[i].v = $3ee4f50b1ae43a89$var$SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
            out[i].t = "t";
            break;
        case "n":
        case "?":
            jj = i + 1;
            while(out[jj] != null && ((c = out[jj].t) === "?" || c === "D" || (c === " " || c === "t") && out[jj + 1] != null && (out[jj + 1].t === "?" || out[jj + 1].t === "t" && out[jj + 1].v === "/") || out[i].t === "(" && (c === " " || c === "n" || c === ")") || c === "t" && (out[jj].v === "/" || out[jj].v === " " && out[jj + 1] != null && out[jj + 1].t == "?"))){
                out[i].v += out[jj].v;
                out[jj] = {
                    v: "",
                    t: ";"
                };
                ++jj;
            }
            nstr += out[i].v;
            i = jj - 1;
            break;
        case "G":
            out[i].t = "t";
            out[i].v = $3ee4f50b1ae43a89$var$SSF_general(v, opts);
            break;
    }
    var vv = "", myv, ostr;
    if (nstr.length > 0) {
        if (nstr.charCodeAt(0) == 40) /* '(' */ {
            myv = v < 0 && nstr.charCodeAt(0) === 45 ? -v : v;
            ostr = $3ee4f50b1ae43a89$var$write_num("n", nstr, myv);
        } else {
            myv = v < 0 && flen > 1 ? -v : v;
            ostr = $3ee4f50b1ae43a89$var$write_num("n", nstr, myv);
            if (myv < 0 && out[0] && out[0].t == "t") {
                ostr = ostr.substr(1);
                out[0].v = "-" + out[0].v;
            }
        }
        jj = ostr.length - 1;
        var decpt = out.length;
        for(i = 0; i < out.length; ++i)if (out[i] != null && out[i].t != "t" && out[i].v.indexOf(".") > -1) {
            decpt = i;
            break;
        }
        var lasti = out.length;
        if (decpt === out.length && ostr.indexOf("E") === -1) {
            for(i = out.length - 1; i >= 0; --i){
                if (out[i] == null || "n?".indexOf(out[i].t) === -1) continue;
                if (jj >= out[i].v.length - 1) {
                    jj -= out[i].v.length;
                    out[i].v = ostr.substr(jj + 1, out[i].v.length);
                } else if (jj < 0) out[i].v = "";
                else {
                    out[i].v = ostr.substr(0, jj + 1);
                    jj = -1;
                }
                out[i].t = "t";
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
        } else if (decpt !== out.length && ostr.indexOf("E") === -1) {
            jj = ostr.indexOf(".") - 1;
            for(i = decpt; i >= 0; --i){
                if (out[i] == null || "n?".indexOf(out[i].t) === -1) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") - 1 : out[i].v.length - 1;
                vv = out[i].v.substr(j + 1);
                for(; j >= 0; --j)if (jj >= 0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
                out[i].v = vv;
                out[i].t = "t";
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
            jj = ostr.indexOf(".") + 1;
            for(i = decpt; i < out.length; ++i){
                if (out[i] == null || "n?(".indexOf(out[i].t) === -1 && i !== decpt) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") + 1 : 0;
                vv = out[i].v.substr(0, j);
                for(; j < out[i].v.length; ++j)if (jj < ostr.length) vv += ostr.charAt(jj++);
                out[i].v = vv;
                out[i].t = "t";
                lasti = i;
            }
        }
    }
    for(i = 0; i < out.length; ++i)if (out[i] != null && "n?".indexOf(out[i].t) > -1) {
        myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === "-" ? -v : v;
        out[i].v = $3ee4f50b1ae43a89$var$write_num(out[i].t, out[i].v, myv);
        out[i].t = "t";
    }
    var retval = "";
    for(i = 0; i !== out.length; ++i)if (out[i] != null) retval += out[i].v;
    return retval;
}
var $3ee4f50b1ae43a89$var$cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function $3ee4f50b1ae43a89$var$chkcond(v, rr) {
    if (rr == null) return false;
    var thresh = parseFloat(rr[2]);
    switch(rr[1]){
        case "=":
            if (v == thresh) return true;
            break;
        case ">":
            if (v > thresh) return true;
            break;
        case "<":
            if (v < thresh) return true;
            break;
        case "<>":
            if (v != thresh) return true;
            break;
        case ">=":
            if (v >= thresh) return true;
            break;
        case "<=":
            if (v <= thresh) return true;
            break;
    }
    return false;
}
function $3ee4f50b1ae43a89$var$choose_fmt(f /*:string*/ , v /*:any*/ ) {
    var fmt = $3ee4f50b1ae43a89$var$SSF_split_fmt(f);
    var l = fmt.length, lat = fmt[l - 1].indexOf("@");
    if (l < 4 && lat > -1) --l;
    if (fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
    if (typeof v !== "number") return [
        4,
        fmt.length === 4 || lat > -1 ? fmt[fmt.length - 1] : "@"
    ];
    switch(fmt.length){
        case 1:
            fmt = lat > -1 ? [
                "General",
                "General",
                "General",
                fmt[0]
            ] : [
                fmt[0],
                fmt[0],
                fmt[0],
                "@"
            ];
            break;
        case 2:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[0],
                fmt[0],
                fmt[1]
            ] : [
                fmt[0],
                fmt[1],
                fmt[0],
                "@"
            ];
            break;
        case 3:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[1],
                fmt[0],
                fmt[2]
            ] : [
                fmt[0],
                fmt[1],
                fmt[2],
                "@"
            ];
            break;
        case 4:
            break;
    }
    var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
    if (fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [
        l,
        ff
    ];
    if (fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
        var m1 = fmt[0].match($3ee4f50b1ae43a89$var$cfregex2);
        var m2 = fmt[1].match($3ee4f50b1ae43a89$var$cfregex2);
        return $3ee4f50b1ae43a89$var$chkcond(v, m1) ? [
            l,
            fmt[0]
        ] : $3ee4f50b1ae43a89$var$chkcond(v, m2) ? [
            l,
            fmt[1]
        ] : [
            l,
            fmt[m1 != null && m2 != null ? 2 : 1]
        ];
    }
    return [
        l,
        ff
    ];
}
function $3ee4f50b1ae43a89$var$SSF_format(fmt /*:string|number*/ , v /*:any*/ , o /*:?any*/ ) {
    if (o == null) o = {};
    var sfmt = "";
    switch(typeof fmt){
        case "string":
            if (fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
            else sfmt = fmt;
            break;
        case "number":
            if (fmt == 14 && o.dateNF) sfmt = o.dateNF;
            else sfmt = (o.table != null ? o.table /*:any*/  : $3ee4f50b1ae43a89$var$table_fmt)[fmt];
            if (sfmt == null) sfmt = o.table && o.table[$3ee4f50b1ae43a89$var$SSF_default_map[fmt]] || $3ee4f50b1ae43a89$var$table_fmt[$3ee4f50b1ae43a89$var$SSF_default_map[fmt]];
            if (sfmt == null) sfmt = $3ee4f50b1ae43a89$var$SSF_default_str[fmt] || "General";
            break;
    }
    if ($3ee4f50b1ae43a89$var$SSF_isgeneral(sfmt, 0)) return $3ee4f50b1ae43a89$var$SSF_general(v, o);
    if (v instanceof Date) v = $3ee4f50b1ae43a89$var$datenum_local(v, o.date1904);
    var f = $3ee4f50b1ae43a89$var$choose_fmt(sfmt, v);
    if ($3ee4f50b1ae43a89$var$SSF_isgeneral(f[1])) return $3ee4f50b1ae43a89$var$SSF_general(v, o);
    if (v === true) v = "TRUE";
    else if (v === false) v = "FALSE";
    else if (v === "" || v == null) return "";
    return $3ee4f50b1ae43a89$var$eval_fmt(f[1], v, o, f[0]);
}
function $3ee4f50b1ae43a89$var$SSF_load(fmt /*:string*/ , idx /*:?number*/ ) /*:number*/ {
    if (typeof idx != "number") {
        idx = +idx || -1;
        /*::if(typeof idx != 'number') return 0x188; */ for(var i = 0; i < 0x0188; ++i){
            /*::if(typeof idx != 'number') return 0x188; */ if ($3ee4f50b1ae43a89$var$table_fmt[i] == undefined) {
                if (idx < 0) idx = i;
                continue;
            }
            if ($3ee4f50b1ae43a89$var$table_fmt[i] == fmt) {
                idx = i;
                break;
            }
        }
        /*::if(typeof idx != 'number') return 0x188; */ if (idx < 0) idx = 0x187;
    }
    /*::if(typeof idx != 'number') return 0x188; */ $3ee4f50b1ae43a89$var$table_fmt[idx] = fmt;
    return idx;
}
function $3ee4f50b1ae43a89$var$SSF_load_table(tbl /*:SSFTable*/ ) /*:void*/ {
    for(var i = 0; i != 0x0188; ++i)if (tbl[i] !== undefined) $3ee4f50b1ae43a89$var$SSF_load(tbl[i], i);
}
function $3ee4f50b1ae43a89$var$make_ssf() {
    $3ee4f50b1ae43a89$var$table_fmt = $3ee4f50b1ae43a89$var$SSF_init_table();
}
var $3ee4f50b1ae43a89$export$40d8edd678456c2b = {
    format: $3ee4f50b1ae43a89$var$SSF_format,
    load: $3ee4f50b1ae43a89$var$SSF_load,
    _table: $3ee4f50b1ae43a89$var$table_fmt,
    load_table: $3ee4f50b1ae43a89$var$SSF_load_table,
    parse_date_code: $3ee4f50b1ae43a89$var$SSF_parse_date_code,
    is_date: $3ee4f50b1ae43a89$var$fmt_is_date,
    get_table: function get_table() {
        return $3ee4f50b1ae43a89$export$40d8edd678456c2b._table = $3ee4f50b1ae43a89$var$table_fmt;
    }
};
var $3ee4f50b1ae43a89$var$SSFImplicit /*{[number]:string}*/  = {
    "5": '"$"#,##0_);\\("$"#,##0\\)',
    "6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "23": "General",
    "24": "General",
    "25": "General",
    "26": "General",
    "27": "m/d/yy",
    "28": "m/d/yy",
    "29": "m/d/yy",
    "30": "m/d/yy",
    "31": "m/d/yy",
    "32": "h:mm:ss",
    "33": "h:mm:ss",
    "34": "h:mm:ss",
    "35": "h:mm:ss",
    "36": "m/d/yy",
    "41": '_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)',
    "42": '_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)',
    "43": '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)',
    "44": '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',
    "50": "m/d/yy",
    "51": "m/d/yy",
    "52": "m/d/yy",
    "53": "m/d/yy",
    "54": "m/d/yy",
    "55": "m/d/yy",
    "56": "m/d/yy",
    "57": "m/d/yy",
    "58": "m/d/yy",
    "59": "0",
    "60": "0.00",
    "61": "#,##0",
    "62": "#,##0.00",
    "63": '"$"#,##0_);\\("$"#,##0\\)',
    "64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "67": "0%",
    "68": "0.00%",
    "69": "# ?/?",
    "70": "# ??/??",
    "71": "m/d/yy",
    "72": "m/d/yy",
    "73": "d-mmm-yy",
    "74": "d-mmm",
    "75": "mmm-yy",
    "76": "h:mm",
    "77": "h:mm:ss",
    "78": "m/d/yy h:mm",
    "79": "mm:ss",
    "80": "[h]:mm:ss",
    "81": "mmss.0"
} /*:any*/ ;
/* dateNF parse TODO: move to SSF */ var $3ee4f50b1ae43a89$var$dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function $3ee4f50b1ae43a89$var$dateNF_regex(dateNF /*:string|number*/ ) /*:RegExp*/ {
    var fmt = typeof dateNF == "number" ? $3ee4f50b1ae43a89$var$table_fmt[dateNF] : dateNF;
    fmt = fmt.replace($3ee4f50b1ae43a89$var$dateNFregex, "(\\d+)");
    return new RegExp("^" + fmt + "$");
}
function $3ee4f50b1ae43a89$var$dateNF_fix(str /*:string*/ , dateNF /*:string*/ , match /*:Array<string>*/ ) /*:string*/ {
    var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
    (dateNF.match($3ee4f50b1ae43a89$var$dateNFregex) || []).forEach(function(n, i) {
        var v = parseInt(match[i + 1], 10);
        switch(n.toLowerCase().charAt(0)){
            case "y":
                Y = v;
                break;
            case "d":
                d = v;
                break;
            case "h":
                H = v;
                break;
            case "s":
                S = v;
                break;
            case "m":
                if (H >= 0) M = v;
                else m = v;
                break;
        }
    });
    if (S >= 0 && M == -1 && m >= 0) {
        M = m;
        m = -1;
    }
    var datestr = ("" + (Y >= 0 ? Y : new Date().getFullYear())).slice(-4) + "-" + ("00" + (m >= 1 ? m : 1)).slice(-2) + "-" + ("00" + (d >= 1 ? d : 1)).slice(-2);
    if (datestr.length == 7) datestr = "0" + datestr;
    if (datestr.length == 8) datestr = "20" + datestr;
    var timestr = ("00" + (H >= 0 ? H : 0)).slice(-2) + ":" + ("00" + (M >= 0 ? M : 0)).slice(-2) + ":" + ("00" + (S >= 0 ? S : 0)).slice(-2);
    if (H == -1 && M == -1 && S == -1) return datestr;
    if (Y == -1 && m == -1 && d == -1) return timestr;
    return datestr + "T" + timestr;
}
/*::
declare var ReadShift:any;
declare var CheckField:any;
declare var prep_blob:any;
declare var __readUInt32LE:any;
declare var __readInt32LE:any;
declare var __toBuffer:any;
declare var __utf16le:any;
declare var bconcat:any;
declare var s2a:any;
declare var chr0:any;
declare var chr1:any;
declare var has_buf:boolean;
declare var new_buf:any;
declare var new_raw_buf:any;
declare var new_unsafe_buf:any;
declare var Buffer_from:any;
*/ /* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*jshint eqnull:true */ /*exported CFB */ /*global Uint8Array:false, Uint16Array:false */ /*::
type SectorEntry = {
	name?:string;
	nodes?:Array<number>;
	data:RawBytes;
};
type SectorList = {
	[k:string|number]:SectorEntry;
	name:?string;
	fat_addrs:Array<number>;
	ssz:number;
}
type CFBFiles = {[n:string]:CFBEntry};
*/ /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */ var $3ee4f50b1ae43a89$var$CRC32 = /*#__PURE__*/ function() {
    var CRC32 = {};
    CRC32.version = "1.2.0";
    /* see perf/crc32table.js */ /*global Int32Array */ function signed_crc_table() /*:any*/ {
        var c = 0, table /*:Array<number>*/  = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== "undefined" ? new Int32Array(table) : table;
    }
    var T0 = signed_crc_table();
    function slice_by_16_tables(T) {
        var c = 0, v = 0, n = 0, table /*:Array<number>*/  = typeof Int32Array !== "undefined" ? new Int32Array(4096) : new Array(4096);
        for(n = 0; n != 256; ++n)table[n] = T[n];
        for(n = 0; n != 256; ++n){
            v = T[n];
            for(c = 256 + n; c < 4096; c += 256)v = table[c] = v >>> 8 ^ T[v & 0xFF];
        }
        var out = [];
        for(n = 1; n != 16; ++n)out[n - 1] = typeof Int32Array !== "undefined" ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
        return out;
    }
    var TT = slice_by_16_tables(T0);
    var T1 = TT[0], T2 = TT[1], T3 = TT[2], T4 = TT[3], T5 = TT[4];
    var T6 = TT[5], T7 = TT[6], T8 = TT[7], T9 = TT[8], Ta = TT[9];
    var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
    function crc32_bstr(bstr /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1;
        for(var i = 0, L = bstr.length; i < L;)C = C >>> 8 ^ T0[(C ^ bstr.charCodeAt(i++)) & 0xFF];
        return ~C;
    }
    function crc32_buf(B /*:Uint8Array|Array<number>*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1, L = B.length - 15, i = 0;
        for(; i < L;)C = Tf[B[i++] ^ C & 255] ^ Te[B[i++] ^ C >> 8 & 255] ^ Td[B[i++] ^ C >> 16 & 255] ^ Tc[B[i++] ^ C >>> 24] ^ Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^ T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^ T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
        L += 15;
        while(i < L)C = C >>> 8 ^ T0[(C ^ B[i++]) & 0xFF];
        return ~C;
    }
    function crc32_str(str /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed ^ -1;
        for(var i = 0, L = str.length, c = 0, d = 0; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) C = C >>> 8 ^ T0[(C ^ c) & 0xFF];
            else if (c < 0x800) {
                C = C >>> 8 ^ T0[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                C = C >>> 8 ^ T0[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d & 63)) & 0xFF];
            } else {
                C = C >>> 8 ^ T0[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            }
        }
        return ~C;
    }
    CRC32.table = T0;
    CRC32.bstr = crc32_bstr;
    CRC32.buf = crc32_buf;
    CRC32.str = crc32_str;
    return CRC32;
}();
/* [MS-CFB] v20171201 */ var $3ee4f50b1ae43a89$export$9f0e51cd97c572a = /*#__PURE__*/ function _CFB() {
    var exports = {};
    exports.version = "1.2.1";
    /* [MS-CFB] 2.6.4 */ function namecmp(l /*:string*/ , r /*:string*/ ) /*:number*/ {
        var L = l.split("/"), R = r.split("/");
        for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i){
            if (c = L[i].length - R[i].length) return c;
            if (L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
        }
        return L.length - R.length;
    }
    function dirname(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return p.slice(0, -1).indexOf("/") === -1 ? p : dirname(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(0, c + 1);
    }
    function filename(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(c + 1);
    }
    /* -------------------------------------------------------------------------- */ /* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/ /* write JS date to buf as a DOS date */ function write_dos_date(buf /*:CFBlob*/ , date /*:Date|string*/ ) {
        if (typeof date === "string") date = new Date(date);
        var hms /*:number*/  = date.getHours();
        hms = hms << 6 | date.getMinutes();
        hms = hms << 5 | date.getSeconds() >>> 1;
        buf.write_shift(2, hms);
        var ymd /*:number*/  = date.getFullYear() - 1980;
        ymd = ymd << 4 | date.getMonth() + 1;
        ymd = ymd << 5 | date.getDate();
        buf.write_shift(2, ymd);
    }
    /* read four bytes from buf and interpret as a DOS date */ function parse_dos_date(buf /*:CFBlob*/ ) /*:Date*/ {
        var hms = buf.read_shift(2) & 0xFFFF;
        var ymd = buf.read_shift(2) & 0xFFFF;
        var val = new Date();
        var d = ymd & 0x1F;
        ymd >>>= 5;
        var m = ymd & 0x0F;
        ymd >>>= 4;
        val.setMilliseconds(0);
        val.setFullYear(ymd + 1980);
        val.setMonth(m - 1);
        val.setDate(d);
        var S = hms & 0x1F;
        hms >>>= 5;
        var M = hms & 0x3F;
        hms >>>= 6;
        val.setHours(hms);
        val.setMinutes(M);
        val.setSeconds(S << 1);
        return val;
    }
    function parse_extra_field(blob /*:CFBlob*/ ) /*:any*/ {
        $3ee4f50b1ae43a89$var$prep_blob(blob, 0);
        var o = /*::(*/ {} /*:: :any)*/ ;
        var flags = 0;
        while(blob.l <= blob.length - 4){
            var type = blob.read_shift(2);
            var sz = blob.read_shift(2), tgt = blob.l + sz;
            var p = {};
            switch(type){
                /* UNIX-style Timestamps */ case 0x5455:
                    flags = blob.read_shift(1);
                    if (flags & 1) p.mtime = blob.read_shift(4);
                    /* for some reason, CD flag corresponds to LFH */ if (sz > 5) {
                        if (flags & 2) p.atime = blob.read_shift(4);
                        if (flags & 4) p.ctime = blob.read_shift(4);
                    }
                    if (p.mtime) p.mt = new Date(p.mtime * 1000);
                    break;
            }
            blob.l = tgt;
            o[type] = p;
        }
        return o;
    }
    var fs /*:: = require('fs'); */ ;
    function get_fs() {
        return fs || (fs = {});
    }
    function parse(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
        if ((file[0] | 0x20) == 0x6d && (file[1] | 0x20) == 0x69) return parse_mad(file, options);
        if (file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
        var mver = 3;
        var ssz = 512;
        var nmfs = 0; // number of mini FAT sectors
        var difat_sec_cnt = 0;
        var dir_start = 0;
        var minifat_start = 0;
        var difat_start = 0;
        var fat_addrs /*:Array<number>*/  = []; // locations of FAT sectors
        /* [MS-CFB] 2.2 Compound File Header */ var blob /*:CFBlob*/  = /*::(*/ file.slice(0, 512) /*:: :any)*/ ;
        $3ee4f50b1ae43a89$var$prep_blob(blob, 0);
        /* major version */ var mv = check_get_mver(blob);
        mver = mv[0];
        switch(mver){
            case 3:
                ssz = 512;
                break;
            case 4:
                ssz = 4096;
                break;
            case 0:
                if (mv[1] == 0) return parse_zip(file, options);
            /* falls through */ default:
                throw new Error("Major Version: Expected 3 or 4 saw " + mver);
        }
        /* reprocess header */ if (ssz !== 512) {
            blob = /*::(*/ file.slice(0, ssz) /*:: :any)*/ ;
            $3ee4f50b1ae43a89$var$prep_blob(blob, 28 /* blob.l */ );
        }
        /* Save header for final object */ var header /*:RawBytes*/  = file.slice(0, ssz);
        check_shifts(blob, mver);
        // Number of Directory Sectors
        var dir_cnt /*:number*/  = blob.read_shift(4, "i");
        if (mver === 3 && dir_cnt !== 0) throw new Error("# Directory Sectors: Expected 0 saw " + dir_cnt);
        // Number of FAT Sectors
        blob.l += 4;
        // First Directory Sector Location
        dir_start = blob.read_shift(4, "i");
        // Transaction Signature
        blob.l += 4;
        // Mini Stream Cutoff Size
        blob.chk("00100000", "Mini Stream Cutoff Size: ");
        // First Mini FAT Sector Location
        minifat_start = blob.read_shift(4, "i");
        // Number of Mini FAT Sectors
        nmfs = blob.read_shift(4, "i");
        // First DIFAT sector location
        difat_start = blob.read_shift(4, "i");
        // Number of DIFAT Sectors
        difat_sec_cnt = blob.read_shift(4, "i");
        // Grab FAT Sector Locations
        for(var q = -1, j = 0; j < 109; ++j){
            q = blob.read_shift(4, "i");
            if (q < 0) break;
            fat_addrs[j] = q;
        }
        /** Break the file up into sectors */ var sectors /*:Array<RawBytes>*/  = sectorify(file, ssz);
        sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
        /** Chains */ var sector_list /*:SectorList*/  = make_sector_list(sectors, dir_start, fat_addrs, ssz);
        sector_list[dir_start].name = "!Directory";
        if (nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
        sector_list[fat_addrs[0]].name = "!FAT";
        sector_list.fat_addrs = fat_addrs;
        sector_list.ssz = ssz;
        /* [MS-CFB] 2.6.1 Compound File Directory Entry */ var files /*:CFBFiles*/  = {}, Paths /*:Array<string>*/  = [], FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
        build_full_paths(FileIndex, FullPaths, Paths);
        Paths.shift();
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        // $FlowIgnore
        if (options && options.raw) o.raw = {
            header: header,
            sectors: sectors
        };
        return o;
    } // parse
    /* [MS-CFB] 2.2 Compound File Header -- read up to major version */ function check_get_mver(blob /*:CFBlob*/ ) /*:[number, number]*/ {
        if (blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [
            0,
            0
        ];
        // header signature 8
        blob.chk(HEADER_SIGNATURE, "Header Signature: ");
        // clsid 16
        //blob.chk(HEADER_CLSID, 'CLSID: ');
        blob.l += 16;
        // minor version 2
        var mver /*:number*/  = blob.read_shift(2, "u");
        return [
            blob.read_shift(2, "u"),
            mver
        ];
    }
    function check_shifts(blob /*:CFBlob*/ , mver /*:number*/ ) /*:void*/ {
        var shift = 0x09;
        // Byte Order
        //blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
        blob.l += 2;
        // Sector Shift
        switch(shift = blob.read_shift(2)){
            case 0x09:
                if (mver != 3) throw new Error("Sector Shift: Expected 9 saw " + shift);
                break;
            case 0x0c:
                if (mver != 4) throw new Error("Sector Shift: Expected 12 saw " + shift);
                break;
            default:
                throw new Error("Sector Shift: Expected 9 or 12 saw " + shift);
        }
        // Mini Sector Shift
        blob.chk("0600", "Mini Sector Shift: ");
        // Reserved
        blob.chk("000000000000", "Reserved: ");
    }
    /** Break the file up into sectors */ function sectorify(file /*:RawBytes*/ , ssz /*:number*/ ) /*:Array<RawBytes>*/ {
        var nsectors = Math.ceil(file.length / ssz) - 1;
        var sectors /*:Array<RawBytes>*/  = [];
        for(var i = 1; i < nsectors; ++i)sectors[i - 1] = file.slice(i * ssz, (i + 1) * ssz);
        sectors[nsectors - 1] = file.slice(nsectors * ssz);
        return sectors;
    }
    /* [MS-CFB] 2.6.4 Red-Black Tree */ function build_full_paths(FI /*:CFBFileIndex*/ , FP /*:Array<string>*/ , Paths /*:Array<string>*/ ) /*:void*/ {
        var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
        var dad /*:Array<number>*/  = [], q /*:Array<number>*/  = [];
        for(; i < pl; ++i){
            dad[i] = q[i] = i;
            FP[i] = Paths[i];
        }
        for(; j < q.length; ++j){
            i = q[j];
            L = FI[i].L;
            R = FI[i].R;
            C = FI[i].C;
            if (dad[i] === i) {
                if (L !== -1 /*NOSTREAM*/  && dad[L] !== L) dad[i] = dad[L];
                if (R !== -1 && dad[R] !== R) dad[i] = dad[R];
            }
            if (C !== -1 /*NOSTREAM*/ ) dad[C] = i;
            if (L !== -1 && i != dad[i]) {
                dad[L] = dad[i];
                if (q.lastIndexOf(L) < j) q.push(L);
            }
            if (R !== -1 && i != dad[i]) {
                dad[R] = dad[i];
                if (q.lastIndexOf(R) < j) q.push(R);
            }
        }
        for(i = 1; i < pl; ++i)if (dad[i] === i) {
            if (R !== -1 /*NOSTREAM*/  && dad[R] !== R) dad[i] = dad[R];
            else if (L !== -1 && dad[L] !== L) dad[i] = dad[L];
        }
        for(i = 1; i < pl; ++i){
            if (FI[i].type === 0 /* unknown */ ) continue;
            j = i;
            if (j != dad[j]) do {
                j = dad[j];
                FP[i] = FP[j] + "/" + FP[i];
            }while (j !== 0 && -1 !== dad[j] && j != dad[j]);
            dad[i] = -1;
        }
        FP[0] += "/";
        for(i = 1; i < pl; ++i)if (FI[i].type !== 2 /* stream */ ) FP[i] += "/";
    }
    function get_mfat_entry(entry /*:CFBEntry*/ , payload /*:RawBytes*/ , mini /*:?RawBytes*/ ) /*:CFBlob*/ {
        var start = entry.start, size = entry.size;
        //return (payload.slice(start*MSSZ, start*MSSZ + size)/*:any*/);
        var o = [];
        var idx = start;
        while(mini && size > 0 && idx >= 0){
            o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
            size -= MSSZ;
            idx = $3ee4f50b1ae43a89$var$__readInt32LE(mini, idx * 4);
        }
        if (o.length === 0) return $3ee4f50b1ae43a89$var$new_buf(0);
        return $3ee4f50b1ae43a89$var$bconcat(o).slice(0, entry.size);
    }
    /** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */ function sleuth_fat(idx /*:number*/ , cnt /*:number*/ , sectors /*:Array<RawBytes>*/ , ssz /*:number*/ , fat_addrs) /*:void*/ {
        var q /*:number*/  = ENDOFCHAIN;
        if (idx === ENDOFCHAIN) {
            if (cnt !== 0) throw new Error("DIFAT chain shorter than expected");
        } else if (idx !== -1 /*FREESECT*/ ) {
            var sector = sectors[idx], m = (ssz >>> 2) - 1;
            if (!sector) return;
            for(var i = 0; i < m; ++i){
                if ((q = $3ee4f50b1ae43a89$var$__readInt32LE(sector, i * 4)) === ENDOFCHAIN) break;
                fat_addrs.push(q);
            }
            sleuth_fat($3ee4f50b1ae43a89$var$__readInt32LE(sector, ssz - 4), cnt - 1, sectors, ssz, fat_addrs);
        }
    }
    /** Follow the linked list of sectors for a given starting point */ function get_sector_list(sectors /*:Array<RawBytes>*/ , start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ , chkd /*:?Array<boolean>*/ ) /*:SectorEntry*/ {
        var buf /*:Array<number>*/  = [], buf_chain /*:Array<any>*/  = [];
        if (!chkd) chkd = [];
        var modulus = ssz - 1, j = 0, jj = 0;
        for(j = start; j >= 0;){
            chkd[j] = true;
            buf[buf.length] = j;
            buf_chain.push(sectors[j]);
            var addr = fat_addrs[Math.floor(j * 4 / ssz)];
            jj = j * 4 & modulus;
            if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
            if (!sectors[addr]) break;
            j = $3ee4f50b1ae43a89$var$__readInt32LE(sectors[addr], jj);
        }
        return {
            nodes: buf,
            data: $3ee4f50b1ae43a89$var$__toBuffer([
                buf_chain
            ])
        };
    }
    /** Chase down the sector linked lists */ function make_sector_list(sectors /*:Array<RawBytes>*/ , dir_start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ ) /*:SectorList*/ {
        var sl = sectors.length, sector_list /*:SectorList*/  = [];
        var chkd /*:Array<boolean>*/  = [], buf /*:Array<number>*/  = [], buf_chain /*:Array<RawBytes>*/  = [];
        var modulus = ssz - 1, i = 0, j = 0, k = 0, jj = 0;
        for(i = 0; i < sl; ++i){
            buf = [];
            k = i + dir_start;
            if (k >= sl) k -= sl;
            if (chkd[k]) continue;
            buf_chain = [];
            var seen = [];
            for(j = k; j >= 0;){
                seen[j] = true;
                chkd[j] = true;
                buf[buf.length] = j;
                buf_chain.push(sectors[j]);
                var addr /*:number*/  = fat_addrs[Math.floor(j * 4 / ssz)];
                jj = j * 4 & modulus;
                if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
                if (!sectors[addr]) break;
                j = $3ee4f50b1ae43a89$var$__readInt32LE(sectors[addr], jj);
                if (seen[j]) break;
            }
            sector_list[k] = {
                nodes: buf,
                data: $3ee4f50b1ae43a89$var$__toBuffer([
                    buf_chain
                ])
            } /*:SectorEntry*/ ;
        }
        return sector_list;
    }
    /* [MS-CFB] 2.6.1 Compound File Directory Entry */ function read_directory(dir_start /*:number*/ , sector_list /*:SectorList*/ , sectors /*:Array<RawBytes>*/ , Paths /*:Array<string>*/ , nmfs, files, FileIndex, mini) {
        var minifat_store = 0, pl = Paths.length ? 2 : 0;
        var sector = sector_list[dir_start].data;
        var i = 0, namelen = 0, name;
        for(; i < sector.length; i += 128){
            var blob /*:CFBlob*/  = /*::(*/ sector.slice(i, i + 128) /*:: :any)*/ ;
            $3ee4f50b1ae43a89$var$prep_blob(blob, 64);
            namelen = blob.read_shift(2);
            name = $3ee4f50b1ae43a89$var$__utf16le(blob, 0, namelen - pl);
            Paths.push(name);
            var o /*:CFBEntry*/  = {
                name: name,
                type: blob.read_shift(1),
                color: blob.read_shift(1),
                L: blob.read_shift(4, "i"),
                R: blob.read_shift(4, "i"),
                C: blob.read_shift(4, "i"),
                clsid: blob.read_shift(16),
                state: blob.read_shift(4, "i"),
                start: 0,
                size: 0
            };
            var ctime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (ctime !== 0) o.ct = read_date(blob, blob.l - 8);
            var mtime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (mtime !== 0) o.mt = read_date(blob, blob.l - 8);
            o.start = blob.read_shift(4, "i");
            o.size = blob.read_shift(4, "i");
            if (o.size < 0 && o.start < 0) {
                o.size = o.type = 0;
                o.start = ENDOFCHAIN;
                o.name = "";
            }
            if (o.type === 5) {
                minifat_store = o.start;
                if (nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
            /*minifat_size = o.size;*/ } else if (o.size >= 4096 /* MSCSZ */ ) {
                o.storage = "fat";
                if (sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
                sector_list[o.start].name = o.name;
                o.content = sector_list[o.start].data.slice(0, o.size);
            } else {
                o.storage = "minifat";
                if (o.size < 0) o.size = 0;
                else if (minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini] || {}).data);
            }
            if (o.content) $3ee4f50b1ae43a89$var$prep_blob(o.content, 0);
            files[name] = o;
            FileIndex.push(o);
        }
    }
    function read_date(blob /*:RawBytes|CFBlob*/ , offset /*:number*/ ) /*:Date*/ {
        return new Date(($3ee4f50b1ae43a89$var$__readUInt32LE(blob, offset + 4) / 1e7 * Math.pow(2, 32) + $3ee4f50b1ae43a89$var$__readUInt32LE(blob, offset) / 1e7 - 11644473600) * 1000);
    }
    function read_file(filename /*:string*/ , options /*:CFBReadOpts*/ ) {
        get_fs();
        return parse(fs.readFileSync(filename), options);
    }
    function read(blob /*:RawBytes|string*/ , options /*:CFBReadOpts*/ ) {
        var type = options && options.type;
        if (!type) {
            if ($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(blob)) type = "buffer";
        }
        switch(type || "base64"){
            case "file":
                /*:: if(typeof blob !== 'string') throw "Must pass a filename when type='file'"; */ return read_file(blob, options);
            case "base64":
                /*:: if(typeof blob !== 'string') throw "Must pass a base64-encoded binary string when type='file'"; */ return parse($3ee4f50b1ae43a89$var$s2a($3ee4f50b1ae43a89$var$Base64_decode(blob)), options);
            case "binary":
                /*:: if(typeof blob !== 'string') throw "Must pass a binary string when type='file'"; */ return parse($3ee4f50b1ae43a89$var$s2a(blob), options);
        }
        return parse(/*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */ blob, options);
    }
    function init_cfb(cfb /*:CFBContainer*/ , opts /*:?any*/ ) /*:void*/ {
        var o = opts || {}, root = o.root || "Root Entry";
        if (!cfb.FullPaths) cfb.FullPaths = [];
        if (!cfb.FileIndex) cfb.FileIndex = [];
        if (cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
        if (cfb.FullPaths.length === 0) {
            cfb.FullPaths[0] = root + "/";
            cfb.FileIndex[0] = {
                name: root,
                type: 5
            } /*:any*/ ;
        }
        if (o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
        seed_cfb(cfb);
    }
    function seed_cfb(cfb /*:CFBContainer*/ ) /*:void*/ {
        var nm = "\x01Sh33tJ5";
        if ($3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "/" + nm)) return;
        var p = $3ee4f50b1ae43a89$var$new_buf(4);
        p[0] = 55;
        p[1] = p[3] = 50;
        p[2] = 54;
        cfb.FileIndex.push({
            name: nm,
            type: 2,
            content: p,
            size: 4,
            L: 69,
            R: 69,
            C: 69
        } /*:any*/ );
        cfb.FullPaths.push(cfb.FullPaths[0] + nm);
        rebuild_cfb(cfb);
    }
    function rebuild_cfb(cfb /*:CFBContainer*/ , f /*:?boolean*/ ) /*:void*/ {
        init_cfb(cfb);
        var gc = false, s = false;
        for(var i = cfb.FullPaths.length - 1; i >= 0; --i){
            var _file = cfb.FileIndex[i];
            switch(_file.type){
                case 0:
                    if (s) gc = true;
                    else {
                        cfb.FileIndex.pop();
                        cfb.FullPaths.pop();
                    }
                    break;
                case 1:
                case 2:
                case 5:
                    s = true;
                    if (isNaN(_file.R * _file.L * _file.C)) gc = true;
                    if (_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
                    break;
                default:
                    gc = true;
                    break;
            }
        }
        if (!gc && !f) return;
        var now = new Date(1987, 1, 19), j = 0;
        // Track which names exist
        var fullPaths = Object.create ? Object.create(null) : {};
        var data /*:Array<[string, CFBEntry]>*/  = [];
        for(i = 0; i < cfb.FullPaths.length; ++i){
            fullPaths[cfb.FullPaths[i]] = true;
            if (cfb.FileIndex[i].type === 0) continue;
            data.push([
                cfb.FullPaths[i],
                cfb.FileIndex[i]
            ]);
        }
        for(i = 0; i < data.length; ++i){
            var dad = dirname(data[i][0]);
            s = fullPaths[dad];
            if (!s) {
                data.push([
                    dad,
                    {
                        name: filename(dad).replace("/", ""),
                        type: 1,
                        clsid: HEADER_CLSID,
                        ct: now,
                        mt: now,
                        content: null
                    } /*:any*/ 
                ]);
                // Add name to set
                fullPaths[dad] = true;
            }
        }
        data.sort(function(x, y) {
            return namecmp(x[0], y[0]);
        });
        cfb.FullPaths = [];
        cfb.FileIndex = [];
        for(i = 0; i < data.length; ++i){
            cfb.FullPaths[i] = data[i][0];
            cfb.FileIndex[i] = data[i][1];
        }
        for(i = 0; i < data.length; ++i){
            var elt = cfb.FileIndex[i];
            var nm = cfb.FullPaths[i];
            elt.name = filename(nm).replace("/", "");
            elt.L = elt.R = elt.C = -(elt.color = 1);
            elt.size = elt.content ? elt.content.length : 0;
            elt.start = 0;
            elt.clsid = elt.clsid || HEADER_CLSID;
            if (i === 0) {
                elt.C = data.length > 1 ? 1 : -1;
                elt.size = 0;
                elt.type = 5;
            } else if (nm.slice(-1) == "/") {
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == nm) break;
                elt.C = j >= data.length ? -1 : j;
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == dirname(nm)) break;
                elt.R = j >= data.length ? -1 : j;
                elt.type = 1;
            } else {
                if (dirname(cfb.FullPaths[i + 1] || "") == dirname(nm)) elt.R = i + 1;
                elt.type = 2;
            }
        }
    }
    function _write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var _opts = options || {};
        /* MAD is order-sensitive, skip rebuild and sort */ if (_opts.fileType == "mad") return write_mad(cfb, _opts);
        rebuild_cfb(cfb);
        switch(_opts.fileType){
            case "zip":
                return write_zip(cfb, _opts);
        }
        var L = function(cfb /*:CFBContainer*/ ) /*:Array<number>*/ {
            var mini_size = 0, fat_size = 0;
            for(var i = 0; i < cfb.FileIndex.length; ++i){
                var file = cfb.FileIndex[i];
                if (!file.content) continue;
                /*:: if(file.content == null) throw new Error("unreachable"); */ var flen = file.content.length;
                if (flen > 0) {
                    if (flen < 0x1000) mini_size += flen + 0x3F >> 6;
                    else fat_size += flen + 0x01FF >> 9;
                }
            }
            var dir_cnt = cfb.FullPaths.length + 3 >> 2;
            var mini_cnt = mini_size + 7 >> 3;
            var mfat_cnt = mini_size + 0x7F >> 7;
            var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
            var fat_cnt = fat_base + 0x7F >> 7;
            var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            while(fat_base + fat_cnt + difat_cnt + 0x7F >> 7 > fat_cnt)difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            var L = [
                1,
                difat_cnt,
                fat_cnt,
                mfat_cnt,
                dir_cnt,
                fat_size,
                mini_size,
                0
            ];
            cfb.FileIndex[0].size = mini_size << 6;
            L[7] = (cfb.FileIndex[0].start = L[0] + L[1] + L[2] + L[3] + L[4] + L[5]) + (L[6] + 7 >> 3);
            return L;
        }(cfb);
        var o = $3ee4f50b1ae43a89$var$new_buf(L[7] << 9);
        var i = 0, T = 0;
        for(i = 0; i < 8; ++i)o.write_shift(1, HEADER_SIG[i]);
        for(i = 0; i < 8; ++i)o.write_shift(2, 0);
        o.write_shift(2, 0x003E);
        o.write_shift(2, 0x0003);
        o.write_shift(2, 0xFFFE);
        o.write_shift(2, 0x0009);
        o.write_shift(2, 0x0006);
        for(i = 0; i < 3; ++i)o.write_shift(2, 0);
        o.write_shift(4, 0);
        o.write_shift(4, L[2]);
        o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
        o.write_shift(4, 0);
        o.write_shift(4, 4096);
        o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[3]);
        o.write_shift(-4, L[1] ? L[0] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[1]);
        for(i = 0; i < 109; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
        if (L[1]) for(T = 0; T < L[1]; ++T){
            for(; i < 236 + T * 127; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
            o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
        }
        var chainit = function(w /*:number*/ ) /*:void*/ {
            for(T += w; i < T - 1; ++i)o.write_shift(-4, i + 1);
            if (w) {
                ++i;
                o.write_shift(-4, ENDOFCHAIN);
            }
        };
        T = i = 0;
        for(T += L[1]; i < T; ++i)o.write_shift(-4, consts.DIFSECT);
        for(T += L[2]; i < T; ++i)o.write_shift(-4, consts.FATSECT);
        chainit(L[3]);
        chainit(L[4]);
        var j /*:number*/  = 0, flen /*:number*/  = 0;
        var file /*:CFBEntry*/  = cfb.FileIndex[0];
        for(; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (flen < 0x1000) continue;
            file.start = T;
            chainit(flen + 0x01FF >> 9);
        }
        chainit(L[6] + 7 >> 3);
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        T = i = 0;
        for(j = 0; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (!flen || flen >= 0x1000) continue;
            file.start = T;
            chainit(flen + 0x3F >> 6);
        }
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        for(i = 0; i < L[4] << 2; ++i){
            var nm = cfb.FullPaths[i];
            if (!nm || nm.length === 0) {
                for(j = 0; j < 17; ++j)o.write_shift(4, 0);
                for(j = 0; j < 3; ++j)o.write_shift(4, -1);
                for(j = 0; j < 12; ++j)o.write_shift(4, 0);
                continue;
            }
            file = cfb.FileIndex[i];
            if (i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
            var _nm /*:string*/  = i === 0 && _opts.root || file.name;
            flen = 2 * (_nm.length + 1);
            o.write_shift(64, _nm, "utf16le");
            o.write_shift(2, flen);
            o.write_shift(1, file.type);
            o.write_shift(1, file.color);
            o.write_shift(-4, file.L);
            o.write_shift(-4, file.R);
            o.write_shift(-4, file.C);
            if (!file.clsid) for(j = 0; j < 4; ++j)o.write_shift(4, 0);
            else o.write_shift(16, file.clsid, "hex");
            o.write_shift(4, file.state || 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, file.start);
            o.write_shift(4, file.size);
            o.write_shift(4, 0);
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size >= 0x1000) {
                o.l = file.start + 1 << 9;
                if ($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 511 & -512;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x1FF; ++j)o.write_shift(1, 0);
                }
            }
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size > 0 && file.size < 0x1000) {
                if ($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 63 & -64;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x3F; ++j)o.write_shift(1, 0);
                }
            }
        }
        if ($3ee4f50b1ae43a89$var$has_buf) o.l = o.length;
        else // When using Buffer, already 0-filled
        while(o.l < o.length)o.write_shift(1, 0);
        return o;
    }
    /* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */ function find(cfb /*:CFBContainer*/ , path /*:string*/ ) /*:?CFBEntry*/ {
        var UCFullPaths /*:Array<string>*/  = cfb.FullPaths.map(function(x) {
            return x.toUpperCase();
        });
        var UCPaths /*:Array<string>*/  = UCFullPaths.map(function(x) {
            var y = x.split("/");
            return y[y.length - (x.slice(-1) == "/" ? 2 : 1)];
        });
        var k /*:boolean*/  = false;
        if (path.charCodeAt(0) === 47 /* "/" */ ) {
            k = true;
            path = UCFullPaths[0].slice(0, -1) + path;
        } else k = path.indexOf("/") !== -1;
        var UCPath /*:string*/  = path.toUpperCase();
        var w /*:number*/  = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
        if (w !== -1) return cfb.FileIndex[w];
        var m = !UCPath.match($3ee4f50b1ae43a89$var$chr1);
        UCPath = UCPath.replace($3ee4f50b1ae43a89$var$chr0, "");
        if (m) UCPath = UCPath.replace($3ee4f50b1ae43a89$var$chr1, "!");
        for(w = 0; w < UCFullPaths.length; ++w){
            if ((m ? UCFullPaths[w].replace($3ee4f50b1ae43a89$var$chr1, "!") : UCFullPaths[w]).replace($3ee4f50b1ae43a89$var$chr0, "") == UCPath) return cfb.FileIndex[w];
            if ((m ? UCPaths[w].replace($3ee4f50b1ae43a89$var$chr1, "!") : UCPaths[w]).replace($3ee4f50b1ae43a89$var$chr0, "") == UCPath) return cfb.FileIndex[w];
        }
        return null;
    }
    /** CFB Constants */ var MSSZ = 64; /* Mini Sector Size = 1<<6 */ 
    //var MSCSZ = 4096; /* Mini Stream Cutoff Size */
    /* 2.1 Compound File Sector Numbers and Types */ var ENDOFCHAIN = -2;
    /* 2.2 Compound File Header */ var HEADER_SIGNATURE = "d0cf11e0a1b11ae1";
    var HEADER_SIG = [
        0xD0,
        0xCF,
        0x11,
        0xE0,
        0xA1,
        0xB1,
        0x1A,
        0xE1
    ];
    var HEADER_CLSID = "00000000000000000000000000000000";
    var consts = {
        /* 2.1 Compund File Sector Numbers and Types */ MAXREGSECT: -6,
        DIFSECT: -4,
        FATSECT: -3,
        ENDOFCHAIN: ENDOFCHAIN,
        FREESECT: -1,
        /* 2.2 Compound File Header */ HEADER_SIGNATURE: HEADER_SIGNATURE,
        HEADER_MINOR_VERSION: "3e00",
        MAXREGSID: -6,
        NOSTREAM: -1,
        HEADER_CLSID: HEADER_CLSID,
        /* 2.6.1 Compound File Directory Entry */ EntryTypes: [
            "unknown",
            "storage",
            "stream",
            "lockbytes",
            "property",
            "root"
        ]
    };
    function write_file(cfb /*:CFBContainer*/ , filename /*:string*/ , options /*:CFBWriteOpts*/ ) /*:void*/ {
        get_fs();
        var o = _write(cfb, options);
        /*:: if(typeof Buffer == 'undefined' || !Buffer.isBuffer(o) || !(o instanceof Buffer)) throw new Error("unreachable"); */ fs.writeFileSync(filename, o);
    }
    function a2s(o /*:RawBytes*/ ) /*:string*/ {
        var out = new Array(o.length);
        for(var i = 0; i < o.length; ++i)out[i] = String.fromCharCode(o[i]);
        return out.join("");
    }
    function write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var o = _write(cfb, options);
        switch(options && options.type || "buffer"){
            case "file":
                get_fs();
                fs.writeFileSync(options.filename, o /*:any*/ );
                return o;
            case "binary":
                return typeof o == "string" ? o : a2s(o);
            case "base64":
                return $3ee4f50b1ae43a89$var$Base64_encode(typeof o == "string" ? o : a2s(o));
            case "buffer":
                if ($3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$require$Buffer.isBuffer(o) ? o : $3ee4f50b1ae43a89$var$Buffer_from(o);
            /* falls through */ case "array":
                return typeof o == "string" ? $3ee4f50b1ae43a89$var$s2a(o) : o;
        }
        return o;
    }
    /* node < 8.1 zlib does not expose bytesRead, so default to pure JS */ var _zlib;
    function use_zlib(zlib) {
        try {
            var InflateRaw = zlib.InflateRaw;
            var InflRaw = new InflateRaw();
            InflRaw._processChunk(new Uint8Array([
                3,
                0
            ]), InflRaw._finishFlushFlag);
            if (InflRaw.bytesRead) _zlib = zlib;
            else throw new Error("zlib does not expose bytesRead");
        } catch (e) {
            console.error("cannot use native zlib: " + (e.message || e));
        }
    }
    function _inflateRawSync(payload, usz) {
        if (!_zlib) return _inflate(payload, usz);
        var InflateRaw = _zlib.InflateRaw;
        var InflRaw = new InflateRaw();
        var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
        payload.l += InflRaw.bytesRead;
        return out;
    }
    function _deflateRawSync(payload) {
        return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
    }
    var CLEN_ORDER = [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    /*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */ var LEN_LN = [
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258
    ];
    /*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */ var DST_LN = [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577
    ];
    function bit_swap_8(n) {
        var t = (n << 1 | n << 11) & 0x22110 | (n << 5 | n << 15) & 0x88440;
        return (t >> 16 | t >> 8 | t) & 0xFF;
    }
    var use_typed_arrays = typeof Uint8Array !== "undefined";
    var bitswap8 = use_typed_arrays ? new Uint8Array(256) : [];
    for(var q = 0; q < 256; ++q)bitswap8[q] = bit_swap_8(q);
    function bit_swap_n(n, b) {
        var rev = bitswap8[n & 0xFF];
        if (b <= 8) return rev >>> 8 - b;
        rev = rev << 8 | bitswap8[n >> 8 & 0xFF];
        if (b <= 16) return rev >>> 16 - b;
        rev = rev << 8 | bitswap8[n >> 16 & 0xFF];
        return rev >>> 24 - b;
    }
    /* helpers for unaligned bit reads */ function read_bits_2(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 6 ? 0 : buf[h + 1] << 8)) >>> w & 0x03;
    }
    function read_bits_3(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 5 ? 0 : buf[h + 1] << 8)) >>> w & 0x07;
    }
    function read_bits_4(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 4 ? 0 : buf[h + 1] << 8)) >>> w & 0x0F;
    }
    function read_bits_5(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 3 ? 0 : buf[h + 1] << 8)) >>> w & 0x1F;
    }
    function read_bits_7(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 1 ? 0 : buf[h + 1] << 8)) >>> w & 0x7F;
    }
    /* works up to n = 3 * 8 + 1 = 25 */ function read_bits_n(buf, bl, n) {
        var w = bl & 7, h = bl >>> 3, f = (1 << n) - 1;
        var v = buf[h] >>> w;
        if (n < 8 - w) return v & f;
        v |= buf[h + 1] << 8 - w;
        if (n < 16 - w) return v & f;
        v |= buf[h + 2] << 16 - w;
        if (n < 24 - w) return v & f;
        v |= buf[h + 3] << 24 - w;
        return v & f;
    }
    /* helpers for unaligned bit writes */ function write_bits_3(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        if (w <= 5) buf[h] |= (v & 7) << w;
        else {
            buf[h] |= v << w & 0xFF;
            buf[h + 1] = (v & 7) >> 8 - w;
        }
        return bl + 3;
    }
    function write_bits_1(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v = (v & 1) << w;
        buf[h] |= v;
        return bl + 1;
    }
    function write_bits_8(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v;
        return bl + 8;
    }
    function write_bits_16(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v & 0xFF;
        buf[h + 2] = v >>> 8;
        return bl + 16;
    }
    /* until ArrayBuffer#realloc is a thing, fake a realloc */ function realloc(b, sz /*:number*/ ) {
        var L = b.length, M = 2 * L > sz ? 2 * L : sz + 5, i = 0;
        if (L >= sz) return b;
        if ($3ee4f50b1ae43a89$var$has_buf) {
            var o = $3ee4f50b1ae43a89$var$new_unsafe_buf(M);
            // $FlowIgnore
            if (b.copy) b.copy(o);
            else for(; i < b.length; ++i)o[i] = b[i];
            return o;
        } else if (use_typed_arrays) {
            var a = new Uint8Array(M);
            if (a.set) a.set(b);
            else for(; i < L; ++i)a[i] = b[i];
            return a;
        }
        b.length = M;
        return b;
    }
    /* zero-filled arrays for older browsers */ function zero_fill_array(n) {
        var o = new Array(n);
        for(var i = 0; i < n; ++i)o[i] = 0;
        return o;
    }
    /* build tree (used for literals and lengths) */ function build_tree(clens, cmap, MAX /*:number*/ ) /*:number*/ {
        var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
        var bl_count = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
        for(i = 0; i < 32; ++i)bl_count[i] = 0;
        for(i = L; i < MAX; ++i)clens[i] = 0;
        L = clens.length;
        var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
        /* build code tree */ for(i = 0; i < L; ++i){
            bl_count[w = clens[i]]++;
            if (maxlen < w) maxlen = w;
            ctree[i] = 0;
        }
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)bl_count[i + 16] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i){
            ccode = clens[i];
            if (ccode != 0) ctree[i] = bl_count[ccode + 16]++;
        }
        /* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bit_swap_n(ctree[i], maxlen) >> maxlen - cleni;
                for(j = (1 << maxlen + 4 - cleni) - 1; j >= 0; --j)cmap[ccode | j << cleni] = cleni & 15 | i << 4;
            }
        }
        return maxlen;
    }
    /* Fixed Huffman */ var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
    var fix_dmap = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
    if (!use_typed_arrays) {
        for(var i = 0; i < 512; ++i)fix_lmap[i] = 0;
        for(i = 0; i < 32; ++i)fix_dmap[i] = 0;
    }
    (function() {
        var dlens /*:Array<number>*/  = [];
        var i = 0;
        for(; i < 32; i++)dlens.push(5);
        build_tree(dlens, fix_dmap, 32);
        var clens /*:Array<number>*/  = [];
        i = 0;
        for(; i <= 143; i++)clens.push(8);
        for(; i <= 255; i++)clens.push(9);
        for(; i <= 279; i++)clens.push(7);
        for(; i <= 287; i++)clens.push(8);
        build_tree(clens, fix_lmap, 288);
    })();
    var _deflateRaw = /*#__PURE__*/ function _deflateRawIIFE() {
        var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
        var j = 0, k = 0;
        for(; j < DST_LN.length - 1; ++j)for(; k < DST_LN[j + 1]; ++k)DST_LN_RE[k] = j;
        for(; k < 32768; ++k)DST_LN_RE[k] = 29;
        var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
        for(j = 0, k = 0; j < LEN_LN.length - 1; ++j)for(; k < LEN_LN[j + 1]; ++k)LEN_LN_RE[k] = j;
        function write_stored(data, out) {
            var boff = 0;
            while(boff < data.length){
                var L = Math.min(0xFFFF, data.length - boff);
                var h = boff + L == data.length;
                out.write_shift(1, +h);
                out.write_shift(2, L);
                out.write_shift(2, ~L & 0xFFFF);
                while(L-- > 0)out[out.l++] = data[boff++];
            }
            return out.l;
        }
        /* Fixed Huffman */ function write_huff_fixed(data, out) {
            var bl = 0;
            var boff = 0;
            var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
            while(boff < data.length){
                var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);
                /* write a stored block for short data */ if (L < 10) {
                    bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
                    if (bl & 7) bl += 8 - (bl & 7);
                    out.l = bl / 8 | 0;
                    out.write_shift(2, L);
                    out.write_shift(2, ~L & 0xFFFF);
                    while(L-- > 0)out[out.l++] = data[boff++];
                    bl = out.l * 8;
                    continue;
                }
                bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
                var hash = 0;
                while(L-- > 0){
                    var d = data[boff];
                    hash = (hash << 5 ^ d) & 0x7FFF;
                    var match = -1, mlen = 0;
                    if (match = addrs[hash]) {
                        match |= boff & -32768;
                        if (match > boff) match -= 0x8000;
                        if (match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250)++mlen;
                    }
                    if (mlen > 2) {
                        /* Copy Token  */ d = LEN_LN_RE[mlen];
                        if (d <= 22) bl = write_bits_8(out, bl, bitswap8[d + 1] >> 1) - 1;
                        else {
                            write_bits_8(out, bl, 3);
                            bl += 5;
                            write_bits_8(out, bl, bitswap8[d - 23] >> 5);
                            bl += 3;
                        }
                        var len_eb = d < 8 ? 0 : d - 4 >> 2;
                        if (len_eb > 0) {
                            write_bits_16(out, bl, mlen - LEN_LN[d]);
                            bl += len_eb;
                        }
                        d = DST_LN_RE[boff - match];
                        bl = write_bits_8(out, bl, bitswap8[d] >> 3);
                        bl -= 3;
                        var dst_eb = d < 4 ? 0 : d - 2 >> 1;
                        if (dst_eb > 0) {
                            write_bits_16(out, bl, boff - match - DST_LN[d]);
                            bl += dst_eb;
                        }
                        for(var q = 0; q < mlen; ++q){
                            addrs[hash] = boff & 0x7FFF;
                            hash = (hash << 5 ^ data[boff]) & 0x7FFF;
                            ++boff;
                        }
                        L -= mlen - 1;
                    } else {
                        /* Literal Token */ if (d <= 143) d = d + 48;
                        else bl = write_bits_1(out, bl, 1);
                        bl = write_bits_8(out, bl, bitswap8[d]);
                        addrs[hash] = boff & 0x7FFF;
                        ++boff;
                    }
                }
                bl = write_bits_8(out, bl, 0) - 1;
            }
            out.l = (bl + 7) / 8 | 0;
            return out.l;
        }
        return function _deflateRaw(data, out) {
            if (data.length < 8) return write_stored(data, out);
            return write_huff_fixed(data, out);
        };
    }();
    function _deflate(data) {
        var buf = $3ee4f50b1ae43a89$var$new_buf(50 + Math.floor(data.length * 1.1));
        var off = _deflateRaw(data, buf);
        return buf.slice(0, off);
    }
    /* modified inflate function also moves original read head */ var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_cmap = use_typed_arrays ? new Uint16Array(128) : zero_fill_array(128);
    var dyn_len_1 = 1, dyn_len_2 = 1;
    /* 5.5.3 Expanding Huffman Codes */ function dyn(data, boff /*:number*/ ) {
        /* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */ var _HLIT = read_bits_5(data, boff) + 257;
        boff += 5;
        var _HDIST = read_bits_5(data, boff) + 1;
        boff += 5;
        var _HCLEN = read_bits_4(data, boff) + 4;
        boff += 4;
        var w = 0;
        /* grab and store code lengths */ var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
        var ctree = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var maxlen = 1;
        var bl_count = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var L = clens.length; /* 19 */ 
        for(var i = 0; i < _HCLEN; ++i){
            clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
            if (maxlen < w) maxlen = w;
            bl_count[w]++;
            boff += 3;
        }
        /* build code tree */ var ccode = 0;
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)next_code[i] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i)if ((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
        /* cmap[7 bits from stream] = (off&7) + (lit<<3) */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bitswap8[ctree[i]] >> 8 - cleni;
                for(var j = (1 << 7 - cleni) - 1; j >= 0; --j)dyn_cmap[ccode | j << cleni] = cleni & 7 | i << 3;
            }
        }
        /* read literal and dist codes at once */ var hcodes /*:Array<number>*/  = [];
        maxlen = 1;
        for(; hcodes.length < _HLIT + _HDIST;){
            ccode = dyn_cmap[read_bits_7(data, boff)];
            boff += ccode & 7;
            switch(ccode >>>= 3){
                case 16:
                    w = 3 + read_bits_2(data, boff);
                    boff += 2;
                    ccode = hcodes[hcodes.length - 1];
                    while(w-- > 0)hcodes.push(ccode);
                    break;
                case 17:
                    w = 3 + read_bits_3(data, boff);
                    boff += 3;
                    while(w-- > 0)hcodes.push(0);
                    break;
                case 18:
                    w = 11 + read_bits_7(data, boff);
                    boff += 7;
                    while(w-- > 0)hcodes.push(0);
                    break;
                default:
                    hcodes.push(ccode);
                    if (maxlen < ccode) maxlen = ccode;
                    break;
            }
        }
        /* build literal / length trees */ var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
        for(i = _HLIT; i < 286; ++i)h1[i] = 0;
        for(i = _HDIST; i < 30; ++i)h2[i] = 0;
        dyn_len_1 = build_tree(h1, dyn_lmap, 286);
        dyn_len_2 = build_tree(h2, dyn_dmap, 30);
        return boff;
    }
    /* return [ data, bytesRead ] */ function inflate(data, usz /*:number*/ ) {
        /* shortcircuit for empty buffer [0x03, 0x00] */ if (data[0] == 3 && !(data[1] & 0x3)) return [
            $3ee4f50b1ae43a89$var$new_raw_buf(usz),
            2
        ];
        /* bit offset */ var boff = 0;
        /* header includes final bit and type bits */ var header = 0;
        var outbuf = $3ee4f50b1ae43a89$var$new_unsafe_buf(usz ? usz : 262144);
        var woff = 0;
        var OL = outbuf.length >>> 0;
        var max_len_1 = 0, max_len_2 = 0;
        while((header & 1) == 0){
            header = read_bits_3(data, boff);
            boff += 3;
            if (header >>> 1 == 0) {
                /* Stored block */ if (boff & 7) boff += 8 - (boff & 7);
                /* 2 bytes sz, 2 bytes bit inverse */ var sz = data[boff >>> 3] | data[(boff >>> 3) + 1] << 8;
                boff += 32;
                /* push sz bytes */ if (sz > 0) {
                    if (!usz && OL < woff + sz) {
                        outbuf = realloc(outbuf, woff + sz);
                        OL = outbuf.length;
                    }
                    while(sz-- > 0){
                        outbuf[woff++] = data[boff >>> 3];
                        boff += 8;
                    }
                }
                continue;
            } else if (header >> 1 == 1) {
                /* Fixed Huffman */ max_len_1 = 9;
                max_len_2 = 5;
            } else {
                /* Dynamic Huffman */ boff = dyn(data, boff);
                max_len_1 = dyn_len_1;
                max_len_2 = dyn_len_2;
            }
            for(;;){
                if (!usz && OL < woff + 32767) {
                    outbuf = realloc(outbuf, woff + 32767);
                    OL = outbuf.length;
                }
                /* ingest code and move read head */ var bits = read_bits_n(data, boff, max_len_1);
                var code = header >>> 1 == 1 ? fix_lmap[bits] : dyn_lmap[bits];
                boff += code & 15;
                code >>>= 4;
                /* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */ if ((code >>> 8 & 0xFF) === 0) outbuf[woff++] = code;
                else if (code == 256) break;
                else {
                    code -= 257;
                    var len_eb = code < 8 ? 0 : code - 4 >> 2;
                    if (len_eb > 5) len_eb = 0;
                    var tgt = woff + LEN_LN[code];
                    /* length extra bits */ if (len_eb > 0) {
                        tgt += read_bits_n(data, boff, len_eb);
                        boff += len_eb;
                    }
                    /* dist code */ bits = read_bits_n(data, boff, max_len_2);
                    code = header >>> 1 == 1 ? fix_dmap[bits] : dyn_dmap[bits];
                    boff += code & 15;
                    code >>>= 4;
                    var dst_eb = code < 4 ? 0 : code - 2 >> 1;
                    var dst = DST_LN[code];
                    /* dist extra bits */ if (dst_eb > 0) {
                        dst += read_bits_n(data, boff, dst_eb);
                        boff += dst_eb;
                    }
                    /* in the common case, manual byte copy is faster than TA set / Buffer copy */ if (!usz && OL < tgt) {
                        outbuf = realloc(outbuf, tgt + 100);
                        OL = outbuf.length;
                    }
                    while(woff < tgt){
                        outbuf[woff] = outbuf[woff - dst];
                        ++woff;
                    }
                }
            }
        }
        if (usz) return [
            outbuf,
            boff + 7 >>> 3
        ];
        return [
            outbuf.slice(0, woff),
            boff + 7 >>> 3
        ];
    }
    function _inflate(payload, usz) {
        var data = payload.slice(payload.l || 0);
        var out = inflate(data, usz);
        payload.l += out[1];
        return out[0];
    }
    function warn_or_throw(wrn, msg) {
        if (wrn) {
            if (typeof console !== "undefined") console.error(msg);
        } else throw new Error(msg);
    }
    function parse_zip(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        var blob /*:CFBlob*/  = /*::(*/ file /*:: :any)*/ ;
        $3ee4f50b1ae43a89$var$prep_blob(blob, 0);
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o, {
            root: options.root
        });
        /* find end of central directory, start just after signature */ var i = blob.length - 4;
        while((blob[i] != 0x50 || blob[i + 1] != 0x4b || blob[i + 2] != 0x05 || blob[i + 3] != 0x06) && i >= 0)--i;
        blob.l = i + 4;
        /* parse end of central directory */ blob.l += 4;
        var fcnt = blob.read_shift(2);
        blob.l += 6;
        var start_cd = blob.read_shift(4);
        /* parse central directory */ blob.l = start_cd;
        for(i = 0; i < fcnt; ++i){
            /* trust local file header instead of CD entry */ blob.l += 20;
            var csz = blob.read_shift(4);
            var usz = blob.read_shift(4);
            var namelen = blob.read_shift(2);
            var efsz = blob.read_shift(2);
            var fcsz = blob.read_shift(2);
            blob.l += 8;
            var offset = blob.read_shift(4);
            var EF = parse_extra_field(/*::(*/ blob.slice(blob.l + namelen, blob.l + namelen + efsz));
            blob.l += namelen + efsz + fcsz;
            var L = blob.l;
            blob.l = offset + 4;
            parse_local_file(blob, csz, usz, o, EF);
            blob.l = L;
        }
        return o;
    }
    /* head starts just after local file header signature */ function parse_local_file(blob /*:CFBlob*/ , csz /*:number*/ , usz /*:number*/ , o /*:CFBContainer*/ , EF) {
        /* [local file header] */ blob.l += 2;
        var flags = blob.read_shift(2);
        var meth = blob.read_shift(2);
        var date = parse_dos_date(blob);
        if (flags & 0x2041) throw new Error("Unsupported ZIP encryption");
        var crc32 = blob.read_shift(4);
        var _csz = blob.read_shift(4);
        var _usz = blob.read_shift(4);
        var namelen = blob.read_shift(2);
        var efsz = blob.read_shift(2);
        // TODO: flags & (1<<11) // UTF8
        var name = "";
        for(var i = 0; i < namelen; ++i)name += String.fromCharCode(blob[blob.l++]);
        if (efsz) {
            var ef = parse_extra_field(/*::(*/ blob.slice(blob.l, blob.l + efsz));
            if ((ef[0x5455] || {}).mt) date = ef[0x5455].mt;
            if (((EF || {})[0x5455] || {}).mt) date = EF[0x5455].mt;
        }
        blob.l += efsz;
        /* [encryption header] */ /* [file data] */ var data = blob.slice(blob.l, blob.l + _csz);
        switch(meth){
            case 8:
                data = _inflateRawSync(blob, _usz);
                break;
            case 0:
                break; // TODO: scan for magic number
            default:
                throw new Error("Unsupported ZIP Compression method " + meth);
        }
        /* [data descriptor] */ var wrn = false;
        if (flags & 8) {
            crc32 = blob.read_shift(4);
            if (crc32 == 0x08074b50) {
                crc32 = blob.read_shift(4);
                wrn = true;
            }
            _csz = blob.read_shift(4);
            _usz = blob.read_shift(4);
        }
        if (_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
        if (_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
        //var _crc32 = CRC32.buf(data, 0);
        //if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
        cfb_add(o, name, data, {
            unsafe: true,
            mt: date
        });
    }
    function write_zip(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes*/ {
        var _opts = options || {};
        var out = [], cdirs = [];
        var o /*:CFBlob*/  = $3ee4f50b1ae43a89$var$new_buf(1);
        var method = _opts.compression ? 8 : 0, flags = 0;
        var desc = false;
        if (desc) flags |= 8;
        var i = 0, j = 0;
        var start_cd = 0, fcnt = 0;
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        var crcs = [];
        var sz_cd = 0;
        for(i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\x01Sh33tJ5") continue;
            var start = start_cd;
            /* TODO: CP437 filename */ var namebuf = $3ee4f50b1ae43a89$var$new_buf(fp.length);
            for(j = 0; j < fp.length; ++j)namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
            namebuf = namebuf.slice(0, namebuf.l);
            crcs[fcnt] = $3ee4f50b1ae43a89$var$CRC32.buf(/*::((*/ fi.content /*::||[]):any)*/ , 0);
            var outbuf = fi.content /*::||[]*/ ;
            if (method == 8) outbuf = _deflateRawSync(outbuf);
            /* local file header */ o = $3ee4f50b1ae43a89$var$new_buf(30);
            o.write_shift(4, 0x04034b50);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            /* TODO: last mod file time/date */ if (fi.mt) write_dos_date(o, fi.mt);
            else o.write_shift(4, 0);
            o.write_shift(-4, flags & 8 ? 0 : crcs[fcnt]);
            o.write_shift(4, flags & 8 ? 0 : outbuf.length);
            o.write_shift(4, flags & 8 ? 0 : /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            start_cd += o.length;
            out.push(o);
            start_cd += namebuf.length;
            out.push(namebuf);
            /* TODO: extra fields? */ /* TODO: encryption header ? */ start_cd += outbuf.length;
            out.push(outbuf);
            /* data descriptor */ if (flags & 8) {
                o = $3ee4f50b1ae43a89$var$new_buf(12);
                o.write_shift(-4, crcs[fcnt]);
                o.write_shift(4, outbuf.length);
                o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
                start_cd += o.l;
                out.push(o);
            }
            /* central directory */ o = $3ee4f50b1ae43a89$var$new_buf(46);
            o.write_shift(4, 0x02014b50);
            o.write_shift(2, 0);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            o.write_shift(4, 0); /* TODO: last mod file time/date */ 
            o.write_shift(-4, crcs[fcnt]);
            o.write_shift(4, outbuf.length);
            o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(4, 0);
            o.write_shift(4, start);
            sz_cd += o.l;
            cdirs.push(o);
            sz_cd += namebuf.length;
            cdirs.push(namebuf);
            ++fcnt;
        }
        /* end of central directory */ o = $3ee4f50b1ae43a89$var$new_buf(22);
        o.write_shift(4, 0x06054b50);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, fcnt);
        o.write_shift(2, fcnt);
        o.write_shift(4, sz_cd);
        o.write_shift(4, start_cd);
        o.write_shift(2, 0);
        return $3ee4f50b1ae43a89$var$bconcat([
            $3ee4f50b1ae43a89$var$bconcat(out /*:any*/ ),
            $3ee4f50b1ae43a89$var$bconcat(cdirs),
            o
        ]);
    }
    var ContentTypeMap = {
        "htm": "text/html",
        "xml": "text/xml",
        "gif": "image/gif",
        "jpg": "image/jpeg",
        "png": "image/png",
        "mso": "application/x-mso",
        "thmx": "application/vnd.ms-officetheme",
        "sh33tj5": "application/octet-stream"
    } /*:any*/ ;
    function get_content_type(fi /*:CFBEntry*/ , fp /*:string*/ ) /*:string*/ {
        if (fi.ctype) return fi.ctype;
        var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
        if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        if (fp) {
            m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
            if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        }
        return "application/octet-stream";
    }
    /* 76 character chunks TODO: intertwine encoding */ function write_base64_76(bstr /*:string*/ ) /*:string*/ {
        var data = $3ee4f50b1ae43a89$var$Base64_encode(bstr);
        var o = [];
        for(var i = 0; i < data.length; i += 76)o.push(data.slice(i, i + 76));
        return o.join("\r\n") + "\r\n";
    }
    /*
Rules for QP:
	- escape =## applies for all non-display characters and literal "="
	- space or tab at end of line must be encoded
	- \r\n newlines can be preserved, but bare \r and \n must be escaped
	- lines must not exceed 76 characters, use soft breaks =\r\n

TODO: Some files from word appear to write line extensions with bare equals:

```
<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
="70%"
```
*/ function write_quoted_printable(text /*:string*/ ) /*:string*/ {
        var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
            var w = c.charCodeAt(0).toString(16).toUpperCase();
            return "=" + (w.length == 1 ? "0" + w : w);
        });
        encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");
        if (encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
        encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");
        var o /*:Array<string>*/  = [], split = encoded.split("\r\n");
        for(var si = 0; si < split.length; ++si){
            var str = split[si];
            if (str.length == 0) {
                o.push("");
                continue;
            }
            for(var i = 0; i < str.length;){
                var end = 76;
                var tmp = str.slice(i, i + end);
                if (tmp.charAt(end - 1) == "=") end--;
                else if (tmp.charAt(end - 2) == "=") end -= 2;
                else if (tmp.charAt(end - 3) == "=") end -= 3;
                tmp = str.slice(i, i + end);
                i += end;
                if (i < str.length) tmp += "=";
                o.push(tmp);
            }
        }
        return o.join("\r\n");
    }
    function parse_quoted_printable(data /*:Array<string>*/ ) /*:RawBytes*/ {
        var o = [];
        /* unify long lines */ for(var di = 0; di < data.length; ++di){
            var line = data[di];
            while(di <= data.length && line.charAt(line.length - 1) == "=")line = line.slice(0, line.length - 1) + data[++di];
            o.push(line);
        }
        /* decode */ for(var oi = 0; oi < o.length; ++oi)o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) {
            return String.fromCharCode(parseInt($$.slice(1), 16));
        });
        return $3ee4f50b1ae43a89$var$s2a(o.join("\r\n"));
    }
    function parse_mime(cfb /*:CFBContainer*/ , data /*:Array<string>*/ , root /*:string*/ ) /*:void*/ {
        var fname = "", cte = "", ctype = "", fdata;
        var di = 0;
        for(; di < 10; ++di){
            var line = data[di];
            if (!line || line.match(/^\s*$/)) break;
            var m = line.match(/^(.*?):\s*([^\s].*)$/);
            if (m) switch(m[1].toLowerCase()){
                case "content-location":
                    fname = m[2].trim();
                    break;
                case "content-type":
                    ctype = m[2].trim();
                    break;
                case "content-transfer-encoding":
                    cte = m[2].trim();
                    break;
            }
        }
        ++di;
        switch(cte.toLowerCase()){
            case "base64":
                fdata = $3ee4f50b1ae43a89$var$s2a($3ee4f50b1ae43a89$var$Base64_decode(data.slice(di).join("")));
                break;
            case "quoted-printable":
                fdata = parse_quoted_printable(data.slice(di));
                break;
            default:
                throw new Error("Unsupported Content-Transfer-Encoding " + cte);
        }
        var file = cfb_add(cfb, fname.slice(root.length), fdata, {
            unsafe: true
        });
        if (ctype) file.ctype = ctype;
    }
    function parse_mad(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (a2s(file.slice(0, 13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
        var root = options && options.root || "";
        // $FlowIgnore
        var data = ($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
        var di = 0, row = "";
        /* if root is not specified, scan for the common prefix */ for(di = 0; di < data.length; ++di){
            row = data[di];
            if (!/^Content-Location:/i.test(row)) continue;
            row = row.slice(row.indexOf("file"));
            if (!root) root = row.slice(0, row.lastIndexOf("/") + 1);
            if (row.slice(0, root.length) == root) continue;
            while(root.length > 0){
                root = root.slice(0, root.length - 1);
                root = root.slice(0, root.lastIndexOf("/") + 1);
                if (row.slice(0, root.length) == root) break;
            }
        }
        var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
        if (!mboundary) throw new Error("MAD cannot find boundary");
        var boundary = "--" + (mboundary[1] || "");
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o);
        var start_di, fcnt = 0;
        for(di = 0; di < data.length; ++di){
            var line = data[di];
            if (line !== boundary && line !== boundary + "--") continue;
            if (fcnt++) parse_mime(o, data.slice(start_di, di), root);
            start_di = di;
        }
        return o;
    }
    function write_mad(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:string*/ {
        var opts = options || {};
        var boundary = opts.boundary || "SheetJS";
        boundary = "------=" + boundary;
        var out = [
            "MIME-Version: 1.0",
            'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
            "",
            "",
            ""
        ];
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        for(var i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\x01Sh33tJ5") continue;
            /* Normalize filename */ fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
                return "_x" + c.charCodeAt(0).toString(16) + "_";
            }).replace(/[\u0080-\uFFFF]/g, function(u) {
                return "_u" + u.charCodeAt(0).toString(16) + "_";
            });
            /* Extract content as binary string */ var ca = fi.content;
            // $FlowIgnore
            var cstr = $3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);
            /* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */ var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
            for(var csl = 0; csl <= L; ++csl)if ((cc = cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
            var qp = dispcnt >= L * 4 / 5;
            out.push(boundary);
            out.push("Content-Location: " + (opts.root || "file:///C:/SheetJS/") + fp);
            out.push("Content-Transfer-Encoding: " + (qp ? "quoted-printable" : "base64"));
            out.push("Content-Type: " + get_content_type(fi, fp));
            out.push("");
            out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
        }
        out.push(boundary + "--\r\n");
        return out.join("\r\n");
    }
    function cfb_new(opts /*:?any*/ ) /*:CFBContainer*/ {
        var o /*:CFBContainer*/  = {} /*:any*/ ;
        init_cfb(o, opts);
        return o;
    }
    function cfb_add(cfb /*:CFBContainer*/ , name /*:string*/ , content /*:?RawBytes*/ , opts /*:?any*/ ) /*:CFBEntry*/ {
        var unsafe = opts && opts.unsafe;
        if (!unsafe) init_cfb(cfb);
        var file = !unsafe && $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, name);
        if (!file) {
            var fpath /*:string*/  = cfb.FullPaths[0];
            if (name.slice(0, fpath.length) == fpath) fpath = name;
            else {
                if (fpath.slice(-1) != "/") fpath += "/";
                fpath = (fpath + name).replace("//", "/");
            }
            file = {
                name: filename(name),
                type: 2
            } /*:any*/ ;
            cfb.FileIndex.push(file);
            cfb.FullPaths.push(fpath);
            if (!unsafe) $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_gc(cfb);
        }
        /*:: if(!file) throw new Error("unreachable"); */ file.content = content /*:any*/ ;
        file.size = content ? content.length : 0;
        if (opts) {
            if (opts.CLSID) file.clsid = opts.CLSID;
            if (opts.mt) file.mt = opts.mt;
            if (opts.ct) file.ct = opts.ct;
        }
        return file;
    }
    function cfb_del(cfb /*:CFBContainer*/ , name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex.splice(j, 1);
                cfb.FullPaths.splice(j, 1);
                return true;
            }
        }
        return false;
    }
    function cfb_mov(cfb /*:CFBContainer*/ , old_name /*:string*/ , new_name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, old_name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex[j].name = filename(new_name);
                cfb.FullPaths[j] = new_name;
                return true;
            }
        }
        return false;
    }
    function cfb_gc(cfb /*:CFBContainer*/ ) /*:void*/ {
        rebuild_cfb(cfb, true);
    }
    exports.find = find;
    exports.read = read;
    exports.parse = parse;
    exports.write = write;
    exports.writeFile = write_file;
    exports.utils = {
        cfb_new: cfb_new,
        cfb_add: cfb_add,
        cfb_del: cfb_del,
        cfb_mov: cfb_mov,
        cfb_gc: cfb_gc,
        ReadShift: $3ee4f50b1ae43a89$var$ReadShift,
        CheckField: $3ee4f50b1ae43a89$var$CheckField,
        prep_blob: $3ee4f50b1ae43a89$var$prep_blob,
        bconcat: $3ee4f50b1ae43a89$var$bconcat,
        use_zlib: use_zlib,
        _deflateRaw: _deflate,
        _inflateRaw: _inflate,
        consts: consts
    };
    return exports;
}();
let $3ee4f50b1ae43a89$var$_fs = void 0;
function $3ee4f50b1ae43a89$export$a48eb669e1768bcf(fs) {
    $3ee4f50b1ae43a89$var$_fs = fs;
}
/* normalize data for blob ctor */ function $3ee4f50b1ae43a89$var$blobify(data) {
    if (typeof data === "string") return $3ee4f50b1ae43a89$var$s2ab(data);
    if (Array.isArray(data)) return $3ee4f50b1ae43a89$var$a2u(data);
    return data;
}
/* write or download file */ function $3ee4f50b1ae43a89$var$write_dl(fname /*:string*/ , payload /*:any*/ , enc /*:?string*/ ) {
    /*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */ if (typeof $3ee4f50b1ae43a89$var$_fs !== "undefined" && $3ee4f50b1ae43a89$var$_fs.writeFileSync) return enc ? $3ee4f50b1ae43a89$var$_fs.writeFileSync(fname, payload, enc) : $3ee4f50b1ae43a89$var$_fs.writeFileSync(fname, payload);
    if (typeof Deno !== "undefined") {
        /* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */ if (enc && typeof payload == "string") switch(enc){
            case "utf8":
                payload = new TextEncoder(enc).encode(payload);
                break;
            case "binary":
                payload = $3ee4f50b1ae43a89$var$s2ab(payload);
                break;
            /* TODO: binary equivalent */ default:
                throw new Error("Unsupported encoding " + enc);
        }
        return Deno.writeFileSync(fname, payload);
    }
    var data = enc == "utf8" ? $3ee4f50b1ae43a89$var$utf8write(payload) : payload;
    /*:: declare var IE_SaveFile: any; */ if (typeof IE_SaveFile !== "undefined") return IE_SaveFile(data, fname);
    if (typeof Blob !== "undefined") {
        var blob = new Blob([
            $3ee4f50b1ae43a89$var$blobify(data)
        ], {
            type: "application/octet-stream"
        });
        /*:: declare var navigator: any; */ if (typeof navigator !== "undefined" && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
        /*:: declare var saveAs: any; */ if (typeof saveAs !== "undefined") return saveAs(blob, fname);
        if (typeof URL !== "undefined" && typeof document !== "undefined" && document.createElement && URL.createObjectURL) {
            var url = URL.createObjectURL(blob);
            /*:: declare var chrome: any; */ if (typeof chrome === "object" && typeof (chrome.downloads || {}).download == "function") {
                if (URL.revokeObjectURL && typeof setTimeout !== "undefined") setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return chrome.downloads.download({
                    url: url,
                    filename: fname,
                    saveAs: true
                });
            }
            var a = document.createElement("a");
            if (a.download != null) {
                /*:: if(document.body == null) throw new Error("unreachable"); */ a.download = fname;
                a.href = url;
                document.body.appendChild(a);
                a.click();
                /*:: if(document.body == null) throw new Error("unreachable"); */ document.body.removeChild(a);
                if (URL.revokeObjectURL && typeof setTimeout !== "undefined") setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return url;
            }
        }
    }
    // $FlowIgnore
    if (typeof $ !== "undefined" && typeof File !== "undefined" && typeof Folder !== "undefined") try {
        // $FlowIgnore
        var out = File(fname);
        out.open("w");
        out.encoding = "binary";
        if (Array.isArray(payload)) payload = $3ee4f50b1ae43a89$var$a2s(payload);
        out.write(payload);
        out.close();
        return payload;
    } catch (e) {
        if (!e.message || !e.message.match(/onstruct/)) throw e;
    }
    throw new Error("cannot save file " + fname);
}
/* read binary data from file */ function $3ee4f50b1ae43a89$var$read_binary(path /*:string*/ ) {
    if (typeof $3ee4f50b1ae43a89$var$_fs !== "undefined") return $3ee4f50b1ae43a89$var$_fs.readFileSync(path);
    if (typeof Deno !== "undefined") return Deno.readFileSync(path);
    // $FlowIgnore
    if (typeof $ !== "undefined" && typeof File !== "undefined" && typeof Folder !== "undefined") try {
        // $FlowIgnore
        var infile = File(path);
        infile.open("r");
        infile.encoding = "binary";
        var data = infile.read();
        infile.close();
        return data;
    } catch (e) {
        if (!e.message || !e.message.match(/onstruct/)) throw e;
    }
    throw new Error("Cannot access file " + path);
}
function $3ee4f50b1ae43a89$var$keys(o /*:any*/ ) /*:Array<any>*/ {
    var ks = Object.keys(o), o2 = [];
    for(var i = 0; i < ks.length; ++i)if (Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
    return o2;
}
function $3ee4f50b1ae43a89$var$evert_key(obj /*:any*/ , key /*:string*/ ) /*:EvertType*/ {
    var o = [], K = $3ee4f50b1ae43a89$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)if (o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
    return o;
}
function $3ee4f50b1ae43a89$var$evert(obj /*:any*/ ) /*:EvertType*/ {
    var o = [], K = $3ee4f50b1ae43a89$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = K[i];
    return o;
}
function $3ee4f50b1ae43a89$var$evert_num(obj /*:any*/ ) /*:EvertNumType*/ {
    var o = [], K = $3ee4f50b1ae43a89$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = parseInt(K[i], 10);
    return o;
}
function $3ee4f50b1ae43a89$var$evert_arr(obj /*:any*/ ) /*:EvertArrType*/ {
    var o /*:EvertArrType*/  = [], K = $3ee4f50b1ae43a89$var$keys(obj);
    for(var i = 0; i !== K.length; ++i){
        if (o[obj[K[i]]] == null) o[obj[K[i]]] = [];
        o[obj[K[i]]].push(K[i]);
    }
    return o;
}
var $3ee4f50b1ae43a89$var$basedate = /*#__PURE__*/ new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
function $3ee4f50b1ae43a89$var$datenum(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    if (date1904) epoch -= 126316800000;
    var dnthresh = /*#__PURE__*/ $3ee4f50b1ae43a89$var$basedate.getTime() + /*#__PURE__*/ (v.getTimezoneOffset() - /*#__PURE__*/ $3ee4f50b1ae43a89$var$basedate.getTimezoneOffset()) * 60000;
    return (epoch - dnthresh) / 86400000;
}
var $3ee4f50b1ae43a89$var$refdate = /*#__PURE__*/ new Date();
var $3ee4f50b1ae43a89$var$dnthresh = /*#__PURE__*/ $3ee4f50b1ae43a89$var$basedate.getTime() + /*#__PURE__*/ ($3ee4f50b1ae43a89$var$refdate.getTimezoneOffset() - /*#__PURE__*/ $3ee4f50b1ae43a89$var$basedate.getTimezoneOffset()) * 60000;
var $3ee4f50b1ae43a89$var$refoffset = /*#__PURE__*/ $3ee4f50b1ae43a89$var$refdate.getTimezoneOffset();
function $3ee4f50b1ae43a89$var$numdate(v /*:number*/ ) /*:Date*/ {
    var out = new Date();
    out.setTime(v * 86400000 + $3ee4f50b1ae43a89$var$dnthresh);
    if (out.getTimezoneOffset() !== $3ee4f50b1ae43a89$var$refoffset) out.setTime(out.getTime() + (out.getTimezoneOffset() - $3ee4f50b1ae43a89$var$refoffset) * 60000);
    return out;
}
/* ISO 8601 Duration */ function $3ee4f50b1ae43a89$var$parse_isodur(s) {
    var sec = 0, mt = 0, time = false;
    var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
    if (!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
    for(var i = 1; i != m.length; ++i){
        if (!m[i]) continue;
        mt = 1;
        if (i > 3) time = true;
        switch(m[i].slice(m[i].length - 1)){
            case "Y":
                throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length - 1));
            case "D":
                mt *= 24;
            /* falls through */ case "H":
                mt *= 60;
            /* falls through */ case "M":
                if (!time) throw new Error("Unsupported ISO Duration Field: M");
                else mt *= 60;
            /* falls through */ case "S":
                break;
        }
        sec += mt * parseInt(m[i], 10);
    }
    return sec;
}
var $3ee4f50b1ae43a89$var$good_pd_date_1 = /*#__PURE__*/ new Date("2017-02-19T19:06:09.000Z");
var $3ee4f50b1ae43a89$var$good_pd_date = /*#__PURE__*/ isNaN(/*#__PURE__*/ $3ee4f50b1ae43a89$var$good_pd_date_1.getFullYear()) ? /*#__PURE__*/ new Date("2/19/17") : $3ee4f50b1ae43a89$var$good_pd_date_1;
var $3ee4f50b1ae43a89$var$good_pd = /*#__PURE__*/ $3ee4f50b1ae43a89$var$good_pd_date.getFullYear() == 2017;
/* parses a date as a local date */ function $3ee4f50b1ae43a89$var$parseDate(str /*:string|Date*/ , fixdate /*:?number*/ ) /*:Date*/ {
    var d = new Date(str);
    if ($3ee4f50b1ae43a89$var$good_pd) {
        /*:: if(fixdate == null) fixdate = 0; */ if (fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60000);
        else if (fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60000);
        return d;
    }
    if (str instanceof Date) return str;
    if ($3ee4f50b1ae43a89$var$good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
        var s = d.getFullYear();
        if (str.indexOf("" + s) > -1) return d;
        d.setFullYear(d.getFullYear() + 100);
        return d;
    }
    var n = str.match(/\d+/g) || [
        "2017",
        "2",
        "19",
        "0",
        "0",
        "0"
    ];
    var out = new Date(+n[0], +n[1] - 1, +n[2], +n[3] || 0, +n[4] || 0, +n[5] || 0);
    if (str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60000);
    return out;
}
function $3ee4f50b1ae43a89$var$cc2str(arr /*:Array<number>*/ , debomit) /*:string*/ {
    if ($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(arr)) {
        if (debomit) {
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $3ee4f50b1ae43a89$var$utf8write(arr.slice(2).toString("utf16le"));
            if (arr[1] == 0xFE && arr[2] == 0xFF) return $3ee4f50b1ae43a89$var$utf8write($3ee4f50b1ae43a89$var$utf16beread(arr.slice(2).toString("binary")));
        }
        return arr.toString("binary");
    }
    if (typeof TextDecoder !== "undefined") try {
        if (debomit) {
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $3ee4f50b1ae43a89$var$utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
            if (arr[0] == 0xFE && arr[1] == 0xFF) return $3ee4f50b1ae43a89$var$utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
        }
        var rev = {
            "\u20AC": "\x80",
            "\u201A": "\x82",
            "\u0192": "\x83",
            "\u201E": "\x84",
            "\u2026": "\x85",
            "\u2020": "\x86",
            "\u2021": "\x87",
            "\u02C6": "\x88",
            "\u2030": "\x89",
            "\u0160": "\x8a",
            "\u2039": "\x8b",
            "\u0152": "\x8c",
            "\u017D": "\x8e",
            "\u2018": "\x91",
            "\u2019": "\x92",
            "\u201C": "\x93",
            "\u201D": "\x94",
            "\u2022": "\x95",
            "\u2013": "\x96",
            "\u2014": "\x97",
            "\u02DC": "\x98",
            "\u2122": "\x99",
            "\u0161": "\x9a",
            "\u203A": "\x9b",
            "\u0153": "\x9c",
            "\u017E": "\x9e",
            "\u0178": "\x9f"
        };
        if (Array.isArray(arr)) arr = new Uint8Array(arr);
        return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) {
            return rev[c] || c;
        });
    } catch (e) {}
    var o = [];
    for(var i = 0; i != arr.length; ++i)o.push(String.fromCharCode(arr[i]));
    return o.join("");
}
function $3ee4f50b1ae43a89$var$dup(o /*:any*/ ) /*:any*/ {
    if (typeof JSON != "undefined" && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
    if (typeof o != "object" || o == null) return o;
    if (o instanceof Date) return new Date(o.getTime());
    var out = {};
    for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = $3ee4f50b1ae43a89$var$dup(o[k]);
    return out;
}
function $3ee4f50b1ae43a89$var$fill(c /*:string*/ , l /*:number*/ ) /*:string*/ {
    var o = "";
    while(o.length < l)o += c;
    return o;
}
/* TODO: stress test */ function $3ee4f50b1ae43a89$var$fuzzynum(s /*:string*/ ) /*:number*/ {
    var v /*:number*/  = Number(s);
    if (!isNaN(v)) return isFinite(v) ? v : NaN;
    if (!/\d/.test(s)) return v;
    var wt = 1;
    var ss = s.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
        wt *= 100;
        return "";
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    ss = ss.replace(/[(](.*)[)]/, function($$, $1) {
        wt = -wt;
        return $1;
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    return v;
}
var $3ee4f50b1ae43a89$var$lower_months = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december"
];
function $3ee4f50b1ae43a89$var$fuzzydate(s /*:string*/ ) /*:Date*/ {
    var o = new Date(s), n = new Date(NaN);
    var y = o.getYear(), m = o.getMonth(), d = o.getDate();
    if (isNaN(d)) return n;
    var lower = s.toLowerCase();
    if (lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
        lower = lower.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, "");
        if (lower.length > 3 && $3ee4f50b1ae43a89$var$lower_months.indexOf(lower) == -1) return n;
    } else if (lower.match(/[a-z]/)) return n;
    if (y < 0 || y > 8099) return n;
    if ((m > 0 || d > 1) && y != 101) return o;
    if (s.match(/[^-0-9:,\/\\]/)) return n;
    return o;
}
var $3ee4f50b1ae43a89$var$split_regex = /*#__PURE__*/ function() {
    var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
    return function split_regex(str /*:string*/ , re, def /*:string*/ ) /*:Array<string>*/ {
        if (safe_split_regex || typeof re == "string") return str.split(re);
        var p = str.split(re), o = [
            p[0]
        ];
        for(var i = 1; i < p.length; ++i){
            o.push(def);
            o.push(p[i]);
        }
        return o;
    };
}();
function $3ee4f50b1ae43a89$var$getdatastr(data) /*:?string*/ {
    if (!data) return null;
    if (data.content && data.type) return $3ee4f50b1ae43a89$var$cc2str(data.content, true);
    if (data.data) return $3ee4f50b1ae43a89$var$debom(data.data);
    if (data.asNodeBuffer && $3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$var$debom(data.asNodeBuffer().toString("binary"));
    if (data.asBinary) return $3ee4f50b1ae43a89$var$debom(data.asBinary());
    if (data._data && data._data.getContent) return $3ee4f50b1ae43a89$var$debom($3ee4f50b1ae43a89$var$cc2str(Array.prototype.slice.call(data._data.getContent(), 0)));
    return null;
}
function $3ee4f50b1ae43a89$var$getdatabin(data) {
    if (!data) return null;
    if (data.data) return $3ee4f50b1ae43a89$var$char_codes(data.data);
    if (data.asNodeBuffer && $3ee4f50b1ae43a89$var$has_buf) return data.asNodeBuffer();
    if (data._data && data._data.getContent) {
        var o = data._data.getContent();
        if (typeof o == "string") return $3ee4f50b1ae43a89$var$char_codes(o);
        return Array.prototype.slice.call(o);
    }
    if (data.content && data.type) return data.content;
    return null;
}
function $3ee4f50b1ae43a89$var$getdata(data) {
    return data && data.name.slice(-4) === ".bin" ? $3ee4f50b1ae43a89$var$getdatabin(data) : $3ee4f50b1ae43a89$var$getdatastr(data);
}
/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */ /* OASIS does not comment on filename case sensitivity */ function $3ee4f50b1ae43a89$var$safegetzipfile(zip, file /*:string*/ ) {
    var k = zip.FullPaths || $3ee4f50b1ae43a89$var$keys(zip.files);
    var f = file.toLowerCase().replace(/[\/]/g, "\\"), g = f.replace(/\\/g, "/");
    for(var i = 0; i < k.length; ++i){
        var n = k[i].replace(/^Root Entry[\/]/, "").toLowerCase();
        if (f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
    }
    return null;
}
function $3ee4f50b1ae43a89$var$getzipfile(zip, file /*:string*/ ) {
    var o = $3ee4f50b1ae43a89$var$safegetzipfile(zip, file);
    if (o == null) throw new Error("Cannot find file " + file + " in zip");
    return o;
}
function $3ee4f50b1ae43a89$var$getzipdata(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $3ee4f50b1ae43a89$var$getdata($3ee4f50b1ae43a89$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $3ee4f50b1ae43a89$var$getzipdata(zip, file);
    } catch (e) {
        return null;
    }
}
function $3ee4f50b1ae43a89$var$getzipstr(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:?string*/ {
    if (!safe) return $3ee4f50b1ae43a89$var$getdatastr($3ee4f50b1ae43a89$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $3ee4f50b1ae43a89$var$getzipstr(zip, file);
    } catch (e) {
        return null;
    }
}
function $3ee4f50b1ae43a89$var$getzipbin(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $3ee4f50b1ae43a89$var$getdatabin($3ee4f50b1ae43a89$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $3ee4f50b1ae43a89$var$getzipbin(zip, file);
    } catch (e) {
        return null;
    }
}
function $3ee4f50b1ae43a89$var$zipentries(zip) {
    var k = zip.FullPaths || $3ee4f50b1ae43a89$var$keys(zip.files), o = [];
    for(var i = 0; i < k.length; ++i)if (k[i].slice(-1) != "/") o.push(k[i].replace(/^Root Entry[\/]/, ""));
    return o.sort();
}
function $3ee4f50b1ae43a89$var$zip_add_file(zip, path, content) {
    if (zip.FullPaths) {
        if (typeof content == "string") {
            var res;
            if ($3ee4f50b1ae43a89$var$has_buf) res = $3ee4f50b1ae43a89$var$Buffer_from(content);
            else res = $3ee4f50b1ae43a89$var$utf8decode(content);
            return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(zip, path, res);
        }
        $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(zip, path, content);
    } else zip.file(path, content);
}
function $3ee4f50b1ae43a89$var$zip_new() {
    return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_new();
}
function $3ee4f50b1ae43a89$var$zip_read(d, o) {
    switch(o.type){
        case "base64":
            return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.read(d, {
                type: "base64"
            });
        case "binary":
            return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.read(d, {
                type: "binary"
            });
        case "buffer":
        case "array":
            return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.read(d, {
                type: "buffer"
            });
    }
    throw new Error("Unrecognized type " + o.type);
}
function $3ee4f50b1ae43a89$var$resolve_path(path /*:string*/ , base /*:string*/ ) /*:string*/ {
    if (path.charAt(0) == "/") return path.slice(1);
    var result = base.split("/");
    if (base.slice(-1) != "/") result.pop(); // folder path
    var target = path.split("/");
    while(target.length !== 0){
        var step = target.shift();
        if (step === "..") result.pop();
        else if (step !== ".") result.push(step);
    }
    return result.join("/");
}
var $3ee4f50b1ae43a89$var$XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var $3ee4f50b1ae43a89$var$attregexg = /([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var $3ee4f50b1ae43a89$var$tagregex1 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, $3ee4f50b1ae43a89$var$tagregex2 = /<[^>]*>/g;
var $3ee4f50b1ae43a89$var$tagregex = /*#__PURE__*/ $3ee4f50b1ae43a89$var$XML_HEADER.match($3ee4f50b1ae43a89$var$tagregex1) ? $3ee4f50b1ae43a89$var$tagregex1 : $3ee4f50b1ae43a89$var$tagregex2;
var $3ee4f50b1ae43a89$var$nsregex = /<\w*:/, $3ee4f50b1ae43a89$var$nsregex2 = /<(\/?)\w+:/;
function $3ee4f50b1ae43a89$var$parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($3ee4f50b1ae43a89$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i];
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        for(j = 0; j != q.length; ++j)if (q.charCodeAt(j) === 58) break;
        if (j === q.length) {
            if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
            z[q] = v;
            if (!skip_LC) z[q.toLowerCase()] = v;
        } else {
            var k = (j === 5 && q.slice(0, 5) === "xmlns" ? "xmlns" : "") + q.slice(j + 1);
            if (z[k] && q.slice(j - 3, j) == "ext") continue; // from ods
            z[k] = v;
            if (!skip_LC) z[k.toLowerCase()] = v;
        }
    }
    return z;
}
function $3ee4f50b1ae43a89$var$strip_ns(x /*:string*/ ) /*:string*/ {
    return x.replace($3ee4f50b1ae43a89$var$nsregex2, "<$1");
}
var $3ee4f50b1ae43a89$var$encodings = {
    "&quot;": '"',
    "&apos;": "'",
    "&gt;": ">",
    "&lt;": "<",
    "&amp;": "&"
};
var $3ee4f50b1ae43a89$var$rencoding = /*#__PURE__*/ $3ee4f50b1ae43a89$var$evert($3ee4f50b1ae43a89$var$encodings);
//var rencstr = "&<>'\"".split("");
// TODO: CP remap (need to read file version to determine OS)
var $3ee4f50b1ae43a89$var$unescapexml /*:StringConv*/  = /*#__PURE__*/ function() {
    /* 22.4.2.4 bstr (Basic String) */ var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
    return function unescapexml(text /*:string*/ ) /*:string*/ {
        var s = text + "", i = s.indexOf("<![CDATA[");
        if (i == -1) return s.replace(encregex, function($$, $1) {
            return $3ee4f50b1ae43a89$var$encodings[$$] || String.fromCharCode(parseInt($1, $$.indexOf("x") > -1 ? 16 : 10)) || $$;
        }).replace(coderegex, function(m, c) {
            return String.fromCharCode(parseInt(c, 16));
        });
        var j = s.indexOf("]]>");
        return unescapexml(s.slice(0, i)) + s.slice(i + 9, j) + unescapexml(s.slice(j + 3));
    };
}();
var $3ee4f50b1ae43a89$var$decregex = /[&<>'"]/g, $3ee4f50b1ae43a89$var$charegex = /[\u0000-\u0008\u000b-\u001f]/g;
function $3ee4f50b1ae43a89$var$escapexml(text /*:string*/ ) /*:string*/ {
    var s = text + "";
    return s.replace($3ee4f50b1ae43a89$var$decregex, function(y) {
        return $3ee4f50b1ae43a89$var$rencoding[y];
    }).replace($3ee4f50b1ae43a89$var$charegex, function(s) {
        return "_x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + "_";
    });
}
function $3ee4f50b1ae43a89$var$escapexmltag(text /*:string*/ ) /*:string*/ {
    return $3ee4f50b1ae43a89$var$escapexml(text).replace(/ /g, "_x0020_");
}
var $3ee4f50b1ae43a89$var$htmlcharegex = /[\u0000-\u001f]/g;
function $3ee4f50b1ae43a89$var$escapehtml(text /*:string*/ ) /*:string*/ {
    var s = text + "";
    return s.replace($3ee4f50b1ae43a89$var$decregex, function(y) {
        return $3ee4f50b1ae43a89$var$rencoding[y];
    }).replace(/\n/g, "<br/>").replace($3ee4f50b1ae43a89$var$htmlcharegex, function(s) {
        return "&#x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + ";";
    });
}
function $3ee4f50b1ae43a89$var$escapexlml(text /*:string*/ ) /*:string*/ {
    var s = text + "";
    return s.replace($3ee4f50b1ae43a89$var$decregex, function(y) {
        return $3ee4f50b1ae43a89$var$rencoding[y];
    }).replace($3ee4f50b1ae43a89$var$htmlcharegex, function(s) {
        return "&#x" + s.charCodeAt(0).toString(16).toUpperCase() + ";";
    });
}
/* TODO: handle codepages */ var $3ee4f50b1ae43a89$var$xlml_fixstr /*:StringConv*/  = /*#__PURE__*/ function() {
    var entregex = /&#(\d+);/g;
    function entrepl($$ /*:string*/ , $1 /*:string*/ ) /*:string*/ {
        return String.fromCharCode(parseInt($1, 10));
    }
    return function xlml_fixstr(str /*:string*/ ) /*:string*/ {
        return str.replace(entregex, entrepl);
    };
}();
function $3ee4f50b1ae43a89$var$xlml_unfixstr(str /*:string*/ ) /*:string*/ {
    return str.replace(/(\r\n|[\r\n])/g, "&#10;");
}
function $3ee4f50b1ae43a89$var$parsexmlbool(value /*:any*/ ) /*:boolean*/ {
    switch(value){
        case 1:
        case true:
        case "1":
        case "true":
        case "TRUE":
            return true;
        /* case '0': case 'false': case 'FALSE':*/ default:
            return false;
    }
}
function $3ee4f50b1ae43a89$var$utf8reada(orig /*:string*/ ) /*:string*/ {
    var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        if (c < 128) {
            out += String.fromCharCode(c);
            continue;
        }
        d = orig.charCodeAt(i++);
        if (c > 191 && c < 224) {
            f = (c & 31) << 6;
            f |= d & 63;
            out += String.fromCharCode(f);
            continue;
        }
        e = orig.charCodeAt(i++);
        if (c < 240) {
            out += String.fromCharCode((c & 15) << 12 | (d & 63) << 6 | e & 63);
            continue;
        }
        f = orig.charCodeAt(i++);
        w = ((c & 7) << 18 | (d & 63) << 12 | (e & 63) << 6 | f & 63) - 65536;
        out += String.fromCharCode(0xD800 + (w >>> 10 & 1023));
        out += String.fromCharCode(0xDC00 + (w & 1023));
    }
    return out;
}
function $3ee4f50b1ae43a89$var$utf8readb(data) {
    var out = $3ee4f50b1ae43a89$var$new_raw_buf(2 * data.length), w, i, j = 1, k = 0, ww = 0, c;
    for(i = 0; i < data.length; i += j){
        j = 1;
        if ((c = data.charCodeAt(i)) < 128) w = c;
        else if (c < 224) {
            w = (c & 31) * 64 + (data.charCodeAt(i + 1) & 63);
            j = 2;
        } else if (c < 240) {
            w = (c & 15) * 4096 + (data.charCodeAt(i + 1) & 63) * 64 + (data.charCodeAt(i + 2) & 63);
            j = 3;
        } else {
            j = 4;
            w = (c & 7) * 262144 + (data.charCodeAt(i + 1) & 63) * 4096 + (data.charCodeAt(i + 2) & 63) * 64 + (data.charCodeAt(i + 3) & 63);
            w -= 65536;
            ww = 0xD800 + (w >>> 10 & 1023);
            w = 0xDC00 + (w & 1023);
        }
        if (ww !== 0) {
            out[k++] = ww & 255;
            out[k++] = ww >>> 8;
            ww = 0;
        }
        out[k++] = w % 256;
        out[k++] = w >>> 8;
    }
    return out.slice(0, k).toString("ucs2");
}
function $3ee4f50b1ae43a89$var$utf8readc(data) {
    return $3ee4f50b1ae43a89$var$Buffer_from(data, "binary").toString("utf8");
}
var $3ee4f50b1ae43a89$var$utf8corpus = "foo bar baz\xe2\x98\x83\xf0\x9f\x8d\xa3";
var $3ee4f50b1ae43a89$var$utf8read = $3ee4f50b1ae43a89$var$has_buf && /*#__PURE__*/ ($3ee4f50b1ae43a89$var$utf8readc($3ee4f50b1ae43a89$var$utf8corpus) == /*#__PURE__*/ $3ee4f50b1ae43a89$var$utf8reada($3ee4f50b1ae43a89$var$utf8corpus) && $3ee4f50b1ae43a89$var$utf8readc || /*#__PURE__*/ $3ee4f50b1ae43a89$var$utf8readb($3ee4f50b1ae43a89$var$utf8corpus) == /*#__PURE__*/ $3ee4f50b1ae43a89$var$utf8reada($3ee4f50b1ae43a89$var$utf8corpus) && $3ee4f50b1ae43a89$var$utf8readb) || $3ee4f50b1ae43a89$var$utf8reada;
var $3ee4f50b1ae43a89$var$utf8write /*:StringConv*/  = $3ee4f50b1ae43a89$var$has_buf ? function(data) {
    return $3ee4f50b1ae43a89$var$Buffer_from(data, "utf8").toString("binary");
} : function(orig /*:string*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [], i = 0, c = 0, d = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        switch(true){
            case c < 128:
                out.push(String.fromCharCode(c));
                break;
            case c < 2048:
                out.push(String.fromCharCode(192 + (c >> 6)));
                out.push(String.fromCharCode(128 + (c & 63)));
                break;
            case c >= 55296 && c < 57344:
                c -= 55296;
                d = orig.charCodeAt(i++) - 56320 + (c << 10);
                out.push(String.fromCharCode(240 + (d >> 18 & 7)));
                out.push(String.fromCharCode(144 + (d >> 12 & 63)));
                out.push(String.fromCharCode(128 + (d >> 6 & 63)));
                out.push(String.fromCharCode(128 + (d & 63)));
                break;
            default:
                out.push(String.fromCharCode(224 + (c >> 12)));
                out.push(String.fromCharCode(128 + (c >> 6 & 63)));
                out.push(String.fromCharCode(128 + (c & 63)));
        }
    }
    return out.join("");
};
// matches <foo>...</foo> extracts content
var $3ee4f50b1ae43a89$var$matchtag = /*#__PURE__*/ function() {
    var mtcache /*:{[k:string]:RegExp}*/  = {} /*:any*/ ;
    return function matchtag(f /*:string*/ , g /*:?string*/ ) /*:RegExp*/ {
        var t = f + "|" + (g || "");
        if (mtcache[t]) return mtcache[t];
        return mtcache[t] = new RegExp("<(?:\\w+:)?" + f + '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' + f + ">", g || "");
    };
}();
var $3ee4f50b1ae43a89$var$htmldecode /*:{(s:string):string}*/  = /*#__PURE__*/ function() {
    var entities /*:Array<[RegExp, string]>*/  = [
        [
            "nbsp",
            " "
        ],
        [
            "middot",
            "\xb7"
        ],
        [
            "quot",
            '"'
        ],
        [
            "apos",
            "'"
        ],
        [
            "gt",
            ">"
        ],
        [
            "lt",
            "<"
        ],
        [
            "amp",
            "&"
        ]
    ].map(function(x /*:[string, string]*/ ) {
        return [
            new RegExp("&" + x[0] + ";", "ig"),
            x[1]
        ];
    });
    return function htmldecode(str /*:string*/ ) /*:string*/ {
        var o = str// Remove new lines and spaces from start of content
        .replace(/^[\t\n\r ]+/, "")// Remove new lines and spaces from end of content
        .replace(/[\t\n\r ]+$/, "")// Added line which removes any white space characters after and before html tags
        .replace(/>\s+/g, ">").replace(/\s+</g, "<")// Replace remaining new lines and spaces with space
        .replace(/[\t\n\r ]+/g, " ")// Replace <br> tags with new lines
        .replace(/<\s*[bB][rR]\s*\/?>/g, "\n")// Strip HTML elements
        .replace(/<[^>]*>/g, "");
        for(var i = 0; i < entities.length; ++i)o = o.replace(entities[i][0], entities[i][1]);
        return o;
    };
}();
var $3ee4f50b1ae43a89$var$vtregex = /*#__PURE__*/ function() {
    var vt_cache = {};
    return function vt_regex(bt) {
        if (vt_cache[bt] !== undefined) return vt_cache[bt];
        return vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", "g");
    };
}();
var $3ee4f50b1ae43a89$var$vtvregex = /<\/?(?:vt:)?variant>/g, $3ee4f50b1ae43a89$var$vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
function $3ee4f50b1ae43a89$var$parseVector(data /*:string*/ , opts) /*:Array<{v:string,t:string}>*/ {
    var h = $3ee4f50b1ae43a89$var$parsexmltag(data);
    var matches /*:Array<string>*/  = data.match($3ee4f50b1ae43a89$var$vtregex(h.baseType)) || [];
    var res /*:Array<any>*/  = [];
    if (matches.length != h.size) {
        if (opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
        return res;
    }
    matches.forEach(function(x /*:string*/ ) {
        var v = x.replace($3ee4f50b1ae43a89$var$vtvregex, "").match($3ee4f50b1ae43a89$var$vtmregex);
        if (v) res.push({
            v: $3ee4f50b1ae43a89$var$utf8read(v[2]),
            t: v[1]
        });
    });
    return res;
}
var $3ee4f50b1ae43a89$var$wtregex = /(^\s|\s$|\n)/;
function $3ee4f50b1ae43a89$var$writetag(f /*:string*/ , g /*:string*/ ) /*:string*/ {
    return "<" + f + (g.match($3ee4f50b1ae43a89$var$wtregex) ? ' xml:space="preserve"' : "") + ">" + g + "</" + f + ">";
}
function $3ee4f50b1ae43a89$var$wxt_helper(h) /*:string*/ {
    return $3ee4f50b1ae43a89$var$keys(h).map(function(k) {
        return " " + k + '="' + h[k] + '"';
    }).join("");
}
function $3ee4f50b1ae43a89$var$writextag(f /*:string*/ , g /*:?string*/ , h) {
    return "<" + f + (h != null ? $3ee4f50b1ae43a89$var$wxt_helper(h) : "") + (g != null ? (g.match($3ee4f50b1ae43a89$var$wtregex) ? ' xml:space="preserve"' : "") + ">" + g + "</" + f : "/") + ">";
}
function $3ee4f50b1ae43a89$var$write_w3cdtf(d /*:Date*/ , t /*:?boolean*/ ) /*:string*/ {
    try {
        return d.toISOString().replace(/\.\d*/, "");
    } catch (e) {
        if (t) throw e;
    }
    return "";
}
function $3ee4f50b1ae43a89$var$write_vt(s, xlsx /*:?boolean*/ ) /*:string*/ {
    switch(typeof s){
        case "string":
            var o = $3ee4f50b1ae43a89$var$writextag("vt:lpwstr", $3ee4f50b1ae43a89$var$escapexml(s));
            if (xlsx) o = o.replace(/&quot;/g, "_x0022_");
            return o;
        case "number":
            return $3ee4f50b1ae43a89$var$writextag((s | 0) == s ? "vt:i4" : "vt:r8", $3ee4f50b1ae43a89$var$escapexml(String(s)));
        case "boolean":
            return $3ee4f50b1ae43a89$var$writextag("vt:bool", s ? "true" : "false");
    }
    if (s instanceof Date) return $3ee4f50b1ae43a89$var$writextag("vt:filetime", $3ee4f50b1ae43a89$var$write_w3cdtf(s));
    throw new Error("Unable to serialize " + s);
}
function $3ee4f50b1ae43a89$var$xlml_normalize(d) /*:string*/ {
    if ($3ee4f50b1ae43a89$var$has_buf && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/ $3ee4f50b1ae43a89$require$Buffer.isBuffer(d)) return d.toString("utf8");
    if (typeof d === "string") return d;
    /* duktape */ if (typeof Uint8Array !== "undefined" && d instanceof Uint8Array) return $3ee4f50b1ae43a89$var$utf8read($3ee4f50b1ae43a89$var$a2s($3ee4f50b1ae43a89$var$ab2a(d)));
    throw new Error("Bad input format: expected Buffer or string");
}
/* UOS uses CJK in tags */ var $3ee4f50b1ae43a89$var$xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg;
//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
var $3ee4f50b1ae43a89$var$XMLNS = {
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
    CT: "http://schemas.openxmlformats.org/package/2006/content-types",
    RELS: "http://schemas.openxmlformats.org/package/2006/relationships",
    TCMNT: "http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments",
    "dc": "http://purl.org/dc/elements/1.1/",
    "dcterms": "http://purl.org/dc/terms/",
    "dcmitype": "http://purl.org/dc/dcmitype/",
    "mx": "http://schemas.microsoft.com/office/mac/excel/2008/main",
    "r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
    "sjs": "http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",
    "vt": "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",
    "xsi": "http://www.w3.org/2001/XMLSchema-instance",
    "xsd": "http://www.w3.org/2001/XMLSchema"
} /*:any*/ ;
var $3ee4f50b1ae43a89$var$XMLNS_main = [
    "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
    "http://purl.oclc.org/ooxml/spreadsheetml/main",
    "http://schemas.microsoft.com/office/excel/2006/main",
    "http://schemas.microsoft.com/office/excel/2006/2"
];
var $3ee4f50b1ae43a89$var$XLMLNS = {
    "o": "urn:schemas-microsoft-com:office:office",
    "x": "urn:schemas-microsoft-com:office:excel",
    "ss": "urn:schemas-microsoft-com:office:spreadsheet",
    "dt": "uuid:C2F41010-65B3-11d1-A29F-00AA00C14882",
    "mv": "http://macVmlSchemaUri",
    "v": "urn:schemas-microsoft-com:vml",
    "html": "http://www.w3.org/TR/REC-html40"
} /*:any*/ ;
function $3ee4f50b1ae43a89$var$read_double_le(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var s = 1 - 2 * (b[idx + 7] >>> 7);
    var e = ((b[idx + 7] & 0x7f) << 4) + (b[idx + 6] >>> 4 & 0x0f);
    var m = b[idx + 6] & 0x0f;
    for(var i = 5; i >= 0; --i)m = m * 256 + b[idx + i];
    if (e == 0x7ff) return m == 0 ? s * Infinity : NaN;
    if (e == 0) e = -1022;
    else {
        e -= 1023;
        m += Math.pow(2, 52);
    }
    return s * Math.pow(2, e - 52) * m;
}
function $3ee4f50b1ae43a89$var$write_double_le(b /*:RawBytes|CFBlob*/ , v /*:number*/ , idx /*:number*/ ) {
    var bs = (v < 0 || 1 / v == -Infinity ? 1 : 0) << 7, e = 0, m = 0;
    var av = bs ? -v : v;
    if (!isFinite(av)) {
        e = 0x7ff;
        m = isNaN(v) ? 0x6969 : 0;
    } else if (av == 0) e = m = 0;
    else {
        e = Math.floor(Math.log(av) / Math.LN2);
        m = av * Math.pow(2, 52 - e);
        if (e <= -1023 && (!isFinite(m) || m < Math.pow(2, 52))) e = -1022;
        else {
            m -= Math.pow(2, 52);
            e += 1023;
        }
    }
    for(var i = 0; i <= 5; ++i, m /= 256)b[idx + i] = m & 0xff;
    b[idx + 6] = (e & 0x0f) << 4 | m & 0xf;
    b[idx + 7] = e >> 4 | bs;
}
var $3ee4f50b1ae43a89$var$___toBuffer = function(bufs /*:Array<Array<RawBytes> >*/ ) /*:RawBytes*/ {
    var x = [], w = 10240;
    for(var i = 0; i < bufs[0].length; ++i)if (bufs[0][i]) for(var j = 0, L = bufs[0][i].length; j < L; j += w)x.push.apply(x, bufs[0][i].slice(j, j + w));
    return x;
};
var $3ee4f50b1ae43a89$var$__toBuffer = $3ee4f50b1ae43a89$var$has_buf ? function(bufs) {
    return bufs[0].length > 0 && $3ee4f50b1ae43a89$require$Buffer.isBuffer(bufs[0][0]) ? $3ee4f50b1ae43a89$require$Buffer.concat(bufs[0].map(function(x) {
        return $3ee4f50b1ae43a89$require$Buffer.isBuffer(x) ? x : $3ee4f50b1ae43a89$var$Buffer_from(x);
    })) : $3ee4f50b1ae43a89$var$___toBuffer(bufs);
} : $3ee4f50b1ae43a89$var$___toBuffer;
var $3ee4f50b1ae43a89$var$___utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < e; i += 2)ss.push(String.fromCharCode($3ee4f50b1ae43a89$var$__readUInt16LE(b, i)));
    return ss.join("").replace($3ee4f50b1ae43a89$var$chr0, "");
};
var $3ee4f50b1ae43a89$var$__utf16le = $3ee4f50b1ae43a89$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    if (!$3ee4f50b1ae43a89$require$Buffer.isBuffer(b)) return $3ee4f50b1ae43a89$var$___utf16le(b, s, e);
    return b.toString("utf16le", s, e).replace($3ee4f50b1ae43a89$var$chr0, "") /*.replace(chr1,'!')*/ ;
} : $3ee4f50b1ae43a89$var$___utf16le;
var $3ee4f50b1ae43a89$var$___hexlify = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < s + l; ++i)ss.push(("0" + b[i].toString(16)).slice(-2));
    return ss.join("");
};
var $3ee4f50b1ae43a89$var$__hexlify = $3ee4f50b1ae43a89$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    return $3ee4f50b1ae43a89$require$Buffer.isBuffer(b) ? b.toString("hex", s, s + l) : $3ee4f50b1ae43a89$var$___hexlify(b, s, l);
} : $3ee4f50b1ae43a89$var$___hexlify;
var $3ee4f50b1ae43a89$var$___utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    var ss = [];
    for(var i = s; i < e; i++)ss.push(String.fromCharCode($3ee4f50b1ae43a89$var$__readUInt8(b, i)));
    return ss.join("");
};
var $3ee4f50b1ae43a89$var$__utf8 = $3ee4f50b1ae43a89$var$has_buf ? function utf8_b(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    return $3ee4f50b1ae43a89$require$Buffer.isBuffer(b) ? b.toString("utf8", s, e) : $3ee4f50b1ae43a89$var$___utf8(b, s, e);
} : $3ee4f50b1ae43a89$var$___utf8;
var $3ee4f50b1ae43a89$var$___lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
    return len > 0 ? $3ee4f50b1ae43a89$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $3ee4f50b1ae43a89$var$__lpstr = $3ee4f50b1ae43a89$var$___lpstr;
var $3ee4f50b1ae43a89$var$___cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
    return len > 0 ? $3ee4f50b1ae43a89$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $3ee4f50b1ae43a89$var$__cpstr = $3ee4f50b1ae43a89$var$___cpstr;
var $3ee4f50b1ae43a89$var$___lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = 2 * $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
    return len > 0 ? $3ee4f50b1ae43a89$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $3ee4f50b1ae43a89$var$__lpwstr = $3ee4f50b1ae43a89$var$___lpwstr;
var $3ee4f50b1ae43a89$var$___lpp4 = function lpp4_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
    return len > 0 ? $3ee4f50b1ae43a89$var$__utf16le(b, i + 4, i + 4 + len) : "";
};
var $3ee4f50b1ae43a89$var$__lpp4 = $3ee4f50b1ae43a89$var$___lpp4;
var $3ee4f50b1ae43a89$var$___8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
    return len > 0 ? $3ee4f50b1ae43a89$var$__utf8(b, i + 4, i + 4 + len) : "";
};
var $3ee4f50b1ae43a89$var$__8lpp4 = $3ee4f50b1ae43a89$var$___8lpp4;
var $3ee4f50b1ae43a89$var$___double = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) {
    return $3ee4f50b1ae43a89$var$read_double_le(b, idx);
};
var $3ee4f50b1ae43a89$var$__double = $3ee4f50b1ae43a89$var$___double;
var $3ee4f50b1ae43a89$var$is_buf = function is_buf_a(a) {
    return Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
};
if ($3ee4f50b1ae43a89$var$has_buf /*:: && typeof Buffer !== 'undefined'*/ ) {
    $3ee4f50b1ae43a89$var$__lpstr = function lpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$3ee4f50b1ae43a89$require$Buffer.isBuffer(b)) return $3ee4f50b1ae43a89$var$___lpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString("utf8", i + 4, i + 4 + len - 1) : "";
    };
    $3ee4f50b1ae43a89$var$__cpstr = function cpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$3ee4f50b1ae43a89$require$Buffer.isBuffer(b)) return $3ee4f50b1ae43a89$var$___cpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString("utf8", i + 4, i + 4 + len - 1) : "";
    };
    $3ee4f50b1ae43a89$var$__lpwstr = function lpwstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$3ee4f50b1ae43a89$require$Buffer.isBuffer(b)) return $3ee4f50b1ae43a89$var$___lpwstr(b, i);
        var len = 2 * b.readUInt32LE(i);
        return b.toString("utf16le", i + 4, i + 4 + len - 1);
    };
    $3ee4f50b1ae43a89$var$__lpp4 = function lpp4_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$3ee4f50b1ae43a89$require$Buffer.isBuffer(b)) return $3ee4f50b1ae43a89$var$___lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString("utf16le", i + 4, i + 4 + len);
    };
    $3ee4f50b1ae43a89$var$__8lpp4 = function lpp4_8b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$3ee4f50b1ae43a89$require$Buffer.isBuffer(b)) return $3ee4f50b1ae43a89$var$___8lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString("utf8", i + 4, i + 4 + len);
    };
    $3ee4f50b1ae43a89$var$__double = function double_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if ($3ee4f50b1ae43a89$require$Buffer.isBuffer(b)) return b.readDoubleLE(i);
        return $3ee4f50b1ae43a89$var$___double(b, i);
    };
    $3ee4f50b1ae43a89$var$is_buf = function is_buf_b(a) {
        return $3ee4f50b1ae43a89$require$Buffer.isBuffer(a) || Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
    };
}
/* from js-xls */ function $3ee4f50b1ae43a89$var$cpdoit() {
    $3ee4f50b1ae43a89$var$__utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $3ee4f50b1ae43a89$var$$cptable.utils.decode(1200, b.slice(s, e)).replace($3ee4f50b1ae43a89$var$chr0, "");
    };
    $3ee4f50b1ae43a89$var$__utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $3ee4f50b1ae43a89$var$$cptable.utils.decode(65001, b.slice(s, e));
    };
    $3ee4f50b1ae43a89$var$__lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
        return len > 0 ? $3ee4f50b1ae43a89$var$$cptable.utils.decode($3ee4f50b1ae43a89$var$current_ansi, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $3ee4f50b1ae43a89$var$__cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
        return len > 0 ? $3ee4f50b1ae43a89$var$$cptable.utils.decode($3ee4f50b1ae43a89$var$current_codepage, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $3ee4f50b1ae43a89$var$__lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = 2 * $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
        return len > 0 ? $3ee4f50b1ae43a89$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $3ee4f50b1ae43a89$var$__lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
        return len > 0 ? $3ee4f50b1ae43a89$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len)) : "";
    };
    $3ee4f50b1ae43a89$var$__8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $3ee4f50b1ae43a89$var$__readUInt32LE(b, i);
        return len > 0 ? $3ee4f50b1ae43a89$var$$cptable.utils.decode(65001, b.slice(i + 4, i + 4 + len)) : "";
    };
}
if (typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined") $3ee4f50b1ae43a89$var$cpdoit();
var $3ee4f50b1ae43a89$var$__readUInt8 = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx];
};
var $3ee4f50b1ae43a89$var$__readUInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 1] * 256 + b[idx];
};
var $3ee4f50b1ae43a89$var$__readInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var u = b[idx + 1] * 256 + b[idx];
    return u < 0x8000 ? u : (0xffff - u + 1) * -1;
};
var $3ee4f50b1ae43a89$var$__readUInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] * 16777216 + (b[idx + 2] << 16) + (b[idx + 1] << 8) + b[idx];
};
var $3ee4f50b1ae43a89$var$__readInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] << 24 | b[idx + 2] << 16 | b[idx + 1] << 8 | b[idx];
};
var $3ee4f50b1ae43a89$var$__readInt32BE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx] << 24 | b[idx + 1] << 16 | b[idx + 2] << 8 | b[idx + 3];
};
function $3ee4f50b1ae43a89$var$ReadShift(size /*:number*/ , t /*:?string*/ ) /*:number|string*/ {
    var o = "", oI /*:: :number = 0*/ , oR, oo = [], w, vv, i, loc;
    switch(t){
        case "dbcs":
            loc = this.l;
            if ($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(this)) o = this.slice(this.l, this.l + 2 * size).toString("utf16le");
            else for(i = 0; i < size; ++i){
                o += String.fromCharCode($3ee4f50b1ae43a89$var$__readUInt16LE(this, loc));
                loc += 2;
            }
            size *= 2;
            break;
        case "utf8":
            o = $3ee4f50b1ae43a89$var$__utf8(this, this.l, this.l + size);
            break;
        case "utf16le":
            size *= 2;
            o = $3ee4f50b1ae43a89$var$__utf16le(this, this.l, this.l + size);
            break;
        case "wstr":
            if (typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined") o = $3ee4f50b1ae43a89$var$$cptable.utils.decode($3ee4f50b1ae43a89$var$current_codepage, this.slice(this.l, this.l + 2 * size));
            else return $3ee4f50b1ae43a89$var$ReadShift.call(this, size, "dbcs");
            size = 2 * size;
            break;
        /* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */ case "lpstr-ansi":
            o = $3ee4f50b1ae43a89$var$__lpstr(this, this.l);
            size = 4 + $3ee4f50b1ae43a89$var$__readUInt32LE(this, this.l);
            break;
        case "lpstr-cp":
            o = $3ee4f50b1ae43a89$var$__cpstr(this, this.l);
            size = 4 + $3ee4f50b1ae43a89$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */ case "lpwstr":
            o = $3ee4f50b1ae43a89$var$__lpwstr(this, this.l);
            size = 4 + 2 * $3ee4f50b1ae43a89$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */ case "lpp4":
            size = 4 + $3ee4f50b1ae43a89$var$__readUInt32LE(this, this.l);
            o = $3ee4f50b1ae43a89$var$__lpp4(this, this.l);
            if (size & 0x02) size += 2;
            break;
        /* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */ case "8lpp4":
            size = 4 + $3ee4f50b1ae43a89$var$__readUInt32LE(this, this.l);
            o = $3ee4f50b1ae43a89$var$__8lpp4(this, this.l);
            if (size & 0x03) size += 4 - (size & 0x03);
            break;
        case "cstr":
            size = 0;
            o = "";
            while((w = $3ee4f50b1ae43a89$var$__readUInt8(this, this.l + size++)) !== 0)oo.push($3ee4f50b1ae43a89$var$_getchar(w));
            o = oo.join("");
            break;
        case "_wstr":
            size = 0;
            o = "";
            while((w = $3ee4f50b1ae43a89$var$__readUInt16LE(this, this.l + size)) !== 0){
                oo.push($3ee4f50b1ae43a89$var$_getchar(w));
                size += 2;
            }
            size += 2;
            o = oo.join("");
            break;
        /* sbcs and dbcs support continue records in the SST way TODO codepages */ case "dbcs-cont":
            o = "";
            loc = this.l;
            for(i = 0; i < size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $3ee4f50b1ae43a89$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $3ee4f50b1ae43a89$var$ReadShift.call(this, size - i, w ? "dbcs-cont" : "sbcs-cont");
                    return oo.join("") + vv;
                }
                oo.push($3ee4f50b1ae43a89$var$_getchar($3ee4f50b1ae43a89$var$__readUInt16LE(this, loc)));
                loc += 2;
            }
            o = oo.join("");
            size *= 2;
            break;
        case "cpstr":
            if (typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined") {
                o = $3ee4f50b1ae43a89$var$$cptable.utils.decode($3ee4f50b1ae43a89$var$current_codepage, this.slice(this.l, this.l + size));
                break;
            }
        /* falls through */ case "sbcs-cont":
            o = "";
            loc = this.l;
            for(i = 0; i != size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $3ee4f50b1ae43a89$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $3ee4f50b1ae43a89$var$ReadShift.call(this, size - i, w ? "dbcs-cont" : "sbcs-cont");
                    return oo.join("") + vv;
                }
                oo.push($3ee4f50b1ae43a89$var$_getchar($3ee4f50b1ae43a89$var$__readUInt8(this, loc)));
                loc += 1;
            }
            o = oo.join("");
            break;
        default:
            switch(size){
                case 1:
                    oI = $3ee4f50b1ae43a89$var$__readUInt8(this, this.l);
                    this.l++;
                    return oI;
                case 2:
                    oI = (t === "i" ? $3ee4f50b1ae43a89$var$__readInt16LE : $3ee4f50b1ae43a89$var$__readUInt16LE)(this, this.l);
                    this.l += 2;
                    return oI;
                case 4:
                case -4:
                    if (t === "i" || (this[this.l + 3] & 0x80) === 0) {
                        oI = (size > 0 ? $3ee4f50b1ae43a89$var$__readInt32LE : $3ee4f50b1ae43a89$var$__readInt32BE)(this, this.l);
                        this.l += 4;
                        return oI;
                    } else {
                        oR = $3ee4f50b1ae43a89$var$__readUInt32LE(this, this.l);
                        this.l += 4;
                    }
                    return oR;
                case 8:
                case -8:
                    if (t === "f") {
                        if (size == 8) oR = $3ee4f50b1ae43a89$var$__double(this, this.l);
                        else oR = $3ee4f50b1ae43a89$var$__double([
                            this[this.l + 7],
                            this[this.l + 6],
                            this[this.l + 5],
                            this[this.l + 4],
                            this[this.l + 3],
                            this[this.l + 2],
                            this[this.l + 1],
                            this[this.l + 0]
                        ], 0);
                        this.l += 8;
                        return oR;
                    } else size = 8;
                /* falls through */ case 16:
                    o = $3ee4f50b1ae43a89$var$__hexlify(this, this.l, size);
                    break;
            }
    }
    this.l += size;
    return o;
}
var $3ee4f50b1ae43a89$var$__writeUInt32LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >>> 8 & 0xFF;
    b[idx + 2] = val >>> 16 & 0xFF;
    b[idx + 3] = val >>> 24 & 0xFF;
};
var $3ee4f50b1ae43a89$var$__writeInt32LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >> 8 & 0xFF;
    b[idx + 2] = val >> 16 & 0xFF;
    b[idx + 3] = val >> 24 & 0xFF;
};
var $3ee4f50b1ae43a89$var$__writeUInt16LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >>> 8 & 0xFF;
};
function $3ee4f50b1ae43a89$var$WriteShift(t /*:number*/ , val /*:string|number*/ , f /*:?string*/ ) /*:any*/ {
    var size = 0, i = 0;
    if (f === "dbcs") {
        /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i)$3ee4f50b1ae43a89$var$__writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
        size = 2 * val.length;
    } else if (f === "sbcs") {
        if (typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined" && $3ee4f50b1ae43a89$var$current_ansi == 874) /* TODO: use tables directly, don't encode */ /*:: if(typeof val !== "string") throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i){
            var cppayload = $3ee4f50b1ae43a89$var$$cptable.utils.encode($3ee4f50b1ae43a89$var$current_ansi, val.charAt(i));
            this[this.l + i] = cppayload[0];
        }
        else {
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ val = val.replace(/[^\x00-\x7F]/g, "_");
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i)this[this.l + i] = val.charCodeAt(i) & 0xFF;
        }
        size = val.length;
    } else if (f === "hex") {
        for(; i < t; ++i)/*:: if(typeof val !== "string") throw new Error("unreachable"); */ this[this.l++] = parseInt(val.slice(2 * i, 2 * i + 2), 16) || 0;
        return this;
    } else if (f === "utf16le") {
        /*:: if(typeof val !== "string") throw new Error("unreachable"); */ var end /*:number*/  = Math.min(this.l + t, this.length);
        for(i = 0; i < Math.min(val.length, t); ++i){
            var cc = val.charCodeAt(i);
            this[this.l++] = cc & 0xff;
            this[this.l++] = cc >> 8;
        }
        while(this.l < end)this[this.l++] = 0;
        return this;
    } else /*:: if(typeof val === 'number') */ switch(t){
        case 1:
            size = 1;
            this[this.l] = val & 0xFF;
            break;
        case 2:
            size = 2;
            this[this.l] = val & 0xFF;
            val >>>= 8;
            this[this.l + 1] = val & 0xFF;
            break;
        case 3:
            size = 3;
            this[this.l] = val & 0xFF;
            val >>>= 8;
            this[this.l + 1] = val & 0xFF;
            val >>>= 8;
            this[this.l + 2] = val & 0xFF;
            break;
        case 4:
            size = 4;
            $3ee4f50b1ae43a89$var$__writeUInt32LE(this, val, this.l);
            break;
        case 8:
            size = 8;
            if (f === "f") {
                $3ee4f50b1ae43a89$var$write_double_le(this, val, this.l);
                break;
            }
        /* falls through */ case 16:
            break;
        case -4:
            size = 4;
            $3ee4f50b1ae43a89$var$__writeInt32LE(this, val, this.l);
            break;
    }
    this.l += size;
    return this;
}
function $3ee4f50b1ae43a89$var$CheckField(hexstr /*:string*/ , fld /*:string*/ ) /*:void*/ {
    var m = $3ee4f50b1ae43a89$var$__hexlify(this, this.l, hexstr.length >> 1);
    if (m !== hexstr) throw new Error(fld + "Expected " + hexstr + " saw " + m);
    this.l += hexstr.length >> 1;
}
function $3ee4f50b1ae43a89$var$prep_blob(blob, pos /*:number*/ ) /*:void*/ {
    blob.l = pos;
    blob.read_shift = /*::(*/ $3ee4f50b1ae43a89$var$ReadShift /*:: :any)*/ ;
    blob.chk = $3ee4f50b1ae43a89$var$CheckField;
    blob.write_shift = $3ee4f50b1ae43a89$var$WriteShift;
}
function $3ee4f50b1ae43a89$var$parsenoop(blob, length /*:: :number, opts?:any */ ) {
    blob.l += length;
}
function $3ee4f50b1ae43a89$var$new_buf(sz /*:number*/ ) /*:Block*/ {
    var o = $3ee4f50b1ae43a89$var$new_raw_buf(sz);
    $3ee4f50b1ae43a89$var$prep_blob(o, 0);
    return o;
}
/* [MS-XLSB] 2.1.4 Record */ function $3ee4f50b1ae43a89$var$recordhopper(data, cb /*:RecordHopperCB*/ , opts /*:?any*/ ) {
    if (!data) return;
    var tmpbyte, cntbyte, length;
    $3ee4f50b1ae43a89$var$prep_blob(data, data.l || 0);
    var L = data.length, RT = 0, tgt = 0;
    while(data.l < L){
        RT = data.read_shift(1);
        if (RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F) << 7);
        var R = $3ee4f50b1ae43a89$var$XLSBRecordEnum[RT] || $3ee4f50b1ae43a89$var$XLSBRecordEnum[0xFFFF];
        tmpbyte = data.read_shift(1);
        length = tmpbyte & 0x7F;
        for(cntbyte = 1; cntbyte < 4 && tmpbyte & 0x80; ++cntbyte)length += ((tmpbyte = data.read_shift(1)) & 0x7F) << 7 * cntbyte;
        tgt = data.l + length;
        var d = R.f && R.f(data, length, opts);
        data.l = tgt;
        if (cb(d, R, RT)) return;
    }
}
/* control buffer usage for fixed-length buffers */ function $3ee4f50b1ae43a89$var$buf_array() /*:BufArray*/ {
    var bufs /*:Array<Block>*/  = [], blksz = $3ee4f50b1ae43a89$var$has_buf ? 256 : 2048;
    var newblk = function ba_newblk(sz /*:number*/ ) /*:Block*/ {
        var o /*:Block*/  = $3ee4f50b1ae43a89$var$new_buf(sz);
        $3ee4f50b1ae43a89$var$prep_blob(o, 0);
        return o;
    };
    var curbuf /*:Block*/  = newblk(blksz);
    var endbuf = function ba_endbuf() {
        if (!curbuf) return;
        if (curbuf.length > curbuf.l) {
            curbuf = curbuf.slice(0, curbuf.l);
            curbuf.l = curbuf.length;
        }
        if (curbuf.length > 0) bufs.push(curbuf);
        curbuf = null;
    };
    var next = function ba_next(sz /*:number*/ ) /*:Block*/ {
        if (curbuf && sz < curbuf.length - curbuf.l) return curbuf;
        endbuf();
        return curbuf = newblk(Math.max(sz + 1, blksz));
    };
    var end = function ba_end() {
        endbuf();
        return $3ee4f50b1ae43a89$var$bconcat(bufs);
    };
    var push = function ba_push(buf) {
        endbuf();
        curbuf = buf;
        if (curbuf.l == null) curbuf.l = curbuf.length;
        next(blksz);
    };
    return {
        next: next,
        push: push,
        end: end,
        _bufs: bufs
    } /*:any*/ ;
}
function $3ee4f50b1ae43a89$var$write_record(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) {
    var t /*:number*/  = +type, l;
    if (isNaN(t)) return; // TODO: throw something here?
    if (!length) length = $3ee4f50b1ae43a89$var$XLSBRecordEnum[t].p || (payload || []).length || 0;
    l = 1 + (t >= 0x80 ? 1 : 0) + 1 /* + length*/ ;
    if (length >= 0x80) ++l;
    if (length >= 0x4000) ++l;
    if (length >= 0x200000) ++l;
    var o = ba.next(l);
    if (t <= 0x7F) o.write_shift(1, t);
    else {
        o.write_shift(1, (t & 0x7F) + 0x80);
        o.write_shift(1, t >> 7);
    }
    for(var i = 0; i != 4; ++i)if (length >= 0x80) {
        o.write_shift(1, (length & 0x7F) + 0x80);
        length >>= 7;
    } else {
        o.write_shift(1, length);
        break;
    }
    if (/*:: length != null &&*/ length > 0 && $3ee4f50b1ae43a89$var$is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */ function $3ee4f50b1ae43a89$var$shift_cell_xls(cell /*:CellAddress*/ , tgt /*:any*/ , opts /*:?any*/ ) /*:CellAddress*/ {
    var out = $3ee4f50b1ae43a89$var$dup(cell);
    if (tgt.s) {
        if (out.cRel) out.c += tgt.s.c;
        if (out.rRel) out.r += tgt.s.r;
    } else {
        if (out.cRel) out.c += tgt.c;
        if (out.rRel) out.r += tgt.r;
    }
    if (!opts || opts.biff < 12) {
        while(out.c >= 0x100)out.c -= 0x100;
        while(out.r >= 0x10000)out.r -= 0x10000;
    }
    return out;
}
function $3ee4f50b1ae43a89$var$shift_range_xls(cell, range, opts) {
    var out = $3ee4f50b1ae43a89$var$dup(cell);
    out.s = $3ee4f50b1ae43a89$var$shift_cell_xls(out.s, range.s, opts);
    out.e = $3ee4f50b1ae43a89$var$shift_cell_xls(out.e, range.s, opts);
    return out;
}
function $3ee4f50b1ae43a89$var$encode_cell_xls(c /*:CellAddress*/ , biff /*:number*/ ) /*:string*/ {
    if (c.cRel && c.c < 0) {
        c = $3ee4f50b1ae43a89$var$dup(c);
        while(c.c < 0)c.c += biff > 8 ? 0x4000 : 0x100;
    }
    if (c.rRel && c.r < 0) {
        c = $3ee4f50b1ae43a89$var$dup(c);
        while(c.r < 0)c.r += biff > 8 ? 0x100000 : biff > 5 ? 0x10000 : 0x4000;
    }
    var s = $3ee4f50b1ae43a89$var$encode_cell(c);
    if (!c.cRel && c.cRel != null) s = $3ee4f50b1ae43a89$var$fix_col(s);
    if (!c.rRel && c.rRel != null) s = $3ee4f50b1ae43a89$var$fix_row(s);
    return s;
}
function $3ee4f50b1ae43a89$var$encode_range_xls(r, opts) /*:string*/ {
    if (r.s.r == 0 && !r.s.rRel) {
        if (r.e.r == (opts.biff >= 12 ? 0xFFFFF : opts.biff >= 8 ? 0x10000 : 0x4000) && !r.e.rRel) return (r.s.cRel ? "" : "$") + $3ee4f50b1ae43a89$var$encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + $3ee4f50b1ae43a89$var$encode_col(r.e.c);
    }
    if (r.s.c == 0 && !r.s.cRel) {
        if (r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) return (r.s.rRel ? "" : "$") + $3ee4f50b1ae43a89$var$encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + $3ee4f50b1ae43a89$var$encode_row(r.e.r);
    }
    return $3ee4f50b1ae43a89$var$encode_cell_xls(r.s, opts.biff) + ":" + $3ee4f50b1ae43a89$var$encode_cell_xls(r.e, opts.biff);
}
function $3ee4f50b1ae43a89$var$decode_row(rowstr /*:string*/ ) /*:number*/ {
    return parseInt($3ee4f50b1ae43a89$var$unfix_row(rowstr), 10) - 1;
}
function $3ee4f50b1ae43a89$var$encode_row(row /*:number*/ ) /*:string*/ {
    return "" + (row + 1);
}
function $3ee4f50b1ae43a89$var$fix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function $3ee4f50b1ae43a89$var$unfix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/\$(\d+)$/, "$1");
}
function $3ee4f50b1ae43a89$var$decode_col(colstr /*:string*/ ) /*:number*/ {
    var c = $3ee4f50b1ae43a89$var$unfix_col(colstr), d = 0, i = 0;
    for(; i !== c.length; ++i)d = 26 * d + c.charCodeAt(i) - 64;
    return d - 1;
}
function $3ee4f50b1ae43a89$var$encode_col(col /*:number*/ ) /*:string*/ {
    if (col < 0) throw new Error("invalid column " + col);
    var s = "";
    for(++col; col; col = Math.floor((col - 1) / 26))s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s;
}
function $3ee4f50b1ae43a89$var$fix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^([A-Z])/, "$$$1");
}
function $3ee4f50b1ae43a89$var$unfix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^\$([A-Z])/, "$1");
}
function $3ee4f50b1ae43a89$var$split_cell(cstr /*:string*/ ) /*:Array<string>*/ {
    return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
//function decode_cell(cstr/*:string*/)/*:CellAddress*/ { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
function $3ee4f50b1ae43a89$var$decode_cell(cstr /*:string*/ ) /*:CellAddress*/ {
    var R = 0, C = 0;
    for(var i = 0; i < cstr.length; ++i){
        var cc = cstr.charCodeAt(i);
        if (cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
        else if (cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
    }
    return {
        c: C - 1,
        r: R - 1
    };
}
//function encode_cell(cell/*:CellAddress*/)/*:string*/ { return encode_col(cell.c) + encode_row(cell.r); }
function $3ee4f50b1ae43a89$var$encode_cell(cell /*:CellAddress*/ ) /*:string*/ {
    var col = cell.c + 1;
    var s = "";
    for(; col; col = (col - 1) / 26 | 0)s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s + (cell.r + 1);
}
function $3ee4f50b1ae43a89$var$decode_range(range /*:string*/ ) /*:Range*/ {
    var idx = range.indexOf(":");
    if (idx == -1) return {
        s: $3ee4f50b1ae43a89$var$decode_cell(range),
        e: $3ee4f50b1ae43a89$var$decode_cell(range)
    };
    return {
        s: $3ee4f50b1ae43a89$var$decode_cell(range.slice(0, idx)),
        e: $3ee4f50b1ae43a89$var$decode_cell(range.slice(idx + 1))
    };
}
/*# if only one arg, it is assumed to be a Range.  If 2 args, both are cell addresses */ function $3ee4f50b1ae43a89$var$encode_range(cs /*:CellAddrSpec|Range*/ , ce /*:?CellAddrSpec*/ ) /*:string*/ {
    if (typeof ce === "undefined" || typeof ce === "number") /*:: if(!(cs instanceof Range)) throw "unreachable"; */ return $3ee4f50b1ae43a89$var$encode_range(cs.s, cs.e);
    /*:: if((cs instanceof Range)) throw "unreachable"; */ if (typeof cs !== "string") cs = $3ee4f50b1ae43a89$var$encode_cell(cs /*:any*/ );
    if (typeof ce !== "string") ce = $3ee4f50b1ae43a89$var$encode_cell(ce /*:any*/ );
    /*:: if(typeof cs !== 'string') throw "unreachable"; */ /*:: if(typeof ce !== 'string') throw "unreachable"; */ return cs == ce ? cs : cs + ":" + ce;
}
function $3ee4f50b1ae43a89$var$safe_decode_range(range /*:string*/ ) /*:Range*/ {
    var o = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var idx = 0, i = 0, cc = 0;
    var len = range.length;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.s.c = --idx;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.s.r = --idx;
    if (i === len || cc != 10) {
        o.e.c = o.s.c;
        o.e.r = o.s.r;
        return o;
    }
    ++i;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.e.c = --idx;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.e.r = --idx;
    return o;
}
function $3ee4f50b1ae43a89$var$safe_format_cell(cell /*:Cell*/ , v /*:any*/ ) {
    var q = cell.t == "d" && v instanceof Date;
    if (cell.z != null) try {
        return cell.w = $3ee4f50b1ae43a89$var$SSF_format(cell.z, q ? $3ee4f50b1ae43a89$var$datenum(v) : v);
    } catch (e) {}
    try {
        return cell.w = $3ee4f50b1ae43a89$var$SSF_format((cell.XF || {}).numFmtId || (q ? 14 : 0), q ? $3ee4f50b1ae43a89$var$datenum(v) : v);
    } catch (e) {
        return "" + v;
    }
}
function $3ee4f50b1ae43a89$var$format_cell(cell /*:Cell*/ , v /*:any*/ , o /*:any*/ ) {
    if (cell == null || cell.t == null || cell.t == "z") return "";
    if (cell.w !== undefined) return cell.w;
    if (cell.t == "d" && !cell.z && o && o.dateNF) cell.z = o.dateNF;
    if (cell.t == "e") return $3ee4f50b1ae43a89$var$BErr[cell.v] || cell.v;
    if (v == undefined) return $3ee4f50b1ae43a89$var$safe_format_cell(cell, cell.v);
    return $3ee4f50b1ae43a89$var$safe_format_cell(cell, v);
}
function $3ee4f50b1ae43a89$var$sheet_to_workbook(sheet /*:Worksheet*/ , opts) /*:Workbook*/ {
    var n = opts && opts.sheet ? opts.sheet : "Sheet1";
    var sheets = {};
    sheets[n] = sheet;
    return {
        SheetNames: [
            n
        ],
        Sheets: sheets
    };
}
function $3ee4f50b1ae43a89$var$sheet_add_aoa(_ws /*:?Worksheet*/ , data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? Array.isArray(_ws) : o.dense;
    if ($3ee4f50b1ae43a89$var$DENSE != null && dense == null) dense = $3ee4f50b1ae43a89$var$DENSE;
    var ws /*:Worksheet*/  = _ws || (dense ? [] : {} /*:any*/ );
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == "number") _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $3ee4f50b1ae43a89$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
        if (!ws["!ref"]) ws["!ref"] = "A1:A1";
    }
    var range /*:Range*/  = {
        s: {
            c: 10000000,
            r: 10000000
        },
        e: {
            c: 0,
            r: 0
        }
    } /*:any*/ ;
    if (ws["!ref"]) {
        var _range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]);
        range.s.c = _range.s.c;
        range.s.r = _range.s.r;
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) range.e.r = _R = _range.e.r + 1;
    }
    for(var R = 0; R != data.length; ++R){
        if (!data[R]) continue;
        if (!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
        for(var C = 0; C != data[R].length; ++C){
            if (typeof data[R][C] === "undefined") continue;
            var cell /*:Cell*/  = {
                v: data[R][C]
            } /*:any*/ ;
            var __R = _R + R, __C = _C + C;
            if (range.s.r > __R) range.s.r = __R;
            if (range.s.c > __C) range.s.c = __C;
            if (range.e.r < __R) range.e.r = __R;
            if (range.e.c < __C) range.e.c = __C;
            if (data[R][C] && typeof data[R][C] === "object" && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
            else {
                if (Array.isArray(cell.v)) {
                    cell.f = data[R][C][1];
                    cell.v = cell.v[0];
                }
                if (cell.v === null) {
                    if (cell.f) cell.t = "n";
                    else if (o.nullError) {
                        cell.t = "e";
                        cell.v = 0;
                    } else if (!o.sheetStubs) continue;
                    else cell.t = "z";
                } else if (typeof cell.v === "number") cell.t = "n";
                else if (typeof cell.v === "boolean") cell.t = "b";
                else if (cell.v instanceof Date) {
                    cell.z = o.dateNF || $3ee4f50b1ae43a89$var$table_fmt[14];
                    if (o.cellDates) {
                        cell.t = "d";
                        cell.w = $3ee4f50b1ae43a89$var$SSF_format(cell.z, $3ee4f50b1ae43a89$var$datenum(cell.v));
                    } else {
                        cell.t = "n";
                        cell.v = $3ee4f50b1ae43a89$var$datenum(cell.v);
                        cell.w = $3ee4f50b1ae43a89$var$SSF_format(cell.z, cell.v);
                    }
                } else cell.t = "s";
            }
            if (dense) {
                if (!ws[__R]) ws[__R] = [];
                if (ws[__R][__C] && ws[__R][__C].z) cell.z = ws[__R][__C].z;
                ws[__R][__C] = cell;
            } else {
                var cell_ref = $3ee4f50b1ae43a89$var$encode_cell({
                    c: __C,
                    r: __R
                } /*:any*/ );
                if (ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
                ws[cell_ref] = cell;
            }
        }
    }
    if (range.s.c < 10000000) ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
    return ws;
}
function $3ee4f50b1ae43a89$var$aoa_to_sheet(data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    return $3ee4f50b1ae43a89$var$sheet_add_aoa(null, data, opts);
}
function $3ee4f50b1ae43a89$var$parse_Int32LE(data) {
    return data.read_shift(4, "i");
}
function $3ee4f50b1ae43a89$var$write_UInt32LE(x /*:number*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(4);
    o.write_shift(4, x);
    return o;
}
/* [MS-XLSB] 2.5.168 */ function $3ee4f50b1ae43a89$var$parse_XLWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "dbcs");
}
function $3ee4f50b1ae43a89$var$write_XLWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $3ee4f50b1ae43a89$var$new_buf(4 + 2 * data.length);
    }
    o.write_shift(4, data.length);
    if (data.length > 0) o.write_shift(0, data, "dbcs");
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.91 */ //function parse_LPWideString(data/*::, length*/)/*:string*/ {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}
/* [MS-XLSB] 2.5.143 */ function $3ee4f50b1ae43a89$var$parse_StrRun(data) {
    return {
        ich: data.read_shift(2),
        ifnt: data.read_shift(2)
    };
}
function $3ee4f50b1ae43a89$var$write_StrRun(run, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(4);
    o.write_shift(2, run.ich || 0);
    o.write_shift(2, run.ifnt || 0);
    return o;
}
/* [MS-XLSB] 2.5.121 */ function $3ee4f50b1ae43a89$var$parse_RichStr(data, length /*:number*/ ) /*:XLString*/ {
    var start = data.l;
    var flags = data.read_shift(1);
    var str = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    var rgsStrRun = [];
    var z = {
        t: str,
        h: str
    } /*:any*/ ;
    if ((flags & 1) !== 0) {
        /* TODO: formatted string */ var dwSizeStrRun = data.read_shift(4);
        for(var i = 0; i != dwSizeStrRun; ++i)rgsStrRun.push($3ee4f50b1ae43a89$var$parse_StrRun(data));
        z.r = rgsStrRun;
    } else z.r = [
        {
            ich: 0,
            ifnt: 0
        }
    ];
    //if((flags & 2) !== 0) { /* fExtStr */
    //	/* TODO: phonetic string */
    //}
    data.l = start + length;
    return z;
}
function $3ee4f50b1ae43a89$var$write_RichStr(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $3ee4f50b1ae43a89$var$new_buf(15 + 4 * str.t.length);
    }
    o.write_shift(1, 0);
    $3ee4f50b1ae43a89$var$write_XLWideString(str.t, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */ var $3ee4f50b1ae43a89$var$parse_BrtCommentText = $3ee4f50b1ae43a89$var$parse_RichStr;
function $3ee4f50b1ae43a89$var$write_BrtCommentText(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $3ee4f50b1ae43a89$var$new_buf(23 + 4 * str.t.length);
    }
    o.write_shift(1, 1);
    $3ee4f50b1ae43a89$var$write_XLWideString(str.t, o);
    o.write_shift(4, 1);
    $3ee4f50b1ae43a89$var$write_StrRun({
        ich: 0,
        ifnt: 0
    }, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.9 */ function $3ee4f50b1ae43a89$var$parse_XLSBCell(data) /*:any*/ {
    var col = data.read_shift(4);
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: col,
        iStyleRef: iStyleRef
    };
}
function $3ee4f50b1ae43a89$var$write_XLSBCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(8);
    o.write_shift(-4, cell.c);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* Short XLSB Cell does not include column */ function $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data) /*:any*/ {
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: -1,
        iStyleRef: iStyleRef
    };
}
function $3ee4f50b1ae43a89$var$write_XLSBShortCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(4);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* [MS-XLSB] 2.5.21 */ var $3ee4f50b1ae43a89$var$parse_XLSBCodeName = $3ee4f50b1ae43a89$var$parse_XLWideString;
var $3ee4f50b1ae43a89$var$write_XLSBCodeName = $3ee4f50b1ae43a89$var$write_XLWideString;
/* [MS-XLSB] 2.5.166 */ function $3ee4f50b1ae43a89$var$parse_XLNullableWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, "dbcs");
}
function $3ee4f50b1ae43a89$var$write_XLNullableWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $3ee4f50b1ae43a89$var$new_buf(127);
    }
    o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
    if (data.length > 0) o.write_shift(0, data, "dbcs");
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.165 */ var $3ee4f50b1ae43a89$var$parse_XLNameWideString = $3ee4f50b1ae43a89$var$parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;
/* [MS-XLSB] 2.5.114 */ var $3ee4f50b1ae43a89$var$parse_RelID = $3ee4f50b1ae43a89$var$parse_XLNullableWideString;
var $3ee4f50b1ae43a89$var$write_RelID = $3ee4f50b1ae43a89$var$write_XLNullableWideString;
/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */ function $3ee4f50b1ae43a89$var$parse_RkNumber(data) /*:number*/ {
    var b = data.slice(data.l, data.l + 4);
    var fX100 = b[0] & 1, fInt = b[0] & 2;
    data.l += 4;
    var RK = fInt === 0 ? $3ee4f50b1ae43a89$var$__double([
        0,
        0,
        0,
        0,
        b[0] & 0xFC,
        b[1],
        b[2],
        b[3]
    ], 0) : $3ee4f50b1ae43a89$var$__readInt32LE(b, 0) >> 2;
    return fX100 ? RK / 100 : RK;
}
function $3ee4f50b1ae43a89$var$write_RkNumber(data /*:number*/ , o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(4);
    var fX100 = 0, fInt = 0, d100 = data * 100;
    if (data == (data | 0) && data >= -536870912 && data < 536870912) fInt = 1;
    else if (d100 == (d100 | 0) && d100 >= -536870912 && d100 < 536870912) {
        fInt = 1;
        fX100 = 1;
    }
    if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
    else throw new Error("unsupported RkNumber " + data); // TODO
}
/* [MS-XLSB] 2.5.117 RfX */ function $3ee4f50b1ae43a89$var$parse_RfX(data /*::, length*/ ) /*:Range*/ {
    var cell /*:Range*/  = {
        s: {},
        e: {}
    } /*:any*/ ;
    cell.s.r = data.read_shift(4);
    cell.e.r = data.read_shift(4);
    cell.s.c = data.read_shift(4);
    cell.e.c = data.read_shift(4);
    return cell;
}
function $3ee4f50b1ae43a89$var$write_RfX(r /*:Range*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(16);
    o.write_shift(4, r.s.r);
    o.write_shift(4, r.e.r);
    o.write_shift(4, r.s.c);
    o.write_shift(4, r.e.c);
    return o;
}
/* [MS-XLSB] 2.5.153 UncheckedRfX */ var $3ee4f50b1ae43a89$var$parse_UncheckedRfX = $3ee4f50b1ae43a89$var$parse_RfX;
var $3ee4f50b1ae43a89$var$write_UncheckedRfX = $3ee4f50b1ae43a89$var$write_RfX;
/* [MS-XLSB] 2.5.155 UncheckedSqRfX */ //function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx/*:string*/) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}
/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */ /* TODO: error checking, NaN and Infinity values are not valid Xnum */ function $3ee4f50b1ae43a89$var$parse_Xnum(data /*::, length*/ ) {
    if (data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
    return data.read_shift(8, "f");
}
function $3ee4f50b1ae43a89$var$write_Xnum(data, o) {
    return (o || $3ee4f50b1ae43a89$var$new_buf(8)).write_shift(8, data, "f");
}
/* [MS-XLSB] 2.4.324 BrtColor */ function $3ee4f50b1ae43a89$var$parse_BrtColor(data /*::, length*/ ) {
    var out = {};
    var d = data.read_shift(1);
    //var fValidRGB = d & 1;
    var xColorType = d >>> 1;
    var index = data.read_shift(1);
    var nTS = data.read_shift(2, "i");
    var bR = data.read_shift(1);
    var bG = data.read_shift(1);
    var bB = data.read_shift(1);
    data.l++; //var bAlpha = data.read_shift(1);
    switch(xColorType){
        case 0:
            out.auto = 1;
            break;
        case 1:
            out.index = index;
            var icv = $3ee4f50b1ae43a89$var$XLSIcv[index];
            /* automatic pseudo index 81 */ if (icv) out.rgb = $3ee4f50b1ae43a89$var$rgb2Hex(icv);
            break;
        case 2:
            /* if(!fValidRGB) throw new Error("invalid"); */ out.rgb = $3ee4f50b1ae43a89$var$rgb2Hex([
                bR,
                bG,
                bB
            ]);
            break;
        case 3:
            out.theme = index;
            break;
    }
    if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
    return out;
}
function $3ee4f50b1ae43a89$var$write_BrtColor(color, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(8);
    if (!color || color.auto) {
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        return o;
    }
    if (color.index != null) {
        o.write_shift(1, 0x02);
        o.write_shift(1, color.index);
    } else if (color.theme != null) {
        o.write_shift(1, 0x06);
        o.write_shift(1, color.theme);
    } else {
        o.write_shift(1, 0x05);
        o.write_shift(1, 0);
    }
    var nTS = color.tint || 0;
    if (nTS > 0) nTS *= 32767;
    else if (nTS < 0) nTS *= 32768;
    o.write_shift(2, nTS);
    if (!color.rgb || color.theme != null) {
        o.write_shift(2, 0);
        o.write_shift(1, 0);
        o.write_shift(1, 0);
    } else {
        var rgb = color.rgb || "FFFFFF";
        if (typeof rgb == "number") rgb = ("000000" + rgb.toString(16)).slice(-6);
        o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
        o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
        o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
        o.write_shift(1, 0xFF);
    }
    return o;
}
/* [MS-XLSB] 2.5.52 */ function $3ee4f50b1ae43a89$var$parse_FontFlags(data /*::, length, opts*/ ) {
    var d = data.read_shift(1);
    data.l++;
    var out = {
        fBold: d & 0x01,
        fItalic: d & 0x02,
        fUnderline: d & 0x04,
        fStrikeout: d & 0x08,
        fOutline: d & 0x10,
        fShadow: d & 0x20,
        fCondense: d & 0x40,
        fExtend: d & 0x80
    };
    return out;
}
function $3ee4f50b1ae43a89$var$write_FontFlags(font, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(2);
    var grbit = (font.italic ? 0x02 : 0) | (font.strike ? 0x08 : 0) | (font.outline ? 0x10 : 0) | (font.shadow ? 0x20 : 0) | (font.condense ? 0x40 : 0) | (font.extend ? 0x80 : 0);
    o.write_shift(1, grbit);
    o.write_shift(1, 0);
    return o;
}
/* [MS-OLEDS] 2.3.1 and 2.3.2 */ function $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrString(o, w /*:number*/ ) /*:string*/ {
    // $FlowIgnore
    var ClipFmt = {
        2: "BITMAP",
        3: "METAFILEPICT",
        8: "DIB",
        14: "ENHMETAFILE"
    };
    var m /*:number*/  = o.read_shift(4);
    switch(m){
        case 0x00000000:
            return "";
        case 0xffffffff:
        case 0xfffffffe:
            return ClipFmt[o.read_shift(4)] || "";
    }
    if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
    o.l -= 4;
    return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrAnsiString(o) {
    return $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrString(o, 1);
}
function $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrUnicodeString(o) {
    return $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrString(o, 2);
}
/* [MS-OLEPS] 2.2 PropertyType */ // Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var $3ee4f50b1ae43a89$var$VT_I2 = 0x0002;
var $3ee4f50b1ae43a89$var$VT_I4 = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var $3ee4f50b1ae43a89$var$VT_BOOL = 0x000B;
var $3ee4f50b1ae43a89$var$VT_VARIANT = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var $3ee4f50b1ae43a89$var$VT_UI4 = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
var $3ee4f50b1ae43a89$var$VT_LPSTR = 0x001E;
//var VT_LPWSTR   = 0x001F;
var $3ee4f50b1ae43a89$var$VT_FILETIME = 0x0040;
var $3ee4f50b1ae43a89$var$VT_BLOB = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var $3ee4f50b1ae43a89$var$VT_CF = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
var $3ee4f50b1ae43a89$var$VT_VECTOR = 0x1000;
var $3ee4f50b1ae43a89$var$VT_VECTOR_VARIANT = 0x100C;
var $3ee4f50b1ae43a89$var$VT_VECTOR_LPSTR = 0x101E;
//var VT_ARRAY    = 0x2000;
var $3ee4f50b1ae43a89$var$VT_STRING = 0x0050; // 2.3.3.1.11 VtString
var $3ee4f50b1ae43a89$var$VT_USTR = 0x0051; // 2.3.3.1.12 VtUnalignedString
var $3ee4f50b1ae43a89$var$VT_CUSTOM = [
    $3ee4f50b1ae43a89$var$VT_STRING,
    $3ee4f50b1ae43a89$var$VT_USTR
];
/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */ var $3ee4f50b1ae43a89$var$DocSummaryPIDDSI = {
    /*::[*/ 0x01: {
        n: "CodePage",
        t: $3ee4f50b1ae43a89$var$VT_I2
    },
    /*::[*/ 0x02: {
        n: "Category",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x03: {
        n: "PresentationFormat",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x04: {
        n: "ByteCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x05: {
        n: "LineCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x06: {
        n: "ParagraphCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x07: {
        n: "SlideCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x08: {
        n: "NoteCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x09: {
        n: "HiddenCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x0a: {
        n: "MultimediaClipCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x0b: {
        n: "ScaleCrop",
        t: $3ee4f50b1ae43a89$var$VT_BOOL
    },
    /*::[*/ 0x0c: {
        n: "HeadingPairs",
        t: $3ee4f50b1ae43a89$var$VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ 
    },
    /*::[*/ 0x0d: {
        n: "TitlesOfParts",
        t: $3ee4f50b1ae43a89$var$VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ 
    },
    /*::[*/ 0x0e: {
        n: "Manager",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x0f: {
        n: "Company",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x10: {
        n: "LinksUpToDate",
        t: $3ee4f50b1ae43a89$var$VT_BOOL
    },
    /*::[*/ 0x11: {
        n: "CharacterCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x13: {
        n: "SharedDoc",
        t: $3ee4f50b1ae43a89$var$VT_BOOL
    },
    /*::[*/ 0x16: {
        n: "HyperlinksChanged",
        t: $3ee4f50b1ae43a89$var$VT_BOOL
    },
    /*::[*/ 0x17: {
        n: "AppVersion",
        t: $3ee4f50b1ae43a89$var$VT_I4,
        p: "version"
    },
    /*::[*/ 0x18: {
        n: "DigSig",
        t: $3ee4f50b1ae43a89$var$VT_BLOB
    },
    /*::[*/ 0x1A: {
        n: "ContentType",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x1B: {
        n: "ContentStatus",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x1C: {
        n: "Language",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x1D: {
        n: "Version",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0xFF: {},
    /* [MS-OLEPS] 2.18 */ /*::[*/ 0x80000000: {
        n: "Locale",
        t: $3ee4f50b1ae43a89$var$VT_UI4
    },
    /*::[*/ 0x80000003: {
        n: "Behavior",
        t: $3ee4f50b1ae43a89$var$VT_UI4
    },
    /*::[*/ 0x72627262: {}
};
/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */ var $3ee4f50b1ae43a89$var$SummaryPIDSI = {
    /*::[*/ 0x01: {
        n: "CodePage",
        t: $3ee4f50b1ae43a89$var$VT_I2
    },
    /*::[*/ 0x02: {
        n: "Title",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x03: {
        n: "Subject",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x04: {
        n: "Author",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x05: {
        n: "Keywords",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x06: {
        n: "Comments",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x07: {
        n: "Template",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x08: {
        n: "LastAuthor",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x09: {
        n: "RevNumber",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x0A: {
        n: "EditTime",
        t: $3ee4f50b1ae43a89$var$VT_FILETIME
    },
    /*::[*/ 0x0B: {
        n: "LastPrinted",
        t: $3ee4f50b1ae43a89$var$VT_FILETIME
    },
    /*::[*/ 0x0C: {
        n: "CreatedDate",
        t: $3ee4f50b1ae43a89$var$VT_FILETIME
    },
    /*::[*/ 0x0D: {
        n: "ModifiedDate",
        t: $3ee4f50b1ae43a89$var$VT_FILETIME
    },
    /*::[*/ 0x0E: {
        n: "PageCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x0F: {
        n: "WordCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x10: {
        n: "CharCount",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0x11: {
        n: "Thumbnail",
        t: $3ee4f50b1ae43a89$var$VT_CF
    },
    /*::[*/ 0x12: {
        n: "Application",
        t: $3ee4f50b1ae43a89$var$VT_STRING
    },
    /*::[*/ 0x13: {
        n: "DocSecurity",
        t: $3ee4f50b1ae43a89$var$VT_I4
    },
    /*::[*/ 0xFF: {},
    /* [MS-OLEPS] 2.18 */ /*::[*/ 0x80000000: {
        n: "Locale",
        t: $3ee4f50b1ae43a89$var$VT_UI4
    },
    /*::[*/ 0x80000003: {
        n: "Behavior",
        t: $3ee4f50b1ae43a89$var$VT_UI4
    },
    /*::[*/ 0x72627262: {}
};
/* [MS-XLS] 2.4.63 Country/Region codes */ var $3ee4f50b1ae43a89$var$CountryEnum = {
    /*::[*/ 0x0001: "US",
    /*::[*/ 0x0002: "CA",
    /*::[*/ 0x0003: "",
    /*::[*/ 0x0007: "RU",
    /*::[*/ 0x0014: "EG",
    /*::[*/ 0x001E: "GR",
    /*::[*/ 0x001F: "NL",
    /*::[*/ 0x0020: "BE",
    /*::[*/ 0x0021: "FR",
    /*::[*/ 0x0022: "ES",
    /*::[*/ 0x0024: "HU",
    /*::[*/ 0x0027: "IT",
    /*::[*/ 0x0029: "CH",
    /*::[*/ 0x002B: "AT",
    /*::[*/ 0x002C: "GB",
    /*::[*/ 0x002D: "DK",
    /*::[*/ 0x002E: "SE",
    /*::[*/ 0x002F: "NO",
    /*::[*/ 0x0030: "PL",
    /*::[*/ 0x0031: "DE",
    /*::[*/ 0x0034: "MX",
    /*::[*/ 0x0037: "BR",
    /*::[*/ 0x003d: "AU",
    /*::[*/ 0x0040: "NZ",
    /*::[*/ 0x0042: "TH",
    /*::[*/ 0x0051: "JP",
    /*::[*/ 0x0052: "KR",
    /*::[*/ 0x0054: "VN",
    /*::[*/ 0x0056: "CN",
    /*::[*/ 0x005A: "TR",
    /*::[*/ 0x0069: "JS",
    /*::[*/ 0x00D5: "DZ",
    /*::[*/ 0x00D8: "MA",
    /*::[*/ 0x00DA: "LY",
    /*::[*/ 0x015F: "PT",
    /*::[*/ 0x0162: "IS",
    /*::[*/ 0x0166: "FI",
    /*::[*/ 0x01A4: "CZ",
    /*::[*/ 0x0376: "TW",
    /*::[*/ 0x03C1: "LB",
    /*::[*/ 0x03C2: "JO",
    /*::[*/ 0x03C3: "SY",
    /*::[*/ 0x03C4: "IQ",
    /*::[*/ 0x03C5: "KW",
    /*::[*/ 0x03C6: "SA",
    /*::[*/ 0x03CB: "AE",
    /*::[*/ 0x03CC: "IL",
    /*::[*/ 0x03CE: "QA",
    /*::[*/ 0x03D5: "IR",
    /*::[*/ 0xFFFF: "US" // United States
};
/* [MS-XLS] 2.5.127 */ var $3ee4f50b1ae43a89$var$XLSFillPattern = [
    null,
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
function $3ee4f50b1ae43a89$var$rgbify(arr /*:Array<number>*/ ) /*:Array<[number, number, number]>*/ {
    return arr.map(function(x) {
        return [
            x >> 16 & 255,
            x >> 8 & 255,
            x & 255
        ];
    });
}
/* [MS-XLS] 2.5.161 */ /* [MS-XLSB] 2.5.75 Icv */ var $3ee4f50b1ae43a89$var$_XLSIcv = /*#__PURE__*/ $3ee4f50b1ae43a89$var$rgbify([
    /* Color Constants */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    /* Overridable Defaults */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    0x800000,
    0x008000,
    0x000080,
    0x808000,
    0x800080,
    0x008080,
    0xC0C0C0,
    0x808080,
    0x9999FF,
    0x993366,
    0xFFFFCC,
    0xCCFFFF,
    0x660066,
    0xFF8080,
    0x0066CC,
    0xCCCCFF,
    0x000080,
    0xFF00FF,
    0xFFFF00,
    0x00FFFF,
    0x800080,
    0x800000,
    0x008080,
    0x0000FF,
    0x00CCFF,
    0xCCFFFF,
    0xCCFFCC,
    0xFFFF99,
    0x99CCFF,
    0xFF99CC,
    0xCC99FF,
    0xFFCC99,
    0x3366FF,
    0x33CCCC,
    0x99CC00,
    0xFFCC00,
    0xFF9900,
    0xFF6600,
    0x666699,
    0x969696,
    0x003366,
    0x339966,
    0x003300,
    0x333300,
    0x993300,
    0x993366,
    0x333399,
    0x333333,
    /* Other entries to appease BIFF8/12 */ 0xFFFFFF,
    /* 0x40 icvForeground ?? */ 0x000000,
    /* 0x41 icvBackground ?? */ 0x000000,
    /* 0x42 icvFrame ?? */ 0x000000,
    /* 0x43 icv3D ?? */ 0x000000,
    /* 0x44 icv3DText ?? */ 0x000000,
    /* 0x45 icv3DHilite ?? */ 0x000000,
    /* 0x46 icv3DShadow ?? */ 0x000000,
    /* 0x47 icvHilite ?? */ 0x000000,
    /* 0x48 icvCtlText ?? */ 0x000000,
    /* 0x49 icvCtlScrl ?? */ 0x000000,
    /* 0x4A icvCtlInv ?? */ 0x000000,
    /* 0x4B icvCtlBody ?? */ 0x000000,
    /* 0x4C icvCtlFrame ?? */ 0x000000,
    /* 0x4D icvCtlFore ?? */ 0x000000,
    /* 0x4E icvCtlBack ?? */ 0x000000,
    /* 0x4F icvCtlNeutral */ 0x000000,
    /* 0x50 icvInfoBk ?? */ 0x000000 /* 0x51 icvInfoText ?? */ 
]);
var $3ee4f50b1ae43a89$var$XLSIcv = /*#__PURE__*/ $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$_XLSIcv);
/* [MS-XLSB] 2.5.97.2 */ var $3ee4f50b1ae43a89$var$BErr = {
    /*::[*/ 0x00: "#NULL!",
    /*::[*/ 0x07: "#DIV/0!",
    /*::[*/ 0x0F: "#VALUE!",
    /*::[*/ 0x17: "#REF!",
    /*::[*/ 0x1D: "#NAME?",
    /*::[*/ 0x24: "#NUM!",
    /*::[*/ 0x2A: "#N/A",
    /*::[*/ 0x2B: "#GETTING_DATA",
    /*::[*/ 0xFF: "#WTF?"
};
//var RBErr = evert_num(BErr);
var $3ee4f50b1ae43a89$var$RBErr = {
    "#NULL!": 0x00,
    "#DIV/0!": 0x07,
    "#VALUE!": 0x0F,
    "#REF!": 0x17,
    "#NAME?": 0x1D,
    "#NUM!": 0x24,
    "#N/A": 0x2A,
    "#GETTING_DATA": 0x2B,
    "#WTF?": 0xFF
};
/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */ /* 12.3 Part Summary <SpreadsheetML> */ /* 14.2 Part Summary <DrawingML> */ /* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */ var $3ee4f50b1ae43a89$var$ct2type /*{[string]:string}*/  = {
    /* Workbook */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
    "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
    /* Worksheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
    "application/vnd.ms-excel.worksheet": "sheets",
    "application/vnd.ms-excel.binIndexWs": "TODO",
    /* Binary Index */ /* Chartsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
    "application/vnd.ms-excel.chartsheet": "charts",
    /* Macrosheet */ "application/vnd.ms-excel.macrosheet+xml": "macros",
    "application/vnd.ms-excel.macrosheet": "macros",
    "application/vnd.ms-excel.intlmacrosheet": "TODO",
    "application/vnd.ms-excel.binIndexMs": "TODO",
    /* Binary Index */ /* Dialogsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
    "application/vnd.ms-excel.dialogsheet": "dialogs",
    /* Shared Strings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
    "application/vnd.ms-excel.sharedStrings": "strs",
    /* Styles */ "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
    "application/vnd.ms-excel.styles": "styles",
    /* File Properties */ "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
    "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
    "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
    /* Custom Data Properties */ "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
    /* Comments */ "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
    "application/vnd.ms-excel.comments": "comments",
    "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
    "application/vnd.ms-excel.person+xml": "people",
    /* Metadata (Stock/Geography and Dynamic Array) */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
    "application/vnd.ms-excel.sheetMetadata": "metadata",
    /* PivotTable */ "application/vnd.ms-excel.pivotTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
    /* Chart Objects */ "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
    /* Chart Colors */ "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
    /* Chart Style */ "application/vnd.ms-office.chartstyle+xml": "TODO",
    /* Chart Advanced */ "application/vnd.ms-office.chartex+xml": "TODO",
    /* Calculation Chain */ "application/vnd.ms-excel.calcChain": "calcchains",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
    /* Printer Settings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
    /* ActiveX */ "application/vnd.ms-office.activeX": "TODO",
    "application/vnd.ms-office.activeX+xml": "TODO",
    /* Custom Toolbars */ "application/vnd.ms-excel.attachedToolbars": "TODO",
    /* External Data Connections */ "application/vnd.ms-excel.connections": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
    /* External Links */ "application/vnd.ms-excel.externalLink": "links",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
    /* PivotCache */ "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
    "application/vnd.ms-excel.pivotCacheRecords": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
    /* Query Table */ "application/vnd.ms-excel.queryTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
    /* Shared Workbook */ "application/vnd.ms-excel.userNames": "TODO",
    "application/vnd.ms-excel.revisionHeaders": "TODO",
    "application/vnd.ms-excel.revisionLog": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
    /* Single Cell Table */ "application/vnd.ms-excel.tableSingleCells": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
    /* Slicer */ "application/vnd.ms-excel.slicer": "TODO",
    "application/vnd.ms-excel.slicerCache": "TODO",
    "application/vnd.ms-excel.slicer+xml": "TODO",
    "application/vnd.ms-excel.slicerCache+xml": "TODO",
    /* Sort Map */ "application/vnd.ms-excel.wsSortMap": "TODO",
    /* Table */ "application/vnd.ms-excel.table": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
    /* Themes */ "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
    /* Theme Override */ "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
    /* Timeline */ "application/vnd.ms-excel.Timeline+xml": "TODO",
    /* verify */ "application/vnd.ms-excel.TimelineCache+xml": "TODO",
    /* verify */ /* VBA */ "application/vnd.ms-office.vbaProject": "vba",
    "application/vnd.ms-office.vbaProjectSignature": "TODO",
    /* Volatile Dependencies */ "application/vnd.ms-office.volatileDependencies": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
    /* Control Properties */ "application/vnd.ms-excel.controlproperties+xml": "TODO",
    /* Data Model */ "application/vnd.openxmlformats-officedocument.model+data": "TODO",
    /* Survey */ "application/vnd.ms-excel.Survey+xml": "TODO",
    /* Drawing */ "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
    "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
    /* VML */ "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
    "application/vnd.openxmlformats-package.relationships+xml": "rels",
    "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
    /* Image */ "image/png": "TODO",
    "sheet": "js"
} /*:any*/ ;
var $3ee4f50b1ae43a89$var$CT_LIST = {
    workbooks: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
        xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
        xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
        xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
        xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
    },
    strs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
        xlsb: "application/vnd.ms-excel.sharedStrings"
    },
    comments: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
        xlsb: "application/vnd.ms-excel.comments"
    },
    sheets: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
        xlsb: "application/vnd.ms-excel.worksheet"
    },
    charts: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
        xlsb: "application/vnd.ms-excel.chartsheet"
    },
    dialogs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
        xlsb: "application/vnd.ms-excel.dialogsheet"
    },
    macros: {
        xlsx: "application/vnd.ms-excel.macrosheet+xml",
        xlsb: "application/vnd.ms-excel.macrosheet"
    },
    metadata: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
        xlsb: "application/vnd.ms-excel.sheetMetadata"
    },
    styles: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
        xlsb: "application/vnd.ms-excel.styles"
    }
};
function $3ee4f50b1ae43a89$var$new_ct() /*:any*/ {
    return {
        workbooks: [],
        sheets: [],
        charts: [],
        dialogs: [],
        macros: [],
        rels: [],
        strs: [],
        comments: [],
        threadedcomments: [],
        links: [],
        coreprops: [],
        extprops: [],
        custprops: [],
        themes: [],
        styles: [],
        calcchains: [],
        vba: [],
        drawings: [],
        metadata: [],
        people: [],
        TODO: [],
        xmlns: ""
    } /*:any*/ ;
}
function $3ee4f50b1ae43a89$var$parse_ct(data /*:?string*/ ) {
    var ct = $3ee4f50b1ae43a89$var$new_ct();
    if (!data || !data.match) return ct;
    var ctext = {};
    (data.match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch(y[0].replace($3ee4f50b1ae43a89$var$nsregex, "<")){
            case "<?xml":
                break;
            case "<Types":
                ct.xmlns = y["xmlns" + (y[0].match(/<(\w+):/) || [
                    "",
                    ""
                ])[1]];
                break;
            case "<Default":
                ctext[y.Extension] = y.ContentType;
                break;
            case "<Override":
                if (ct[$3ee4f50b1ae43a89$var$ct2type[y.ContentType]] !== undefined) ct[$3ee4f50b1ae43a89$var$ct2type[y.ContentType]].push(y.PartName);
                break;
        }
    });
    if (ct.xmlns !== $3ee4f50b1ae43a89$var$XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
    ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
    ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
    ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
    ct.defaults = ctext;
    delete ct.calcchains;
    return ct;
}
function $3ee4f50b1ae43a89$var$write_ct(ct, opts) /*:string*/ {
    var type2ct /*{[string]:Array<string>}*/  = $3ee4f50b1ae43a89$var$evert_arr($3ee4f50b1ae43a89$var$ct2type);
    var o /*:Array<string>*/  = [], v;
    o[o.length] = $3ee4f50b1ae43a89$var$XML_HEADER;
    o[o.length] = $3ee4f50b1ae43a89$var$writextag("Types", null, {
        "xmlns": $3ee4f50b1ae43a89$var$XMLNS.CT,
        "xmlns:xsd": $3ee4f50b1ae43a89$var$XMLNS.xsd,
        "xmlns:xsi": $3ee4f50b1ae43a89$var$XMLNS.xsi
    });
    o = o.concat([
        [
            "xml",
            "application/xml"
        ],
        [
            "bin",
            "application/vnd.ms-excel.sheet.binary.macroEnabled.main"
        ],
        [
            "vml",
            "application/vnd.openxmlformats-officedocument.vmlDrawing"
        ],
        [
            "data",
            "application/vnd.openxmlformats-officedocument.model+data"
        ],
        /* from test files */ [
            "bmp",
            "image/bmp"
        ],
        [
            "png",
            "image/png"
        ],
        [
            "gif",
            "image/gif"
        ],
        [
            "emf",
            "image/x-emf"
        ],
        [
            "wmf",
            "image/x-wmf"
        ],
        [
            "jpg",
            "image/jpeg"
        ],
        [
            "jpeg",
            "image/jpeg"
        ],
        [
            "tif",
            "image/tiff"
        ],
        [
            "tiff",
            "image/tiff"
        ],
        [
            "pdf",
            "application/pdf"
        ],
        [
            "rels",
            "application/vnd.openxmlformats-package.relationships+xml"
        ]
    ].map(function(x) {
        return $3ee4f50b1ae43a89$var$writextag("Default", null, {
            "Extension": x[0],
            "ContentType": x[1]
        });
    }));
    /* only write first instance */ var f1 = function(w) {
        if (ct[w] && ct[w].length > 0) {
            v = ct[w][0];
            o[o.length] = $3ee4f50b1ae43a89$var$writextag("Override", null, {
                "PartName": (v[0] == "/" ? "" : "/") + v,
                "ContentType": $3ee4f50b1ae43a89$var$CT_LIST[w][opts.bookType] || $3ee4f50b1ae43a89$var$CT_LIST[w]["xlsx"]
            });
        }
    };
    /* book type-specific */ var f2 = function(w) {
        (ct[w] || []).forEach(function(v) {
            o[o.length] = $3ee4f50b1ae43a89$var$writextag("Override", null, {
                "PartName": (v[0] == "/" ? "" : "/") + v,
                "ContentType": $3ee4f50b1ae43a89$var$CT_LIST[w][opts.bookType] || $3ee4f50b1ae43a89$var$CT_LIST[w]["xlsx"]
            });
        });
    };
    /* standard type */ var f3 = function(t) {
        (ct[t] || []).forEach(function(v) {
            o[o.length] = $3ee4f50b1ae43a89$var$writextag("Override", null, {
                "PartName": (v[0] == "/" ? "" : "/") + v,
                "ContentType": type2ct[t][0]
            });
        });
    };
    f1("workbooks");
    f2("sheets");
    f2("charts");
    f3("themes");
    [
        "strs",
        "styles"
    ].forEach(f1);
    [
        "coreprops",
        "extprops",
        "custprops"
    ].forEach(f3);
    f3("vba");
    f3("comments");
    f3("threadedcomments");
    f3("drawings");
    f2("metadata");
    f3("people");
    if (o.length > 2) {
        o[o.length] = "</Types>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 9.3 Relationships */ var $3ee4f50b1ae43a89$var$RELS = {
    WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
    VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
    XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
    XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
    XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
    CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
    CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
    CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties",
    SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
    STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
    THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
    CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
    CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
    CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
    WS: [
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
        "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
    ],
    DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
    MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
    IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
    DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
    XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
    TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
    PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
    VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
} /*:any*/ ;
/* 9.3.3 Representing Relationships */ function $3ee4f50b1ae43a89$var$get_rels_path(file /*:string*/ ) /*:string*/ {
    var n = file.lastIndexOf("/");
    return file.slice(0, n + 1) + "_rels/" + file.slice(n + 1) + ".rels";
}
function $3ee4f50b1ae43a89$var$parse_rels(data /*:?string*/ , currentFilePath /*:string*/ ) {
    var rels = {
        "!id": {}
    };
    if (!data) return rels;
    if (currentFilePath.charAt(0) !== "/") currentFilePath = "/" + currentFilePath;
    var hash = {};
    (data.match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        /* 9.3.2.2 OPC_Relationships */ if (y[0] === "<Relationship") {
            var rel = {};
            rel.Type = y.Type;
            rel.Target = y.Target;
            rel.Id = y.Id;
            if (y.TargetMode) rel.TargetMode = y.TargetMode;
            var canonictarget = y.TargetMode === "External" ? y.Target : $3ee4f50b1ae43a89$var$resolve_path(y.Target, currentFilePath);
            rels[canonictarget] = rel;
            hash[y.Id] = rel;
        }
    });
    rels["!id"] = hash;
    return rels;
}
/* TODO */ function $3ee4f50b1ae43a89$var$write_rels(rels) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag("Relationships", null, {
            //'xmlns:ns0': XMLNS.RELS,
            "xmlns": $3ee4f50b1ae43a89$var$XMLNS.RELS
        })
    ];
    $3ee4f50b1ae43a89$var$keys(rels["!id"]).forEach(function(rid) {
        o[o.length] = $3ee4f50b1ae43a89$var$writextag("Relationship", null, rels["!id"][rid]);
    });
    if (o.length > 2) {
        o[o.length] = "</Relationships>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
function $3ee4f50b1ae43a89$var$add_rels(rels, rId /*:number*/ , f, type, relobj, targetmode /*:?string*/ ) /*:number*/ {
    if (!relobj) relobj = {};
    if (!rels["!id"]) rels["!id"] = {};
    if (!rels["!idx"]) rels["!idx"] = 1;
    if (rId < 0) for(rId = rels["!idx"]; rels["!id"]["rId" + rId]; ++rId);
    rels["!idx"] = rId + 1;
    relobj.Id = "rId" + rId;
    relobj.Type = type;
    relobj.Target = f;
    if (targetmode) relobj.TargetMode = targetmode;
    else if ([
        $3ee4f50b1ae43a89$var$RELS.HLINK,
        $3ee4f50b1ae43a89$var$RELS.XPATH,
        $3ee4f50b1ae43a89$var$RELS.XMISS
    ].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
    if (rels["!id"][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
    rels["!id"][relobj.Id] = relobj;
    rels[("/" + relobj.Target).replace("//", "/")] = relobj;
    return rId;
}
/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */ /* Part 3 Section 4 Manifest File */ var $3ee4f50b1ae43a89$var$CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function $3ee4f50b1ae43a89$var$parse_manifest(d, opts) {
    var str = $3ee4f50b1ae43a89$var$xlml_normalize(d);
    var Rn;
    var FEtag;
    while(Rn = $3ee4f50b1ae43a89$var$xlmlregex.exec(str))switch(Rn[3]){
        case "manifest":
            break; // 4.2 <manifest:manifest>
        case "file-entry":
            FEtag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            if (FEtag.path == "/" && FEtag.type !== $3ee4f50b1ae43a89$var$CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
            break;
        case "encryption-data":
        case "algorithm":
        case "start-key-generation":
        case "key-derivation":
            throw new Error("Unsupported ODS Encryption");
        default:
            if (opts && opts.WTF) throw Rn;
    }
}
function $3ee4f50b1ae43a89$var$write_manifest(manifest /*:Array<Array<string> >*/ ) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER
    ];
    o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
    o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
    for(var i = 0; i < manifest.length; ++i)o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
    o.push("</manifest:manifest>");
    return o.join("");
}
/* Part 3 Section 6 Metadata Manifest File */ function $3ee4f50b1ae43a89$var$write_rdf_type(file /*:string*/ , res /*:string*/ , tag /*:?string*/ ) {
    return [
        '  <rdf:Description rdf:about="' + file + '">\n',
        '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + "#" + res + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $3ee4f50b1ae43a89$var$write_rdf_has(base /*:string*/ , file /*:string*/ ) {
    return [
        '  <rdf:Description rdf:about="' + base + '">\n',
        '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $3ee4f50b1ae43a89$var$write_rdf(rdf) {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER
    ];
    o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
    for(var i = 0; i != rdf.length; ++i){
        o.push($3ee4f50b1ae43a89$var$write_rdf_type(rdf[i][0], rdf[i][1]));
        o.push($3ee4f50b1ae43a89$var$write_rdf_has("", rdf[i][0]));
    }
    o.push($3ee4f50b1ae43a89$var$write_rdf_type("", "Document", "pkg"));
    o.push("</rdf:RDF>");
    return o.join("");
}
/* TODO: pull properties */ function $3ee4f50b1ae43a89$var$write_meta_ods() /*:string*/ {
    return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + $3ee4f50b1ae43a89$var$XLSX.version + "</meta:generator></office:meta></office:document-meta>";
}
/* ECMA-376 Part II 11.1 Core Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $3ee4f50b1ae43a89$var$CORE_PROPS /*:Array<Array<string> >*/  = [
    [
        "cp:category",
        "Category"
    ],
    [
        "cp:contentStatus",
        "ContentStatus"
    ],
    [
        "cp:keywords",
        "Keywords"
    ],
    [
        "cp:lastModifiedBy",
        "LastAuthor"
    ],
    [
        "cp:lastPrinted",
        "LastPrinted"
    ],
    [
        "cp:revision",
        "RevNumber"
    ],
    [
        "cp:version",
        "Version"
    ],
    [
        "dc:creator",
        "Author"
    ],
    [
        "dc:description",
        "Comments"
    ],
    [
        "dc:identifier",
        "Identifier"
    ],
    [
        "dc:language",
        "Language"
    ],
    [
        "dc:subject",
        "Subject"
    ],
    [
        "dc:title",
        "Title"
    ],
    [
        "dcterms:created",
        "CreatedDate",
        "date"
    ],
    [
        "dcterms:modified",
        "ModifiedDate",
        "date"
    ]
];
var $3ee4f50b1ae43a89$var$CORE_PROPS_REGEX /*:Array<RegExp>*/  = /*#__PURE__*/ function() {
    var r = new Array($3ee4f50b1ae43a89$var$CORE_PROPS.length);
    for(var i = 0; i < $3ee4f50b1ae43a89$var$CORE_PROPS.length; ++i){
        var f = $3ee4f50b1ae43a89$var$CORE_PROPS[i];
        var g = "(?:" + f[0].slice(0, f[0].indexOf(":")) + ":)" + f[0].slice(f[0].indexOf(":") + 1);
        r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)</" + g + ">");
    }
    return r;
}();
function $3ee4f50b1ae43a89$var$parse_core_props(data) {
    var p = {};
    data = $3ee4f50b1ae43a89$var$utf8read(data);
    for(var i = 0; i < $3ee4f50b1ae43a89$var$CORE_PROPS.length; ++i){
        var f = $3ee4f50b1ae43a89$var$CORE_PROPS[i], cur = data.match($3ee4f50b1ae43a89$var$CORE_PROPS_REGEX[i]);
        if (cur != null && cur.length > 0) p[f[1]] = $3ee4f50b1ae43a89$var$unescapexml(cur[1]);
        if (f[2] === "date" && p[f[1]]) p[f[1]] = $3ee4f50b1ae43a89$var$parseDate(p[f[1]]);
    }
    return p;
}
function $3ee4f50b1ae43a89$var$cp_doit(f, g, h, o, p) {
    if (p[f] != null || g == null || g === "") return;
    p[f] = g;
    g = $3ee4f50b1ae43a89$var$escapexml(g);
    o[o.length] = h ? $3ee4f50b1ae43a89$var$writextag(f, g, h) : $3ee4f50b1ae43a89$var$writetag(f, g);
}
function $3ee4f50b1ae43a89$var$write_core_props(cp, _opts) {
    var opts = _opts || {};
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag("cp:coreProperties", null, {
            //'xmlns': XMLNS.CORE_PROPS,
            "xmlns:cp": $3ee4f50b1ae43a89$var$XMLNS.CORE_PROPS,
            "xmlns:dc": $3ee4f50b1ae43a89$var$XMLNS.dc,
            "xmlns:dcterms": $3ee4f50b1ae43a89$var$XMLNS.dcterms,
            "xmlns:dcmitype": $3ee4f50b1ae43a89$var$XMLNS.dcmitype,
            "xmlns:xsi": $3ee4f50b1ae43a89$var$XMLNS.xsi
        })
    ], p = {};
    if (!cp && !opts.Props) return o.join("");
    if (cp) {
        if (cp.CreatedDate != null) $3ee4f50b1ae43a89$var$cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : $3ee4f50b1ae43a89$var$write_w3cdtf(cp.CreatedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
        if (cp.ModifiedDate != null) $3ee4f50b1ae43a89$var$cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : $3ee4f50b1ae43a89$var$write_w3cdtf(cp.ModifiedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
    }
    for(var i = 0; i != $3ee4f50b1ae43a89$var$CORE_PROPS.length; ++i){
        var f = $3ee4f50b1ae43a89$var$CORE_PROPS[i];
        var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
        if (v === true) v = "1";
        else if (v === false) v = "0";
        else if (typeof v == "number") v = String(v);
        if (v != null) $3ee4f50b1ae43a89$var$cp_doit(f[0], v, null, o, p);
    }
    if (o.length > 2) {
        o[o.length] = "</cp:coreProperties>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $3ee4f50b1ae43a89$var$EXT_PROPS /*:Array<Array<string> >*/  = [
    [
        "Application",
        "Application",
        "string"
    ],
    [
        "AppVersion",
        "AppVersion",
        "string"
    ],
    [
        "Company",
        "Company",
        "string"
    ],
    [
        "DocSecurity",
        "DocSecurity",
        "string"
    ],
    [
        "Manager",
        "Manager",
        "string"
    ],
    [
        "HyperlinksChanged",
        "HyperlinksChanged",
        "bool"
    ],
    [
        "SharedDoc",
        "SharedDoc",
        "bool"
    ],
    [
        "LinksUpToDate",
        "LinksUpToDate",
        "bool"
    ],
    [
        "ScaleCrop",
        "ScaleCrop",
        "bool"
    ],
    [
        "HeadingPairs",
        "HeadingPairs",
        "raw"
    ],
    [
        "TitlesOfParts",
        "TitlesOfParts",
        "raw"
    ]
];
var $3ee4f50b1ae43a89$var$PseudoPropsPairs = [
    "Worksheets",
    "SheetNames",
    "NamedRanges",
    "DefinedNames",
    "Chartsheets",
    "ChartNames"
];
function $3ee4f50b1ae43a89$var$load_props_pairs(HP /*:string|Array<Array<any>>*/ , TOP, props, opts) {
    var v = [];
    if (typeof HP == "string") v = $3ee4f50b1ae43a89$var$parseVector(HP, opts);
    else for(var j = 0; j < HP.length; ++j)v = v.concat(HP[j].map(function(hp) {
        return {
            v: hp
        };
    }));
    var parts = typeof TOP == "string" ? $3ee4f50b1ae43a89$var$parseVector(TOP, opts).map(function(x) {
        return x.v;
    }) : TOP;
    var idx = 0, len = 0;
    if (parts.length > 0) for(var i = 0; i !== v.length; i += 2){
        len = +v[i + 1].v;
        switch(v[i].v){
            case "Worksheets":
            case "\u5DE5\u4F5C\u8868":
            case "\u041B\u0438\u0441\u0442\u044B":
            case "\u0623\u0648\u0631\u0627\u0642 \u0627\u0644\u0639\u0645\u0644":
            case "\u30EF\u30FC\u30AF\u30B7\u30FC\u30C8":
            case "\u05D2\u05DC\u05D9\u05D5\u05E0\u05D5\u05EA \u05E2\u05D1\u05D5\u05D3\u05D4":
            case "Arbeitsbl\xe4tter":
            case "\xc7al\u0131\u015Fma Sayfalar\u0131":
            case "Feuilles de calcul":
            case "Fogli di lavoro":
            case "Folhas de c\xe1lculo":
            case "Planilhas":
            case "Regneark":
            case "Hojas de c\xe1lculo":
            case "Werkbladen":
                props.Worksheets = len;
                props.SheetNames = parts.slice(idx, idx + len);
                break;
            case "Named Ranges":
            case "Rangos con nombre":
            case "\u540D\u524D\u4ED8\u304D\u4E00\u89A7":
            case "Benannte Bereiche":
            case "Navngivne omr\xe5der":
                props.NamedRanges = len;
                props.DefinedNames = parts.slice(idx, idx + len);
                break;
            case "Charts":
            case "Diagramme":
                props.Chartsheets = len;
                props.ChartNames = parts.slice(idx, idx + len);
                break;
        }
        idx += len;
    }
}
function $3ee4f50b1ae43a89$var$parse_ext_props(data, p, opts) {
    var q = {};
    if (!p) p = {};
    data = $3ee4f50b1ae43a89$var$utf8read(data);
    $3ee4f50b1ae43a89$var$EXT_PROPS.forEach(function(f) {
        var xml = (data.match($3ee4f50b1ae43a89$var$matchtag(f[0])) || [])[1];
        switch(f[2]){
            case "string":
                if (xml) p[f[1]] = $3ee4f50b1ae43a89$var$unescapexml(xml);
                break;
            case "bool":
                p[f[1]] = xml === "true";
                break;
            case "raw":
                var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)</" + f[0] + ">"));
                if (cur && cur.length > 0) q[f[1]] = cur[1];
                break;
        }
    });
    if (q.HeadingPairs && q.TitlesOfParts) $3ee4f50b1ae43a89$var$load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
    return p;
}
function $3ee4f50b1ae43a89$var$write_ext_props(cp /*::, opts*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], W = $3ee4f50b1ae43a89$var$writextag;
    if (!cp) cp = {};
    cp.Application = "SheetJS";
    o[o.length] = $3ee4f50b1ae43a89$var$XML_HEADER;
    o[o.length] = $3ee4f50b1ae43a89$var$writextag("Properties", null, {
        "xmlns": $3ee4f50b1ae43a89$var$XMLNS.EXT_PROPS,
        "xmlns:vt": $3ee4f50b1ae43a89$var$XMLNS.vt
    });
    $3ee4f50b1ae43a89$var$EXT_PROPS.forEach(function(f) {
        if (cp[f[1]] === undefined) return;
        var v;
        switch(f[2]){
            case "string":
                v = $3ee4f50b1ae43a89$var$escapexml(String(cp[f[1]]));
                break;
            case "bool":
                v = cp[f[1]] ? "true" : "false";
                break;
        }
        if (v !== undefined) o[o.length] = W(f[0], v);
    });
    /* TODO: HeadingPairs, TitlesOfParts */ o[o.length] = W("HeadingPairs", W("vt:vector", W("vt:variant", "<vt:lpstr>Worksheets</vt:lpstr>") + W("vt:variant", W("vt:i4", String(cp.Worksheets))), {
        size: 2,
        baseType: "variant"
    }));
    o[o.length] = W("TitlesOfParts", W("vt:vector", cp.SheetNames.map(function(s) {
        return "<vt:lpstr>" + $3ee4f50b1ae43a89$var$escapexml(s) + "</vt:lpstr>";
    }).join(""), {
        size: cp.Worksheets,
        baseType: "lpstr"
    }));
    if (o.length > 2) {
        o[o.length] = "</Properties>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */ var $3ee4f50b1ae43a89$var$custregex = /<[^>]+>[^<]*/g;
function $3ee4f50b1ae43a89$var$parse_cust_props(data /*:string*/ , opts) {
    var p = {}, name = "";
    var m = data.match($3ee4f50b1ae43a89$var$custregex);
    if (m) for(var i = 0; i != m.length; ++i){
        var x = m[i], y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch(y[0]){
            case "<?xml":
                break;
            case "<Properties":
                break;
            case "<property":
                name = $3ee4f50b1ae43a89$var$unescapexml(y.name);
                break;
            case "</property>":
                name = null;
                break;
            default:
                if (x.indexOf("<vt:") === 0) {
                    var toks = x.split(">");
                    var type = toks[0].slice(4), text = toks[1];
                    /* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */ switch(type){
                        case "lpstr":
                        case "bstr":
                        case "lpwstr":
                            p[name] = $3ee4f50b1ae43a89$var$unescapexml(text);
                            break;
                        case "bool":
                            p[name] = $3ee4f50b1ae43a89$var$parsexmlbool(text);
                            break;
                        case "i1":
                        case "i2":
                        case "i4":
                        case "i8":
                        case "int":
                        case "uint":
                            p[name] = parseInt(text, 10);
                            break;
                        case "r4":
                        case "r8":
                        case "decimal":
                            p[name] = parseFloat(text);
                            break;
                        case "filetime":
                        case "date":
                            p[name] = $3ee4f50b1ae43a89$var$parseDate(text);
                            break;
                        case "cy":
                        case "error":
                            p[name] = $3ee4f50b1ae43a89$var$unescapexml(text);
                            break;
                        default:
                            if (type.slice(-1) == "/") break;
                            if (opts.WTF && typeof console !== "undefined") console.warn("Unexpected", x, type, toks);
                    }
                } else if (x.slice(0, 2) === "</") ;
                else if (opts.WTF) throw new Error(x);
        }
    }
    return p;
}
function $3ee4f50b1ae43a89$var$write_cust_props(cp /*::, opts*/ ) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag("Properties", null, {
            "xmlns": $3ee4f50b1ae43a89$var$XMLNS.CUST_PROPS,
            "xmlns:vt": $3ee4f50b1ae43a89$var$XMLNS.vt
        })
    ];
    if (!cp) return o.join("");
    var pid = 1;
    $3ee4f50b1ae43a89$var$keys(cp).forEach(function custprop(k) {
        ++pid;
        o[o.length] = $3ee4f50b1ae43a89$var$writextag("property", $3ee4f50b1ae43a89$var$write_vt(cp[k], true), {
            "fmtid": "{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",
            "pid": pid,
            "name": $3ee4f50b1ae43a89$var$escapexml(k)
        });
    });
    if (o.length > 2) {
        o[o.length] = "</Properties>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* Common Name -> XLML Name */ var $3ee4f50b1ae43a89$var$XLMLDocPropsMap = {
    Title: "Title",
    Subject: "Subject",
    Author: "Author",
    Keywords: "Keywords",
    Comments: "Description",
    LastAuthor: "LastAuthor",
    RevNumber: "Revision",
    Application: "AppName",
    /* TotalTime: 'TotalTime', */ LastPrinted: "LastPrinted",
    CreatedDate: "Created",
    ModifiedDate: "LastSaved",
    /* Pages */ /* Words */ /* Characters */ Category: "Category",
    /* PresentationFormat */ Manager: "Manager",
    Company: "Company",
    /* Guid */ /* HyperlinkBase */ /* Bytes */ /* Lines */ /* Paragraphs */ /* CharactersWithSpaces */ AppVersion: "Version",
    ContentStatus: "ContentStatus",
    /* NOTE: missing from schema */ Identifier: "Identifier",
    /* NOTE: missing from schema */ Language: "Language" /* NOTE: missing from schema */ 
};
var $3ee4f50b1ae43a89$var$evert_XLMLDPM;
function $3ee4f50b1ae43a89$var$xlml_set_prop(Props, tag /*:string*/ , val) {
    if (!$3ee4f50b1ae43a89$var$evert_XLMLDPM) $3ee4f50b1ae43a89$var$evert_XLMLDPM = $3ee4f50b1ae43a89$var$evert($3ee4f50b1ae43a89$var$XLMLDocPropsMap);
    tag = $3ee4f50b1ae43a89$var$evert_XLMLDPM[tag] || tag;
    Props[tag] = val;
}
function $3ee4f50b1ae43a89$var$xlml_write_docprops(Props, opts) {
    var o /*:Array<string>*/  = [];
    $3ee4f50b1ae43a89$var$keys($3ee4f50b1ae43a89$var$XLMLDocPropsMap).map(function(m) {
        for(var i = 0; i < $3ee4f50b1ae43a89$var$CORE_PROPS.length; ++i)if ($3ee4f50b1ae43a89$var$CORE_PROPS[i][1] == m) return $3ee4f50b1ae43a89$var$CORE_PROPS[i];
        for(i = 0; i < $3ee4f50b1ae43a89$var$EXT_PROPS.length; ++i)if ($3ee4f50b1ae43a89$var$EXT_PROPS[i][1] == m) return $3ee4f50b1ae43a89$var$EXT_PROPS[i];
        throw m;
    }).forEach(function(p) {
        if (Props[p[1]] == null) return;
        var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
        switch(p[2]){
            case "date":
                m = new Date(m).toISOString().replace(/\.\d*Z/, "Z");
                break;
        }
        if (typeof m == "number") m = String(m);
        else if (m === true || m === false) m = m ? "1" : "0";
        else if (m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/, "");
        o.push($3ee4f50b1ae43a89$var$writetag($3ee4f50b1ae43a89$var$XLMLDocPropsMap[p[1]] || p[1], m));
    });
    return $3ee4f50b1ae43a89$var$writextag("DocumentProperties", o.join(""), {
        xmlns: $3ee4f50b1ae43a89$var$XLMLNS.o
    });
}
function $3ee4f50b1ae43a89$var$xlml_write_custprops(Props, Custprops /*::, opts*/ ) {
    var BLACKLIST = [
        "Worksheets",
        "SheetNames"
    ];
    var T = "CustomDocumentProperties";
    var o /*:Array<string>*/  = [];
    if (Props) $3ee4f50b1ae43a89$var$keys(Props).forEach(function(k) {
        /*:: if(!Props) return; */ if (!Object.prototype.hasOwnProperty.call(Props, k)) return;
        for(var i = 0; i < $3ee4f50b1ae43a89$var$CORE_PROPS.length; ++i)if (k == $3ee4f50b1ae43a89$var$CORE_PROPS[i][1]) return;
        for(i = 0; i < $3ee4f50b1ae43a89$var$EXT_PROPS.length; ++i)if (k == $3ee4f50b1ae43a89$var$EXT_PROPS[i][1]) return;
        for(i = 0; i < BLACKLIST.length; ++i)if (k == BLACKLIST[i]) return;
        var m = Props[k];
        var t = "string";
        if (typeof m == "number") {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else m = String(m);
        o.push($3ee4f50b1ae43a89$var$writextag($3ee4f50b1ae43a89$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    if (Custprops) $3ee4f50b1ae43a89$var$keys(Custprops).forEach(function(k) {
        /*:: if(!Custprops) return; */ if (!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
        if (Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
        var m = Custprops[k];
        var t = "string";
        if (typeof m == "number") {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else if (m instanceof Date) {
            t = "dateTime.tz";
            m = m.toISOString();
        } else m = String(m);
        o.push($3ee4f50b1ae43a89$var$writextag($3ee4f50b1ae43a89$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    return "<" + T + ' xmlns="' + $3ee4f50b1ae43a89$var$XLMLNS.o + '">' + o.join("") + "</" + T + ">";
}
/* [MS-DTYP] 2.3.3 FILETIME */ /* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */ /* [MS-OLEPS] 2.8 FILETIME (Packet Version) */ function $3ee4f50b1ae43a89$var$parse_FILETIME(blob) {
    var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
    return new Date((dwHighDateTime / 1e7 * Math.pow(2, 32) + dwLowDateTime / 1e7 - 11644473600) * 1000).toISOString().replace(/\.000/, "");
}
function $3ee4f50b1ae43a89$var$write_FILETIME(time /*:string|Date*/ ) {
    var date = typeof time == "string" ? new Date(Date.parse(time)) : time;
    var t = date.getTime() / 1000 + 11644473600;
    var l = t % Math.pow(2, 32), h = (t - l) / Math.pow(2, 32);
    l *= 1e7;
    h *= 1e7;
    var w = l / Math.pow(2, 32) | 0;
    if (w > 0) {
        l = l % Math.pow(2, 32);
        h += w;
    }
    var o = $3ee4f50b1ae43a89$var$new_buf(8);
    o.write_shift(4, l);
    o.write_shift(4, h);
    return o;
}
/* [MS-OSHARED] 2.3.3.1.4 Lpstr */ function $3ee4f50b1ae43a89$var$parse_lpstr(blob, type, pad /*:?number*/ ) {
    var start = blob.l;
    var str = blob.read_shift(0, "lpstr-cp");
    if (pad) while(blob.l - start & 3)++blob.l;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */ function $3ee4f50b1ae43a89$var$parse_lpwstr(blob, type, pad) {
    var str = blob.read_shift(0, "lpwstr");
    if (pad) blob.l += 4 - (str.length + 1 & 3) & 3;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.11 VtString */ /* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */ function $3ee4f50b1ae43a89$var$parse_VtStringBase(blob, stringType, pad) {
    if (stringType === 0x1F /*VT_LPWSTR*/ ) return $3ee4f50b1ae43a89$var$parse_lpwstr(blob);
    return $3ee4f50b1ae43a89$var$parse_lpstr(blob, stringType, pad);
}
function $3ee4f50b1ae43a89$var$parse_VtString(blob, t /*:number*/ , pad /*:?boolean*/ ) {
    return $3ee4f50b1ae43a89$var$parse_VtStringBase(blob, t, pad === false ? 0 : 4);
}
function $3ee4f50b1ae43a89$var$parse_VtUnalignedString(blob, t /*:number*/ ) {
    if (!t) throw new Error("VtUnalignedString must have positive length");
    return $3ee4f50b1ae43a89$var$parse_VtStringBase(blob, t, 0);
}
/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */ function $3ee4f50b1ae43a89$var$parse_VtVecLpwstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i){
        var start = blob.l;
        ret[i] = blob.read_shift(0, "lpwstr").replace($3ee4f50b1ae43a89$var$chr0, "");
        if (blob.l - start & 0x02) blob.l += 2;
    }
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */ function $3ee4f50b1ae43a89$var$parse_VtVecUnalignedLpstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i)ret[i] = blob.read_shift(0, "lpstr-cp").replace($3ee4f50b1ae43a89$var$chr0, "");
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */ function $3ee4f50b1ae43a89$var$parse_VtHeadingPair(blob) {
    var start = blob.l;
    var headingString = $3ee4f50b1ae43a89$var$parse_TypedPropertyValue(blob, $3ee4f50b1ae43a89$var$VT_USTR);
    if (blob[blob.l] == 0x00 && blob[blob.l + 1] == 0x00 && blob.l - start & 0x02) blob.l += 2;
    var headerParts = $3ee4f50b1ae43a89$var$parse_TypedPropertyValue(blob, $3ee4f50b1ae43a89$var$VT_I4);
    return [
        headingString,
        headerParts
    ];
}
/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */ function $3ee4f50b1ae43a89$var$parse_VtVecHeadingPairValue(blob) {
    var cElements = blob.read_shift(4);
    var out = [];
    for(var i = 0; i < cElements / 2; ++i)out.push($3ee4f50b1ae43a89$var$parse_VtHeadingPair(blob));
    return out;
}
/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */ function $3ee4f50b1ae43a89$var$parse_dictionary(blob, CodePage) {
    var cnt = blob.read_shift(4);
    var dict /*:{[number]:string}*/  = {} /*:any*/ ;
    for(var j = 0; j != cnt; ++j){
        var pid = blob.read_shift(4);
        var len = blob.read_shift(4);
        dict[pid] = blob.read_shift(len, CodePage === 0x4B0 ? "utf16le" : "utf8").replace($3ee4f50b1ae43a89$var$chr0, "").replace($3ee4f50b1ae43a89$var$chr1, "!");
        if (CodePage === 0x4B0 && len % 2) blob.l += 2;
    }
    if (blob.l & 3) blob.l = blob.l >> 3 << 2;
    return dict;
}
/* [MS-OLEPS] 2.9 BLOB */ function $3ee4f50b1ae43a89$var$parse_BLOB(blob) {
    var size = blob.read_shift(4);
    var bytes = blob.slice(blob.l, blob.l + size);
    blob.l += size;
    if ((size & 3) > 0) blob.l += 4 - (size & 3) & 3;
    return bytes;
}
/* [MS-OLEPS] 2.11 ClipboardData */ function $3ee4f50b1ae43a89$var$parse_ClipboardData(blob) {
    // TODO
    var o = {};
    o.Size = blob.read_shift(4);
    //o.Format = blob.read_shift(4);
    blob.l += o.Size + 3 - (o.Size - 1) % 4;
    return o;
}
/* [MS-OLEPS] 2.15 TypedPropertyValue */ function $3ee4f50b1ae43a89$var$parse_TypedPropertyValue(blob, type /*:number*/ , _opts) /*:any*/ {
    var t = blob.read_shift(2), ret, opts = _opts || {};
    blob.l += 2;
    if (type !== $3ee4f50b1ae43a89$var$VT_VARIANT) {
        if (t !== type && $3ee4f50b1ae43a89$var$VT_CUSTOM.indexOf(type) === -1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error("Expected type " + type + " saw " + t);
    }
    switch(type === $3ee4f50b1ae43a89$var$VT_VARIANT ? t : type){
        case 0x02 /*VT_I2*/ :
            ret = blob.read_shift(2, "i");
            if (!opts.raw) blob.l += 2;
            return ret;
        case 0x03 /*VT_I4*/ :
            ret = blob.read_shift(4, "i");
            return ret;
        case 0x0B /*VT_BOOL*/ :
            return blob.read_shift(4) !== 0x0;
        case 0x13 /*VT_UI4*/ :
            ret = blob.read_shift(4);
            return ret;
        case 0x1E /*VT_LPSTR*/ :
            return $3ee4f50b1ae43a89$var$parse_lpstr(blob, t, 4).replace($3ee4f50b1ae43a89$var$chr0, "");
        case 0x1F /*VT_LPWSTR*/ :
            return $3ee4f50b1ae43a89$var$parse_lpwstr(blob);
        case 0x40 /*VT_FILETIME*/ :
            return $3ee4f50b1ae43a89$var$parse_FILETIME(blob);
        case 0x41 /*VT_BLOB*/ :
            return $3ee4f50b1ae43a89$var$parse_BLOB(blob);
        case 0x47 /*VT_CF*/ :
            return $3ee4f50b1ae43a89$var$parse_ClipboardData(blob);
        case 0x50 /*VT_STRING*/ :
            return $3ee4f50b1ae43a89$var$parse_VtString(blob, t, !opts.raw).replace($3ee4f50b1ae43a89$var$chr0, "");
        case 0x51 /*VT_USTR*/ :
            return $3ee4f50b1ae43a89$var$parse_VtUnalignedString(blob, t /*, 4*/ ).replace($3ee4f50b1ae43a89$var$chr0, "");
        case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
            return $3ee4f50b1ae43a89$var$parse_VtVecHeadingPairValue(blob);
        case 0x101E /*VT_VECTOR|VT_LPSTR*/ :
        case 0x101F /*VT_VECTOR|VT_LPWSTR*/ :
            return t == 0x101F ? $3ee4f50b1ae43a89$var$parse_VtVecLpwstrValue(blob) : $3ee4f50b1ae43a89$var$parse_VtVecUnalignedLpstrValue(blob);
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
    }
}
function $3ee4f50b1ae43a89$var$write_TypedPropertyValue(type /*:number*/ , value) {
    var o = $3ee4f50b1ae43a89$var$new_buf(4), p = $3ee4f50b1ae43a89$var$new_buf(4);
    o.write_shift(4, type == 0x50 ? 0x1F : type);
    switch(type){
        case 0x03 /*VT_I4*/ :
            p.write_shift(-4, value);
            break;
        case 0x05 /*VT_I4*/ :
            p = $3ee4f50b1ae43a89$var$new_buf(8);
            p.write_shift(8, value, "f");
            break;
        case 0x0B /*VT_BOOL*/ :
            p.write_shift(4, value ? 0x01 : 0x00);
            break;
        case 0x40 /*VT_FILETIME*/ :
            /*:: if(typeof value !== "string" && !(value instanceof Date)) throw "unreachable"; */ p = $3ee4f50b1ae43a89$var$write_FILETIME(value);
            break;
        case 0x1F /*VT_LPWSTR*/ :
        case 0x50 /*VT_STRING*/ :
            /*:: if(typeof value !== "string") throw "unreachable"; */ p = $3ee4f50b1ae43a89$var$new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            p.write_shift(4, value.length + 1);
            p.write_shift(0, value, "dbcs");
            while(p.l != p.length)p.write_shift(1, 0);
            break;
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
    }
    return $3ee4f50b1ae43a89$var$bconcat([
        o,
        p
    ]);
}
/* [MS-OLEPS] 2.20 PropertySet */ function $3ee4f50b1ae43a89$var$parse_PropertySet(blob, PIDSI) {
    var start_addr = blob.l;
    var size = blob.read_shift(4);
    var NumProps = blob.read_shift(4);
    var Props = [], i = 0;
    var CodePage = 0;
    var Dictionary = -1, DictObj /*:{[number]:string}*/  = {} /*:any*/ ;
    for(i = 0; i != NumProps; ++i){
        var PropID = blob.read_shift(4);
        var Offset = blob.read_shift(4);
        Props[i] = [
            PropID,
            Offset + start_addr
        ];
    }
    Props.sort(function(x, y) {
        return x[1] - y[1];
    });
    var PropH = {};
    for(i = 0; i != NumProps; ++i){
        if (blob.l !== Props[i][1]) {
            var fail = true;
            if (i > 0 && PIDSI) switch(PIDSI[Props[i - 1][0]].t){
                case 0x02 /*VT_I2*/ :
                    if (blob.l + 2 === Props[i][1]) {
                        blob.l += 2;
                        fail = false;
                    }
                    break;
                case 0x50 /*VT_STRING*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
                case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
            }
            if ((!PIDSI || i == 0) && blob.l <= Props[i][1]) {
                fail = false;
                blob.l = Props[i][1];
            }
            if (fail) throw new Error("Read Error: Expected address " + Props[i][1] + " at " + blob.l + " :" + i);
        }
        if (PIDSI) {
            var piddsi = PIDSI[Props[i][0]];
            PropH[piddsi.n] = $3ee4f50b1ae43a89$var$parse_TypedPropertyValue(blob, piddsi.t, {
                raw: true
            });
            if (piddsi.p === "version") PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
            if (piddsi.n == "CodePage") switch(PropH[piddsi.n]){
                case 0:
                    PropH[piddsi.n] = 1252;
                /* falls through */ case 874:
                case 932:
                case 936:
                case 949:
                case 950:
                case 1250:
                case 1251:
                case 1253:
                case 1254:
                case 1255:
                case 1256:
                case 1257:
                case 1258:
                case 10000:
                case 1200:
                case 1201:
                case 1252:
                case 65000:
                case -536:
                case 65001:
                case -535:
                    $3ee4f50b1ae43a89$var$set_cp(CodePage = PropH[piddsi.n] >>> 0 & 0xFFFF);
                    break;
                default:
                    throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
            }
        } else {
            if (Props[i][0] === 0x1) {
                CodePage = PropH.CodePage = $3ee4f50b1ae43a89$var$parse_TypedPropertyValue(blob, $3ee4f50b1ae43a89$var$VT_I2);
                $3ee4f50b1ae43a89$var$set_cp(CodePage);
                if (Dictionary !== -1) {
                    var oldpos = blob.l;
                    blob.l = Props[Dictionary][1];
                    DictObj = $3ee4f50b1ae43a89$var$parse_dictionary(blob, CodePage);
                    blob.l = oldpos;
                }
            } else if (Props[i][0] === 0) {
                if (CodePage === 0) {
                    Dictionary = i;
                    blob.l = Props[i + 1][1];
                    continue;
                }
                DictObj = $3ee4f50b1ae43a89$var$parse_dictionary(blob, CodePage);
            } else {
                var name = DictObj[Props[i][0]];
                var val;
                /* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */ switch(blob[blob.l]){
                    case 0x41 /*VT_BLOB*/ :
                        blob.l += 4;
                        val = $3ee4f50b1ae43a89$var$parse_BLOB(blob);
                        break;
                    case 0x1E /*VT_LPSTR*/ :
                        blob.l += 4;
                        val = $3ee4f50b1ae43a89$var$parse_VtString(blob, blob[blob.l - 4]).replace(/\u0000+$/, "");
                        break;
                    case 0x1F /*VT_LPWSTR*/ :
                        blob.l += 4;
                        val = $3ee4f50b1ae43a89$var$parse_VtString(blob, blob[blob.l - 4]).replace(/\u0000+$/, "");
                        break;
                    case 0x03 /*VT_I4*/ :
                        blob.l += 4;
                        val = blob.read_shift(4, "i");
                        break;
                    case 0x13 /*VT_UI4*/ :
                        blob.l += 4;
                        val = blob.read_shift(4);
                        break;
                    case 0x05 /*VT_R8*/ :
                        blob.l += 4;
                        val = blob.read_shift(8, "f");
                        break;
                    case 0x0B /*VT_BOOL*/ :
                        blob.l += 4;
                        val = $3ee4f50b1ae43a89$var$parsebool(blob, 4);
                        break;
                    case 0x40 /*VT_FILETIME*/ :
                        blob.l += 4;
                        val = $3ee4f50b1ae43a89$var$parseDate($3ee4f50b1ae43a89$var$parse_FILETIME(blob));
                        break;
                    default:
                        throw new Error("unparsed value: " + blob[blob.l]);
                }
                PropH[name] = val;
            }
        }
    }
    blob.l = start_addr + size; /* step ahead to skip padding */ 
    return PropH;
}
var $3ee4f50b1ae43a89$var$XLSPSSkip = [
    "CodePage",
    "Thumbnail",
    "_PID_LINKBASE",
    "_PID_HLINKS",
    "SystemIdentifier",
    "FMTID"
]; //.concat(PseudoPropsPairs);
function $3ee4f50b1ae43a89$var$guess_property_type(val /*:any*/ ) /*:number*/ {
    switch(typeof val){
        case "boolean":
            return 0x0B;
        case "number":
            return (val | 0) == val ? 0x03 : 0x05;
        case "string":
            return 0x1F;
        case "object":
            if (val instanceof Date) return 0x40;
            break;
    }
    return -1;
}
function $3ee4f50b1ae43a89$var$write_PropertySet(entries, RE, PIDSI) {
    var hdr = $3ee4f50b1ae43a89$var$new_buf(8), piao = [], prop = [];
    var sz = 8, i = 0;
    var pr = $3ee4f50b1ae43a89$var$new_buf(8), pio = $3ee4f50b1ae43a89$var$new_buf(8);
    pr.write_shift(4, 0x0002);
    pr.write_shift(4, 0x04B0);
    pio.write_shift(4, 0x0001);
    prop.push(pr);
    piao.push(pio);
    sz += 8 + pr.length;
    if (!RE) {
        pio = $3ee4f50b1ae43a89$var$new_buf(8);
        pio.write_shift(4, 0);
        piao.unshift(pio);
        var bufs = [
            $3ee4f50b1ae43a89$var$new_buf(4)
        ];
        bufs[0].write_shift(4, entries.length);
        for(i = 0; i < entries.length; ++i){
            var value = entries[i][0];
            pr = $3ee4f50b1ae43a89$var$new_buf(8 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            pr.write_shift(4, i + 2);
            pr.write_shift(4, value.length + 1);
            pr.write_shift(0, value, "dbcs");
            while(pr.l != pr.length)pr.write_shift(1, 0);
            bufs.push(pr);
        }
        pr = $3ee4f50b1ae43a89$var$bconcat(bufs);
        prop.unshift(pr);
        sz += 8 + pr.length;
    }
    for(i = 0; i < entries.length; ++i){
        if (RE && !RE[entries[i][0]]) continue;
        if ($3ee4f50b1ae43a89$var$XLSPSSkip.indexOf(entries[i][0]) > -1 || $3ee4f50b1ae43a89$var$PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
        if (entries[i][1] == null) continue;
        var val = entries[i][1], idx = 0;
        if (RE) {
            idx = +RE[entries[i][0]];
            var pinfo = PIDSI /*:: || {}*/ [idx] /*:: || {} */ ;
            if (pinfo.p == "version" && typeof val == "string") {
                /*:: if(typeof val !== "string") throw "unreachable"; */ var arr = val.split(".");
                val = (+arr[0] << 16) + (+arr[1] || 0);
            }
            pr = $3ee4f50b1ae43a89$var$write_TypedPropertyValue(pinfo.t, val);
        } else {
            var T = $3ee4f50b1ae43a89$var$guess_property_type(val);
            if (T == -1) {
                T = 0x1F;
                val = String(val);
            }
            pr = $3ee4f50b1ae43a89$var$write_TypedPropertyValue(T, val);
        }
        prop.push(pr);
        pio = $3ee4f50b1ae43a89$var$new_buf(8);
        pio.write_shift(4, !RE ? 2 + i : idx);
        piao.push(pio);
        sz += 8 + pr.length;
    }
    var w = 8 * (prop.length + 1);
    for(i = 0; i < prop.length; ++i){
        piao[i].write_shift(4, w);
        w += prop[i].length;
    }
    hdr.write_shift(4, sz);
    hdr.write_shift(4, prop.length);
    return $3ee4f50b1ae43a89$var$bconcat([
        hdr
    ].concat(piao).concat(prop));
}
/* [MS-OLEPS] 2.21 PropertySetStream */ function $3ee4f50b1ae43a89$var$parse_PropertySetStream(file, PIDSI, clsid) {
    var blob = file.content;
    if (!blob) return {} /*:any*/ ;
    $3ee4f50b1ae43a89$var$prep_blob(blob, 0);
    var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
    blob.chk("feff", "Byte Order: ");
    /*var vers = */ blob.read_shift(2); // TODO: check version
    var SystemIdentifier = blob.read_shift(4);
    var CLSID = blob.read_shift(16);
    if (CLSID !== $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
    NumSets = blob.read_shift(4);
    if (NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
    FMTID0 = blob.read_shift(16);
    Offset0 = blob.read_shift(4);
    if (NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
    else if (NumSets === 2) {
        FMTID1 = blob.read_shift(16);
        Offset1 = blob.read_shift(4);
    }
    var PSet0 = $3ee4f50b1ae43a89$var$parse_PropertySet(blob, PIDSI);
    var rval = {
        SystemIdentifier: SystemIdentifier
    } /*:any*/ ;
    for(var y in PSet0)rval[y] = PSet0[y];
    //rval.blob = blob;
    rval.FMTID = FMTID0;
    //rval.PSet0 = PSet0;
    if (NumSets === 1) return rval;
    if (Offset1 - blob.l == 2) blob.l += 2;
    if (blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
    var PSet1;
    try {
        PSet1 = $3ee4f50b1ae43a89$var$parse_PropertySet(blob, null);
    } catch (e) {}
    for(y in PSet1)rval[y] = PSet1[y];
    rval.FMTID = [
        FMTID0,
        FMTID1
    ]; // TODO: verify FMTID0/1
    return rval;
}
function $3ee4f50b1ae43a89$var$write_PropertySetStream(entries, clsid, RE, PIDSI /*:{[key:string|number]:any}*/ , entries2 /*:?any*/ , clsid2 /*:?any*/ ) {
    var hdr = $3ee4f50b1ae43a89$var$new_buf(entries2 ? 68 : 48);
    var bufs = [
        hdr
    ];
    hdr.write_shift(2, 0xFFFE);
    hdr.write_shift(2, 0x0000); /* TODO: type 1 props */ 
    hdr.write_shift(4, 0x32363237);
    hdr.write_shift(16, $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID, "hex");
    hdr.write_shift(4, entries2 ? 2 : 1);
    hdr.write_shift(16, clsid, "hex");
    hdr.write_shift(4, entries2 ? 68 : 48);
    var ps0 = $3ee4f50b1ae43a89$var$write_PropertySet(entries, RE, PIDSI);
    bufs.push(ps0);
    if (entries2) {
        var ps1 = $3ee4f50b1ae43a89$var$write_PropertySet(entries2, null, null);
        hdr.write_shift(16, clsid2, "hex");
        hdr.write_shift(4, 68 + ps0.length);
        bufs.push(ps1);
    }
    return $3ee4f50b1ae43a89$var$bconcat(bufs);
}
function $3ee4f50b1ae43a89$var$parsenoop2(blob, length) {
    blob.read_shift(length);
    return null;
}
function $3ee4f50b1ae43a89$var$writezeroes(n, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(n);
    for(var j = 0; j < n; ++j)o.write_shift(1, 0);
    return o;
}
function $3ee4f50b1ae43a89$var$parslurp(blob, length, cb) {
    var arr = [], target = blob.l + length;
    while(blob.l < target)arr.push(cb(blob, target - blob.l));
    if (target !== blob.l) throw new Error("Slurp error");
    return arr;
}
function $3ee4f50b1ae43a89$var$parsebool(blob, length /*:number*/ ) {
    return blob.read_shift(length) === 0x1;
}
function $3ee4f50b1ae43a89$var$writebool(v /*:any*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(2);
    o.write_shift(2, +!!v);
    return o;
}
function $3ee4f50b1ae43a89$var$parseuint16(blob /*::, length:?number, opts:?any*/ ) {
    return blob.read_shift(2, "u");
}
function $3ee4f50b1ae43a89$var$writeuint16(v /*:number*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(2);
    o.write_shift(2, v);
    return o;
}
function $3ee4f50b1ae43a89$var$parseuint16a(blob, length /*:: :?number, opts:?any*/ ) {
    return $3ee4f50b1ae43a89$var$parslurp(blob, length, $3ee4f50b1ae43a89$var$parseuint16);
}
/* --- 2.5 Structures --- */ /* [MS-XLS] 2.5.10 Bes (boolean or error) */ function $3ee4f50b1ae43a89$var$parse_Bes(blob /*::, length*/ ) {
    var v = blob.read_shift(1), t = blob.read_shift(1);
    return t === 0x01 ? v : v === 0x01;
}
function $3ee4f50b1ae43a89$var$write_Bes(v, t /*:string*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(2);
    o.write_shift(1, t == "e" ? +v : +!!v);
    o.write_shift(1, t == "e" ? 1 : 0);
    return o;
}
/* [MS-XLS] 2.5.240 ShortXLUnicodeString */ function $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
    var encoding = "sbcs-cont";
    var cp = $3ee4f50b1ae43a89$var$current_codepage;
    if (opts && opts.biff >= 8) $3ee4f50b1ae43a89$var$current_codepage = 1200;
    if (!opts || opts.biff == 8) {
        var fHighByte = blob.read_shift(1);
        if (fHighByte) encoding = "dbcs-cont";
    } else if (opts.biff == 12) encoding = "wstr";
    if (opts.biff >= 2 && opts.biff <= 5) encoding = "cpstr";
    var o = cch ? blob.read_shift(cch, encoding) : "";
    $3ee4f50b1ae43a89$var$current_codepage = cp;
    return o;
}
/* 2.5.293 XLUnicodeRichExtendedString */ function $3ee4f50b1ae43a89$var$parse_XLUnicodeRichExtendedString(blob) {
    var cp = $3ee4f50b1ae43a89$var$current_codepage;
    $3ee4f50b1ae43a89$var$current_codepage = 1200;
    var cch = blob.read_shift(2), flags = blob.read_shift(1);
    var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
    var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
    var cRun = 0, cbExtRst;
    var z = {};
    if (fRichSt) cRun = blob.read_shift(2);
    if (fExtSt) cbExtRst = blob.read_shift(4);
    var encoding = width == 2 ? "dbcs-cont" : "sbcs-cont";
    var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
    if (fRichSt) blob.l += 4 * cRun; //TODO: parse this
    if (fExtSt) blob.l += cbExtRst; //TODO: parse this
    z.t = msg;
    if (!fRichSt) {
        z.raw = "<t>" + z.t + "</t>";
        z.r = z.t;
    }
    $3ee4f50b1ae43a89$var$current_codepage = cp;
    return z;
}
function $3ee4f50b1ae43a89$var$write_XLUnicodeRichExtendedString(xlstr /*:: :XLString, opts*/ ) {
    var str = xlstr.t || "", nfmts = 1;
    var hdr = $3ee4f50b1ae43a89$var$new_buf(3 + (nfmts > 1 ? 2 : 0));
    hdr.write_shift(2, str.length);
    hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
    if (nfmts > 1) hdr.write_shift(2, nfmts);
    var otext = $3ee4f50b1ae43a89$var$new_buf(2 * str.length);
    otext.write_shift(2 * str.length, str, "utf16le");
    var out = [
        hdr,
        otext
    ];
    return $3ee4f50b1ae43a89$var$bconcat(out);
}
/* 2.5.296 XLUnicodeStringNoCch */ function $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cch, opts) {
    var retval;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, "cpstr");
        if (opts.biff >= 12) return blob.read_shift(cch, "dbcs-cont");
    }
    var fHighByte = blob.read_shift(1);
    if (fHighByte === 0) retval = blob.read_shift(cch, "sbcs-cont");
    else retval = blob.read_shift(cch, "dbcs-cont");
    return retval;
}
/* 2.5.294 XLUnicodeString */ function $3ee4f50b1ae43a89$var$parse_XLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */ function $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, length, opts) {
    if (opts.biff > 5) return $3ee4f50b1ae43a89$var$parse_XLUnicodeString(blob, length, opts);
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, opts.biff <= 4 || !blob.lens ? "cpstr" : "sbcs-cont");
}
/* TODO: BIFF5 and lower, codepage awareness */ function $3ee4f50b1ae43a89$var$write_XLUnicodeString(str, opts, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(3 + 2 * str.length);
    o.write_shift(2, str.length);
    o.write_shift(1, 1);
    o.write_shift(31, str, "utf16le");
    return o;
}
/* [MS-XLS] 2.5.61 ControlInfo */ function $3ee4f50b1ae43a89$var$parse_ControlInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(1);
    blob.l++;
    var accel = blob.read_shift(2);
    blob.l += 2;
    return [
        flags,
        accel
    ];
}
/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */ function $3ee4f50b1ae43a89$var$parse_URLMoniker(blob /*::, length, opts*/ ) {
    var len = blob.read_shift(4), start = blob.l;
    var extra = false;
    if (len > 24) {
        /* look ahead */ blob.l += len - 24;
        if (blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
        blob.l = start;
    }
    var url = blob.read_shift((extra ? len - 24 : len) >> 1, "utf16le").replace($3ee4f50b1ae43a89$var$chr0, "");
    if (extra) blob.l += 24;
    return url;
}
/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */ function $3ee4f50b1ae43a89$var$parse_FileMoniker(blob /*::, length*/ ) {
    var cAnti = blob.read_shift(2);
    var preamble = "";
    while(cAnti-- > 0)preamble += "../";
    var ansiPath = blob.read_shift(0, "lpstr-ansi");
    blob.l += 2; //var endServer = blob.read_shift(2);
    if (blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
    var sz = blob.read_shift(4);
    if (sz === 0) return preamble + ansiPath.replace(/\\/g, "/");
    var bytes = blob.read_shift(4);
    if (blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
    var unicodePath = blob.read_shift(bytes >> 1, "utf16le").replace($3ee4f50b1ae43a89$var$chr0, "");
    return preamble + unicodePath;
}
/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */ function $3ee4f50b1ae43a89$var$parse_HyperlinkMoniker(blob, length) {
    var clsid = blob.read_shift(16);
    length -= 16;
    switch(clsid){
        case "e0c9ea79f9bace118c8200aa004ba90b":
            return $3ee4f50b1ae43a89$var$parse_URLMoniker(blob, length);
        case "0303000000000000c000000000000046":
            return $3ee4f50b1ae43a89$var$parse_FileMoniker(blob, length);
        default:
            throw new Error("Unsupported Moniker " + clsid);
    }
}
/* [MS-OSHARED] 2.3.7.9 HyperlinkString */ function $3ee4f50b1ae43a89$var$parse_HyperlinkString(blob /*::, length*/ ) {
    var len = blob.read_shift(4);
    var o = len > 0 ? blob.read_shift(len, "utf16le").replace($3ee4f50b1ae43a89$var$chr0, "") : "";
    return o;
}
function $3ee4f50b1ae43a89$var$write_HyperlinkString(str /*:string*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(6 + str.length * 2);
    o.write_shift(4, 1 + str.length);
    for(var i = 0; i < str.length; ++i)o.write_shift(2, str.charCodeAt(i));
    o.write_shift(2, 0);
    return o;
}
/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */ function $3ee4f50b1ae43a89$var$parse_Hyperlink(blob, length) /*:Hyperlink*/ {
    var end = blob.l + length;
    var sVer = blob.read_shift(4);
    if (sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
    var flags = blob.read_shift(2);
    blob.l += 2;
    var displayName, targetFrameName, moniker, oleMoniker, Loc = "", guid, fileTime;
    if (flags & 0x0010) displayName = $3ee4f50b1ae43a89$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0080) targetFrameName = $3ee4f50b1ae43a89$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0101) moniker = $3ee4f50b1ae43a89$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0001) oleMoniker = $3ee4f50b1ae43a89$var$parse_HyperlinkMoniker(blob, end - blob.l);
    if (flags & 0x0008) Loc = $3ee4f50b1ae43a89$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0020) guid = blob.read_shift(16);
    if (flags & 0x0040) fileTime = $3ee4f50b1ae43a89$var$parse_FILETIME(blob /*, 8*/ );
    blob.l = end;
    var target = targetFrameName || moniker || oleMoniker || "";
    if (target && Loc) target += "#" + Loc;
    if (!target) target = "#" + Loc;
    if (flags & 0x0002 && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
    var out = {
        Target: target
    } /*:any*/ ;
    if (guid) out.guid = guid;
    if (fileTime) out.time = fileTime;
    if (displayName) out.Tooltip = displayName;
    return out;
}
function $3ee4f50b1ae43a89$var$write_Hyperlink(hl) {
    var out = $3ee4f50b1ae43a89$var$new_buf(512), i = 0;
    var Target = hl.Target;
    if (Target.slice(0, 7) == "file://") Target = Target.slice(7);
    var hashidx = Target.indexOf("#");
    var F = hashidx > -1 ? 0x1f : 0x17;
    switch(Target.charAt(0)){
        case "#":
            F = 0x1c;
            break;
        case ".":
            F &= -3;
            break;
    }
    out.write_shift(4, 2);
    out.write_shift(4, F);
    var data = [
        8,
        6815827,
        6619237,
        4849780,
        83
    ];
    for(i = 0; i < data.length; ++i)out.write_shift(4, data[i]);
    if (F == 0x1C) {
        Target = Target.slice(1);
        $3ee4f50b1ae43a89$var$write_HyperlinkString(Target, out);
    } else if (F & 0x02) {
        data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
        out.write_shift(4, 2 * (Pretarget.length + 1));
        for(i = 0; i < Pretarget.length; ++i)out.write_shift(2, Pretarget.charCodeAt(i));
        out.write_shift(2, 0);
        if (F & 0x08) $3ee4f50b1ae43a89$var$write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx + 1) : "", out);
    } else {
        data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var P = 0;
        while(Target.slice(P * 3, P * 3 + 3) == "../" || Target.slice(P * 3, P * 3 + 3) == "..\\")++P;
        out.write_shift(2, P);
        out.write_shift(4, Target.length - 3 * P + 1);
        for(i = 0; i < Target.length - 3 * P; ++i)out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
        out.write_shift(1, 0);
        out.write_shift(2, 0xFFFF);
        out.write_shift(2, 0xDEAD);
        for(i = 0; i < 6; ++i)out.write_shift(4, 0);
    }
    return out.slice(0, out.l);
}
/* 2.5.178 LongRGBA */ function $3ee4f50b1ae43a89$var$parse_LongRGBA(blob /*::, length*/ ) {
    var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1);
    return [
        r,
        g,
        b,
        a
    ];
}
/* 2.5.177 LongRGB */ function $3ee4f50b1ae43a89$var$parse_LongRGB(blob, length) {
    var x = $3ee4f50b1ae43a89$var$parse_LongRGBA(blob, length);
    x[3] = 0;
    return x;
}
/* [MS-XLS] 2.5.19 */ function $3ee4f50b1ae43a89$var$parse_XLSCell(blob /*::, length*/ ) /*:Cell*/ {
    var rw = blob.read_shift(2); // 0-indexed
    var col = blob.read_shift(2);
    var ixfe = blob.read_shift(2);
    return {
        r: rw,
        c: col,
        ixfe: ixfe
    } /*:any*/ ;
}
function $3ee4f50b1ae43a89$var$write_XLSCell(R /*:number*/ , C /*:number*/ , ixfe /*:?number*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(6);
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, ixfe || 0);
    return o;
}
/* [MS-XLS] 2.5.134 */ function $3ee4f50b1ae43a89$var$parse_frtHeader(blob) {
    var rt = blob.read_shift(2);
    var flags = blob.read_shift(2); // TODO: parse these flags
    blob.l += 8;
    return {
        type: rt,
        flags: flags
    };
}
function $3ee4f50b1ae43a89$var$parse_OptXLUnicodeString(blob, length, opts) {
    return length === 0 ? "" : $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, length, opts);
}
/* [MS-XLS] 2.5.344 */ function $3ee4f50b1ae43a89$var$parse_XTI(blob, length, opts) {
    var w = opts.biff > 8 ? 4 : 2;
    var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w, "i"), itabLast = blob.read_shift(w, "i");
    return [
        iSupBook,
        itabFirst,
        itabLast
    ];
}
/* [MS-XLS] 2.5.218 */ function $3ee4f50b1ae43a89$var$parse_RkRec(blob) {
    var ixfe = blob.read_shift(2);
    var RK = $3ee4f50b1ae43a89$var$parse_RkNumber(blob);
    return [
        ixfe,
        RK
    ];
}
/* [MS-XLS] 2.5.1 */ function $3ee4f50b1ae43a89$var$parse_AddinUdf(blob, length, opts) {
    blob.l += 4;
    length -= 4;
    var l = blob.l + length;
    var udfName = $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, length, opts);
    var cb = blob.read_shift(2);
    l -= blob.l;
    if (cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
    blob.l += cb;
    return udfName;
}
/* [MS-XLS] 2.5.209 TODO: Check sizes */ function $3ee4f50b1ae43a89$var$parse_Ref8U(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(2);
    var colLast = blob.read_shift(2);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
function $3ee4f50b1ae43a89$var$write_Ref8U(r /*:Range*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(8);
    o.write_shift(2, r.s.r);
    o.write_shift(2, r.e.r);
    o.write_shift(2, r.s.c);
    o.write_shift(2, r.e.c);
    return o;
}
/* [MS-XLS] 2.5.211 */ function $3ee4f50b1ae43a89$var$parse_RefU(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(1);
    var colLast = blob.read_shift(1);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
/* [MS-XLS] 2.5.207 */ var $3ee4f50b1ae43a89$var$parse_Ref = $3ee4f50b1ae43a89$var$parse_RefU;
/* [MS-XLS] 2.5.143 */ function $3ee4f50b1ae43a89$var$parse_FtCmo(blob /*::, length*/ ) {
    blob.l += 4;
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var flags = blob.read_shift(2);
    blob.l += 12;
    return [
        id,
        ot,
        flags
    ];
}
/* [MS-XLS] 2.5.149 */ function $3ee4f50b1ae43a89$var$parse_FtNts(blob) {
    var out = {};
    blob.l += 4;
    blob.l += 16; // GUID TODO
    out.fSharedNote = blob.read_shift(2);
    blob.l += 4;
    return out;
}
/* [MS-XLS] 2.5.142 */ function $3ee4f50b1ae43a89$var$parse_FtCf(blob) {
    var out = {};
    blob.l += 4;
    blob.cf = blob.read_shift(2);
    return out;
}
/* [MS-XLS] 2.5.140 - 2.5.154 and friends */ function $3ee4f50b1ae43a89$var$parse_FtSkip(blob) {
    blob.l += 2;
    blob.l += blob.read_shift(2);
}
var $3ee4f50b1ae43a89$var$FtTab = {
    /*::[*/ 0x00: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtEnd */ /*::[*/ 0x04: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtMacro */ /*::[*/ 0x05: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtButton */ /*::[*/ 0x06: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtGmo */ /*::[*/ 0x07: $3ee4f50b1ae43a89$var$parse_FtCf,
    /* FtCf */ /*::[*/ 0x08: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtPioGrbit */ /*::[*/ 0x09: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtPictFmla */ /*::[*/ 0x0A: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtCbls */ /*::[*/ 0x0B: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtRbo */ /*::[*/ 0x0C: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtSbs */ /*::[*/ 0x0D: $3ee4f50b1ae43a89$var$parse_FtNts,
    /* FtNts */ /*::[*/ 0x0E: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtSbsFmla */ /*::[*/ 0x0F: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtGboData */ /*::[*/ 0x10: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtEdoData */ /*::[*/ 0x11: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtRboData */ /*::[*/ 0x12: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtCblsData */ /*::[*/ 0x13: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtLbsData */ /*::[*/ 0x14: $3ee4f50b1ae43a89$var$parse_FtSkip,
    /* FtCblsFmla */ /*::[*/ 0x15: $3ee4f50b1ae43a89$var$parse_FtCmo
};
function $3ee4f50b1ae43a89$var$parse_FtArray(blob, length /*::, ot*/ ) {
    var tgt = blob.l + length;
    var fts = [];
    while(blob.l < tgt){
        var ft = blob.read_shift(2);
        blob.l -= 2;
        try {
            fts.push($3ee4f50b1ae43a89$var$FtTab[ft](blob, tgt - blob.l));
        } catch (e) {
            blob.l = tgt;
            return fts;
        }
    }
    if (blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
    return fts;
}
/* --- 2.4 Records --- */ /* [MS-XLS] 2.4.21 */ function $3ee4f50b1ae43a89$var$parse_BOF(blob, length) {
    var o = {
        BIFFVer: 0,
        dt: 0
    };
    o.BIFFVer = blob.read_shift(2);
    length -= 2;
    if (length >= 2) {
        o.dt = blob.read_shift(2);
        blob.l -= 2;
    }
    switch(o.BIFFVer){
        case 0x0600:
        /* BIFF8 */ case 0x0500:
        /* BIFF5 */ case 0x0400:
        /* BIFF4 */ case 0x0300:
        /* BIFF3 */ case 0x0200:
        /* BIFF2 */ case 0x0002:
        case 0x0007:
            break;
        default:
            if (length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
    }
    blob.read_shift(length);
    return o;
}
function $3ee4f50b1ae43a89$var$write_BOF(wb /*:Workbook*/ , t /*:number*/ , o) {
    var h = 0x0600, w = 16;
    switch(o.bookType){
        case "biff8":
            break;
        case "biff5":
            h = 0x0500;
            w = 8;
            break;
        case "biff4":
            h = 0x0004;
            w = 6;
            break;
        case "biff3":
            h = 0x0003;
            w = 6;
            break;
        case "biff2":
            h = 0x0002;
            w = 4;
            break;
        case "xla":
            break;
        default:
            throw new Error("unsupported BIFF version");
    }
    var out = $3ee4f50b1ae43a89$var$new_buf(w);
    out.write_shift(2, h);
    out.write_shift(2, t);
    if (w > 4) out.write_shift(2, 0x7262);
    if (w > 6) out.write_shift(2, 0x07CD);
    if (w > 8) {
        out.write_shift(2, 0xC009);
        out.write_shift(2, 0x0001);
        out.write_shift(2, 0x0706);
        out.write_shift(2, 0x0000);
    }
    return out;
}
/* [MS-XLS] 2.4.146 */ function $3ee4f50b1ae43a89$var$parse_InterfaceHdr(blob, length) {
    if (length === 0) return 0x04b0;
    blob.read_shift(2);
    return 0x04b0;
}
/* [MS-XLS] 2.4.349 */ function $3ee4f50b1ae43a89$var$parse_WriteAccess(blob, length, opts) {
    if (opts.enc) {
        blob.l += length;
        return "";
    }
    var l = blob.l;
    // TODO: make sure XLUnicodeString doesnt overrun
    var UserName = $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, 0, opts);
    blob.read_shift(length + l - blob.l);
    return UserName;
}
function $3ee4f50b1ae43a89$var$write_WriteAccess(s /*:string*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $3ee4f50b1ae43a89$var$new_buf(b8 ? 112 : 54);
    o.write_shift(opts.biff == 8 ? 2 : 1, 7);
    if (b8) o.write_shift(1, 0);
    o.write_shift(4, 0x33336853);
    o.write_shift(4, 0x00534A74 | (b8 ? 0 : 0x20000000));
    while(o.l < o.length)o.write_shift(1, b8 ? 0 : 32);
    return o;
}
/* [MS-XLS] 2.4.351 */ function $3ee4f50b1ae43a89$var$parse_WsBool(blob, length, opts) {
    var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
    return {
        fDialog: flags & 0x10,
        fBelow: flags & 0x40,
        fRight: flags & 0x80
    };
}
/* [MS-XLS] 2.4.28 */ function $3ee4f50b1ae43a89$var$parse_BoundSheet8(blob, length, opts) {
    var pos = blob.read_shift(4);
    var hidden = blob.read_shift(1) & 0x03;
    var dt = blob.read_shift(1);
    switch(dt){
        case 0:
            dt = "Worksheet";
            break;
        case 1:
            dt = "Macrosheet";
            break;
        case 2:
            dt = "Chartsheet";
            break;
        case 6:
            dt = "VBAModule";
            break;
    }
    var name = $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, 0, opts);
    if (name.length === 0) name = "Sheet1";
    return {
        pos: pos,
        hs: hidden,
        dt: dt,
        name: name
    };
}
function $3ee4f50b1ae43a89$var$write_BoundSheet8(data, opts) {
    var w = !opts || opts.biff >= 8 ? 2 : 1;
    var o = $3ee4f50b1ae43a89$var$new_buf(8 + w * data.name.length);
    o.write_shift(4, data.pos);
    o.write_shift(1, data.hs || 0);
    o.write_shift(1, data.dt);
    o.write_shift(1, data.name.length);
    if (opts.biff >= 8) o.write_shift(1, 1);
    o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? "sbcs" : "utf16le");
    var out = o.slice(0, o.l);
    out.l = o.l;
    return out;
}
/* [MS-XLS] 2.4.265 TODO */ function $3ee4f50b1ae43a89$var$parse_SST(blob, length) /*:SST*/ {
    var end = blob.l + length;
    var cnt = blob.read_shift(4);
    var ucnt = blob.read_shift(4);
    var strs /*:SST*/  = [];
    for(var i = 0; i != ucnt && blob.l < end; ++i)strs.push($3ee4f50b1ae43a89$var$parse_XLUnicodeRichExtendedString(blob));
    strs.Count = cnt;
    strs.Unique = ucnt;
    return strs;
}
function $3ee4f50b1ae43a89$var$write_SST(sst, opts) {
    var header = $3ee4f50b1ae43a89$var$new_buf(8);
    header.write_shift(4, sst.Count);
    header.write_shift(4, sst.Unique);
    var strs = [];
    for(var j = 0; j < sst.length; ++j)strs[j] = $3ee4f50b1ae43a89$var$write_XLUnicodeRichExtendedString(sst[j], opts);
    var o = $3ee4f50b1ae43a89$var$bconcat([
        header
    ].concat(strs));
    /*::(*/ o /*:: :any)*/ .parts = [
        header.length
    ].concat(strs.map(function(str) {
        return str.length;
    }));
    return o;
}
/* [MS-XLS] 2.4.107 */ function $3ee4f50b1ae43a89$var$parse_ExtSST(blob, length) {
    var extsst = {};
    extsst.dsst = blob.read_shift(2);
    blob.l += length - 2;
    return extsst;
}
/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */ function $3ee4f50b1ae43a89$var$parse_Row(blob) {
    var z = {} /*:any*/ ;
    z.r = blob.read_shift(2);
    z.c = blob.read_shift(2);
    z.cnt = blob.read_shift(2) - z.c;
    var miyRw = blob.read_shift(2);
    blob.l += 4; // reserved(2), unused(2)
    var flags = blob.read_shift(1); // various flags
    blob.l += 3; // reserved(8), ixfe(12), flags(4)
    if (flags & 0x07) z.level = flags & 0x07;
    // collapsed: flags & 0x10
    if (flags & 0x20) z.hidden = true;
    if (flags & 0x40) z.hpt = miyRw / 20;
    return z;
}
/* [MS-XLS] 2.4.125 */ function $3ee4f50b1ae43a89$var$parse_ForceFullCalculation(blob) {
    var header = $3ee4f50b1ae43a89$var$parse_frtHeader(blob);
    if (header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
    var fullcalc = blob.read_shift(4);
    return fullcalc !== 0x0;
}
/* [MS-XLS] 2.4.215 rt */ function $3ee4f50b1ae43a89$var$parse_RecalcId(blob) {
    blob.read_shift(2);
    return blob.read_shift(4);
}
/* [MS-XLS] 2.4.87 */ function $3ee4f50b1ae43a89$var$parse_DefaultRowHeight(blob, length, opts) {
    var f = 0;
    if (!(opts && opts.biff == 2)) f = blob.read_shift(2);
    var miyRw = blob.read_shift(2);
    if (opts && opts.biff == 2) {
        f = 1 - (miyRw >> 15);
        miyRw &= 0x7fff;
    }
    var fl = {
        Unsynced: f & 1,
        DyZero: (f & 2) >> 1,
        ExAsc: (f & 4) >> 2,
        ExDsc: (f & 8) >> 3
    };
    return [
        fl,
        miyRw
    ];
}
/* [MS-XLS] 2.4.345 TODO */ function $3ee4f50b1ae43a89$var$parse_Window1(blob) {
    var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
    var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
    var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
    return {
        Pos: [
            xWn,
            yWn
        ],
        Dim: [
            dxWn,
            dyWn
        ],
        Flags: flags,
        CurTab: iTabCur,
        FirstTab: iTabFirst,
        Selected: ctabSel,
        TabRatio: wTabRatio
    };
}
function $3ee4f50b1ae43a89$var$write_Window1() {
    var o = $3ee4f50b1ae43a89$var$new_buf(18);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0x7260);
    o.write_shift(2, 0x44c0);
    o.write_shift(2, 0x38);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 1);
    o.write_shift(2, 0x01f4);
    return o;
}
/* [MS-XLS] 2.4.346 TODO */ function $3ee4f50b1ae43a89$var$parse_Window2(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff < 5) return {};
    var f = blob.read_shift(2);
    return {
        RTL: f & 0x40
    };
}
function $3ee4f50b1ae43a89$var$write_Window2(view) {
    var o = $3ee4f50b1ae43a89$var$new_buf(18), f = 0x6b6;
    if (view && view.RTL) f |= 0x40;
    o.write_shift(2, f);
    o.write_shift(4, 0);
    o.write_shift(4, 64);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLS] 2.4.189 TODO */ function $3ee4f50b1ae43a89$var$parse_Pane() {}
/* [MS-XLS] 2.4.122 TODO */ function $3ee4f50b1ae43a89$var$parse_Font(blob, length, opts) {
    var o /*:any*/  = {
        dyHeight: blob.read_shift(2),
        fl: blob.read_shift(2)
    };
    switch(opts && opts.biff || 8){
        case 2:
            break;
        case 3:
        case 4:
            blob.l += 2;
            break;
        default:
            blob.l += 10;
            break;
    }
    o.name = $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, 0, opts);
    return o;
}
function $3ee4f50b1ae43a89$var$write_Font(data, opts) {
    var name = data.name || "Arial";
    var b5 = opts && opts.biff == 5, w = b5 ? 15 + name.length : 16 + 2 * name.length;
    var o = $3ee4f50b1ae43a89$var$new_buf(w);
    o.write_shift(2, (data.sz || 12) * 20);
    o.write_shift(4, 0);
    o.write_shift(2, 400);
    o.write_shift(4, 0);
    o.write_shift(2, 0);
    o.write_shift(1, name.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * name.length, name, b5 ? "sbcs" : "utf16le");
    return o;
}
/* [MS-XLS] 2.4.149 */ function $3ee4f50b1ae43a89$var$parse_LabelSst(blob) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob);
    cell.isst = blob.read_shift(4);
    return cell;
}
function $3ee4f50b1ae43a89$var$write_LabelSst(R /*:number*/ , C /*:number*/ , v /*:number*/ , os /*:number*/  /*::, opts*/ ) {
    var o = $3ee4f50b1ae43a89$var$new_buf(10);
    $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os, o);
    o.write_shift(4, v);
    return o;
}
/* [MS-XLS] 2.4.148 */ function $3ee4f50b1ae43a89$var$parse_Label(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var target = blob.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6);
    if (opts.biff == 2) blob.l++;
    var str = $3ee4f50b1ae43a89$var$parse_XLUnicodeString(blob, target - blob.l, opts);
    cell.val = str;
    return cell;
}
function $3ee4f50b1ae43a89$var$write_Label(R /*:number*/ , C /*:number*/ , v /*:string*/ , os /*:number*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $3ee4f50b1ae43a89$var$new_buf(8 + +b8 + (1 + b8) * v.length);
    $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os, o);
    o.write_shift(2, v.length);
    if (b8) o.write_shift(1, 1);
    o.write_shift((1 + b8) * v.length, v, b8 ? "utf16le" : "sbcs");
    return o;
}
/* [MS-XLS] 2.4.126 Number Formats */ function $3ee4f50b1ae43a89$var$parse_Format(blob, length, opts) {
    var numFmtId = blob.read_shift(2);
    var fmtstr = $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        numFmtId,
        fmtstr
    ];
}
function $3ee4f50b1ae43a89$var$write_Format(i /*:number*/ , f /*:string*/ , opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(b5 ? 3 + f.length : 5 + 2 * f.length);
    o.write_shift(2, i);
    o.write_shift(b5 ? 1 : 2, f.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * f.length, f, b5 ? "sbcs" : "utf16le");
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (out.l == null) out.l = out.length;
    return out;
}
var $3ee4f50b1ae43a89$var$parse_BIFF2Format = $3ee4f50b1ae43a89$var$parse_XLUnicodeString2;
/* [MS-XLS] 2.4.90 */ function $3ee4f50b1ae43a89$var$parse_Dimensions(blob, length, opts) {
    var end = blob.l + length;
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = blob.read_shift(2), C = blob.read_shift(2);
    blob.l = end;
    return {
        s: {
            r: r,
            c: c
        },
        e: {
            r: R,
            c: C
        }
    };
}
function $3ee4f50b1ae43a89$var$write_Dimensions(range, opts) {
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var o = $3ee4f50b1ae43a89$var$new_buf(2 * w + 6);
    o.write_shift(w, range.s.r);
    o.write_shift(w, range.e.r + 1);
    o.write_shift(2, range.s.c);
    o.write_shift(2, range.e.c + 1);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.220 */ function $3ee4f50b1ae43a89$var$parse_RK(blob) {
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrec = $3ee4f50b1ae43a89$var$parse_RkRec(blob);
    return {
        r: rw,
        c: col,
        ixfe: rkrec[0],
        rknum: rkrec[1]
    };
}
/* [MS-XLS] 2.4.175 */ function $3ee4f50b1ae43a89$var$parse_MulRk(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrecs = [];
    while(blob.l < target)rkrecs.push($3ee4f50b1ae43a89$var$parse_RkRec(blob));
    if (blob.l !== target) throw new Error("MulRK read error");
    var lastcol = blob.read_shift(2);
    if (rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        rkrec: rkrecs
    };
}
/* [MS-XLS] 2.4.174 */ function $3ee4f50b1ae43a89$var$parse_MulBlank(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var ixfes = [];
    while(blob.l < target)ixfes.push(blob.read_shift(2));
    if (blob.l !== target) throw new Error("MulBlank read error");
    var lastcol = blob.read_shift(2);
    if (ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        ixfe: ixfes
    };
}
/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */ function $3ee4f50b1ae43a89$var$parse_CellStyleXF(blob, length, style, opts) {
    var o = {};
    var a = blob.read_shift(4), b = blob.read_shift(4);
    var c = blob.read_shift(4), d = blob.read_shift(2);
    o.patternType = $3ee4f50b1ae43a89$var$XLSFillPattern[c >> 26];
    if (!opts.cellStyles) return o;
    o.alc = a & 0x07;
    o.fWrap = a >> 3 & 0x01;
    o.alcV = a >> 4 & 0x07;
    o.fJustLast = a >> 7 & 0x01;
    o.trot = a >> 8 & 0xFF;
    o.cIndent = a >> 16 & 0x0F;
    o.fShrinkToFit = a >> 20 & 0x01;
    o.iReadOrder = a >> 22 & 0x02;
    o.fAtrNum = a >> 26 & 0x01;
    o.fAtrFnt = a >> 27 & 0x01;
    o.fAtrAlc = a >> 28 & 0x01;
    o.fAtrBdr = a >> 29 & 0x01;
    o.fAtrPat = a >> 30 & 0x01;
    o.fAtrProt = a >> 31 & 0x01;
    o.dgLeft = b & 0x0F;
    o.dgRight = b >> 4 & 0x0F;
    o.dgTop = b >> 8 & 0x0F;
    o.dgBottom = b >> 12 & 0x0F;
    o.icvLeft = b >> 16 & 0x7F;
    o.icvRight = b >> 23 & 0x7F;
    o.grbitDiag = b >> 30 & 0x03;
    o.icvTop = c & 0x7F;
    o.icvBottom = c >> 7 & 0x7F;
    o.icvDiag = c >> 14 & 0x7F;
    o.dgDiag = c >> 21 & 0x0F;
    o.icvFore = d & 0x7F;
    o.icvBack = d >> 7 & 0x7F;
    o.fsxButton = d >> 14 & 0x01;
    return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
/* [MS-XLS] 2.4.353 TODO: actually do this right */ function $3ee4f50b1ae43a89$var$parse_XF(blob, length, opts) {
    var o = {};
    o.ifnt = blob.read_shift(2);
    o.numFmtId = blob.read_shift(2);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    length -= 6;
    o.data = $3ee4f50b1ae43a89$var$parse_CellStyleXF(blob, length, o.fStyle, opts);
    return o;
}
function $3ee4f50b1ae43a89$var$write_XF(data, ixfeP, opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(b5 ? 16 : 20);
    o.write_shift(2, 0);
    if (data.style) {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, 0xFFF4);
    } else {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, ixfeP << 4);
    }
    var f = 0;
    if (data.numFmtId > 0 && b5) f |= 0x0400;
    o.write_shift(4, f);
    o.write_shift(4, 0);
    if (!b5) o.write_shift(4, 0);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.134 */ function $3ee4f50b1ae43a89$var$parse_Guts(blob) {
    blob.l += 4;
    var out = [
        blob.read_shift(2),
        blob.read_shift(2)
    ];
    if (out[0] !== 0) out[0]--;
    if (out[1] !== 0) out[1]--;
    if (out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
    return out;
}
function $3ee4f50b1ae43a89$var$write_Guts(guts /*:Array<number>*/ ) {
    var o = $3ee4f50b1ae43a89$var$new_buf(8);
    o.write_shift(4, 0);
    o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
    o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
    return o;
}
/* [MS-XLS] 2.4.24 */ function $3ee4f50b1ae43a89$var$parse_BoolErr(blob, length, opts) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6);
    if (opts.biff == 2 || length == 9) ++blob.l;
    var val = $3ee4f50b1ae43a89$var$parse_Bes(blob, 2);
    cell.val = val;
    cell.t = val === true || val === false ? "b" : "e";
    return cell;
}
function $3ee4f50b1ae43a89$var$write_BoolErr(R /*:number*/ , C /*:number*/ , v, os /*:number*/ , opts, t /*:string*/ ) {
    var o = $3ee4f50b1ae43a89$var$new_buf(8);
    $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os, o);
    $3ee4f50b1ae43a89$var$write_Bes(v, t, o);
    return o;
}
/* [MS-XLS] 2.4.180 Number */ function $3ee4f50b1ae43a89$var$parse_Number(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6);
    var xnum = $3ee4f50b1ae43a89$var$parse_Xnum(blob, 8);
    cell.val = xnum;
    return cell;
}
function $3ee4f50b1ae43a89$var$write_Number(R /*:number*/ , C /*:number*/ , v, os /*:: :number, opts*/ ) {
    var o = $3ee4f50b1ae43a89$var$new_buf(14);
    $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os, o);
    $3ee4f50b1ae43a89$var$write_Xnum(v, o);
    return o;
}
var $3ee4f50b1ae43a89$var$parse_XLHeaderFooter = $3ee4f50b1ae43a89$var$parse_OptXLUnicodeString; // TODO: parse 2.4.136
/* [MS-XLS] 2.4.271 */ function $3ee4f50b1ae43a89$var$parse_SupBook(blob, length, opts) {
    var end = blob.l + length;
    var ctab = blob.read_shift(2);
    var cch = blob.read_shift(2);
    opts.sbcch = cch;
    if (cch == 0x0401 || cch == 0x3A01) return [
        cch,
        ctab
    ];
    if (cch < 0x01 || cch > 0xff) throw new Error("Unexpected SupBook type: " + cch);
    var virtPath = $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cch);
    /* TODO: 2.5.277 Virtual Path */ var rgst = [];
    while(end > blob.l)rgst.push($3ee4f50b1ae43a89$var$parse_XLUnicodeString(blob));
    return [
        cch,
        ctab,
        virtPath,
        rgst
    ];
}
/* [MS-XLS] 2.4.105 TODO */ function $3ee4f50b1ae43a89$var$parse_ExternName(blob, length, opts) {
    var flags = blob.read_shift(2);
    var body;
    var o = {
        fBuiltIn: flags & 0x01,
        fWantAdvise: flags >>> 1 & 0x01,
        fWantPict: flags >>> 2 & 0x01,
        fOle: flags >>> 3 & 0x01,
        fOleLink: flags >>> 4 & 0x01,
        cf: flags >>> 5 & 0x3FF,
        fIcon: flags >>> 15 & 0x01
    } /*:any*/ ;
    if (opts.sbcch === 0x3A01) body = $3ee4f50b1ae43a89$var$parse_AddinUdf(blob, length - 2, opts);
    //else throw new Error("unsupported SupBook cch: " + opts.sbcch);
    o.body = body || blob.read_shift(length - 2);
    if (typeof body === "string") o.Name = body;
    return o;
}
/* [MS-XLS] 2.4.150 TODO */ var $3ee4f50b1ae43a89$var$XLSLblBuiltIn = [
    "_xlnm.Consolidate_Area",
    "_xlnm.Auto_Open",
    "_xlnm.Auto_Close",
    "_xlnm.Extract",
    "_xlnm.Database",
    "_xlnm.Criteria",
    "_xlnm.Print_Area",
    "_xlnm.Print_Titles",
    "_xlnm.Recorder",
    "_xlnm.Data_Form",
    "_xlnm.Auto_Activate",
    "_xlnm.Auto_Deactivate",
    "_xlnm.Sheet_Title",
    "_xlnm._FilterDatabase"
];
function $3ee4f50b1ae43a89$var$parse_Lbl(blob, length, opts) {
    var target = blob.l + length;
    var flags = blob.read_shift(2);
    var chKey = blob.read_shift(1);
    var cch = blob.read_shift(1);
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var itab = 0;
    if (!opts || opts.biff >= 5) {
        if (opts.biff != 5) blob.l += 2;
        itab = blob.read_shift(2);
        if (opts.biff == 5) blob.l += 2;
        blob.l += 4;
    }
    var name = $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    if (flags & 0x20) name = $3ee4f50b1ae43a89$var$XLSLblBuiltIn[name.charCodeAt(0)];
    var npflen = target - blob.l;
    if (opts && opts.biff == 2) --npflen;
    /*jshint -W018 */ var rgce = target == blob.l || cce === 0 || !(npflen > 0) ? [] : $3ee4f50b1ae43a89$var$parse_NameParsedFormula(blob, npflen, opts, cce);
    /*jshint +W018 */ return {
        chKey: chKey,
        Name: name,
        itab: itab,
        rgce: rgce
    };
}
/* [MS-XLS] 2.4.106 TODO: verify filename encoding */ function $3ee4f50b1ae43a89$var$parse_ExternSheet(blob, length, opts) {
    if (opts.biff < 8) return $3ee4f50b1ae43a89$var$parse_BIFF5ExternSheet(blob, length, opts);
    var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
    while(len-- !== 0)o.push($3ee4f50b1ae43a89$var$parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
    // [iSupBook, itabFirst, itabLast];
    if (blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BIFF5ExternSheet(blob, length, opts) {
    if (blob[blob.l + 1] == 0x03) blob[blob.l]++;
    var o = $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, length, opts);
    return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}
/* [MS-XLS] 2.4.176 TODO: check older biff */ function $3ee4f50b1ae43a89$var$parse_NameCmt(blob, length, opts) {
    if (opts.biff < 8) {
        blob.l += length;
        return;
    }
    var cchName = blob.read_shift(2);
    var cchComment = blob.read_shift(2);
    var name = $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cchName, opts);
    var comment = $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cchComment, opts);
    return [
        name,
        comment
    ];
}
/* [MS-XLS] 2.4.260 */ function $3ee4f50b1ae43a89$var$parse_ShrFmla(blob, length, opts) {
    var ref = $3ee4f50b1ae43a89$var$parse_RefU(blob, 6);
    blob.l++;
    var cUse = blob.read_shift(1);
    length -= 8;
    return [
        $3ee4f50b1ae43a89$var$parse_SharedParsedFormula(blob, length, opts),
        cUse,
        ref
    ];
}
/* [MS-XLS] 2.4.4 TODO */ function $3ee4f50b1ae43a89$var$parse_Array(blob, length, opts) {
    var ref = $3ee4f50b1ae43a89$var$parse_Ref(blob, 6);
    /* TODO: fAlwaysCalc */ switch(opts.biff){
        case 2:
            blob.l++;
            length -= 7;
            break;
        case 3:
        case 4:
            blob.l += 2;
            length -= 8;
            break;
        default:
            blob.l += 6;
            length -= 12;
    }
    return [
        ref,
        $3ee4f50b1ae43a89$var$parse_ArrayParsedFormula(blob, length, opts, ref)
    ];
}
/* [MS-XLS] 2.4.173 */ function $3ee4f50b1ae43a89$var$parse_MTRSettings(blob) {
    var fMTREnabled = blob.read_shift(4) !== 0x00;
    var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
    var cUserThreadCount = blob.read_shift(4);
    return [
        fMTREnabled,
        fUserSetThreadCount,
        cUserThreadCount
    ];
}
/* [MS-XLS] 2.5.186 TODO: BIFF5 */ function $3ee4f50b1ae43a89$var$parse_NoteSh(blob, length, opts) {
    if (opts.biff < 8) return;
    var row = blob.read_shift(2), col = blob.read_shift(2);
    var flags = blob.read_shift(2), idObj = blob.read_shift(2);
    var stAuthor = $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, 0, opts);
    if (opts.biff < 8) blob.read_shift(1);
    return [
        {
            r: row,
            c: col
        },
        stAuthor,
        idObj,
        flags
    ];
}
/* [MS-XLS] 2.4.179 */ function $3ee4f50b1ae43a89$var$parse_Note(blob, length, opts) {
    /* TODO: Support revisions */ return $3ee4f50b1ae43a89$var$parse_NoteSh(blob, length, opts);
}
/* [MS-XLS] 2.4.168 */ function $3ee4f50b1ae43a89$var$parse_MergeCells(blob, length) /*:Array<Range>*/ {
    var merges /*:Array<Range>*/  = [];
    var cmcs = blob.read_shift(2);
    while(cmcs--)merges.push($3ee4f50b1ae43a89$var$parse_Ref8U(blob, length));
    return merges;
}
function $3ee4f50b1ae43a89$var$write_MergeCells(merges /*:Array<Range>*/ ) {
    var o = $3ee4f50b1ae43a89$var$new_buf(2 + merges.length * 8);
    o.write_shift(2, merges.length);
    for(var i = 0; i < merges.length; ++i)$3ee4f50b1ae43a89$var$write_Ref8U(merges[i], o);
    return o;
}
/* [MS-XLS] 2.4.181 TODO: parse all the things! */ function $3ee4f50b1ae43a89$var$parse_Obj(blob, length, opts) {
    if (opts && opts.biff < 8) return $3ee4f50b1ae43a89$var$parse_BIFF5Obj(blob, length, opts);
    var cmo = $3ee4f50b1ae43a89$var$parse_FtCmo(blob, 22); // id, ot, flags
    var fts = $3ee4f50b1ae43a89$var$parse_FtArray(blob, length - 22, cmo[1]);
    return {
        cmo: cmo,
        ft: fts
    };
}
/* from older spec */ var $3ee4f50b1ae43a89$var$parse_BIFF5OT = {
    0x08: function(blob, length) {
        var tgt = blob.l + length;
        blob.l += 10; // todo
        var cf = blob.read_shift(2);
        blob.l += 4;
        blob.l += 2; //var cbPictFmla = blob.read_shift(2);
        blob.l += 2;
        blob.l += 2; //var grbit = blob.read_shift(2);
        blob.l += 4;
        var cchName = blob.read_shift(1);
        blob.l += cchName; // TODO: stName
        blob.l = tgt; // TODO: fmla
        return {
            fmt: cf
        };
    }
};
function $3ee4f50b1ae43a89$var$parse_BIFF5Obj(blob, length, opts) {
    blob.l += 4; //var cnt = blob.read_shift(4);
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var grbit = blob.read_shift(2);
    blob.l += 2; //var colL = blob.read_shift(2);
    blob.l += 2; //var dxL = blob.read_shift(2);
    blob.l += 2; //var rwT = blob.read_shift(2);
    blob.l += 2; //var dyT = blob.read_shift(2);
    blob.l += 2; //var colR = blob.read_shift(2);
    blob.l += 2; //var dxR = blob.read_shift(2);
    blob.l += 2; //var rwB = blob.read_shift(2);
    blob.l += 2; //var dyB = blob.read_shift(2);
    blob.l += 2; //var cbMacro = blob.read_shift(2);
    blob.l += 6;
    length -= 36;
    var fts = [];
    fts.push(($3ee4f50b1ae43a89$var$parse_BIFF5OT[ot] || $3ee4f50b1ae43a89$var$parsenoop)(blob, length, opts));
    return {
        cmo: [
            id,
            ot,
            grbit
        ],
        ft: fts
    };
}
/* [MS-XLS] 2.4.329 TODO: parse properly */ function $3ee4f50b1ae43a89$var$parse_TxO(blob, length, opts) {
    var s = blob.l;
    var texts = "";
    try {
        blob.l += 4;
        var ot = (opts.lastobj || {
            cmo: [
                0,
                0
            ]
        }).cmo[1];
        var controlInfo; // eslint-disable-line no-unused-vars
        if ([
            0,
            5,
            7,
            11,
            12,
            14
        ].indexOf(ot) == -1) blob.l += 6;
        else controlInfo = $3ee4f50b1ae43a89$var$parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
        var cchText = blob.read_shift(2);
        /*var cbRuns = */ blob.read_shift(2);
        /*var ifntEmpty = */ $3ee4f50b1ae43a89$var$parseuint16(blob, 2);
        var len = blob.read_shift(2);
        blob.l += len;
        //var fmla = parse_ObjFmla(blob, s + length - blob.l);
        for(var i = 1; i < blob.lens.length - 1; ++i){
            if (blob.l - s != blob.lens[i]) throw new Error("TxO: bad continue record");
            var hdr = blob[blob.l];
            var t = $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, blob.lens[i + 1] - blob.lens[i] - 1);
            texts += t;
            if (texts.length >= (hdr ? cchText : 2 * cchText)) break;
        }
        if (texts.length !== cchText && texts.length !== cchText * 2) throw new Error("cchText: " + cchText + " != " + texts.length);
        blob.l = s + length;
        /* [MS-XLS] 2.5.272 TxORuns */ //	var rgTxoRuns = [];
        //	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
        //	var cchText2 = blob.read_shift(2);
        //	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
        //	blob.l += 6;
        //	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
        return {
            t: texts
        };
    } catch (e) {
        blob.l = s + length;
        return {
            t: texts
        };
    }
}
/* [MS-XLS] 2.4.140 */ function $3ee4f50b1ae43a89$var$parse_HLink(blob, length) {
    var ref = $3ee4f50b1ae43a89$var$parse_Ref8U(blob, 8);
    blob.l += 16; /* CLSID */ 
    var hlink = $3ee4f50b1ae43a89$var$parse_Hyperlink(blob, length - 24);
    return [
        ref,
        hlink
    ];
}
function $3ee4f50b1ae43a89$var$write_HLink(hl) {
    var O = $3ee4f50b1ae43a89$var$new_buf(24);
    var ref = $3ee4f50b1ae43a89$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
    for(var i = 0; i < 16; ++i)O.write_shift(1, parseInt(clsid[i], 16));
    return $3ee4f50b1ae43a89$var$bconcat([
        O,
        $3ee4f50b1ae43a89$var$write_Hyperlink(hl[1])
    ]);
}
/* [MS-XLS] 2.4.141 */ function $3ee4f50b1ae43a89$var$parse_HLinkTooltip(blob, length) {
    blob.read_shift(2);
    var ref = $3ee4f50b1ae43a89$var$parse_Ref8U(blob, 8);
    var wzTooltip = blob.read_shift((length - 10) / 2, "dbcs-cont");
    wzTooltip = wzTooltip.replace($3ee4f50b1ae43a89$var$chr0, "");
    return [
        ref,
        wzTooltip
    ];
}
function $3ee4f50b1ae43a89$var$write_HLinkTooltip(hl) {
    var TT = hl[1].Tooltip;
    var O = $3ee4f50b1ae43a89$var$new_buf(10 + 2 * (TT.length + 1));
    O.write_shift(2, 0x0800);
    var ref = $3ee4f50b1ae43a89$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    for(var i = 0; i < TT.length; ++i)O.write_shift(2, TT.charCodeAt(i));
    O.write_shift(2, 0);
    return O;
}
/* [MS-XLS] 2.4.63 */ function $3ee4f50b1ae43a89$var$parse_Country(blob) /*:[string|number, string|number]*/ {
    var o = [
        0,
        0
    ], d;
    d = blob.read_shift(2);
    o[0] = $3ee4f50b1ae43a89$var$CountryEnum[d] || d;
    d = blob.read_shift(2);
    o[1] = $3ee4f50b1ae43a89$var$CountryEnum[d] || d;
    return o;
}
function $3ee4f50b1ae43a89$var$write_Country(o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(4);
    o.write_shift(2, 0x01);
    o.write_shift(2, 0x01);
    return o;
}
/* [MS-XLS] 2.4.50 ClrtClient */ function $3ee4f50b1ae43a89$var$parse_ClrtClient(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($3ee4f50b1ae43a89$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.188 */ function $3ee4f50b1ae43a89$var$parse_Palette(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($3ee4f50b1ae43a89$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.354 */ function $3ee4f50b1ae43a89$var$parse_XFCRC(blob) {
    blob.l += 2;
    var o = {
        cxfs: 0,
        crc: 0
    };
    o.cxfs = blob.read_shift(2);
    o.crc = blob.read_shift(4);
    return o;
}
/* [MS-XLS] 2.4.53 TODO: parse flags */ /* [MS-XLSB] 2.4.323 TODO: parse flags */ function $3ee4f50b1ae43a89$var$parse_ColInfo(blob, length, opts) {
    if (!opts.cellStyles) return $3ee4f50b1ae43a89$var$parsenoop(blob, length);
    var w = opts && opts.biff >= 12 ? 4 : 2;
    var colFirst = blob.read_shift(w);
    var colLast = blob.read_shift(w);
    var coldx = blob.read_shift(w);
    var ixfe = blob.read_shift(w);
    var flags = blob.read_shift(2);
    if (w == 2) blob.l += 2;
    var o = {
        s: colFirst,
        e: colLast,
        w: coldx,
        ixfe: ixfe,
        flags: flags
    } /*:any*/ ;
    if (opts.biff >= 5 || !opts.biff) o.level = flags >> 8 & 0x7;
    return o;
}
function $3ee4f50b1ae43a89$var$write_ColInfo(col, idx) {
    var o = $3ee4f50b1ae43a89$var$new_buf(12);
    o.write_shift(2, idx);
    o.write_shift(2, idx);
    o.write_shift(2, col.width * 256);
    o.write_shift(2, 0);
    var f = 0;
    if (col.hidden) f |= 1;
    o.write_shift(1, f);
    f = col.level || 0;
    o.write_shift(1, f);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.257 */ function $3ee4f50b1ae43a89$var$parse_Setup(blob, length) {
    var o = {};
    if (length < 32) return o;
    blob.l += 16;
    o.header = $3ee4f50b1ae43a89$var$parse_Xnum(blob, 8);
    o.footer = $3ee4f50b1ae43a89$var$parse_Xnum(blob, 8);
    blob.l += 2;
    return o;
}
/* [MS-XLS] 2.4.261 */ function $3ee4f50b1ae43a89$var$parse_ShtProps(blob, length, opts) {
    var def = {
        area: false
    };
    if (opts.biff != 5) {
        blob.l += length;
        return def;
    }
    var d = blob.read_shift(1);
    blob.l += 3;
    if (d & 0x10) def.area = true;
    return def;
}
/* [MS-XLS] 2.4.241 */ function $3ee4f50b1ae43a89$var$write_RRTabId(n /*:number*/ ) {
    var out = $3ee4f50b1ae43a89$var$new_buf(2 * n);
    for(var i = 0; i < n; ++i)out.write_shift(2, i + 1);
    return out;
}
var $3ee4f50b1ae43a89$var$parse_Blank = $3ee4f50b1ae43a89$var$parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */ 
var $3ee4f50b1ae43a89$var$parse_Scl = $3ee4f50b1ae43a89$var$parseuint16a; /* [MS-XLS] 2.4.247 num, den */ 
var $3ee4f50b1ae43a89$var$parse_String = $3ee4f50b1ae43a89$var$parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */ 
/* --- Specific to versions before BIFF8 --- */ function $3ee4f50b1ae43a89$var$parse_ImData(blob) {
    var cf = blob.read_shift(2);
    var env = blob.read_shift(2);
    var lcb = blob.read_shift(4);
    var o = {
        fmt: cf,
        env: env,
        len: lcb,
        data: blob.slice(blob.l, blob.l + lcb)
    };
    blob.l += lcb;
    return o;
}
/* BIFF2_??? where ??? is the name from [XLS] */ function $3ee4f50b1ae43a89$var$parse_BIFF2STR(blob, length, opts) {
    if (opts.biffguess && opts.biff == 5) opts.biff = 2;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6);
    ++blob.l;
    var str = $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, length - 7, opts);
    cell.t = "str";
    cell.val = str;
    return cell;
}
function $3ee4f50b1ae43a89$var$parse_BIFF2NUM(blob /*::, length*/ ) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6);
    ++blob.l;
    var num = $3ee4f50b1ae43a89$var$parse_Xnum(blob, 8);
    cell.t = "n";
    cell.val = num;
    return cell;
}
function $3ee4f50b1ae43a89$var$write_BIFF2NUM(r /*:number*/ , c /*:number*/ , val /*:number*/ ) {
    var out = $3ee4f50b1ae43a89$var$new_buf(15);
    $3ee4f50b1ae43a89$var$write_BIFF2Cell(out, r, c);
    out.write_shift(8, val, "f");
    return out;
}
function $3ee4f50b1ae43a89$var$parse_BIFF2INT(blob) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6);
    ++blob.l;
    var num = blob.read_shift(2);
    cell.t = "n";
    cell.val = num;
    return cell;
}
function $3ee4f50b1ae43a89$var$write_BIFF2INT(r /*:number*/ , c /*:number*/ , val /*:number*/ ) {
    var out = $3ee4f50b1ae43a89$var$new_buf(9);
    $3ee4f50b1ae43a89$var$write_BIFF2Cell(out, r, c);
    out.write_shift(2, val);
    return out;
}
function $3ee4f50b1ae43a89$var$parse_BIFF2STRING(blob) {
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, "sbcs-cont");
}
/* TODO: convert to BIFF8 font struct */ function $3ee4f50b1ae43a89$var$parse_BIFF2FONTXTRA(blob, length) {
    blob.l += 6; // unknown
    blob.l += 2; // font weight "bls"
    blob.l += 1; // charset
    blob.l += 3; // unknown
    blob.l += 1; // font family
    blob.l += length - 13;
}
/* TODO: parse rich text runs */ function $3ee4f50b1ae43a89$var$parse_RString(blob, length, opts) {
    var end = blob.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6);
    var cch = blob.read_shift(2);
    var str = $3ee4f50b1ae43a89$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    blob.l = end;
    cell.t = "str";
    cell.val = str;
    return cell;
}
/* from js-harb (C) 2014-present  SheetJS */ var $3ee4f50b1ae43a89$var$DBF_SUPPORTED_VERSIONS = [
    0x02,
    0x03,
    0x30,
    0x31,
    0x83,
    0x8B,
    0x8C,
    0xF5
];
var $3ee4f50b1ae43a89$var$DBF = /*#__PURE__*/ function() {
    var dbf_codepage_map = {
        /* Code Pages Supported by Visual FoxPro */ /*::[*/ 0x01: 437,
        /*::[*/ 0x02: 850,
        /*::[*/ 0x03: 1252,
        /*::[*/ 0x04: 10000,
        /*::[*/ 0x64: 852,
        /*::[*/ 0x65: 866,
        /*::[*/ 0x66: 865,
        /*::[*/ 0x67: 861,
        /*::[*/ 0x68: 895,
        /*::[*/ 0x69: 620,
        /*::[*/ 0x6A: 737,
        /*::[*/ 0x6B: 857,
        /*::[*/ 0x78: 950,
        /*::[*/ 0x79: 949,
        /*::[*/ 0x7A: 936,
        /*::[*/ 0x7B: 932,
        /*::[*/ 0x7C: 874,
        /*::[*/ 0x7D: 1255,
        /*::[*/ 0x7E: 1256,
        /*::[*/ 0x96: 10007,
        /*::[*/ 0x97: 10029,
        /*::[*/ 0x98: 10006,
        /*::[*/ 0xC8: 1250,
        /*::[*/ 0xC9: 1251,
        /*::[*/ 0xCA: 1254,
        /*::[*/ 0xCB: 1253,
        /* shapefile DBF extension */ /*::[*/ 0x00: 20127,
        /*::[*/ 0x08: 865,
        /*::[*/ 0x09: 437,
        /*::[*/ 0x0A: 850,
        /*::[*/ 0x0B: 437,
        /*::[*/ 0x0D: 437,
        /*::[*/ 0x0E: 850,
        /*::[*/ 0x0F: 437,
        /*::[*/ 0x10: 850,
        /*::[*/ 0x11: 437,
        /*::[*/ 0x12: 850,
        /*::[*/ 0x13: 932,
        /*::[*/ 0x14: 850,
        /*::[*/ 0x15: 437,
        /*::[*/ 0x16: 850,
        /*::[*/ 0x17: 865,
        /*::[*/ 0x18: 437,
        /*::[*/ 0x19: 437,
        /*::[*/ 0x1A: 850,
        /*::[*/ 0x1B: 437,
        /*::[*/ 0x1C: 863,
        /*::[*/ 0x1D: 850,
        /*::[*/ 0x1F: 852,
        /*::[*/ 0x22: 852,
        /*::[*/ 0x23: 852,
        /*::[*/ 0x24: 860,
        /*::[*/ 0x25: 850,
        /*::[*/ 0x26: 866,
        /*::[*/ 0x37: 850,
        /*::[*/ 0x40: 852,
        /*::[*/ 0x4D: 936,
        /*::[*/ 0x4E: 949,
        /*::[*/ 0x4F: 950,
        /*::[*/ 0x50: 874,
        /*::[*/ 0x57: 1252,
        /*::[*/ 0x58: 1252,
        /*::[*/ 0x59: 1252,
        /*::[*/ 0x6C: 863,
        /*::[*/ 0x86: 737,
        /*::[*/ 0x87: 852,
        /*::[*/ 0x88: 857,
        /*::[*/ 0xCC: 1257,
        /*::[*/ 0xFF: 16969
    };
    var dbf_reverse_map = $3ee4f50b1ae43a89$var$evert({
        /*::[*/ 0x01: 437,
        /*::[*/ 0x02: 850,
        /*::[*/ 0x03: 1252,
        /*::[*/ 0x04: 10000,
        /*::[*/ 0x64: 852,
        /*::[*/ 0x65: 866,
        /*::[*/ 0x66: 865,
        /*::[*/ 0x67: 861,
        /*::[*/ 0x68: 895,
        /*::[*/ 0x69: 620,
        /*::[*/ 0x6A: 737,
        /*::[*/ 0x6B: 857,
        /*::[*/ 0x78: 950,
        /*::[*/ 0x79: 949,
        /*::[*/ 0x7A: 936,
        /*::[*/ 0x7B: 932,
        /*::[*/ 0x7C: 874,
        /*::[*/ 0x7D: 1255,
        /*::[*/ 0x7E: 1256,
        /*::[*/ 0x96: 10007,
        /*::[*/ 0x97: 10029,
        /*::[*/ 0x98: 10006,
        /*::[*/ 0xC8: 1250,
        /*::[*/ 0xC9: 1251,
        /*::[*/ 0xCA: 1254,
        /*::[*/ 0xCB: 1253,
        /*::[*/ 0x00: 20127
    });
    /* TODO: find an actual specification */ function dbf_to_aoa(buf, opts) /*:AOA*/ {
        var out /*:AOA*/  = [];
        var d /*:Block*/  = $3ee4f50b1ae43a89$var$new_raw_buf(1);
        switch(opts.type){
            case "base64":
                d = $3ee4f50b1ae43a89$var$s2a($3ee4f50b1ae43a89$var$Base64_decode(buf));
                break;
            case "binary":
                d = $3ee4f50b1ae43a89$var$s2a(buf);
                break;
            case "buffer":
            case "array":
                d = buf;
                break;
        }
        $3ee4f50b1ae43a89$var$prep_blob(d, 0);
        /* header */ var ft = d.read_shift(1);
        var memo = !!(ft & 0x88);
        var vfp = false, l7 = false;
        switch(ft){
            case 0x02:
                break; // dBASE II
            case 0x03:
                break; // dBASE III
            case 0x30:
                vfp = true;
                memo = true;
                break; // VFP
            case 0x31:
                vfp = true;
                memo = true;
                break; // VFP with autoincrement
            // 0x43 dBASE IV SQL table files
            // 0x63 dBASE IV SQL system files
            case 0x83:
                break; // dBASE III with memo
            case 0x8B:
                break; // dBASE IV with memo
            case 0x8C:
                l7 = true;
                break; // dBASE Level 7 with memo
            // case 0xCB dBASE IV SQL table files with memo
            case 0xF5:
                break; // FoxPro 2.x with memo
            // case 0xFB FoxBASE
            default:
                throw new Error("DBF Unsupported Version: " + ft.toString(16));
        }
        var nrow = 0, fpos = 0x0209;
        if (ft == 0x02) nrow = d.read_shift(2);
        d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
        if (ft != 0x02) nrow = d.read_shift(4);
        if (nrow > 1048576) nrow = 1e6;
        if (ft != 0x02) fpos = d.read_shift(2); // header length
        var rlen = d.read_shift(2); // record length
        var /*flags = 0,*/ current_cp = opts.codepage || 1252;
        if (ft != 0x02) {
            d.l += 16;
            /*flags = */ d.read_shift(1);
            //if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
            /* codepage present in FoxPro and dBASE Level 7 */ if (d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
            d.l += 1;
            d.l += 2;
        }
        if (l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
        /*:: type DBFField = { name:string; len:number; type:string; } */ var fields /*:Array<DBFField>*/  = [], field /*:DBFField*/  = {} /*:any*/ ;
        var hend = Math.min(d.length, ft == 0x02 ? 0x209 : fpos - 10 - (vfp ? 264 : 0));
        var ww = l7 ? 32 : 11;
        while(d.l < hend && d[d.l] != 0x0d){
            field = {} /*:any*/ ;
            field.name = $3ee4f50b1ae43a89$var$$cptable.utils.decode(current_cp, d.slice(d.l, d.l + ww)).replace(/[\u0000\r\n].*$/g, "");
            d.l += ww;
            field.type = String.fromCharCode(d.read_shift(1));
            if (ft != 0x02 && !l7) field.offset = d.read_shift(4);
            field.len = d.read_shift(1);
            if (ft == 0x02) field.offset = d.read_shift(2);
            field.dec = d.read_shift(1);
            if (field.name.length) fields.push(field);
            if (ft != 0x02) d.l += l7 ? 13 : 14;
            switch(field.type){
                case "B":
                    if ((!vfp || field.len != 8) && opts.WTF) console.log("Skipping " + field.name + ":" + field.type);
                    break;
                case "G":
                case "P":
                    if (opts.WTF) console.log("Skipping " + field.name + ":" + field.type);
                    break;
                case "+":
                case "0":
                case "@":
                case "C":
                case "D":
                case "F":
                case "I":
                case "L":
                case "M":
                case "N":
                case "O":
                case "T":
                case "Y":
                    break;
                default:
                    throw new Error("Unknown Field Type: " + field.type);
            }
        }
        if (d[d.l] !== 0x0D) d.l = fpos - 1;
        if (d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
        d.l = fpos;
        /* data */ var R = 0, C = 0;
        out[0] = [];
        for(C = 0; C != fields.length; ++C)out[0][C] = fields[C].name;
        while(nrow-- > 0){
            if (d[d.l] === 0x2A) {
                // TODO: record marked as deleted -- create a hidden row?
                d.l += rlen;
                continue;
            }
            ++d.l;
            out[++R] = [];
            C = 0;
            for(C = 0; C != fields.length; ++C){
                var dd = d.slice(d.l, d.l + fields[C].len);
                d.l += fields[C].len;
                $3ee4f50b1ae43a89$var$prep_blob(dd, 0);
                var s = $3ee4f50b1ae43a89$var$$cptable.utils.decode(current_cp, dd);
                switch(fields[C].type){
                    case "C":
                        // NOTE: it is conventional to write '  /  /  ' for empty dates
                        if (s.trim().length) out[R][C] = s.replace(/\s+$/, "");
                        break;
                    case "D":
                        if (s.length === 8) out[R][C] = new Date(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8));
                        else out[R][C] = s;
                        break;
                    case "F":
                        out[R][C] = parseFloat(s.trim());
                        break;
                    case "+":
                    case "I":
                        out[R][C] = l7 ? dd.read_shift(-4, "i") ^ 0x80000000 : dd.read_shift(4, "i");
                        break;
                    case "L":
                        switch(s.trim().toUpperCase()){
                            case "Y":
                            case "T":
                                out[R][C] = true;
                                break;
                            case "N":
                            case "F":
                                out[R][C] = false;
                                break;
                            case "":
                            case "?":
                                break;
                            default:
                                throw new Error("DBF Unrecognized L:|" + s + "|");
                        }
                        break;
                    case "M":
                        /* TODO: handle memo files */ if (!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
                        out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10) : dd.read_shift(4));
                        break;
                    case "N":
                        s = s.replace(/\u0000/g, "").trim();
                        // NOTE: dBASE II interprets "  .  " as 0
                        if (s && s != ".") out[R][C] = +s || 0;
                        break;
                    case "@":
                        // NOTE: dBASE specs appear to be incorrect
                        out[R][C] = new Date(dd.read_shift(-8, "f") - 0x388317533400);
                        break;
                    case "T":
                        out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4));
                        break;
                    case "Y":
                        out[R][C] = dd.read_shift(4, "i") / 1e4 + dd.read_shift(4, "i") / 1e4 * Math.pow(2, 32);
                        break;
                    case "O":
                        out[R][C] = -dd.read_shift(-8, "f");
                        break;
                    case "B":
                        if (vfp && fields[C].len == 8) {
                            out[R][C] = dd.read_shift(8, "f");
                            break;
                        }
                    /* falls through */ case "G":
                    case "P":
                        dd.l += fields[C].len;
                        break;
                    case "0":
                        if (fields[C].name === "_NullFlags") break;
                    /* falls through */ default:
                        throw new Error("DBF Unsupported data type " + fields[C].type);
                }
            }
        }
        if (ft != 0x02) {
            if (d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l - 1) + " of " + d.length + " " + d[d.l - 1].toString(16));
        }
        if (opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
        opts.DBF = fields;
        return out;
    }
    function dbf_to_sheet(buf, opts) /*:Worksheet*/ {
        var o = opts || {};
        if (!o.dateNF) o.dateNF = "yyyymmdd";
        var ws = $3ee4f50b1ae43a89$var$aoa_to_sheet(dbf_to_aoa(buf, o), o);
        ws["!cols"] = o.DBF.map(function(field) {
            return {
                wch: field.len,
                DBF: field
            };
        });
        delete o.DBF;
        return ws;
    }
    function dbf_to_workbook(buf, opts) /*:Workbook*/ {
        try {
            return $3ee4f50b1ae43a89$var$sheet_to_workbook(dbf_to_sheet(buf, opts), opts);
        } catch (e) {
            if (opts && opts.WTF) throw e;
        }
        return {
            SheetNames: [],
            Sheets: {}
        };
    }
    var _RLEN = {
        "B": 8,
        "C": 250,
        "L": 1,
        "D": 8,
        "?": 0,
        "": 0
    };
    function sheet_to_dbf(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $3ee4f50b1ae43a89$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write DBF to JS string");
        var ba = $3ee4f50b1ae43a89$var$buf_array();
        var aoa /*:AOA*/  = $3ee4f50b1ae43a89$var$sheet_to_json(ws, {
            header: 1,
            raw: true,
            cellDates: true
        });
        var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
        var i = 0, j = 0, hcnt = 0, rlen = 1;
        for(i = 0; i < headers.length; ++i){
            if (((cols[i] || {}).DBF || {}).name) {
                headers[i] = cols[i].DBF.name;
                ++hcnt;
                continue;
            }
            if (headers[i] == null) continue;
            ++hcnt;
            if (typeof headers[i] === "number") headers[i] = headers[i].toString(10);
            if (typeof headers[i] !== "string") throw new Error("DBF Invalid column name " + headers[i] + " |" + typeof headers[i] + "|");
            if (headers.indexOf(headers[i]) !== i) {
                for(j = 0; j < 1024; ++j)if (headers.indexOf(headers[i] + "_" + j) == -1) {
                    headers[i] += "_" + j;
                    break;
                }
            }
        }
        var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]);
        var coltypes /*:Array<string>*/  = [];
        var colwidths /*:Array<number>*/  = [];
        var coldecimals /*:Array<number>*/  = [];
        for(i = 0; i <= range.e.c - range.s.c; ++i){
            var guess = "", _guess = "", maxlen = 0;
            var col /*:Array<any>*/  = [];
            for(j = 0; j < data.length; ++j)if (data[j][i] != null) col.push(data[j][i]);
            if (col.length == 0 || headers[i] == null) {
                coltypes[i] = "?";
                continue;
            }
            for(j = 0; j < col.length; ++j){
                switch(typeof col[j]){
                    /* TODO: check if L2 compat is desired */ case "number":
                        _guess = "B";
                        break;
                    case "string":
                        _guess = "C";
                        break;
                    case "boolean":
                        _guess = "L";
                        break;
                    case "object":
                        _guess = col[j] instanceof Date ? "D" : "C";
                        break;
                    default:
                        _guess = "C";
                }
                maxlen = Math.max(maxlen, String(col[j]).length);
                guess = guess && guess != _guess ? "C" : _guess;
            //if(guess == 'C') break;
            }
            if (maxlen > 250) maxlen = 250;
            _guess = ((cols[i] || {}).DBF || {}).type;
            /* TODO: more fine grained control over DBF type resolution */ if (_guess == "C") {
                if (cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
            }
            if (guess == "B" && _guess == "N") {
                guess = "N";
                coldecimals[i] = cols[i].DBF.dec;
                maxlen = cols[i].DBF.len;
            }
            colwidths[i] = guess == "C" || _guess == "N" ? maxlen : _RLEN[guess] || 0;
            rlen += colwidths[i];
            coltypes[i] = guess;
        }
        var h = ba.next(32);
        h.write_shift(4, 0x13021130);
        h.write_shift(4, data.length);
        h.write_shift(2, 296 + 32 * hcnt);
        h.write_shift(2, rlen);
        for(i = 0; i < 4; ++i)h.write_shift(4, 0);
        h.write_shift(4, 0x00000000 | (+dbf_reverse_map[/*::String(*/ $3ee4f50b1ae43a89$var$current_ansi /*::)*/ ] || 0x03) << 8);
        for(i = 0, j = 0; i < headers.length; ++i){
            if (headers[i] == null) continue;
            var hf = ba.next(32);
            var _f = (headers[i].slice(-10) + "\0\0\0\0\0\0\0\0\0\0\0").slice(0, 11);
            hf.write_shift(1, _f, "sbcs");
            hf.write_shift(1, coltypes[i] == "?" ? "C" : coltypes[i], "sbcs");
            hf.write_shift(4, j);
            hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
            hf.write_shift(1, coldecimals[i] || 0);
            hf.write_shift(1, 0x02);
            hf.write_shift(4, 0);
            hf.write_shift(1, 0);
            hf.write_shift(4, 0);
            hf.write_shift(4, 0);
            j += colwidths[i] || _RLEN[coltypes[i]] || 0;
        }
        var hb = ba.next(264);
        hb.write_shift(4, 0x0000000D);
        for(i = 0; i < 65; ++i)hb.write_shift(4, 0x00000000);
        for(i = 0; i < data.length; ++i){
            var rout = ba.next(rlen);
            rout.write_shift(1, 0);
            for(j = 0; j < headers.length; ++j){
                if (headers[j] == null) continue;
                switch(coltypes[j]){
                    case "L":
                        rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46);
                        break;
                    case "B":
                        rout.write_shift(8, data[i][j] || 0, "f");
                        break;
                    case "N":
                        var _n = "0";
                        if (typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j] || 0);
                        for(hcnt = 0; hcnt < colwidths[j] - _n.length; ++hcnt)rout.write_shift(1, 0x20);
                        rout.write_shift(1, _n, "sbcs");
                        break;
                    case "D":
                        if (!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
                        else {
                            rout.write_shift(4, ("0000" + data[i][j].getFullYear()).slice(-4), "sbcs");
                            rout.write_shift(2, ("00" + (data[i][j].getMonth() + 1)).slice(-2), "sbcs");
                            rout.write_shift(2, ("00" + data[i][j].getDate()).slice(-2), "sbcs");
                        }
                        break;
                    case "C":
                        var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
                        rout.write_shift(1, _s, "sbcs");
                        for(hcnt = 0; hcnt < colwidths[j] - _s.length; ++hcnt)rout.write_shift(1, 0x20);
                        break;
                }
            }
        // data
        }
        ba.next(1).write_shift(1, 0x1A);
        return ba.end();
    }
    return {
        to_workbook: dbf_to_workbook,
        to_sheet: dbf_to_sheet,
        from_sheet: sheet_to_dbf
    };
}();
var $3ee4f50b1ae43a89$var$SYLK = /*#__PURE__*/ function() {
    /* TODO: stress test sequences */ var sylk_escapes = {
        AA: "\xc0",
        BA: "\xc1",
        CA: "\xc2",
        DA: 195,
        HA: "\xc4",
        JA: 197,
        AE: "\xc8",
        BE: "\xc9",
        CE: "\xca",
        HE: "\xcb",
        AI: "\xcc",
        BI: "\xcd",
        CI: "\xce",
        HI: "\xcf",
        AO: "\xd2",
        BO: "\xd3",
        CO: "\xd4",
        DO: 213,
        HO: "\xd6",
        AU: "\xd9",
        BU: "\xda",
        CU: "\xdb",
        HU: "\xdc",
        Aa: "\xe0",
        Ba: "\xe1",
        Ca: "\xe2",
        Da: 227,
        Ha: "\xe4",
        Ja: 229,
        Ae: "\xe8",
        Be: "\xe9",
        Ce: "\xea",
        He: "\xeb",
        Ai: "\xec",
        Bi: "\xed",
        Ci: "\xee",
        Hi: "\xef",
        Ao: "\xf2",
        Bo: "\xf3",
        Co: "\xf4",
        Do: 245,
        Ho: "\xf6",
        Au: "\xf9",
        Bu: "\xfa",
        Cu: "\xfb",
        Hu: "\xfc",
        KC: "\xc7",
        Kc: "\xe7",
        q: "\xe6",
        z: "\u0153",
        a: "\xc6",
        j: "\u0152",
        DN: 209,
        Dn: 241,
        Hy: 255,
        S: 169,
        c: 170,
        R: 174,
        "B ": 180,
        /*::[*/ 0: 176,
        /*::[*/ 1: 177,
        /*::[*/ 2: 178,
        /*::[*/ 3: 179,
        /*::[*/ 5: 181,
        /*::[*/ 6: 182,
        /*::[*/ 7: 183,
        Q: 185,
        k: 186,
        b: 208,
        i: 216,
        l: 222,
        s: 240,
        y: 248,
        "!": 161,
        '"': 162,
        "#": 163,
        "(": 164,
        "%": 165,
        "'": 167,
        "H ": 168,
        "+": 171,
        ";": 187,
        "<": 188,
        "=": 189,
        ">": 190,
        "?": 191,
        "{": 223
    } /*:any*/ ;
    var sylk_char_regex = new RegExp("\x1bN(" + $3ee4f50b1ae43a89$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm");
    var sylk_char_fn = function(_, $1) {
        var o = sylk_escapes[$1];
        return typeof o == "number" ? $3ee4f50b1ae43a89$var$_getansi(o) : o;
    };
    var decode_sylk_char = function($$, $1, $2) {
        var newcc = $1.charCodeAt(0) - 0x20 << 4 | $2.charCodeAt(0) - 0x30;
        return newcc == 59 ? $$ : $3ee4f50b1ae43a89$var$_getansi(newcc);
    };
    sylk_escapes["|"] = 254;
    /* TODO: find an actual specification */ function sylk_to_aoa(d /*:RawData*/ , opts) /*:[AOA, Worksheet]*/ {
        switch(opts.type){
            case "base64":
                return sylk_to_aoa_str($3ee4f50b1ae43a89$var$Base64_decode(d), opts);
            case "binary":
                return sylk_to_aoa_str(d, opts);
            case "buffer":
                return sylk_to_aoa_str($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(d) ? d.toString("binary") : $3ee4f50b1ae43a89$var$a2s(d), opts);
            case "array":
                return sylk_to_aoa_str($3ee4f50b1ae43a89$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function sylk_to_aoa_str(str /*:string*/ , opts) /*:[AOA, Worksheet]*/ {
        var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr /*:AOA*/  = [];
        var formats /*:Array<string>*/  = [];
        var next_cell_format /*:string|null*/  = null;
        var sht = {}, rowinfo /*:Array<RowInfo>*/  = [], colinfo /*:Array<ColInfo>*/  = [], cw /*:Array<string>*/  = [];
        var Mval = 0, j;
        if (+opts.codepage >= 0) $3ee4f50b1ae43a89$var$set_cp(+opts.codepage);
        for(; ri !== records.length; ++ri){
            Mval = 0;
            var rstr = records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
            var record = rstr.replace(/;;/g, "\0").split(";").map(function(x) {
                return x.replace(/\u0000/g, ";");
            });
            var RT = record[0], val;
            if (rstr.length > 0) switch(RT){
                case "ID":
                    break; /* header */ 
                case "E":
                    break; /* EOF */ 
                case "B":
                    break; /* dimensions */ 
                case "O":
                    break; /* options? */ 
                case "W":
                    break; /* window? */ 
                case "P":
                    if (record[1].charAt(0) == "P") formats.push(rstr.slice(3).replace(/;;/g, ";"));
                    break;
                case "C":
                    var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1;
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case "A":
                            break; // TODO: comment
                        case "X":
                            C = parseInt(record[rj].slice(1)) - 1;
                            C_seen_X = true;
                            break;
                        case "Y":
                            R = parseInt(record[rj].slice(1)) - 1;
                            if (!C_seen_X) C = 0;
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case "K":
                            val = record[rj].slice(1);
                            if (val.charAt(0) === '"') val = val.slice(1, val.length - 1);
                            else if (val === "TRUE") val = true;
                            else if (val === "FALSE") val = false;
                            else if (!isNaN($3ee4f50b1ae43a89$var$fuzzynum(val))) {
                                val = $3ee4f50b1ae43a89$var$fuzzynum(val);
                                if (next_cell_format !== null && $3ee4f50b1ae43a89$var$fmt_is_date(next_cell_format)) val = $3ee4f50b1ae43a89$var$numdate(val);
                            } else if (!isNaN($3ee4f50b1ae43a89$var$fuzzydate(val).getDate())) val = $3ee4f50b1ae43a89$var$parseDate(val);
                            if (typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined" && typeof val == "string" && (opts || {}).type != "string" && (opts || {}).codepage) val = $3ee4f50b1ae43a89$var$$cptable.utils.decode(opts.codepage, val);
                            C_seen_K = true;
                            break;
                        case "E":
                            C_seen_E = true;
                            var formula = $3ee4f50b1ae43a89$var$rc_to_a1(record[rj].slice(1), {
                                r: R,
                                c: C
                            });
                            arr[R][C] = [
                                arr[R][C],
                                formula
                            ];
                            break;
                        case "S":
                            C_seen_S = true;
                            arr[R][C] = [
                                arr[R][C],
                                "S5S"
                            ];
                            break;
                        case "G":
                            break; // unknown
                        case "R":
                            _R = parseInt(record[rj].slice(1)) - 1;
                            break;
                        case "C":
                            _C = parseInt(record[rj].slice(1)) - 1;
                            break;
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (C_seen_K) {
                        if (arr[R][C] && arr[R][C].length == 2) arr[R][C][0] = val;
                        else arr[R][C] = val;
                        next_cell_format = null;
                    }
                    if (C_seen_S) {
                        if (C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
                        var shrbase = _R > -1 && arr[_R][_C];
                        if (!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
                        arr[R][C][1] = $3ee4f50b1ae43a89$var$shift_formula_str(shrbase[1], {
                            r: R - _R,
                            c: C - _C
                        });
                    }
                    break;
                case "F":
                    var F_seen = 0;
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case "X":
                            C = parseInt(record[rj].slice(1)) - 1;
                            ++F_seen;
                            break;
                        case "Y":
                            R = parseInt(record[rj].slice(1)) - 1; /*C = 0;*/ 
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case "M":
                            Mval = parseInt(record[rj].slice(1)) / 20;
                            break;
                        case "F":
                            break; /* ??? */ 
                        case "G":
                            break; /* hide grid */ 
                        case "P":
                            next_cell_format = formats[parseInt(record[rj].slice(1))];
                            break;
                        case "S":
                            break; /* cell style */ 
                        case "D":
                            break; /* column */ 
                        case "N":
                            break; /* font */ 
                        case "W":
                            cw = record[rj].slice(1).split(" ");
                            for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j){
                                Mval = parseInt(cw[2], 10);
                                colinfo[j - 1] = Mval === 0 ? {
                                    hidden: true
                                } : {
                                    wch: Mval
                                };
                                $3ee4f50b1ae43a89$var$process_col(colinfo[j - 1]);
                            }
                            break;
                        case "C":
                            /* default column format */ C = parseInt(record[rj].slice(1)) - 1;
                            if (!colinfo[C]) colinfo[C] = {};
                            break;
                        case "R":
                            /* row properties */ R = parseInt(record[rj].slice(1)) - 1;
                            if (!rowinfo[R]) rowinfo[R] = {};
                            if (Mval > 0) {
                                rowinfo[R].hpt = Mval;
                                rowinfo[R].hpx = $3ee4f50b1ae43a89$var$pt2px(Mval);
                            } else if (Mval === 0) rowinfo[R].hidden = true;
                            break;
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (F_seen < 1) next_cell_format = null;
                    break;
                default:
                    if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
            }
        }
        if (rowinfo.length > 0) sht["!rows"] = rowinfo;
        if (colinfo.length > 0) sht["!cols"] = colinfo;
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return [
            arr,
            sht
        ];
    }
    function sylk_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        var aoasht = sylk_to_aoa(d, opts);
        var aoa = aoasht[0], ws = aoasht[1];
        var o = $3ee4f50b1ae43a89$var$aoa_to_sheet(aoa, opts);
        $3ee4f50b1ae43a89$var$keys(ws).forEach(function(k) {
            o[k] = ws[k];
        });
        return o;
    }
    function sylk_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $3ee4f50b1ae43a89$var$sheet_to_workbook(sylk_to_sheet(d, opts), opts);
    }
    function write_ws_cell_sylk(cell /*:Cell*/ , ws /*:Worksheet*/ , R /*:number*/ , C /*:number*/  /*::, opts*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";K";
        switch(cell.t){
            case "n":
                o += cell.v || 0;
                if (cell.f && !cell.F) o += ";E" + $3ee4f50b1ae43a89$var$a1_to_rc(cell.f, {
                    r: R,
                    c: C
                });
                break;
            case "b":
                o += cell.v ? "TRUE" : "FALSE";
                break;
            case "e":
                o += cell.w || cell.v;
                break;
            case "d":
                o += '"' + (cell.w || cell.v) + '"';
                break;
            case "s":
                o += '"' + cell.v.replace(/"/g, "").replace(/;/g, ";;") + '"';
                break;
        }
        return o;
    }
    function write_ws_cols_sylk(out, cols) {
        cols.forEach(function(col, i) {
            var rec = "F;W" + (i + 1) + " " + (i + 1) + " ";
            if (col.hidden) rec += "0";
            else {
                if (typeof col.width == "number" && !col.wpx) col.wpx = $3ee4f50b1ae43a89$var$width2px(col.width);
                if (typeof col.wpx == "number" && !col.wch) col.wch = $3ee4f50b1ae43a89$var$px2char(col.wpx);
                if (typeof col.wch == "number") rec += Math.round(col.wch);
            }
            if (rec.charAt(rec.length - 1) != " ") out.push(rec);
        });
    }
    function write_ws_rows_sylk(out /*:Array<string>*/ , rows /*:Array<RowInfo>*/ ) {
        rows.forEach(function(row, i) {
            var rec = "F;";
            if (row.hidden) rec += "M0;";
            else if (row.hpt) rec += "M" + 20 * row.hpt + ";";
            else if (row.hpx) rec += "M" + 20 * $3ee4f50b1ae43a89$var$px2pt(row.hpx) + ";";
            if (rec.length > 2) out.push(rec + "R" + (i + 1));
        });
    }
    function sheet_to_sylk(ws /*:Worksheet*/ , opts /*:?any*/ ) /*:string*/ {
        var preamble /*:Array<string>*/  = [
            "ID;PWXL;N;E"
        ], o /*:Array<string>*/  = [];
        var r = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]), cell /*:Cell*/ ;
        var dense = Array.isArray(ws);
        var RS = "\r\n";
        preamble.push("P;PGeneral");
        preamble.push("F;P0;DG0G8;M255");
        if (ws["!cols"]) write_ws_cols_sylk(preamble, ws["!cols"]);
        if (ws["!rows"]) write_ws_rows_sylk(preamble, ws["!rows"]);
        preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [
            r.s.c,
            r.s.r,
            r.e.c,
            r.e.r
        ].join(" "));
        for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
            var coord = $3ee4f50b1ae43a89$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? (ws[R] || [])[C] : ws[coord];
            if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
            o.push(write_ws_cell_sylk(cell, ws, R, C, opts));
        }
        return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
    }
    return {
        to_workbook: sylk_to_workbook,
        to_sheet: sylk_to_sheet,
        from_sheet: sheet_to_sylk
    };
}();
var $3ee4f50b1ae43a89$var$DIF = /*#__PURE__*/ function() {
    function dif_to_aoa(d /*:RawData*/ , opts) /*:AOA*/ {
        switch(opts.type){
            case "base64":
                return dif_to_aoa_str($3ee4f50b1ae43a89$var$Base64_decode(d), opts);
            case "binary":
                return dif_to_aoa_str(d, opts);
            case "buffer":
                return dif_to_aoa_str($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(d) ? d.toString("binary") : $3ee4f50b1ae43a89$var$a2s(d), opts);
            case "array":
                return dif_to_aoa_str($3ee4f50b1ae43a89$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function dif_to_aoa_str(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split("\n"), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            if (records[ri].trim() === "BOT") {
                arr[++R] = [];
                C = 0;
                continue;
            }
            if (R < 0) continue;
            var metadata = records[ri].trim().split(",");
            var type = metadata[0], value = metadata[1];
            ++ri;
            var data = records[ri] || "";
            while((data.match(/["]/g) || []).length & 1 && ri < records.length - 1)data += "\n" + records[++ri];
            data = data.trim();
            switch(+type){
                case -1:
                    if (data === "BOT") {
                        arr[++R] = [];
                        C = 0;
                        continue;
                    } else if (data !== "EOD") throw new Error("Unrecognized DIF special command " + data);
                    break;
                case 0:
                    if (data === "TRUE") arr[R][C] = true;
                    else if (data === "FALSE") arr[R][C] = false;
                    else if (!isNaN($3ee4f50b1ae43a89$var$fuzzynum(value))) arr[R][C] = $3ee4f50b1ae43a89$var$fuzzynum(value);
                    else if (!isNaN($3ee4f50b1ae43a89$var$fuzzydate(value).getDate())) arr[R][C] = $3ee4f50b1ae43a89$var$parseDate(value);
                    else arr[R][C] = value;
                    ++C;
                    break;
                case 1:
                    data = data.slice(1, data.length - 1);
                    data = data.replace(/""/g, '"');
                    if ($3ee4f50b1ae43a89$var$DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
                    arr[R][C++] = data !== "" ? data : null;
                    break;
            }
            if (data === "EOD") break;
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function dif_to_sheet(str /*:string*/ , opts) /*:Worksheet*/ {
        return $3ee4f50b1ae43a89$var$aoa_to_sheet(dif_to_aoa(str, opts), opts);
    }
    function dif_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
        return $3ee4f50b1ae43a89$var$sheet_to_workbook(dif_to_sheet(str, opts), opts);
    }
    var sheet_to_dif = /*#__PURE__*/ function() {
        var push_field = function pf(o /*:Array<string>*/ , topic /*:string*/ , v /*:number*/ , n /*:number*/ , s /*:string*/ ) {
            o.push(topic);
            o.push(v + "," + n);
            o.push('"' + s.replace(/"/g, '""') + '"');
        };
        var push_value = function po(o /*:Array<string>*/ , type /*:number*/ , v /*:any*/ , s /*:string*/ ) {
            o.push(type + "," + v);
            o.push(type == 1 ? '"' + s.replace(/"/g, '""') + '"' : s);
        };
        return function sheet_to_dif(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
            var o /*:Array<string>*/  = [];
            var r = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]), cell /*:Cell*/ ;
            var dense = Array.isArray(ws);
            push_field(o, "TABLE", 0, 1, "sheetjs");
            push_field(o, "VECTORS", 0, r.e.r - r.s.r + 1, "");
            push_field(o, "TUPLES", 0, r.e.c - r.s.c + 1, "");
            push_field(o, "DATA", 0, 0, "");
            for(var R = r.s.r; R <= r.e.r; ++R){
                push_value(o, -1, 0, "BOT");
                for(var C = r.s.c; C <= r.e.c; ++C){
                    var coord = $3ee4f50b1ae43a89$var$encode_cell({
                        r: R,
                        c: C
                    });
                    cell = dense ? (ws[R] || [])[C] : ws[coord];
                    if (!cell) {
                        push_value(o, 1, 0, "");
                        continue;
                    }
                    switch(cell.t){
                        case "n":
                            var val = $3ee4f50b1ae43a89$var$DIF_XL ? cell.w : cell.v;
                            if (!val && cell.v != null) val = cell.v;
                            if (val == null) {
                                if ($3ee4f50b1ae43a89$var$DIF_XL && cell.f && !cell.F) push_value(o, 1, 0, "=" + cell.f);
                                else push_value(o, 1, 0, "");
                            } else push_value(o, 0, val, "V");
                            break;
                        case "b":
                            push_value(o, 0, cell.v ? 1 : 0, cell.v ? "TRUE" : "FALSE");
                            break;
                        case "s":
                            push_value(o, 1, 0, !$3ee4f50b1ae43a89$var$DIF_XL || isNaN(cell.v) ? cell.v : '="' + cell.v + '"');
                            break;
                        case "d":
                            if (!cell.w) cell.w = $3ee4f50b1ae43a89$var$SSF_format(cell.z || $3ee4f50b1ae43a89$var$table_fmt[14], $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v)));
                            if ($3ee4f50b1ae43a89$var$DIF_XL) push_value(o, 0, cell.w, "V");
                            else push_value(o, 1, 0, cell.w);
                            break;
                        default:
                            push_value(o, 1, 0, "");
                    }
                }
            }
            push_value(o, -1, 0, "EOD");
            var RS = "\r\n";
            var oo = o.join(RS);
            //while((oo.length & 0x7F) != 0) oo += "\0";
            return oo;
        };
    }();
    return {
        to_workbook: dif_to_workbook,
        to_sheet: dif_to_sheet,
        from_sheet: sheet_to_dif
    };
}();
var $3ee4f50b1ae43a89$var$ETH = /*#__PURE__*/ function() {
    function decode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, "\n");
    }
    function encode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
    }
    function eth_to_aoa(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split("\n"), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            var record = records[ri].trim().split(":");
            if (record[0] !== "cell") continue;
            var addr = $3ee4f50b1ae43a89$var$decode_cell(record[1]);
            if (arr.length <= addr.r) {
                for(R = arr.length; R <= addr.r; ++R)if (!arr[R]) arr[R] = [];
            }
            R = addr.r;
            C = addr.c;
            switch(record[2]){
                case "t":
                    arr[R][C] = decode(record[3]);
                    break;
                case "v":
                    arr[R][C] = +record[3];
                    break;
                case "vtf":
                    var _f = record[record.length - 1];
                /* falls through */ case "vtc":
                    switch(record[3]){
                        case "nl":
                            arr[R][C] = +record[4] ? true : false;
                            break;
                        default:
                            arr[R][C] = +record[4];
                            break;
                    }
                    if (record[2] == "vtf") arr[R][C] = [
                        arr[R][C],
                        _f
                    ];
            }
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function eth_to_sheet(d /*:string*/ , opts) /*:Worksheet*/ {
        return $3ee4f50b1ae43a89$var$aoa_to_sheet(eth_to_aoa(d, opts), opts);
    }
    function eth_to_workbook(d /*:string*/ , opts) /*:Workbook*/ {
        return $3ee4f50b1ae43a89$var$sheet_to_workbook(eth_to_sheet(d, opts), opts);
    }
    var header = [
        "socialcalc:version:1.5",
        "MIME-Version: 1.0",
        "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
    ].join("\n");
    var sep = [
        "--SocialCalcSpreadsheetControlSave",
        "Content-type: text/plain; charset=UTF-8"
    ].join("\n") + "\n";
    /* TODO: the other parts */ var meta = [
        "# SocialCalc Spreadsheet Control Save",
        "part:sheet"
    ].join("\n");
    var end = "--SocialCalcSpreadsheetControlSave--";
    function sheet_to_eth_data(ws /*:Worksheet*/ ) /*:string*/ {
        if (!ws || !ws["!ref"]) return "";
        var o /*:Array<string>*/  = [], oo /*:Array<string>*/  = [], cell, coord = "";
        var r = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
        var dense = Array.isArray(ws);
        for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
            coord = $3ee4f50b1ae43a89$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? (ws[R] || [])[C] : ws[coord];
            if (!cell || cell.v == null || cell.t === "z") continue;
            oo = [
                "cell",
                coord,
                "t"
            ];
            switch(cell.t){
                case "s":
                case "str":
                    oo.push(encode(cell.v));
                    break;
                case "n":
                    if (!cell.f) {
                        oo[2] = "v";
                        oo[3] = cell.v;
                    } else {
                        oo[2] = "vtf";
                        oo[3] = "n";
                        oo[4] = cell.v;
                        oo[5] = encode(cell.f);
                    }
                    break;
                case "b":
                    oo[2] = "vt" + (cell.f ? "f" : "c");
                    oo[3] = "nl";
                    oo[4] = cell.v ? "1" : "0";
                    oo[5] = encode(cell.f || (cell.v ? "TRUE" : "FALSE"));
                    break;
                case "d":
                    var t = $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v));
                    oo[2] = "vtc";
                    oo[3] = "nd";
                    oo[4] = "" + t;
                    oo[5] = cell.w || $3ee4f50b1ae43a89$var$SSF_format(cell.z || $3ee4f50b1ae43a89$var$table_fmt[14], t);
                    break;
                case "e":
                    continue;
            }
            o.push(oo.join(":"));
        }
        o.push("sheet:c:" + (r.e.c - r.s.c + 1) + ":r:" + (r.e.r - r.s.r + 1) + ":tvf:1");
        o.push("valueformat:1:text-wiki");
        //o.push("copiedfrom:" + ws['!ref']); // clipboard only
        return o.join("\n");
    }
    function sheet_to_eth(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        return [
            header,
            sep,
            meta,
            sep,
            sheet_to_eth_data(ws),
            end
        ].join("\n");
    // return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
    }
    return {
        to_workbook: eth_to_workbook,
        to_sheet: eth_to_sheet,
        from_sheet: sheet_to_eth
    };
}();
var $3ee4f50b1ae43a89$var$PRN = /*#__PURE__*/ function() {
    function set_text_arr(data /*:string*/ , arr /*:AOA*/ , R /*:number*/ , C /*:number*/ , o /*:any*/ ) {
        if (o.raw) arr[R][C] = data;
        else if (data === "") ;
        else if (data === "TRUE") arr[R][C] = true;
        else if (data === "FALSE") arr[R][C] = false;
        else if (!isNaN($3ee4f50b1ae43a89$var$fuzzynum(data))) arr[R][C] = $3ee4f50b1ae43a89$var$fuzzynum(data);
        else if (!isNaN($3ee4f50b1ae43a89$var$fuzzydate(data).getDate())) arr[R][C] = $3ee4f50b1ae43a89$var$parseDate(data);
        else arr[R][C] = data;
    }
    function prn_to_aoa_str(f /*:string*/ , opts) /*:AOA*/ {
        var o = opts || {};
        var arr /*:AOA*/  = [];
        if (!f || f.length === 0) return arr;
        var lines = f.split(/[\r\n]/);
        var L = lines.length - 1;
        while(L >= 0 && lines[L].length === 0)--L;
        var start = 10, idx = 0;
        var R = 0;
        for(; R <= L; ++R){
            idx = lines[R].indexOf(" ");
            if (idx == -1) idx = lines[R].length;
            else idx++;
            start = Math.max(start, idx);
        }
        for(R = 0; R <= L; ++R){
            arr[R] = [];
            /* TODO: confirm that widths are always 10 */ var C = 0;
            set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
            for(C = 1; C <= (lines[R].length - start) / 10 + 1; ++C)set_text_arr(lines[R].slice(start + (C - 1) * 10, start + C * 10).trim(), arr, R, C, o);
        }
        if (o.sheetRows) arr = arr.slice(0, o.sheetRows);
        return arr;
    }
    // List of accepted CSV separators
    var guess_seps = {
        /*::[*/ 0x2C: ",",
        /*::[*/ 0x09: "	",
        /*::[*/ 0x3B: ";",
        /*::[*/ 0x7C: "|"
    };
    // CSV separator weights to be used in case of equal numbers
    var guess_sep_weights = {
        /*::[*/ 0x2C: 3,
        /*::[*/ 0x09: 2,
        /*::[*/ 0x3B: 1,
        /*::[*/ 0x7C: 0
    };
    function guess_sep(str) {
        var cnt = {}, instr = false, end = 0, cc = 0;
        for(; end < str.length; ++end){
            if ((cc = str.charCodeAt(end)) == 0x22) instr = !instr;
            else if (!instr && cc in guess_seps) cnt[cc] = (cnt[cc] || 0) + 1;
        }
        cc = [];
        for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
            cnt[end],
            end
        ]);
        if (!cc.length) {
            cnt = guess_sep_weights;
            for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
                cnt[end],
                end
            ]);
        }
        cc.sort(function(a, b) {
            return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]];
        });
        return guess_seps[cc.pop()[1]] || 0x2C;
    }
    function dsv_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        var o = opts || {};
        var sep = "";
        if ($3ee4f50b1ae43a89$var$DENSE != null && o.dense == null) o.dense = $3ee4f50b1ae43a89$var$DENSE;
        var ws /*:Worksheet*/  = o.dense ? [] : {} /*:any*/ ;
        var range /*:Range*/  = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        } /*:any*/ ;
        if (str.slice(0, 4) == "sep=") {
            // If the line ends in \r\n
            if (str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10) {
                sep = str.charAt(4);
                str = str.slice(7);
            } else if (str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10) {
                sep = str.charAt(4);
                str = str.slice(6);
            } else sep = guess_sep(str.slice(0, 1024));
        } else if (o && o.FS) sep = o.FS;
        else sep = guess_sep(str.slice(0, 1024));
        var R = 0, C = 0, v = 0;
        var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc = 0, startcc = str.charCodeAt(0);
        str = str.replace(/\r\n/mg, "\n");
        var _re /*:?RegExp*/  = o.dateNF != null ? $3ee4f50b1ae43a89$var$dateNF_regex(o.dateNF) : null;
        function finish_cell() {
            var s = str.slice(start, end);
            var cell = {} /*:any*/ ;
            if (s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1, -1).replace(/""/g, '"');
            if (s.length === 0) cell.t = "z";
            else if (o.raw) {
                cell.t = "s";
                cell.v = s;
            } else if (s.trim().length === 0) {
                cell.t = "s";
                cell.v = s;
            } else if (s.charCodeAt(0) == 0x3D) {
                if (s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) {
                    cell.t = "s";
                    cell.v = s.slice(2, -1).replace(/""/g, '"');
                } else if ($3ee4f50b1ae43a89$var$fuzzyfmla(s)) {
                    cell.t = "n";
                    cell.f = s.slice(1);
                } else {
                    cell.t = "s";
                    cell.v = s;
                }
            } else if (s == "TRUE") {
                cell.t = "b";
                cell.v = true;
            } else if (s == "FALSE") {
                cell.t = "b";
                cell.v = false;
            } else if (!isNaN(v = $3ee4f50b1ae43a89$var$fuzzynum(s))) {
                cell.t = "n";
                if (o.cellText !== false) cell.w = s;
                cell.v = v;
            } else if (!isNaN($3ee4f50b1ae43a89$var$fuzzydate(s).getDate()) || _re && s.match(_re)) {
                cell.z = o.dateNF || $3ee4f50b1ae43a89$var$table_fmt[14];
                var k = 0;
                if (_re && s.match(_re)) {
                    s = $3ee4f50b1ae43a89$var$dateNF_fix(s, o.dateNF, s.match(_re) || []);
                    k = 1;
                }
                if (o.cellDates) {
                    cell.t = "d";
                    cell.v = $3ee4f50b1ae43a89$var$parseDate(s, k);
                } else {
                    cell.t = "n";
                    cell.v = $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(s, k));
                }
                if (o.cellText !== false) cell.w = $3ee4f50b1ae43a89$var$SSF_format(cell.z, cell.v instanceof Date ? $3ee4f50b1ae43a89$var$datenum(cell.v) : cell.v);
                if (!o.cellNF) delete cell.z;
            } else {
                cell.t = "s";
                cell.v = s;
            }
            if (cell.t == "z") ;
            else if (o.dense) {
                if (!ws[R]) ws[R] = [];
                ws[R][C] = cell;
            } else ws[$3ee4f50b1ae43a89$var$encode_cell({
                c: C,
                r: R
            })] = cell;
            start = end + 1;
            startcc = str.charCodeAt(start);
            if (range.e.c < C) range.e.c = C;
            if (range.e.r < R) range.e.r = R;
            if (cc == sepcc) ++C;
            else {
                C = 0;
                ++R;
                if (o.sheetRows && o.sheetRows <= R) return true;
            }
        }
        outer: for(; end < str.length; ++end)switch(cc = str.charCodeAt(end)){
            case 0x22:
                if (startcc === 0x22) instr = !instr;
                break;
            case sepcc:
            case 0x0a:
            case 0x0d:
                if (!instr && finish_cell()) break outer;
                break;
            default:
                break;
        }
        if (end - start > 0) finish_cell();
        ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
        return ws;
    }
    function prn_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        if (!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
        if (opts.FS) return dsv_to_sheet_str(str, opts);
        if (str.slice(0, 4) == "sep=") return dsv_to_sheet_str(str, opts);
        if (str.indexOf("	") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
        return $3ee4f50b1ae43a89$var$aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
    }
    function prn_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        var str = "", bytes = opts.type == "string" ? [
            0,
            0,
            0,
            0
        ] : $3ee4f50b1ae43a89$var$firstbyte(d, opts);
        switch(opts.type){
            case "base64":
                str = $3ee4f50b1ae43a89$var$Base64_decode(d);
                break;
            case "binary":
                str = d;
                break;
            case "buffer":
                if (opts.codepage == 65001) str = d.toString("utf8"); // TODO: test if buf
                else if (opts.codepage && typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined") str = $3ee4f50b1ae43a89$var$$cptable.utils.decode(opts.codepage, d);
                else str = $3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(d) ? d.toString("binary") : $3ee4f50b1ae43a89$var$a2s(d);
                break;
            case "array":
                str = $3ee4f50b1ae43a89$var$cc2str(d);
                break;
            case "string":
                str = d;
                break;
            default:
                throw new Error("Unrecognized type " + opts.type);
        }
        if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $3ee4f50b1ae43a89$var$utf8read(str.slice(3));
        else if (opts.type != "string" && opts.type != "buffer" && opts.codepage == 65001) str = $3ee4f50b1ae43a89$var$utf8read(str);
        else if (opts.type == "binary" && typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined" && opts.codepage) str = $3ee4f50b1ae43a89$var$$cptable.utils.decode(opts.codepage, $3ee4f50b1ae43a89$var$$cptable.utils.encode(28591, str));
        if (str.slice(0, 19) == "socialcalc:version:") return $3ee4f50b1ae43a89$var$ETH.to_sheet(opts.type == "string" ? str : $3ee4f50b1ae43a89$var$utf8read(str), opts);
        return prn_to_sheet_str(str, opts);
    }
    function prn_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $3ee4f50b1ae43a89$var$sheet_to_workbook(prn_to_sheet(d, opts), opts);
    }
    function sheet_to_prn(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var o /*:Array<string>*/  = [];
        var r = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]), cell /*:Cell*/ ;
        var dense = Array.isArray(ws);
        for(var R = r.s.r; R <= r.e.r; ++R){
            var oo /*:Array<string>*/  = [];
            for(var C = r.s.c; C <= r.e.c; ++C){
                var coord = $3ee4f50b1ae43a89$var$encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws[R] || [])[C] : ws[coord];
                if (!cell || cell.v == null) {
                    oo.push("          ");
                    continue;
                }
                var w = (cell.w || ($3ee4f50b1ae43a89$var$format_cell(cell), cell.w) || "").slice(0, 10);
                while(w.length < 10)w += " ";
                oo.push(w + (C === 0 ? " " : ""));
            }
            o.push(oo.join(""));
        }
        return o.join("\n");
    }
    return {
        to_workbook: prn_to_workbook,
        to_sheet: prn_to_sheet,
        from_sheet: sheet_to_prn
    };
}();
/* Excel defaults to SYLK but warns if data is not valid */ function $3ee4f50b1ae43a89$var$read_wb_ID(d, opts) {
    var o = opts || {}, OLD_WTF = !!o.WTF;
    o.WTF = true;
    try {
        var out = $3ee4f50b1ae43a89$var$SYLK.to_workbook(d, o);
        o.WTF = OLD_WTF;
        return out;
    } catch (e) {
        o.WTF = OLD_WTF;
        if (!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
        return $3ee4f50b1ae43a89$var$PRN.to_workbook(d, opts);
    }
}
var $3ee4f50b1ae43a89$var$WK_ = /*#__PURE__*/ function() {
    function lotushopper(data, cb /*:RecordHopperCB*/ , opts /*:any*/ ) {
        if (!data) return;
        $3ee4f50b1ae43a89$var$prep_blob(data, data.l || 0);
        var Enum = opts.Enum || WK1Enum;
        while(data.l < data.length){
            var RT = data.read_shift(2);
            var R = Enum[RT] || Enum[0xFFFF];
            var length = data.read_shift(2);
            var tgt = data.l + length;
            var d = R.f && R.f(data, length, opts);
            data.l = tgt;
            if (cb(d, R, RT)) return;
        }
    }
    function lotus_to_workbook(d /*:RawData*/ , opts) {
        switch(opts.type){
            case "base64":
                return lotus_to_workbook_buf($3ee4f50b1ae43a89$var$s2a($3ee4f50b1ae43a89$var$Base64_decode(d)), opts);
            case "binary":
                return lotus_to_workbook_buf($3ee4f50b1ae43a89$var$s2a(d), opts);
            case "buffer":
            case "array":
                return lotus_to_workbook_buf(d, opts);
        }
        throw "Unsupported type " + opts.type;
    }
    function lotus_to_workbook_buf(d, opts) /*:Workbook*/ {
        if (!d) return d;
        var o = opts || {};
        if ($3ee4f50b1ae43a89$var$DENSE != null && o.dense == null) o.dense = $3ee4f50b1ae43a89$var$DENSE;
        var s /*:Worksheet*/  = o.dense ? [] : {}, n = "Sheet1", next_n = "", sidx = 0;
        var sheets = {}, snames = [], realnames = [];
        var refguess = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        var sheetRows = o.sheetRows || 0;
        if (d[2] == 0x00) {
            if (d[3] == 0x08 || d[3] == 0x09) {
                if (d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
            }
        }
        if (d[2] == 0x02) {
            o.Enum = WK1Enum;
            lotushopper(d, function(val, R, RT) {
                switch(RT){
                    case 0x00:
                        /* BOF */ o.vers = val;
                        if (val >= 0x1000) o.qpro = true;
                        break;
                    case 0x06:
                        refguess = val;
                        break; /* RANGE */ 
                    case 0xCC:
                        if (val) next_n = val;
                        break; /* SHEETNAMECS */ 
                    case 0xDE:
                        next_n = val;
                        break; /* SHEETNAMELP */ 
                    case 0x0F:
                    /* LABEL */ case 0x33:
                        /* STRING */ if (!o.qpro) val[1].v = val[1].v.slice(1);
                    /* falls through */ case 0x0D:
                    /* INTEGER */ case 0x0E:
                    /* NUMBER */ case 0x10:
                        /* FORMULA */ /* TODO: actual translation of the format code */ if (RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
                            val[1].z = o.dateNF || $3ee4f50b1ae43a89$var$table_fmt[14];
                            if (o.cellDates) {
                                val[1].t = "d";
                                val[1].v = $3ee4f50b1ae43a89$var$numdate(val[1].v);
                            }
                        }
                        if (o.qpro) {
                            if (val[3] > sidx) {
                                s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
                                sheets[n] = s;
                                snames.push(n);
                                s = o.dense ? [] : {};
                                refguess = {
                                    s: {
                                        r: 0,
                                        c: 0
                                    },
                                    e: {
                                        r: 0,
                                        c: 0
                                    }
                                };
                                sidx = val[3];
                                n = next_n || "Sheet" + (sidx + 1);
                                next_n = "";
                            }
                        }
                        var tmpcell = o.dense ? (s[val[0].r] || [])[val[0].c] : s[$3ee4f50b1ae43a89$var$encode_cell(val[0])];
                        if (tmpcell) {
                            tmpcell.t = val[1].t;
                            tmpcell.v = val[1].v;
                            if (val[1].z != null) tmpcell.z = val[1].z;
                            if (val[1].f != null) tmpcell.f = val[1].f;
                            break;
                        }
                        if (o.dense) {
                            if (!s[val[0].r]) s[val[0].r] = [];
                            s[val[0].r][val[0].c] = val[1];
                        } else s[$3ee4f50b1ae43a89$var$encode_cell(val[0])] = val[1];
                        break;
                    default:
                }
            }, o);
        } else if (d[2] == 0x1A || d[2] == 0x0E) {
            o.Enum = WK3Enum;
            if (d[2] == 0x0E) {
                o.qpro = true;
                d.l = 0;
            }
            lotushopper(d, function(val, R, RT) {
                switch(RT){
                    case 0xCC:
                        n = val;
                        break; /* SHEETNAMECS */ 
                    case 0x16:
                        /* LABEL16 */ val[1].v = val[1].v.slice(1);
                    /* falls through */ case 0x17:
                    /* NUMBER17 */ case 0x18:
                    /* NUMBER18 */ case 0x19:
                    /* FORMULA19 */ case 0x25:
                    /* NUMBER25 */ case 0x27:
                    /* NUMBER27 */ case 0x28:
                        /* FORMULA28 */ if (val[3] > sidx) {
                            s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
                            sheets[n] = s;
                            snames.push(n);
                            s = o.dense ? [] : {};
                            refguess = {
                                s: {
                                    r: 0,
                                    c: 0
                                },
                                e: {
                                    r: 0,
                                    c: 0
                                }
                            };
                            sidx = val[3];
                            n = "Sheet" + (sidx + 1);
                        }
                        if (sheetRows > 0 && val[0].r >= sheetRows) break;
                        if (o.dense) {
                            if (!s[val[0].r]) s[val[0].r] = [];
                            s[val[0].r][val[0].c] = val[1];
                        } else s[$3ee4f50b1ae43a89$var$encode_cell(val[0])] = val[1];
                        if (refguess.e.c < val[0].c) refguess.e.c = val[0].c;
                        if (refguess.e.r < val[0].r) refguess.e.r = val[0].r;
                        break;
                    case 0x1B:
                        /* XFORMAT */ if (val[0x36b0]) realnames[val[0x36b0][0]] = val[0x36b0][1];
                        break;
                    case 0x0601:
                        /* SHEETINFOQP */ realnames[val[0]] = val[1];
                        if (val[0] == sidx) n = val[1];
                        break;
                    default:
                        break;
                }
            }, o);
        } else throw new Error("Unrecognized LOTUS BOF " + d[2]);
        s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
        sheets[next_n || n] = s;
        snames.push(next_n || n);
        if (!realnames.length) return {
            SheetNames: snames,
            Sheets: sheets
        };
        var osheets = {}, rnames = [];
        /* TODO: verify no collisions */ for(var i = 0; i < realnames.length; ++i)if (sheets[snames[i]]) {
            rnames.push(realnames[i] || snames[i]);
            osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
        } else {
            rnames.push(realnames[i]);
            osheets[realnames[i]] = {
                "!ref": "A1"
            };
        }
        return {
            SheetNames: rnames,
            Sheets: osheets
        };
    }
    function sheet_to_wk1(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $3ee4f50b1ae43a89$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK1 to JS string");
        var ba = $3ee4f50b1ae43a89$var$buf_array();
        var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]);
        var dense = Array.isArray(ws);
        var cols = [];
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x06, write_RANGE(range));
        var max_R = Math.min(range.e.r, 8191);
        for(var R = range.s.r; R <= max_R; ++R){
            var rr = $3ee4f50b1ae43a89$var$encode_row(R);
            for(var C = range.s.c; C <= range.e.c; ++C){
                if (R === range.s.r) cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
                var ref = cols[C] + rr;
                var cell = dense ? (ws[R] || [])[C] : ws[ref];
                if (!cell || cell.t == "z") continue;
                /* TODO: formula records */ if (cell.t == "n") {
                    if ((cell.v | 0) == cell.v && cell.v >= -32768 && cell.v <= 32767) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell.v));
                    else $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell.v));
                } else {
                    var str = $3ee4f50b1ae43a89$var$format_cell(cell);
                    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
                }
            }
        }
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function book_to_wk3(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $3ee4f50b1ae43a89$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK3 to JS string");
        var ba = $3ee4f50b1ae43a89$var$buf_array();
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
        for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i)if ((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
        var wsidx = 0;
        for(i = 0; i < wb.SheetNames.length; ++i){
            var ws = wb.Sheets[wb.SheetNames[i]];
            if (!ws || !ws["!ref"]) continue;
            var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]);
            var dense = Array.isArray(ws);
            var cols = [];
            var max_R = Math.min(range.e.r, 8191);
            for(var R = range.s.r; R <= max_R; ++R){
                var rr = $3ee4f50b1ae43a89$var$encode_row(R);
                for(var C = range.s.c; C <= range.e.c; ++C){
                    if (R === range.s.r) cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
                    var ref = cols[C] + rr;
                    var cell = dense ? (ws[R] || [])[C] : ws[ref];
                    if (!cell || cell.t == "z") continue;
                    /* TODO: FORMULA19 NUMBER18 records */ if (cell.t == "n") $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
                    else {
                        var str = $3ee4f50b1ae43a89$var$format_cell(cell);
                        /* TODO: max len? */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
                    }
                }
            }
            ++wsidx;
        }
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function write_BOF_WK1(v /*:number*/ ) {
        var out = $3ee4f50b1ae43a89$var$new_buf(2);
        out.write_shift(2, v);
        return out;
    }
    function write_BOF_WK3(wb /*:Workbook*/ ) {
        var out = $3ee4f50b1ae43a89$var$new_buf(26);
        out.write_shift(2, 0x1000);
        out.write_shift(2, 0x0004);
        out.write_shift(4, 0x0000);
        var rows = 0, cols = 0, wscnt = 0;
        for(var i = 0; i < wb.SheetNames.length; ++i){
            var name = wb.SheetNames[i];
            var ws = wb.Sheets[name];
            if (!ws || !ws["!ref"]) continue;
            ++wscnt;
            var range = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
            if (rows < range.e.r) rows = range.e.r;
            if (cols < range.e.c) cols = range.e.c;
        }
        if (rows > 8191) rows = 8191;
        out.write_shift(2, rows);
        out.write_shift(1, wscnt);
        out.write_shift(1, cols);
        out.write_shift(2, 0x00);
        out.write_shift(2, 0x00);
        out.write_shift(1, 0x01);
        out.write_shift(1, 0x02);
        out.write_shift(4, 0);
        out.write_shift(4, 0);
        return out;
    }
    function parse_RANGE(blob, length, opts) {
        var o = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        };
        if (length == 8 && opts.qpro) {
            o.s.c = blob.read_shift(1);
            blob.l++;
            o.s.r = blob.read_shift(2);
            o.e.c = blob.read_shift(1);
            blob.l++;
            o.e.r = blob.read_shift(2);
            return o;
        }
        o.s.c = blob.read_shift(2);
        o.s.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        o.e.c = blob.read_shift(2);
        o.e.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        if (o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
        return o;
    }
    function write_RANGE(range) {
        var out = $3ee4f50b1ae43a89$var$new_buf(8);
        out.write_shift(2, range.s.c);
        out.write_shift(2, range.s.r);
        out.write_shift(2, range.e.c);
        out.write_shift(2, range.e.r);
        return out;
    }
    function parse_cell(blob, length, opts) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: "n",
                v: 0
            },
            0,
            0
        ];
        if (opts.qpro && opts.vers != 0x5120) {
            o[0].c = blob.read_shift(1);
            o[3] = blob.read_shift(1);
            o[0].r = blob.read_shift(2);
            blob.l += 2;
        } else {
            o[2] = blob.read_shift(1);
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
        }
        return o;
    }
    function parse_LABEL(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = "s";
        if (opts.vers == 0x5120) {
            blob.l++;
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, "utf8");
            return o;
        }
        if (opts.qpro) blob.l++;
        o[1].v = blob.read_shift(tgt - blob.l, "cstr");
        return o;
    }
    function write_LABEL(R, C, s) {
        /* TODO: encoding */ var o = $3ee4f50b1ae43a89$var$new_buf(7 + s.length);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(1, 0x27); // ??
        for(var i = 0; i < o.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_INTEGER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(2, "i");
        return o;
    }
    function write_INTEGER(R, C, v) {
        var o = $3ee4f50b1ae43a89$var$new_buf(7);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(2, v, "i");
        return o;
    }
    function parse_NUMBER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(8, "f");
        return o;
    }
    function write_NUMBER(R, C, v) {
        var o = $3ee4f50b1ae43a89$var$new_buf(13);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(8, v, "f");
        return o;
    }
    function parse_FORMULA(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        /* TODO: formula */ o[1].v = blob.read_shift(8, "f");
        if (opts.qpro) blob.l = tgt;
        else {
            var flen = blob.read_shift(2);
            wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
            blob.l += flen;
        }
        return o;
    }
    function wk1_parse_rc(B, V, col) {
        var rel = V & 0x8000;
        V &= -32769;
        V = (rel ? B : 0) + (V >= 0x2000 ? V - 0x4000 : V);
        return (rel ? "" : "$") + (col ? $3ee4f50b1ae43a89$var$encode_col(V) : $3ee4f50b1ae43a89$var$encode_row(V));
    }
    /* var oprec = [
		8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
		3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
	]; */ /* TODO: flesh out */ var FuncTab = {
        0x33: [
            "FALSE",
            0
        ],
        0x34: [
            "TRUE",
            0
        ],
        0x46: [
            "LEN",
            1
        ],
        0x50: [
            "SUM",
            69
        ],
        0x51: [
            "AVERAGEA",
            69
        ],
        0x52: [
            "COUNTA",
            69
        ],
        0x53: [
            "MINA",
            69
        ],
        0x54: [
            "MAXA",
            69
        ],
        0x6F: [
            "T",
            1
        ]
    };
    var BinOpTab = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "+",
        "-",
        "*",
        "/",
        "^",
        "=",
        "<>",
        "<=",
        ">=",
        "<",
        ">",
        "",
        "",
        "",
        "",
        "&",
        "",
        "",
        "",
        "",
        "",
        "",
        "" // eslint-disable-line no-mixed-spaces-and-tabs
    ];
    function wk1_fmla_to_csf(blob, o) {
        $3ee4f50b1ae43a89$var$prep_blob(blob, 0);
        var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
        while(blob.l < blob.length){
            var cc = blob[blob.l++];
            switch(cc){
                case 0x00:
                    out.push(blob.read_shift(8, "f"));
                    break;
                case 0x01:
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(C + R);
                    break;
                case 0x02:
                    var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(c + r + ":" + C + R);
                    break;
                case 0x03:
                    if (blob.l < blob.length) {
                        console.error("WK1 premature formula end");
                        return;
                    }
                    break;
                case 0x04:
                    out.push("(" + out.pop() + ")");
                    break;
                case 0x05:
                    out.push(blob.read_shift(2));
                    break;
                case 0x06:
                    /* TODO: text encoding */ var Z = "";
                    while(cc = blob[blob.l++])Z += String.fromCharCode(cc);
                    out.push('"' + Z.replace(/"/g, '""') + '"');
                    break;
                case 0x08:
                    out.push("-" + out.pop());
                    break;
                case 0x17:
                    out.push("+" + out.pop());
                    break;
                case 0x16:
                    out.push("NOT(" + out.pop() + ")");
                    break;
                case 0x14:
                case 0x15:
                    argR = out.pop();
                    argL = out.pop();
                    out.push([
                        "AND",
                        "OR"
                    ][cc - 0x14] + "(" + argL + "," + argR + ")");
                    break;
                default:
                    if (cc < 0x20 && BinOpTab[cc]) {
                        argR = out.pop();
                        argL = out.pop();
                        out.push(argL + BinOpTab[cc] + argR);
                    } else if (FuncTab[cc]) {
                        argc = FuncTab[cc][1];
                        if (argc == 69) argc = blob[blob.l++];
                        if (argc > out.length) {
                            console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|");
                            return;
                        }
                        var args = out.slice(-argc);
                        out.length -= argc;
                        out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
                    } else if (cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
                    else if (cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
                    else return console.error("WK1 unrecognized opcode " + cc.toString(16));
            }
        }
        if (out.length == 1) o[1].f = "" + out[0];
        else console.error("WK1 bad formula parse |" + out.join("|") + "|");
    }
    function parse_cell_3(blob /*::, length*/ ) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: "n",
                v: 0
            },
            0
        ];
        o[0].r = blob.read_shift(2);
        o[3] = blob[blob.l++];
        o[0].c = blob[blob.l++];
        return o;
    }
    function parse_LABEL_16(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].t = "s";
        o[1].v = blob.read_shift(length - 4, "cstr");
        return o;
    }
    function write_LABEL_16(R, C, wsidx, s) {
        /* TODO: encoding */ var o = $3ee4f50b1ae43a89$var$new_buf(6 + s.length);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        o.write_shift(1, 0x27);
        for(var i = 0; i < s.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_NUMBER_18(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].v = blob.read_shift(2);
        var v = o[1].v >> 1;
        if (o[1].v & 0x1) switch(v & 0x07){
            case 0:
                v = (v >> 3) * 5000;
                break;
            case 1:
                v = (v >> 3) * 500;
                break;
            case 2:
                v = (v >> 3) / 20;
                break;
            case 3:
                v = (v >> 3) / 200;
                break;
            case 4:
                v = (v >> 3) / 2000;
                break;
            case 5:
                v = (v >> 3) / 20000;
                break;
            case 6:
                v = (v >> 3) / 16;
                break;
            case 7:
                v = (v >> 3) / 64;
                break;
        }
        o[1].v = v;
        return o;
    }
    function parse_NUMBER_17(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        var v2 = blob.read_shift(4);
        var e = blob.read_shift(2);
        if (e == 0xFFFF) {
            if (v1 === 0 && v2 === 0xC0000000) {
                o[1].t = "e";
                o[1].v = 0x0F;
            } else if (v1 === 0 && v2 === 0xD0000000) {
                o[1].t = "e";
                o[1].v = 0x2A;
            } else o[1].v = 0;
            return o;
        }
        var s = e & 0x8000;
        e = (e & 0x7FFF) - 16446;
        o[1].v = (1 - s * 2) * (v2 * Math.pow(2, e + 32) + v1 * Math.pow(2, e));
        return o;
    }
    function write_NUMBER_17(R, C, wsidx, v) {
        var o = $3ee4f50b1ae43a89$var$new_buf(14);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        if (v == 0) {
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(2, 0xFFFF);
            return o;
        }
        var s = 0, e = 0, v1 = 0, v2 = 0;
        if (v < 0) {
            s = 1;
            v = -v;
        }
        e = Math.log2(v) | 0;
        v /= Math.pow(2, e - 31);
        v2 = v >>> 0;
        if ((v2 & 0x80000000) == 0) {
            v /= 2;
            ++e;
            v2 = v >>> 0;
        }
        v -= v2;
        v2 |= 0x80000000;
        v2 >>>= 0;
        v *= Math.pow(2, 32);
        v1 = v >>> 0;
        o.write_shift(4, v1);
        o.write_shift(4, v2);
        e += 0x3FFF + (s ? 0x8000 : 0);
        o.write_shift(2, e);
        return o;
    }
    function parse_FORMULA_19(blob, length) {
        var o = parse_NUMBER_17(blob, 14);
        blob.l += length - 14; /* TODO: WK3 formula */ 
        return o;
    }
    function parse_NUMBER_25(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        o[1].v = v1 >> 6;
        return o;
    }
    function parse_NUMBER_27(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(8, "f");
        o[1].v = v1;
        return o;
    }
    function parse_FORMULA_28(blob, length) {
        var o = parse_NUMBER_27(blob, 14);
        blob.l += length - 10; /* TODO: formula */ 
        return o;
    }
    function parse_SHEETNAMECS(blob, length) {
        return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, "cstr") : "";
    }
    function parse_SHEETNAMELP(blob, length) {
        var len = blob[blob.l++];
        if (len > length - 1) len = length - 1;
        var o = "";
        while(o.length < len)o += String.fromCharCode(blob[blob.l++]);
        return o;
    }
    function parse_SHEETINFOQP(blob, length, opts) {
        if (!opts.qpro || length < 21) return;
        var id = blob.read_shift(1);
        blob.l += 17;
        blob.l += 1; //var len = blob.read_shift(1);
        blob.l += 2;
        var nm = blob.read_shift(length - 21, "cstr");
        return [
            id,
            nm
        ];
    }
    function parse_XFORMAT(blob, length) {
        var o = {}, tgt = blob.l + length;
        while(blob.l < tgt){
            var dt = blob.read_shift(2);
            if (dt == 0x36b0) {
                o[dt] = [
                    0,
                    ""
                ];
                o[dt][0] = blob.read_shift(2);
                while(blob[blob.l]){
                    o[dt][1] += String.fromCharCode(blob[blob.l]);
                    blob.l++;
                }
                blob.l++;
            }
        // TODO: 0x3a99 ??
        }
        return o;
    }
    function write_XFORMAT_SHEETNAME(name, wsidx) {
        var out = $3ee4f50b1ae43a89$var$new_buf(5 + name.length);
        out.write_shift(2, 0x36b0);
        out.write_shift(2, wsidx);
        for(var i = 0; i < name.length; ++i){
            var cc = name.charCodeAt(i);
            out[out.l++] = cc > 0x7F ? 0x5F : cc;
        }
        out[out.l++] = 0;
        return out;
    }
    var WK1Enum = {
        /*::[*/ 0x0000: {
            n: "BOF",
            f: $3ee4f50b1ae43a89$var$parseuint16
        },
        /*::[*/ 0x0001: {
            n: "EOF"
        },
        /*::[*/ 0x0002: {
            n: "CALCMODE"
        },
        /*::[*/ 0x0003: {
            n: "CALCORDER"
        },
        /*::[*/ 0x0004: {
            n: "SPLIT"
        },
        /*::[*/ 0x0005: {
            n: "SYNC"
        },
        /*::[*/ 0x0006: {
            n: "RANGE",
            f: parse_RANGE
        },
        /*::[*/ 0x0007: {
            n: "WINDOW1"
        },
        /*::[*/ 0x0008: {
            n: "COLW1"
        },
        /*::[*/ 0x0009: {
            n: "WINTWO"
        },
        /*::[*/ 0x000A: {
            n: "COLW2"
        },
        /*::[*/ 0x000B: {
            n: "NAME"
        },
        /*::[*/ 0x000C: {
            n: "BLANK"
        },
        /*::[*/ 0x000D: {
            n: "INTEGER",
            f: parse_INTEGER
        },
        /*::[*/ 0x000E: {
            n: "NUMBER",
            f: parse_NUMBER
        },
        /*::[*/ 0x000F: {
            n: "LABEL",
            f: parse_LABEL
        },
        /*::[*/ 0x0010: {
            n: "FORMULA",
            f: parse_FORMULA
        },
        /*::[*/ 0x0018: {
            n: "TABLE"
        },
        /*::[*/ 0x0019: {
            n: "ORANGE"
        },
        /*::[*/ 0x001A: {
            n: "PRANGE"
        },
        /*::[*/ 0x001B: {
            n: "SRANGE"
        },
        /*::[*/ 0x001C: {
            n: "FRANGE"
        },
        /*::[*/ 0x001D: {
            n: "KRANGE1"
        },
        /*::[*/ 0x0020: {
            n: "HRANGE"
        },
        /*::[*/ 0x0023: {
            n: "KRANGE2"
        },
        /*::[*/ 0x0024: {
            n: "PROTEC"
        },
        /*::[*/ 0x0025: {
            n: "FOOTER"
        },
        /*::[*/ 0x0026: {
            n: "HEADER"
        },
        /*::[*/ 0x0027: {
            n: "SETUP"
        },
        /*::[*/ 0x0028: {
            n: "MARGINS"
        },
        /*::[*/ 0x0029: {
            n: "LABELFMT"
        },
        /*::[*/ 0x002A: {
            n: "TITLES"
        },
        /*::[*/ 0x002B: {
            n: "SHEETJS"
        },
        /*::[*/ 0x002D: {
            n: "GRAPH"
        },
        /*::[*/ 0x002E: {
            n: "NGRAPH"
        },
        /*::[*/ 0x002F: {
            n: "CALCCOUNT"
        },
        /*::[*/ 0x0030: {
            n: "UNFORMATTED"
        },
        /*::[*/ 0x0031: {
            n: "CURSORW12"
        },
        /*::[*/ 0x0032: {
            n: "WINDOW"
        },
        /*::[*/ 0x0033: {
            n: "STRING",
            f: parse_LABEL
        },
        /*::[*/ 0x0037: {
            n: "PASSWORD"
        },
        /*::[*/ 0x0038: {
            n: "LOCKED"
        },
        /*::[*/ 0x003C: {
            n: "QUERY"
        },
        /*::[*/ 0x003D: {
            n: "QUERYNAME"
        },
        /*::[*/ 0x003E: {
            n: "PRINT"
        },
        /*::[*/ 0x003F: {
            n: "PRINTNAME"
        },
        /*::[*/ 0x0040: {
            n: "GRAPH2"
        },
        /*::[*/ 0x0041: {
            n: "GRAPHNAME"
        },
        /*::[*/ 0x0042: {
            n: "ZOOM"
        },
        /*::[*/ 0x0043: {
            n: "SYMSPLIT"
        },
        /*::[*/ 0x0044: {
            n: "NSROWS"
        },
        /*::[*/ 0x0045: {
            n: "NSCOLS"
        },
        /*::[*/ 0x0046: {
            n: "RULER"
        },
        /*::[*/ 0x0047: {
            n: "NNAME"
        },
        /*::[*/ 0x0048: {
            n: "ACOMM"
        },
        /*::[*/ 0x0049: {
            n: "AMACRO"
        },
        /*::[*/ 0x004A: {
            n: "PARSE"
        },
        /*::[*/ 0x0066: {
            n: "PRANGES??"
        },
        /*::[*/ 0x0067: {
            n: "RRANGES??"
        },
        /*::[*/ 0x0068: {
            n: "FNAME??"
        },
        /*::[*/ 0x0069: {
            n: "MRANGES??"
        },
        /*::[*/ 0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        /*::[*/ 0x00DE: {
            n: "SHEETNAMELP",
            f: parse_SHEETNAMELP
        },
        /*::[*/ 0xFFFF: {
            n: ""
        }
    };
    var WK3Enum = {
        /*::[*/ 0x0000: {
            n: "BOF"
        },
        /*::[*/ 0x0001: {
            n: "EOF"
        },
        /*::[*/ 0x0002: {
            n: "PASSWORD"
        },
        /*::[*/ 0x0003: {
            n: "CALCSET"
        },
        /*::[*/ 0x0004: {
            n: "WINDOWSET"
        },
        /*::[*/ 0x0005: {
            n: "SHEETCELLPTR"
        },
        /*::[*/ 0x0006: {
            n: "SHEETLAYOUT"
        },
        /*::[*/ 0x0007: {
            n: "COLUMNWIDTH"
        },
        /*::[*/ 0x0008: {
            n: "HIDDENCOLUMN"
        },
        /*::[*/ 0x0009: {
            n: "USERRANGE"
        },
        /*::[*/ 0x000A: {
            n: "SYSTEMRANGE"
        },
        /*::[*/ 0x000B: {
            n: "ZEROFORCE"
        },
        /*::[*/ 0x000C: {
            n: "SORTKEYDIR"
        },
        /*::[*/ 0x000D: {
            n: "FILESEAL"
        },
        /*::[*/ 0x000E: {
            n: "DATAFILLNUMS"
        },
        /*::[*/ 0x000F: {
            n: "PRINTMAIN"
        },
        /*::[*/ 0x0010: {
            n: "PRINTSTRING"
        },
        /*::[*/ 0x0011: {
            n: "GRAPHMAIN"
        },
        /*::[*/ 0x0012: {
            n: "GRAPHSTRING"
        },
        /*::[*/ 0x0013: {
            n: "??"
        },
        /*::[*/ 0x0014: {
            n: "ERRCELL"
        },
        /*::[*/ 0x0015: {
            n: "NACELL"
        },
        /*::[*/ 0x0016: {
            n: "LABEL16",
            f: parse_LABEL_16
        },
        /*::[*/ 0x0017: {
            n: "NUMBER17",
            f: parse_NUMBER_17
        },
        /*::[*/ 0x0018: {
            n: "NUMBER18",
            f: parse_NUMBER_18
        },
        /*::[*/ 0x0019: {
            n: "FORMULA19",
            f: parse_FORMULA_19
        },
        /*::[*/ 0x001A: {
            n: "FORMULA1A"
        },
        /*::[*/ 0x001B: {
            n: "XFORMAT",
            f: parse_XFORMAT
        },
        /*::[*/ 0x001C: {
            n: "DTLABELMISC"
        },
        /*::[*/ 0x001D: {
            n: "DTLABELCELL"
        },
        /*::[*/ 0x001E: {
            n: "GRAPHWINDOW"
        },
        /*::[*/ 0x001F: {
            n: "CPA"
        },
        /*::[*/ 0x0020: {
            n: "LPLAUTO"
        },
        /*::[*/ 0x0021: {
            n: "QUERY"
        },
        /*::[*/ 0x0022: {
            n: "HIDDENSHEET"
        },
        /*::[*/ 0x0023: {
            n: "??"
        },
        /*::[*/ 0x0025: {
            n: "NUMBER25",
            f: parse_NUMBER_25
        },
        /*::[*/ 0x0026: {
            n: "??"
        },
        /*::[*/ 0x0027: {
            n: "NUMBER27",
            f: parse_NUMBER_27
        },
        /*::[*/ 0x0028: {
            n: "FORMULA28",
            f: parse_FORMULA_28
        },
        /*::[*/ 0x008E: {
            n: "??"
        },
        /*::[*/ 0x0093: {
            n: "??"
        },
        /*::[*/ 0x0096: {
            n: "??"
        },
        /*::[*/ 0x0097: {
            n: "??"
        },
        /*::[*/ 0x0098: {
            n: "??"
        },
        /*::[*/ 0x0099: {
            n: "??"
        },
        /*::[*/ 0x009A: {
            n: "??"
        },
        /*::[*/ 0x009B: {
            n: "??"
        },
        /*::[*/ 0x009C: {
            n: "??"
        },
        /*::[*/ 0x00A3: {
            n: "??"
        },
        /*::[*/ 0x00AE: {
            n: "??"
        },
        /*::[*/ 0x00AF: {
            n: "??"
        },
        /*::[*/ 0x00B0: {
            n: "??"
        },
        /*::[*/ 0x00B1: {
            n: "??"
        },
        /*::[*/ 0x00B8: {
            n: "??"
        },
        /*::[*/ 0x00B9: {
            n: "??"
        },
        /*::[*/ 0x00BA: {
            n: "??"
        },
        /*::[*/ 0x00BB: {
            n: "??"
        },
        /*::[*/ 0x00BC: {
            n: "??"
        },
        /*::[*/ 0x00C3: {
            n: "??"
        },
        /*::[*/ 0x00C9: {
            n: "??"
        },
        /*::[*/ 0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        /*::[*/ 0x00CD: {
            n: "??"
        },
        /*::[*/ 0x00CE: {
            n: "??"
        },
        /*::[*/ 0x00CF: {
            n: "??"
        },
        /*::[*/ 0x00D0: {
            n: "??"
        },
        /*::[*/ 0x0100: {
            n: "??"
        },
        /*::[*/ 0x0103: {
            n: "??"
        },
        /*::[*/ 0x0104: {
            n: "??"
        },
        /*::[*/ 0x0105: {
            n: "??"
        },
        /*::[*/ 0x0106: {
            n: "??"
        },
        /*::[*/ 0x0107: {
            n: "??"
        },
        /*::[*/ 0x0109: {
            n: "??"
        },
        /*::[*/ 0x010A: {
            n: "??"
        },
        /*::[*/ 0x010B: {
            n: "??"
        },
        /*::[*/ 0x010C: {
            n: "??"
        },
        /*::[*/ 0x010E: {
            n: "??"
        },
        /*::[*/ 0x010F: {
            n: "??"
        },
        /*::[*/ 0x0180: {
            n: "??"
        },
        /*::[*/ 0x0185: {
            n: "??"
        },
        /*::[*/ 0x0186: {
            n: "??"
        },
        /*::[*/ 0x0189: {
            n: "??"
        },
        /*::[*/ 0x018C: {
            n: "??"
        },
        /*::[*/ 0x0200: {
            n: "??"
        },
        /*::[*/ 0x0202: {
            n: "??"
        },
        /*::[*/ 0x0201: {
            n: "??"
        },
        /*::[*/ 0x0204: {
            n: "??"
        },
        /*::[*/ 0x0205: {
            n: "??"
        },
        /*::[*/ 0x0280: {
            n: "??"
        },
        /*::[*/ 0x0281: {
            n: "??"
        },
        /*::[*/ 0x0282: {
            n: "??"
        },
        /*::[*/ 0x0283: {
            n: "??"
        },
        /*::[*/ 0x0284: {
            n: "??"
        },
        /*::[*/ 0x0285: {
            n: "??"
        },
        /*::[*/ 0x0286: {
            n: "??"
        },
        /*::[*/ 0x0287: {
            n: "??"
        },
        /*::[*/ 0x0288: {
            n: "??"
        },
        /*::[*/ 0x0292: {
            n: "??"
        },
        /*::[*/ 0x0293: {
            n: "??"
        },
        /*::[*/ 0x0294: {
            n: "??"
        },
        /*::[*/ 0x0295: {
            n: "??"
        },
        /*::[*/ 0x0296: {
            n: "??"
        },
        /*::[*/ 0x0299: {
            n: "??"
        },
        /*::[*/ 0x029A: {
            n: "??"
        },
        /*::[*/ 0x0300: {
            n: "??"
        },
        /*::[*/ 0x0304: {
            n: "??"
        },
        /*::[*/ 0x0601: {
            n: "SHEETINFOQP",
            f: parse_SHEETINFOQP
        },
        /*::[*/ 0x0640: {
            n: "??"
        },
        /*::[*/ 0x0642: {
            n: "??"
        },
        /*::[*/ 0x0701: {
            n: "??"
        },
        /*::[*/ 0x0702: {
            n: "??"
        },
        /*::[*/ 0x0703: {
            n: "??"
        },
        /*::[*/ 0x0704: {
            n: "??"
        },
        /*::[*/ 0x0780: {
            n: "??"
        },
        /*::[*/ 0x0800: {
            n: "??"
        },
        /*::[*/ 0x0801: {
            n: "??"
        },
        /*::[*/ 0x0804: {
            n: "??"
        },
        /*::[*/ 0x0A80: {
            n: "??"
        },
        /*::[*/ 0x2AF6: {
            n: "??"
        },
        /*::[*/ 0x3231: {
            n: "??"
        },
        /*::[*/ 0x6E49: {
            n: "??"
        },
        /*::[*/ 0x6F44: {
            n: "??"
        },
        /*::[*/ 0xFFFF: {
            n: ""
        }
    };
    return {
        sheet_to_wk1: sheet_to_wk1,
        book_to_wk3: book_to_wk3,
        to_workbook: lotus_to_workbook
    };
}();
/* 18.4.7 rPr CT_RPrElt */ function $3ee4f50b1ae43a89$var$parse_rpr(rpr) {
    var font = {}, m = rpr.match($3ee4f50b1ae43a89$var$tagregex), i = 0;
    var pass = false;
    if (m) for(; i != m.length; ++i){
        var y = $3ee4f50b1ae43a89$var$parsexmltag(m[i]);
        switch(y[0].replace(/\w*:/g, "")){
            /* 18.8.12 condense CT_BooleanProperty */ /* ** not required . */ case "<condense":
                break;
            /* 18.8.17 extend CT_BooleanProperty */ /* ** not required . */ case "<extend":
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ /* ** not required . */ case "<shadow":
                if (!y.val) break;
            /* falls through */ case "<shadow>":
            case "<shadow/>":
                font.shadow = 1;
                break;
            case "</shadow>":
                break;
            /* 18.4.1 charset CT_IntProperty TODO */ case "<charset":
                if (y.val == "1") break;
                font.cp = $3ee4f50b1ae43a89$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.4.2 outline CT_BooleanProperty TODO */ case "<outline":
                if (!y.val) break;
            /* falls through */ case "<outline>":
            case "<outline/>":
                font.outline = 1;
                break;
            case "</outline>":
                break;
            /* 18.4.5 rFont CT_FontName */ case "<rFont":
                font.name = y.val;
                break;
            /* 18.4.11 sz CT_FontSize */ case "<sz":
                font.sz = y.val;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case "<strike":
                if (!y.val) break;
            /* falls through */ case "<strike>":
            case "<strike/>":
                font.strike = 1;
                break;
            case "</strike>":
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case "<u":
                if (!y.val) break;
                switch(y.val){
                    case "double":
                        font.uval = "double";
                        break;
                    case "singleAccounting":
                        font.uval = "single-accounting";
                        break;
                    case "doubleAccounting":
                        font.uval = "double-accounting";
                        break;
                }
            /* falls through */ case "<u>":
            case "<u/>":
                font.u = 1;
                break;
            case "</u>":
                break;
            /* 18.8.2 b */ case "<b":
                if (y.val == "0") break;
            /* falls through */ case "<b>":
            case "<b/>":
                font.b = 1;
                break;
            case "</b>":
                break;
            /* 18.8.26 i */ case "<i":
                if (y.val == "0") break;
            /* falls through */ case "<i>":
            case "<i/>":
                font.i = 1;
                break;
            case "</i>":
                break;
            /* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */ case "<color":
                if (y.rgb) font.color = y.rgb.slice(2, 8);
                break;
            case "<color>":
            case "<color/>":
            case "</color>":
                break;
            /* 18.8.18 family ST_FontFamily */ case "<family":
                font.family = y.val;
                break;
            case "<family>":
            case "<family/>":
            case "</family>":
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */ case "<vertAlign":
                font.valign = y.val;
                break;
            case "<vertAlign>":
            case "<vertAlign/>":
            case "</vertAlign>":
                break;
            /* 18.8.35 scheme CT_FontScheme TODO */ case "<scheme":
                break;
            case "<scheme>":
            case "<scheme/>":
            case "</scheme>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (y[0].charCodeAt(1) !== 47 && !pass) throw new Error("Unrecognized rich format " + y[0]);
        }
    }
    return font;
}
var $3ee4f50b1ae43a89$var$parse_rs = /*#__PURE__*/ function() {
    var tregex = $3ee4f50b1ae43a89$var$matchtag("t"), rpregex = $3ee4f50b1ae43a89$var$matchtag("rPr");
    /* 18.4.4 r CT_RElt */ function parse_r(r) {
        /* 18.4.12 t ST_Xstring */ var t = r.match(tregex) /*, cp = 65001*/ ;
        if (!t) return {
            t: "s",
            v: ""
        };
        var o /*:Cell*/  = {
            t: "s",
            v: $3ee4f50b1ae43a89$var$unescapexml(t[1])
        } /*:any*/ ;
        var rpr = r.match(rpregex);
        if (rpr) o.s = $3ee4f50b1ae43a89$var$parse_rpr(rpr[1]);
        return o;
    }
    var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
    return function parse_rs(rs) {
        return rs.replace(rregex, "").split(rend).map(parse_r).filter(function(r) {
            return r.v;
        });
    };
}();
/* Parse a list of <r> tags */ var $3ee4f50b1ae43a89$var$rs_to_html = /*#__PURE__*/ function parse_rs_factory() {
    var nlregex = /(\r\n|\n)/g;
    function parse_rpr2(font, intro, outro) {
        var style /*:Array<string>*/  = [];
        if (font.u) style.push("text-decoration: underline;");
        if (font.uval) style.push("text-underline-style:" + font.uval + ";");
        if (font.sz) style.push("font-size:" + font.sz + "pt;");
        if (font.outline) style.push("text-effect: outline;");
        if (font.shadow) style.push("text-shadow: auto;");
        intro.push('<span style="' + style.join("") + '">');
        if (font.b) {
            intro.push("<b>");
            outro.push("</b>");
        }
        if (font.i) {
            intro.push("<i>");
            outro.push("</i>");
        }
        if (font.strike) {
            intro.push("<s>");
            outro.push("</s>");
        }
        var align = font.valign || "";
        if (align == "superscript" || align == "super") align = "sup";
        else if (align == "subscript") align = "sub";
        if (align != "") {
            intro.push("<" + align + ">");
            outro.push("</" + align + ">");
        }
        outro.push("</span>");
        return font;
    }
    /* 18.4.4 r CT_RElt */ function r_to_html(r) {
        var terms /*:[Array<string>, string, Array<string>]*/  = [
            [],
            r.v,
            []
        ];
        if (!r.v) return "";
        if (r.s) parse_rpr2(r.s, terms[0], terms[2]);
        return terms[0].join("") + terms[1].replace(nlregex, "<br/>") + terms[2].join("");
    }
    return function parse_rs(rs) {
        return rs.map(r_to_html).join("");
    };
}();
/* 18.4.8 si CT_Rst */ var $3ee4f50b1ae43a89$var$sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, $3ee4f50b1ae43a89$var$sirregex = /<(?:\w+:)?r>/;
var $3ee4f50b1ae43a89$var$sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function $3ee4f50b1ae43a89$var$parse_si(x, opts) {
    var html = opts ? opts.cellHTML : true;
    var z = {};
    if (!x) return {
        t: ""
    };
    //var y;
    /* 18.4.12 t ST_Xstring (Plaintext String) */ // TODO: is whitespace actually valid here?
    if (x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
        z.t = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(x.slice(x.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || ""));
        z.r = $3ee4f50b1ae43a89$var$utf8read(x);
        if (html) z.h = $3ee4f50b1ae43a89$var$escapehtml(z.t);
    } else if (/*y = */ x.match($3ee4f50b1ae43a89$var$sirregex)) {
        z.r = $3ee4f50b1ae43a89$var$utf8read(x);
        z.t = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read((x.replace($3ee4f50b1ae43a89$var$sirphregex, "").match($3ee4f50b1ae43a89$var$sitregex) || []).join("").replace($3ee4f50b1ae43a89$var$tagregex, "")));
        if (html) z.h = $3ee4f50b1ae43a89$var$rs_to_html($3ee4f50b1ae43a89$var$parse_rs(z.r));
    }
    /* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */ /* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */ return z;
}
/* 18.4 Shared String Table */ var $3ee4f50b1ae43a89$var$sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
var $3ee4f50b1ae43a89$var$sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var $3ee4f50b1ae43a89$var$sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function $3ee4f50b1ae43a89$var$parse_sst_xml(data /*:string*/ , opts) /*:SST*/ {
    var s /*:SST*/  = [], ss = "";
    if (!data) return s;
    /* 18.4.9 sst CT_Sst */ var sst = data.match($3ee4f50b1ae43a89$var$sstr0);
    if (sst) {
        ss = sst[2].replace($3ee4f50b1ae43a89$var$sstr1, "").split($3ee4f50b1ae43a89$var$sstr2);
        for(var i = 0; i != ss.length; ++i){
            var o = $3ee4f50b1ae43a89$var$parse_si(ss[i].trim(), opts);
            if (o != null) s[s.length] = o;
        }
        sst = $3ee4f50b1ae43a89$var$parsexmltag(sst[1]);
        s.Count = sst.count;
        s.Unique = sst.uniqueCount;
    }
    return s;
}
var $3ee4f50b1ae43a89$var$straywsregex = /^\s|\s$|[\t\n\r]/;
function $3ee4f50b1ae43a89$var$write_sst_xml(sst /*:SST*/ , opts) /*:string*/ {
    if (!opts.bookSST) return "";
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER
    ];
    o[o.length] = $3ee4f50b1ae43a89$var$writextag("sst", null, {
        xmlns: $3ee4f50b1ae43a89$var$XMLNS_main[0],
        count: sst.Count,
        uniqueCount: sst.Unique
    });
    for(var i = 0; i != sst.length; ++i){
        if (sst[i] == null) continue;
        var s /*:XLString*/  = sst[i];
        var sitag = "<si>";
        if (s.r) sitag += s.r;
        else {
            sitag += "<t";
            if (!s.t) s.t = "";
            if (s.t.match($3ee4f50b1ae43a89$var$straywsregex)) sitag += ' xml:space="preserve"';
            sitag += ">" + $3ee4f50b1ae43a89$var$escapexml(s.t) + "</t>";
        }
        sitag += "</si>";
        o[o.length] = sitag;
    }
    if (o.length > 2) {
        o[o.length] = "</sst>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */ function $3ee4f50b1ae43a89$var$parse_BrtBeginSst(data) {
    return [
        data.read_shift(4),
        data.read_shift(4)
    ];
}
/* [MS-XLSB] 2.1.7.45 Shared Strings */ function $3ee4f50b1ae43a89$var$parse_sst_bin(data, opts) /*:SST*/ {
    var s /*:SST*/  = [];
    var pass = false;
    $3ee4f50b1ae43a89$var$recordhopper(data, function hopper_sst(val, R, RT) {
        switch(RT){
            case 0x009F:
                /* BrtBeginSst */ s.Count = val[0];
                s.Unique = val[1];
                break;
            case 0x0013:
                /* BrtSSTItem */ s.push(val);
                break;
            case 0x00A0:
                /* BrtEndSst */ return true;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            default:
                R.T;
                if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return s;
}
function $3ee4f50b1ae43a89$var$write_BrtBeginSst(sst, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(8);
    o.write_shift(4, sst.Count);
    o.write_shift(4, sst.Unique);
    return o;
}
var $3ee4f50b1ae43a89$var$write_BrtSSTItem = $3ee4f50b1ae43a89$var$write_RichStr;
function $3ee4f50b1ae43a89$var$write_sst_bin(sst /*::, opts*/ ) {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    $3ee4f50b1ae43a89$var$write_record(ba, 0x009F /* BrtBeginSst */ , $3ee4f50b1ae43a89$var$write_BrtBeginSst(sst));
    for(var i = 0; i < sst.length; ++i)$3ee4f50b1ae43a89$var$write_record(ba, 0x0013 /* BrtSSTItem */ , $3ee4f50b1ae43a89$var$write_BrtSSTItem(sst[i]));
    /* FRTSST */ $3ee4f50b1ae43a89$var$write_record(ba, 0x00A0 /* BrtEndSst */ );
    return ba.end();
}
function $3ee4f50b1ae43a89$var$_JS2ANSI(str /*:string*/ ) /*:Array<number>*/ {
    if (typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined") return $3ee4f50b1ae43a89$var$$cptable.utils.encode($3ee4f50b1ae43a89$var$current_ansi, str);
    var o /*:Array<number>*/  = [], oo = str.split("");
    for(var i = 0; i < oo.length; ++i)o[i] = oo[i].charCodeAt(0);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.4 Version */ function $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, length /*:?number*/ ) {
    var o /*:any*/  = {};
    o.Major = blob.read_shift(2);
    o.Minor = blob.read_shift(2);
    /*:: if(length == null) return o; */ if (length >= 4) blob.l += length - 4;
    return o;
}
/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */ function $3ee4f50b1ae43a89$var$parse_DataSpaceVersionInfo(blob) {
    var o = {};
    o.id = blob.read_shift(0, "lpp4");
    o.R = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    o.U = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    o.W = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */ function $3ee4f50b1ae43a89$var$parse_DataSpaceMapEntry(blob) {
    var len = blob.read_shift(4);
    var end = blob.l + len - 4;
    var o = {};
    var cnt = blob.read_shift(4);
    var comps /*:Array<{t:number, v:string}>*/  = [];
    /* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */ while(cnt-- > 0)comps.push({
        t: blob.read_shift(4),
        v: blob.read_shift(0, "lpp4")
    });
    o.name = blob.read_shift(0, "lpp4");
    o.comps = comps;
    if (blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */ function $3ee4f50b1ae43a89$var$parse_DataSpaceMap(blob) {
    var o = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push($3ee4f50b1ae43a89$var$parse_DataSpaceMapEntry(blob));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */ function $3ee4f50b1ae43a89$var$parse_DataSpaceDefinition(blob) /*:Array<string>*/ {
    var o /*:Array<string>*/  = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push(blob.read_shift(0, "lpp4"));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */ function $3ee4f50b1ae43a89$var$parse_TransformInfoHeader(blob) {
    var o = {};
    /*var len = */ blob.read_shift(4);
    blob.l += 4; // must be 0x1
    o.id = blob.read_shift(0, "lpp4");
    o.name = blob.read_shift(0, "lpp4");
    o.R = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    o.U = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    o.W = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_Primary(blob) {
    /* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */ var hdr = $3ee4f50b1ae43a89$var$parse_TransformInfoHeader(blob);
    /* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */ hdr.ename = blob.read_shift(0, "8lpp4");
    hdr.blksz = blob.read_shift(4);
    hdr.cmode = blob.read_shift(4);
    if (blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
    return hdr;
}
/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */ function $3ee4f50b1ae43a89$var$parse_EncryptionHeader(blob, length /*:number*/ ) {
    var tgt = blob.l + length;
    var o = {};
    o.Flags = blob.read_shift(4) & 0x3F;
    blob.l += 4;
    o.AlgID = blob.read_shift(4);
    var valid = false;
    switch(o.AlgID){
        case 0x660E:
        case 0x660F:
        case 0x6610:
            valid = o.Flags == 0x24;
            break;
        case 0x6801:
            valid = o.Flags == 0x04;
            break;
        case 0:
            valid = o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24;
            break;
        default:
            throw "Unrecognized encryption algorithm: " + o.AlgID;
    }
    if (!valid) throw new Error("Encryption Flags/AlgID mismatch");
    o.AlgIDHash = blob.read_shift(4);
    o.KeySize = blob.read_shift(4);
    o.ProviderType = blob.read_shift(4);
    blob.l += 8;
    o.CSPName = blob.read_shift(tgt - blob.l >> 1, "utf16le");
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */ function $3ee4f50b1ae43a89$var$parse_EncryptionVerifier(blob, length /*:number*/ ) {
    var o = {}, tgt = blob.l + length;
    blob.l += 4; // SaltSize must be 0x10
    o.Salt = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    o.Verifier = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    /*var sz = */ blob.read_shift(4);
    o.VerifierHash = blob.slice(blob.l, tgt);
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */ function $3ee4f50b1ae43a89$var$parse_EncryptionInfo(blob) {
    var vers = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob);
    switch(vers.Minor){
        case 0x02:
            return [
                vers.Minor,
                $3ee4f50b1ae43a89$var$parse_EncInfoStd(blob, vers)
            ];
        case 0x03:
            return [
                vers.Minor,
                $3ee4f50b1ae43a89$var$parse_EncInfoExt(blob, vers)
            ];
        case 0x04:
            return [
                vers.Minor,
                $3ee4f50b1ae43a89$var$parse_EncInfoAgl(blob, vers)
            ];
    }
    throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}
/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */ function $3ee4f50b1ae43a89$var$parse_EncInfoStd(blob /*::, vers*/ ) {
    var flags = blob.read_shift(4);
    if ((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
    var sz = blob.read_shift(4);
    //var tgt = blob.l + sz;
    var hdr = $3ee4f50b1ae43a89$var$parse_EncryptionHeader(blob, sz);
    var verifier = $3ee4f50b1ae43a89$var$parse_EncryptionVerifier(blob, blob.length - blob.l);
    return {
        t: "Std",
        h: hdr,
        v: verifier
    };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */ function $3ee4f50b1ae43a89$var$parse_EncInfoExt() {
    throw new Error("File is password-protected: ECMA-376 Extensible");
}
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */ function $3ee4f50b1ae43a89$var$parse_EncInfoAgl(blob /*::, vers*/ ) {
    var KeyData = [
        "saltSize",
        "blockSize",
        "keyBits",
        "hashSize",
        "cipherAlgorithm",
        "cipherChaining",
        "hashAlgorithm",
        "saltValue"
    ];
    blob.l += 4;
    var xml = blob.read_shift(blob.length - blob.l, "utf8");
    var o = {};
    xml.replace($3ee4f50b1ae43a89$var$tagregex, function xml_agile(x) {
        var y /*:any*/  = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<encryption":
            case "</encryption>":
                break;
            case "<keyData":
                KeyData.forEach(function(k) {
                    o[k] = y[k];
                });
                break;
            case "<dataIntegrity":
                o.encryptedHmacKey = y.encryptedHmacKey;
                o.encryptedHmacValue = y.encryptedHmacValue;
                break;
            case "<keyEncryptors>":
            case "<keyEncryptors":
                o.encs = [];
                break;
            case "</keyEncryptors>":
                break;
            case "<keyEncryptor":
                o.uri = y.uri;
                break;
            case "</keyEncryptor>":
                break;
            case "<encryptedKey":
                o.encs.push(y);
                break;
            default:
                throw y[0];
        }
    });
    return o;
}
/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */ function $3ee4f50b1ae43a89$var$parse_RC4CryptoHeader(blob, length /*:number*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    length -= 4;
    if (vers.Minor != 2) throw new Error("unrecognized minor version code: " + vers.Minor);
    if (vers.Major > 4 || vers.Major < 2) throw new Error("unrecognized major version code: " + vers.Major);
    o.Flags = blob.read_shift(4);
    length -= 4;
    var sz = blob.read_shift(4);
    length -= 4;
    o.EncryptionHeader = $3ee4f50b1ae43a89$var$parse_EncryptionHeader(blob, sz);
    length -= sz;
    o.EncryptionVerifier = $3ee4f50b1ae43a89$var$parse_EncryptionVerifier(blob, length);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */ function $3ee4f50b1ae43a89$var$parse_RC4Header(blob /*::, length*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $3ee4f50b1ae43a89$var$parse_CRYPTOVersion(blob, 4);
    if (vers.Major != 1 || vers.Minor != 1) throw "unrecognized version code " + vers.Major + " : " + vers.Minor;
    o.Salt = blob.read_shift(16);
    o.EncryptedVerifier = blob.read_shift(16);
    o.EncryptedVerifierHash = blob.read_shift(16);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */ function $3ee4f50b1ae43a89$var$crypto_CreatePasswordVerifier_Method1(Password /*:string*/ ) {
    var Verifier = 0x0000, PasswordArray;
    var PasswordDecoded = $3ee4f50b1ae43a89$var$_JS2ANSI(Password);
    var len = PasswordDecoded.length + 1, i, PasswordByte;
    var Intermediate1, Intermediate2, Intermediate3;
    PasswordArray = $3ee4f50b1ae43a89$var$new_raw_buf(len);
    PasswordArray[0] = PasswordDecoded.length;
    for(i = 1; i != len; ++i)PasswordArray[i] = PasswordDecoded[i - 1];
    for(i = len - 1; i >= 0; --i){
        PasswordByte = PasswordArray[i];
        Intermediate1 = (Verifier & 0x4000) === 0x0000 ? 0 : 1;
        Intermediate2 = Verifier << 1 & 0x7FFF;
        Intermediate3 = Intermediate1 | Intermediate2;
        Verifier = Intermediate3 ^ PasswordByte;
    }
    return Verifier ^ 0xCE4B;
}
/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */ var $3ee4f50b1ae43a89$var$crypto_CreateXorArray_Method1 = /*#__PURE__*/ function() {
    var PadArray = [
        0xBB,
        0xFF,
        0xFF,
        0xBA,
        0xFF,
        0xFF,
        0xB9,
        0x80,
        0x00,
        0xBE,
        0x0F,
        0x00,
        0xBF,
        0x0F,
        0x00
    ];
    var InitialCode = [
        0xE1F0,
        0x1D0F,
        0xCC9C,
        0x84C0,
        0x110C,
        0x0E10,
        0xF1CE,
        0x313E,
        0x1872,
        0xE139,
        0xD40F,
        0x84F9,
        0x280C,
        0xA96A,
        0x4EC3
    ];
    var XorMatrix = [
        0xAEFC,
        0x4DD9,
        0x9BB2,
        0x2745,
        0x4E8A,
        0x9D14,
        0x2A09,
        0x7B61,
        0xF6C2,
        0xFDA5,
        0xEB6B,
        0xC6F7,
        0x9DCF,
        0x2BBF,
        0x4563,
        0x8AC6,
        0x05AD,
        0x0B5A,
        0x16B4,
        0x2D68,
        0x5AD0,
        0x0375,
        0x06EA,
        0x0DD4,
        0x1BA8,
        0x3750,
        0x6EA0,
        0xDD40,
        0xD849,
        0xA0B3,
        0x5147,
        0xA28E,
        0x553D,
        0xAA7A,
        0x44D5,
        0x6F45,
        0xDE8A,
        0xAD35,
        0x4A4B,
        0x9496,
        0x390D,
        0x721A,
        0xEB23,
        0xC667,
        0x9CEF,
        0x29FF,
        0x53FE,
        0xA7FC,
        0x5FD9,
        0x47D3,
        0x8FA6,
        0x0F6D,
        0x1EDA,
        0x3DB4,
        0x7B68,
        0xF6D0,
        0xB861,
        0x60E3,
        0xC1C6,
        0x93AD,
        0x377B,
        0x6EF6,
        0xDDEC,
        0x45A0,
        0x8B40,
        0x06A1,
        0x0D42,
        0x1A84,
        0x3508,
        0x6A10,
        0xAA51,
        0x4483,
        0x8906,
        0x022D,
        0x045A,
        0x08B4,
        0x1168,
        0x76B4,
        0xED68,
        0xCAF1,
        0x85C3,
        0x1BA7,
        0x374E,
        0x6E9C,
        0x3730,
        0x6E60,
        0xDCC0,
        0xA9A1,
        0x4363,
        0x86C6,
        0x1DAD,
        0x3331,
        0x6662,
        0xCCC4,
        0x89A9,
        0x0373,
        0x06E6,
        0x0DCC,
        0x1021,
        0x2042,
        0x4084,
        0x8108,
        0x1231,
        0x2462,
        0x48C4
    ];
    var Ror = function(Byte) {
        return (Byte / 2 | Byte * 128) & 0xFF;
    };
    var XorRor = function(byte1, byte2) {
        return Ror(byte1 ^ byte2);
    };
    var CreateXorKey_Method1 = function(Password) {
        var XorKey = InitialCode[Password.length - 1];
        var CurrentElement = 0x68;
        for(var i = Password.length - 1; i >= 0; --i){
            var Char = Password[i];
            for(var j = 0; j != 7; ++j){
                if (Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
                Char *= 2;
                --CurrentElement;
            }
        }
        return XorKey;
    };
    return function(password /*:string*/ ) {
        var Password = $3ee4f50b1ae43a89$var$_JS2ANSI(password);
        var XorKey = CreateXorKey_Method1(Password);
        var Index = Password.length;
        var ObfuscationArray = $3ee4f50b1ae43a89$var$new_raw_buf(16);
        for(var i = 0; i != 16; ++i)ObfuscationArray[i] = 0x00;
        var Temp, PasswordLastChar, PadIndex;
        if ((Index & 1) === 1) {
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            PasswordLastChar = Password[Password.length - 1];
            ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
        }
        while(Index > 0){
            --Index;
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
        }
        Index = 15;
        PadIndex = 15 - Password.length;
        while(PadIndex > 0){
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
            --Index;
            --PadIndex;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            --PadIndex;
        }
        return ObfuscationArray;
    };
}();
/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */ var $3ee4f50b1ae43a89$var$crypto_DecryptData_Method1 = function(password /*:string*/ , Data, XorArrayIndex, XorArray, O) {
    /* If XorArray is set, use it; if O is not set, make changes in-place */ if (!O) O = Data;
    if (!XorArray) XorArray = $3ee4f50b1ae43a89$var$crypto_CreateXorArray_Method1(password);
    var Index, Value;
    for(Index = 0; Index != Data.length; ++Index){
        Value = Data[Index];
        Value ^= XorArray[XorArrayIndex];
        Value = (Value >> 5 | Value << 3) & 0xFF;
        O[Index] = Value;
        ++XorArrayIndex;
    }
    return [
        O,
        XorArrayIndex,
        XorArray
    ];
};
var $3ee4f50b1ae43a89$var$crypto_MakeXorDecryptor = function(password /*:string*/ ) {
    var XorArrayIndex = 0, XorArray = $3ee4f50b1ae43a89$var$crypto_CreateXorArray_Method1(password);
    return function(Data) {
        var O = $3ee4f50b1ae43a89$var$crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
        XorArrayIndex = O[1];
        return O[0];
    };
};
/* 2.5.343 */ function $3ee4f50b1ae43a89$var$parse_XORObfuscation(blob, length, opts, out) {
    var o = {
        key: $3ee4f50b1ae43a89$var$parseuint16(blob),
        verificationBytes: $3ee4f50b1ae43a89$var$parseuint16(blob)
    } /*:any*/ ;
    if (opts.password) o.verifier = $3ee4f50b1ae43a89$var$crypto_CreatePasswordVerifier_Method1(opts.password);
    out.valid = o.verificationBytes === o.verifier;
    if (out.valid) out.insitu = $3ee4f50b1ae43a89$var$crypto_MakeXorDecryptor(opts.password);
    return o;
}
/* 2.4.117 */ function $3ee4f50b1ae43a89$var$parse_FilePassHeader(blob, length /*:number*/ , oo) {
    var o = oo || {};
    o.Info = blob.read_shift(2);
    blob.l -= 2;
    if (o.Info === 1) o.Data = $3ee4f50b1ae43a89$var$parse_RC4Header(blob, length);
    else o.Data = $3ee4f50b1ae43a89$var$parse_RC4CryptoHeader(blob, length);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_FilePass(blob, length /*:number*/ , opts) {
    var o = {
        Type: opts.biff >= 8 ? blob.read_shift(2) : 0
    } /*:any*/ ; /* wEncryptionType */ 
    if (o.Type) $3ee4f50b1ae43a89$var$parse_FilePassHeader(blob, length - 2, o);
    else $3ee4f50b1ae43a89$var$parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
    return o;
}
var $3ee4f50b1ae43a89$var$RTF = /*#__PURE__*/ function() {
    function rtf_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        switch(opts.type){
            case "base64":
                return rtf_to_sheet_str($3ee4f50b1ae43a89$var$Base64_decode(d), opts);
            case "binary":
                return rtf_to_sheet_str(d, opts);
            case "buffer":
                return rtf_to_sheet_str($3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(d) ? d.toString("binary") : $3ee4f50b1ae43a89$var$a2s(d), opts);
            case "array":
                return rtf_to_sheet_str($3ee4f50b1ae43a89$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    /* TODO: this is a stub */ function rtf_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        var o = opts || {};
        var ws /*:Worksheet*/  = o.dense ? [] : {} /*:any*/ ;
        var rows = str.match(/\\trowd.*?\\row\b/g);
        if (!rows.length) throw new Error("RTF missing table");
        var range /*:Range*/  = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: rows.length - 1
            }
        } /*:any*/ ;
        rows.forEach(function(rowtf, R) {
            if (Array.isArray(ws)) ws[R] = [];
            var rtfre = /\\\w+\b/g;
            var last_index = 0;
            var res;
            var C = -1;
            while(res = rtfre.exec(rowtf)){
                switch(res[0]){
                    case "\\cell":
                        var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
                        if (data[0] == " ") data = data.slice(1);
                        ++C;
                        if (data.length) {
                            // TODO: value parsing, including codepage adjustments
                            var cell = {
                                v: data,
                                t: "s"
                            };
                            if (Array.isArray(ws)) ws[R][C] = cell;
                            else ws[$3ee4f50b1ae43a89$var$encode_cell({
                                r: R,
                                c: C
                            })] = cell;
                        }
                        break;
                }
                last_index = rtfre.lastIndex;
            }
            if (C > range.e.c) range.e.c = C;
        });
        ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
        return ws;
    }
    function rtf_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $3ee4f50b1ae43a89$var$sheet_to_workbook(rtf_to_sheet(d, opts), opts);
    }
    /* TODO: this is a stub */ function sheet_to_rtf(ws /*:Worksheet*/  /*::, opts*/ ) /*:string*/ {
        var o = [
            "{\\rtf1\\ansi"
        ];
        var r = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]), cell /*:Cell*/ ;
        var dense = Array.isArray(ws);
        for(var R = r.s.r; R <= r.e.r; ++R){
            o.push("\\trowd\\trautofit1");
            for(var C = r.s.c; C <= r.e.c; ++C)o.push("\\cellx" + (C + 1));
            o.push("\\pard\\intbl");
            for(C = r.s.c; C <= r.e.c; ++C){
                var coord = $3ee4f50b1ae43a89$var$encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws[R] || [])[C] : ws[coord];
                if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
                o.push(" " + (cell.w || ($3ee4f50b1ae43a89$var$format_cell(cell), cell.w)));
                o.push("\\cell");
            }
            o.push("\\pard\\intbl\\row");
        }
        return o.join("") + "}";
    }
    return {
        to_workbook: rtf_to_workbook,
        to_sheet: rtf_to_sheet,
        from_sheet: sheet_to_rtf
    };
}();
function $3ee4f50b1ae43a89$var$hex2RGB(h) {
    var o = h.slice(h[0] === "#" ? 1 : 0).slice(0, 6);
    return [
        parseInt(o.slice(0, 2), 16),
        parseInt(o.slice(2, 4), 16),
        parseInt(o.slice(4, 6), 16)
    ];
}
function $3ee4f50b1ae43a89$var$rgb2Hex(rgb) {
    for(var i = 0, o = 1; i != 3; ++i)o = o * 256 + (rgb[i] > 255 ? 255 : rgb[i] < 0 ? 0 : rgb[i]);
    return o.toString(16).toUpperCase().slice(1);
}
function $3ee4f50b1ae43a89$var$rgb2HSL(rgb) {
    var R = rgb[0] / 255, G = rgb[1] / 255, B = rgb[2] / 255;
    var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
    if (C === 0) return [
        0,
        0,
        R
    ];
    var H6 = 0, S = 0, L2 = M + m;
    S = C / (L2 > 1 ? 2 - L2 : L2);
    switch(M){
        case R:
            H6 = ((G - B) / C + 6) % 6;
            break;
        case G:
            H6 = (B - R) / C + 2;
            break;
        case B:
            H6 = (R - G) / C + 4;
            break;
    }
    return [
        H6 / 6,
        S,
        L2 / 2
    ];
}
function $3ee4f50b1ae43a89$var$hsl2RGB(hsl) {
    var H = hsl[0], S = hsl[1], L = hsl[2];
    var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C / 2;
    var rgb = [
        m,
        m,
        m
    ], h6 = 6 * H;
    var X;
    if (S !== 0) switch(h6 | 0){
        case 0:
        case 6:
            X = C * h6;
            rgb[0] += C;
            rgb[1] += X;
            break;
        case 1:
            X = C * (2 - h6);
            rgb[0] += X;
            rgb[1] += C;
            break;
        case 2:
            X = C * (h6 - 2);
            rgb[1] += C;
            rgb[2] += X;
            break;
        case 3:
            X = C * (4 - h6);
            rgb[1] += X;
            rgb[2] += C;
            break;
        case 4:
            X = C * (h6 - 4);
            rgb[2] += C;
            rgb[0] += X;
            break;
        case 5:
            X = C * (6 - h6);
            rgb[2] += X;
            rgb[0] += C;
            break;
    }
    for(var i = 0; i != 3; ++i)rgb[i] = Math.round(rgb[i] * 255);
    return rgb;
}
/* 18.8.3 bgColor tint algorithm */ function $3ee4f50b1ae43a89$var$rgb_tint(hex, tint) {
    if (tint === 0) return hex;
    var hsl = $3ee4f50b1ae43a89$var$rgb2HSL($3ee4f50b1ae43a89$var$hex2RGB(hex));
    if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
    else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
    return $3ee4f50b1ae43a89$var$rgb2Hex($3ee4f50b1ae43a89$var$hsl2RGB(hsl));
}
/* 18.3.1.13 width calculations */ /* [MS-OI29500] 2.1.595 Column Width & Formatting */ var $3ee4f50b1ae43a89$var$DEF_MDW = 6, $3ee4f50b1ae43a89$var$MAX_MDW = 15, $3ee4f50b1ae43a89$var$MIN_MDW = 1, $3ee4f50b1ae43a89$var$MDW = $3ee4f50b1ae43a89$var$DEF_MDW;
function $3ee4f50b1ae43a89$var$width2px(width) {
    return Math.floor((width + Math.round(128 / $3ee4f50b1ae43a89$var$MDW) / 256) * $3ee4f50b1ae43a89$var$MDW);
}
function $3ee4f50b1ae43a89$var$px2char(px) {
    return Math.floor((px - 5) / $3ee4f50b1ae43a89$var$MDW * 100 + 0.5) / 100;
}
function $3ee4f50b1ae43a89$var$char2width(chr) {
    return Math.round((chr * $3ee4f50b1ae43a89$var$MDW + 5) / $3ee4f50b1ae43a89$var$MDW * 256) / 256;
}
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function $3ee4f50b1ae43a89$var$cycle_width(collw) {
    return $3ee4f50b1ae43a89$var$char2width($3ee4f50b1ae43a89$var$px2char($3ee4f50b1ae43a89$var$width2px(collw)));
}
/* XLSX/XLSB/XLS specify width in units of MDW */ function $3ee4f50b1ae43a89$var$find_mdw_colw(collw) {
    var delta = Math.abs(collw - $3ee4f50b1ae43a89$var$cycle_width(collw)), _MDW = $3ee4f50b1ae43a89$var$MDW;
    if (delta > 0.005) {
        for($3ee4f50b1ae43a89$var$MDW = $3ee4f50b1ae43a89$var$MIN_MDW; $3ee4f50b1ae43a89$var$MDW < $3ee4f50b1ae43a89$var$MAX_MDW; ++$3ee4f50b1ae43a89$var$MDW)if (Math.abs(collw - $3ee4f50b1ae43a89$var$cycle_width(collw)) <= delta) {
            delta = Math.abs(collw - $3ee4f50b1ae43a89$var$cycle_width(collw));
            _MDW = $3ee4f50b1ae43a89$var$MDW;
        }
    }
    $3ee4f50b1ae43a89$var$MDW = _MDW;
}
/* XLML specifies width in terms of pixels */ /*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/ function $3ee4f50b1ae43a89$var$process_col(coll /*:ColInfo*/ ) {
    if (coll.width) {
        coll.wpx = $3ee4f50b1ae43a89$var$width2px(coll.width);
        coll.wch = $3ee4f50b1ae43a89$var$px2char(coll.wpx);
        coll.MDW = $3ee4f50b1ae43a89$var$MDW;
    } else if (coll.wpx) {
        coll.wch = $3ee4f50b1ae43a89$var$px2char(coll.wpx);
        coll.width = $3ee4f50b1ae43a89$var$char2width(coll.wch);
        coll.MDW = $3ee4f50b1ae43a89$var$MDW;
    } else if (typeof coll.wch == "number") {
        coll.width = $3ee4f50b1ae43a89$var$char2width(coll.wch);
        coll.wpx = $3ee4f50b1ae43a89$var$width2px(coll.width);
        coll.MDW = $3ee4f50b1ae43a89$var$MDW;
    }
    if (coll.customWidth) delete coll.customWidth;
}
var $3ee4f50b1ae43a89$var$DEF_PPI = 96, $3ee4f50b1ae43a89$var$PPI = $3ee4f50b1ae43a89$var$DEF_PPI;
function $3ee4f50b1ae43a89$var$px2pt(px) {
    return px * 96 / $3ee4f50b1ae43a89$var$PPI;
}
function $3ee4f50b1ae43a89$var$pt2px(pt) {
    return pt * $3ee4f50b1ae43a89$var$PPI / 96;
}
/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */ var $3ee4f50b1ae43a89$var$XLMLPatternTypeMap = {
    "None": "none",
    "Solid": "solid",
    "Gray50": "mediumGray",
    "Gray75": "darkGray",
    "Gray25": "lightGray",
    "HorzStripe": "darkHorizontal",
    "VertStripe": "darkVertical",
    "ReverseDiagStripe": "darkDown",
    "DiagStripe": "darkUp",
    "DiagCross": "darkGrid",
    "ThickDiagCross": "darkTrellis",
    "ThinHorzStripe": "lightHorizontal",
    "ThinVertStripe": "lightVertical",
    "ThinReverseDiagStripe": "lightDown",
    "ThinHorzCross": "lightGrid"
};
/* 18.8.5 borders CT_Borders */ function $3ee4f50b1ae43a89$var$parse_borders(t, styles, themes, opts) {
    styles.Borders = [];
    var border = {};
    var pass = false;
    (t[0].match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<borders":
            case "<borders>":
            case "</borders>":
                break;
            /* 18.8.4 border CT_Border */ case "<border":
            case "<border>":
            case "<border/>":
                border = /*::(*/ {} /*:: :any)*/ ;
                if (y.diagonalUp) border.diagonalUp = $3ee4f50b1ae43a89$var$parsexmlbool(y.diagonalUp);
                if (y.diagonalDown) border.diagonalDown = $3ee4f50b1ae43a89$var$parsexmlbool(y.diagonalDown);
                styles.Borders.push(border);
                break;
            case "</border>":
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case "<left/>":
                break;
            case "<left":
            case "<left>":
                break;
            case "</left>":
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case "<right/>":
                break;
            case "<right":
            case "<right>":
                break;
            case "</right>":
                break;
            /* 18.8.43 top CT_BorderPr */ case "<top/>":
                break;
            case "<top":
            case "<top>":
                break;
            case "</top>":
                break;
            /* 18.8.6 bottom CT_BorderPr */ case "<bottom/>":
                break;
            case "<bottom":
            case "<bottom>":
                break;
            case "</bottom>":
                break;
            /* 18.8.13 diagonal CT_BorderPr */ case "<diagonal":
            case "<diagonal>":
            case "<diagonal/>":
                break;
            case "</diagonal>":
                break;
            /* 18.8.25 horizontal CT_BorderPr */ case "<horizontal":
            case "<horizontal>":
            case "<horizontal/>":
                break;
            case "</horizontal>":
                break;
            /* 18.8.44 vertical CT_BorderPr */ case "<vertical":
            case "<vertical>":
            case "<vertical/>":
                break;
            case "</vertical>":
                break;
            /* 18.8.37 start CT_BorderPr */ case "<start":
            case "<start>":
            case "<start/>":
                break;
            case "</start>":
                break;
            /* 18.8.16 end CT_BorderPr */ case "<end":
            case "<end>":
            case "<end/>":
                break;
            case "</end>":
                break;
            /* 18.8.? color CT_Color */ case "<color":
            case "<color>":
                break;
            case "<color/>":
            case "</color>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in borders");
                }
        }
    });
}
/* 18.8.21 fills CT_Fills */ function $3ee4f50b1ae43a89$var$parse_fills(t, styles, themes, opts) {
    styles.Fills = [];
    var fill = {};
    var pass = false;
    (t[0].match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<fills":
            case "<fills>":
            case "</fills>":
                break;
            /* 18.8.20 fill CT_Fill */ case "<fill>":
            case "<fill":
            case "<fill/>":
                fill = {};
                styles.Fills.push(fill);
                break;
            case "</fill>":
                break;
            /* 18.8.24 gradientFill CT_GradientFill */ case "<gradientFill>":
                break;
            case "<gradientFill":
            case "</gradientFill>":
                styles.Fills.push(fill);
                fill = {};
                break;
            /* 18.8.32 patternFill CT_PatternFill */ case "<patternFill":
            case "<patternFill>":
                if (y.patternType) fill.patternType = y.patternType;
                break;
            case "<patternFill/>":
            case "</patternFill>":
                break;
            /* 18.8.3 bgColor CT_Color */ case "<bgColor":
                if (!fill.bgColor) fill.bgColor = {};
                if (y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
                if (y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.bgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
                break;
            case "<bgColor/>":
            case "</bgColor>":
                break;
            /* 18.8.19 fgColor CT_Color */ case "<fgColor":
                if (!fill.fgColor) fill.fgColor = {};
                if (y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.fgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
                break;
            case "<fgColor/>":
            case "</fgColor>":
                break;
            /* 18.8.38 stop CT_GradientStop */ case "<stop":
            case "<stop/>":
                break;
            case "</stop>":
                break;
            /* 18.8.? color CT_Color */ case "<color":
            case "<color/>":
                break;
            case "</color>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in fills");
                }
        }
    });
}
/* 18.8.23 fonts CT_Fonts */ function $3ee4f50b1ae43a89$var$parse_fonts(t, styles, themes, opts) {
    styles.Fonts = [];
    var font = {};
    var pass = false;
    (t[0].match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<fonts":
            case "<fonts>":
            case "</fonts>":
                break;
            /* 18.8.22 font CT_Font */ case "<font":
            case "<font>":
                break;
            case "</font>":
            case "<font/>":
                styles.Fonts.push(font);
                font = {};
                break;
            /* 18.8.29 name CT_FontName */ case "<name":
                if (y.val) font.name = $3ee4f50b1ae43a89$var$utf8read(y.val);
                break;
            case "<name/>":
            case "</name>":
                break;
            /* 18.8.2  b CT_BooleanProperty */ case "<b":
                font.bold = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case "<b/>":
                font.bold = 1;
                break;
            /* 18.8.26 i CT_BooleanProperty */ case "<i":
                font.italic = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case "<i/>":
                font.italic = 1;
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case "<u":
                switch(y.val){
                    case "none":
                        font.underline = 0x00;
                        break;
                    case "single":
                        font.underline = 0x01;
                        break;
                    case "double":
                        font.underline = 0x02;
                        break;
                    case "singleAccounting":
                        font.underline = 0x21;
                        break;
                    case "doubleAccounting":
                        font.underline = 0x22;
                        break;
                }
                break;
            case "<u/>":
                font.underline = 1;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case "<strike":
                font.strike = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case "<strike/>":
                font.strike = 1;
                break;
            /* 18.4.2  outline CT_BooleanProperty */ case "<outline":
                font.outline = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case "<outline/>":
                font.outline = 1;
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ case "<shadow":
                font.shadow = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case "<shadow/>":
                font.shadow = 1;
                break;
            /* 18.8.12 condense CT_BooleanProperty */ case "<condense":
                font.condense = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case "<condense/>":
                font.condense = 1;
                break;
            /* 18.8.17 extend CT_BooleanProperty */ case "<extend":
                font.extend = y.val ? $3ee4f50b1ae43a89$var$parsexmlbool(y.val) : 1;
                break;
            case "<extend/>":
                font.extend = 1;
                break;
            /* 18.4.11 sz CT_FontSize */ case "<sz":
                if (y.val) font.sz = +y.val;
                break;
            case "<sz/>":
            case "</sz>":
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty */ case "<vertAlign":
                if (y.val) font.vertAlign = y.val;
                break;
            case "<vertAlign/>":
            case "</vertAlign>":
                break;
            /* 18.8.18 family CT_FontFamily */ case "<family":
                if (y.val) font.family = parseInt(y.val, 10);
                break;
            case "<family/>":
            case "</family>":
                break;
            /* 18.8.35 scheme CT_FontScheme */ case "<scheme":
                if (y.val) font.scheme = y.val;
                break;
            case "<scheme/>":
            case "</scheme>":
                break;
            /* 18.4.1 charset CT_IntProperty */ case "<charset":
                if (y.val == "1") break;
                y.codepage = $3ee4f50b1ae43a89$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.?.? color CT_Color */ case "<color":
                if (!font.color) font.color = {};
                if (y.auto) font.color.auto = $3ee4f50b1ae43a89$var$parsexmlbool(y.auto);
                if (y.rgb) font.color.rgb = y.rgb.slice(-6);
                else if (y.indexed) {
                    font.color.index = parseInt(y.indexed, 10);
                    var icv = $3ee4f50b1ae43a89$var$XLSIcv[font.color.index];
                    if (font.color.index == 81) icv = $3ee4f50b1ae43a89$var$XLSIcv[1];
                    if (!icv) icv = $3ee4f50b1ae43a89$var$XLSIcv[1]; //throw new Error(x); // note: 206 is valid
                    font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
                } else if (y.theme) {
                    font.color.theme = parseInt(y.theme, 10);
                    if (y.tint) font.color.tint = parseFloat(y.tint);
                    if (y.theme && themes.themeElements && themes.themeElements.clrScheme) font.color.rgb = $3ee4f50b1ae43a89$var$rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
                }
                break;
            case "<color/>":
            case "</color>":
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case "<AlternateContent":
                pass = true;
                break;
            case "</AlternateContent>":
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in fonts");
                }
        }
    });
}
/* 18.8.31 numFmts CT_NumFmts */ function $3ee4f50b1ae43a89$var$parse_numFmts(t, styles, opts) {
    styles.NumberFmt = [];
    var k /*Array<number>*/  = $3ee4f50b1ae43a89$var$keys($3ee4f50b1ae43a89$var$table_fmt);
    for(var i = 0; i < k.length; ++i)styles.NumberFmt[k[i]] = $3ee4f50b1ae43a89$var$table_fmt[k[i]];
    var m = t[0].match($3ee4f50b1ae43a89$var$tagregex);
    if (!m) return;
    for(i = 0; i < m.length; ++i){
        var y = $3ee4f50b1ae43a89$var$parsexmltag(m[i]);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<numFmts":
            case "</numFmts>":
            case "<numFmts/>":
            case "<numFmts>":
                break;
            case "<numFmt":
                var f = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(y.formatCode)), j = parseInt(y.numFmtId, 10);
                styles.NumberFmt[j] = f;
                if (j > 0) {
                    if (j > 0x188) {
                        for(j = 0x188; j > 0x3c; --j)if (styles.NumberFmt[j] == null) break;
                        styles.NumberFmt[j] = f;
                    }
                    $3ee4f50b1ae43a89$var$SSF_load(f, j);
                }
                break;
            case "</numFmt>":
                break;
            default:
                if (opts.WTF) throw new Error("unrecognized " + y[0] + " in numFmts");
        }
    }
}
function $3ee4f50b1ae43a89$var$write_numFmts(NF /*:{[n:number|string]:string}*/  /*::, opts*/ ) {
    var o = [
        "<numFmts>"
    ];
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) o[o.length] = $3ee4f50b1ae43a89$var$writextag("numFmt", null, {
            numFmtId: i,
            formatCode: $3ee4f50b1ae43a89$var$escapexml(NF[i])
        });
    });
    if (o.length === 1) return "";
    o[o.length] = "</numFmts>";
    o[0] = $3ee4f50b1ae43a89$var$writextag("numFmts", null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8.10 cellXfs CT_CellXfs */ var $3ee4f50b1ae43a89$var$cellXF_uint = [
    "numFmtId",
    "fillId",
    "fontId",
    "borderId",
    "xfId"
];
var $3ee4f50b1ae43a89$var$cellXF_bool = [
    "applyAlignment",
    "applyBorder",
    "applyFill",
    "applyFont",
    "applyNumberFormat",
    "applyProtection",
    "pivotButton",
    "quotePrefix"
];
function $3ee4f50b1ae43a89$var$parse_cellXfs(t, styles, opts) {
    styles.CellXf = [];
    var xf;
    var pass = false;
    (t[0].match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x), i = 0;
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<cellXfs":
            case "<cellXfs>":
            case "<cellXfs/>":
            case "</cellXfs>":
                break;
            /* 18.8.45 xf CT_Xf */ case "<xf":
            case "<xf/>":
                xf = y;
                delete xf[0];
                for(i = 0; i < $3ee4f50b1ae43a89$var$cellXF_uint.length; ++i)if (xf[$3ee4f50b1ae43a89$var$cellXF_uint[i]]) xf[$3ee4f50b1ae43a89$var$cellXF_uint[i]] = parseInt(xf[$3ee4f50b1ae43a89$var$cellXF_uint[i]], 10);
                for(i = 0; i < $3ee4f50b1ae43a89$var$cellXF_bool.length; ++i)if (xf[$3ee4f50b1ae43a89$var$cellXF_bool[i]]) xf[$3ee4f50b1ae43a89$var$cellXF_bool[i]] = $3ee4f50b1ae43a89$var$parsexmlbool(xf[$3ee4f50b1ae43a89$var$cellXF_bool[i]]);
                if (styles.NumberFmt && xf.numFmtId > 0x188) {
                    for(i = 0x188; i > 0x3c; --i)if (styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) {
                        xf.numFmtId = i;
                        break;
                    }
                }
                styles.CellXf.push(xf);
                break;
            case "</xf>":
                break;
            /* 18.8.1 alignment CT_CellAlignment */ case "<alignment":
            case "<alignment/>":
                var alignment = {};
                if (y.vertical) alignment.vertical = y.vertical;
                if (y.horizontal) alignment.horizontal = y.horizontal;
                if (y.textRotation != null) alignment.textRotation = y.textRotation;
                if (y.indent) alignment.indent = y.indent;
                if (y.wrapText) alignment.wrapText = $3ee4f50b1ae43a89$var$parsexmlbool(y.wrapText);
                xf.alignment = alignment;
                break;
            case "</alignment>":
                break;
            /* 18.8.33 protection CT_CellProtection */ case "<protection":
                break;
            case "</protection>":
            case "<protection/>":
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case "<AlternateContent":
                pass = true;
                break;
            case "</AlternateContent>":
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in cellXfs");
                }
        }
    });
}
function $3ee4f50b1ae43a89$var$write_cellXfs(cellXfs) /*:string*/ {
    var o /*:Array<string>*/  = [];
    o[o.length] = $3ee4f50b1ae43a89$var$writextag("cellXfs", null);
    cellXfs.forEach(function(c) {
        o[o.length] = $3ee4f50b1ae43a89$var$writextag("xf", null, c);
    });
    o[o.length] = "</cellXfs>";
    if (o.length === 2) return "";
    o[0] = $3ee4f50b1ae43a89$var$writextag("cellXfs", null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8 Styles CT_Stylesheet*/ var $3ee4f50b1ae43a89$var$parse_sty_xml = /*#__PURE__*/ function make_pstyx() {
    var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
    var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
    var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
    var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
    var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
    return function parse_sty_xml(data, themes, opts) {
        var styles = {};
        if (!data) return styles;
        data = data.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
        /* 18.8.39 styleSheet CT_Stylesheet */ var t;
        /* 18.8.31 numFmts CT_NumFmts ? */ if (t = data.match(numFmtRegex)) $3ee4f50b1ae43a89$var$parse_numFmts(t, styles, opts);
        /* 18.8.23 fonts CT_Fonts ? */ if (t = data.match(fontsRegex)) $3ee4f50b1ae43a89$var$parse_fonts(t, styles, themes, opts);
        /* 18.8.21 fills CT_Fills ? */ if (t = data.match(fillsRegex)) $3ee4f50b1ae43a89$var$parse_fills(t, styles, themes, opts);
        /* 18.8.5  borders CT_Borders ? */ if (t = data.match(bordersRegex)) $3ee4f50b1ae43a89$var$parse_borders(t, styles, themes, opts);
        /* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */ /* 18.8.8  cellStyles CT_CellStyles ? */ /* 18.8.10 cellXfs CT_CellXfs ? */ if (t = data.match(cellXfRegex)) $3ee4f50b1ae43a89$var$parse_cellXfs(t, styles, opts);
        /* 18.8.15 dxfs CT_Dxfs ? */ /* 18.8.42 tableStyles CT_TableStyles ? */ /* 18.8.11 colors CT_Colors ? */ /* 18.2.10 extLst CT_ExtensionList ? */ return styles;
    };
}();
function $3ee4f50b1ae43a89$var$write_sty_xml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag("styleSheet", null, {
            "xmlns": $3ee4f50b1ae43a89$var$XMLNS_main[0],
            "xmlns:vt": $3ee4f50b1ae43a89$var$XMLNS.vt
        })
    ], w;
    if (wb.SSF && (w = $3ee4f50b1ae43a89$var$write_numFmts(wb.SSF)) != null) o[o.length] = w;
    o[o.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';
    o[o.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';
    o[o.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';
    o[o.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
    if (w = $3ee4f50b1ae43a89$var$write_cellXfs(opts.cellXfs)) o[o.length] = w;
    o[o.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';
    o[o.length] = '<dxfs count="0"/>';
    o[o.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';
    if (o.length > 2) {
        o[o.length] = "</styleSheet>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */ function $3ee4f50b1ae43a89$var$parse_BrtFmt(data, length /*:number*/ ) {
    var numFmtId = data.read_shift(2);
    var stFmtCode = $3ee4f50b1ae43a89$var$parse_XLWideString(data, length - 2);
    return [
        numFmtId,
        stFmtCode
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtFmt(i /*:number*/ , f /*:string*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(6 + 4 * f.length);
    o.write_shift(2, i);
    $3ee4f50b1ae43a89$var$write_XLWideString(f, o);
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (o.l == null) o.l = o.length;
    return out;
}
/* [MS-XLSB] 2.4.659 BrtFont TODO */ function $3ee4f50b1ae43a89$var$parse_BrtFont(data, length /*:number*/ , opts) {
    var out = {} /*:any*/ ;
    out.sz = data.read_shift(2) / 20;
    var grbit = $3ee4f50b1ae43a89$var$parse_FontFlags(data, 2, opts);
    if (grbit.fItalic) out.italic = 1;
    if (grbit.fCondense) out.condense = 1;
    if (grbit.fExtend) out.extend = 1;
    if (grbit.fShadow) out.shadow = 1;
    if (grbit.fOutline) out.outline = 1;
    if (grbit.fStrikeout) out.strike = 1;
    var bls = data.read_shift(2);
    if (bls === 0x02BC) out.bold = 1;
    switch(data.read_shift(2)){
        /* case 0: out.vertAlign = "baseline"; break; */ case 1:
            out.vertAlign = "superscript";
            break;
        case 2:
            out.vertAlign = "subscript";
            break;
    }
    var underline = data.read_shift(1);
    if (underline != 0) out.underline = underline;
    var family = data.read_shift(1);
    if (family > 0) out.family = family;
    var bCharSet = data.read_shift(1);
    if (bCharSet > 0) out.charset = bCharSet;
    data.l++;
    out.color = $3ee4f50b1ae43a89$var$parse_BrtColor(data, 8);
    switch(data.read_shift(1)){
        /* case 0: out.scheme = "none": break; */ case 1:
            out.scheme = "major";
            break;
        case 2:
            out.scheme = "minor";
            break;
    }
    out.name = $3ee4f50b1ae43a89$var$parse_XLWideString(data, length - 21);
    return out;
}
function $3ee4f50b1ae43a89$var$write_BrtFont(font /*:any*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(153);
    o.write_shift(2, font.sz * 20);
    $3ee4f50b1ae43a89$var$write_FontFlags(font, o);
    o.write_shift(2, font.bold ? 0x02BC : 0x0190);
    var sss = 0;
    if (font.vertAlign == "superscript") sss = 1;
    else if (font.vertAlign == "subscript") sss = 2;
    o.write_shift(2, sss);
    o.write_shift(1, font.underline || 0);
    o.write_shift(1, font.family || 0);
    o.write_shift(1, font.charset || 0);
    o.write_shift(1, 0);
    $3ee4f50b1ae43a89$var$write_BrtColor(font.color, o);
    var scheme = 0;
    if (font.scheme == "major") scheme = 1;
    if (font.scheme == "minor") scheme = 2;
    o.write_shift(1, scheme);
    $3ee4f50b1ae43a89$var$write_XLWideString(font.name, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.650 BrtFill */ var $3ee4f50b1ae43a89$var$XLSBFillPTNames = [
    "none",
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
var $3ee4f50b1ae43a89$var$rev_XLSBFillPTNames /*:EvertNumType*/ ;
/* TODO: gradient fill representation */ var $3ee4f50b1ae43a89$var$parse_BrtFill = $3ee4f50b1ae43a89$var$parsenoop;
function $3ee4f50b1ae43a89$var$write_BrtFill(fill, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(84);
    if (!$3ee4f50b1ae43a89$var$rev_XLSBFillPTNames) $3ee4f50b1ae43a89$var$rev_XLSBFillPTNames = $3ee4f50b1ae43a89$var$evert($3ee4f50b1ae43a89$var$XLSBFillPTNames);
    var fls /*:number*/  = $3ee4f50b1ae43a89$var$rev_XLSBFillPTNames[fill.patternType];
    if (fls == null) fls = 0x28;
    o.write_shift(4, fls);
    var j = 0;
    if (fls != 0x28) {
        /* TODO: custom FG Color */ $3ee4f50b1ae43a89$var$write_BrtColor({
            auto: 1
        }, o);
        /* TODO: custom BG Color */ $3ee4f50b1ae43a89$var$write_BrtColor({
            auto: 1
        }, o);
        for(; j < 12; ++j)o.write_shift(4, 0);
    } else {
        for(; j < 4; ++j)o.write_shift(4, 0);
        for(; j < 12; ++j)o.write_shift(4, 0); /* TODO */ 
    /* iGradientType */ /* xnumDegree */ /* xnumFillToLeft */ /* xnumFillToRight */ /* xnumFillToTop */ /* xnumFillToBottom */ /* cNumStop */ /* xfillGradientStop */ }
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.824 BrtXF */ function $3ee4f50b1ae43a89$var$parse_BrtXF(data, length /*:number*/ ) {
    var tgt = data.l + length;
    var ixfeParent = data.read_shift(2);
    var ifmt = data.read_shift(2);
    data.l = tgt;
    return {
        ixfe: ixfeParent,
        numFmtId: ifmt
    };
}
function $3ee4f50b1ae43a89$var$write_BrtXF(data, ixfeP, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(16);
    o.write_shift(2, ixfeP || 0);
    o.write_shift(2, data.numFmtId || 0);
    o.write_shift(2, 0); /* iFont */ 
    o.write_shift(2, 0); /* iFill */ 
    o.write_shift(2, 0); /* ixBorder */ 
    o.write_shift(1, 0); /* trot */ 
    o.write_shift(1, 0); /* indent */ 
    var flow = 0;
    o.write_shift(1, flow); /* flags */ 
    o.write_shift(1, 0); /* flags */ 
    o.write_shift(1, 0); /* xfGrbitAtr */ 
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.5.4 Blxf TODO */ function $3ee4f50b1ae43a89$var$write_Blxf(data, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(10);
    o.write_shift(1, 0); /* dg */ 
    o.write_shift(1, 0);
    o.write_shift(4, 0); /* color */ 
    o.write_shift(4, 0); /* color */ 
    return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */ var $3ee4f50b1ae43a89$var$parse_BrtBorder = $3ee4f50b1ae43a89$var$parsenoop;
function $3ee4f50b1ae43a89$var$write_BrtBorder(border, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(51);
    o.write_shift(1, 0); /* diagonal */ 
    $3ee4f50b1ae43a89$var$write_Blxf(null, o); /* top */ 
    $3ee4f50b1ae43a89$var$write_Blxf(null, o); /* bottom */ 
    $3ee4f50b1ae43a89$var$write_Blxf(null, o); /* left */ 
    $3ee4f50b1ae43a89$var$write_Blxf(null, o); /* right */ 
    $3ee4f50b1ae43a89$var$write_Blxf(null, o); /* diag */ 
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.763 BrtStyle TODO */ function $3ee4f50b1ae43a89$var$write_BrtStyle(style, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(52);
    o.write_shift(4, style.xfId);
    o.write_shift(2, 1);
    o.write_shift(1, +style.builtinId);
    o.write_shift(1, 0); /* iLevel */ 
    $3ee4f50b1ae43a89$var$write_XLNullableWideString(style.name || "", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */ function $3ee4f50b1ae43a89$var$write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
    var o = $3ee4f50b1ae43a89$var$new_buf(2052);
    o.write_shift(4, cnt);
    $3ee4f50b1ae43a89$var$write_XLNullableWideString(defTableStyle, o);
    $3ee4f50b1ae43a89$var$write_XLNullableWideString(defPivotStyle, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.1.7.50 Styles */ function $3ee4f50b1ae43a89$var$parse_sty_bin(data, themes, opts) {
    var styles = {};
    styles.NumberFmt = [];
    for(var y in $3ee4f50b1ae43a89$var$table_fmt)styles.NumberFmt[y] = $3ee4f50b1ae43a89$var$table_fmt[y];
    styles.CellXf = [];
    styles.Fonts = [];
    var state /*:Array<string>*/  = [];
    var pass = false;
    $3ee4f50b1ae43a89$var$recordhopper(data, function hopper_sty(val, R, RT) {
        switch(RT){
            case 0x002C:
                /* BrtFmt */ styles.NumberFmt[val[0]] = val[1];
                $3ee4f50b1ae43a89$var$SSF_load(val[1], val[0]);
                break;
            case 0x002B:
                /* BrtFont */ styles.Fonts.push(val);
                if (val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) val.color.rgb = $3ee4f50b1ae43a89$var$rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
                break;
            case 0x0401:
                break;
            case 0x002D:
                break;
            case 0x002E:
                break;
            case 0x002F:
                /* BrtXF */ if (state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */ ) styles.CellXf.push(val);
                break;
            case 0x0030:
            /* BrtStyle */ case 0x01FB:
            /* BrtDXF */ case 0x023C:
            /* BrtMRUColor */ case 0x01DB:
                break;
            case 0x0493:
            /* BrtDXF14 */ case 0x0836:
            /* BrtDXF15 */ case 0x046A:
            /* BrtSlicerStyleElement */ case 0x0200:
            /* BrtTableStyleElement */ case 0x082F:
            /* BrtTimelineStyleElement */ case 0x0C00:
                break;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            case 0x0025:
                /* BrtACBegin */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* BrtACEnd */ state.pop();
                pass = false;
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return styles;
}
function $3ee4f50b1ae43a89$var$write_FMTS_bin(ba, NF /*:?SSFTable*/ ) {
    if (!NF) return;
    var cnt = 0;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) ++cnt;
    });
    if (cnt == 0) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0267 /* BrtBeginFmts */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $3ee4f50b1ae43a89$var$write_record(ba, 0x002C /* BrtFmt */ , $3ee4f50b1ae43a89$var$write_BrtFmt(i, NF[i]));
    });
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0268 /* BrtEndFmts */ );
}
function $3ee4f50b1ae43a89$var$write_FONTS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0263 /* BrtBeginFonts */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x002B /* BrtFont */ , $3ee4f50b1ae43a89$var$write_BrtFont({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Calibri",
        family: 2,
        scheme: "minor"
    }));
    /* 1*65491BrtFont [ACFONTS] */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0264 /* BrtEndFonts */ );
}
function $3ee4f50b1ae43a89$var$write_FILLS_bin(ba /*::, data*/ ) {
    var cnt = 2;
    if (cnt == 0) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x025B /* BrtBeginFills */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x002D /* BrtFill */ , $3ee4f50b1ae43a89$var$write_BrtFill({
        patternType: "none"
    }));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x002D /* BrtFill */ , $3ee4f50b1ae43a89$var$write_BrtFill({
        patternType: "gray125"
    }));
    /* 1*65431BrtFill */ $3ee4f50b1ae43a89$var$write_record(ba, 0x025C /* BrtEndFills */ );
}
function $3ee4f50b1ae43a89$var$write_BORDERS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0265 /* BrtBeginBorders */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x002E /* BrtBorder */ , $3ee4f50b1ae43a89$var$write_BrtBorder({}));
    /* 1*65430BrtBorder */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0266 /* BrtEndBorders */ );
}
function $3ee4f50b1ae43a89$var$write_CELLSTYLEXFS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x002F /* BrtXF */ , $3ee4f50b1ae43a89$var$write_BrtXF({
        numFmtId: 0,
        fontId: 0,
        fillId: 0,
        borderId: 0
    }, 0xFFFF));
    /* 1*65430(BrtXF *FRT) */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0273 /* BrtEndCellStyleXFs */ );
}
function $3ee4f50b1ae43a89$var$write_CELLXFS_bin(ba, data) {
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0269 /* BrtBeginCellXFs */ , $3ee4f50b1ae43a89$var$write_UInt32LE(data.length));
    data.forEach(function(c) {
        $3ee4f50b1ae43a89$var$write_record(ba, 0x002F /* BrtXF */ , $3ee4f50b1ae43a89$var$write_BrtXF(c, 0));
    });
    /* 1*65430(BrtXF *FRT) */ $3ee4f50b1ae43a89$var$write_record(ba, 0x026A /* BrtEndCellXFs */ );
}
function $3ee4f50b1ae43a89$var$write_STYLES_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x026B /* BrtBeginStyles */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0030 /* BrtStyle */ , $3ee4f50b1ae43a89$var$write_BrtStyle({
        xfId: 0,
        builtinId: 0,
        name: "Normal"
    }));
    /* 1*65430(BrtStyle *FRT) */ $3ee4f50b1ae43a89$var$write_record(ba, 0x026C /* BrtEndStyles */ );
}
function $3ee4f50b1ae43a89$var$write_DXFS_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x01F9 /* BrtBeginDXFs */ , $3ee4f50b1ae43a89$var$write_UInt32LE(cnt));
    /* *2147483647(BrtDXF *FRT) */ $3ee4f50b1ae43a89$var$write_record(ba, 0x01FA /* BrtEndDXFs */ );
}
function $3ee4f50b1ae43a89$var$write_TABLESTYLES_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x01FC /* BrtBeginTableStyles */ , $3ee4f50b1ae43a89$var$write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
    /* *TABLESTYLE */ $3ee4f50b1ae43a89$var$write_record(ba, 0x01FD /* BrtEndTableStyles */ );
}
function $3ee4f50b1ae43a89$var$write_COLORPALETTE_bin() {
    return;
/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */ }
/* [MS-XLSB] 2.1.7.50 Styles */ function $3ee4f50b1ae43a89$var$write_sty_bin(wb, opts) {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0116 /* BrtBeginStyleSheet */ );
    $3ee4f50b1ae43a89$var$write_FMTS_bin(ba, wb.SSF);
    $3ee4f50b1ae43a89$var$write_FONTS_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_FILLS_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_BORDERS_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_CELLSTYLEXFS_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_CELLXFS_bin(ba, opts.cellXfs);
    $3ee4f50b1ae43a89$var$write_STYLES_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_DXFS_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_TABLESTYLES_bin(ba, wb);
    $3ee4f50b1ae43a89$var$write_COLORPALETTE_bin(ba, wb);
    /* FRTSTYLESHEET*/ $3ee4f50b1ae43a89$var$write_record(ba, 0x0117 /* BrtEndStyleSheet */ );
    return ba.end();
}
/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */ var $3ee4f50b1ae43a89$var$XLSXThemeClrScheme = [
    "</a:lt1>",
    "</a:dk1>",
    "</a:lt2>",
    "</a:dk2>",
    "</a:accent1>",
    "</a:accent2>",
    "</a:accent3>",
    "</a:accent4>",
    "</a:accent5>",
    "</a:accent6>",
    "</a:hlink>",
    "</a:folHlink>"
];
/* 20.1.6.2 clrScheme CT_ColorScheme */ function $3ee4f50b1ae43a89$var$parse_clrScheme(t, themes, opts) {
    themes.themeElements.clrScheme = [];
    var color = {};
    (t[0].match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch(y[0]){
            /* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */ case "<a:clrScheme":
            case "</a:clrScheme>":
                break;
            /* 20.1.2.3.32 srgbClr CT_SRgbColor */ case "<a:srgbClr":
                color.rgb = y.val;
                break;
            /* 20.1.2.3.33 sysClr CT_SystemColor */ case "<a:sysClr":
                color.rgb = y.lastClr;
                break;
            /* 20.1.4.1.1 accent1 (Accent 1) */ /* 20.1.4.1.2 accent2 (Accent 2) */ /* 20.1.4.1.3 accent3 (Accent 3) */ /* 20.1.4.1.4 accent4 (Accent 4) */ /* 20.1.4.1.5 accent5 (Accent 5) */ /* 20.1.4.1.6 accent6 (Accent 6) */ /* 20.1.4.1.9 dk1 (Dark 1) */ /* 20.1.4.1.10 dk2 (Dark 2) */ /* 20.1.4.1.15 folHlink (Followed Hyperlink) */ /* 20.1.4.1.19 hlink (Hyperlink) */ /* 20.1.4.1.22 lt1 (Light 1) */ /* 20.1.4.1.23 lt2 (Light 2) */ case "<a:dk1>":
            case "</a:dk1>":
            case "<a:lt1>":
            case "</a:lt1>":
            case "<a:dk2>":
            case "</a:dk2>":
            case "<a:lt2>":
            case "</a:lt2>":
            case "<a:accent1>":
            case "</a:accent1>":
            case "<a:accent2>":
            case "</a:accent2>":
            case "<a:accent3>":
            case "</a:accent3>":
            case "<a:accent4>":
            case "</a:accent4>":
            case "<a:accent5>":
            case "</a:accent5>":
            case "<a:accent6>":
            case "</a:accent6>":
            case "<a:hlink>":
            case "</a:hlink>":
            case "<a:folHlink>":
            case "</a:folHlink>":
                if (y[0].charAt(1) === "/") {
                    themes.themeElements.clrScheme[$3ee4f50b1ae43a89$var$XLSXThemeClrScheme.indexOf(y[0])] = color;
                    color = {};
                } else color.name = y[0].slice(3, y[0].length - 1);
                break;
            default:
                if (opts && opts.WTF) throw new Error("Unrecognized " + y[0] + " in clrScheme");
        }
    });
}
/* 20.1.4.1.18 fontScheme CT_FontScheme */ function $3ee4f50b1ae43a89$var$parse_fontScheme() {}
/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */ function $3ee4f50b1ae43a89$var$parse_fmtScheme() {}
var $3ee4f50b1ae43a89$var$clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
var $3ee4f50b1ae43a89$var$fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
var $3ee4f50b1ae43a89$var$fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
/* 20.1.6.10 themeElements CT_BaseStyles */ function $3ee4f50b1ae43a89$var$parse_themeElements(data, themes, opts) {
    themes.themeElements = {};
    var t;
    [
        /* clrScheme CT_ColorScheme */ [
            "clrScheme",
            $3ee4f50b1ae43a89$var$clrsregex,
            $3ee4f50b1ae43a89$var$parse_clrScheme
        ],
        /* fontScheme CT_FontScheme */ [
            "fontScheme",
            $3ee4f50b1ae43a89$var$fntsregex,
            $3ee4f50b1ae43a89$var$parse_fontScheme
        ],
        /* fmtScheme CT_StyleMatrix */ [
            "fmtScheme",
            $3ee4f50b1ae43a89$var$fmtsregex,
            $3ee4f50b1ae43a89$var$parse_fmtScheme
        ]
    ].forEach(function(m) {
        if (!(t = data.match(m[1]))) throw new Error(m[0] + " not found in themeElements");
        m[2](t, themes, opts);
    });
}
var $3ee4f50b1ae43a89$var$themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
/* 14.2.7 Theme Part */ function $3ee4f50b1ae43a89$var$parse_theme_xml(data /*:string*/ , opts) {
    /* 20.1.6.9 theme CT_OfficeStyleSheet */ if (!data || data.length === 0) data = $3ee4f50b1ae43a89$var$write_theme();
    var t;
    var themes = {};
    /* themeElements CT_BaseStyles */ if (!(t = data.match($3ee4f50b1ae43a89$var$themeltregex))) throw new Error("themeElements not found in theme");
    $3ee4f50b1ae43a89$var$parse_themeElements(t[0], themes, opts);
    themes.raw = data;
    return themes;
}
function $3ee4f50b1ae43a89$var$write_theme(Themes, opts) /*:string*/ {
    if (opts && opts.themeXLSX) return opts.themeXLSX;
    if (Themes && typeof Themes.raw == "string") return Themes.raw;
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER
    ];
    o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
    o[o.length] = "<a:themeElements>";
    o[o.length] = '<a:clrScheme name="Office">';
    o[o.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
    o[o.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
    o[o.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
    o[o.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
    o[o.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
    o[o.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
    o[o.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
    o[o.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
    o[o.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
    o[o.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
    o[o.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
    o[o.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
    o[o.length] = "</a:clrScheme>";
    o[o.length] = '<a:fontScheme name="Office">';
    o[o.length] = "<a:majorFont>";
    o[o.length] = '<a:latin typeface="Cambria"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="MoolBoran"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = "</a:majorFont>";
    o[o.length] = "<a:minorFont>";
    o[o.length] = '<a:latin typeface="Calibri"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Arial"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Arial"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="DaunPenh"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Arial"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = "</a:minorFont>";
    o[o.length] = "</a:fontScheme>";
    o[o.length] = '<a:fmtScheme name="Office">';
    o[o.length] = "<a:fillStyleLst>";
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:lin ang="16200000" scaled="1"/>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:lin ang="16200000" scaled="0"/>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = "</a:fillStyleLst>";
    o[o.length] = "<a:lnStyleLst>";
    o[o.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = "</a:lnStyleLst>";
    o[o.length] = "<a:effectStyleLst>";
    o[o.length] = "<a:effectStyle>";
    o[o.length] = "<a:effectLst>";
    o[o.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = "</a:effectLst>";
    o[o.length] = "</a:effectStyle>";
    o[o.length] = "<a:effectStyle>";
    o[o.length] = "<a:effectLst>";
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = "</a:effectLst>";
    o[o.length] = "</a:effectStyle>";
    o[o.length] = "<a:effectStyle>";
    o[o.length] = "<a:effectLst>";
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = "</a:effectLst>";
    o[o.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
    o[o.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
    o[o.length] = "</a:effectStyle>";
    o[o.length] = "</a:effectStyleLst>";
    o[o.length] = "<a:bgFillStyleLst>";
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = "</a:bgFillStyleLst>";
    o[o.length] = "</a:fmtScheme>";
    o[o.length] = "</a:themeElements>";
    o[o.length] = "<a:objectDefaults>";
    o[o.length] = "<a:spDef>";
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
    o[o.length] = "</a:spDef>";
    o[o.length] = "<a:lnDef>";
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
    o[o.length] = "</a:lnDef>";
    o[o.length] = "</a:objectDefaults>";
    o[o.length] = "<a:extraClrSchemeLst/>";
    o[o.length] = "</a:theme>";
    return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */ function $3ee4f50b1ae43a89$var$parse_Theme(blob, length, opts) {
    var end = blob.l + length;
    var dwThemeVersion = blob.read_shift(4);
    if (dwThemeVersion === 124226) return;
    if (!opts.cellStyles) {
        blob.l = end;
        return;
    }
    var data = blob.slice(blob.l);
    blob.l = end;
    var zip;
    try {
        zip = $3ee4f50b1ae43a89$var$zip_read(data, {
            type: "array"
        });
    } catch (e) {
        return;
    }
    var themeXML = $3ee4f50b1ae43a89$var$getzipstr(zip, "theme/theme/theme1.xml", true);
    if (!themeXML) return;
    return $3ee4f50b1ae43a89$var$parse_theme_xml(themeXML, opts);
}
/* 2.5.49 */ function $3ee4f50b1ae43a89$var$parse_ColorTheme(blob /*::, length*/ ) {
    return blob.read_shift(4);
}
/* 2.5.155 */ function $3ee4f50b1ae43a89$var$parse_FullColorExt(blob /*::, length*/ ) {
    var o = {};
    o.xclrType = blob.read_shift(2);
    o.nTintShade = blob.read_shift(2);
    switch(o.xclrType){
        case 0:
            blob.l += 4;
            break;
        case 1:
            o.xclrValue = $3ee4f50b1ae43a89$var$parse_IcvXF(blob, 4);
            break;
        case 2:
            o.xclrValue = $3ee4f50b1ae43a89$var$parse_LongRGBA(blob, 4);
            break;
        case 3:
            o.xclrValue = $3ee4f50b1ae43a89$var$parse_ColorTheme(blob, 4);
            break;
        case 4:
            blob.l += 4;
            break;
    }
    blob.l += 8;
    return o;
}
/* 2.5.164 TODO: read 7 bits*/ function $3ee4f50b1ae43a89$var$parse_IcvXF(blob, length) {
    return $3ee4f50b1ae43a89$var$parsenoop(blob, length);
}
/* 2.5.280 */ function $3ee4f50b1ae43a89$var$parse_XFExtGradient(blob, length) {
    return $3ee4f50b1ae43a89$var$parsenoop(blob, length);
}
/* [MS-XLS] 2.5.108 */ function $3ee4f50b1ae43a89$var$parse_ExtProp(blob /*::, length*/ ) /*:Array<any>*/ {
    var extType = blob.read_shift(2);
    var cb = blob.read_shift(2) - 4;
    var o = [
        extType
    ];
    switch(extType){
        case 0x04:
        case 0x05:
        case 0x07:
        case 0x08:
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0D:
            o[1] = $3ee4f50b1ae43a89$var$parse_FullColorExt(blob, cb);
            break;
        case 0x06:
            o[1] = $3ee4f50b1ae43a89$var$parse_XFExtGradient(blob, cb);
            break;
        case 0x0E:
        case 0x0F:
            o[1] = blob.read_shift(cb === 1 ? 1 : 2);
            break;
        default:
            throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
    }
    return o;
}
/* 2.4.355 */ function $3ee4f50b1ae43a89$var$parse_XFExt(blob, length) {
    var end = blob.l + length;
    blob.l += 2;
    var ixfe = blob.read_shift(2);
    blob.l += 2;
    var cexts = blob.read_shift(2);
    var ext /*:AOA*/  = [];
    while(cexts-- > 0)ext.push($3ee4f50b1ae43a89$var$parse_ExtProp(blob, end - blob.l));
    return {
        ixfe: ixfe,
        ext: ext
    };
}
/* xf is an XF, see parse_XFExt for xfext */ function $3ee4f50b1ae43a89$var$update_xfext(xf, xfext) {
    xfext.forEach(function(xfe) {
        xfe[0];
    });
}
function $3ee4f50b1ae43a89$var$parse_BrtMdtinfo(data, length) {
    return {
        flags: data.read_shift(4),
        version: data.read_shift(4),
        name: $3ee4f50b1ae43a89$var$parse_XLWideString(data, length - 8)
    };
}
function $3ee4f50b1ae43a89$var$write_BrtMdtinfo(data) {
    var o = $3ee4f50b1ae43a89$var$new_buf(12 + 2 * data.name.length);
    o.write_shift(4, data.flags);
    o.write_shift(4, data.version);
    $3ee4f50b1ae43a89$var$write_XLWideString(data.name, o);
    return o.slice(0, o.l);
}
function $3ee4f50b1ae43a89$var$parse_BrtMdb(data) {
    var out = [];
    var cnt = data.read_shift(4);
    while(cnt-- > 0)out.push([
        data.read_shift(4),
        data.read_shift(4)
    ]);
    return out;
}
function $3ee4f50b1ae43a89$var$write_BrtMdb(mdb) {
    var o = $3ee4f50b1ae43a89$var$new_buf(4 + 8 * mdb.length);
    o.write_shift(4, mdb.length);
    for(var i = 0; i < mdb.length; ++i){
        o.write_shift(4, mdb[i][0]);
        o.write_shift(4, mdb[i][1]);
    }
    return o;
}
function $3ee4f50b1ae43a89$var$write_BrtBeginEsfmd(cnt, name) {
    var o = $3ee4f50b1ae43a89$var$new_buf(8 + 2 * name.length);
    o.write_shift(4, cnt);
    $3ee4f50b1ae43a89$var$write_XLWideString(name, o);
    return o.slice(0, o.l);
}
function $3ee4f50b1ae43a89$var$parse_BrtBeginEsmdb(data) {
    data.l += 4;
    return data.read_shift(4) != 0;
}
function $3ee4f50b1ae43a89$var$write_BrtBeginEsmdb(cnt, cm) {
    var o = $3ee4f50b1ae43a89$var$new_buf(8);
    o.write_shift(4, cnt);
    o.write_shift(4, cm ? 1 : 0);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_xlmeta_bin(data, name, _opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    var opts = _opts || {};
    var state = [];
    var pass = false;
    var metatype = 2;
    $3ee4f50b1ae43a89$var$recordhopper(data, function(val, R, RT) {
        switch(RT){
            case 335:
                out.Types.push({
                    name: val.name
                });
                break;
            case 51:
                val.forEach(function(r) {
                    if (metatype == 1) out.Cell.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                    else if (metatype == 0) out.Value.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                });
                break;
            case 337:
                metatype = val ? 1 : 0;
                break;
            case 338:
                metatype = 2;
                break;
            case 35:
                state.push(RT);
                pass = true;
                break;
            case 36:
                state.pop();
                pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 35) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $3ee4f50b1ae43a89$var$write_xlmeta_bin() {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    $3ee4f50b1ae43a89$var$write_record(ba, 332);
    $3ee4f50b1ae43a89$var$write_record(ba, 334, $3ee4f50b1ae43a89$var$write_UInt32LE(1));
    $3ee4f50b1ae43a89$var$write_record(ba, 335, $3ee4f50b1ae43a89$var$write_BrtMdtinfo({
        name: "XLDAPR",
        version: 12e4,
        flags: 3496657072
    }));
    $3ee4f50b1ae43a89$var$write_record(ba, 336);
    $3ee4f50b1ae43a89$var$write_record(ba, 339, $3ee4f50b1ae43a89$var$write_BrtBeginEsfmd(1, "XLDAPR"));
    $3ee4f50b1ae43a89$var$write_record(ba, 52);
    $3ee4f50b1ae43a89$var$write_record(ba, 35, $3ee4f50b1ae43a89$var$write_UInt32LE(514));
    $3ee4f50b1ae43a89$var$write_record(ba, 4096, $3ee4f50b1ae43a89$var$write_UInt32LE(0));
    $3ee4f50b1ae43a89$var$write_record(ba, 4097, $3ee4f50b1ae43a89$var$writeuint16(1));
    $3ee4f50b1ae43a89$var$write_record(ba, 36);
    $3ee4f50b1ae43a89$var$write_record(ba, 53);
    $3ee4f50b1ae43a89$var$write_record(ba, 340);
    $3ee4f50b1ae43a89$var$write_record(ba, 337, $3ee4f50b1ae43a89$var$write_BrtBeginEsmdb(1, true));
    $3ee4f50b1ae43a89$var$write_record(ba, 51, $3ee4f50b1ae43a89$var$write_BrtMdb([
        [
            1,
            0
        ]
    ]));
    $3ee4f50b1ae43a89$var$write_record(ba, 338);
    $3ee4f50b1ae43a89$var$write_record(ba, 333);
    return ba.end();
}
function $3ee4f50b1ae43a89$var$parse_xlmeta_xml(data, name, opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    if (!data) return out;
    var pass = false;
    var metatype = 2;
    var lastmeta;
    data.replace($3ee4f50b1ae43a89$var$tagregex, function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<metadata":
            case "</metadata>":
                break;
            case "<metadataTypes":
            case "</metadataTypes>":
                break;
            case "<metadataType":
                out.Types.push({
                    name: y.name
                });
                break;
            case "</metadataType>":
                break;
            case "<futureMetadata":
                for(var j = 0; j < out.Types.length; ++j)if (out.Types[j].name == y.name) lastmeta = out.Types[j];
                break;
            case "</futureMetadata>":
                break;
            case "<bk>":
                break;
            case "</bk>":
                break;
            case "<rc":
                if (metatype == 1) out.Cell.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                else if (metatype == 0) out.Value.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                break;
            case "</rc>":
                break;
            case "<cellMetadata":
                metatype = 1;
                break;
            case "</cellMetadata>":
                metatype = 2;
                break;
            case "<valueMetadata":
                metatype = 0;
                break;
            case "</valueMetadata>":
                metatype = 2;
                break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            case "<rvb":
                if (!lastmeta) break;
                if (!lastmeta.offsets) lastmeta.offsets = [];
                lastmeta.offsets.push(+y.i);
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in metadata");
        }
        return x;
    });
    return out;
}
function $3ee4f50b1ae43a89$var$write_xlmeta_xml() {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER
    ];
    o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
    return o.join("");
}
/* 18.6 Calculation Chain */ function $3ee4f50b1ae43a89$var$parse_cc_xml(data /*::, name, opts*/ ) /*:Array<any>*/ {
    var d = [];
    if (!data) return d;
    var i = 1;
    (data.match($3ee4f50b1ae43a89$var$tagregex) || []).forEach(function(x) {
        var y = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch(y[0]){
            case "<?xml":
                break;
            /* 18.6.2  calcChain CT_CalcChain 1 */ case "<calcChain":
            case "<calcChain>":
            case "</calcChain>":
                break;
            /* 18.6.1  c CT_CalcCell 1 */ case "<c":
                delete y[0];
                if (y.i) i = y.i;
                else y.i = i;
                d.push(y);
                break;
        }
    });
    return d;
}
//function write_cc_xml(data, opts) { }
/* [MS-XLSB] 2.6.4.1 */ function $3ee4f50b1ae43a89$var$parse_BrtCalcChainItem$(data) {
    var out = {};
    out.i = data.read_shift(4);
    var cell = {};
    cell.r = data.read_shift(4);
    cell.c = data.read_shift(4);
    out.r = $3ee4f50b1ae43a89$var$encode_cell(cell);
    var flags = data.read_shift(1);
    if (flags & 0x2) out.l = "1";
    if (flags & 0x8) out.a = "1";
    return out;
}
/* 18.6 Calculation Chain */ function $3ee4f50b1ae43a89$var$parse_cc_bin(data, name, opts) {
    var out = [];
    var pass = false;
    $3ee4f50b1ae43a89$var$recordhopper(data, function hopper_cc(val, R, RT) {
        switch(RT){
            case 0x003F:
                /* 'BrtCalcChainItem$' */ out.push(val);
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */ function $3ee4f50b1ae43a89$var$parse_xlink_xml() {
//var opts = _opts || {};
//if(opts.WTF) throw "XLSX External Link";
}
/* [MS-XLSB] 2.1.7.25 External Link */ function $3ee4f50b1ae43a89$var$parse_xlink_bin(data, rel, name /*:string*/ , _opts) {
    if (!data) return data;
    var opts = _opts || {};
    var pass = false, end = false;
    $3ee4f50b1ae43a89$var$recordhopper(data, function xlink_parse(val, R, RT) {
        if (end) return;
        switch(RT){
            case 0x0167:
            /* 'BrtSupTabs' */ case 0x016B:
            /* 'BrtExternTableStart' */ case 0x016C:
            /* 'BrtExternTableEnd' */ case 0x016E:
            /* 'BrtExternRowHdr' */ case 0x016F:
            /* 'BrtExternCellBlank' */ case 0x0170:
            /* 'BrtExternCellReal' */ case 0x0171:
            /* 'BrtExternCellBool' */ case 0x0172:
            /* 'BrtExternCellError' */ case 0x0173:
            /* 'BrtExternCellString' */ case 0x01D8:
            /* 'BrtExternValueMeta' */ case 0x0241:
            /* 'BrtSupNameStart' */ case 0x0242:
            /* 'BrtSupNameValueStart' */ case 0x0243:
            /* 'BrtSupNameValueEnd' */ case 0x0244:
            /* 'BrtSupNameNum' */ case 0x0245:
            /* 'BrtSupNameErr' */ case 0x0246:
            /* 'BrtSupNameSt' */ case 0x0247:
            /* 'BrtSupNameNil' */ case 0x0248:
            /* 'BrtSupNameBool' */ case 0x0249:
            /* 'BrtSupNameFmla' */ case 0x024A:
            /* 'BrtSupNameBits' */ case 0x024B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
}
/* 20.5 DrawingML - SpreadsheetML Drawing */ /* 20.5.2.35 wsDr CT_Drawing */ function $3ee4f50b1ae43a89$var$parse_drawing(data, rels /*:any*/ ) {
    if (!data) return "??";
    /*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/ var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/) || [
        "",
        ""
    ])[1];
    return rels["!id"][id].Target;
}
/* L.5.5.2 SpreadsheetML Comments + VML Schema */ var $3ee4f50b1ae43a89$var$_shapeid = 1024;
function $3ee4f50b1ae43a89$var$write_comments_vml(rId /*:number*/ , comments) {
    var csize = [
        21600,
        21600
    ];
    /* L.5.2.1.2 Path Attribute */ var bbox = [
        "m0,0l0",
        csize[1],
        csize[0],
        csize[1],
        csize[0],
        "0xe"
    ].join(",");
    var o = [
        $3ee4f50b1ae43a89$var$writextag("xml", null, {
            "xmlns:v": $3ee4f50b1ae43a89$var$XLMLNS.v,
            "xmlns:o": $3ee4f50b1ae43a89$var$XLMLNS.o,
            "xmlns:x": $3ee4f50b1ae43a89$var$XLMLNS.x,
            "xmlns:mv": $3ee4f50b1ae43a89$var$XLMLNS.mv
        }).replace(/\/>/, ">"),
        $3ee4f50b1ae43a89$var$writextag("o:shapelayout", $3ee4f50b1ae43a89$var$writextag("o:idmap", null, {
            "v:ext": "edit",
            "data": rId
        }), {
            "v:ext": "edit"
        }),
        $3ee4f50b1ae43a89$var$writextag("v:shapetype", [
            $3ee4f50b1ae43a89$var$writextag("v:stroke", null, {
                joinstyle: "miter"
            }),
            $3ee4f50b1ae43a89$var$writextag("v:path", null, {
                gradientshapeok: "t",
                "o:connecttype": "rect"
            })
        ].join(""), {
            id: "_x0000_t202",
            "o:spt": 202,
            coordsize: csize.join(","),
            path: bbox
        })
    ];
    while($3ee4f50b1ae43a89$var$_shapeid < rId * 1000)$3ee4f50b1ae43a89$var$_shapeid += 1000;
    comments.forEach(function(x) {
        var c = $3ee4f50b1ae43a89$var$decode_cell(x[0]);
        var fillopts = /*::(*/ {
            "color2": "#BEFF82",
            "type": "gradient"
        } /*:: :any)*/ ;
        if (fillopts.type == "gradient") fillopts.angle = "-180";
        var fillparm = fillopts.type == "gradient" ? $3ee4f50b1ae43a89$var$writextag("o:fill", null, {
            type: "gradientUnscaled",
            "v:ext": "view"
        }) : null;
        var fillxml = $3ee4f50b1ae43a89$var$writextag("v:fill", fillparm, fillopts);
        var shadata = {
            on: "t",
            "obscured": "t"
        } /*:any*/ ;
        ++$3ee4f50b1ae43a89$var$_shapeid;
        o = o.concat([
            "<v:shape" + $3ee4f50b1ae43a89$var$wxt_helper({
                id: "_x0000_s" + $3ee4f50b1ae43a89$var$_shapeid,
                type: "#_x0000_t202",
                style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : ""),
                fillcolor: "#ECFAD4",
                strokecolor: "#edeaa1"
            }) + ">",
            fillxml,
            $3ee4f50b1ae43a89$var$writextag("v:shadow", null, shadata),
            $3ee4f50b1ae43a89$var$writextag("v:path", null, {
                "o:connecttype": "none"
            }),
            '<v:textbox><div style="text-align:left"></div></v:textbox>',
            '<x:ClientData ObjectType="Note">',
            "<x:MoveWithCells/>",
            "<x:SizeWithCells/>",
            /* Part 4 19.4.2.3 Anchor (Anchor) */ $3ee4f50b1ae43a89$var$writetag("x:Anchor", [
                c.c + 1,
                0,
                c.r + 1,
                0,
                c.c + 3,
                20,
                c.r + 5,
                20
            ].join(",")),
            $3ee4f50b1ae43a89$var$writetag("x:AutoFill", "False"),
            $3ee4f50b1ae43a89$var$writetag("x:Row", String(c.r)),
            $3ee4f50b1ae43a89$var$writetag("x:Column", String(c.c)),
            x[1].hidden ? "" : "<x:Visible/>",
            "</x:ClientData>",
            "</v:shape>"
        ]);
    });
    o.push("</xml>");
    return o.join("");
}
function $3ee4f50b1ae43a89$var$sheet_insert_comments(sheet, comments /*:Array<RawComment>*/ , threaded /*:boolean*/ , people /*:?Array<any>*/ ) {
    var dense = Array.isArray(sheet);
    var cell /*:Cell*/ ;
    comments.forEach(function(comment) {
        var r = $3ee4f50b1ae43a89$var$decode_cell(comment.ref);
        if (dense) {
            if (!sheet[r.r]) sheet[r.r] = [];
            cell = sheet[r.r][r.c];
        } else cell = sheet[comment.ref];
        if (!cell) {
            cell = {
                t: "z"
            } /*:any*/ ;
            if (dense) sheet[r.r][r.c] = cell;
            else sheet[comment.ref] = cell;
            var range = $3ee4f50b1ae43a89$var$safe_decode_range(sheet["!ref"] || "BDWGO1000001:A1");
            if (range.s.r > r.r) range.s.r = r.r;
            if (range.e.r < r.r) range.e.r = r.r;
            if (range.s.c > r.c) range.s.c = r.c;
            if (range.e.c < r.c) range.e.c = r.c;
            var encoded = $3ee4f50b1ae43a89$var$encode_range(range);
            if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
        }
        if (!cell.c) cell.c = [];
        var o /*:Comment*/  = {
            a: comment.author,
            t: comment.t,
            r: comment.r,
            T: threaded
        };
        if (comment.h) o.h = comment.h;
        /* threaded comments always override */ for(var i = cell.c.length - 1; i >= 0; --i){
            if (!threaded && cell.c[i].T) return;
            if (threaded && !cell.c[i].T) cell.c.splice(i, 1);
        }
        if (threaded && people) {
            for(i = 0; i < people.length; ++i)if (o.a == people[i].id) {
                o.a = people[i].name || o.a;
                break;
            }
        }
        cell.c.push(o);
    });
}
/* 18.7 Comments */ function $3ee4f50b1ae43a89$var$parse_comments_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    /* 18.7.6 CT_Comments */ if (data.match(/<(?:\w+:)?comments *\/>/)) return [];
    var authors /*:Array<string>*/  = [];
    var commentList /*:Array<RawComment>*/  = [];
    var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
    if (authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
        if (a) authors.push(a[1]);
    });
    var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
    if (cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
        if (!cm) return;
        var y = $3ee4f50b1ae43a89$var$parsexmltag(cm[0]);
        var comment /*:RawComment*/  = {
            author: y.authorId && authors[y.authorId] || "sheetjsghost",
            ref: y.ref,
            guid: y.guid
        } /*:any*/ ;
        var cell = $3ee4f50b1ae43a89$var$decode_cell(y.ref);
        if (opts.sheetRows && opts.sheetRows <= cell.r) return;
        var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
        var rt = !!textMatch && !!textMatch[1] && $3ee4f50b1ae43a89$var$parse_si(textMatch[1]) || {
            r: "",
            t: "",
            h: ""
        };
        comment.r = rt.r;
        if (rt.r == "<t></t>") rt.t = rt.h = "";
        comment.t = (rt.t || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        if (opts.cellHTML) comment.h = rt.h;
        commentList.push(comment);
    });
    return commentList;
}
function $3ee4f50b1ae43a89$var$write_comments_xml(data /*::, opts*/ ) {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag("comments", null, {
            "xmlns": $3ee4f50b1ae43a89$var$XMLNS_main[0]
        })
    ];
    var iauthor /*:Array<string>*/  = [];
    o.push("<authors>");
    data.forEach(function(x) {
        x[1].forEach(function(w) {
            var a = $3ee4f50b1ae43a89$var$escapexml(w.a);
            if (iauthor.indexOf(a) == -1) {
                iauthor.push(a);
                o.push("<author>" + a + "</author>");
            }
            if (w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
                iauthor.push("tc=" + w.ID);
                o.push("<author>tc=" + w.ID + "</author>");
            }
        });
    });
    if (iauthor.length == 0) {
        iauthor.push("SheetJ5");
        o.push("<author>SheetJ5</author>");
    }
    o.push("</authors>");
    o.push("<commentList>");
    data.forEach(function(d) {
        /* 18.7.3 CT_Comment */ var lastauthor = 0, ts = [];
        if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
        else d[1].forEach(function(c) {
            if (c.a) lastauthor = iauthor.indexOf($3ee4f50b1ae43a89$var$escapexml(c.a));
            ts.push(c.t || "");
        });
        o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
        if (ts.length <= 1) o.push($3ee4f50b1ae43a89$var$writetag("t", $3ee4f50b1ae43a89$var$escapexml(ts[0] || "")));
        else {
            /* based on Threaded Comments -> Comments projection */ var t = "Comment:\n    " + ts[0] + "\n";
            for(var i = 1; i < ts.length; ++i)t += "Reply:\n    " + ts[i] + "\n";
            o.push($3ee4f50b1ae43a89$var$writetag("t", $3ee4f50b1ae43a89$var$escapexml(t)));
        }
        o.push("</text></comment>");
    });
    o.push("</commentList>");
    if (o.length > 2) {
        o[o.length] = "</comments>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSX] 2.1.17 */ function $3ee4f50b1ae43a89$var$parse_tcmnt_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    var out = [];
    var pass = false, comment = {}, tidx = 0;
    data.replace($3ee4f50b1ae43a89$var$tagregex, function xml_tcmnt(x, idx) {
        var y /*:any*/  = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<?xml":
                break;
            /* 2.6.207 ThreadedComments CT_ThreadedComments */ case "<ThreadedComments":
                break;
            case "</ThreadedComments>":
                break;
            /* 2.6.205 threadedComment CT_ThreadedComment */ case "<threadedComment":
                comment = {
                    author: y.personId,
                    guid: y.id,
                    ref: y.ref,
                    T: 1
                };
                break;
            case "</threadedComment>":
                if (comment.t != null) out.push(comment);
                break;
            case "<text>":
            case "<text":
                tidx = idx + x.length;
                break;
            case "</text>":
                comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                break;
            /* 2.6.206 mentions CT_ThreadedCommentMentions TODO */ case "<mentions":
            case "<mentions>":
                pass = true;
                break;
            case "</mentions>":
                pass = false;
                break;
            /* 2.6.202 mention CT_Mention TODO */ /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            /* 18.2.7  ext CT_Extension + */ case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in threaded comments");
        }
        return x;
    });
    return out;
}
function $3ee4f50b1ae43a89$var$write_tcmnt_xml(comments, people, opts) {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag("ThreadedComments", null, {
            "xmlns": $3ee4f50b1ae43a89$var$XMLNS.TCMNT
        }).replace(/[\/]>/, ">")
    ];
    comments.forEach(function(carr) {
        var rootid = "";
        (carr[1] || []).forEach(function(c, idx) {
            if (!c.T) {
                delete c.ID;
                return;
            }
            if (c.a && people.indexOf(c.a) == -1) people.push(c.a);
            var tcopts = {
                ref: carr[0],
                id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
            };
            if (idx == 0) rootid = tcopts.id;
            else tcopts.parentId = rootid;
            c.ID = tcopts.id;
            if (c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
            o.push($3ee4f50b1ae43a89$var$writextag("threadedComment", $3ee4f50b1ae43a89$var$writetag("text", c.t || ""), tcopts));
        });
    });
    o.push("</ThreadedComments>");
    return o.join("");
}
/* [MS-XLSX] 2.1.18 */ function $3ee4f50b1ae43a89$var$parse_people_xml(data /*:string*/ , opts) {
    var out = [];
    var pass = false;
    data.replace($3ee4f50b1ae43a89$var$tagregex, function xml_tcmnt(x) {
        var y /*:any*/  = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<?xml":
                break;
            /* 2.4.85 personList CT_PersonList */ case "<personList":
                break;
            case "</personList>":
                break;
            /* 2.6.203 person CT_Person TODO: providers */ case "<person":
                out.push({
                    name: y.displayname,
                    id: y.id
                });
                break;
            case "</person>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            /* 18.2.7  ext CT_Extension + */ case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in threaded comments");
        }
        return x;
    });
    return out;
}
function $3ee4f50b1ae43a89$var$write_people_xml(people /*, opts*/ ) {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag("personList", null, {
            "xmlns": $3ee4f50b1ae43a89$var$XMLNS.TCMNT,
            "xmlns:x": $3ee4f50b1ae43a89$var$XMLNS_main[0]
        }).replace(/[\/]>/, ">")
    ];
    people.forEach(function(person, idx) {
        o.push($3ee4f50b1ae43a89$var$writextag("person", null, {
            displayName: person,
            id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
            userId: person,
            providerId: "None"
        }));
    });
    o.push("</personList>");
    return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */ function $3ee4f50b1ae43a89$var$parse_BrtBeginComment(data) {
    var out = {};
    out.iauthor = data.read_shift(4);
    var rfx = $3ee4f50b1ae43a89$var$parse_UncheckedRfX(data, 16);
    out.rfx = rfx.s;
    out.ref = $3ee4f50b1ae43a89$var$encode_cell(rfx.s);
    data.l += 16; /*var guid = parse_GUID(data); */ 
    return out;
}
function $3ee4f50b1ae43a89$var$write_BrtBeginComment(data, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(36);
    o.write_shift(4, data[1].iauthor);
    $3ee4f50b1ae43a89$var$write_UncheckedRfX(data[0], o);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLSB] 2.4.327 BrtCommentAuthor */ var $3ee4f50b1ae43a89$var$parse_BrtCommentAuthor = $3ee4f50b1ae43a89$var$parse_XLWideString;
function $3ee4f50b1ae43a89$var$write_BrtCommentAuthor(data) {
    return $3ee4f50b1ae43a89$var$write_XLWideString(data.slice(0, 54));
}
/* [MS-XLSB] 2.1.7.8 Comments */ function $3ee4f50b1ae43a89$var$parse_comments_bin(data, opts) /*:Array<RawComment>*/ {
    var out /*:Array<RawComment>*/  = [];
    var authors /*:Array<string>*/  = [];
    var c = {};
    var pass = false;
    $3ee4f50b1ae43a89$var$recordhopper(data, function hopper_cmnt(val, R, RT) {
        switch(RT){
            case 0x0278:
                /* 'BrtCommentAuthor' */ authors.push(val);
                break;
            case 0x027B:
                /* 'BrtBeginComment' */ c = val;
                break;
            case 0x027D:
                /* 'BrtCommentText' */ c.t = val.t;
                c.h = val.h;
                c.r = val.r;
                break;
            case 0x027C:
                /* 'BrtEndComment' */ c.author = authors[c.iauthor];
                delete c /*:any*/ .iauthor;
                if (opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
                if (!c.t) c.t = "";
                delete c.rfx;
                out.push(c);
                break;
            case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                break;
            case 0x0026:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $3ee4f50b1ae43a89$var$write_comments_bin(data /*::, opts*/ ) {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    var iauthor /*:Array<string>*/  = [];
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0274 /* BrtBeginComments */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0276 /* BrtBeginCommentAuthors */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            if (iauthor.indexOf(c.a) > -1) return;
            iauthor.push(c.a.slice(0, 54));
            $3ee4f50b1ae43a89$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $3ee4f50b1ae43a89$var$write_BrtCommentAuthor(c.a));
        });
    });
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0277 /* BrtEndCommentAuthors */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0279 /* BrtBeginCommentList */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            c.iauthor = iauthor.indexOf(c.a);
            var range = {
                s: $3ee4f50b1ae43a89$var$decode_cell(comment[0]),
                e: $3ee4f50b1ae43a89$var$decode_cell(comment[0])
            };
            $3ee4f50b1ae43a89$var$write_record(ba, 0x027B /* BrtBeginComment */ , $3ee4f50b1ae43a89$var$write_BrtBeginComment([
                range,
                c
            ]));
            if (c.t && c.t.length > 0) $3ee4f50b1ae43a89$var$write_record(ba, 0x027D /* BrtCommentText */ , $3ee4f50b1ae43a89$var$write_BrtCommentText(c));
            $3ee4f50b1ae43a89$var$write_record(ba, 0x027C /* BrtEndComment */ );
            delete c.iauthor;
        });
    });
    $3ee4f50b1ae43a89$var$write_record(ba, 0x027A /* BrtEndCommentList */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0275 /* BrtEndComments */ );
    return ba.end();
}
var $3ee4f50b1ae43a89$var$CT_VBA = "application/vnd.ms-office.vbaProject";
function $3ee4f50b1ae43a89$var$make_vba_xls(cfb) {
    var newcfb = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    cfb.FullPaths.forEach(function(p, i) {
        if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
        var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
        $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
    });
    return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.write(newcfb);
}
function $3ee4f50b1ae43a89$var$fill_vba_xls(cfb, vba) {
    vba.FullPaths.forEach(function(p, i) {
        if (i == 0) return;
        var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
        if (newpath.slice(-1) !== "/") $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
    });
}
var $3ee4f50b1ae43a89$var$VBAFMTS = [
    "xlsb",
    "xlsm",
    "xlam",
    "biff8",
    "xla"
];
/* macro and dialog sheet stubs */ function $3ee4f50b1ae43a89$var$parse_ds_bin() /*:Worksheet*/ {
    return {
        "!type": "dialog"
    };
}
function $3ee4f50b1ae43a89$var$parse_ds_xml() /*:Worksheet*/ {
    return {
        "!type": "dialog"
    };
}
function $3ee4f50b1ae43a89$var$parse_ms_bin() /*:Worksheet*/ {
    return {
        "!type": "macro"
    };
}
function $3ee4f50b1ae43a89$var$parse_ms_xml() /*:Worksheet*/ {
    return {
        "!type": "macro"
    };
}
/* TODO: it will be useful to parse the function str */ var $3ee4f50b1ae43a89$var$rc_to_a1 = /*#__PURE__*/ function() {
    var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
    var rcbase /*:Cell*/  = {
        r: 0,
        c: 0
    } /*:any*/ ;
    function rcfunc($$, $1, $2, $3) {
        var cRel = false, rRel = false;
        if ($2.length == 0) rRel = true;
        else if ($2.charAt(0) == "[") {
            rRel = true;
            $2 = $2.slice(1, -1);
        }
        if ($3.length == 0) cRel = true;
        else if ($3.charAt(0) == "[") {
            cRel = true;
            $3 = $3.slice(1, -1);
        }
        var R = $2.length > 0 ? parseInt($2, 10) | 0 : 0, C = $3.length > 0 ? parseInt($3, 10) | 0 : 0;
        if (cRel) C += rcbase.c;
        else --C;
        if (rRel) R += rcbase.r;
        else --R;
        return $1 + (cRel ? "" : "$") + $3ee4f50b1ae43a89$var$encode_col(C) + (rRel ? "" : "$") + $3ee4f50b1ae43a89$var$encode_row(R);
    }
    return function rc_to_a1(fstr /*:string*/ , base /*:Cell*/ ) /*:string*/ {
        rcbase = base;
        return fstr.replace(rcregex, rcfunc);
    };
}();
var $3ee4f50b1ae43a89$var$crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
var $3ee4f50b1ae43a89$var$a1_to_rc = /*#__PURE__*/ function() {
    return function a1_to_rc(fstr /*:string*/ , base /*:CellAddress*/ ) {
        return fstr.replace($3ee4f50b1ae43a89$var$crefregex, function($0, $1, $2, $3, $4, $5) {
            var c = $3ee4f50b1ae43a89$var$decode_col($3) - ($2 ? 0 : base.c);
            var r = $3ee4f50b1ae43a89$var$decode_row($5) - ($4 ? 0 : base.r);
            var R = r == 0 ? "" : !$4 ? "[" + r + "]" : r + 1;
            var C = c == 0 ? "" : !$2 ? "[" + c + "]" : c + 1;
            return $1 + "R" + R + "C" + C;
        });
    };
}();
/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */ function $3ee4f50b1ae43a89$var$shift_formula_str(f /*:string*/ , delta /*:Cell*/ ) /*:string*/ {
    return f.replace($3ee4f50b1ae43a89$var$crefregex, function($0, $1, $2, $3, $4, $5) {
        return $1 + ($2 == "$" ? $2 + $3 : $3ee4f50b1ae43a89$var$encode_col($3ee4f50b1ae43a89$var$decode_col($3) + delta.c)) + ($4 == "$" ? $4 + $5 : $3ee4f50b1ae43a89$var$encode_row($3ee4f50b1ae43a89$var$decode_row($5) + delta.r));
    });
}
function $3ee4f50b1ae43a89$var$shift_formula_xlsx(f /*:string*/ , range /*:string*/ , cell /*:string*/ ) /*:string*/ {
    var r = $3ee4f50b1ae43a89$var$decode_range(range), s = r.s, c = $3ee4f50b1ae43a89$var$decode_cell(cell);
    var delta = {
        r: c.r - s.r,
        c: c.c - s.c
    };
    return $3ee4f50b1ae43a89$var$shift_formula_str(f, delta);
}
/* TODO: parse formula */ function $3ee4f50b1ae43a89$var$fuzzyfmla(f /*:string*/ ) /*:boolean*/ {
    if (f.length == 1) return false;
    return true;
}
function $3ee4f50b1ae43a89$var$_xlfn(f /*:string*/ ) /*:string*/ {
    return f.replace(/_xlfn\./g, "");
}
function $3ee4f50b1ae43a89$var$parseread1(blob) {
    blob.l += 1;
    return;
}
/* [MS-XLS] 2.5.51 */ function $3ee4f50b1ae43a89$var$parse_ColRelU(blob, length) {
    var c = blob.read_shift(length == 1 ? 1 : 2);
    return [
        c & 0x3FFF,
        c >> 14 & 1,
        c >> 15 & 1
    ];
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */ function $3ee4f50b1ae43a89$var$parse_RgceArea(blob, length, opts) {
    var w = 2;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return $3ee4f50b1ae43a89$var$parse_RgceArea_BIFF2(blob, length, opts);
        else if (opts.biff == 12) w = 4;
    }
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    var C = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* BIFF 2-5 encodes flags in the row field */ function $3ee4f50b1ae43a89$var$parse_RgceArea_BIFF2(blob /*::, length, opts*/ ) {
    var r = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2), R = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    var C = blob.read_shift(1);
    return {
        s: {
            r: r[0],
            c: c,
            cRel: r[1],
            rRel: r[2]
        },
        e: {
            r: R[0],
            c: C,
            cRel: R[1],
            rRel: R[2]
        }
    };
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */ function $3ee4f50b1ae43a89$var$parse_RgceAreaRel(blob, length, opts) {
    if (opts.biff < 8) return $3ee4f50b1ae43a89$var$parse_RgceArea_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts.biff == 12 ? 4 : 2), R = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var c = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    var C = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */ function $3ee4f50b1ae43a89$var$parse_RgceLoc(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff <= 5) return $3ee4f50b1ae43a89$var$parse_RgceLoc_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
    var c = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    return {
        r: r,
        c: c[0],
        cRel: c[1],
        rRel: c[2]
    };
}
function $3ee4f50b1ae43a89$var$parse_RgceLoc_BIFF2(blob /*::, length, opts*/ ) {
    var r = $3ee4f50b1ae43a89$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    return {
        r: r[0],
        c: c,
        cRel: r[1],
        rRel: r[2]
    };
}
/* [MS-XLS] 2.5.198.107, 2.5.47 */ function $3ee4f50b1ae43a89$var$parse_RgceElfLoc(blob /*::, length, opts*/ ) {
    var r = blob.read_shift(2);
    var c = blob.read_shift(2);
    return {
        r: r,
        c: c & 0xFF,
        fQuoted: !!(c & 0x4000),
        cRel: c >> 15,
        rRel: c >> 15
    };
}
/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */ function $3ee4f50b1ae43a89$var$parse_RgceLocRel(blob, length, opts) {
    var biff = opts && opts.biff ? opts.biff : 8;
    if (biff >= 2 && biff <= 5) return $3ee4f50b1ae43a89$var$parse_RgceLocRel_BIFF2(blob, length, opts);
    var r = blob.read_shift(biff >= 12 ? 4 : 2);
    var cl = blob.read_shift(2);
    var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
    cl &= 0x3FFF;
    if (rRel == 1) while(r > 0x7FFFF)r -= 0x100000;
    if (cRel == 1) while(cl > 0x1FFF)cl = cl - 0x4000;
    return {
        r: r,
        c: cl,
        cRel: cRel,
        rRel: rRel
    };
}
function $3ee4f50b1ae43a89$var$parse_RgceLocRel_BIFF2(blob /*::, length:number, opts*/ ) {
    var rl = blob.read_shift(2);
    var c = blob.read_shift(1);
    var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
    rl &= 0x3FFF;
    if (rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
    if (cRel == 1 && c >= 0x80) c = c - 0x100;
    return {
        r: rl,
        c: c,
        cRel: cRel,
        rRel: rRel
    };
}
/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */ function $3ee4f50b1ae43a89$var$parse_PtgArea(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $3ee4f50b1ae43a89$var$parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */ function $3ee4f50b1ae43a89$var$parse_PtgArea3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2, "i");
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    var area = $3ee4f50b1ae43a89$var$parse_RgceArea(blob, w, opts);
    return [
        type,
        ixti,
        area
    ];
}
/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */ function $3ee4f50b1ae43a89$var$parse_PtgAreaErr(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts && opts.biff > 8 ? 12 : opts.biff < 8 ? 6 : 8;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */ function $3ee4f50b1ae43a89$var$parse_PtgAreaErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */ function $3ee4f50b1ae43a89$var$parse_PtgAreaN(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $3ee4f50b1ae43a89$var$parse_RgceAreaRel(blob, length - 1, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */ function $3ee4f50b1ae43a89$var$parse_PtgArray(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrBaxcel(blob) {
    var bitSemi = blob[blob.l + 1] & 0x01; /* 1 = volatile */ 
    var bitBaxcel = 1;
    blob.l += 4;
    return [
        bitSemi,
        bitBaxcel
    ];
}
/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrChoose(blob, length, opts) /*:Array<number>*/ {
    blob.l += 2;
    var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var o /*:Array<number>*/  = [];
    /* offset is 1 less than the number of elements */ for(var i = 0; i <= offset; ++i)o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
    return o;
}
/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrGoto(blob, length, opts) {
    var bitGoto = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitGoto,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrIf(blob, length, opts) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLSB] 2.5.97.28 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrIfError(blob) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(2)
    ];
}
/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrSemi(blob, length, opts) {
    var bitSemi = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return [
        bitSemi
    ];
}
/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrSpaceType(blob /*::, length*/ ) {
    var type = blob.read_shift(1), cch = blob.read_shift(1);
    return [
        type,
        cch
    ];
}
/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrSpace(blob) {
    blob.read_shift(2);
    return $3ee4f50b1ae43a89$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrSpaceSemi(blob) {
    blob.read_shift(2);
    return $3ee4f50b1ae43a89$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */ function $3ee4f50b1ae43a89$var$parse_PtgRef(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $3ee4f50b1ae43a89$var$parse_RgceLoc(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */ function $3ee4f50b1ae43a89$var$parse_PtgRefN(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $3ee4f50b1ae43a89$var$parse_RgceLocRel(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */ function $3ee4f50b1ae43a89$var$parse_PtgRef3d(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var ixti = blob.read_shift(2); // XtiIndex
    if (opts && opts.biff == 5) blob.l += 12;
    var loc = $3ee4f50b1ae43a89$var$parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
    return [
        type,
        ixti,
        loc
    ];
}
/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */ function $3ee4f50b1ae43a89$var$parse_PtgFunc(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
    return [
        $3ee4f50b1ae43a89$var$FtabArgc[iftab],
        $3ee4f50b1ae43a89$var$Ftab[iftab],
        type
    ];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */ function $3ee4f50b1ae43a89$var$parse_PtgFuncVar(blob, length, opts) {
    var type = blob[blob.l++];
    var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [
        type == 0x58 ? -1 : 0,
        blob.read_shift(1)
    ] : $3ee4f50b1ae43a89$var$parsetab(blob);
    return [
        cparams,
        (tab[0] === 0 ? $3ee4f50b1ae43a89$var$Ftab : $3ee4f50b1ae43a89$var$Cetab)[tab[1]]
    ];
}
function $3ee4f50b1ae43a89$var$parsetab(blob) {
    return [
        blob[blob.l + 1] >> 7,
        blob.read_shift(2) & 0x7FFF
    ];
}
/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */ function $3ee4f50b1ae43a89$var$parse_PtgAttrSum(blob, length, opts) {
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return;
}
/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */ function $3ee4f50b1ae43a89$var$parse_PtgExp(blob, length, opts) {
    blob.l++;
    if (opts && opts.biff == 12) return [
        blob.read_shift(4, "i"),
        0
    ];
    var row = blob.read_shift(2);
    var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        row,
        col
    ];
}
/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */ function $3ee4f50b1ae43a89$var$parse_PtgErr(blob) {
    blob.l++;
    return $3ee4f50b1ae43a89$var$BErr[blob.read_shift(1)];
}
/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */ function $3ee4f50b1ae43a89$var$parse_PtgInt(blob) {
    blob.l++;
    return blob.read_shift(2);
}
/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */ function $3ee4f50b1ae43a89$var$parse_PtgBool(blob) {
    blob.l++;
    return blob.read_shift(1) !== 0;
}
/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */ function $3ee4f50b1ae43a89$var$parse_PtgNum(blob) {
    blob.l++;
    return $3ee4f50b1ae43a89$var$parse_Xnum(blob, 8);
}
/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */ function $3ee4f50b1ae43a89$var$parse_PtgStr(blob, length, opts) {
    blob.l++;
    return $3ee4f50b1ae43a89$var$parse_ShortXLUnicodeString(blob, length - 1, opts);
}
/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */ /* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */ function $3ee4f50b1ae43a89$var$parse_SerAr(blob, biff /*:number*/ ) {
    var val = [
        blob.read_shift(1)
    ];
    if (biff == 12) switch(val[0]){
        case 0x02:
            val[0] = 0x04;
            break; /* SerBool */ 
        case 0x04:
            val[0] = 0x10;
            break; /* SerErr */ 
        case 0x00:
            val[0] = 0x01;
            break; /* SerNum */ 
        case 0x01:
            val[0] = 0x02;
            break; /* SerStr */ 
    }
    switch(val[0]){
        case 0x04:
            /* SerBool -- boolean */ val[1] = $3ee4f50b1ae43a89$var$parsebool(blob, 1) ? "TRUE" : "FALSE";
            if (biff != 12) blob.l += 7;
            break;
        case 0x25:
        /* appears to be an alias */ case 0x10:
            /* SerErr -- error */ val[1] = $3ee4f50b1ae43a89$var$BErr[blob[blob.l]];
            blob.l += biff == 12 ? 4 : 8;
            break;
        case 0x00:
            /* SerNil -- honestly, I'm not sure how to reproduce this */ blob.l += 8;
            break;
        case 0x01:
            /* SerNum -- Xnum */ val[1] = $3ee4f50b1ae43a89$var$parse_Xnum(blob, 8);
            break;
        case 0x02:
            /* SerStr -- XLUnicodeString (<256 chars) */ val[1] = $3ee4f50b1ae43a89$var$parse_XLUnicodeString2(blob, 0, {
                biff: biff > 0 && biff < 8 ? 2 : biff
            });
            break;
        default:
            throw new Error("Bad SerAr: " + val[0]); /* Unreachable */ 
    }
    return val;
}
/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */ function $3ee4f50b1ae43a89$var$parse_PtgExtraMem(blob, cce, opts) {
    var count = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var out /*:Array<Range>*/  = [];
    for(var i = 0; i != count; ++i)out.push((opts.biff == 12 ? $3ee4f50b1ae43a89$var$parse_UncheckedRfX : $3ee4f50b1ae43a89$var$parse_Ref8U)(blob, 8));
    return out;
}
/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */ function $3ee4f50b1ae43a89$var$parse_PtgExtraArray(blob, length, opts) {
    var rows = 0, cols = 0;
    if (opts.biff == 12) {
        rows = blob.read_shift(4); // DRw
        cols = blob.read_shift(4); // DCol
    } else {
        cols = 1 + blob.read_shift(1); //DColByteU
        rows = 1 + blob.read_shift(2); //DRw
    }
    if (opts.biff >= 2 && opts.biff < 8) {
        --rows;
        if (--cols == 0) cols = 0x100;
    }
    // $FlowIgnore
    for(var i = 0, o /*:Array<Array<any>>*/  = []; i != rows && (o[i] = []); ++i)for(var j = 0; j != cols; ++j)o[i][j] = $3ee4f50b1ae43a89$var$parse_SerAr(blob, opts.biff);
    return o;
}
/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */ function $3ee4f50b1ae43a89$var$parse_PtgName(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var w = !opts || opts.biff >= 8 ? 4 : 2;
    var nameindex = blob.read_shift(w);
    switch(opts.biff){
        case 2:
            blob.l += 5;
            break;
        case 3:
        case 4:
            blob.l += 8;
            break;
        case 5:
            blob.l += 12;
            break;
    }
    return [
        type,
        0,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */ function $3ee4f50b1ae43a89$var$parse_PtgNameX(blob, length, opts) {
    if (opts.biff == 5) return $3ee4f50b1ae43a89$var$parse_PtgNameX_BIFF5(blob, length, opts);
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2); // XtiIndex
    var nameindex = blob.read_shift(4);
    return [
        type,
        ixti,
        nameindex
    ];
}
function $3ee4f50b1ae43a89$var$parse_PtgNameX_BIFF5(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2, "i"); // XtiIndex
    blob.l += 8;
    var nameindex = blob.read_shift(2);
    blob.l += 12;
    return [
        type,
        ixti,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */ function $3ee4f50b1ae43a89$var$parse_PtgMemArea(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */ function $3ee4f50b1ae43a89$var$parse_PtgMemFunc(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */ function $3ee4f50b1ae43a89$var$parse_PtgRefErr(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += 4;
    if (opts.biff < 8) blob.l--;
    if (opts.biff == 12) blob.l += 2;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */ function $3ee4f50b1ae43a89$var$parse_PtgRefErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 4;
    if (opts) switch(opts.biff){
        case 5:
            w = 15;
            break;
        case 12:
            w = 6;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */ var $3ee4f50b1ae43a89$var$parse_PtgMemErr = $3ee4f50b1ae43a89$var$parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */ var $3ee4f50b1ae43a89$var$parse_PtgMemNoMem = $3ee4f50b1ae43a89$var$parsenoop;
/* [MS-XLS] 2.5.198.92 */ var $3ee4f50b1ae43a89$var$parse_PtgTbl = $3ee4f50b1ae43a89$var$parsenoop;
function $3ee4f50b1ae43a89$var$parse_PtgElfLoc(blob, length, opts) {
    blob.l += 2;
    return [
        $3ee4f50b1ae43a89$var$parse_RgceElfLoc(blob, 4, opts)
    ];
}
function $3ee4f50b1ae43a89$var$parse_PtgElfNoop(blob /*::, length, opts*/ ) {
    blob.l += 6;
    return [];
}
/* [MS-XLS] 2.5.198.46 */ var $3ee4f50b1ae43a89$var$parse_PtgElfCol = $3ee4f50b1ae43a89$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */ var $3ee4f50b1ae43a89$var$parse_PtgElfColS = $3ee4f50b1ae43a89$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */ var $3ee4f50b1ae43a89$var$parse_PtgElfColSV = $3ee4f50b1ae43a89$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */ var $3ee4f50b1ae43a89$var$parse_PtgElfColV = $3ee4f50b1ae43a89$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */ function $3ee4f50b1ae43a89$var$parse_PtgElfLel(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        $3ee4f50b1ae43a89$var$parseuint16(blob),
        blob.read_shift(2) & 0x01
    ];
}
/* [MS-XLS] 2.5.198.51 */ var $3ee4f50b1ae43a89$var$parse_PtgElfRadical = $3ee4f50b1ae43a89$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */ var $3ee4f50b1ae43a89$var$parse_PtgElfRadicalLel = $3ee4f50b1ae43a89$var$parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */ var $3ee4f50b1ae43a89$var$parse_PtgElfRadicalS = $3ee4f50b1ae43a89$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */ var $3ee4f50b1ae43a89$var$parse_PtgElfRw = $3ee4f50b1ae43a89$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */ var $3ee4f50b1ae43a89$var$parse_PtgElfRwV = $3ee4f50b1ae43a89$var$parse_PtgElfLoc;
/* [MS-XLSB] 2.5.97.52 TODO */ var $3ee4f50b1ae43a89$var$PtgListRT = [
    "Data",
    "All",
    "Headers",
    "??",
    "?Data2",
    "??",
    "?DataHeaders",
    "??",
    "Totals",
    "??",
    "??",
    "??",
    "?DataTotals",
    "??",
    "??",
    "??",
    "?Current"
];
function $3ee4f50b1ae43a89$var$parse_PtgList(blob /*::, length, opts*/ ) {
    blob.l += 2;
    var ixti = blob.read_shift(2);
    var flags = blob.read_shift(2);
    var idx = blob.read_shift(4);
    var c = blob.read_shift(2);
    var C = blob.read_shift(2);
    var rt = $3ee4f50b1ae43a89$var$PtgListRT[flags >> 2 & 0x1F];
    return {
        ixti: ixti,
        coltype: flags & 0x3,
        rt: rt,
        idx: idx,
        c: c,
        C: C
    };
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */ function $3ee4f50b1ae43a89$var$parse_PtgSxName(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        blob.read_shift(4)
    ];
}
/* [XLS] old spec */ function $3ee4f50b1ae43a89$var$parse_PtgSheet(blob, length, opts) {
    blob.l += 5;
    blob.l += 2;
    blob.l += opts.biff == 2 ? 1 : 4;
    return [
        "PTGSHEET"
    ];
}
function $3ee4f50b1ae43a89$var$parse_PtgEndSheet(blob, length, opts) {
    blob.l += opts.biff == 2 ? 4 : 5;
    return [
        "PTGENDSHEET"
    ];
}
function $3ee4f50b1ae43a89$var$parse_PtgMemAreaN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $3ee4f50b1ae43a89$var$parse_PtgMemNoMemN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $3ee4f50b1ae43a89$var$parse_PtgAttrNoop(blob /*::, length, opts*/ ) {
    blob.l += 4;
    return [
        0,
        0
    ];
}
/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */ var $3ee4f50b1ae43a89$var$PtgTypes = {
    /*::[*/ 0x01: {
        n: "PtgExp",
        f: $3ee4f50b1ae43a89$var$parse_PtgExp
    },
    /*::[*/ 0x02: {
        n: "PtgTbl",
        f: $3ee4f50b1ae43a89$var$parse_PtgTbl
    },
    /*::[*/ 0x03: {
        n: "PtgAdd",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x04: {
        n: "PtgSub",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x05: {
        n: "PtgMul",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x06: {
        n: "PtgDiv",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x07: {
        n: "PtgPower",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x08: {
        n: "PtgConcat",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x09: {
        n: "PtgLt",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x0A: {
        n: "PtgLe",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x0B: {
        n: "PtgEq",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x0C: {
        n: "PtgGe",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x0D: {
        n: "PtgGt",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x0E: {
        n: "PtgNe",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x0F: {
        n: "PtgIsect",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x10: {
        n: "PtgUnion",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x11: {
        n: "PtgRange",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x12: {
        n: "PtgUplus",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x13: {
        n: "PtgUminus",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x14: {
        n: "PtgPercent",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x15: {
        n: "PtgParen",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x16: {
        n: "PtgMissArg",
        f: $3ee4f50b1ae43a89$var$parseread1
    },
    /*::[*/ 0x17: {
        n: "PtgStr",
        f: $3ee4f50b1ae43a89$var$parse_PtgStr
    },
    /*::[*/ 0x1A: {
        n: "PtgSheet",
        f: $3ee4f50b1ae43a89$var$parse_PtgSheet
    },
    /*::[*/ 0x1B: {
        n: "PtgEndSheet",
        f: $3ee4f50b1ae43a89$var$parse_PtgEndSheet
    },
    /*::[*/ 0x1C: {
        n: "PtgErr",
        f: $3ee4f50b1ae43a89$var$parse_PtgErr
    },
    /*::[*/ 0x1D: {
        n: "PtgBool",
        f: $3ee4f50b1ae43a89$var$parse_PtgBool
    },
    /*::[*/ 0x1E: {
        n: "PtgInt",
        f: $3ee4f50b1ae43a89$var$parse_PtgInt
    },
    /*::[*/ 0x1F: {
        n: "PtgNum",
        f: $3ee4f50b1ae43a89$var$parse_PtgNum
    },
    /*::[*/ 0x20: {
        n: "PtgArray",
        f: $3ee4f50b1ae43a89$var$parse_PtgArray
    },
    /*::[*/ 0x21: {
        n: "PtgFunc",
        f: $3ee4f50b1ae43a89$var$parse_PtgFunc
    },
    /*::[*/ 0x22: {
        n: "PtgFuncVar",
        f: $3ee4f50b1ae43a89$var$parse_PtgFuncVar
    },
    /*::[*/ 0x23: {
        n: "PtgName",
        f: $3ee4f50b1ae43a89$var$parse_PtgName
    },
    /*::[*/ 0x24: {
        n: "PtgRef",
        f: $3ee4f50b1ae43a89$var$parse_PtgRef
    },
    /*::[*/ 0x25: {
        n: "PtgArea",
        f: $3ee4f50b1ae43a89$var$parse_PtgArea
    },
    /*::[*/ 0x26: {
        n: "PtgMemArea",
        f: $3ee4f50b1ae43a89$var$parse_PtgMemArea
    },
    /*::[*/ 0x27: {
        n: "PtgMemErr",
        f: $3ee4f50b1ae43a89$var$parse_PtgMemErr
    },
    /*::[*/ 0x28: {
        n: "PtgMemNoMem",
        f: $3ee4f50b1ae43a89$var$parse_PtgMemNoMem
    },
    /*::[*/ 0x29: {
        n: "PtgMemFunc",
        f: $3ee4f50b1ae43a89$var$parse_PtgMemFunc
    },
    /*::[*/ 0x2A: {
        n: "PtgRefErr",
        f: $3ee4f50b1ae43a89$var$parse_PtgRefErr
    },
    /*::[*/ 0x2B: {
        n: "PtgAreaErr",
        f: $3ee4f50b1ae43a89$var$parse_PtgAreaErr
    },
    /*::[*/ 0x2C: {
        n: "PtgRefN",
        f: $3ee4f50b1ae43a89$var$parse_PtgRefN
    },
    /*::[*/ 0x2D: {
        n: "PtgAreaN",
        f: $3ee4f50b1ae43a89$var$parse_PtgAreaN
    },
    /*::[*/ 0x2E: {
        n: "PtgMemAreaN",
        f: $3ee4f50b1ae43a89$var$parse_PtgMemAreaN
    },
    /*::[*/ 0x2F: {
        n: "PtgMemNoMemN",
        f: $3ee4f50b1ae43a89$var$parse_PtgMemNoMemN
    },
    /*::[*/ 0x39: {
        n: "PtgNameX",
        f: $3ee4f50b1ae43a89$var$parse_PtgNameX
    },
    /*::[*/ 0x3A: {
        n: "PtgRef3d",
        f: $3ee4f50b1ae43a89$var$parse_PtgRef3d
    },
    /*::[*/ 0x3B: {
        n: "PtgArea3d",
        f: $3ee4f50b1ae43a89$var$parse_PtgArea3d
    },
    /*::[*/ 0x3C: {
        n: "PtgRefErr3d",
        f: $3ee4f50b1ae43a89$var$parse_PtgRefErr3d
    },
    /*::[*/ 0x3D: {
        n: "PtgAreaErr3d",
        f: $3ee4f50b1ae43a89$var$parse_PtgAreaErr3d
    },
    /*::[*/ 0xFF: {}
};
/* These are duplicated in the PtgTypes table */ var $3ee4f50b1ae43a89$var$PtgDupes = {
    /*::[*/ 0x40: 0x20,
    /*::[*/ 0x60: 0x20,
    /*::[*/ 0x41: 0x21,
    /*::[*/ 0x61: 0x21,
    /*::[*/ 0x42: 0x22,
    /*::[*/ 0x62: 0x22,
    /*::[*/ 0x43: 0x23,
    /*::[*/ 0x63: 0x23,
    /*::[*/ 0x44: 0x24,
    /*::[*/ 0x64: 0x24,
    /*::[*/ 0x45: 0x25,
    /*::[*/ 0x65: 0x25,
    /*::[*/ 0x46: 0x26,
    /*::[*/ 0x66: 0x26,
    /*::[*/ 0x47: 0x27,
    /*::[*/ 0x67: 0x27,
    /*::[*/ 0x48: 0x28,
    /*::[*/ 0x68: 0x28,
    /*::[*/ 0x49: 0x29,
    /*::[*/ 0x69: 0x29,
    /*::[*/ 0x4A: 0x2A,
    /*::[*/ 0x6A: 0x2A,
    /*::[*/ 0x4B: 0x2B,
    /*::[*/ 0x6B: 0x2B,
    /*::[*/ 0x4C: 0x2C,
    /*::[*/ 0x6C: 0x2C,
    /*::[*/ 0x4D: 0x2D,
    /*::[*/ 0x6D: 0x2D,
    /*::[*/ 0x4E: 0x2E,
    /*::[*/ 0x6E: 0x2E,
    /*::[*/ 0x4F: 0x2F,
    /*::[*/ 0x6F: 0x2F,
    /*::[*/ 0x58: 0x22,
    /*::[*/ 0x78: 0x22,
    /*::[*/ 0x59: 0x39,
    /*::[*/ 0x79: 0x39,
    /*::[*/ 0x5A: 0x3A,
    /*::[*/ 0x7A: 0x3A,
    /*::[*/ 0x5B: 0x3B,
    /*::[*/ 0x7B: 0x3B,
    /*::[*/ 0x5C: 0x3C,
    /*::[*/ 0x7C: 0x3C,
    /*::[*/ 0x5D: 0x3D,
    /*::[*/ 0x7D: 0x3D
};
var $3ee4f50b1ae43a89$var$Ptg18 = {
    /*::[*/ 0x01: {
        n: "PtgElfLel",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfLel
    },
    /*::[*/ 0x02: {
        n: "PtgElfRw",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfRw
    },
    /*::[*/ 0x03: {
        n: "PtgElfCol",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfCol
    },
    /*::[*/ 0x06: {
        n: "PtgElfRwV",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfRwV
    },
    /*::[*/ 0x07: {
        n: "PtgElfColV",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfColV
    },
    /*::[*/ 0x0A: {
        n: "PtgElfRadical",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfRadical
    },
    /*::[*/ 0x0B: {
        n: "PtgElfRadicalS",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfRadicalS
    },
    /*::[*/ 0x0D: {
        n: "PtgElfColS",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfColS
    },
    /*::[*/ 0x0F: {
        n: "PtgElfColSV",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfColSV
    },
    /*::[*/ 0x10: {
        n: "PtgElfRadicalLel",
        f: $3ee4f50b1ae43a89$var$parse_PtgElfRadicalLel
    },
    /*::[*/ 0x19: {
        n: "PtgList",
        f: $3ee4f50b1ae43a89$var$parse_PtgList
    },
    /*::[*/ 0x1D: {
        n: "PtgSxName",
        f: $3ee4f50b1ae43a89$var$parse_PtgSxName
    },
    /*::[*/ 0xFF: {}
};
var $3ee4f50b1ae43a89$var$Ptg19 = {
    /*::[*/ 0x00: {
        n: "PtgAttrNoop",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrNoop
    },
    /*::[*/ 0x01: {
        n: "PtgAttrSemi",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrSemi
    },
    /*::[*/ 0x02: {
        n: "PtgAttrIf",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrIf
    },
    /*::[*/ 0x04: {
        n: "PtgAttrChoose",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrChoose
    },
    /*::[*/ 0x08: {
        n: "PtgAttrGoto",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrGoto
    },
    /*::[*/ 0x10: {
        n: "PtgAttrSum",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrSum
    },
    /*::[*/ 0x20: {
        n: "PtgAttrBaxcel",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrBaxcel
    },
    /*::[*/ 0x21: {
        n: "PtgAttrBaxcel",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrBaxcel
    },
    /*::[*/ 0x40: {
        n: "PtgAttrSpace",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrSpace
    },
    /*::[*/ 0x41: {
        n: "PtgAttrSpaceSemi",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrSpaceSemi
    },
    /*::[*/ 0x80: {
        n: "PtgAttrIfError",
        f: $3ee4f50b1ae43a89$var$parse_PtgAttrIfError
    },
    /*::[*/ 0xFF: {}
};
/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */ function $3ee4f50b1ae43a89$var$parse_RgbExtra(blob, length, rgce, opts) {
    if (opts.biff < 8) return $3ee4f50b1ae43a89$var$parsenoop(blob, length);
    var target = blob.l + length;
    var o = [];
    for(var i = 0; i !== rgce.length; ++i)switch(rgce[i][0]){
        case "PtgArray":
            /* PtgArray -> PtgExtraArray */ rgce[i][1] = $3ee4f50b1ae43a89$var$parse_PtgExtraArray(blob, 0, opts);
            o.push(rgce[i][1]);
            break;
        case "PtgMemArea":
            /* PtgMemArea -> PtgExtraMem */ rgce[i][2] = $3ee4f50b1ae43a89$var$parse_PtgExtraMem(blob, rgce[i][1], opts);
            o.push(rgce[i][2]);
            break;
        case "PtgExp":
            /* PtgExp -> PtgExtraCol */ if (opts && opts.biff == 12) {
                rgce[i][1][1] = blob.read_shift(4);
                o.push(rgce[i][1]);
            }
            break;
        case "PtgList":
        /* TODO: PtgList -> PtgExtraList */ case "PtgElfRadicalS":
        /* TODO: PtgElfRadicalS -> PtgExtraElf */ case "PtgElfColS":
        /* TODO: PtgElfColS -> PtgExtraElf */ case "PtgElfColSV":
            /* TODO: PtgElfColSV -> PtgExtraElf */ throw "Unsupported " + rgce[i][0];
        default:
            break;
    }
    length = target - blob.l;
    /* note: this is technically an error but Excel disregards */ //if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
    if (length !== 0) o.push($3ee4f50b1ae43a89$var$parsenoop(blob, length));
    return o;
}
/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */ function $3ee4f50b1ae43a89$var$parse_Rgce(blob, length, opts) {
    var target = blob.l + length;
    var R, id, ptgs = [];
    while(target != blob.l){
        length = target - blob.l;
        id = blob[blob.l];
        R = $3ee4f50b1ae43a89$var$PtgTypes[id] || $3ee4f50b1ae43a89$var$PtgTypes[$3ee4f50b1ae43a89$var$PtgDupes[id]];
        if (id === 0x18 || id === 0x19) R = (id === 0x18 ? $3ee4f50b1ae43a89$var$Ptg18 : $3ee4f50b1ae43a89$var$Ptg19)[blob[blob.l + 1]];
        if (!R || !R.f) $3ee4f50b1ae43a89$var$parsenoop(blob, length);
        else ptgs.push([
            R.n,
            R.f(blob, length, opts)
        ]);
    }
    return ptgs;
}
function $3ee4f50b1ae43a89$var$stringify_array(f /*:Array<Array<string>>*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < f.length; ++i){
        var x = f[i], r /*:Array<string>*/  = [];
        for(var j = 0; j < x.length; ++j){
            var y = x[j];
            if (y) switch(y[0]){
                // TODO: handle embedded quotes
                case 0x02:
                    /*:: if(typeof y[1] != 'string') throw "unreachable"; */ r.push('"' + y[1].replace(/"/g, '""') + '"');
                    break;
                default:
                    r.push(y[1]);
            }
            else r.push("");
        }
        o.push(r.join(","));
    }
    return o.join(";");
}
/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */ var $3ee4f50b1ae43a89$var$PtgBinOp = {
    PtgAdd: "+",
    PtgConcat: "&",
    PtgDiv: "/",
    PtgEq: "=",
    PtgGe: ">=",
    PtgGt: ">",
    PtgLe: "<=",
    PtgLt: "<",
    PtgMul: "*",
    PtgNe: "<>",
    PtgPower: "^",
    PtgSub: "-"
};
// List of invalid characters needs to be tested further
function $3ee4f50b1ae43a89$var$formula_quote_sheet_name(sname /*:string*/ , opts) /*:string*/ {
    if (!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
    if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname + "'";
    return sname;
}
function $3ee4f50b1ae43a89$var$get_ixti_raw(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    if (!supbooks) return "SH33TJSERR0";
    if (opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
    if (!supbooks.XTI) return "SH33TJSERR6";
    var XTI = supbooks.XTI[ixti];
    if (opts.biff < 8) {
        if (ixti > 10000) ixti -= 65536;
        if (ixti < 0) ixti = -ixti;
        return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
    }
    if (!XTI) return "SH33TJSERR1";
    var o = "";
    if (opts.biff > 8) switch(supbooks[XTI[0]][0]){
        case 0x0165:
            /* 'BrtSupSelf' */ o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x0166:
            /* 'BrtSupSame' */ if (opts.SID != null) return supbooks.SheetNames[opts.SID];
            return "SH33TJSSAME" + supbooks[XTI[0]][0];
        case 0x0163:
        /* 'BrtSupBookSrc' */ /* falls through */ default:
            return "SH33TJSSRC" + supbooks[XTI[0]][0];
    }
    switch(supbooks[XTI[0]][0][0]){
        case 0x0401:
            o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]] || "SH33TJSERR3";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x3A01:
            return supbooks[XTI[0]].slice(1).map(function(name) {
                return name.Name;
            }).join(";;"); //return "SH33TJSERR8";
        default:
            if (!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
            o = XTI[1] == -1 ? "#REF" : supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
    }
}
function $3ee4f50b1ae43a89$var$get_ixti(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    var ixtiraw = $3ee4f50b1ae43a89$var$get_ixti_raw(supbooks, ixti, opts);
    return ixtiraw == "#REF" ? ixtiraw : $3ee4f50b1ae43a89$var$formula_quote_sheet_name(ixtiraw, opts);
}
function $3ee4f50b1ae43a89$var$stringify_formula(formula /*Array<any>*/ , range, cell /*:any*/ , supbooks, opts) /*:string*/ {
    var biff = opts && opts.biff || 8;
    var _range = /*range != null ? range :*/ {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var stack /*:Array<string>*/  = [], e1, e2, /*::type,*/ c /*:CellAddress*/ , ixti = 0, nameidx = 0, r, sname = "";
    if (!formula[0] || !formula[0][0]) return "";
    var last_sp = -1, sp = "";
    for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff){
        var f = formula[0][ff];
        switch(f[0]){
            case "PtgUminus":
                /* [MS-XLS] 2.5.198.93 */ stack.push("-" + stack.pop());
                break;
            case "PtgUplus":
                /* [MS-XLS] 2.5.198.95 */ stack.push("+" + stack.pop());
                break;
            case "PtgPercent":
                /* [MS-XLS] 2.5.198.81 */ stack.push(stack.pop() + "%");
                break;
            case "PtgAdd":
            /* [MS-XLS] 2.5.198.26 */ case "PtgConcat":
            /* [MS-XLS] 2.5.198.43 */ case "PtgDiv":
            /* [MS-XLS] 2.5.198.45 */ case "PtgEq":
            /* [MS-XLS] 2.5.198.56 */ case "PtgGe":
            /* [MS-XLS] 2.5.198.64 */ case "PtgGt":
            /* [MS-XLS] 2.5.198.65 */ case "PtgLe":
            /* [MS-XLS] 2.5.198.68 */ case "PtgLt":
            /* [MS-XLS] 2.5.198.69 */ case "PtgMul":
            /* [MS-XLS] 2.5.198.75 */ case "PtgNe":
            /* [MS-XLS] 2.5.198.78 */ case "PtgPower":
            /* [MS-XLS] 2.5.198.82 */ case "PtgSub":
                /* [MS-XLS] 2.5.198.90 */ e1 = stack.pop();
                e2 = stack.pop();
                if (last_sp >= 0) {
                    switch(formula[0][last_sp][1][0]){
                        case 0:
                            // $FlowIgnore
                            sp = $3ee4f50b1ae43a89$var$fill(" ", formula[0][last_sp][1][1]);
                            break;
                        case 1:
                            // $FlowIgnore
                            sp = $3ee4f50b1ae43a89$var$fill("\r", formula[0][last_sp][1][1]);
                            break;
                        default:
                            sp = "";
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    e2 = e2 + sp;
                    last_sp = -1;
                }
                stack.push(e2 + $3ee4f50b1ae43a89$var$PtgBinOp[f[0]] + e1);
                break;
            case "PtgIsect":
                /* [MS-XLS] 2.5.198.67 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + " " + e1);
                break;
            case "PtgUnion":
                /* [MS-XLS] 2.5.198.94 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + "," + e1);
                break;
            case "PtgRange":
                /* [MS-XLS] 2.5.198.83 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + ":" + e1);
                break;
            case "PtgAttrChoose":
                break;
            case "PtgAttrGoto":
                break;
            case "PtgAttrIf":
                break;
            case "PtgAttrIfError":
                break;
            case "PtgRef":
                /* [MS-XLS] 2.5.198.84 */ /*::type = f[1][0]; */ c = $3ee4f50b1ae43a89$var$shift_cell_xls(f[1][1], _range, opts);
                stack.push($3ee4f50b1ae43a89$var$encode_cell_xls(c, biff));
                break;
            case "PtgRefN":
                /* [MS-XLS] 2.5.198.88 */ /*::type = f[1][0]; */ c = cell ? $3ee4f50b1ae43a89$var$shift_cell_xls(f[1][1], cell, opts) : f[1][1];
                stack.push($3ee4f50b1ae43a89$var$encode_cell_xls(c, biff));
                break;
            case "PtgRef3d":
                /* [MS-XLS] 2.5.198.85 */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                c = $3ee4f50b1ae43a89$var$shift_cell_xls(f[1][2], _range, opts);
                sname = $3ee4f50b1ae43a89$var$get_ixti(supbooks, ixti, opts);
                var w = sname; /* IE9 fails on defined names */  // eslint-disable-line no-unused-vars
                stack.push(sname + "!" + $3ee4f50b1ae43a89$var$encode_cell_xls(c, biff));
                break;
            case "PtgFunc":
            /* [MS-XLS] 2.5.198.62 */ case "PtgFuncVar":
                /* [MS-XLS] 2.5.198.63 */ /* f[1] = [argc, func, type] */ var argc /*:number*/  = f[1][0], func /*:string*/  = f[1][1];
                if (!argc) argc = 0;
                argc &= 0x7F;
                var args = argc == 0 ? [] : stack.slice(-argc);
                stack.length -= argc;
                if (func === "User") func = args.shift();
                stack.push(func + "(" + args.join(",") + ")");
                break;
            case "PtgBool":
                /* [MS-XLS] 2.5.198.42 */ stack.push(f[1] ? "TRUE" : "FALSE");
                break;
            case "PtgInt":
                /* [MS-XLS] 2.5.198.66 */ stack.push(/*::String(*/ f[1]);
                break;
            case "PtgNum":
                /* [MS-XLS] 2.5.198.79 TODO: precision? */ stack.push(String(f[1]));
                break;
            case "PtgStr":
                /* [MS-XLS] 2.5.198.89 */ // $FlowIgnore
                stack.push('"' + f[1].replace(/"/g, '""') + '"');
                break;
            case "PtgErr":
                /* [MS-XLS] 2.5.198.57 */ stack.push(/*::String(*/ f[1]);
                break;
            case "PtgAreaN":
                /* [MS-XLS] 2.5.198.31 TODO */ /*::type = f[1][0]; */ r = $3ee4f50b1ae43a89$var$shift_range_xls(f[1][1], cell ? {
                    s: cell
                } : _range, opts);
                stack.push($3ee4f50b1ae43a89$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case "PtgArea":
                /* [MS-XLS] 2.5.198.27 TODO: fixed points */ /*::type = f[1][0]; */ r = $3ee4f50b1ae43a89$var$shift_range_xls(f[1][1], _range, opts);
                stack.push($3ee4f50b1ae43a89$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case "PtgArea3d":
                /* [MS-XLS] 2.5.198.28 TODO */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                r = f[1][2];
                sname = $3ee4f50b1ae43a89$var$get_ixti(supbooks, ixti, opts);
                stack.push(sname + "!" + $3ee4f50b1ae43a89$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case "PtgAttrSum":
                /* [MS-XLS] 2.5.198.41 */ stack.push("SUM(" + stack.pop() + ")");
                break;
            case "PtgAttrBaxcel":
            /* [MS-XLS] 2.5.198.33 */ case "PtgAttrSemi":
                break;
            case "PtgName":
                /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */ /* f[1] = type, 0, nameindex */ nameidx = f[1][2];
                var lbl = (supbooks.names || [])[nameidx - 1] || (supbooks[0] || [])[nameidx];
                var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
                /* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */ if (name && name.slice(0, 6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
                stack.push(name);
                break;
            case "PtgNameX":
                /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */ /* f[1] = type, ixti, nameindex */ var bookidx /*:number*/  = f[1][1];
                nameidx = f[1][2];
                var externbook;
                /* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */ if (opts.biff <= 5) {
                    if (bookidx < 0) bookidx = -bookidx;
                    if (supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
                } else {
                    var o = "";
                    if (((supbooks[bookidx] || [])[0] || [])[0] == 0x3A01) ;
                    else if (((supbooks[bookidx] || [])[0] || [])[0] == 0x0401) {
                        if (supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab - 1] + "!";
                    } else o = supbooks.SheetNames[nameidx - 1] + "!";
                    if (supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
                    else if (supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
                    else {
                        var ixtidata = ($3ee4f50b1ae43a89$var$get_ixti_raw(supbooks, bookidx, opts) || "").split(";;");
                        if (ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
                        else o += "SH33TJSERRX";
                    }
                    stack.push(o);
                    break;
                }
                if (!externbook) externbook = {
                    Name: "SH33TJSERRY"
                };
                stack.push(externbook.Name);
                break;
            case "PtgParen":
                /* [MS-XLS] 2.5.198.80 */ var lp = "(", rp = ")";
                if (last_sp >= 0) {
                    sp = "";
                    switch(formula[0][last_sp][1][0]){
                        // $FlowIgnore
                        case 2:
                            lp = $3ee4f50b1ae43a89$var$fill(" ", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 3:
                            lp = $3ee4f50b1ae43a89$var$fill("\r", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 4:
                            rp = $3ee4f50b1ae43a89$var$fill(" ", formula[0][last_sp][1][1]) + rp;
                            break;
                        // $FlowIgnore
                        case 5:
                            rp = $3ee4f50b1ae43a89$var$fill("\r", formula[0][last_sp][1][1]) + rp;
                            break;
                        default:
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    last_sp = -1;
                }
                stack.push(lp + stack.pop() + rp);
                break;
            case "PtgRefErr":
                /* [MS-XLS] 2.5.198.86 */ stack.push("#REF!");
                break;
            case "PtgRefErr3d":
                /* [MS-XLS] 2.5.198.87 */ stack.push("#REF!");
                break;
            case "PtgExp":
                /* [MS-XLS] 2.5.198.58 TODO */ c = {
                    c: f[1][1],
                    r: f[1][0]
                };
                var q = {
                    c: cell.c,
                    r: cell.r
                } /*:any*/ ;
                if (supbooks.sharedf[$3ee4f50b1ae43a89$var$encode_cell(c)]) {
                    var parsedf = supbooks.sharedf[$3ee4f50b1ae43a89$var$encode_cell(c)];
                    stack.push($3ee4f50b1ae43a89$var$stringify_formula(parsedf, _range, q, supbooks, opts));
                } else {
                    var fnd = false;
                    for(e1 = 0; e1 != supbooks.arrayf.length; ++e1){
                        /* TODO: should be something like range_has */ e2 = supbooks.arrayf[e1];
                        if (c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
                        if (c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
                        stack.push($3ee4f50b1ae43a89$var$stringify_formula(e2[1], _range, q, supbooks, opts));
                        fnd = true;
                        break;
                    }
                    if (!fnd) stack.push(/*::String(*/ f[1]);
                }
                break;
            case "PtgArray":
                /* [MS-XLS] 2.5.198.32 TODO */ stack.push("{" + $3ee4f50b1ae43a89$var$stringify_array(/*::(*/ f[1]) + "}");
                break;
            case "PtgMemArea":
                break;
            case "PtgAttrSpace":
            /* [MS-XLS] 2.5.198.38 */ case "PtgAttrSpaceSemi":
                /* [MS-XLS] 2.5.198.39 */ last_sp = ff;
                break;
            case "PtgTbl":
                break;
            case "PtgMemErr":
                break;
            case "PtgMissArg":
                /* [MS-XLS] 2.5.198.74 */ stack.push("");
                break;
            case "PtgAreaErr":
                /* [MS-XLS] 2.5.198.29 */ stack.push("#REF!");
                break;
            case "PtgAreaErr3d":
                /* [MS-XLS] 2.5.198.30 */ stack.push("#REF!");
                break;
            case "PtgList":
                /* [MS-XLSB] 2.5.97.52 */ // $FlowIgnore
                stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
                break;
            case "PtgMemAreaN":
            case "PtgMemNoMemN":
            case "PtgAttrNoop":
            case "PtgSheet":
            case "PtgEndSheet":
                break;
            case "PtgMemFunc":
                break;
            case "PtgMemNoMem":
                break;
            case "PtgElfCol":
            /* [MS-XLS] 2.5.198.46 */ case "PtgElfColS":
            /* [MS-XLS] 2.5.198.47 */ case "PtgElfColSV":
            /* [MS-XLS] 2.5.198.48 */ case "PtgElfColV":
            /* [MS-XLS] 2.5.198.49 */ case "PtgElfLel":
            /* [MS-XLS] 2.5.198.50 */ case "PtgElfRadical":
            /* [MS-XLS] 2.5.198.51 */ case "PtgElfRadicalLel":
            /* [MS-XLS] 2.5.198.52 */ case "PtgElfRadicalS":
            /* [MS-XLS] 2.5.198.53 */ case "PtgElfRw":
            /* [MS-XLS] 2.5.198.54 */ case "PtgElfRwV":
                /* [MS-XLS] 2.5.198.55 */ throw new Error("Unsupported ELFs");
            case "PtgSxName":
                /* [MS-XLS] 2.5.198.91 TODO -- find a test case */ throw new Error("Unrecognized Formula Token: " + String(f));
            default:
                throw new Error("Unrecognized Formula Token: " + String(f));
        }
        var PtgNonDisp = [
            "PtgAttrSpace",
            "PtgAttrSpaceSemi",
            "PtgAttrGoto"
        ];
        if (opts.biff != 3) {
            if (last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
                f = formula[0][last_sp];
                var _left = true;
                switch(f[1][0]){
                    /* note: some bad XLSB files omit the PtgParen */ case 4:
                        _left = false;
                    /* falls through */ case 0:
                        // $FlowIgnore
                        sp = $3ee4f50b1ae43a89$var$fill(" ", f[1][1]);
                        break;
                    case 5:
                        _left = false;
                    /* falls through */ case 1:
                        // $FlowIgnore
                        sp = $3ee4f50b1ae43a89$var$fill("\r", f[1][1]);
                        break;
                    default:
                        sp = "";
                        // $FlowIgnore
                        if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
                }
                stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
                last_sp = -1;
            }
        }
    }
    if (stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
    return stack[0];
}
/* [MS-XLS] 2.5.198.1 TODO */ function $3ee4f50b1ae43a89$var$parse_ArrayParsedFormula(blob, length, opts /*::, ref*/ ) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $3ee4f50b1ae43a89$var$parsenoop(blob, length - 2)
    ];
    var rgce = $3ee4f50b1ae43a89$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $3ee4f50b1ae43a89$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.3 TODO */ function $3ee4f50b1ae43a89$var$parse_XLSCellParsedFormula(blob, length, opts) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $3ee4f50b1ae43a89$var$parsenoop(blob, length - 2)
    ];
    var rgce = $3ee4f50b1ae43a89$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $3ee4f50b1ae43a89$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.21 */ function $3ee4f50b1ae43a89$var$parse_NameParsedFormula(blob, length, opts, cce) {
    var target = blob.l + length;
    var rgce = $3ee4f50b1ae43a89$var$parse_Rgce(blob, cce, opts);
    var rgcb;
    if (target !== blob.l) rgcb = $3ee4f50b1ae43a89$var$parse_RgbExtra(blob, target - blob.l, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.118 TODO */ function $3ee4f50b1ae43a89$var$parse_SharedParsedFormula(blob, length, opts) {
    var target = blob.l + length;
    var rgcb, cce = blob.read_shift(2); // length of rgce
    var rgce = $3ee4f50b1ae43a89$var$parse_Rgce(blob, cce, opts);
    if (cce == 0xFFFF) return [
        [],
        $3ee4f50b1ae43a89$var$parsenoop(blob, length - 2)
    ];
    if (length !== cce + 2) rgcb = $3ee4f50b1ae43a89$var$parse_RgbExtra(blob, target - cce - 2, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */ function $3ee4f50b1ae43a89$var$parse_FormulaValue(blob /*::, length*/ ) {
    var b;
    if ($3ee4f50b1ae43a89$var$__readUInt16LE(blob, blob.l + 6) !== 0xFFFF) return [
        $3ee4f50b1ae43a89$var$parse_Xnum(blob),
        "n"
    ];
    switch(blob[blob.l]){
        case 0x00:
            blob.l += 8;
            return [
                "String",
                "s"
            ];
        case 0x01:
            b = blob[blob.l + 2] === 0x1;
            blob.l += 8;
            return [
                b,
                "b"
            ];
        case 0x02:
            b = blob[blob.l + 2];
            blob.l += 8;
            return [
                b,
                "e"
            ];
        case 0x03:
            blob.l += 8;
            return [
                "",
                "s"
            ];
    }
    return [];
}
function $3ee4f50b1ae43a89$var$write_FormulaValue(value) {
    if (value == null) {
        // Blank String Value
        var o = $3ee4f50b1ae43a89$var$new_buf(8);
        o.write_shift(1, 0x03);
        o.write_shift(1, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0xFFFF);
        return o;
    } else if (typeof value == "number") return $3ee4f50b1ae43a89$var$write_Xnum(value);
    return $3ee4f50b1ae43a89$var$write_Xnum(0);
}
/* [MS-XLS] 2.4.127 TODO */ function $3ee4f50b1ae43a89$var$parse_Formula(blob, length, opts) {
    var end = blob.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSCell(blob, 6);
    if (opts.biff == 2) ++blob.l;
    var val = $3ee4f50b1ae43a89$var$parse_FormulaValue(blob, 8);
    var flags = blob.read_shift(1);
    if (opts.biff != 2) {
        blob.read_shift(1);
        if (opts.biff >= 5) /*var chn = */ blob.read_shift(4);
    }
    var cbf = $3ee4f50b1ae43a89$var$parse_XLSCellParsedFormula(blob, end - blob.l, opts);
    return {
        cell: cell,
        val: val[0],
        formula: cbf,
        shared: flags >> 3 & 1,
        tt: val[1]
    };
}
function $3ee4f50b1ae43a89$var$write_Formula(cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, os /*:number*/ ) {
    // Cell
    var o1 = $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os);
    // FormulaValue
    var o2 = $3ee4f50b1ae43a89$var$write_FormulaValue(cell.v);
    // flags + cache
    var o3 = $3ee4f50b1ae43a89$var$new_buf(6);
    var flags = 33;
    o3.write_shift(2, flags);
    o3.write_shift(4, 0);
    // CellParsedFormula
    var bf = $3ee4f50b1ae43a89$var$new_buf(cell.bf.length);
    for(var i = 0; i < cell.bf.length; ++i)bf[i] = cell.bf[i];
    var out = $3ee4f50b1ae43a89$var$bconcat([
        o1,
        o2,
        o3,
        bf
    ]);
    return out;
}
/* XLSB Parsed Formula records have the same shape */ function $3ee4f50b1ae43a89$var$parse_XLSBParsedFormula(data, length, opts) {
    var cce = data.read_shift(4);
    var rgce = $3ee4f50b1ae43a89$var$parse_Rgce(data, cce, opts);
    var cb = data.read_shift(4);
    var rgcb = cb > 0 ? $3ee4f50b1ae43a89$var$parse_RgbExtra(data, cb, rgce, opts) : null;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */ var $3ee4f50b1ae43a89$var$parse_XLSBArrayParsedFormula = $3ee4f50b1ae43a89$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */ var $3ee4f50b1ae43a89$var$parse_XLSBCellParsedFormula = $3ee4f50b1ae43a89$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.8 DVParsedFormula */ //var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */ //var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */ var $3ee4f50b1ae43a89$var$parse_XLSBNameParsedFormula = $3ee4f50b1ae43a89$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */ var $3ee4f50b1ae43a89$var$parse_XLSBSharedParsedFormula = $3ee4f50b1ae43a89$var$parse_XLSBParsedFormula;
var $3ee4f50b1ae43a89$var$Cetab = {
    0: "BEEP",
    1: "OPEN",
    2: "OPEN.LINKS",
    3: "CLOSE.ALL",
    4: "SAVE",
    5: "SAVE.AS",
    6: "FILE.DELETE",
    7: "PAGE.SETUP",
    8: "PRINT",
    9: "PRINTER.SETUP",
    10: "QUIT",
    11: "NEW.WINDOW",
    12: "ARRANGE.ALL",
    13: "WINDOW.SIZE",
    14: "WINDOW.MOVE",
    15: "FULL",
    16: "CLOSE",
    17: "RUN",
    22: "SET.PRINT.AREA",
    23: "SET.PRINT.TITLES",
    24: "SET.PAGE.BREAK",
    25: "REMOVE.PAGE.BREAK",
    26: "FONT",
    27: "DISPLAY",
    28: "PROTECT.DOCUMENT",
    29: "PRECISION",
    30: "A1.R1C1",
    31: "CALCULATE.NOW",
    32: "CALCULATION",
    34: "DATA.FIND",
    35: "EXTRACT",
    36: "DATA.DELETE",
    37: "SET.DATABASE",
    38: "SET.CRITERIA",
    39: "SORT",
    40: "DATA.SERIES",
    41: "TABLE",
    42: "FORMAT.NUMBER",
    43: "ALIGNMENT",
    44: "STYLE",
    45: "BORDER",
    46: "CELL.PROTECTION",
    47: "COLUMN.WIDTH",
    48: "UNDO",
    49: "CUT",
    50: "COPY",
    51: "PASTE",
    52: "CLEAR",
    53: "PASTE.SPECIAL",
    54: "EDIT.DELETE",
    55: "INSERT",
    56: "FILL.RIGHT",
    57: "FILL.DOWN",
    61: "DEFINE.NAME",
    62: "CREATE.NAMES",
    63: "FORMULA.GOTO",
    64: "FORMULA.FIND",
    65: "SELECT.LAST.CELL",
    66: "SHOW.ACTIVE.CELL",
    67: "GALLERY.AREA",
    68: "GALLERY.BAR",
    69: "GALLERY.COLUMN",
    70: "GALLERY.LINE",
    71: "GALLERY.PIE",
    72: "GALLERY.SCATTER",
    73: "COMBINATION",
    74: "PREFERRED",
    75: "ADD.OVERLAY",
    76: "GRIDLINES",
    77: "SET.PREFERRED",
    78: "AXES",
    79: "LEGEND",
    80: "ATTACH.TEXT",
    81: "ADD.ARROW",
    82: "SELECT.CHART",
    83: "SELECT.PLOT.AREA",
    84: "PATTERNS",
    85: "MAIN.CHART",
    86: "OVERLAY",
    87: "SCALE",
    88: "FORMAT.LEGEND",
    89: "FORMAT.TEXT",
    90: "EDIT.REPEAT",
    91: "PARSE",
    92: "JUSTIFY",
    93: "HIDE",
    94: "UNHIDE",
    95: "WORKSPACE",
    96: "FORMULA",
    97: "FORMULA.FILL",
    98: "FORMULA.ARRAY",
    99: "DATA.FIND.NEXT",
    100: "DATA.FIND.PREV",
    101: "FORMULA.FIND.NEXT",
    102: "FORMULA.FIND.PREV",
    103: "ACTIVATE",
    104: "ACTIVATE.NEXT",
    105: "ACTIVATE.PREV",
    106: "UNLOCKED.NEXT",
    107: "UNLOCKED.PREV",
    108: "COPY.PICTURE",
    109: "SELECT",
    110: "DELETE.NAME",
    111: "DELETE.FORMAT",
    112: "VLINE",
    113: "HLINE",
    114: "VPAGE",
    115: "HPAGE",
    116: "VSCROLL",
    117: "HSCROLL",
    118: "ALERT",
    119: "NEW",
    120: "CANCEL.COPY",
    121: "SHOW.CLIPBOARD",
    122: "MESSAGE",
    124: "PASTE.LINK",
    125: "APP.ACTIVATE",
    126: "DELETE.ARROW",
    127: "ROW.HEIGHT",
    128: "FORMAT.MOVE",
    129: "FORMAT.SIZE",
    130: "FORMULA.REPLACE",
    131: "SEND.KEYS",
    132: "SELECT.SPECIAL",
    133: "APPLY.NAMES",
    134: "REPLACE.FONT",
    135: "FREEZE.PANES",
    136: "SHOW.INFO",
    137: "SPLIT",
    138: "ON.WINDOW",
    139: "ON.DATA",
    140: "DISABLE.INPUT",
    142: "OUTLINE",
    143: "LIST.NAMES",
    144: "FILE.CLOSE",
    145: "SAVE.WORKBOOK",
    146: "DATA.FORM",
    147: "COPY.CHART",
    148: "ON.TIME",
    149: "WAIT",
    150: "FORMAT.FONT",
    151: "FILL.UP",
    152: "FILL.LEFT",
    153: "DELETE.OVERLAY",
    155: "SHORT.MENUS",
    159: "SET.UPDATE.STATUS",
    161: "COLOR.PALETTE",
    162: "DELETE.STYLE",
    163: "WINDOW.RESTORE",
    164: "WINDOW.MAXIMIZE",
    166: "CHANGE.LINK",
    167: "CALCULATE.DOCUMENT",
    168: "ON.KEY",
    169: "APP.RESTORE",
    170: "APP.MOVE",
    171: "APP.SIZE",
    172: "APP.MINIMIZE",
    173: "APP.MAXIMIZE",
    174: "BRING.TO.FRONT",
    175: "SEND.TO.BACK",
    185: "MAIN.CHART.TYPE",
    186: "OVERLAY.CHART.TYPE",
    187: "SELECT.END",
    188: "OPEN.MAIL",
    189: "SEND.MAIL",
    190: "STANDARD.FONT",
    191: "CONSOLIDATE",
    192: "SORT.SPECIAL",
    193: "GALLERY.3D.AREA",
    194: "GALLERY.3D.COLUMN",
    195: "GALLERY.3D.LINE",
    196: "GALLERY.3D.PIE",
    197: "VIEW.3D",
    198: "GOAL.SEEK",
    199: "WORKGROUP",
    200: "FILL.GROUP",
    201: "UPDATE.LINK",
    202: "PROMOTE",
    203: "DEMOTE",
    204: "SHOW.DETAIL",
    206: "UNGROUP",
    207: "OBJECT.PROPERTIES",
    208: "SAVE.NEW.OBJECT",
    209: "SHARE",
    210: "SHARE.NAME",
    211: "DUPLICATE",
    212: "APPLY.STYLE",
    213: "ASSIGN.TO.OBJECT",
    214: "OBJECT.PROTECTION",
    215: "HIDE.OBJECT",
    216: "SET.EXTRACT",
    217: "CREATE.PUBLISHER",
    218: "SUBSCRIBE.TO",
    219: "ATTRIBUTES",
    220: "SHOW.TOOLBAR",
    222: "PRINT.PREVIEW",
    223: "EDIT.COLOR",
    224: "SHOW.LEVELS",
    225: "FORMAT.MAIN",
    226: "FORMAT.OVERLAY",
    227: "ON.RECALC",
    228: "EDIT.SERIES",
    229: "DEFINE.STYLE",
    240: "LINE.PRINT",
    243: "ENTER.DATA",
    249: "GALLERY.RADAR",
    250: "MERGE.STYLES",
    251: "EDITION.OPTIONS",
    252: "PASTE.PICTURE",
    253: "PASTE.PICTURE.LINK",
    254: "SPELLING",
    256: "ZOOM",
    259: "INSERT.OBJECT",
    260: "WINDOW.MINIMIZE",
    265: "SOUND.NOTE",
    266: "SOUND.PLAY",
    267: "FORMAT.SHAPE",
    268: "EXTEND.POLYGON",
    269: "FORMAT.AUTO",
    272: "GALLERY.3D.BAR",
    273: "GALLERY.3D.SURFACE",
    274: "FILL.AUTO",
    276: "CUSTOMIZE.TOOLBAR",
    277: "ADD.TOOL",
    278: "EDIT.OBJECT",
    279: "ON.DOUBLECLICK",
    280: "ON.ENTRY",
    281: "WORKBOOK.ADD",
    282: "WORKBOOK.MOVE",
    283: "WORKBOOK.COPY",
    284: "WORKBOOK.OPTIONS",
    285: "SAVE.WORKSPACE",
    288: "CHART.WIZARD",
    289: "DELETE.TOOL",
    290: "MOVE.TOOL",
    291: "WORKBOOK.SELECT",
    292: "WORKBOOK.ACTIVATE",
    293: "ASSIGN.TO.TOOL",
    295: "COPY.TOOL",
    296: "RESET.TOOL",
    297: "CONSTRAIN.NUMERIC",
    298: "PASTE.TOOL",
    302: "WORKBOOK.NEW",
    305: "SCENARIO.CELLS",
    306: "SCENARIO.DELETE",
    307: "SCENARIO.ADD",
    308: "SCENARIO.EDIT",
    309: "SCENARIO.SHOW",
    310: "SCENARIO.SHOW.NEXT",
    311: "SCENARIO.SUMMARY",
    312: "PIVOT.TABLE.WIZARD",
    313: "PIVOT.FIELD.PROPERTIES",
    314: "PIVOT.FIELD",
    315: "PIVOT.ITEM",
    316: "PIVOT.ADD.FIELDS",
    318: "OPTIONS.CALCULATION",
    319: "OPTIONS.EDIT",
    320: "OPTIONS.VIEW",
    321: "ADDIN.MANAGER",
    322: "MENU.EDITOR",
    323: "ATTACH.TOOLBARS",
    324: "VBAActivate",
    325: "OPTIONS.CHART",
    328: "VBA.INSERT.FILE",
    330: "VBA.PROCEDURE.DEFINITION",
    336: "ROUTING.SLIP",
    338: "ROUTE.DOCUMENT",
    339: "MAIL.LOGON",
    342: "INSERT.PICTURE",
    343: "EDIT.TOOL",
    344: "GALLERY.DOUGHNUT",
    350: "CHART.TREND",
    352: "PIVOT.ITEM.PROPERTIES",
    354: "WORKBOOK.INSERT",
    355: "OPTIONS.TRANSITION",
    356: "OPTIONS.GENERAL",
    370: "FILTER.ADVANCED",
    373: "MAIL.ADD.MAILER",
    374: "MAIL.DELETE.MAILER",
    375: "MAIL.REPLY",
    376: "MAIL.REPLY.ALL",
    377: "MAIL.FORWARD",
    378: "MAIL.NEXT.LETTER",
    379: "DATA.LABEL",
    380: "INSERT.TITLE",
    381: "FONT.PROPERTIES",
    382: "MACRO.OPTIONS",
    383: "WORKBOOK.HIDE",
    384: "WORKBOOK.UNHIDE",
    385: "WORKBOOK.DELETE",
    386: "WORKBOOK.NAME",
    388: "GALLERY.CUSTOM",
    390: "ADD.CHART.AUTOFORMAT",
    391: "DELETE.CHART.AUTOFORMAT",
    392: "CHART.ADD.DATA",
    393: "AUTO.OUTLINE",
    394: "TAB.ORDER",
    395: "SHOW.DIALOG",
    396: "SELECT.ALL",
    397: "UNGROUP.SHEETS",
    398: "SUBTOTAL.CREATE",
    399: "SUBTOTAL.REMOVE",
    400: "RENAME.OBJECT",
    412: "WORKBOOK.SCROLL",
    413: "WORKBOOK.NEXT",
    414: "WORKBOOK.PREV",
    415: "WORKBOOK.TAB.SPLIT",
    416: "FULL.SCREEN",
    417: "WORKBOOK.PROTECT",
    420: "SCROLLBAR.PROPERTIES",
    421: "PIVOT.SHOW.PAGES",
    422: "TEXT.TO.COLUMNS",
    423: "FORMAT.CHARTTYPE",
    424: "LINK.FORMAT",
    425: "TRACER.DISPLAY",
    430: "TRACER.NAVIGATE",
    431: "TRACER.CLEAR",
    432: "TRACER.ERROR",
    433: "PIVOT.FIELD.GROUP",
    434: "PIVOT.FIELD.UNGROUP",
    435: "CHECKBOX.PROPERTIES",
    436: "LABEL.PROPERTIES",
    437: "LISTBOX.PROPERTIES",
    438: "EDITBOX.PROPERTIES",
    439: "PIVOT.REFRESH",
    440: "LINK.COMBO",
    441: "OPEN.TEXT",
    442: "HIDE.DIALOG",
    443: "SET.DIALOG.FOCUS",
    444: "ENABLE.OBJECT",
    445: "PUSHBUTTON.PROPERTIES",
    446: "SET.DIALOG.DEFAULT",
    447: "FILTER",
    448: "FILTER.SHOW.ALL",
    449: "CLEAR.OUTLINE",
    450: "FUNCTION.WIZARD",
    451: "ADD.LIST.ITEM",
    452: "SET.LIST.ITEM",
    453: "REMOVE.LIST.ITEM",
    454: "SELECT.LIST.ITEM",
    455: "SET.CONTROL.VALUE",
    456: "SAVE.COPY.AS",
    458: "OPTIONS.LISTS.ADD",
    459: "OPTIONS.LISTS.DELETE",
    460: "SERIES.AXES",
    461: "SERIES.X",
    462: "SERIES.Y",
    463: "ERRORBAR.X",
    464: "ERRORBAR.Y",
    465: "FORMAT.CHART",
    466: "SERIES.ORDER",
    467: "MAIL.LOGOFF",
    468: "CLEAR.ROUTING.SLIP",
    469: "APP.ACTIVATE.MICROSOFT",
    470: "MAIL.EDIT.MAILER",
    471: "ON.SHEET",
    472: "STANDARD.WIDTH",
    473: "SCENARIO.MERGE",
    474: "SUMMARY.INFO",
    475: "FIND.FILE",
    476: "ACTIVE.CELL.FONT",
    477: "ENABLE.TIPWIZARD",
    478: "VBA.MAKE.ADDIN",
    480: "INSERTDATATABLE",
    481: "WORKGROUP.OPTIONS",
    482: "MAIL.SEND.MAILER",
    485: "AUTOCORRECT",
    489: "POST.DOCUMENT",
    491: "PICKLIST",
    493: "VIEW.SHOW",
    494: "VIEW.DEFINE",
    495: "VIEW.DELETE",
    509: "SHEET.BACKGROUND",
    510: "INSERT.MAP.OBJECT",
    511: "OPTIONS.MENONO",
    517: "MSOCHECKS",
    518: "NORMAL",
    519: "LAYOUT",
    520: "RM.PRINT.AREA",
    521: "CLEAR.PRINT.AREA",
    522: "ADD.PRINT.AREA",
    523: "MOVE.BRK",
    545: "HIDECURR.NOTE",
    546: "HIDEALL.NOTES",
    547: "DELETE.NOTE",
    548: "TRAVERSE.NOTES",
    549: "ACTIVATE.NOTES",
    620: "PROTECT.REVISIONS",
    621: "UNPROTECT.REVISIONS",
    647: "OPTIONS.ME",
    653: "WEB.PUBLISH",
    667: "NEWWEBQUERY",
    673: "PIVOT.TABLE.CHART",
    753: "OPTIONS.SAVE",
    755: "OPTIONS.SPELL",
    808: "HIDEALL.INKANNOTS"
};
var $3ee4f50b1ae43a89$var$Ftab = {
    0: "COUNT",
    1: "IF",
    2: "ISNA",
    3: "ISERROR",
    4: "SUM",
    5: "AVERAGE",
    6: "MIN",
    7: "MAX",
    8: "ROW",
    9: "COLUMN",
    10: "NA",
    11: "NPV",
    12: "STDEV",
    13: "DOLLAR",
    14: "FIXED",
    15: "SIN",
    16: "COS",
    17: "TAN",
    18: "ATAN",
    19: "PI",
    20: "SQRT",
    21: "EXP",
    22: "LN",
    23: "LOG10",
    24: "ABS",
    25: "INT",
    26: "SIGN",
    27: "ROUND",
    28: "LOOKUP",
    29: "INDEX",
    30: "REPT",
    31: "MID",
    32: "LEN",
    33: "VALUE",
    34: "TRUE",
    35: "FALSE",
    36: "AND",
    37: "OR",
    38: "NOT",
    39: "MOD",
    40: "DCOUNT",
    41: "DSUM",
    42: "DAVERAGE",
    43: "DMIN",
    44: "DMAX",
    45: "DSTDEV",
    46: "VAR",
    47: "DVAR",
    48: "TEXT",
    49: "LINEST",
    50: "TREND",
    51: "LOGEST",
    52: "GROWTH",
    53: "GOTO",
    54: "HALT",
    55: "RETURN",
    56: "PV",
    57: "FV",
    58: "NPER",
    59: "PMT",
    60: "RATE",
    61: "MIRR",
    62: "IRR",
    63: "RAND",
    64: "MATCH",
    65: "DATE",
    66: "TIME",
    67: "DAY",
    68: "MONTH",
    69: "YEAR",
    70: "WEEKDAY",
    71: "HOUR",
    72: "MINUTE",
    73: "SECOND",
    74: "NOW",
    75: "AREAS",
    76: "ROWS",
    77: "COLUMNS",
    78: "OFFSET",
    79: "ABSREF",
    80: "RELREF",
    81: "ARGUMENT",
    82: "SEARCH",
    83: "TRANSPOSE",
    84: "ERROR",
    85: "STEP",
    86: "TYPE",
    87: "ECHO",
    88: "SET.NAME",
    89: "CALLER",
    90: "DEREF",
    91: "WINDOWS",
    92: "SERIES",
    93: "DOCUMENTS",
    94: "ACTIVE.CELL",
    95: "SELECTION",
    96: "RESULT",
    97: "ATAN2",
    98: "ASIN",
    99: "ACOS",
    100: "CHOOSE",
    101: "HLOOKUP",
    102: "VLOOKUP",
    103: "LINKS",
    104: "INPUT",
    105: "ISREF",
    106: "GET.FORMULA",
    107: "GET.NAME",
    108: "SET.VALUE",
    109: "LOG",
    110: "EXEC",
    111: "CHAR",
    112: "LOWER",
    113: "UPPER",
    114: "PROPER",
    115: "LEFT",
    116: "RIGHT",
    117: "EXACT",
    118: "TRIM",
    119: "REPLACE",
    120: "SUBSTITUTE",
    121: "CODE",
    122: "NAMES",
    123: "DIRECTORY",
    124: "FIND",
    125: "CELL",
    126: "ISERR",
    127: "ISTEXT",
    128: "ISNUMBER",
    129: "ISBLANK",
    130: "T",
    131: "N",
    132: "FOPEN",
    133: "FCLOSE",
    134: "FSIZE",
    135: "FREADLN",
    136: "FREAD",
    137: "FWRITELN",
    138: "FWRITE",
    139: "FPOS",
    140: "DATEVALUE",
    141: "TIMEVALUE",
    142: "SLN",
    143: "SYD",
    144: "DDB",
    145: "GET.DEF",
    146: "REFTEXT",
    147: "TEXTREF",
    148: "INDIRECT",
    149: "REGISTER",
    150: "CALL",
    151: "ADD.BAR",
    152: "ADD.MENU",
    153: "ADD.COMMAND",
    154: "ENABLE.COMMAND",
    155: "CHECK.COMMAND",
    156: "RENAME.COMMAND",
    157: "SHOW.BAR",
    158: "DELETE.MENU",
    159: "DELETE.COMMAND",
    160: "GET.CHART.ITEM",
    161: "DIALOG.BOX",
    162: "CLEAN",
    163: "MDETERM",
    164: "MINVERSE",
    165: "MMULT",
    166: "FILES",
    167: "IPMT",
    168: "PPMT",
    169: "COUNTA",
    170: "CANCEL.KEY",
    171: "FOR",
    172: "WHILE",
    173: "BREAK",
    174: "NEXT",
    175: "INITIATE",
    176: "REQUEST",
    177: "POKE",
    178: "EXECUTE",
    179: "TERMINATE",
    180: "RESTART",
    181: "HELP",
    182: "GET.BAR",
    183: "PRODUCT",
    184: "FACT",
    185: "GET.CELL",
    186: "GET.WORKSPACE",
    187: "GET.WINDOW",
    188: "GET.DOCUMENT",
    189: "DPRODUCT",
    190: "ISNONTEXT",
    191: "GET.NOTE",
    192: "NOTE",
    193: "STDEVP",
    194: "VARP",
    195: "DSTDEVP",
    196: "DVARP",
    197: "TRUNC",
    198: "ISLOGICAL",
    199: "DCOUNTA",
    200: "DELETE.BAR",
    201: "UNREGISTER",
    204: "USDOLLAR",
    205: "FINDB",
    206: "SEARCHB",
    207: "REPLACEB",
    208: "LEFTB",
    209: "RIGHTB",
    210: "MIDB",
    211: "LENB",
    212: "ROUNDUP",
    213: "ROUNDDOWN",
    214: "ASC",
    215: "DBCS",
    216: "RANK",
    219: "ADDRESS",
    220: "DAYS360",
    221: "TODAY",
    222: "VDB",
    223: "ELSE",
    224: "ELSE.IF",
    225: "END.IF",
    226: "FOR.CELL",
    227: "MEDIAN",
    228: "SUMPRODUCT",
    229: "SINH",
    230: "COSH",
    231: "TANH",
    232: "ASINH",
    233: "ACOSH",
    234: "ATANH",
    235: "DGET",
    236: "CREATE.OBJECT",
    237: "VOLATILE",
    238: "LAST.ERROR",
    239: "CUSTOM.UNDO",
    240: "CUSTOM.REPEAT",
    241: "FORMULA.CONVERT",
    242: "GET.LINK.INFO",
    243: "TEXT.BOX",
    244: "INFO",
    245: "GROUP",
    246: "GET.OBJECT",
    247: "DB",
    248: "PAUSE",
    251: "RESUME",
    252: "FREQUENCY",
    253: "ADD.TOOLBAR",
    254: "DELETE.TOOLBAR",
    255: "User",
    256: "RESET.TOOLBAR",
    257: "EVALUATE",
    258: "GET.TOOLBAR",
    259: "GET.TOOL",
    260: "SPELLING.CHECK",
    261: "ERROR.TYPE",
    262: "APP.TITLE",
    263: "WINDOW.TITLE",
    264: "SAVE.TOOLBAR",
    265: "ENABLE.TOOL",
    266: "PRESS.TOOL",
    267: "REGISTER.ID",
    268: "GET.WORKBOOK",
    269: "AVEDEV",
    270: "BETADIST",
    271: "GAMMALN",
    272: "BETAINV",
    273: "BINOMDIST",
    274: "CHIDIST",
    275: "CHIINV",
    276: "COMBIN",
    277: "CONFIDENCE",
    278: "CRITBINOM",
    279: "EVEN",
    280: "EXPONDIST",
    281: "FDIST",
    282: "FINV",
    283: "FISHER",
    284: "FISHERINV",
    285: "FLOOR",
    286: "GAMMADIST",
    287: "GAMMAINV",
    288: "CEILING",
    289: "HYPGEOMDIST",
    290: "LOGNORMDIST",
    291: "LOGINV",
    292: "NEGBINOMDIST",
    293: "NORMDIST",
    294: "NORMSDIST",
    295: "NORMINV",
    296: "NORMSINV",
    297: "STANDARDIZE",
    298: "ODD",
    299: "PERMUT",
    300: "POISSON",
    301: "TDIST",
    302: "WEIBULL",
    303: "SUMXMY2",
    304: "SUMX2MY2",
    305: "SUMX2PY2",
    306: "CHITEST",
    307: "CORREL",
    308: "COVAR",
    309: "FORECAST",
    310: "FTEST",
    311: "INTERCEPT",
    312: "PEARSON",
    313: "RSQ",
    314: "STEYX",
    315: "SLOPE",
    316: "TTEST",
    317: "PROB",
    318: "DEVSQ",
    319: "GEOMEAN",
    320: "HARMEAN",
    321: "SUMSQ",
    322: "KURT",
    323: "SKEW",
    324: "ZTEST",
    325: "LARGE",
    326: "SMALL",
    327: "QUARTILE",
    328: "PERCENTILE",
    329: "PERCENTRANK",
    330: "MODE",
    331: "TRIMMEAN",
    332: "TINV",
    334: "MOVIE.COMMAND",
    335: "GET.MOVIE",
    336: "CONCATENATE",
    337: "POWER",
    338: "PIVOT.ADD.DATA",
    339: "GET.PIVOT.TABLE",
    340: "GET.PIVOT.FIELD",
    341: "GET.PIVOT.ITEM",
    342: "RADIANS",
    343: "DEGREES",
    344: "SUBTOTAL",
    345: "SUMIF",
    346: "COUNTIF",
    347: "COUNTBLANK",
    348: "SCENARIO.GET",
    349: "OPTIONS.LISTS.GET",
    350: "ISPMT",
    351: "DATEDIF",
    352: "DATESTRING",
    353: "NUMBERSTRING",
    354: "ROMAN",
    355: "OPEN.DIALOG",
    356: "SAVE.DIALOG",
    357: "VIEW.GET",
    358: "GETPIVOTDATA",
    359: "HYPERLINK",
    360: "PHONETIC",
    361: "AVERAGEA",
    362: "MAXA",
    363: "MINA",
    364: "STDEVPA",
    365: "VARPA",
    366: "STDEVA",
    367: "VARA",
    368: "BAHTTEXT",
    369: "THAIDAYOFWEEK",
    370: "THAIDIGIT",
    371: "THAIMONTHOFYEAR",
    372: "THAINUMSOUND",
    373: "THAINUMSTRING",
    374: "THAISTRINGLENGTH",
    375: "ISTHAIDIGIT",
    376: "ROUNDBAHTDOWN",
    377: "ROUNDBAHTUP",
    378: "THAIYEAR",
    379: "RTD",
    380: "CUBEVALUE",
    381: "CUBEMEMBER",
    382: "CUBEMEMBERPROPERTY",
    383: "CUBERANKEDMEMBER",
    384: "HEX2BIN",
    385: "HEX2DEC",
    386: "HEX2OCT",
    387: "DEC2BIN",
    388: "DEC2HEX",
    389: "DEC2OCT",
    390: "OCT2BIN",
    391: "OCT2HEX",
    392: "OCT2DEC",
    393: "BIN2DEC",
    394: "BIN2OCT",
    395: "BIN2HEX",
    396: "IMSUB",
    397: "IMDIV",
    398: "IMPOWER",
    399: "IMABS",
    400: "IMSQRT",
    401: "IMLN",
    402: "IMLOG2",
    403: "IMLOG10",
    404: "IMSIN",
    405: "IMCOS",
    406: "IMEXP",
    407: "IMARGUMENT",
    408: "IMCONJUGATE",
    409: "IMAGINARY",
    410: "IMREAL",
    411: "COMPLEX",
    412: "IMSUM",
    413: "IMPRODUCT",
    414: "SERIESSUM",
    415: "FACTDOUBLE",
    416: "SQRTPI",
    417: "QUOTIENT",
    418: "DELTA",
    419: "GESTEP",
    420: "ISEVEN",
    421: "ISODD",
    422: "MROUND",
    423: "ERF",
    424: "ERFC",
    425: "BESSELJ",
    426: "BESSELK",
    427: "BESSELY",
    428: "BESSELI",
    429: "XIRR",
    430: "XNPV",
    431: "PRICEMAT",
    432: "YIELDMAT",
    433: "INTRATE",
    434: "RECEIVED",
    435: "DISC",
    436: "PRICEDISC",
    437: "YIELDDISC",
    438: "TBILLEQ",
    439: "TBILLPRICE",
    440: "TBILLYIELD",
    441: "PRICE",
    442: "YIELD",
    443: "DOLLARDE",
    444: "DOLLARFR",
    445: "NOMINAL",
    446: "EFFECT",
    447: "CUMPRINC",
    448: "CUMIPMT",
    449: "EDATE",
    450: "EOMONTH",
    451: "YEARFRAC",
    452: "COUPDAYBS",
    453: "COUPDAYS",
    454: "COUPDAYSNC",
    455: "COUPNCD",
    456: "COUPNUM",
    457: "COUPPCD",
    458: "DURATION",
    459: "MDURATION",
    460: "ODDLPRICE",
    461: "ODDLYIELD",
    462: "ODDFPRICE",
    463: "ODDFYIELD",
    464: "RANDBETWEEN",
    465: "WEEKNUM",
    466: "AMORDEGRC",
    467: "AMORLINC",
    468: "CONVERT",
    724: "SHEETJS",
    469: "ACCRINT",
    470: "ACCRINTM",
    471: "WORKDAY",
    472: "NETWORKDAYS",
    473: "GCD",
    474: "MULTINOMIAL",
    475: "LCM",
    476: "FVSCHEDULE",
    477: "CUBEKPIMEMBER",
    478: "CUBESET",
    479: "CUBESETCOUNT",
    480: "IFERROR",
    481: "COUNTIFS",
    482: "SUMIFS",
    483: "AVERAGEIF",
    484: "AVERAGEIFS"
};
var $3ee4f50b1ae43a89$var$FtabArgc = {
    2: 1,
    3: 1,
    10: 0,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    34: 0,
    35: 0,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    63: 0,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    74: 0,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    89: 0,
    90: 1,
    94: 0,
    95: 0,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    106: 1,
    108: 2,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    161: 1,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    186: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    225: 0,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    382: 3,
    385: 1,
    392: 1,
    393: 1,
    396: 2,
    397: 2,
    398: 2,
    399: 1,
    400: 1,
    401: 1,
    402: 1,
    403: 1,
    404: 1,
    405: 1,
    406: 1,
    407: 1,
    408: 1,
    409: 1,
    410: 1,
    414: 4,
    415: 1,
    416: 1,
    417: 2,
    420: 1,
    421: 1,
    422: 2,
    424: 1,
    425: 2,
    426: 2,
    427: 2,
    428: 2,
    430: 3,
    438: 3,
    439: 3,
    440: 3,
    443: 2,
    444: 2,
    445: 2,
    446: 2,
    447: 6,
    448: 6,
    449: 2,
    450: 2,
    464: 2,
    468: 3,
    476: 2,
    479: 1,
    480: 2,
    65535: 0
};
/* Part 3 TODO: actually parse formulae */ function $3ee4f50b1ae43a89$var$ods_to_csf_formula(f /*:string*/ ) /*:string*/ {
    if (f.slice(0, 3) == "of:") f = f.slice(3);
    /* 5.2 Basic Expressions */ if (f.charCodeAt(0) == 61) {
        f = f.slice(1);
        if (f.charCodeAt(0) == 61) f = f.slice(1);
    }
    f = f.replace(/COM\.MICROSOFT\./g, "");
    /* Part 3 Section 5.8 References */ f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) {
        return $1.replace(/\./g, "");
    });
    /* TODO: something other than this */ f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
    return f.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function $3ee4f50b1ae43a89$var$csf_to_ods_formula(f /*:string*/ ) /*:string*/ {
    var o = "of:=" + f.replace($3ee4f50b1ae43a89$var$crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
    /* TODO: something other than this */ return o.replace(/;/g, "|").replace(/,/g, ";");
}
function $3ee4f50b1ae43a89$var$ods_to_csf_3D(r /*:string*/ ) /*:[string, string]*/ {
    var a = r.split(":");
    var s = a[0].split(".")[0];
    return [
        s,
        a[0].split(".")[1] + (a.length > 1 ? ":" + (a[1].split(".")[1] || a[1].split(".")[0]) : "")
    ];
}
function $3ee4f50b1ae43a89$var$csf_to_ods_3D(r /*:string*/ ) /*:string*/ {
    return r.replace(/\./, "!");
}
var $3ee4f50b1ae43a89$var$strs = {}; // shared strings
var $3ee4f50b1ae43a89$var$_ssfopts = {}; // spreadsheet formatting options
/*global Map */ var $3ee4f50b1ae43a89$var$browser_has_Map = typeof Map !== "undefined";
function $3ee4f50b1ae43a89$var$get_sst_id(sst /*:SST*/ , str /*:string*/ , rev) /*:number*/ {
    var i = 0, len = sst.length;
    if (rev) {
        if ($3ee4f50b1ae43a89$var$browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
            var revarr = $3ee4f50b1ae43a89$var$browser_has_Map ? rev.get(str) : rev[str];
            for(; i < revarr.length; ++i)if (sst[revarr[i]].t === str) {
                sst.Count++;
                return revarr[i];
            }
        }
    } else for(; i < len; ++i)if (sst[i].t === str) {
        sst.Count++;
        return i;
    }
    sst[len] = {
        t: str
    } /*:any*/ ;
    sst.Count++;
    sst.Unique++;
    if (rev) {
        if ($3ee4f50b1ae43a89$var$browser_has_Map) {
            if (!rev.has(str)) rev.set(str, []);
            rev.get(str).push(len);
        } else {
            if (!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
            rev[str].push(len);
        }
    }
    return len;
}
function $3ee4f50b1ae43a89$var$col_obj_w(C /*:number*/ , col) {
    var p = {
        min: C + 1,
        max: C + 1
    } /*:any*/ ;
    /* wch (chars), wpx (pixels) */ var wch = -1;
    if (col.MDW) $3ee4f50b1ae43a89$var$MDW = col.MDW;
    if (col.width != null) p.customWidth = 1;
    else if (col.wpx != null) wch = $3ee4f50b1ae43a89$var$px2char(col.wpx);
    else if (col.wch != null) wch = col.wch;
    if (wch > -1) {
        p.width = $3ee4f50b1ae43a89$var$char2width(wch);
        p.customWidth = 1;
    } else if (col.width != null) p.width = col.width;
    if (col.hidden) p.hidden = true;
    if (col.level != null) p.outlineLevel = p.level = col.level;
    return p;
}
function $3ee4f50b1ae43a89$var$default_margins(margins /*:Margins*/ , mode /*:?string*/ ) {
    if (!margins) return;
    var defs = [
        0.7,
        0.7,
        0.75,
        0.75,
        0.3,
        0.3
    ];
    if (mode == "xlml") defs = [
        1,
        1,
        1,
        1,
        0.5,
        0.5
    ];
    if (margins.left == null) margins.left = defs[0];
    if (margins.right == null) margins.right = defs[1];
    if (margins.top == null) margins.top = defs[2];
    if (margins.bottom == null) margins.bottom = defs[3];
    if (margins.header == null) margins.header = defs[4];
    if (margins.footer == null) margins.footer = defs[5];
}
function $3ee4f50b1ae43a89$var$get_cell_style(styles /*:Array<any>*/ , cell /*:Cell*/ , opts) {
    var z = opts.revssf[cell.z != null ? cell.z : "General"];
    var i = 0x3c, len = styles.length;
    if (z == null && opts.ssf) {
        for(; i < 0x188; ++i)if (opts.ssf[i] == null) {
            $3ee4f50b1ae43a89$var$SSF_load(cell.z, i);
            // $FlowIgnore
            opts.ssf[i] = cell.z;
            opts.revssf[cell.z] = z = i;
            break;
        }
    }
    for(i = 0; i != len; ++i)if (styles[i].numFmtId === z) return i;
    styles[len] = {
        numFmtId: z,
        fontId: 0,
        fillId: 0,
        borderId: 0,
        xfId: 0,
        applyNumberFormat: 1
    };
    return len;
}
function $3ee4f50b1ae43a89$var$safe_format(p /*:Cell*/ , fmtid /*:number*/ , fillid /*:?number*/ , opts, themes, styles) {
    try {
        if (opts.cellNF) p.z = $3ee4f50b1ae43a89$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (p.t === "z" && !opts.cellStyles) return;
    if (p.t === "d" && typeof p.v === "string") p.v = $3ee4f50b1ae43a89$var$parseDate(p.v);
    if ((!opts || opts.cellText !== false) && p.t !== "z") try {
        if ($3ee4f50b1ae43a89$var$table_fmt[fmtid] == null) $3ee4f50b1ae43a89$var$SSF_load($3ee4f50b1ae43a89$var$SSFImplicit[fmtid] || "General", fmtid);
        if (p.t === "e") p.w = p.w || $3ee4f50b1ae43a89$var$BErr[p.v];
        else if (fmtid === 0) {
            if (p.t === "n") {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $3ee4f50b1ae43a89$var$SSF_general_num(p.v);
            } else if (p.t === "d") {
                var dd = $3ee4f50b1ae43a89$var$datenum(p.v);
                if ((dd | 0) === dd) p.w = dd.toString(10);
                else p.w = $3ee4f50b1ae43a89$var$SSF_general_num(dd);
            } else if (p.v === undefined) return "";
            else p.w = $3ee4f50b1ae43a89$var$SSF_general(p.v, $3ee4f50b1ae43a89$var$_ssfopts);
        } else if (p.t === "d") p.w = $3ee4f50b1ae43a89$var$SSF_format(fmtid, $3ee4f50b1ae43a89$var$datenum(p.v), $3ee4f50b1ae43a89$var$_ssfopts);
        else p.w = $3ee4f50b1ae43a89$var$SSF_format(fmtid, p.v, $3ee4f50b1ae43a89$var$_ssfopts);
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts.cellStyles) return;
    if (fillid != null) try {
        p.s = styles.Fills[fillid];
        if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
            p.s.fgColor.rgb = $3ee4f50b1ae43a89$var$rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
            if (opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
        }
        if (p.s.bgColor && p.s.bgColor.theme) {
            p.s.bgColor.rgb = $3ee4f50b1ae43a89$var$rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
            if (opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
        }
    } catch (e) {
        if (opts.WTF && styles.Fills) throw e;
    }
}
function $3ee4f50b1ae43a89$var$check_ws(ws /*:Worksheet*/ , sname /*:string*/ , i /*:number*/ ) {
    if (ws && ws["!ref"]) {
        var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]);
        if (range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws["!ref"]);
    }
}
function $3ee4f50b1ae43a89$var$parse_ws_xml_dim(ws /*:Worksheet*/ , s /*:string*/ ) {
    var d = $3ee4f50b1ae43a89$var$safe_decode_range(s);
    if (d.s.r <= d.e.r && d.s.c <= d.e.c && d.s.r >= 0 && d.s.c >= 0) ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(d);
}
var $3ee4f50b1ae43a89$var$mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
var $3ee4f50b1ae43a89$var$sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;
var $3ee4f50b1ae43a89$var$hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
var $3ee4f50b1ae43a89$var$dimregex = /"(\w*:\w*)"/;
var $3ee4f50b1ae43a89$var$colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
var $3ee4f50b1ae43a89$var$afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
var $3ee4f50b1ae43a89$var$marginregex = /<(?:\w:)?pageMargins[^>]*\/>/g;
var $3ee4f50b1ae43a89$var$sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
var $3ee4f50b1ae43a89$var$sheetprregex2 = /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;
var $3ee4f50b1ae43a89$var$svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
/* 18.3 Worksheets */ function $3ee4f50b1ae43a89$var$parse_ws_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        "!id": {}
    };
    if ($3ee4f50b1ae43a89$var$DENSE != null && opts.dense == null) opts.dense = $3ee4f50b1ae43a89$var$DENSE;
    /* 18.3.1.99 worksheet CT_Worksheet */ var s = opts.dense ? [] : {} /*:any*/ ;
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    } /*:any*/ ;
    var data1 = "", data2 = "";
    var mtch /*:?any*/  = data.match($3ee4f50b1ae43a89$var$sheetdataregex);
    if (mtch) {
        data1 = data.slice(0, mtch.index);
        data2 = data.slice(mtch.index + mtch[0].length);
    } else data1 = data2 = data;
    /* 18.3.1.82 sheetPr CT_SheetPr */ var sheetPr = data1.match($3ee4f50b1ae43a89$var$sheetprregex);
    if (sheetPr) $3ee4f50b1ae43a89$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    else if (sheetPr = data1.match($3ee4f50b1ae43a89$var$sheetprregex2)) $3ee4f50b1ae43a89$var$parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1] || "", s, wb, idx, styles, themes);
    /* 18.3.1.35 dimension CT_SheetDimension */ var ridx = (data1.match(/<(?:\w*:)?dimension/) || {
        index: -1
    }).index;
    if (ridx > 0) {
        var ref = data1.slice(ridx, ridx + 50).match($3ee4f50b1ae43a89$var$dimregex);
        if (ref) $3ee4f50b1ae43a89$var$parse_ws_xml_dim(s, ref[1]);
    }
    /* 18.3.1.88 sheetViews CT_SheetViews */ var svs = data1.match($3ee4f50b1ae43a89$var$svsregex);
    if (svs && svs[1]) $3ee4f50b1ae43a89$var$parse_ws_xml_sheetviews(svs[1], wb);
    /* 18.3.1.17 cols CT_Cols */ var columns /*:Array<ColInfo>*/  = [];
    if (opts.cellStyles) {
        /* 18.3.1.13 col CT_Col */ var cols = data1.match($3ee4f50b1ae43a89$var$colregex);
        if (cols) $3ee4f50b1ae43a89$var$parse_ws_xml_cols(columns, cols);
    }
    /* 18.3.1.80 sheetData CT_SheetData ? */ if (mtch) $3ee4f50b1ae43a89$var$parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);
    /* 18.3.1.2  autoFilter CT_AutoFilter */ var afilter = data2.match($3ee4f50b1ae43a89$var$afregex);
    if (afilter) s["!autofilter"] = $3ee4f50b1ae43a89$var$parse_ws_xml_autofilter(afilter[0]);
    /* 18.3.1.55 mergeCells CT_MergeCells */ var merges /*:Array<Range>*/  = [];
    var _merge = data2.match($3ee4f50b1ae43a89$var$mergecregex);
    if (_merge) for(ridx = 0; ridx != _merge.length; ++ridx)merges[ridx] = $3ee4f50b1ae43a89$var$safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf('"') + 1));
    /* 18.3.1.48 hyperlinks CT_Hyperlinks */ var hlink = data2.match($3ee4f50b1ae43a89$var$hlinkregex);
    if (hlink) $3ee4f50b1ae43a89$var$parse_ws_xml_hlinks(s, hlink, rels);
    /* 18.3.1.62 pageMargins CT_PageMargins */ var margins = data2.match($3ee4f50b1ae43a89$var$marginregex);
    if (margins) s["!margins"] = $3ee4f50b1ae43a89$var$parse_ws_xml_margins($3ee4f50b1ae43a89$var$parsexmltag(margins[0]));
    if (!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
    if (opts.sheetRows > 0 && s["!ref"]) {
        var tmpref = $3ee4f50b1ae43a89$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(tmpref);
        }
    }
    if (columns.length > 0) s["!cols"] = columns;
    if (merges.length > 0) s["!merges"] = merges;
    return s;
}
function $3ee4f50b1ae43a89$var$write_ws_xml_merges(merges /*:Array<Range>*/ ) /*:string*/ {
    if (merges.length === 0) return "";
    var o = '<mergeCells count="' + merges.length + '">';
    for(var i = 0; i != merges.length; ++i)o += '<mergeCell ref="' + $3ee4f50b1ae43a89$var$encode_range(merges[i]) + '"/>';
    return o + "</mergeCells>";
}
/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */ function $3ee4f50b1ae43a89$var$parse_ws_xml_sheetpr(sheetPr /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    var data = $3ee4f50b1ae43a89$var$parsexmltag(sheetPr);
    if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
    if (data.codeName) wb.Sheets[idx].CodeName = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(data.codeName));
}
function $3ee4f50b1ae43a89$var$parse_ws_xml_sheetpr2(sheetPr /*:string*/ , body /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    $3ee4f50b1ae43a89$var$parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
}
function $3ee4f50b1ae43a89$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
    var needed = false;
    var props = {}, payload = null;
    if (opts.bookType !== "xlsx" && wb.vbaraw) {
        var cname = wb.SheetNames[idx];
        try {
            if (wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname;
        } catch (e) {}
        needed = true;
        props.codeName = $3ee4f50b1ae43a89$var$utf8write($3ee4f50b1ae43a89$var$escapexml(cname));
    }
    if (ws && ws["!outline"]) {
        var outlineprops = {
            summaryBelow: 1,
            summaryRight: 1
        };
        if (ws["!outline"].above) outlineprops.summaryBelow = 0;
        if (ws["!outline"].left) outlineprops.summaryRight = 0;
        payload = (payload || "") + $3ee4f50b1ae43a89$var$writextag("outlinePr", null, outlineprops);
    }
    if (!needed && !payload) return;
    o[o.length] = $3ee4f50b1ae43a89$var$writextag("sheetPr", payload, props);
}
/* 18.3.1.85 sheetProtection CT_SheetProtection */ var $3ee4f50b1ae43a89$var$sheetprot_deffalse = [
    "objects",
    "scenarios",
    "selectLockedCells",
    "selectUnlockedCells"
];
var $3ee4f50b1ae43a89$var$sheetprot_deftrue = [
    "formatColumns",
    "formatRows",
    "formatCells",
    "insertColumns",
    "insertRows",
    "insertHyperlinks",
    "deleteColumns",
    "deleteRows",
    "sort",
    "autoFilter",
    "pivotTables"
];
function $3ee4f50b1ae43a89$var$write_ws_xml_protection(sp) /*:string*/ {
    // algorithmName, hashValue, saltValue, spinCount
    var o = {
        sheet: 1
    } /*:any*/ ;
    $3ee4f50b1ae43a89$var$sheetprot_deffalse.forEach(function(n) {
        if (sp[n] != null && sp[n]) o[n] = "1";
    });
    $3ee4f50b1ae43a89$var$sheetprot_deftrue.forEach(function(n) {
        if (sp[n] != null && !sp[n]) o[n] = "0";
    });
    /* TODO: algorithm */ if (sp.password) o.password = $3ee4f50b1ae43a89$var$crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
    return $3ee4f50b1ae43a89$var$writextag("sheetProtection", null, o);
}
function $3ee4f50b1ae43a89$var$parse_ws_xml_hlinks(s, data /*:Array<string>*/ , rels) {
    var dense = Array.isArray(s);
    for(var i = 0; i != data.length; ++i){
        var val = $3ee4f50b1ae43a89$var$parsexmltag($3ee4f50b1ae43a89$var$utf8read(data[i]), true);
        if (!val.ref) return;
        var rel = ((rels || {})["!id"] || [])[val.id];
        if (rel) {
            val.Target = rel.Target;
            if (val.location) val.Target += "#" + $3ee4f50b1ae43a89$var$unescapexml(val.location);
        } else {
            val.Target = "#" + $3ee4f50b1ae43a89$var$unescapexml(val.location);
            rel = {
                Target: val.Target,
                TargetMode: "Internal"
            };
        }
        val.Rel = rel;
        if (val.tooltip) {
            val.Tooltip = val.tooltip;
            delete val.tooltip;
        }
        var rng = $3ee4f50b1ae43a89$var$safe_decode_range(val.ref);
        for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
            var addr = $3ee4f50b1ae43a89$var$encode_cell({
                c: C,
                r: R
            });
            if (dense) {
                if (!s[R]) s[R] = [];
                if (!s[R][C]) s[R][C] = {
                    t: "z",
                    v: undefined
                };
                s[R][C].l = val;
            } else {
                if (!s[addr]) s[addr] = {
                    t: "z",
                    v: undefined
                };
                s[addr].l = val;
            }
        }
    }
}
function $3ee4f50b1ae43a89$var$parse_ws_xml_margins(margin) {
    var o = {};
    [
        "left",
        "right",
        "top",
        "bottom",
        "header",
        "footer"
    ].forEach(function(k) {
        if (margin[k]) o[k] = parseFloat(margin[k]);
    });
    return o;
}
function $3ee4f50b1ae43a89$var$write_ws_xml_margins(margin) /*:string*/ {
    $3ee4f50b1ae43a89$var$default_margins(margin);
    return $3ee4f50b1ae43a89$var$writextag("pageMargins", null, margin);
}
function $3ee4f50b1ae43a89$var$parse_ws_xml_cols(columns, cols) {
    var seencol = false;
    for(var coli = 0; coli != cols.length; ++coli){
        var coll = $3ee4f50b1ae43a89$var$parsexmltag(cols[coli], true);
        if (coll.hidden) coll.hidden = $3ee4f50b1ae43a89$var$parsexmlbool(coll.hidden);
        var colm = parseInt(coll.min, 10) - 1, colM = parseInt(coll.max, 10) - 1;
        if (coll.outlineLevel) coll.level = +coll.outlineLevel || 0;
        delete coll.min;
        delete coll.max;
        coll.width = +coll.width;
        if (!seencol && coll.width) {
            seencol = true;
            $3ee4f50b1ae43a89$var$find_mdw_colw(coll.width);
        }
        $3ee4f50b1ae43a89$var$process_col(coll);
        while(colm <= colM)columns[colm++] = $3ee4f50b1ae43a89$var$dup(coll);
    }
}
function $3ee4f50b1ae43a89$var$write_ws_xml_cols(ws, cols) /*:string*/ {
    var o = [
        "<cols>"
    ], col;
    for(var i = 0; i != cols.length; ++i){
        if (!(col = cols[i])) continue;
        o[o.length] = $3ee4f50b1ae43a89$var$writextag("col", null, $3ee4f50b1ae43a89$var$col_obj_w(i, col));
    }
    o[o.length] = "</cols>";
    return o.join("");
}
function $3ee4f50b1ae43a89$var$parse_ws_xml_autofilter(data /*:string*/ ) {
    var o = {
        ref: (data.match(/ref="([^"]*)"/) || [])[1]
    };
    return o;
}
function $3ee4f50b1ae43a89$var$write_ws_xml_autofilter(data, ws, wb, idx) /*:string*/ {
    var ref = typeof data.ref == "string" ? data.ref : $3ee4f50b1ae43a89$var$encode_range(data.ref);
    if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $3ee4f50b1ae43a89$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]).e.r;
        ref = $3ee4f50b1ae43a89$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != "_xlnm._FilterDatabase") continue;
        if (name.Sheet != idx) continue;
        name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref;
        break;
    }
    if (i == names.length) names.push({
        Name: "_xlnm._FilterDatabase",
        Sheet: idx,
        Ref: "'" + wb.SheetNames[idx] + "'!" + ref
    });
    return $3ee4f50b1ae43a89$var$writextag("autoFilter", null, {
        ref: ref
    });
}
/* 18.3.1.88 sheetViews CT_SheetViews */ /* 18.3.1.87 sheetView CT_SheetView */ var $3ee4f50b1ae43a89$var$sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
function $3ee4f50b1ae43a89$var$parse_ws_xml_sheetviews(data, wb /*:WBWBProps*/ ) {
    if (!wb.Views) wb.Views = [
        {}
    ];
    (data.match($3ee4f50b1ae43a89$var$sviewregex) || []).forEach(function(r /*:string*/ , i /*:number*/ ) {
        var tag = $3ee4f50b1ae43a89$var$parsexmltag(r);
        // $FlowIgnore
        if (!wb.Views[i]) wb.Views[i] = {};
        // $FlowIgnore
        if (+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
        // $FlowIgnore
        if ($3ee4f50b1ae43a89$var$parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
    });
}
function $3ee4f50b1ae43a89$var$write_ws_xml_sheetviews(ws, opts, idx, wb) /*:string*/ {
    var sview = {
        workbookViewId: "0"
    } /*:any*/ ;
    // $FlowIgnore
    if ((((wb || {}).Workbook || {}).Views || [])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
    return $3ee4f50b1ae43a89$var$writextag("sheetViews", $3ee4f50b1ae43a89$var$writextag("sheetView", null, sview), {});
}
function $3ee4f50b1ae43a89$var$write_ws_xml_cell(cell /*:Cell*/ , ref, ws, opts /*::, idx, wb*/ ) /*:string*/ {
    if (cell.c) ws["!comments"].push([
        ref,
        cell.c
    ]);
    if (cell.v === undefined && typeof cell.f !== "string" || cell.t === "z" && !cell.f) return "";
    var vv = "";
    var oldt = cell.t, oldv = cell.v;
    if (cell.t !== "z") switch(cell.t){
        case "b":
            vv = cell.v ? "1" : "0";
            break;
        case "n":
            vv = "" + cell.v;
            break;
        case "e":
            vv = $3ee4f50b1ae43a89$var$BErr[cell.v];
            break;
        case "d":
            if (opts && opts.cellDates) vv = $3ee4f50b1ae43a89$var$parseDate(cell.v, -1).toISOString();
            else {
                cell = $3ee4f50b1ae43a89$var$dup(cell);
                cell.t = "n";
                vv = "" + (cell.v = $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v)));
            }
            if (typeof cell.z === "undefined") cell.z = $3ee4f50b1ae43a89$var$table_fmt[14];
            break;
        default:
            vv = cell.v;
            break;
    }
    var v = $3ee4f50b1ae43a89$var$writetag("v", $3ee4f50b1ae43a89$var$escapexml(vv)), o = {
        r: ref
    } /*:any*/ ;
    /* TODO: cell style */ var os = $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, cell, opts);
    if (os !== 0) o.s = os;
    switch(cell.t){
        case "n":
            break;
        case "d":
            o.t = "d";
            break;
        case "b":
            o.t = "b";
            break;
        case "e":
            o.t = "e";
            break;
        case "z":
            break;
        default:
            if (cell.v == null) {
                delete cell.t;
                break;
            }
            if (cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
            if (opts && opts.bookSST) {
                v = $3ee4f50b1ae43a89$var$writetag("v", "" + $3ee4f50b1ae43a89$var$get_sst_id(opts.Strings, cell.v, opts.revStrings));
                o.t = "s";
                break;
            }
            o.t = "str";
            break;
    }
    if (cell.t != oldt) {
        cell.t = oldt;
        cell.v = oldv;
    }
    if (typeof cell.f == "string" && cell.f) {
        var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {
            t: "array",
            ref: cell.F
        } : null;
        v = $3ee4f50b1ae43a89$var$writextag("f", $3ee4f50b1ae43a89$var$escapexml(cell.f), ff) + (cell.v != null ? v : "");
    }
    if (cell.l) ws["!links"].push([
        ref,
        cell.l
    ]);
    if (cell.D) o.cm = 1;
    return $3ee4f50b1ae43a89$var$writextag("c", v, o);
}
var $3ee4f50b1ae43a89$var$parse_ws_xml_data = /*#__PURE__*/ function() {
    var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
    var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
    var refregex = /ref=["']([^"']*)["']/;
    var match_v = $3ee4f50b1ae43a89$var$matchtag("v"), match_f = $3ee4f50b1ae43a89$var$matchtag("f");
    return function parse_ws_xml_data(sdata /*:string*/ , s, opts, guess /*:Range*/ , themes, styles) {
        var ri = 0, x = "", cells /*:Array<string>*/  = [], cref /*:?Array<string>*/  = [], idx = 0, i = 0, cc = 0, d = "", p /*:any*/ ;
        var tag, tagr = 0, tagc = 0;
        var sstr, ftag;
        var fmtid = 0, fillid = 0;
        var do_format = Array.isArray(styles.CellXf), cf;
        var arrayf /*:Array<[Range, string]>*/  = [];
        var sharedf = [];
        var dense = Array.isArray(s);
        var rows /*:Array<RowInfo>*/  = [], rowobj = {}, rowrite = false;
        var sheetStubs = !!opts.sheetStubs;
        for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt){
            x = marr[mt].trim();
            var xlen = x.length;
            if (xlen === 0) continue;
            /* 18.3.1.73 row CT_Row */ var rstarti = 0;
            outa: for(ri = 0; ri < xlen; ++ri)switch(/*x.charCodeAt(ri)*/ x[ri]){
                case ">" /*62*/ :
                    if (/*x.charCodeAt(ri-1) != 47*/ x[ri - 1] != "/") {
                        ++ri;
                        break outa;
                    }
                    if (opts && opts.cellStyles) {
                        // TODO: avoid duplication
                        tag = $3ee4f50b1ae43a89$var$parsexmltag(x.slice(rstarti, ri), true);
                        tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
                        tagc = -1;
                        if (opts.sheetRows && opts.sheetRows < tagr) continue;
                        rowobj = {};
                        rowrite = false;
                        if (tag.ht) {
                            rowrite = true;
                            rowobj.hpt = parseFloat(tag.ht);
                            rowobj.hpx = $3ee4f50b1ae43a89$var$pt2px(rowobj.hpt);
                        }
                        if (tag.hidden == "1") {
                            rowrite = true;
                            rowobj.hidden = true;
                        }
                        if (tag.outlineLevel != null) {
                            rowrite = true;
                            rowobj.level = +tag.outlineLevel;
                        }
                        if (rowrite) rows[tagr - 1] = rowobj;
                    }
                    break;
                case "<" /*60*/ :
                    rstarti = ri;
                    break;
            }
            if (rstarti >= ri) break;
            tag = $3ee4f50b1ae43a89$var$parsexmltag(x.slice(rstarti, ri), true);
            tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
            tagc = -1;
            if (opts.sheetRows && opts.sheetRows < tagr) continue;
            if (guess.s.r > tagr - 1) guess.s.r = tagr - 1;
            if (guess.e.r < tagr - 1) guess.e.r = tagr - 1;
            if (opts && opts.cellStyles) {
                rowobj = {};
                rowrite = false;
                if (tag.ht) {
                    rowrite = true;
                    rowobj.hpt = parseFloat(tag.ht);
                    rowobj.hpx = $3ee4f50b1ae43a89$var$pt2px(rowobj.hpt);
                }
                if (tag.hidden == "1") {
                    rowrite = true;
                    rowobj.hidden = true;
                }
                if (tag.outlineLevel != null) {
                    rowrite = true;
                    rowobj.level = +tag.outlineLevel;
                }
                if (rowrite) rows[tagr - 1] = rowobj;
            }
            /* 18.3.1.4 c CT_Cell */ cells = x.slice(ri).split(cellregex);
            for(var rslice = 0; rslice != cells.length; ++rslice)if (cells[rslice].trim().charAt(0) != "<") break;
            cells = cells.slice(rslice);
            for(ri = 0; ri != cells.length; ++ri){
                x = cells[ri].trim();
                if (x.length === 0) continue;
                cref = x.match(rregex);
                idx = ri;
                i = 0;
                cc = 0;
                x = "<c " + (x.slice(0, 1) == "<" ? ">" : "") + x;
                if (cref != null && cref.length === 2) {
                    idx = 0;
                    d = cref[1];
                    for(i = 0; i != d.length; ++i){
                        if ((cc = d.charCodeAt(i) - 64) < 1 || cc > 26) break;
                        idx = 26 * idx + cc;
                    }
                    --idx;
                    tagc = idx;
                } else ++tagc;
                for(i = 0; i != x.length; ++i)if (x.charCodeAt(i) === 62) break;
                ++i;
                tag = $3ee4f50b1ae43a89$var$parsexmltag(x.slice(0, i), true);
                if (!tag.r) tag.r = $3ee4f50b1ae43a89$var$encode_cell({
                    r: tagr - 1,
                    c: tagc
                });
                d = x.slice(i);
                p = {
                    t: ""
                } /*:any*/ ;
                if ((cref = d.match(match_v)) != null && /*::cref != null && */ cref[1] !== "") p.v = $3ee4f50b1ae43a89$var$unescapexml(cref[1]);
                if (opts.cellFormula) {
                    if ((cref = d.match(match_f)) != null && /*::cref != null && */ cref[1] !== "") {
                        /* TODO: match against XLSXFutureFunctions */ p.f = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(cref[1])).replace(/\r\n/g, "\n");
                        if (!opts.xlfn) p.f = $3ee4f50b1ae43a89$var$_xlfn(p.f);
                        if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="array"') > -1) {
                            p.F = (d.match(refregex) || [])[1];
                            if (p.F.indexOf(":") > -1) arrayf.push([
                                $3ee4f50b1ae43a89$var$safe_decode_range(p.F),
                                p.F
                            ]);
                        } else if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                            // TODO: parse formula
                            ftag = $3ee4f50b1ae43a89$var$parsexmltag(cref[0]);
                            var ___f = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(cref[1]));
                            if (!opts.xlfn) ___f = $3ee4f50b1ae43a89$var$_xlfn(___f);
                            sharedf[parseInt(ftag.si, 10)] = [
                                ftag,
                                ___f,
                                tag.r
                            ];
                        }
                    } else if (cref = d.match(/<f[^>]*\/>/)) {
                        ftag = $3ee4f50b1ae43a89$var$parsexmltag(cref[0]);
                        if (sharedf[ftag.si]) p.f = $3ee4f50b1ae43a89$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                    }
                    /* TODO: factor out contains logic */ var _tag = $3ee4f50b1ae43a89$var$decode_cell(tag.r);
                    for(i = 0; i < arrayf.length; ++i)if (_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r) {
                        if (_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c) p.F = arrayf[i][1];
                    }
                }
                if (tag.t == null && p.v === undefined) {
                    if (p.f || p.F) {
                        p.v = 0;
                        p.t = "n";
                    } else if (!sheetStubs) continue;
                    else p.t = "z";
                } else p.t = tag.t || "n";
                if (guess.s.c > tagc) guess.s.c = tagc;
                if (guess.e.c < tagc) guess.e.c = tagc;
                /* 18.18.11 t ST_CellType */ switch(p.t){
                    case "n":
                        if (p.v == "" || p.v == null) {
                            if (!sheetStubs) continue;
                            p.t = "z";
                        } else p.v = parseFloat(p.v);
                        break;
                    case "s":
                        if (typeof p.v == "undefined") {
                            if (!sheetStubs) continue;
                            p.t = "z";
                        } else {
                            sstr = $3ee4f50b1ae43a89$var$strs[parseInt(p.v, 10)];
                            p.v = sstr.t;
                            p.r = sstr.r;
                            if (opts.cellHTML) p.h = sstr.h;
                        }
                        break;
                    case "str":
                        p.t = "s";
                        p.v = p.v != null ? $3ee4f50b1ae43a89$var$utf8read(p.v) : "";
                        if (opts.cellHTML) p.h = $3ee4f50b1ae43a89$var$escapehtml(p.v);
                        break;
                    case "inlineStr":
                        cref = d.match(isregex);
                        p.t = "s";
                        if (cref != null && (sstr = $3ee4f50b1ae43a89$var$parse_si(cref[1]))) {
                            p.v = sstr.t;
                            if (opts.cellHTML) p.h = sstr.h;
                        } else p.v = "";
                        break;
                    case "b":
                        p.v = $3ee4f50b1ae43a89$var$parsexmlbool(p.v);
                        break;
                    case "d":
                        if (opts.cellDates) p.v = $3ee4f50b1ae43a89$var$parseDate(p.v, 1);
                        else {
                            p.v = $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(p.v, 1));
                            p.t = "n";
                        }
                        break;
                    /* error string in .w, number in .v */ case "e":
                        if (!opts || opts.cellText !== false) p.w = p.v;
                        p.v = $3ee4f50b1ae43a89$var$RBErr[p.v];
                        break;
                }
                /* formatting */ fmtid = fillid = 0;
                cf = null;
                if (do_format && tag.s !== undefined) {
                    cf = styles.CellXf[tag.s];
                    if (cf != null) {
                        if (cf.numFmtId != null) fmtid = cf.numFmtId;
                        if (opts.cellStyles) {
                            if (cf.fillId != null) fillid = cf.fillId;
                        }
                    }
                }
                $3ee4f50b1ae43a89$var$safe_format(p, fmtid, fillid, opts, themes, styles);
                if (opts.cellDates && do_format && p.t == "n" && $3ee4f50b1ae43a89$var$fmt_is_date($3ee4f50b1ae43a89$var$table_fmt[fmtid])) {
                    p.t = "d";
                    p.v = $3ee4f50b1ae43a89$var$numdate(p.v);
                }
                if (tag.cm && opts.xlmeta) {
                    var cm = (opts.xlmeta.Cell || [])[+tag.cm - 1];
                    if (cm && cm.type == "XLDAPR") p.D = true;
                }
                if (dense) {
                    var _r = $3ee4f50b1ae43a89$var$decode_cell(tag.r);
                    if (!s[_r.r]) s[_r.r] = [];
                    s[_r.r][_r.c] = p;
                } else s[tag.r] = p;
            }
        }
        if (rows.length > 0) s["!rows"] = rows;
    };
}();
function $3ee4f50b1ae43a89$var$write_ws_xml_data(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/  /*::, rels*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], r /*:Array<string>*/  = [], range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]), cell = "", ref, rr = "", cols /*:Array<string>*/  = [], R = 0, C = 0, rows = ws["!rows"];
    var dense = Array.isArray(ws);
    var params = {
        r: rr
    } /*:any*/ , row /*:RowInfo*/ , height = -1;
    for(C = range.s.c; C <= range.e.c; ++C)cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
    for(R = range.s.r; R <= range.e.r; ++R){
        r = [];
        rr = $3ee4f50b1ae43a89$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            ref = cols[C] + rr;
            var _cell = dense ? (ws[R] || [])[C] : ws[ref];
            if (_cell === undefined) continue;
            if ((cell = $3ee4f50b1ae43a89$var$write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
        }
        if (r.length > 0 || rows && rows[R]) {
            params = {
                r: rr
            } /*:any*/ ;
            if (rows && rows[R]) {
                row = rows[R];
                if (row.hidden) params.hidden = 1;
                height = -1;
                if (row.hpx) height = $3ee4f50b1ae43a89$var$px2pt(row.hpx);
                else if (row.hpt) height = row.hpt;
                if (height > -1) {
                    params.ht = height;
                    params.customHeight = 1;
                }
                if (row.level) params.outlineLevel = row.level;
            }
            o[o.length] = $3ee4f50b1ae43a89$var$writextag("row", r.join(""), params);
        }
    }
    if (rows) {
        for(; R < rows.length; ++R)if (rows && rows[R]) {
            params = {
                r: R + 1
            } /*:any*/ ;
            row = rows[R];
            if (row.hidden) params.hidden = 1;
            height = -1;
            if (row.hpx) height = $3ee4f50b1ae43a89$var$px2pt(row.hpx);
            else if (row.hpt) height = row.hpt;
            if (height > -1) {
                params.ht = height;
                params.customHeight = 1;
            }
            if (row.level) params.outlineLevel = row.level;
            o[o.length] = $3ee4f50b1ae43a89$var$writextag("row", "", params);
        }
    }
    return o.join("");
}
function $3ee4f50b1ae43a89$var$write_ws_xml(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag("worksheet", null, {
            "xmlns": $3ee4f50b1ae43a89$var$XMLNS_main[0],
            "xmlns:r": $3ee4f50b1ae43a89$var$XMLNS.r
        })
    ];
    var s = wb.SheetNames[idx], sidx = 0, rdata = "";
    var ws = wb.Sheets[s];
    if (ws == null) ws = {};
    var ref = ws["!ref"] || "A1";
    var range = $3ee4f50b1ae43a89$var$safe_decode_range(ref);
    if (range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
        range.e.c = Math.min(range.e.c, 0x3FFF);
        range.e.r = Math.min(range.e.c, 0xFFFFF);
        ref = $3ee4f50b1ae43a89$var$encode_range(range);
    }
    if (!rels) rels = {};
    ws["!comments"] = [];
    var _drawing = [];
    $3ee4f50b1ae43a89$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o);
    o[o.length] = $3ee4f50b1ae43a89$var$writextag("dimension", null, {
        "ref": ref
    });
    o[o.length] = $3ee4f50b1ae43a89$var$write_ws_xml_sheetviews(ws, opts, idx, wb);
    /* TODO: store in WB, process styles */ if (opts.sheetFormat) o[o.length] = $3ee4f50b1ae43a89$var$writextag("sheetFormatPr", null, {
        defaultRowHeight: opts.sheetFormat.defaultRowHeight || "16",
        baseColWidth: opts.sheetFormat.baseColWidth || "10",
        outlineLevelRow: opts.sheetFormat.outlineLevelRow || "7"
    });
    if (ws["!cols"] != null && ws["!cols"].length > 0) o[o.length] = $3ee4f50b1ae43a89$var$write_ws_xml_cols(ws, ws["!cols"]);
    o[sidx = o.length] = "<sheetData/>";
    ws["!links"] = [];
    if (ws["!ref"] != null) {
        rdata = $3ee4f50b1ae43a89$var$write_ws_xml_data(ws, opts, idx, wb, rels);
        if (rdata.length > 0) o[o.length] = rdata;
    }
    if (o.length > sidx + 1) {
        o[o.length] = "</sheetData>";
        o[sidx] = o[sidx].replace("/>", ">");
    }
    /* sheetCalcPr */ if (ws["!protect"]) o[o.length] = $3ee4f50b1ae43a89$var$write_ws_xml_protection(ws["!protect"]);
    /* protectedRanges */ /* scenarios */ if (ws["!autofilter"] != null) o[o.length] = $3ee4f50b1ae43a89$var$write_ws_xml_autofilter(ws["!autofilter"], ws, wb, idx);
    /* sortState */ /* dataConsolidate */ /* customSheetViews */ if (ws["!merges"] != null && ws["!merges"].length > 0) o[o.length] = $3ee4f50b1ae43a89$var$write_ws_xml_merges(ws["!merges"]);
    /* phoneticPr */ /* conditionalFormatting */ /* dataValidations */ var relc = -1, rel, rId = -1;
    if (/*::(*/ ws["!links"]/*::||[])*/ .length > 0) {
        o[o.length] = "<hyperlinks>";
        /*::(*/ ws["!links"]/*::||[])*/ .forEach(function(l) {
            if (!l[1].Target) return;
            rel = {
                "ref": l[0]
            } /*:any*/ ;
            if (l[1].Target.charAt(0) != "#") {
                rId = $3ee4f50b1ae43a89$var$add_rels(rels, -1, $3ee4f50b1ae43a89$var$escapexml(l[1].Target).replace(/#.*$/, ""), $3ee4f50b1ae43a89$var$RELS.HLINK);
                rel["r:id"] = "rId" + rId;
            }
            if ((relc = l[1].Target.indexOf("#")) > -1) rel.location = $3ee4f50b1ae43a89$var$escapexml(l[1].Target.slice(relc + 1));
            if (l[1].Tooltip) rel.tooltip = $3ee4f50b1ae43a89$var$escapexml(l[1].Tooltip);
            o[o.length] = $3ee4f50b1ae43a89$var$writextag("hyperlink", null, rel);
        });
        o[o.length] = "</hyperlinks>";
    }
    delete ws["!links"];
    /* printOptions */ if (ws["!margins"] != null) o[o.length] = $3ee4f50b1ae43a89$var$write_ws_xml_margins(ws["!margins"]);
    /* pageSetup */ /* headerFooter */ /* rowBreaks */ /* colBreaks */ /* customProperties */ /* cellWatches */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) o[o.length] = $3ee4f50b1ae43a89$var$writetag("ignoredErrors", $3ee4f50b1ae43a89$var$writextag("ignoredError", null, {
        numberStoredAsText: 1,
        sqref: ref
    }));
    /* smartTags */ if (_drawing.length > 0) {
        rId = $3ee4f50b1ae43a89$var$add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", $3ee4f50b1ae43a89$var$RELS.DRAW);
        o[o.length] = $3ee4f50b1ae43a89$var$writextag("drawing", null, {
            "r:id": "rId" + rId
        });
        ws["!drawing"] = _drawing;
    }
    if (ws["!comments"].length > 0) {
        rId = $3ee4f50b1ae43a89$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $3ee4f50b1ae43a89$var$RELS.VML);
        o[o.length] = $3ee4f50b1ae43a89$var$writextag("legacyDrawing", null, {
            "r:id": "rId" + rId
        });
        ws["!legacy"] = rId;
    }
    /* legacyDrawingHF */ /* picture */ /* oleObjects */ /* controls */ /* webPublishItems */ /* tableParts */ /* extLst */ if (o.length > 1) {
        o[o.length] = "</worksheet>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.726 BrtRowHdr */ function $3ee4f50b1ae43a89$var$parse_BrtRowHdr(data, length) {
    var z = {} /*:any*/ ;
    var tgt = data.l + length;
    z.r = data.read_shift(4);
    data.l += 4; // TODO: ixfe
    var miyRw = data.read_shift(2);
    data.l += 1; // TODO: top/bot padding
    var flags = data.read_shift(1);
    data.l = tgt;
    if (flags & 0x07) z.level = flags & 0x07;
    if (flags & 0x10) z.hidden = true;
    if (flags & 0x20) z.hpt = miyRw / 20;
    return z;
}
function $3ee4f50b1ae43a89$var$write_BrtRowHdr(R /*:number*/ , range, ws) {
    var o = $3ee4f50b1ae43a89$var$new_buf(145);
    var row = (ws["!rows"] || [])[R] || {};
    o.write_shift(4, R);
    o.write_shift(4, 0); /* TODO: ixfe */ 
    var miyRw = 0x0140;
    if (row.hpx) miyRw = $3ee4f50b1ae43a89$var$px2pt(row.hpx) * 20;
    else if (row.hpt) miyRw = row.hpt * 20;
    o.write_shift(2, miyRw);
    o.write_shift(1, 0); /* top/bot padding */ 
    var flags = 0x0;
    if (row.level) flags |= row.level;
    if (row.hidden) flags |= 0x10;
    if (row.hpx || row.hpt) flags |= 0x20;
    o.write_shift(1, flags);
    o.write_shift(1, 0); /* phonetic guide */ 
    /* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */ var ncolspan = 0, lcs = o.l;
    o.l += 4;
    var caddr = {
        r: R,
        c: 0
    };
    for(var i = 0; i < 16; ++i){
        if (range.s.c > i + 1 << 10 || range.e.c < i << 10) continue;
        var first = -1, last = -1;
        for(var j = i << 10; j < i + 1 << 10; ++j){
            caddr.c = j;
            var cell = Array.isArray(ws) ? (ws[caddr.r] || [])[caddr.c] : ws[$3ee4f50b1ae43a89$var$encode_cell(caddr)];
            if (cell) {
                if (first < 0) first = j;
                last = j;
            }
        }
        if (first < 0) continue;
        ++ncolspan;
        o.write_shift(4, first);
        o.write_shift(4, last);
    }
    var l = o.l;
    o.l = lcs;
    o.write_shift(4, ncolspan);
    o.l = l;
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $3ee4f50b1ae43a89$var$write_row_header(ba, ws, range, R) {
    var o = $3ee4f50b1ae43a89$var$write_BrtRowHdr(R, range, ws);
    if (o.length > 17 || (ws["!rows"] || [])[R]) $3ee4f50b1ae43a89$var$write_record(ba, 0x0000 /* BrtRowHdr */ , o);
}
/* [MS-XLSB] 2.4.820 BrtWsDim */ var $3ee4f50b1ae43a89$var$parse_BrtWsDim = $3ee4f50b1ae43a89$var$parse_UncheckedRfX;
var $3ee4f50b1ae43a89$var$write_BrtWsDim = $3ee4f50b1ae43a89$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */ function $3ee4f50b1ae43a89$var$parse_BrtWsFmtInfo() {}
//function write_BrtWsFmtInfo(ws, o) { }
/* [MS-XLSB] 2.4.823 BrtWsProp */ function $3ee4f50b1ae43a89$var$parse_BrtWsProp(data, length) {
    var z = {};
    var f = data[data.l];
    ++data.l;
    z.above = !(f & 0x40);
    z.left = !(f & 0x80);
    /* TODO: pull flags */ data.l += 18;
    z.name = $3ee4f50b1ae43a89$var$parse_XLSBCodeName(data, length - 19);
    return z;
}
function $3ee4f50b1ae43a89$var$write_BrtWsProp(str, outl, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(84 + 4 * str.length);
    var f = 0xC0;
    if (outl) {
        if (outl.above) f &= -65;
        if (outl.left) f &= -129;
    }
    o.write_shift(1, f);
    for(var i = 1; i < 3; ++i)o.write_shift(1, 0);
    $3ee4f50b1ae43a89$var$write_BrtColor({
        auto: 1
    }, o);
    o.write_shift(-4, -1);
    o.write_shift(-4, -1);
    $3ee4f50b1ae43a89$var$write_XLSBCodeName(str, o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.306 BrtCellBlank */ function $3ee4f50b1ae43a89$var$parse_BrtCellBlank(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    return [
        cell
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellBlank(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(8);
    return $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
}
function $3ee4f50b1ae43a89$var$parse_BrtShortBlank(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    return [
        cell
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortBlank(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(4);
    return $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
}
/* [MS-XLSB] 2.4.307 BrtCellBool */ function $3ee4f50b1ae43a89$var$parse_BrtCellBool(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        "b"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellBool(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(9);
    $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BrtShortBool(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        "b"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortBool(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(5);
    $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
/* [MS-XLSB] 2.4.308 BrtCellError */ function $3ee4f50b1ae43a89$var$parse_BrtCellError(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        "e"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellError(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(9);
    $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BrtShortError(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        "e"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortError(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(8);
    $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v);
    o.write_shift(2, 0);
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.4.311 BrtCellIsst */ function $3ee4f50b1ae43a89$var$parse_BrtCellIsst(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        "s"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellIsst(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(12);
    $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BrtShortIsst(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        "s"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortIsst(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(8);
    $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
/* [MS-XLSB] 2.4.313 BrtCellReal */ function $3ee4f50b1ae43a89$var$parse_BrtCellReal(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_Xnum(data);
    return [
        cell,
        value,
        "n"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellReal(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(16);
    $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
    $3ee4f50b1ae43a89$var$write_Xnum(cell.v, o);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BrtShortReal(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_Xnum(data);
    return [
        cell,
        value,
        "n"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortReal(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(12);
    $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
    $3ee4f50b1ae43a89$var$write_Xnum(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.314 BrtCellRk */ function $3ee4f50b1ae43a89$var$parse_BrtCellRk(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_RkNumber(data);
    return [
        cell,
        value,
        "n"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellRk(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(12);
    $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
    $3ee4f50b1ae43a89$var$write_RkNumber(cell.v, o);
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BrtShortRk(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_RkNumber(data);
    return [
        cell,
        value,
        "n"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortRk(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(8);
    $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
    $3ee4f50b1ae43a89$var$write_RkNumber(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.323 BrtCellRString */ function $3ee4f50b1ae43a89$var$parse_BrtCellRString(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_RichStr(data);
    return [
        cell,
        value,
        "is"
    ];
}
/* [MS-XLSB] 2.4.317 BrtCellSt */ function $3ee4f50b1ae43a89$var$parse_BrtCellSt(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    return [
        cell,
        value,
        "str"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtCellSt(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(12 + 4 * cell.v.length);
    $3ee4f50b1ae43a89$var$write_XLSBCell(ncell, o);
    $3ee4f50b1ae43a89$var$write_XLWideString(cell.v, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $3ee4f50b1ae43a89$var$parse_BrtShortSt(data) {
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBShortCell(data);
    var value = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    return [
        cell,
        value,
        "str"
    ];
}
function $3ee4f50b1ae43a89$var$write_BrtShortSt(cell, ncell, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(8 + 4 * cell.v.length);
    $3ee4f50b1ae43a89$var$write_XLSBShortCell(ncell, o);
    $3ee4f50b1ae43a89$var$write_XLWideString(cell.v, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.653 BrtFmlaBool */ function $3ee4f50b1ae43a89$var$parse_BrtFmlaBool(data, length, opts) {
    var end = data.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        "b"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $3ee4f50b1ae43a89$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $3ee4f50b1ae43a89$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.654 BrtFmlaError */ function $3ee4f50b1ae43a89$var$parse_BrtFmlaError(data, length, opts) {
    var end = data.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        "e"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $3ee4f50b1ae43a89$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $3ee4f50b1ae43a89$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.655 BrtFmlaNum */ function $3ee4f50b1ae43a89$var$parse_BrtFmlaNum(data, length, opts) {
    var end = data.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = $3ee4f50b1ae43a89$var$parse_Xnum(data);
    var o = [
        cell,
        value,
        "n"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $3ee4f50b1ae43a89$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $3ee4f50b1ae43a89$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.656 BrtFmlaString */ function $3ee4f50b1ae43a89$var$parse_BrtFmlaString(data, length, opts) {
    var end = data.l + length;
    var cell = $3ee4f50b1ae43a89$var$parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    var o = [
        cell,
        value,
        "str"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $3ee4f50b1ae43a89$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $3ee4f50b1ae43a89$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.682 BrtMergeCell */ var $3ee4f50b1ae43a89$var$parse_BrtMergeCell = $3ee4f50b1ae43a89$var$parse_UncheckedRfX;
var $3ee4f50b1ae43a89$var$write_BrtMergeCell = $3ee4f50b1ae43a89$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */ function $3ee4f50b1ae43a89$var$write_BrtBeginMergeCells(cnt, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(4);
    o.write_shift(4, cnt);
    return o;
}
/* [MS-XLSB] 2.4.662 BrtHLink */ function $3ee4f50b1ae43a89$var$parse_BrtHLink(data, length /*::, opts*/ ) {
    var end = data.l + length;
    var rfx = $3ee4f50b1ae43a89$var$parse_UncheckedRfX(data, 16);
    var relId = $3ee4f50b1ae43a89$var$parse_XLNullableWideString(data);
    var loc = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    var tooltip = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    var display = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    data.l = end;
    var o = {
        rfx: rfx,
        relId: relId,
        loc: loc,
        display: display
    } /*:any*/ ;
    if (tooltip) o.Tooltip = tooltip;
    return o;
}
function $3ee4f50b1ae43a89$var$write_BrtHLink(l, rId) {
    var o = $3ee4f50b1ae43a89$var$new_buf(50 + 4 * (l[1].Target.length + (l[1].Tooltip || "").length));
    $3ee4f50b1ae43a89$var$write_UncheckedRfX({
        s: $3ee4f50b1ae43a89$var$decode_cell(l[0]),
        e: $3ee4f50b1ae43a89$var$decode_cell(l[0])
    }, o);
    $3ee4f50b1ae43a89$var$write_RelID("rId" + rId, o);
    var locidx = l[1].Target.indexOf("#");
    var loc = locidx == -1 ? "" : l[1].Target.slice(locidx + 1);
    $3ee4f50b1ae43a89$var$write_XLWideString(loc || "", o);
    $3ee4f50b1ae43a89$var$write_XLWideString(l[1].Tooltip || "", o);
    $3ee4f50b1ae43a89$var$write_XLWideString("", o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.692 BrtPane */ function $3ee4f50b1ae43a89$var$parse_BrtPane() {}
/* [MS-XLSB] 2.4.6 BrtArrFmla */ function $3ee4f50b1ae43a89$var$parse_BrtArrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $3ee4f50b1ae43a89$var$parse_RfX(data, 16);
    var fAlwaysCalc = data.read_shift(1);
    var o = [
        rfx
    ];
    o[2] = fAlwaysCalc;
    if (opts.cellFormula) {
        var formula = $3ee4f50b1ae43a89$var$parse_XLSBArrayParsedFormula(data, end - data.l, opts);
        o[1] = formula;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.750 BrtShrFmla */ function $3ee4f50b1ae43a89$var$parse_BrtShrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $3ee4f50b1ae43a89$var$parse_UncheckedRfX(data, 16);
    var o = [
        rfx
    ];
    if (opts.cellFormula) {
        var formula = $3ee4f50b1ae43a89$var$parse_XLSBSharedParsedFormula(data, end - data.l, opts);
        o[1] = formula;
        data.l = end;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.323 BrtColInfo */ /* TODO: once XLS ColInfo is set, combine the functions */ function $3ee4f50b1ae43a89$var$write_BrtColInfo(C /*:number*/ , col, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(18);
    var p = $3ee4f50b1ae43a89$var$col_obj_w(C, col);
    o.write_shift(-4, C);
    o.write_shift(-4, C);
    o.write_shift(4, (p.width || 10) * 256);
    o.write_shift(4, 0 /*ixfe*/ ); // style
    var flags = 0;
    if (col.hidden) flags |= 0x01;
    if (typeof p.width == "number") flags |= 0x02;
    if (col.level) flags |= col.level << 8;
    o.write_shift(2, flags); // bit flag
    return o;
}
/* [MS-XLSB] 2.4.678 BrtMargins */ var $3ee4f50b1ae43a89$var$BrtMarginKeys = [
    "left",
    "right",
    "top",
    "bottom",
    "header",
    "footer"
];
function $3ee4f50b1ae43a89$var$parse_BrtMargins(data /*::, length, opts*/ ) /*:Margins*/ {
    var margins = {} /*:any*/ ;
    $3ee4f50b1ae43a89$var$BrtMarginKeys.forEach(function(k) {
        margins[k] = $3ee4f50b1ae43a89$var$parse_Xnum(data, 8);
    });
    return margins;
}
function $3ee4f50b1ae43a89$var$write_BrtMargins(margins /*:Margins*/ , o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(48);
    $3ee4f50b1ae43a89$var$default_margins(margins);
    $3ee4f50b1ae43a89$var$BrtMarginKeys.forEach(function(k) {
        $3ee4f50b1ae43a89$var$write_Xnum(margins /*:any*/ [k], o);
    });
    return o;
}
/* [MS-XLSB] 2.4.299 BrtBeginWsView */ function $3ee4f50b1ae43a89$var$parse_BrtBeginWsView(data /*::, length, opts*/ ) {
    var f = data.read_shift(2);
    data.l += 28;
    return {
        RTL: f & 0x20
    };
}
function $3ee4f50b1ae43a89$var$write_BrtBeginWsView(ws, Workbook, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(30);
    var f = 0x39c;
    if ((((Workbook || {}).Views || [])[0] || {}).RTL) f |= 0x20;
    o.write_shift(2, f); // bit flag
    o.write_shift(4, 0);
    o.write_shift(4, 0); // view first row
    o.write_shift(4, 0); // view first col
    o.write_shift(1, 0); // gridline color ICV
    o.write_shift(1, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 100); // zoom scale
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(4, 0); // workbook view id
    return o;
}
/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */ function $3ee4f50b1ae43a89$var$write_BrtCellIgnoreEC(ref) {
    var o = $3ee4f50b1ae43a89$var$new_buf(24);
    o.write_shift(4, 4);
    o.write_shift(4, 1);
    $3ee4f50b1ae43a89$var$write_UncheckedRfX(ref, o);
    return o;
}
/* [MS-XLSB] 2.4.748 BrtSheetProtection */ function $3ee4f50b1ae43a89$var$write_BrtSheetProtection(sp, o) {
    if (o == null) o = $3ee4f50b1ae43a89$var$new_buf(66);
    o.write_shift(2, sp.password ? $3ee4f50b1ae43a89$var$crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
    o.write_shift(4, 1); // this record should not be written if no protection
    [
        [
            "objects",
            false
        ],
        [
            "scenarios",
            false
        ],
        [
            "formatCells",
            true
        ],
        [
            "formatColumns",
            true
        ],
        [
            "formatRows",
            true
        ],
        [
            "insertColumns",
            true
        ],
        [
            "insertRows",
            true
        ],
        [
            "insertHyperlinks",
            true
        ],
        [
            "deleteColumns",
            true
        ],
        [
            "deleteRows",
            true
        ],
        [
            "selectLockedCells",
            false
        ],
        [
            "sort",
            true
        ],
        [
            "autoFilter",
            true
        ],
        [
            "pivotTables",
            true
        ],
        [
            "selectUnlockedCells",
            false
        ] // fSelUnlockedCells
    ].forEach(function(n) {
        /*:: if(o == null) throw "unreachable"; */ if (n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
        else o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
    });
    return o;
}
function $3ee4f50b1ae43a89$var$parse_BrtDVal() {}
function $3ee4f50b1ae43a89$var$parse_BrtDVal14() {}
/* [MS-XLSB] 2.1.7.61 Worksheet */ function $3ee4f50b1ae43a89$var$parse_ws_bin(data, _opts, idx, rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    var opts = _opts || {};
    if (!rels) rels = {
        "!id": {}
    };
    if ($3ee4f50b1ae43a89$var$DENSE != null && opts.dense == null) opts.dense = $3ee4f50b1ae43a89$var$DENSE;
    var s /*:Worksheet*/  = opts.dense ? [] : {};
    var ref;
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var state /*:Array<string>*/  = [];
    var pass = false, end = false;
    var row, p, cf, R, C, addr, sstr, rr, cell /*:Cell*/ ;
    var merges /*:Array<Range>*/  = [];
    opts.biff = 12;
    opts["!row"] = 0;
    var ai = 0, af = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var sharedf = {};
    var supbooks = opts.supbooks || /*::(*/ wb /*:: :any)*/ .supbooks || [
        []
    ];
    supbooks.sharedf = sharedf;
    supbooks.arrayf = arrayf;
    supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) {
        return x.name;
    });
    if (!opts.supbooks) {
        opts.supbooks = supbooks;
        if (wb.Names) for(var i = 0; i < wb.Names.length; ++i)supbooks[0][i + 1] = wb.Names[i];
    }
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    $3ee4f50b1ae43a89$var$XLSBRecordEnum[0x0010] = {
        n: "BrtShortReal",
        f: $3ee4f50b1ae43a89$var$parse_BrtShortReal
    };
    var cm, vm;
    $3ee4f50b1ae43a89$var$recordhopper(data, function ws_parse(val, RR, RT) {
        if (end) return;
        switch(RT){
            case 0x0094:
                /* 'BrtWsDim' */ ref = val;
                break;
            case 0x0000:
                /* 'BrtRowHdr' */ row = val;
                if (opts.sheetRows && opts.sheetRows <= row.r) end = true;
                rr = $3ee4f50b1ae43a89$var$encode_row(R = row.r);
                opts["!row"] = row.r;
                if (val.hidden || val.hpt || val.level != null) {
                    if (val.hpt) val.hpx = $3ee4f50b1ae43a89$var$pt2px(val.hpt);
                    rowinfo[val.r] = val;
                }
                break;
            case 0x0002:
            /* 'BrtCellRk' */ case 0x0003:
            /* 'BrtCellError' */ case 0x0004:
            /* 'BrtCellBool' */ case 0x0005:
            /* 'BrtCellReal' */ case 0x0006:
            /* 'BrtCellSt' */ case 0x0007:
            /* 'BrtCellIsst' */ case 0x0008:
            /* 'BrtFmlaString' */ case 0x0009:
            /* 'BrtFmlaNum' */ case 0x000A:
            /* 'BrtFmlaBool' */ case 0x000B:
            /* 'BrtFmlaError' */ case 0x000D:
            /* 'BrtShortRk' */ case 0x000E:
            /* 'BrtShortError' */ case 0x000F:
            /* 'BrtShortBool' */ case 0x0010:
            /* 'BrtShortReal' */ case 0x0011:
            /* 'BrtShortSt' */ case 0x0012:
            /* 'BrtShortIsst' */ case 0x003E:
                /* 'BrtCellRString' */ p = {
                    t: val[2]
                } /*:any*/ ;
                switch(val[2]){
                    case "n":
                        p.v = val[1];
                        break;
                    case "s":
                        sstr = $3ee4f50b1ae43a89$var$strs[val[1]];
                        p.v = sstr.t;
                        p.r = sstr.r;
                        break;
                    case "b":
                        p.v = val[1] ? true : false;
                        break;
                    case "e":
                        p.v = val[1];
                        if (opts.cellText !== false) p.w = $3ee4f50b1ae43a89$var$BErr[p.v];
                        break;
                    case "str":
                        p.t = "s";
                        p.v = val[1];
                        break;
                    case "is":
                        p.t = "s";
                        p.v = val[1].t;
                        break;
                }
                if (cf = styles.CellXf[val[0].iStyleRef]) $3ee4f50b1ae43a89$var$safe_format(p, cf.numFmtId, null, opts, themes, styles);
                C = val[0].c == -1 ? C + 1 : val[0].c;
                if (opts.dense) {
                    if (!s[R]) s[R] = [];
                    s[R][C] = p;
                } else s[$3ee4f50b1ae43a89$var$encode_col(C) + rr] = p;
                if (opts.cellFormula) {
                    af = false;
                    for(ai = 0; ai < arrayf.length; ++ai){
                        var aii = arrayf[ai];
                        if (row.r >= aii[0].s.r && row.r <= aii[0].e.r) {
                            if (C >= aii[0].s.c && C <= aii[0].e.c) {
                                p.F = $3ee4f50b1ae43a89$var$encode_range(aii[0]);
                                af = true;
                            }
                        }
                    }
                    if (!af && val.length > 3) p.f = val[3];
                }
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (opts.cellDates && cf && p.t == "n" && $3ee4f50b1ae43a89$var$fmt_is_date($3ee4f50b1ae43a89$var$table_fmt[cf.numFmtId])) {
                    var _d = $3ee4f50b1ae43a89$var$SSF_parse_date_code(p.v);
                    if (_d) {
                        p.t = "d";
                        p.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
                    }
                }
                if (cm) {
                    if (cm.type == "XLDAPR") p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x0001:
            /* 'BrtCellBlank' */ case 0x000C:
                /* 'BrtShortBlank' */ if (!opts.sheetStubs || pass) break;
                p = {
                    t: "z",
                    v: void 0
                } /*:any*/ ;
                C = val[0].c == -1 ? C + 1 : val[0].c;
                if (opts.dense) {
                    if (!s[R]) s[R] = [];
                    s[R][C] = p;
                } else s[$3ee4f50b1ae43a89$var$encode_col(C) + rr] = p;
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (cm) {
                    if (cm.type == "XLDAPR") p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x00B0:
                /* 'BrtMergeCell' */ merges.push(val);
                break;
            case 0x0031:
                cm = ((opts.xlmeta || {}).Cell || [])[val - 1];
                break;
            case 0x01EE:
                /* 'BrtHLink' */ var rel = rels["!id"][val.relId];
                if (rel) {
                    val.Target = rel.Target;
                    if (val.loc) val.Target += "#" + val.loc;
                    val.Rel = rel;
                } else if (val.relId == "") val.Target = "#" + val.loc;
                for(R = val.rfx.s.r; R <= val.rfx.e.r; ++R)for(C = val.rfx.s.c; C <= val.rfx.e.c; ++C)if (opts.dense) {
                    if (!s[R]) s[R] = [];
                    if (!s[R][C]) s[R][C] = {
                        t: "z",
                        v: undefined
                    };
                    s[R][C].l = val;
                } else {
                    addr = $3ee4f50b1ae43a89$var$encode_cell({
                        c: C,
                        r: R
                    });
                    if (!s[addr]) s[addr] = {
                        t: "z",
                        v: undefined
                    };
                    s[addr].l = val;
                }
                break;
            case 0x01AA:
                /* 'BrtArrFmla' */ if (!opts.cellFormula) break;
                arrayf.push(val);
                cell = opts.dense ? s[R][C] : s[$3ee4f50b1ae43a89$var$encode_col(C) + rr];
                cell.f = $3ee4f50b1ae43a89$var$stringify_formula(val[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                cell.F = $3ee4f50b1ae43a89$var$encode_range(val[0]);
                break;
            case 0x01AB:
                /* 'BrtShrFmla' */ if (!opts.cellFormula) break;
                sharedf[$3ee4f50b1ae43a89$var$encode_cell(val[0].s)] = val[1];
                cell = opts.dense ? s[R][C] : s[$3ee4f50b1ae43a89$var$encode_col(C) + rr];
                cell.f = $3ee4f50b1ae43a89$var$stringify_formula(val[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                break;
            /* identical to 'ColInfo' in XLS */ case 0x003C:
                /* 'BrtColInfo' */ if (!opts.cellStyles) break;
                while(val.e >= val.s){
                    colinfo[val.e--] = {
                        width: val.w / 256,
                        hidden: !!(val.flags & 0x01),
                        level: val.level
                    };
                    if (!seencol) {
                        seencol = true;
                        $3ee4f50b1ae43a89$var$find_mdw_colw(val.w / 256);
                    }
                    $3ee4f50b1ae43a89$var$process_col(colinfo[val.e + 1]);
                }
                break;
            case 0x00A1:
                /* 'BrtBeginAFilter' */ s["!autofilter"] = {
                    ref: $3ee4f50b1ae43a89$var$encode_range(val)
                };
                break;
            case 0x01DC:
                /* 'BrtMargins' */ s["!margins"] = val;
                break;
            case 0x0093:
                /* 'BrtWsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val.name) wb.Sheets[idx].CodeName = val.name;
                if (val.above || val.left) s["!outline"] = {
                    above: val.above,
                    left: val.left
                };
                break;
            case 0x0089:
                /* 'BrtBeginWsView' */ if (!wb.Views) wb.Views = [
                    {}
                ];
                if (!wb.Views[0]) wb.Views[0] = {};
                if (val.RTL) wb.Views[0].RTL = true;
                break;
            case 0x01E5:
                break;
            case 0x0040:
            /* 'BrtDVal' */ case 0x041D:
                break;
            case 0x0097:
                break;
            case 0x0098:
            /* 'BrtSel' */ case 0x00AF:
            /* 'BrtAFilterDateGroupItem' */ case 0x0284:
            /* 'BrtActiveX' */ case 0x0271:
            /* 'BrtBigName' */ case 0x0232:
            /* 'BrtBkHim' */ case 0x018C:
            /* 'BrtBrk' */ case 0x0458:
            /* 'BrtCFIcon' */ case 0x047A:
            /* 'BrtCFRuleExt' */ case 0x01D7:
            /* 'BrtCFVO' */ case 0x041A:
            /* 'BrtCFVO14' */ case 0x0289:
            /* 'BrtCellIgnoreEC' */ case 0x0451:
            /* 'BrtCellIgnoreEC14' */ case 0x024D:
            /* 'BrtCellSmartTagProperty' */ case 0x025F:
            /* 'BrtCellWatch' */ case 0x0234:
            /* 'BrtColor' */ case 0x041F:
            /* 'BrtColor14' */ case 0x00A8:
            /* 'BrtColorFilter' */ case 0x00AE:
            /* 'BrtCustomFilter' */ case 0x049C:
            /* 'BrtCustomFilter14' */ case 0x01F3:
            /* 'BrtDRef' */ case 0x01FB:
            /* 'BrtDXF' */ case 0x0226:
            /* 'BrtDrawing' */ case 0x00AB:
            /* 'BrtDynamicFilter' */ case 0x00A7:
            /* 'BrtFilter' */ case 0x0499:
            /* 'BrtFilter14' */ case 0x00A9:
            /* 'BrtIconFilter' */ case 0x049D:
            /* 'BrtIconFilter14' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x0295:
            /* 'BrtListPart' */ case 0x027F:
            /* 'BrtOleObject' */ case 0x01DE:
            /* 'BrtPageSetup' */ case 0x0219:
            /* 'BrtPhoneticInfo' */ case 0x01DD:
            /* 'BrtPrintOptions' */ case 0x0218:
            /* 'BrtRangeProtection' */ case 0x044F:
            /* 'BrtRangeProtection14' */ case 0x02A8:
            /* 'BrtRangeProtectionIso' */ case 0x0450:
            /* 'BrtRangeProtectionIso14' */ case 0x0400:
            /* 'BrtRwDescent' */ case 0x0297:
            /* 'BrtSheetCalcProp' */ case 0x0217:
            /* 'BrtSheetProtection' */ case 0x02A6:
            /* 'BrtSheetProtectionIso' */ case 0x01F8:
            /* 'BrtSlc' */ case 0x0413:
            /* 'BrtSparkline' */ case 0x01AC:
            /* 'BrtTable' */ case 0x00AA:
            /* 'BrtTop10Filter' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0032:
            /* 'BrtValueMeta' */ case 0x0816:
            /* 'BrtWebExtension' */ case 0x0415:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            default:
                if (RR.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    delete opts.supbooks;
    delete opts["!row"];
    if (!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(ref || refguess);
    if (opts.sheetRows && s["!ref"]) {
        var tmpref = $3ee4f50b1ae43a89$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $3ee4f50b1ae43a89$var$encode_range(tmpref);
        }
    }
    if (merges.length > 0) s["!merges"] = merges;
    if (colinfo.length > 0) s["!cols"] = colinfo;
    if (rowinfo.length > 0) s["!rows"] = rowinfo;
    return s;
}
/* TODO: something useful -- this is a stub */ function $3ee4f50b1ae43a89$var$write_ws_bin_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, ws /*:Worksheet*/ , last_seen /*:boolean*/ ) /*:boolean*/ {
    if (cell.v === undefined) return false;
    var vv = "";
    switch(cell.t){
        case "b":
            vv = cell.v ? "1" : "0";
            break;
        case "d":
            cell = $3ee4f50b1ae43a89$var$dup(cell);
            cell.z = cell.z || $3ee4f50b1ae43a89$var$table_fmt[14];
            cell.v = $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v));
            cell.t = "n";
            break;
        /* falls through */ case "n":
        case "e":
            vv = "" + cell.v;
            break;
        default:
            vv = cell.v;
            break;
    }
    var o /*:any*/  = {
        r: R,
        c: C
    } /*:any*/ ;
    /* TODO: cell style */ o.s = $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.l) ws["!links"].push([
        $3ee4f50b1ae43a89$var$encode_cell(o),
        cell.l
    ]);
    if (cell.c) ws["!comments"].push([
        $3ee4f50b1ae43a89$var$encode_cell(o),
        cell.c
    ]);
    switch(cell.t){
        case "s":
        case "str":
            if (opts.bookSST) {
                vv = $3ee4f50b1ae43a89$var$get_sst_id(opts.Strings, cell.v /*:any*/ , opts.revStrings);
                o.t = "s";
                o.v = vv;
                if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x0012 /* BrtShortIsst */ , $3ee4f50b1ae43a89$var$write_BrtShortIsst(cell, o));
                else $3ee4f50b1ae43a89$var$write_record(ba, 0x0007 /* BrtCellIsst */ , $3ee4f50b1ae43a89$var$write_BrtCellIsst(cell, o));
            } else {
                o.t = "str";
                if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x0011 /* BrtShortSt */ , $3ee4f50b1ae43a89$var$write_BrtShortSt(cell, o));
                else $3ee4f50b1ae43a89$var$write_record(ba, 0x0006 /* BrtCellSt */ , $3ee4f50b1ae43a89$var$write_BrtCellSt(cell, o));
            }
            return true;
        case "n":
            /* TODO: determine threshold for Real vs RK */ if (cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
                if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x000D /* BrtShortRk */ , $3ee4f50b1ae43a89$var$write_BrtShortRk(cell, o));
                else $3ee4f50b1ae43a89$var$write_record(ba, 0x0002 /* BrtCellRk */ , $3ee4f50b1ae43a89$var$write_BrtCellRk(cell, o));
            } else if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x0010 /* BrtShortReal */ , $3ee4f50b1ae43a89$var$write_BrtShortReal(cell, o));
            else $3ee4f50b1ae43a89$var$write_record(ba, 0x0005 /* BrtCellReal */ , $3ee4f50b1ae43a89$var$write_BrtCellReal(cell, o));
            return true;
        case "b":
            o.t = "b";
            if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x000F /* BrtShortBool */ , $3ee4f50b1ae43a89$var$write_BrtShortBool(cell, o));
            else $3ee4f50b1ae43a89$var$write_record(ba, 0x0004 /* BrtCellBool */ , $3ee4f50b1ae43a89$var$write_BrtCellBool(cell, o));
            return true;
        case "e":
            o.t = "e";
            if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x000E /* BrtShortError */ , $3ee4f50b1ae43a89$var$write_BrtShortError(cell, o));
            else $3ee4f50b1ae43a89$var$write_record(ba, 0x0003 /* BrtCellError */ , $3ee4f50b1ae43a89$var$write_BrtCellError(cell, o));
            return true;
    }
    if (last_seen) $3ee4f50b1ae43a89$var$write_record(ba, 0x000C /* BrtShortBlank */ , $3ee4f50b1ae43a89$var$write_BrtShortBlank(cell, o));
    else $3ee4f50b1ae43a89$var$write_record(ba, 0x0001 /* BrtCellBlank */ , $3ee4f50b1ae43a89$var$write_BrtCellBlank(cell, o));
    return true;
}
function $3ee4f50b1ae43a89$var$write_CELLTABLE(ba, ws /*:Worksheet*/ , idx /*:number*/ , opts /*::, wb:Workbook*/ ) {
    var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"] || "A1"), ref, rr = "", cols /*:Array<string>*/  = [];
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0091 /* BrtBeginSheetData */ );
    var dense = Array.isArray(ws);
    var cap = range.e.r;
    if (ws["!rows"]) cap = Math.max(range.e.r, ws["!rows"].length - 1);
    for(var R = range.s.r; R <= cap; ++R){
        rr = $3ee4f50b1ae43a89$var$encode_row(R);
        /* [ACCELLTABLE] */ /* BrtRowHdr */ $3ee4f50b1ae43a89$var$write_row_header(ba, ws, range, R);
        var last_seen = false;
        if (R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C){
            /* *16384CELL */ if (R === range.s.r) cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
            ref = cols[C] + rr;
            var cell = dense ? (ws[R] || [])[C] : ws[ref];
            if (!cell) {
                last_seen = false;
                continue;
            }
            /* write cell */ last_seen = $3ee4f50b1ae43a89$var$write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen);
        }
    }
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0092 /* BrtEndSheetData */ );
}
function $3ee4f50b1ae43a89$var$write_MERGECELLS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws["!merges"]) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x00B1 /* BrtBeginMergeCells */ , $3ee4f50b1ae43a89$var$write_BrtBeginMergeCells(ws["!merges"].length));
    ws["!merges"].forEach(function(m) {
        $3ee4f50b1ae43a89$var$write_record(ba, 0x00B0 /* BrtMergeCell */ , $3ee4f50b1ae43a89$var$write_BrtMergeCell(m));
    });
    $3ee4f50b1ae43a89$var$write_record(ba, 0x00B2 /* BrtEndMergeCells */ );
}
function $3ee4f50b1ae43a89$var$write_COLINFOS(ba, ws /*:Worksheet*/  /*::, idx:number, opts, wb:Workbook*/ ) {
    if (!ws || !ws["!cols"]) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0186 /* BrtBeginColInfos */ );
    ws["!cols"].forEach(function(m, i) {
        if (m) $3ee4f50b1ae43a89$var$write_record(ba, 0x003C /* 'BrtColInfo' */ , $3ee4f50b1ae43a89$var$write_BrtColInfo(i, m));
    });
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0187 /* BrtEndColInfos */ );
}
function $3ee4f50b1ae43a89$var$write_IGNOREECS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws["!ref"]) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0289 /* BrtCellIgnoreEC */ , $3ee4f50b1ae43a89$var$write_BrtCellIgnoreEC($3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"])));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x028A /* BrtEndCellIgnoreECs */ );
}
function $3ee4f50b1ae43a89$var$write_HLINKS(ba, ws /*:Worksheet*/ , rels) {
    /* *BrtHLink */ ws["!links"].forEach(function(l) {
        if (!l[1].Target) return;
        var rId = $3ee4f50b1ae43a89$var$add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), $3ee4f50b1ae43a89$var$RELS.HLINK);
        $3ee4f50b1ae43a89$var$write_record(ba, 0x01EE /* BrtHLink */ , $3ee4f50b1ae43a89$var$write_BrtHLink(l, rId));
    });
    delete ws["!links"];
}
function $3ee4f50b1ae43a89$var$write_LEGACYDRAWING(ba, ws /*:Worksheet*/ , idx /*:number*/ , rels) {
    /* [BrtLegacyDrawing] */ if (ws["!comments"].length > 0) {
        var rId = $3ee4f50b1ae43a89$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $3ee4f50b1ae43a89$var$RELS.VML);
        $3ee4f50b1ae43a89$var$write_record(ba, 0x0227 /* BrtLegacyDrawing */ , $3ee4f50b1ae43a89$var$write_RelID("rId" + rId));
        ws["!legacy"] = rId;
    }
}
function $3ee4f50b1ae43a89$var$write_AUTOFILTER(ba, ws, wb, idx) {
    if (!ws["!autofilter"]) return;
    var data = ws["!autofilter"];
    var ref = typeof data.ref === "string" ? data.ref : $3ee4f50b1ae43a89$var$encode_range(data.ref);
    /* Update FilterDatabase defined name for the worksheet */ if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $3ee4f50b1ae43a89$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]).e.r;
        ref = $3ee4f50b1ae43a89$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != "_xlnm._FilterDatabase") continue;
        if (name.Sheet != idx) continue;
        name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref;
        break;
    }
    if (i == names.length) names.push({
        Name: "_xlnm._FilterDatabase",
        Sheet: idx,
        Ref: "'" + wb.SheetNames[idx] + "'!" + ref
    });
    $3ee4f50b1ae43a89$var$write_record(ba, 0x00A1 /* BrtBeginAFilter */ , $3ee4f50b1ae43a89$var$write_UncheckedRfX($3ee4f50b1ae43a89$var$safe_decode_range(ref)));
    /* *FILTERCOLUMN */ /* [SORTSTATE] */ /* BrtEndAFilter */ $3ee4f50b1ae43a89$var$write_record(ba, 0x00A2 /* BrtEndAFilter */ );
}
function $3ee4f50b1ae43a89$var$write_WSVIEWS2(ba, ws, Workbook) {
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0085 /* BrtBeginWsViews */ );
    /* [ACUID] */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0089 /* BrtBeginWsView */ , $3ee4f50b1ae43a89$var$write_BrtBeginWsView(ws, Workbook));
    /* [BrtPane] */ /* *4BrtSel */ /* *4SXSELECT */ /* *FRT */ $3ee4f50b1ae43a89$var$write_record(ba, 0x008A /* BrtEndWsView */ );
    /* *FRT */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0086 /* BrtEndWsViews */ );
}
function $3ee4f50b1ae43a89$var$write_WSFMTINFO() {
/* [ACWSFMTINFO] */ // write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
}
function $3ee4f50b1ae43a89$var$write_SHEETPROTECT(ba, ws) {
    if (!ws["!protect"]) return;
    /* [BrtSheetProtectionIso] */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0217 /* BrtSheetProtection */ , $3ee4f50b1ae43a89$var$write_BrtSheetProtection(ws["!protect"]));
}
function $3ee4f50b1ae43a89$var$write_ws_bin(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var c /*:string*/  = s;
    try {
        if (wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c;
    } catch (e) {}
    var r = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"] || "A1");
    if (r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + (ws["!ref"] || "A1") + " exceeds format limit A1:XFD1048576");
        r.e.c = Math.min(r.e.c, 0x3FFF);
        r.e.r = Math.min(r.e.c, 0xFFFFF);
    }
    ws["!links"] = [];
    /* passed back to write_zip and removed there */ ws["!comments"] = [];
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0081 /* BrtBeginSheet */ );
    if (wb.vbaraw || ws["!outline"]) $3ee4f50b1ae43a89$var$write_record(ba, 0x0093 /* BrtWsProp */ , $3ee4f50b1ae43a89$var$write_BrtWsProp(c, ws["!outline"]));
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0094 /* BrtWsDim */ , $3ee4f50b1ae43a89$var$write_BrtWsDim(r));
    $3ee4f50b1ae43a89$var$write_WSVIEWS2(ba, ws, wb.Workbook);
    $3ee4f50b1ae43a89$var$write_WSFMTINFO(ba, ws);
    $3ee4f50b1ae43a89$var$write_COLINFOS(ba, ws, idx, opts, wb);
    $3ee4f50b1ae43a89$var$write_CELLTABLE(ba, ws, idx, opts, wb);
    /* [BrtSheetCalcProp] */ $3ee4f50b1ae43a89$var$write_SHEETPROTECT(ba, ws);
    /* *([BrtRangeProtectionIso] BrtRangeProtection) */ /* [SCENMAN] */ $3ee4f50b1ae43a89$var$write_AUTOFILTER(ba, ws, wb, idx);
    /* [SORTSTATE] */ /* [DCON] */ /* [USERSHVIEWS] */ $3ee4f50b1ae43a89$var$write_MERGECELLS(ba, ws);
    /* [BrtPhoneticInfo] */ /* *CONDITIONALFORMATTING */ /* [DVALS] */ $3ee4f50b1ae43a89$var$write_HLINKS(ba, ws, rels);
    /* [BrtPrintOptions] */ if (ws["!margins"]) $3ee4f50b1ae43a89$var$write_record(ba, 0x01DC /* BrtMargins */ , $3ee4f50b1ae43a89$var$write_BrtMargins(ws["!margins"]));
    /* [BrtPageSetup] */ /* [HEADERFOOTER] */ /* [RWBRK] */ /* [COLBRK] */ /* *BrtBigName */ /* [CELLWATCHES] */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) $3ee4f50b1ae43a89$var$write_IGNOREECS(ba, ws);
    /* [SMARTTAGS] */ /* [BrtDrawing] */ $3ee4f50b1ae43a89$var$write_LEGACYDRAWING(ba, ws, idx, rels);
    /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [OLEOBJECTS] */ /* [ACTIVEXCONTROLS] */ /* [WEBPUBITEMS] */ /* [LISTPARTS] */ /* FRTWORKSHEET */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0082 /* BrtEndSheet */ );
    return ba.end();
}
function $3ee4f50b1ae43a89$var$parse_Cache(data /*:string*/ ) /*:[Array<number|string>, string, ?string]*/ {
    var col /*:Array<number|string>*/  = [];
    var num = data.match(/^<c:numCache>/);
    var f;
    /* 21.2.2.150 pt CT_NumVal */ (data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg) || []).forEach(function(pt) {
        var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
        if (!q) return;
        col[+q[1]] = num ? +q[2] : q[2];
    });
    /* 21.2.2.71 formatCode CT_Xstring */ var nf = $3ee4f50b1ae43a89$var$unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || [
        "",
        "General"
    ])[1]);
    (data.match(/<c:f>(.*?)<\/c:f>/mg) || []).forEach(function(F) {
        f = F.replace(/<.*?>/g, "");
    });
    return [
        col,
        nf,
        f
    ];
}
/* 21.2 DrawingML - Charts */ function $3ee4f50b1ae43a89$var$parse_chart(data /*:?string*/ , name /*:string*/ , opts, rels, wb, csheet) {
    var cs /*:Worksheet*/  = csheet || {
        "!type": "chart"
    };
    if (!data) return csheet;
    /* 21.2.2.27 chart CT_Chart */ var C = 0, R = 0, col = "A";
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    /* 21.2.2.120 numCache CT_NumData */ (data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function(nc) {
        var cache = $3ee4f50b1ae43a89$var$parse_Cache(nc);
        refguess.s.r = refguess.s.c = 0;
        refguess.e.c = C;
        col = $3ee4f50b1ae43a89$var$encode_col(C);
        cache[0].forEach(function(n, i) {
            cs[col + $3ee4f50b1ae43a89$var$encode_row(i)] = {
                t: "n",
                v: n,
                z: cache[1]
            };
            R = i;
        });
        if (refguess.e.r < R) refguess.e.r = R;
        ++C;
    });
    if (C > 0) cs["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
    return cs;
}
/* 18.3 Worksheets also covers Chartsheets */ function $3ee4f50b1ae43a89$var$parse_cs_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    /* 18.3.1.12 chartsheet CT_ChartSheet */ if (!rels) rels = {
        "!id": {}
    };
    var s = {
        "!type": "chart",
        "!drawel": null,
        "!rel": ""
    } /*:any*/ ;
    var m;
    /* 18.3.1.83 sheetPr CT_ChartsheetPr */ var sheetPr = data.match($3ee4f50b1ae43a89$var$sheetprregex);
    if (sheetPr) $3ee4f50b1ae43a89$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    /* 18.3.1.36 drawing CT_Drawing */ if (m = data.match(/drawing r:id="(.*?)"/)) s["!rel"] = m[1];
    if (rels["!id"][s["!rel"]]) s["!drawel"] = rels["!id"][s["!rel"]];
    return s;
}
function $3ee4f50b1ae43a89$var$write_cs_xml(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER,
        $3ee4f50b1ae43a89$var$writextag("chartsheet", null, {
            "xmlns": $3ee4f50b1ae43a89$var$XMLNS_main[0],
            "xmlns:r": $3ee4f50b1ae43a89$var$XMLNS.r
        })
    ];
    o[o.length] = $3ee4f50b1ae43a89$var$writextag("drawing", null, {
        "r:id": "rId1"
    });
    $3ee4f50b1ae43a89$var$add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", $3ee4f50b1ae43a89$var$RELS.DRAW);
    if (o.length > 2) {
        o[o.length] = "</chartsheet>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.331 BrtCsProp */ function $3ee4f50b1ae43a89$var$parse_BrtCsProp(data, length /*:number*/ ) {
    data.l += 10;
    var name = $3ee4f50b1ae43a89$var$parse_XLWideString(data, length - 10);
    return {
        name: name
    };
}
/* [MS-XLSB] 2.1.7.7 Chart Sheet */ function $3ee4f50b1ae43a89$var$parse_cs_bin(data, opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        "!id": {}
    };
    var s = {
        "!type": "chart",
        "!drawel": null,
        "!rel": ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    $3ee4f50b1ae43a89$var$recordhopper(data, function cs_parse(val, R, RT) {
        switch(RT){
            case 0x0226:
                /* 'BrtDrawing' */ s["!rel"] = val;
                break;
            case 0x028B:
                /* 'BrtCsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val.name) wb.Sheets[idx].CodeName = val.name;
                break;
            case 0x0232:
            /* 'BrtBkHim' */ case 0x028C:
            /* 'BrtCsPageSetup' */ case 0x029D:
            /* 'BrtCsProtection' */ case 0x02A7:
            /* 'BrtCsProtectionIso' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x01DC:
            /* 'BrtMargins' */ case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    if (rels["!id"][s["!rel"]]) s["!drawel"] = rels["!id"][s["!rel"]];
    return s;
}
function $3ee4f50b1ae43a89$var$write_cs_bin() {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0081 /* BrtBeginSheet */ );
    /* [BrtCsProp] */ /* CSVIEWS */ /* [[BrtCsProtectionIso] BrtCsProtection] */ /* [USERCSVIEWS] */ /* [BrtMargins] */ /* [BrtCsPageSetup] */ /* [HEADERFOOTER] */ /* BrtDrawing */ /* [BrtLegacyDrawing] */ /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [WEBPUBITEMS] */ /* FRTCHARTSHEET */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0082 /* BrtEndSheet */ );
    return ba.end();
}
/* 18.2.28 (CT_WorkbookProtection) Defaults */ var $3ee4f50b1ae43a89$var$WBPropsDef = [
    [
        "allowRefreshQuery",
        false,
        "bool"
    ],
    [
        "autoCompressPictures",
        true,
        "bool"
    ],
    [
        "backupFile",
        false,
        "bool"
    ],
    [
        "checkCompatibility",
        false,
        "bool"
    ],
    [
        "CodeName",
        ""
    ],
    [
        "date1904",
        false,
        "bool"
    ],
    [
        "defaultThemeVersion",
        0,
        "int"
    ],
    [
        "filterPrivacy",
        false,
        "bool"
    ],
    [
        "hidePivotFieldList",
        false,
        "bool"
    ],
    [
        "promptedSolutions",
        false,
        "bool"
    ],
    [
        "publishItems",
        false,
        "bool"
    ],
    [
        "refreshAllConnections",
        false,
        "bool"
    ],
    [
        "saveExternalLinkValues",
        true,
        "bool"
    ],
    [
        "showBorderUnselectedTables",
        true,
        "bool"
    ],
    [
        "showInkAnnotation",
        true,
        "bool"
    ],
    [
        "showObjects",
        "all"
    ],
    [
        "showPivotChartFilter",
        false,
        "bool"
    ],
    [
        "updateLinks",
        "userSet"
    ]
];
/* 18.2.30 (CT_BookView) Defaults */ var $3ee4f50b1ae43a89$var$WBViewDef = [
    [
        "activeTab",
        0,
        "int"
    ],
    [
        "autoFilterDateGrouping",
        true,
        "bool"
    ],
    [
        "firstSheet",
        0,
        "int"
    ],
    [
        "minimized",
        false,
        "bool"
    ],
    [
        "showHorizontalScroll",
        true,
        "bool"
    ],
    [
        "showSheetTabs",
        true,
        "bool"
    ],
    [
        "showVerticalScroll",
        true,
        "bool"
    ],
    [
        "tabRatio",
        600,
        "int"
    ],
    [
        "visibility",
        "visible"
    ]
];
/* 18.2.19 (CT_Sheet) Defaults */ var $3ee4f50b1ae43a89$var$SheetDef = [];
/* 18.2.2  (CT_CalcPr) Defaults */ var $3ee4f50b1ae43a89$var$CalcPrDef = [
    [
        "calcCompleted",
        "true"
    ],
    [
        "calcMode",
        "auto"
    ],
    [
        "calcOnSave",
        "true"
    ],
    [
        "concurrentCalc",
        "true"
    ],
    [
        "fullCalcOnLoad",
        "false"
    ],
    [
        "fullPrecision",
        "true"
    ],
    [
        "iterate",
        "false"
    ],
    [
        "iterateCount",
        "100"
    ],
    [
        "iterateDelta",
        "0.001"
    ],
    [
        "refMode",
        "A1"
    ]
];
/* 18.2.3 (CT_CustomWorkbookView) Defaults */ /*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/ function $3ee4f50b1ae43a89$var$push_defaults_array(target, defaults) {
    for(var j = 0; j != target.length; ++j){
        var w = target[j];
        for(var i = 0; i != defaults.length; ++i){
            var z = defaults[i];
            if (w[z[0]] == null) w[z[0]] = z[1];
            else switch(z[2]){
                case "bool":
                    if (typeof w[z[0]] == "string") w[z[0]] = $3ee4f50b1ae43a89$var$parsexmlbool(w[z[0]]);
                    break;
                case "int":
                    if (typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10);
                    break;
            }
        }
    }
}
function $3ee4f50b1ae43a89$var$push_defaults(target, defaults) {
    for(var i = 0; i != defaults.length; ++i){
        var z = defaults[i];
        if (target[z[0]] == null) target[z[0]] = z[1];
        else switch(z[2]){
            case "bool":
                if (typeof target[z[0]] == "string") target[z[0]] = $3ee4f50b1ae43a89$var$parsexmlbool(target[z[0]]);
                break;
            case "int":
                if (typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10);
                break;
        }
    }
}
function $3ee4f50b1ae43a89$var$parse_wb_defaults(wb) {
    $3ee4f50b1ae43a89$var$push_defaults(wb.WBProps, $3ee4f50b1ae43a89$var$WBPropsDef);
    $3ee4f50b1ae43a89$var$push_defaults(wb.CalcPr, $3ee4f50b1ae43a89$var$CalcPrDef);
    $3ee4f50b1ae43a89$var$push_defaults_array(wb.WBView, $3ee4f50b1ae43a89$var$WBViewDef);
    $3ee4f50b1ae43a89$var$push_defaults_array(wb.Sheets, $3ee4f50b1ae43a89$var$SheetDef);
    $3ee4f50b1ae43a89$var$_ssfopts.date1904 = $3ee4f50b1ae43a89$var$parsexmlbool(wb.WBProps.date1904);
}
function $3ee4f50b1ae43a89$var$safe1904(wb /*:Workbook*/ ) /*:string*/ {
    /* TODO: store date1904 somewhere else */ if (!wb.Workbook) return "false";
    if (!wb.Workbook.WBProps) return "false";
    return $3ee4f50b1ae43a89$var$parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}
var $3ee4f50b1ae43a89$var$badchars = /*#__PURE__*/ "][*?/\\".split("");
function $3ee4f50b1ae43a89$var$check_ws_name(n /*:string*/ , safe /*:?boolean*/ ) /*:boolean*/ {
    if (n.length > 31) {
        if (safe) return false;
        throw new Error("Sheet names cannot exceed 31 chars");
    }
    var _good = true;
    $3ee4f50b1ae43a89$var$badchars.forEach(function(c) {
        if (n.indexOf(c) == -1) return;
        if (!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
        _good = false;
    });
    return _good;
}
function $3ee4f50b1ae43a89$var$check_wb_names(N, S, codes) {
    N.forEach(function(n, i) {
        $3ee4f50b1ae43a89$var$check_ws_name(n);
        for(var j = 0; j < i; ++j)if (n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
        if (codes) {
            var cn = S && S[i] && S[i].CodeName || n;
            if (cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
        }
    });
}
function $3ee4f50b1ae43a89$var$check_wb(wb) {
    if (!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
    if (!wb.SheetNames.length) throw new Error("Workbook is empty");
    var Sheets = wb.Workbook && wb.Workbook.Sheets || [];
    $3ee4f50b1ae43a89$var$check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
    for(var i = 0; i < wb.SheetNames.length; ++i)$3ee4f50b1ae43a89$var$check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
/* TODO: validate workbook */ }
/* 18.2 Workbook */ var $3ee4f50b1ae43a89$var$wbnsregex = /<\w+:workbook/;
function $3ee4f50b1ae43a89$var$parse_wb_xml(data, opts) /*:WorkbookFile*/ {
    if (!data) throw new Error("Could not find file");
    var wb = /*::(*/ {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        Names: [],
        xmlns: ""
    } /*::)*/ ;
    var pass = false, xmlns = "xmlns";
    var dname = {}, dnstart = 0;
    data.replace($3ee4f50b1ae43a89$var$tagregex, function xml_wb(x, idx) {
        var y /*:any*/  = $3ee4f50b1ae43a89$var$parsexmltag(x);
        switch($3ee4f50b1ae43a89$var$strip_ns(y[0])){
            case "<?xml":
                break;
            /* 18.2.27 workbook CT_Workbook 1 */ case "<workbook":
                if (x.match($3ee4f50b1ae43a89$var$wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
                wb.xmlns = y[xmlns];
                break;
            case "</workbook>":
                break;
            /* 18.2.13 fileVersion CT_FileVersion ? */ case "<fileVersion":
                delete y[0];
                wb.AppVersion = y;
                break;
            case "<fileVersion/>":
            case "</fileVersion>":
                break;
            /* 18.2.12 fileSharing CT_FileSharing ? */ case "<fileSharing":
                break;
            case "<fileSharing/>":
                break;
            /* 18.2.28 workbookPr CT_WorkbookPr ? */ case "<workbookPr":
            case "<workbookPr/>":
                $3ee4f50b1ae43a89$var$WBPropsDef.forEach(function(w) {
                    if (y[w[0]] == null) return;
                    switch(w[2]){
                        case "bool":
                            wb.WBProps[w[0]] = $3ee4f50b1ae43a89$var$parsexmlbool(y[w[0]]);
                            break;
                        case "int":
                            wb.WBProps[w[0]] = parseInt(y[w[0]], 10);
                            break;
                        default:
                            wb.WBProps[w[0]] = y[w[0]];
                    }
                });
                if (y.codeName) wb.WBProps.CodeName = $3ee4f50b1ae43a89$var$utf8read(y.codeName);
                break;
            case "</workbookPr>":
                break;
            /* 18.2.29 workbookProtection CT_WorkbookProtection ? */ case "<workbookProtection":
                break;
            case "<workbookProtection/>":
                break;
            /* 18.2.1  bookViews CT_BookViews ? */ case "<bookViews":
            case "<bookViews>":
            case "</bookViews>":
                break;
            /* 18.2.30   workbookView CT_BookView + */ case "<workbookView":
            case "<workbookView/>":
                delete y[0];
                wb.WBView.push(y);
                break;
            case "</workbookView>":
                break;
            /* 18.2.20 sheets CT_Sheets 1 */ case "<sheets":
            case "<sheets>":
            case "</sheets>":
                break; // aggregate sheet
            /* 18.2.19   sheet CT_Sheet + */ case "<sheet":
                switch(y.state){
                    case "hidden":
                        y.Hidden = 1;
                        break;
                    case "veryHidden":
                        y.Hidden = 2;
                        break;
                    default:
                        y.Hidden = 0;
                }
                delete y.state;
                y.name = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(y.name));
                delete y[0];
                wb.Sheets.push(y);
                break;
            case "</sheet>":
                break;
            /* 18.2.15 functionGroups CT_FunctionGroups ? */ case "<functionGroups":
            case "<functionGroups/>":
                break;
            /* 18.2.14   functionGroup CT_FunctionGroup + */ case "<functionGroup":
                break;
            /* 18.2.9  externalReferences CT_ExternalReferences ? */ case "<externalReferences":
            case "</externalReferences>":
            case "<externalReferences>":
                break;
            /* 18.2.8    externalReference CT_ExternalReference + */ case "<externalReference":
                break;
            /* 18.2.6  definedNames CT_DefinedNames ? */ case "<definedNames/>":
                break;
            case "<definedNames>":
            case "<definedNames":
                pass = true;
                break;
            case "</definedNames>":
                pass = false;
                break;
            /* 18.2.5    definedName CT_DefinedName + */ case "<definedName":
                dname = {};
                dname.Name = $3ee4f50b1ae43a89$var$utf8read(y.name);
                if (y.comment) dname.Comment = y.comment;
                if (y.localSheetId) dname.Sheet = +y.localSheetId;
                if ($3ee4f50b1ae43a89$var$parsexmlbool(y.hidden || "0")) dname.Hidden = true;
                dnstart = idx + x.length;
                break;
            case "</definedName>":
                dname.Ref = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$utf8read(data.slice(dnstart, idx)));
                wb.Names.push(dname);
                break;
            case "<definedName/>":
                break;
            /* 18.2.2  calcPr CT_CalcPr ? */ case "<calcPr":
                delete y[0];
                wb.CalcPr = y;
                break;
            case "<calcPr/>":
                delete y[0];
                wb.CalcPr = y;
                break;
            case "</calcPr>":
                break;
            /* 18.2.16 oleSize CT_OleSize ? (ref required) */ case "<oleSize":
                break;
            /* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */ case "<customWorkbookViews>":
            case "</customWorkbookViews>":
            case "<customWorkbookViews":
                break;
            /* 18.2.3  customWorkbookView CT_CustomWorkbookView + */ case "<customWorkbookView":
            case "</customWorkbookView>":
                break;
            /* 18.2.18 pivotCaches CT_PivotCaches ? */ case "<pivotCaches>":
            case "</pivotCaches>":
            case "<pivotCaches":
                break;
            /* 18.2.17 pivotCache CT_PivotCache ? */ case "<pivotCache":
                break;
            /* 18.2.21 smartTagPr CT_SmartTagPr ? */ case "<smartTagPr":
            case "<smartTagPr/>":
                break;
            /* 18.2.23 smartTagTypes CT_SmartTagTypes ? */ case "<smartTagTypes":
            case "<smartTagTypes>":
            case "</smartTagTypes>":
                break;
            /* 18.2.22 smartTagType CT_SmartTagType ? */ case "<smartTagType":
                break;
            /* 18.2.24 webPublishing CT_WebPublishing ? */ case "<webPublishing":
            case "<webPublishing/>":
                break;
            /* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */ case "<fileRecoveryPr":
            case "<fileRecoveryPr/>":
                break;
            /* 18.2.26 webPublishObjects CT_WebPublishObjects ? */ case "<webPublishObjects>":
            case "<webPublishObjects":
            case "</webPublishObjects>":
                break;
            /* 18.2.25 webPublishObject CT_WebPublishObject ? */ case "<webPublishObject":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            /* 18.2.7  ext CT_Extension + */ case "<ext":
                pass = true;
                break; //TODO: check with versions of excel
            case "</ext>":
                pass = false;
                break;
            /* Others */ case "<ArchID":
                break;
            case "<AlternateContent":
            case "<AlternateContent>":
                pass = true;
                break;
            case "</AlternateContent>":
                pass = false;
                break;
            /* TODO */ case "<revisionPtr":
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in workbook");
        }
        return x;
    });
    if ($3ee4f50b1ae43a89$var$XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
    $3ee4f50b1ae43a89$var$parse_wb_defaults(wb);
    return wb;
}
function $3ee4f50b1ae43a89$var$write_wb_xml(wb /*:Workbook*/  /*::, opts:?WriteOpts*/ ) /*:string*/ {
    var o = [
        $3ee4f50b1ae43a89$var$XML_HEADER
    ];
    o[o.length] = $3ee4f50b1ae43a89$var$writextag("workbook", null, {
        "xmlns": $3ee4f50b1ae43a89$var$XMLNS_main[0],
        //'xmlns:mx': XMLNS.mx,
        //'xmlns:s': XMLNS_main[0],
        "xmlns:r": $3ee4f50b1ae43a89$var$XMLNS.r
    });
    var write_names = wb.Workbook && (wb.Workbook.Names || []).length > 0;
    /* fileVersion */ /* fileSharing */ var workbookPr /*:any*/  = {
        codeName: "ThisWorkbook"
    } /*:any*/ ;
    if (wb.Workbook && wb.Workbook.WBProps) {
        $3ee4f50b1ae43a89$var$WBPropsDef.forEach(function(x) {
            /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps[x[0]] == null) return;
            if (wb.Workbook.WBProps[x[0]] == x[1]) return;
            workbookPr[x[0]] = wb.Workbook.WBProps[x[0]];
        });
        /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps.CodeName) {
            workbookPr.codeName = wb.Workbook.WBProps.CodeName;
            delete workbookPr.CodeName;
        }
    }
    o[o.length] = $3ee4f50b1ae43a89$var$writextag("workbookPr", null, workbookPr);
    /* workbookProtection */ var sheets = wb.Workbook && wb.Workbook.Sheets || [];
    var i = 0;
    /* bookViews only written if first worksheet is hidden */ if (sheets && sheets[0] && !!sheets[0].Hidden) {
        o[o.length] = "<bookViews>";
        for(i = 0; i != wb.SheetNames.length; ++i){
            if (!sheets[i]) break;
            if (!sheets[i].Hidden) break;
        }
        if (i == wb.SheetNames.length) i = 0;
        o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
        o[o.length] = "</bookViews>";
    }
    o[o.length] = "<sheets>";
    for(i = 0; i != wb.SheetNames.length; ++i){
        var sht = {
            name: $3ee4f50b1ae43a89$var$escapexml(wb.SheetNames[i].slice(0, 31))
        } /*:any*/ ;
        sht.sheetId = "" + (i + 1);
        sht["r:id"] = "rId" + (i + 1);
        if (sheets[i]) switch(sheets[i].Hidden){
            case 1:
                sht.state = "hidden";
                break;
            case 2:
                sht.state = "veryHidden";
                break;
        }
        o[o.length] = $3ee4f50b1ae43a89$var$writextag("sheet", null, sht);
    }
    o[o.length] = "</sheets>";
    /* functionGroups */ /* externalReferences */ if (write_names) {
        o[o.length] = "<definedNames>";
        if (wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
            var d /*:any*/  = {
                name: n.Name
            };
            if (n.Comment) d.comment = n.Comment;
            if (n.Sheet != null) d.localSheetId = "" + n.Sheet;
            if (n.Hidden) d.hidden = "1";
            if (!n.Ref) return;
            o[o.length] = $3ee4f50b1ae43a89$var$writextag("definedName", $3ee4f50b1ae43a89$var$escapexml(n.Ref), d);
        });
        o[o.length] = "</definedNames>";
    }
    /* calcPr */ /* oleSize */ /* customWorkbookViews */ /* pivotCaches */ /* smartTagPr */ /* smartTagTypes */ /* webPublishing */ /* fileRecoveryPr */ /* webPublishObjects */ /* extLst */ if (o.length > 2) {
        o[o.length] = "</workbook>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */ function $3ee4f50b1ae43a89$var$parse_BrtBundleSh(data, length /*:number*/ ) {
    var z = {};
    z.Hidden = data.read_shift(4); //hsState ST_SheetState
    z.iTabID = data.read_shift(4);
    z.strRelID = $3ee4f50b1ae43a89$var$parse_RelID(data, length - 8);
    z.name = $3ee4f50b1ae43a89$var$parse_XLWideString(data);
    return z;
}
function $3ee4f50b1ae43a89$var$write_BrtBundleSh(data, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(127);
    o.write_shift(4, data.Hidden);
    o.write_shift(4, data.iTabID);
    $3ee4f50b1ae43a89$var$write_RelID(data.strRelID, o);
    $3ee4f50b1ae43a89$var$write_XLWideString(data.name.slice(0, 31), o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.815 BrtWbProp */ function $3ee4f50b1ae43a89$var$parse_BrtWbProp(data, length) /*:WBProps*/ {
    var o /*:WBProps*/  = {} /*:any*/ ;
    var flags = data.read_shift(4);
    o.defaultThemeVersion = data.read_shift(4);
    var strName = length > 8 ? $3ee4f50b1ae43a89$var$parse_XLWideString(data) : "";
    if (strName.length > 0) o.CodeName = strName;
    o.autoCompressPictures = !!(flags & 0x10000);
    o.backupFile = !!(flags & 0x40);
    o.checkCompatibility = !!(flags & 0x1000);
    o.date1904 = !!(flags & 0x01);
    o.filterPrivacy = !!(flags & 0x08);
    o.hidePivotFieldList = !!(flags & 0x400);
    o.promptedSolutions = !!(flags & 0x10);
    o.publishItems = !!(flags & 0x800);
    o.refreshAllConnections = !!(flags & 0x40000);
    o.saveExternalLinkValues = !!(flags & 0x80);
    o.showBorderUnselectedTables = !!(flags & 0x04);
    o.showInkAnnotation = !!(flags & 0x20);
    o.showObjects = [
        "all",
        "placeholders",
        "none"
    ][flags >> 13 & 0x03];
    o.showPivotChartFilter = !!(flags & 0x8000);
    o.updateLinks = [
        "userSet",
        "never",
        "always"
    ][flags >> 8 & 0x03];
    return o;
}
function $3ee4f50b1ae43a89$var$write_BrtWbProp(data /*:?WBProps*/ , o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(72);
    var flags = 0;
    if (data) /* TODO: mirror parse_BrtWbProp fields */ {
        if (data.filterPrivacy) flags |= 0x08;
    }
    o.write_shift(4, flags);
    o.write_shift(4, 0);
    $3ee4f50b1ae43a89$var$write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
    return o.slice(0, o.l);
}
function $3ee4f50b1ae43a89$var$parse_BrtFRTArchID$(data, length) {
    var o = {};
    data.read_shift(4);
    o.ArchID = data.read_shift(4);
    data.l += length - 8;
    return o;
}
/* [MS-XLSB] 2.4.687 BrtName */ function $3ee4f50b1ae43a89$var$parse_BrtName(data, length, opts) {
    var end = data.l + length;
    data.l += 4; //var flags = data.read_shift(4);
    data.l += 1; //var chKey = data.read_shift(1);
    var itab = data.read_shift(4);
    var name = $3ee4f50b1ae43a89$var$parse_XLNameWideString(data);
    var formula = $3ee4f50b1ae43a89$var$parse_XLSBNameParsedFormula(data, 0, opts);
    var comment = $3ee4f50b1ae43a89$var$parse_XLNullableWideString(data);
    //if(0 /* fProc */) {
    // unusedstring1: XLNullableWideString
    // description: XLNullableWideString
    // helpTopic: XLNullableWideString
    // unusedstring2: XLNullableWideString
    //}
    data.l = end;
    var out = {
        Name: name,
        Ptg: formula
    } /*:any*/ ;
    if (itab < 0xFFFFFFF) out.Sheet = itab;
    if (comment) out.Comment = comment;
    return out;
}
/* [MS-XLSB] 2.1.7.61 Workbook */ function $3ee4f50b1ae43a89$var$parse_wb_bin(data, opts) /*:WorkbookFile*/ {
    var wb = {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        xmlns: ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    if (!opts) opts = {};
    opts.biff = 12;
    var Names = [];
    var supbooks = [
        []
    ];
    supbooks.SheetNames = [];
    supbooks.XTI = [];
    $3ee4f50b1ae43a89$var$XLSBRecordEnum[0x0010] = {
        n: "BrtFRTArchID$",
        f: $3ee4f50b1ae43a89$var$parse_BrtFRTArchID$
    };
    $3ee4f50b1ae43a89$var$recordhopper(data, function hopper_wb(val, R, RT) {
        switch(RT){
            case 0x009C:
                /* 'BrtBundleSh' */ supbooks.SheetNames.push(val.name);
                wb.Sheets.push(val);
                break;
            case 0x0099:
                /* 'BrtWbProp' */ wb.WBProps = val;
                break;
            case 0x0027:
                /* 'BrtName' */ if (val.Sheet != null) opts.SID = val.Sheet;
                val.Ref = $3ee4f50b1ae43a89$var$stringify_formula(val.Ptg, null, null, supbooks, opts);
                delete opts.SID;
                delete val.Ptg;
                Names.push(val);
                break;
            case 0x040C:
                break;
            case 0x0165:
            /* 'BrtSupSelf' */ case 0x0166:
            /* 'BrtSupSame' */ case 0x0163:
            /* 'BrtSupBookSrc' */ case 0x029B:
                /* 'BrtSupAddin' */ if (!supbooks[0].length) supbooks[0] = [
                    RT,
                    val
                ];
                else supbooks.push([
                    RT,
                    val
                ]);
                supbooks[supbooks.length - 1].XTI = [];
                break;
            case 0x016A:
                /* 'BrtExternSheet' */ if (supbooks.length === 0) {
                    supbooks[0] = [];
                    supbooks[0].XTI = [];
                }
                supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
                supbooks.XTI = supbooks.XTI.concat(val);
                break;
            case 0x0169:
                break;
            case 0x0817:
            /* 'BrtAbsPath15' */ case 0x009E:
            /* 'BrtBookView' */ case 0x008F:
            /* 'BrtBeginBundleShs' */ case 0x0298:
            /* 'BrtBeginFnGroup' */ case 0x0161:
                break;
            /* case 'BrtModelTimeGroupingCalcCol' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0C01:
            /* 'BrtRevisionPtr' */ case 0x0216:
            /* 'BrtBookProtection' */ case 0x02A5:
            /* 'BrtBookProtectionIso' */ case 0x009D:
            /* 'BrtCalcProp' */ case 0x0262:
            /* 'BrtCrashRecErr' */ case 0x0802:
            /* 'BrtDecoupledPivotCacheID' */ case 0x009B:
            /* 'BrtFileRecover' */ case 0x0224:
            /* 'BrtFileSharing' */ case 0x02A4:
            /* 'BrtFileSharingIso' */ case 0x0080:
            /* 'BrtFileVersion' */ case 0x0299:
            /* 'BrtFnGroup' */ case 0x0850:
            /* 'BrtModelRelationship' */ case 0x084D:
            /* 'BrtModelTable' */ case 0x0225:
            /* 'BrtOleSize' */ case 0x0805:
            /* 'BrtPivotTableRef' */ case 0x0254:
            /* 'BrtSmartTagType' */ case 0x081C:
            /* 'BrtTableSlicerCacheID' */ case 0x081B:
            /* 'BrtTableSlicerCacheIDs' */ case 0x0822:
            /* 'BrtTimelineCachePivotCacheID' */ case 0x018D:
            /* 'BrtUserBookView' */ case 0x009A:
            /* 'BrtWbFactoid' */ case 0x045D:
            /* 'BrtWbProp14' */ case 0x0229:
            /* 'BrtWebOpt' */ case 0x082B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ state.pop();
                pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            case 0x0010:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */  && state[state.length - 1] != 0x0023 /* BrtFRTBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    $3ee4f50b1ae43a89$var$parse_wb_defaults(wb);
    // $FlowIgnore
    wb.Names = Names;
    wb /*:any*/ .supbooks = supbooks;
    return wb;
}
function $3ee4f50b1ae43a89$var$write_BUNDLESHS(ba, wb /*::, opts*/ ) {
    $3ee4f50b1ae43a89$var$write_record(ba, 0x008F /* BrtBeginBundleShs */ );
    for(var idx = 0; idx != wb.SheetNames.length; ++idx){
        var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
        var d = {
            Hidden: viz,
            iTabID: idx + 1,
            strRelID: "rId" + (idx + 1),
            name: wb.SheetNames[idx]
        };
        $3ee4f50b1ae43a89$var$write_record(ba, 0x009C /* BrtBundleSh */ , $3ee4f50b1ae43a89$var$write_BrtBundleSh(d));
    }
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0090 /* BrtEndBundleShs */ );
}
/* [MS-XLSB] 2.4.649 BrtFileVersion */ function $3ee4f50b1ae43a89$var$write_BrtFileVersion(data, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(127);
    for(var i = 0; i != 4; ++i)o.write_shift(4, 0);
    $3ee4f50b1ae43a89$var$write_XLWideString("SheetJS", o);
    $3ee4f50b1ae43a89$var$write_XLWideString($3ee4f50b1ae43a89$var$XLSX.version, o);
    $3ee4f50b1ae43a89$var$write_XLWideString($3ee4f50b1ae43a89$var$XLSX.version, o);
    $3ee4f50b1ae43a89$var$write_XLWideString("7262", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.301 BrtBookView */ function $3ee4f50b1ae43a89$var$write_BrtBookView(idx, o) {
    if (!o) o = $3ee4f50b1ae43a89$var$new_buf(29);
    o.write_shift(-4, 0);
    o.write_shift(-4, 460);
    o.write_shift(4, 28800);
    o.write_shift(4, 17600);
    o.write_shift(4, 500);
    o.write_shift(4, idx);
    o.write_shift(4, idx);
    var flags = 0x78;
    o.write_shift(1, flags);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $3ee4f50b1ae43a89$var$write_BOOKVIEWS(ba, wb /*::, opts*/ ) {
    /* required if hidden tab appears before visible tab */ if (!wb.Workbook || !wb.Workbook.Sheets) return;
    var sheets = wb.Workbook.Sheets;
    var i = 0, vistab = -1, hidden = -1;
    for(; i < sheets.length; ++i){
        if (!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
        else if (sheets[i].Hidden == 1 && hidden == -1) hidden = i;
    }
    if (hidden > vistab) return;
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0087 /* BrtBeginBookViews */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x009E /* BrtBookView */ , $3ee4f50b1ae43a89$var$write_BrtBookView(vistab));
    /* 1*(BrtBookView *FRT) */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0088 /* BrtEndBookViews */ );
}
/* [MS-XLSB] 2.4.305 BrtCalcProp */ /*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/ /* [MS-XLSB] 2.4.646 BrtFileRecover */ /*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/ /* [MS-XLSB] 2.1.7.61 Workbook */ function $3ee4f50b1ae43a89$var$write_wb_bin(wb, opts) {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0083 /* BrtBeginBook */ );
    $3ee4f50b1ae43a89$var$write_record(ba, 0x0080 /* BrtFileVersion */ , $3ee4f50b1ae43a89$var$write_BrtFileVersion());
    /* [[BrtFileSharingIso] BrtFileSharing] */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0099 /* BrtWbProp */ , $3ee4f50b1ae43a89$var$write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
    /* [ACABSPATH] */ /* [[BrtBookProtectionIso] BrtBookProtection] */ $3ee4f50b1ae43a89$var$write_BOOKVIEWS(ba, wb, opts);
    $3ee4f50b1ae43a89$var$write_BUNDLESHS(ba, wb, opts);
    /* [FNGROUP] */ /* [EXTERNALS] */ /* *BrtName */ /* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */ /* [BrtOleSize] */ /* *(BrtUserBookView *FRT) */ /* [PIVOTCACHEIDS] */ /* [BrtWbFactoid] */ /* [SMARTTAGTYPES] */ /* [BrtWebOpt] */ /* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */ /* [WEBPUBITEMS] */ /* [CRERRS] */ /* FRTWORKBOOK */ $3ee4f50b1ae43a89$var$write_record(ba, 0x0084 /* BrtEndBook */ );
    return ba.end();
}
function $3ee4f50b1ae43a89$var$parse_wb(data, name /*:string*/ , opts) /*:WorkbookFile*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_wb_bin(data /*:any*/ , opts);
    return $3ee4f50b1ae43a89$var$parse_wb_xml(data /*:any*/ , opts);
}
function $3ee4f50b1ae43a89$var$parse_ws(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_ws_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $3ee4f50b1ae43a89$var$parse_ws_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $3ee4f50b1ae43a89$var$parse_cs(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_cs_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $3ee4f50b1ae43a89$var$parse_cs_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $3ee4f50b1ae43a89$var$parse_ms(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_ms_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $3ee4f50b1ae43a89$var$parse_ms_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $3ee4f50b1ae43a89$var$parse_ds(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_ds_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $3ee4f50b1ae43a89$var$parse_ds_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $3ee4f50b1ae43a89$var$parse_sty(data, name /*:string*/ , themes, opts) {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_sty_bin(data /*:any*/ , themes, opts);
    return $3ee4f50b1ae43a89$var$parse_sty_xml(data /*:any*/ , themes, opts);
}
function $3ee4f50b1ae43a89$var$parse_theme(data /*:string*/ , name /*:string*/ , opts) {
    return $3ee4f50b1ae43a89$var$parse_theme_xml(data, opts);
}
function $3ee4f50b1ae43a89$var$parse_sst(data, name /*:string*/ , opts) /*:SST*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_sst_bin(data /*:any*/ , opts);
    return $3ee4f50b1ae43a89$var$parse_sst_xml(data /*:any*/ , opts);
}
function $3ee4f50b1ae43a89$var$parse_cmnt(data, name /*:string*/ , opts) /*:Array<RawComment>*/ {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_comments_bin(data /*:any*/ , opts);
    return $3ee4f50b1ae43a89$var$parse_comments_xml(data /*:any*/ , opts);
}
function $3ee4f50b1ae43a89$var$parse_cc(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_cc_bin(data /*:any*/ , name, opts);
    return $3ee4f50b1ae43a89$var$parse_cc_xml(data /*:any*/ , name, opts);
}
function $3ee4f50b1ae43a89$var$parse_xlink(data, rel, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_xlink_bin(data /*:any*/ , rel, name, opts);
    return $3ee4f50b1ae43a89$var$parse_xlink_xml(data /*:any*/ , rel, name, opts);
}
function $3ee4f50b1ae43a89$var$parse_xlmeta(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $3ee4f50b1ae43a89$var$parse_xlmeta_bin(data /*:any*/ , name, opts);
    return $3ee4f50b1ae43a89$var$parse_xlmeta_xml(data /*:any*/ , name, opts);
}
function $3ee4f50b1ae43a89$var$write_wb(wb, name /*:string*/ , opts) {
    return (name.slice(-4) === ".bin" ? $3ee4f50b1ae43a89$var$write_wb_bin : $3ee4f50b1ae43a89$var$write_wb_xml)(wb, opts);
}
function $3ee4f50b1ae43a89$var$write_ws(data /*:number*/ , name /*:string*/ , opts, wb /*:Workbook*/ , rels) {
    return (name.slice(-4) === ".bin" ? $3ee4f50b1ae43a89$var$write_ws_bin : $3ee4f50b1ae43a89$var$write_ws_xml)(data, opts, wb, rels);
}
// eslint-disable-next-line no-unused-vars
function $3ee4f50b1ae43a89$var$write_cs(data /*:number*/ , name /*:string*/ , opts, wb /*:Workbook*/ , rels) {
    return (name.slice(-4) === ".bin" ? $3ee4f50b1ae43a89$var$write_cs_bin : $3ee4f50b1ae43a89$var$write_cs_xml)(data, opts, wb, rels);
}
function $3ee4f50b1ae43a89$var$write_sty(data, name /*:string*/ , opts) {
    return (name.slice(-4) === ".bin" ? $3ee4f50b1ae43a89$var$write_sty_bin : $3ee4f50b1ae43a89$var$write_sty_xml)(data, opts);
}
function $3ee4f50b1ae43a89$var$write_sst(data /*:SST*/ , name /*:string*/ , opts) {
    return (name.slice(-4) === ".bin" ? $3ee4f50b1ae43a89$var$write_sst_bin : $3ee4f50b1ae43a89$var$write_sst_xml)(data, opts);
}
function $3ee4f50b1ae43a89$var$write_cmnt(data /*:Array<any>*/ , name /*:string*/ , opts) {
    return (name.slice(-4) === ".bin" ? $3ee4f50b1ae43a89$var$write_comments_bin : $3ee4f50b1ae43a89$var$write_comments_xml)(data, opts);
}
/*
function write_cc(data, name:string, opts) {
	return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
}
*/ function $3ee4f50b1ae43a89$var$write_xlmeta(name /*:string*/ ) {
    return (name.slice(-4) === ".bin" ? $3ee4f50b1ae43a89$var$write_xlmeta_bin : $3ee4f50b1ae43a89$var$write_xlmeta_xml)();
}
var $3ee4f50b1ae43a89$var$attregexg2 = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var $3ee4f50b1ae43a89$var$attregex2 = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function $3ee4f50b1ae43a89$var$xlml_parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ ) {
    var words = tag.split(/\s+/);
    var z /*:any*/  = [];
    if (!skip_root) z[0] = words[0];
    if (words.length === 1) return z;
    var m = tag.match($3ee4f50b1ae43a89$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($3ee4f50b1ae43a89$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
function $3ee4f50b1ae43a89$var$xlml_parsexmltagobj(tag /*:string*/ ) {
    var words = tag.split(/\s+/);
    var z = {};
    if (words.length === 1) return z;
    var m = tag.match($3ee4f50b1ae43a89$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($3ee4f50b1ae43a89$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
// ----
/* map from xlml named formats to SSF TODO: localize */ var $3ee4f50b1ae43a89$var$XLMLFormatMap /*: {[string]:string}*/ ;
function $3ee4f50b1ae43a89$var$xlml_format(format, value) /*:string*/ {
    var fmt = $3ee4f50b1ae43a89$var$XLMLFormatMap[format] || $3ee4f50b1ae43a89$var$unescapexml(format);
    if (fmt === "General") return $3ee4f50b1ae43a89$var$SSF_general(value);
    return $3ee4f50b1ae43a89$var$SSF_format(fmt, value);
}
function $3ee4f50b1ae43a89$var$xlml_set_custprop(Custprops, key, cp, val /*:string*/ ) {
    var oval /*:any*/  = val;
    switch((cp[0].match(/dt:dt="([\w.]+)"/) || [
        "",
        ""
    ])[1]){
        case "boolean":
            oval = $3ee4f50b1ae43a89$var$parsexmlbool(val);
            break;
        case "i2":
        case "int":
            oval = parseInt(val, 10);
            break;
        case "r4":
        case "float":
            oval = parseFloat(val);
            break;
        case "date":
        case "dateTime.tz":
            oval = $3ee4f50b1ae43a89$var$parseDate(val);
            break;
        case "i8":
        case "string":
        case "fixed":
        case "uuid":
        case "bin.base64":
            break;
        default:
            throw new Error("bad custprop:" + cp[0]);
    }
    Custprops[$3ee4f50b1ae43a89$var$unescapexml(key)] = oval;
}
function $3ee4f50b1ae43a89$var$safe_format_xlml(cell /*:Cell*/ , nf, o) {
    if (cell.t === "z") return;
    if (!o || o.cellText !== false) try {
        if (cell.t === "e") cell.w = cell.w || $3ee4f50b1ae43a89$var$BErr[cell.v];
        else if (nf === "General") {
            if (cell.t === "n") {
                if ((cell.v | 0) === cell.v) cell.w = cell.v.toString(10);
                else cell.w = $3ee4f50b1ae43a89$var$SSF_general_num(cell.v);
            } else cell.w = $3ee4f50b1ae43a89$var$SSF_general(cell.v);
        } else cell.w = $3ee4f50b1ae43a89$var$xlml_format(nf || "General", cell.v);
    } catch (e) {
        if (o.WTF) throw e;
    }
    try {
        var z = $3ee4f50b1ae43a89$var$XLMLFormatMap[nf] || nf || "General";
        if (o.cellNF) cell.z = z;
        if (o.cellDates && cell.t == "n" && $3ee4f50b1ae43a89$var$fmt_is_date(z)) {
            var _d = $3ee4f50b1ae43a89$var$SSF_parse_date_code(cell.v);
            if (_d) {
                cell.t = "d";
                cell.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
            }
        }
    } catch (e) {
        if (o.WTF) throw e;
    }
}
function $3ee4f50b1ae43a89$var$process_style_xlml(styles, stag, opts) {
    if (opts.cellStyles) {
        if (stag.Interior) {
            var I = stag.Interior;
            if (I.Pattern) I.patternType = $3ee4f50b1ae43a89$var$XLMLPatternTypeMap[I.Pattern] || I.Pattern;
        }
    }
    styles[stag.ID] = stag;
}
/* TODO: there must exist some form of OSP-blessed spec */ function $3ee4f50b1ae43a89$var$parse_xlml_data(xml, ss, data, cell /*:any*/ , base, styles, csty, row, arrayf, o) {
    var nf = "General", sid = cell.StyleID, S = {};
    o = o || {};
    var interiors = [];
    var i = 0;
    if (sid === undefined && row) sid = row.StyleID;
    if (sid === undefined && csty) sid = csty.StyleID;
    while(styles[sid] !== undefined){
        if (styles[sid].nf) nf = styles[sid].nf;
        if (styles[sid].Interior) interiors.push(styles[sid].Interior);
        if (!styles[sid].Parent) break;
        sid = styles[sid].Parent;
    }
    switch(data.Type){
        case "Boolean":
            cell.t = "b";
            cell.v = $3ee4f50b1ae43a89$var$parsexmlbool(xml);
            break;
        case "String":
            cell.t = "s";
            cell.r = $3ee4f50b1ae43a89$var$xlml_fixstr($3ee4f50b1ae43a89$var$unescapexml(xml));
            cell.v = xml.indexOf("<") > -1 ? $3ee4f50b1ae43a89$var$unescapexml(ss || xml).replace(/<.*?>/g, "") : cell.r; // todo: BR etc
            break;
        case "DateTime":
            if (xml.slice(-1) != "Z") xml += "Z";
            cell.v = ($3ee4f50b1ae43a89$var$parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / 86400000;
            if (cell.v !== cell.v) cell.v = $3ee4f50b1ae43a89$var$unescapexml(xml);
            else if (cell.v < 60) cell.v = cell.v - 1;
            if (!nf || nf == "General") nf = "yyyy-mm-dd";
        /* falls through */ case "Number":
            if (cell.v === undefined) cell.v = +xml;
            if (!cell.t) cell.t = "n";
            break;
        case "Error":
            cell.t = "e";
            cell.v = $3ee4f50b1ae43a89$var$RBErr[xml];
            if (o.cellText !== false) cell.w = xml;
            break;
        default:
            if (xml == "" && ss == "") cell.t = "z";
            else {
                cell.t = "s";
                cell.v = $3ee4f50b1ae43a89$var$xlml_fixstr(ss || xml);
            }
            break;
    }
    $3ee4f50b1ae43a89$var$safe_format_xlml(cell, nf, o);
    if (o.cellFormula !== false) {
        if (cell.Formula) {
            var fstr = $3ee4f50b1ae43a89$var$unescapexml(cell.Formula);
            /* strictly speaking, the leading = is required but some writers omit */ if (fstr.charCodeAt(0) == 61 /* = */ ) fstr = fstr.slice(1);
            cell.f = $3ee4f50b1ae43a89$var$rc_to_a1(fstr, base);
            delete cell.Formula;
            if (cell.ArrayRange == "RC") cell.F = $3ee4f50b1ae43a89$var$rc_to_a1("RC:RC", base);
            else if (cell.ArrayRange) {
                cell.F = $3ee4f50b1ae43a89$var$rc_to_a1(cell.ArrayRange, base);
                arrayf.push([
                    $3ee4f50b1ae43a89$var$safe_decode_range(cell.F),
                    cell.F
                ]);
            }
        } else {
            for(i = 0; i < arrayf.length; ++i)if (base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r) {
                if (base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c) cell.F = arrayf[i][1];
            }
        }
    }
    if (o.cellStyles) {
        interiors.forEach(function(x) {
            if (!S.patternType && x.patternType) S.patternType = x.patternType;
        });
        cell.s = S;
    }
    if (cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}
function $3ee4f50b1ae43a89$var$xlml_clean_comment(comment /*:any*/ ) {
    comment.t = comment.v || "";
    comment.t = comment.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    comment.v = comment.w = comment.ixfe = undefined;
}
/* TODO: Everything */ function $3ee4f50b1ae43a89$var$parse_xlml_xml(d, _opts) /*:Workbook*/ {
    var opts = _opts || {};
    $3ee4f50b1ae43a89$var$make_ssf();
    var str = $3ee4f50b1ae43a89$var$debom($3ee4f50b1ae43a89$var$xlml_normalize(d));
    if (opts.type == "binary" || opts.type == "array" || opts.type == "base64") {
        if (typeof $3ee4f50b1ae43a89$var$$cptable !== "undefined") str = $3ee4f50b1ae43a89$var$$cptable.utils.decode(65001, $3ee4f50b1ae43a89$var$char_codes(str));
        else str = $3ee4f50b1ae43a89$var$utf8read(str);
    }
    var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
    opening = opening.replace(/".*?"/g, "");
    if ((opening.indexOf(">") & 1023) > Math.min(opening.indexOf(",") & 1023, opening.indexOf(";") & 1023)) {
        var _o = $3ee4f50b1ae43a89$var$dup(opts);
        _o.type = "string";
        return $3ee4f50b1ae43a89$var$PRN.to_workbook(str, _o);
    }
    if (opening.indexOf("<?xml") == -1) [
        "html",
        "table",
        "head",
        "meta",
        "script",
        "style",
        "div"
    ].forEach(function(tag) {
        if (opening.indexOf("<" + tag) >= 0) ishtml = true;
    });
    if (ishtml) return $3ee4f50b1ae43a89$var$html_to_workbook(str, opts);
    $3ee4f50b1ae43a89$var$XLMLFormatMap = {
        "General Number": "General",
        "General Date": $3ee4f50b1ae43a89$var$table_fmt[22],
        "Long Date": "dddd, mmmm dd, yyyy",
        "Medium Date": $3ee4f50b1ae43a89$var$table_fmt[15],
        "Short Date": $3ee4f50b1ae43a89$var$table_fmt[14],
        "Long Time": $3ee4f50b1ae43a89$var$table_fmt[19],
        "Medium Time": $3ee4f50b1ae43a89$var$table_fmt[18],
        "Short Time": $3ee4f50b1ae43a89$var$table_fmt[20],
        "Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        "Fixed": $3ee4f50b1ae43a89$var$table_fmt[2],
        "Standard": $3ee4f50b1ae43a89$var$table_fmt[4],
        "Percent": $3ee4f50b1ae43a89$var$table_fmt[10],
        "Scientific": $3ee4f50b1ae43a89$var$table_fmt[11],
        "Yes/No": '"Yes";"Yes";"No";@',
        "True/False": '"True";"True";"False";@',
        "On/Off": '"Yes";"Yes";"No";@'
    } /*:any*/ ;
    var Rn;
    var state = [], tmp;
    if ($3ee4f50b1ae43a89$var$DENSE != null && opts.dense == null) opts.dense = $3ee4f50b1ae43a89$var$DENSE;
    var sheets = {}, sheetnames /*:Array<string>*/  = [], cursheet /*:Worksheet*/  = opts.dense ? [] : {}, sheetname = "";
    var cell = {} /*:any*/ , row = {}; // eslint-disable-line no-unused-vars
    var dtag = $3ee4f50b1ae43a89$var$xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
    var c = 0, r = 0;
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var styles = {}, stag = {};
    var ss = "", fidx = 0;
    var merges /*:Array<Range>*/  = [];
    var Props = {}, Custprops = {}, pidx = 0, cp = [];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var cstys = [], csty, seencol = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var rowinfo /*:Array<RowInfo>*/  = [], rowobj = {}, cc = 0, rr = 0;
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        }
    } /*:any*/ , wsprops = {};
    $3ee4f50b1ae43a89$var$xlmlregex.lastIndex = 0;
    str = str.replace(/<!--([\s\S]*?)-->/mg, "");
    var raw_Rn3 = "";
    while(Rn = $3ee4f50b1ae43a89$var$xlmlregex.exec(str))switch(Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase()){
        case "data" /*case 'Data'*/ :
            if (raw_Rn3 == "data") {
                if (Rn[1] === "/") {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                    Rn[3],
                    true
                ]);
                break;
            }
            if (state[state.length - 1][1]) break;
            if (Rn[1] === "/") $3ee4f50b1ae43a89$var$parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length - 1][0] == /*"Comment"*/ "comment" ? comment : cell, {
                c: c,
                r: r
            }, styles, cstys[c], row, arrayf, opts);
            else {
                ss = "";
                dtag = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
                didx = Rn.index + Rn[0].length;
            }
            break;
        case "cell" /*case 'Cell'*/ :
            if (Rn[1] === "/") {
                if (comments.length > 0) cell.c = comments;
                if ((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) {
                    if (opts.dense) {
                        if (!cursheet[r]) cursheet[r] = [];
                        cursheet[r][c] = cell;
                    } else cursheet[$3ee4f50b1ae43a89$var$encode_col(c) + $3ee4f50b1ae43a89$var$encode_row(r)] = cell;
                }
                if (cell.HRef) {
                    cell.l = {
                        Target: $3ee4f50b1ae43a89$var$unescapexml(cell.HRef)
                    } /*:any*/ ;
                    if (cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
                    delete cell.HRef;
                    delete cell.HRefScreenTip;
                }
                if (cell.MergeAcross || cell.MergeDown) {
                    cc = c + (parseInt(cell.MergeAcross, 10) | 0);
                    rr = r + (parseInt(cell.MergeDown, 10) | 0);
                    merges.push({
                        s: {
                            c: c,
                            r: r
                        },
                        e: {
                            c: cc,
                            r: rr
                        }
                    });
                }
                if (!opts.sheetStubs) {
                    if (cell.MergeAcross) c = cc + 1;
                    else ++c;
                } else if (cell.MergeAcross || cell.MergeDown) {
                    /*:: if(!cc) cc = 0; if(!rr) rr = 0; */ for(var cma = c; cma <= cc; ++cma){
                        for(var cmd = r; cmd <= rr; ++cmd)if (cma > c || cmd > r) {
                            if (opts.dense) {
                                if (!cursheet[cmd]) cursheet[cmd] = [];
                                cursheet[cmd][cma] = {
                                    t: "z"
                                };
                            } else cursheet[$3ee4f50b1ae43a89$var$encode_col(cma) + $3ee4f50b1ae43a89$var$encode_row(cmd)] = {
                                t: "z"
                            };
                        }
                    }
                    c = cc + 1;
                } else ++c;
            } else {
                cell = $3ee4f50b1ae43a89$var$xlml_parsexmltagobj(Rn[0]);
                if (cell.Index) c = +cell.Index - 1;
                if (c < refguess.s.c) refguess.s.c = c;
                if (c > refguess.e.c) refguess.e.c = c;
                if (Rn[0].slice(-2) === "/>") ++c;
                comments = [];
            }
            break;
        case "row" /*case 'Row'*/ :
            if (Rn[1] === "/" || Rn[0].slice(-2) === "/>") {
                if (r < refguess.s.r) refguess.s.r = r;
                if (r > refguess.e.r) refguess.e.r = r;
                if (Rn[0].slice(-2) === "/>") {
                    row = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
                    if (row.Index) r = +row.Index - 1;
                }
                c = 0;
                ++r;
            } else {
                row = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
                if (row.Index) r = +row.Index - 1;
                rowobj = {};
                if (row.AutoFitHeight == "0" || row.Height) {
                    rowobj.hpx = parseInt(row.Height, 10);
                    rowobj.hpt = $3ee4f50b1ae43a89$var$px2pt(rowobj.hpx);
                    rowinfo[r] = rowobj;
                }
                if (row.Hidden == "1") {
                    rowobj.hidden = true;
                    rowinfo[r] = rowobj;
                }
            }
            break;
        case "worksheet" /*case 'Worksheet'*/ :
            /* TODO: read range from FullRows/FullColumns */ if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                sheetnames.push(sheetname);
                if (refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
                    cursheet["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
                    if (opts.sheetRows && opts.sheetRows <= refguess.e.r) {
                        cursheet["!fullref"] = cursheet["!ref"];
                        refguess.e.r = opts.sheetRows - 1;
                        cursheet["!ref"] = $3ee4f50b1ae43a89$var$encode_range(refguess);
                    }
                }
                if (merges.length) cursheet["!merges"] = merges;
                if (cstys.length > 0) cursheet["!cols"] = cstys;
                if (rowinfo.length > 0) cursheet["!rows"] = rowinfo;
                sheets[sheetname] = cursheet;
            } else {
                refguess = {
                    s: {
                        r: 2000000,
                        c: 2000000
                    },
                    e: {
                        r: 0,
                        c: 0
                    }
                };
                r = c = 0;
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
                sheetname = $3ee4f50b1ae43a89$var$unescapexml(tmp.Name);
                cursheet = opts.dense ? [] : {};
                merges = [];
                arrayf = [];
                rowinfo = [];
                wsprops = {
                    name: sheetname,
                    Hidden: 0
                };
                Workbook.Sheets.push(wsprops);
            }
            break;
        case "table" /*case 'Table'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].slice(-2) == "/>") break;
            else {
                state.push([
                    Rn[3],
                    false
                ]);
                cstys = [];
                seencol = false;
            }
            break;
        case "style" /*case 'Style'*/ :
            if (Rn[1] === "/") $3ee4f50b1ae43a89$var$process_style_xlml(styles, stag, opts);
            else stag = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
            break;
        case "numberformat" /*case 'NumberFormat'*/ :
            stag.nf = $3ee4f50b1ae43a89$var$unescapexml($3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]).Format || "General");
            if ($3ee4f50b1ae43a89$var$XLMLFormatMap[stag.nf]) stag.nf = $3ee4f50b1ae43a89$var$XLMLFormatMap[stag.nf];
            for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx)if ($3ee4f50b1ae43a89$var$table_fmt[ssfidx] == stag.nf) break;
            if (ssfidx == 0x188) {
                for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx)if ($3ee4f50b1ae43a89$var$table_fmt[ssfidx] == null) {
                    $3ee4f50b1ae43a89$var$SSF_load(stag.nf, ssfidx);
                    break;
                }
            }
            break;
        case "column" /*case 'Column'*/ :
            if (state[state.length - 1][0] !== /*'Table'*/ "table") break;
            csty = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
            if (csty.Hidden) {
                csty.hidden = true;
                delete csty.Hidden;
            }
            if (csty.Width) csty.wpx = parseInt(csty.Width, 10);
            if (!seencol && csty.wpx > 10) {
                seencol = true;
                $3ee4f50b1ae43a89$var$MDW = $3ee4f50b1ae43a89$var$DEF_MDW; //find_mdw_wpx(csty.wpx);
                for(var _col = 0; _col < cstys.length; ++_col)if (cstys[_col]) $3ee4f50b1ae43a89$var$process_col(cstys[_col]);
            }
            if (seencol) $3ee4f50b1ae43a89$var$process_col(csty);
            cstys[csty.Index - 1 || cstys.length] = csty;
            for(var i = 0; i < +csty.Span; ++i)cstys[cstys.length] = $3ee4f50b1ae43a89$var$dup(csty);
            break;
        case "namedrange" /*case 'NamedRange'*/ :
            if (Rn[1] === "/") break;
            if (!Workbook.Names) Workbook.Names = [];
            var _NamedRange = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0]);
            var _DefinedName /*:DefinedName*/  = {
                Name: _NamedRange.Name,
                Ref: $3ee4f50b1ae43a89$var$rc_to_a1(_NamedRange.RefersTo.slice(1), {
                    r: 0,
                    c: 0
                })
            } /*:any*/ ;
            if (Workbook.Sheets.length > 0) _DefinedName.Sheet = Workbook.Sheets.length - 1;
            /*:: if(Workbook.Names) */ Workbook.Names.push(_DefinedName);
            break;
        case "namedcell" /*case 'NamedCell'*/ :
            break;
        case "b" /*case 'B'*/ :
            break;
        case "i" /*case 'I'*/ :
            break;
        case "u" /*case 'U'*/ :
            break;
        case "s" /*case 'S'*/ :
            break;
        case "em" /*case 'EM'*/ :
            break;
        case "h2" /*case 'H2'*/ :
            break;
        case "h3" /*case 'H3'*/ :
            break;
        case "sub" /*case 'Sub'*/ :
            break;
        case "sup" /*case 'Sup'*/ :
            break;
        case "span" /*case 'Span'*/ :
            break;
        case "alignment" /*case 'Alignment'*/ :
            break;
        case "borders" /*case 'Borders'*/ :
            break;
        case "border" /*case 'Border'*/ :
            break;
        case "font" /*case 'Font'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") ss += str.slice(fidx, Rn.index);
            else fidx = Rn.index + Rn[0].length;
            break;
        case "interior" /*case 'Interior'*/ :
            if (!opts.cellStyles) break;
            stag.Interior = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
            break;
        case "protection" /*case 'Protection'*/ :
            break;
        case "author" /*case 'Author'*/ :
        case "title" /*case 'Title'*/ :
        case "description" /*case 'Description'*/ :
        case "created" /*case 'Created'*/ :
        case "keywords" /*case 'Keywords'*/ :
        case "subject" /*case 'Subject'*/ :
        case "category" /*case 'Category'*/ :
        case "company" /*case 'Company'*/ :
        case "lastauthor" /*case 'LastAuthor'*/ :
        case "lastsaved" /*case 'LastSaved'*/ :
        case "lastprinted" /*case 'LastPrinted'*/ :
        case "version" /*case 'Version'*/ :
        case "revision" /*case 'Revision'*/ :
        case "totaltime" /*case 'TotalTime'*/ :
        case "hyperlinkbase" /*case 'HyperlinkBase'*/ :
        case "manager" /*case 'Manager'*/ :
        case "contentstatus" /*case 'ContentStatus'*/ :
        case "identifier" /*case 'Identifier'*/ :
        case "language" /*case 'Language'*/ :
        case "appname" /*case 'AppName'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") $3ee4f50b1ae43a89$var$xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
            else pidx = Rn.index + Rn[0].length;
            break;
        case "paragraphs" /*case 'Paragraphs'*/ :
            break;
        case "styles" /*case 'Styles'*/ :
        case "workbook" /*case 'Workbook'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else state.push([
                Rn[3],
                false
            ]);
            break;
        case "comment" /*case 'Comment'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                $3ee4f50b1ae43a89$var$xlml_clean_comment(comment);
                comments.push(comment);
            } else {
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
                comment = {
                    a: tmp.Author
                } /*:any*/ ;
            }
            break;
        case "autofilter" /*case 'AutoFilter'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                var AutoFilter = $3ee4f50b1ae43a89$var$xlml_parsexmltag(Rn[0]);
                cursheet["!autofilter"] = {
                    ref: $3ee4f50b1ae43a89$var$rc_to_a1(AutoFilter.Range).replace(/\$/g, "")
                };
                state.push([
                    Rn[3],
                    true
                ]);
            }
            break;
        case "name" /*case 'Name'*/ :
            break;
        case "datavalidation" /*case 'DataValidation'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                true
            ]);
            break;
        case "pixelsperinch" /*case 'PixelsPerInch'*/ :
            break;
        case "componentoptions" /*case 'ComponentOptions'*/ :
        case "documentproperties" /*case 'DocumentProperties'*/ :
        case "customdocumentproperties" /*case 'CustomDocumentProperties'*/ :
        case "officedocumentsettings" /*case 'OfficeDocumentSettings'*/ :
        case "pivottable" /*case 'PivotTable'*/ :
        case "pivotcache" /*case 'PivotCache'*/ :
        case "names" /*case 'Names'*/ :
        case "mapinfo" /*case 'MapInfo'*/ :
        case "pagebreaks" /*case 'PageBreaks'*/ :
        case "querytable" /*case 'QueryTable'*/ :
        case "sorting" /*case 'Sorting'*/ :
        case "schema" /*case 'Schema'*/ :
        case "conditionalformatting" /*case 'ConditionalFormatting'*/ :
        case "smarttagtype" /*case 'SmartTagType'*/ :
        case "smarttags" /*case 'SmartTags'*/ :
        case "excelworkbook" /*case 'ExcelWorkbook'*/ :
        case "workbookoptions" /*case 'WorkbookOptions'*/ :
        case "worksheetoptions" /*case 'WorksheetOptions'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                true
            ]);
            break;
        case "null" /*case 'Null'*/ :
            break;
        default:
            /* FODS file root is <office:document> */ if (state.length == 0 && Rn[3] == "document") return $3ee4f50b1ae43a89$var$parse_fods(str, opts);
            /* UOS file root is <uof:UOF> */ if (state.length == 0 && Rn[3] == "uof" /*"UOF"*/ ) return $3ee4f50b1ae43a89$var$parse_fods(str, opts);
            var seen = true;
            switch(state[state.length - 1][0]){
                /* OfficeDocumentSettings */ case "officedocumentsettings" /*case 'OfficeDocumentSettings'*/ :
                    switch(Rn[3]){
                        case "allowpng" /*case 'AllowPNG'*/ :
                            break;
                        case "removepersonalinformation" /*case 'RemovePersonalInformation'*/ :
                            break;
                        case "downloadcomponents" /*case 'DownloadComponents'*/ :
                            break;
                        case "locationofcomponents" /*case 'LocationOfComponents'*/ :
                            break;
                        case "colors" /*case 'Colors'*/ :
                            break;
                        case "color" /*case 'Color'*/ :
                            break;
                        case "index" /*case 'Index'*/ :
                            break;
                        case "rgb" /*case 'RGB'*/ :
                            break;
                        case "targetscreensize" /*case 'TargetScreenSize'*/ :
                            break;
                        case "readonlyrecommended" /*case 'ReadOnlyRecommended'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ComponentOptions */ case "componentoptions" /*case 'ComponentOptions'*/ :
                    switch(Rn[3]){
                        case "toolbar" /*case 'Toolbar'*/ :
                            break;
                        case "hideofficelogo" /*case 'HideOfficeLogo'*/ :
                            break;
                        case "spreadsheetautofit" /*case 'SpreadsheetAutoFit'*/ :
                            break;
                        case "label" /*case 'Label'*/ :
                            break;
                        case "caption" /*case 'Caption'*/ :
                            break;
                        case "maxheight" /*case 'MaxHeight'*/ :
                            break;
                        case "maxwidth" /*case 'MaxWidth'*/ :
                            break;
                        case "nextsheetnumber" /*case 'NextSheetNumber'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ExcelWorkbook */ case "excelworkbook" /*case 'ExcelWorkbook'*/ :
                    switch(Rn[3]){
                        case "date1904" /*case 'Date1904'*/ :
                            /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ Workbook.WBProps.date1904 = true;
                            break;
                        case "windowheight" /*case 'WindowHeight'*/ :
                            break;
                        case "windowwidth" /*case 'WindowWidth'*/ :
                            break;
                        case "windowtopx" /*case 'WindowTopX'*/ :
                            break;
                        case "windowtopy" /*case 'WindowTopY'*/ :
                            break;
                        case "tabratio" /*case 'TabRatio'*/ :
                            break;
                        case "protectstructure" /*case 'ProtectStructure'*/ :
                            break;
                        case "protectwindow" /*case 'ProtectWindow'*/ :
                            break;
                        case "protectwindows" /*case 'ProtectWindows'*/ :
                            break;
                        case "activesheet" /*case 'ActiveSheet'*/ :
                            break;
                        case "displayinknotes" /*case 'DisplayInkNotes'*/ :
                            break;
                        case "firstvisiblesheet" /*case 'FirstVisibleSheet'*/ :
                            break;
                        case "supbook" /*case 'SupBook'*/ :
                            break;
                        case "sheetname" /*case 'SheetName'*/ :
                            break;
                        case "sheetindex" /*case 'SheetIndex'*/ :
                            break;
                        case "sheetindexfirst" /*case 'SheetIndexFirst'*/ :
                            break;
                        case "sheetindexlast" /*case 'SheetIndexLast'*/ :
                            break;
                        case "dll" /*case 'Dll'*/ :
                            break;
                        case "acceptlabelsinformulas" /*case 'AcceptLabelsInFormulas'*/ :
                            break;
                        case "donotsavelinkvalues" /*case 'DoNotSaveLinkValues'*/ :
                            break;
                        case "iteration" /*case 'Iteration'*/ :
                            break;
                        case "maxiterations" /*case 'MaxIterations'*/ :
                            break;
                        case "maxchange" /*case 'MaxChange'*/ :
                            break;
                        case "path" /*case 'Path'*/ :
                            break;
                        case "xct" /*case 'Xct'*/ :
                            break;
                        case "count" /*case 'Count'*/ :
                            break;
                        case "selectedsheets" /*case 'SelectedSheets'*/ :
                            break;
                        case "calculation" /*case 'Calculation'*/ :
                            break;
                        case "uncalced" /*case 'Uncalced'*/ :
                            break;
                        case "startupprompt" /*case 'StartupPrompt'*/ :
                            break;
                        case "crn" /*case 'Crn'*/ :
                            break;
                        case "externname" /*case 'ExternName'*/ :
                            break;
                        case "formula" /*case 'Formula'*/ :
                            break;
                        case "colfirst" /*case 'ColFirst'*/ :
                            break;
                        case "collast" /*case 'ColLast'*/ :
                            break;
                        case "wantadvise" /*case 'WantAdvise'*/ :
                            break;
                        case "boolean" /*case 'Boolean'*/ :
                            break;
                        case "error" /*case 'Error'*/ :
                            break;
                        case "text" /*case 'Text'*/ :
                            break;
                        case "ole" /*case 'OLE'*/ :
                            break;
                        case "noautorecover" /*case 'NoAutoRecover'*/ :
                            break;
                        case "publishobjects" /*case 'PublishObjects'*/ :
                            break;
                        case "donotcalculatebeforesave" /*case 'DoNotCalculateBeforeSave'*/ :
                            break;
                        case "number" /*case 'Number'*/ :
                            break;
                        case "refmoder1c1" /*case 'RefModeR1C1'*/ :
                            break;
                        case "embedsavesmarttags" /*case 'EmbedSaveSmartTags'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorkbookOptions */ case "workbookoptions" /*case 'WorkbookOptions'*/ :
                    switch(Rn[3]){
                        case "owcversion" /*case 'OWCVersion'*/ :
                            break;
                        case "height" /*case 'Height'*/ :
                            break;
                        case "width" /*case 'Width'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorksheetOptions */ case "worksheetoptions" /*case 'WorksheetOptions'*/ :
                    switch(Rn[3]){
                        case "visible" /*case 'Visible'*/ :
                            if (Rn[0].slice(-2) === "/>") ;
                            else if (Rn[1] === "/") switch(str.slice(pidx, Rn.index)){
                                case "SheetHidden":
                                    wsprops.Hidden = 1;
                                    break;
                                case "SheetVeryHidden":
                                    wsprops.Hidden = 2;
                                    break;
                            }
                            else pidx = Rn.index + Rn[0].length;
                            break;
                        case "header" /*case 'Header'*/ :
                            if (!cursheet["!margins"]) $3ee4f50b1ae43a89$var$default_margins(cursheet["!margins"] = {}, "xlml");
                            if (!isNaN(+$3ee4f50b1ae43a89$var$parsexmltag(Rn[0]).Margin)) cursheet["!margins"].header = +$3ee4f50b1ae43a89$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case "footer" /*case 'Footer'*/ :
                            if (!cursheet["!margins"]) $3ee4f50b1ae43a89$var$default_margins(cursheet["!margins"] = {}, "xlml");
                            if (!isNaN(+$3ee4f50b1ae43a89$var$parsexmltag(Rn[0]).Margin)) cursheet["!margins"].footer = +$3ee4f50b1ae43a89$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case "pagemargins" /*case 'PageMargins'*/ :
                            var pagemargins = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0]);
                            if (!cursheet["!margins"]) $3ee4f50b1ae43a89$var$default_margins(cursheet["!margins"] = {}, "xlml");
                            if (!isNaN(+pagemargins.Top)) cursheet["!margins"].top = +pagemargins.Top;
                            if (!isNaN(+pagemargins.Left)) cursheet["!margins"].left = +pagemargins.Left;
                            if (!isNaN(+pagemargins.Right)) cursheet["!margins"].right = +pagemargins.Right;
                            if (!isNaN(+pagemargins.Bottom)) cursheet["!margins"].bottom = +pagemargins.Bottom;
                            break;
                        case "displayrighttoleft" /*case 'DisplayRightToLeft'*/ :
                            if (!Workbook.Views) Workbook.Views = [];
                            if (!Workbook.Views[0]) Workbook.Views[0] = {};
                            Workbook.Views[0].RTL = true;
                            break;
                        case "freezepanes" /*case 'FreezePanes'*/ :
                            break;
                        case "frozennosplit" /*case 'FrozenNoSplit'*/ :
                            break;
                        case "splithorizontal" /*case 'SplitHorizontal'*/ :
                        case "splitvertical" /*case 'SplitVertical'*/ :
                            break;
                        case "donotdisplaygridlines" /*case 'DoNotDisplayGridlines'*/ :
                            break;
                        case "activerow" /*case 'ActiveRow'*/ :
                            break;
                        case "activecol" /*case 'ActiveCol'*/ :
                            break;
                        case "toprowbottompane" /*case 'TopRowBottomPane'*/ :
                            break;
                        case "leftcolumnrightpane" /*case 'LeftColumnRightPane'*/ :
                            break;
                        case "unsynced" /*case 'Unsynced'*/ :
                            break;
                        case "print" /*case 'Print'*/ :
                            break;
                        case "printerrors" /*case 'PrintErrors'*/ :
                            break;
                        case "panes" /*case 'Panes'*/ :
                            break;
                        case "scale" /*case 'Scale'*/ :
                            break;
                        case "pane" /*case 'Pane'*/ :
                            break;
                        case "number" /*case 'Number'*/ :
                            break;
                        case "layout" /*case 'Layout'*/ :
                            break;
                        case "pagesetup" /*case 'PageSetup'*/ :
                            break;
                        case "selected" /*case 'Selected'*/ :
                            break;
                        case "protectobjects" /*case 'ProtectObjects'*/ :
                            break;
                        case "enableselection" /*case 'EnableSelection'*/ :
                            break;
                        case "protectscenarios" /*case 'ProtectScenarios'*/ :
                            break;
                        case "validprinterinfo" /*case 'ValidPrinterInfo'*/ :
                            break;
                        case "horizontalresolution" /*case 'HorizontalResolution'*/ :
                            break;
                        case "verticalresolution" /*case 'VerticalResolution'*/ :
                            break;
                        case "numberofcopies" /*case 'NumberofCopies'*/ :
                            break;
                        case "activepane" /*case 'ActivePane'*/ :
                            break;
                        case "toprowvisible" /*case 'TopRowVisible'*/ :
                            break;
                        case "leftcolumnvisible" /*case 'LeftColumnVisible'*/ :
                            break;
                        case "fittopage" /*case 'FitToPage'*/ :
                            break;
                        case "rangeselection" /*case 'RangeSelection'*/ :
                            break;
                        case "papersizeindex" /*case 'PaperSizeIndex'*/ :
                            break;
                        case "pagelayoutzoom" /*case 'PageLayoutZoom'*/ :
                            break;
                        case "pagebreakzoom" /*case 'PageBreakZoom'*/ :
                            break;
                        case "filteron" /*case 'FilterOn'*/ :
                            break;
                        case "fitwidth" /*case 'FitWidth'*/ :
                            break;
                        case "fitheight" /*case 'FitHeight'*/ :
                            break;
                        case "commentslayout" /*case 'CommentsLayout'*/ :
                            break;
                        case "zoom" /*case 'Zoom'*/ :
                            break;
                        case "lefttoright" /*case 'LeftToRight'*/ :
                            break;
                        case "gridlines" /*case 'Gridlines'*/ :
                            break;
                        case "allowsort" /*case 'AllowSort'*/ :
                            break;
                        case "allowfilter" /*case 'AllowFilter'*/ :
                            break;
                        case "allowinsertrows" /*case 'AllowInsertRows'*/ :
                            break;
                        case "allowdeleterows" /*case 'AllowDeleteRows'*/ :
                            break;
                        case "allowinsertcols" /*case 'AllowInsertCols'*/ :
                            break;
                        case "allowdeletecols" /*case 'AllowDeleteCols'*/ :
                            break;
                        case "allowinserthyperlinks" /*case 'AllowInsertHyperlinks'*/ :
                            break;
                        case "allowformatcells" /*case 'AllowFormatCells'*/ :
                            break;
                        case "allowsizecols" /*case 'AllowSizeCols'*/ :
                            break;
                        case "allowsizerows" /*case 'AllowSizeRows'*/ :
                            break;
                        case "nosummaryrowsbelowdetail" /*case 'NoSummaryRowsBelowDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].above = true;
                            break;
                        case "tabcolorindex" /*case 'TabColorIndex'*/ :
                            break;
                        case "donotdisplayheadings" /*case 'DoNotDisplayHeadings'*/ :
                            break;
                        case "showpagelayoutzoom" /*case 'ShowPageLayoutZoom'*/ :
                            break;
                        case "nosummarycolumnsrightdetail" /*case 'NoSummaryColumnsRightDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].left = true;
                            break;
                        case "blackandwhite" /*case 'BlackAndWhite'*/ :
                            break;
                        case "donotdisplayzeros" /*case 'DoNotDisplayZeros'*/ :
                            break;
                        case "displaypagebreak" /*case 'DisplayPageBreak'*/ :
                            break;
                        case "rowcolheadings" /*case 'RowColHeadings'*/ :
                            break;
                        case "donotdisplayoutline" /*case 'DoNotDisplayOutline'*/ :
                            break;
                        case "noorientation" /*case 'NoOrientation'*/ :
                            break;
                        case "allowusepivottables" /*case 'AllowUsePivotTables'*/ :
                            break;
                        case "zeroheight" /*case 'ZeroHeight'*/ :
                            break;
                        case "viewablerange" /*case 'ViewableRange'*/ :
                            break;
                        case "selection" /*case 'Selection'*/ :
                            break;
                        case "protectcontents" /*case 'ProtectContents'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PivotTable */ case "pivottable" /*case 'PivotTable'*/ :
                case "pivotcache" /*case 'PivotCache'*/ :
                    switch(Rn[3]){
                        case "immediateitemsondrop" /*case 'ImmediateItemsOnDrop'*/ :
                            break;
                        case "showpagemultipleitemlabel" /*case 'ShowPageMultipleItemLabel'*/ :
                            break;
                        case "compactrowindent" /*case 'CompactRowIndent'*/ :
                            break;
                        case "location" /*case 'Location'*/ :
                            break;
                        case "pivotfield" /*case 'PivotField'*/ :
                            break;
                        case "orientation" /*case 'Orientation'*/ :
                            break;
                        case "layoutform" /*case 'LayoutForm'*/ :
                            break;
                        case "layoutsubtotallocation" /*case 'LayoutSubtotalLocation'*/ :
                            break;
                        case "layoutcompactrow" /*case 'LayoutCompactRow'*/ :
                            break;
                        case "position" /*case 'Position'*/ :
                            break;
                        case "pivotitem" /*case 'PivotItem'*/ :
                            break;
                        case "datatype" /*case 'DataType'*/ :
                            break;
                        case "datafield" /*case 'DataField'*/ :
                            break;
                        case "sourcename" /*case 'SourceName'*/ :
                            break;
                        case "parentfield" /*case 'ParentField'*/ :
                            break;
                        case "ptlineitems" /*case 'PTLineItems'*/ :
                            break;
                        case "ptlineitem" /*case 'PTLineItem'*/ :
                            break;
                        case "countofsameitems" /*case 'CountOfSameItems'*/ :
                            break;
                        case "item" /*case 'Item'*/ :
                            break;
                        case "itemtype" /*case 'ItemType'*/ :
                            break;
                        case "ptsource" /*case 'PTSource'*/ :
                            break;
                        case "cacheindex" /*case 'CacheIndex'*/ :
                            break;
                        case "consolidationreference" /*case 'ConsolidationReference'*/ :
                            break;
                        case "filename" /*case 'FileName'*/ :
                            break;
                        case "reference" /*case 'Reference'*/ :
                            break;
                        case "nocolumngrand" /*case 'NoColumnGrand'*/ :
                            break;
                        case "norowgrand" /*case 'NoRowGrand'*/ :
                            break;
                        case "blanklineafteritems" /*case 'BlankLineAfterItems'*/ :
                            break;
                        case "hidden" /*case 'Hidden'*/ :
                            break;
                        case "subtotal" /*case 'Subtotal'*/ :
                            break;
                        case "basefield" /*case 'BaseField'*/ :
                            break;
                        case "mapchilditems" /*case 'MapChildItems'*/ :
                            break;
                        case "function" /*case 'Function'*/ :
                            break;
                        case "refreshonfileopen" /*case 'RefreshOnFileOpen'*/ :
                            break;
                        case "printsettitles" /*case 'PrintSetTitles'*/ :
                            break;
                        case "mergelabels" /*case 'MergeLabels'*/ :
                            break;
                        case "defaultversion" /*case 'DefaultVersion'*/ :
                            break;
                        case "refreshname" /*case 'RefreshName'*/ :
                            break;
                        case "refreshdate" /*case 'RefreshDate'*/ :
                            break;
                        case "refreshdatecopy" /*case 'RefreshDateCopy'*/ :
                            break;
                        case "versionlastrefresh" /*case 'VersionLastRefresh'*/ :
                            break;
                        case "versionlastupdate" /*case 'VersionLastUpdate'*/ :
                            break;
                        case "versionupdateablemin" /*case 'VersionUpdateableMin'*/ :
                            break;
                        case "versionrefreshablemin" /*case 'VersionRefreshableMin'*/ :
                            break;
                        case "calculation" /*case 'Calculation'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PageBreaks */ case "pagebreaks" /*case 'PageBreaks'*/ :
                    switch(Rn[3]){
                        case "colbreaks" /*case 'ColBreaks'*/ :
                            break;
                        case "colbreak" /*case 'ColBreak'*/ :
                            break;
                        case "rowbreaks" /*case 'RowBreaks'*/ :
                            break;
                        case "rowbreak" /*case 'RowBreak'*/ :
                            break;
                        case "colstart" /*case 'ColStart'*/ :
                            break;
                        case "colend" /*case 'ColEnd'*/ :
                            break;
                        case "rowend" /*case 'RowEnd'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* AutoFilter */ case "autofilter" /*case 'AutoFilter'*/ :
                    switch(Rn[3]){
                        case "autofiltercolumn" /*case 'AutoFilterColumn'*/ :
                            break;
                        case "autofiltercondition" /*case 'AutoFilterCondition'*/ :
                            break;
                        case "autofilterand" /*case 'AutoFilterAnd'*/ :
                            break;
                        case "autofilteror" /*case 'AutoFilterOr'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* QueryTable */ case "querytable" /*case 'QueryTable'*/ :
                    switch(Rn[3]){
                        case "id" /*case 'Id'*/ :
                            break;
                        case "autoformatfont" /*case 'AutoFormatFont'*/ :
                            break;
                        case "autoformatpattern" /*case 'AutoFormatPattern'*/ :
                            break;
                        case "querysource" /*case 'QuerySource'*/ :
                            break;
                        case "querytype" /*case 'QueryType'*/ :
                            break;
                        case "enableredirections" /*case 'EnableRedirections'*/ :
                            break;
                        case "refreshedinxl9" /*case 'RefreshedInXl9'*/ :
                            break;
                        case "urlstring" /*case 'URLString'*/ :
                            break;
                        case "htmltables" /*case 'HTMLTables'*/ :
                            break;
                        case "connection" /*case 'Connection'*/ :
                            break;
                        case "commandtext" /*case 'CommandText'*/ :
                            break;
                        case "refreshinfo" /*case 'RefreshInfo'*/ :
                            break;
                        case "notitles" /*case 'NoTitles'*/ :
                            break;
                        case "nextid" /*case 'NextId'*/ :
                            break;
                        case "columninfo" /*case 'ColumnInfo'*/ :
                            break;
                        case "overwritecells" /*case 'OverwriteCells'*/ :
                            break;
                        case "donotpromptforfile" /*case 'DoNotPromptForFile'*/ :
                            break;
                        case "textwizardsettings" /*case 'TextWizardSettings'*/ :
                            break;
                        case "source" /*case 'Source'*/ :
                            break;
                        case "number" /*case 'Number'*/ :
                            break;
                        case "decimal" /*case 'Decimal'*/ :
                            break;
                        case "thousandseparator" /*case 'ThousandSeparator'*/ :
                            break;
                        case "trailingminusnumbers" /*case 'TrailingMinusNumbers'*/ :
                            break;
                        case "formatsettings" /*case 'FormatSettings'*/ :
                            break;
                        case "fieldtype" /*case 'FieldType'*/ :
                            break;
                        case "delimiters" /*case 'Delimiters'*/ :
                            break;
                        case "tab" /*case 'Tab'*/ :
                            break;
                        case "comma" /*case 'Comma'*/ :
                            break;
                        case "autoformatname" /*case 'AutoFormatName'*/ :
                            break;
                        case "versionlastedit" /*case 'VersionLastEdit'*/ :
                            break;
                        case "versionlastrefresh" /*case 'VersionLastRefresh'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case "datavalidation" /*case 'DataValidation'*/ :
                    switch(Rn[3]){
                        case "range" /*case 'Range'*/ :
                            break;
                        case "type" /*case 'Type'*/ :
                            break;
                        case "min" /*case 'Min'*/ :
                            break;
                        case "max" /*case 'Max'*/ :
                            break;
                        case "sort" /*case 'Sort'*/ :
                            break;
                        case "descending" /*case 'Descending'*/ :
                            break;
                        case "order" /*case 'Order'*/ :
                            break;
                        case "casesensitive" /*case 'CaseSensitive'*/ :
                            break;
                        case "value" /*case 'Value'*/ :
                            break;
                        case "errorstyle" /*case 'ErrorStyle'*/ :
                            break;
                        case "errormessage" /*case 'ErrorMessage'*/ :
                            break;
                        case "errortitle" /*case 'ErrorTitle'*/ :
                            break;
                        case "inputmessage" /*case 'InputMessage'*/ :
                            break;
                        case "inputtitle" /*case 'InputTitle'*/ :
                            break;
                        case "combohide" /*case 'ComboHide'*/ :
                            break;
                        case "inputhide" /*case 'InputHide'*/ :
                            break;
                        case "condition" /*case 'Condition'*/ :
                            break;
                        case "qualifier" /*case 'Qualifier'*/ :
                            break;
                        case "useblank" /*case 'UseBlank'*/ :
                            break;
                        case "value1" /*case 'Value1'*/ :
                            break;
                        case "value2" /*case 'Value2'*/ :
                            break;
                        case "format" /*case 'Format'*/ :
                            break;
                        case "cellrangelist" /*case 'CellRangeList'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case "sorting" /*case 'Sorting'*/ :
                case "conditionalformatting" /*case 'ConditionalFormatting'*/ :
                    switch(Rn[3]){
                        case "range" /*case 'Range'*/ :
                            break;
                        case "type" /*case 'Type'*/ :
                            break;
                        case "min" /*case 'Min'*/ :
                            break;
                        case "max" /*case 'Max'*/ :
                            break;
                        case "sort" /*case 'Sort'*/ :
                            break;
                        case "descending" /*case 'Descending'*/ :
                            break;
                        case "order" /*case 'Order'*/ :
                            break;
                        case "casesensitive" /*case 'CaseSensitive'*/ :
                            break;
                        case "value" /*case 'Value'*/ :
                            break;
                        case "errorstyle" /*case 'ErrorStyle'*/ :
                            break;
                        case "errormessage" /*case 'ErrorMessage'*/ :
                            break;
                        case "errortitle" /*case 'ErrorTitle'*/ :
                            break;
                        case "cellrangelist" /*case 'CellRangeList'*/ :
                            break;
                        case "inputmessage" /*case 'InputMessage'*/ :
                            break;
                        case "inputtitle" /*case 'InputTitle'*/ :
                            break;
                        case "combohide" /*case 'ComboHide'*/ :
                            break;
                        case "inputhide" /*case 'InputHide'*/ :
                            break;
                        case "condition" /*case 'Condition'*/ :
                            break;
                        case "qualifier" /*case 'Qualifier'*/ :
                            break;
                        case "useblank" /*case 'UseBlank'*/ :
                            break;
                        case "value1" /*case 'Value1'*/ :
                            break;
                        case "value2" /*case 'Value2'*/ :
                            break;
                        case "format" /*case 'Format'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* MapInfo (schema) */ case "mapinfo" /*case 'MapInfo'*/ :
                case "schema" /*case 'Schema'*/ :
                case "data" /*case 'data'*/ :
                    switch(Rn[3]){
                        case "map" /*case 'Map'*/ :
                            break;
                        case "entry" /*case 'Entry'*/ :
                            break;
                        case "range" /*case 'Range'*/ :
                            break;
                        case "xpath" /*case 'XPath'*/ :
                            break;
                        case "field" /*case 'Field'*/ :
                            break;
                        case "xsdtype" /*case 'XSDType'*/ :
                            break;
                        case "filteron" /*case 'FilterOn'*/ :
                            break;
                        case "aggregate" /*case 'Aggregate'*/ :
                            break;
                        case "elementtype" /*case 'ElementType'*/ :
                            break;
                        case "attributetype" /*case 'AttributeType'*/ :
                            break;
                        /* These are from xsd (XML Schema Definition) */ case "schema" /*case 'schema'*/ :
                        case "element" /*case 'element'*/ :
                        case "complextype" /*case 'complexType'*/ :
                        case "datatype" /*case 'datatype'*/ :
                        case "all" /*case 'all'*/ :
                        case "attribute" /*case 'attribute'*/ :
                        case "extends" /*case 'extends'*/ :
                            break;
                        case "row" /*case 'row'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* SmartTags (can be anything) */ case "smarttags" /*case 'SmartTags'*/ :
                    break;
                default:
                    seen = false;
                    break;
            }
            if (seen) break;
            /* CustomDocumentProperties */ if (Rn[3].match(/!\[CDATA/)) break;
            if (!state[state.length - 1][1]) throw "Unrecognized tag: " + Rn[3] + "|" + state.join("|");
            if (state[state.length - 1][0] === /*'CustomDocumentProperties'*/ "customdocumentproperties") {
                if (Rn[0].slice(-2) === "/>") break;
                else if (Rn[1] === "/") $3ee4f50b1ae43a89$var$xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
                else {
                    cp = Rn;
                    pidx = Rn.index + Rn[0].length;
                }
                break;
            }
            if (opts.WTF) throw "Unrecognized tag: " + Rn[3] + "|" + state.join("|");
    }
    var out = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
    out.SheetNames = sheetnames;
    out.Workbook = Workbook;
    out.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    out.Props = Props;
    out.Custprops = Custprops;
    return out;
}
function $3ee4f50b1ae43a89$var$parse_xlml(data /*:RawBytes|string*/ , opts) /*:Workbook*/ {
    $3ee4f50b1ae43a89$var$fix_read_opts(opts = opts || {});
    switch(opts.type || "base64"){
        case "base64":
            return $3ee4f50b1ae43a89$var$parse_xlml_xml($3ee4f50b1ae43a89$var$Base64_decode(data), opts);
        case "binary":
        case "buffer":
        case "file":
            return $3ee4f50b1ae43a89$var$parse_xlml_xml(data, opts);
        case "array":
            return $3ee4f50b1ae43a89$var$parse_xlml_xml($3ee4f50b1ae43a89$var$a2s(data), opts);
    }
/*:: throw new Error("unsupported type " + opts.type); */ }
/* TODO */ function $3ee4f50b1ae43a89$var$write_props_xlml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o /*:Array<string>*/  = [];
    /* DocumentProperties */ if (wb.Props) o.push($3ee4f50b1ae43a89$var$xlml_write_docprops(wb.Props, opts));
    /* CustomDocumentProperties */ if (wb.Custprops) o.push($3ee4f50b1ae43a89$var$xlml_write_custprops(wb.Props, wb.Custprops, opts));
    return o.join("");
}
/* TODO */ function $3ee4f50b1ae43a89$var$write_wb_xlml() /*:string*/ {
    /* OfficeDocumentSettings */ /* ExcelWorkbook */ return "";
}
/* TODO */ function $3ee4f50b1ae43a89$var$write_sty_xlml(wb, opts) /*:string*/ {
    /* Styles */ var styles /*:Array<string>*/  = [
        '<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'
    ];
    opts.cellXfs.forEach(function(xf, id) {
        var payload /*:Array<string>*/  = [];
        payload.push($3ee4f50b1ae43a89$var$writextag("NumberFormat", null, {
            "ss:Format": $3ee4f50b1ae43a89$var$escapexml($3ee4f50b1ae43a89$var$table_fmt[xf.numFmtId])
        }));
        var o = /*::(*/ {
            "ss:ID": "s" + (21 + id)
        } /*:: :any)*/ ;
        styles.push($3ee4f50b1ae43a89$var$writextag("Style", payload.join(""), o));
    });
    return $3ee4f50b1ae43a89$var$writextag("Styles", styles.join(""));
}
function $3ee4f50b1ae43a89$var$write_name_xlml(n) {
    return $3ee4f50b1ae43a89$var$writextag("NamedRange", null, {
        "ss:Name": n.Name,
        "ss:RefersTo": "=" + $3ee4f50b1ae43a89$var$a1_to_rc(n.Ref, {
            r: 0,
            c: 0
        })
    });
}
function $3ee4f50b1ae43a89$var$write_names_xlml(wb /*::, opts*/ ) /*:string*/ {
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != null) continue;
        if (n.Name.match(/^_xlfn\./)) continue;
        out.push($3ee4f50b1ae43a89$var$write_name_xlml(n));
    }
    return $3ee4f50b1ae43a89$var$writextag("Names", out.join(""));
}
function $3ee4f50b1ae43a89$var$write_ws_xlml_names(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != idx) continue;
        /*switch(n.Name) {
			case "_": continue;
		}*/ if (n.Name.match(/^_xlfn\./)) continue;
        out.push($3ee4f50b1ae43a89$var$write_name_xlml(n));
    }
    return out.join("");
}
/* WorksheetOptions */ function $3ee4f50b1ae43a89$var$write_ws_xlml_wsopts(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    var o /*:Array<string>*/  = [];
    /* NOTE: spec technically allows any order, but stick with implied order */ /* FitToPage */ /* DoNotDisplayColHeaders */ /* DoNotDisplayRowHeaders */ /* ViewableRange */ /* Selection */ /* GridlineColor */ /* Name */ /* ExcelWorksheetType */ /* IntlMacro */ /* Unsynced */ /* Selected */ /* CodeName */ if (ws["!margins"]) {
        o.push("<PageSetup>");
        if (ws["!margins"].header) o.push($3ee4f50b1ae43a89$var$writextag("Header", null, {
            "x:Margin": ws["!margins"].header
        }));
        if (ws["!margins"].footer) o.push($3ee4f50b1ae43a89$var$writextag("Footer", null, {
            "x:Margin": ws["!margins"].footer
        }));
        o.push($3ee4f50b1ae43a89$var$writextag("PageMargins", null, {
            "x:Bottom": ws["!margins"].bottom || "0.75",
            "x:Left": ws["!margins"].left || "0.7",
            "x:Right": ws["!margins"].right || "0.7",
            "x:Top": ws["!margins"].top || "0.75"
        }));
        o.push("</PageSetup>");
    }
    /* PageSetup */ /* DisplayPageBreak */ /* TransitionExpressionEvaluation */ /* TransitionFormulaEntry */ /* Print */ /* Zoom */ /* PageLayoutZoom */ /* PageBreakZoom */ /* ShowPageBreakZoom */ /* DefaultRowHeight */ /* DefaultColumnWidth */ /* StandardWidth */ if (wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
        /* Visible */ if (wb.Workbook.Sheets[idx].Hidden) o.push($3ee4f50b1ae43a89$var$writextag("Visible", wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
        else {
            /* Selected */ for(var i = 0; i < idx; ++i)if (wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
            if (i == idx) o.push("<Selected/>");
        }
    }
    /* LeftColumnVisible */ if (((((wb || {}).Workbook || {}).Views || [])[0] || {}).RTL) o.push("<DisplayRightToLeft/>");
    /* GridlineColorIndex */ /* DisplayFormulas */ /* DoNotDisplayGridlines */ /* DoNotDisplayHeadings */ /* DoNotDisplayOutline */ /* ApplyAutomaticOutlineStyles */ /* NoSummaryRowsBelowDetail */ /* NoSummaryColumnsRightDetail */ /* DoNotDisplayZeros */ /* ActiveRow */ /* ActiveColumn */ /* FilterOn */ /* RangeSelection */ /* TopRowVisible */ /* TopRowBottomPane */ /* LeftColumnRightPane */ /* ActivePane */ /* SplitHorizontal */ /* SplitVertical */ /* FreezePanes */ /* FrozenNoSplit */ /* TabColorIndex */ /* Panes */ /* NOTE: Password not supported in XLML Format */ if (ws["!protect"]) {
        o.push($3ee4f50b1ae43a89$var$writetag("ProtectContents", "True"));
        if (ws["!protect"].objects) o.push($3ee4f50b1ae43a89$var$writetag("ProtectObjects", "True"));
        if (ws["!protect"].scenarios) o.push($3ee4f50b1ae43a89$var$writetag("ProtectScenarios", "True"));
        if (ws["!protect"].selectLockedCells != null && !ws["!protect"].selectLockedCells) o.push($3ee4f50b1ae43a89$var$writetag("EnableSelection", "NoSelection"));
        else if (ws["!protect"].selectUnlockedCells != null && !ws["!protect"].selectUnlockedCells) o.push($3ee4f50b1ae43a89$var$writetag("EnableSelection", "UnlockedCells"));
        [
            [
                "formatCells",
                "AllowFormatCells"
            ],
            [
                "formatColumns",
                "AllowSizeCols"
            ],
            [
                "formatRows",
                "AllowSizeRows"
            ],
            [
                "insertColumns",
                "AllowInsertCols"
            ],
            [
                "insertRows",
                "AllowInsertRows"
            ],
            [
                "insertHyperlinks",
                "AllowInsertHyperlinks"
            ],
            [
                "deleteColumns",
                "AllowDeleteCols"
            ],
            [
                "deleteRows",
                "AllowDeleteRows"
            ],
            [
                "sort",
                "AllowSort"
            ],
            [
                "autoFilter",
                "AllowFilter"
            ],
            [
                "pivotTables",
                "AllowUsePivotTables"
            ]
        ].forEach(function(x) {
            if (ws["!protect"][x[0]]) o.push("<" + x[1] + "/>");
        });
    }
    if (o.length == 0) return "";
    return $3ee4f50b1ae43a89$var$writextag("WorksheetOptions", o.join(""), {
        xmlns: $3ee4f50b1ae43a89$var$XLMLNS.x
    });
}
function $3ee4f50b1ae43a89$var$write_ws_xlml_comment(comments /*:Array<any>*/ ) /*:string*/ {
    return comments.map(function(c) {
        // TODO: formatted text
        var t = $3ee4f50b1ae43a89$var$xlml_unfixstr(c.t || "");
        var d = $3ee4f50b1ae43a89$var$writextag("ss:Data", t, {
            "xmlns": "http://www.w3.org/TR/REC-html40"
        });
        return $3ee4f50b1ae43a89$var$writextag("Comment", d, {
            "ss:Author": c.a
        });
    }).join("");
}
function $3ee4f50b1ae43a89$var$write_ws_xlml_cell(cell, ref /*:string*/ , ws, opts, idx /*:number*/ , wb, addr) /*:string*/ {
    if (!cell || cell.v == undefined && cell.f == undefined) return "";
    var attr = {};
    if (cell.f) attr["ss:Formula"] = "=" + $3ee4f50b1ae43a89$var$escapexml($3ee4f50b1ae43a89$var$a1_to_rc(cell.f, addr));
    if (cell.F && cell.F.slice(0, ref.length) == ref) {
        var end = $3ee4f50b1ae43a89$var$decode_cell(cell.F.slice(ref.length + 1));
        attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
    }
    if (cell.l && cell.l.Target) {
        attr["ss:HRef"] = $3ee4f50b1ae43a89$var$escapexml(cell.l.Target);
        if (cell.l.Tooltip) attr["x:HRefScreenTip"] = $3ee4f50b1ae43a89$var$escapexml(cell.l.Tooltip);
    }
    if (ws["!merges"]) {
        var marr = ws["!merges"];
        for(var mi = 0; mi != marr.length; ++mi){
            if (marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
            if (marr[mi].e.c > marr[mi].s.c) attr["ss:MergeAcross"] = marr[mi].e.c - marr[mi].s.c;
            if (marr[mi].e.r > marr[mi].s.r) attr["ss:MergeDown"] = marr[mi].e.r - marr[mi].s.r;
        }
    }
    var t = "", p = "";
    switch(cell.t){
        case "z":
            if (!opts.sheetStubs) return "";
            break;
        case "n":
            t = "Number";
            p = String(cell.v);
            break;
        case "b":
            t = "Boolean";
            p = cell.v ? "1" : "0";
            break;
        case "e":
            t = "Error";
            p = $3ee4f50b1ae43a89$var$BErr[cell.v];
            break;
        case "d":
            t = "DateTime";
            p = new Date(cell.v).toISOString();
            if (cell.z == null) cell.z = cell.z || $3ee4f50b1ae43a89$var$table_fmt[14];
            break;
        case "s":
            t = "String";
            p = $3ee4f50b1ae43a89$var$escapexlml(cell.v || "");
            break;
    }
    /* TODO: cell style */ var os = $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, cell, opts);
    attr["ss:StyleID"] = "s" + (21 + os);
    attr["ss:Index"] = addr.c + 1;
    var _v = cell.v != null ? p : "";
    var m = cell.t == "z" ? "" : '<Data ss:Type="' + t + '">' + _v + "</Data>";
    if ((cell.c || []).length > 0) m += $3ee4f50b1ae43a89$var$write_ws_xlml_comment(cell.c);
    return $3ee4f50b1ae43a89$var$writextag("Cell", m, attr);
}
function $3ee4f50b1ae43a89$var$write_ws_xlml_row(R /*:number*/ , row) /*:string*/ {
    var o = '<Row ss:Index="' + (R + 1) + '"';
    if (row) {
        if (row.hpt && !row.hpx) row.hpx = $3ee4f50b1ae43a89$var$pt2px(row.hpt);
        if (row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
        if (row.hidden) o += ' ss:Hidden="1"';
    }
    return o + ">";
}
/* TODO */ function $3ee4f50b1ae43a89$var$write_ws_xlml_table(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws["!ref"]) return "";
    var range /*:Range*/  = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]);
    var marr /*:Array<Range>*/  = ws["!merges"] || [], mi = 0;
    var o /*:Array<string>*/  = [];
    if (ws["!cols"]) ws["!cols"].forEach(function(n, i) {
        $3ee4f50b1ae43a89$var$process_col(n);
        var w = !!n.width;
        var p = $3ee4f50b1ae43a89$var$col_obj_w(i, n);
        var k /*:any*/  = {
            "ss:Index": i + 1
        };
        if (w) k["ss:Width"] = $3ee4f50b1ae43a89$var$width2px(p.width);
        if (n.hidden) k["ss:Hidden"] = "1";
        o.push($3ee4f50b1ae43a89$var$writextag("Column", null, k));
    });
    var dense = Array.isArray(ws);
    for(var R = range.s.r; R <= range.e.r; ++R){
        var row = [
            $3ee4f50b1ae43a89$var$write_ws_xlml_row(R, (ws["!rows"] || [])[R])
        ];
        for(var C = range.s.c; C <= range.e.c; ++C){
            var skip = false;
            for(mi = 0; mi != marr.length; ++mi){
                if (marr[mi].s.c > C) continue;
                if (marr[mi].s.r > R) continue;
                if (marr[mi].e.c < C) continue;
                if (marr[mi].e.r < R) continue;
                if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                break;
            }
            if (skip) continue;
            var addr = {
                r: R,
                c: C
            };
            var ref = $3ee4f50b1ae43a89$var$encode_cell(addr), cell = dense ? (ws[R] || [])[C] : ws[ref];
            row.push($3ee4f50b1ae43a89$var$write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
        }
        row.push("</Row>");
        if (row.length > 2) o.push(row.join(""));
    }
    return o.join("");
}
function $3ee4f50b1ae43a89$var$write_ws_xlml(idx /*:number*/ , opts, wb /*:Workbook*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    var s = wb.SheetNames[idx];
    var ws = wb.Sheets[s];
    var t /*:string*/  = ws ? $3ee4f50b1ae43a89$var$write_ws_xlml_names(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Names>" + t + "</Names>");
    /* Table */ t = ws ? $3ee4f50b1ae43a89$var$write_ws_xlml_table(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Table>" + t + "</Table>");
    /* WorksheetOptions */ o.push($3ee4f50b1ae43a89$var$write_ws_xlml_wsopts(ws, opts, idx, wb));
    return o.join("");
}
function $3ee4f50b1ae43a89$var$write_xlml(wb, opts) /*:string*/ {
    if (!opts) opts = {};
    if (!wb.SSF) wb.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    if (wb.SSF) {
        $3ee4f50b1ae43a89$var$make_ssf();
        $3ee4f50b1ae43a89$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $3ee4f50b1ae43a89$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    var d /*:Array<string>*/  = [];
    d.push($3ee4f50b1ae43a89$var$write_props_xlml(wb, opts));
    d.push($3ee4f50b1ae43a89$var$write_wb_xlml(wb, opts));
    d.push("");
    d.push("");
    for(var i = 0; i < wb.SheetNames.length; ++i)d.push($3ee4f50b1ae43a89$var$writextag("Worksheet", $3ee4f50b1ae43a89$var$write_ws_xlml(i, opts, wb), {
        "ss:Name": $3ee4f50b1ae43a89$var$escapexml(wb.SheetNames[i])
    }));
    d[2] = $3ee4f50b1ae43a89$var$write_sty_xlml(wb, opts);
    d[3] = $3ee4f50b1ae43a89$var$write_names_xlml(wb, opts);
    return $3ee4f50b1ae43a89$var$XML_HEADER + $3ee4f50b1ae43a89$var$writextag("Workbook", d.join(""), {
        "xmlns": $3ee4f50b1ae43a89$var$XLMLNS.ss,
        "xmlns:o": $3ee4f50b1ae43a89$var$XLMLNS.o,
        "xmlns:x": $3ee4f50b1ae43a89$var$XLMLNS.x,
        "xmlns:ss": $3ee4f50b1ae43a89$var$XLMLNS.ss,
        "xmlns:dt": $3ee4f50b1ae43a89$var$XLMLNS.dt,
        "xmlns:html": $3ee4f50b1ae43a89$var$XLMLNS.html
    });
}
/* [MS-OLEDS] 2.3.8 CompObjStream */ function $3ee4f50b1ae43a89$var$parse_compobj(obj /*:CFBEntry*/ ) {
    var v = {};
    var o = obj.content;
    /*:: if(o == null) return; */ /* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */ o.l = 28;
    v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
    v.AnsiClipboardFormat = $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrAnsiString(o);
    if (o.length - o.l <= 4) return v;
    var m /*:number*/  = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved1 = o.read_shift(0, "lpstr-ansi");
    if (o.length - o.l <= 4) return v;
    m = o.read_shift(4);
    if (m !== 0x71b239f4) return v;
    v.UnicodeClipboardFormat = $3ee4f50b1ae43a89$var$parse_ClipboardFormatOrUnicodeString(o);
    m = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved2 = o.read_shift(0, "lpwstr");
}
/*
	Continue logic for:
	- 2.4.58 Continue          0x003c
	- 2.4.59 ContinueBigName   0x043c
	- 2.4.60 ContinueFrt       0x0812
	- 2.4.61 ContinueFrt11     0x0875
	- 2.4.62 ContinueFrt12     0x087f
*/ var $3ee4f50b1ae43a89$var$CONTINUE_RT = [
    0x003c,
    0x043c,
    0x0812,
    0x0875,
    0x087f
];
function $3ee4f50b1ae43a89$var$slurp(RecordType, R, blob, length /*:number*/ , opts) /*:any*/ {
    var l = length;
    var bufs = [];
    var d = blob.slice(blob.l, blob.l + l);
    if (opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType){
        case 0x0009:
        case 0x0209:
        case 0x0409:
        case 0x0809 /* BOF */ :
        case 0x002f /* FilePass */ :
        case 0x0195 /* FileLock */ :
        case 0x00e1 /* InterfaceHdr */ :
        case 0x0196 /* RRDInfo */ :
        case 0x0138 /* RRDHead */ :
        case 0x0194 /* UsrExcl */ :
        case 0x000a /* EOF */ :
            break;
        case 0x0085 /* BoundSheet8 */ :
            break;
        default:
            opts.enc.insitu(d);
    }
    bufs.push(d);
    blob.l += l;
    var nextrt = $3ee4f50b1ae43a89$var$__readUInt16LE(blob, blob.l), next = $3ee4f50b1ae43a89$var$XLSRecordEnum[nextrt];
    var start = 0;
    while(next != null && $3ee4f50b1ae43a89$var$CONTINUE_RT.indexOf(nextrt) > -1){
        l = $3ee4f50b1ae43a89$var$__readUInt16LE(blob, blob.l + 2);
        start = blob.l + 4;
        if (nextrt == 0x0812 /* ContinueFrt */ ) start += 4;
        else if (nextrt == 0x0875 || nextrt == 0x087f) start += 12;
        d = blob.slice(start, blob.l + 4 + l);
        bufs.push(d);
        blob.l += 4 + l;
        next = $3ee4f50b1ae43a89$var$XLSRecordEnum[nextrt = $3ee4f50b1ae43a89$var$__readUInt16LE(blob, blob.l)];
    }
    var b = $3ee4f50b1ae43a89$var$bconcat(bufs);
    $3ee4f50b1ae43a89$var$prep_blob(b, 0);
    var ll = 0;
    b.lens = [];
    for(var j = 0; j < bufs.length; ++j){
        b.lens.push(ll);
        ll += bufs[j].length;
    }
    if (b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
    return R.f(b, b.length, opts);
}
function $3ee4f50b1ae43a89$var$safe_format_xf(p /*:any*/ , opts /*:ParseOpts*/ , date1904 /*:?boolean*/ ) {
    if (p.t === "z") return;
    if (!p.XF) return;
    var fmtid = 0;
    try {
        fmtid = p.z || p.XF.numFmtId || 0;
        if (opts.cellNF) p.z = $3ee4f50b1ae43a89$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts || opts.cellText !== false) try {
        if (p.t === "e") p.w = p.w || $3ee4f50b1ae43a89$var$BErr[p.v];
        else if (fmtid === 0 || fmtid == "General") {
            if (p.t === "n") {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $3ee4f50b1ae43a89$var$SSF_general_num(p.v);
            } else p.w = $3ee4f50b1ae43a89$var$SSF_general(p.v);
        } else p.w = $3ee4f50b1ae43a89$var$SSF_format(fmtid, p.v, {
            date1904: !!date1904,
            dateNF: opts && opts.dateNF
        });
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (opts.cellDates && fmtid && p.t == "n" && $3ee4f50b1ae43a89$var$fmt_is_date($3ee4f50b1ae43a89$var$table_fmt[fmtid] || String(fmtid))) {
        var _d = $3ee4f50b1ae43a89$var$SSF_parse_date_code(p.v);
        if (_d) {
            p.t = "d";
            p.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
        }
    }
}
function $3ee4f50b1ae43a89$var$make_cell(val, ixfe, t) /*:Cell*/ {
    return {
        v: val,
        ixfe: ixfe,
        t: t
    } /*:any*/ ;
}
// 2.3.2
function $3ee4f50b1ae43a89$var$parse_workbook(blob, options /*:ParseOpts*/ ) /*:Workbook*/ {
    var wb = {
        opts: {}
    } /*:any*/ ;
    var Sheets = {};
    if ($3ee4f50b1ae43a89$var$DENSE != null && options.dense == null) options.dense = $3ee4f50b1ae43a89$var$DENSE;
    var out /*:Worksheet*/  = options.dense ? [] : {};
    var Directory = {};
    var range /*:Range*/  = {} /*:any*/ ;
    var last_formula = null;
    var sst /*:SST*/  = [];
    var cur_sheet = "";
    var Preamble = {};
    var lastcell, last_cell = "", cc /*:Cell*/ , cmnt, rngC, rngR;
    var sharedf = {};
    var arrayf /*:Array<[Range, string]>*/  = [];
    var temp_val /*:Cell*/ ;
    var country;
    var XFs = []; /* XF records */ 
    var palette /*:Array<[number, number, number]>*/  = [];
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        },
        Views: [
            {}
        ]
    } /*:any*/ , wsprops = {};
    var get_rgb = function getrgb(icv /*:number*/ ) /*:[number, number, number]*/ {
        if (icv < 8) return $3ee4f50b1ae43a89$var$XLSIcv[icv];
        if (icv < 64) return palette[icv - 8] || $3ee4f50b1ae43a89$var$XLSIcv[icv];
        return $3ee4f50b1ae43a89$var$XLSIcv[icv];
    };
    var process_cell_style = function pcs(cell, line /*:any*/ , options) {
        var xfd = line.XF.data;
        if (!xfd || !xfd.patternType || !options || !options.cellStyles) return;
        line.s = {} /*:any*/ ;
        line.s.patternType = xfd.patternType;
        var t;
        if (t = $3ee4f50b1ae43a89$var$rgb2Hex(get_rgb(xfd.icvFore))) line.s.fgColor = {
            rgb: t
        };
        if (t = $3ee4f50b1ae43a89$var$rgb2Hex(get_rgb(xfd.icvBack))) line.s.bgColor = {
            rgb: t
        };
    };
    var addcell = function addcell(cell /*:any*/ , line /*:any*/ , options /*:any*/ ) {
        if (file_depth > 1) return;
        if (options.sheetRows && cell.r >= options.sheetRows) return;
        if (options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
        delete line.ixfe;
        delete line.XF;
        lastcell = cell;
        last_cell = $3ee4f50b1ae43a89$var$encode_cell(cell);
        if (!range || !range.s || !range.e) range = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        if (cell.r < range.s.r) range.s.r = cell.r;
        if (cell.c < range.s.c) range.s.c = cell.c;
        if (cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
        if (cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
        if (options.cellFormula && line.f) for(var afi = 0; afi < arrayf.length; ++afi){
            if (arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
            if (arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
            line.F = $3ee4f50b1ae43a89$var$encode_range(arrayf[afi][0]);
            if (arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
            if (line.f) line.f = "" + $3ee4f50b1ae43a89$var$stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
            break;
        }
        if (options.dense) {
            if (!out[cell.r]) out[cell.r] = [];
            out[cell.r][cell.c] = line;
        } else out[last_cell] = line;
    };
    var opts = {
        enc: false,
        sbcch: 0,
        snames: [],
        sharedf: sharedf,
        arrayf: arrayf,
        rrtabid: [],
        lastuser: "",
        biff: 8,
        codepage: 0,
        winlocked: 0,
        cellStyles: !!options && !!options.cellStyles,
        WTF: !!options && !!options.wtf
    } /*:any*/ ;
    if (options.password) opts.password = options.password;
    var themes;
    var merges /*:Array<Range>*/  = [];
    var objects = [];
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    var supbooks = []; // 1-indexed, will hold extern names
    supbooks.SheetNames = opts.snames;
    supbooks.sharedf = opts.sharedf;
    supbooks.arrayf = opts.arrayf;
    supbooks.names = [];
    supbooks.XTI = [];
    var last_RT = 0;
    var file_depth = 0; /* TODO: make a real stack */ 
    var BIFF2Fmt = 0, BIFF2FmtTable /*:Array<string>*/  = [];
    var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */ 
    var last_lbl /*:?DefinedName*/ ;
    /* explicit override for some broken writers */ opts.codepage = 1200;
    $3ee4f50b1ae43a89$var$set_cp(1200);
    var seen_codepage = false;
    while(blob.l < blob.length - 1){
        var s = blob.l;
        var RecordType = blob.read_shift(2);
        if (RecordType === 0 && last_RT === 0x000a /* EOF */ ) break;
        var length = blob.l === blob.length ? 0 : blob.read_shift(2);
        var R = $3ee4f50b1ae43a89$var$XLSRecordEnum[RecordType];
        //console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
        //if(!R) console.log(blob.slice(blob.l, blob.l + length));
        if (R && R.f) {
            if (options.bookSheets) {
                if (last_RT === 0x0085 /* BoundSheet8 */  && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */ ) break;
            }
            last_RT = RecordType;
            if (R.r === 2 || R.r == 12) {
                var rt = blob.read_shift(2);
                length -= 2;
                if (!opts.enc && rt !== RecordType && ((rt & 0xFF) << 8 | rt >> 8) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
                if (R.r == 12) {
                    blob.l += 10;
                    length -= 10;
                } // skip FRT
            }
            //console.error(R,blob.l,length,blob.length);
            var val /*:any*/  = {} /*:any*/ ;
            if (RecordType === 0x000a /* EOF */ ) val = /*::(*/ R.f(blob, length, opts) /*:: :any)*/ ;
            else val = /*::(*/ $3ee4f50b1ae43a89$var$slurp(RecordType, R, blob, length, opts) /*:: :any)*/ ;
            /*:: val = (val:any); */ if (file_depth == 0 && [
                0x0009,
                0x0209,
                0x0409,
                0x0809
            ].indexOf(last_RT) === -1 /* 'BOF' */ ) continue;
            switch(RecordType){
                case 0x0022 /* Date1904 */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ wb.opts.Date1904 = Workbook.WBProps.date1904 = val;
                    break;
                case 0x0086 /* WriteProtect */ :
                    wb.opts.WriteProtect = true;
                    break;
                case 0x002f /* FilePass */ :
                    if (!opts.enc) blob.l = 0;
                    opts.enc = val;
                    if (!options.password) throw new Error("File is password-protected");
                    if (val.valid == null) throw new Error("Encryption scheme unsupported");
                    if (!val.valid) throw new Error("Password is incorrect");
                    break;
                case 0x005c /* WriteAccess */ :
                    opts.lastuser = val;
                    break;
                case 0x0042 /* CodePage */ :
                    var cpval = Number(val);
                    /* overrides based on test cases */ switch(cpval){
                        case 0x5212:
                            cpval = 1200;
                            break;
                        case 0x8000:
                            cpval = 10000;
                            break;
                        case 0x8001:
                            cpval = 1252;
                            break;
                    }
                    $3ee4f50b1ae43a89$var$set_cp(opts.codepage = cpval);
                    seen_codepage = true;
                    break;
                case 0x013d /* RRTabId */ :
                    opts.rrtabid = val;
                    break;
                case 0x0019 /* WinProtect */ :
                    opts.winlocked = val;
                    break;
                case 0x01b7 /* RefreshAll */ :
                    wb.opts["RefreshAll"] = val;
                    break;
                case 0x000c /* CalcCount */ :
                    wb.opts["CalcCount"] = val;
                    break;
                case 0x0010 /* CalcDelta */ :
                    wb.opts["CalcDelta"] = val;
                    break;
                case 0x0011 /* CalcIter */ :
                    wb.opts["CalcIter"] = val;
                    break;
                case 0x000d /* CalcMode */ :
                    wb.opts["CalcMode"] = val;
                    break;
                case 0x000e /* CalcPrecision */ :
                    wb.opts["CalcPrecision"] = val;
                    break;
                case 0x005f /* CalcSaveRecalc */ :
                    wb.opts["CalcSaveRecalc"] = val;
                    break;
                case 0x000f /* CalcRefMode */ :
                    opts.CalcRefMode = val;
                    break; // TODO: implement R1C1
                case 0x08a3 /* ForceFullCalculation */ :
                    wb.opts.FullCalc = val;
                    break;
                case 0x0081 /* WsBool */ :
                    if (val.fDialog) out["!type"] = "dialog";
                    if (!val.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
                    if (!val.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
                    break; // TODO
                case 0x00e0 /* XF */ :
                    XFs.push(val);
                    break;
                case 0x01ae /* SupBook */ :
                    supbooks.push([
                        val
                    ]);
                    supbooks[supbooks.length - 1].XTI = [];
                    break;
                case 0x0023:
                case 0x0223 /* ExternName */ :
                    supbooks[supbooks.length - 1].push(val);
                    break;
                case 0x0018:
                case 0x0218 /* Lbl */ :
                    last_lbl = {
                        Name: val.Name,
                        Ref: $3ee4f50b1ae43a89$var$stringify_formula(val.rgce, range, null, supbooks, opts)
                    } /*:DefinedName*/ ;
                    if (val.itab > 0) last_lbl.Sheet = val.itab - 1;
                    supbooks.names.push(last_lbl);
                    if (!supbooks[0]) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].push(val);
                    if (val.Name == "_xlnm._FilterDatabase" && val.itab > 0) {
                        if (val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == "PtgArea3d") FilterDatabases[val.itab - 1] = {
                            ref: $3ee4f50b1ae43a89$var$encode_range(val.rgce[0][0][1][2])
                        };
                    }
                    break;
                case 0x0016 /* ExternCount */ :
                    opts.ExternCount = val;
                    break;
                case 0x0017 /* ExternSheet */ :
                    if (supbooks.length == 0) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
                    supbooks.XTI = supbooks.XTI.concat(val);
                    break;
                case 0x0894 /* NameCmt */ :
                    /* TODO: search for correct name */ if (opts.biff < 8) break;
                    if (last_lbl != null) last_lbl.Comment = val[1];
                    break;
                case 0x0012 /* Protect */ :
                    out["!protect"] = val;
                    break; /* for sheet or book */ 
                case 0x0013 /* Password */ :
                    if (val !== 0 && opts.WTF) console.error("Password verifier: " + val);
                    break;
                case 0x0085 /* BoundSheet8 */ :
                    Directory[val.pos] = val;
                    opts.snames.push(val.name);
                    break;
                case 0x000a /* EOF */ :
                    if (--file_depth) break;
                    if (range.e) {
                        if (range.e.r > 0 && range.e.c > 0) {
                            range.e.r--;
                            range.e.c--;
                            out["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
                            if (options.sheetRows && options.sheetRows <= range.e.r) {
                                var tmpri = range.e.r;
                                range.e.r = options.sheetRows - 1;
                                out["!fullref"] = out["!ref"];
                                out["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
                                range.e.r = tmpri;
                            }
                            range.e.r++;
                            range.e.c++;
                        }
                        if (merges.length > 0) out["!merges"] = merges;
                        if (objects.length > 0) out["!objects"] = objects;
                        if (colinfo.length > 0) out["!cols"] = colinfo;
                        if (rowinfo.length > 0) out["!rows"] = rowinfo;
                        Workbook.Sheets.push(wsprops);
                    }
                    if (cur_sheet === "") Preamble = out;
                    else Sheets[cur_sheet] = out;
                    out = options.dense ? [] : {};
                    break;
                case 0x0009:
                case 0x0209:
                case 0x0409:
                case 0x0809 /* BOF */ :
                    if (opts.biff === 8) opts.biff = ({
                        /*::[*/ 0x0009: 2,
                        /*::[*/ 0x0209: 3,
                        /*::[*/ 0x0409: 4
                    })[RecordType] || ({
                        /*::[*/ 0x0200: 2,
                        /*::[*/ 0x0300: 3,
                        /*::[*/ 0x0400: 4,
                        /*::[*/ 0x0500: 5,
                        /*::[*/ 0x0600: 8,
                        /*::[*/ 0x0002: 2,
                        /*::[*/ 0x0007: 2
                    })[val.BIFFVer] || 8;
                    opts.biffguess = val.BIFFVer == 0;
                    if (val.BIFFVer == 0 && val.dt == 0x1000) {
                        opts.biff = 5;
                        seen_codepage = true;
                        $3ee4f50b1ae43a89$var$set_cp(opts.codepage = 28591);
                    }
                    if (opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
                    if (file_depth++) break;
                    out = options.dense ? [] : {};
                    if (opts.biff < 8 && !seen_codepage) {
                        seen_codepage = true;
                        $3ee4f50b1ae43a89$var$set_cp(opts.codepage = options.codepage || 1252);
                    }
                    if (opts.biff < 5 || val.BIFFVer == 0 && val.dt == 0x1000) {
                        if (cur_sheet === "") cur_sheet = "Sheet1";
                        range = {
                            s: {
                                r: 0,
                                c: 0
                            },
                            e: {
                                r: 0,
                                c: 0
                            }
                        };
                        /* fake BoundSheet8 */ var fakebs8 = {
                            pos: blob.l - length,
                            name: cur_sheet
                        };
                        Directory[fakebs8.pos] = fakebs8;
                        opts.snames.push(cur_sheet);
                    } else cur_sheet = (Directory[s] || {
                        name: ""
                    }).name;
                    if (val.dt == 0x20) out["!type"] = "chart";
                    if (val.dt == 0x40) out["!type"] = "macro";
                    merges = [];
                    objects = [];
                    opts.arrayf = arrayf = [];
                    colinfo = [];
                    rowinfo = [];
                    seencol = false;
                    wsprops = {
                        Hidden: (Directory[s] || {
                            hs: 0
                        }).hs,
                        name: cur_sheet
                    };
                    break;
                case 0x0203 /* Number */ :
                case 0x0003 /* BIFF2NUM */ :
                case 0x0002 /* BIFF2INT */ :
                    if (out["!type"] == "chart") {
                        if (options.dense ? (out[val.r] || [])[val.c] : out[$3ee4f50b1ae43a89$var$encode_cell({
                            c: val.c,
                            r: val.r
                        })]) ++val.c;
                    }
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe] || {},
                        v: val.val,
                        t: "n"
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0005:
                case 0x0205 /* BoolErr */ :
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe],
                        v: val.val,
                        t: val.t
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x027e /* RK */ :
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe],
                        v: val.rknum,
                        t: "n"
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x00bd /* MulRk */ :
                    for(var j = val.c; j <= val.C; ++j){
                        var ixfe = val.rkrec[j - val.c][0];
                        temp_val = {
                            ixfe: ixfe,
                            XF: XFs[ixfe],
                            v: val.rkrec[j - val.c][1],
                            t: "n"
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: j,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x0006:
                case 0x0206:
                case 0x0406 /* Formula */ :
                    if (val.val == "String") {
                        last_formula = val;
                        break;
                    }
                    temp_val = $3ee4f50b1ae43a89$var$make_cell(val.val, val.cell.ixfe, val.tt);
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (options.cellFormula) {
                        var _f = val.formula;
                        if (_f && _f[0] && _f[0][0] && _f[0][0][0] == "PtgExp") {
                            var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
                            var _fe = $3ee4f50b1ae43a89$var$encode_cell({
                                r: _fr,
                                c: _fc
                            });
                            if (sharedf[_fe]) temp_val.f = "" + $3ee4f50b1ae43a89$var$stringify_formula(val.formula, range, val.cell, supbooks, opts);
                            else temp_val.F = ((options.dense ? (out[_fr] || [])[_fc] : out[_fe]) || {}).F;
                        } else temp_val.f = "" + $3ee4f50b1ae43a89$var$stringify_formula(val.formula, range, val.cell, supbooks, opts);
                    }
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell(val.cell, temp_val, options);
                    last_formula = val;
                    break;
                case 0x0007:
                case 0x0207 /* String */ :
                    if (last_formula) {
                        last_formula.val = val;
                        temp_val = $3ee4f50b1ae43a89$var$make_cell(val, last_formula.cell.ixfe, "s");
                        temp_val.XF = XFs[temp_val.ixfe];
                        if (options.cellFormula) temp_val.f = "" + $3ee4f50b1ae43a89$var$stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell(last_formula.cell, temp_val, options);
                        last_formula = null;
                    } else throw new Error("String record expects Formula");
                    break;
                case 0x0021:
                case 0x0221 /* Array */ :
                    arrayf.push(val);
                    var _arraystart = $3ee4f50b1ae43a89$var$encode_cell(val[0].s);
                    cc = options.dense ? (out[val[0].s.r] || [])[val[0].s.c] : out[_arraystart];
                    if (options.cellFormula && cc) {
                        if (!last_formula) break; /* technically unreachable */ 
                        if (!_arraystart || !cc) break;
                        cc.f = "" + $3ee4f50b1ae43a89$var$stringify_formula(val[1], range, val[0], supbooks, opts);
                        cc.F = $3ee4f50b1ae43a89$var$encode_range(val[0]);
                    }
                    break;
                case 0x04bc /* ShrFmla */ :
                    if (!options.cellFormula) break;
                    if (last_cell) {
                        /* TODO: capture range */ if (!last_formula) break; /* technically unreachable */ 
                        sharedf[$3ee4f50b1ae43a89$var$encode_cell(last_formula.cell)] = val[0];
                        cc = options.dense ? (out[last_formula.cell.r] || [])[last_formula.cell.c] : out[$3ee4f50b1ae43a89$var$encode_cell(last_formula.cell)];
                        (cc || {}).f = "" + $3ee4f50b1ae43a89$var$stringify_formula(val[0], range, lastcell, supbooks, opts);
                    }
                    break;
                case 0x00fd /* LabelSst */ :
                    temp_val = $3ee4f50b1ae43a89$var$make_cell(sst[val.isst].t, val.ixfe, "s");
                    if (sst[val.isst].h) temp_val.h = sst[val.isst].h;
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0201 /* Blank */ :
                    if (options.sheetStubs) {
                        temp_val = {
                            ixfe: val.ixfe,
                            XF: XFs[val.ixfe],
                            t: "z"
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val.c,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00be /* MulBlank */ :
                    if (options.sheetStubs) for(var _j = val.c; _j <= val.C; ++_j){
                        var _ixfe = val.ixfe[_j - val.c];
                        temp_val = {
                            ixfe: _ixfe,
                            XF: XFs[_ixfe],
                            t: "z"
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: _j,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00d6 /* RString */ :
                case 0x0204 /* Label */ :
                case 0x0004 /* BIFF2STR */ :
                    temp_val = $3ee4f50b1ae43a89$var$make_cell(val.val, val.ixfe, "s");
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $3ee4f50b1ae43a89$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0000:
                case 0x0200 /* Dimensions */ :
                    if (file_depth === 1) range = val; /* TODO: stack */ 
                    break;
                case 0x00fc /* SST */ :
                    sst = val;
                    break;
                case 0x041e /* Format */ :
                    if (opts.biff == 4) {
                        BIFF2FmtTable[BIFF2Fmt++] = val[1];
                        for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx)if ($3ee4f50b1ae43a89$var$table_fmt[b4idx] == val[1]) break;
                        if (b4idx >= 163) $3ee4f50b1ae43a89$var$SSF_load(val[1], BIFF2Fmt + 163);
                    } else $3ee4f50b1ae43a89$var$SSF_load(val[1], val[0]);
                    break;
                case 0x001e /* BIFF2FORMAT */ :
                    BIFF2FmtTable[BIFF2Fmt++] = val;
                    for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx)if ($3ee4f50b1ae43a89$var$table_fmt[b2idx] == val) break;
                    if (b2idx >= 163) $3ee4f50b1ae43a89$var$SSF_load(val, BIFF2Fmt + 163);
                    break;
                case 0x00e5 /* MergeCells */ :
                    merges = merges.concat(val);
                    break;
                case 0x005d /* Obj */ :
                    objects[val.cmo[0]] = opts.lastobj = val;
                    break;
                case 0x01b6 /* TxO */ :
                    opts.lastobj.TxO = val;
                    break;
                case 0x007f /* ImData */ :
                    opts.lastobj.ImData = val;
                    break;
                case 0x01b8 /* HLink */ :
                    for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC){
                        cc = options.dense ? (out[rngR] || [])[rngC] : out[$3ee4f50b1ae43a89$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc) cc.l = val[1];
                    }
                    break;
                case 0x0800 /* HLinkTooltip */ :
                    for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC){
                        cc = options.dense ? (out[rngR] || [])[rngC] : out[$3ee4f50b1ae43a89$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc && cc.l) cc.l.Tooltip = val[1];
                    }
                    break;
                case 0x001c /* Note */ :
                    if (opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */ 
                    cc = options.dense ? (out[val[0].r] || [])[val[0].c] : out[$3ee4f50b1ae43a89$var$encode_cell(val[0])];
                    var noteobj = objects[val[2]];
                    if (!cc) {
                        if (options.dense) {
                            if (!out[val[0].r]) out[val[0].r] = [];
                            cc = out[val[0].r][val[0].c] = {
                                t: "z"
                            } /*:any*/ ;
                        } else cc = out[$3ee4f50b1ae43a89$var$encode_cell(val[0])] = {
                            t: "z"
                        } /*:any*/ ;
                        range.e.r = Math.max(range.e.r, val[0].r);
                        range.s.r = Math.min(range.s.r, val[0].r);
                        range.e.c = Math.max(range.e.c, val[0].c);
                        range.s.c = Math.min(range.s.c, val[0].c);
                    }
                    if (!cc.c) cc.c = [];
                    cmnt = {
                        a: val[1],
                        t: noteobj.TxO.t
                    };
                    cc.c.push(cmnt);
                    break;
                case 0x087d /* XFExt */ :
                    $3ee4f50b1ae43a89$var$update_xfext(XFs[val.ixfe], val.ext);
                    break;
                case 0x007d /* ColInfo */ :
                    if (!opts.cellStyles) break;
                    while(val.e >= val.s){
                        colinfo[val.e--] = {
                            width: val.w / 256,
                            level: val.level || 0,
                            hidden: !!(val.flags & 1)
                        };
                        if (!seencol) {
                            seencol = true;
                            $3ee4f50b1ae43a89$var$find_mdw_colw(val.w / 256);
                        }
                        $3ee4f50b1ae43a89$var$process_col(colinfo[val.e + 1]);
                    }
                    break;
                case 0x0208 /* Row */ :
                    var rowobj = {};
                    if (val.level != null) {
                        rowinfo[val.r] = rowobj;
                        rowobj.level = val.level;
                    }
                    if (val.hidden) {
                        rowinfo[val.r] = rowobj;
                        rowobj.hidden = true;
                    }
                    if (val.hpt) {
                        rowinfo[val.r] = rowobj;
                        rowobj.hpt = val.hpt;
                        rowobj.hpx = $3ee4f50b1ae43a89$var$pt2px(val.hpt);
                    }
                    break;
                case 0x0026 /* LeftMargin */ :
                case 0x0027 /* RightMargin */ :
                case 0x0028 /* TopMargin */ :
                case 0x0029 /* BottomMargin */ :
                    if (!out["!margins"]) $3ee4f50b1ae43a89$var$default_margins(out["!margins"] = {});
                    out["!margins"][({
                        0x26: "left",
                        0x27: "right",
                        0x28: "top",
                        0x29: "bottom"
                    })[RecordType]] = val;
                    break;
                case 0x00a1 /* Setup */ :
                    if (!out["!margins"]) $3ee4f50b1ae43a89$var$default_margins(out["!margins"] = {});
                    out["!margins"].header = val.header;
                    out["!margins"].footer = val.footer;
                    break;
                case 0x023e /* Window2 */ :
                    // $FlowIgnore
                    if (val.RTL) Workbook.Views[0].RTL = true;
                    break;
                case 0x0092 /* Palette */ :
                    palette = val;
                    break;
                case 0x0896 /* Theme */ :
                    themes = val;
                    break;
                case 0x008c /* Country */ :
                    country = val;
                    break;
                case 0x01ba /* CodeName */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ if (!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
                    else wsprops.CodeName = val || wsprops.name;
                    break;
            }
        } else {
            if (!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
            blob.l += length;
        }
    }
    wb.SheetNames = $3ee4f50b1ae43a89$var$keys(Directory).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(x) {
        return Directory[x].name;
    });
    if (!options.bookSheets) wb.Sheets = Sheets;
    if (!wb.SheetNames.length && Preamble["!ref"]) {
        wb.SheetNames.push("Sheet1");
        /*jshint -W069 */ if (wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
    /*jshint +W069 */ } else wb.Preamble = Preamble;
    if (wb.Sheets) FilterDatabases.forEach(function(r, i) {
        wb.Sheets[wb.SheetNames[i]]["!autofilter"] = r;
    });
    wb.Strings = sst;
    wb.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    if (opts.enc) wb.Encryption = opts.enc;
    if (themes) wb.Themes = themes;
    wb.Metadata = {};
    if (country !== undefined) wb.Metadata.Country = country;
    if (supbooks.names.length > 0) Workbook.Names = supbooks.names;
    wb.Workbook = Workbook;
    return wb;
}
/* TODO: split props*/ var $3ee4f50b1ae43a89$var$PSCLSID = {
    SI: "e0859ff2f94f6810ab9108002b27b3d9",
    DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
    UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function $3ee4f50b1ae43a89$var$parse_xls_props(cfb /*:CFBContainer*/ , props, o) {
    /* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */ var DSI = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "/!DocumentSummaryInformation");
    if (DSI && DSI.size > 0) try {
        var DocSummary = $3ee4f50b1ae43a89$var$parse_PropertySetStream(DSI, $3ee4f50b1ae43a89$var$DocSummaryPIDDSI, $3ee4f50b1ae43a89$var$PSCLSID.DSI);
        for(var d in DocSummary)props[d] = DocSummary[d];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    /* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/ var SI = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "/!SummaryInformation");
    if (SI && SI.size > 0) try {
        var Summary = $3ee4f50b1ae43a89$var$parse_PropertySetStream(SI, $3ee4f50b1ae43a89$var$SummaryPIDSI, $3ee4f50b1ae43a89$var$PSCLSID.SI);
        for(var s in Summary)if (props[s] == null) props[s] = Summary[s];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    if (props.HeadingPairs && props.TitlesOfParts) {
        $3ee4f50b1ae43a89$var$load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
        delete props.HeadingPairs;
        delete props.TitlesOfParts;
    }
}
function $3ee4f50b1ae43a89$var$write_xls_props(wb /*:Workbook*/ , cfb /*:CFBContainer*/ ) {
    var DSEntries = [], SEntries = [], CEntries = [];
    var i = 0, Keys;
    var DocSummaryRE /*:{[key:string]:string}*/  = $3ee4f50b1ae43a89$var$evert_key($3ee4f50b1ae43a89$var$DocSummaryPIDDSI, "n");
    var SummaryRE /*:{[key:string]:string}*/  = $3ee4f50b1ae43a89$var$evert_key($3ee4f50b1ae43a89$var$SummaryPIDSI, "n");
    if (wb.Props) {
        Keys = $3ee4f50b1ae43a89$var$keys(wb.Props);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)(Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Props[Keys[i]]
        ]);
    }
    if (wb.Custprops) {
        Keys = $3ee4f50b1ae43a89$var$keys(wb.Custprops);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)if (!Object.prototype.hasOwnProperty.call(wb.Props || {}, Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Custprops[Keys[i]]
        ]);
    }
    var CEntries2 = [];
    for(i = 0; i < CEntries.length; ++i){
        if ($3ee4f50b1ae43a89$var$XLSPSSkip.indexOf(CEntries[i][0]) > -1 || $3ee4f50b1ae43a89$var$PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
        if (CEntries[i][1] == null) continue;
        CEntries2.push(CEntries[i]);
    }
    if (SEntries.length) $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\x05SummaryInformation", $3ee4f50b1ae43a89$var$write_PropertySetStream(SEntries, $3ee4f50b1ae43a89$var$PSCLSID.SI, SummaryRE, $3ee4f50b1ae43a89$var$SummaryPIDSI));
    if (DSEntries.length || CEntries2.length) $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\x05DocumentSummaryInformation", $3ee4f50b1ae43a89$var$write_PropertySetStream(DSEntries, $3ee4f50b1ae43a89$var$PSCLSID.DSI, DocSummaryRE, $3ee4f50b1ae43a89$var$DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, $3ee4f50b1ae43a89$var$PSCLSID.UDI));
}
function $3ee4f50b1ae43a89$export$b41972a043aba84c(cfb /*:any*/ , options /*:?ParseOpts*/ ) /*:Workbook*/ {
    if (!options) options = {};
    $3ee4f50b1ae43a89$var$fix_read_opts(options);
    $3ee4f50b1ae43a89$var$reset_cp();
    if (options.codepage) $3ee4f50b1ae43a89$var$set_ansi(options.codepage);
    var CompObj /*:?CFBEntry*/ , WB /*:?any*/ ;
    if (cfb.FullPaths) {
        if ($3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "/encryption")) throw new Error("File is password-protected");
        CompObj = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "!CompObj");
        WB = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "/Workbook") || $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "/Book");
    } else {
        switch(options.type){
            case "base64":
                cfb = $3ee4f50b1ae43a89$var$s2a($3ee4f50b1ae43a89$var$Base64_decode(cfb));
                break;
            case "binary":
                cfb = $3ee4f50b1ae43a89$var$s2a(cfb);
                break;
            case "buffer":
                break;
            case "array":
                if (!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb);
                break;
        }
        $3ee4f50b1ae43a89$var$prep_blob(cfb, 0);
        WB = {
            content: cfb
        } /*:any*/ ;
    }
    var /*::CompObjP, */ WorkbookP /*:: :Workbook = XLSX.utils.book_new(); */ ;
    var _data /*:?any*/ ;
    if (CompObj) /*::CompObjP = */ $3ee4f50b1ae43a89$var$parse_compobj(CompObj);
    if (options.bookProps && !options.bookSheets) WorkbookP = {} /*:any*/ ;
    else /*:: if(cfb instanceof CFBContainer) */ {
        var T = $3ee4f50b1ae43a89$var$has_buf ? "buffer" : "array";
        if (WB && WB.content) WorkbookP = $3ee4f50b1ae43a89$var$parse_workbook(WB.content, options);
        else if ((_data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "PerfectOffice_MAIN")) && _data.content) WorkbookP = $3ee4f50b1ae43a89$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "NativeContent_MAIN")) && _data.content) WorkbookP = $3ee4f50b1ae43a89$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "MN0")) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
        else throw new Error("Cannot find Workbook stream");
        if (options.bookVBA && cfb.FullPaths && $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "/_VBA_PROJECT_CUR/VBA/dir")) WorkbookP.vbaraw = $3ee4f50b1ae43a89$var$make_vba_xls(cfb);
    }
    var props = {};
    if (cfb.FullPaths) $3ee4f50b1ae43a89$var$parse_xls_props(/*::((*/ cfb /*:: :any):CFBContainer)*/ , props, options);
    WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */ 
    if (options.bookFiles) WorkbookP.cfb = cfb;
    /*WorkbookP.CompObjP = CompObjP; // TODO: storage? */ return WorkbookP;
}
function $3ee4f50b1ae43a89$var$write_xlscfb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:CFBContainer*/ {
    var o = opts || {};
    var cfb = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    var wbpath = "/Workbook";
    switch(o.bookType || "xls"){
        case "xls":
            o.bookType = "biff8";
        /* falls through */ case "xla":
            if (!o.bookType) o.bookType = "xla";
        /* falls through */ case "biff8":
            wbpath = "/Workbook";
            o.biff = 8;
            break;
        case "biff5":
            wbpath = "/Book";
            o.biff = 5;
            break;
        default:
            throw new Error("invalid type " + o.bookType + " for XLS CFB");
    }
    $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_add(cfb, wbpath, $3ee4f50b1ae43a89$var$write_biff_buf(wb, o));
    if (o.biff == 8 && (wb.Props || wb.Custprops)) $3ee4f50b1ae43a89$var$write_xls_props(wb, cfb);
    // TODO: SI, DSI, CO
    if (o.biff == 8 && wb.vbaraw) $3ee4f50b1ae43a89$var$fill_vba_xls(cfb, $3ee4f50b1ae43a89$export$9f0e51cd97c572a.read(wb.vbaraw, {
        type: typeof wb.vbaraw == "string" ? "binary" : "buffer"
    }));
    return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */ var $3ee4f50b1ae43a89$var$XLSBRecordEnum = {
    /*::[*/ 0x0000: {
        f: $3ee4f50b1ae43a89$var$parse_BrtRowHdr
    },
    /*::[*/ 0x0001: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellBlank
    },
    /*::[*/ 0x0002: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellRk
    },
    /*::[*/ 0x0003: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellError
    },
    /*::[*/ 0x0004: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellBool
    },
    /*::[*/ 0x0005: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellReal
    },
    /*::[*/ 0x0006: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellSt
    },
    /*::[*/ 0x0007: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellIsst
    },
    /*::[*/ 0x0008: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFmlaString
    },
    /*::[*/ 0x0009: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFmlaNum
    },
    /*::[*/ 0x000A: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFmlaBool
    },
    /*::[*/ 0x000B: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFmlaError
    },
    /*::[*/ 0x000C: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortBlank
    },
    /*::[*/ 0x000D: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortRk
    },
    /*::[*/ 0x000E: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortError
    },
    /*::[*/ 0x000F: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortBool
    },
    /*::[*/ 0x0010: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortReal
    },
    /*::[*/ 0x0011: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortSt
    },
    /*::[*/ 0x0012: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShortIsst
    },
    /*::[*/ 0x0013: {
        f: $3ee4f50b1ae43a89$var$parse_RichStr
    },
    /*::[*/ 0x0014: {},
    /*::[*/ 0x0015: {},
    /*::[*/ 0x0016: {},
    /*::[*/ 0x0017: {},
    /*::[*/ 0x0018: {},
    /*::[*/ 0x0019: {},
    /*::[*/ 0x001A: {},
    /*::[*/ 0x001B: {},
    /*::[*/ 0x001C: {},
    /*::[*/ 0x001D: {},
    /*::[*/ 0x001E: {},
    /*::[*/ 0x001F: {},
    /*::[*/ 0x0020: {},
    /*::[*/ 0x0021: {},
    /*::[*/ 0x0022: {},
    /*::[*/ 0x0023: {
        T: 1
    },
    /*::[*/ 0x0024: {
        T: -1
    },
    /*::[*/ 0x0025: {
        T: 1
    },
    /*::[*/ 0x0026: {
        T: -1
    },
    /*::[*/ 0x0027: {
        f: $3ee4f50b1ae43a89$var$parse_BrtName
    },
    /*::[*/ 0x0028: {},
    /*::[*/ 0x002A: {},
    /*::[*/ 0x002B: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFont
    },
    /*::[*/ 0x002C: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFmt
    },
    /*::[*/ 0x002D: {
        f: $3ee4f50b1ae43a89$var$parse_BrtFill
    },
    /*::[*/ 0x002E: {
        f: $3ee4f50b1ae43a89$var$parse_BrtBorder
    },
    /*::[*/ 0x002F: {
        f: $3ee4f50b1ae43a89$var$parse_BrtXF
    },
    /*::[*/ 0x0030: {},
    /*::[*/ 0x0031: {
        f: $3ee4f50b1ae43a89$var$parse_Int32LE
    },
    /*::[*/ 0x0032: {},
    /*::[*/ 0x0033: {
        f: $3ee4f50b1ae43a89$var$parse_BrtMdb
    },
    /*::[*/ 0x0034: {
        T: 1
    },
    /*::[*/ 0x0035: {
        T: -1
    },
    /*::[*/ 0x0036: {
        T: 1
    },
    /*::[*/ 0x0037: {
        T: -1
    },
    /*::[*/ 0x0038: {
        T: 1
    },
    /*::[*/ 0x0039: {
        T: -1
    },
    /*::[*/ 0x003A: {},
    /*::[*/ 0x003B: {},
    /*::[*/ 0x003C: {
        f: $3ee4f50b1ae43a89$var$parse_ColInfo
    },
    /*::[*/ 0x003E: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCellRString
    },
    /*::[*/ 0x003F: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCalcChainItem$
    },
    /*::[*/ 0x0040: {
        f: $3ee4f50b1ae43a89$var$parse_BrtDVal
    },
    /*::[*/ 0x0041: {},
    /*::[*/ 0x0042: {},
    /*::[*/ 0x0043: {},
    /*::[*/ 0x0044: {},
    /*::[*/ 0x0045: {},
    /*::[*/ 0x0046: {},
    /*::[*/ 0x0080: {},
    /*::[*/ 0x0081: {
        T: 1
    },
    /*::[*/ 0x0082: {
        T: -1
    },
    /*::[*/ 0x0083: {
        T: 1,
        f: $3ee4f50b1ae43a89$var$parsenoop,
        p: 0
    },
    /*::[*/ 0x0084: {
        T: -1
    },
    /*::[*/ 0x0085: {
        T: 1
    },
    /*::[*/ 0x0086: {
        T: -1
    },
    /*::[*/ 0x0087: {
        T: 1
    },
    /*::[*/ 0x0088: {
        T: -1
    },
    /*::[*/ 0x0089: {
        T: 1,
        f: $3ee4f50b1ae43a89$var$parse_BrtBeginWsView
    },
    /*::[*/ 0x008A: {
        T: -1
    },
    /*::[*/ 0x008B: {
        T: 1
    },
    /*::[*/ 0x008C: {
        T: -1
    },
    /*::[*/ 0x008D: {
        T: 1
    },
    /*::[*/ 0x008E: {
        T: -1
    },
    /*::[*/ 0x008F: {
        T: 1
    },
    /*::[*/ 0x0090: {
        T: -1
    },
    /*::[*/ 0x0091: {
        T: 1
    },
    /*::[*/ 0x0092: {
        T: -1
    },
    /*::[*/ 0x0093: {
        f: $3ee4f50b1ae43a89$var$parse_BrtWsProp
    },
    /*::[*/ 0x0094: {
        f: $3ee4f50b1ae43a89$var$parse_BrtWsDim,
        p: 16
    },
    /*::[*/ 0x0097: {
        f: $3ee4f50b1ae43a89$var$parse_BrtPane
    },
    /*::[*/ 0x0098: {},
    /*::[*/ 0x0099: {
        f: $3ee4f50b1ae43a89$var$parse_BrtWbProp
    },
    /*::[*/ 0x009A: {},
    /*::[*/ 0x009B: {},
    /*::[*/ 0x009C: {
        f: $3ee4f50b1ae43a89$var$parse_BrtBundleSh
    },
    /*::[*/ 0x009D: {},
    /*::[*/ 0x009E: {},
    /*::[*/ 0x009F: {
        T: 1,
        f: $3ee4f50b1ae43a89$var$parse_BrtBeginSst
    },
    /*::[*/ 0x00A0: {
        T: -1
    },
    /*::[*/ 0x00A1: {
        T: 1,
        f: $3ee4f50b1ae43a89$var$parse_UncheckedRfX
    },
    /*::[*/ 0x00A2: {
        T: -1
    },
    /*::[*/ 0x00A3: {
        T: 1
    },
    /*::[*/ 0x00A4: {
        T: -1
    },
    /*::[*/ 0x00A5: {
        T: 1
    },
    /*::[*/ 0x00A6: {
        T: -1
    },
    /*::[*/ 0x00A7: {},
    /*::[*/ 0x00A8: {},
    /*::[*/ 0x00A9: {},
    /*::[*/ 0x00AA: {},
    /*::[*/ 0x00AB: {},
    /*::[*/ 0x00AC: {
        T: 1
    },
    /*::[*/ 0x00AD: {
        T: -1
    },
    /*::[*/ 0x00AE: {},
    /*::[*/ 0x00AF: {},
    /*::[*/ 0x00B0: {
        f: $3ee4f50b1ae43a89$var$parse_BrtMergeCell
    },
    /*::[*/ 0x00B1: {
        T: 1
    },
    /*::[*/ 0x00B2: {
        T: -1
    },
    /*::[*/ 0x00B3: {
        T: 1
    },
    /*::[*/ 0x00B4: {
        T: -1
    },
    /*::[*/ 0x00B5: {
        T: 1
    },
    /*::[*/ 0x00B6: {
        T: -1
    },
    /*::[*/ 0x00B7: {
        T: 1
    },
    /*::[*/ 0x00B8: {
        T: -1
    },
    /*::[*/ 0x00B9: {
        T: 1
    },
    /*::[*/ 0x00BA: {
        T: -1
    },
    /*::[*/ 0x00BB: {
        T: 1
    },
    /*::[*/ 0x00BC: {
        T: -1
    },
    /*::[*/ 0x00BD: {
        T: 1
    },
    /*::[*/ 0x00BE: {
        T: -1
    },
    /*::[*/ 0x00BF: {
        T: 1
    },
    /*::[*/ 0x00C0: {
        T: -1
    },
    /*::[*/ 0x00C1: {
        T: 1
    },
    /*::[*/ 0x00C2: {
        T: -1
    },
    /*::[*/ 0x00C3: {
        T: 1
    },
    /*::[*/ 0x00C4: {
        T: -1
    },
    /*::[*/ 0x00C5: {
        T: 1
    },
    /*::[*/ 0x00C6: {
        T: -1
    },
    /*::[*/ 0x00C7: {
        T: 1
    },
    /*::[*/ 0x00C8: {
        T: -1
    },
    /*::[*/ 0x00C9: {
        T: 1
    },
    /*::[*/ 0x00CA: {
        T: -1
    },
    /*::[*/ 0x00CB: {
        T: 1
    },
    /*::[*/ 0x00CC: {
        T: -1
    },
    /*::[*/ 0x00CD: {
        T: 1
    },
    /*::[*/ 0x00CE: {
        T: -1
    },
    /*::[*/ 0x00CF: {
        T: 1
    },
    /*::[*/ 0x00D0: {
        T: -1
    },
    /*::[*/ 0x00D1: {
        T: 1
    },
    /*::[*/ 0x00D2: {
        T: -1
    },
    /*::[*/ 0x00D3: {
        T: 1
    },
    /*::[*/ 0x00D4: {
        T: -1
    },
    /*::[*/ 0x00D5: {
        T: 1
    },
    /*::[*/ 0x00D6: {
        T: -1
    },
    /*::[*/ 0x00D7: {
        T: 1
    },
    /*::[*/ 0x00D8: {
        T: -1
    },
    /*::[*/ 0x00D9: {
        T: 1
    },
    /*::[*/ 0x00DA: {
        T: -1
    },
    /*::[*/ 0x00DB: {
        T: 1
    },
    /*::[*/ 0x00DC: {
        T: -1
    },
    /*::[*/ 0x00DD: {
        T: 1
    },
    /*::[*/ 0x00DE: {
        T: -1
    },
    /*::[*/ 0x00DF: {
        T: 1
    },
    /*::[*/ 0x00E0: {
        T: -1
    },
    /*::[*/ 0x00E1: {
        T: 1
    },
    /*::[*/ 0x00E2: {
        T: -1
    },
    /*::[*/ 0x00E3: {
        T: 1
    },
    /*::[*/ 0x00E4: {
        T: -1
    },
    /*::[*/ 0x00E5: {
        T: 1
    },
    /*::[*/ 0x00E6: {
        T: -1
    },
    /*::[*/ 0x00E7: {
        T: 1
    },
    /*::[*/ 0x00E8: {
        T: -1
    },
    /*::[*/ 0x00E9: {
        T: 1
    },
    /*::[*/ 0x00EA: {
        T: -1
    },
    /*::[*/ 0x00EB: {
        T: 1
    },
    /*::[*/ 0x00EC: {
        T: -1
    },
    /*::[*/ 0x00ED: {
        T: 1
    },
    /*::[*/ 0x00EE: {
        T: -1
    },
    /*::[*/ 0x00EF: {
        T: 1
    },
    /*::[*/ 0x00F0: {
        T: -1
    },
    /*::[*/ 0x00F1: {
        T: 1
    },
    /*::[*/ 0x00F2: {
        T: -1
    },
    /*::[*/ 0x00F3: {
        T: 1
    },
    /*::[*/ 0x00F4: {
        T: -1
    },
    /*::[*/ 0x00F5: {
        T: 1
    },
    /*::[*/ 0x00F6: {
        T: -1
    },
    /*::[*/ 0x00F7: {
        T: 1
    },
    /*::[*/ 0x00F8: {
        T: -1
    },
    /*::[*/ 0x00F9: {
        T: 1
    },
    /*::[*/ 0x00FA: {
        T: -1
    },
    /*::[*/ 0x00FB: {
        T: 1
    },
    /*::[*/ 0x00FC: {
        T: -1
    },
    /*::[*/ 0x00FD: {
        T: 1
    },
    /*::[*/ 0x00FE: {
        T: -1
    },
    /*::[*/ 0x00FF: {
        T: 1
    },
    /*::[*/ 0x0100: {
        T: -1
    },
    /*::[*/ 0x0101: {
        T: 1
    },
    /*::[*/ 0x0102: {
        T: -1
    },
    /*::[*/ 0x0103: {
        T: 1
    },
    /*::[*/ 0x0104: {
        T: -1
    },
    /*::[*/ 0x0105: {
        T: 1
    },
    /*::[*/ 0x0106: {
        T: -1
    },
    /*::[*/ 0x0107: {
        T: 1
    },
    /*::[*/ 0x0108: {
        T: -1
    },
    /*::[*/ 0x0109: {
        T: 1
    },
    /*::[*/ 0x010A: {
        T: -1
    },
    /*::[*/ 0x010B: {
        T: 1
    },
    /*::[*/ 0x010C: {
        T: -1
    },
    /*::[*/ 0x010D: {
        T: 1
    },
    /*::[*/ 0x010E: {
        T: -1
    },
    /*::[*/ 0x010F: {
        T: 1
    },
    /*::[*/ 0x0110: {
        T: -1
    },
    /*::[*/ 0x0111: {
        T: 1
    },
    /*::[*/ 0x0112: {
        T: -1
    },
    /*::[*/ 0x0113: {
        T: 1
    },
    /*::[*/ 0x0114: {
        T: -1
    },
    /*::[*/ 0x0115: {},
    /*::[*/ 0x0116: {
        T: 1
    },
    /*::[*/ 0x0117: {
        T: -1
    },
    /*::[*/ 0x0118: {
        T: 1
    },
    /*::[*/ 0x0119: {
        T: -1
    },
    /*::[*/ 0x011A: {
        T: 1
    },
    /*::[*/ 0x011B: {
        T: 1
    },
    /*::[*/ 0x011C: {
        T: -1
    },
    /*::[*/ 0x011D: {
        T: 1
    },
    /*::[*/ 0x011E: {
        T: -1
    },
    /*::[*/ 0x011F: {
        T: 1
    },
    /*::[*/ 0x0120: {
        T: -1
    },
    /*::[*/ 0x0121: {
        T: 1
    },
    /*::[*/ 0x0122: {
        T: -1
    },
    /*::[*/ 0x0123: {
        T: 1
    },
    /*::[*/ 0x0124: {
        T: -1
    },
    /*::[*/ 0x0125: {
        T: 1
    },
    /*::[*/ 0x0126: {
        T: -1
    },
    /*::[*/ 0x0127: {
        T: 1
    },
    /*::[*/ 0x0128: {
        T: -1
    },
    /*::[*/ 0x0129: {
        T: 1
    },
    /*::[*/ 0x012A: {
        T: -1
    },
    /*::[*/ 0x012B: {
        T: 1
    },
    /*::[*/ 0x012C: {
        T: -1
    },
    /*::[*/ 0x012D: {
        T: 1
    },
    /*::[*/ 0x012E: {
        T: -1
    },
    /*::[*/ 0x012F: {
        T: 1
    },
    /*::[*/ 0x0130: {
        T: -1
    },
    /*::[*/ 0x0131: {
        T: 1
    },
    /*::[*/ 0x0132: {
        T: -1
    },
    /*::[*/ 0x0133: {
        T: 1
    },
    /*::[*/ 0x0134: {
        T: -1
    },
    /*::[*/ 0x0135: {
        T: 1
    },
    /*::[*/ 0x0136: {
        T: -1
    },
    /*::[*/ 0x0137: {
        T: 1
    },
    /*::[*/ 0x0138: {
        T: -1
    },
    /*::[*/ 0x0139: {
        T: -1
    },
    /*::[*/ 0x013A: {
        T: 1
    },
    /*::[*/ 0x013B: {
        T: -1
    },
    /*::[*/ 0x013C: {
        T: 1
    },
    /*::[*/ 0x013D: {
        T: -1
    },
    /*::[*/ 0x013E: {
        T: 1
    },
    /*::[*/ 0x013F: {
        T: -1
    },
    /*::[*/ 0x0140: {
        T: 1
    },
    /*::[*/ 0x0141: {
        T: -1
    },
    /*::[*/ 0x0142: {
        T: 1
    },
    /*::[*/ 0x0143: {
        T: -1
    },
    /*::[*/ 0x0144: {
        T: 1
    },
    /*::[*/ 0x0145: {
        T: -1
    },
    /*::[*/ 0x0146: {
        T: 1
    },
    /*::[*/ 0x0147: {
        T: -1
    },
    /*::[*/ 0x0148: {
        T: 1
    },
    /*::[*/ 0x0149: {
        T: -1
    },
    /*::[*/ 0x014A: {
        T: 1
    },
    /*::[*/ 0x014B: {
        T: -1
    },
    /*::[*/ 0x014C: {
        T: 1
    },
    /*::[*/ 0x014D: {
        T: -1
    },
    /*::[*/ 0x014E: {
        T: 1
    },
    /*::[*/ 0x014F: {
        f: $3ee4f50b1ae43a89$var$parse_BrtMdtinfo
    },
    /*::[*/ 0x0150: {
        T: -1
    },
    /*::[*/ 0x0151: {
        f: $3ee4f50b1ae43a89$var$parse_BrtBeginEsmdb,
        T: 1
    },
    /*::[*/ 0x0152: {
        T: -1
    },
    /*::[*/ 0x0153: {
        T: 1
    },
    /*::[*/ 0x0154: {
        T: -1
    },
    /*::[*/ 0x0155: {
        T: 1
    },
    /*::[*/ 0x0156: {
        T: -1
    },
    /*::[*/ 0x0157: {
        T: 1
    },
    /*::[*/ 0x0158: {
        T: -1
    },
    /*::[*/ 0x0159: {
        T: 1
    },
    /*::[*/ 0x015A: {
        T: -1
    },
    /*::[*/ 0x015B: {
        T: 1
    },
    /*::[*/ 0x015C: {
        T: -1
    },
    /*::[*/ 0x015D: {
        T: 1
    },
    /*::[*/ 0x015E: {
        T: -1
    },
    /*::[*/ 0x015F: {},
    /*::[*/ 0x0160: {},
    /*::[*/ 0x0161: {
        T: 1
    },
    /*::[*/ 0x0162: {
        T: -1
    },
    /*::[*/ 0x0163: {
        f: $3ee4f50b1ae43a89$var$parse_RelID
    },
    /*::[*/ 0x0165: {},
    /*::[*/ 0x0166: {},
    /*::[*/ 0x0167: {},
    /*::[*/ 0x0168: {
        T: 1
    },
    /*::[*/ 0x0169: {},
    /*::[*/ 0x016A: {
        f: $3ee4f50b1ae43a89$var$parse_ExternSheet
    },
    /*::[*/ 0x016B: {},
    /*::[*/ 0x016C: {},
    /*::[*/ 0x016E: {},
    /*::[*/ 0x016F: {},
    /*::[*/ 0x0170: {},
    /*::[*/ 0x0171: {},
    /*::[*/ 0x0172: {},
    /*::[*/ 0x0173: {},
    /*::[*/ 0x0174: {
        T: 1
    },
    /*::[*/ 0x0175: {
        T: -1
    },
    /*::[*/ 0x0176: {
        T: 1
    },
    /*::[*/ 0x0177: {
        T: -1
    },
    /*::[*/ 0x0178: {
        T: 1
    },
    /*::[*/ 0x0179: {
        T: -1
    },
    /*::[*/ 0x017A: {
        T: 1
    },
    /*::[*/ 0x017B: {
        T: -1
    },
    /*::[*/ 0x017C: {
        T: 1
    },
    /*::[*/ 0x017D: {
        T: -1
    },
    /*::[*/ 0x017E: {
        T: 1
    },
    /*::[*/ 0x017F: {
        T: -1
    },
    /*::[*/ 0x0180: {
        T: 1
    },
    /*::[*/ 0x0181: {
        T: -1
    },
    /*::[*/ 0x0182: {
        T: 1
    },
    /*::[*/ 0x0183: {
        T: -1
    },
    /*::[*/ 0x0184: {
        T: 1
    },
    /*::[*/ 0x0185: {
        T: -1
    },
    /*::[*/ 0x0186: {
        T: 1
    },
    /*::[*/ 0x0187: {
        T: -1
    },
    /*::[*/ 0x0188: {
        T: 1
    },
    /*::[*/ 0x0189: {
        T: -1
    },
    /*::[*/ 0x018A: {
        T: 1
    },
    /*::[*/ 0x018B: {
        T: -1
    },
    /*::[*/ 0x018C: {},
    /*::[*/ 0x018D: {},
    /*::[*/ 0x018E: {},
    /*::[*/ 0x018F: {},
    /*::[*/ 0x0190: {},
    /*::[*/ 0x0191: {
        T: 1
    },
    /*::[*/ 0x0193: {},
    /*::[*/ 0x0194: {},
    /*::[*/ 0x0195: {},
    /*::[*/ 0x0196: {},
    /*::[*/ 0x0197: {},
    /*::[*/ 0x0198: {},
    /*::[*/ 0x0199: {},
    /*::[*/ 0x019A: {},
    /*::[*/ 0x019B: {},
    /*::[*/ 0x019C: {},
    /*::[*/ 0x019D: {},
    /*::[*/ 0x019E: {},
    /*::[*/ 0x019F: {},
    /*::[*/ 0x01A0: {},
    /*::[*/ 0x01A1: {},
    /*::[*/ 0x01A2: {},
    /*::[*/ 0x01A3: {},
    /*::[*/ 0x01A4: {},
    /*::[*/ 0x01A5: {},
    /*::[*/ 0x01A6: {
        T: 1
    },
    /*::[*/ 0x01A7: {
        T: 1
    },
    /*::[*/ 0x01A8: {
        T: -1
    },
    /*::[*/ 0x01A9: {
        T: -1
    },
    /*::[*/ 0x01AA: {
        f: $3ee4f50b1ae43a89$var$parse_BrtArrFmla
    },
    /*::[*/ 0x01AB: {
        f: $3ee4f50b1ae43a89$var$parse_BrtShrFmla
    },
    /*::[*/ 0x01AC: {},
    /*::[*/ 0x01AD: {
        T: 1
    },
    /*::[*/ 0x01AE: {
        T: -1
    },
    /*::[*/ 0x01AF: {
        T: 1
    },
    /*::[*/ 0x01B0: {
        T: -1
    },
    /*::[*/ 0x01B1: {
        T: 1
    },
    /*::[*/ 0x01B2: {
        T: -1
    },
    /*::[*/ 0x01B3: {
        T: 1
    },
    /*::[*/ 0x01B4: {
        T: -1
    },
    /*::[*/ 0x01B5: {
        T: 1
    },
    /*::[*/ 0x01B6: {
        T: -1
    },
    /*::[*/ 0x01B7: {
        T: 1
    },
    /*::[*/ 0x01B8: {
        T: -1
    },
    /*::[*/ 0x01B9: {
        T: 1
    },
    /*::[*/ 0x01BA: {
        T: -1
    },
    /*::[*/ 0x01BB: {
        T: 1
    },
    /*::[*/ 0x01BC: {
        T: -1
    },
    /*::[*/ 0x01BD: {
        T: 1
    },
    /*::[*/ 0x01BE: {
        T: -1
    },
    /*::[*/ 0x01BF: {
        T: 1
    },
    /*::[*/ 0x01C0: {
        T: -1
    },
    /*::[*/ 0x01C1: {
        T: 1
    },
    /*::[*/ 0x01C2: {
        T: -1
    },
    /*::[*/ 0x01C3: {
        T: 1
    },
    /*::[*/ 0x01C4: {
        T: -1
    },
    /*::[*/ 0x01C5: {
        T: 1
    },
    /*::[*/ 0x01C6: {
        T: -1
    },
    /*::[*/ 0x01C7: {
        T: 1
    },
    /*::[*/ 0x01C8: {
        T: -1
    },
    /*::[*/ 0x01C9: {
        T: 1
    },
    /*::[*/ 0x01CA: {
        T: -1
    },
    /*::[*/ 0x01CB: {
        T: 1
    },
    /*::[*/ 0x01CC: {
        T: -1
    },
    /*::[*/ 0x01CD: {
        T: 1
    },
    /*::[*/ 0x01CE: {
        T: -1
    },
    /*::[*/ 0x01CF: {
        T: 1
    },
    /*::[*/ 0x01D0: {
        T: -1
    },
    /*::[*/ 0x01D1: {
        T: 1
    },
    /*::[*/ 0x01D2: {
        T: -1
    },
    /*::[*/ 0x01D3: {
        T: 1
    },
    /*::[*/ 0x01D4: {
        T: -1
    },
    /*::[*/ 0x01D5: {
        T: 1
    },
    /*::[*/ 0x01D6: {
        T: -1
    },
    /*::[*/ 0x01D7: {},
    /*::[*/ 0x01D8: {},
    /*::[*/ 0x01D9: {
        T: 1
    },
    /*::[*/ 0x01DA: {
        T: -1
    },
    /*::[*/ 0x01DB: {},
    /*::[*/ 0x01DC: {
        f: $3ee4f50b1ae43a89$var$parse_BrtMargins
    },
    /*::[*/ 0x01DD: {},
    /*::[*/ 0x01DE: {},
    /*::[*/ 0x01DF: {
        T: 1
    },
    /*::[*/ 0x01E0: {
        T: -1
    },
    /*::[*/ 0x01E1: {
        T: 1
    },
    /*::[*/ 0x01E2: {
        T: -1
    },
    /*::[*/ 0x01E3: {
        T: 1
    },
    /*::[*/ 0x01E4: {
        T: -1
    },
    /*::[*/ 0x01E5: {
        f: $3ee4f50b1ae43a89$var$parse_BrtWsFmtInfo
    },
    /*::[*/ 0x01E6: {
        T: 1
    },
    /*::[*/ 0x01E7: {
        T: -1
    },
    /*::[*/ 0x01E8: {
        T: 1
    },
    /*::[*/ 0x01E9: {
        T: -1
    },
    /*::[*/ 0x01EA: {
        T: 1
    },
    /*::[*/ 0x01EB: {
        T: -1
    },
    /*::[*/ 0x01EC: {
        T: 1
    },
    /*::[*/ 0x01ED: {
        T: -1
    },
    /*::[*/ 0x01EE: {
        f: $3ee4f50b1ae43a89$var$parse_BrtHLink
    },
    /*::[*/ 0x01EF: {
        T: 1
    },
    /*::[*/ 0x01F0: {
        T: -1
    },
    /*::[*/ 0x01F1: {
        T: 1
    },
    /*::[*/ 0x01F2: {
        T: -1
    },
    /*::[*/ 0x01F3: {},
    /*::[*/ 0x01F4: {
        T: 1
    },
    /*::[*/ 0x01F5: {
        T: -1
    },
    /*::[*/ 0x01F6: {
        T: 1
    },
    /*::[*/ 0x01F7: {
        T: -1
    },
    /*::[*/ 0x01F8: {},
    /*::[*/ 0x01F9: {
        T: 1
    },
    /*::[*/ 0x01FA: {
        T: -1
    },
    /*::[*/ 0x01FB: {},
    /*::[*/ 0x01FC: {
        T: 1
    },
    /*::[*/ 0x01FD: {
        T: -1
    },
    /*::[*/ 0x01FE: {
        T: 1
    },
    /*::[*/ 0x01FF: {
        T: -1
    },
    /*::[*/ 0x0200: {},
    /*::[*/ 0x0201: {},
    /*::[*/ 0x0202: {
        T: 1
    },
    /*::[*/ 0x0203: {
        T: -1
    },
    /*::[*/ 0x0204: {
        T: 1
    },
    /*::[*/ 0x0205: {
        T: -1
    },
    /*::[*/ 0x0206: {
        T: 1
    },
    /*::[*/ 0x0207: {
        T: -1
    },
    /*::[*/ 0x0208: {
        T: 1
    },
    /*::[*/ 0x0209: {
        T: -1
    },
    /*::[*/ 0x020A: {},
    /*::[*/ 0x020B: {},
    /*::[*/ 0x020C: {},
    /*::[*/ 0x020D: {},
    /*::[*/ 0x020E: {},
    /*::[*/ 0x020F: {},
    /*::[*/ 0x0210: {
        T: 1
    },
    /*::[*/ 0x0211: {
        T: -1
    },
    /*::[*/ 0x0212: {
        T: 1
    },
    /*::[*/ 0x0213: {
        T: -1
    },
    /*::[*/ 0x0214: {
        T: 1
    },
    /*::[*/ 0x0215: {
        T: -1
    },
    /*::[*/ 0x0216: {},
    /*::[*/ 0x0217: {},
    /*::[*/ 0x0218: {},
    /*::[*/ 0x0219: {},
    /*::[*/ 0x021A: {
        T: 1
    },
    /*::[*/ 0x021B: {
        T: -1
    },
    /*::[*/ 0x021C: {
        T: 1
    },
    /*::[*/ 0x021D: {
        T: -1
    },
    /*::[*/ 0x021E: {
        T: 1
    },
    /*::[*/ 0x0224: {},
    /*::[*/ 0x0225: {},
    /*::[*/ 0x0226: {
        f: $3ee4f50b1ae43a89$var$parse_RelID
    },
    /*::[*/ 0x0227: {},
    /*::[*/ 0x0228: {},
    /*::[*/ 0x0229: {},
    /*::[*/ 0x022A: {
        T: 1
    },
    /*::[*/ 0x022B: {
        T: -1
    },
    /*::[*/ 0x022C: {
        T: 1
    },
    /*::[*/ 0x022D: {
        T: -1
    },
    /*::[*/ 0x022E: {
        T: 1
    },
    /*::[*/ 0x022F: {
        T: -1
    },
    /*::[*/ 0x0230: {
        T: 1
    },
    /*::[*/ 0x0231: {
        T: -1
    },
    /*::[*/ 0x0232: {},
    /*::[*/ 0x0234: {},
    /*::[*/ 0x0235: {
        T: 1
    },
    /*::[*/ 0x0236: {
        T: -1
    },
    /*::[*/ 0x0239: {
        T: 1
    },
    /*::[*/ 0x023A: {
        T: -1
    },
    /*::[*/ 0x023C: {},
    /*::[*/ 0x023D: {
        T: 1
    },
    /*::[*/ 0x023E: {
        T: -1
    },
    /*::[*/ 0x0241: {},
    /*::[*/ 0x0242: {},
    /*::[*/ 0x0243: {},
    /*::[*/ 0x0244: {},
    /*::[*/ 0x0245: {},
    /*::[*/ 0x0246: {},
    /*::[*/ 0x0247: {},
    /*::[*/ 0x0248: {},
    /*::[*/ 0x0249: {},
    /*::[*/ 0x024A: {},
    /*::[*/ 0x024B: {},
    /*::[*/ 0x024C: {
        T: -1
    },
    /*::[*/ 0x024D: {},
    /*::[*/ 0x024E: {
        T: 1
    },
    /*::[*/ 0x024F: {
        T: -1
    },
    /*::[*/ 0x0250: {
        T: 1
    },
    /*::[*/ 0x0251: {
        T: -1
    },
    /*::[*/ 0x0252: {
        T: 1
    },
    /*::[*/ 0x0253: {
        T: -1
    },
    /*::[*/ 0x0254: {},
    /*::[*/ 0x0255: {
        T: 1
    },
    /*::[*/ 0x0256: {
        T: -1
    },
    /*::[*/ 0x0257: {
        T: 1
    },
    /*::[*/ 0x0258: {
        T: -1
    },
    /*::[*/ 0x0259: {
        T: 1
    },
    /*::[*/ 0x025A: {
        T: -1
    },
    /*::[*/ 0x025B: {
        T: 1
    },
    /*::[*/ 0x025C: {
        T: -1
    },
    /*::[*/ 0x025D: {
        T: 1
    },
    /*::[*/ 0x025E: {
        T: -1
    },
    /*::[*/ 0x025F: {},
    /*::[*/ 0x0260: {
        T: 1
    },
    /*::[*/ 0x0261: {
        T: -1
    },
    /*::[*/ 0x0262: {},
    /*::[*/ 0x0263: {
        T: 1
    },
    /*::[*/ 0x0264: {
        T: -1
    },
    /*::[*/ 0x0265: {
        T: 1
    },
    /*::[*/ 0x0266: {
        T: -1
    },
    /*::[*/ 0x0267: {
        T: 1
    },
    /*::[*/ 0x0268: {
        T: -1
    },
    /*::[*/ 0x0269: {
        T: 1
    },
    /*::[*/ 0x026A: {
        T: -1
    },
    /*::[*/ 0x026B: {
        T: 1
    },
    /*::[*/ 0x026C: {
        T: -1
    },
    /*::[*/ 0x0271: {},
    /*::[*/ 0x0272: {
        T: 1
    },
    /*::[*/ 0x0273: {
        T: -1
    },
    /*::[*/ 0x0274: {
        T: 1
    },
    /*::[*/ 0x0275: {
        T: -1
    },
    /*::[*/ 0x0276: {
        T: 1
    },
    /*::[*/ 0x0277: {
        T: -1
    },
    /*::[*/ 0x0278: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCommentAuthor
    },
    /*::[*/ 0x0279: {
        T: 1
    },
    /*::[*/ 0x027A: {
        T: -1
    },
    /*::[*/ 0x027B: {
        T: 1,
        f: $3ee4f50b1ae43a89$var$parse_BrtBeginComment
    },
    /*::[*/ 0x027C: {
        T: -1
    },
    /*::[*/ 0x027D: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCommentText
    },
    /*::[*/ 0x027E: {
        T: 1
    },
    /*::[*/ 0x027F: {},
    /*::[*/ 0x0280: {
        T: -1
    },
    /*::[*/ 0x0281: {
        T: 1
    },
    /*::[*/ 0x0282: {
        T: -1
    },
    /*::[*/ 0x0283: {
        T: 1
    },
    /*::[*/ 0x0284: {},
    /*::[*/ 0x0285: {
        T: -1
    },
    /*::[*/ 0x0286: {
        T: 1
    },
    /*::[*/ 0x0288: {
        T: 1
    },
    /*::[*/ 0x0289: {},
    /*::[*/ 0x028A: {
        T: -1
    },
    /*::[*/ 0x028B: {
        f: $3ee4f50b1ae43a89$var$parse_BrtCsProp
    },
    /*::[*/ 0x028C: {},
    /*::[*/ 0x028D: {
        T: 1
    },
    /*::[*/ 0x028E: {
        T: -1
    },
    /*::[*/ 0x028F: {
        T: 1
    },
    /*::[*/ 0x0290: {
        T: -1
    },
    /*::[*/ 0x0291: {
        T: 1
    },
    /*::[*/ 0x0292: {
        T: -1
    },
    /*::[*/ 0x0293: {},
    /*::[*/ 0x0294: {
        T: 1
    },
    /*::[*/ 0x0295: {},
    /*::[*/ 0x0296: {
        T: -1
    },
    /*::[*/ 0x0297: {},
    /*::[*/ 0x0298: {
        T: 1
    },
    /*::[*/ 0x0299: {},
    /*::[*/ 0x029A: {
        T: -1
    },
    /*::[*/ 0x029B: {},
    /*::[*/ 0x029C: {},
    /*::[*/ 0x029D: {},
    /*::[*/ 0x029F: {
        T: 1
    },
    /*::[*/ 0x02A0: {
        T: -1
    },
    /*::[*/ 0x02A1: {
        T: 1
    },
    /*::[*/ 0x02A2: {
        T: -1
    },
    /*::[*/ 0x02A3: {},
    /*::[*/ 0x02A4: {},
    /*::[*/ 0x02A5: {},
    /*::[*/ 0x02A6: {},
    /*::[*/ 0x02A7: {},
    /*::[*/ 0x02A8: {},
    /*::[*/ 0x02A9: {},
    /*::[*/ 0x0400: {},
    /*::[*/ 0x0401: {},
    /*::[*/ 0x0402: {
        T: 1
    },
    /*::[*/ 0x0403: {
        T: -1
    },
    /*::[*/ 0x0404: {
        T: 1
    },
    /*::[*/ 0x0405: {
        T: -1
    },
    /*::[*/ 0x0406: {},
    /*::[*/ 0x0407: {
        T: 1
    },
    /*::[*/ 0x0408: {
        T: -1
    },
    /*::[*/ 0x0409: {
        T: 1
    },
    /*::[*/ 0x040A: {
        T: -1
    },
    /*::[*/ 0x040B: {},
    /*::[*/ 0x040C: {},
    /*::[*/ 0x040D: {},
    /*::[*/ 0x040E: {
        T: 1
    },
    /*::[*/ 0x040F: {
        T: -1
    },
    /*::[*/ 0x0410: {},
    /*::[*/ 0x0411: {
        T: 1
    },
    /*::[*/ 0x0412: {
        T: -1
    },
    /*::[*/ 0x0413: {},
    /*::[*/ 0x0414: {},
    /*::[*/ 0x0415: {},
    /*::[*/ 0x0416: {
        T: 1
    },
    /*::[*/ 0x0417: {
        T: -1
    },
    /*::[*/ 0x0418: {
        T: 1
    },
    /*::[*/ 0x0419: {
        T: -1
    },
    /*::[*/ 0x041A: {},
    /*::[*/ 0x041B: {
        T: 1
    },
    /*::[*/ 0x041C: {
        T: 1
    },
    /*::[*/ 0x041D: {
        f: $3ee4f50b1ae43a89$var$parse_BrtDVal14
    },
    /*::[*/ 0x041E: {
        T: 1
    },
    /*::[*/ 0x041F: {},
    /*::[*/ 0x0420: {
        T: 1
    },
    /*::[*/ 0x0421: {
        T: -1
    },
    /*::[*/ 0x0422: {
        T: 1
    },
    /*::[*/ 0x0423: {
        T: -1
    },
    /*::[*/ 0x0425: {},
    /*::[*/ 0x0426: {
        T: 1
    },
    /*::[*/ 0x0427: {
        T: -1
    },
    /*::[*/ 0x0428: {
        T: 1
    },
    /*::[*/ 0x0429: {
        T: -1
    },
    /*::[*/ 0x042A: {
        T: 1
    },
    /*::[*/ 0x042B: {
        T: -1
    },
    /*::[*/ 0x042C: {
        T: 1
    },
    /*::[*/ 0x042D: {
        T: -1
    },
    /*::[*/ 0x042E: {
        T: 1
    },
    /*::[*/ 0x042F: {
        T: -1
    },
    /*::[*/ 0x0430: {
        T: 1
    },
    /*::[*/ 0x0431: {
        T: -1
    },
    /*::[*/ 0x0433: {
        T: 1
    },
    /*::[*/ 0x0434: {
        T: -1
    },
    /*::[*/ 0x0435: {
        T: 1
    },
    /*::[*/ 0x0436: {
        T: -1
    },
    /*::[*/ 0x0437: {
        T: 1
    },
    /*::[*/ 0x0438: {
        T: -1
    },
    /*::[*/ 0x0439: {
        T: 1
    },
    /*::[*/ 0x043A: {
        T: -1
    },
    /*::[*/ 0x043B: {
        T: 1
    },
    /*::[*/ 0x043C: {
        T: -1
    },
    /*::[*/ 0x043D: {},
    /*::[*/ 0x043E: {
        T: 1
    },
    /*::[*/ 0x043F: {
        T: -1
    },
    /*::[*/ 0x0440: {
        T: 1
    },
    /*::[*/ 0x0441: {
        T: -1
    },
    /*::[*/ 0x0442: {
        T: 1
    },
    /*::[*/ 0x0443: {
        T: -1
    },
    /*::[*/ 0x0444: {
        T: 1
    },
    /*::[*/ 0x0445: {
        T: -1
    },
    /*::[*/ 0x0446: {
        T: 1
    },
    /*::[*/ 0x0447: {
        T: -1
    },
    /*::[*/ 0x0448: {},
    /*::[*/ 0x0449: {
        T: 1
    },
    /*::[*/ 0x044A: {},
    /*::[*/ 0x044B: {
        T: -1
    },
    /*::[*/ 0x044C: {
        T: 1
    },
    /*::[*/ 0x044D: {
        T: -1
    },
    /*::[*/ 0x044E: {},
    /*::[*/ 0x044F: {},
    /*::[*/ 0x0450: {},
    /*::[*/ 0x0451: {},
    /*::[*/ 0x0457: {},
    /*::[*/ 0x0458: {},
    /*::[*/ 0x0459: {
        T: 1
    },
    /*::[*/ 0x045A: {
        T: -1
    },
    /*::[*/ 0x045B: {
        T: 1
    },
    /*::[*/ 0x045C: {
        T: -1
    },
    /*::[*/ 0x045D: {},
    /*::[*/ 0x045E: {
        T: 1
    },
    /*::[*/ 0x045F: {
        T: -1
    },
    /*::[*/ 0x0460: {
        T: 1
    },
    /*::[*/ 0x0461: {
        T: -1
    },
    /*::[*/ 0x0462: {
        T: 1
    },
    /*::[*/ 0x0463: {
        T: -1
    },
    /*::[*/ 0x0464: {
        T: 1
    },
    /*::[*/ 0x0465: {
        T: -1
    },
    /*::[*/ 0x0466: {},
    /*::[*/ 0x0468: {
        T: 1
    },
    /*::[*/ 0x0469: {
        T: -1
    },
    /*::[*/ 0x046A: {},
    /*::[*/ 0x046B: {
        T: 1
    },
    /*::[*/ 0x046C: {
        T: -1
    },
    /*::[*/ 0x046D: {
        T: 1
    },
    /*::[*/ 0x046E: {
        T: -1
    },
    /*::[*/ 0x046F: {
        T: 1
    },
    /*::[*/ 0x0470: {
        T: -1
    },
    /*::[*/ 0x0471: {
        T: 1
    },
    /*::[*/ 0x0472: {
        T: -1
    },
    /*::[*/ 0x0473: {
        T: 1
    },
    /*::[*/ 0x0474: {
        T: -1
    },
    /*::[*/ 0x0475: {},
    /*::[*/ 0x0476: {
        T: 1
    },
    /*::[*/ 0x0477: {
        T: -1
    },
    /*::[*/ 0x0478: {
        T: 1
    },
    /*::[*/ 0x0479: {
        T: -1
    },
    /*::[*/ 0x047A: {},
    /*::[*/ 0x047B: {
        T: 1
    },
    /*::[*/ 0x047C: {
        T: -1
    },
    /*::[*/ 0x047D: {
        T: 1
    },
    /*::[*/ 0x047E: {
        T: -1
    },
    /*::[*/ 0x0480: {
        T: 1
    },
    /*::[*/ 0x0481: {
        T: -1
    },
    /*::[*/ 0x0482: {
        T: -1
    },
    /*::[*/ 0x0483: {
        T: -1
    },
    /*::[*/ 0x0484: {
        T: -1
    },
    /*::[*/ 0x0485: {
        T: 1
    },
    /*::[*/ 0x0486: {
        T: -1
    },
    /*::[*/ 0x0487: {
        T: 1
    },
    /*::[*/ 0x0488: {
        T: -1
    },
    /*::[*/ 0x0489: {
        T: 1
    },
    /*::[*/ 0x048A: {
        T: -1
    },
    /*::[*/ 0x048B: {
        T: 1
    },
    /*::[*/ 0x048C: {
        T: -1
    },
    /*::[*/ 0x048D: {
        T: 1
    },
    /*::[*/ 0x048E: {
        T: -1
    },
    /*::[*/ 0x048F: {
        T: 1
    },
    /*::[*/ 0x0490: {
        T: -1
    },
    /*::[*/ 0x0491: {
        T: 1
    },
    /*::[*/ 0x0492: {
        T: -1
    },
    /*::[*/ 0x0493: {},
    /*::[*/ 0x0494: {
        T: 1
    },
    /*::[*/ 0x0495: {
        T: -1
    },
    /*::[*/ 0x0499: {},
    /*::[*/ 0x049A: {
        T: 1
    },
    /*::[*/ 0x049C: {},
    /*::[*/ 0x049D: {},
    /*::[*/ 0x049E: {},
    /*::[*/ 0x0800: {
        T: 1
    },
    /*::[*/ 0x0801: {
        T: -1
    },
    /*::[*/ 0x0802: {},
    /*::[*/ 0x0803: {
        T: 1
    },
    /*::[*/ 0x0804: {
        T: -1
    },
    /*::[*/ 0x0805: {},
    /*::[*/ 0x0806: {},
    /*::[*/ 0x0807: {
        T: 1
    },
    /*::[*/ 0x0808: {
        T: -1
    },
    /*::[*/ 0x0809: {
        T: 1
    },
    /*::[*/ 0x080A: {
        T: -1
    },
    /*::[*/ 0x080C: {},
    /*::[*/ 0x0813: {},
    /*::[*/ 0x0814: {
        T: 1
    },
    /*::[*/ 0x0815: {
        T: -1
    },
    /*::[*/ 0x0816: {},
    /*::[*/ 0x0817: {},
    /*::[*/ 0x0818: {
        T: 1
    },
    /*::[*/ 0x0819: {
        T: -1
    },
    /*::[*/ 0x081B: {},
    /*::[*/ 0x081C: {},
    /*::[*/ 0x081D: {
        T: 1
    },
    /*::[*/ 0x081E: {
        T: -1
    },
    /*::[*/ 0x081F: {},
    /*::[*/ 0x0820: {
        T: 1
    },
    /*::[*/ 0x0821: {
        T: -1
    },
    /*::[*/ 0x0822: {},
    /*::[*/ 0x0823: {
        T: 1
    },
    /*::[*/ 0x0824: {
        T: -1
    },
    /*::[*/ 0x0825: {
        T: 1
    },
    /*::[*/ 0x0826: {
        T: -1
    },
    /*::[*/ 0x0827: {
        T: 1
    },
    /*::[*/ 0x0828: {
        T: -1
    },
    /*::[*/ 0x0829: {
        T: 1
    },
    /*::[*/ 0x082A: {
        T: -1
    },
    /*::[*/ 0x082B: {},
    /*::[*/ 0x082C: {},
    /*::[*/ 0x082D: {
        T: 1
    },
    /*::[*/ 0x082E: {
        T: -1
    },
    /*::[*/ 0x082F: {},
    /*::[*/ 0x0830: {
        T: 1
    },
    /*::[*/ 0x0831: {
        T: -1
    },
    /*::[*/ 0x0832: {
        T: 1
    },
    /*::[*/ 0x0833: {
        T: -1
    },
    /*::[*/ 0x0834: {
        T: 1
    },
    /*::[*/ 0x0835: {
        T: -1
    },
    /*::[*/ 0x0836: {},
    /*::[*/ 0x0837: {
        T: 1
    },
    /*::[*/ 0x0838: {
        T: -1
    },
    /*::[*/ 0x0839: {},
    /*::[*/ 0x083A: {
        T: 1
    },
    /*::[*/ 0x083B: {
        T: -1
    },
    /*::[*/ 0x083C: {},
    /*::[*/ 0x083D: {
        T: 1
    },
    /*::[*/ 0x083E: {
        T: -1
    },
    /*::[*/ 0x083F: {
        T: 1
    },
    /*::[*/ 0x0840: {
        T: -1
    },
    /*::[*/ 0x0841: {
        T: 1
    },
    /*::[*/ 0x0842: {
        T: -1
    },
    /*::[*/ 0x0843: {},
    /*::[*/ 0x0844: {},
    /*::[*/ 0x0845: {},
    /*::[*/ 0x0846: {
        T: 1
    },
    /*::[*/ 0x0847: {
        T: -1
    },
    /*::[*/ 0x0848: {},
    /*::[*/ 0x0849: {
        T: 1
    },
    /*::[*/ 0x084A: {
        T: -1
    },
    /*::[*/ 0x084B: {
        T: 1
    },
    /*::[*/ 0x084C: {
        T: -1
    },
    /*::[*/ 0x084D: {},
    /*::[*/ 0x084E: {
        T: 1
    },
    /*::[*/ 0x084F: {
        T: -1
    },
    /*::[*/ 0x0850: {},
    /*::[*/ 0x0851: {
        T: 1
    },
    /*::[*/ 0x0852: {
        T: -1
    },
    /*::[*/ 0x0853: {
        T: 1
    },
    /*::[*/ 0x0854: {
        T: -1
    },
    /*::[*/ 0x0855: {
        T: 1
    },
    /*::[*/ 0x0856: {},
    /*::[*/ 0x0857: {},
    /*::[*/ 0x0858: {},
    /*::[*/ 0x0859: {
        T: 1
    },
    /*::[*/ 0x085A: {
        T: -1
    },
    /*::[*/ 0x085B: {
        T: 1
    },
    /*::[*/ 0x085C: {
        T: -1
    },
    /*::[*/ 0x085D: {},
    /*::[*/ 0x0C00: {},
    /*::[*/ 0x0C01: {},
    /*::[*/ 0x1000: {
        T: 1
    },
    /*::[*/ 0x1001: {
        T: -1
    },
    /*::[*/ 0x138A: {
        T: 1
    },
    /*::[*/ 0x138B: {
        T: -1
    },
    /*::[*/ 0x13D9: {
        T: 1
    },
    /*::[*/ 0x13DA: {
        T: -1
    },
    /*::[*/ 0x13DB: {},
    /*::[*/ 0x13DC: {
        T: 1
    },
    /*::[*/ 0x13DD: {
        T: -1
    },
    /*::[*/ 0x13DE: {
        T: 1
    },
    /*::[*/ 0x13DF: {
        T: -1
    },
    /*::[*/ 0x13E0: {},
    /*::[*/ 0x13E1: {},
    /*::[*/ 0x13E2: {},
    /*::[*/ 0x13E4: {
        T: 1
    },
    /*::[*/ 0x13E5: {
        T: -1
    },
    /*::[*/ 0x13E6: {},
    /*::[*/ 0x13E7: {
        T: 1
    },
    /*::[*/ 0x13E8: {
        T: -1
    },
    /*::[*/ 0x13E9: {},
    /*::[*/ 0x13EB: {},
    /*::[*/ 0xFFFF: {
        n: ""
    }
};
/* [MS-XLS] 2.3 Record Enumeration (and other sources) */ var $3ee4f50b1ae43a89$var$XLSRecordEnum = {
    /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */ /*::[*/ 0x0006: {
        f: $3ee4f50b1ae43a89$var$parse_Formula
    },
    /*::[*/ 0x000a: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    /*::[*/ 0x000c: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x000d: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x000e: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x000f: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x0010: {
        f: $3ee4f50b1ae43a89$var$parse_Xnum
    },
    /*::[*/ 0x0011: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x0012: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x0013: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x0014: {
        f: $3ee4f50b1ae43a89$var$parse_XLHeaderFooter
    },
    /*::[*/ 0x0015: {
        f: $3ee4f50b1ae43a89$var$parse_XLHeaderFooter
    },
    /*::[*/ 0x0017: {
        f: $3ee4f50b1ae43a89$var$parse_ExternSheet
    },
    /*::[*/ 0x0018: {
        f: $3ee4f50b1ae43a89$var$parse_Lbl
    },
    /*::[*/ 0x0019: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x001a: {},
    /*::[*/ 0x001b: {},
    /*::[*/ 0x001c: {
        f: $3ee4f50b1ae43a89$var$parse_Note
    },
    /*::[*/ 0x001d: {},
    /*::[*/ 0x0022: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x0023: {
        f: $3ee4f50b1ae43a89$var$parse_ExternName
    },
    /*::[*/ 0x0026: {
        f: $3ee4f50b1ae43a89$var$parse_Xnum
    },
    /*::[*/ 0x0027: {
        f: $3ee4f50b1ae43a89$var$parse_Xnum
    },
    /*::[*/ 0x0028: {
        f: $3ee4f50b1ae43a89$var$parse_Xnum
    },
    /*::[*/ 0x0029: {
        f: $3ee4f50b1ae43a89$var$parse_Xnum
    },
    /*::[*/ 0x002a: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x002b: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x002f: {
        f: $3ee4f50b1ae43a89$var$parse_FilePass
    },
    /*::[*/ 0x0031: {
        f: $3ee4f50b1ae43a89$var$parse_Font
    },
    /*::[*/ 0x0033: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x003c: {},
    /*::[*/ 0x003d: {
        f: $3ee4f50b1ae43a89$var$parse_Window1
    },
    /*::[*/ 0x0040: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x0041: {
        f: $3ee4f50b1ae43a89$var$parse_Pane
    },
    /*::[*/ 0x0042: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x004d: {},
    /*::[*/ 0x0050: {},
    /*::[*/ 0x0051: {},
    /*::[*/ 0x0052: {},
    /*::[*/ 0x0055: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x0059: {},
    /*::[*/ 0x005a: {},
    /*::[*/ 0x005b: {},
    /*::[*/ 0x005c: {
        f: $3ee4f50b1ae43a89$var$parse_WriteAccess
    },
    /*::[*/ 0x005d: {
        f: $3ee4f50b1ae43a89$var$parse_Obj
    },
    /*::[*/ 0x005e: {},
    /*::[*/ 0x005f: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x0060: {},
    /*::[*/ 0x0061: {},
    /*::[*/ 0x0063: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x007d: {
        f: $3ee4f50b1ae43a89$var$parse_ColInfo
    },
    /*::[*/ 0x0080: {
        f: $3ee4f50b1ae43a89$var$parse_Guts
    },
    /*::[*/ 0x0081: {
        f: $3ee4f50b1ae43a89$var$parse_WsBool
    },
    /*::[*/ 0x0082: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x0083: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x0084: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x0085: {
        f: $3ee4f50b1ae43a89$var$parse_BoundSheet8
    },
    /*::[*/ 0x0086: {},
    /*::[*/ 0x008c: {
        f: $3ee4f50b1ae43a89$var$parse_Country
    },
    /*::[*/ 0x008d: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x0090: {},
    /*::[*/ 0x0092: {
        f: $3ee4f50b1ae43a89$var$parse_Palette
    },
    /*::[*/ 0x0097: {},
    /*::[*/ 0x0098: {},
    /*::[*/ 0x0099: {},
    /*::[*/ 0x009a: {},
    /*::[*/ 0x009b: {},
    /*::[*/ 0x009c: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x009d: {},
    /*::[*/ 0x009e: {},
    /*::[*/ 0x00a0: {
        f: $3ee4f50b1ae43a89$var$parse_Scl
    },
    /*::[*/ 0x00a1: {
        f: $3ee4f50b1ae43a89$var$parse_Setup
    },
    /*::[*/ 0x00ae: {},
    /*::[*/ 0x00af: {},
    /*::[*/ 0x00b0: {},
    /*::[*/ 0x00b1: {},
    /*::[*/ 0x00b2: {},
    /*::[*/ 0x00b4: {},
    /*::[*/ 0x00b5: {},
    /*::[*/ 0x00b6: {},
    /*::[*/ 0x00b8: {},
    /*::[*/ 0x00b9: {},
    /*::[*/ 0x00bd: {
        f: $3ee4f50b1ae43a89$var$parse_MulRk
    },
    /*::[*/ 0x00be: {
        f: $3ee4f50b1ae43a89$var$parse_MulBlank
    },
    /*::[*/ 0x00c1: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    /*::[*/ 0x00c5: {},
    /*::[*/ 0x00c6: {},
    /*::[*/ 0x00c7: {},
    /*::[*/ 0x00c8: {},
    /*::[*/ 0x00c9: {},
    /*::[*/ 0x00ca: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x00cb: {},
    /*::[*/ 0x00cc: {},
    /*::[*/ 0x00cd: {},
    /*::[*/ 0x00ce: {},
    /*::[*/ 0x00cf: {},
    /*::[*/ 0x00d0: {},
    /*::[*/ 0x00d1: {},
    /*::[*/ 0x00d2: {},
    /*::[*/ 0x00d3: {},
    /*::[*/ 0x00d5: {},
    /*::[*/ 0x00d7: {},
    /*::[*/ 0x00d8: {},
    /*::[*/ 0x00d9: {},
    /*::[*/ 0x00da: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x00dc: {},
    /*::[*/ 0x00dd: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x00de: {},
    /*::[*/ 0x00e0: {
        f: $3ee4f50b1ae43a89$var$parse_XF
    },
    /*::[*/ 0x00e1: {
        f: $3ee4f50b1ae43a89$var$parse_InterfaceHdr
    },
    /*::[*/ 0x00e2: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    /*::[*/ 0x00e3: {},
    /*::[*/ 0x00e5: {
        f: $3ee4f50b1ae43a89$var$parse_MergeCells
    },
    /*::[*/ 0x00e9: {},
    /*::[*/ 0x00eb: {},
    /*::[*/ 0x00ec: {},
    /*::[*/ 0x00ed: {},
    /*::[*/ 0x00ef: {},
    /*::[*/ 0x00f0: {},
    /*::[*/ 0x00f1: {},
    /*::[*/ 0x00f2: {},
    /*::[*/ 0x00f4: {},
    /*::[*/ 0x00f5: {},
    /*::[*/ 0x00f6: {},
    /*::[*/ 0x00f7: {},
    /*::[*/ 0x00f8: {},
    /*::[*/ 0x00f9: {},
    /*::[*/ 0x00fb: {},
    /*::[*/ 0x00fc: {
        f: $3ee4f50b1ae43a89$var$parse_SST
    },
    /*::[*/ 0x00fd: {
        f: $3ee4f50b1ae43a89$var$parse_LabelSst
    },
    /*::[*/ 0x00ff: {
        f: $3ee4f50b1ae43a89$var$parse_ExtSST
    },
    /*::[*/ 0x0100: {},
    /*::[*/ 0x0103: {},
    /*::[*/ 0x0122: {},
    /*::[*/ 0x0137: {},
    /*::[*/ 0x0138: {},
    /*::[*/ 0x013b: {},
    /*::[*/ 0x013d: {
        f: $3ee4f50b1ae43a89$var$parseuint16a
    },
    /*::[*/ 0x013e: {},
    /*::[*/ 0x013f: {},
    /*::[*/ 0x0140: {},
    /*::[*/ 0x014a: {},
    /*::[*/ 0x014b: {},
    /*::[*/ 0x014d: {},
    /*::[*/ 0x014e: {},
    /*::[*/ 0x014f: {},
    /*::[*/ 0x0150: {},
    /*::[*/ 0x0151: {},
    /*::[*/ 0x0152: {},
    /*::[*/ 0x0153: {},
    /*::[*/ 0x0154: {},
    /*::[*/ 0x015f: {},
    /*::[*/ 0x0160: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x0161: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    /*::[*/ 0x0191: {},
    /*::[*/ 0x0192: {},
    /*::[*/ 0x0193: {},
    /*::[*/ 0x0194: {},
    /*::[*/ 0x0195: {},
    /*::[*/ 0x0196: {},
    /*::[*/ 0x0197: {},
    /*::[*/ 0x0198: {},
    /*::[*/ 0x01a9: {},
    /*::[*/ 0x01aa: {},
    /*::[*/ 0x01ab: {},
    /*::[*/ 0x01ac: {},
    /*::[*/ 0x01ad: {},
    /*::[*/ 0x01ae: {
        f: $3ee4f50b1ae43a89$var$parse_SupBook
    },
    /*::[*/ 0x01af: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x01b0: {},
    /*::[*/ 0x01b1: {},
    /*::[*/ 0x01b2: {},
    /*::[*/ 0x01b5: {},
    /*::[*/ 0x01b6: {
        f: $3ee4f50b1ae43a89$var$parse_TxO
    },
    /*::[*/ 0x01b7: {
        f: $3ee4f50b1ae43a89$var$parsebool
    },
    /*::[*/ 0x01b8: {
        f: $3ee4f50b1ae43a89$var$parse_HLink
    },
    /*::[*/ 0x01b9: {},
    /*::[*/ 0x01ba: {
        f: $3ee4f50b1ae43a89$var$parse_XLUnicodeString
    },
    /*::[*/ 0x01bb: {},
    /*::[*/ 0x01bc: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x01bd: {},
    /*::[*/ 0x01be: {},
    /*::[*/ 0x01c0: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    /*::[*/ 0x01c1: {
        f: $3ee4f50b1ae43a89$var$parse_RecalcId,
        r: 2
    },
    /*::[*/ 0x01c2: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    /*::[*/ 0x0200: {
        f: $3ee4f50b1ae43a89$var$parse_Dimensions
    },
    /*::[*/ 0x0201: {
        f: $3ee4f50b1ae43a89$var$parse_Blank
    },
    /*::[*/ 0x0203: {
        f: $3ee4f50b1ae43a89$var$parse_Number
    },
    /*::[*/ 0x0204: {
        f: $3ee4f50b1ae43a89$var$parse_Label
    },
    /*::[*/ 0x0205: {
        f: $3ee4f50b1ae43a89$var$parse_BoolErr
    },
    /*::[*/ 0x0207: {
        f: $3ee4f50b1ae43a89$var$parse_String
    },
    /*::[*/ 0x0208: {
        f: $3ee4f50b1ae43a89$var$parse_Row
    },
    /*::[*/ 0x020b: {},
    /*::[*/ 0x0221: {
        f: $3ee4f50b1ae43a89$var$parse_Array
    },
    /*::[*/ 0x0225: {
        f: $3ee4f50b1ae43a89$var$parse_DefaultRowHeight
    },
    /*::[*/ 0x0236: {},
    /*::[*/ 0x023e: {
        f: $3ee4f50b1ae43a89$var$parse_Window2
    },
    /*::[*/ 0x027e: {
        f: $3ee4f50b1ae43a89$var$parse_RK
    },
    /*::[*/ 0x0293: {},
    /*::[*/ 0x0418: {},
    /*::[*/ 0x041e: {
        f: $3ee4f50b1ae43a89$var$parse_Format
    },
    /*::[*/ 0x043c: {},
    /*::[*/ 0x04bc: {
        f: $3ee4f50b1ae43a89$var$parse_ShrFmla
    },
    /*::[*/ 0x0800: {
        f: $3ee4f50b1ae43a89$var$parse_HLinkTooltip
    },
    /*::[*/ 0x0801: {},
    /*::[*/ 0x0802: {},
    /*::[*/ 0x0803: {},
    /*::[*/ 0x0804: {},
    /*::[*/ 0x0805: {},
    /*::[*/ 0x0806: {},
    /*::[*/ 0x0807: {},
    /*::[*/ 0x0808: {},
    /*::[*/ 0x0809: {
        f: $3ee4f50b1ae43a89$var$parse_BOF
    },
    /*::[*/ 0x080a: {},
    /*::[*/ 0x080b: {},
    /*::[*/ 0x080c: {},
    /*::[*/ 0x080d: {},
    /*::[*/ 0x080e: {},
    /*::[*/ 0x080f: {},
    /*::[*/ 0x0810: {},
    /*::[*/ 0x0812: {},
    /*::[*/ 0x0813: {},
    /*::[*/ 0x0850: {},
    /*::[*/ 0x0851: {},
    /*::[*/ 0x0852: {},
    /*::[*/ 0x0853: {},
    /*::[*/ 0x0854: {},
    /*::[*/ 0x0855: {},
    /*::[*/ 0x0856: {},
    /*::[*/ 0x0857: {},
    /*::[*/ 0x0858: {},
    /*::[*/ 0x0859: {},
    /*::[*/ 0x085a: {},
    /*::[*/ 0x0862: {},
    /*::[*/ 0x0863: {
        r: 12
    },
    /*::[*/ 0x0864: {},
    /*::[*/ 0x0865: {},
    /*::[*/ 0x0866: {},
    /*::[*/ 0x0867: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    /*::[*/ 0x0868: {},
    /*::[*/ 0x086a: {},
    /*::[*/ 0x086b: {},
    /*::[*/ 0x086c: {},
    /*::[*/ 0x0871: {},
    /*::[*/ 0x0872: {},
    /*::[*/ 0x0874: {},
    /*::[*/ 0x0875: {},
    /*::[*/ 0x0876: {},
    /*::[*/ 0x0877: {},
    /*::[*/ 0x0878: {},
    /*::[*/ 0x0879: {},
    /*::[*/ 0x087a: {},
    /*::[*/ 0x087b: {},
    /*::[*/ 0x087c: {
        f: $3ee4f50b1ae43a89$var$parse_XFCRC,
        r: 12
    },
    /*::[*/ 0x087d: {
        f: $3ee4f50b1ae43a89$var$parse_XFExt,
        r: 12
    },
    /*::[*/ 0x087e: {},
    /*::[*/ 0x087f: {},
    /*::[*/ 0x0884: {},
    /*::[*/ 0x0885: {},
    /*::[*/ 0x0886: {},
    /*::[*/ 0x0887: {},
    /*::[*/ 0x0888: {},
    /*::[*/ 0x0889: {},
    /*::[*/ 0x088a: {},
    /*::[*/ 0x088b: {},
    /*::[*/ 0x088c: {
        f: $3ee4f50b1ae43a89$var$parsebool,
        r: 12
    },
    /*::[*/ 0x088d: {},
    /*::[*/ 0x088e: {
        r: 12
    },
    /*::[*/ 0x088f: {},
    /*::[*/ 0x0890: {},
    /*::[*/ 0x0892: {},
    /*::[*/ 0x0893: {},
    /*::[*/ 0x0894: {
        f: $3ee4f50b1ae43a89$var$parse_NameCmt,
        r: 12
    },
    /*::[*/ 0x0895: {},
    /*::[*/ 0x0896: {
        f: $3ee4f50b1ae43a89$var$parse_Theme,
        r: 12
    },
    /*::[*/ 0x0897: {},
    /*::[*/ 0x0898: {},
    /*::[*/ 0x0899: {},
    /*::[*/ 0x089a: {
        f: $3ee4f50b1ae43a89$var$parse_MTRSettings,
        r: 12
    },
    /*::[*/ 0x089b: {
        f: $3ee4f50b1ae43a89$var$parsenoop2
    },
    /*::[*/ 0x089c: {},
    /*::[*/ 0x089d: {},
    /*::[*/ 0x089e: {},
    /*::[*/ 0x089f: {},
    /*::[*/ 0x08a3: {
        f: $3ee4f50b1ae43a89$var$parse_ForceFullCalculation
    },
    /*::[*/ 0x08a4: {},
    /*::[*/ 0x08a5: {},
    /*::[*/ 0x08a6: {},
    /*::[*/ 0x08a7: {},
    /*::[*/ 0x1001: {},
    /*::[*/ 0x1002: {},
    /*::[*/ 0x1003: {},
    /*::[*/ 0x1006: {},
    /*::[*/ 0x1007: {},
    /*::[*/ 0x1009: {},
    /*::[*/ 0x100a: {},
    /*::[*/ 0x100b: {},
    /*::[*/ 0x100c: {},
    /*::[*/ 0x100d: {},
    /*::[*/ 0x1014: {},
    /*::[*/ 0x1015: {},
    /*::[*/ 0x1016: {},
    /*::[*/ 0x1017: {},
    /*::[*/ 0x1018: {},
    /*::[*/ 0x1019: {},
    /*::[*/ 0x101a: {},
    /*::[*/ 0x101b: {},
    /*::[*/ 0x101c: {},
    /*::[*/ 0x101d: {},
    /*::[*/ 0x101e: {},
    /*::[*/ 0x101f: {},
    /*::[*/ 0x1020: {},
    /*::[*/ 0x1021: {},
    /*::[*/ 0x1022: {},
    /*::[*/ 0x1024: {},
    /*::[*/ 0x1025: {},
    /*::[*/ 0x1026: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x1027: {},
    /*::[*/ 0x1032: {},
    /*::[*/ 0x1033: {},
    /*::[*/ 0x1034: {},
    /*::[*/ 0x1035: {},
    /*::[*/ 0x103a: {},
    /*::[*/ 0x103c: {},
    /*::[*/ 0x103d: {},
    /*::[*/ 0x103e: {},
    /*::[*/ 0x103f: {},
    /*::[*/ 0x1040: {},
    /*::[*/ 0x1041: {},
    /*::[*/ 0x1043: {},
    /*::[*/ 0x1044: {
        f: $3ee4f50b1ae43a89$var$parse_ShtProps
    },
    /*::[*/ 0x1045: {},
    /*::[*/ 0x1046: {},
    /*::[*/ 0x1048: {},
    /*::[*/ 0x104a: {},
    /*::[*/ 0x104b: {},
    /*::[*/ 0x104e: {},
    /*::[*/ 0x104f: {},
    /*::[*/ 0x1050: {},
    /*::[*/ 0x1051: {},
    /*::[*/ 0x105b: {},
    /*::[*/ 0x105c: {
        f: $3ee4f50b1ae43a89$var$parse_ClrtClient
    },
    /*::[*/ 0x105d: {},
    /*::[*/ 0x105f: {},
    /*::[*/ 0x1060: {},
    /*::[*/ 0x1061: {},
    /*::[*/ 0x1062: {},
    /*::[*/ 0x1063: {},
    /*::[*/ 0x1064: {},
    /*::[*/ 0x1065: {},
    /*::[*/ 0x1066: {},
    /*::[*/ 0x1067: {},
    /*::[*/ 0x1068: {},
    /*::[*/ 0x0000: {
        f: $3ee4f50b1ae43a89$var$parse_Dimensions
    },
    /*::[*/ 0x0001: {},
    /*::[*/ 0x0002: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2INT
    },
    /*::[*/ 0x0003: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2NUM
    },
    /*::[*/ 0x0004: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2STR
    },
    /*::[*/ 0x0005: {
        f: $3ee4f50b1ae43a89$var$parse_BoolErr
    },
    /*::[*/ 0x0007: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2STRING
    },
    /*::[*/ 0x0008: {},
    /*::[*/ 0x0009: {
        f: $3ee4f50b1ae43a89$var$parse_BOF
    },
    /*::[*/ 0x000b: {},
    /*::[*/ 0x0016: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x001e: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2Format
    },
    /*::[*/ 0x001f: {},
    /* 16-bit cnt of BIFF2FORMAT records */ /*::[*/ 0x0020: {},
    /*::[*/ 0x0021: {
        f: $3ee4f50b1ae43a89$var$parse_Array
    },
    /*::[*/ 0x0024: {},
    /*::[*/ 0x0025: {
        f: $3ee4f50b1ae43a89$var$parse_DefaultRowHeight
    },
    // 0x2c ??
    // 0x2d ??
    // 0x2e ??
    // 0x30 FONTCOUNT: number of fonts
    /*::[*/ 0x0032: {
        f: $3ee4f50b1ae43a89$var$parse_BIFF2FONTXTRA
    },
    // 0x35: INFOOPTS
    // 0x36: TABLE (BIFF2 only)
    // 0x37: TABLE2 (BIFF2 only)
    // 0x38: WNDESK
    // 0x39 ??
    // 0x3a: BEGINPREF
    // 0x3b: ENDPREF
    /*::[*/ 0x003e: {},
    // 0x3f ??
    // 0x46: SHOWSCROLL
    // 0x47: SHOWFORMULA
    // 0x48: STATUSBAR
    // 0x49: SHORTMENUS
    // 0x4A:
    // 0x4B:
    // 0x4C:
    // 0x4E:
    // 0x4F:
    // 0x58: TOOLBAR (BIFF3)
    /* - - - */ /*::[*/ 0x0034: {},
    /*::[*/ 0x0043: {},
    /*::[*/ 0x0044: {
        f: $3ee4f50b1ae43a89$var$parseuint16
    },
    /*::[*/ 0x0045: {},
    /*::[*/ 0x0056: {},
    /* 16-bit cnt, similar to BIFF2 */ /*::[*/ 0x007e: {},
    /* Not necessarily same as 0x027e */ /*::[*/ 0x007f: {
        f: $3ee4f50b1ae43a89$var$parse_ImData
    },
    /*::[*/ 0x0087: {},
    /*::[*/ 0x0088: {},
    /*::[*/ 0x0089: {},
    // 0x8A
    // 0x8B LH: alternate menu key flag (BIFF3/4)
    // 0x8E
    // 0x8F
    /*::[*/ 0x0091: {},
    // 0x93 STYLE
    /*::[*/ 0x0094: {},
    /*::[*/ 0x0095: {},
    /*::[*/ 0x0096: {},
    // 0xA2 FNPROTO: function prototypes (BIFF4)
    // 0xA3
    // 0xA8
    /*::[*/ 0x00a9: {},
    /*::[*/ 0x00ab: {},
    /*::[*/ 0x00bc: {},
    /* Not necessarily same as 0x04bc */ /*::[*/ 0x00bf: {},
    /*::[*/ 0x00c0: {},
    /*::[*/ 0x00c2: {},
    /*::[*/ 0x00c3: {},
    /*::[*/ 0x00d6: {
        f: $3ee4f50b1ae43a89$var$parse_RString
    },
    /*::[*/ 0x00df: {},
    /*::[*/ 0x00ea: {},
    /*::[*/ 0x0162: {},
    /*::[*/ 0x01a5: {},
    /*::[*/ 0x0206: {
        f: $3ee4f50b1ae43a89$var$parse_Formula
    },
    /*::[*/ 0x0209: {
        f: $3ee4f50b1ae43a89$var$parse_BOF
    },
    /*::[*/ 0x0218: {
        f: $3ee4f50b1ae43a89$var$parse_Lbl
    },
    /*::[*/ 0x0223: {
        f: $3ee4f50b1ae43a89$var$parse_ExternName
    },
    /*::[*/ 0x0231: {},
    /*::[*/ 0x0243: {},
    /*::[*/ 0x0406: {
        f: $3ee4f50b1ae43a89$var$parse_Formula
    },
    /*::[*/ 0x0409: {
        f: $3ee4f50b1ae43a89$var$parse_BOF
    },
    /*::[*/ 0x0443: {},
    /*::[*/ 0x086d: {},
    /*::[*/ 0x0873: {},
    /*::[*/ 0x0881: {},
    /*::[*/ 0x08c0: {},
    /*::[*/ 0x08c1: {},
    /*::[*/ 0x08c2: {},
    /*::[*/ 0x08c3: {},
    /*::[*/ 0x08c4: {},
    /*::[*/ 0x08c5: {},
    /*::[*/ 0x08c6: {},
    /*::[*/ 0x08c7: {},
    /*::[*/ 0x08c8: {},
    /*::[*/ 0x08c9: {},
    /*::[*/ 0x08ca: {},
    /*::[*/ 0x08cb: {},
    /*::[*/ 0x08d6: {
        r: 12
    },
    /*::[*/ 0x7262: {}
};
function $3ee4f50b1ae43a89$var$write_biff_rec(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var t /*:number*/  = type;
    if (isNaN(t)) return;
    var len = length || (payload || []).length || 0;
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, len);
    if (/*:: len != null &&*/ len > 0 && $3ee4f50b1ae43a89$var$is_buf(payload)) ba.push(payload);
}
function $3ee4f50b1ae43a89$var$write_biff_continue(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var len = length || (payload || []).length || 0;
    if (len <= 8224) return $3ee4f50b1ae43a89$var$write_biff_rec(ba, type, payload, len);
    var t = type;
    if (isNaN(t)) return;
    var parts = payload.parts || [], sidx = 0;
    var i = 0, w = 0;
    while(w + (parts[sidx] || 8224) <= 8224){
        w += parts[sidx] || 8224;
        sidx++;
    }
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, w);
    ba.push(payload.slice(i, i + w));
    i += w;
    while(i < len){
        o = ba.next(4);
        o.write_shift(2, 0x3c); // TODO: figure out correct continue type
        w = 0;
        while(w + (parts[sidx] || 8224) <= 8224){
            w += parts[sidx] || 8224;
            sidx++;
        }
        o.write_shift(2, w);
        ba.push(payload.slice(i, i + w));
        i += w;
    }
}
function $3ee4f50b1ae43a89$var$write_BIFF2Cell(out, r /*:number*/ , c /*:number*/ ) {
    if (!out) out = $3ee4f50b1ae43a89$var$new_buf(7);
    out.write_shift(2, r);
    out.write_shift(2, c);
    out.write_shift(2, 0);
    out.write_shift(1, 0);
    return out;
}
function $3ee4f50b1ae43a89$var$write_BIFF2BERR(r /*:number*/ , c /*:number*/ , val, t /*:?string*/ ) {
    var out = $3ee4f50b1ae43a89$var$new_buf(9);
    $3ee4f50b1ae43a89$var$write_BIFF2Cell(out, r, c);
    $3ee4f50b1ae43a89$var$write_Bes(val, t || "b", out);
    return out;
}
/* TODO: codepage, large strings */ function $3ee4f50b1ae43a89$var$write_BIFF2LABEL(r /*:number*/ , c /*:number*/ , val) {
    var out = $3ee4f50b1ae43a89$var$new_buf(8 + 2 * val.length);
    $3ee4f50b1ae43a89$var$write_BIFF2Cell(out, r, c);
    out.write_shift(1, val.length);
    out.write_shift(val.length, val, "sbcs");
    return out.l < out.length ? out.slice(0, out.l) : out;
}
function $3ee4f50b1ae43a89$var$write_ws_biff2_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/  /*::, opts*/ ) {
    if (cell.v != null) switch(cell.t){
        case "d":
        case "n":
            var v = cell.t == "d" ? $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v)) : cell.v;
            if (v == (v | 0) && v >= 0 && v < 65536) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0002, $3ee4f50b1ae43a89$var$write_BIFF2INT(R, C, v));
            else $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0003, $3ee4f50b1ae43a89$var$write_BIFF2NUM(R, C, v));
            return;
        case "b":
        case "e":
            $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0005, $3ee4f50b1ae43a89$var$write_BIFF2BERR(R, C, cell.v, cell.t));
            return;
        /* TODO: codepage, sst */ case "s":
        case "str":
            $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0004, $3ee4f50b1ae43a89$var$write_BIFF2LABEL(R, C, (cell.v || "").slice(0, 255)));
            return;
    }
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0001, $3ee4f50b1ae43a89$var$write_BIFF2Cell(null, R, C));
}
function $3ee4f50b1ae43a89$var$write_ws_biff2(ba /*:BufArray*/ , ws /*:Worksheet*/ , idx /*:number*/ , opts /*::, wb:Workbook*/ ) {
    var dense = Array.isArray(ws);
    var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"] || "A1"), ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    if (range.e.c > 0xFF || range.e.r > 0x3FFF) {
        if (opts.WTF) throw new Error("Range " + (ws["!ref"] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.c, 0x3FFF);
        ref = $3ee4f50b1ae43a89$var$encode_range(range);
    }
    for(var R = range.s.r; R <= range.e.r; ++R){
        rr = $3ee4f50b1ae43a89$var$encode_row(R);
        for(var C = range.s.c; C <= range.e.c; ++C){
            if (R === range.s.r) cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
            ref = cols[C] + rr;
            var cell = dense ? (ws[R] || [])[C] : ws[ref];
            if (!cell) continue;
            /* write cell */ $3ee4f50b1ae43a89$var$write_ws_biff2_cell(ba, cell, R, C, opts);
        }
    }
}
/* Based on test files */ function $3ee4f50b1ae43a89$var$write_biff2_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    if ($3ee4f50b1ae43a89$var$DENSE != null && o.dense == null) o.dense = $3ee4f50b1ae43a89$var$DENSE;
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    var idx = 0;
    for(var i = 0; i < wb.SheetNames.length; ++i)if (wb.SheetNames[i] == o.sheet) idx = i;
    if (idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, o.biff == 4 ? 0x0409 : o.biff == 3 ? 0x0209 : 0x0009, $3ee4f50b1ae43a89$var$write_BOF(wb, 0x10, o));
    /* ... */ $3ee4f50b1ae43a89$var$write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
    /* ... */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x000A);
    return ba.end();
}
function $3ee4f50b1ae43a89$var$write_FONTS_biff8(ba, data, opts) {
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0031 /* Font */ , $3ee4f50b1ae43a89$var$write_Font({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Arial",
        family: 2,
        scheme: "minor"
    }, opts));
}
function $3ee4f50b1ae43a89$var$write_FMTS_biff8(ba, NF /*:?SSFTable*/ , opts) {
    if (!NF) return;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x041E /* Format */ , $3ee4f50b1ae43a89$var$write_Format(i, NF[i], opts));
    });
}
function $3ee4f50b1ae43a89$var$write_FEAT(ba, ws) {
    /* [MS-XLS] 2.4.112 */ var o = $3ee4f50b1ae43a89$var$new_buf(19);
    o.write_shift(4, 0x867);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 1);
    o.write_shift(4, 0);
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0867 /* FeatHdr */ , o);
    /* [MS-XLS] 2.4.111 */ o = $3ee4f50b1ae43a89$var$new_buf(39);
    o.write_shift(4, 0x868);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 1);
    o.write_shift(4, 4);
    o.write_shift(2, 0);
    $3ee4f50b1ae43a89$var$write_Ref8U($3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"] || "A1"), o);
    o.write_shift(4, 4);
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0868 /* Feat */ , o);
}
function $3ee4f50b1ae43a89$var$write_CELLXFS_biff8(ba, opts) {
    for(var i = 0; i < 16; ++i)$3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00e0 /* XF */ , $3ee4f50b1ae43a89$var$write_XF({
        numFmtId: 0,
        style: true
    }, 0, opts));
    opts.cellXfs.forEach(function(c) {
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00e0 /* XF */ , $3ee4f50b1ae43a89$var$write_XF(c, 0, opts));
    });
}
function $3ee4f50b1ae43a89$var$write_ws_biff8_hlinks(ba /*:BufArray*/ , ws) {
    for(var R = 0; R < ws["!links"].length; ++R){
        var HL = ws["!links"][R];
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x01b8 /* HLink */ , $3ee4f50b1ae43a89$var$write_HLink(HL));
        if (HL[1].Tooltip) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0800 /* HLinkTooltip */ , $3ee4f50b1ae43a89$var$write_HLinkTooltip(HL));
    }
    delete ws["!links"];
}
function $3ee4f50b1ae43a89$var$write_ws_cols_biff8(ba, cols) {
    if (!cols) return;
    var cnt = 0;
    cols.forEach(function(col, idx) {
        if (++cnt <= 256 && col) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x007d /* ColInfo */ , $3ee4f50b1ae43a89$var$write_ColInfo($3ee4f50b1ae43a89$var$col_obj_w(idx, col), idx));
    });
}
function $3ee4f50b1ae43a89$var$write_ws_biff8_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts) {
    var os = 16 + $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.v == null && !cell.bf) {
        $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0201 /* Blank */ , $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os));
        return;
    }
    if (cell.bf) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0006 /* Formula */ , $3ee4f50b1ae43a89$var$write_Formula(cell, R, C, opts, os));
    else switch(cell.t){
        case "d":
        case "n":
            var v = cell.t == "d" ? $3ee4f50b1ae43a89$var$datenum($3ee4f50b1ae43a89$var$parseDate(cell.v)) : cell.v;
            /* TODO: emit RK as appropriate */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0203 /* Number */ , $3ee4f50b1ae43a89$var$write_Number(R, C, v, os, opts));
            break;
        case "b":
        case "e":
            $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $3ee4f50b1ae43a89$var$write_BoolErr(R, C, cell.v, os, opts, cell.t));
            break;
        /* TODO: codepage, sst */ case "s":
        case "str":
            if (opts.bookSST) {
                var isst = $3ee4f50b1ae43a89$var$get_sst_id(opts.Strings, cell.v, opts.revStrings);
                $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00fd /* LabelSst */ , $3ee4f50b1ae43a89$var$write_LabelSst(R, C, isst, os, opts));
            } else $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0204 /* Label */ , $3ee4f50b1ae43a89$var$write_Label(R, C, (cell.v || "").slice(0, 255), os, opts));
            break;
        default:
            $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0201 /* Blank */ , $3ee4f50b1ae43a89$var$write_XLSCell(R, C, os));
    }
}
/* [MS-XLS] 2.1.7.20.5 */ function $3ee4f50b1ae43a89$var$write_ws_biff8(idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var ba = $3ee4f50b1ae43a89$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheet /*:WBWSProp*/  = (_WB.Sheets || [])[idx] || {} /*:any*/ ;
    var dense = Array.isArray(ws);
    var b8 = opts.biff == 8;
    var ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    var range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"] || "A1");
    var MAX_ROWS = b8 ? 65536 : 16384;
    if (range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
        if (opts.WTF) throw new Error("Range " + (ws["!ref"] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.c, MAX_ROWS - 1);
    }
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0809, $3ee4f50b1ae43a89$var$write_BOF(wb, 0x10, opts));
    /* [Uncalced] Index */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x000d /* CalcMode */ , $3ee4f50b1ae43a89$var$writeuint16(1));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x000c /* CalcCount */ , $3ee4f50b1ae43a89$var$writeuint16(100));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x000f /* CalcRefMode */ , $3ee4f50b1ae43a89$var$writebool(true));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0011 /* CalcIter */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0010 /* CalcDelta */ , $3ee4f50b1ae43a89$var$write_Xnum(0.001));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x005f /* CalcSaveRecalc */ , $3ee4f50b1ae43a89$var$writebool(true));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x002a /* PrintRowCol */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x002b /* PrintGrid */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0082 /* GridSet */ , $3ee4f50b1ae43a89$var$writeuint16(1));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0080 /* Guts */ , $3ee4f50b1ae43a89$var$write_Guts([
        0,
        0
    ]));
    /* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */ /* Header (string) */ /* Footer (string) */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0083 /* HCenter */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x0084 /* VCenter */ , $3ee4f50b1ae43a89$var$writebool(false));
    /* ... */ if (b8) $3ee4f50b1ae43a89$var$write_ws_cols_biff8(ba, ws["!cols"]);
    /* ... */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x200, $3ee4f50b1ae43a89$var$write_Dimensions(range, opts));
    /* ... */ if (b8) ws["!links"] = [];
    for(var R = range.s.r; R <= range.e.r; ++R){
        rr = $3ee4f50b1ae43a89$var$encode_row(R);
        for(var C = range.s.c; C <= range.e.c; ++C){
            if (R === range.s.r) cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
            ref = cols[C] + rr;
            var cell = dense ? (ws[R] || [])[C] : ws[ref];
            if (!cell) continue;
            /* write cell */ $3ee4f50b1ae43a89$var$write_ws_biff8_cell(ba, cell, R, C, opts);
            if (b8 && cell.l) ws["!links"].push([
                ref,
                cell.l
            ]);
        }
    }
    var cname /*:string*/  = _sheet.CodeName || _sheet.name || s;
    /* ... */ if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x023e /* Window2 */ , $3ee4f50b1ae43a89$var$write_Window2((_WB.Views || [])[0]));
    /* ... */ if (b8 && (ws["!merges"] || []).length) $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x00e5 /* MergeCells */ , $3ee4f50b1ae43a89$var$write_MergeCells(ws["!merges"]));
    /* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */ if (b8) $3ee4f50b1ae43a89$var$write_ws_biff8_hlinks(ba, ws);
    /* [DVAL] */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x01ba /* CodeName */ , $3ee4f50b1ae43a89$var$write_XLUnicodeString(cname, opts));
    /* *WebPub *CellWatch [SheetExt] */ if (b8) $3ee4f50b1ae43a89$var$write_FEAT(ba, ws);
    /* *FEAT11 *RECORD12 */ $3ee4f50b1ae43a89$var$write_biff_rec(ba, 0x000a /* EOF */ );
    return ba.end();
}
/* [MS-XLS] 2.1.7.20.3 */ function $3ee4f50b1ae43a89$var$write_biff8_global(wb /*:Workbook*/ , bufs, opts /*:WriteOpts*/ ) {
    var A = $3ee4f50b1ae43a89$var$buf_array();
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheets /*:Array<WBWSProp>*/  = _WB.Sheets || [];
    var _wb /*:WBProps*/  = /*::((*/ _WB.WBProps || {} /*:: ):any)*/ ;
    var b8 = opts.biff == 8, b5 = opts.biff == 5;
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0809, $3ee4f50b1ae43a89$var$write_BOF(wb, 0x05, opts));
    if (opts.bookType == "xla") $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0087 /* Addin */ );
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00e1 /* InterfaceHdr */ , b8 ? $3ee4f50b1ae43a89$var$writeuint16(0x04b0) : null);
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00c1 /* Mms */ , $3ee4f50b1ae43a89$var$writezeroes(2));
    if (b5) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00bf /* ToolbarHdr */ );
    if (b5) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00c0 /* ToolbarEnd */ );
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00e2 /* InterfaceEnd */ );
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x005c /* WriteAccess */ , $3ee4f50b1ae43a89$var$write_WriteAccess("SheetJS", opts));
    /* [FileSharing] */ $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0042 /* CodePage */ , $3ee4f50b1ae43a89$var$writeuint16(b8 ? 0x04b0 : 0x04E4));
    /* *2047 Lel */ if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0161 /* DSF */ , $3ee4f50b1ae43a89$var$writeuint16(0));
    if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x01c0 /* Excel9File */ );
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x013d /* RRTabId */ , $3ee4f50b1ae43a89$var$write_RRTabId(wb.SheetNames.length));
    if (b8 && wb.vbaraw) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00d3 /* ObProj */ );
    /* [ObNoMacros] */ if (b8 && wb.vbaraw) {
        var cname /*:string*/  = _wb.CodeName || "ThisWorkbook";
        $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x01ba /* CodeName */ , $3ee4f50b1ae43a89$var$write_XLUnicodeString(cname, opts));
    }
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */ , $3ee4f50b1ae43a89$var$writeuint16(0x11));
    /* *FnGroupName *FnGrp12 */ /* *Lbl */ /* [OleObjectSize] */ $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0019 /* WinProtect */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0012 /* Protect */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0013 /* Password */ , $3ee4f50b1ae43a89$var$writeuint16(0));
    if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x01af /* Prot4Rev */ , $3ee4f50b1ae43a89$var$writebool(false));
    if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x01bc /* Prot4RevPass */ , $3ee4f50b1ae43a89$var$writeuint16(0));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x003d /* Window1 */ , $3ee4f50b1ae43a89$var$write_Window1(opts));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0040 /* Backup */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x008d /* HideObj */ , $3ee4f50b1ae43a89$var$writeuint16(0));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0022 /* Date1904 */ , $3ee4f50b1ae43a89$var$writebool($3ee4f50b1ae43a89$var$safe1904(wb) == "true"));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x000e /* CalcPrecision */ , $3ee4f50b1ae43a89$var$writebool(true));
    if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x01b7 /* RefreshAll */ , $3ee4f50b1ae43a89$var$writebool(false));
    $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x00DA /* BookBool */ , $3ee4f50b1ae43a89$var$writeuint16(0));
    /* ... */ $3ee4f50b1ae43a89$var$write_FONTS_biff8(A, wb, opts);
    $3ee4f50b1ae43a89$var$write_FMTS_biff8(A, wb.SSF, opts);
    $3ee4f50b1ae43a89$var$write_CELLXFS_biff8(A, opts);
    /* ... */ if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(A, 0x0160 /* UsesELFs */ , $3ee4f50b1ae43a89$var$writebool(false));
    var a = A.end();
    var C = $3ee4f50b1ae43a89$var$buf_array();
    /* METADATA [MTRSettings] [ForceFullCalculation] */ if (b8) $3ee4f50b1ae43a89$var$write_biff_rec(C, 0x008C, $3ee4f50b1ae43a89$var$write_Country());
    /* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */ /* BIFF8: [SST *Continue] ExtSST */ if (b8 && opts.Strings) $3ee4f50b1ae43a89$var$write_biff_continue(C, 0x00FC, $3ee4f50b1ae43a89$var$write_SST(opts.Strings, opts));
    /* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */ $3ee4f50b1ae43a89$var$write_biff_rec(C, 0x000A /* EOF */ );
    var c = C.end();
    var B = $3ee4f50b1ae43a89$var$buf_array();
    var blen = 0, j = 0;
    for(j = 0; j < wb.SheetNames.length; ++j)blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
    var start = a.length + blen + c.length;
    for(j = 0; j < wb.SheetNames.length; ++j){
        var _sheet /*:WBWSProp*/  = _sheets[j] || {} /*:any*/ ;
        $3ee4f50b1ae43a89$var$write_biff_rec(B, 0x0085 /* BoundSheet8 */ , $3ee4f50b1ae43a89$var$write_BoundSheet8({
            pos: start,
            hs: _sheet.Hidden || 0,
            dt: 0,
            name: wb.SheetNames[j]
        }, opts));
        start += bufs[j].length;
    }
    /* 1*BoundSheet8 */ var b = B.end();
    if (blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
    var out = [];
    if (a.length) out.push(a);
    if (b.length) out.push(b);
    if (c.length) out.push(c);
    return $3ee4f50b1ae43a89$var$bconcat(out);
}
/* [MS-XLS] 2.1.7.20 Workbook Stream */ function $3ee4f50b1ae43a89$var$write_biff8_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var bufs = [];
    if (wb && !wb.SSF) wb.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    if (wb && wb.SSF) {
        $3ee4f50b1ae43a89$var$make_ssf();
        $3ee4f50b1ae43a89$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        o.revssf = $3ee4f50b1ae43a89$var$evert_num(wb.SSF);
        o.revssf[wb.SSF[65535]] = 0;
        o.ssf = wb.SSF;
    }
    o.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    o.Strings.Count = 0;
    o.Strings.Unique = 0;
    $3ee4f50b1ae43a89$var$fix_write_opts(o);
    o.cellXfs = [];
    $3ee4f50b1ae43a89$var$get_cell_style(o.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    for(var i = 0; i < wb.SheetNames.length; ++i)bufs[bufs.length] = $3ee4f50b1ae43a89$var$write_ws_biff8(i, o, wb);
    bufs.unshift($3ee4f50b1ae43a89$var$write_biff8_global(wb, bufs, o));
    return $3ee4f50b1ae43a89$var$bconcat(bufs);
}
function $3ee4f50b1ae43a89$var$write_biff_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    for(var i = 0; i <= wb.SheetNames.length; ++i){
        var ws = wb.Sheets[wb.SheetNames[i]];
        if (!ws || !ws["!ref"]) continue;
        var range = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
        if (range.e.c > 255) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
        }
    }
    var o = opts || {};
    switch(o.biff || 2){
        case 8:
        case 5:
            return $3ee4f50b1ae43a89$var$write_biff8_buf(wb, opts);
        case 4:
        case 3:
        case 2:
            return $3ee4f50b1ae43a89$var$write_biff2_buf(wb, opts);
    }
    throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */ function $3ee4f50b1ae43a89$var$html_to_sheet(str /*:string*/ , _opts) /*:Workbook*/ {
    var opts = _opts || {};
    if ($3ee4f50b1ae43a89$var$DENSE != null && opts.dense == null) opts.dense = $3ee4f50b1ae43a89$var$DENSE;
    var ws /*:Worksheet*/  = opts.dense ? [] : {} /*:any*/ ;
    str = str.replace(/<!--.*?-->/g, "");
    var mtch /*:any*/  = str.match(/<table/i);
    if (!mtch) throw new Error("Invalid HTML: could not find <table>");
    var mtch2 /*:any*/  = str.match(/<\/table/i);
    var i /*:number*/  = mtch.index, j /*:number*/  = mtch2 && mtch2.index || str.length;
    var rows = $3ee4f50b1ae43a89$var$split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
    var R = -1, C = 0, RS = 0, CS = 0;
    var range /*:Range*/  = {
        s: {
            r: 10000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var merges /*:Array<Range>*/  = [];
    for(i = 0; i < rows.length; ++i){
        var row = rows[i].trim();
        var hd = row.slice(0, 3).toLowerCase();
        if (hd == "<tr") {
            ++R;
            if (opts.sheetRows && opts.sheetRows <= R) {
                --R;
                break;
            }
            C = 0;
            continue;
        }
        if (hd != "<td" && hd != "<th") continue;
        var cells = row.split(/<\/t[dh]>/i);
        for(j = 0; j < cells.length; ++j){
            var cell = cells[j].trim();
            if (!cell.match(/<t[dh]/i)) continue;
            var m = cell, cc = 0;
            /* TODO: parse styles etc */ while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1)m = m.slice(cc + 1);
            for(var midx = 0; midx < merges.length; ++midx){
                var _merge /*:Range*/  = merges[midx];
                if (_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) {
                    C = _merge.e.c + 1;
                    midx = -1;
                }
            }
            var tag = $3ee4f50b1ae43a89$var$parsexmltag(cell.slice(0, cell.indexOf(">")));
            CS = tag.colspan ? +tag.colspan : 1;
            if ((RS = +tag.rowspan) > 1 || CS > 1) merges.push({
                s: {
                    r: R,
                    c: C
                },
                e: {
                    r: R + (RS || 1) - 1,
                    c: C + CS - 1
                }
            });
            var _t /*:string*/  = tag.t || tag["data-t"] || "";
            /* TODO: generate stub cells */ if (!m.length) {
                C += CS;
                continue;
            }
            m = $3ee4f50b1ae43a89$var$htmldecode(m);
            if (range.s.r > R) range.s.r = R;
            if (range.e.r < R) range.e.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.c < C) range.e.c = C;
            if (!m.length) {
                C += CS;
                continue;
            }
            var o /*:Cell*/  = {
                t: "s",
                v: m
            };
            if (opts.raw || !m.trim().length || _t == "s") ;
            else if (m === "TRUE") o = {
                t: "b",
                v: true
            };
            else if (m === "FALSE") o = {
                t: "b",
                v: false
            };
            else if (!isNaN($3ee4f50b1ae43a89$var$fuzzynum(m))) o = {
                t: "n",
                v: $3ee4f50b1ae43a89$var$fuzzynum(m)
            };
            else if (!isNaN($3ee4f50b1ae43a89$var$fuzzydate(m).getDate())) {
                o = {
                    t: "d",
                    v: $3ee4f50b1ae43a89$var$parseDate(m)
                } /*:any*/ ;
                if (!opts.cellDates) o = {
                    t: "n",
                    v: $3ee4f50b1ae43a89$var$datenum(o.v)
                } /*:any*/ ;
                o.z = opts.dateNF || $3ee4f50b1ae43a89$var$table_fmt[14];
            }
            if (opts.dense) {
                if (!ws[R]) ws[R] = [];
                ws[R][C] = o;
            } else ws[$3ee4f50b1ae43a89$var$encode_cell({
                r: R,
                c: C
            })] = o;
            C += CS;
        }
    }
    ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
    if (merges.length) ws["!merges"] = merges;
    return ws;
}
function $3ee4f50b1ae43a89$var$make_html_row(ws /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var M /*:Array<Range>*/  = ws["!merges"] || [];
    var oo /*:Array<string>*/  = [];
    for(var C = r.s.c; C <= r.e.c; ++C){
        var RS = 0, CS = 0;
        for(var j = 0; j < M.length; ++j){
            if (M[j].s.r > R || M[j].s.c > C) continue;
            if (M[j].e.r < R || M[j].e.c < C) continue;
            if (M[j].s.r < R || M[j].s.c < C) {
                RS = -1;
                break;
            }
            RS = M[j].e.r - M[j].s.r + 1;
            CS = M[j].e.c - M[j].s.c + 1;
            break;
        }
        if (RS < 0) continue;
        var coord = $3ee4f50b1ae43a89$var$encode_cell({
            r: R,
            c: C
        });
        var cell = o.dense ? (ws[R] || [])[C] : ws[coord];
        /* TODO: html entities */ var w = cell && cell.v != null && (cell.h || $3ee4f50b1ae43a89$var$escapehtml(cell.w || ($3ee4f50b1ae43a89$var$format_cell(cell), cell.w) || "")) || "";
        var sp = {} /*:any*/ ;
        if (RS > 1) sp.rowspan = RS;
        if (CS > 1) sp.colspan = CS;
        if (o.editable) w = '<span contenteditable="true">' + w + "</span>";
        else if (cell) {
            sp["data-t"] = cell && cell.t || "z";
            if (cell.v != null) sp["data-v"] = cell.v;
            if (cell.z != null) sp["data-z"] = cell.z;
            if (cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + cell.l.Target + '">' + w + "</a>";
        }
        sp.id = (o.id || "sjs") + "-" + coord;
        oo.push($3ee4f50b1ae43a89$var$writextag("td", w, sp));
    }
    var preamble = "<tr>";
    return preamble + oo.join("") + "</tr>";
}
var $3ee4f50b1ae43a89$var$HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
var $3ee4f50b1ae43a89$var$HTML_END = "</body></html>";
function $3ee4f50b1ae43a89$var$html_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
    var mtch = str.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
    if (!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
    if (mtch.length == 1) return $3ee4f50b1ae43a89$var$sheet_to_workbook($3ee4f50b1ae43a89$var$html_to_sheet(mtch[0], opts), opts);
    var wb = $3ee4f50b1ae43a89$var$book_new();
    mtch.forEach(function(s, idx) {
        $3ee4f50b1ae43a89$var$book_append_sheet(wb, $3ee4f50b1ae43a89$var$html_to_sheet(s, opts), "Sheet" + (idx + 1));
    });
    return wb;
}
function $3ee4f50b1ae43a89$var$make_html_preamble(ws /*:Worksheet*/ , R /*:Range*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    return out.join("") + "<table" + (o && o.id ? ' id="' + o.id + '"' : "") + ">";
}
function $3ee4f50b1ae43a89$var$sheet_to_html(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/  /*, wb:?Workbook*/ ) /*:string*/ {
    var o = opts || {};
    var header = o.header != null ? o.header : $3ee4f50b1ae43a89$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $3ee4f50b1ae43a89$var$HTML_END;
    var out /*:Array<string>*/  = [
        header
    ];
    var r = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
    o.dense = Array.isArray(ws);
    out.push($3ee4f50b1ae43a89$var$make_html_preamble(ws, r, o));
    for(var R = r.s.r; R <= r.e.r; ++R)out.push($3ee4f50b1ae43a89$var$make_html_row(ws, r, R, o));
    out.push("</table>" + footer);
    return out.join("");
}
function $3ee4f50b1ae43a89$var$sheet_add_dom(ws /*:Worksheet*/ , table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var opts = _opts || {};
    if ($3ee4f50b1ae43a89$var$DENSE != null) opts.dense = $3ee4f50b1ae43a89$var$DENSE;
    var or_R = 0, or_C = 0;
    if (opts.origin != null) {
        if (typeof opts.origin == "number") or_R = opts.origin;
        else {
            var _origin /*:CellAddress*/  = typeof opts.origin == "string" ? $3ee4f50b1ae43a89$var$decode_cell(opts.origin) : opts.origin;
            or_R = _origin.r;
            or_C = _origin.c;
        }
    }
    var rows /*:HTMLCollection<HTMLTableRowElement>*/  = table.getElementsByTagName("tr");
    var sheetRows = Math.min(opts.sheetRows || 10000000, rows.length);
    var range /*:Range*/  = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: or_R,
            c: or_C
        }
    };
    if (ws["!ref"]) {
        var _range /*:Range*/  = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
        range.s.r = Math.min(range.s.r, _range.s.r);
        range.s.c = Math.min(range.s.c, _range.s.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        range.e.c = Math.max(range.e.c, _range.e.c);
        if (or_R == -1) range.e.r = or_R = _range.e.r + 1;
    }
    var merges /*:Array<Range>*/  = [], midx = 0;
    var rowinfo /*:Array<RowInfo>*/  = ws["!rows"] || (ws["!rows"] = []);
    var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
    if (!ws["!cols"]) ws["!cols"] = [];
    for(; _R < rows.length && R < sheetRows; ++_R){
        var row /*:HTMLTableRowElement*/  = rows[_R];
        if ($3ee4f50b1ae43a89$var$is_dom_element_hidden(row)) {
            if (opts.display) continue;
            rowinfo[R] = {
                hidden: true
            };
        }
        var elts /*:HTMLCollection<HTMLTableCellElement>*/  = row.children /*:any*/ ;
        for(_C = C = 0; _C < elts.length; ++_C){
            var elt /*:HTMLTableCellElement*/  = elts[_C];
            if (opts.display && $3ee4f50b1ae43a89$var$is_dom_element_hidden(elt)) continue;
            var v /*:?string*/  = elt.hasAttribute("data-v") ? elt.getAttribute("data-v") : elt.hasAttribute("v") ? elt.getAttribute("v") : $3ee4f50b1ae43a89$var$htmldecode(elt.innerHTML);
            var z /*:?string*/  = elt.getAttribute("data-z") || elt.getAttribute("z");
            for(midx = 0; midx < merges.length; ++midx){
                var m /*:Range*/  = merges[midx];
                if (m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) {
                    C = m.e.c + 1 - or_C;
                    midx = -1;
                }
            }
            /* TODO: figure out how to extract nonstandard mso- style */ CS = +elt.getAttribute("colspan") || 1;
            if ((RS = +elt.getAttribute("rowspan") || 1) > 1 || CS > 1) merges.push({
                s: {
                    r: R + or_R,
                    c: C + or_C
                },
                e: {
                    r: R + or_R + (RS || 1) - 1,
                    c: C + or_C + (CS || 1) - 1
                }
            });
            var o /*:Cell*/  = {
                t: "s",
                v: v
            };
            var _t /*:string*/  = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
            if (v != null) {
                if (v.length == 0) o.t = _t || "z";
                else if (opts.raw || v.trim().length == 0 || _t == "s") ;
                else if (v === "TRUE") o = {
                    t: "b",
                    v: true
                };
                else if (v === "FALSE") o = {
                    t: "b",
                    v: false
                };
                else if (!isNaN($3ee4f50b1ae43a89$var$fuzzynum(v))) o = {
                    t: "n",
                    v: $3ee4f50b1ae43a89$var$fuzzynum(v)
                };
                else if (!isNaN($3ee4f50b1ae43a89$var$fuzzydate(v).getDate())) {
                    o = {
                        t: "d",
                        v: $3ee4f50b1ae43a89$var$parseDate(v)
                    } /*:any*/ ;
                    if (!opts.cellDates) o = {
                        t: "n",
                        v: $3ee4f50b1ae43a89$var$datenum(o.v)
                    } /*:any*/ ;
                    o.z = opts.dateNF || $3ee4f50b1ae43a89$var$table_fmt[14];
                }
            }
            if (o.z === undefined && z != null) o.z = z;
            /* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */ var l = "", Aelts = elt.getElementsByTagName("A");
            if (Aelts && Aelts.length) {
                for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)if (Aelts[Aelti].hasAttribute("href")) {
                    l = Aelts[Aelti].getAttribute("href");
                    if (l.charAt(0) != "#") break;
                }
            }
            if (l && l.charAt(0) != "#") o.l = {
                Target: l
            };
            if (opts.dense) {
                if (!ws[R + or_R]) ws[R + or_R] = [];
                ws[R + or_R][C + or_C] = o;
            } else ws[$3ee4f50b1ae43a89$var$encode_cell({
                c: C + or_C,
                r: R + or_R
            })] = o;
            if (range.e.c < C + or_C) range.e.c = C + or_C;
            C += CS;
        }
        ++R;
    }
    if (merges.length) ws["!merges"] = (ws["!merges"] || []).concat(merges);
    range.e.r = Math.max(range.e.r, R - 1 + or_R);
    ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
    if (R >= sheetRows) ws["!fullref"] = $3ee4f50b1ae43a89$var$encode_range((range.e.r = rows.length - _R + R - 1 + or_R, range)); // We can count the real number of rows to parse but we don't to improve the performance
    return ws;
}
function $3ee4f50b1ae43a89$var$parse_dom_table(table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var opts = _opts || {};
    var ws /*:Worksheet*/  = opts.dense ? [] : {} /*:any*/ ;
    return $3ee4f50b1ae43a89$var$sheet_add_dom(ws, table, _opts);
}
function $3ee4f50b1ae43a89$var$table_to_book(table /*:HTMLElement*/ , opts /*:?any*/ ) /*:Workbook*/ {
    return $3ee4f50b1ae43a89$var$sheet_to_workbook($3ee4f50b1ae43a89$var$parse_dom_table(table, opts), opts);
}
function $3ee4f50b1ae43a89$var$is_dom_element_hidden(element /*:HTMLElement*/ ) /*:boolean*/ {
    var display /*:string*/  = "";
    var get_computed_style /*:?function*/  = $3ee4f50b1ae43a89$var$get_get_computed_style_function(element);
    if (get_computed_style) display = get_computed_style(element).getPropertyValue("display");
    if (!display) display = element.style && element.style.display;
    return display === "none";
}
/* global getComputedStyle */ function $3ee4f50b1ae43a89$var$get_get_computed_style_function(element /*:HTMLElement*/ ) /*:?function*/ {
    // The proper getComputedStyle implementation is the one defined in the element window
    if (element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === "function") return element.ownerDocument.defaultView.getComputedStyle;
    // If it is not available, try to get one from the global namespace
    if (typeof getComputedStyle === "function") return getComputedStyle;
    return null;
}
/* OpenDocument */ function $3ee4f50b1ae43a89$var$parse_text_p(text /*:string*/  /*::, tag*/ ) /*:Array<any>*/ {
    /* 6.1.2 White Space Characters */ var fixed = text.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function($$, $1) {
        return Array(parseInt($1, 10) + 1).join(" ");
    }).replace(/<text:tab[^>]*\/>/g, "	").replace(/<text:line-break\/>/g, "\n");
    var v = $3ee4f50b1ae43a89$var$unescapexml(fixed.replace(/<[^>]*>/g, ""));
    return [
        v
    ];
}
var $3ee4f50b1ae43a89$var$number_formats_ods = {
    /* ods name: [short ssf fmt, long ssf fmt] */ day: [
        "d",
        "dd"
    ],
    month: [
        "m",
        "mm"
    ],
    year: [
        "y",
        "yy"
    ],
    hours: [
        "h",
        "hh"
    ],
    minutes: [
        "m",
        "mm"
    ],
    seconds: [
        "s",
        "ss"
    ],
    "am-pm": [
        "A/P",
        "AM/PM"
    ],
    "day-of-week": [
        "ddd",
        "dddd"
    ],
    era: [
        "e",
        "ee"
    ],
    /* there is no native representation of LO "Q" format */ quarter: [
        "\\Qm",
        'm\\"th quarter"'
    ]
};
function $3ee4f50b1ae43a89$var$parse_content_xml(d /*:string*/ , _opts) /*:Workbook*/ {
    var opts = _opts || {};
    if ($3ee4f50b1ae43a89$var$DENSE != null && opts.dense == null) opts.dense = $3ee4f50b1ae43a89$var$DENSE;
    var str = $3ee4f50b1ae43a89$var$xlml_normalize(d);
    var state /*:Array<any>*/  = [], tmp;
    var tag /*:: = {}*/ ;
    var NFtag = {
        name: ""
    }, NF = "", pidx = 0;
    var sheetag /*:: = {name:"", '名称':""}*/ ;
    var rowtag /*:: = {'行号':""}*/ ;
    var Sheets = {}, SheetNames /*:Array<string>*/  = [];
    var ws = opts.dense ? [] : {} /*:any*/ ;
    var Rn, q /*:: :any = ({t:"", v:null, z:null, w:"",c:[],}:any)*/ ;
    var ctag = {
        value: ""
    } /*:any*/ ;
    var textp = "", textpidx = 0, textptag /*:: = {}*/ ;
    var textR = [];
    var R = -1, C = -1, range = {
        s: {
            r: 1000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var row_ol = 0;
    var number_format_map = {};
    var merges /*:Array<Range>*/  = [], mrange = {}, mR = 0, mC = 0;
    var rowinfo /*:Array<RowInfo>*/  = [], rowpeat = 1, colpeat = 1;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var WB = {
        Names: []
    };
    var atag = {} /*:any*/ ;
    var _Ref /*:[string, string]*/  = [
        "",
        ""
    ];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var creator = "", creatoridx = 0;
    var isstub = false, intable = false;
    var i = 0;
    $3ee4f50b1ae43a89$var$xlmlregex.lastIndex = 0;
    str = str.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
    while(Rn = $3ee4f50b1ae43a89$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_.*$/, "")){
        case "table":
        case "\u5DE5\u4F5C\u8868":
            if (Rn[1] === "/") {
                if (range.e.c >= range.s.c && range.e.r >= range.s.r) ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
                else ws["!ref"] = "A1:A1";
                if (opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
                    ws["!fullref"] = ws["!ref"];
                    range.e.r = opts.sheetRows - 1;
                    ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
                }
                if (merges.length) ws["!merges"] = merges;
                if (rowinfo.length) ws["!rows"] = rowinfo;
                sheetag.name = sheetag["\u540D\u79F0"] || sheetag.name;
                if (typeof JSON !== "undefined") JSON.stringify(sheetag);
                SheetNames.push(sheetag.name);
                Sheets[sheetag.name] = ws;
                intable = false;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                sheetag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                R = C = -1;
                range.s.r = range.s.c = 10000000;
                range.e.r = range.e.c = 0;
                ws = opts.dense ? [] : {} /*:any*/ ;
                merges = [];
                rowinfo = [];
                intable = true;
            }
            break;
        case "table-row-group":
            if (Rn[1] === "/") --row_ol;
            else ++row_ol;
            break;
        case "table-row":
        case "\u884C":
            if (Rn[1] === "/") {
                R += rowpeat;
                rowpeat = 1;
                break;
            }
            rowtag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            if (rowtag["\u884C\u53F7"]) R = rowtag["\u884C\u53F7"] - 1;
            else if (R == -1) R = 0;
            rowpeat = +rowtag["number-rows-repeated"] || 1;
            /* TODO: remove magic */ if (rowpeat < 10) {
                for(i = 0; i < rowpeat; ++i)if (row_ol > 0) rowinfo[R + i] = {
                    level: row_ol
                };
            }
            C = -1;
            break;
        case "covered-table-cell":
            if (Rn[1] !== "/") ++C;
            if (opts.sheetStubs) {
                if (opts.dense) {
                    if (!ws[R]) ws[R] = [];
                    ws[R][C] = {
                        t: "z"
                    };
                } else ws[$3ee4f50b1ae43a89$var$encode_cell({
                    r: R,
                    c: C
                })] = {
                    t: "z"
                };
            }
            textp = "";
            textR = [];
            break; /* stub */ 
        case "table-cell":
        case "\u6570\u636E":
            if (Rn[0].charAt(Rn[0].length - 2) === "/") {
                ++C;
                ctag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag["number-columns-repeated"] || "1", 10);
                q = {
                    t: "z",
                    v: null
                } /*:any*/ ;
                if (ctag.formula && opts.cellFormula != false) q.f = $3ee4f50b1ae43a89$var$ods_to_csf_formula($3ee4f50b1ae43a89$var$unescapexml(ctag.formula));
                if ((ctag["\u6570\u636E\u7C7B\u578B"] || ctag["value-type"]) == "string") {
                    q.t = "s";
                    q.v = $3ee4f50b1ae43a89$var$unescapexml(ctag["string-value"] || "");
                    if (opts.dense) {
                        if (!ws[R]) ws[R] = [];
                        ws[R][C] = q;
                    } else ws[$3ee4f50b1ae43a89$var$encode_cell({
                        r: R,
                        c: C
                    })] = q;
                }
                C += colpeat - 1;
            } else if (Rn[1] !== "/") {
                ++C;
                textp = "";
                textpidx = 0;
                textR = [];
                colpeat = 1;
                var rptR = rowpeat ? R + rowpeat - 1 : R;
                if (C > range.e.c) range.e.c = C;
                if (C < range.s.c) range.s.c = C;
                if (R < range.s.r) range.s.r = R;
                if (rptR > range.e.r) range.e.r = rptR;
                ctag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                comments = [];
                comment = {} /*:any*/ ;
                q = {
                    t: ctag["\u6570\u636E\u7C7B\u578B"] || ctag["value-type"],
                    v: null
                } /*:any*/ ;
                if (opts.cellFormula) {
                    if (ctag.formula) ctag.formula = $3ee4f50b1ae43a89$var$unescapexml(ctag.formula);
                    if (ctag["number-matrix-columns-spanned"] && ctag["number-matrix-rows-spanned"]) {
                        mR = parseInt(ctag["number-matrix-rows-spanned"], 10) || 0;
                        mC = parseInt(ctag["number-matrix-columns-spanned"], 10) || 0;
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        q.F = $3ee4f50b1ae43a89$var$encode_range(mrange);
                        arrayf.push([
                            mrange,
                            q.F
                        ]);
                    }
                    if (ctag.formula) q.f = $3ee4f50b1ae43a89$var$ods_to_csf_formula(ctag.formula);
                    else for(i = 0; i < arrayf.length; ++i)if (R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r) {
                        if (C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c) q.F = arrayf[i][1];
                    }
                }
                if (ctag["number-columns-spanned"] || ctag["number-rows-spanned"]) {
                    mR = parseInt(ctag["number-rows-spanned"], 10) || 0;
                    mC = parseInt(ctag["number-columns-spanned"], 10) || 0;
                    mrange = {
                        s: {
                            r: R,
                            c: C
                        },
                        e: {
                            r: R + mR - 1,
                            c: C + mC - 1
                        }
                    };
                    merges.push(mrange);
                }
                /* 19.675.2 table:number-columns-repeated */ if (ctag["number-columns-repeated"]) colpeat = parseInt(ctag["number-columns-repeated"], 10);
                /* 19.385 office:value-type */ switch(q.t){
                    case "boolean":
                        q.t = "b";
                        q.v = $3ee4f50b1ae43a89$var$parsexmlbool(ctag["boolean-value"]);
                        break;
                    case "float":
                        q.t = "n";
                        q.v = parseFloat(ctag.value);
                        break;
                    case "percentage":
                        q.t = "n";
                        q.v = parseFloat(ctag.value);
                        break;
                    case "currency":
                        q.t = "n";
                        q.v = parseFloat(ctag.value);
                        break;
                    case "date":
                        q.t = "d";
                        q.v = $3ee4f50b1ae43a89$var$parseDate(ctag["date-value"]);
                        if (!opts.cellDates) {
                            q.t = "n";
                            q.v = $3ee4f50b1ae43a89$var$datenum(q.v);
                        }
                        q.z = "m/d/yy";
                        break;
                    case "time":
                        q.t = "n";
                        q.v = $3ee4f50b1ae43a89$var$parse_isodur(ctag["time-value"]) / 86400;
                        if (opts.cellDates) {
                            q.t = "d";
                            q.v = $3ee4f50b1ae43a89$var$numdate(q.v);
                        }
                        q.z = "HH:MM:SS";
                        break;
                    case "number":
                        q.t = "n";
                        q.v = parseFloat(ctag["\u6570\u636E\u6570\u503C"]);
                        break;
                    default:
                        if (q.t === "string" || q.t === "text" || !q.t) {
                            q.t = "s";
                            if (ctag["string-value"] != null) {
                                textp = $3ee4f50b1ae43a89$var$unescapexml(ctag["string-value"]);
                                textR = [];
                            }
                        } else throw new Error("Unsupported value type " + q.t);
                }
            } else {
                isstub = false;
                if (q.t === "s") {
                    q.v = textp || "";
                    if (textR.length) q.R = textR;
                    isstub = textpidx == 0;
                }
                if (atag.Target) q.l = atag;
                if (comments.length > 0) {
                    q.c = comments;
                    comments = [];
                }
                if (textp && opts.cellText !== false) q.w = textp;
                if (isstub) {
                    q.t = "z";
                    delete q.v;
                }
                if (!isstub || opts.sheetStubs) {
                    if (!(opts.sheetRows && opts.sheetRows <= R)) for(var rpt = 0; rpt < rowpeat; ++rpt){
                        colpeat = parseInt(ctag["number-columns-repeated"] || "1", 10);
                        if (opts.dense) {
                            if (!ws[R + rpt]) ws[R + rpt] = [];
                            ws[R + rpt][C] = rpt == 0 ? q : $3ee4f50b1ae43a89$var$dup(q);
                            while(--colpeat > 0)ws[R + rpt][C + colpeat] = $3ee4f50b1ae43a89$var$dup(q);
                        } else {
                            ws[$3ee4f50b1ae43a89$var$encode_cell({
                                r: R + rpt,
                                c: C
                            })] = q;
                            while(--colpeat > 0)ws[$3ee4f50b1ae43a89$var$encode_cell({
                                r: R + rpt,
                                c: C + colpeat
                            })] = $3ee4f50b1ae43a89$var$dup(q);
                        }
                        if (range.e.c <= C) range.e.c = C;
                    }
                }
                colpeat = parseInt(ctag["number-columns-repeated"] || "1", 10);
                C += colpeat - 1;
                colpeat = 0;
                q = {};
                textp = "";
                textR = [];
            }
            atag = {} /*:any*/ ;
            break; // 9.1.4 <table:table-cell>
        /* pure state */ case "document":
        case "document-content":
        case "\u7535\u5B50\u8868\u683C\u6587\u6863":
        case "spreadsheet":
        case "\u4E3B\u4F53":
        case "scripts":
        case "styles":
        case "font-face-decls":
        case "master-styles":
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                true
            ]);
            break;
        case "annotation":
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
                comment.t = textp;
                if (textR.length) /*::(*/ comment /*:: :any)*/ .R = textR;
                comment.a = creator;
                comments.push(comment);
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                false
            ]);
            creator = "";
            creatoridx = 0;
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case "creator":
            if (Rn[1] === "/") creator = str.slice(creatoridx, Rn.index);
            else creatoridx = Rn.index + Rn[0].length;
            break;
        /* ignore state */ case "meta":
        case "\u5143\u6570\u636E":
        case "settings":
        case "config-item-set":
        case "config-item-map-indexed":
        case "config-item-map-entry":
        case "config-item-map-named":
        case "shapes":
        case "frame":
        case "text-box":
        case "image":
        case "data-pilot-tables":
        case "list-style":
        case "form":
        case "dde-links":
        case "event-listeners":
        case "chart":
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                false
            ]);
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case "scientific-number":
            break;
        case "currency-symbol":
            break;
        case "currency-style":
            break;
        case "number-style":
        case "percentage-style":
        case "date-style":
        case "time-style":
            if (Rn[1] === "/") {
                number_format_map[NFtag.name] = NF;
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                NF = "";
                NFtag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                state.push([
                    Rn[3],
                    true
                ]);
            }
            break;
        case "script":
            break; // 3.13 <office:script>
        case "libraries":
            break; // TODO: <ooo:libraries>
        case "automatic-styles":
            break; // 3.15.3 <office:automatic-styles>
        case "default-style":
        case "page-layout":
            break; // TODO: <style:page-layout>
        case "style":
            break;
        case "map":
            break; // 16.3 <style:map>
        case "font-face":
            break; // 16.21 <style:font-face>
        case "paragraph-properties":
            break; // 17.6 <style:paragraph-properties>
        case "table-properties":
            break; // 17.15 <style:table-properties>
        case "table-column-properties":
            break; // 17.16 <style:table-column-properties>
        case "table-row-properties":
            break; // 17.17 <style:table-row-properties>
        case "table-cell-properties":
            break; // 17.18 <style:table-cell-properties>
        case "number":
            switch(state[state.length - 1][0]){
                case "time-style":
                case "date-style":
                    tag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                    NF += $3ee4f50b1ae43a89$var$number_formats_ods[Rn[3]][tag.style === "long" ? 1 : 0];
                    break;
            }
            break;
        case "fraction":
            break; // TODO 16.27.6 <number:fraction>
        case "day":
        case "month":
        case "year":
        case "era":
        case "day-of-week":
        case "week-of-year":
        case "quarter":
        case "hours":
        case "minutes":
        case "seconds":
        case "am-pm":
            switch(state[state.length - 1][0]){
                case "time-style":
                case "date-style":
                    tag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                    NF += $3ee4f50b1ae43a89$var$number_formats_ods[Rn[3]][tag.style === "long" ? 1 : 0];
                    break;
            }
            break;
        case "boolean-style":
            break; // 16.27.23 <number:boolean-style>
        case "boolean":
            break; // 16.27.24 <number:boolean>
        case "text-style":
            break; // 16.27.25 <number:text-style>
        case "text":
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") switch(state[state.length - 1][0]){
                case "number-style":
                case "date-style":
                case "time-style":
                    NF += str.slice(pidx, Rn.index);
                    break;
            }
            else pidx = Rn.index + Rn[0].length;
            break;
        case "named-range":
            tag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
            _Ref = $3ee4f50b1ae43a89$var$ods_to_csf_3D(tag["cell-range-address"]);
            var nrange = {
                Name: tag.name,
                Ref: _Ref[0] + "!" + _Ref[1]
            } /*:any*/ ;
            if (intable) nrange.Sheet = SheetNames.length;
            WB.Names.push(nrange);
            break;
        case "text-content":
            break; // 16.27.27 <number:text-content>
        case "text-properties":
            break; // 16.27.27 <style:text-properties>
        case "embedded-text":
            break; // 16.27.4 <number:embedded-text>
        case "body":
        case "\u7535\u5B50\u8868\u683C":
            break; // 3.3 16.9.6 19.726.3
        case "forms":
            break; // 12.25.2 13.2
        case "table-column":
            break; // 9.1.6 <table:table-column>
        case "table-header-rows":
            break; // 9.1.7 <table:table-header-rows>
        case "table-rows":
            break; // 9.1.12 <table:table-rows>
        /* TODO: outline levels */ case "table-column-group":
            break; // 9.1.10 <table:table-column-group>
        case "table-header-columns":
            break; // 9.1.11 <table:table-header-columns>
        case "table-columns":
            break; // 9.1.12 <table:table-columns>
        case "null-date":
            break; // 9.4.2 <table:null-date> TODO: date1904
        case "graphic-properties":
            break; // 17.21 <style:graphic-properties>
        case "calculation-settings":
            break; // 9.4.1 <table:calculation-settings>
        case "named-expressions":
            break; // 9.4.11 <table:named-expressions>
        case "label-range":
            break; // 9.4.9 <table:label-range>
        case "label-ranges":
            break; // 9.4.10 <table:label-ranges>
        case "named-expression":
            break; // 9.4.13 <table:named-expression>
        case "sort":
            break; // 9.4.19 <table:sort>
        case "sort-by":
            break; // 9.4.20 <table:sort-by>
        case "sort-groups":
            break; // 9.4.22 <table:sort-groups>
        case "tab":
            break; // 6.1.4 <text:tab>
        case "line-break":
            break; // 6.1.5 <text:line-break>
        case "span":
            break; // 6.1.7 <text:span>
        case "p":
        case "\u6587\u672C\u4E32":
            if ([
                "master-styles"
            ].indexOf(state[state.length - 1][0]) > -1) break;
            if (Rn[1] === "/" && (!ctag || !ctag["string-value"])) {
                var ptp = $3ee4f50b1ae43a89$var$parse_text_p(str.slice(textpidx, Rn.index), textptag);
                textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
            } else {
                textptag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                textpidx = Rn.index + Rn[0].length;
            }
            break; // <text:p>
        case "s":
            break; // <text:s>
        case "database-range":
            if (Rn[1] === "/") break;
            try {
                _Ref = $3ee4f50b1ae43a89$var$ods_to_csf_3D($3ee4f50b1ae43a89$var$parsexmltag(Rn[0])["target-range-address"]);
                Sheets[_Ref[0]]["!autofilter"] = {
                    ref: _Ref[1]
                };
            } catch (e) {}
            break;
        case "date":
            break; // <*:date>
        case "object":
            break; // 10.4.6.2 <draw:object>
        case "title":
        case "\u6807\u9898":
            break; // <*:title> OR <uof:标题>
        case "desc":
            break; // <*:desc>
        case "binary-data":
            break; // 10.4.5 TODO: b64 blob
        /* 9.2 Advanced Tables */ case "table-source":
            break; // 9.2.6
        case "scenario":
            break; // 9.2.6
        case "iteration":
            break; // 9.4.3 <table:iteration>
        case "content-validations":
            break; // 9.4.4 <table:
        case "content-validation":
            break; // 9.4.5 <table:
        case "help-message":
            break; // 9.4.6 <table:
        case "error-message":
            break; // 9.4.7 <table:
        case "database-ranges":
            break; // 9.4.14 <table:database-ranges>
        case "filter":
            break; // 9.5.2 <table:filter>
        case "filter-and":
            break; // 9.5.3 <table:filter-and>
        case "filter-or":
            break; // 9.5.4 <table:filter-or>
        case "filter-condition":
            break; // 9.5.5 <table:filter-condition>
        case "list-level-style-bullet":
            break; // 16.31 <text:
        case "list-level-style-number":
            break; // 16.32 <text:
        case "list-level-properties":
            break; // 17.19 <style:
        /* 7.3 Document Fields */ case "sender-firstname":
        case "sender-lastname":
        case "sender-initials":
        case "sender-title":
        case "sender-position":
        case "sender-email":
        case "sender-phone-private":
        case "sender-fax":
        case "sender-company":
        case "sender-phone-work":
        case "sender-street":
        case "sender-city":
        case "sender-postal-code":
        case "sender-country":
        case "sender-state-or-province":
        case "author-name":
        case "author-initials":
        case "chapter":
        case "file-name":
        case "template-name":
        case "sheet-name":
            break;
        case "event-listener":
            break;
        /* TODO: FODS Properties */ case "initial-creator":
        case "creation-date":
        case "print-date":
        case "generator":
        case "document-statistic":
        case "user-defined":
        case "editing-duration":
        case "editing-cycles":
            break;
        /* TODO: FODS Config */ case "config-item":
            break;
        /* TODO: style tokens */ case "page-number":
            break; // TODO <text:page-number>
        case "page-count":
            break; // TODO <text:page-count>
        case "time":
            break; // TODO <text:time>
        /* 9.3 Advanced Table Cells */ case "cell-range-source":
            break; // 9.3.1 <table:
        case "detective":
            break; // 9.3.2 <table:
        case "operation":
            break; // 9.3.3 <table:
        case "highlighted-range":
            break; // 9.3.4 <table:
        /* 9.6 Data Pilot Tables <table: */ case "data-pilot-table":
        case "source-cell-range":
        case "source-service":
        case "data-pilot-field":
        case "data-pilot-level":
        case "data-pilot-subtotals":
        case "data-pilot-subtotal":
        case "data-pilot-members":
        case "data-pilot-member":
        case "data-pilot-display-info":
        case "data-pilot-sort-info":
        case "data-pilot-layout-info":
        case "data-pilot-field-reference":
        case "data-pilot-groups":
        case "data-pilot-group":
        case "data-pilot-group-member":
            break;
        /* 10.3 Drawing Shapes */ case "rect":
            break;
        /* 14.6 DDE Connections */ case "dde-connection-decls":
        case "dde-connection-decl":
        case "dde-link":
        case "dde-source":
            break;
        case "properties":
            break; // 13.7 <form:properties>
        case "property":
            break; // 13.8 <form:property>
        case "a":
            if (Rn[1] !== "/") {
                atag = $3ee4f50b1ae43a89$var$parsexmltag(Rn[0], false);
                if (!atag.href) break;
                atag.Target = $3ee4f50b1ae43a89$var$unescapexml(atag.href);
                delete atag.href;
                if (atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
                    _Ref = $3ee4f50b1ae43a89$var$ods_to_csf_3D(atag.Target.slice(1));
                    atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
                } else if (atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
            }
            break;
        /* non-standard */ case "table-protection":
            break;
        case "data-pilot-grand-total":
            break; // <table:
        case "office-document-common-attrs":
            break; // bare
        default:
            switch(Rn[2]){
                case "dc:":
                case "calcext:":
                case "loext:":
                case "ooo:":
                case "chartooo:":
                case "draw:":
                case "style:":
                case "chart:":
                case "form:":
                case "uof:":
                case "\u8868:":
                case "\u5B57:":
                    break;
                default:
                    if (opts.WTF) throw new Error(Rn);
            }
    }
    var out /*:Workbook*/  = {
        Sheets: Sheets,
        SheetNames: SheetNames,
        Workbook: WB
    } /*:any*/ ;
    if (opts.bookSheets) delete /*::(*/ out /*:: :any)*/ .Sheets;
    return out;
}
function $3ee4f50b1ae43a89$var$parse_ods(zip /*:ZIPFile*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    opts = opts || {} /*:any*/ ;
    if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, "META-INF/manifest.xml")) $3ee4f50b1ae43a89$var$parse_manifest($3ee4f50b1ae43a89$var$getzipdata(zip, "META-INF/manifest.xml"), opts);
    var content = $3ee4f50b1ae43a89$var$getzipstr(zip, "content.xml");
    if (!content) throw new Error("Missing content.xml in ODS / UOF file");
    var wb = $3ee4f50b1ae43a89$var$parse_content_xml($3ee4f50b1ae43a89$var$utf8read(content), opts);
    if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, "meta.xml")) wb.Props = $3ee4f50b1ae43a89$var$parse_core_props($3ee4f50b1ae43a89$var$getzipdata(zip, "meta.xml"));
    return wb;
}
function $3ee4f50b1ae43a89$var$parse_fods(data /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    return $3ee4f50b1ae43a89$var$parse_content_xml(data, opts);
}
/* OpenDocument */ var $3ee4f50b1ae43a89$var$write_styles_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    var master_styles = [
        "<office:master-styles>",
        '<style:master-page style:name="mp1" style:page-layout-name="mp1">',
        "<style:header/>",
        '<style:header-left style:display="false"/>',
        "<style:footer/>",
        '<style:footer-left style:display="false"/>',
        "</style:master-page>",
        "</office:master-styles>"
    ].join("");
    var payload = "<office:document-styles " + $3ee4f50b1ae43a89$var$wxt_helper({
        "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
        "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
        "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
        "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
        "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
        "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "xmlns:dc": "http://purl.org/dc/elements/1.1/",
        "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
        "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
        "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
        "office:version": "1.2"
    }) + ">" + master_styles + "</office:document-styles>";
    return function wso() {
        return $3ee4f50b1ae43a89$var$XML_HEADER + payload;
    };
}();
var $3ee4f50b1ae43a89$var$write_content_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    /* 6.1.2 White Space Characters */ var write_text_p = function(text /*:string*/ ) /*:string*/ {
        return $3ee4f50b1ae43a89$var$escapexml(text).replace(/  +/g, function($$) {
            return '<text:s text:c="' + $$.length + '"/>';
        }).replace(/\t/g, "<text:tab/>").replace(/\n/g, "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
    };
    var null_cell_xml = "          <table:table-cell />\n";
    var covered_cell_xml = "          <table:covered-table-cell/>\n";
    var write_ws = function(ws, wb /*:Workbook*/ , i /*:number*/  /*::, opts*/ ) /*:string*/ {
        /* Section 9 Tables */ var o /*:Array<string>*/  = [];
        o.push('      <table:table table:name="' + $3ee4f50b1ae43a89$var$escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
        var R = 0, C = 0, range = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"] || "A1");
        var marr /*:Array<Range>*/  = ws["!merges"] || [], mi = 0;
        var dense = Array.isArray(ws);
        if (ws["!cols"]) for(C = 0; C <= range.e.c; ++C)o.push("        <table:table-column" + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : "") + "></table:table-column>\n");
        var H = "", ROWS = ws["!rows"] || [];
        for(R = 0; R < range.s.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push("        <table:table-row" + H + "></table:table-row>\n");
        }
        for(; R <= range.e.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push("        <table:table-row" + H + ">\n");
            for(C = 0; C < range.s.c; ++C)o.push(null_cell_xml);
            for(; C <= range.e.c; ++C){
                var skip = false, ct = {}, textp = "";
                for(mi = 0; mi != marr.length; ++mi){
                    if (marr[mi].s.c > C) continue;
                    if (marr[mi].s.r > R) continue;
                    if (marr[mi].e.c < C) continue;
                    if (marr[mi].e.r < R) continue;
                    if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                    ct["table:number-columns-spanned"] = marr[mi].e.c - marr[mi].s.c + 1;
                    ct["table:number-rows-spanned"] = marr[mi].e.r - marr[mi].s.r + 1;
                    break;
                }
                if (skip) {
                    o.push(covered_cell_xml);
                    continue;
                }
                var ref = $3ee4f50b1ae43a89$var$encode_cell({
                    r: R,
                    c: C
                }), cell = dense ? (ws[R] || [])[C] : ws[ref];
                if (cell && cell.f) {
                    ct["table:formula"] = $3ee4f50b1ae43a89$var$escapexml($3ee4f50b1ae43a89$var$csf_to_ods_formula(cell.f));
                    if (cell.F) {
                        if (cell.F.slice(0, ref.length) == ref) {
                            var _Fref = $3ee4f50b1ae43a89$var$decode_range(cell.F);
                            ct["table:number-matrix-columns-spanned"] = _Fref.e.c - _Fref.s.c + 1;
                            ct["table:number-matrix-rows-spanned"] = _Fref.e.r - _Fref.s.r + 1;
                        }
                    }
                }
                if (!cell) {
                    o.push(null_cell_xml);
                    continue;
                }
                switch(cell.t){
                    case "b":
                        textp = cell.v ? "TRUE" : "FALSE";
                        ct["office:value-type"] = "boolean";
                        ct["office:boolean-value"] = cell.v ? "true" : "false";
                        break;
                    case "n":
                        textp = cell.w || String(cell.v || 0);
                        ct["office:value-type"] = "float";
                        ct["office:value"] = cell.v || 0;
                        break;
                    case "s":
                    case "str":
                        textp = cell.v == null ? "" : cell.v;
                        ct["office:value-type"] = "string";
                        break;
                    case "d":
                        textp = cell.w || $3ee4f50b1ae43a89$var$parseDate(cell.v).toISOString();
                        ct["office:value-type"] = "date";
                        ct["office:date-value"] = $3ee4f50b1ae43a89$var$parseDate(cell.v).toISOString();
                        ct["table:style-name"] = "ce1";
                        break;
                    //case 'e':
                    default:
                        o.push(null_cell_xml);
                        continue;
                }
                var text_p = write_text_p(textp);
                if (cell.l && cell.l.Target) {
                    var _tgt = cell.l.Target;
                    _tgt = _tgt.charAt(0) == "#" ? "#" + $3ee4f50b1ae43a89$var$csf_to_ods_3D(_tgt.slice(1)) : _tgt;
                    // TODO: choose correct parent path format based on link delimiters
                    if (_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = "../" + _tgt;
                    text_p = $3ee4f50b1ae43a89$var$writextag("text:a", text_p, {
                        "xlink:href": _tgt.replace(/&/g, "&amp;")
                    });
                }
                o.push("          " + $3ee4f50b1ae43a89$var$writextag("table:table-cell", $3ee4f50b1ae43a89$var$writextag("text:p", text_p, {}), ct) + "\n");
            }
            o.push("        </table:table-row>\n");
        }
        o.push("      </table:table>\n");
        return o.join("");
    };
    var write_automatic_styles_ods = function(o /*:Array<string>*/ , wb) {
        o.push(" <office:automatic-styles>\n");
        o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
        o.push('   <number:month number:style="long"/>\n');
        o.push("   <number:text>/</number:text>\n");
        o.push('   <number:day number:style="long"/>\n');
        o.push("   <number:text>/</number:text>\n");
        o.push("   <number:year/>\n");
        o.push("  </number:date-style>\n");
        /* column styles */ var cidx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!cols"]) {
                for(var C = 0; C < ws["!cols"].length; ++C)if (ws["!cols"][C]) {
                    var colobj = ws["!cols"][C];
                    if (colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
                    $3ee4f50b1ae43a89$var$process_col(colobj);
                    colobj.ods = cidx;
                    var w = ws["!cols"][C].wpx + "px";
                    o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
                    o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
                    o.push("  </style:style>\n");
                    ++cidx;
                }
            }
        });
        /* row styles */ var ridx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!rows"]) {
                for(var R = 0; R < ws["!rows"].length; ++R)if (ws["!rows"][R]) {
                    ws["!rows"][R].ods = ridx;
                    var h = ws["!rows"][R].hpx + "px";
                    o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
                    o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
                    o.push("  </style:style>\n");
                    ++ridx;
                }
            }
        });
        /* table */ o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
        o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
        o.push("  </style:style>\n");
        /* table cells, text */ o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
        /* page-layout */ o.push(" </office:automatic-styles>\n");
    };
    return function wcx(wb, opts) {
        var o = [
            $3ee4f50b1ae43a89$var$XML_HEADER
        ];
        /* 3.1.3.2 */ var attr = $3ee4f50b1ae43a89$var$wxt_helper({
            "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
            "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
            "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
            "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
            "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
            "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            "xmlns:dc": "http://purl.org/dc/elements/1.1/",
            "xmlns:meta": "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
            "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
            "xmlns:presentation": "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
            "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
            "xmlns:chart": "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
            "xmlns:dr3d": "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
            "xmlns:math": "http://www.w3.org/1998/Math/MathML",
            "xmlns:form": "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
            "xmlns:script": "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
            "xmlns:ooo": "http://openoffice.org/2004/office",
            "xmlns:ooow": "http://openoffice.org/2004/writer",
            "xmlns:oooc": "http://openoffice.org/2004/calc",
            "xmlns:dom": "http://www.w3.org/2001/xml-events",
            "xmlns:xforms": "http://www.w3.org/2002/xforms",
            "xmlns:xsd": "http://www.w3.org/2001/XMLSchema",
            "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
            "xmlns:sheet": "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
            "xmlns:rpt": "http://openoffice.org/2005/report",
            "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
            "xmlns:xhtml": "http://www.w3.org/1999/xhtml",
            "xmlns:grddl": "http://www.w3.org/2003/g/data-view#",
            "xmlns:tableooo": "http://openoffice.org/2009/table",
            "xmlns:drawooo": "http://openoffice.org/2010/draw",
            "xmlns:calcext": "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
            "xmlns:loext": "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
            "xmlns:field": "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
            "xmlns:formx": "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
            "xmlns:css3t": "http://www.w3.org/TR/css3-text/",
            "office:version": "1.2"
        });
        var fods = $3ee4f50b1ae43a89$var$wxt_helper({
            "xmlns:config": "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
            "office:mimetype": "application/vnd.oasis.opendocument.spreadsheet"
        });
        if (opts.bookType == "fods") {
            o.push("<office:document" + attr + fods + ">\n");
            o.push($3ee4f50b1ae43a89$var$write_meta_ods().replace(/office:document-meta/g, "office:meta"));
        // TODO: settings (equiv of settings.xml for ODS)
        } else o.push("<office:document-content" + attr + ">\n");
        // o.push('  <office:scripts/>\n');
        write_automatic_styles_ods(o, wb);
        o.push("  <office:body>\n");
        o.push("    <office:spreadsheet>\n");
        for(var i = 0; i != wb.SheetNames.length; ++i)o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts));
        o.push("    </office:spreadsheet>\n");
        o.push("  </office:body>\n");
        if (opts.bookType == "fods") o.push("</office:document>");
        else o.push("</office:document-content>");
        return o.join("");
    };
}();
function $3ee4f50b1ae43a89$var$write_ods(wb /*:any*/ , opts /*:any*/ ) {
    if (opts.bookType == "fods") return $3ee4f50b1ae43a89$var$write_content_ods(wb, opts);
    var zip = $3ee4f50b1ae43a89$var$zip_new();
    var f = "";
    var manifest /*:Array<Array<string> >*/  = [];
    var rdf /*:Array<[string, string]>*/  = [];
    /* Part 3 Section 3.3 MIME Media Type */ f = "mimetype";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
    /* Part 1 Section 2.2 Documents */ f = "content.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_content_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "ContentFile"
    ]);
    /* TODO: these are hard-coded styles to satiate excel */ f = "styles.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_styles_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "StylesFile"
    ]);
    /* TODO: this is hard-coded to satiate excel */ f = "meta.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$XML_HEADER + $3ee4f50b1ae43a89$var$write_meta_ods());
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "MetadataFile"
    ]);
    /* Part 3 Section 6 Metadata Manifest File */ f = "manifest.rdf";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_rdf(rdf /*, opts*/ ));
    manifest.push([
        f,
        "application/rdf+xml"
    ]);
    /* Part 3 Section 4 Manifest File */ f = "META-INF/manifest.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_manifest(manifest /*, opts*/ ));
    return zip;
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */ function $3ee4f50b1ae43a89$var$u8_to_dataview(array) {
    return new DataView(array.buffer, array.byteOffset, array.byteLength);
}
function $3ee4f50b1ae43a89$var$u8str(u8) {
    return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : $3ee4f50b1ae43a89$var$utf8read($3ee4f50b1ae43a89$var$a2s(u8));
}
function $3ee4f50b1ae43a89$var$stru8(str) {
    return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : $3ee4f50b1ae43a89$var$s2a($3ee4f50b1ae43a89$var$utf8write(str));
}
function $3ee4f50b1ae43a89$var$u8contains(body, search) {
    outer: for(var L = 0; L <= body.length - search.length; ++L){
        for(var j = 0; j < search.length; ++j)if (body[L + j] != search[j]) continue outer;
        return true;
    }
    return false;
}
function $3ee4f50b1ae43a89$var$u8concat(u8a) {
    var len = u8a.reduce(function(acc, x) {
        return acc + x.length;
    }, 0);
    var out = new Uint8Array(len);
    var off = 0;
    u8a.forEach(function(u8) {
        out.set(u8, off);
        off += u8.length;
    });
    return out;
}
function $3ee4f50b1ae43a89$var$popcnt(x) {
    x -= x >> 1 & 1431655765;
    x = (x & 858993459) + (x >> 2 & 858993459);
    return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
}
function $3ee4f50b1ae43a89$var$readDecimal128LE(buf, offset) {
    var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
    var mantissa = buf[offset + 14] & 1;
    for(var j = offset + 13; j >= offset; --j)mantissa = mantissa * 256 + buf[j];
    return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
}
function $3ee4f50b1ae43a89$var$writeDecimal128LE(buf, offset, value) {
    var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 20;
    var mantissa = value / Math.pow(10, exp - 6176);
    buf[offset + 15] |= exp >> 7;
    buf[offset + 14] |= (exp & 127) << 1;
    for(var i = 0; mantissa >= 1; ++i, mantissa /= 256)buf[offset + i] = mantissa & 255;
    buf[offset + 15] |= value >= 0 ? 0 : 128;
}
function $3ee4f50b1ae43a89$var$parse_varint49(buf, ptr) {
    var l = ptr ? ptr[0] : 0;
    var usz = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        usz |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 28);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 35);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 42);
        ++l;
        if (buf[l++] < 128) break varint;
    }
    if (ptr) ptr[0] = l;
    return usz;
}
function $3ee4f50b1ae43a89$var$write_varint49(v) {
    var usz = new Uint8Array(7);
    usz[0] = v & 127;
    var L = 1;
    sz: if (v > 127) {
        usz[L - 1] |= 128;
        usz[L] = v >> 7 & 127;
        ++L;
        if (v <= 16383) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 14 & 127;
        ++L;
        if (v <= 2097151) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 21 & 127;
        ++L;
        if (v <= 268435455) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 256 >>> 21 & 127;
        ++L;
        if (v <= 34359738367) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 65536 >>> 21 & 127;
        ++L;
        if (v <= 4398046511103) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 16777216 >>> 21 & 127;
        ++L;
    }
    return usz.slice(0, L);
}
function $3ee4f50b1ae43a89$var$varint_to_i32(buf) {
    var l = 0, i32 = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        i32 |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 28;
    }
    return i32;
}
function $3ee4f50b1ae43a89$var$parse_shallow(buf) {
    var out = [], ptr = [
        0
    ];
    while(ptr[0] < buf.length){
        var off = ptr[0];
        var num = $3ee4f50b1ae43a89$var$parse_varint49(buf, ptr);
        var type = num & 7;
        num = Math.floor(num / 8);
        var len = 0;
        var res;
        if (num == 0) break;
        switch(type){
            case 0:
                var l = ptr[0];
                while(buf[ptr[0]++] >= 128);
                res = buf.slice(l, ptr[0]);
                break;
            case 5:
                len = 4;
                res = buf.slice(ptr[0], ptr[0] + len);
                ptr[0] += len;
                break;
            case 1:
                len = 8;
                res = buf.slice(ptr[0], ptr[0] + len);
                ptr[0] += len;
                break;
            case 2:
                len = $3ee4f50b1ae43a89$var$parse_varint49(buf, ptr);
                res = buf.slice(ptr[0], ptr[0] + len);
                ptr[0] += len;
                break;
            case 3:
            case 4:
            default:
                throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
        }
        var v = {
            data: res,
            type: type
        };
        if (out[num] == null) out[num] = [
            v
        ];
        else out[num].push(v);
    }
    return out;
}
function $3ee4f50b1ae43a89$var$write_shallow(proto) {
    var out = [];
    proto.forEach(function(field, idx) {
        field.forEach(function(item) {
            if (!item.data) return;
            out.push($3ee4f50b1ae43a89$var$write_varint49(idx * 8 + item.type));
            if (item.type == 2) out.push($3ee4f50b1ae43a89$var$write_varint49(item.data.length));
            out.push(item.data);
        });
    });
    return $3ee4f50b1ae43a89$var$u8concat(out);
}
function $3ee4f50b1ae43a89$var$mappa(data, cb) {
    return (data == null ? void 0 : data.map(function(d) {
        return cb(d.data);
    })) || [];
}
function $3ee4f50b1ae43a89$var$parse_iwa_file(buf) {
    var _a;
    var out = [], ptr = [
        0
    ];
    while(ptr[0] < buf.length){
        var len = $3ee4f50b1ae43a89$var$parse_varint49(buf, ptr);
        var ai = $3ee4f50b1ae43a89$var$parse_shallow(buf.slice(ptr[0], ptr[0] + len));
        ptr[0] += len;
        var res = {
            id: $3ee4f50b1ae43a89$var$varint_to_i32(ai[1][0].data),
            messages: []
        };
        ai[2].forEach(function(b) {
            var mi = $3ee4f50b1ae43a89$var$parse_shallow(b.data);
            var fl = $3ee4f50b1ae43a89$var$varint_to_i32(mi[3][0].data);
            res.messages.push({
                meta: mi,
                data: buf.slice(ptr[0], ptr[0] + fl)
            });
            ptr[0] += fl;
        });
        if ((_a = ai[3]) == null ? void 0 : _a[0]) res.merge = $3ee4f50b1ae43a89$var$varint_to_i32(ai[3][0].data) >>> 0 > 0;
        out.push(res);
    }
    return out;
}
function $3ee4f50b1ae43a89$var$write_iwa_file(ias) {
    var bufs = [];
    ias.forEach(function(ia) {
        var ai = [];
        ai[1] = [
            {
                data: $3ee4f50b1ae43a89$var$write_varint49(ia.id),
                type: 0
            }
        ];
        ai[2] = [];
        if (ia.merge != null) ai[3] = [
            {
                data: $3ee4f50b1ae43a89$var$write_varint49(+!!ia.merge),
                type: 0
            }
        ];
        var midata = [];
        ia.messages.forEach(function(mi) {
            midata.push(mi.data);
            mi.meta[3] = [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49(mi.data.length)
                }
            ];
            ai[2].push({
                data: $3ee4f50b1ae43a89$var$write_shallow(mi.meta),
                type: 2
            });
        });
        var aipayload = $3ee4f50b1ae43a89$var$write_shallow(ai);
        bufs.push($3ee4f50b1ae43a89$var$write_varint49(aipayload.length));
        bufs.push(aipayload);
        midata.forEach(function(mid) {
            return bufs.push(mid);
        });
    });
    return $3ee4f50b1ae43a89$var$u8concat(bufs);
}
function $3ee4f50b1ae43a89$var$parse_snappy_chunk(type, buf) {
    if (type != 0) throw new Error("Unexpected Snappy chunk type ".concat(type));
    var ptr = [
        0
    ];
    var usz = $3ee4f50b1ae43a89$var$parse_varint49(buf, ptr);
    var chunks = [];
    while(ptr[0] < buf.length){
        var tag = buf[ptr[0]] & 3;
        if (tag == 0) {
            var len = buf[ptr[0]++] >> 2;
            if (len < 60) ++len;
            else {
                var c = len - 59;
                len = buf[ptr[0]];
                if (c > 1) len |= buf[ptr[0] + 1] << 8;
                if (c > 2) len |= buf[ptr[0] + 2] << 16;
                if (c > 3) len |= buf[ptr[0] + 3] << 24;
                len >>>= 0;
                len++;
                ptr[0] += c;
            }
            chunks.push(buf.slice(ptr[0], ptr[0] + len));
            ptr[0] += len;
            continue;
        } else {
            var offset = 0, length = 0;
            if (tag == 1) {
                length = (buf[ptr[0]] >> 2 & 7) + 4;
                offset = (buf[ptr[0]++] & 224) << 3;
                offset |= buf[ptr[0]++];
            } else {
                length = (buf[ptr[0]++] >> 2) + 1;
                if (tag == 2) {
                    offset = buf[ptr[0]] | buf[ptr[0] + 1] << 8;
                    ptr[0] += 2;
                } else {
                    offset = (buf[ptr[0]] | buf[ptr[0] + 1] << 8 | buf[ptr[0] + 2] << 16 | buf[ptr[0] + 3] << 24) >>> 0;
                    ptr[0] += 4;
                }
            }
            chunks = [
                $3ee4f50b1ae43a89$var$u8concat(chunks)
            ];
            if (offset == 0) throw new Error("Invalid offset 0");
            if (offset > chunks[0].length) throw new Error("Invalid offset beyond length");
            if (length >= offset) {
                chunks.push(chunks[0].slice(-offset));
                length -= offset;
                while(length >= chunks[chunks.length - 1].length){
                    chunks.push(chunks[chunks.length - 1]);
                    length -= chunks[chunks.length - 1].length;
                }
            }
            chunks.push(chunks[0].slice(-offset, -offset + length));
        }
    }
    var o = $3ee4f50b1ae43a89$var$u8concat(chunks);
    if (o.length != usz) throw new Error("Unexpected length: ".concat(o.length, " != ").concat(usz));
    return o;
}
function $3ee4f50b1ae43a89$var$decompress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while(l < buf.length){
        var t = buf[l++];
        var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
        l += 3;
        out.push($3ee4f50b1ae43a89$var$parse_snappy_chunk(t, buf.slice(l, l + len)));
        l += len;
    }
    if (l !== buf.length) throw new Error("data is not a valid framed stream!");
    return $3ee4f50b1ae43a89$var$u8concat(out);
}
function $3ee4f50b1ae43a89$var$compress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while(l < buf.length){
        var c = Math.min(buf.length - l, 268435455);
        var frame = new Uint8Array(4);
        out.push(frame);
        var usz = $3ee4f50b1ae43a89$var$write_varint49(c);
        var L = usz.length;
        out.push(usz);
        if (c <= 60) {
            L++;
            out.push(new Uint8Array([
                c - 1 << 2
            ]));
        } else if (c <= 256) {
            L += 2;
            out.push(new Uint8Array([
                240,
                c - 1 & 255
            ]));
        } else if (c <= 65536) {
            L += 3;
            out.push(new Uint8Array([
                244,
                c - 1 & 255,
                c - 1 >> 8 & 255
            ]));
        } else if (c <= 16777216) {
            L += 4;
            out.push(new Uint8Array([
                248,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255
            ]));
        } else if (c <= 4294967296) {
            L += 5;
            out.push(new Uint8Array([
                252,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255,
                c - 1 >>> 24 & 255
            ]));
        }
        out.push(buf.slice(l, l + c));
        L += c;
        frame[0] = 0;
        frame[1] = L & 255;
        frame[2] = L >> 8 & 255;
        frame[3] = L >> 16 & 255;
        l += c;
    }
    return $3ee4f50b1ae43a89$var$u8concat(out);
}
function $3ee4f50b1ae43a89$var$parse_old_storage(buf, sst, rsst, v) {
    var dv = $3ee4f50b1ae43a89$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var data_offset = (v > 1 ? 12 : 8) + $3ee4f50b1ae43a89$var$popcnt(flags & (v > 1 ? 3470 : 398)) * 4;
    var ridx = -1, sidx = -1, ieee = NaN, dt = new Date(2001, 0, 1);
    if (flags & 512) {
        ridx = dv.getUint32(data_offset, true);
        data_offset += 4;
    }
    data_offset += $3ee4f50b1ae43a89$var$popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
    if (flags & 16) {
        sidx = dv.getUint32(data_offset, true);
        data_offset += 4;
    }
    if (flags & 32) {
        ieee = dv.getFloat64(data_offset, true);
        data_offset += 8;
    }
    if (flags & 64) {
        dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
        data_offset += 8;
    }
    var ret;
    switch(buf[2]){
        case 0:
            break;
        case 2:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: sst[sidx]
            };
            break;
        case 5:
            ret = {
                t: "d",
                v: dt
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee / 86400
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) ret = {
                t: "s",
                v: rsst[ridx]
            };
            else if (sidx > -1) ret = {
                t: "s",
                v: sst[sidx]
            };
            else if (!isNaN(ieee)) ret = {
                t: "n",
                v: ieee
            };
            else throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
    }
    return ret;
}
function $3ee4f50b1ae43a89$var$parse_new_storage(buf, sst, rsst) {
    var dv = $3ee4f50b1ae43a89$var$u8_to_dataview(buf);
    var flags = dv.getUint32(8, true);
    var data_offset = 12;
    var ridx = -1, sidx = -1, d128 = NaN, ieee = NaN, dt = new Date(2001, 0, 1);
    if (flags & 1) {
        d128 = $3ee4f50b1ae43a89$var$readDecimal128LE(buf, data_offset);
        data_offset += 16;
    }
    if (flags & 2) {
        ieee = dv.getFloat64(data_offset, true);
        data_offset += 8;
    }
    if (flags & 4) {
        dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
        data_offset += 8;
    }
    if (flags & 8) {
        sidx = dv.getUint32(data_offset, true);
        data_offset += 4;
    }
    if (flags & 16) {
        ridx = dv.getUint32(data_offset, true);
        data_offset += 4;
    }
    var ret;
    switch(buf[1]){
        case 0:
            break;
        case 2:
            ret = {
                t: "n",
                v: d128
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: sst[sidx]
            };
            break;
        case 5:
            ret = {
                t: "d",
                v: dt
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee / 86400
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) ret = {
                t: "s",
                v: rsst[ridx]
            };
            else throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
            break;
        case 10:
            ret = {
                t: "n",
                v: d128
            };
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
    }
    return ret;
}
function $3ee4f50b1ae43a89$var$write_new_storage(cell, sst) {
    var out = new Uint8Array(32), dv = $3ee4f50b1ae43a89$var$u8_to_dataview(out), l = 12, flags = 0;
    out[0] = 5;
    switch(cell.t){
        case "n":
            out[1] = 2;
            $3ee4f50b1ae43a89$var$writeDecimal128LE(out, l, cell.v);
            flags |= 1;
            l += 16;
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            flags |= 2;
            l += 8;
            break;
        case "s":
            if (sst.indexOf(cell.v) == -1) throw new Error("Value ".concat(cell.v, " missing from SST!"));
            out[1] = 3;
            dv.setUint32(l, sst.indexOf(cell.v), true);
            flags |= 8;
            l += 4;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(8, flags, true);
    return out.slice(0, l);
}
function $3ee4f50b1ae43a89$var$write_old_storage(cell, sst) {
    var out = new Uint8Array(32), dv = $3ee4f50b1ae43a89$var$u8_to_dataview(out), l = 12, flags = 0;
    out[0] = 3;
    switch(cell.t){
        case "n":
            out[2] = 2;
            dv.setFloat64(l, cell.v, true);
            flags |= 32;
            l += 8;
            break;
        case "b":
            out[2] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            flags |= 32;
            l += 8;
            break;
        case "s":
            if (sst.indexOf(cell.v) == -1) throw new Error("Value ".concat(cell.v, " missing from SST!"));
            out[2] = 3;
            dv.setUint32(l, sst.indexOf(cell.v), true);
            flags |= 16;
            l += 4;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(4, flags, true);
    return out.slice(0, l);
}
function $3ee4f50b1ae43a89$var$parse_cell_storage(buf, sst, rsst) {
    switch(buf[0]){
        case 0:
        case 1:
        case 2:
        case 3:
            return $3ee4f50b1ae43a89$var$parse_old_storage(buf, sst, rsst, buf[0]);
        case 5:
            return $3ee4f50b1ae43a89$var$parse_new_storage(buf, sst, rsst);
        default:
            throw new Error("Unsupported payload version ".concat(buf[0]));
    }
}
function $3ee4f50b1ae43a89$var$parse_TSP_Reference(buf) {
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(buf);
    return $3ee4f50b1ae43a89$var$parse_varint49(pb[1][0].data);
}
function $3ee4f50b1ae43a89$var$write_TSP_Reference(idx) {
    var out = [];
    out[1] = [
        {
            type: 0,
            data: $3ee4f50b1ae43a89$var$write_varint49(idx)
        }
    ];
    return $3ee4f50b1ae43a89$var$write_shallow(out);
}
function $3ee4f50b1ae43a89$var$parse_TST_TableDataList(M, root) {
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(root.data);
    var type = $3ee4f50b1ae43a89$var$varint_to_i32(pb[1][0].data);
    var entries = pb[3];
    var data = [];
    (entries || []).forEach(function(entry) {
        var le = $3ee4f50b1ae43a89$var$parse_shallow(entry.data);
        var key = $3ee4f50b1ae43a89$var$varint_to_i32(le[1][0].data) >>> 0;
        switch(type){
            case 1:
                data[key] = $3ee4f50b1ae43a89$var$u8str(le[3][0].data);
                break;
            case 8:
                var rt = M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(le[9][0].data)][0];
                var rtp = $3ee4f50b1ae43a89$var$parse_shallow(rt.data);
                var rtpref = M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(rtp[1][0].data)][0];
                var mtype = $3ee4f50b1ae43a89$var$varint_to_i32(rtpref.meta[1][0].data);
                if (mtype != 2001) throw new Error("2000 unexpected reference to ".concat(mtype));
                var tswpsa = $3ee4f50b1ae43a89$var$parse_shallow(rtpref.data);
                data[key] = tswpsa[3].map(function(x) {
                    return $3ee4f50b1ae43a89$var$u8str(x.data);
                }).join("");
                break;
        }
    });
    return data;
}
function $3ee4f50b1ae43a89$var$parse_TST_TileRowInfo(u8, type) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(u8);
    var R = $3ee4f50b1ae43a89$var$varint_to_i32(pb[1][0].data) >>> 0;
    var cnt = $3ee4f50b1ae43a89$var$varint_to_i32(pb[2][0].data) >>> 0;
    var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && $3ee4f50b1ae43a89$var$varint_to_i32(pb[8][0].data) > 0 || false;
    var used_storage_u8, used_storage;
    if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
        used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
        used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
    } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
        used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
        used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
    } else throw "NUMBERS Tile missing ".concat(type, " cell storage");
    var width = wide_offsets ? 4 : 1;
    var used_storage_offsets = $3ee4f50b1ae43a89$var$u8_to_dataview(used_storage_u8);
    var offsets = [];
    for(var C = 0; C < used_storage_u8.length / 2; ++C){
        var off = used_storage_offsets.getUint16(C * 2, true);
        if (off < 65535) offsets.push([
            C,
            off
        ]);
    }
    if (offsets.length != cnt) throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
    var cells = [];
    for(C = 0; C < offsets.length - 1; ++C)cells[offsets[C][0]] = used_storage.subarray(offsets[C][1] * width, offsets[C + 1][1] * width);
    if (offsets.length >= 1) cells[offsets[offsets.length - 1][0]] = used_storage.subarray(offsets[offsets.length - 1][1] * width);
    return {
        R: R,
        cells: cells
    };
}
function $3ee4f50b1ae43a89$var$parse_TST_Tile(M, root) {
    var _a;
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(root.data);
    var storage = ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) ? $3ee4f50b1ae43a89$var$varint_to_i32(pb[7][0].data) >>> 0 > 0 ? 1 : 0 : -1;
    var ri = $3ee4f50b1ae43a89$var$mappa(pb[5], function(u8) {
        return $3ee4f50b1ae43a89$var$parse_TST_TileRowInfo(u8, storage);
    });
    return {
        nrows: $3ee4f50b1ae43a89$var$varint_to_i32(pb[4][0].data) >>> 0,
        data: ri.reduce(function(acc, x) {
            if (!acc[x.R]) acc[x.R] = [];
            x.cells.forEach(function(cell, C) {
                if (acc[x.R][C]) throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
                acc[x.R][C] = cell;
            });
            return acc;
        }, [])
    };
}
function $3ee4f50b1ae43a89$var$parse_TST_TableModelArchive(M, root, ws) {
    var _a;
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(root.data);
    var range = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    range.e.r = ($3ee4f50b1ae43a89$var$varint_to_i32(pb[6][0].data) >>> 0) - 1;
    if (range.e.r < 0) throw new Error("Invalid row varint ".concat(pb[6][0].data));
    range.e.c = ($3ee4f50b1ae43a89$var$varint_to_i32(pb[7][0].data) >>> 0) - 1;
    if (range.e.c < 0) throw new Error("Invalid col varint ".concat(pb[7][0].data));
    ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
    var store = $3ee4f50b1ae43a89$var$parse_shallow(pb[4][0].data);
    var sst = $3ee4f50b1ae43a89$var$parse_TST_TableDataList(M, M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(store[4][0].data)][0]);
    var rsst = ((_a = store[17]) == null ? void 0 : _a[0]) ? $3ee4f50b1ae43a89$var$parse_TST_TableDataList(M, M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(store[17][0].data)][0]) : [];
    var tile = $3ee4f50b1ae43a89$var$parse_shallow(store[3][0].data);
    var _R = 0;
    tile[1].forEach(function(t) {
        var tl = $3ee4f50b1ae43a89$var$parse_shallow(t.data);
        var ref = M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(tl[2][0].data)][0];
        var mtype = $3ee4f50b1ae43a89$var$varint_to_i32(ref.meta[1][0].data);
        if (mtype != 6002) throw new Error("6001 unexpected reference to ".concat(mtype));
        var _tile = $3ee4f50b1ae43a89$var$parse_TST_Tile(M, ref);
        _tile.data.forEach(function(row, R) {
            row.forEach(function(buf, C) {
                var addr = $3ee4f50b1ae43a89$var$encode_cell({
                    r: _R + R,
                    c: C
                });
                var res = $3ee4f50b1ae43a89$var$parse_cell_storage(buf, sst, rsst);
                if (res) ws[addr] = res;
            });
        });
        _R += _tile.nrows;
    });
}
function $3ee4f50b1ae43a89$var$parse_TST_TableInfoArchive(M, root) {
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(root.data);
    var out = {
        "!ref": "A1"
    };
    var tableref = M[$3ee4f50b1ae43a89$var$parse_TSP_Reference(pb[2][0].data)];
    var mtype = $3ee4f50b1ae43a89$var$varint_to_i32(tableref[0].meta[1][0].data);
    if (mtype != 6001) throw new Error("6000 unexpected reference to ".concat(mtype));
    $3ee4f50b1ae43a89$var$parse_TST_TableModelArchive(M, tableref[0], out);
    return out;
}
function $3ee4f50b1ae43a89$var$parse_TN_SheetArchive(M, root) {
    var _a;
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(root.data);
    var out = {
        name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? $3ee4f50b1ae43a89$var$u8str(pb[1][0].data) : "",
        sheets: []
    };
    var shapeoffs = $3ee4f50b1ae43a89$var$mappa(pb[2], $3ee4f50b1ae43a89$var$parse_TSP_Reference);
    shapeoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $3ee4f50b1ae43a89$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 6e3) out.sheets.push($3ee4f50b1ae43a89$var$parse_TST_TableInfoArchive(M, m));
        });
    });
    return out;
}
function $3ee4f50b1ae43a89$var$parse_TN_DocumentArchive(M, root) {
    var out = $3ee4f50b1ae43a89$var$book_new();
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(root.data);
    var sheetoffs = $3ee4f50b1ae43a89$var$mappa(pb[1], $3ee4f50b1ae43a89$var$parse_TSP_Reference);
    sheetoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $3ee4f50b1ae43a89$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 2) {
                var root2 = $3ee4f50b1ae43a89$var$parse_TN_SheetArchive(M, m);
                root2.sheets.forEach(function(sheet, idx) {
                    $3ee4f50b1ae43a89$var$book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
                });
            }
        });
    });
    if (out.SheetNames.length == 0) throw new Error("Empty NUMBERS file");
    return out;
}
function $3ee4f50b1ae43a89$var$parse_numbers_iwa(cfb) {
    var _a, _b, _c, _d;
    var M = {}, indices = [];
    cfb.FullPaths.forEach(function(p) {
        if (p.match(/\.iwpv2/)) throw new Error("Unsupported password protection");
    });
    cfb.FileIndex.forEach(function(s) {
        if (!s.name.match(/\.iwa$/)) return;
        var o;
        try {
            o = $3ee4f50b1ae43a89$var$decompress_iwa_file(s.content);
        } catch (e) {
            return console.log("?? " + s.content.length + " " + (e.message || e));
        }
        var packets;
        try {
            packets = $3ee4f50b1ae43a89$var$parse_iwa_file(o);
        } catch (e) {
            return console.log("## " + (e.message || e));
        }
        packets.forEach(function(packet) {
            M[packet.id] = packet.messages;
            indices.push(packet.id);
        });
    });
    if (!indices.length) throw new Error("File has no messages");
    var docroot = ((_d = (_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0]) == null ? void 0 : _b.meta) == null ? void 0 : _c[1]) == null ? void 0 : _d[0].data) && $3ee4f50b1ae43a89$var$varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
    if (!docroot) indices.forEach(function(idx) {
        M[idx].forEach(function(iwam) {
            var mtype = $3ee4f50b1ae43a89$var$varint_to_i32(iwam.meta[1][0].data) >>> 0;
            if (mtype == 1) {
                if (!docroot) docroot = iwam;
                else throw new Error("Document has multiple roots");
            }
        });
    });
    if (!docroot) throw new Error("Cannot find Document root");
    return $3ee4f50b1ae43a89$var$parse_TN_DocumentArchive(M, docroot);
}
function $3ee4f50b1ae43a89$var$write_tile_row(tri, data, SST) {
    var _a, _b, _c, _d;
    if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0])) throw "Mutation only works on post-BNC storages!";
    var wide_offsets = ((_d = (_c = tri[8]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && $3ee4f50b1ae43a89$var$varint_to_i32(tri[8][0].data) > 0 || false;
    if (wide_offsets) throw "Math only works with normal offsets";
    var cnt = 0;
    var dv = $3ee4f50b1ae43a89$var$u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
    var _dv = $3ee4f50b1ae43a89$var$u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
    for(var C = 0; C < data.length; ++C){
        if (data[C] == null) {
            dv.setUint16(C * 2, 65535, true);
            _dv.setUint16(C * 2, 65535);
            continue;
        }
        dv.setUint16(C * 2, last_offset, true);
        _dv.setUint16(C * 2, _last_offset, true);
        var celload, _celload;
        switch(typeof data[C]){
            case "string":
                celload = $3ee4f50b1ae43a89$var$write_new_storage({
                    t: "s",
                    v: data[C]
                }, SST);
                _celload = $3ee4f50b1ae43a89$var$write_old_storage({
                    t: "s",
                    v: data[C]
                }, SST);
                break;
            case "number":
                celload = $3ee4f50b1ae43a89$var$write_new_storage({
                    t: "n",
                    v: data[C]
                }, SST);
                _celload = $3ee4f50b1ae43a89$var$write_old_storage({
                    t: "n",
                    v: data[C]
                }, SST);
                break;
            case "boolean":
                celload = $3ee4f50b1ae43a89$var$write_new_storage({
                    t: "b",
                    v: data[C]
                }, SST);
                _celload = $3ee4f50b1ae43a89$var$write_old_storage({
                    t: "b",
                    v: data[C]
                }, SST);
                break;
            default:
                throw new Error("Unsupported value " + data[C]);
        }
        cell_storage.push(celload);
        last_offset += celload.length;
        _cell_storage.push(_celload);
        _last_offset += _celload.length;
        ++cnt;
    }
    tri[2][0].data = $3ee4f50b1ae43a89$var$write_varint49(cnt);
    for(; C < tri[7][0].data.length / 2; ++C){
        dv.setUint16(C * 2, 65535, true);
        _dv.setUint16(C * 2, 65535, true);
    }
    tri[6][0].data = $3ee4f50b1ae43a89$var$u8concat(cell_storage);
    tri[3][0].data = $3ee4f50b1ae43a89$var$u8concat(_cell_storage);
    return cnt;
}
function $3ee4f50b1ae43a89$var$write_numbers_iwa(wb, opts) {
    if (!opts || !opts.numbers) throw new Error("Must pass a `numbers` option -- check the README");
    var ws = wb.Sheets[wb.SheetNames[0]];
    if (wb.SheetNames.length > 1) console.error("The Numbers writer currently writes only the first table");
    var range = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
    range.s.r = range.s.c = 0;
    var trunc = false;
    if (range.e.c > 9) {
        trunc = true;
        range.e.c = 9;
    }
    if (range.e.r > 49) {
        trunc = true;
        range.e.r = 49;
    }
    if (trunc) console.error("The Numbers writer is currently limited to ".concat($3ee4f50b1ae43a89$var$encode_range(range)));
    var data = $3ee4f50b1ae43a89$var$sheet_to_json(ws, {
        range: range,
        header: 1
    });
    var SST = [
        "~Sh33tJ5~"
    ];
    data.forEach(function(row) {
        return row.forEach(function(cell) {
            if (typeof cell == "string") SST.push(cell);
        });
    });
    var dependents = {};
    var indices = [];
    var cfb = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.read(opts.numbers, {
        type: "base64"
    });
    cfb.FileIndex.map(function(fi, idx) {
        return [
            fi,
            cfb.FullPaths[idx]
        ];
    }).forEach(function(row) {
        var fi = row[0], fp = row[1];
        if (fi.type != 2) return;
        if (!fi.name.match(/\.iwa/)) return;
        var old_content = fi.content;
        var raw1 = $3ee4f50b1ae43a89$var$decompress_iwa_file(old_content);
        var x2 = $3ee4f50b1ae43a89$var$parse_iwa_file(raw1);
        x2.forEach(function(packet2) {
            indices.push(packet2.id);
            dependents[packet2.id] = {
                deps: [],
                location: fp,
                type: $3ee4f50b1ae43a89$var$varint_to_i32(packet2.messages[0].meta[1][0].data)
            };
        });
    });
    indices.sort(function(x2, y2) {
        return x2 - y2;
    });
    var indices_varint = indices.filter(function(x2) {
        return x2 > 1;
    }).map(function(x2) {
        return [
            x2,
            $3ee4f50b1ae43a89$var$write_varint49(x2)
        ];
    });
    cfb.FileIndex.map(function(fi, idx) {
        return [
            fi,
            cfb.FullPaths[idx]
        ];
    }).forEach(function(row) {
        var fi = row[0], fp = row[1];
        if (!fi.name.match(/\.iwa/)) return;
        var x2 = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(fi.content));
        x2.forEach(function(ia) {
            ia.messages.forEach(function(m) {
                indices_varint.forEach(function(ivi) {
                    if (ia.messages.some(function(mess) {
                        return $3ee4f50b1ae43a89$var$varint_to_i32(mess.meta[1][0].data) != 11006 && $3ee4f50b1ae43a89$var$u8contains(mess.data, ivi[1]);
                    })) dependents[ivi[0]].deps.push(ia.id);
                });
            });
        });
    });
    function get_unique_msgid() {
        for(var i = 927262; i < 2e6; ++i)if (!dependents[i]) return i;
        throw new Error("Too many messages");
    }
    var entry = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, dependents[1].location);
    var x = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(entry.content));
    var docroot;
    for(var xi = 0; xi < x.length; ++xi){
        var packet = x[xi];
        if (packet.id == 1) docroot = packet;
    }
    var sheetrootref = $3ee4f50b1ae43a89$var$parse_TSP_Reference($3ee4f50b1ae43a89$var$parse_shallow(docroot.messages[0].data)[1][0].data);
    entry = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, dependents[sheetrootref].location);
    x = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(entry.content));
    for(xi = 0; xi < x.length; ++xi){
        packet = x[xi];
        if (packet.id == sheetrootref) docroot = packet;
    }
    sheetrootref = $3ee4f50b1ae43a89$var$parse_TSP_Reference($3ee4f50b1ae43a89$var$parse_shallow(docroot.messages[0].data)[2][0].data);
    entry = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, dependents[sheetrootref].location);
    x = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(entry.content));
    for(xi = 0; xi < x.length; ++xi){
        packet = x[xi];
        if (packet.id == sheetrootref) docroot = packet;
    }
    sheetrootref = $3ee4f50b1ae43a89$var$parse_TSP_Reference($3ee4f50b1ae43a89$var$parse_shallow(docroot.messages[0].data)[2][0].data);
    entry = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, dependents[sheetrootref].location);
    x = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(entry.content));
    for(xi = 0; xi < x.length; ++xi){
        packet = x[xi];
        if (packet.id == sheetrootref) docroot = packet;
    }
    var pb = $3ee4f50b1ae43a89$var$parse_shallow(docroot.messages[0].data);
    pb[6][0].data = $3ee4f50b1ae43a89$var$write_varint49(range.e.r + 1);
    pb[7][0].data = $3ee4f50b1ae43a89$var$write_varint49(range.e.c + 1);
    var cruidsref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(pb[46][0].data);
    var oldbucket = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, dependents[cruidsref].location);
    var _x = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(oldbucket.content));
    for(var j = 0; j < _x.length; ++j){
        if (_x[j].id == cruidsref) break;
    }
    if (_x[j].id != cruidsref) throw "Bad ColumnRowUIDMapArchive";
    var cruids = $3ee4f50b1ae43a89$var$parse_shallow(_x[j].messages[0].data);
    cruids[1] = [];
    cruids[2] = [], cruids[3] = [];
    for(var C = 0; C <= range.e.c; ++C){
        var uuid = [];
        uuid[1] = uuid[2] = [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(C + 420690)
            }
        ];
        cruids[1].push({
            type: 2,
            data: $3ee4f50b1ae43a89$var$write_shallow(uuid)
        });
        cruids[2].push({
            type: 0,
            data: $3ee4f50b1ae43a89$var$write_varint49(C)
        });
        cruids[3].push({
            type: 0,
            data: $3ee4f50b1ae43a89$var$write_varint49(C)
        });
    }
    cruids[4] = [];
    cruids[5] = [], cruids[6] = [];
    for(var R = 0; R <= range.e.r; ++R){
        uuid = [];
        uuid[1] = uuid[2] = [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(R + 726270)
            }
        ];
        cruids[4].push({
            type: 2,
            data: $3ee4f50b1ae43a89$var$write_shallow(uuid)
        });
        cruids[5].push({
            type: 0,
            data: $3ee4f50b1ae43a89$var$write_varint49(R)
        });
        cruids[6].push({
            type: 0,
            data: $3ee4f50b1ae43a89$var$write_varint49(R)
        });
    }
    _x[j].messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(cruids);
    oldbucket.content = $3ee4f50b1ae43a89$var$compress_iwa_file($3ee4f50b1ae43a89$var$write_iwa_file(_x));
    oldbucket.size = oldbucket.content.length;
    delete pb[46];
    var store = $3ee4f50b1ae43a89$var$parse_shallow(pb[4][0].data);
    store[7][0].data = $3ee4f50b1ae43a89$var$write_varint49(range.e.r + 1);
    var row_headers = $3ee4f50b1ae43a89$var$parse_shallow(store[1][0].data);
    var row_header_ref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(row_headers[2][0].data);
    oldbucket = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, dependents[row_header_ref].location);
    _x = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(oldbucket.content));
    if (_x[0].id != row_header_ref) throw "Bad HeaderStorageBucket";
    var base_bucket = $3ee4f50b1ae43a89$var$parse_shallow(_x[0].messages[0].data);
    for(R = 0; R < data.length; ++R){
        var _bucket = $3ee4f50b1ae43a89$var$parse_shallow(base_bucket[2][0].data);
        _bucket[1][0].data = $3ee4f50b1ae43a89$var$write_varint49(R);
        _bucket[4][0].data = $3ee4f50b1ae43a89$var$write_varint49(data[R].length);
        base_bucket[2][R] = {
            type: base_bucket[2][0].type,
            data: $3ee4f50b1ae43a89$var$write_shallow(_bucket)
        };
    }
    _x[0].messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(base_bucket);
    oldbucket.content = $3ee4f50b1ae43a89$var$compress_iwa_file($3ee4f50b1ae43a89$var$write_iwa_file(_x));
    oldbucket.size = oldbucket.content.length;
    var col_header_ref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(store[2][0].data);
    oldbucket = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, dependents[col_header_ref].location);
    _x = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(oldbucket.content));
    if (_x[0].id != col_header_ref) throw "Bad HeaderStorageBucket";
    base_bucket = $3ee4f50b1ae43a89$var$parse_shallow(_x[0].messages[0].data);
    for(C = 0; C <= range.e.c; ++C){
        _bucket = $3ee4f50b1ae43a89$var$parse_shallow(base_bucket[2][0].data);
        _bucket[1][0].data = $3ee4f50b1ae43a89$var$write_varint49(C);
        _bucket[4][0].data = $3ee4f50b1ae43a89$var$write_varint49(range.e.r + 1);
        base_bucket[2][C] = {
            type: base_bucket[2][0].type,
            data: $3ee4f50b1ae43a89$var$write_shallow(_bucket)
        };
    }
    _x[0].messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(base_bucket);
    oldbucket.content = $3ee4f50b1ae43a89$var$compress_iwa_file($3ee4f50b1ae43a89$var$write_iwa_file(_x));
    oldbucket.size = oldbucket.content.length;
    var sstref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(store[4][0].data);
    (function() {
        var sentry = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, dependents[sstref].location);
        var sx = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(sentry.content));
        var sstroot;
        for(var sxi = 0; sxi < sx.length; ++sxi){
            var packet2 = sx[sxi];
            if (packet2.id == sstref) sstroot = packet2;
        }
        var sstdata = $3ee4f50b1ae43a89$var$parse_shallow(sstroot.messages[0].data);
        sstdata[3] = [];
        var newsst = [];
        SST.forEach(function(str, i) {
            newsst[1] = [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49(i)
                }
            ];
            newsst[2] = [
                {
                    type: 0,
                    data: $3ee4f50b1ae43a89$var$write_varint49(1)
                }
            ];
            newsst[3] = [
                {
                    type: 2,
                    data: $3ee4f50b1ae43a89$var$stru8(str)
                }
            ];
            sstdata[3].push({
                type: 2,
                data: $3ee4f50b1ae43a89$var$write_shallow(newsst)
            });
        });
        sstroot.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(sstdata);
        var sy = $3ee4f50b1ae43a89$var$write_iwa_file(sx);
        var raw32 = $3ee4f50b1ae43a89$var$compress_iwa_file(sy);
        sentry.content = raw32;
        sentry.size = sentry.content.length;
    })();
    var tile = $3ee4f50b1ae43a89$var$parse_shallow(store[3][0].data);
    var t = tile[1][0];
    delete tile[2];
    var tl = $3ee4f50b1ae43a89$var$parse_shallow(t.data);
    var tileref = $3ee4f50b1ae43a89$var$parse_TSP_Reference(tl[2][0].data);
    (function() {
        var tentry = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, dependents[tileref].location);
        var tx = $3ee4f50b1ae43a89$var$parse_iwa_file($3ee4f50b1ae43a89$var$decompress_iwa_file(tentry.content));
        var tileroot;
        for(var sxi = 0; sxi < tx.length; ++sxi){
            var packet2 = tx[sxi];
            if (packet2.id == tileref) tileroot = packet2;
        }
        var tiledata = $3ee4f50b1ae43a89$var$parse_shallow(tileroot.messages[0].data);
        delete tiledata[6];
        delete tile[7];
        var rowload = new Uint8Array(tiledata[5][0].data);
        tiledata[5] = [];
        var cnt = 0;
        for(var R2 = 0; R2 <= range.e.r; ++R2){
            var tilerow = $3ee4f50b1ae43a89$var$parse_shallow(rowload);
            cnt += $3ee4f50b1ae43a89$var$write_tile_row(tilerow, data[R2], SST);
            tilerow[1][0].data = $3ee4f50b1ae43a89$var$write_varint49(R2);
            tiledata[5].push({
                data: $3ee4f50b1ae43a89$var$write_shallow(tilerow),
                type: 2
            });
        }
        tiledata[1] = [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(range.e.c + 1)
            }
        ];
        tiledata[2] = [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(range.e.r + 1)
            }
        ];
        tiledata[3] = [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(cnt)
            }
        ];
        tiledata[4] = [
            {
                type: 0,
                data: $3ee4f50b1ae43a89$var$write_varint49(range.e.r + 1)
            }
        ];
        tileroot.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(tiledata);
        var ty = $3ee4f50b1ae43a89$var$write_iwa_file(tx);
        var raw32 = $3ee4f50b1ae43a89$var$compress_iwa_file(ty);
        tentry.content = raw32;
        tentry.size = tentry.content.length;
    })();
    t.data = $3ee4f50b1ae43a89$var$write_shallow(tl);
    store[3][0].data = $3ee4f50b1ae43a89$var$write_shallow(tile);
    pb[4][0].data = $3ee4f50b1ae43a89$var$write_shallow(store);
    docroot.messages[0].data = $3ee4f50b1ae43a89$var$write_shallow(pb);
    var y = $3ee4f50b1ae43a89$var$write_iwa_file(x);
    var raw3 = $3ee4f50b1ae43a89$var$compress_iwa_file(y);
    entry.content = raw3;
    entry.size = entry.content.length;
    return cfb;
}
function $3ee4f50b1ae43a89$var$fix_opts_func(defaults /*:Array<Array<any> >*/ ) /*:{(o:any):void}*/ {
    return function fix_opts(opts) {
        for(var i = 0; i != defaults.length; ++i){
            var d = defaults[i];
            if (opts[d[0]] === undefined) opts[d[0]] = d[1];
            if (d[2] === "n") opts[d[0]] = Number(opts[d[0]]);
        }
    };
}
function $3ee4f50b1ae43a89$var$fix_read_opts(opts) {
    $3ee4f50b1ae43a89$var$fix_opts_func([
        [
            "cellNF",
            false
        ],
        /* emit cell number format string as .z */ [
            "cellHTML",
            true
        ],
        /* emit html string as .h */ [
            "cellFormula",
            true
        ],
        /* emit formulae as .f */ [
            "cellStyles",
            false
        ],
        /* emits style/theme as .s */ [
            "cellText",
            true
        ],
        /* emit formatted text as .w */ [
            "cellDates",
            false
        ],
        /* emit date cells with type `d` */ [
            "sheetStubs",
            false
        ],
        /* emit empty cells */ [
            "sheetRows",
            0,
            "n"
        ],
        /* read n rows (0 = read all rows) */ [
            "bookDeps",
            false
        ],
        /* parse calculation chains */ [
            "bookSheets",
            false
        ],
        /* only try to get sheet names (no Sheets) */ [
            "bookProps",
            false
        ],
        /* only try to get properties (no Sheets) */ [
            "bookFiles",
            false
        ],
        /* include raw file structure (keys, files, cfb) */ [
            "bookVBA",
            false
        ],
        /* include vba raw data (vbaraw) */ [
            "password",
            ""
        ],
        /* password */ [
            "WTF",
            false
        ]
    ])(opts);
}
function $3ee4f50b1ae43a89$var$fix_write_opts(opts) {
    $3ee4f50b1ae43a89$var$fix_opts_func([
        [
            "cellDates",
            false
        ],
        /* write date cells with type `d` */ [
            "bookSST",
            false
        ],
        /* Generate Shared String Table */ [
            "bookType",
            "xlsx"
        ],
        /* Type of workbook (xlsx/m/b) */ [
            "compression",
            false
        ],
        /* Use file compression */ [
            "WTF",
            false
        ]
    ])(opts);
}
function $3ee4f50b1ae43a89$var$get_sheet_type(n /*:string*/ ) /*:string*/ {
    if ($3ee4f50b1ae43a89$var$RELS.WS.indexOf(n) > -1) return "sheet";
    if ($3ee4f50b1ae43a89$var$RELS.CS && n == $3ee4f50b1ae43a89$var$RELS.CS) return "chart";
    if ($3ee4f50b1ae43a89$var$RELS.DS && n == $3ee4f50b1ae43a89$var$RELS.DS) return "dialog";
    if ($3ee4f50b1ae43a89$var$RELS.MS && n == $3ee4f50b1ae43a89$var$RELS.MS) return "macro";
    return n && n.length ? n : "sheet";
}
function $3ee4f50b1ae43a89$var$safe_parse_wbrels(wbrels, sheets) {
    if (!wbrels) return 0;
    try {
        wbrels = sheets.map(function pwbr(w) {
            if (!w.id) w.id = w.strRelID;
            return [
                w.name,
                wbrels["!id"][w.id].Target,
                $3ee4f50b1ae43a89$var$get_sheet_type(wbrels["!id"][w.id].Type)
            ];
        });
    } catch (e) {
        return null;
    }
    return !wbrels || wbrels.length === 0 ? null : wbrels;
}
function $3ee4f50b1ae43a89$var$safe_parse_sheet(zip, path /*:string*/ , relsPath /*:string*/ , sheet, idx /*:number*/ , sheetRels, sheets, stype /*:string*/ , opts, wb, themes, styles) {
    try {
        sheetRels[sheet] = $3ee4f50b1ae43a89$var$parse_rels($3ee4f50b1ae43a89$var$getzipstr(zip, relsPath, true), path);
        var data = $3ee4f50b1ae43a89$var$getzipdata(zip, path);
        var _ws;
        switch(stype){
            case "sheet":
                _ws = $3ee4f50b1ae43a89$var$parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case "chart":
                _ws = $3ee4f50b1ae43a89$var$parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                if (!_ws || !_ws["!drawel"]) break;
                var dfile = $3ee4f50b1ae43a89$var$resolve_path(_ws["!drawel"].Target, path);
                var drelsp = $3ee4f50b1ae43a89$var$get_rels_path(dfile);
                var draw = $3ee4f50b1ae43a89$var$parse_drawing($3ee4f50b1ae43a89$var$getzipstr(zip, dfile, true), $3ee4f50b1ae43a89$var$parse_rels($3ee4f50b1ae43a89$var$getzipstr(zip, drelsp, true), dfile));
                var chartp = $3ee4f50b1ae43a89$var$resolve_path(draw, dfile);
                var crelsp = $3ee4f50b1ae43a89$var$get_rels_path(chartp);
                _ws = $3ee4f50b1ae43a89$var$parse_chart($3ee4f50b1ae43a89$var$getzipstr(zip, chartp, true), chartp, opts, $3ee4f50b1ae43a89$var$parse_rels($3ee4f50b1ae43a89$var$getzipstr(zip, crelsp, true), chartp), wb, _ws);
                break;
            case "macro":
                _ws = $3ee4f50b1ae43a89$var$parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case "dialog":
                _ws = $3ee4f50b1ae43a89$var$parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            default:
                throw new Error("Unrecognized sheet type " + stype);
        }
        sheets[sheet] = _ws;
        /* scan rels for comments and threaded comments */ var tcomments = [];
        if (sheetRels && sheetRels[sheet]) $3ee4f50b1ae43a89$var$keys(sheetRels[sheet]).forEach(function(n) {
            var dfile = "";
            if (sheetRels[sheet][n].Type == $3ee4f50b1ae43a89$var$RELS.CMNT) {
                dfile = $3ee4f50b1ae43a89$var$resolve_path(sheetRels[sheet][n].Target, path);
                var comments = $3ee4f50b1ae43a89$var$parse_cmnt($3ee4f50b1ae43a89$var$getzipdata(zip, dfile, true), dfile, opts);
                if (!comments || !comments.length) return;
                $3ee4f50b1ae43a89$var$sheet_insert_comments(_ws, comments, false);
            }
            if (sheetRels[sheet][n].Type == $3ee4f50b1ae43a89$var$RELS.TCMNT) {
                dfile = $3ee4f50b1ae43a89$var$resolve_path(sheetRels[sheet][n].Target, path);
                tcomments = tcomments.concat($3ee4f50b1ae43a89$var$parse_tcmnt_xml($3ee4f50b1ae43a89$var$getzipdata(zip, dfile, true), opts));
            }
        });
        if (tcomments && tcomments.length) $3ee4f50b1ae43a89$var$sheet_insert_comments(_ws, tcomments, true, opts.people || []);
    } catch (e) {
        if (opts.WTF) throw e;
    }
}
function $3ee4f50b1ae43a89$var$strip_front_slash(x /*:string*/ ) /*:string*/ {
    return x.charAt(0) == "/" ? x.slice(1) : x;
}
function $3ee4f50b1ae43a89$export$b165387946f79a1(zip /*:ZIP*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $3ee4f50b1ae43a89$var$make_ssf();
    opts = opts || {};
    $3ee4f50b1ae43a89$var$fix_read_opts(opts);
    /* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */ if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, "META-INF/manifest.xml")) return $3ee4f50b1ae43a89$var$parse_ods(zip, opts);
    /* UOC */ if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, "objectdata.xml")) return $3ee4f50b1ae43a89$var$parse_ods(zip, opts);
    /* Numbers */ if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, "Index/Document.iwa")) {
        if (typeof Uint8Array == "undefined") throw new Error("NUMBERS file parsing requires Uint8Array support");
        if (typeof $3ee4f50b1ae43a89$var$parse_numbers_iwa != "undefined") {
            if (zip.FileIndex) return $3ee4f50b1ae43a89$var$parse_numbers_iwa(zip);
            var _zip = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.utils.cfb_new();
            $3ee4f50b1ae43a89$var$zipentries(zip).forEach(function(e) {
                $3ee4f50b1ae43a89$var$zip_add_file(_zip, e, $3ee4f50b1ae43a89$var$getzipbin(zip, e));
            });
            return $3ee4f50b1ae43a89$var$parse_numbers_iwa(_zip);
        }
        throw new Error("Unsupported NUMBERS file");
    }
    if (!$3ee4f50b1ae43a89$var$safegetzipfile(zip, "[Content_Types].xml")) {
        if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, "index.xml.gz")) throw new Error("Unsupported NUMBERS 08 file");
        if ($3ee4f50b1ae43a89$var$safegetzipfile(zip, "index.xml")) throw new Error("Unsupported NUMBERS 09 file");
        throw new Error("Unsupported ZIP file");
    }
    var entries = $3ee4f50b1ae43a89$var$zipentries(zip);
    var dir = $3ee4f50b1ae43a89$var$parse_ct($3ee4f50b1ae43a89$var$getzipstr(zip, "[Content_Types].xml"));
    var xlsb = false;
    var sheets, binname;
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.xml";
        if ($3ee4f50b1ae43a89$var$getzipdata(zip, binname, true)) dir.workbooks.push(binname);
    }
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.bin";
        if (!$3ee4f50b1ae43a89$var$getzipdata(zip, binname, true)) throw new Error("Could not find workbook");
        dir.workbooks.push(binname);
        xlsb = true;
    }
    if (dir.workbooks[0].slice(-3) == "bin") xlsb = true;
    var themes = {} /*:any*/ ;
    var styles = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) {
        $3ee4f50b1ae43a89$var$strs = [];
        if (dir.sst) try {
            $3ee4f50b1ae43a89$var$strs = $3ee4f50b1ae43a89$var$parse_sst($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.sst)), dir.sst, opts);
        } catch (e) {
            if (opts.WTF) throw e;
        }
        if (opts.cellStyles && dir.themes.length) themes = $3ee4f50b1ae43a89$var$parse_theme($3ee4f50b1ae43a89$var$getzipstr(zip, dir.themes[0].replace(/^\//, ""), true) || "", dir.themes[0], opts);
        if (dir.style) styles = $3ee4f50b1ae43a89$var$parse_sty($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.style)), dir.style, themes, opts);
    }
    /*var externbooks = */ dir.links.map(function(link) {
        try {
            var rels = $3ee4f50b1ae43a89$var$parse_rels($3ee4f50b1ae43a89$var$getzipstr(zip, $3ee4f50b1ae43a89$var$get_rels_path($3ee4f50b1ae43a89$var$strip_front_slash(link))), link);
            return $3ee4f50b1ae43a89$var$parse_xlink($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(link)), rels, link, opts);
        } catch (e) {}
    });
    var wb = $3ee4f50b1ae43a89$var$parse_wb($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
    var props = {}, propdata = "";
    if (dir.coreprops.length) {
        propdata = $3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.coreprops[0]), true);
        if (propdata) props = $3ee4f50b1ae43a89$var$parse_core_props(propdata);
        if (dir.extprops.length !== 0) {
            propdata = $3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.extprops[0]), true);
            if (propdata) $3ee4f50b1ae43a89$var$parse_ext_props(propdata, props, opts);
        }
    }
    var custprops = {};
    if (!opts.bookSheets || opts.bookProps) {
        if (dir.custprops.length !== 0) {
            propdata = $3ee4f50b1ae43a89$var$getzipstr(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.custprops[0]), true);
            if (propdata) custprops = $3ee4f50b1ae43a89$var$parse_cust_props(propdata, opts);
        }
    }
    var out = {} /*:any*/ ;
    if (opts.bookSheets || opts.bookProps) {
        if (wb.Sheets) sheets = wb.Sheets.map(function pluck(x) {
            return x.name;
        });
        else if (props.Worksheets && props.SheetNames.length > 0) sheets = props.SheetNames;
        if (opts.bookProps) {
            out.Props = props;
            out.Custprops = custprops;
        }
        if (opts.bookSheets && typeof sheets !== "undefined") out.SheetNames = sheets;
        if (opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
    }
    sheets = {};
    var deps = {};
    if (opts.bookDeps && dir.calcchain) deps = $3ee4f50b1ae43a89$var$parse_cc($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.calcchain)), dir.calcchain, opts);
    var i = 0;
    var sheetRels = {} /*:any*/ ;
    var path, relsPath;
    var wbsheets = wb.Sheets;
    props.Worksheets = wbsheets.length;
    props.SheetNames = [];
    for(var j = 0; j != wbsheets.length; ++j)props.SheetNames[j] = wbsheets[j].name;
    var wbext = xlsb ? "bin" : "xml";
    var wbrelsi = dir.workbooks[0].lastIndexOf("/");
    var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi + 1) + "_rels/" + dir.workbooks[0].slice(wbrelsi + 1) + ".rels").replace(/^\//, "");
    if (!$3ee4f50b1ae43a89$var$safegetzipfile(zip, wbrelsfile)) wbrelsfile = "xl/_rels/workbook." + wbext + ".rels";
    var wbrels = $3ee4f50b1ae43a89$var$parse_rels($3ee4f50b1ae43a89$var$getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));
    if ((dir.metadata || []).length >= 1) /* TODO: MDX and other types of metadata */ opts.xlmeta = $3ee4f50b1ae43a89$var$parse_xlmeta($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.metadata[0])), dir.metadata[0], opts);
    if ((dir.people || []).length >= 1) opts.people = $3ee4f50b1ae43a89$var$parse_people_xml($3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.people[0])), opts);
    if (wbrels) wbrels = $3ee4f50b1ae43a89$var$safe_parse_wbrels(wbrels, wb.Sheets);
    /* Numbers iOS hack */ var nmode = $3ee4f50b1ae43a89$var$getzipdata(zip, "xl/worksheets/sheet.xml", true) ? 1 : 0;
    wsloop: for(i = 0; i != props.Worksheets; ++i){
        var stype = "sheet";
        if (wbrels && wbrels[i]) {
            path = "xl/" + wbrels[i][1].replace(/[\/]?xl\//, "");
            if (!$3ee4f50b1ae43a89$var$safegetzipfile(zip, path)) path = wbrels[i][1];
            if (!$3ee4f50b1ae43a89$var$safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/, "") + wbrels[i][1];
            stype = wbrels[i][2];
        } else {
            path = "xl/worksheets/sheet" + (i + 1 - nmode) + "." + wbext;
            path = path.replace(/sheet0\./, "sheet.");
        }
        relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
        if (opts && opts.sheets != null) switch(typeof opts.sheets){
            case "number":
                if (i != opts.sheets) continue wsloop;
                break;
            case "string":
                if (props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop;
                break;
            default:
                if (Array.isArray && Array.isArray(opts.sheets)) {
                    var snjseen = false;
                    for(var snj = 0; snj != opts.sheets.length; ++snj){
                        if (typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen = 1;
                        if (typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
                    }
                    if (!snjseen) continue wsloop;
                }
        }
        $3ee4f50b1ae43a89$var$safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
    }
    out = {
        Directory: dir,
        Workbook: wb,
        Props: props,
        Custprops: custprops,
        Deps: deps,
        Sheets: sheets,
        SheetNames: props.SheetNames,
        Strings: $3ee4f50b1ae43a89$var$strs,
        Styles: styles,
        Themes: themes,
        SSF: $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt)
    } /*:any*/ ;
    if (opts && opts.bookFiles) {
        if (zip.files) {
            out.keys = entries;
            out.files = zip.files;
        } else {
            out.keys = [];
            out.files = {};
            zip.FullPaths.forEach(function(p, idx) {
                p = p.replace(/^Root Entry[\/]/, "");
                out.keys.push(p);
                out.files[p] = zip.FileIndex[idx];
            });
        }
    }
    if (opts && opts.bookVBA) {
        if (dir.vba.length > 0) out.vbaraw = $3ee4f50b1ae43a89$var$getzipdata(zip, $3ee4f50b1ae43a89$var$strip_front_slash(dir.vba[0]), true);
        else if (dir.defaults && dir.defaults.bin === $3ee4f50b1ae43a89$var$CT_VBA) out.vbaraw = $3ee4f50b1ae43a89$var$getzipdata(zip, "xl/vbaProject.bin", true);
    }
    return out;
}
/* [MS-OFFCRYPTO] 2.1.1 */ function $3ee4f50b1ae43a89$var$parse_xlsxcfb(cfb, _opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var opts = _opts || {};
    var f = "Workbook", data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
    try {
        f = "/!DataSpaces/Version";
        data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var version = */ $3ee4f50b1ae43a89$var$parse_DataSpaceVersionInfo(data.content);
        /* 2.3.4.1 */ f = "/!DataSpaces/DataSpaceMap";
        data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var dsm = $3ee4f50b1ae43a89$var$parse_DataSpaceMap(data.content);
        if (dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.2 */ f = "/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace";
        data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var seds = $3ee4f50b1ae43a89$var$parse_DataSpaceDefinition(data.content);
        if (seds.length != 1 || seds[0] != "StrongEncryptionTransform") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.3 */ f = "/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary";
        data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var hdr = */ $3ee4f50b1ae43a89$var$parse_Primary(data.content);
    } catch (e) {}
    f = "/EncryptionInfo";
    data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    var einfo = $3ee4f50b1ae43a89$var$parse_EncryptionInfo(data.content);
    /* 2.3.4.4 */ f = "/EncryptedPackage";
    data = $3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    /*global decrypt_agile */ /*:: declare var decrypt_agile:any; */ if (einfo[0] == 0x04 && typeof decrypt_agile !== "undefined") return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
    /*global decrypt_std76 */ /*:: declare var decrypt_std76:any; */ if (einfo[0] == 0x02 && typeof decrypt_std76 !== "undefined") return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
    throw new Error("File is password-protected");
}
function $3ee4f50b1ae43a89$var$write_zip(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (opts.bookType == "ods") return $3ee4f50b1ae43a89$var$write_ods(wb, opts);
    if (opts.bookType == "numbers") return $3ee4f50b1ae43a89$var$write_numbers_iwa(wb, opts);
    if (opts.bookType == "xlsb") return $3ee4f50b1ae43a89$var$write_zip_xlsxb(wb, opts);
    return $3ee4f50b1ae43a89$var$write_zip_xlsx(wb, opts);
}
/* XLSX and XLSB writing are very similar.  Originally they were unified in one
   export function.  This is horrible for tree shaking in the common case (most
   applications need to export files in one format) so this function supports
   both formats while write_zip_xlsx only handles XLSX */ function $3ee4f50b1ae43a89$var$write_zip_xlsxb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    $3ee4f50b1ae43a89$var$_shapeid = 1024;
    if (wb && !wb.SSF) wb.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    if (wb && wb.SSF) {
        $3ee4f50b1ae43a89$var$make_ssf();
        $3ee4f50b1ae43a89$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $3ee4f50b1ae43a89$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($3ee4f50b1ae43a89$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = opts.bookType == "xlsb" ? "bin" : "xml";
    var vbafmt = $3ee4f50b1ae43a89$var$VBAFMTS.indexOf(opts.bookType) > -1;
    var ct = $3ee4f50b1ae43a89$var$new_ct();
    $3ee4f50b1ae43a89$var$fix_write_opts(opts = opts || {});
    var zip = $3ee4f50b1ae43a89$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.rels, 2, f, $3ee4f50b1ae43a89$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.rels, 3, f, $3ee4f50b1ae43a89$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $3ee4f50b1ae43a89$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.rels, 4, f, $3ee4f50b1ae43a89$var$RELS.CUST_PROPS);
    }
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            "!id": {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_ws(rId - 1, f, opts, wb, wsrels));
        ct.sheets.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $3ee4f50b1ae43a89$var$RELS.WS[0]);
        if (ws) {
            var comments = ws["!comments"];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                cf = "xl/comments" + rId + "." + wbext;
                $3ee4f50b1ae43a89$var$zip_add_file(zip, cf, $3ee4f50b1ae43a89$var$write_cmnt(comments, cf, opts));
                ct.comments.push(cf);
                $3ee4f50b1ae43a89$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $3ee4f50b1ae43a89$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws["!legacy"]) {
                if (need_vml) $3ee4f50b1ae43a89$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $3ee4f50b1ae43a89$var$write_comments_vml(rId, ws["!comments"]));
            }
            delete ws["!comments"];
            delete ws["!legacy"];
        }
        if (wsrels["!id"].rId1) $3ee4f50b1ae43a89$var$zip_add_file(zip, $3ee4f50b1ae43a89$var$get_rels_path(f), $3ee4f50b1ae43a89$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_sst(opts.Strings, f, opts));
        ct.strs.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $3ee4f50b1ae43a89$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_wb(wb, f, opts));
    ct.workbooks.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.rels, 1, f, $3ee4f50b1ae43a89$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_theme(wb.Themes, opts));
    ct.themes.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $3ee4f50b1ae43a89$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_sty(wb, f, opts));
    ct.styles.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "styles." + wbext, $3ee4f50b1ae43a89$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $3ee4f50b1ae43a89$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_xlmeta(f));
    ct.metadata.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $3ee4f50b1ae43a89$var$RELS.XLMETA);
    $3ee4f50b1ae43a89$var$zip_add_file(zip, "[Content_Types].xml", $3ee4f50b1ae43a89$var$write_ct(ct, opts));
    $3ee4f50b1ae43a89$var$zip_add_file(zip, "_rels/.rels", $3ee4f50b1ae43a89$var$write_rels(opts.rels));
    $3ee4f50b1ae43a89$var$zip_add_file(zip, "xl/_rels/workbook." + wbext + ".rels", $3ee4f50b1ae43a89$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $3ee4f50b1ae43a89$var$write_zip_xlsx(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    $3ee4f50b1ae43a89$var$_shapeid = 1024;
    if (wb && !wb.SSF) wb.SSF = $3ee4f50b1ae43a89$var$dup($3ee4f50b1ae43a89$var$table_fmt);
    if (wb && wb.SSF) {
        $3ee4f50b1ae43a89$var$make_ssf();
        $3ee4f50b1ae43a89$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $3ee4f50b1ae43a89$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($3ee4f50b1ae43a89$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "xml";
    var vbafmt = $3ee4f50b1ae43a89$var$VBAFMTS.indexOf(opts.bookType) > -1;
    var ct = $3ee4f50b1ae43a89$var$new_ct();
    $3ee4f50b1ae43a89$var$fix_write_opts(opts = opts || {});
    var zip = $3ee4f50b1ae43a89$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $3ee4f50b1ae43a89$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.rels, 2, f, $3ee4f50b1ae43a89$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.rels, 3, f, $3ee4f50b1ae43a89$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $3ee4f50b1ae43a89$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.rels, 4, f, $3ee4f50b1ae43a89$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            "!id": {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_ws_xml(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $3ee4f50b1ae43a89$var$RELS.WS[0]);
        if (ws) {
            var comments = ws["!comments"];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + "." + wbext;
                    $3ee4f50b1ae43a89$var$zip_add_file(zip, cf, $3ee4f50b1ae43a89$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $3ee4f50b1ae43a89$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + "." + wbext, $3ee4f50b1ae43a89$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $3ee4f50b1ae43a89$var$zip_add_file(zip, cf, $3ee4f50b1ae43a89$var$write_comments_xml(comments, opts));
                ct.comments.push(cf);
                $3ee4f50b1ae43a89$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $3ee4f50b1ae43a89$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws["!legacy"]) {
                if (need_vml) $3ee4f50b1ae43a89$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $3ee4f50b1ae43a89$var$write_comments_vml(rId, ws["!comments"]));
            }
            delete ws["!comments"];
            delete ws["!legacy"];
        }
        if (wsrels["!id"].rId1) $3ee4f50b1ae43a89$var$zip_add_file(zip, $3ee4f50b1ae43a89$var$get_rels_path(f), $3ee4f50b1ae43a89$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_sst_xml(opts.Strings, opts));
        ct.strs.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $3ee4f50b1ae43a89$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_wb_xml(wb, opts));
    ct.workbooks.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.rels, 1, f, $3ee4f50b1ae43a89$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_theme(wb.Themes, opts));
    ct.themes.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $3ee4f50b1ae43a89$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_sty_xml(wb, opts));
    ct.styles.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "styles." + wbext, $3ee4f50b1ae43a89$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $3ee4f50b1ae43a89$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_xlmeta_xml());
    ct.metadata.push(f);
    $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $3ee4f50b1ae43a89$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $3ee4f50b1ae43a89$var$zip_add_file(zip, f, $3ee4f50b1ae43a89$var$write_people_xml(people, opts));
        ct.people.push(f);
        $3ee4f50b1ae43a89$var$add_rels(opts.wbrels, -1, "persons/person.xml", $3ee4f50b1ae43a89$var$RELS.PEOPLE);
    }
    $3ee4f50b1ae43a89$var$zip_add_file(zip, "[Content_Types].xml", $3ee4f50b1ae43a89$var$write_ct(ct, opts));
    $3ee4f50b1ae43a89$var$zip_add_file(zip, "_rels/.rels", $3ee4f50b1ae43a89$var$write_rels(opts.rels));
    $3ee4f50b1ae43a89$var$zip_add_file(zip, "xl/_rels/workbook." + wbext + ".rels", $3ee4f50b1ae43a89$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $3ee4f50b1ae43a89$var$firstbyte(f /*:RawData*/ , o /*:?TypeOpts*/ ) /*:Array<number>*/ {
    var x = "";
    switch((o || {}).type || "base64"){
        case "buffer":
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        case "base64":
            x = $3ee4f50b1ae43a89$var$Base64_decode(f.slice(0, 12));
            break;
        case "binary":
            x = f;
            break;
        case "array":
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        default:
            throw new Error("Unrecognized type " + (o && o.type || "undefined"));
    }
    return [
        x.charCodeAt(0),
        x.charCodeAt(1),
        x.charCodeAt(2),
        x.charCodeAt(3),
        x.charCodeAt(4),
        x.charCodeAt(5),
        x.charCodeAt(6),
        x.charCodeAt(7)
    ];
}
function $3ee4f50b1ae43a89$var$read_cfb(cfb /*:CFBContainer*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    if ($3ee4f50b1ae43a89$export$9f0e51cd97c572a.find(cfb, "EncryptedPackage")) return $3ee4f50b1ae43a89$var$parse_xlsxcfb(cfb, opts);
    return $3ee4f50b1ae43a89$export$b41972a043aba84c(cfb, opts);
}
function $3ee4f50b1ae43a89$var$read_zip(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var zip, d = data;
    var o = opts || {};
    if (!o.type) o.type = $3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    zip = $3ee4f50b1ae43a89$var$zip_read(d, o);
    return $3ee4f50b1ae43a89$export$b165387946f79a1(zip, o);
}
function $3ee4f50b1ae43a89$var$read_plaintext(data /*:string*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var i = 0;
    main: while(i < data.length)switch(data.charCodeAt(i)){
        case 0x0A:
        case 0x0D:
        case 0x20:
            ++i;
            break;
        case 0x3C:
            return $3ee4f50b1ae43a89$var$parse_xlml(data.slice(i), o);
        default:
            break main;
    }
    return $3ee4f50b1ae43a89$var$PRN.to_workbook(data, o);
}
function $3ee4f50b1ae43a89$var$read_plaintext_raw(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var str = "", bytes = $3ee4f50b1ae43a89$var$firstbyte(data, o);
    switch(o.type){
        case "base64":
            str = $3ee4f50b1ae43a89$var$Base64_decode(data);
            break;
        case "binary":
            str = data;
            break;
        case "buffer":
            str = data.toString("binary");
            break;
        case "array":
            str = $3ee4f50b1ae43a89$var$cc2str(data);
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $3ee4f50b1ae43a89$var$utf8read(str);
    o.type = "binary";
    return $3ee4f50b1ae43a89$var$read_plaintext(str, o);
}
function $3ee4f50b1ae43a89$var$read_utf16(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var d = data;
    if (o.type == "base64") d = $3ee4f50b1ae43a89$var$Base64_decode(d);
    d = $3ee4f50b1ae43a89$var$$cptable.utils.decode(1200, d.slice(2), "str");
    o.type = "binary";
    return $3ee4f50b1ae43a89$var$read_plaintext(d, o);
}
function $3ee4f50b1ae43a89$var$bstrify(data /*:string*/ ) /*:string*/ {
    return !data.match(/[^\x00-\x7F]/) ? data : $3ee4f50b1ae43a89$var$utf8write(data);
}
function $3ee4f50b1ae43a89$var$read_prn(data, d, o, str) {
    if (str) {
        o.type = "string";
        return $3ee4f50b1ae43a89$var$PRN.to_workbook(data, o);
    }
    return $3ee4f50b1ae43a89$var$PRN.to_workbook(d, o);
}
function $3ee4f50b1ae43a89$export$aafa59e2e03f2942(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $3ee4f50b1ae43a89$var$reset_cp();
    var o = opts || {};
    if (typeof ArrayBuffer !== "undefined" && data instanceof ArrayBuffer) return $3ee4f50b1ae43a89$export$aafa59e2e03f2942(new Uint8Array(data), (o = $3ee4f50b1ae43a89$var$dup(o), o.type = "array", o));
    if (typeof Uint8Array !== "undefined" && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
    var d = data, n = [
        0,
        0,
        0,
        0
    ], str = false;
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    $3ee4f50b1ae43a89$var$_ssfopts = {};
    if (o.dateNF) $3ee4f50b1ae43a89$var$_ssfopts.dateNF = o.dateNF;
    if (!o.type) o.type = $3ee4f50b1ae43a89$var$has_buf && $3ee4f50b1ae43a89$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    if (o.type == "file") {
        o.type = $3ee4f50b1ae43a89$var$has_buf ? "buffer" : "binary";
        d = $3ee4f50b1ae43a89$var$read_binary(data);
        if (typeof Uint8Array !== "undefined" && !$3ee4f50b1ae43a89$var$has_buf) o.type = "array";
    }
    if (o.type == "string") {
        str = true;
        o.type = "binary";
        o.codepage = 65001;
        d = $3ee4f50b1ae43a89$var$bstrify(data);
    }
    if (o.type == "array" && typeof Uint8Array !== "undefined" && data instanceof Uint8Array && typeof ArrayBuffer !== "undefined") {
        // $FlowIgnore
        var ab = new ArrayBuffer(3), vu = new Uint8Array(ab);
        vu.foo = "bar";
        // $FlowIgnore
        if (!vu.foo) {
            o = $3ee4f50b1ae43a89$var$dup(o);
            o.type = "array";
            return $3ee4f50b1ae43a89$export$aafa59e2e03f2942($3ee4f50b1ae43a89$var$ab2a(d), o);
        }
    }
    switch((n = $3ee4f50b1ae43a89$var$firstbyte(d, o))[0]){
        case 0xD0:
            if (n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return $3ee4f50b1ae43a89$var$read_cfb($3ee4f50b1ae43a89$export$9f0e51cd97c572a.read(d, o), o);
            break;
        case 0x09:
            if (n[1] <= 0x08) return $3ee4f50b1ae43a89$export$b41972a043aba84c(d, o);
            break;
        case 0x3C:
            return $3ee4f50b1ae43a89$var$parse_xlml(d, o);
        case 0x49:
            if (n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
            if (n[1] === 0x44) return $3ee4f50b1ae43a89$var$read_wb_ID(d, o);
            break;
        case 0x54:
            if (n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return $3ee4f50b1ae43a89$var$DIF.to_workbook(d, o);
            break;
        case 0x50:
            return n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09 ? $3ee4f50b1ae43a89$var$read_zip(d, o) : $3ee4f50b1ae43a89$var$read_prn(data, d, o, str);
        case 0xEF:
            return n[3] === 0x3C ? $3ee4f50b1ae43a89$var$parse_xlml(d, o) : $3ee4f50b1ae43a89$var$read_prn(data, d, o, str);
        case 0xFF:
            if (n[1] === 0xFE) return $3ee4f50b1ae43a89$var$read_utf16(d, o);
            else if (n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return $3ee4f50b1ae43a89$var$WK_.to_workbook(d, o);
            break;
        case 0x00:
            if (n[1] === 0x00) {
                if (n[2] >= 0x02 && n[3] === 0x00) return $3ee4f50b1ae43a89$var$WK_.to_workbook(d, o);
                if (n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return $3ee4f50b1ae43a89$var$WK_.to_workbook(d, o);
            }
            break;
        case 0x03:
        case 0x83:
        case 0x8B:
        case 0x8C:
            return $3ee4f50b1ae43a89$var$DBF.to_workbook(d, o);
        case 0x7B:
            if (n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return $3ee4f50b1ae43a89$var$RTF.to_workbook(d, o);
            break;
        case 0x0A:
        case 0x0D:
        case 0x20:
            return $3ee4f50b1ae43a89$var$read_plaintext_raw(d, o);
        case 0x89:
            if (n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet");
            break;
    }
    if ($3ee4f50b1ae43a89$var$DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return $3ee4f50b1ae43a89$var$DBF.to_workbook(d, o);
    return $3ee4f50b1ae43a89$var$read_prn(data, d, o, str);
}
function $3ee4f50b1ae43a89$export$72c04af63de9061a(filename /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var o = opts || {};
    o.type = "file";
    return $3ee4f50b1ae43a89$export$aafa59e2e03f2942(filename, o);
}
function $3ee4f50b1ae43a89$var$write_cfb_ctr(cfb /*:CFBContainer*/ , o /*:WriteOpts*/ ) /*:any*/ {
    switch(o.type){
        case "base64":
        case "binary":
            break;
        case "buffer":
        case "array":
            o.type = "";
            break;
        case "file":
            return $3ee4f50b1ae43a89$var$write_dl(o.file, $3ee4f50b1ae43a89$export$9f0e51cd97c572a.write(cfb, {
                type: $3ee4f50b1ae43a89$var$has_buf ? "buffer" : ""
            }));
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    return $3ee4f50b1ae43a89$export$9f0e51cd97c572a.write(cfb, o);
}
/*:: declare var encrypt_agile:any; */ function $3ee4f50b1ae43a89$var$write_zip_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $3ee4f50b1ae43a89$var$dup(opts || {});
    var z = $3ee4f50b1ae43a89$var$write_zip(wb, o);
    return $3ee4f50b1ae43a89$var$write_zip_denouement(z, o);
}
function $3ee4f50b1ae43a89$var$write_zip_typeXLSX(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $3ee4f50b1ae43a89$var$dup(opts || {});
    var z = $3ee4f50b1ae43a89$var$write_zip_xlsx(wb, o);
    return $3ee4f50b1ae43a89$var$write_zip_denouement(z, o);
}
function $3ee4f50b1ae43a89$var$write_zip_denouement(z /*:any*/ , o /*:?WriteOpts*/ ) /*:any*/ {
    var oopts = {};
    var ftype = $3ee4f50b1ae43a89$var$has_buf ? "nodebuffer" : typeof Uint8Array !== "undefined" ? "array" : "string";
    if (o.compression) oopts.compression = "DEFLATE";
    if (o.password) oopts.type = ftype;
    else switch(o.type){
        case "base64":
            oopts.type = "base64";
            break;
        case "binary":
            oopts.type = "string";
            break;
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        case "buffer":
        case "file":
            oopts.type = ftype;
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    var out = z.FullPaths ? $3ee4f50b1ae43a89$export$9f0e51cd97c572a.write(z, {
        fileType: "zip",
        type: /*::(*/ {
            "nodebuffer": "buffer",
            "string": "binary"
        } /*:: :any)*/ [oopts.type] || oopts.type,
        compression: !!o.compression
    }) : z.generate(oopts);
    if (typeof Deno !== "undefined") {
        if (typeof out == "string") {
            if (o.type == "binary" || o.type == "base64") return out;
            out = new Uint8Array($3ee4f50b1ae43a89$var$s2ab(out));
        }
    }
    /*jshint -W083 */ if (o.password && typeof encrypt_agile !== "undefined") return $3ee4f50b1ae43a89$var$write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
    /*jshint +W083 */ if (o.type === "file") return $3ee4f50b1ae43a89$var$write_dl(o.file, out);
    return o.type == "string" ? $3ee4f50b1ae43a89$var$utf8read(/*::(*/ out /*:: :any)*/ ) : out;
}
function $3ee4f50b1ae43a89$var$write_cfb_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = opts || {};
    var cfb /*:CFBContainer*/  = $3ee4f50b1ae43a89$var$write_xlscfb(wb, o);
    return $3ee4f50b1ae43a89$var$write_cfb_ctr(cfb, o);
}
function $3ee4f50b1ae43a89$var$write_string_type(out /*:string*/ , opts /*:WriteOpts*/ , bom /*:?string*/ ) /*:any*/ {
    if (!bom) bom = "";
    var o = bom + out;
    switch(opts.type){
        case "base64":
            return $3ee4f50b1ae43a89$var$Base64_encode($3ee4f50b1ae43a89$var$utf8write(o));
        case "binary":
            return $3ee4f50b1ae43a89$var$utf8write(o);
        case "string":
            return out;
        case "file":
            return $3ee4f50b1ae43a89$var$write_dl(opts.file, o, "utf8");
        case "buffer":
            if ($3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$var$Buffer_from(o, "utf8");
            else if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
            else return $3ee4f50b1ae43a89$var$write_string_type(o, {
                type: "binary"
            }).split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $3ee4f50b1ae43a89$var$write_stxt_type(out /*:string*/ , opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "base64":
            return $3ee4f50b1ae43a89$var$Base64_encode(out);
        case "binary":
            return out;
        case "string":
            return out; /* override in sheet_to_txt */ 
        case "file":
            return $3ee4f50b1ae43a89$var$write_dl(opts.file, out, "binary");
        case "buffer":
            if ($3ee4f50b1ae43a89$var$has_buf) return $3ee4f50b1ae43a89$var$Buffer_from(out, "binary");
            else return out.split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
/* TODO: test consistency */ function $3ee4f50b1ae43a89$var$write_binary_type(out, opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "string":
        case "base64":
        case "binary":
            var bstr = "";
            // $FlowIgnore
            for(var i = 0; i < out.length; ++i)bstr += String.fromCharCode(out[i]);
            return opts.type == "base64" ? $3ee4f50b1ae43a89$var$Base64_encode(bstr) : opts.type == "string" ? $3ee4f50b1ae43a89$var$utf8read(bstr) : bstr;
        case "file":
            return $3ee4f50b1ae43a89$var$write_dl(opts.file, out);
        case "buffer":
            return out;
        default:
            throw new Error("Unrecognized type " + opts.type);
    }
}
function $3ee4f50b1ae43a89$export$f6ca43591cb061b1(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $3ee4f50b1ae43a89$var$reset_cp();
    $3ee4f50b1ae43a89$var$check_wb(wb);
    var o = $3ee4f50b1ae43a89$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $3ee4f50b1ae43a89$export$f6ca43591cb061b1(wb, o);
        o.type = "array";
        return $3ee4f50b1ae43a89$var$s2ab(out);
    }
    return $3ee4f50b1ae43a89$var$write_zip_typeXLSX(wb, o);
}
function $3ee4f50b1ae43a89$export$68d8715fc104d294(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $3ee4f50b1ae43a89$var$reset_cp();
    $3ee4f50b1ae43a89$var$check_wb(wb);
    var o = $3ee4f50b1ae43a89$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $3ee4f50b1ae43a89$export$68d8715fc104d294(wb, o);
        o.type = "array";
        return $3ee4f50b1ae43a89$var$s2ab(out);
    }
    var idx = 0;
    if (o.sheet) {
        if (typeof o.sheet == "number") idx = o.sheet;
        else idx = wb.SheetNames.indexOf(o.sheet);
        if (!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + typeof o.sheet);
    }
    switch(o.bookType || "xlsb"){
        case "xml":
        case "xlml":
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$write_xlml(wb, o), o);
        case "slk":
        case "sylk":
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "htm":
        case "html":
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "txt":
            return $3ee4f50b1ae43a89$var$write_stxt_type($3ee4f50b1ae43a89$var$sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "csv":
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\uFEFF");
        case "dif":
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "dbf":
            return $3ee4f50b1ae43a89$var$write_binary_type($3ee4f50b1ae43a89$var$DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "prn":
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "rtf":
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$RTF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "eth":
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "fods":
            return $3ee4f50b1ae43a89$var$write_string_type($3ee4f50b1ae43a89$var$write_ods(wb, o), o);
        case "wk1":
            return $3ee4f50b1ae43a89$var$write_binary_type($3ee4f50b1ae43a89$var$WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "wk3":
            return $3ee4f50b1ae43a89$var$write_binary_type($3ee4f50b1ae43a89$var$WK_.book_to_wk3(wb, o), o);
        case "biff2":
            if (!o.biff) o.biff = 2; /* falls through */ 
        case "biff3":
            if (!o.biff) o.biff = 3; /* falls through */ 
        case "biff4":
            if (!o.biff) o.biff = 4;
            return $3ee4f50b1ae43a89$var$write_binary_type($3ee4f50b1ae43a89$var$write_biff_buf(wb, o), o);
        case "biff5":
            if (!o.biff) o.biff = 5; /* falls through */ 
        case "biff8":
        case "xla":
        case "xls":
            if (!o.biff) o.biff = 8;
            return $3ee4f50b1ae43a89$var$write_cfb_type(wb, o);
        case "xlsx":
        case "xlsm":
        case "xlam":
        case "xlsb":
        case "numbers":
        case "ods":
            return $3ee4f50b1ae43a89$var$write_zip_type(wb, o);
        default:
            throw new Error("Unrecognized bookType |" + o.bookType + "|");
    }
}
function $3ee4f50b1ae43a89$var$resolve_book_type(o /*:WriteFileOpts*/ ) {
    if (o.bookType) return;
    var _BT = {
        "xls": "biff8",
        "htm": "html",
        "slk": "sylk",
        "socialcalc": "eth",
        "Sh33tJS": "WTF"
    };
    var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
    if (ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
    o.bookType = _BT[o.bookType] || o.bookType;
}
function $3ee4f50b1ae43a89$export$552bfb764b5cd2b4(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = "file";
    o.file = filename;
    $3ee4f50b1ae43a89$var$resolve_book_type(o);
    return $3ee4f50b1ae43a89$export$68d8715fc104d294(wb, o);
}
function $3ee4f50b1ae43a89$export$40a06aea54ee074e(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = "file";
    o.file = filename;
    $3ee4f50b1ae43a89$var$resolve_book_type(o);
    return $3ee4f50b1ae43a89$export$f6ca43591cb061b1(wb, o);
}
function $3ee4f50b1ae43a89$export$25469296c4b8ebda(filename /*:string*/ , wb /*:Workbook*/ , opts /*:?WriteFileOpts*/ , cb /*:?(e?:ErrnoError)=>void*/ ) {
    var o = opts || {};
    o.type = "file";
    o.file = filename;
    $3ee4f50b1ae43a89$var$resolve_book_type(o);
    o.type = "buffer";
    var _cb = cb;
    if (!(_cb instanceof Function)) _cb = opts /*:any*/ ;
    return $3ee4f50b1ae43a89$var$_fs.writeFile(filename, $3ee4f50b1ae43a89$export$68d8715fc104d294(wb, o), _cb);
}
/*::
type MJRObject = {
	row: any;
	isempty: boolean;
};
*/ function $3ee4f50b1ae43a89$var$make_json_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , header /*:number*/ , hdr /*:Array<any>*/ , dense /*:boolean*/ , o /*:Sheet2JSONOpts*/ ) /*:MJRObject*/ {
    var rr = $3ee4f50b1ae43a89$var$encode_row(R);
    var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
    var isempty = true;
    var row /*:any*/  = header === 1 ? [] : {};
    if (header !== 1) {
        if (Object.defineProperty) try {
            Object.defineProperty(row, "__rowNum__", {
                value: R,
                enumerable: false
            });
        } catch (e) {
            row.__rowNum__ = R;
        }
        else row.__rowNum__ = R;
    }
    if (!dense || sheet[R]) for(var C = r.s.c; C <= r.e.c; ++C){
        var val = dense ? sheet[R][C] : sheet[cols[C] + rr];
        if (val === undefined || val.t === undefined) {
            if (defval === undefined) continue;
            if (hdr[C] != null) row[hdr[C]] = defval;
            continue;
        }
        var v = val.v;
        switch(val.t){
            case "z":
                if (v == null) break;
                continue;
            case "e":
                v = v == 0 ? null : void 0;
                break;
            case "s":
            case "d":
            case "b":
            case "n":
                break;
            default:
                throw new Error("unrecognized type " + val.t);
        }
        if (hdr[C] != null) {
            if (v == null) {
                if (val.t == "e" && v === null) row[hdr[C]] = null;
                else if (defval !== undefined) row[hdr[C]] = defval;
                else if (raw && v === null) row[hdr[C]] = null;
                else continue;
            } else row[hdr[C]] = raw && (val.t !== "n" || val.t === "n" && o.rawNumbers !== false) ? v : $3ee4f50b1ae43a89$var$format_cell(val, v, o);
            if (v != null) isempty = false;
        }
    }
    return {
        row: row,
        isempty: isempty
    };
}
function $3ee4f50b1ae43a89$var$sheet_to_json(sheet /*:Worksheet*/ , opts /*:?Sheet2JSONOpts*/ ) {
    if (sheet == null || sheet["!ref"] == null) return [];
    var val = {
        t: "n",
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    else if (o.header == null) header = 0;
    switch(typeof range){
        case "string":
            r = $3ee4f50b1ae43a89$var$safe_decode_range(range);
            break;
        case "number":
            r = $3ee4f50b1ae43a89$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $3ee4f50b1ae43a89$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var out /*:Array<any>*/  = [];
    var outi = 0, counter = 0;
    var dense = Array.isArray(sheet);
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet[R]) sheet[R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
        val = dense ? sheet[R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val == null) val = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $3ee4f50b1ae43a89$var$format_cell(val, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    for(R = r.s.r + offset; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        var row = $3ee4f50b1ae43a89$var$make_json_row(sheet, r, R, cols, header, hdr, dense, o);
        if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
    }
    out.length = outi;
    return out;
}
var $3ee4f50b1ae43a89$var$qreg = /"/g;
function $3ee4f50b1ae43a89$var$make_csv_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , fs /*:number*/ , rs /*:number*/ , FS /*:string*/ , o /*:Sheet2CSVOpts*/ ) /*:?string*/ {
    var isempty = true;
    var row /*:Array<string>*/  = [], txt = "", rr = $3ee4f50b1ae43a89$var$encode_row(R);
    for(var C = r.s.c; C <= r.e.c; ++C){
        if (!cols[C]) continue;
        var val = o.dense ? (sheet[R] || [])[C] : sheet[cols[C] + rr];
        if (val == null) txt = "";
        else if (val.v != null) {
            isempty = false;
            txt = "" + (o.rawNumbers && val.t == "n" ? val.v : $3ee4f50b1ae43a89$var$format_cell(val, null, o));
            for(var i = 0, cc = 0; i !== txt.length; ++i)if ((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {
                txt = '"' + txt.replace($3ee4f50b1ae43a89$var$qreg, '""') + '"';
                break;
            }
            if (txt == "ID") txt = '"ID"';
        } else if (val.f != null && !val.F) {
            isempty = false;
            txt = "=" + val.f;
            if (txt.indexOf(",") >= 0) txt = '"' + txt.replace($3ee4f50b1ae43a89$var$qreg, '""') + '"';
        } else txt = "";
        /* NOTE: Excel CSV does not support array formulae */ row.push(txt);
    }
    if (o.blankrows === false && isempty) return null;
    return row.join(FS);
}
function $3ee4f50b1ae43a89$var$sheet_to_csv(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) return "";
    var r = $3ee4f50b1ae43a89$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var endregex = new RegExp((FS == "|" ? "\\|" : FS) + "+$");
    var row = "", cols /*:Array<string>*/  = [];
    o.dense = Array.isArray(sheet);
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
    var w = 0;
    for(var R = r.s.r; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        row = $3ee4f50b1ae43a89$var$make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
        if (row == null) continue;
        if (o.strip) row = row.replace(endregex, "");
        if (row || o.blankrows !== false) out.push((w++ ? RS : "") + row);
    }
    delete o.dense;
    return out.join("");
}
function $3ee4f50b1ae43a89$var$sheet_to_txt(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    if (!opts) opts = {};
    opts.FS = "	";
    opts.RS = "\n";
    var s = $3ee4f50b1ae43a89$var$sheet_to_csv(sheet, opts);
    if (typeof $3ee4f50b1ae43a89$var$$cptable == "undefined" || opts.type == "string") return s;
    var o = $3ee4f50b1ae43a89$var$$cptable.utils.encode(1200, s, "str");
    return String.fromCharCode(255) + String.fromCharCode(254) + o;
}
function $3ee4f50b1ae43a89$var$sheet_to_formulae(sheet /*:Worksheet*/ ) /*:Array<string>*/ {
    var y = "", x, val = "";
    if (sheet == null || sheet["!ref"] == null) return [];
    var r = $3ee4f50b1ae43a89$var$safe_decode_range(sheet["!ref"]), rr = "", cols /*:Array<string>*/  = [], C;
    var cmds /*:Array<string>*/  = [];
    var dense = Array.isArray(sheet);
    for(C = r.s.c; C <= r.e.c; ++C)cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
    for(var R = r.s.r; R <= r.e.r; ++R){
        rr = $3ee4f50b1ae43a89$var$encode_row(R);
        for(C = r.s.c; C <= r.e.c; ++C){
            y = cols[C] + rr;
            x = dense ? (sheet[R] || [])[C] : sheet[y];
            val = "";
            if (x === undefined) continue;
            else if (x.F != null) {
                y = x.F;
                if (!x.f) continue;
                val = x.f;
                if (y.indexOf(":") == -1) y = y + ":" + y;
            }
            if (x.f != null) val = x.f;
            else if (x.t == "z") continue;
            else if (x.t == "n" && x.v != null) val = "" + x.v;
            else if (x.t == "b") val = x.v ? "TRUE" : "FALSE";
            else if (x.w !== undefined) val = "'" + x.w;
            else if (x.v === undefined) continue;
            else if (x.t == "s") val = "'" + x.v;
            else val = "" + x.v;
            cmds[cmds.length] = y + "=" + val;
        }
    }
    return cmds;
}
function $3ee4f50b1ae43a89$var$sheet_add_json(_ws /*:?Worksheet*/ , js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    var o = opts || {};
    var offset = +!o.skipHeader;
    var ws /*:Worksheet*/  = _ws || {} /*:any*/ ;
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == "number") _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $3ee4f50b1ae43a89$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var cell /*:Cell*/ ;
    var range /*:Range*/  = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: _C,
            r: _R + js.length - 1 + offset
        }
    } /*:any*/ ;
    if (ws["!ref"]) {
        var _range = $3ee4f50b1ae43a89$var$safe_decode_range(ws["!ref"]);
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) {
            _R = _range.e.r + 1;
            range.e.r = _R + js.length - 1 + offset;
        }
    } else if (_R == -1) {
        _R = 0;
        range.e.r = js.length - 1 + offset;
    }
    var hdr /*:Array<string>*/  = o.header || [], C = 0;
    js.forEach(function(JS, R /*:number*/ ) {
        $3ee4f50b1ae43a89$var$keys(JS).forEach(function(k) {
            if ((C = hdr.indexOf(k)) == -1) hdr[C = hdr.length] = k;
            var v = JS[k];
            var t = "z";
            var z = "";
            var ref = $3ee4f50b1ae43a89$var$encode_cell({
                c: _C + C,
                r: _R + R + offset
            });
            cell = $3ee4f50b1ae43a89$var$ws_get_cell_stub(ws, ref);
            if (v && typeof v === "object" && !(v instanceof Date)) ws[ref] = v;
            else {
                if (typeof v == "number") t = "n";
                else if (typeof v == "boolean") t = "b";
                else if (typeof v == "string") t = "s";
                else if (v instanceof Date) {
                    t = "d";
                    if (!o.cellDates) {
                        t = "n";
                        v = $3ee4f50b1ae43a89$var$datenum(v);
                    }
                    z = o.dateNF || $3ee4f50b1ae43a89$var$table_fmt[14];
                } else if (v === null && o.nullError) {
                    t = "e";
                    v = 0;
                }
                if (!cell) ws[ref] = cell = {
                    t: t,
                    v: v
                } /*:any*/ ;
                else {
                    cell.t = t;
                    cell.v = v;
                    delete cell.w;
                    delete cell.R;
                    if (z) cell.z = z;
                }
                if (z) cell.z = z;
            }
        });
    });
    range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
    var __R = $3ee4f50b1ae43a89$var$encode_row(_R);
    if (offset) for(C = 0; C < hdr.length; ++C)ws[$3ee4f50b1ae43a89$var$encode_col(C + _C) + __R] = {
        t: "s",
        v: hdr[C]
    };
    ws["!ref"] = $3ee4f50b1ae43a89$var$encode_range(range);
    return ws;
}
function $3ee4f50b1ae43a89$var$json_to_sheet(js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    return $3ee4f50b1ae43a89$var$sheet_add_json(null, js, opts);
}
/* get cell, creating a stub if necessary */ function $3ee4f50b1ae43a89$var$ws_get_cell_stub(ws /*:Worksheet*/ , R, C /*:?number*/ ) /*:Cell*/ {
    /* A1 cell address */ if (typeof R == "string") {
        /* dense */ if (Array.isArray(ws)) {
            var RC = $3ee4f50b1ae43a89$var$decode_cell(R);
            if (!ws[RC.r]) ws[RC.r] = [];
            return ws[RC.r][RC.c] || (ws[RC.r][RC.c] = {
                t: "z"
            });
        }
        return ws[R] || (ws[R] = {
            t: "z"
        });
    }
    /* cell address object */ if (typeof R != "number") return $3ee4f50b1ae43a89$var$ws_get_cell_stub(ws, $3ee4f50b1ae43a89$var$encode_cell(R));
    /* R and C are 0-based indices */ return $3ee4f50b1ae43a89$var$ws_get_cell_stub(ws, $3ee4f50b1ae43a89$var$encode_cell({
        r: R,
        c: C || 0
    }));
}
/* find sheet index for given name / validate index */ function $3ee4f50b1ae43a89$var$wb_sheet_idx(wb /*:Workbook*/ , sh /*:number|string*/ ) {
    if (typeof sh == "number") {
        if (sh >= 0 && wb.SheetNames.length > sh) return sh;
        throw new Error("Cannot find sheet # " + sh);
    } else if (typeof sh == "string") {
        var idx = wb.SheetNames.indexOf(sh);
        if (idx > -1) return idx;
        throw new Error("Cannot find sheet name |" + sh + "|");
    } else throw new Error("Cannot find sheet |" + sh + "|");
}
/* simple blank workbook object */ function $3ee4f50b1ae43a89$var$book_new() /*:Workbook*/ {
    return {
        SheetNames: [],
        Sheets: {}
    };
}
/* add a worksheet to the end of a given workbook */ function $3ee4f50b1ae43a89$var$book_append_sheet(wb /*:Workbook*/ , ws /*:Worksheet*/ , name /*:?string*/ , roll /*:?boolean*/ ) /*:string*/ {
    var i = 1;
    if (!name) {
        for(; i <= 0xFFFF; ++i, name = undefined)if (wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
    }
    if (!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
    if (roll && wb.SheetNames.indexOf(name) >= 0) {
        var m = name.match(/(^.*?)(\d+)$/);
        i = m && +m[2] || 0;
        var root = m && m[1] || name;
        for(++i; i <= 0xFFFF; ++i)if (wb.SheetNames.indexOf(name = root + i) == -1) break;
    }
    $3ee4f50b1ae43a89$var$check_ws_name(name);
    if (wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
    wb.SheetNames.push(name);
    wb.Sheets[name] = ws;
    return name;
}
/* set sheet visibility (visible/hidden/very hidden) */ function $3ee4f50b1ae43a89$var$book_set_sheet_visibility(wb /*:Workbook*/ , sh /*:number|string*/ , vis /*:number*/ ) {
    if (!wb.Workbook) wb.Workbook = {};
    if (!wb.Workbook.Sheets) wb.Workbook.Sheets = [];
    var idx = $3ee4f50b1ae43a89$var$wb_sheet_idx(wb, sh);
    // $FlowIgnore
    if (!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};
    switch(vis){
        case 0:
        case 1:
        case 2:
            break;
        default:
            throw new Error("Bad sheet visibility setting " + vis);
    }
    // $FlowIgnore
    wb.Workbook.Sheets[idx].Hidden = vis;
}
/* set number format */ function $3ee4f50b1ae43a89$var$cell_set_number_format(cell /*:Cell*/ , fmt /*:string|number*/ ) {
    cell.z = fmt;
    return cell;
}
/* set cell hyperlink */ function $3ee4f50b1ae43a89$var$cell_set_hyperlink(cell /*:Cell*/ , target /*:string*/ , tooltip /*:?string*/ ) {
    if (!target) delete cell.l;
    else {
        cell.l = {
            Target: target
        } /*:Hyperlink*/ ;
        if (tooltip) cell.l.Tooltip = tooltip;
    }
    return cell;
}
function $3ee4f50b1ae43a89$var$cell_set_internal_link(cell /*:Cell*/ , range /*:string*/ , tooltip /*:?string*/ ) {
    return $3ee4f50b1ae43a89$var$cell_set_hyperlink(cell, "#" + range, tooltip);
}
/* add to cell comments */ function $3ee4f50b1ae43a89$var$cell_add_comment(cell /*:Cell*/ , text /*:string*/ , author /*:?string*/ ) {
    if (!cell.c) cell.c = [];
    cell.c.push({
        t: text,
        a: author || "SheetJS"
    });
}
/* set array formula and flush related cells */ function $3ee4f50b1ae43a89$var$sheet_set_array_formula(ws /*:Worksheet*/ , range, formula /*:string*/ , dynamic /*:boolean*/ ) {
    var rng = typeof range != "string" ? range : $3ee4f50b1ae43a89$var$safe_decode_range(range);
    var rngstr = typeof range == "string" ? range : $3ee4f50b1ae43a89$var$encode_range(range);
    for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
        var cell = $3ee4f50b1ae43a89$var$ws_get_cell_stub(ws, R, C);
        cell.t = "n";
        cell.F = rngstr;
        delete cell.v;
        if (R == rng.s.r && C == rng.s.c) {
            cell.f = formula;
            if (dynamic) cell.D = true;
        }
    }
    return ws;
}
var $3ee4f50b1ae43a89$export$eab97d15b1788b8d /*:any*/  = {
    encode_col: $3ee4f50b1ae43a89$var$encode_col,
    encode_row: $3ee4f50b1ae43a89$var$encode_row,
    encode_cell: $3ee4f50b1ae43a89$var$encode_cell,
    encode_range: $3ee4f50b1ae43a89$var$encode_range,
    decode_col: $3ee4f50b1ae43a89$var$decode_col,
    decode_row: $3ee4f50b1ae43a89$var$decode_row,
    split_cell: $3ee4f50b1ae43a89$var$split_cell,
    decode_cell: $3ee4f50b1ae43a89$var$decode_cell,
    decode_range: $3ee4f50b1ae43a89$var$decode_range,
    format_cell: $3ee4f50b1ae43a89$var$format_cell,
    sheet_add_aoa: $3ee4f50b1ae43a89$var$sheet_add_aoa,
    sheet_add_json: $3ee4f50b1ae43a89$var$sheet_add_json,
    sheet_add_dom: $3ee4f50b1ae43a89$var$sheet_add_dom,
    aoa_to_sheet: $3ee4f50b1ae43a89$var$aoa_to_sheet,
    json_to_sheet: $3ee4f50b1ae43a89$var$json_to_sheet,
    table_to_sheet: $3ee4f50b1ae43a89$var$parse_dom_table,
    table_to_book: $3ee4f50b1ae43a89$var$table_to_book,
    sheet_to_csv: $3ee4f50b1ae43a89$var$sheet_to_csv,
    sheet_to_txt: $3ee4f50b1ae43a89$var$sheet_to_txt,
    sheet_to_json: $3ee4f50b1ae43a89$var$sheet_to_json,
    sheet_to_html: $3ee4f50b1ae43a89$var$sheet_to_html,
    sheet_to_formulae: $3ee4f50b1ae43a89$var$sheet_to_formulae,
    sheet_to_row_object_array: $3ee4f50b1ae43a89$var$sheet_to_json,
    sheet_get_cell: $3ee4f50b1ae43a89$var$ws_get_cell_stub,
    book_new: $3ee4f50b1ae43a89$var$book_new,
    book_append_sheet: $3ee4f50b1ae43a89$var$book_append_sheet,
    book_set_sheet_visibility: $3ee4f50b1ae43a89$var$book_set_sheet_visibility,
    cell_set_number_format: $3ee4f50b1ae43a89$var$cell_set_number_format,
    cell_set_hyperlink: $3ee4f50b1ae43a89$var$cell_set_hyperlink,
    cell_set_internal_link: $3ee4f50b1ae43a89$var$cell_set_internal_link,
    cell_add_comment: $3ee4f50b1ae43a89$var$cell_add_comment,
    sheet_set_array_formula: $3ee4f50b1ae43a89$var$sheet_set_array_formula,
    consts: {
        SHEET_VISIBLE: 0,
        SHEET_HIDDEN: 1,
        SHEET_VERY_HIDDEN: 2
    }
};
var $3ee4f50b1ae43a89$var$_Readable;
function $3ee4f50b1ae43a89$var$set_readable(R) {
    $3ee4f50b1ae43a89$var$_Readable = R;
}
function $3ee4f50b1ae43a89$var$write_csv_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $3ee4f50b1ae43a89$var$_Readable();
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var r = $3ee4f50b1ae43a89$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var endregex = new RegExp((FS == "|" ? "\\|" : FS) + "+$");
    var row /*:?string*/  = "", cols /*:Array<string>*/  = [];
    o.dense = Array.isArray(sheet);
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
    var R = r.s.r;
    var BOM = false, w = 0;
    stream._read = function() {
        if (!BOM) {
            BOM = true;
            return stream.push("\uFEFF");
        }
        while(R <= r.e.r){
            ++R;
            if ((rowinfo[R - 1] || {}).hidden) continue;
            row = $3ee4f50b1ae43a89$var$make_csv_row(sheet, r, R - 1, cols, fs, rs, FS, o);
            if (row != null) {
                if (o.strip) row = row.replace(endregex, "");
                if (row || o.blankrows !== false) return stream.push((w++ ? RS : "") + row);
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $3ee4f50b1ae43a89$var$write_html_stream(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/ ) {
    var stream = $3ee4f50b1ae43a89$var$_Readable();
    var o = opts || {};
    var header = o.header != null ? o.header : $3ee4f50b1ae43a89$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $3ee4f50b1ae43a89$var$HTML_END;
    stream.push(header);
    var r = $3ee4f50b1ae43a89$var$decode_range(ws["!ref"]);
    o.dense = Array.isArray(ws);
    stream.push($3ee4f50b1ae43a89$var$make_html_preamble(ws, r, o));
    var R = r.s.r;
    var end = false;
    stream._read = function() {
        if (R > r.e.r) {
            if (!end) {
                end = true;
                stream.push("</table>" + footer);
            }
            return stream.push(null);
        }
        while(R <= r.e.r){
            stream.push($3ee4f50b1ae43a89$var$make_html_row(ws, r, R, o));
            ++R;
            break;
        }
    };
    return stream;
}
function $3ee4f50b1ae43a89$var$write_json_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $3ee4f50b1ae43a89$var$_Readable({
        objectMode: true
    });
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var val = {
        t: "n",
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    switch(typeof range){
        case "string":
            r = $3ee4f50b1ae43a89$var$safe_decode_range(range);
            break;
        case "number":
            r = $3ee4f50b1ae43a89$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $3ee4f50b1ae43a89$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var counter = 0;
    var dense = Array.isArray(sheet);
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet[R]) sheet[R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $3ee4f50b1ae43a89$var$encode_col(C);
        val = dense ? sheet[R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val == null) val = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $3ee4f50b1ae43a89$var$format_cell(val, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    R = r.s.r + offset;
    stream._read = function() {
        while(R <= r.e.r){
            if ((rowinfo[R - 1] || {}).hidden) continue;
            var row = $3ee4f50b1ae43a89$var$make_json_row(sheet, r, R, cols, header, hdr, dense, o);
            ++R;
            if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
                stream.push(row.row);
                return;
            }
        }
        return stream.push(null);
    };
    return stream;
}
var $3ee4f50b1ae43a89$export$4938110305e6185f = {
    to_json: $3ee4f50b1ae43a89$var$write_json_stream,
    to_html: $3ee4f50b1ae43a89$var$write_html_stream,
    to_csv: $3ee4f50b1ae43a89$var$write_csv_stream,
    set_readable: $3ee4f50b1ae43a89$var$set_readable
};
const $3ee4f50b1ae43a89$export$83d89fbfd8236492 = $3ee4f50b1ae43a89$var$XLSX.version;


var $23e83188f10c8284$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($23e83188f10c8284$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $23e83188f10c8284$exports = g;
});




var $bh6RR = parcelRequire("bh6RR");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5606419dfe2e9b1b$var$extendStatics = function(d, b) {
    $5606419dfe2e9b1b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5606419dfe2e9b1b$var$extendStatics(d, b);
};
function $5606419dfe2e9b1b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5606419dfe2e9b1b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5606419dfe2e9b1b$export$18ce0697a983be9b = function() {
    $5606419dfe2e9b1b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5606419dfe2e9b1b$export$18ce0697a983be9b.apply(this, arguments);
};
function $5606419dfe2e9b1b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5606419dfe2e9b1b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5606419dfe2e9b1b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5606419dfe2e9b1b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5606419dfe2e9b1b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5606419dfe2e9b1b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5606419dfe2e9b1b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5606419dfe2e9b1b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5606419dfe2e9b1b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5606419dfe2e9b1b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5606419dfe2e9b1b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5606419dfe2e9b1b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5606419dfe2e9b1b$export$45d3717a4c69092e(o, m, p);
}
function $5606419dfe2e9b1b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5606419dfe2e9b1b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5606419dfe2e9b1b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5606419dfe2e9b1b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5606419dfe2e9b1b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5606419dfe2e9b1b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5606419dfe2e9b1b$export$10c90e4f7922046c(v) {
    return this instanceof $5606419dfe2e9b1b$export$10c90e4f7922046c ? (this.v = v, this) : new $5606419dfe2e9b1b$export$10c90e4f7922046c(v);
}
function $5606419dfe2e9b1b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5606419dfe2e9b1b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5606419dfe2e9b1b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5606419dfe2e9b1b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5606419dfe2e9b1b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5606419dfe2e9b1b$export$19a8beecd37a4c45 === "function" ? $5606419dfe2e9b1b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5606419dfe2e9b1b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5606419dfe2e9b1b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5606419dfe2e9b1b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5606419dfe2e9b1b$export$45d3717a4c69092e(result, mod, k);
    }
    $5606419dfe2e9b1b$var$__setModuleDefault(result, mod);
    return result;
}
function $5606419dfe2e9b1b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5606419dfe2e9b1b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5606419dfe2e9b1b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5606419dfe2e9b1b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5606419dfe2e9b1b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5606419dfe2e9b1b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5606419dfe2e9b1b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5606419dfe2e9b1b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5606419dfe2e9b1b$export$2e2bcd8739ae039 = {
    __extends: $5606419dfe2e9b1b$export$a8ba968b8961cb8a,
    __assign: $5606419dfe2e9b1b$export$18ce0697a983be9b,
    __rest: $5606419dfe2e9b1b$export$3c9a16f847548506,
    __decorate: $5606419dfe2e9b1b$export$29e00dfd3077644b,
    __param: $5606419dfe2e9b1b$export$d5ad3fd78186038f,
    __metadata: $5606419dfe2e9b1b$export$f1db080c865becb9,
    __awaiter: $5606419dfe2e9b1b$export$1050f835b63b671e,
    __generator: $5606419dfe2e9b1b$export$67ebef60e6f28a6,
    __createBinding: $5606419dfe2e9b1b$export$45d3717a4c69092e,
    __exportStar: $5606419dfe2e9b1b$export$f33643c0debef087,
    __values: $5606419dfe2e9b1b$export$19a8beecd37a4c45,
    __read: $5606419dfe2e9b1b$export$8d051b38c9118094,
    __spread: $5606419dfe2e9b1b$export$afc72e2116322959,
    __spreadArrays: $5606419dfe2e9b1b$export$6388937ca91ccae8,
    __spreadArray: $5606419dfe2e9b1b$export$1216008129fb82ed,
    __await: $5606419dfe2e9b1b$export$10c90e4f7922046c,
    __asyncGenerator: $5606419dfe2e9b1b$export$e427f37a30a4de9b,
    __asyncDelegator: $5606419dfe2e9b1b$export$bbd80228419bb833,
    __asyncValues: $5606419dfe2e9b1b$export$e3b29a3d6162315f,
    __makeTemplateObject: $5606419dfe2e9b1b$export$4fb47efe1390b86f,
    __importStar: $5606419dfe2e9b1b$export$c21735bcef00d192,
    __importDefault: $5606419dfe2e9b1b$export$da59b14a69baef04,
    __classPrivateFieldGet: $5606419dfe2e9b1b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5606419dfe2e9b1b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5606419dfe2e9b1b$export$81fdc39f203e4e04,
    __addDisposableResource: $5606419dfe2e9b1b$export$88ac25d8e944e405,
    __disposeResources: $5606419dfe2e9b1b$export$8f076105dc360e92
};


function $9145dbf8e0e857b1$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $a4c525d7dbc25949$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $a4c525d7dbc25949$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9145dbf8e0e857b1$export$2e2bcd8739ae039)(function(prop) {
    return $a4c525d7dbc25949$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $bh6RR = parcelRequire("bh6RR");
var $53a106364dbd0a1b$exports = {};
//
$53a106364dbd0a1b$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $783faa7ec18221fc$export$71ad59f2e432cfe8 = "-ms-";
var $783faa7ec18221fc$export$2c0f367103c8d01c = "-moz-";
var $783faa7ec18221fc$export$39dfd62a25e0fe93 = "-webkit-";
var $783faa7ec18221fc$export$a29989082612d0d9 = "comm";
var $783faa7ec18221fc$export$aa3a2e812ca8570d = "rule";
var $783faa7ec18221fc$export$527d108ccf083c2b = "decl";
var $783faa7ec18221fc$export$d3d35020fa5b54f0 = "@page";
var $783faa7ec18221fc$export$500415a86c544f73 = "@media";
var $783faa7ec18221fc$export$a763edbf796b780a = "@import";
var $783faa7ec18221fc$export$2790aeb8b4e5c826 = "@charset";
var $783faa7ec18221fc$export$1cc683e23b84b133 = "@viewport";
var $783faa7ec18221fc$export$9447a5efea57e862 = "@supports";
var $783faa7ec18221fc$export$ef011b4e114b1fba = "@document";
var $783faa7ec18221fc$export$6aad947bda0f3f46 = "@namespace";
var $783faa7ec18221fc$export$b44a8529a35fcb60 = "@keyframes";
var $783faa7ec18221fc$export$2c16de31893252e6 = "@font-face";
var $783faa7ec18221fc$export$3d846dd52e150c6f = "@counter-style";
var $783faa7ec18221fc$export$22314bfbb57653fe = "@font-feature-values";
var $783faa7ec18221fc$export$d773506282b3cfe6 = "@layer";
var $783faa7ec18221fc$export$1c5a554c78c0cd12 = "@scope";
var $783faa7ec18221fc$export$2335f513bbd82c6d = Math.abs;
var $783faa7ec18221fc$export$6788812c4e6611e6 = String.fromCharCode;
var $783faa7ec18221fc$export$e6e34fd1f2686227 = Object.assign;
function $783faa7ec18221fc$export$d6af199866bfb566(e, r) {
    return $783faa7ec18221fc$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 0)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 1)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 2)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 3) : 0;
}
function $783faa7ec18221fc$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $783faa7ec18221fc$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $783faa7ec18221fc$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $783faa7ec18221fc$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $783faa7ec18221fc$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $783faa7ec18221fc$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $783faa7ec18221fc$export$36776f635604f274(e) {
    return e.length;
}
function $783faa7ec18221fc$export$f9084667e487ed46(e) {
    return e.length;
}
function $783faa7ec18221fc$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $783faa7ec18221fc$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $783faa7ec18221fc$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$783faa7ec18221fc$export$4659b591c19bdf3d(e, r);
    });
}
var $783faa7ec18221fc$export$53f1d5ea8de3d7c = 1;
var $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1;
var $783faa7ec18221fc$export$f24224f1c91d8156 = 0;
var $783faa7ec18221fc$export$5880b8b5730aff45 = 0;
var $783faa7ec18221fc$export$c0306caf338ac095 = 0;
var $783faa7ec18221fc$export$30a86d91af8ff6e6 = "";
function $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $783faa7ec18221fc$export$53f1d5ea8de3d7c,
        column: $783faa7ec18221fc$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $783faa7ec18221fc$export$784d13d8ee351f07(e, r) {
    return $783faa7ec18221fc$export$e6e34fd1f2686227($783faa7ec18221fc$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $783faa7ec18221fc$export$590e8b2c435046d9(e) {
    while(e.root)e = $783faa7ec18221fc$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $783faa7ec18221fc$export$10d8903dec122b9d(e, e.siblings);
}
function $783faa7ec18221fc$export$eba6f6f03b0a92e7() {
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$232faf9add678146() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 > 0 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, --$783faa7ec18221fc$export$5880b8b5730aff45) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3--, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c--;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$48cfd1e771a65c4f() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 < $783faa7ec18221fc$export$f24224f1c91d8156 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45++) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3++, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c++;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$4d3fb11e950abb9e() {
    return $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$e88cb2efb12ae807() {
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$58adb3bec8346d0f(e, r) {
    return $783faa7ec18221fc$export$2f35ab04d2335697($783faa7ec18221fc$export$30a86d91af8ff6e6, e, r);
}
function $783faa7ec18221fc$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $783faa7ec18221fc$export$2de70f21292aac9e(e) {
    return $783faa7ec18221fc$export$53f1d5ea8de3d7c = $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$f24224f1c91d8156 = $783faa7ec18221fc$export$36776f635604f274($783faa7ec18221fc$export$30a86d91af8ff6e6 = e), $783faa7ec18221fc$export$5880b8b5730aff45 = 0, [];
}
function $783faa7ec18221fc$export$45918ac1574455b1(e) {
    return $783faa7ec18221fc$export$30a86d91af8ff6e6 = "", e;
}
function $783faa7ec18221fc$export$410ac95b9ec204b8(e) {
    return $783faa7ec18221fc$export$87c2784dc9fc4ab($783faa7ec18221fc$export$58adb3bec8346d0f($783faa7ec18221fc$export$5880b8b5730aff45 - 1, $783faa7ec18221fc$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $783faa7ec18221fc$export$660b2ee2d4fb4eff(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$5f8c09e3ae6f64e1($783faa7ec18221fc$export$2de70f21292aac9e(e)));
}
function $783faa7ec18221fc$export$7af1228ff777d175(e) {
    while($783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$4d3fb11e950abb9e())if ($783faa7ec18221fc$export$c0306caf338ac095 < 33) $783faa7ec18221fc$export$48cfd1e771a65c4f();
    else break;
    return $783faa7ec18221fc$export$9e1725a4cfeada27(e) > 2 || $783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $783faa7ec18221fc$export$5f8c09e3ae6f64e1(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095)){
        case 0:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$c0306caf338ac095), e);
            break;
        default:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$c0306caf338ac095), e);
    }
    return e;
}
function $783faa7ec18221fc$export$955ba06d119e085e(e, r) {
    while(--r && $783faa7ec18221fc$export$48cfd1e771a65c4f())if ($783faa7ec18221fc$export$c0306caf338ac095 < 48 || $783faa7ec18221fc$export$c0306caf338ac095 > 102 || $783faa7ec18221fc$export$c0306caf338ac095 > 57 && $783faa7ec18221fc$export$c0306caf338ac095 < 65 || $783faa7ec18221fc$export$c0306caf338ac095 > 70 && $783faa7ec18221fc$export$c0306caf338ac095 < 97) break;
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$e88cb2efb12ae807() + (r < 6 && $783faa7ec18221fc$export$4d3fb11e950abb9e() == 32 && $783faa7ec18221fc$export$48cfd1e771a65c4f() == 32));
}
function $783faa7ec18221fc$export$c889f2fcc19dbf12(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$c0306caf338ac095){
        case e:
            return $783faa7ec18221fc$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $783faa7ec18221fc$export$c889f2fcc19dbf12($783faa7ec18221fc$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $783faa7ec18221fc$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $783faa7ec18221fc$export$48cfd1e771a65c4f();
            break;
    }
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$4254d4e2b3745c4c(e, r) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 57) break;
    else if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 84 && $783faa7ec18221fc$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $783faa7ec18221fc$export$58adb3bec8346d0f(r, $783faa7ec18221fc$export$5880b8b5730aff45 - 1) + "*" + $783faa7ec18221fc$export$6788812c4e6611e6(e === 47 ? e : $783faa7ec18221fc$export$48cfd1e771a65c4f());
}
function $783faa7ec18221fc$export$c2ab62c7bf24634(e) {
    while(!$783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$4d3fb11e950abb9e()))$783faa7ec18221fc$export$48cfd1e771a65c4f();
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$ef7acd7185315e22(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $783faa7ec18221fc$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $783faa7ec18221fc$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $783faa7ec18221fc$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $783faa7ec18221fc$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($783faa7ec18221fc$export$f8e21b1e77979a08(z += $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $783faa7ec18221fc$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $783faa7ec18221fc$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $783faa7ec18221fc$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $783faa7ec18221fc$export$955ba06d119e085e($783faa7ec18221fc$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($783faa7ec18221fc$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$4a34f930e789283c($783faa7ec18221fc$export$4254d4e2b3745c4c($783faa7ec18221fc$export$48cfd1e771a65c4f(), $783faa7ec18221fc$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $783faa7ec18221fc$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $783faa7ec18221fc$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $783faa7ec18221fc$export$36776f635604f274(z) - l) $783faa7ec18221fc$export$10d8903dec122b9d(p > 32 ? $783faa7ec18221fc$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $783faa7ec18221fc$export$f8483753829ec8f3($783faa7ec18221fc$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $783faa7ec18221fc$export$10d8903dec122b9d(j = $783faa7ec18221fc$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $783faa7ec18221fc$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $783faa7ec18221fc$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $783faa7ec18221fc$export$98e6a39c04603d36(e, j, j, n && $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $783faa7ec18221fc$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $783faa7ec18221fc$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $783faa7ec18221fc$export$232faf9add678146() == 125) continue;
            }
            switch(z += $783faa7ec18221fc$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($783faa7ec18221fc$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($783faa7ec18221fc$export$4d3fb11e950abb9e() === 45) z += $783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$48cfd1e771a65c4f());
                    v = $783faa7ec18221fc$export$4d3fb11e950abb9e(), o = l = $783faa7ec18221fc$export$36776f635604f274(k = z += $783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $783faa7ec18221fc$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $783faa7ec18221fc$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $783faa7ec18221fc$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $783faa7ec18221fc$export$2f35ab04d2335697(e, p + 1, p = $783faa7ec18221fc$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $783faa7ec18221fc$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $783faa7ec18221fc$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, s === 0 ? $783faa7ec18221fc$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $783faa7ec18221fc$export$4a34f930e789283c(e, r, a, c) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$a29989082612d0d9, $783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$eba6f6f03b0a92e7()), $783faa7ec18221fc$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $783faa7ec18221fc$export$f8483753829ec8f3(e, r, a, n, c) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$527d108ccf083c2b, $783faa7ec18221fc$export$2f35ab04d2335697(e, 0, n), $783faa7ec18221fc$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $783faa7ec18221fc$export$82e9f45cca5ba907(n, c, s) {
    switch($783faa7ec18221fc$export$d6af199866bfb566(n, c)){
        case 5103:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $783faa7ec18221fc$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$2c0f367103c8d01c + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-$1$2" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-item-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-line-pack" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-grow", "") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-pack:$3" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-column-align" + $783faa7ec18221fc$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$783faa7ec18221fc$export$f8e21b1e77979a08(s, "span", 0) ? $783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) : +$783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) - +$783faa7ec18221fc$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($783faa7ec18221fc$export$36776f635604f274(n) - 1 - c > 6) switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $783faa7ec18221fc$export$2c0f367103c8d01c + ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n, "stretch", 0) ? $783faa7ec18221fc$export$82e9f45cca5ba907($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 6) === 121) return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, $783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + ($783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $783faa7ec18221fc$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $783faa7ec18221fc$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $783faa7ec18221fc$export$a763edbf796b780a:
        case $783faa7ec18221fc$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $783faa7ec18221fc$export$a29989082612d0d9:
            return "";
        case $783faa7ec18221fc$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            if (!$783faa7ec18221fc$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $783faa7ec18221fc$export$36776f635604f274(a = $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $783faa7ec18221fc$export$5a7767152ae0305f(e) {
    var r = $783faa7ec18221fc$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $783faa7ec18221fc$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $783faa7ec18221fc$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $783faa7ec18221fc$export$527d108ccf083c2b:
                n.return = $783faa7ec18221fc$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $783faa7ec18221fc$export$b44a8529a35fcb60:
                return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                    $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                        value: $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $783faa7ec18221fc$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $783faa7ec18221fc$export$aa3a2e812ca8570d:
                if (n.length) return $783faa7ec18221fc$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($783faa7ec18221fc$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $783faa7ec18221fc$export$e6e34fd1f2686227(n, {
                                props: $783faa7ec18221fc$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $783faa7ec18221fc$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $783faa7ec18221fc$export$e6e34fd1f2686227(n, {
                                props: $783faa7ec18221fc$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $783faa7ec18221fc$export$76a88f7de6507443(e) {
    switch(e.type){
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $783faa7ec18221fc$export$1be1fc439b849fdf($783faa7ec18221fc$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($783faa7ec18221fc$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $783faa7ec18221fc$export$2f35ab04d2335697(r, 1, $783faa7ec18221fc$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $783faa7ec18221fc$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $783faa7ec18221fc$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $783faa7ec18221fc$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $78b52bced097bc64$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $391299e0893a3dfa$exports = {};
// shim for using process in browser
var $391299e0893a3dfa$var$process = $391299e0893a3dfa$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};


var $e484c752f3f06549$var$f = ("undefined" != typeof $391299e0893a3dfa$exports && void 0 !== $391299e0893a3dfa$exports.env && undefined, "data-styled"), $e484c752f3f06549$var$m = "active", $e484c752f3f06549$var$y = "data-styled-version", $e484c752f3f06549$export$83d89fbfd8236492 = "6.1.13", $e484c752f3f06549$var$g = "/*!sc*/\n", $e484c752f3f06549$var$S = "undefined" != typeof window && "HTMLElement" in window, $e484c752f3f06549$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $391299e0893a3dfa$exports && $391299e0893a3dfa$exports.env, "undefined" != typeof $391299e0893a3dfa$exports && $391299e0893a3dfa$exports.env, false)), $e484c752f3f06549$var$b = {}, $e484c752f3f06549$var$E = /invalid hook call/i, $e484c752f3f06549$var$N = new Set, $e484c752f3f06549$var$P = function(t, n) {
    var o, s, i, a, e;
}, $e484c752f3f06549$var$_ = Object.freeze([]), $e484c752f3f06549$var$C = Object.freeze({});
function $e484c752f3f06549$var$I(e, t, n) {
    return void 0 === n && (n = $e484c752f3f06549$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $e484c752f3f06549$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $e484c752f3f06549$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $e484c752f3f06549$var$D = /(^-|-$)/g;
function $e484c752f3f06549$var$R(e) {
    return e.replace($e484c752f3f06549$var$O, "-").replace($e484c752f3f06549$var$D, "");
}
var $e484c752f3f06549$var$T = /(a)(d)/gi, $e484c752f3f06549$var$k = 52, $e484c752f3f06549$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $e484c752f3f06549$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $e484c752f3f06549$var$k; t = t / $e484c752f3f06549$var$k | 0)n = $e484c752f3f06549$var$j(t % $e484c752f3f06549$var$k) + n;
    return ($e484c752f3f06549$var$j(t % $e484c752f3f06549$var$k) + n).replace($e484c752f3f06549$var$T, "$1-$2");
}
var $e484c752f3f06549$var$V, $e484c752f3f06549$var$F = 5381, $e484c752f3f06549$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $e484c752f3f06549$var$z = function(e) {
    return $e484c752f3f06549$var$M($e484c752f3f06549$var$F, e);
};
function $e484c752f3f06549$var$$(e) {
    return $e484c752f3f06549$var$x($e484c752f3f06549$var$z(e) >>> 0);
}
function $e484c752f3f06549$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $e484c752f3f06549$var$L(e) {
    return "string" == typeof e && true;
}
var $e484c752f3f06549$var$G = "function" == typeof Symbol && Symbol.for, $e484c752f3f06549$var$Y = $e484c752f3f06549$var$G ? Symbol.for("react.memo") : 60115, $e484c752f3f06549$var$W = $e484c752f3f06549$var$G ? Symbol.for("react.forward_ref") : 60112, $e484c752f3f06549$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $e484c752f3f06549$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $e484c752f3f06549$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $e484c752f3f06549$var$J = (($e484c752f3f06549$var$V = {})[$e484c752f3f06549$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $e484c752f3f06549$var$V[$e484c752f3f06549$var$Y] = $e484c752f3f06549$var$U, $e484c752f3f06549$var$V);
function $e484c752f3f06549$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $e484c752f3f06549$var$Y ? $e484c752f3f06549$var$U : "$$typeof" in e ? $e484c752f3f06549$var$J[e.$$typeof] : $e484c752f3f06549$var$q;
}
var $e484c752f3f06549$var$Z = Object.defineProperty, $e484c752f3f06549$var$K = Object.getOwnPropertyNames, $e484c752f3f06549$var$Q = Object.getOwnPropertySymbols, $e484c752f3f06549$var$ee = Object.getOwnPropertyDescriptor, $e484c752f3f06549$var$te = Object.getPrototypeOf, $e484c752f3f06549$var$ne = Object.prototype;
function $e484c752f3f06549$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($e484c752f3f06549$var$ne) {
            var o = $e484c752f3f06549$var$te(t);
            o && o !== $e484c752f3f06549$var$ne && $e484c752f3f06549$var$oe(e, o, n);
        }
        var r = $e484c752f3f06549$var$K(t);
        $e484c752f3f06549$var$Q && (r = r.concat($e484c752f3f06549$var$Q(t)));
        for(var s = $e484c752f3f06549$var$X(e), i = $e484c752f3f06549$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $e484c752f3f06549$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $e484c752f3f06549$var$ee(t, c);
                try {
                    $e484c752f3f06549$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $e484c752f3f06549$var$re(e) {
    return "function" == typeof e;
}
function $e484c752f3f06549$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $e484c752f3f06549$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $e484c752f3f06549$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $e484c752f3f06549$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $e484c752f3f06549$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$e484c752f3f06549$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $e484c752f3f06549$var$le(e[o], t[o]);
    else if ($e484c752f3f06549$var$ce(t)) for(var o in t)e[o] = $e484c752f3f06549$var$le(e[o], t[o]);
    return e;
}
function $e484c752f3f06549$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $e484c752f3f06549$var$pe = {};
function $e484c752f3f06549$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $e484c752f3f06549$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $e484c752f3f06549$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $e484c752f3f06549$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($e484c752f3f06549$var$g);
        return t;
    }, e;
}(), $e484c752f3f06549$var$me = 1073741824, $e484c752f3f06549$var$ye = new Map, $e484c752f3f06549$var$ve = new Map, $e484c752f3f06549$var$ge = 1, $e484c752f3f06549$var$Se = function(e) {
    if ($e484c752f3f06549$var$ye.has(e)) return $e484c752f3f06549$var$ye.get(e);
    for(; $e484c752f3f06549$var$ve.has($e484c752f3f06549$var$ge);)$e484c752f3f06549$var$ge++;
    var t = $e484c752f3f06549$var$ge++;
    return $e484c752f3f06549$var$ye.set(e, t), $e484c752f3f06549$var$ve.set(t, e), t;
}, $e484c752f3f06549$var$we = function(e, t) {
    $e484c752f3f06549$var$ge = t + 1, $e484c752f3f06549$var$ye.set(e, t), $e484c752f3f06549$var$ve.set(t, e);
}, $e484c752f3f06549$var$be = "style[".concat($e484c752f3f06549$var$f, "][").concat($e484c752f3f06549$var$y, '="').concat($e484c752f3f06549$export$83d89fbfd8236492, '"]'), $e484c752f3f06549$var$Ee = new RegExp("^".concat($e484c752f3f06549$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $e484c752f3f06549$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $e484c752f3f06549$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($e484c752f3f06549$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($e484c752f3f06549$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($e484c752f3f06549$var$we(u, l), $e484c752f3f06549$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $e484c752f3f06549$var$_e = function(e) {
    for(var t = document.querySelectorAll($e484c752f3f06549$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($e484c752f3f06549$var$f) !== $e484c752f3f06549$var$m && ($e484c752f3f06549$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $e484c752f3f06549$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $e484c752f3f06549$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($e484c752f3f06549$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($e484c752f3f06549$var$f, $e484c752f3f06549$var$m), o.setAttribute($e484c752f3f06549$var$y, $e484c752f3f06549$export$83d89fbfd8236492);
    var i = $e484c752f3f06549$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $e484c752f3f06549$var$Ae = function() {
    function e(e) {
        this.element = $e484c752f3f06549$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $e484c752f3f06549$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $e484c752f3f06549$var$Oe = function() {
    function e(e) {
        this.element = $e484c752f3f06549$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $e484c752f3f06549$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $e484c752f3f06549$var$Re = $e484c752f3f06549$var$S, $e484c752f3f06549$var$Te = {
    isServer: !$e484c752f3f06549$var$S,
    useCSSOMInjection: !$e484c752f3f06549$var$w
}, $e484c752f3f06549$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $e484c752f3f06549$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, $e484c752f3f06549$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $e484c752f3f06549$var$S && $e484c752f3f06549$var$Re && ($e484c752f3f06549$var$Re = !1, $e484c752f3f06549$var$_e(this)), $e484c752f3f06549$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $e484c752f3f06549$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($e484c752f3f06549$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($e484c752f3f06549$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $e484c752f3f06549$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $e484c752f3f06549$var$S && $e484c752f3f06549$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $e484c752f3f06549$var$De(n) : t ? new $e484c752f3f06549$var$Ae(n) : new $e484c752f3f06549$var$Oe(n);
        }(this.options), new $e484c752f3f06549$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($e484c752f3f06549$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($e484c752f3f06549$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($e484c752f3f06549$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $e484c752f3f06549$var$je = /&/g, $e484c752f3f06549$var$xe = /^\s*\/\/.*$/gm;
function $e484c752f3f06549$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $e484c752f3f06549$var$Ve(e.children, t)), e;
    });
}
function $e484c752f3f06549$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $e484c752f3f06549$var$C : e, s = r.options, i = void 0 === s ? $e484c752f3f06549$var$C : s, a = r.plugins, c = void 0 === a ? $e484c752f3f06549$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $783faa7ec18221fc$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($e484c752f3f06549$var$je, n).replace(o, l));
    }), i.prefix && u.push($783faa7ec18221fc$export$e08c7d021b829b7a), u.push($783faa7ec18221fc$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($e484c752f3f06549$var$xe, ""), l = $783faa7ec18221fc$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $e484c752f3f06549$var$Ve(l, i.namespace));
        var p = [];
        return $783faa7ec18221fc$export$dfdc1655ccc5b9cb(l, $783faa7ec18221fc$export$5a7767152ae0305f(u.concat($783faa7ec18221fc$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $e484c752f3f06549$var$he(15), $e484c752f3f06549$var$M(e, t.name);
    }, $e484c752f3f06549$var$F).toString() : "", p;
}
var $e484c752f3f06549$var$Me = new $e484c752f3f06549$var$ke, $e484c752f3f06549$var$ze = $e484c752f3f06549$var$Fe(), $e484c752f3f06549$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $e484c752f3f06549$var$Me,
    stylis: $e484c752f3f06549$var$ze
}), $e484c752f3f06549$export$91317688fc694efa = $e484c752f3f06549$export$8c190ef828af4c86.Consumer, $e484c752f3f06549$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(void 0);
function $e484c752f3f06549$var$Ge() {
    return (0, $bh6RR.useContext)($e484c752f3f06549$export$8c190ef828af4c86);
}
function $e484c752f3f06549$export$a473771da2f0ff7c(e) {
    var t = (0, $bh6RR.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $e484c752f3f06549$var$Ge().styleSheet, l = (0, $bh6RR.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $bh6RR.useMemo)(function() {
        return $e484c752f3f06549$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $bh6RR.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($53a106364dbd0a1b$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $bh6RR.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$var$Le.Provider, {
        value: u
    }, e.children));
}
var $e484c752f3f06549$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $e484c752f3f06549$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $e484c752f3f06549$var$ue(this, function() {
            throw $e484c752f3f06549$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $e484c752f3f06549$var$ze), this.name + e.hash;
    }, e;
}(), $e484c752f3f06549$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $e484c752f3f06549$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $e484c752f3f06549$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $e484c752f3f06549$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $e484c752f3f06549$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$e484c752f3f06549$var$Ue(i) && (Array.isArray(i) && i.isCss || $e484c752f3f06549$var$re(i) ? r.push("".concat($e484c752f3f06549$var$He(s), ":"), i, ";") : $e484c752f3f06549$var$ce(i) ? r.push.apply(r, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)((0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $e484c752f3f06549$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($e484c752f3f06549$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $78b52bced097bc64$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $e484c752f3f06549$var$Xe(e, t, n, o) {
    if ($e484c752f3f06549$var$Ue(e)) return [];
    if ($e484c752f3f06549$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($e484c752f3f06549$var$re(e)) {
        if (!$e484c752f3f06549$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $e484c752f3f06549$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $e484c752f3f06549$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $e484c752f3f06549$var$ce(e) ? $e484c752f3f06549$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($e484c752f3f06549$var$_, e.map(function(e) {
        return $e484c752f3f06549$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $e484c752f3f06549$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($e484c752f3f06549$var$re(n) && !$e484c752f3f06549$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $e484c752f3f06549$var$Ke = $e484c752f3f06549$var$z($e484c752f3f06549$export$83d89fbfd8236492), $e484c752f3f06549$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $e484c752f3f06549$var$Ze(e), this.componentId = t, this.baseHash = $e484c752f3f06549$var$M($e484c752f3f06549$var$Ke, t), this.baseStyle = n, $e484c752f3f06549$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $e484c752f3f06549$var$ie(o, this.staticRulesId);
            else {
                var r = $e484c752f3f06549$var$ae($e484c752f3f06549$var$Xe(this.rules, e, t, n)), s = $e484c752f3f06549$var$x($e484c752f3f06549$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $e484c752f3f06549$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $e484c752f3f06549$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $e484c752f3f06549$var$ae($e484c752f3f06549$var$Xe(u, e, t, n));
                    a = $e484c752f3f06549$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $e484c752f3f06549$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $e484c752f3f06549$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $e484c752f3f06549$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(void 0), $e484c752f3f06549$export$b631efc24e9d5e2f = $e484c752f3f06549$export$2c657da244d00bd6.Consumer;
function $e484c752f3f06549$export$93d4e7f90805808f() {
    var e = (0, $bh6RR.useContext)($e484c752f3f06549$export$2c657da244d00bd6);
    if (!e) throw $e484c752f3f06549$var$he(18);
    return e;
}
function $e484c752f3f06549$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), r = (0, $bh6RR.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $e484c752f3f06549$var$he(14);
            if ($e484c752f3f06549$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $e484c752f3f06549$var$he(8);
            return n ? (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $e484c752f3f06549$var$rt = {}, $e484c752f3f06549$var$st = new Set;
function $e484c752f3f06549$var$it(e, r, s) {
    var i = $e484c752f3f06549$export$7ba318d8d2f06c76(e), a = e, c = !$e484c752f3f06549$var$L(e), p = r.attrs, d = void 0 === p ? $e484c752f3f06549$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $e484c752f3f06549$var$R(e);
        $e484c752f3f06549$var$rt[n] = ($e484c752f3f06549$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($e484c752f3f06549$var$$($e484c752f3f06549$export$83d89fbfd8236492 + n + $e484c752f3f06549$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $e484c752f3f06549$var$L(e) ? "styled.".concat(e) : "Styled(".concat($e484c752f3f06549$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($e484c752f3f06549$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $e484c752f3f06549$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), m = $e484c752f3f06549$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $e484c752f3f06549$var$I(r, f, c) || $e484c752f3f06549$var$C, g = function(e, n, o) {
                for(var r, s = (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $e484c752f3f06549$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $e484c752f3f06549$var$ie(s[c], a[c]) : "style" === c ? (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $e484c752f3f06549$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $e484c752f3f06549$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $e484c752f3f06549$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$e484c752f3f06549$var$L(S) && !$e484c752f3f06549$var$A.has(S) ? "class" : "className"] = N, w.ref = s, (0, $bh6RR.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $e484c752f3f06549$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$e484c752f3f06549$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $e484c752f3f06549$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $e484c752f3f06549$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $e484c752f3f06549$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $e484c752f3f06549$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $e484c752f3f06549$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($e484c752f3f06549$var$re(t) || $e484c752f3f06549$var$ce(t)) return $e484c752f3f06549$var$ct($e484c752f3f06549$var$Xe($e484c752f3f06549$var$at($e484c752f3f06549$var$_, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $e484c752f3f06549$var$Xe(r) : $e484c752f3f06549$var$ct($e484c752f3f06549$var$Xe($e484c752f3f06549$var$at(r, n)));
}
function $e484c752f3f06549$var$ut(n, o, r) {
    if (void 0 === r && (r = $e484c752f3f06549$var$C), !o) throw $e484c752f3f06549$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $e484c752f3f06549$var$ut(n, o, (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $e484c752f3f06549$var$ut(n, o, (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $e484c752f3f06549$var$pt = function(e) {
    return $e484c752f3f06549$var$ut($e484c752f3f06549$var$it, e);
}, $e484c752f3f06549$export$2e2bcd8739ae039 = $e484c752f3f06549$var$pt;
$e484c752f3f06549$var$A.forEach(function(e) {
    $e484c752f3f06549$export$2e2bcd8739ae039[e] = $e484c752f3f06549$var$pt(e);
});
var $e484c752f3f06549$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $e484c752f3f06549$var$Ze(e), $e484c752f3f06549$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($e484c752f3f06549$var$ae($e484c752f3f06549$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $e484c752f3f06549$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $e484c752f3f06549$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($e484c752f3f06549$var$$(JSON.stringify(i))), c = new $e484c752f3f06549$var$ht(i, a);
    var l = function(e) {
        var t = $e484c752f3f06549$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $e484c752f3f06549$var$b, o, s);
        else {
            var i = (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)((0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, n), {
                theme: $e484c752f3f06549$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(l);
}
function $e484c752f3f06549$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $e484c752f3f06549$var$ae($e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $5606419dfe2e9b1b$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $e484c752f3f06549$var$$(r);
    return new $e484c752f3f06549$var$We(s, r);
}
function $e484c752f3f06549$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(function(n, r) {
        var s = $e484c752f3f06549$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(e, (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($e484c752f3f06549$var$B(e), ")"), $e484c752f3f06549$var$oe(n, e);
}
var $e484c752f3f06549$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $e484c752f3f06549$var$Ce(), o = $e484c752f3f06549$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($e484c752f3f06549$var$f, '="true"'),
                "".concat($e484c752f3f06549$var$y, '="').concat($e484c752f3f06549$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $e484c752f3f06549$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $e484c752f3f06549$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$e484c752f3f06549$var$f] = "", n[$e484c752f3f06549$var$y] = $e484c752f3f06549$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $e484c752f3f06549$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("style", (0, $5606419dfe2e9b1b$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $e484c752f3f06549$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $e484c752f3f06549$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $e484c752f3f06549$var$he(3);
    }, e;
}(), $e484c752f3f06549$export$5c87cfe6c475f500 = {
    StyleSheet: $e484c752f3f06549$var$ke,
    mainSheet: $e484c752f3f06549$var$Me
};
var $e484c752f3f06549$var$St = "__sc-".concat($e484c752f3f06549$var$f, "__");


// Such export is called Tree Shaking. It allows to import only the components
// that are needed while webpack will remove the rest of the code from the bundle.
const $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c = "#4fa94d";
const $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18 = {
    "aria-busy": true,
    role: "progressbar"
};
const $d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56 = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div`
  display: ${(props)=>props.$visible ? "flex" : "none"};
`;
const $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c = "http://www.w3.org/2000/svg";
const $d7a2f601d92a963f$export$153755f98d9861de = ({ height: height = "100", width: width = "100", color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "audio-loading", wrapperStyle: wrapperStyle = {}, wrapperClass: wrapperClass, visible: visible = true })=>(0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        $visible: visible,
        style: {
            ...wrapperStyle
        },
        className: wrapperClass,
        "data-testid": "audio-loading",
        "aria-label": ariaLabel,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
            height: `${height}`,
            width: `${width}`,
            fill: color,
            viewBox: "0 0 55 80",
            xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "audio-svg",
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("title", {
                    children: "Audio Visualization"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("desc", {
                    children: "Animated representation of audio data"
                }),
                (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                    transform: "matrix(1 0 0 -1 0 80)",
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                            width: "10",
                            height: "20",
                            rx: "3",
                            children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "4.3s",
                                values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                            x: "15",
                            width: "10",
                            height: "80",
                            rx: "3",
                            children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "80;55;33;5;75;23;73;33;12;14;60;80",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                            x: "30",
                            width: "10",
                            height: "50",
                            rx: "3",
                            children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "1.4s",
                                values: "50;34;78;23;56;23;34;76;80;54;21;50",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                            x: "45",
                            width: "10",
                            height: "30",
                            rx: "3",
                            children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "30;45;13;80;56;72;45;76;34;23;67;30",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            ]
        })
    });
const $d7a2f601d92a963f$export$68949ad0373623af = ({ height: height = 100, width: width = 100, radius: radius = 5, color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "ball-triangle-loading", wrapperClass: wrapperClass, wrapperStyle: wrapperStyle, visible: visible = true })=>(0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: {
            ...wrapperStyle
        },
        $visible: visible,
        className: wrapperClass,
        "data-testid": "ball-triangle-loading",
        "aria-label": ariaLabel,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
            height: height,
            width: width,
            stroke: color,
            viewBox: "0 0 57 57",
            xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "ball-triangle-svg",
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("title", {
                    children: "Ball Triangle"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("desc", {
                    children: "Animated representation of three balls"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                        transform: "translate(1 1)",
                        strokeWidth: "2",
                        children: [
                            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                                cx: "5",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;5;50;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "5;27;49;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                                cx: "27",
                                cy: "5",
                                r: radius,
                                children: [
                                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "5",
                                        to: "5",
                                        values: "5;50;50;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "27",
                                        to: "27",
                                        values: "27;49;5;27",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                                cx: "49",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;50;5;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        from: "49",
                                        to: "49",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "49;5;27;49",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
const $d7a2f601d92a963f$export$fbc7d6f7dd821b47 = ({ height: height = 80, width: width = 80, color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "bars-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        $visible: visible,
        style: {
            ...wrapperStyle
        },
        className: wrapperClass,
        "data-testid": "bars-loading",
        "aria-label": ariaLabel,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
            width: width,
            height: height,
            fill: color,
            viewBox: "0 0 135 140",
            xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "bars-svg",
            children: [
                (0, $d4dab640dcbe486c$exports.jsxs)("rect", {
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $d4dab640dcbe486c$exports.jsxs)("rect", {
                    x: "30",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $d4dab640dcbe486c$exports.jsxs)("rect", {
                    x: "60",
                    width: "15",
                    height: "140",
                    rx: "6",
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $d4dab640dcbe486c$exports.jsxs)("rect", {
                    x: "90",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $d4dab640dcbe486c$exports.jsxs)("rect", {
                    x: "120",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
const $d7a2f601d92a963f$export$765808835a2dc0a2 = ({ height: height = 80, width: width = 80, color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "circles-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "circles-loading",
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 135 135",
            xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "circles-svg",
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("title", {
                    children: "circles-loading"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("desc", {
                    children: "Animated representation of circles"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z",
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "-360 67 67",
                        dur: "2.5s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z",
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "360 67 67",
                        dur: "8s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $d7a2f601d92a963f$export$17c11650828d97e = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, outerCircleColor: outerCircleColor, innerCircleColor: innerCircleColor, barColor: barColor, ariaLabel: ariaLabel = "circles-with-bar-loading" })=>{
    return (0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        "data-testid": "circles-with-bar-wrapper",
        children: (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
            version: "1.1",
            id: "L1",
            xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            height: `${height}`,
            width: `${width}`,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "circles-with-bar-svg",
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("title", {
                    children: "circles-with-bar-loading"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("desc", {
                    children: "Animated representation of circles with bar"
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    fill: "none",
                    stroke: `${outerCircleColor || color}`,
                    strokeWidth: "6",
                    strokeMiterlimit: "15",
                    strokeDasharray: "14.2472,14.2472",
                    cx: "50",
                    cy: "50",
                    r: "47",
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    fill: "none",
                    stroke: `${innerCircleColor || color}`,
                    strokeWidth: "1",
                    strokeMiterlimit: "10",
                    strokeDasharray: "10,10",
                    cx: "50",
                    cy: "50",
                    r: "39",
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                    fill: `${barColor || color}`,
                    "data-testid": "circles-with-bar-svg-bar",
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                            x: "30",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                            x: "40",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                            x: "50",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                            x: "60",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.4"
                            })
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                            x: "70",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.5"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $d7a2f601d92a963f$export$ef2184bd89960b14 = ({ height: height = 80, width: width = 80, radius: radius = 12.5, color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "grid-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "grid-loading",
        "aria-label": ariaLabel,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 105 105",
            fill: color,
            "data-testid": "grid-svg",
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "100ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "300ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "600ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "800ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "400ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "700ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "500ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "200ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $d7a2f601d92a963f$export$2da2f0c7403af3ce = ({ height: height = 80, width: width = 80, color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "hearts-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "hearts-loading",
        "aria-label": ariaLabel,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 140 64",
            xmlns: "http://www.w3.org/2000/svg",
            fill: color,
            "data-testid": "hearts-svg",
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.717-6.002 11.47-7.65 17.305-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.592-2.32 17.307 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0.7s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"
                })
            ]
        })
    });
const $d7a2f601d92a963f$var$$ad60b992c945fdb5$var$len = 242.776657104492;
const $d7a2f601d92a963f$var$$ad60b992c945fdb5$var$time = 1.6;
const $d7a2f601d92a963f$var$$ad60b992c945fdb5$var$anim = (0, $e484c752f3f06549$export$d25ddfdf17c3ad3e)`
12.5% {
  stroke-dasharray: ${$d7a2f601d92a963f$var$$ad60b992c945fdb5$var$len * 0.14}px, ${$d7a2f601d92a963f$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$d7a2f601d92a963f$var$$ad60b992c945fdb5$var$len * 0.11}px;
}
43.75% {
  stroke-dasharray: ${$d7a2f601d92a963f$var$$ad60b992c945fdb5$var$len * 0.35}px, ${$d7a2f601d92a963f$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$d7a2f601d92a963f$var$$ad60b992c945fdb5$var$len * 0.35}px;
}
100% {
  stroke-dasharray: ${$d7a2f601d92a963f$var$$ad60b992c945fdb5$var$len * 0.01}px, ${$d7a2f601d92a963f$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$d7a2f601d92a963f$var$$ad60b992c945fdb5$var$len * 0.99}px;
}
`;
const $d7a2f601d92a963f$var$$ad60b992c945fdb5$var$Path = (0, $e484c752f3f06549$export$2e2bcd8739ae039).path`
  stroke-dasharray: ${$d7a2f601d92a963f$var$$ad60b992c945fdb5$var$len * 0.01}px, ${$d7a2f601d92a963f$var$$ad60b992c945fdb5$var$len};
  stroke-dashoffset: 0;
  animation: ${$d7a2f601d92a963f$var$$ad60b992c945fdb5$var$anim} ${$d7a2f601d92a963f$var$$ad60b992c945fdb5$var$time}s linear infinite;
`;
const $d7a2f601d92a963f$export$8009d4483dfda42 = ({ color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, width: width = "200" })=>{
    return (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: `${width}`,
        height: `${Number(width) * 0.5}`,
        viewBox: `0 0 ${width} ${Number(100)}`,
        "data-testid": "infinity-spin",
        children: [
            (0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$ad60b992c945fdb5$var$Path, {
                "data-testid": "infinity-spin-path-1",
                stroke: color,
                fill: "none",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                "data-testid": "infinity-spin-path-2",
                opacity: "0.07",
                fill: "none",
                stroke: color,
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            })
        ]
    });
};
const $d7a2f601d92a963f$export$d2101d81f63866ab = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "line-wave-loading", firstLineColor: firstLineColor, middleLineColor: middleLineColor, lastLineColor: lastLineColor })=>{
    return (0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "line-wave-wrapper",
        "aria-label": ariaLabel,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
            version: "1.1",
            height: `${height}`,
            width: `${width}`,
            xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 0 0",
            xmlSpace: "preserve",
            "data-testid": "line-wave-svg",
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                    x: "20",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: firstLineColor || color,
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                    x: "30",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: middleLineColor || color,
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.2s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                    x: "40",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: lastLineColor || color,
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.4s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
};
const $d7a2f601d92a963f$export$64ea884904791f4 = ({ height: height = 90, width: width = 80, radius: radius = 12.5, color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "mutating-dots-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "mutating-dots-loading",
        "aria-label": ariaLabel,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
            id: "goo-loader",
            width: width,
            height: height,
            "data-testid": "mutating-dots-svg",
            children: [
                (0, $d4dab640dcbe486c$exports.jsxs)("filter", {
                    id: "fancy-goo",
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("feGaussianBlur", {
                            in: "SourceGraphic",
                            stdDeviation: "6",
                            result: "blur"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("feColorMatrix", {
                            in: "blur",
                            mode: "matrix",
                            values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
                            result: "goo"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("feComposite", {
                            in: "SourceGraphic",
                            in2: "goo",
                            operator: "atop"
                        })
                    ]
                }),
                (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                    filter: "url(#fancy-goo)",
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                            id: "mainAnim",
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            from: "0 50 50",
                            to: "359 50 50",
                            dur: "1.2s",
                            repeatCount: "indefinite"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                            cx: "50%",
                            cy: "40",
                            r: radius,
                            fill: color,
                            children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                id: "cAnim1",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0;cAnim1.end+0.2s",
                                calcMode: "spline",
                                values: "40;20;40",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                            cx: "50%",
                            cy: "60",
                            r: radius,
                            fill: secondaryColor,
                            children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                id: "cAnim2",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0.4s;cAnim2.end+0.2s",
                                calcMode: "spline",
                                values: "60;80;60",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        })
                    ]
                })
            ]
        })
    });
/**
 * The radius of the circle
 * The Loader size is set with the width and height of the SVG
 * @type {number}
 */ const $d7a2f601d92a963f$var$$a5fa864d4dd36deb$var$RADIUS = 20;
/**
 * Compute Path depending on circle radius
 * The structure with radius 20 is "M20 0c0-9.94-8.06-20-20-20"
 * @param radius of the circle radius default 20
 * @returns {string}
 */ const $d7a2f601d92a963f$var$$a5fa864d4dd36deb$var$getPath = (radius)=>{
    return [
        "M" + radius + " 0c0-9.94-8.06",
        radius,
        radius,
        radius
    ].join("-");
};
/**
 * Compute the size of the view box depending on the radius and Stroke-Width
 * @param strokeWidth Stroke-Width of the full circle
 * @param secondaryStrokeWidth Stroke-Width of the 1/4 circle
 * @param radius radius of the circle
 * @returns {string}
 */ const $d7a2f601d92a963f$var$$a5fa864d4dd36deb$var$getViewBoxSize = (strokeWidth, secondaryStrokeWidth, radius)=>{
    const maxStrokeWidth = Math.max(strokeWidth, secondaryStrokeWidth);
    const startingPoint = -radius - maxStrokeWidth / 2 + 1;
    const endpoint = radius * 2 + maxStrokeWidth;
    return [
        startingPoint,
        startingPoint,
        endpoint,
        endpoint
    ].join(" ");
};
const $d7a2f601d92a963f$export$67ad50c48ca3ede4 = ({ height: height = 80, width: width = 80, color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "oval-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true, strokeWidth: strokeWidth = 2, strokeWidthSecondary: strokeWidthSecondary })=>(0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "oval-loading",
        "aria-label": ariaLabel,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: $d7a2f601d92a963f$var$$a5fa864d4dd36deb$var$getViewBoxSize(Number(strokeWidth), Number(strokeWidthSecondary || strokeWidth), $d7a2f601d92a963f$var$$a5fa864d4dd36deb$var$RADIUS),
            xmlns: "http://www.w3.org/2000/svg",
            stroke: color,
            "data-testid": "oval-svg",
            children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                    transform: "translate(1 1)",
                    strokeWidth: Number(strokeWidthSecondary || strokeWidth),
                    "data-testid": "oval-secondary-group",
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                            strokeOpacity: ".5",
                            cx: "0",
                            cy: "0",
                            r: $d7a2f601d92a963f$var$$a5fa864d4dd36deb$var$RADIUS,
                            stroke: secondaryColor,
                            strokeWidth: strokeWidth
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("path", {
                            d: $d7a2f601d92a963f$var$$a5fa864d4dd36deb$var$getPath($d7a2f601d92a963f$var$$a5fa864d4dd36deb$var$RADIUS),
                            children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                from: "0 0 0",
                                to: "360 0 0",
                                dur: "1s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    });
const $d7a2f601d92a963f$export$83d2259ec538613b = ({ height: height = 80, width: width = 80, radius: radius = 1, color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "puff-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "puff-loading",
        "aria-label": ariaLabel,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 44 44",
            xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "puff-svg",
            children: (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                strokeWidth: "2",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        })
    });
const $d7a2f601d92a963f$export$8e22e563e5362f75 = ({ radius: radius = 45, strokeWidth: strokeWidth = 5, color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor, ariaLabel: ariaLabel = "revolving-dot-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "revolving-dot-loading",
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
            version: "1.1",
            width: `calc(${radius} * 2.5)`,
            height: `calc(${radius} * 2.5)`,
            xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            "data-testid": "revolving-dot-svg",
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    fill: "none",
                    stroke: secondaryColor || color,
                    strokeWidth: strokeWidth,
                    cx: `calc(${radius} * 1.28)`,
                    cy: `calc(${radius} * 1.28)`,
                    r: radius,
                    style: {
                        opacity: 0.5
                    }
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    fill: color,
                    stroke: color,
                    strokeWidth: "3",
                    cx: `calc(${radius} * 1.28)`,
                    cy: `calc(${radius} / 3.5)`,
                    r: `calc(${radius} / 5)`,
                    style: {
                        transformOrigin: "50% 50%"
                    },
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0",
                        to: "360",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $d7a2f601d92a963f$export$fdd9e2f491a77de7 = ({ height: height = 80, width: width = 80, radius: radius = 6, color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "rings-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rings-loading",
        "aria-label": ariaLabel,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 45 45",
            xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "rings-svg",
            children: (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(1 1)",
                strokeWidth: "2",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "1.5s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                attributeName: "stroke-opacity",
                                begin: "1.5s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                attributeName: "stroke-width",
                                begin: "1.5s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "3s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "3s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                attributeName: "strokeWidth",
                                begin: "3s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                        cx: "22",
                        cy: "22",
                        r: Number(radius) + 2,
                        children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "r",
                            begin: "0s",
                            dur: "1.5s",
                            values: "6;1;2;3;4;5;6",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    })
                ]
            })
        })
    });
const $d7a2f601d92a963f$export$bb511942ded86554 = ({ wrapperClass: wrapperClass = "", color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, height: height = 100, width: width = 100, strokeWidth: strokeWidth = 4, ariaLabel: ariaLabel = "rotating-square-loading", wrapperStyle: wrapperStyle = {}, visible: visible = true })=>{
    return (0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rotating-square-wrapper",
        "aria-label": ariaLabel,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
            version: "1.1",
            xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            height: `${height}`,
            width: `${width}`,
            "data-testid": "rotating-square-svg",
            xmlSpace: "preserve",
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: strokeWidth,
                    x: "25",
                    y: "25",
                    width: "50",
                    height: "50",
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "0.5s",
                        from: "0 50 50",
                        to: "180 50 50",
                        type: "rotate",
                        id: "strokeBox",
                        attributeType: "XML",
                        begin: "rectBox.end"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                    x: "27",
                    y: "27",
                    fill: color,
                    width: "46",
                    height: "50",
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "height",
                        dur: "1.3s",
                        attributeType: "XML",
                        from: "50",
                        to: "0",
                        id: "rectBox",
                        fill: "freeze",
                        begin: "0s;strokeBox.end"
                    })
                })
            ]
        })
    });
};
const $d7a2f601d92a963f$var$$5819da83a926266a$var$POINTS = [
    0,
    30,
    60,
    90,
    120,
    150,
    180,
    210,
    240,
    270,
    300,
    330
];
const $d7a2f601d92a963f$var$$5819da83a926266a$var$spin = (0, $e484c752f3f06549$export$d25ddfdf17c3ad3e)`
to {
   transform: rotate(360deg);
 }
`;
const $d7a2f601d92a963f$var$$5819da83a926266a$var$Svg = (0, $e484c752f3f06549$export$2e2bcd8739ae039).svg`
  animation: ${$d7a2f601d92a963f$var$$5819da83a926266a$var$spin} 0.75s steps(12, end) infinite;
  animation-duration: 0.75s;
`;
const $d7a2f601d92a963f$var$$5819da83a926266a$var$Polyline = (0, $e484c752f3f06549$export$2e2bcd8739ae039).polyline`
  stroke-width: ${(props)=>props.width}px;
  stroke-linecap: round;

  &:nth-child(12n + 0) {
    stroke-opacity: 0.08;
  }

  &:nth-child(12n + 1) {
    stroke-opacity: 0.17;
  }

  &:nth-child(12n + 2) {
    stroke-opacity: 0.25;
  }

  &:nth-child(12n + 3) {
    stroke-opacity: 0.33;
  }

  &:nth-child(12n + 4) {
    stroke-opacity: 0.42;
  }

  &:nth-child(12n + 5) {
    stroke-opacity: 0.5;
  }

  &:nth-child(12n + 6) {
    stroke-opacity: 0.58;
  }

  &:nth-child(12n + 7) {
    stroke-opacity: 0.66;
  }

  &:nth-child(12n + 8) {
    stroke-opacity: 0.75;
  }

  &:nth-child(12n + 9) {
    stroke-opacity: 0.83;
  }

  &:nth-child(12n + 11) {
    stroke-opacity: 0.92;
  }
`;
const $d7a2f601d92a963f$export$d20df8773b6b77b5 = ({ strokeColor: strokeColor = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, strokeWidth: strokeWidth = "5", animationDuration: animationDuration = "0.75", width: width = "96", visible: visible = true, ariaLabel: ariaLabel = "rotating-lines-loading" })=>{
    const lines = (0, $bh6RR.useCallback)(()=>$d7a2f601d92a963f$var$$5819da83a926266a$var$POINTS.map((point)=>(0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$5819da83a926266a$var$Polyline, {
                points: "24,12 24,4",
                width: strokeWidth,
                transform: `rotate(${point}, 24, 24)`
            }, point)), [
        strokeWidth
    ]);
    return !visible ? null : (0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$5819da83a926266a$var$Svg, {
        xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 48 48",
        width: width,
        stroke: strokeColor,
        speed: animationDuration,
        "data-testid": "rotating-lines-svg",
        "aria-label": ariaLabel,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: lines()
    });
};
const $d7a2f601d92a963f$export$f8e5ae7506d65b32 = ({ height: height = 80, width: width = 80, strokeWidth: strokeWidth = 2, radius: radius = 1, color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "tail-spin-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>{
    const strokeWidthNum = parseInt(String(strokeWidth));
    const viewBoxValue = strokeWidthNum + 36;
    const halfStrokeWidth = strokeWidthNum / 2;
    const processedRadius = halfStrokeWidth + parseInt(String(radius)) - 1;
    return (0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "tail-spin-loading",
        "aria-label": ariaLabel,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: `0 0 ${viewBoxValue} ${viewBoxValue}`,
            xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "tail-spin-svg",
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                    children: (0, $d4dab640dcbe486c$exports.jsxs)("linearGradient", {
                        x1: "8.042%",
                        y1: "0%",
                        x2: "65.682%",
                        y2: "23.865%",
                        id: "a",
                        children: [
                            (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: "0",
                                offset: "0%"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: ".631",
                                offset: "63.146%"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("stop", {
                                stopColor: color,
                                offset: "100%"
                            })
                        ]
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                        transform: `translate(${halfStrokeWidth} ${halfStrokeWidth})`,
                        children: [
                            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                d: "M36 18c0-9.94-8.06-18-18-18",
                                id: "Oval-2",
                                stroke: color,
                                strokeWidth: strokeWidth,
                                children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                                fill: "#fff",
                                cx: "36",
                                cy: "18",
                                r: processedRadius,
                                children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $d7a2f601d92a963f$export$e21573137ccb7f5d = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "three-circles-loading", outerCircleColor: outerCircleColor, innerCircleColor: innerCircleColor, middleCircleColor: middleCircleColor })=>{
    return (0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-circles-wrapper",
        "aria-label": ariaLabel,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
            version: "1.1",
            height: `${height}`,
            width: `${width}`,
            xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "three-circles-svg",
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    fill: outerCircleColor || color,
                    d: "M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3 c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z",
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    fill: middleCircleColor || color,
                    d: "M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7 c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z",
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "1s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                    fill: innerCircleColor || color,
                    d: "M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5 L82,35.7z",
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
};
const $d7a2f601d92a963f$export$4bf83b24a11cff0b = ({ height: height = 80, width: width = 80, radius: radius = 9, color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "three-dots-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-dots-loading",
        "aria-label": ariaLabel,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 120 30",
            xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "three-dots-svg",
            children: [
                (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                    cx: "15",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                    cx: "60",
                    cy: "15",
                    r: radius,
                    attributeName: "fill-opacity",
                    from: "1",
                    to: "0.3",
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "9",
                            to: "9",
                            begin: "0s",
                            dur: "0.8s",
                            values: "9;15;9",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "0.5",
                            to: "0.5",
                            begin: "0s",
                            dur: "0.8s",
                            values: ".5;1;.5",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                    cx: "105",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
const $d7a2f601d92a963f$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES = "-3 -4 39 39";
const $d7a2f601d92a963f$var$$afa12dd3e98f740f$var$POLYGON_POINTS = "16,0 32,32 0,32";
/** Styles */ const $d7a2f601d92a963f$var$$afa12dd3e98f740f$var$dash = (0, $e484c752f3f06549$export$d25ddfdf17c3ad3e)`
to {
   stroke-dashoffset: 136;
 }
`;
const $d7a2f601d92a963f$var$$afa12dd3e98f740f$var$Polygon = (0, $e484c752f3f06549$export$2e2bcd8739ae039).polygon`
  stroke-dasharray: 17;
  animation: ${$d7a2f601d92a963f$var$$afa12dd3e98f740f$var$dash} 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;
`;
const $d7a2f601d92a963f$var$$afa12dd3e98f740f$var$SVG = (0, $e484c752f3f06549$export$2e2bcd8739ae039).svg`
  transform-origin: 50% 65%;
`;
const $d7a2f601d92a963f$export$5a465592bfe74b48 = ({ height: height = 80, width: width = 80, color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "triangle-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>{
    return (0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: `${wrapperClass}`,
        "data-testid": "triangle-loading",
        "aria-label": ariaLabel,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$afa12dd3e98f740f$var$SVG, {
            id: "triangle",
            width: width,
            height: height,
            xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: $d7a2f601d92a963f$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES,
            "data-testid": "triangle-svg",
            children: (0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$afa12dd3e98f740f$var$Polygon, {
                fill: "transparent",
                stroke: color,
                strokeWidth: "1",
                points: $d7a2f601d92a963f$var$$afa12dd3e98f740f$var$POLYGON_POINTS
            })
        })
    });
};
const $d7a2f601d92a963f$export$4c68f1a79f88778c = ({ height: height = 80, width: width = 80, radius: radius = 48, color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "watch-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $d4dab640dcbe486c$exports.jsx)($d7a2f601d92a963f$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "watch-loading",
        "aria-label": ariaLabel,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
            width: width,
            height: height,
            version: "1.1",
            id: "L2",
            xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "watch-svg",
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    cx: "50",
                    cy: "50",
                    r: radius
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "85",
                    y2: "50.5",
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "49.5",
                    y2: "74",
                    children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "15s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $d7a2f601d92a963f$export$1ed1943372cc63a9 = ({ color: color = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, width: width = "100", visible: visible = true })=>{
    return visible ? (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: width,
        viewBox: "0 0 100 100",
        "data-testid": "falling-lines",
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $d4dab640dcbe486c$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-1",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-2",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    })
                ]
            })
        ]
    }) : null;
};
const $d7a2f601d92a963f$export$d25f4198d7ad6c78 = ({ visible: visible = true, height: height = "80", width: width = "80", ariaLabel: ariaLabel = "vortex-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, colors: colors = [
    "#1B5299",
    "#EF8354",
    "#DB5461",
    "#1B5299",
    "#EF8354",
    "#DB5461"
] })=>{
    return !visible ? null : (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        height: height,
        width: width,
        xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "data-testid": "vortex-svg",
        "aria-label": ariaLabel,
        style: wrapperStyle,
        className: wrapperClass,
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
                transform: "scale(0.7)",
                children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                        transform: "rotate(137.831 50 50)",
                        children: [
                            (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                repeatCount: "indefinite",
                                values: "360 50 50;0 50 50",
                                keyTimes: "0;1",
                                dur: "1",
                                keySplines: "0.5 0.5 0.5 0.5",
                                calcMode: "spline"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                fill: colors[0],
                                d: "M30.4,9.7c-7.4,10.9-11.8,23.8-12.3,37.9c0.2,1,0.5,1.9,0.7,2.8c1.4-5.2,3.4-10.3,6.2-15.1 c2.6-4.4,5.6-8.4,9-12c0.7-0.7,1.4-1.4,2.1-2.1c7.4-7,16.4-12,26-14.6C51.5,3.6,40.2,4.9,30.4,9.7z"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                fill: colors[1],
                                d: "M24.8,64.2c-2.6-4.4-4.5-9.1-5.9-13.8c-0.3-0.9-0.5-1.9-0.7-2.8c-2.4-9.9-2.2-20.2,0.4-29.8 C10.6,25.5,6,36,5.3,46.8C11,58.6,20,68.9,31.9,76.3c0.9,0.3,1.9,0.5,2.8,0.8C31,73.3,27.6,69,24.8,64.2z"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                fill: colors[2],
                                d: "M49.6,78.9c-5.1,0-10.1-0.6-14.9-1.8c-1-0.2-1.9-0.5-2.8-0.8c-9.8-2.9-18.5-8.2-25.6-15.2 c2.8,10.8,9.5,20,18.5,26c13.1,0.9,26.6-1.7,38.9-8.3c0.7-0.7,1.4-1.4,2.1-2.1C60.7,78.2,55.3,78.9,49.6,78.9z"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                fill: colors[3],
                                d: "M81.1,49.6c-1.4,5.2-3.4,10.3-6.2,15.1c-2.6,4.4-5.6,8.4-9,12c-0.7,0.7-1.4,1.4-2.1,2.1 c-7.4,7-16.4,12-26,14.6c10.7,3,22.1,1.7,31.8-3.1c7.4-10.9,11.8-23.8,12.3-37.9C81.6,51.5,81.4,50.6,81.1,49.6z"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                fill: colors[4],
                                d: "M75.2,12.9c-13.1-0.9-26.6,1.7-38.9,8.3c-0.7,0.7-1.4,1.4-2.1,2.1c5.2-1.4,10.6-2.2,16.2-2.2 c5.1,0,10.1,0.6,14.9,1.8c1,0.2,1.9,0.5,2.8,0.8c9.8,2.9,18.5,8.2,25.6,15.2C90.9,28.1,84.2,18.9,75.2,12.9z"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                fill: colors[5],
                                d: "M94.7,53.2C89,41.4,80,31.1,68.1,23.7c-0.9-0.3-1.9-0.5-2.8-0.8c3.8,3.8,7.2,8.1,10,13 c2.6,4.4,4.5,9.1,5.9,13.8c0.3,0.9,0.5,1.9,0.7,2.8c2.4,9.9,2.2,20.2-0.4,29.8C89.4,74.5,94,64,94.7,53.2z"
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $d7a2f601d92a963f$export$f64f16a115ce395d = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "rotating-triangle-loading", colors: colors = [
    "#1B5299",
    "#EF8354",
    "#DB5461"
] })=>{
    return !visible ? null : (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "rotating-triangle-svg",
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
            transform: "translate(50,42)",
            children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
                transform: "scale(0.8)",
                children: (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                    transform: "translate(-50,-50)",
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsx)("polygon", {
                            points: "72.5,50 50,11 27.5,50 50,50",
                            fill: colors[0],
                            transform: "rotate(186 50 38.5)",
                            children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 50 38.5;360 50 38.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("polygon", {
                            points: "5,89 50,89 27.5,50",
                            fill: colors[1],
                            transform: "rotate(186 27.5 77.5)",
                            children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 27.5 77.5;360 27.5 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $d4dab640dcbe486c$exports.jsx)("polygon", {
                            points: "72.5,50 50,89 95,89",
                            fill: colors[2],
                            transform: "rotate(186 72.2417 77.5)",
                            children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 72.5 77.5;360 72 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $d7a2f601d92a963f$export$d7b12c4107be0d61 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "radio-loading", colors: colors = [
    $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
    $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
    $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c
] })=>{
    return !visible ? null : (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "radio-bar-svg",
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: "28",
                cy: "75",
                r: "11",
                fill: colors[0],
                children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                    attributeName: "fill-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M28 47A28 28 0 0 1 56 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[1],
                children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.1s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M28 25A50 50 0 0 1 78 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[2],
                children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.2s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $d7a2f601d92a963f$export$c17561cb55d4db30 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "progress-bar-loading", borderColor: borderColor = "#F4442E", barColor: barColor = "#51E5FF" })=>{
    return !visible ? null : (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "progress-bar-svg",
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                children: (0, $d4dab640dcbe486c$exports.jsx)("clipPath", {
                    x: "0",
                    y: "0",
                    width: "100",
                    height: "100",
                    id: "lds-progress-cpid-5009611b8a418",
                    children: (0, $d4dab640dcbe486c$exports.jsxs)("rect", {
                        x: "0",
                        y: "0",
                        width: "66.6667",
                        height: "100",
                        children: [
                            (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                attributeName: "width",
                                calcMode: "linear",
                                values: "0;100;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                attributeName: "x",
                                calcMode: "linear",
                                values: "0;0;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                })
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fill: "none",
                strokeWidth: "2.7928",
                d: "M82,63H18c-7.2,0-13-5.8-13-13v0c0-7.2,5.8-13,13-13h64c7.2,0,13,5.8,13,13v0C95,57.2,89.2,63,82,63z",
                stroke: borderColor
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M81.3,58.7H18.7c-4.8,0-8.7-3.9-8.7-8.7v0c0-4.8,3.9-8.7,8.7-8.7h62.7c4.8,0,8.7,3.9,8.7,8.7v0C90,54.8,86.1,58.7,81.3,58.7z",
                fill: barColor,
                clipPath: "url(#lds-progress-cpid-5009611b8a418)"
            })
        ]
    });
};
const $d7a2f601d92a963f$export$bdf537af43a20db5 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "magnifying-glass-loading", glassColor: glassColor = "#c0efff", color: color = "#e15b64" })=>{
    return !visible ? null : (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "magnifying-glass-svg",
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
                transform: "scale(0.82)",
                children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                        transform: "translate(16.3636 -20)",
                        children: [
                            (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "translate",
                                calcMode: "linear",
                                values: "-20 -20;20 -20;0 20;-20 -20",
                                keyTimes: "0;0.33;0.66;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                d: "M44.19,26.158c-4.817,0-9.345,1.876-12.751,5.282c-3.406,3.406-5.282,7.934-5.282,12.751 c0,4.817,1.876,9.345,5.282,12.751c3.406,3.406,7.934,5.282,12.751,5.282s9.345-1.876,12.751-5.282 c3.406-3.406,5.282-7.934,5.282-12.751c0-4.817-1.876-9.345-5.282-12.751C53.536,28.033,49.007,26.158,44.19,26.158z",
                                fill: glassColor
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                d: "M78.712,72.492L67.593,61.373l-3.475-3.475c1.621-2.352,2.779-4.926,3.475-7.596c1.044-4.008,1.044-8.23,0-12.238 c-1.048-4.022-3.146-7.827-6.297-10.979C56.572,22.362,50.381,20,44.19,20C38,20,31.809,22.362,27.085,27.085 c-9.447,9.447-9.447,24.763,0,34.21C31.809,66.019,38,68.381,44.19,68.381c4.798,0,9.593-1.425,13.708-4.262l9.695,9.695 l4.899,4.899C73.351,79.571,74.476,80,75.602,80s2.251-0.429,3.11-1.288C80.429,76.994,80.429,74.209,78.712,72.492z M56.942,56.942 c-3.406,3.406-7.934,5.282-12.751,5.282s-9.345-1.876-12.751-5.282c-3.406-3.406-5.282-7.934-5.282-12.751 c0-4.817,1.876-9.345,5.282-12.751c3.406-3.406,7.934-5.282,12.751-5.282c4.817,0,9.345,1.876,12.751,5.282 c3.406,3.406,5.282,7.934,5.282,12.751C62.223,49.007,60.347,53.536,56.942,56.942z",
                                fill: color
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $d7a2f601d92a963f$export$8e3fad5cade57efa = ({ width: width = "80", height: height = "80", backgroundColor: backgroundColor = $d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ballColors: ballColors = [
    "#fc636b",
    "#6a67ce",
    "#ffb900"
], wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "fidget-spinner-loader", visible: visible = true })=>{
    return !visible ? null : (0, $d4dab640dcbe486c$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "fidget-spinner-svg",
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", {
            transform: "rotate(6 50 50)",
            children: [
                (0, $d4dab640dcbe486c$exports.jsx)("g", {
                    transform: "translate(50 50)",
                    children: (0, $d4dab640dcbe486c$exports.jsx)("g", {
                        transform: "scale(0.9)",
                        children: (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                            transform: "translate(-50 -58)",
                            children: [
                                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                    d: "M27.1,79.4c-1.1,0.6-2.4,1-3.7,1c-2.6,0-5.1-1.4-6.4-3.7c-2-3.5-0.8-8,2.7-10.1c1.1-0.6,2.4-1,3.7-1c2.6,0,5.1,1.4,6.4,3.7 C31.8,72.9,30.6,77.4,27.1,79.4z",
                                    fill: ballColors[0]
                                }),
                                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                    d: "M72.9,79.4c1.1,0.6,2.4,1,3.7,1c2.6,0,5.1-1.4,6.4-3.7c2-3.5,0.8-8-2.7-10.1c-1.1-0.6-2.4-1-3.7-1c-2.6,0-5.1,1.4-6.4,3.7 C68.2,72.9,69.4,77.4,72.9,79.4z",
                                    fill: ballColors[1]
                                }),
                                (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                                    cx: "50",
                                    cy: "27",
                                    r: "7.4",
                                    fill: ballColors[2]
                                }),
                                (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                    d: "M86.5,57.5c-3.1-1.9-6.4-2.8-9.8-2.8c-0.5,0-0.9,0-1.4,0c-0.4,0-0.8,0-1.1,0c-2.1,0-4.2-0.4-6.2-1.2 c-0.8-3.6-2.8-6.9-5.4-9.3c0.4-2.5,1.3-4.8,2.7-6.9c2-2.9,3.2-6.5,3.2-10.4c0-10.2-8.2-18.4-18.4-18.4c-0.3,0-0.6,0-0.9,0 C39.7,9,32,16.8,31.6,26.2c-0.2,4.1,1,7.9,3.2,11c1.4,2.1,2.3,4.5,2.7,6.9c-2.6,2.5-4.6,5.7-5.4,9.3c-1.9,0.7-4,1.1-6.1,1.1 c-0.4,0-0.8,0-1.2,0c-0.5,0-0.9-0.1-1.4-0.1c-3.1,0-6.3,0.8-9.2,2.5c-9.1,5.2-12,17-6.3,25.9c3.5,5.4,9.5,8.4,15.6,8.4 c2.9,0,5.8-0.7,8.5-2.1c3.6-1.9,6.3-4.9,8-8.3c1.1-2.3,2.7-4.2,4.6-5.8c1.7,0.5,3.5,0.8,5.4,0.8c1.9,0,3.7-0.3,5.4-0.8 c1.9,1.6,3.5,3.5,4.6,5.7c1.5,3.2,4,6,7.4,8c2.9,1.7,6.1,2.5,9.2,2.5c6.6,0,13.1-3.6,16.4-10C97.3,73.1,94.4,62.5,86.5,57.5z M29.6,83.7c-1.9,1.1-4,1.6-6.1,1.6c-4.2,0-8.4-2.2-10.6-6.1c-3.4-5.9-1.4-13.4,4.5-16.8c1.9-1.1,4-1.6,6.1-1.6 c4.2,0,8.4,2.2,10.6,6.1C37.5,72.8,35.4,80.3,29.6,83.7z M50,39.3c-6.8,0-12.3-5.5-12.3-12.3S43.2,14.7,50,14.7 c6.8,0,12.3,5.5,12.3,12.3S56.8,39.3,50,39.3z M87.2,79.2c-2.3,3.9-6.4,6.1-10.6,6.1c-2.1,0-4.2-0.5-6.1-1.6 c-5.9-3.4-7.9-10.9-4.5-16.8c2.3-3.9,6.4-6.1,10.6-6.1c2.1,0,4.2,0.5,6.1,1.6C88.6,65.8,90.6,73.3,87.2,79.2z",
                                    fill: backgroundColor
                                })
                            ]
                        })
                    })
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            ]
        })
    });
};
const $d7a2f601d92a963f$export$bee07fdc425df572 = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "dna-loading" })=>{
    return !visible ? null : (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "dna-svg",
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "60.6229",
                r: "3.41988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "0s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "39.3771",
                r: "2.58012",
                fill: "#46dff0",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "68.1552",
                r: "3.17988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "31.8448",
                r: "2.82012",
                fill: "#46dff0",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "69.3634",
                r: "2.93988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "30.6366",
                r: "3.06012",
                fill: "#46dff0",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "65.3666",
                r: "2.69988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "34.6334",
                r: "3.30012",
                fill: "#46dff0",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "53.8474",
                r: "2.45988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "46.1526",
                r: "3.54012",
                fill: "#46dff0",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "39.3771",
                r: "2.58012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "60.6229",
                r: "3.41988",
                fill: "#46dff0",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.5s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "31.8448",
                r: "2.82012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "68.1552",
                r: "3.17988",
                fill: "#46dff0",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.7s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "30.6366",
                r: "3.06012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "69.3634",
                r: "2.93988",
                fill: "#46dff0",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.9s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "34.6334",
                r: "3.30012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "65.3666",
                r: "2.69988",
                fill: "#46dff0",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.1s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "46.1526",
                r: "3.54012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "53.8474",
                r: "2.45988",
                fill: "#46dff0",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.3s"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            })
        ]
    });
};
const $d7a2f601d92a963f$export$f93420b62a5bdffa = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "discuss-loading", colors: colors = [
    "#ff727d",
    "#ff727d"
] })=>{
    return !visible ? null : (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "discuss-svg",
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fill: "none",
                d: "M82 50A32 32 0 1 1 23.533421623214014 32.01333190873183 L21.71572875253809 21.7157287525381 L32.013331908731814 23.53342162321403 A32 32 0 0 1 82 50",
                strokeWidth: "5",
                stroke: colors[0]
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: "50",
                cy: "50",
                fill: "none",
                strokeLinecap: "round",
                r: "20",
                strokeWidth: "5",
                stroke: colors[1],
                strokeDasharray: "31.41592653589793 31.41592653589793",
                transform: "rotate(96 50 50)",
                children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $d7a2f601d92a963f$export$dc036a5afb9ca26f = ({ visible: visible = true, width: width = "80", height: height = "80", colors: colors = [
    "#e15b64",
    "#f47e60",
    "#f8b26a",
    "#abbd81",
    "#849b87"
], wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "color-ring-loading" })=>{
    return !visible ? null : (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "color-ring-svg",
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $d4dab640dcbe486c$exports.jsx)("defs", {
                children: (0, $d4dab640dcbe486c$exports.jsx)("mask", {
                    id: "ldio-4offds5dlws-mask",
                    children: (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                        cx: "50",
                        cy: "50",
                        r: "26",
                        stroke: "#fff",
                        strokeLinecap: "round",
                        strokeDasharray: "122.52211349000194 40.840704496667314",
                        strokeWidth: "9",
                        transform: "rotate(198.018 50 50)",
                        children: (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                            attributeName: "transform",
                            type: "rotate",
                            values: "0 50 50;360 50 50",
                            keyTimes: "0;1",
                            dur: "1s",
                            repeatCount: "indefinite"
                        })
                    })
                })
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                mask: "url(#ldio-4offds5dlws-mask)",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                        x: "14.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[0],
                        children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.8s"
                        })
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                        x: "28.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[1],
                        children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.6s"
                        })
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                        x: "42.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[2],
                        children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.4s"
                        })
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                        x: "56.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[3],
                        children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.2s"
                        })
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                        x: "70.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[4],
                        children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "0s"
                        })
                    })
                ]
            })
        ]
    });
};
const $d7a2f601d92a963f$export$4d299b491347818a = ({ visible: visible = true, width: width = "80", height: height = "80", backgroundColor: backgroundColor = "#ff6d00", color: color = "#fff", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "comment-loading" })=>{
    return !visible ? null : (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "comment-svg",
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                d: "M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z",
                fill: backgroundColor
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: "30",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: "50",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.2;0.4;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                cx: "70",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.4;0.6;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $d7a2f601d92a963f$export$2ba1b65b747a57aa = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "blocks-loading" })=>{
    return !visible ? null : (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: width,
        height: height,
        className: wrapperClass,
        style: wrapperStyle,
        xmlns: $d7a2f601d92a963f$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "aria-label": ariaLabel,
        "data-testid": "blocks-svg",
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $d4dab640dcbe486c$exports.jsx)("title", {
                children: "Blocks"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("desc", {
                children: "Animated representation of blocks"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                x: "17",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s",
                    calcMode: "discrete"
                })
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                x: "40",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.125s",
                    calcMode: "discrete"
                })
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                x: "63",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.25s",
                    calcMode: "discrete"
                })
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                x: "17",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.875s",
                    calcMode: "discrete"
                })
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                x: "63",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.375s",
                    calcMode: "discrete"
                })
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                x: "17",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.75s",
                    calcMode: "discrete"
                })
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                x: "40",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.625s",
                    calcMode: "discrete"
                })
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("rect", {
                x: "63",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.5s",
                    calcMode: "discrete"
                })
            })
        ]
    });
};
const $d7a2f601d92a963f$export$f3c41beb83007357 = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "hourglass-loading", colors: colors = [
    "#306cce",
    "#72a1ed"
] })=>{
    return !visible ? null : (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 350 350",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "hourglass-svg",
        ...$d7a2f601d92a963f$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $d4dab640dcbe486c$exports.jsx)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                values: "0; 0; -30; 360; 360",
                keyTimes: "0; 0.40; 0.55; 0.65; 1",
                dur: "3s",
                begin: "0s",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                children: [
                    (0, $d4dab640dcbe486c$exports.jsx)("path", {
                        fill: colors[0],
                        stroke: colors[0],
                        d: "M324.658,20.572v-2.938C324.658,7.935,316.724,0,307.025,0H40.313c-9.699,0-17.635,7.935-17.635,17.634v2.938     c0,9.699,7.935,17.634,17.635,17.634h6.814c3.5,0,3.223,3.267,3.223,4.937c0,19.588,8.031,42.231,14.186,56.698     c12.344,29.012,40.447,52.813,63.516,69.619c4.211,3.068,3.201,5.916,0.756,7.875c-22.375,17.924-51.793,40.832-64.271,70.16     c-6.059,14.239-13.934,36.4-14.18,55.772c-0.025,1.987,0.771,5.862-3.979,5.862h-6.064c-9.699,0-17.635,7.936-17.635,17.634v2.94     c0,9.698,7.935,17.634,17.635,17.634h266.713c9.699,0,17.633-7.936,17.633-17.634v-2.94c0-9.698-7.934-17.634-17.633-17.634     h-3.816c-7,0-6.326-5.241-6.254-7.958c0.488-18.094-4.832-38.673-12.617-54.135c-17.318-34.389-44.629-56.261-61.449-68.915     c-3.65-2.745-4.018-6.143,0-8.906c17.342-11.929,44.131-34.526,61.449-68.916c8.289-16.464,13.785-38.732,12.447-57.621     c-0.105-1.514-0.211-4.472,3.758-4.472h6.482C316.725,38.206,324.658,30.272,324.658,20.572z M270.271,93.216     c-16.113,31.998-41.967,54.881-64.455,68.67c-1.354,0.831-3.936,2.881-3.936,8.602v6.838c0,6.066,2.752,7.397,4.199,8.286     c22.486,13.806,48.143,36.636,64.191,68.508c7.414,14.727,11.266,32.532,10.885,46.702c-0.078,2.947,1.053,8.308-6.613,8.308     H72.627c-6.75,0-6.475-3.37-6.459-5.213c0.117-12.895,4.563-30.757,12.859-50.255c14.404-33.854,44.629-54.988,64.75-67.577     c0.896-0.561,2.629-1.567,2.629-6.922v-10.236c0-5.534-2.656-7.688-4.057-8.57c-20.098-12.688-49.256-33.618-63.322-66.681     c-8.383-19.702-12.834-37.732-12.861-50.657c-0.002-1.694,0.211-4.812,3.961-4.812h206.582c4.168,0,4.127,3.15,4.264,4.829     C282.156,57.681,278.307,77.257,270.271,93.216z"
                    }),
                    (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                        children: [
                            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M169.541,196.2l-68.748,86.03c-2.27,2.842-1.152,5.166,2.484,5.166h140.781c3.637,0,4.756-2.324,2.484-5.166     l-68.746-86.03C175.525,193.358,171.811,193.358,169.541,196.2z"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                attributeName: "opacity",
                                values: "0; 0; 1; 1; 0; 0",
                                keyTimes: "0; 0.1; 0.4; 0.6; 0.61; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                        children: [
                            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M168.986,156.219c2.576,2.568,6.789,2.568,9.363,0l34.576-34.489c2.574-2.568,1.707-4.67-1.932-4.67H136.34     c-3.637,0-4.506,2.102-1.932,4.67L168.986,156.219z"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("animate", {
                                attributeName: "opacity",
                                values: "1; 1; 0; 0; 1; 1",
                                keyTimes: "0; 0.1; 0.4; 0.65; 0.66; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



parcelRequire("bh6RR");

/*!
 * chartjs-chart-matrix v0.0.0-development
 * https://chartjs-chart-matrix.pages.dev/
 * (c) 2025 Jukka Kurkela
 * Released under the MIT license
 */ 
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */ 




var $a80483fb0ffadadd$var$version = "0.0.0-development";
class $a80483fb0ffadadd$export$8fd72f75d9c9a26f extends (0, $41f2dc2c94660a50$export$75572ec5c55b4048) {
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(rects, start, count, mode) {
        const reset = mode === "reset";
        const { xScale: xScale, yScale: yScale } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        for(let i = start; i < start + count; i++){
            const parsed = !reset && this.getParsed(i);
            const x = reset ? xScale.getBasePixel() : xScale.getPixelForValue(parsed.x);
            const y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(parsed.y);
            const options = this.resolveDataElementOptions(i, mode);
            const { width: width, height: height, anchorX: anchorX, anchorY: anchorY } = options;
            const properties = {
                x: $a80483fb0ffadadd$var$resolveX(anchorX, x, width),
                y: $a80483fb0ffadadd$var$resolveY(anchorY, y, height),
                width: width,
                height: height,
                options: options
            };
            this.updateElement(rects[i], i, properties, mode);
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    draw() {
        const ctx = this.chart.ctx;
        const data = this.getMeta().data || [];
        let i, ilen;
        for(i = 0, ilen = data.length; i < ilen; ++i)data[i].draw(ctx);
    }
}
$a80483fb0ffadadd$export$8fd72f75d9c9a26f.id = "matrix";
$a80483fb0ffadadd$export$8fd72f75d9c9a26f.version = $a80483fb0ffadadd$var$version;
$a80483fb0ffadadd$export$8fd72f75d9c9a26f.defaults = {
    dataElementType: "matrix",
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "width",
                "height"
            ]
        }
    }
};
$a80483fb0ffadadd$export$8fd72f75d9c9a26f.overrides = {
    interaction: {
        mode: "nearest",
        intersect: true
    },
    scales: {
        x: {
            type: "linear",
            offset: true
        },
        y: {
            type: "linear",
            reverse: true
        }
    }
};
function $a80483fb0ffadadd$var$resolveX(anchorX, x, width) {
    if (anchorX === "left" || anchorX === "start") return x;
    if (anchorX === "right" || anchorX === "end") return x - width;
    return x - width / 2;
}
function $a80483fb0ffadadd$var$resolveY(anchorY, y, height) {
    if (anchorY === "top" || anchorY === "start") return y;
    if (anchorY === "bottom" || anchorY === "end") return y - height;
    return y - height / 2;
}
function $a80483fb0ffadadd$var$getBounds(element, useFinalPosition) {
    const { x: x, y: y, width: width, height: height } = element.getProps([
        "x",
        "y",
        "width",
        "height"
    ], useFinalPosition);
    return {
        left: x,
        top: y,
        right: x + width,
        bottom: y + height
    };
}
function $a80483fb0ffadadd$var$limit(value, min, max) {
    return Math.max(Math.min(value, max), min);
}
function $a80483fb0ffadadd$var$parseBorderWidth(options, maxW, maxH) {
    const value = options.borderWidth;
    let t, r, b, l;
    if ((0, $5ea20a8ea64fa9d9$export$23f2a1d2818174ef)(value)) {
        t = +value.top || 0;
        r = +value.right || 0;
        b = +value.bottom || 0;
        l = +value.left || 0;
    } else t = r = b = l = +value || 0;
    return {
        t: $a80483fb0ffadadd$var$limit(t, 0, maxH),
        r: $a80483fb0ffadadd$var$limit(r, 0, maxW),
        b: $a80483fb0ffadadd$var$limit(b, 0, maxH),
        l: $a80483fb0ffadadd$var$limit(l, 0, maxW)
    };
}
function $a80483fb0ffadadd$var$boundingRects(element) {
    const bounds = $a80483fb0ffadadd$var$getBounds(element, false);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $a80483fb0ffadadd$var$parseBorderWidth(element.options, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b
        }
    };
}
function $a80483fb0ffadadd$var$inRange(element, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const bounds = !element || skipX && skipY ? false : $a80483fb0ffadadd$var$getBounds(element, useFinalPosition);
    return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
}
class $a80483fb0ffadadd$export$75126afba5fd227f extends (0, $41f2dc2c94660a50$export$db77ccec0bb4ccac) {
    draw(ctx) {
        const options = this.options;
        const { inner: inner, outer: outer } = $a80483fb0ffadadd$var$boundingRects(this);
        const radius = (0, $5ea20a8ea64fa9d9$export$9fa96a7d116ea3ce)(options.borderRadius);
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            (0, $5ea20a8ea64fa9d9$export$d66dc83d8cfc8dd)(ctx, {
                x: outer.x,
                y: outer.y,
                w: outer.w,
                h: outer.h,
                radius: radius
            });
            (0, $5ea20a8ea64fa9d9$export$d66dc83d8cfc8dd)(ctx, {
                x: inner.x,
                y: inner.y,
                w: inner.w,
                h: inner.h,
                radius: radius
            });
            ctx.fillStyle = options.backgroundColor;
            ctx.fill();
            ctx.fillStyle = options.borderColor;
            ctx.fill("evenodd");
        } else {
            ctx.beginPath();
            (0, $5ea20a8ea64fa9d9$export$d66dc83d8cfc8dd)(ctx, {
                x: inner.x,
                y: inner.y,
                w: inner.w,
                h: inner.h,
                radius: radius
            });
            ctx.fillStyle = options.backgroundColor;
            ctx.fill();
        }
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $a80483fb0ffadadd$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $a80483fb0ffadadd$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $a80483fb0ffadadd$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, width: width, height: height } = this.getProps([
            "x",
            "y",
            "width",
            "height"
        ], useFinalPosition);
        return {
            x: x + width / 2,
            y: y + height / 2
        };
    }
    tooltipPosition() {
        return this.getCenterPoint();
    }
    getRange(axis) {
        return axis === "x" ? this.width / 2 : this.height / 2;
    }
    constructor(cfg){
        super();
        if (cfg) Object.assign(this, cfg);
    }
}
$a80483fb0ffadadd$export$75126afba5fd227f.id = "matrix";
$a80483fb0ffadadd$export$75126afba5fd227f.defaults = {
    backgroundColor: undefined,
    borderColor: undefined,
    borderWidth: undefined,
    borderRadius: 0,
    anchorX: "center",
    anchorY: "center",
    width: 20,
    height: 20
};



(0, $41f2dc2c94660a50$export$acaa6426d77a227e).register(...(0, $41f2dc2c94660a50$export$e8959e79e3af550f), (0, $a80483fb0ffadadd$export$8fd72f75d9c9a26f), (0, $a80483fb0ffadadd$export$75126afba5fd227f));
function $0184aa4e65cdddb3$var$PeakActivityGraph({ data: data }) {
    if (!Array.isArray(data) || data.length === 0) // return <div style={{ textAlign: "center" }}>No peak activity data available</div>;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {});
    const weekDays = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
    ];
    const hours = Array.from({
        length: 24
    }, (_, i)=>i);
    // Initialize activity matrix
    const activity = {};
    weekDays.forEach((day)=>activity[day] = Array(24).fill(0));
    // Fill matrix with activity data
    data.forEach((company)=>{
        company.data.forEach((entry)=>{
            const d = new Date(entry.created_at);
            const day = weekDays[(d.getDay() + 6) % 7]; // Monday = 0
            const hour = d.getHours();
            activity[day][hour]++;
        });
    });
    // Flatten data for chart.js
    const matrixData = [];
    weekDays.forEach((day)=>{
        hours.forEach((hour)=>{
            matrixData.push({
                x: day,
                y: hour,
                v: activity[day][hour]
            });
        });
    });
    // Compute color scale
    const allValues = matrixData.map((d)=>d.v);
    const maxValue = Math.max(...allValues);
    const minValue = Math.min(...allValues);
    const getColor = (v)=>{
        if (v === 0) return "rgba(164, 201, 243, 0.4)"; // pale blue for no activity
        const intensity = (v - minValue) / (maxValue - minValue || 1);
        const alpha = 0.3 + intensity * 0.7;
        return `rgba(0, 123, 255, ${alpha})`;
    };
    const chartData = {
        datasets: [
            {
                label: "Peak Activity",
                data: matrixData,
                backgroundColor: (ctx)=>getColor(ctx.raw.v),
                borderColor: (ctx)=>{
                    const dayIndex = weekDays.indexOf(ctx.raw.x);
                    // Thicker border for vertical weekday separators
                    return dayIndex < weekDays.length - 1 ? "rgba(255,255,255,0.9)" : "rgba(255,255,255,0.9)";
                },
                borderWidth: (ctx)=>{
                    const dayIndex = weekDays.indexOf(ctx.raw.x);
                    // Slightly thicker borders at day boundaries
                    return {
                        top: 1,
                        bottom: 1,
                        left: dayIndex === 0 ? 2 : 0.5,
                        right: 1.5
                    };
                },
                width: (ctx)=>{
                    const chart = ctx.chart;
                    if (!chart.chartArea) return 20;
                    return chart.chartArea.width / weekDays.length;
                },
                height: (ctx)=>{
                    const chart = ctx.chart;
                    if (!chart.chartArea) return 20;
                    return chart.chartArea.height / 24;
                }
            }
        ]
    };
    // Chart configuration
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        alignToPixels: true,
        elements: {
            rectangle: {
                borderSkipped: false
            }
        },
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: "Peak Activity",
                font: {
                    size: 18
                },
                color: "#333"
            },
            tooltip: {
                callbacks: {
                    title: (ctx)=>{
                        const { x: x, y: y } = ctx[0].raw;
                        return `${x} at ${y}:00`;
                    },
                    label: (ctx)=>`${ctx.raw.v} activities`
                }
            }
        },
        scales: {
            x: {
                type: "category",
                labels: weekDays,
                offset: true,
                title: {
                    display: true,
                    text: "Weekday",
                    font: {
                        weight: "bold"
                    }
                },
                grid: {
                    display: false,
                    drawBorder: true
                }
            },
            y: {
                type: "linear",
                min: 0,
                max: 23,
                offset: true,
                reverse: true,
                ticks: {
                    stepSize: 2,
                    callback: (val)=>`${val}:00`
                },
                title: {
                    display: true,
                    text: "Hour of Day",
                    font: {
                        weight: "bold"
                    }
                },
                grid: {
                    display: false,
                    drawBorder: true
                }
            }
        }
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        style: {
            width: "90%",
            height: "500px",
            margin: "2rem auto"
        },
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2ad20ccd62d19c94$export$acaa6426d77a227e), {
            type: "matrix",
            data: chartData,
            options: options
        })
    });
}
var $0184aa4e65cdddb3$export$2e2bcd8739ae039 = $0184aa4e65cdddb3$var$PeakActivityGraph;



parcelRequire("bh6RR");


(0, $41f2dc2c94660a50$export$acaa6426d77a227e).register((0, $41f2dc2c94660a50$export$d48203c759d6a1fc), (0, $41f2dc2c94660a50$export$28c660c63b792dea), (0, $41f2dc2c94660a50$export$ed247974535929c7));
function $0e8d2945f81e0ec0$var$RedirectionPieChart({ data: data }) {
    if (!Array.isArray(data) || data.length === 0) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {});
    let redirected = 0;
    let notRedirected = 0;
    data.forEach((company)=>{
        company.data.forEach((entry)=>{
            if (entry.redirection === 0) notRedirected++;
            else redirected++;
        });
    });
    const totalCalls = redirected + notRedirected;
    const chartData = {
        labels: [
            "Call Not Transferred",
            "Call Transferred"
        ],
        datasets: [
            {
                data: [
                    notRedirected,
                    redirected
                ],
                backgroundColor: [
                    "#0e7aed",
                    "#A9A9A9"
                ],
                borderColor: "#ffffff",
                borderWidth: 2
            }
        ]
    };
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    font: {
                        size: 14
                    }
                }
            },
            title: {
                display: true,
                text: `Call Transfer \u{2014} Total Calls: ${totalCalls}`,
                font: {
                    size: 18
                }
            },
            tooltip: {
                callbacks: {
                    label: (ctx)=>`${ctx.label}: ${ctx.raw}`
                }
            }
        }
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        style: {
            width: "350px",
            margin: "2rem auto"
        },
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2ad20ccd62d19c94$export$2ae8800cf67c848c), {
            data: chartData,
            options: options
        })
    });
}
var $0e8d2945f81e0ec0$export$2e2bcd8739ae039 = $0e8d2945f81e0ec0$var$RedirectionPieChart;



parcelRequire("bh6RR");



(0, $41f2dc2c94660a50$export$acaa6426d77a227e).register(...(0, $41f2dc2c94660a50$export$e8959e79e3af550f), (0, $a80483fb0ffadadd$export$8fd72f75d9c9a26f), (0, $a80483fb0ffadadd$export$75126afba5fd227f));
function $3f8e271fd13a9954$var$RedirectedPeakActivityGraph({ data: data }) {
    if (!Array.isArray(data) || data.length === 0) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {});
    const weekDays = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
    ];
    const hours = Array.from({
        length: 24
    }, (_, i)=>i);
    // Initialize activity matrix
    const activity = {};
    weekDays.forEach((day)=>{
        activity[day] = Array(24).fill(0);
    });
    // Fill matrix ONLY for redirection === 1
    data.forEach((company)=>{
        company.data.forEach((entry)=>{
            if (Number(entry.redirection) !== 1) return;
            const day = entry.day;
            const hour = parseInt(entry.hour.split(":")[0], 10);
            if (!weekDays.includes(day) || isNaN(hour)) return;
            activity[day][hour]++;
        });
    });
    // Flatten for chart.js matrix
    const matrixData = [];
    weekDays.forEach((day)=>{
        hours.forEach((hour)=>{
            matrixData.push({
                x: day,
                y: hour,
                v: activity[day][hour]
            });
        });
    });
    // Compute color scale
    const allValues = matrixData.map((d)=>d.v);
    const maxValue = Math.max(...allValues);
    const minValue = Math.min(...allValues);
    const getColor = (v)=>{
        if (v === 0) return "rgba(164, 201, 243, 0.4)"; // pale blue for no activity
        const intensity = (v - minValue) / (maxValue - minValue || 1);
        const alpha = 0.3 + intensity * 0.7;
        return `rgba(0, 123, 255, ${alpha})`;
    };
    const chartData = {
        datasets: [
            {
                label: "Redirected Calls",
                data: matrixData,
                backgroundColor: (ctx)=>getColor(ctx.raw.v),
                borderColor: "rgba(255,255,255,0.9)",
                borderWidth: 1,
                width: (ctx)=>{
                    const chart = ctx.chart;
                    if (!chart.chartArea) return 20;
                    return chart.chartArea.width / weekDays.length;
                },
                height: (ctx)=>{
                    const chart = ctx.chart;
                    if (!chart.chartArea) return 20;
                    return chart.chartArea.height / 24;
                }
            }
        ]
    };
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: "Call Transfer Activity",
                font: {
                    size: 18
                }
            },
            tooltip: {
                callbacks: {
                    title: (ctx)=>{
                        const { x: x, y: y } = ctx[0].raw;
                        return `${x} at ${y}:00`;
                    },
                    label: (ctx)=>`Redirected calls: ${ctx.raw.v}`
                }
            }
        },
        scales: {
            x: {
                type: "category",
                labels: weekDays,
                offset: true,
                title: {
                    display: true,
                    text: "Weekday",
                    font: {
                        weight: "bold"
                    }
                },
                grid: {
                    display: false
                }
            },
            y: {
                type: "linear",
                min: 0,
                max: 23,
                reverse: true,
                ticks: {
                    stepSize: 2,
                    callback: (v)=>`${v}:00`
                },
                title: {
                    display: true,
                    text: "Hour of Day",
                    font: {
                        weight: "bold"
                    }
                },
                grid: {
                    display: false
                }
            }
        }
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        style: {
            width: "90%",
            height: "500px",
            margin: "2rem auto"
        },
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2ad20ccd62d19c94$export$acaa6426d77a227e), {
            type: "matrix",
            data: chartData,
            options: options
        })
    });
}
var $3f8e271fd13a9954$export$2e2bcd8739ae039 = $3f8e271fd13a9954$var$RedirectedPeakActivityGraph;


(0, $41f2dc2c94660a50$export$acaa6426d77a227e).register(...(0, $41f2dc2c94660a50$export$e8959e79e3af550f));
function $214178c5589c8def$var$AnalyticsGraph({ option: option }) {
    const { analytics: analytics, metrics: metrics, metrics_id: metrics_id, isLoading: isLoading, view: view, peakActivity: peakActivity, redirectionActivity: redirectionActivity } = (0, $612615ca67331c5d$export$89605b40d8b4f599)();
    const dispatch = (0, $612615ca67331c5d$export$2708059e7a8caa93)();
    const [chart, setChart] = (0, $bh6RR.useState)("pie");
    const canvasRef = (0, $bh6RR.useRef)(null);
    const [clickedLabel, setClickedLabel] = (0, $bh6RR.useState)(null);
    const [clickedTime, setClickedTime] = (0, $bh6RR.useState)(null);
    const [hoveredLabelIndex, setHoveredLabelIndex] = (0, $bh6RR.useState)(null);
    // const { dateLabel , timeLabel  } = useAnalyticsStateContext();
    var type = option;
    const metricsChoice = (0, $c0945ce29f1eac52$export$2e2bcd8739ae039)(metrics);
    const { setChoiceMetric: setChoiceMetric, getMetricValue: getMetricValue } = (0, $d243346d1fa8c7d5$export$2e2bcd8739ae039)(metrics, metrics_id);
    const metricValue = getMetricValue();
    if (option === "metrics" && metrics_id != null && metricValue == null) return null;
    const config = (0, $d496355af03335df$export$76b2c6e79e0bcec0)(analytics, metrics, option, chart, metrics_id);
    const options = chart == "line" ? {
        scales: {
            xAxis: {
                ticks: {
                    maxTicksLimit: 10,
                    color: function(context) {
                        return context.index === hoveredLabelIndex ? "#0e7aed" : "black";
                    },
                    font: function(context) {
                        return context.index === hoveredLabelIndex ? {
                            weight: "bold"
                        } : {};
                    }
                }
            },
            yAxis: {
                min: 0,
                max: config.max,
                ticks: {
                    maxTicksLimit: 6,
                    beginAtZero: true
                }
            }
        }
    } : {
        plugins: {
            tooltip: {
                callbacks: {
                    label: function(info) {
                        const { label: label, dataset: dataset, dataIndex: dataIndex, chart: chart, datasetIndex: datasetIndex } = info;
                        if (Array.isArray(dataset.data)) {
                            const data = dataset.data.filter((value, index)=>chart._hiddenIndices[index] !== true);
                            let total = data.reduce((previousValue, currentValue)=>previousValue + currentValue, 0);
                            let currentValue = dataset.data[dataIndex];
                            let percentage = Math.round(currentValue / total * 1000) / 10;
                            return `${label} : ${percentage} % (${currentValue})`;
                        } else {
                            const keys = Object.keys(dataset.data);
                            let currentValue;
                            if (keys.length > dataIndex) {
                                const key = keys[dataIndex];
                                currentValue = dataset.data[key];
                            } else currentValue = "N/A";
                            return `${label} : ${currentValue}`;
                        }
                    }
                }
            }
        }
    };
    const plugins = [
        {
            afterDraw: (chart)=>{
                let meta = chart.getDatasetMeta(0);
                if (meta.type == "doughnut") {
                    let data = meta._dataset.data.filter((value, index)=>chart._hiddenIndices[index] !== true);
                    if (data.length !== 0) return;
                }
                if (meta.type == "line") {
                    let data = chart.data.datasets.filter((dataset)=>chart.getDatasetMeta(dataset.id).hidden !== true);
                    if (data.length !== 0) return;
                }
                let ctx = chart.ctx;
                let width = chart.width;
                let height = chart.height;
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                ctx.font = "30px Arial";
                // ctx.fillText("No data to display", width / 2, height / 2);
                ctx.restore();
            }
        }
    ];
    // To refactor if the client ask for multiple download zzzzz
    const downloadAnalyticsXlxs = ()=>{
        const { values: data, name: name } = (0, $d496355af03335df$export$d6477e394a1cc22)(analytics, metrics, type, option, metrics_id);
        const workbook = $3ee4f50b1ae43a89$export$eab97d15b1788b8d.book_new();
        const sheet = $3ee4f50b1ae43a89$export$eab97d15b1788b8d.aoa_to_sheet([
            []
        ]);
        let allDates = [];
        for(const prop in data)for(const date in data[prop]){
            if (allDates.includes(date)) continue;
            allDates.push(date);
        }
        allDates.sort((a, b)=>new Date(b) - new Date(a));
        const headerRow = [
            "Date"
        ];
        for(const prop in data)headerRow.push(prop);
        $3ee4f50b1ae43a89$export$eab97d15b1788b8d.sheet_add_aoa(sheet, [
            headerRow
        ]);
        // Ajouter les données
        allDates.forEach((date)=>{
            const rowData = [
                date
            ];
            for(const prop in data)rowData.push(data[prop][date] || 0);
            $3ee4f50b1ae43a89$export$eab97d15b1788b8d.sheet_add_aoa(sheet, [
                rowData
            ], {
                origin: -1
            });
        });
        $3ee4f50b1ae43a89$export$eab97d15b1788b8d.book_append_sheet(workbook, sheet, "Metric");
        const excelBuffer = $3ee4f50b1ae43a89$export$68d8715fc104d294(workbook, {
            bookType: "xlsx",
            type: "array"
        });
        const blob = new Blob([
            excelBuffer
        ], {
            type: "application/octet-stream"
        });
        const nameFile = +Date.now() + "_" + (name ? name : id);
        (0, $23e83188f10c8284$exports.saveAs)(blob, `${nameFile}.xlsx`);
    };
    // Cette fonction me permet de gerer les clics sur le canvas
    const handleCanvasClick = (event)=>{
        const chart = (0, $41f2dc2c94660a50$export$acaa6426d77a227e).getChart(canvasRef.current);
        if (view !== "dates" && view !== "hours") return;
        if (!chart) return;
        // Récupération de la position du clic par rapport au canvas
        const canvasPosition = chart.canvas.getBoundingClientRect();
        const x = event.clientX - canvasPosition.left;
        const y = event.clientY - canvasPosition.top;
        // Récupération des axes X et Y du chart
        const xAxis = chart.scales.x || chart.scales.xAxis;
        const yAxis = chart.scales.y || chart.scales.yAxis;
        if (!xAxis || !yAxis) {
            console.error("Axes introuvables");
            return;
        }
        // Conversion des coordonnées du clic en valeurs de données sur les axes
        const dataX = xAxis.getValueForPixel(x);
        const dataY = yAxis.getValueForPixel(y);
        // Calcul de l'index du point cliqué dans le tableau des labels
        const index = Math.round(dataX);
        // Si l'index est valide, on récupère le label correspondant et on le traite
        if (index >= 0 && index < chart.data.labels.length) {
            const clickedLabel = chart.data.labels[index];
            handlePointClick(clickedLabel);
        }
    };
    function isValidDateString(dateString) {
        const regex = /^\d{4}-\d{2}-\d{2}$/;
        if (!regex.test(dateString)) return false;
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return false;
        const [year, month, day] = dateString.split("-");
        return date.getUTCFullYear() === parseInt(year, 10) && date.getUTCMonth() + 1 === parseInt(month, 10) && date.getUTCDate() === parseInt(day, 10);
    }
    const handlePointClick = (label)=>{
        if (view === "dates") {
            setClickedLabel(label);
            dispatch({
                type: "SET_CLICKED_LABEL",
                payload: label
            });
            dispatch({
                type: "SET_VIEW",
                payload: "hours"
            });
        } else if (view === "hours") {
            if (isValidDateString(label)) {
                setClickedLabel(label);
                dispatch({
                    type: "SET_CLICKED_LABEL",
                    payload: label
                });
                dispatch({
                    type: "SET_VIEW",
                    payload: "hours"
                });
            } else {
                setClickedTime(label);
                dispatch({
                    type: "SET_CLICKED_TIME",
                    payload: {
                        date: clickedLabel,
                        time: label
                    }
                });
                dispatch({
                    type: "SET_VIEW",
                    payload: "other"
                });
            }
        }
    };
    const getSortedAndFormattedDataForAllDatasets = (datasets, id1)=>{
        const sortedKeys = Object.keys(datasets[0].data).sort((a, b)=>a - b);
        const formattedLabels = sortedKeys.map((key)=>{
            if (clickedTime) {
                let hour = clickedTime?.split(":")[0];
                return `${hour}h${key}`;
            } else return clickedLabel;
        });
        const formattedDatasets = datasets.map((dataset)=>{
            const sortedData = sortedKeys.map((key)=>dataset.data[key]);
            return {
                ...dataset,
                data: sortedData
            };
        });
        return {
            id: id1,
            labels: formattedLabels,
            datasets: formattedDatasets
        };
    };
    const handleMouseMove = (event)=>{
        const chart = (0, $41f2dc2c94660a50$export$acaa6426d77a227e).getChart(canvasRef.current);
        if (!chart) return;
        const canvas = chart.ctx.canvas;
        const canvasPosition = canvas.getBoundingClientRect();
        const x = event.clientX - canvasPosition.left;
        const xAxis = chart.scales.x || chart.scales.xAxis;
        const ticks = xAxis.ticks.map((tick)=>xAxis.getPixelForValue(tick.value));
        const tickWidth = 10;
        const hoveredIndex = ticks.findIndex((tickX)=>x >= tickX - tickWidth / 2 && x <= tickX + tickWidth / 2);
        if (hoveredIndex >= 0 && view != "other") {
            setHoveredLabelIndex(hoveredIndex);
            canvas.style.cursor = "pointer";
        } else {
            setHoveredLabelIndex(null);
            canvas.style.cursor = "default";
        }
    };
    const sortedConfig = view === "other" ? getSortedAndFormattedDataForAllDatasets(config.datasets, config.id) : config;
    const handleArrowClick = (direction)=>{
        dispatch({
            type: "SET_VIEW",
            payload: "dates"
        });
        setClickedLabel(null);
        setClickedTime(null);
        dispatch({
            type: "SET_CLICKED_LABEL",
            payload: null
        });
        dispatch({
            type: "SET_CLICKED_TIME",
            payload: {
                time: null,
                date: null
            }
        });
        setChoiceMetric(direction);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "chart_container",
        children: isLoading ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: "loader-container",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d7a2f601d92a963f$export$4bf83b24a11cff0b), {
                height: "100",
                width: "100",
                color: "var(--main)",
                ariaLabel: "loading"
            })
        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "column"
            },
            children: [
                view !== "dates" && metrics_id === null && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "back-button",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                        className: "main-iconButton profil_action main_add-button space_tableButton",
                        icon: "fas fa-arrow-left",
                        onClick: ()=>{
                            dispatch({
                                type: "SET_VIEW",
                                payload: "dates"
                            });
                            setClickedLabel(null);
                            setClickedTime(null);
                            dispatch({
                                type: "SET_CLICKED_LABEL",
                                payload: null
                            });
                            dispatch({
                                type: "SET_CLICKED_TIME",
                                payload: {
                                    time: null,
                                    date: null
                                }
                            });
                        }
                    })
                }),
                type === "metrics" && metrics_id != null ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                    className: "main-iconButton profil_action main_add-button space_tableButton" + (chart === "line" ? " selected" : ""),
                                    icon: "fas fa-chart-line",
                                    onClick: ()=>setChart("line")
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                    className: "main-iconButton profil_action main_add-button space_tableButton" + (chart === "pie" ? " selected" : ""),
                                    icon: "fas fa-chart-pie",
                                    onClick: ()=>setChart("pie")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                className: "main-iconButton profil_action main_add-button space_tableButton",
                                icon: "fas fa-download",
                                onClick: downloadAnalyticsXlxs
                            })
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: [
                        metricsChoice.length !== 1 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            className: "arrow prev",
                            onClick: ()=>handleArrowClick(-1)
                        }) : null,
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            style: {
                                fontSize: "22px",
                                fontWeight: "bold"
                            },
                            children: metrics_id === null ? "All metrics" : getMetricValue(metricsChoice, metrics_id) || "Unknown metric"
                        }),
                        metricsChoice.length !== 1 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            style: {
                                display: "flex"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "arrow next",
                                    onClick: ()=>handleArrowClick(1)
                                }),
                                " ",
                                view !== "dates" && getMetricValue() === undefined ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    style: {
                                        fontWeight: "bold"
                                    }
                                }) : null
                            ]
                        }) : null
                    ]
                }),
                type === "metrics" && metrics_id != null && chart === "pie" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    style: {
                        width: "50%",
                        margin: "auto"
                    },
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2ad20ccd62d19c94$export$b8b3cfdc3fe36b10), {
                        datasetIdKey: "pie",
                        data: config,
                        options: options,
                        plugins: plugins
                    })
                }) : metrics_id != null && type === "metrics" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2ad20ccd62d19c94$export$17d680238e50603e), {
                    datasetIdKey: "multi-line",
                    data: config,
                    options: options,
                    plugins: plugins
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2ad20ccd62d19c94$export$17d680238e50603e), {
                    ref: canvasRef,
                    datasetIdKey: "line",
                    data: sortedConfig,
                    options: options,
                    plugins: plugins,
                    onMouseMove: handleMouseMove,
                    onClick: handleCanvasClick
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0e8d2945f81e0ec0$export$2e2bcd8739ae039), {
                    data: redirectionActivity,
                    options: options,
                    plugins: plugins
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0184aa4e65cdddb3$export$2e2bcd8739ae039), {
                    data: peakActivity,
                    options: options,
                    plugins: plugins
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3f8e271fd13a9954$export$2e2bcd8739ae039), {
                    data: redirectionActivity,
                    options: options,
                    plugins: plugins
                })
            ]
        })
    });
}
var $214178c5589c8def$export$2e2bcd8739ae039 = $214178c5589c8def$var$AnalyticsGraph;




var $bh6RR = parcelRequire("bh6RR");




(0, $41f2dc2c94660a50$export$acaa6426d77a227e).register((0, $41f2dc2c94660a50$export$55e463fa7bcd3469), (0, $41f2dc2c94660a50$export$bd159b522b230b7a), (0, $41f2dc2c94660a50$export$e7f4e5e8656f0b93), (0, $41f2dc2c94660a50$export$f99233281efd08a0), (0, $41f2dc2c94660a50$export$28c660c63b792dea), (0, $41f2dc2c94660a50$export$ed247974535929c7), (0, $41f2dc2c94660a50$export$29e663ba4d09fe7));
const $c2bd8954f6b6e3d9$var$buildBins = (max)=>{
    const bins = [];
    for(let i = 0; i < 60; i += 10)bins.push(i);
    for(let i = 60; i < 180; i += 30)bins.push(i);
    for(let i = 180; i < max + 60; i += 60)bins.push(i);
    return bins;
};
const $c2bd8954f6b6e3d9$var$AnalyticsCallDurationGraph = ({ conversations: conversations, loading: loading })=>{
    const [chartData, setChartData] = (0, $bh6RR.useState)(null);
    (0, $bh6RR.useEffect)(()=>{
        const durations = conversations.filter((conv)=>conv && typeof conv.duration === "number" && conv.duration > 0).map((conv)=>conv.duration);
        if (durations.length === 0) {
            setChartData(null);
            return;
        }
        const maxDuration = Math.max(...durations);
        const bins = $c2bd8954f6b6e3d9$var$buildBins(maxDuration);
        const counts = new Array(bins.length - 1).fill(0);
        durations.forEach((d)=>{
            for(let i = 0; i < bins.length - 1; i++)if (d >= bins[i] && d < bins[i + 1]) {
                counts[i]++;
                break;
            }
        });
        const labels = bins.slice(0, -1).map((val, i)=>`${val}-${bins[i + 1]}s`);
        setChartData({
            labels: labels,
            datasets: [
                {
                    label: "Number of calls",
                    data: counts,
                    borderColor: "#3b82f6",
                    backgroundColor: "rgba(59, 130, 246, 0.1)",
                    fill: true,
                    tension: 0.4,
                    cubicInterpolationMode: "monotone",
                    pointRadius: 0
                }
            ]
        });
    }, [
        conversations
    ]);
    if (!chartData) return null;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        id: "analytics-call-duration-graph",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                className: "title-call-duration",
                children: "Distribution of call durations"
            }),
            loading ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "loader-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d7a2f601d92a963f$export$4bf83b24a11cff0b), {
                    height: "100",
                    width: "100",
                    color: "var(--main)",
                    ariaLabel: "loading"
                })
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2ad20ccd62d19c94$export$17d680238e50603e), {
                data: chartData,
                options: {
                    responsive: true,
                    interaction: {
                        intersect: false
                    },
                    scales: {
                        x: {
                            title: {
                                display: true,
                                text: "Call duration"
                            }
                        },
                        y: {
                            title: {
                                display: true,
                                text: "Number of calls"
                            },
                            beginAtZero: true,
                            ticks: {
                                stepSize: 1
                            },
                            suggestedMax: Math.max(...chartData.datasets[0].data) + 2
                        }
                    }
                }
            })
        ]
    });
};
var $c2bd8954f6b6e3d9$export$2e2bcd8739ae039 = $c2bd8954f6b6e3d9$var$AnalyticsCallDurationGraph;




function $71520a1540f25d04$var$AnalyticsContainer({ data: data }) {
    const { analytics: analytics, metrics_id: metrics_id, metrics: metrics, channel_type_id: channel_type_id, periodChoice: periodChoice, firstPeriod: firstPeriod, channel_id: channel_id } = (0, $612615ca67331c5d$export$89605b40d8b4f599)();
    const { conversations: conversations, loading: loading } = (0, $8d408649534363a8$export$2e2bcd8739ae039)({
        periodChoice: periodChoice,
        date_start: firstPeriod?.date_start,
        date_end: firstPeriod?.date_end,
        channel_id: channel_id == null ? null : channel_id
    });
    const stateSection = (0, $bh6RR.useState)("number_of_messages");
    const [section] = stateSection;
    const sum = (object)=>{
        const data = Object.values(object);
        return data.length ? data.reduce((previousValue, currentValue)=>previousValue + currentValue) : 0;
    };
    const number_of_conversations = sum(analytics.number_of_conversations_stats);
    const number_of_users = sum(analytics.number_of_users_stats);
    const number_of_messages = sum(analytics.number_of_messages_stats);
    const average_duration_of_conversations = sum(analytics.average_duration_of_conversations_stats) / 60;
    const average_number_of_messages = sum(analytics.average_number_of_messages_stats);
    const message_per_conversation = average_number_of_messages / (Object.values(analytics.average_number_of_messages_stats).length || 1);
    const conversation_duration = average_duration_of_conversations / (Object.values(analytics.average_duration_of_conversations_stats).length || 1);
    const number_of_minutes_total = Math.ceil(sum(analytics.number_of_minutes_total_stats)) /// on arrondi a la minute superieur
    ;
    const number_of_minutes_bot = Math.ceil(sum(analytics.number_of_minutes_bot_stats));
    const number_of_minutes_human = Math.ceil(sum(analytics.number_of_minutes_human_stats));
    //console.log(conversation_duration);
    const number_of_unanswered_call = analytics.number_of_unanswered_call ? sum(analytics.number_of_unanswered_call) : null;
    var number_of_passing_by_block = 0;
    if (metrics_id != null) {
        const condition = metrics.conditions.filter((condition)=>condition.id == metrics_id);
        const redirection = metrics.redirections.filter((redirection)=>redirection.id == metrics_id);
        if (condition.length == 1) {
            const result = Object.values(condition[0].values).map((array)=>Object.values(array).reduce((accumulator, value)=>accumulator + value), 0);
            number_of_passing_by_block = result.reduce((accumulator, value)=>accumulator + value);
        }
        if (redirection.length) {
            const result = Object.values(redirection[0].values).map((array)=>Object.values(array).reduce((accumulator, value)=>accumulator + value), 0);
            number_of_passing_by_block = result.reduce((accumulator, value)=>accumulator + value);
        }
    }
    (0, $bh6RR.useEffect)(()=>{
        const [section, setSection] = stateSection;
        if (section === "metrics" && metrics_id == null) setSection("number_of_messages");
        else if (section !== "metrics" && metrics_id != null) setSection("metrics");
    }, [
        metrics_id,
        stateSection
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "main_elements",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "break"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6aeeaf3992abef38$export$2e2bcd8739ae039), {
                className: "small",
                title: channel_type_id == 3 ? "Calls" : "Conversations",
                number: number_of_conversations,
                type: "number_of_conversations",
                stateSection: stateSection
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6aeeaf3992abef38$export$2e2bcd8739ae039), {
                className: "small",
                title: "Interactions",
                number: number_of_messages,
                type: "number_of_messages",
                stateSection: stateSection
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6aeeaf3992abef38$export$2e2bcd8739ae039), {
                className: "small",
                title: "Interactions per " + (channel_type_id == 3 ? "call" : "conversation"),
                percentage: -4,
                number: message_per_conversation,
                type: "average_number_of_interactions",
                stateSection: stateSection
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6aeeaf3992abef38$export$2e2bcd8739ae039), {
                className: "small",
                //title={"Total duration mean"}
                title: (channel_type_id == 3 ? "Call" : "Conversation") + " duration with AI Agent in minutes",
                percentage: 120,
                number: conversation_duration,
                type: "average_duration_of_conversations",
                stateSection: stateSection,
                hoverInfo: channel_type_id == 1 ? "The duration of web conversation is the delay between the first and the last message of the conversation" : ""
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6aeeaf3992abef38$export$2e2bcd8739ae039), {
                className: "small",
                title: "Users",
                number: number_of_users,
                type: "number_of_users",
                stateSection: stateSection
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6aeeaf3992abef38$export$2e2bcd8739ae039), {
                className: "small",
                title: "Total duration in minutes",
                number: number_of_minutes_total,
                type: "number_of_minutes_total",
                stateSection: stateSection
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6aeeaf3992abef38$export$2e2bcd8739ae039), {
                className: "small",
                title: "Total duration with AI Agent in minutes",
                number: number_of_minutes_bot,
                type: "number_of_minutes_bot",
                stateSection: stateSection
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6aeeaf3992abef38$export$2e2bcd8739ae039), {
                className: "small",
                title: "Total duration with Human in minutes",
                number: number_of_minutes_human,
                type: "number_of_minutes_human",
                stateSection: stateSection
            }),
            number_of_unanswered_call ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6aeeaf3992abef38$export$2e2bcd8739ae039), {
                className: "small",
                title: "Unanswered Call",
                number: number_of_unanswered_call,
                type: "number_of_unanswered_call",
                stateSection: stateSection
            }) : null,
            metrics_id ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6aeeaf3992abef38$export$2e2bcd8739ae039), {
                className: "small",
                title: "Number of passage",
                number: number_of_passing_by_block,
                type: "metrics",
                stateSection: stateSection
            }) : "",
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "break"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $214178c5589c8def$export$2e2bcd8739ae039), {
                option: section
            }),
            channel_type_id !== 1 && channel_type_id !== 2 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c2bd8954f6b6e3d9$export$2e2bcd8739ae039), {
                conversations: conversations,
                loading: loading
            })
        ]
    });
}
var $71520a1540f25d04$export$2e2bcd8739ae039 = $71520a1540f25d04$var$AnalyticsContainer;



const $061adcb1a57556aa$var$TypesChannel = [
    {
        text: "All",
        value: null
    },
    {
        text: "Web",
        value: 1
    },
    {
        text: "Call",
        value: 3
    },
    {
        text: "Rcs",
        value: 2
    }
];
var $061adcb1a57556aa$export$2e2bcd8739ae039 = $061adcb1a57556aa$var$TypesChannel;


const $5f5f2e6367b716f2$var$TypesDuration = [
    {
        value: "day",
        text: "Last day"
    },
    {
        value: "week",
        text: "Last week"
    },
    {
        value: "month",
        text: "Last month"
    },
    {
        value: "year",
        text: "Last year"
    },
    {
        value: "all",
        text: "All time"
    }
];
var $5f5f2e6367b716f2$export$2e2bcd8739ae039 = $5f5f2e6367b716f2$var$TypesDuration;




var $ec3c83de6a185323$exports = {};
$ec3c83de6a185323$exports = new URL("analytics-blue.c1429973.svg", import.meta.url).toString();


var $4924e8ade90d6f74$exports = {};
$4924e8ade90d6f74$exports = new URL("devices.8a88d407.svg", import.meta.url).toString();








var $bh6RR = parcelRequire("bh6RR");

var $bb4e77bbc51546c3$export$2e2bcd8739ae039 = {
    getChannels: (bot, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`analytics/${bot}/info/channels`, data),
    getAnalytics: (bot, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`analytics/${bot}/info/all/analytics`, data),
    getMetrics: (bot, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`analytics/${bot}/info/all/metrics`, data),
    getPeakActivity: (bot, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`analytics/${bot}/info/peak_conv_activity`, data),
    getRedirection: (bot, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`analytics/${bot}/info/redirection`, data),
    deleteAll: (bot, data, channel_id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`analytics/${bot}/info/all`, {
            ...data,
            channel_id: channel_id
        }),
    getCall: (bot, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`analytics/${bot}/info/call`, data),
    getCumulatedStats: (bot, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`analytics/${bot}/info/cumulated`, data),
    getNumOfCall: (bot, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`analytics/${bot}/info/num_call`, data),
    getNumOfConv: (bot, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`analytics/${bot}/info/num_conv`, data)
};




function $7256b5c4828974ea$var$useAnalyticsTopBarHookData(name, channel_type_id, firstPeriod, channel_id, condition_id, redirection_id) {
    const data = {
        channel_type_id: channel_type_id,
        date_start: firstPeriod.date_start,
        date_end: firstPeriod.date_end,
        channel_id: channel_id,
        condition_id: condition_id,
        redirection_id: redirection_id
    };
    const dispatch = (0, $612615ca67331c5d$export$2708059e7a8caa93)();
    const { clickedLabel: clickedLabel, clickedTime: clickedTime, clickedDate: clickedDate, metrics: metrics, metrics_id: metrics_id } = (0, $612615ca67331c5d$export$89605b40d8b4f599)();
    const previousMetricValueRef = (0, $bh6RR.useRef)();
    const { getMetricValue: getMetricValue } = (0, $d243346d1fa8c7d5$export$2e2bcd8739ae039)(metrics, metrics_id);
    const [isReset, setIsReset] = (0, $bh6RR.useState)(false);
    const { deleteAll: deleteAll, ...analyticService } = (0, $bb4e77bbc51546c3$export$2e2bcd8739ae039);
    (0, $bh6RR.useEffect)(()=>{
        const currentMetricValue = getMetricValue();
        if (currentMetricValue !== undefined && previousMetricValueRef.current !== currentMetricValue) {
            dispatch({
                type: "RESET_CLICKED_STATES"
            });
            setIsReset(true);
        }
        previousMetricValueRef.current = currentMetricValue;
    }, [
        getMetricValue
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const fetchData = async ()=>{
            dispatch({
                type: "SET_LOADING",
                payload: true
            });
            try {
                var [metrics, error] = await analyticService.getMetrics(name, data);
                if (error) {
                    dispatch({
                        type: "SET_LOADING",
                        payload: false
                    });
                    return;
                }
                //var condition_id = metrics.conditions[0] ? metrics.conditions[0].id : null; // avant on affichait la premiere condition, plus maintenant
                var condition_id = null; // la valeur pas defaut pour afficher les informations de "all metrics" 
                if (condition_id) dispatch({
                    type: "setResultInformation",
                    payload: {
                        metrics: metrics,
                        metrics_id: condition_id,
                        condition_id: condition_id
                    }
                });
                else {
                    //var redirection_id = metrics.redirections[0] ? metrics.redirections[0].id : null;// avant on affichait la premiere redirection, plus maintenant
                    var redirection_id = null; // la valeur pas defaut pour afficher les informations de "all metrics" 
                    if (redirection_id) dispatch({
                        type: "setResultInformation",
                        payload: {
                            metrics: metrics,
                            metrics_id: redirection_id,
                            redirection_id: redirection_id
                        }
                    });
                    else dispatch({
                        type: "setResultInformation",
                        payload: {
                            metrics: metrics,
                            metrics_id: null
                        }
                    });
                }
            } finally{
                dispatch({
                    type: "SET_LOADING",
                    payload: false
                });
            }
        };
        fetchData();
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        if (name == undefined) return;
        const fetchData = async ()=>{
            dispatch({
                type: "SET_LOADING",
                payload: true
            });
            try {
                const requests = Object.values(analyticService).map((request)=>{
                    if (clickedLabel && !clickedTime) return request(name, {
                        ...data,
                        detail_date: clickedLabel
                    });
                    else if (clickedTime) return request(name, {
                        ...data,
                        detail_date: clickedDate,
                        detail_time: clickedTime
                    });
                    else return request(name, data);
                });
                const responses = await Promise.all(requests);
                const [channelsResponse, analyticsResponse, metricsResponse, peakActivityResponse, redirectionResponse] = responses;
                var payload = {
                    channels: channelsResponse[0],
                    analytics: analyticsResponse[0]?.data,
                    metrics: metricsResponse[0],
                    peakActivity: peakActivityResponse[0],
                    redirectionActivity: redirectionResponse[0]
                };
                if (redirection_id != null && metricsResponse[0]?.redirections.filter((redirection)=>redirection.id == redirection_id).length == 0) payload = {
                    ...payload,
                    metrics_id: null,
                    redirection_id: null
                };
                if (condition_id != null && metricsResponse[0].conditions.filter((condition)=>condition.id == condition_id).length == 0) payload = {
                    ...payload,
                    metrics_id: null,
                    condition_id: null
                };
                dispatch({
                    type: "setResultInformation",
                    payload: payload
                });
            } finally{
                dispatch({
                    type: "SET_LOADING",
                    payload: false
                });
            }
        };
        fetchData();
    }, [
        name,
        channel_type_id,
        firstPeriod.date_start,
        firstPeriod.date_end,
        condition_id,
        redirection_id,
        channel_id,
        clickedLabel,
        clickedTime
    ]);
}
var $7256b5c4828974ea$export$2e2bcd8739ae039 = $7256b5c4828974ea$var$useAnalyticsTopBarHookData;





var $cxTnx = parcelRequire("cxTnx");






var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");
function $8d067e9882ec5367$var$useAnalyticsModalDatePickerHook(dateRange) {
    const checkError = ()=>{
        const disabledButtonOrNot = ()=>{
            const button = document.querySelector(".content .button.validate");
            const inputsErrors = [
                ...document.querySelectorAll(".rdrInvalidDateInput")
            ];
            button.disabled = inputsErrors.length ? true : false;
        };
        setTimeout(disabledButtonOrNot, 100);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (dateRange == null) return null;
        const [inputStart, inputEnd] = [
            ...document.querySelectorAll(".rdrDateInput > input")
        ];
        inputStart.addEventListener("blur", checkError);
        inputEnd.addEventListener("blur", checkError);
        inputStart.classList.add("date_start");
        inputEnd.classList.add("date_end");
        return ()=>{
            inputStart.removeEventListener("blur", checkError);
            inputEnd.removeEventListener("blur", checkError);
        };
    }, []);
    return {
        checkError: checkError
    };
}
var $8d067e9882ec5367$export$2e2bcd8739ae039 = $8d067e9882ec5367$var$useAnalyticsModalDatePickerHook;






// Popup use to create or modificate a variable name / type
function $e4065528df528e84$var$AnalyticsModalDatePicker({ onClose: onClose }) {
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { firstPeriod: firstPeriod } = (0, $612615ca67331c5d$export$89605b40d8b4f599)();
    const onClick = ()=>{
        modal.resolve(state);
        return onClose();
    };
    const dateRange = (0, $bh6RR.useRef)();
    const { checkError: checkError } = (0, $8d067e9882ec5367$export$2e2bcd8739ae039)(dateRange);
    const { bots: bots } = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company");
    // Get the bot from url cause tired of pass him by component
    const pathsPiece = [
        ...window.location.pathname.split("/")
    ].filter((piece)=>piece);
    const botName = pathsPiece.pop();
    var bot = bots.filter((bot)=>bot.name == botName).pop();
    bot == bot == undefined || bot;
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() - 1);
    const minDate = new Date(bot?.created_at ?? new Date().setFullYear(new Date().getFullYear() - 10));
    //minDate.setDate(minDate.getDate() - 400)
    const startDate = new Date(firstPeriod.date_start);
    const endDate = new Date(firstPeriod.date_end);
    const [state, setState] = (0, $bh6RR.useState)([
        {
            startDate: startDate,
            endDate: endDate,
            key: "selection"
        }
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("form", {
        className: "variables_modal",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                className: "title",
                children: "Choose a Custom Period"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "area-edit",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $22a3ef5ef5ef755f$export$2e2bcd8739ae039), {
                    editableDateInputs: true,
                    onChange: (item)=>{
                        setState([
                            item.selection
                        ]);
                        checkError();
                    },
                    moveRangeOnFirstSelection: false,
                    ranges: state,
                    ref: dateRange,
                    maxDate: maxDate,
                    minDate: minDate,
                    shownDate: endDate,
                    rangeColors: [
                        "#65abf61a",
                        "#0e7aed",
                        "#65abf61a"
                    ],
                    navigatorRenderer: (0, $ab82b87e555e0e5c$export$2e2bcd8739ae039),
                    dateDisplayFormat: "dd/MM/yyyy",
                    direction: "horizontal"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                label: "Confirm",
                onClick: onClick
            })
        ]
    });
}
var $e4065528df528e84$export$2e2bcd8739ae039 = $e4065528df528e84$var$AnalyticsModalDatePicker;




function $06764d94b10785c2$var$AnalyticsTopBarAction(metrics) {
    const dispatch = (0, $612615ca67331c5d$export$2708059e7a8caa93)();
    const setValueDropdown = (name, value, func)=>{
        dispatch({
            type: "setResultInformation",
            payload: {
                [name]: value
            }
        });
        if (name == "channel_type_id") dispatch({
            type: "setResultInformation",
            payload: {
                ["channel_id"]: null
            }
        });
    };
    const setValueDropdownDate = async (name, value, state)=>{
        if (value == "custom") {
            const data = await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show("analytics-popup", {
                Component: (0, $e4065528df528e84$export$2e2bcd8739ae039)
            });
            var { startDate: startDate, endDate: endDate } = data[0];
            startDate = (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(startDate.getTime()).format("YYYY-MM-DD");
            endDate = (0, (/*@__PURE__*/$parcel$interopDefault($cxTnx)))(endDate.getTime()).format("YYYY-MM-DD");
            const payload = {
                periodChoice: "custom",
                firstPeriod: {
                    date_start: startDate,
                    date_end: endDate
                }
            };
            state.func({
                value: "custom",
                text: `${startDate} - ${endDate}`
            });
            dispatch({
                type: "setResultInformation",
                payload: payload
            });
            return;
        }
        const dates = (0, $492314d12994f680$export$4083acfb0660b3eb)(new Date(), (0, $86e52d87e3c3d7b1$export$2e2bcd8739ae039)[value]);
        const payload = {
            [name]: value,
            firstPeriod: {
                date_start: dates.start,
                date_end: dates.end
            }
        };
        dispatch({
            type: "setResultInformation",
            payload: payload
        });
    };
    const setValueDropdownMetric = (name, value, func)=>{
        var payload = {
            condition_id: null,
            redirection_id: null,
            metrics_id: null
        };
        if (value != null) {
            const [id, type] = value.split("-");
            payload = {
                ...payload,
                [type]: id,
                metrics_id: id
            };
            const typesMetrics = {
                condition_id: "conditions",
                redirection_id: "redirections"
            };
            var IndexMetricPrecise = metrics[typesMetrics[type]].findIndex((metric)=>metric.id == id);
            var data = metrics[typesMetrics[type]][IndexMetricPrecise];
            var max = 0;
            for(let key in data.values)for(let date in data.values[key]){
                if (data.values[key][date] > max) max = data.values[key][date];
                data.values[key][date] = 0;
            }
            metrics[typesMetrics[type]][IndexMetricPrecise].max = max;
            payload = {
                ...payload,
                ...metrics
            };
        }
        dispatch({
            type: "setResultInformation",
            payload: payload
        });
    };
    return {
        setValueDropdown: setValueDropdown,
        setValueDropdownDate: setValueDropdownDate,
        setValueDropdownMetric: setValueDropdownMetric
    };
}
var $06764d94b10785c2$export$2e2bcd8739ae039 = $06764d94b10785c2$var$AnalyticsTopBarAction;



var $bh6RR = parcelRequire("bh6RR");
function $4aa559ff01d5b628$var$AnalyticsTopBar({ name: name }) {
    const dispatch = (0, $612615ca67331c5d$export$2708059e7a8caa93)();
    const { channel_id: channel_id, firstPeriod: firstPeriod, channel_type_id: channel_type_id, periodChoice: periodChoice, channels: channels, metrics: metrics, condition_id: condition_id, redirection_id: redirection_id, metrics_id: metrics_id } = (0, $612615ca67331c5d$export$89605b40d8b4f599)();
    (0, $7256b5c4828974ea$export$2e2bcd8739ae039)(name, channel_type_id, firstPeriod, channel_id, condition_id, redirection_id);
    const { setValueDropdown: setValueDropdown, setValueDropdownDate: setValueDropdownDate, setValueDropdownMetric: setValueDropdownMetric } = (0, $06764d94b10785c2$export$2e2bcd8739ae039)(metrics);
    var channelsChoice = channels.map((channel)=>{
        return {
            value: channel.id,
            text: channel.channel_name,
            icon: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                className: "flag-icon flag-icon-fr",
                style: {
                    marginRight: 10
                }
            })
        };
    });
    channelsChoice = [
        {
            value: null,
            text: "All"
        },
        ...channelsChoice
    ];
    const metricsChoice = (0, $c0945ce29f1eac52$export$2e2bcd8739ae039)(metrics);
    const width = 380;
    var metric_id_fix = null; // par defaut on affiche "all metrics"
    /* //pour changer la valeur par defaut des metrics a afficher en arrivant sur la page
    var metric_id_fix = metrics_id;

    if (metrics_id != null && condition_id == metrics_id) {
        metric_id_fix = metric_id_fix + "-condition_id";
    }

    if (metrics_id != null && redirection_id == metrics_id) {
        metric_id_fix = metric_id_fix + "-redirection_id";
    }
    */ const TypesDurationForDropdown = [
        ...(0, $5f5f2e6367b716f2$export$2e2bcd8739ae039)
    ];
    const customChoice = periodChoice == "custom" ? {
        value: "custom",
        text: `${firstPeriod.date_start} - ${firstPeriod.date_end}`
    } : {
        value: "custom",
        text: "Custom period"
    };
    TypesDurationForDropdown.push(customChoice);
    var icon;
    if (channel_type_id == 2 || channel_type_id == 3) icon = (0, (/*@__PURE__*/$parcel$interopDefault($986e564353b9e0a7$exports)));
    if (channel_type_id == 1 || channel_type_id == 4) icon = (0, (/*@__PURE__*/$parcel$interopDefault($ae6a237c45c511ec$exports)));
    (0, $bh6RR.useEffect)(()=>{
        dispatch({
            type: "RESET_VIEW_TO_DATES"
        });
    }, [
        metrics_id,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "top_elements",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                    name: "periodChoice",
                    choices: TypesDurationForDropdown,
                    width: "280px",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($51167188b4b0cf43$exports))),
                    defaultChoice: periodChoice,
                    setValue: setValueDropdownDate,
                    hideSelectItem: false
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                    name: "channel_type_id",
                    choices: (0, $061adcb1a57556aa$export$2e2bcd8739ae039),
                    width: "220px",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4924e8ade90d6f74$exports))),
                    setValue: setValueDropdown
                })
            }),
            channel_type_id != null ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                    name: "channel_id",
                    className: "analytics_top_channels_dropdown",
                    choices: channelsChoice,
                    icon: icon,
                    width: "240px",
                    setValue: setValueDropdown
                })
            }) : null,
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    minWidth: width
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                    name: "metric_id",
                    choices: metricsChoice,
                    width: width,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($ec3c83de6a185323$exports))),
                    defaultChoice: metric_id_fix,
                    setValue: setValueDropdownMetric
                })
            })
        ]
    });
}
var $4aa559ff01d5b628$export$2e2bcd8739ae039 = $4aa559ff01d5b628$var$AnalyticsTopBar;



function $5db62bc1a17260e8$var$AnalyticsView({ name: name }) {
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const cells = [
        {
            column: "Name",
            name: "name",
            show: (value)=>(0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value)
        },
        {
            column: "Language",
            name: "language.slug",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: "flag-icon flag-icon-" + value.toLowerCase()
                })
        }
    ];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4aa559ff01d5b628$export$2e2bcd8739ae039), {
                name: name
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $71520a1540f25d04$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $622d10ce6fcda9af$export$2e2bcd8739ae039), {
                id: "analytics-popup"
            })
        ]
    });
}
var $5db62bc1a17260e8$export$2e2bcd8739ae039 = $5db62bc1a17260e8$var$AnalyticsView;










parcelRequire("bh6RR");
function $d0814407ce3a420f$var$AnalyticsDeleteForm({ firstPeriod: firstPeriod, periodChoice: periodChoice, channels: channels }) {
    var text = "";
    if (periodChoice === "custom") text = "since " + firstPeriod.date_start + " to " + firstPeriod.date_end;
    else if (periodChoice !== "all") text = `since last ${periodChoice}`;
    text += " for one of the following channel(s) ?";
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                children: [
                    "Do you really want to delete all analytics ",
                    text
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    padding: "0 100px"
                },
                children: channels.map((channel, index)=>{
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "row",
                            paddingTop: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                className: channel.value.length == "32" ? "fas fa-globe" : "fas fa-phone",
                                style: {
                                    fontSize: 27,
                                    color: "var(--main)"
                                }
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                style: {
                                    paddingLeft: 10,
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "16px",
                                    color: "var(--dark)"
                                },
                                children: [
                                    channel.value,
                                    " "
                                ]
                            })
                        ]
                    });
                })
            })
        ]
    });
}
function $d0814407ce3a420f$var$AnalyticsPageContent() {
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    var name = location.pathname.split("/").pop();
    const { is_admin: is_admin } = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("user");
    const { deleteAll: deleteAll } = (0, $bb4e77bbc51546c3$export$2e2bcd8739ae039);
    const { periodChoice: periodChoice, firstPeriod: firstPeriod, channels: channels } = (0, $612615ca67331c5d$export$89605b40d8b4f599)();
    const deleteAction = async ()=>{
        const body = {
            ...firstPeriod
        };
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete Analytics " + name,
            body: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($d0814407ce3a420f$var$AnalyticsDeleteForm, {
                periodChoice: periodChoice,
                firstPeriod: firstPeriod,
                channels: channels
            }),
            api: {
                request: deleteAll,
                param: [
                    name,
                    body
                ]
            },
            buttons: [
                {
                    className: "cancel",
                    label: "Cancel"
                },
                {
                    className: "validate",
                    label: "Yes",
                    type: "submit"
                }
            ],
            confirm: {
                name: channels,
                fieldName: "the channel"
            }
        }).then(()=>window.location.reload());
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: "Analytics " + name,
                children: is_admin && channels.length ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                    className: "error-iconButton delete_action main_add-button space_tableButton",
                    icon: "fas fa-trash",
                    onClick: deleteAction
                }) : null
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5db62bc1a17260e8$export$2e2bcd8739ae039), {
                name: name
            })
        ]
    });
}
function $d0814407ce3a420f$var$AnalyticsPage() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $612615ca67331c5d$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($d0814407ce3a420f$var$AnalyticsPageContent, {})
        })
    });
}
var $d0814407ce3a420f$export$2e2bcd8739ae039 = $d0814407ce3a420f$var$AnalyticsPage;




var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");












var $bh6RR = parcelRequire("bh6RR");




var $91781fdb5acb258d$export$2e2bcd8739ae039 = {
    getConversations: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("conversations/list", data),
    getMarkers: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`conversation/markers`, data),
    getRelaunch: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("botjob/list", data),
    getRelaunchID: (instance_id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`relaunch/${instance_id}`),
    getConversation: (instance_id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`conversation/${instance_id}`),
    deleteConversation: (instance_id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`conversation/${instance_id}`),
    deleteRelaunch: (instance_id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`botjob/${instance_id}`),
    deleteMarkerFromConversation: (marker_id, conversation_id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`conversations/${conversation_id}/marker/${marker_id}`),
    addMarkersToConversation: (data, conversation_id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`conversations/${conversation_id}/markers`, data),
    sendConversationByMail: (conversation_id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`conversations/mail-convo/${conversation_id}`)
};





function $a98a47e0813800fe$export$5a544e13ad4e1fa5(hex) {
    hex = hex.replace("#", "");
    // Divise la couleur hexadécimale en trois parties : R, G et B
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `${r}, ${g}, ${b}`;
}




const $178302845e817360$var$ConversationMarker = ({ marker: marker, mode: mode, className: className, style: style, onClick: onClick, icon: icon })=>{
    var color = (0, $a98a47e0813800fe$export$5a544e13ad4e1fa5)(marker.color);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        id: marker.id,
        style: style,
        className: className,
        children: [
            mode != 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    background: `rgba(${color}, 0.9)`
                },
                className: "marker_conversation_circle conversation_bubble_marker",
                title: marker.name
            }),
            mode == 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                id: marker.id,
                className: "marker_conversation_inline_main_container",
                title: marker.name,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "marker_conversation_inline_block_container",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            style: {
                                background: `rgba(${color}, 0.9)`,
                                marginRight: "0"
                            },
                            className: "marker_conversation_circle conversation_bubble_marker",
                            title: marker.name
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            className: "marker_conversation_inline_text",
                            children: marker.name
                        }),
                        icon != "" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                            className: "main-iconButton modalButtons-input icon_marker_conversation",
                            icon: icon,
                            onClick: onClick
                        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            style: {
                                height: "42px",
                                width: "45px"
                            }
                        })
                    ]
                })
            })
        ]
    });
};
var /**
        <div id={marker.id} >
                <div style={{ background: `rgba(${color}, 0.1)`, border: `solid 1px ${marker.color}`, cursor: "default" }} className='conversation_bubble_marker'>
                    <span className='conversation_bubble_marker_text' style={{ color: marker.color }}>{marker.name}</span>
                </div>
            </div>

            * */ $178302845e817360$export$2e2bcd8739ae039 = $178302845e817360$var$ConversationMarker;



var $bh6RR = parcelRequire("bh6RR");

function $00f7a8dfc6513112$var$useDashboards(id) {
    const [markers, setMarkers] = (0, $bh6RR.useState)(null);
    const { getMarkers: getMarkers } = (0, $91781fdb5acb258d$export$2e2bcd8739ae039);
    async function setUpMarkers() {
        const [response, errors] = await getMarkers(id);
        if (errors != null) {
            console.log(errors);
            return;
        }
        setMarkers(response);
    }
    (0, $bh6RR.useEffect)(()=>{
        setUpMarkers();
    }, []);
    return {
        markers: markers,
        setMarkers: setMarkers
    };
}
var $00f7a8dfc6513112$export$2e2bcd8739ae039 = $00f7a8dfc6513112$var$useDashboards;






var $47f201cbd9fb80ac$exports = {};
$47f201cbd9fb80ac$exports = new URL("scenario.94b0367b.svg", import.meta.url).toString();


var $1fee5a8fea268ee3$export$2e2bcd8739ae039 = {
    sms: (0, (/*@__PURE__*/$parcel$interopDefault($ae6a237c45c511ec$exports))),
    rcs: (0, (/*@__PURE__*/$parcel$interopDefault($c1a9e44ef4dfbd63$exports))),
    phone: (0, (/*@__PURE__*/$parcel$interopDefault($986e564353b9e0a7$exports))),
    mail: (0, (/*@__PURE__*/$parcel$interopDefault($ec781ed39d836b3e$exports))),
    scenario: (0, (/*@__PURE__*/$parcel$interopDefault($47f201cbd9fb80ac$exports)))
};



const $7a02280d6ba3fae9$var$ConversationModalFollowUp = ({ data: data, state: state })=>{
    const [conversation, setConversation] = (0, $bh6RR.useState)(data);
    const [listMarkerAdded, setListMarkerAdded] = (0, $bh6RR.useState)(conversation.markers);
    const { addMarkersToConversation: addMarkersToConversation, deleteMarkerFromConversation: deleteMarkerFromConversation } = (0, $91781fdb5acb258d$export$2e2bcd8739ae039);
    const { markers: markers, setMarkers: setMarkers } = (0, $00f7a8dfc6513112$export$2e2bcd8739ae039)(data.id);
    const [printAddSection, setPrintAddSection] = (0, $bh6RR.useState)(false);
    const [listMarkerToAdd, setListMarkerToAdd] = (0, $bh6RR.useState)([]);
    const dataCommons = [
        {
            name: "ID",
            value: state == 3 ? data.bot_job_id : data.id
        },
        {
            name: "Date",
            value: (0, $e2b536164b89f027$export$6dd95649f19af5f8)(state == 3 ? data.schedule : data.created_at, state == 3)
        },
        {
            name: "Bot",
            value: state == 3 ? data.bot.name : data.name
        }
    ];
    const onClickAddMarker = async (marker)=>{
        let dataToSend = {
            markers: marker.id.toString()
        };
        const [response, errors] = await addMarkersToConversation(dataToSend, conversation.id);
        if (errors != null) {
            console.log(errors);
            return;
        }
        let updatedMarkers = [
            ...listMarkerAdded,
            marker
        ];
        let _conversation = {
            ...conversation,
            markers: updatedMarkers
        };
        setListMarkerAdded(updatedMarkers);
        updateListMarkersAvailable(_conversation);
        setConversation(_conversation);
    };
    const onClickDeleteMarker = async (marker)=>{
        const [response, errors] = await deleteMarkerFromConversation(marker.id, conversation.id);
        if (errors != null) {
            console.log(errors);
            return;
        }
        let updatedMarkers = conversation.markers.filter((_marker)=>_marker.id !== marker.id);
        let _conversation = {
            ...conversation,
            markers: updatedMarkers
        };
        setConversation(_conversation);
        updateListMarkersAvailable(_conversation);
        setListMarkerAdded((current)=>current.filter((_m)=>{
                return _m.id !== marker.id;
            }));
    };
    const updateListMarkersAvailable = (_conversation)=>{
        let listMarkerIdUsed = _conversation.markers.map((marker)=>marker.id);
        let listMarkersAvailable = markers.filter((marker)=>!listMarkerIdUsed.includes(marker.id));
        setListMarkerToAdd(listMarkersAvailable);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (markers == null || conversation.markers == null) return;
        updateListMarkersAvailable(conversation);
    }, [
        markers
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "conversation_modal_content_detail",
        children: state == 1 || state == 2 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: "text-size",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: "Markers",
                        listLabelClassName: "titles-input"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "marker-container",
                        children: listMarkerAdded.map((marker)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $178302845e817360$export$2e2bcd8739ae039), {
                                marker: marker,
                                mode: 1,
                                icon: state == 2 ? "" : "fas fa-trash",
                                onClick: ()=>onClickDeleteMarker(marker)
                            }))
                    }),
                    state != 2 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "conversation_follow_up_separator"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                        label: "Add a new Marker",
                                        listLabelClassName: "titles-input"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                        className: "main-iconButton add-hover modalButtons-input",
                                        icon: (!printAddSection ? "fas fa-plus-circle" : "fas fa-minus-circle") + " content_detail_icon_add_marker",
                                        onClick: ()=>setPrintAddSection(!printAddSection)
                                    })
                                ]
                            })
                        ]
                    }),
                    printAddSection && state != 2 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
                        children: markers != null && listMarkerToAdd.length > 0 ? listMarkerToAdd.map((marker)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $178302845e817360$export$2e2bcd8739ae039), {
                                marker: marker,
                                mode: 1,
                                icon: state == 2 ? "" : "fas fa-plus-circle",
                                onClick: ()=>onClickAddMarker(marker)
                            })) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "conversation_follow_up_no_marker_message",
                            children: "There are no more markers available"
                        })
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "conversation_information_details_block_relaunch",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "container_element_block_relaunch",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            label: "Channel",
                            listLabelClassName: "titles-input text-bold"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "channel-icon-container",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                width: "30px",
                                style: {
                                    marginLeft: data.channel_type_id == 1 || data.bot_job_type?.name == "web" ? "-5px" : "0",
                                    marginTop: "7px"
                                },
                                srcSet: data.channel_type_id ? (0, $b3e51b95dcf04d66$export$2e2bcd8739ae039)[data.channel_type.name] : (0, $1fee5a8fea268ee3$export$2e2bcd8739ae039)[data.bot_job_type.name]
                            })
                        })
                    ]
                }),
                dataCommons.map((row)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "container_element_block_relaunch",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: row.name,
                                listLabelClassName: "titles-input"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: row.value,
                                listLabelClassName: "titles-input conversation_detail_text_input_value_weight"
                            })
                        ]
                    }))
            ]
        })
    });
};
var $7a02280d6ba3fae9$export$2e2bcd8739ae039 = $7a02280d6ba3fae9$var$ConversationModalFollowUp;










var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
"use client";
const $8ac51c03dfec543e$var$defaultIconDimensions = Object.freeze({
    left: 0,
    top: 0,
    width: 16,
    height: 16
});
const $8ac51c03dfec543e$var$defaultIconTransformations = Object.freeze({
    rotate: 0,
    vFlip: false,
    hFlip: false
});
const $8ac51c03dfec543e$var$defaultIconProps = Object.freeze({
    ...$8ac51c03dfec543e$var$defaultIconDimensions,
    ...$8ac51c03dfec543e$var$defaultIconTransformations
});
const $8ac51c03dfec543e$var$defaultExtendedIconProps = Object.freeze({
    ...$8ac51c03dfec543e$var$defaultIconProps,
    body: "",
    hidden: false
});
function $8ac51c03dfec543e$var$mergeIconTransformations(obj1, obj2) {
    const result = {};
    if (!obj1.hFlip !== !obj2.hFlip) result.hFlip = true;
    if (!obj1.vFlip !== !obj2.vFlip) result.vFlip = true;
    const rotate = ((obj1.rotate || 0) + (obj2.rotate || 0)) % 4;
    if (rotate) result.rotate = rotate;
    return result;
}
function $8ac51c03dfec543e$var$mergeIconData(parent, child) {
    const result = $8ac51c03dfec543e$var$mergeIconTransformations(parent, child);
    for(const key in $8ac51c03dfec543e$var$defaultExtendedIconProps){
        if (key in $8ac51c03dfec543e$var$defaultIconTransformations) {
            if (key in parent && !(key in result)) result[key] = $8ac51c03dfec543e$var$defaultIconTransformations[key];
        } else if (key in child) result[key] = child[key];
        else if (key in parent) result[key] = parent[key];
    }
    return result;
}
function $8ac51c03dfec543e$var$getIconsTree(data, names) {
    const icons = data.icons;
    const aliases = data.aliases || /* @__PURE__ */ Object.create(null);
    const resolved = /* @__PURE__ */ Object.create(null);
    function resolve(name) {
        if (icons[name]) return resolved[name] = [];
        if (!(name in resolved)) {
            resolved[name] = null;
            const parent = aliases[name] && aliases[name].parent;
            const value = parent && resolve(parent);
            if (value) resolved[name] = [
                parent
            ].concat(value);
        }
        return resolved[name];
    }
    Object.keys(icons).concat(Object.keys(aliases)).forEach(resolve);
    return resolved;
}
function $8ac51c03dfec543e$var$internalGetIconData(data, name, tree) {
    const icons = data.icons;
    const aliases = data.aliases || /* @__PURE__ */ Object.create(null);
    let currentProps = {};
    function parse(name2) {
        currentProps = $8ac51c03dfec543e$var$mergeIconData(icons[name2] || aliases[name2], currentProps);
    }
    parse(name);
    tree.forEach(parse);
    return $8ac51c03dfec543e$var$mergeIconData(data, currentProps);
}
function $8ac51c03dfec543e$var$parseIconSet(data, callback) {
    const names = [];
    if (typeof data !== "object" || typeof data.icons !== "object") return names;
    if (data.not_found instanceof Array) data.not_found.forEach((name)=>{
        callback(name, null);
        names.push(name);
    });
    const tree = $8ac51c03dfec543e$var$getIconsTree(data);
    for(const name in tree){
        const item = tree[name];
        if (item) {
            callback(name, $8ac51c03dfec543e$var$internalGetIconData(data, name, item));
            names.push(name);
        }
    }
    return names;
}
const $8ac51c03dfec543e$var$optionalPropertyDefaults = {
    provider: "",
    aliases: {},
    not_found: {},
    ...$8ac51c03dfec543e$var$defaultIconDimensions
};
function $8ac51c03dfec543e$var$checkOptionalProps(item, defaults) {
    for(const prop in defaults){
        if (prop in item && typeof item[prop] !== typeof defaults[prop]) return false;
    }
    return true;
}
function $8ac51c03dfec543e$var$quicklyValidateIconSet(obj) {
    if (typeof obj !== "object" || obj === null) return null;
    const data = obj;
    if (typeof data.prefix !== "string" || !obj.icons || typeof obj.icons !== "object") return null;
    if (!$8ac51c03dfec543e$var$checkOptionalProps(obj, $8ac51c03dfec543e$var$optionalPropertyDefaults)) return null;
    const icons = data.icons;
    for(const name in icons){
        const icon = icons[name];
        if (// Name cannot be empty
        !name || // Must have body
        typeof icon.body !== "string" || // Check other props
        !$8ac51c03dfec543e$var$checkOptionalProps(icon, $8ac51c03dfec543e$var$defaultExtendedIconProps)) return null;
    }
    const aliases = data.aliases || /* @__PURE__ */ Object.create(null);
    for(const name in aliases){
        const icon = aliases[name];
        const parent = icon.parent;
        if (// Name cannot be empty
        !name || // Parent must be set and point to existing icon
        typeof parent !== "string" || !icons[parent] && !aliases[parent] || // Check other props
        !$8ac51c03dfec543e$var$checkOptionalProps(icon, $8ac51c03dfec543e$var$defaultExtendedIconProps)) return null;
    }
    return data;
}
const $8ac51c03dfec543e$var$matchIconName = /^[a-z0-9]+(-[a-z0-9]+)*$/;
const $8ac51c03dfec543e$var$stringToIcon = (value, validate, allowSimpleName, provider = "")=>{
    const colonSeparated = value.split(":");
    if (value.slice(0, 1) === "@") {
        if (colonSeparated.length < 2 || colonSeparated.length > 3) return null;
        provider = colonSeparated.shift().slice(1);
    }
    if (colonSeparated.length > 3 || !colonSeparated.length) return null;
    if (colonSeparated.length > 1) {
        const name2 = colonSeparated.pop();
        const prefix = colonSeparated.pop();
        const result = {
            // Allow provider without '@': "provider:prefix:name"
            provider: colonSeparated.length > 0 ? colonSeparated[0] : provider,
            prefix: prefix,
            name: name2
        };
        return validate && !$8ac51c03dfec543e$var$validateIconName(result) ? null : result;
    }
    const name = colonSeparated[0];
    const dashSeparated = name.split("-");
    if (dashSeparated.length > 1) {
        const result = {
            provider: provider,
            prefix: dashSeparated.shift(),
            name: dashSeparated.join("-")
        };
        return validate && !$8ac51c03dfec543e$var$validateIconName(result) ? null : result;
    }
    if (allowSimpleName && provider === "") {
        const result = {
            provider: provider,
            prefix: "",
            name: name
        };
        return validate && !$8ac51c03dfec543e$var$validateIconName(result, allowSimpleName) ? null : result;
    }
    return null;
};
const $8ac51c03dfec543e$var$validateIconName = (icon, allowSimpleName)=>{
    if (!icon) return false;
    return !!// Check name: cannot be empty
    ((allowSimpleName && icon.prefix === "" || !!icon.prefix) && !!icon.name);
};
const $8ac51c03dfec543e$var$dataStorage = /* @__PURE__ */ Object.create(null);
function $8ac51c03dfec543e$var$newStorage(provider, prefix) {
    return {
        provider: provider,
        prefix: prefix,
        icons: /* @__PURE__ */ Object.create(null),
        missing: /* @__PURE__ */ new Set()
    };
}
function $8ac51c03dfec543e$var$getStorage(provider, prefix) {
    const providerStorage = $8ac51c03dfec543e$var$dataStorage[provider] || ($8ac51c03dfec543e$var$dataStorage[provider] = /* @__PURE__ */ Object.create(null));
    return providerStorage[prefix] || (providerStorage[prefix] = $8ac51c03dfec543e$var$newStorage(provider, prefix));
}
function $8ac51c03dfec543e$var$addIconSet(storage, data) {
    if (!$8ac51c03dfec543e$var$quicklyValidateIconSet(data)) return [];
    return $8ac51c03dfec543e$var$parseIconSet(data, (name, icon)=>{
        if (icon) storage.icons[name] = icon;
        else storage.missing.add(name);
    });
}
function $8ac51c03dfec543e$var$addIconToStorage(storage, name, icon) {
    try {
        if (typeof icon.body === "string") {
            storage.icons[name] = {
                ...icon
            };
            return true;
        }
    } catch (err) {}
    return false;
}
function $8ac51c03dfec543e$export$a598a3910899291f(provider, prefix) {
    let allIcons = [];
    const providers = typeof provider === "string" ? [
        provider
    ] : Object.keys($8ac51c03dfec543e$var$dataStorage);
    providers.forEach((provider2)=>{
        const prefixes = typeof provider2 === "string" && typeof prefix === "string" ? [
            prefix
        ] : Object.keys($8ac51c03dfec543e$var$dataStorage[provider2] || {});
        prefixes.forEach((prefix2)=>{
            const storage = $8ac51c03dfec543e$var$getStorage(provider2, prefix2);
            allIcons = allIcons.concat(Object.keys(storage.icons).map((name)=>(provider2 !== "" ? "@" + provider2 + ":" : "") + prefix2 + ":" + name));
        });
    });
    return allIcons;
}
let $8ac51c03dfec543e$var$simpleNames = false;
function $8ac51c03dfec543e$var$allowSimpleNames(allow) {
    if (typeof allow === "boolean") $8ac51c03dfec543e$var$simpleNames = allow;
    return $8ac51c03dfec543e$var$simpleNames;
}
function $8ac51c03dfec543e$var$getIconData(name) {
    const icon = typeof name === "string" ? $8ac51c03dfec543e$var$stringToIcon(name, true, $8ac51c03dfec543e$var$simpleNames) : name;
    if (icon) {
        const storage = $8ac51c03dfec543e$var$getStorage(icon.provider, icon.prefix);
        const iconName = icon.name;
        return storage.icons[iconName] || (storage.missing.has(iconName) ? null : void 0);
    }
}
function $8ac51c03dfec543e$export$3488242433cbedb(name, data) {
    const icon = $8ac51c03dfec543e$var$stringToIcon(name, true, $8ac51c03dfec543e$var$simpleNames);
    if (!icon) return false;
    const storage = $8ac51c03dfec543e$var$getStorage(icon.provider, icon.prefix);
    if (data) return $8ac51c03dfec543e$var$addIconToStorage(storage, icon.name, data);
    else {
        storage.missing.add(icon.name);
        return true;
    }
}
function $8ac51c03dfec543e$export$933f273b2a11730f(data, provider) {
    if (typeof data !== "object") return false;
    if (typeof provider !== "string") provider = data.provider || "";
    if ($8ac51c03dfec543e$var$simpleNames && !provider && !data.prefix) {
        let added = false;
        if ($8ac51c03dfec543e$var$quicklyValidateIconSet(data)) {
            data.prefix = "";
            $8ac51c03dfec543e$var$parseIconSet(data, (name, icon)=>{
                if ($8ac51c03dfec543e$export$3488242433cbedb(name, icon)) added = true;
            });
        }
        return added;
    }
    const prefix = data.prefix;
    if (!$8ac51c03dfec543e$var$validateIconName({
        prefix: prefix,
        name: "a"
    })) return false;
    const storage = $8ac51c03dfec543e$var$getStorage(provider, prefix);
    return !!$8ac51c03dfec543e$var$addIconSet(storage, data);
}
function $8ac51c03dfec543e$export$26bbc7c9bc8e9ac3(name) {
    return !!$8ac51c03dfec543e$var$getIconData(name);
}
function $8ac51c03dfec543e$export$16b26cd5e98d9100(name) {
    const result = $8ac51c03dfec543e$var$getIconData(name);
    return result ? {
        ...$8ac51c03dfec543e$var$defaultIconProps,
        ...result
    } : result;
}
const $8ac51c03dfec543e$var$defaultIconSizeCustomisations = Object.freeze({
    width: null,
    height: null
});
const $8ac51c03dfec543e$var$defaultIconCustomisations = Object.freeze({
    // Dimensions
    ...$8ac51c03dfec543e$var$defaultIconSizeCustomisations,
    // Transformations
    ...$8ac51c03dfec543e$var$defaultIconTransformations
});
const $8ac51c03dfec543e$var$unitsSplit = /(-?[0-9.]*[0-9]+[0-9.]*)/g;
const $8ac51c03dfec543e$var$unitsTest = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function $8ac51c03dfec543e$export$907c7b8171f13ef1(size, ratio, precision) {
    if (ratio === 1) return size;
    precision = precision || 100;
    if (typeof size === "number") return Math.ceil(size * ratio * precision) / precision;
    if (typeof size !== "string") return size;
    const oldParts = size.split($8ac51c03dfec543e$var$unitsSplit);
    if (oldParts === null || !oldParts.length) return size;
    const newParts = [];
    let code = oldParts.shift();
    let isNumber = $8ac51c03dfec543e$var$unitsTest.test(code);
    while(true){
        if (isNumber) {
            const num = parseFloat(code);
            if (isNaN(num)) newParts.push(code);
            else newParts.push(Math.ceil(num * ratio * precision) / precision);
        } else newParts.push(code);
        code = oldParts.shift();
        if (code === void 0) return newParts.join("");
        isNumber = !isNumber;
    }
}
function $8ac51c03dfec543e$var$splitSVGDefs(content, tag = "defs") {
    let defs = "";
    const index = content.indexOf("<" + tag);
    while(index >= 0){
        const start = content.indexOf(">", index);
        const end = content.indexOf("</" + tag);
        if (start === -1 || end === -1) break;
        const endEnd = content.indexOf(">", end);
        if (endEnd === -1) break;
        defs += content.slice(start + 1, end).trim();
        content = content.slice(0, index).trim() + content.slice(endEnd + 1);
    }
    return {
        defs: defs,
        content: content
    };
}
function $8ac51c03dfec543e$var$mergeDefsAndContent(defs, content) {
    return defs ? "<defs>" + defs + "</defs>" + content : content;
}
function $8ac51c03dfec543e$var$wrapSVGContent(body, start, end) {
    const split = $8ac51c03dfec543e$var$splitSVGDefs(body);
    return $8ac51c03dfec543e$var$mergeDefsAndContent(split.defs, start + split.content + end);
}
const $8ac51c03dfec543e$var$isUnsetKeyword = (value)=>value === "unset" || value === "undefined" || value === "none";
function $8ac51c03dfec543e$export$78c1051fc6863a0b(icon, customisations) {
    const fullIcon = {
        ...$8ac51c03dfec543e$var$defaultIconProps,
        ...icon
    };
    const fullCustomisations = {
        ...$8ac51c03dfec543e$var$defaultIconCustomisations,
        ...customisations
    };
    const box = {
        left: fullIcon.left,
        top: fullIcon.top,
        width: fullIcon.width,
        height: fullIcon.height
    };
    let body = fullIcon.body;
    [
        fullIcon,
        fullCustomisations
    ].forEach((props)=>{
        const transformations = [];
        const hFlip = props.hFlip;
        const vFlip = props.vFlip;
        let rotation = props.rotate;
        if (hFlip) {
            if (vFlip) rotation += 2;
            else {
                transformations.push("translate(" + (box.width + box.left).toString() + " " + (0 - box.top).toString() + ")");
                transformations.push("scale(-1 1)");
                box.top = box.left = 0;
            }
        } else if (vFlip) {
            transformations.push("translate(" + (0 - box.left).toString() + " " + (box.height + box.top).toString() + ")");
            transformations.push("scale(1 -1)");
            box.top = box.left = 0;
        }
        let tempValue;
        if (rotation < 0) rotation -= Math.floor(rotation / 4) * 4;
        rotation = rotation % 4;
        switch(rotation){
            case 1:
                tempValue = box.height / 2 + box.top;
                transformations.unshift("rotate(90 " + tempValue.toString() + " " + tempValue.toString() + ")");
                break;
            case 2:
                transformations.unshift("rotate(180 " + (box.width / 2 + box.left).toString() + " " + (box.height / 2 + box.top).toString() + ")");
                break;
            case 3:
                tempValue = box.width / 2 + box.left;
                transformations.unshift("rotate(-90 " + tempValue.toString() + " " + tempValue.toString() + ")");
                break;
        }
        if (rotation % 2 === 1) {
            if (box.left !== box.top) {
                tempValue = box.left;
                box.left = box.top;
                box.top = tempValue;
            }
            if (box.width !== box.height) {
                tempValue = box.width;
                box.width = box.height;
                box.height = tempValue;
            }
        }
        if (transformations.length) body = $8ac51c03dfec543e$var$wrapSVGContent(body, '<g transform="' + transformations.join(" ") + '">', "</g>");
    });
    const customisationsWidth = fullCustomisations.width;
    const customisationsHeight = fullCustomisations.height;
    const boxWidth = box.width;
    const boxHeight = box.height;
    let width;
    let height;
    if (customisationsWidth === null) {
        height = customisationsHeight === null ? "1em" : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
        width = $8ac51c03dfec543e$export$907c7b8171f13ef1(height, boxWidth / boxHeight);
    } else {
        width = customisationsWidth === "auto" ? boxWidth : customisationsWidth;
        height = customisationsHeight === null ? $8ac51c03dfec543e$export$907c7b8171f13ef1(width, boxHeight / boxWidth) : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
    }
    const attributes = {};
    const setAttr = (prop, value)=>{
        if (!$8ac51c03dfec543e$var$isUnsetKeyword(value)) attributes[prop] = value.toString();
    };
    setAttr("width", width);
    setAttr("height", height);
    const viewBox = [
        box.left,
        box.top,
        boxWidth,
        boxHeight
    ];
    attributes.viewBox = viewBox.join(" ");
    return {
        attributes: attributes,
        viewBox: viewBox,
        body: body
    };
}
const $8ac51c03dfec543e$var$regex = /\sid="(\S+)"/g;
const $8ac51c03dfec543e$var$randomPrefix = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let $8ac51c03dfec543e$var$counter = 0;
function $8ac51c03dfec543e$export$cae0fa3719aa5dc4(body, prefix = $8ac51c03dfec543e$var$randomPrefix) {
    const ids = [];
    let match;
    while(match = $8ac51c03dfec543e$var$regex.exec(body))ids.push(match[1]);
    if (!ids.length) return body;
    const suffix = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
    ids.forEach((id)=>{
        const newID = typeof prefix === "function" ? prefix(id) : prefix + ($8ac51c03dfec543e$var$counter++).toString();
        const escapedID = id.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        body = body.replace(// Allowed characters before id: [#;"]
        // Allowed characters after id: [)"], .[a-z]
        new RegExp('([#;"])(' + escapedID + ')([")]|\\.[a-z])', "g"), "$1" + newID + suffix + "$3");
    });
    body = body.replace(new RegExp(suffix, "g"), "");
    return body;
}
const $8ac51c03dfec543e$var$storage = /* @__PURE__ */ Object.create(null);
function $8ac51c03dfec543e$var$setAPIModule(provider, item) {
    $8ac51c03dfec543e$var$storage[provider] = item;
}
function $8ac51c03dfec543e$var$getAPIModule(provider) {
    return $8ac51c03dfec543e$var$storage[provider] || $8ac51c03dfec543e$var$storage[""];
}
function $8ac51c03dfec543e$var$createAPIConfig(source) {
    let resources;
    if (typeof source.resources === "string") resources = [
        source.resources
    ];
    else {
        resources = source.resources;
        if (!(resources instanceof Array) || !resources.length) return null;
    }
    const result = {
        resources: // API hosts
        resources,
        // Root path
        path: source.path || "/",
        // URL length limit
        maxURL: source.maxURL || 500,
        // Timeout before next host is used.
        rotate: source.rotate || 750,
        // Timeout before failing query.
        timeout: source.timeout || 5e3,
        // Randomise default API end point.
        random: source.random === true,
        // Start index
        index: source.index || 0,
        // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
        dataAfterTimeout: source.dataAfterTimeout !== false
    };
    return result;
}
const $8ac51c03dfec543e$var$configStorage = /* @__PURE__ */ Object.create(null);
const $8ac51c03dfec543e$var$fallBackAPISources = [
    "https://api.simplesvg.com",
    "https://api.unisvg.com"
];
const $8ac51c03dfec543e$var$fallBackAPI = [];
while($8ac51c03dfec543e$var$fallBackAPISources.length > 0){
    if ($8ac51c03dfec543e$var$fallBackAPISources.length === 1) $8ac51c03dfec543e$var$fallBackAPI.push($8ac51c03dfec543e$var$fallBackAPISources.shift());
    else if (Math.random() > 0.5) $8ac51c03dfec543e$var$fallBackAPI.push($8ac51c03dfec543e$var$fallBackAPISources.shift());
    else $8ac51c03dfec543e$var$fallBackAPI.push($8ac51c03dfec543e$var$fallBackAPISources.pop());
}
$8ac51c03dfec543e$var$configStorage[""] = $8ac51c03dfec543e$var$createAPIConfig({
    resources: [
        "https://api.iconify.design"
    ].concat($8ac51c03dfec543e$var$fallBackAPI)
});
function $8ac51c03dfec543e$export$ddfda4eca64d59f6(provider, customConfig) {
    const config = $8ac51c03dfec543e$var$createAPIConfig(customConfig);
    if (config === null) return false;
    $8ac51c03dfec543e$var$configStorage[provider] = config;
    return true;
}
function $8ac51c03dfec543e$var$getAPIConfig(provider) {
    return $8ac51c03dfec543e$var$configStorage[provider];
}
function $8ac51c03dfec543e$var$listAPIProviders() {
    return Object.keys($8ac51c03dfec543e$var$configStorage);
}
const $8ac51c03dfec543e$var$detectFetch = ()=>{
    let callback;
    try {
        callback = fetch;
        if (typeof callback === "function") return callback;
    } catch (err) {}
};
let $8ac51c03dfec543e$var$fetchModule = $8ac51c03dfec543e$var$detectFetch();
function $8ac51c03dfec543e$var$setFetch(fetch2) {
    $8ac51c03dfec543e$var$fetchModule = fetch2;
}
function $8ac51c03dfec543e$var$getFetch() {
    return $8ac51c03dfec543e$var$fetchModule;
}
function $8ac51c03dfec543e$var$calculateMaxLength(provider, prefix) {
    const config = $8ac51c03dfec543e$var$getAPIConfig(provider);
    if (!config) return 0;
    let result;
    if (!config.maxURL) result = 0;
    else {
        let maxHostLength = 0;
        config.resources.forEach((item)=>{
            const host = item;
            maxHostLength = Math.max(maxHostLength, host.length);
        });
        const url = prefix + ".json?icons=";
        result = config.maxURL - maxHostLength - config.path.length - url.length;
    }
    return result;
}
function $8ac51c03dfec543e$var$shouldAbort(status) {
    return status === 404;
}
const $8ac51c03dfec543e$var$prepare = (provider, prefix, icons)=>{
    const results = [];
    const maxLength = $8ac51c03dfec543e$var$calculateMaxLength(provider, prefix);
    const type = "icons";
    let item = {
        type: type,
        provider: provider,
        prefix: prefix,
        icons: []
    };
    let length = 0;
    icons.forEach((name, index)=>{
        length += name.length + 1;
        if (length >= maxLength && index > 0) {
            results.push(item);
            item = {
                type: type,
                provider: provider,
                prefix: prefix,
                icons: []
            };
            length = name.length;
        }
        item.icons.push(name);
    });
    results.push(item);
    return results;
};
function $8ac51c03dfec543e$var$getPath(provider) {
    if (typeof provider === "string") {
        const config = $8ac51c03dfec543e$var$getAPIConfig(provider);
        if (config) return config.path;
    }
    return "/";
}
const $8ac51c03dfec543e$var$send = (host, params, callback)=>{
    if (!$8ac51c03dfec543e$var$fetchModule) {
        callback("abort", 424);
        return;
    }
    let path = $8ac51c03dfec543e$var$getPath(params.provider);
    switch(params.type){
        case "icons":
            {
                const prefix = params.prefix;
                const icons = params.icons;
                const iconsList = icons.join(",");
                const urlParams = new URLSearchParams({
                    icons: iconsList
                });
                path += prefix + ".json?" + urlParams.toString();
                break;
            }
        case "custom":
            {
                const uri = params.uri;
                path += uri.slice(0, 1) === "/" ? uri.slice(1) : uri;
                break;
            }
        default:
            callback("abort", 400);
            return;
    }
    let defaultError = 503;
    $8ac51c03dfec543e$var$fetchModule(host + path).then((response)=>{
        const status = response.status;
        if (status !== 200) {
            setTimeout(()=>{
                callback($8ac51c03dfec543e$var$shouldAbort(status) ? "abort" : "next", status);
            });
            return;
        }
        defaultError = 501;
        return response.json();
    }).then((data)=>{
        if (typeof data !== "object" || data === null) {
            setTimeout(()=>{
                if (data === 404) callback("abort", data);
                else callback("next", defaultError);
            });
            return;
        }
        setTimeout(()=>{
            callback("success", data);
        });
    }).catch(()=>{
        callback("next", defaultError);
    });
};
const $8ac51c03dfec543e$var$fetchAPIModule = {
    prepare: $8ac51c03dfec543e$var$prepare,
    send: $8ac51c03dfec543e$var$send
};
function $8ac51c03dfec543e$var$sortIcons(icons) {
    const result = {
        loaded: [],
        missing: [],
        pending: []
    };
    const storage = /* @__PURE__ */ Object.create(null);
    icons.sort((a, b)=>{
        if (a.provider !== b.provider) return a.provider.localeCompare(b.provider);
        if (a.prefix !== b.prefix) return a.prefix.localeCompare(b.prefix);
        return a.name.localeCompare(b.name);
    });
    let lastIcon = {
        provider: "",
        prefix: "",
        name: ""
    };
    icons.forEach((icon)=>{
        if (lastIcon.name === icon.name && lastIcon.prefix === icon.prefix && lastIcon.provider === icon.provider) return;
        lastIcon = icon;
        const provider = icon.provider;
        const prefix = icon.prefix;
        const name = icon.name;
        const providerStorage = storage[provider] || (storage[provider] = /* @__PURE__ */ Object.create(null));
        const localStorage = providerStorage[prefix] || (providerStorage[prefix] = $8ac51c03dfec543e$var$getStorage(provider, prefix));
        let list;
        if (name in localStorage.icons) list = result.loaded;
        else if (prefix === "" || localStorage.missing.has(name)) list = result.missing;
        else list = result.pending;
        const item = {
            provider: provider,
            prefix: prefix,
            name: name
        };
        list.push(item);
    });
    return result;
}
function $8ac51c03dfec543e$var$removeCallback(storages, id) {
    storages.forEach((storage)=>{
        const items = storage.loaderCallbacks;
        if (items) storage.loaderCallbacks = items.filter((row)=>row.id !== id);
    });
}
function $8ac51c03dfec543e$var$updateCallbacks(storage) {
    if (!storage.pendingCallbacksFlag) {
        storage.pendingCallbacksFlag = true;
        setTimeout(()=>{
            storage.pendingCallbacksFlag = false;
            const items = storage.loaderCallbacks ? storage.loaderCallbacks.slice(0) : [];
            if (!items.length) return;
            let hasPending = false;
            const provider = storage.provider;
            const prefix = storage.prefix;
            items.forEach((item)=>{
                const icons = item.icons;
                const oldLength = icons.pending.length;
                icons.pending = icons.pending.filter((icon)=>{
                    if (icon.prefix !== prefix) return true;
                    const name = icon.name;
                    if (storage.icons[name]) icons.loaded.push({
                        provider: provider,
                        prefix: prefix,
                        name: name
                    });
                    else if (storage.missing.has(name)) icons.missing.push({
                        provider: provider,
                        prefix: prefix,
                        name: name
                    });
                    else {
                        hasPending = true;
                        return true;
                    }
                    return false;
                });
                if (icons.pending.length !== oldLength) {
                    if (!hasPending) $8ac51c03dfec543e$var$removeCallback([
                        storage
                    ], item.id);
                    item.callback(icons.loaded.slice(0), icons.missing.slice(0), icons.pending.slice(0), item.abort);
                }
            });
        });
    }
}
let $8ac51c03dfec543e$var$idCounter = 0;
function $8ac51c03dfec543e$var$storeCallback(callback, icons, pendingSources) {
    const id = $8ac51c03dfec543e$var$idCounter++;
    const abort = $8ac51c03dfec543e$var$removeCallback.bind(null, pendingSources, id);
    if (!icons.pending.length) return abort;
    const item = {
        id: id,
        icons: icons,
        callback: callback,
        abort: abort
    };
    pendingSources.forEach((storage)=>{
        (storage.loaderCallbacks || (storage.loaderCallbacks = [])).push(item);
    });
    return abort;
}
function $8ac51c03dfec543e$var$listToIcons(list, validate = true, simpleNames = false) {
    const result = [];
    list.forEach((item)=>{
        const icon = typeof item === "string" ? $8ac51c03dfec543e$var$stringToIcon(item, validate, simpleNames) : item;
        if (icon) result.push(icon);
    });
    return result;
}
// src/config.ts
var $8ac51c03dfec543e$var$defaultConfig = {
    resources: [],
    index: 0,
    timeout: 2e3,
    rotate: 750,
    random: false,
    dataAfterTimeout: false
};
// src/query.ts
function $8ac51c03dfec543e$var$sendQuery(config, payload, query, done) {
    const resourcesCount = config.resources.length;
    const startIndex = config.random ? Math.floor(Math.random() * resourcesCount) : config.index;
    let resources;
    if (config.random) {
        let list = config.resources.slice(0);
        resources = [];
        while(list.length > 1){
            const nextIndex = Math.floor(Math.random() * list.length);
            resources.push(list[nextIndex]);
            list = list.slice(0, nextIndex).concat(list.slice(nextIndex + 1));
        }
        resources = resources.concat(list);
    } else resources = config.resources.slice(startIndex).concat(config.resources.slice(0, startIndex));
    const startTime = Date.now();
    let status = "pending";
    let queriesSent = 0;
    let lastError;
    let timer = null;
    let queue = [];
    let doneCallbacks = [];
    if (typeof done === "function") doneCallbacks.push(done);
    function resetTimer() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }
    function abort() {
        if (status === "pending") status = "aborted";
        resetTimer();
        queue.forEach((item)=>{
            if (item.status === "pending") item.status = "aborted";
        });
        queue = [];
    }
    function subscribe(callback, overwrite) {
        if (overwrite) doneCallbacks = [];
        if (typeof callback === "function") doneCallbacks.push(callback);
    }
    function getQueryStatus() {
        return {
            startTime: startTime,
            payload: payload,
            status: status,
            queriesSent: queriesSent,
            queriesPending: queue.length,
            subscribe: subscribe,
            abort: abort
        };
    }
    function failQuery() {
        status = "failed";
        doneCallbacks.forEach((callback)=>{
            callback(void 0, lastError);
        });
    }
    function clearQueue() {
        queue.forEach((item)=>{
            if (item.status === "pending") item.status = "aborted";
        });
        queue = [];
    }
    function moduleResponse(item, response, data) {
        const isError = response !== "success";
        queue = queue.filter((queued)=>queued !== item);
        switch(status){
            case "pending":
                break;
            case "failed":
                if (isError || !config.dataAfterTimeout) return;
                break;
            default:
                return;
        }
        if (response === "abort") {
            lastError = data;
            failQuery();
            return;
        }
        if (isError) {
            lastError = data;
            if (!queue.length) {
                if (!resources.length) failQuery();
                else execNext();
            }
            return;
        }
        resetTimer();
        clearQueue();
        if (!config.random) {
            const index = config.resources.indexOf(item.resource);
            if (index !== -1 && index !== config.index) config.index = index;
        }
        status = "completed";
        doneCallbacks.forEach((callback)=>{
            callback(data);
        });
    }
    function execNext() {
        if (status !== "pending") return;
        resetTimer();
        const resource = resources.shift();
        if (resource === void 0) {
            if (queue.length) {
                timer = setTimeout(()=>{
                    resetTimer();
                    if (status === "pending") {
                        clearQueue();
                        failQuery();
                    }
                }, config.timeout);
                return;
            }
            failQuery();
            return;
        }
        const item = {
            status: "pending",
            resource: resource,
            callback: (status2, data)=>{
                moduleResponse(item, status2, data);
            }
        };
        queue.push(item);
        queriesSent++;
        timer = setTimeout(execNext, config.rotate);
        query(resource, payload, item.callback);
    }
    setTimeout(execNext);
    return getQueryStatus;
}
// src/index.ts
function $8ac51c03dfec543e$var$initRedundancy(cfg) {
    const config = {
        ...$8ac51c03dfec543e$var$defaultConfig,
        ...cfg
    };
    let queries = [];
    function cleanup() {
        queries = queries.filter((item)=>item().status === "pending");
    }
    function query(payload, queryCallback, doneCallback) {
        const query2 = $8ac51c03dfec543e$var$sendQuery(config, payload, queryCallback, (data, error)=>{
            cleanup();
            if (doneCallback) doneCallback(data, error);
        });
        queries.push(query2);
        return query2;
    }
    function find(callback) {
        return queries.find((value)=>{
            return callback(value);
        }) || null;
    }
    const instance = {
        query: query,
        find: find,
        setIndex: (index)=>{
            config.index = index;
        },
        getIndex: ()=>config.index,
        cleanup: cleanup
    };
    return instance;
}
function $8ac51c03dfec543e$var$emptyCallback$1() {}
const $8ac51c03dfec543e$var$redundancyCache = /* @__PURE__ */ Object.create(null);
function $8ac51c03dfec543e$var$getRedundancyCache(provider) {
    if (!$8ac51c03dfec543e$var$redundancyCache[provider]) {
        const config = $8ac51c03dfec543e$var$getAPIConfig(provider);
        if (!config) return;
        const redundancy = $8ac51c03dfec543e$var$initRedundancy(config);
        const cachedReundancy = {
            config: config,
            redundancy: redundancy
        };
        $8ac51c03dfec543e$var$redundancyCache[provider] = cachedReundancy;
    }
    return $8ac51c03dfec543e$var$redundancyCache[provider];
}
function $8ac51c03dfec543e$var$sendAPIQuery(target, query, callback) {
    let redundancy;
    let send;
    if (typeof target === "string") {
        const api = $8ac51c03dfec543e$var$getAPIModule(target);
        if (!api) {
            callback(void 0, 424);
            return $8ac51c03dfec543e$var$emptyCallback$1;
        }
        send = api.send;
        const cached = $8ac51c03dfec543e$var$getRedundancyCache(target);
        if (cached) redundancy = cached.redundancy;
    } else {
        const config = $8ac51c03dfec543e$var$createAPIConfig(target);
        if (config) {
            redundancy = $8ac51c03dfec543e$var$initRedundancy(config);
            const moduleKey = target.resources ? target.resources[0] : "";
            const api = $8ac51c03dfec543e$var$getAPIModule(moduleKey);
            if (api) send = api.send;
        }
    }
    if (!redundancy || !send) {
        callback(void 0, 424);
        return $8ac51c03dfec543e$var$emptyCallback$1;
    }
    return redundancy.query(query, send, callback)().abort;
}
function $8ac51c03dfec543e$var$emptyCallback() {}
function $8ac51c03dfec543e$var$loadedNewIcons(storage) {
    if (!storage.iconsLoaderFlag) {
        storage.iconsLoaderFlag = true;
        setTimeout(()=>{
            storage.iconsLoaderFlag = false;
            $8ac51c03dfec543e$var$updateCallbacks(storage);
        });
    }
}
function $8ac51c03dfec543e$var$checkIconNamesForAPI(icons) {
    const valid = [];
    const invalid = [];
    icons.forEach((name)=>{
        (name.match($8ac51c03dfec543e$var$matchIconName) ? valid : invalid).push(name);
    });
    return {
        valid: valid,
        invalid: invalid
    };
}
function $8ac51c03dfec543e$var$parseLoaderResponse(storage, icons, data) {
    function checkMissing() {
        const pending = storage.pendingIcons;
        icons.forEach((name)=>{
            if (pending) pending.delete(name);
            if (!storage.icons[name]) storage.missing.add(name);
        });
    }
    if (data && typeof data === "object") try {
        const parsed = $8ac51c03dfec543e$var$addIconSet(storage, data);
        if (!parsed.length) {
            checkMissing();
            return;
        }
    } catch (err) {
        console.error(err);
    }
    checkMissing();
    $8ac51c03dfec543e$var$loadedNewIcons(storage);
}
function $8ac51c03dfec543e$var$parsePossiblyAsyncResponse(response, callback) {
    if (response instanceof Promise) response.then((data)=>{
        callback(data);
    }).catch(()=>{
        callback(null);
    });
    else callback(response);
}
function $8ac51c03dfec543e$var$loadNewIcons(storage, icons) {
    if (!storage.iconsToLoad) storage.iconsToLoad = icons;
    else storage.iconsToLoad = storage.iconsToLoad.concat(icons).sort();
    if (!storage.iconsQueueFlag) {
        storage.iconsQueueFlag = true;
        setTimeout(()=>{
            storage.iconsQueueFlag = false;
            const { provider: provider, prefix: prefix } = storage;
            const icons2 = storage.iconsToLoad;
            delete storage.iconsToLoad;
            if (!icons2 || !icons2.length) return;
            const customIconLoader = storage.loadIcon;
            if (storage.loadIcons && (icons2.length > 1 || !customIconLoader)) {
                $8ac51c03dfec543e$var$parsePossiblyAsyncResponse(storage.loadIcons(icons2, prefix, provider), (data)=>{
                    $8ac51c03dfec543e$var$parseLoaderResponse(storage, icons2, data);
                });
                return;
            }
            if (customIconLoader) {
                icons2.forEach((name)=>{
                    const response = customIconLoader(name, prefix, provider);
                    $8ac51c03dfec543e$var$parsePossiblyAsyncResponse(response, (data)=>{
                        const iconSet = data ? {
                            prefix: prefix,
                            icons: {
                                [name]: data
                            }
                        } : null;
                        $8ac51c03dfec543e$var$parseLoaderResponse(storage, [
                            name
                        ], iconSet);
                    });
                });
                return;
            }
            const { valid: valid, invalid: invalid } = $8ac51c03dfec543e$var$checkIconNamesForAPI(icons2);
            if (invalid.length) $8ac51c03dfec543e$var$parseLoaderResponse(storage, invalid, null);
            if (!valid.length) return;
            const api = prefix.match($8ac51c03dfec543e$var$matchIconName) ? $8ac51c03dfec543e$var$getAPIModule(provider) : null;
            if (!api) {
                $8ac51c03dfec543e$var$parseLoaderResponse(storage, valid, null);
                return;
            }
            const params = api.prepare(provider, prefix, valid);
            params.forEach((item)=>{
                $8ac51c03dfec543e$var$sendAPIQuery(provider, item, (data)=>{
                    $8ac51c03dfec543e$var$parseLoaderResponse(storage, item.icons, data);
                });
            });
        });
    }
}
const $8ac51c03dfec543e$export$2527eb85cb3fa9f = (icons, callback)=>{
    const cleanedIcons = $8ac51c03dfec543e$var$listToIcons(icons, true, $8ac51c03dfec543e$var$allowSimpleNames());
    const sortedIcons = $8ac51c03dfec543e$var$sortIcons(cleanedIcons);
    if (!sortedIcons.pending.length) {
        let callCallback = true;
        if (callback) setTimeout(()=>{
            if (callCallback) callback(sortedIcons.loaded, sortedIcons.missing, sortedIcons.pending, $8ac51c03dfec543e$var$emptyCallback);
        });
        return ()=>{
            callCallback = false;
        };
    }
    const newIcons = /* @__PURE__ */ Object.create(null);
    const sources = [];
    let lastProvider, lastPrefix;
    sortedIcons.pending.forEach((icon)=>{
        const { provider: provider, prefix: prefix } = icon;
        if (prefix === lastPrefix && provider === lastProvider) return;
        lastProvider = provider;
        lastPrefix = prefix;
        sources.push($8ac51c03dfec543e$var$getStorage(provider, prefix));
        const providerNewIcons = newIcons[provider] || (newIcons[provider] = /* @__PURE__ */ Object.create(null));
        if (!providerNewIcons[prefix]) providerNewIcons[prefix] = [];
    });
    sortedIcons.pending.forEach((icon)=>{
        const { provider: provider, prefix: prefix, name: name } = icon;
        const storage = $8ac51c03dfec543e$var$getStorage(provider, prefix);
        const pendingQueue = storage.pendingIcons || (storage.pendingIcons = /* @__PURE__ */ new Set());
        if (!pendingQueue.has(name)) {
            pendingQueue.add(name);
            newIcons[provider][prefix].push(name);
        }
    });
    sources.forEach((storage)=>{
        const list = newIcons[storage.provider][storage.prefix];
        if (list.length) $8ac51c03dfec543e$var$loadNewIcons(storage, list);
    });
    return callback ? $8ac51c03dfec543e$var$storeCallback(callback, sortedIcons, sources) : $8ac51c03dfec543e$var$emptyCallback;
};
const $8ac51c03dfec543e$export$8e757e0542ac47f6 = (icon)=>{
    return new Promise((fulfill, reject)=>{
        const iconObj = typeof icon === "string" ? $8ac51c03dfec543e$var$stringToIcon(icon, true) : icon;
        if (!iconObj) {
            reject(icon);
            return;
        }
        $8ac51c03dfec543e$export$2527eb85cb3fa9f([
            iconObj || icon
        ], (loaded)=>{
            if (loaded.length && iconObj) {
                const data = $8ac51c03dfec543e$var$getIconData(iconObj);
                if (data) {
                    fulfill({
                        ...$8ac51c03dfec543e$var$defaultIconProps,
                        ...data
                    });
                    return;
                }
            }
            reject(icon);
        });
    });
};
function $8ac51c03dfec543e$export$e4c6e88f1f5eeacc(loader, prefix, provider) {
    $8ac51c03dfec543e$var$getStorage(provider || "", prefix).loadIcons = loader;
}
function $8ac51c03dfec543e$export$605d11454a711a89(loader, prefix, provider) {
    $8ac51c03dfec543e$var$getStorage(provider || "", prefix).loadIcon = loader;
}
function $8ac51c03dfec543e$var$mergeCustomisations(defaults, item) {
    const result = {
        ...defaults
    };
    for(const key in item){
        const value = item[key];
        const valueType = typeof value;
        if (key in $8ac51c03dfec543e$var$defaultIconSizeCustomisations) {
            if (value === null || value && (valueType === "string" || valueType === "number")) result[key] = value;
        } else if (valueType === typeof result[key]) result[key] = key === "rotate" ? value % 4 : value;
    }
    return result;
}
const $8ac51c03dfec543e$var$separator = /[\s,]+/;
function $8ac51c03dfec543e$var$flipFromString(custom, flip) {
    flip.split($8ac51c03dfec543e$var$separator).forEach((str)=>{
        const value = str.trim();
        switch(value){
            case "horizontal":
                custom.hFlip = true;
                break;
            case "vertical":
                custom.vFlip = true;
                break;
        }
    });
}
function $8ac51c03dfec543e$var$rotateFromString(value, defaultValue = 0) {
    const units = value.replace(/^-?[0-9.]*/, "");
    function cleanup(value2) {
        while(value2 < 0)value2 += 4;
        return value2 % 4;
    }
    if (units === "") {
        const num = parseInt(value);
        return isNaN(num) ? 0 : cleanup(num);
    } else if (units !== value) {
        let split = 0;
        switch(units){
            case "%":
                split = 25;
                break;
            case "deg":
                split = 90;
        }
        if (split) {
            let num = parseFloat(value.slice(0, value.length - units.length));
            if (isNaN(num)) return 0;
            num = num / split;
            return num % 1 === 0 ? cleanup(num) : 0;
        }
    }
    return defaultValue;
}
function $8ac51c03dfec543e$var$iconToHTML(body, attributes) {
    let renderAttribsHTML = body.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
    for(const attr in attributes)renderAttribsHTML += " " + attr + '="' + attributes[attr] + '"';
    return '<svg xmlns="http://www.w3.org/2000/svg"' + renderAttribsHTML + ">" + body + "</svg>";
}
function $8ac51c03dfec543e$var$encodeSVGforURL(svg) {
    return svg.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function $8ac51c03dfec543e$var$svgToData(svg) {
    return "data:image/svg+xml," + $8ac51c03dfec543e$var$encodeSVGforURL(svg);
}
function $8ac51c03dfec543e$var$svgToURL(svg) {
    return 'url("' + $8ac51c03dfec543e$var$svgToData(svg) + '")';
}
let $8ac51c03dfec543e$var$policy;
function $8ac51c03dfec543e$var$createPolicy() {
    try {
        $8ac51c03dfec543e$var$policy = window.trustedTypes.createPolicy("iconify", {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            createHTML: (s)=>s
        });
    } catch (err) {
        $8ac51c03dfec543e$var$policy = null;
    }
}
function $8ac51c03dfec543e$var$cleanUpInnerHTML(html) {
    if ($8ac51c03dfec543e$var$policy === void 0) $8ac51c03dfec543e$var$createPolicy();
    return $8ac51c03dfec543e$var$policy ? $8ac51c03dfec543e$var$policy.createHTML(html) : html;
}
const $8ac51c03dfec543e$var$defaultExtendedIconCustomisations = {
    ...$8ac51c03dfec543e$var$defaultIconCustomisations,
    inline: false
};
/**
 * Default SVG attributes
 */ const $8ac51c03dfec543e$var$svgDefaults = {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlnsXlink": "http://www.w3.org/1999/xlink",
    "aria-hidden": true,
    "role": "img"
};
/**
 * Style modes
 */ const $8ac51c03dfec543e$var$commonProps = {
    display: "inline-block"
};
const $8ac51c03dfec543e$var$monotoneProps = {
    backgroundColor: "currentColor"
};
const $8ac51c03dfec543e$var$coloredProps = {
    backgroundColor: "transparent"
};
// Dynamically add common props to variables above
const $8ac51c03dfec543e$var$propsToAdd = {
    Image: "var(--svg)",
    Repeat: "no-repeat",
    Size: "100% 100%"
};
const $8ac51c03dfec543e$var$propsToAddTo = {
    WebkitMask: $8ac51c03dfec543e$var$monotoneProps,
    mask: $8ac51c03dfec543e$var$monotoneProps,
    background: $8ac51c03dfec543e$var$coloredProps
};
for(const prefix in $8ac51c03dfec543e$var$propsToAddTo){
    const list = $8ac51c03dfec543e$var$propsToAddTo[prefix];
    for(const prop in $8ac51c03dfec543e$var$propsToAdd)list[prefix + prop] = $8ac51c03dfec543e$var$propsToAdd[prop];
}
/**
 * Default values for customisations for inline icon
 */ const $8ac51c03dfec543e$var$inlineDefaults = {
    ...$8ac51c03dfec543e$var$defaultExtendedIconCustomisations,
    inline: true
};
/**
 * Fix size: add 'px' to numbers
 */ function $8ac51c03dfec543e$var$fixSize(value) {
    return value + (value.match(/^[-0-9.]+$/) ? "px" : "");
}
/**
 * Render icon
 */ const $8ac51c03dfec543e$var$render = (// Icon must be validated before calling this function
icon, // Partial properties
props, // Icon name
name)=>{
    // Get default properties
    const defaultProps = props.inline ? $8ac51c03dfec543e$var$inlineDefaults : $8ac51c03dfec543e$var$defaultExtendedIconCustomisations;
    // Get all customisations
    const customisations = $8ac51c03dfec543e$var$mergeCustomisations(defaultProps, props);
    // Check mode
    const mode = props.mode || "svg";
    // Create style
    const style = {};
    const customStyle = props.style || {};
    // Create SVG component properties
    const componentProps = {
        ...mode === "svg" ? $8ac51c03dfec543e$var$svgDefaults : {}
    };
    if (name) {
        const iconName = $8ac51c03dfec543e$var$stringToIcon(name, false, true);
        if (iconName) {
            const classNames = [
                "iconify"
            ];
            const props = [
                "provider",
                "prefix"
            ];
            for (const prop of props)if (iconName[prop]) classNames.push("iconify--" + iconName[prop]);
            componentProps.className = classNames.join(" ");
        }
    }
    // Get element properties
    for(let key in props){
        const value = props[key];
        if (value === void 0) continue;
        switch(key){
            // Properties to ignore
            case "icon":
            case "style":
            case "children":
            case "onLoad":
            case "mode":
            case "ssr":
                break;
            // Forward ref
            case "_ref":
                componentProps.ref = value;
                break;
            // Merge class names
            case "className":
                componentProps[key] = (componentProps[key] ? componentProps[key] + " " : "") + value;
                break;
            // Boolean attributes
            case "inline":
            case "hFlip":
            case "vFlip":
                customisations[key] = value === true || value === "true" || value === 1;
                break;
            // Flip as string: 'horizontal,vertical'
            case "flip":
                if (typeof value === "string") $8ac51c03dfec543e$var$flipFromString(customisations, value);
                break;
            // Color: copy to style
            case "color":
                style.color = value;
                break;
            // Rotation as string
            case "rotate":
                if (typeof value === "string") customisations[key] = $8ac51c03dfec543e$var$rotateFromString(value);
                else if (typeof value === "number") customisations[key] = value;
                break;
            // Remove aria-hidden
            case "ariaHidden":
            case "aria-hidden":
                if (value !== true && value !== "true") delete componentProps["aria-hidden"];
                break;
            // Copy missing property if it does not exist in customisations
            default:
                if (defaultProps[key] === void 0) componentProps[key] = value;
        }
    }
    // Generate icon
    const item = $8ac51c03dfec543e$export$78c1051fc6863a0b(icon, customisations);
    const renderAttribs = item.attributes;
    // Inline display
    if (customisations.inline) style.verticalAlign = "-0.125em";
    if (mode === "svg") {
        // Add style
        componentProps.style = {
            ...style,
            ...customStyle
        };
        // Add icon stuff
        Object.assign(componentProps, renderAttribs);
        // Counter for ids based on "id" property to render icons consistently on server and client
        let localCounter = 0;
        let id = props.id;
        if (typeof id === "string") // Convert '-' to '_' to avoid errors in animations
        id = id.replace(/-/g, "_");
        // Add icon stuff
        componentProps.dangerouslySetInnerHTML = {
            __html: $8ac51c03dfec543e$var$cleanUpInnerHTML($8ac51c03dfec543e$export$cae0fa3719aa5dc4(item.body, id ? ()=>id + "ID" + localCounter++ : "iconifyReact"))
        };
        return (0, $bh6RR.createElement)("svg", componentProps);
    }
    // Render <span> with style
    const { body: body, width: width, height: height } = icon;
    const useMask = mode === "mask" || (mode === "bg" ? false : body.indexOf("currentColor") !== -1);
    // Generate SVG
    const html = $8ac51c03dfec543e$var$iconToHTML(body, {
        ...renderAttribs,
        width: width + "",
        height: height + ""
    });
    // Generate style
    componentProps.style = {
        ...style,
        "--svg": $8ac51c03dfec543e$var$svgToURL(html),
        "width": $8ac51c03dfec543e$var$fixSize(renderAttribs.width),
        "height": $8ac51c03dfec543e$var$fixSize(renderAttribs.height),
        ...$8ac51c03dfec543e$var$commonProps,
        ...useMask ? $8ac51c03dfec543e$var$monotoneProps : $8ac51c03dfec543e$var$coloredProps,
        ...customStyle
    };
    return (0, $bh6RR.createElement)("span", componentProps);
};
/**
 * Enable cache
 *
 * @deprecated No longer used
 */ function $8ac51c03dfec543e$export$86165a58bbc2b5ab(storage) {
//
}
/**
 * Disable cache
 *
 * @deprecated No longer used
 */ function $8ac51c03dfec543e$export$36cc41bb19333364(storage) {
//
}
/**
 * Initialise stuff
 */ // Enable short names
$8ac51c03dfec543e$var$allowSimpleNames(true);
// Set API module
$8ac51c03dfec543e$var$setAPIModule("", $8ac51c03dfec543e$var$fetchAPIModule);
/**
 * Browser stuff
 */ if (typeof document !== "undefined" && typeof window !== "undefined") {
    const _window = window;
    // Load icons from global "IconifyPreload"
    if (_window.IconifyPreload !== void 0) {
        const preload = _window.IconifyPreload;
        const err = "Invalid IconifyPreload syntax.";
        if (typeof preload === "object" && preload !== null) (preload instanceof Array ? preload : [
            preload
        ]).forEach((item)=>{
            try {
                if (// Check if item is an object and not null/array
                typeof item !== "object" || item === null || item instanceof Array || // Check for 'icons' and 'prefix'
                typeof item.icons !== "object" || typeof item.prefix !== "string" || // Add icon set
                !$8ac51c03dfec543e$export$933f273b2a11730f(item)) console.error(err);
            } catch (e) {
                console.error(err);
            }
        });
    }
    // Set API from global "IconifyProviders"
    if (_window.IconifyProviders !== void 0) {
        const providers = _window.IconifyProviders;
        if (typeof providers === "object" && providers !== null) for(let key in providers){
            const err = "IconifyProviders[" + key + "] is invalid.";
            try {
                const value = providers[key];
                if (typeof value !== "object" || !value || value.resources === void 0) continue;
                if (!$8ac51c03dfec543e$export$ddfda4eca64d59f6(key, value)) console.error(err);
            } catch (e) {
                console.error(err);
            }
        }
    }
}
function $8ac51c03dfec543e$var$IconComponent(props) {
    const [mounted, setMounted] = (0, $bh6RR.useState)(!!props.ssr);
    const [abort, setAbort] = (0, $bh6RR.useState)({});
    // Get initial state
    function getInitialState(mounted) {
        if (mounted) {
            const name = props.icon;
            if (typeof name === "object") // Icon as object
            return {
                name: "",
                data: name
            };
            const data = $8ac51c03dfec543e$var$getIconData(name);
            if (data) return {
                name: name,
                data: data
            };
        }
        return {
            name: ""
        };
    }
    const [state, setState] = (0, $bh6RR.useState)(getInitialState(!!props.ssr));
    // Cancel loading
    function cleanup() {
        const callback = abort.callback;
        if (callback) {
            callback();
            setAbort({});
        }
    }
    // Change state if it is different
    function changeState(newState) {
        if (JSON.stringify(state) !== JSON.stringify(newState)) {
            cleanup();
            setState(newState);
            return true;
        }
    }
    // Update state
    function updateState() {
        var _a;
        const name = props.icon;
        if (typeof name === "object") {
            // Icon as object
            changeState({
                name: "",
                data: name
            });
            return;
        }
        // New icon or got icon data
        const data = $8ac51c03dfec543e$var$getIconData(name);
        if (changeState({
            name: name,
            data: data
        })) {
            if (data === undefined) {
                // Load icon, update state when done
                const callback = $8ac51c03dfec543e$export$2527eb85cb3fa9f([
                    name
                ], updateState);
                setAbort({
                    callback: callback
                });
            } else if (data) // Icon data is available: trigger onLoad callback if present
            (_a = props.onLoad) === null || _a === void 0 || _a.call(props, name);
        }
    }
    // Mounted state, cleanup for loader
    (0, $bh6RR.useEffect)(()=>{
        setMounted(true);
        return cleanup;
    }, []);
    // Icon changed or component mounted
    (0, $bh6RR.useEffect)(()=>{
        if (mounted) updateState();
    }, [
        props.icon,
        mounted
    ]);
    // Render icon
    const { name: name, data: data } = state;
    if (!data) return props.children ? props.children : props.fallback ? props.fallback : (0, $bh6RR.createElement)("span", {});
    return $8ac51c03dfec543e$var$render({
        ...$8ac51c03dfec543e$var$defaultIconProps,
        ...data
    }, props, name);
}
/**
 * Block icon
 *
 * @param props - Component properties
 */ const $8ac51c03dfec543e$export$f04a61298a47a40f = (0, $bh6RR.forwardRef)((props, ref)=>$8ac51c03dfec543e$var$IconComponent({
        ...props,
        _ref: ref
    }));
/**
 * Inline icon (has negative verticalAlign that makes it behave like icon font)
 *
 * @param props - Component properties
 */ const $8ac51c03dfec543e$export$d1314c9fc3bb2a13 = (0, $bh6RR.forwardRef)((props, ref)=>$8ac51c03dfec543e$var$IconComponent({
        inline: true,
        ...props,
        _ref: ref
    }));
/**
 * Internal API
 */ const $8ac51c03dfec543e$export$14dadc205e26d636 = {
    getAPIConfig: $8ac51c03dfec543e$var$getAPIConfig,
    setAPIModule: $8ac51c03dfec543e$var$setAPIModule,
    sendAPIQuery: $8ac51c03dfec543e$var$sendAPIQuery,
    setFetch: $8ac51c03dfec543e$var$setFetch,
    getFetch: $8ac51c03dfec543e$var$getFetch,
    listAPIProviders: $8ac51c03dfec543e$var$listAPIProviders
};


var $2d5b1ac1574da936$exports = {};
function $2d5b1ac1574da936$var$_extends() {
    return $2d5b1ac1574da936$exports = $2d5b1ac1574da936$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2d5b1ac1574da936$exports.__esModule = true, $2d5b1ac1574da936$exports["default"] = $2d5b1ac1574da936$exports, $2d5b1ac1574da936$var$_extends.apply(null, arguments);
}
$2d5b1ac1574da936$exports = $2d5b1ac1574da936$var$_extends, $2d5b1ac1574da936$exports.__esModule = true, $2d5b1ac1574da936$exports["default"] = $2d5b1ac1574da936$exports;



var $bh6RR = parcelRequire("bh6RR");
const $58e7d7e7a518e14b$export$7e9bdabab6bd863e = (layout)=>{
    switch(layout){
        case "stacked":
            return "rhap_stacked";
        case "stacked-reverse":
            return "rhap_stacked-reverse";
        case "horizontal":
            return "rhap_horizontal";
        case "horizontal-reverse":
            return "rhap_horizontal-reverse";
        default:
            return "rhap_stacked";
    }
};
const $58e7d7e7a518e14b$export$e03817b45ea5db12 = (event)=>{
    if (event instanceof MouseEvent) return event.clientX;
    else return event.touches[0].clientX;
};
const $58e7d7e7a518e14b$var$addHeadingZero = (num)=>{
    return num > 9 ? num.toString() : `0${num}`;
};
const $58e7d7e7a518e14b$export$5ee6a13c18d2456e = (seconds, totalSeconds, timeFormat)=>{
    if (!isFinite(seconds)) return null;
    const min = Math.floor(seconds / 60);
    const minStr = $58e7d7e7a518e14b$var$addHeadingZero(min);
    const secStr = $58e7d7e7a518e14b$var$addHeadingZero(Math.floor(seconds % 60));
    const minStrForHour = $58e7d7e7a518e14b$var$addHeadingZero(Math.floor(min % 60));
    const hourStr = Math.floor(min / 60);
    const mmSs = `${minStr}:${secStr}`;
    const hhMmSs = `${hourStr}:${minStrForHour}:${secStr}`;
    if (timeFormat === "auto") {
        if (totalSeconds >= 3600) return hhMmSs;
        else return mmSs;
    } else if (timeFormat === "mm:ss") return mmSs;
    else if (timeFormat === "hh:mm:ss") return hhMmSs;
};
function $58e7d7e7a518e14b$export$de363e709c412c8a(func, limit) {
    let inThrottle = false;
    return (arg)=>{
        if (!inThrottle) {
            func(arg);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}


class $0798354ecd49a108$export$c17561cb55d4db30 extends (0, $bh6RR.Component) {
    timeOnMouseMove = 0;
    hasAddedAudioEventListener = false;
    state = {
        isDraggingProgress: false,
        currentTimePos: "0%",
        hasDownloadProgressAnimation: false,
        downloadProgressArr: [],
        waitingForSeekCallback: false
    };
    getDuration() {
        const { audio: audio, srcDuration: srcDuration } = this.props;
        return typeof srcDuration === "undefined" ? audio.duration : srcDuration;
    }
    getCurrentProgress = (event)=>{
        const { audio: audio, progressBar: progressBar } = this.props;
        const isSingleFileProgressiveDownload = audio.src.indexOf("blob:") !== 0 && typeof this.props.srcDuration === "undefined";
        if (isSingleFileProgressiveDownload && (!audio.src || !isFinite(audio.currentTime) || !progressBar.current)) return {
            currentTime: 0,
            currentTimePos: "0%"
        };
        const progressBarRect = progressBar.current.getBoundingClientRect();
        const maxRelativePos = progressBarRect.width;
        let relativePos = (0, $58e7d7e7a518e14b$export$e03817b45ea5db12)(event) - progressBarRect.left;
        if (relativePos < 0) relativePos = 0;
        else if (relativePos > maxRelativePos) relativePos = maxRelativePos;
        const duration = this.getDuration();
        const currentTime = duration * relativePos / maxRelativePos;
        return {
            currentTime: currentTime,
            currentTimePos: `${(relativePos / maxRelativePos * 100).toFixed(2)}%`
        };
    };
    handleContextMenu = (event)=>{
        event.preventDefault();
    };
    handleMouseDownOrTouchStartProgressBar = (event)=>{
        event.stopPropagation();
        const { currentTime: currentTime, currentTimePos: currentTimePos } = this.getCurrentProgress(event.nativeEvent);
        if (isFinite(currentTime)) {
            this.timeOnMouseMove = currentTime;
            this.setState({
                isDraggingProgress: true,
                currentTimePos: currentTimePos
            });
            if (event.nativeEvent instanceof MouseEvent) {
                window.addEventListener("mousemove", this.handleWindowMouseOrTouchMove);
                window.addEventListener("mouseup", this.handleWindowMouseOrTouchUp);
            } else {
                window.addEventListener("touchmove", this.handleWindowMouseOrTouchMove);
                window.addEventListener("touchend", this.handleWindowMouseOrTouchUp);
            }
        }
    };
    handleWindowMouseOrTouchMove = (event)=>{
        if (event instanceof MouseEvent) event.preventDefault();
        event.stopPropagation();
        const windowSelection = window.getSelection();
        if (windowSelection && windowSelection.type === "Range") windowSelection.empty();
        const { isDraggingProgress: isDraggingProgress } = this.state;
        if (isDraggingProgress) {
            const { currentTime: currentTime, currentTimePos: currentTimePos } = this.getCurrentProgress(event);
            this.timeOnMouseMove = currentTime;
            this.setState({
                currentTimePos: currentTimePos
            });
        }
    };
    handleWindowMouseOrTouchUp = (event)=>{
        event.stopPropagation();
        const newTime = this.timeOnMouseMove;
        const { audio: audio, onChangeCurrentTimeError: onChangeCurrentTimeError, onSeek: onSeek } = this.props;
        if (onSeek) this.setState({
            isDraggingProgress: false,
            waitingForSeekCallback: true
        }, ()=>{
            onSeek(audio, newTime).then(()=>this.setState({
                    waitingForSeekCallback: false
                }), (err)=>{
                throw new Error(err);
            });
        });
        else {
            const newProps = {
                isDraggingProgress: false
            };
            if (audio.readyState === audio.HAVE_NOTHING || audio.readyState === audio.HAVE_METADATA || !isFinite(newTime)) try {
                audio.load();
            } catch (err) {
                newProps.currentTimePos = "0%";
                return onChangeCurrentTimeError && onChangeCurrentTimeError(err);
            }
            audio.currentTime = newTime;
            this.setState(newProps);
        }
        if (event instanceof MouseEvent) {
            window.removeEventListener("mousemove", this.handleWindowMouseOrTouchMove);
            window.removeEventListener("mouseup", this.handleWindowMouseOrTouchUp);
        } else {
            window.removeEventListener("touchmove", this.handleWindowMouseOrTouchMove);
            window.removeEventListener("touchend", this.handleWindowMouseOrTouchUp);
        }
    };
    handleAudioTimeUpdate = (()=>(0, $58e7d7e7a518e14b$export$de363e709c412c8a)((e)=>{
            const { isDraggingProgress: isDraggingProgress } = this.state;
            const audio = e.target;
            if (isDraggingProgress || this.state.waitingForSeekCallback === true) return;
            const { currentTime: currentTime } = audio;
            const duration = this.getDuration();
            this.setState({
                currentTimePos: `${(currentTime / duration * 100 || 0).toFixed(2)}%`
            });
        }, this.props.progressUpdateInterval))();
    handleAudioDownloadProgressUpdate = (e)=>{
        const audio = e.target;
        const duration = this.getDuration();
        const downloadProgressArr = [];
        for(let i = 0; i < audio.buffered.length; i++){
            const bufferedStart = audio.buffered.start(i);
            const bufferedEnd = audio.buffered.end(i);
            downloadProgressArr.push({
                left: `${Math.round(100 / duration * bufferedStart) || 0}%`,
                width: `${Math.round(100 / duration * (bufferedEnd - bufferedStart)) || 0}%`
            });
        }
        clearTimeout(this.downloadProgressAnimationTimer);
        this.setState({
            downloadProgressArr: downloadProgressArr,
            hasDownloadProgressAnimation: true
        });
        this.downloadProgressAnimationTimer = setTimeout(()=>{
            this.setState({
                hasDownloadProgressAnimation: false
            });
        }, 200);
    };
    initialize() {
        const { audio: audio } = this.props;
        if (audio && !this.hasAddedAudioEventListener) {
            this.audio = audio;
            this.hasAddedAudioEventListener = true;
            audio.addEventListener("timeupdate", this.handleAudioTimeUpdate);
            audio.addEventListener("progress", this.handleAudioDownloadProgressUpdate);
        }
    }
    componentDidMount() {
        this.initialize();
    }
    componentDidUpdate() {
        this.initialize();
    }
    componentWillUnmount() {
        if (this.audio && this.hasAddedAudioEventListener) {
            this.audio.removeEventListener("timeupdate", this.handleAudioTimeUpdate);
            this.audio.removeEventListener("progress", this.handleAudioDownloadProgressUpdate);
        }
        clearTimeout(this.downloadProgressAnimationTimer);
    }
    render() {
        const { showDownloadProgress: showDownloadProgress, showFilledProgress: showFilledProgress, progressBar: progressBar, i18nProgressBar: i18nProgressBar } = this.props;
        const { currentTimePos: currentTimePos, downloadProgressArr: downloadProgressArr, hasDownloadProgressAnimation: hasDownloadProgressAnimation } = this.state;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: "rhap_progress-container",
            ref: progressBar,
            "aria-label": i18nProgressBar,
            role: "progressbar",
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "aria-valuenow": Number(currentTimePos.split("%")[0]),
            tabIndex: 0,
            onMouseDown: this.handleMouseDownOrTouchStartProgressBar,
            onTouchStart: this.handleMouseDownOrTouchStartProgressBar,
            onContextMenu: this.handleContextMenu
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: `rhap_progress-bar ${showDownloadProgress ? "rhap_progress-bar-show-download" : ""}`
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: "rhap_progress-indicator",
            style: {
                left: currentTimePos
            }
        }), showFilledProgress && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: "rhap_progress-filled",
            style: {
                width: currentTimePos
            }
        }), showDownloadProgress && downloadProgressArr.map((_ref, i)=>{
            let { left: left, width: width } = _ref;
            return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                key: i,
                className: "rhap_download-progress",
                style: {
                    left: left,
                    width: width,
                    transitionDuration: hasDownloadProgressAnimation ? ".2s" : "0s"
                }
            });
        })));
    }
}
const $0798354ecd49a108$export$f7d95841652261aa = (props, ref)=>(0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($0798354ecd49a108$export$c17561cb55d4db30, (0, (/*@__PURE__*/$parcel$interopDefault($2d5b1ac1574da936$exports)))({}, props, {
        progressBar: ref
    }));
var $0798354ecd49a108$export$2e2bcd8739ae039 = (0, $bh6RR.forwardRef)($0798354ecd49a108$export$f7d95841652261aa);



var $bh6RR = parcelRequire("bh6RR");

class $361a70cb554308af$var$CurrentTime extends (0, $bh6RR.PureComponent) {
    hasAddedAudioEventListener = false;
    constructor(props){
        super(props);
        const { audio: audio, defaultCurrentTime: defaultCurrentTime, isLeftTime: isLeftTime, timeFormat: timeFormat } = props;
        let currentTime = defaultCurrentTime;
        if (audio) currentTime = (0, $58e7d7e7a518e14b$export$5ee6a13c18d2456e)(isLeftTime ? audio.duration - audio.currentTime : audio.currentTime, audio.duration, timeFormat);
        this.state = {
            currentTime: currentTime
        };
    }
    state = {
        currentTime: this.props.defaultCurrentTime
    };
    handleAudioCurrentTimeChange = (e)=>{
        const audio = e.target;
        const { isLeftTime: isLeftTime, timeFormat: timeFormat, defaultCurrentTime: defaultCurrentTime } = this.props;
        this.setState({
            currentTime: (0, $58e7d7e7a518e14b$export$5ee6a13c18d2456e)(isLeftTime ? audio.duration - audio.currentTime : audio.currentTime, audio.duration, timeFormat) || defaultCurrentTime
        });
    };
    addAudioEventListeners = ()=>{
        const { audio: audio } = this.props;
        if (audio && !this.hasAddedAudioEventListener) {
            this.audio = audio;
            this.hasAddedAudioEventListener = true;
            audio.addEventListener("timeupdate", this.handleAudioCurrentTimeChange);
            audio.addEventListener("loadedmetadata", this.handleAudioCurrentTimeChange);
        }
    };
    componentDidMount() {
        this.addAudioEventListeners();
    }
    componentDidUpdate() {
        this.addAudioEventListeners();
    }
    componentWillUnmount() {
        if (this.audio && this.hasAddedAudioEventListener) {
            this.audio.removeEventListener("timeupdate", this.handleAudioCurrentTimeChange);
            this.audio.removeEventListener("loadedmetadata", this.handleAudioCurrentTimeChange);
        }
    }
    render() {
        return this.state.currentTime;
    }
}
var $361a70cb554308af$export$2e2bcd8739ae039 = $361a70cb554308af$var$CurrentTime;



var $bh6RR = parcelRequire("bh6RR");

class $3d752d32cc4df51a$var$Duration extends (0, $bh6RR.PureComponent) {
    hasAddedAudioEventListener = false;
    constructor(props){
        super(props);
        const { audio: audio, timeFormat: timeFormat, defaultDuration: defaultDuration } = props;
        this.state = {
            duration: audio ? (0, $58e7d7e7a518e14b$export$5ee6a13c18d2456e)(audio.duration, audio.duration, timeFormat) : defaultDuration
        };
    }
    state = (()=>({
            duration: this.props.audio ? (0, $58e7d7e7a518e14b$export$5ee6a13c18d2456e)(this.props.audio.duration, this.props.audio.duration, this.props.timeFormat) : this.props.defaultDuration
        }))();
    handleAudioDurationChange = (e)=>{
        const audio = e.target;
        const { timeFormat: timeFormat, defaultDuration: defaultDuration } = this.props;
        this.setState({
            duration: (0, $58e7d7e7a518e14b$export$5ee6a13c18d2456e)(audio.duration, audio.duration, timeFormat) || defaultDuration
        });
    };
    addAudioEventListeners = ()=>{
        const { audio: audio } = this.props;
        if (audio && !this.hasAddedAudioEventListener) {
            this.audio = audio;
            this.hasAddedAudioEventListener = true;
            audio.addEventListener("durationchange", this.handleAudioDurationChange);
            audio.addEventListener("abort", this.handleAudioDurationChange);
        }
    };
    componentDidMount() {
        this.addAudioEventListeners();
    }
    componentDidUpdate() {
        this.addAudioEventListeners();
    }
    componentWillUnmount() {
        if (this.audio && this.hasAddedAudioEventListener) {
            this.audio.removeEventListener("durationchange", this.handleAudioDurationChange);
            this.audio.removeEventListener("abort", this.handleAudioDurationChange);
        }
    }
    render() {
        return this.state.duration;
    }
}
var $3d752d32cc4df51a$export$2e2bcd8739ae039 = $3d752d32cc4df51a$var$Duration;



var $bh6RR = parcelRequire("bh6RR");

class $cd25d970f1263001$var$VolumeControls extends (0, $bh6RR.Component) {
    hasAddedAudioEventListener = false;
    volumeBar = (()=>(0, $bh6RR.createRef)())();
    volumeAnimationTimer = 0;
    lastVolume = this.props.volume;
    state = (()=>({
            currentVolumePos: `${(this.lastVolume / 1 * 100 || 0).toFixed(2)}%`,
            hasVolumeAnimation: false,
            isDraggingVolume: false
        }))();
    getCurrentVolume = (event)=>{
        const { audio: audio } = this.props;
        if (!this.volumeBar.current) return {
            currentVolume: audio.volume,
            currentVolumePos: this.state.currentVolumePos
        };
        const volumeBarRect = this.volumeBar.current.getBoundingClientRect();
        const maxRelativePos = volumeBarRect.width;
        const relativePos = (0, $58e7d7e7a518e14b$export$e03817b45ea5db12)(event) - volumeBarRect.left;
        let currentVolume;
        let currentVolumePos;
        if (relativePos < 0) {
            currentVolume = 0;
            currentVolumePos = "0%";
        } else if (relativePos > volumeBarRect.width) {
            currentVolume = 1;
            currentVolumePos = "100%";
        } else {
            currentVolume = relativePos / maxRelativePos;
            currentVolumePos = `${relativePos / maxRelativePos * 100}%`;
        }
        return {
            currentVolume: currentVolume,
            currentVolumePos: currentVolumePos
        };
    };
    handleContextMenu = (event)=>{
        event.preventDefault();
    };
    handleClickVolumeButton = ()=>{
        const { audio: audio } = this.props;
        if (audio.volume > 0) {
            this.lastVolume = audio.volume;
            audio.volume = 0;
        } else audio.volume = this.lastVolume;
    };
    handleVolumnControlMouseOrTouchDown = (event)=>{
        event.stopPropagation();
        const { audio: audio } = this.props;
        const { currentVolume: currentVolume, currentVolumePos: currentVolumePos } = this.getCurrentVolume(event.nativeEvent);
        audio.volume = currentVolume;
        this.setState({
            isDraggingVolume: true,
            currentVolumePos: currentVolumePos
        });
        if (event.nativeEvent instanceof MouseEvent) {
            window.addEventListener("mousemove", this.handleWindowMouseOrTouchMove);
            window.addEventListener("mouseup", this.handleWindowMouseOrTouchUp);
        } else {
            window.addEventListener("touchmove", this.handleWindowMouseOrTouchMove);
            window.addEventListener("touchend", this.handleWindowMouseOrTouchUp);
        }
    };
    handleWindowMouseOrTouchMove = (event)=>{
        if (event instanceof MouseEvent) event.preventDefault();
        event.stopPropagation();
        const { audio: audio } = this.props;
        const windowSelection = window.getSelection();
        if (windowSelection && windowSelection.type === "Range") windowSelection.empty();
        const { isDraggingVolume: isDraggingVolume } = this.state;
        if (isDraggingVolume) {
            const { currentVolume: currentVolume, currentVolumePos: currentVolumePos } = this.getCurrentVolume(event);
            audio.volume = currentVolume;
            this.setState({
                currentVolumePos: currentVolumePos
            });
        }
    };
    handleWindowMouseOrTouchUp = (event)=>{
        event.stopPropagation();
        this.setState({
            isDraggingVolume: false
        });
        if (event instanceof MouseEvent) {
            window.removeEventListener("mousemove", this.handleWindowMouseOrTouchMove);
            window.removeEventListener("mouseup", this.handleWindowMouseOrTouchUp);
        } else {
            window.removeEventListener("touchmove", this.handleWindowMouseOrTouchMove);
            window.removeEventListener("touchend", this.handleWindowMouseOrTouchUp);
        }
    };
    handleAudioVolumeChange = (e)=>{
        const { isDraggingVolume: isDraggingVolume } = this.state;
        const { volume: volume } = e.target;
        if (this.lastVolume > 0 && volume === 0 || this.lastVolume === 0 && volume > 0) this.props.onMuteChange();
        this.lastVolume = volume;
        if (isDraggingVolume) return;
        this.setState({
            hasVolumeAnimation: true,
            currentVolumePos: `${(volume / 1 * 100 || 0).toFixed(2)}%`
        });
        clearTimeout(this.volumeAnimationTimer);
        this.volumeAnimationTimer = setTimeout(()=>{
            this.setState({
                hasVolumeAnimation: false
            });
        }, 100);
    };
    componentDidUpdate() {
        const { audio: audio } = this.props;
        if (audio && !this.hasAddedAudioEventListener) {
            this.audio = audio;
            this.hasAddedAudioEventListener = true;
            audio.addEventListener("volumechange", this.handleAudioVolumeChange);
        }
    }
    componentWillUnmount() {
        if (this.audio && this.hasAddedAudioEventListener) this.audio.removeEventListener("volumechange", this.handleAudioVolumeChange);
        clearTimeout(this.volumeAnimationTimer);
    }
    render() {
        const { audio: audio, showFilledVolume: showFilledVolume, i18nVolumeControl: i18nVolumeControl } = this.props;
        const { currentVolumePos: currentVolumePos, hasVolumeAnimation: hasVolumeAnimation } = this.state;
        const { volume: volume } = audio || {};
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            ref: this.volumeBar,
            onMouseDown: this.handleVolumnControlMouseOrTouchDown,
            onTouchStart: this.handleVolumnControlMouseOrTouchDown,
            onContextMenu: this.handleContextMenu,
            role: "progressbar",
            "aria-label": i18nVolumeControl,
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "aria-valuenow": Number((volume * 100).toFixed(0)),
            tabIndex: 0,
            className: "rhap_volume-bar-area"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: "rhap_volume-bar"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: "rhap_volume-indicator",
            style: {
                left: currentVolumePos,
                transitionDuration: hasVolumeAnimation ? ".1s" : "0s"
            }
        }), showFilledVolume && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: "rhap_volume-filled",
            style: {
                width: currentVolumePos
            }
        })));
    }
}
var $cd25d970f1263001$export$2e2bcd8739ae039 = $cd25d970f1263001$var$VolumeControls;


let $9cc3ea70cb340790$export$a6e85c853f2c034c = function(RHAP_UI) {
    RHAP_UI["CURRENT_TIME"] = "CURRENT_TIME";
    RHAP_UI["CURRENT_LEFT_TIME"] = "CURRENT_LEFT_TIME";
    RHAP_UI["PROGRESS_BAR"] = "PROGRESS_BAR";
    RHAP_UI["DURATION"] = "DURATION";
    RHAP_UI["ADDITIONAL_CONTROLS"] = "ADDITIONAL_CONTROLS";
    RHAP_UI["MAIN_CONTROLS"] = "MAIN_CONTROLS";
    RHAP_UI["VOLUME_CONTROLS"] = "VOLUME_CONTROLS";
    RHAP_UI["LOOP"] = "LOOP";
    RHAP_UI["VOLUME"] = "VOLUME";
    return RHAP_UI;
}({});



class $4a788f79bad88934$var$H5AudioPlayer extends (0, $bh6RR.Component) {
    static defaultI18nAriaLabels = {
        player: "Audio player",
        progressControl: "Audio progress control",
        volumeControl: "Volume control",
        play: "Play",
        pause: "Pause",
        rewind: "Rewind",
        forward: "Forward",
        previous: "Previous",
        next: "Skip",
        loop: "Disable loop",
        loopOff: "Enable loop",
        volume: "Mute",
        volumeMute: "Unmute"
    };
    static defaultProps = {
        progressJumpSteps: {
            backward: 5000,
            forward: 5000
        },
        progressJumpStep: 5000
    };
    audio = (()=>(0, $bh6RR.createRef)())();
    progressBar = (()=>(0, $bh6RR.createRef)())();
    container = (()=>(0, $bh6RR.createRef)())();
    lastVolume = (()=>this.props.volume ?? 1)();
    togglePlay = (e)=>{
        e.stopPropagation();
        const audio = this.audio.current;
        if ((audio.paused || audio.ended) && audio.src) this.playAudioPromise();
        else if (!audio.paused) audio.pause();
    };
    playAudioPromise = ()=>{
        if (this.audio.current.error) this.audio.current.load();
        const playPromise = this.audio.current.play();
        if (playPromise) playPromise.then(null).catch((err)=>{
            const { onPlayError: onPlayError } = this.props;
            onPlayError && onPlayError(new Error(err));
        });
        else this.forceUpdate();
    };
    isPlaying = ()=>{
        const audio = this.audio.current;
        if (!audio) return false;
        return !audio.paused && !audio.ended;
    };
    handlePlay = (e)=>{
        this.forceUpdate();
        this.props.onPlay && this.props.onPlay(e);
    };
    handlePause = (e)=>{
        if (!this.audio) return;
        this.forceUpdate();
        this.props.onPause && this.props.onPause(e);
    };
    handleEnded = (e)=>{
        if (!this.audio) return;
        this.forceUpdate();
        this.props.onEnded && this.props.onEnded(e);
    };
    handleAbort = (e)=>{
        this.props.onAbort && this.props.onAbort(e);
    };
    handleClickVolumeButton = ()=>{
        const audio = this.audio.current;
        if (audio.volume > 0) {
            this.lastVolume = audio.volume;
            audio.volume = 0;
        } else audio.volume = this.lastVolume;
    };
    handleMuteChange = ()=>{
        this.forceUpdate();
    };
    handleClickLoopButton = ()=>{
        this.audio.current.loop = !this.audio.current.loop;
        this.forceUpdate();
    };
    handleClickRewind = ()=>{
        const { progressJumpSteps: progressJumpSteps, progressJumpStep: progressJumpStep } = this.props;
        const jumpStep = progressJumpSteps.backward || progressJumpStep;
        this.setJumpTime(-jumpStep);
    };
    handleClickForward = ()=>{
        const { progressJumpSteps: progressJumpSteps, progressJumpStep: progressJumpStep } = this.props;
        const jumpStep = progressJumpSteps.forward || progressJumpStep;
        this.setJumpTime(jumpStep);
    };
    setJumpTime = (time)=>{
        const audio = this.audio.current;
        const { duration: duration, currentTime: prevTime } = audio;
        if (audio.readyState === audio.HAVE_NOTHING || audio.readyState === audio.HAVE_METADATA || !isFinite(duration) || !isFinite(prevTime)) try {
            audio.load();
        } catch (err) {
            return this.props.onChangeCurrentTimeError && this.props.onChangeCurrentTimeError(err);
        }
        let currentTime = prevTime + time / 1000;
        if (currentTime < 0) {
            audio.currentTime = 0;
            currentTime = 0;
        } else if (currentTime > duration) {
            audio.currentTime = duration;
            currentTime = duration;
        } else audio.currentTime = currentTime;
    };
    setJumpVolume = (volume)=>{
        let newVolume = this.audio.current.volume + volume;
        if (newVolume < 0) newVolume = 0;
        else if (newVolume > 1) newVolume = 1;
        this.audio.current.volume = newVolume;
    };
    handleKeyDown = (e)=>{
        if (this.props.hasDefaultKeyBindings ?? true) switch(e.key){
            case " ":
                if (e.target === this.container.current || e.target === this.progressBar.current) {
                    e.preventDefault();
                    this.togglePlay(e);
                }
                break;
            case "ArrowLeft":
                this.handleClickRewind();
                break;
            case "ArrowRight":
                this.handleClickForward();
                break;
            case "ArrowUp":
                e.preventDefault();
                this.setJumpVolume(this.props.volumeJumpStep);
                break;
            case "ArrowDown":
                e.preventDefault();
                this.setJumpVolume(-this.props.volumeJumpStep);
                break;
            case "l":
                this.handleClickLoopButton();
                break;
            case "m":
                this.handleClickVolumeButton();
                break;
        }
    };
    renderUIModules = (modules)=>{
        return modules.map((comp, i)=>this.renderUIModule(comp, i));
    };
    renderUIModule = (comp, key)=>{
        const { defaultCurrentTime: defaultCurrentTime = "--:--", progressUpdateInterval: progressUpdateInterval = 20, showDownloadProgress: showDownloadProgress = true, showFilledProgress: showFilledProgress = true, showFilledVolume: showFilledVolume = false, defaultDuration: defaultDuration = "--:--", customIcons: customIcons = {}, showSkipControls: showSkipControls = false, onClickPrevious: onClickPrevious, onClickNext: onClickNext, onChangeCurrentTimeError: onChangeCurrentTimeError, showJumpControls: showJumpControls = true, customAdditionalControls: customAdditionalControls = [
            (0, $9cc3ea70cb340790$export$a6e85c853f2c034c).LOOP
        ], customVolumeControls: customVolumeControls = [
            (0, $9cc3ea70cb340790$export$a6e85c853f2c034c).VOLUME
        ], muted: muted = false, timeFormat: timeFormat = "auto", volume: volumeProp = 1, loop: loopProp = false, mse: mse, i18nAriaLabels: i18nAriaLabels = $4a788f79bad88934$var$H5AudioPlayer.defaultI18nAriaLabels } = this.props;
        switch(comp){
            case (0, $9cc3ea70cb340790$export$a6e85c853f2c034c).CURRENT_TIME:
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    key: key,
                    id: "rhap_current-time",
                    className: "rhap_time rhap_current-time"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $361a70cb554308af$export$2e2bcd8739ae039), {
                    audio: this.audio.current,
                    isLeftTime: false,
                    defaultCurrentTime: defaultCurrentTime,
                    timeFormat: timeFormat
                }));
            case (0, $9cc3ea70cb340790$export$a6e85c853f2c034c).CURRENT_LEFT_TIME:
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    key: key,
                    id: "rhap_current-left-time",
                    className: "rhap_time rhap_current-left-time"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $361a70cb554308af$export$2e2bcd8739ae039), {
                    audio: this.audio.current,
                    isLeftTime: true,
                    defaultCurrentTime: defaultCurrentTime,
                    timeFormat: timeFormat
                }));
            case (0, $9cc3ea70cb340790$export$a6e85c853f2c034c).PROGRESS_BAR:
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $0798354ecd49a108$export$2e2bcd8739ae039), {
                    key: key,
                    ref: this.progressBar,
                    audio: this.audio.current,
                    progressUpdateInterval: progressUpdateInterval,
                    showDownloadProgress: showDownloadProgress,
                    showFilledProgress: showFilledProgress,
                    onSeek: mse && mse.onSeek,
                    onChangeCurrentTimeError: onChangeCurrentTimeError,
                    srcDuration: mse && mse.srcDuration,
                    i18nProgressBar: i18nAriaLabels.progressControl
                });
            case (0, $9cc3ea70cb340790$export$a6e85c853f2c034c).DURATION:
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    key: key,
                    className: "rhap_time rhap_total-time"
                }, mse && mse.srcDuration ? (0, $58e7d7e7a518e14b$export$5ee6a13c18d2456e)(mse.srcDuration, mse.srcDuration, this.props.timeFormat) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3d752d32cc4df51a$export$2e2bcd8739ae039), {
                    audio: this.audio.current,
                    defaultDuration: defaultDuration,
                    timeFormat: timeFormat
                }));
            case (0, $9cc3ea70cb340790$export$a6e85c853f2c034c).ADDITIONAL_CONTROLS:
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    key: key,
                    className: "rhap_additional-controls"
                }, this.renderUIModules(customAdditionalControls));
            case (0, $9cc3ea70cb340790$export$a6e85c853f2c034c).MAIN_CONTROLS:
                {
                    const isPlaying = this.isPlaying();
                    let actionIcon;
                    if (isPlaying) actionIcon = customIcons.pause ? customIcons.pause : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8ac51c03dfec543e$export$f04a61298a47a40f), {
                        icon: "mdi:pause-circle"
                    });
                    else actionIcon = customIcons.play ? customIcons.play : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8ac51c03dfec543e$export$f04a61298a47a40f), {
                        icon: "mdi:play-circle"
                    });
                    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                        key: key,
                        className: "rhap_main-controls"
                    }, showSkipControls && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("button", {
                        "aria-label": i18nAriaLabels.previous,
                        className: "rhap_button-clear rhap_main-controls-button rhap_skip-button",
                        type: "button",
                        onClick: onClickPrevious
                    }, customIcons.previous ? customIcons.previous : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8ac51c03dfec543e$export$f04a61298a47a40f), {
                        icon: "mdi:skip-previous"
                    })), showJumpControls && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("button", {
                        "aria-label": i18nAriaLabels.rewind,
                        className: "rhap_button-clear rhap_main-controls-button rhap_rewind-button",
                        type: "button",
                        onClick: this.handleClickRewind
                    }, customIcons.rewind ? customIcons.rewind : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8ac51c03dfec543e$export$f04a61298a47a40f), {
                        icon: "mdi:rewind"
                    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("button", {
                        "aria-label": isPlaying ? i18nAriaLabels.pause : i18nAriaLabels.play,
                        className: "rhap_button-clear rhap_main-controls-button rhap_play-pause-button",
                        type: "button",
                        onClick: this.togglePlay
                    }, actionIcon), showJumpControls && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("button", {
                        "aria-label": i18nAriaLabels.forward,
                        className: "rhap_button-clear rhap_main-controls-button rhap_forward-button",
                        type: "button",
                        onClick: this.handleClickForward
                    }, customIcons.forward ? customIcons.forward : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8ac51c03dfec543e$export$f04a61298a47a40f), {
                        icon: "mdi:fast-forward"
                    })), showSkipControls && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("button", {
                        "aria-label": i18nAriaLabels.next,
                        className: "rhap_button-clear rhap_main-controls-button rhap_skip-button",
                        type: "button",
                        onClick: onClickNext
                    }, customIcons.next ? customIcons.next : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8ac51c03dfec543e$export$f04a61298a47a40f), {
                        icon: "mdi:skip-next"
                    })));
                }
            case (0, $9cc3ea70cb340790$export$a6e85c853f2c034c).VOLUME_CONTROLS:
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    key: key,
                    className: "rhap_volume-controls"
                }, this.renderUIModules(customVolumeControls));
            case (0, $9cc3ea70cb340790$export$a6e85c853f2c034c).LOOP:
                {
                    const loop = this.audio.current ? this.audio.current.loop : loopProp;
                    let loopIcon;
                    if (loop) loopIcon = customIcons.loop ? customIcons.loop : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8ac51c03dfec543e$export$f04a61298a47a40f), {
                        icon: "mdi:repeat"
                    });
                    else loopIcon = customIcons.loopOff ? customIcons.loopOff : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8ac51c03dfec543e$export$f04a61298a47a40f), {
                        icon: "mdi:repeat-off"
                    });
                    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("button", {
                        key: key,
                        "aria-label": loop ? i18nAriaLabels.loop : i18nAriaLabels.loopOff,
                        className: "rhap_button-clear rhap_repeat-button",
                        type: "button",
                        onClick: this.handleClickLoopButton
                    }, loopIcon);
                }
            case (0, $9cc3ea70cb340790$export$a6e85c853f2c034c).VOLUME:
                {
                    const { volume: volume = muted ? 0 : volumeProp } = this.audio.current || {};
                    let volumeIcon;
                    if (volume) volumeIcon = customIcons.volume ? customIcons.volume : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8ac51c03dfec543e$export$f04a61298a47a40f), {
                        icon: "mdi:volume-high"
                    });
                    else volumeIcon = customIcons.volume ? customIcons.volumeMute : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8ac51c03dfec543e$export$f04a61298a47a40f), {
                        icon: "mdi:volume-mute"
                    });
                    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                        key: key,
                        className: "rhap_volume-container"
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("button", {
                        "aria-label": volume ? i18nAriaLabels.volume : i18nAriaLabels.volumeMute,
                        onClick: this.handleClickVolumeButton,
                        type: "button",
                        className: "rhap_button-clear rhap_volume-button"
                    }, volumeIcon), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $cd25d970f1263001$export$2e2bcd8739ae039), {
                        audio: this.audio.current,
                        volume: volume,
                        onMuteChange: this.handleMuteChange,
                        showFilledVolume: showFilledVolume,
                        i18nVolumeControl: i18nAriaLabels.volumeControl
                    }));
                }
            default:
                if (!(0, $bh6RR.isValidElement)(comp)) return null;
                return comp.key ? comp : (0, $bh6RR.cloneElement)(comp, {
                    key: key
                });
        }
    };
    componentDidMount() {
        this.forceUpdate();
        const audio = this.audio.current;
        if (this.props.muted) audio.volume = 0;
        else audio.volume = this.lastVolume;
        audio.addEventListener("error", (e)=>{
            const target = e.target;
            if (target.error && target.currentTime === target.duration) return this.props.onEnded && this.props.onEnded(e);
            this.props.onError && this.props.onError(e);
        });
        audio.addEventListener("canplay", (e)=>{
            this.props.onCanPlay && this.props.onCanPlay(e);
        });
        audio.addEventListener("canplaythrough", (e)=>{
            this.props.onCanPlayThrough && this.props.onCanPlayThrough(e);
        });
        audio.addEventListener("play", this.handlePlay);
        audio.addEventListener("abort", this.handleAbort);
        audio.addEventListener("ended", this.handleEnded);
        audio.addEventListener("playing", (e)=>{
            this.props.onPlaying && this.props.onPlaying(e);
        });
        audio.addEventListener("seeking", (e)=>{
            this.props.onSeeking && this.props.onSeeking(e);
        });
        audio.addEventListener("seeked", (e)=>{
            this.props.onSeeked && this.props.onSeeked(e);
        });
        audio.addEventListener("waiting", (e)=>{
            this.props.onWaiting && this.props.onWaiting(e);
        });
        audio.addEventListener("emptied", (e)=>{
            this.props.onEmptied && this.props.onEmptied(e);
        });
        audio.addEventListener("stalled", (e)=>{
            this.props.onStalled && this.props.onStalled(e);
        });
        audio.addEventListener("suspend", (e)=>{
            this.props.onSuspend && this.props.onSuspend(e);
        });
        audio.addEventListener("loadstart", (e)=>{
            this.props.onLoadStart && this.props.onLoadStart(e);
        });
        audio.addEventListener("loadedmetadata", (e)=>{
            this.props.onLoadedMetaData && this.props.onLoadedMetaData(e);
        });
        audio.addEventListener("loadeddata", (e)=>{
            this.props.onLoadedData && this.props.onLoadedData(e);
        });
        audio.addEventListener("pause", this.handlePause);
        audio.addEventListener("timeupdate", (0, $58e7d7e7a518e14b$export$de363e709c412c8a)((e)=>{
            this.props.onListen && this.props.onListen(e);
        }, this.props.listenInterval));
        audio.addEventListener("volumechange", (e)=>{
            this.props.onVolumeChange && this.props.onVolumeChange(e);
        });
        audio.addEventListener("encrypted", (e)=>{
            const { mse: mse } = this.props;
            mse && mse.onEcrypted && mse.onEcrypted(e);
        });
    }
    componentDidUpdate(prevProps) {
        const { src: src, autoPlayAfterSrcChange: autoPlayAfterSrcChange } = this.props;
        if (prevProps.src !== src) {
            if (autoPlayAfterSrcChange) this.playAudioPromise();
            else this.forceUpdate();
        }
    }
    render() {
        const { className: className = "", src: src, loop: loopProp = false, preload: preload = "auto", autoPlay: autoPlay = false, crossOrigin: crossOrigin, mediaGroup: mediaGroup, header: header, footer: footer, layout: layout = "stacked", customProgressBarSection: customProgressBarSection = [
            (0, $9cc3ea70cb340790$export$a6e85c853f2c034c).CURRENT_TIME,
            (0, $9cc3ea70cb340790$export$a6e85c853f2c034c).PROGRESS_BAR,
            (0, $9cc3ea70cb340790$export$a6e85c853f2c034c).DURATION
        ], customControlsSection: customControlsSection = [
            (0, $9cc3ea70cb340790$export$a6e85c853f2c034c).ADDITIONAL_CONTROLS,
            (0, $9cc3ea70cb340790$export$a6e85c853f2c034c).MAIN_CONTROLS,
            (0, $9cc3ea70cb340790$export$a6e85c853f2c034c).VOLUME_CONTROLS
        ], children: children, style: style, i18nAriaLabels: i18nAriaLabels = $4a788f79bad88934$var$H5AudioPlayer.defaultI18nAriaLabels } = this.props;
        const loop = this.audio.current ? this.audio.current.loop : loopProp;
        const loopClass = loop ? "rhap_loop--on" : "rhap_loop--off";
        const isPlayingClass = this.isPlaying() ? "rhap_play-status--playing" : "rhap_play-status--paused";
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            role: "group",
            tabIndex: 0,
            "aria-label": i18nAriaLabels.player,
            className: `rhap_container ${loopClass} ${isPlayingClass} ${className}`,
            onKeyDown: this.handleKeyDown,
            ref: this.container,
            style: style
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("audio", {
            src: src,
            controls: false,
            loop: loop,
            autoPlay: autoPlay,
            preload: preload,
            crossOrigin: crossOrigin,
            mediaGroup: mediaGroup,
            ref: this.audio
        }, children), header && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: "rhap_header"
        }, header), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: `rhap_main ${(0, $58e7d7e7a518e14b$export$7e9bdabab6bd863e)(layout)}`
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: "rhap_progress-section"
        }, this.renderUIModules(customProgressBarSection)), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: "rhap_controls-section"
        }, this.renderUIModules(customControlsSection))), footer && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: "rhap_footer"
        }, footer));
    }
}
var $4a788f79bad88934$export$2e2bcd8739ae039 = $4a788f79bad88934$var$H5AudioPlayer;





const $15cc967688028d0b$var$AudioSource = ({ src: src, picture: picture, downloadUrl: downloadUrl })=>{
    const [blobUrl, setBlobUrl] = (0, $bh6RR.useState)(null);
    downloadUrl = downloadUrl == null ? src : downloadUrl;
    (0, $bh6RR.useEffect)(()=>{
        let active = true;
        let objectUrl = null;
        const loadBlob = async ()=>{
            try {
                const token = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("token");
                const response = await fetch(src, {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                });
                if (!response.ok) {
                    const text = await response.text();
                    console.error("Erreur fetch :", text);
                    throw new Error(`HTTP ${response.status}`);
                }
                const blob = await response.blob();
                objectUrl = URL.createObjectURL(blob);
                if (active) setBlobUrl(objectUrl);
            } catch (e) {
                console.error("Erreur chargement blob audio :", e);
            }
        };
        loadBlob();
        return ()=>{
            active = false;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [
        src
    ]);
    if (!blobUrl) return null;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "audio-container",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4a788f79bad88934$export$2e2bcd8739ae039), {
                src: blobUrl,
                autoPlay: false
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "download_button_container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                    href: downloadUrl,
                    className: "download_audio_source",
                    download: true,
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                        icon: "fas fa-download",
                        className: "download_button_audio"
                    })
                })
            })
        ]
    });
};
var $15cc967688028d0b$export$2e2bcd8739ae039 = $15cc967688028d0b$var$AudioSource;






function $160f69507d0a991d$var$ConversationChatbox({ messages: messages }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "conversation_chatbox_main_container",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: "conversation_content",
            children: messages && messages.map(({ human: human, content: content, is_hidden: is_hidden }, index)=>{
                return is_hidden == 0 && (index == messages.length - 1 || messages[index + 1].is_hidden != 1) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "conversation_bubble_conv " + (human == 0 ? "conversation_bubble_bot_conv" : "conversation_bubble_human_conv"),
                    children: content
                }, index);
            })
        })
    });
}
var $160f69507d0a991d$export$2e2bcd8739ae039 = $160f69507d0a991d$var$ConversationChatbox;




const $28b1d37546c8d957$var$numberOfInteraction = (messages)=>{
    let cpt = 0;
    let currentType = null;
    for(let i = 0; i < messages.length; i++){
        let mess = messages[i];
        if (mess.human == 0) continue;
        cpt++;
        currentType = mess.human;
    }
    return cpt;
};
var $28b1d37546c8d957$export$2e2bcd8739ae039 = $28b1d37546c8d957$var$numberOfInteraction;


const $95dd689368015240$export$75bba95db5c3e753 = (duration, conversation_created_at, messages, updated_at)=>{
    if (messages.length == 0 || conversation_created_at == null) return "0s";
    const firstMsg = $95dd689368015240$var$parseUTC(conversation_created_at);
    const updatedAtDate = $95dd689368015240$var$parseUTC(updated_at);
    var diffMs = updatedAtDate - firstMsg;
    if (diffMs > 3600000) diffMs = diffMs - 3600000;
    var totalSeconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    let val = minutes ? `${minutes}min` : "";
    return val += seconds + "s";
};
const $95dd689368015240$export$7a80cf575381397d = (conversation_created_at, messages, updated_at)=>{
    if (messages.length == 0 || conversation_created_at == null) return "0s";
    let firstMsg = $95dd689368015240$var$parseUTC(conversation_created_at);
    let lastMsg = $95dd689368015240$var$parseUTC(messages[messages.length - 1].created_at.split(".")[0]);
    let updatedAtDate = $95dd689368015240$var$parseUTC(updated_at);
    if (updatedAtDate - lastMsg <= 45000 && updatedAtDate >= lastMsg) lastMsg = updatedAtDate;
    var diffMs = lastMsg - firstMsg;
    var totalSeconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    let val = minutes ? `${minutes}min` : "";
    return val += seconds + "s";
};
var $95dd689368015240$export$2e2bcd8739ae039 = $95dd689368015240$export$75bba95db5c3e753;
const $95dd689368015240$var$parseUTC = (dateStr)=>{
    if (!dateStr) return null;
    let formatted = dateStr.replace(" ", "T");
    if (!formatted.endsWith("Z")) formatted += "Z";
    return new Date(formatted);
};






const $25a7f3edb16cffb1$var$getAudioUrl = (conversationId, objectId, download = false)=>`${(0, $651df53b10514175$export$a7b6bc01c63cdfc3).REACT_APP_API_PATH}/conversation/completed/${conversationId}/audio?object_id=${objectId}&download=${download}&token_auth=${(0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("token")}`;
const $25a7f3edb16cffb1$var$ConversationModalInformationDetails = ({ data: data, state: state, onClose: onClose })=>{
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const dataCommons = [
        {
            name: "ID",
            value: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                style: {
                    color: "var(--main)",
                    cursor: "pointer"
                },
                onClick: (e)=>navigator.clipboard.writeText(data.instance_id).then((_)=>{
                        toast.success("Copy token to clipboard", "You can paste this token where you need !", 5000);
                    }),
                children: [
                    "  ",
                    data.instance_id
                ]
            })
        },
        {
            name: "Date",
            value: (0, $e2b536164b89f027$export$6dd95649f19af5f8)(state == 1 || state == 2 ? data.created_at : data.schedule, state == 3)
        },
        {
            name: "Bot",
            value: state == 1 || state == 2 ? data.name : data.bot.name
        }
    ];
    const dataCompleted = state == 1 || state == 2 ? [
        {
            name: "Total Duration",
            value: data.duration || data.conversation_telephony_created_at ? (0, $95dd689368015240$export$2e2bcd8739ae039)(data.duration, data.conversation_telephony_created_at, data.messages, data.updated_at) : ""
        },
        {
            name: "Interactions",
            value: (0, $28b1d37546c8d957$export$2e2bcd8739ae039)(data.messages)
        },
        {
            name: "Caller",
            value: data.caller ? (0, $6fa58a9c96b5552d$export$2e2bcd8739ae039)(data.caller) : "Unknown"
        },
        {
            name: "Called",
            value: data.numbers ? (0, $6fa58a9c96b5552d$export$2e2bcd8739ae039)(data.numbers) : "Unknown"
        }
    ] : [];
    const dataRow = [
        ...dataCommons,
        ...dataCompleted
    ];
    const renderChannelType = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                label: "Channel",
                listLabelClassName: "titles-input text-bold"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "channel-icon-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    width: "30px",
                    style: {
                        marginLeft: "20px",
                        marginTop: "-5px"
                    },
                    srcSet: data.channel_type_id ? (0, $b3e51b95dcf04d66$export$2e2bcd8739ae039)[data.channel_type.name] : (0, $1fee5a8fea268ee3$export$2e2bcd8739ae039)[data.bot_job_type.name]
                })
            })
        ]
    });
    // Fonction pour ajouter des balises HTML et des styles aux clés et aux valeurs
    const highlightJSON = (jsonString)=>{
        let result = jsonString;
        result = result.replace(/"([\w\s-]+)":/g, '<span style="color: rgb(14, 122, 237);">"$1":</span>');
        result = result.replace(/: ("[^"]*")/g, ': <span style="color: green;">$1</span>');
        result = result.replace(/\\n/g, "").replace(/\\"/g, '"').replace(/\"\"/, '"');
        return result;
    };
    const highlightedJSON = highlightJSON(data.body ? JSON.stringify(data.body, null, 2) : "");
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: state == 1 || state == 2 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "block_conversation",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "container-conversations",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "grid_container_conversation_fields",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "row-conversation",
                                    children: renderChannelType
                                }),
                                dataRow.map((row, i)=>(i >= dataRow.length - 2 && data.channel_type_id == 3 || i < dataRow.length - 2) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                        className: "container_field_converation_information",
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                label: row.name,
                                                listLabelClassName: "titles-input"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                label: row.value,
                                                listLabelClassName: "titles-input conversation_detail_text_input_value conversation_detail_text_input_value_weight"
                                            })
                                        ]
                                    }))
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "conversation_follow_up_separator",
                            style: {
                                marginTop: "1px"
                            }
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            style: {
                                justifyContent: "center",
                                display: "flex",
                                marginTop: data.channel_type_id == 3 ? "" : "5%"
                            },
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "conversation_chat_conversations",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $160f69507d0a991d$export$2e2bcd8739ae039), {
                                    messages: data.messages
                                })
                            })
                        })
                    ]
                }),
                data.channel_type_id == 3 && !data.messages.some((message)=>message.is_hidden == 1) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                style: {
                                    width: "75%"
                                },
                                children: data.audio_object_id && data.audio_object_id.includes(".") == false ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $15cc967688028d0b$export$2e2bcd8739ae039), {
                                    className: "audio_src_conversation_information_modal",
                                    picture: false,
                                    src: $25a7f3edb16cffb1$var$getAudioUrl(data.id, data.audio_object_id),
                                    downloadUrl: $25a7f3edb16cffb1$var$getAudioUrl(data.id, data.audio_object_id, true)
                                }) : null
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "conversation_modal_follow_up_block_relaunch",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "flex_url",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            label: "Url :",
                            listLabelClassName: "titles-input"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                children: [
                                    " \xa0 ",
                                    data.url,
                                    " "
                                ]
                            }),
                            listLabelClassName: "titles-input conversation_detail_text_input_value_weight"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                            label: "Body",
                            listLabelClassName: "titles-input"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("pre", {
                            className: "conversation_modal_follow_up_body_json_detail",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("code", {
                                dangerouslySetInnerHTML: {
                                    __html: $726d757834788151$exports.sanitize(highlightedJSON, {
                                        sanitize: true
                                    })
                                },
                                style: {
                                    fontFamily: "Nunito",
                                    fontWeight: "600px"
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $25a7f3edb16cffb1$export$2e2bcd8739ae039 = $25a7f3edb16cffb1$var$ConversationModalInformationDetails;






var $bh6RR = parcelRequire("bh6RR");
const $f31d16d63c660e6d$var$ConversationDetailsModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ title: title, data: data, state: state, onRefresh: onRefresh })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const handleClose = ()=>{
        onClose();
        onRefresh && onRefresh();
    };
    const copyToClipBoard = async (e)=>{
        const url = `${location.protocol}//${location.host}${location.pathname}?conversation_id=${data?.instance_id}`;
        await navigator.clipboard.writeText(url);
        toast.success("Share your Url", `The Url of sharing is copied`, 5000);
    };
    const [isSending, setIsSending] = (0, $bh6RR.useState)(false);
    const mailConvo = async (data)=>{
        if (isSending) return;
        try {
            setIsSending(true);
            if (!data.messages || data.messages.length === 0) {
                toast.error("No Conversation to send", "There is no conversation to mail");
                alert("No messages to send");
                return;
            }
            // onClose();
            const conversationId = data.id;
            const response = await (0, $91781fdb5acb258d$export$2e2bcd8739ae039).sendConversationByMail(conversationId);
            const result = response?.[0];
            if (result?.success) toast.success("Conversation sent successfully", "The conversation has been sent to your email address.");
            else toast.error("Failed to send conversation", "The conversation could not be sent.");
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong", "We couldn\u2019t send the conversation. Please try again later.");
        } finally{
            setIsSending(false);
        }
    };
    const itemsConversations = [
        {
            name: "Information",
            component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $25a7f3edb16cffb1$export$2e2bcd8739ae039), {
                data: data,
                state: state,
                onClose: handleClose
            })
        },
        {
            name: state == 1 ? "Follow-up" : "Content",
            component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7a02280d6ba3fae9$export$2e2bcd8739ae039), {
                data: data,
                state: state
            })
        }
    ];
    /*
        const itemsRelaunch = [
            { name: 'Information', component: <ConversationModalInformationDetails data={data} state={state} /> },
            { name: 'Follow-up', component: <ConversationModalFollowUp url={data.url} body={data.body} {...state} /> },
        ];
    */ return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $9c2d88d3df32f983$export$2e2bcd8739ae039), {
        id: modal.id,
        autoClose: "true",
        onClose: handleClose,
        style: {
            width: "550px",
            zIndex: "1000"
        },
        name: "conversation_modal",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container close_convo_modal_container",
                    onClick: handleClose,
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
                className: "form-conversation edit-container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "title",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                                children: title
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                class: "icon",
                                onClick: copyToClipBoard
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: `send-convo-icon ${isSending ? "disabled" : ""}`,
                                onClick: ()=>mailConvo(data),
                                title: "Send conversation by email",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                    className: "fa fa-paper-plane",
                                    "aria-hidden": "true",
                                    alt: "Send conversation by email",
                                    style: {
                                        color: "var(--main)"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                        className: "body-editModal-container",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $297630b888b8597e$export$2e2bcd8739ae039), {
                            name: "slide_conversation_modal_form",
                            items: itemsConversations,
                            classNameTab: "tab-justify",
                            classNameIndicator: "space_left_conversation_form_modal",
                            type: "tab"
                        })
                    })
                ]
            })
        ]
    });
});
var $f31d16d63c660e6d$export$2e2bcd8739ae039 = $f31d16d63c660e6d$var$ConversationDetailsModal;









var $bh6RR = parcelRequire("bh6RR");








var $bh6RR = parcelRequire("bh6RR");
const $24d2cf612fa4105f$var$TextInputTime = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, ref)=>{
    const prefixeClassName = "input";
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
        ...props,
        ref: ref,
        type: "time",
        className: prefixeClassName + (props.className ? " " + props.className : "")
    });
});
$24d2cf612fa4105f$var$TextInputTime.defaultProps = {
    className: "full-width",
    type: "text",
    autoComplete: "chrome-off"
};
var $24d2cf612fa4105f$export$2e2bcd8739ae039 = $24d2cf612fa4105f$var$TextInputTime;










var /*
export default {
    mail: IconWeb,
    sms: IconMessenger,
    phone: IconPhone
}
*/ $898b3cc64e8cf0eb$export$2e2bcd8739ae039 = [
    {
        value: "1",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                " ",
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    srcSet: (0, (/*@__PURE__*/$parcel$interopDefault($ec781ed39d836b3e$exports)))
                }),
                " "
            ]
        })
    },
    {
        value: "2",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                " ",
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    srcSet: (0, (/*@__PURE__*/$parcel$interopDefault($986e564353b9e0a7$exports)))
                }),
                " "
            ]
        })
    },
    {
        value: "3",
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                " ",
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    srcSet: (0, (/*@__PURE__*/$parcel$interopDefault($ae6a237c45c511ec$exports)))
                })
            ]
        })
    }
];








var /*
export default {
    mail: IconWeb,
    sms: IconMessenger,
    phone: IconPhone
}
*/ $9a804d912b8ef767$export$2e2bcd8739ae039 = [
    {
        value: 1,
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                " ",
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    srcSet: (0, (/*@__PURE__*/$parcel$interopDefault($ae6a237c45c511ec$exports)))
                }),
                " "
            ]
        })
    },
    {
        value: 3,
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                " ",
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    srcSet: (0, (/*@__PURE__*/$parcel$interopDefault($986e564353b9e0a7$exports)))
                })
            ]
        })
    }
];




var $bh6RR = parcelRequire("bh6RR");





const $ee0a6fe529c238bb$var$ListMarkers = ({ updateMarkersValues: updateMarkersValues, resetMarkers: resetMarkers })=>{
    const [listCheckedMarkerList, setListCheckedMarkerList] = (0, $bh6RR.useState)([]);
    const { getMarkers: getMarkers } = (0, $91781fdb5acb258d$export$2e2bcd8739ae039);
    const [markersList, setMarkersList] = (0, $bh6RR.useState)([]);
    const [isChecked, setIsChecked] = (0, $bh6RR.useState)(false);
    const getAllMarkers = async ()=>{
        let [response, error] = await getMarkers();
        if (error !== null) {
            console.log(error);
            return;
        }
        let markers = (0, $b6b235c5b8c1f5b6$export$e14f85ca0e45cc50)("conversation_filters")?.markers?.split(","); // un state surtout pour actualiser visuellement les dropdown quand on refresh
        setListCheckedMarkerList(markers ? markers.map((id)=>{
            return {
                id: id
            };
        }) : []);
        setMarkersList(response);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (markersList != []) setListCheckedMarkerList([]);
    }, [
        resetMarkers
    ]);
    (0, $bh6RR.useEffect)(()=>{
        getAllMarkers();
    }, []);
    const checkMarkerList = (_marker)=>{
        setIsChecked(!isChecked);
        let resultList = [
            ...listCheckedMarkerList
        ];
        let index = resultList.findIndex((item)=>item.id == _marker.id);
        if (index === -1) resultList.push(_marker);
        else resultList.splice(index, 1);
        setListCheckedMarkerList(resultList);
        let markerIdsTextList = resultList.filter((res)=>res.id != "").map((marker)=>marker.id).join(",");
        updateMarkersValues(markerIdsTextList, resultList);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: Array.isArray(markersList) && markersList.length > 0 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: "markers_list_channel_filter",
            children: markersList.map((marker, i)=>{
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $178302845e817360$export$2e2bcd8739ae039), {
                    marker: marker,
                    mode: 1,
                    icon: listCheckedMarkerList.some((item)=>item.id == marker.id) ? "fas fa-check-circle" : "fas fa-plus-circle",
                    onClick: ()=>checkMarkerList(marker)
                }, i);
            })
        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: "conversation_follow_up_no_marker_message",
            style: {
                width: "85%"
            },
            children: "There are no more markers available"
        })
    });
};
var $ee0a6fe529c238bb$export$2e2bcd8739ae039 = $ee0a6fe529c238bb$var$ListMarkers;




const $3235f35df9231c2e$var$FormConversationFilter = ({ title: title, onCloseModal: onCloseModal, postbackAction: postbackAction, mode: mode })=>{
    const { getBots: getBots } = (0, $24a8370de200c756$export$2e2bcd8739ae039);
    const [dataLocal, setDataLocal] = (0, $bh6RR.useState)((0, $b6b235c5b8c1f5b6$export$e14f85ca0e45cc50)("conversation_filters")); // un state surtout pour actualiser visuellement les dropdown quand on refresh
    const [bots, setBots] = (0, $bh6RR.useState)("");
    const [selectedDates, setSelectedDates] = (0, $bh6RR.useState)(dataLocal?.dates ?? null);
    const [resetMarkers, setResetMarkers] = (0, $bh6RR.useState)(false);
    const [startTime, setStartTime] = (0, $bh6RR.useState)("");
    const [endTime, setEndTime] = (0, $bh6RR.useState)("");
    const defaultValues = {
        bot_id: "",
        channel_type_id: "",
        markers: "",
        dates: "",
        conversation_id: "",
        text_content: "",
        caller: "",
        numbers: "",
        calldata: "",
        url: "",
        body: "",
        bot_job_id: "",
        bot_job_type_id: "",
        start_time: "",
        end_time: ""
    };
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors }, formState: formState, getValues: getValues, setValue: setValue, watch: watch } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            bot_id: dataLocal ? dataLocal.bot_id : -1,
            channel_type_id: dataLocal ? dataLocal.channel_type_id : -1,
            markers: dataLocal ? dataLocal.markers : "",
            dates: dataLocal ? dataLocal.dates : "",
            conversation_id: dataLocal ? dataLocal.conversation_id : "",
            bot_job_id: dataLocal ? dataLocal.bot_job_id : "",
            text_content: dataLocal ? dataLocal.text_content : "",
            caller: dataLocal ? dataLocal.caller : "",
            numbers: dataLocal ? dataLocal.numbers : "",
            calldata: dataLocal ? dataLocal.calldata : "",
            url: dataLocal ? dataLocal.url : "",
            body: dataLocal ? dataLocal.body : "",
            start_time: dataLocal ? dataLocal.start_time : "",
            end_time: dataLocal ? dataLocal.end_time : ""
        }
    });
    const cleanStorage = ()=>{
        (0, $b6b235c5b8c1f5b6$export$436ab9ffc2d94549)("conversation_filters", {});
        setSelectedDates(null);
        for(let fieldName in defaultValues)setValue(fieldName, defaultValues[fieldName]);
        setDataLocal(defaultValues);
        setResetMarkers(!resetMarkers);
    };
    const updateMarkersValues = (selectedMarkersList, resultList)=>{
        setValue("markers", selectedMarkersList);
    };
    const checkEmptyDropdownValue = (data, label)=>{
        let value = data[label];
        if (value == "" || value == -1) value = value == -1 ? "" : dataLocal ? dataLocal[label] : ""; //au cas ou on ne selectionne rien dans la dropdown
        return value;
    };
    const onSubmit = ()=>{
        let data = getValues();
        data.bot_id = checkEmptyDropdownValue(data, "bot_id");
        data.channel_type_id = checkEmptyDropdownValue(data, "channel_type_id");
        //data.date = selectedDates;
        let dataToSend = data;
        if (mode == 2) dataToSend.bot_job_type_id = dataToSend.channel_type_id;
        const noEmptyValues = Object.fromEntries(Object.entries(data).filter(([_, value])=>value !== null && value !== "" && value !== undefined));
        (0, $b6b235c5b8c1f5b6$export$436ab9ffc2d94549)("conversation_filters", noEmptyValues);
        postbackAction(noEmptyValues);
        onCloseModal();
    };
    const setUpBots = (_bots)=>{
        const bots = _bots || [];
        const initialOption = {
            value: "-1",
            text: "Choose bot"
        };
        const sortedBots = bots.sort((a, b)=>a.name.localeCompare(b.name));
        return [
            initialOption,
            ...sortedBots.map((bot)=>({
                    value: bot.id,
                    text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                        style: {
                            maxWidth: "300px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                style: {
                                    marginRight: "15px"
                                },
                                className: "flag-icon flag-icon-" + bot.language.slug.toLowerCase()
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "conversation_content_dropdown",
                                children: bot.name
                            })
                        ]
                    })
                }))
        ];
    };
    let listChannelChoice = [
        {
            value: "-1",
            text: "Choose channel"
        },
        ...mode != "2" ? (0, $9a804d912b8ef767$export$2e2bcd8739ae039) : (0, $898b3cc64e8cf0eb$export$2e2bcd8739ae039)
    ];
    const getAllBots = async ()=>{
        let [response, error] = await getBots();
        if (error !== null) {
            console.log(error);
            return;
        }
        setValue("bot", "");
        setBots(setUpBots(response));
    };
    (0, $bh6RR.useEffect)(()=>{
        getAllBots();
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                children: title
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                className: (mode == 0 || mode == 1) && "conversation_form_filter_body",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "content_form_filter_conversation",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "conversation_filter_dropdown_container",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Channel",
                                    listLabelClassName: "field-modal"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    children: (0, $8f11537c2efba18d$export$2e2bcd8739ae039)?.length > 0 && // la valeur par default existe OBLIGATOIREMENT sinon la liste serait vide donc pas affichee
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                        name: "channel_type_id",
                                        setValue: setValue,
                                        choices: listChannelChoice,
                                        defaultChoice: dataLocal ? dataLocal.channel_type_id : (0, $8f11537c2efba18d$export$2e2bcd8739ae039)[0]?.id,
                                        width: "200px"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "conversation_filter_dropdown_container",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Bot",
                                    listLabelClassName: "field-modal"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    children: bots?.length > 0 && // la valeur par default existe OBLIGATOIREMENT sinon la liste serait vide donc pas affichee
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                        name: "bot_id",
                                        setValue: setValue,
                                        choices: bots,
                                        defaultChoice: dataLocal ? dataLocal.bot_id : bots[0]?.id,
                                        width: "200px"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "conversation_filter_input_container",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "ID",
                                    listLabelClassName: "field-modal"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ...register(mode == 2 ? "bot_job_id" : "conversation_id"),
                                    placeholder: "Enter the conversation id",
                                    className: "input full-width"
                                })
                            ]
                        }),
                        (mode == 0 || mode == 1) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                            children: [
                                mode == 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "conversation_filter_input_container",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Days",
                                            listLabelClassName: "field-modal"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $038b1e84aa307cfb$export$2e2bcd8739ae039), {
                                            className: "conversation_input_date",
                                            dates: selectedDates,
                                            setValue: (_dates)=>{
                                                setValue("dates", _dates);
                                                setSelectedDates(_dates);
                                            },
                                            removeSeparator: true
                                        })
                                    ]
                                }),
                                mode == 0 && selectedDates && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "conversation_filter_input_container",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Time",
                                            listLabelClassName: "field-modal"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "conversation_container_time-inputs",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24d2cf612fa4105f$export$2e2bcd8739ae039), {
                                                    ...register("start_time"),
                                                    onChange: (e)=>setStartTime(e.target.value),
                                                    placeholder: "Start Time"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    children: "to"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24d2cf612fa4105f$export$2e2bcd8739ae039), {
                                                    ...register("end_time"),
                                                    onChange: (e)=>setEndTime(e.target.value),
                                                    placeholder: "End Time"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "conversation_filter_input_container",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Text Content",
                                            listLabelClassName: "field-modal"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("text_content"),
                                            placeholder: "Enter the content text",
                                            className: "input full-width"
                                        })
                                    ]
                                }),
                                watch("channel_type_id") !== 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "conversation_filter_input_container",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                    label: "Caller",
                                                    listLabelClassName: "field-modal"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                                    ...register("caller"),
                                                    placeholder: "Enter the phone number",
                                                    className: "input full-width"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "conversation_filter_input_container",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                    label: "Called",
                                                    listLabelClassName: "field-modal"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                                    ...register("numbers"),
                                                    placeholder: "Enter the phone number",
                                                    className: "input full-width"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        mode == 2 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "conversation_filter_input_container",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Url",
                                            listLabelClassName: "field-modal"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("url"),
                                            placeholder: "Enter the url",
                                            className: "input full-width"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "conversation_filter_input_container",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Body",
                                            listLabelClassName: "field-modal"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("body"),
                                            placeholder: "Enter the body content",
                                            className: "input full-width"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "conversation_filter_input_container",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Data",
                                            listLabelClassName: "field-modal"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                            ...register("calldata"),
                                            placeholder: "Enter the data",
                                            className: "input full-width"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "conversation_filter_input_container",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Markers",
                                            listLabelClassName: "field-modal"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ee0a6fe529c238bb$export$2e2bcd8739ae039), {
                                            updateMarkersValues: updateMarkersValues,
                                            resetMarkers: resetMarkers
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                className: "form_conversation_filter_space_button",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        type: "button",
                        label: "Reset Filter",
                        className: "button cancel",
                        onClick: cleanStorage
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        type: "submit",
                        label: "Ok",
                        className: "validate  btn-center",
                        disabled: !formState.isValid
                    })
                ]
            })
        ]
    });
};
var $3235f35df9231c2e$export$2e2bcd8739ae039 = $3235f35df9231c2e$var$FormConversationFilter;



const $2c39501eaa1138c9$var$ConversationFilterModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ title: title, postbackAction: postbackAction, mode: mode })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        name: mode == 0 || mode == 1 ? "conversation_filter_modal_container" : "conversation_filter_relaunch_modal_container",
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "leave-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3235f35df9231c2e$export$2e2bcd8739ae039), {
                title: title,
                onCloseModal: onClose,
                postbackAction: postbackAction,
                mode: mode
            })
        ]
    });
});
var $2c39501eaa1138c9$export$2e2bcd8739ae039 = $2c39501eaa1138c9$var$ConversationFilterModal;






















const $dbafeaff139f6b19$var$ConversationLogVariable = ({ variable: variable })=>{
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "conversation_log_container_variable",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "conversation_log_name_variable",
                title: variable[0],
                children: [
                    " ",
                    [
                        variable[0]
                    ],
                    " "
                ]
            }),
            " ",
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                className: "conversation_log_value_variable",
                defaultValue: variable[1],
                disabled: true
            })
        ]
    });
};
var $dbafeaff139f6b19$export$2e2bcd8739ae039 = $dbafeaff139f6b19$var$ConversationLogVariable;


const $46ed2f2c173ddc6a$var$ConversationLogsModalVariablesDetails = ({ data: data })=>{
    const variablesJSON = JSON.parse(data.logs) ? JSON.parse(data.logs).variables ?? [] : [];
    let variables = Object.keys(variablesJSON).map((key)=>[
            key,
            variablesJSON[key]
        ]);
    variables = variables.sort((a, b)=>a[0].localeCompare(b[0]));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "grid_container_conversation_variables_fields",
        children: variables.map((variable, i)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $dbafeaff139f6b19$export$2e2bcd8739ae039), {
                variable: variable
            }, i))
    });
};
var $46ed2f2c173ddc6a$export$2e2bcd8739ae039 = $46ed2f2c173ddc6a$var$ConversationLogsModalVariablesDetails;








const $c86b02b9cef71cb4$var$ConversationPath = ({ block: block, bot: bot })=>{
    const url = `${location.protocol}//${location.host}/company/${bot.company.name}/bots/${bot.name}?#${block?.object_id}`;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "conversation_log_container_variable",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "chatbox_path_container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "chatbox_path_icon " + block?.type.name + "_icon"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("a", {
                    href: url,
                    target: "_blank",
                    children: [
                        " ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                            className: "hover_label_path " + block?.type.name + "_label_path",
                            children: [
                                " ",
                                block?.name
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $c86b02b9cef71cb4$export$2e2bcd8739ae039 = $c86b02b9cef71cb4$var$ConversationPath;




var $bh6RR = parcelRequire("bh6RR");

const $b7aaa7f99a4c73ce$var$ConversationLogsModalPathDetails = ({ data: data, state: state })=>{
    const [blocksBot, setBlocksBot] = (0, $bh6RR.useState)([]);
    const { getBotInformations: getBotInformations } = (0, $09b215dee01724cc$export$2e2bcd8739ae039);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const path = JSON.parse(data.logs) ? JSON.parse(data.logs).path : [];
    const actionGetBotInformations = async ()=>{
        const [response, error] = await getBotInformations(data.bot.name);
        if (error !== null) {
            const { status: status } = error;
            if (status == 422) return error;
            toast.error("Error during loading", "Cannot fetch bot data");
            return;
        }
        var { blocks: blocks } = response;
        setBlocksBot(blocks);
    };
    const getBlock = (block_id)=>{
        return blocksBot.find((b)=>b.object_id === block_id);
    };
    (0, $bh6RR.useEffect)(()=>{
        actionGetBotInformations();
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "grid_container_conversation_path_fields",
        children: blocksBot.length > 0 && path.map((block_id, i)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c86b02b9cef71cb4$export$2e2bcd8739ae039), {
                block: getBlock(block_id),
                bot: data.bot
            }, i))
    });
};
var $b7aaa7f99a4c73ce$export$2e2bcd8739ae039 = $b7aaa7f99a4c73ce$var$ConversationLogsModalPathDetails;




const $01c9eda283185e67$var$ConversationLogsModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ title: title, data: data })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const itemsConversations = [
        {
            name: "Variables",
            component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $46ed2f2c173ddc6a$export$2e2bcd8739ae039), {
                data: data
            })
        },
        {
            name: "Path",
            component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b7aaa7f99a4c73ce$export$2e2bcd8739ae039), {
                data: data
            })
        }
    ];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $9c2d88d3df32f983$export$2e2bcd8739ae039), {
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        style: {
            width: "550px",
            overflow: "unset"
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
                className: "conversation_logs_edit_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                        className: "conversation_logs_body_container",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $297630b888b8597e$export$2e2bcd8739ae039), {
                            name: "slide_conversation_logs_form",
                            items: itemsConversations,
                            classNameTab: "conversation_logs_modal_tab_justify",
                            classNameIndicator: "space_left_conversation_logs_modal",
                            type: "tab"
                        })
                    })
                ]
            })
        ]
    });
});
var $01c9eda283185e67$export$2e2bcd8739ae039 = $01c9eda283185e67$var$ConversationLogsModal;



function $25f04b1f711109b7$var$ConversationTableCompleted({ setRefreshList: setRefreshList }) {
    const { getConversations: getConversations, deleteConversation: deleteConversation } = (0, $5432fd46a827f2ed$export$2e2bcd8739ae039);
    const urlParams = new URLSearchParams(window.location.search);
    const filters = (0, $b6b235c5b8c1f5b6$export$e14f85ca0e45cc50)("conversation_filters");
    if (filters.conversation_id) delete filters.conversation_id;
    const conversation_id = urlParams.get("conversation_id");
    if (conversation_id) filters.conversation_id = conversation_id;
    const [filterValues, setFilterValues] = (0, $bh6RR.useState)(filters);
    const [refreshTable, setRefreshTable] = (0, $bh6RR.useState)(false);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const cells = [
        {
            name: "channel_type.name",
            column: "Channel",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    width: "20px",
                    srcSet: (0, $b3e51b95dcf04d66$export$2e2bcd8739ae039)[value]
                })
        },
        /*
        {
            name: 'instance_id',
            column: 'ID',
            show : (value) =><span style={{color : "var(--main)", cursor: "pointer"}} onClick={(e) => navigator.clipboard.writeText(value).then(_ => { toast.success('Copy token to clipboard', 'You can paste this token where you need !',5000); })}>  {getCutToken(value) }</span>,
        },
        */ {
            name: "created_at",
            column: "Date",
            show: (value)=>(0, $e2b536164b89f027$export$6dd95649f19af5f8)(value),
            sort: true
        },
        {
            name: "bot.name",
            column: "Bot",
            show: (value)=>(0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value),
            sort: true
        },
        {
            name: [
                "duration",
                "conversation_telephony_created_at",
                "messages",
                "updated_at"
            ],
            // column: 'Duration',
            column: "Total Time",
            show: ([duration, time, messages, updated_at])=>time || duration ? (0, $95dd689368015240$export$75bba95db5c3e753)(duration, time, messages, updated_at) : null
        },
        {
            name: [
                "duration",
                "conversation_telephony_created_at",
                "messages",
                "updated_at"
            ],
            // column: 'Duration',
            column: "Bot Time",
            show: ([duration, time, messages, updated_at])=>time || duration ? (0, $95dd689368015240$export$7a80cf575381397d)(time, messages, updated_at) : null
        },
        {
            name: "messages",
            column: "NB",
            show: (value)=>(0, $28b1d37546c8d957$export$2e2bcd8739ae039)(value)
        },
        {
            name: "caller",
            column: "Caller",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    style: {
                        color: "var(--main)",
                        cursor: "pointer",
                        fontSize: "11px"
                    },
                    onClick: (e)=>navigator.clipboard.writeText(value).then((_)=>{
                            toast.success("Copy phone number to clipboard", "You can paste this phone number where you need !", 5000);
                        }),
                    children: (0, $6fa58a9c96b5552d$export$2e2bcd8739ae039)(value)
                })
        },
        {
            name: "numbers",
            column: "Called",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    style: {
                        color: "var(--main)",
                        cursor: "pointer",
                        fontSize: "11px"
                    },
                    onClick: (e)=>navigator.clipboard.writeText(value).then((_)=>{
                            toast.success("Copy phone number to clipboard", "You can paste this phone number where you need !", 5000);
                        }),
                    children: (0, $6fa58a9c96b5552d$export$2e2bcd8739ae039)(value)
                })
        },
        {
            name: "markers",
            column: "Markers",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "list_makers_conversation_table",
                    children: [
                        " ",
                        value.map((marker, i)=>i < 4 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $178302845e817360$export$2e2bcd8739ae039), {
                                marker: marker,
                                className: i != 0 ? "superposition_maker_conversation_circle" : "",
                                style: {
                                    left: "-" + 9 * i + "px",
                                    zIndex: i
                                }
                            }, i))
                    ]
                })
        }
    ];
    const onClickRefresh = ()=>{
        setRefreshTable(!refreshTable);
    };
    const handleFilterSubmit = (filters)=>{
        setFilterValues(filters);
    };
    const handleTableRefresh = ()=>{
        setRefreshTable(!refreshTable); // Mettre à jour le tableau
    };
    const onClickFilter = ()=>{
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $2c39501eaa1138c9$export$2e2bcd8739ae039), {
            title: "Filter conversations",
            postbackAction: handleFilterSubmit,
            mode: 0
        });
    };
    const onClickView = ({ updateRow: updateRow, row: row })=>{
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $f31d16d63c660e6d$export$2e2bcd8739ae039), {
            data: row,
            title: "Conversation details",
            state: 1,
            onRefresh: handleTableRefresh
        }).then((conversation)=>updateRow(conversation));
    };
    const onClickShowLogs = ({ row: row })=>{
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $01c9eda283185e67$export$2e2bcd8739ae039), {
            data: row,
            title: "Conversation logs"
        });
    };
    const onClickDelete = ({ row: row, deleteRow: deleteRow })=>{
        const { instance_id: instance_id, id: id, bot: bot } = row;
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete conversation",
            body: "Do you really want to delete conversation from the bot " + bot.name + "?",
            api: {
                request: deleteConversation,
                param: [
                    id
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel"
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ],
            confirm: {
                name: bot.name,
                fieldName: "the bot"
            }
        }).then(()=>deleteRow(id));
    };
    const actions = [
        {
            className: "fas fa-file-alt action-button profil_action",
            style: {},
            onClick: onClickView,
            title: "Details"
        },
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_conversations") && {
            className: "fas fa-file-invoice action-button profil_action",
            style: {},
            onClick: onClickShowLogs,
            title: "Logs"
        },
        // {className : "fas fa-thumbtack action-button profil_action", style : { }, onClick : onClickView,title: "mark conversation" },
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("delete_conversation") && {
            className: "fas fa-trash action-button delete_action",
            style: {},
            onClick: onClickDelete,
            title: "Delete conversation"
        }
    ].filter((action)=>action);
    const buttons = [
        {
            icon: "fas fa-sync",
            onClick: onClickRefresh
        },
        {
            className: "main-iconButton profil_action main_add-button" + (!Object.keys(filterValues).length == 0 ? " conversations_active_filter" : ""),
            icon: "fas fa-filter",
            onClick: onClickFilter
        }
    ].filter((button)=>button);
    (0, $bh6RR.useEffect)(()=>{
        setRefreshList();
    }, [
        filterValues
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $67108b46a15aa360$export$2e2bcd8739ae039), {
        name: "last conversation",
        buttons: buttons,
        filterValues: filterValues,
        refreshState: [
            refreshTable,
            setRefreshTable
        ],
        className: "table-conversation",
        cells: cells,
        api: getConversations,
        actions: actions
    });
}
var $25f04b1f711109b7$export$2e2bcd8739ae039 = $25f04b1f711109b7$var$ConversationTableCompleted;





var $bh6RR = parcelRequire("bh6RR");







var $fcb1f34936e546c6$export$2e2bcd8739ae039 = {
    getConversations: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("conversations/inprogress", data),
    getConversation: ({ id: id })=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`conversation/inprogress/${id}`, {})
};











function $2cb5f51f0d238105$var$ConversationTableInProgress({ setRefreshList: setRefreshList }) {
    const { getConversations: getConversations } = (0, $fcb1f34936e546c6$export$2e2bcd8739ae039);
    const [filterValues, setFilterValues] = (0, $bh6RR.useState)((0, $b6b235c5b8c1f5b6$export$e14f85ca0e45cc50)("conversation_filters"));
    const [refreshTable, setRefreshTable] = (0, $bh6RR.useState)(false);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const cells = [
        {
            name: "channel_type.name",
            column: "Channel",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    width: "20px",
                    srcSet: (0, $b3e51b95dcf04d66$export$2e2bcd8739ae039)[value]
                })
        },
        {
            name: "instance_id",
            column: "ID",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    style: {
                        color: "var(--main)",
                        cursor: "pointer"
                    },
                    onClick: (e)=>navigator.clipboard.writeText(value).then((_)=>{
                            toast.success("Copy token to clipboard", "You can paste this token where you need !", 5000);
                        }),
                    children: [
                        "  ",
                        (0, $2ec34e35a5139fe7$export$2e2bcd8739ae039)(value)
                    ]
                })
        },
        {
            name: "bot.name",
            column: "Bot",
            show: (value)=>(0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value),
            sort: true
        },
        {
            name: "messages",
            column: "Interactions",
            show: (value)=>(0, $28b1d37546c8d957$export$2e2bcd8739ae039)(value)
        },
        {
            name: "caller",
            column: "Caller",
            show: (value)=>(0, $6fa58a9c96b5552d$export$2e2bcd8739ae039)(value)
        },
        {
            name: "numbers",
            column: "Called",
            show: (value)=>(0, $6fa58a9c96b5552d$export$2e2bcd8739ae039)(value)
        },
        {
            name: "markers",
            column: "Markers",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "list_makers_conversation_table",
                    children: [
                        " ",
                        value.map((marker, i)=>i < 3 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $178302845e817360$export$2e2bcd8739ae039), {
                                marker: marker,
                                className: i !== 0 ? "superposition_maker_conversation_circle" : undefined,
                                style: {
                                    left: "-" + 9 * i + "px",
                                    zIndex: i
                                }
                            }, marker.id || i))
                    ]
                })
        }
    ];
    const handleTableRefresh = ()=>{
        setRefreshTable(!refreshTable); // Mettre à jour le tableau
    };
    const handleFilterSubmit = (filters)=>{
        setFilterValues(filters);
    };
    const onClickSearch = ()=>{
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $2c39501eaa1138c9$export$2e2bcd8739ae039), {
            title: "Search conversation",
            postbackAction: handleFilterSubmit,
            mode: 1
        });
    };
    const onClickView = ({ updateRow: updateRow, row: row })=>{
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $f31d16d63c660e6d$export$2e2bcd8739ae039), {
            data: row,
            title: "Conversation details",
            state: 2,
            onRefresh: handleTableRefresh
        }).then((conversation)=>updateRow(conversation));
    };
    const actions = [
        {
            className: "fas fa-file-alt action-button profil_action",
            style: {},
            onClick: onClickView,
            title: "Details"
        }
    ];
    const buttons = [
        {
            icon: "fas fa-sync",
            onClick: handleTableRefresh
        },
        {
            className: "main-iconButton profil_action main_add-button" + (!Object.keys(filterValues).length == 0 ? " conversations_active_filter" : ""),
            icon: "fas fa-filter",
            onClick: onClickSearch
        }
    ].filter((button)=>button);
    (0, $bh6RR.useEffect)(()=>{
        setRefreshList();
    }, [
        filterValues
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $67108b46a15aa360$export$2e2bcd8739ae039), {
        name: "conversation",
        buttons: buttons,
        filterValues: filterValues,
        refreshState: [
            refreshTable,
            setRefreshTable
        ],
        className: "table-conversation",
        cells: cells,
        api: getConversations,
        actions: actions,
        supplementaryParamUrl: filterValues,
        setRefreshTable: setRefreshTable,
        refreshTable: refreshTable
    });
}
var $2cb5f51f0d238105$export$2e2bcd8739ae039 = $2cb5f51f0d238105$var$ConversationTableInProgress;





var $bh6RR = parcelRequire("bh6RR");









var $79418b12040f48ef$export$2e2bcd8739ae039 = {
    getConversations: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("conversations/upgoing", data),
    getConversation: ({ id: id })=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`conversation/upgoing/${id}`, {}),
    deleteConversation: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`conversation/upgoing/${id}`, data),
    deleteAllConversation: ({ data: data })=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`conversations/upgoing`, data),
    deleteMultiplesConversation: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`conversations/upgoing/multiples`, data),
    updateConversation: ({ id: id })=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`conversation/upgoin/${id}`, {}),
    getConversationMarkers: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`conversation/markers`, data),
    getMarkersOfConversation: ({ id: id })=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`conversation/${id}/markers`, {}),
    deleteMarkerFromConversation: ({ conversationId: conversationId, markerId: markerId })=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`conversation/${conversationId}/marker/${markerId}`, {}),
    setMarkerToConversation: ({ conversationId: conversationId, markerId: markerId })=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`conversation/${conversationId}/marker/${markerId}`, {})
};






function $30596912d0e599a2$var$ConversationTableUpGoing({ setRefreshList: setRefreshList, resetList: resetList = false }) {
    const { getConversations: getConversations, deleteConversation: deleteConversation, deleteMultiplesConversation: deleteMultiplesConversation } = (0, $79418b12040f48ef$export$2e2bcd8739ae039);
    const [filterValues, setFilterValues] = (0, $bh6RR.useState)((0, $b6b235c5b8c1f5b6$export$e14f85ca0e45cc50)("conversation_filters"));
    const [refreshTable, setRefreshTable] = (0, $bh6RR.useState)(false);
    const [rows, setRows] = (0, $bh6RR.useState)([]);
    const user = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("user");
    //const choicesChannel = Object.keys(Icons).map(key => { return { value: key, text: <img width="20px" srcSet={Icons[key]}></img> } })
    const cells = [
        {
            name: "bot_job_id",
            column: "Check",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $52b728934d836302$export$2e2bcd8739ae039), {
                    id: "bot_job_id" + value,
                    name: "bot_job_id",
                    setValue: (name, checked)=>{
                        console.log(value);
                        handleCheck(value, checked);
                    },
                    check: rows.includes(value)
                })
        },
        {
            name: "bot_job_type.name",
            column: "Channel",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    width: "20px",
                    srcSet: (0, $1fee5a8fea268ee3$export$2e2bcd8739ae039)[value]
                })
        },
        {
            name: "bot_job_id",
            column: "ID",
            show: (value)=>value,
            sort: true
        },
        {
            name: "schedule",
            column: "Date",
            show: (value)=>(0, $e2b536164b89f027$export$6dd95649f19af5f8)(value, true),
            sort: true
        },
        {
            name: "bot.name",
            column: "Bot",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                    children: value
                }),
            sort: true
        },
        {
            name: "url",
            column: "URL",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                    children: value
                })
        }
    ];
    const handleCheck = (id, checked)=>{
        setRows((prev)=>prev.includes(id) ? prev.filter((itemId)=>itemId !== id) : [
                ...prev,
                id
            ]);
    };
    console.log(rows);
    const onClickRefresh = ()=>{
        setRefreshTable(!refreshTable);
    };
    const handleFilterSubmit = (filters)=>{
        setFilterValues(filters);
    };
    const onClickSearch = ()=>{
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $2c39501eaa1138c9$export$2e2bcd8739ae039), {
            title: "Search conversation",
            postbackAction: handleFilterSubmit,
            mode: 2
        });
    };
    const onClickView = ({ row: row })=>{
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $f31d16d63c660e6d$export$2e2bcd8739ae039), {
            data: row,
            title: "Conversation details",
            state: 3
        });
    };
    const onClickDeleteRows = ()=>{
        let ids = rows.map((row)=>row);
        console.log(ids);
        let deleteObject = {
            title: "Delete conversations",
            body: "Do you really want to delete all the conversations selected ?",
            api: {
                request: deleteMultiplesConversation,
                param: [
                    {
                        ids: ids
                    }
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel"
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ]
        };
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), deleteObject).then(()=>setRefreshTable(!refreshTable));
    };
    const onClickDelete = ({ row: row, deleteRow: deleteRow })=>{
        const { id: id, bot_job_id: bot_job_id, bot: bot } = row;
        let deleteObject = {
            title: "Delete conversation",
            body: "Do you really want to delete conversation from the bot " + bot.name + "?",
            api: {
                request: deleteConversation,
                param: [
                    bot_job_id,
                    {
                        bot_id: bot.id
                    }
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel"
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ]
        };
        /*
          confirm: {
                name:  bot.name,
                fieldName: "the bot",
            }
            */ if (!user.is_admin) deleteObject = {
            ...deleteObject,
            confirm: {
                name: bot.name,
                fieldName: "the bot"
            }
        };
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), deleteObject).then(()=>deleteRow(bot_job_id, "bot_job_id"));
    };
    const actions = [
        {
            className: "fas fa-file-alt action-button profil_action",
            style: {},
            onClick: onClickView,
            title: "Details"
        },
        // {className : "fas fa-thumbtack action-button profil_action", style : {}, onClick : onClickView,title: "mark conversation" },
        {
            className: "fas fa-trash action-button delete_action",
            style: {},
            onClick: onClickDelete,
            title: "Delete conversation"
        }
    ];
    const buttons = [
        {
            icon: "fas fa-sync",
            onClick: onClickRefresh
        },
        {
            className: "main-iconButton profil_action main_add-button" + (!Object.keys(filterValues).length == 0 ? " conversations_active_filter" : ""),
            icon: "fas fa-filter",
            onClick: onClickSearch
        },
        {
            className: "main-iconButton delete_action main_add-button",
            icon: "fas fa-trash",
            onClick: onClickDeleteRows
        }
    ].filter((button)=>button);
    (0, $bh6RR.useEffect)(()=>{
        setRefreshList();
    }, [
        filterValues
    ]);
    (0, $bh6RR.useEffect)(()=>{
        onClickRefresh();
    }, [
        resetList
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $67108b46a15aa360$export$2e2bcd8739ae039), {
        name: "conversation",
        buttons: buttons,
        filterValues: filterValues,
        refreshState: [
            refreshTable,
            setRefreshTable
        ],
        className: "table-conversation",
        cells: cells,
        api: getConversations,
        actions: actions,
        supplementaryParamUrl: filterValues,
        setRefreshTable: setRefreshTable,
        refreshTable: refreshTable
    });
}
var $30596912d0e599a2$export$2e2bcd8739ae039 = $30596912d0e599a2$var$ConversationTableUpGoing;









var $bh6RR = parcelRequire("bh6RR");
const $bb87df056f7fca74$export$ec103f175115c9cb = /*#__PURE__*/ (0, $bh6RR.createContext)();
function $bb87df056f7fca74$export$fcb0a38c620c523b({ children: children }) {
    const [selectedTabName, setSelectedTabName] = (0, $bh6RR.useState)("Completed");
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($bb87df056f7fca74$export$ec103f175115c9cb.Provider, {
        value: {
            selectedTabName: selectedTabName,
            setSelectedTabName: setSelectedTabName
        },
        children: children
    });
}







function $23d72cde5bd353c9$var$ConversationList() {
    const company = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company");
    const { is_admin: is_admin } = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("user");
    const { deleteAllConversation: deleteAllConversation } = (0, $79418b12040f48ef$export$2e2bcd8739ae039);
    const [refreshTableForce, setRefreshTableForce] = (0, $bh6RR.useState)(false);
    const refreshList = ()=>{
        setItems([
            ...items.map((item)=>item)
        ]);
    };
    const getItems = ()=>{
        return [
            {
                name: "Completed",
                component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $25f04b1f711109b7$export$2e2bcd8739ae039), {
                    setRefreshList: refreshList
                }),
                type: 0
            },
            {
                name: "In progress",
                component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2cb5f51f0d238105$export$2e2bcd8739ae039), {
                    setRefreshList: refreshList
                }),
                type: 1
            },
            {
                name: "Upgoing",
                component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $30596912d0e599a2$export$2e2bcd8739ae039), {
                    setRefreshList: refreshList,
                    resetList: refreshTableForce
                }),
                type: 2
            }
        ];
    };
    const token = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("token");
    //const [filterValues, setFilterValues] = useState(getStorageParamForCurrentCompany('conversation_filters') || {});
    const [selectedIndex, setSelectedIndex] = (0, $bh6RR.useState)(0);
    const [downloadUrl, setDownloadUrl] = (0, $bh6RR.useState)("");
    const [items, setItems] = (0, $bh6RR.useState)(getItems());
    (0, $bh6RR.useEffect)(()=>{
        const selectedTab = items[selectedIndex];
        const currentFilters = (0, $b6b235c5b8c1f5b6$export$e14f85ca0e45cc50)("conversation_filters");
        const url = new URL(`${(0, $651df53b10514175$export$a7b6bc01c63cdfc3).REACT_APP_API_PATH}/export/conversations/xlsx`);
        url.searchParams.append("token_auth", token);
        url.searchParams.append("type", selectedTab.type);
        Object.keys(currentFilters).forEach((key)=>{
            if (currentFilters[key]) {
                if (Array.isArray(currentFilters[key])) url.searchParams.append(key, currentFilters[key].join(","));
                else url.searchParams.append(key, currentFilters[key]);
            }
        });
        url.searchParams.append("company", company.id);
        const decodedUrl = url.toString().replace(/%2C/g, ",");
        setDownloadUrl(decodedUrl);
    }, [
        selectedIndex,
        token,
        company
    ]);
    const handleTabChange = (index)=>{
        setSelectedIndex(index);
    };
    const deleteAction = async ()=>{
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete all upgoing conversations from  " + company.name,
            body: "Do you really want to delete all upgoing conversations from the company " + company.name + " ?",
            api: {
                request: deleteAllConversation,
                param: [
                    company.id
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel"
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ],
            confirm: {
                name: company.name,
                fieldName: "your company"
            }
        }).then(()=>{
            refreshForce();
        });
    };
    const refreshForce = ()=>{
        setItems(getItems().map((item, index)=>{
            if (item.type === 2) return {
                ...item,
                component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $30596912d0e599a2$export$2e2bcd8739ae039), {
                    setRefreshList: refreshList,
                    resetList: !refreshTableForce
                })
            };
            return item;
        }));
        setRefreshTableForce(!refreshTableForce);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $bb87df056f7fca74$export$fcb0a38c620c523b), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                    title: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                        children: [
                            " List of Last Conversations from ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                style: {
                                    color: "var(--main)"
                                },
                                children: company.name
                            })
                        ]
                    }),
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                            href: downloadUrl,
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                className: "icons_up main-iconButton profil_action main_add-button space_tableButton",
                                icon: "fas fa-download",
                                title: "Export Conversations"
                            })
                        }),
                        selectedIndex == 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                            href: downloadUrl + "&message=false",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                className: "icons_up main-iconButton profil_action main_add-button space_tableButton",
                                icon: "fas fa-file-zipper",
                                title: "Export Conversations without message"
                            })
                        }),
                        (is_admin || (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("delete_conversation")) && selectedIndex == 2 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                            onClick: deleteAction,
                            className: " icons_up main-iconButton delete_action main_add-button space_tableButton red-button-action-bg_color",
                            icon: "fas fa-trash",
                            title: "Delete All Conversations Upgoing"
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5c5c6a9b8c6e5949$export$2e2bcd8739ae039), {
                    items: items,
                    name: "conversations",
                    type: "table",
                    onTabChange: handleTabChange
                })
            ]
        })
    });
}
var $23d72cde5bd353c9$export$2e2bcd8739ae039 = $23d72cde5bd353c9$var$ConversationList;


const $50b2ac115c40ff2e$var$rootSupervision = "company/:company/supervision/";
const $50b2ac115c40ff2e$var$routes = [
    {
        path: $50b2ac115c40ff2e$var$rootSupervision + "conversations/list",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $23d72cde5bd353c9$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "view_conversations"
        ]
    },
    {
        path: $50b2ac115c40ff2e$var$rootSupervision + "analytics/list",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2c6f290c170e8f3a$export$2e2bcd8739ae039), {}),
        isPublic: false,
        isSidebar: true,
        permissions: [
            "view_analytics"
        ]
    },
    {
        path: $50b2ac115c40ff2e$var$rootSupervision + "analytics/:bot",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d0814407ce3a420f$export$2e2bcd8739ae039), {}),
        isPublic: false,
        isSidebar: true
    }
];
var $50b2ac115c40ff2e$export$2e2bcd8739ae039 = $50b2ac115c40ff2e$var$routes;






var $bh6RR = parcelRequire("bh6RR");







var $bh6RR = parcelRequire("bh6RR");






function $a51c8bad0568fabd$var$SsoCallback() {
    const [searchParams] = (0, $0bd3411f2ec14e23$export$f1a78c17382fe22a)();
    const authDispatchContext = (0, $373f9505ebba8636$export$a03a56d03840936f)();
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    (0, $bh6RR.useEffect)(()=>{
        const handleSsoCallback = async ()=>{
            const ssoSuccess = searchParams.get("sso_success");
            const jwt = searchParams.get("jwt");
            const refreshToken = searchParams.get("refresh_token");
            const error = searchParams.get("error");
            if (error) {
                const errorMessage = searchParams.get("message") || searchParams.get("error_description") || "SSO authentication failed";
                toast.error("SSO Error", errorMessage, 5000);
                navigate("/login-sso-edf");
                return;
            }
            if (ssoSuccess === "1" && jwt) try {
                // Store JWT first so API calls are authenticated
                (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").set("token", jwt);
                if (refreshToken) (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").set("refresh_token", refreshToken);
                // Fetch complete user info (company with bots/datasets/dashboards + permissions)
                const [response, fetchError] = await (0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("user/info");
                if (fetchError) {
                    console.error("SSO: Failed to fetch user info", fetchError);
                    toast.error("SSO Error", "Failed to load user data", 5000);
                    (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").remove("token");
                    (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").remove("refresh_token");
                    navigate("/login-sso-edf");
                    return;
                }
                const { user: user, company: company, permissions: permissions } = response;
                // Store data exactly like the normal login flow
                (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").set("user", user);
                (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").set("company", company);
                (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").set("permissions", permissions);
                authDispatchContext({
                    type: "loginSuccess",
                    payload: {
                        token: jwt,
                        user: user,
                        refresh_token: refreshToken || null
                    }
                });
                toast.success("SSO Success", `Welcome ${user.username || ""}!`, 3000);
                navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("home"));
            } catch (e) {
                console.error("SSO callback error:", e);
                toast.error("SSO Error", "Failed to process authentication data", 5000);
                navigate("/login-sso-edf");
            }
        };
        handleSsoCallback();
    }, [
        searchParams,
        authDispatchContext,
        toast,
        navigate
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            fontSize: "18px",
            color: "#666"
        },
        children: "Processing SSO authentication..."
    });
}
var $a51c8bad0568fabd$export$2e2bcd8739ae039 = $a51c8bad0568fabd$var$SsoCallback;


function $b802280c2a861c11$var$RedirectHomeOrNotFound() {
    const [searchParams] = (0, $0bd3411f2ec14e23$export$f1a78c17382fe22a)();
    const naviguate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const { user: user, fetching: fetching, error: error } = (0, $373f9505ebba8636$export$ea6ddbd83f749864)();
    const ssoSuccess = searchParams.get("sso_success");
    const ssoError = searchParams.get("error");
    const isAuthenticated = user && user.id;
    const isSsoCallback = ssoSuccess === "1" || ssoError;
    (0, $bh6RR.useEffect)(()=>{
        if (isSsoCallback || fetching) return;
        if (!isAuthenticated) {
            naviguate("/login");
            return;
        }
        naviguate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("home"));
    }, [
        isAuthenticated,
        fetching,
        naviguate,
        isSsoCallback
    ]);
    if (isSsoCallback) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a51c8bad0568fabd$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            fetching == true ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $02702eb17aeccbb5$export$2e2bcd8739ae039), {}) : null,
            error == true ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $70b8a3ef3c035a5f$export$2e2bcd8739ae039), {}) : null
        ]
    });
}
var $b802280c2a861c11$export$2e2bcd8739ae039 = $b802280c2a861c11$var$RedirectHomeOrNotFound;


const $c11fd52bdac0a00c$var$routes = [
    {
        path: "/",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b802280c2a861c11$export$2e2bcd8739ae039), {}),
        isPublic: true,
        isSidebar: false
    },
    {
        path: "*",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $70b8a3ef3c035a5f$export$2e2bcd8739ae039), {}),
        isPublic: true,
        isSidebar: false
    }
];
var $c11fd52bdac0a00c$export$2e2bcd8739ae039 = $c11fd52bdac0a00c$var$routes;





var $bh6RR = parcelRequire("bh6RR");















function $ade7abfa47642d3a$var$DashboardTable() {
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const { getDashboards: getDashboards, deleteDashboard: deleteDashboard, getDashboardsShared: getDashboardsShared } = (0, $c67d47eff71309b3$export$2e2bcd8739ae039);
    const cells = [
        {
            column: "NAME",
            name: [
                "dashboard.name",
                "name",
                "dashboard.company.name",
                "origin"
            ],
            //sort: true,
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    style: {
                        textDecoration: value[3] == 0 ? "underline dotted" : ""
                    },
                    title: (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value[0] + " for " + value[2]),
                    children: [
                        (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value[1] != null ? value[1] : value[0]),
                        " ",
                        " "
                    ]
                })
        },
        {
            column: "BOT NAME",
            name: "dashboard.bot.name",
            sort: true,
            show: (value)=>(0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value)
        },
        {
            column: "SHARING",
            name: [
                "origin",
                "dashboard.company",
                "shared_dashboards"
            ],
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        style: {
                            display: "flex"
                        },
                        children: [
                            value[0] == 2 && value[2].map((dashboard, i)=>{
                                if (dashboard.company == null) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                    srcSet: dashboard.company.logo,
                                    title: dashboard.company.name,
                                    alt: "",
                                    style: {
                                        left: "-" + 9 * i + "px",
                                        zIndex: i,
                                        position: "relative"
                                    }
                                }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)());
                            }),
                            value[0] == 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "shared_by_dashboard_table",
                                children: [
                                    " ",
                                    value[0] == 0 && "Shared by " + value[1].name
                                ]
                            })
                        ]
                    })
                })
        },
        {
            column: "DESCRIPTION",
            name: [
                "dashboard.description",
                "description",
                "dashboard.company.name",
                "origin"
            ],
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    children: [
                        (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value[1] != null && value[1].length > 0 ? value[1] : value[0].length > 0 ? value[0] : "Empty"),
                        " "
                    ]
                })
        },
        {
            column: "LAST UPDATE",
            name: "updated_at",
            sort: true,
            show: (value)=>(0, $df9ad4654a227866$export$3ae94a2503e890a1)(value)
        },
        {
            column: "CHANNEL",
            name: "dashboards_channels_links",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "container_avaibility",
                    title: value.map((element)=>"\n" + element.channel.name),
                    children: [
                        " ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "circle_point " + (value.length == 0 ? "unavailable" : "available"),
                            children: " "
                        }),
                        " ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                            style: {
                                color: "var(--main)"
                            },
                            children: [
                                "(" + value.length + ")",
                                " "
                            ]
                        })
                    ]
                })
        }
    ];
    const filters = [
        {
            type: "input",
            placeholder: "content",
            name: "term"
        }
    ];
    const onClickDelete = async ({ row: row, deleteRow: deleteRow })=>{
        const { id: id } = row;
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete dashboard " + row.dashboard.name,
            body: "Do you really want to delete the dashboard " + row.dashboard.name,
            api: {
                request: deleteDashboard,
                param: [
                    row.dashboard.id,
                    {
                        id: row.dashboard.id
                    }
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel"
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ],
            confirm: {
                name: row.dashboard.name,
                fieldName: "the dashboard"
            }
        }).then(()=>{
            deleteRow(id);
        });
    };
    const onClickAdd = ()=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/dashboard/create"));
    const onClickUpdate = ({ row: row })=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/dashboard/update"), {
            state: {
                data: row,
                type: "update"
            }
        });
    const onClickShowEditor = ({ row: row })=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/dashboard/editor/" + row.id), {
            state: {
                data: row,
                access: (0, $da2068bd2c317854$export$3026e5a52c747d2c).Administrator
            }
        });
    const onClickShowEditorViewMode = ({ row: row })=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/dashboard/editor/view/" + row.id), {
            state: {
                data: row,
                access: (0, $da2068bd2c317854$export$3026e5a52c747d2c).Client
            }
        });
    const actions = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_dashboard") && {
            className: "fas fa-cog action-button edit_action",
            style: {},
            onClick: onClickUpdate,
            title: "General informations"
        },
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_dashboard") && {
            condition: "origin",
            condition_match: "0",
            className: "fas fa-hand-sparkles action-button profil_action",
            style: {
                paddingLeft: "8px",
                paddingRight: "12px"
            },
            onClick: onClickShowEditor,
            title: "Edit structure"
        },
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_dashboard") && {
            className: "fas fa-edit action-button profil_action",
            style: {},
            onClick: onClickShowEditorViewMode,
            title: "Use dashboard"
        },
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("delete_dashboard") && {
            condition: "origin",
            condition_match: "0",
            className: "fas fa-trash action-button delete_action",
            style: {},
            onClick: onClickDelete,
            title: "Delete"
        }
    ].filter((action)=>action);
    console.log(actions);
    const buttons = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("create_dashboard") ? {
            icon: "fas fa-plus",
            onClick: onClickAdd
        } : null
    ].filter((action)=>action);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
            className: "dashboard",
            name: "Dashboard",
            cells: cells,
            api: getDashboards,
            actions: actions,
            buttons: buttons,
            filters: filters
        })
    });
}
var $ade7abfa47642d3a$export$2e2bcd8739ae039 = $ade7abfa47642d3a$var$DashboardTable;




















function $45348566527e7b39$var$DashboardSharedTable() {
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const { deleteDashboard: deleteDashboard, getDashboardsShared: getDashboardsShared } = (0, $c67d47eff71309b3$export$2e2bcd8739ae039);
    const cells = [
        {
            column: "NAME",
            name: [
                "dashboard.name",
                "name",
                "dashboard.company.name",
                "origin"
            ],
            //sort: true,
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    style: {
                        textDecoration: value[3] == 0 ? "underline dotted" : ""
                    },
                    title: (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value[0] + " for " + value[2]),
                    children: [
                        (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value[1] != null ? value[1] : value[0]),
                        " ",
                        " "
                    ]
                })
        },
        {
            column: "BOT NAME",
            name: "dashboard.bot.name",
            sort: true,
            show: (value)=>(0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value)
        },
        {
            column: "ORGANIZATION",
            name: "company",
            show: (value)=>value ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        srcSet: value.logo,
                        title: value.name,
                        alt: ""
                    })
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {})
        },
        /*
        {
            column: 'SHARING',
            name: ['origin', "dashboard.company.name"],
            //name : "origin",
            show: (value) => <div className={value[0] == 2 ? "shared_dashboard_table" : value[0] == 1 ?  "" /*"no_shared_dashboard_table"*/ //: "shared_by_dashboard_table"}> {value[0] == 0 && "Shared by " + value[1]} {/* value[0] ==  1 && "Not Shared" */} {value[0] == 2 && "Shared"}</div>
        //},
        {
            column: "DESCRIPTION",
            name: [
                "dashboard.description",
                "description",
                "dashboard.company.name",
                "origin"
            ],
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    children: [
                        (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value[1] != null && value[1].length > 0 ? value[1] : value[0].length > 0 ? value[0] : "Empty"),
                        " "
                    ]
                })
        },
        {
            column: "LAST UPDATE",
            name: "updated_at",
            sort: true,
            show: (value)=>(0, $df9ad4654a227866$export$3ae94a2503e890a1)(value)
        },
        {
            column: "CHANNEL",
            name: "dashboards_channels_links",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "container_avaibility",
                    title: value.map((element)=>"\n" + element.channel.name),
                    children: [
                        " ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "circle_point " + (value.length == 0 ? "unavailable" : "available"),
                            children: " "
                        }),
                        " ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                            style: {
                                color: "var(--main)"
                            },
                            children: [
                                "(" + value.length + ")",
                                " "
                            ]
                        })
                    ]
                })
        }
    ];
    const filters = [];
    const onClickDelete = async ({ row: row, deleteRow: deleteRow })=>{
        const { id: id } = row;
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete dashboard " + row.dashboard.name,
            body: "Do you really want to delete the dashboard " + row.dashboard.name,
            api: {
                request: deleteDashboard,
                param: [
                    row.dashboard.id,
                    {
                        id: row.dashboard.id
                    }
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel"
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ],
            confirm: {
                name: row.dashboard.name,
                fieldName: "the dashboard"
            }
        }).then(()=>{
            deleteRow(id);
        });
    };
    const onClickAdd = ()=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/dashboard/create"));
    const onClickUpdate = ({ row: row })=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/dashboard/update"), {
            state: {
                data: row,
                type: "update"
            }
        });
    const onClickShowEditor = ({ row: row })=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/dashboard/editor/" + row.id), {
            state: {
                data: row,
                access: (0, $da2068bd2c317854$export$3026e5a52c747d2c).Administrator
            }
        });
    const onClickShowEditorViewMode = ({ row: row })=>navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/dashboard/editor/view/" + row.id), {
            state: {
                data: row,
                access: (0, $da2068bd2c317854$export$3026e5a52c747d2c).Client
            }
        });
    const actions = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_dashboard") && {
            className: "fas fa-cog action-button edit_action",
            style: {},
            onClick: onClickUpdate,
            title: "General informations"
        },
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_dashboard") && {
            condition: "origin",
            condition_match: "0",
            className: "fas fa-hand-sparkles action-button profil_action",
            style: {
                paddingLeft: "8px",
                paddingRight: "12px"
            },
            onClick: onClickShowEditor,
            title: "Edit structure"
        },
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_dashboard") && {
            className: "fas fa-edit action-button profil_action",
            style: {},
            onClick: onClickShowEditorViewMode,
            title: "Use dashboard"
        },
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("delete_dashboard") && {
            condition: "origin",
            condition_match: "0",
            className: "fas fa-trash action-button delete_action",
            style: {},
            onClick: onClickDelete,
            title: "Delete"
        }
    ].filter((action)=>action);
    const buttons = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("create_dashboard") && {
            icon: "fas fa-plus",
            onClick: onClickAdd
        }
    ].filter((button)=>button);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
            className: "dashboard",
            name: "Dashboard",
            cells: cells,
            api: getDashboardsShared,
            actions: actions,
            buttons: buttons,
            filters: filters
        })
    });
}
var $45348566527e7b39$export$2e2bcd8739ae039 = $45348566527e7b39$var$DashboardSharedTable;




function $4986d5e51af661d2$var$DashboardList() {
    const [selectedComponent, setSelectedComponent] = (0, $bh6RR.useState)(0);
    const handleButtonClick = (componentNumber)=>{
        setSelectedComponent(componentNumber);
    };
    const items = [
        {
            name: "Tailored",
            component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ade7abfa47642d3a$export$2e2bcd8739ae039), {})
        },
        {
            name: "Plug-and-Play",
            component: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $45348566527e7b39$export$2e2bcd8739ae039), {})
        }
    ];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: "List of Dashboards"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $297630b888b8597e$export$2e2bcd8739ae039), {
                items: items
            })
        ]
    });
}
var $4986d5e51af661d2$export$2e2bcd8739ae039 = $4986d5e51af661d2$var$DashboardList;




var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");


















var $4f33eb6c97b0cc54$export$2e2bcd8739ae039 = {
    create: {
        title: "\uD83D\uDEE0\uFE0F Create a new Dashboard",
        send: "Create"
    },
    update: {
        title: "\uD83D\uDEE0\uFE0F Update your Dashboard",
        send: "Update"
    }
};




const { addDashboard: $65cbbc5cb1cad876$var$addDashboard, updateDashboard: $65cbbc5cb1cad876$var$updateDashboard, updateDashboardShared: $65cbbc5cb1cad876$var$updateDashboardShared } = (0, $c67d47eff71309b3$export$2e2bcd8739ae039);
async function $65cbbc5cb1cad876$export$12a68174fbf0d3f1(data, dashboard_channel_id) {
    delete data.bot_id;
    delete data.company_ids;
    data.dashboard_channel_id = dashboard_channel_id;
    const [response, errors] = await $65cbbc5cb1cad876$var$updateDashboardShared(dashboard_channel_id, data);
    if (errors != null) {
        console.log(errors);
        return;
    }
    return "/dashboards/list";
}
async function $65cbbc5cb1cad876$export$f8f7518ecbd654bc(data) {
    const [response, errors] = await $65cbbc5cb1cad876$var$addDashboard(data);
    if (errors != null) {
        console.log(errors);
        return;
    }
    return "/dashboard/editor/" + response.id;
}
async function $65cbbc5cb1cad876$export$e3c921ee9483b0f1(data, dashboard_channel_id) {
    console.log(data);
    data.dashboard_channel_id = dashboard_channel_id;
    const [response, errors] = await $65cbbc5cb1cad876$var$updateDashboard(dashboard_channel_id, data);
    if (errors != null) {
        console.log(errors);
        return;
    }
    return "/dashboards/list";
}




function $c5181aac592da883$var$DashboardForm({ data: data, type: type }) {
    var dashboard = data?.dashboard;
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const dataType = (0, $4f33eb6c97b0cc54$export$2e2bcd8739ae039)[type ? type : "create"];
    const isShared = data?.origin == 0;
    const { register: register, handleSubmit: handleSubmit, watch: watch, formState: { errors: errors }, formState: formState, getValues: getValues, setValue: setValue } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            bot_id: dashboard ? dashboard.bot.id : "",
            name: dashboard ? isShared && data.name != null ? data.name : dashboard.name : "",
            description: dashboard ? isShared && data.description != null ? data.description : dashboard.description : ""
        }
    });
    const [listCheckedCompany, setListCheckedCompany] = (0, $bh6RR.useState)([]);
    const [listRemovedSharedDash, setListRemovedSharedDash] = (0, $bh6RR.useState)([]);
    const [listCheckedChannel, setListCheckedChannel] = (0, $bh6RR.useState)([]);
    //const { bots } = useBots();
    const { getChannelsAvailableForDashboard: getChannelsAvailableForDashboard } = (0, $c67d47eff71309b3$export$2e2bcd8739ae039);
    const { getBots: getBots } = (0, $24a8370de200c756$export$2e2bcd8739ae039);
    const { getCompaniesWithoutPagination: getCompaniesWithoutPagination } = (0, $e2bea698183eb612$export$2e2bcd8739ae039);
    const [bots, setBots] = (0, $bh6RR.useState)("");
    const [channels, setChannels] = (0, $bh6RR.useState)("");
    const [companies, setCompanies] = (0, $bh6RR.useState)("");
    const storage = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session");
    //console.log(data)
    const onSubmit = async ()=>{
        var dataToSend = getValues();
        dataToSend.company_ids = listCheckedCompany.map((company)=>{
            if (company == null) return;
            if (company.id_shared == null) return company.id;
        }).filter((_id)=>_id !== undefined);
        dataToSend.channel_ids = listCheckedChannel;
        dataToSend.removed_dashboard_id = listRemovedSharedDash;
        let res = null;
        if (dashboard == null) res = await (0, $65cbbc5cb1cad876$export$f8f7518ecbd654bc)(dataToSend);
        else if (isShared == true) res = await (0, $65cbbc5cb1cad876$export$12a68174fbf0d3f1)(dataToSend, data.id);
        else res = await (0, $65cbbc5cb1cad876$export$e3c921ee9483b0f1)(dataToSend, data.id);
        return navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)(res));
    };
    const getAllBots = async ()=>{
        let [response, error] = await getBots();
        if (error !== null) {
            console.log(error);
            return;
        }
        setValue("bot_id", dashboard ? dashboard.bot.id : response[0]?.id);
        setBots(setUpBots(response));
    };
    const getAllChannels = async (bot_id)=>{
        let params = {
            bot_id: bot_id
        };
        if (data != null) {
            params.dashboard_channel_id = data.id; // important pour les conflits
            params.company_id = data.company_id; // si on arrive dans le update depuis la page Plug and Play, permet de voir les bons channels
        }
        let [response, error] = await getChannelsAvailableForDashboard(params);
        if (error !== null) {
            console.log(error);
            return;
        }
        let res = data ? data.dashboards_channels_links.map((channel_link)=>channel_link.channel_id) : [];
        setListCheckedChannel(res);
        setChannels([
            ...response
        ]);
    };
    const getAllCompanies = async ()=>{
        let [response, error] = await getCompaniesWithoutPagination();
        if (error !== null) {
            console.log(error);
            return;
        }
        setCompanies(response); // when the companies are retrieved, we have to check if one or many have shared dashboard (update)
        if (data == null) return;
        let res = data.shared_dashboards.map((shared)=>{
            if (shared.company == null) return null;
            shared.company.base_dashboard = true;
            shared.company.id_shared = shared.id;
            return shared.company;
        });
        setListCheckedCompany(res);
    };
    const setUpBots = (tmpBots)=>tmpBots.map((bot)=>{
            return {
                value: bot.id,
                text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    style: {
                        maxWidth: "300px"
                    },
                    children: [
                        " ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                            style: {
                                marginRight: "15px"
                            },
                            className: "flag-icon flag-icon-" + bot.language.slug.toLowerCase()
                        }),
                        " ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "dashboard_content_dropdown",
                            children: [
                                " ",
                                bot.name,
                                " "
                            ]
                        }),
                        " "
                    ]
                })
            };
        });
    const addCompanySharing = (_company)=>{
        if (_company == null) return;
        _company.base_dashboard = false;
        let array = [
            ...listCheckedCompany,
            _company
        ];
        array = array.sort((a, b)=>a?.name < b?.name ? -1 : 1);
        setListCheckedCompany(array);
    };
    const checkChannel = (_channel_id)=>{
        let result = listCheckedChannel;
        let color = "";
        let icon = "";
        if (result.filter((id)=>{
            return id == _channel_id;
        }).length == 0) {
            result.push(_channel_id);
            color = "var(--green)";
            icon = "fas fa-check-circle";
        } else {
            color = "var(--main)";
            icon = "fas fa-plus-circle";
            let index = listCheckedChannel.findIndex((id)=>id === _channel_id);
            result.splice(index, 1);
        }
        document.getElementById(_channel_id + "button").style.color = color;
        document.getElementById(_channel_id + "button").children[0].classList = icon;
        setListCheckedChannel([
            ...result
        ]);
    };
    const deleteCompanyShared = (index, id_shared)=>{
        if (id_shared != null) setListRemovedSharedDash([
            ...listRemovedSharedDash,
            data.shared_dashboards.find((shared)=>id_shared == shared.id).id
        ]);
        setListCheckedCompany((companies)=>{
            return companies.filter((_, i)=>i !== index);
        });
    };
    (0, $bh6RR.useEffect)(()=>{
        getAllBots();
        getAllCompanies();
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        let bot_id = getValues("bot_id");
        if (bot_id) getAllChannels(bot_id);
    }, [
        bots
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
        onSubmit: handleSubmit(onSubmit),
        className: "main_container_form_dashboard",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                children: dataType.title
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                className: "body_form_dashboard",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $51a8b46ec4198ef9$export$2e2bcd8739ae039), {
                    className: "slider_dashboard_form",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                            name: "main_form",
                            className: "slide_dashboard_form",
                            children: [
                                type == null ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "container_line_dropdown_dashboard",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Select a bot",
                                            listLabelClassName: "titles-input"
                                        }),
                                        Array.isArray(bots) && bots.length > 0 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            className: "container_dropdown_dashboard",
                                            style: {
                                                marginRight: 70
                                            },
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                                ...register("bot_id"),
                                                setValue: (name, value)=>{
                                                    setValue(name, value);
                                                    setValue("channel", -1);
                                                    getAllChannels(value);
                                                },
                                                choices: bots,
                                                width: "280px",
                                                defaultChoice: dashboard ? dashboard.bot_id : bots[0]?.value
                                            })
                                        }) : null
                                    ]
                                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                    children: [
                                        data?.origin == 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "information_message",
                                            style: {
                                                marginLeft: "2%",
                                                width: "75%",
                                                marginBottom: "0"
                                            },
                                            children: [
                                                "  Shared By : ",
                                                (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(dashboard.company.name)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "container_line_dropdown_dashboard",
                                            style: {
                                                justifyContent: "start"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                    label: "Related Bot : ",
                                                    listLabelClassName: "titles-input"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                    label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                                        style: {
                                                            fontWeight: "bold",
                                                            marginLeft: "10px"
                                                        },
                                                        children: [
                                                            (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(dashboard.bot.name),
                                                            " "
                                                        ]
                                                    }),
                                                    listLabelClassName: "titles-input"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "dashboard_form-container",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                        label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                            children: [
                                                "Dashboard ",
                                                isShared ? " shared " : "",
                                                " name",
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    className: "obligatory_field",
                                                    children: "*"
                                                }),
                                                " "
                                            ]
                                        }),
                                        listLabelClassName: "titles-input",
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                                ...register("name", {
                                                    required: true,
                                                    minLength: 3
                                                }),
                                                style: errors.name ? {
                                                    borderColor: "red"
                                                } : {}
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                className: "error",
                                                children: errors.name ? errors.name.message ? errors.name.message : "At least 3 letters" : ""
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "dashboard_form-container",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                        label: "Enter a description",
                                        listLabelClassName: "titles-input",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0db11626bd290ec1$export$2e2bcd8739ae039), {
                                            style: {
                                                height: "70px" /*'40px'*/ 
                                            },
                                            ...register("description", {
                                                required: false
                                            })
                                        })
                                    })
                                }),
                                Array.isArray(channels.list) && channels.list.find((x)=>x.id == watch("channel_id"))?.is_available == false && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "error",
                                    style: {
                                        textAlign: "left",
                                        fontSize: "18px",
                                        width: "85%",
                                        paddingLeft: "0"
                                    },
                                    children: " There is conflicts between dashboards "
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "dashboard_form_advanced_parameters",
                                    onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("channels_section"),
                                    children: [
                                        " Select channel(s) ",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                            class: "fas fa-arrow-right",
                                            style: {
                                                marginLeft: "5px",
                                                marginTop: "25px"
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                            name: "channels_section",
                            className: "slide_dashboard_form_channel",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                listCheckedChannel.length == 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "information_message",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                            className: "fas fa-info-circle",
                                            style: {
                                                marginRight: "15px"
                                            }
                                        }),
                                        "Your dashboard is not use on any channel. If you want to link your dashboard to a channel to use it, please check the list below"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    style: {
                                        height: listCheckedChannel.length == 0 ? "50%" : "70%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Link the dashboard to the channel(s)",
                                            listLabelClassName: "titles-input"
                                        }),
                                        channels != null && Array.isArray(channels) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            className: "dashboard_container_list",
                                            style: {
                                                height: "100%"
                                            },
                                            children: channels.map((_channel, i)=>{
                                                let bool = listCheckedChannel.includes(_channel.id);
                                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                    id: _channel.id + "container",
                                                    className: "dashboard_list_companies",
                                                    "data-checked": "false",
                                                    "data-id": _channel.id,
                                                    style: {
                                                        border: _channel.is_available ? bool ? "2px solid var(--main)" : "" : "2px solid var(--pink)"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                            className: "dashboard_list_channel_container",
                                                            children: [
                                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                                                    srcSet: (0, $b3e51b95dcf04d66$export$2e2bcd8739ae039)[_channel.type.name]
                                                                }),
                                                                _channel.name
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                            children: _channel.is_available ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                                class: "buttonWrap",
                                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                                                    id: _channel.id + "button",
                                                                    className: "main-iconButton add-hover modalButtons-input",
                                                                    icon: bool ? "fas fa-check-circle" : "fas fa-plus-circle",
                                                                    style: {
                                                                        color: bool ? "var(--green)" : "var(--main)"
                                                                    },
                                                                    onClick: (e)=>checkChannel(_channel.id)
                                                                })
                                                            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                                style: {
                                                                    color: "var(--pink)",
                                                                    marginRight: "10px"
                                                                },
                                                                children: "Conflict\xb7s"
                                                            })
                                                        })
                                                    ]
                                                });
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "90%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "dashboard_form_advanced_parameters",
                                            onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("main_form"),
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                    class: "fas fa-arrow-left",
                                                    style: {
                                                        marginRight: "10px",
                                                        marginTop: "25px"
                                                    }
                                                }),
                                                "Main parameters"
                                            ]
                                        }),
                                        isShared == false && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "dashboard_form_advanced_parameters",
                                            onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("share_company"),
                                            children: [
                                                "Share Dashboard ",
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                    class: "fas fa-arrow-right",
                                                    style: {
                                                        marginLeft: "5px",
                                                        marginTop: "25px"
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        isShared == false && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                            name: "share_company",
                            className: "slide_dashboard_form",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Companies with their own instance of your dashboard",
                                    listLabelClassName: "titles-input"
                                }),
                                listCheckedCompany.length != 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "dashboard_container_list",
                                    children: listCheckedCompany.map((_company, i)=>{
                                        if (_company == null) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
                                        let full_name = _company.id_shared ? " - " + data.shared_dashboards.find((shared)=>_company.id_shared == shared.id).name : "";
                                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            id: _company.id + "container",
                                            className: "dashboard_list_companies",
                                            "data-checked": "false",
                                            "data-id": _company.id,
                                            style: {
                                                padding: "5px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                            className: "fas fa-building"
                                                        }),
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                            children: [
                                                                _company.name,
                                                                " ",
                                                                full_name
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                        class: "buttonWrap",
                                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                                            id: _company.id + "button",
                                                            className: "main-iconButton red-button modalButtons-input",
                                                            icon: "fas fa-trash",
                                                            onClick: (e)=>deleteCompanyShared(i, _company.id_shared)
                                                        })
                                                    })
                                                })
                                            ]
                                        });
                                    })
                                }),
                                listCheckedCompany.length == 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "information_message",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                            className: "fas fa-info-circle",
                                            style: {
                                                marginRight: "15px"
                                            }
                                        }),
                                        "Your dashboard is not shared to any company. If you want to duplicate your dashboard and handle an instance of it to another company, please check the list below"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                (dashboard == null || !isShared == 1) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Share a new instance to other companies",
                                            listLabelClassName: "titles-input"
                                        }),
                                        companies != null && Array.isArray(companies) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            className: "dashboard_container_list",
                                            children: companies.map((_company, i)=>{
                                                let bool = data?.shared_dashboards.some((dash)=>dash.company_id == _company.id);
                                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                    id: _company.id + "container",
                                                    className: "dashboard_list_companies",
                                                    "data-checked": "false",
                                                    "data-id": _company.id,
                                                    style: {
                                                        border: bool ? "2px solid var(--main)" : "",
                                                        backgroundColor: bool ? "var(--secondary)" : ""
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                                    className: "fas fa-building"
                                                                }),
                                                                _company.name
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                                class: "buttonWrap",
                                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                                                    id: _company.id + "button",
                                                                    className: "main-iconButton add-hover modalButtons-input",
                                                                    icon: "fas fa-plus-circle",
                                                                    onClick: (e)=>addCompanySharing(_company)
                                                                })
                                                            })
                                                        })
                                                    ]
                                                });
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "dashboard_form_advanced_parameters",
                                    onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("channels_section"),
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                            class: "fas fa-arrow-left",
                                            style: {
                                                marginRight: "10px",
                                                marginTop: "25px"
                                            }
                                        }),
                                        "Select channel(s)"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                className: "dashboard_last_row",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                    type: "submit",
                    label: dataType.send,
                    className: "validate",
                    disabled: formState.isValid == false || Array.isArray(channels.list) && channels.list.find((x)=>x.id == watch("channel_id"))?.is_available == false ? true : false
                })
            })
        ]
    });
}
var $c5181aac592da883$export$2e2bcd8739ae039 = $c5181aac592da883$var$DashboardForm;




function $7626f2bdde1fbfae$var$DashboardFormPage() {
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    var data = null;
    var type = null;
    if (location.state != null) {
        data = location.state.data;
        type = location.state.type;
    }
    (0, $bh6RR.useEffect)(()=>{
        if (location.pathname.includes("/update") && location.state == null) return navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/dashboards/list"));
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $afaae2ff7871e331$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c5181aac592da883$export$2e2bcd8739ae039), {
                data: data,
                type: type
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f0aded74899c8465$export$2e2bcd8739ae039), {})
        ]
    });
}
var $7626f2bdde1fbfae$export$2e2bcd8739ae039 = $7626f2bdde1fbfae$var$DashboardFormPage;










var $bh6RR = parcelRequire("bh6RR");







var $bh6RR = parcelRequire("bh6RR");












const $b19cef4654724e98$export$e5f1fc2c2eb7b5da = {
    create: {
        title: "Build a new Block",
        send: "Create"
    },
    update: {
        title: "Update your Block",
        send: "Update"
    }
};
const $b19cef4654724e98$export$e03c0de46de1c54b = {
    create: {
        title: "Add a new variable",
        send: "Add"
    },
    update: {
        title: "Edit variable",
        send: "Update"
    }
};





var $bh6RR = parcelRequire("bh6RR");

function $11cef0d734338ff6$var$useVariablesBotAvailable(dashboard_channel_id, bot_id, exceptions, defaultValue = null) {
    const [variablesBot, setVariablesBot] = (0, $bh6RR.useState)("");
    const { getBotVariableAvailable: getBotVariableAvailable } = (0, $c67d47eff71309b3$export$2e2bcd8739ae039);
    async function setUpVariableBotRender() {
        const [response, errors] = await getBotVariableAvailable({
            dashboard_channel_id: dashboard_channel_id,
            bot_id: bot_id,
            exception: exceptions
        });
        if (errors != null) {
            console.log(errors);
            return;
        }
        let variables = response;
        variables = variables.sort((a, b)=>a.name[0].localeCompare(b.name[0]));
        let result = [];
        variables.forEach((_variable)=>{
            result.push({
                value: _variable.id,
                text: _variable.name
            });
        });
        if (defaultValue != null) result.push({
            value: defaultValue.value,
            text: defaultValue.text
        });
        setVariablesBot(result);
    }
    (0, $bh6RR.useEffect)(()=>{
        setUpVariableBotRender();
    }, []);
    return {
        variablesBot: variablesBot,
        setVariablesBot: setVariablesBot
    };
}
var $11cef0d734338ff6$export$2e2bcd8739ae039 = $11cef0d734338ff6$var$useVariablesBotAvailable;



parcelRequire("bh6RR");





const $2bf44ffc3bdfdb72$var$DashboardVariableFormButtonSection = ({ setValue: setValue, watch: watch, register: register, getValues: getValues })=>{
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "checkbox_dashboard_variable_container checkbox_without_margin",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Enable Message Popup",
                                listLabelClassName: "field-modal"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                style: {
                                    marginRight: "100px"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                    ...register("enable_message_popup"),
                                    onChange: ()=>setValue("enable_message_popup", !getValues("enable_message_popup")),
                                    checked: getValues("enable_message_popup")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "title_container",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                    children: [
                                        "Confirmation Message Popup ",
                                        watch("enable_message_popup") == 0 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            className: "disabled_field_message",
                                            children: "Disabled"
                                        }) : ""
                                    ]
                                }),
                                listLabelClassName: "field-modal"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0db11626bd290ec1$export$2e2bcd8739ae039), {
                                ...register("message_popup"),
                                placeholder: "Enter the message you want have when you'll click on button",
                                disabled: watch("enable_message_popup") == 1 ? false : true,
                                className: "input full-width resize-area text_area_dashboard_form_variable " + (watch("enable_message_popup") == 1 ? "" : "text_area_disabled")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "checkbox_dashboard_variable_container checkbox_without_margin",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Enable Response Popup",
                                listLabelClassName: "field-modal"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                style: {
                                    marginRight: "100px"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                    ...register("enable_response_popup"),
                                    onChange: ()=>setValue("enable_response_popup", !getValues("enable_response_popup")),
                                    checked: getValues("enable_response_popup")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "title_container",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                    children: [
                                        "Response Message Popup ",
                                        watch("enable_response_popup") == 0 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                            className: "disabled_field_message",
                                            children: "Disabled"
                                        }) : ""
                                    ]
                                }),
                                listLabelClassName: "field-modal"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0db11626bd290ec1$export$2e2bcd8739ae039), {
                                ...register("response_popup"),
                                placeholder: "Enter the message you want have when you'll click on button",
                                disabled: watch("enable_response_popup") == 1 ? false : true,
                                className: "input full-width resize-area text_area_dashboard_form_variable " + (watch("enable_response_popup") == 1 ? "" : "text_area_disabled")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "dashboard_advanced_parameters",
                        onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("obligatory"),
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                className: "fas fa-arrow-left",
                                style: {
                                    marginRight: "10px"
                                }
                            }),
                            "Main Parameters"
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "dashboard_advanced_parameters",
                        onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("advanced"),
                        children: [
                            " Advanced Parameters ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                className: "fas fa-arrow-right",
                                style: {
                                    marginRight: "10px"
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $2bf44ffc3bdfdb72$export$2e2bcd8739ae039 = $2bf44ffc3bdfdb72$var$DashboardVariableFormButtonSection;



parcelRequire("bh6RR");





const $142ea350c70b4680$export$52463409c7783422 = [
    {
        name: "Toggle",
        value: 0
    },
    {
        name: "Input",
        value: 1
    },
    {
        name: "Dropdown",
        value: 2
    },
    {
        name: "Button",
        value: 3
    },
    {
        name: "Number",
        value: 4
    }
];
let $142ea350c70b4680$var$styleDiv = {
    justifyContent: "start"
};
let $142ea350c70b4680$var$styleIcons = {
    marginRight: "25px",
    color: "var(--main)"
};
const $142ea350c70b4680$export$a589239b7577feaf = [
    {
        value: 0,
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
            className: "fas fa-toggle-on",
            style: $142ea350c70b4680$var$styleIcons
        })
    },
    {
        value: 4,
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
            className: "fas fa-dice-six",
            style: $142ea350c70b4680$var$styleIcons
        })
    },
    {
        value: 1,
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
            className: "fas fa-keyboard",
            style: $142ea350c70b4680$var$styleIcons
        })
    },
    {
        value: 2,
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
            className: "fas fa-caret-square-down",
            style: $142ea350c70b4680$var$styleIcons
        })
    },
    {
        value: 3,
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
            className: "fas fa-dot-circle",
            style: $142ea350c70b4680$var$styleIcons
        })
    }
];
function $142ea350c70b4680$export$b8850386e2a1b0ae(type) {
    if (type == null) return;
    return $142ea350c70b4680$export$a589239b7577feaf.find((element)=>element.value == type).text;
}
const $142ea350c70b4680$export$558122ad37458598 = [
    {
        value: 0,
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            style: $142ea350c70b4680$var$styleDiv,
            children: [
                " ",
                $142ea350c70b4680$export$b8850386e2a1b0ae(0),
                " Switch Button "
            ]
        })
    },
    {
        value: 4,
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            style: $142ea350c70b4680$var$styleDiv,
            children: [
                $142ea350c70b4680$export$b8850386e2a1b0ae(4),
                " Number "
            ]
        })
    },
    {
        value: 1,
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            style: $142ea350c70b4680$var$styleDiv,
            children: [
                $142ea350c70b4680$export$b8850386e2a1b0ae(1),
                " Text input "
            ]
        })
    },
    {
        value: 2,
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            style: $142ea350c70b4680$var$styleDiv,
            children: [
                $142ea350c70b4680$export$b8850386e2a1b0ae(2),
                " Drop-down list "
            ]
        })
    },
    {
        value: 3,
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            style: $142ea350c70b4680$var$styleDiv,
            children: [
                $142ea350c70b4680$export$b8850386e2a1b0ae(3),
                " Button "
            ]
        })
    }
];






function $666be866da7290c5$var$Tooltip({ text: text, classNameContainer: classNameContainer, classNameIcon: classNameIcon, classNameBoxText: classNameBoxText }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "con-tooltip " + (classNameContainer ? classNameContainer : ""),
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                className: "fas fa-info-circle " + (classNameIcon ? classNameIcon : ""),
                style: {
                    marginLeft: "10px",
                    fontSize: "18px"
                }
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "tooltip " + (classNameBoxText ? classNameBoxText : ""),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "content_tooltip_text",
                        children: [
                            text,
                            " "
                        ]
                    })
                })
            })
        ]
    });
}
var $666be866da7290c5$export$2e2bcd8739ae039 = $666be866da7290c5$var$Tooltip;




var $bh6RR = parcelRequire("bh6RR");
function $688661aa3b2284ac$var$useDropdownDashboard(dataDropdown) {
    const [dropdownDefaultValue, setDropdownDefaultValue] = (0, $bh6RR.useState)("");
    const modifyDropdownValues = (val)=>{
        var choices = val ? val : null //getValues("value_dropdown");
        ;
        choices = choices?.split("|");
        if (choices == null || choices.join("").replace(/\s/g, "").length == 0) {
            setDropdownDefaultValue([
                {
                    value: -1,
                    text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        children: " Nothing"
                    })
                }
            ]);
            return;
        }
        var arrayChoices = [];
        for(var i = 0; i < choices.length; i++){
            if (choices[i].replace(/\s/g, "").length == 0) continue;
            arrayChoices.push({
                value: i,
                text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    children: [
                        choices[i],
                        " "
                    ]
                })
            });
        }
        setDropdownDefaultValue(arrayChoices);
    };
    (0, $bh6RR.useEffect)(()=>{
        modifyDropdownValues(dataDropdown);
    }, []);
    return {
        dropdownDefaultValue: dropdownDefaultValue,
        modifyDropdownValues: modifyDropdownValues
    };
}
var $688661aa3b2284ac$export$2e2bcd8739ae039 = $688661aa3b2284ac$var$useDropdownDashboard;



const $b2d24a8b2a57eed6$var$DashboardVariableFormMain = ({ setValue: setValue, watch: watch, register: register, variable: variable, variablesBot: variablesBot, getValues: getValues })=>{
    const isButton = ()=>variable?.type == 3;
    const isNumber = ()=>variable?.type == 4;
    const { dropdownDefaultValue: dropdownDefaultValue, modifyDropdownValues: modifyDropdownValues } = (0, $688661aa3b2284ac$export$2e2bcd8739ae039)(getValues("value_dropdown"));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "dropdown_container dropdown_dashboard_variable_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: "Type variable",
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        style: {
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                            ...register("type", {
                                valueAsNumber: true
                            }),
                            setValue: setValue,
                            choices: (0, $142ea350c70b4680$export$558122ad37458598),
                            width: "240px",
                            defaultChoice: variable ? variable.type : 0
                        })
                    })
                ]
            }),
            watch("type") != 3 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "dropdown_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: "Variable from the bot",
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        style: {
                            marginTop: "2%"
                        },
                        children: variablesBot != "" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                            ...register("bot_variable_id", {
                                valueAsNumber: true
                            }),
                            setValue: setValue,
                            choices: variablesBot,
                            width: "240px",
                            defaultChoice: variable?.bot_variable_id
                        })
                    })
                ]
            }),
            watch("type") == 2 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "type_dropdown_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        style: {
                            display: "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Variables in the dropdown",
                                listLabelClassName: "field-modal"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $666be866da7290c5$export$2e2bcd8739ae039), {
                                classNameContainer: "top",
                                classNameBoxText: "tooltip_upper",
                                text: "You have to put value like : Orange|Banana|Tomato separate with pipes |"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                        ...register("value_dropdown"),
                        onChange: (e)=>modifyDropdownValues(e.target.value),
                        onKeyUp: (e)=>modifyDropdownValues(e.target.value),
                        placeholder: "Example : Orange|Banana|Tomato",
                        className: "input_variable_dashboard_form"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "title_container " + (watch("type") == 3 ? "form_container_title" : ""),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: "Renamed variable in the dashboard",
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                        ...register("label", {
                            required: true,
                            minLength: 3
                        }),
                        placeholder: watch("type") == 3 ? "Enter the label of the button action" : "Enter your variable's title",
                        className: "input_variable_dashboard_form"
                    })
                ]
            }),
            watch("type") == 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "checkbox_dashboard_variable_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: "Default value",
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        style: {
                            marginRight: "100px"
                        },
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                            ...register("empty"),
                            name: "default_value_checkbox",
                            onChange: ()=>setValue("default_value_checkbox", !getValues("default_value_checkbox")),
                            checked: getValues("default_value_checkbox")
                        })
                    })
                ]
            }),
            watch("type") == 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "title_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: "Default value",
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                        ...register("default_value", {
                            maxLength: 200
                        }),
                        placeholder: "Enter the default value",
                        className: "input_variable_dashboard_form"
                    })
                ]
            }),
            watch("type") == 2 && dropdownDefaultValue.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "dropdown_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: "Default value",
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        style: {
                            marginTop: "2%"
                        },
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                            ...register("default_value_dropdown", {
                                valueAsNumber: true
                            }),
                            choices: dropdownDefaultValue,
                            defaultChoice: variable?.default_value,
                            width: "240px",
                            heightFix: "55px",
                            setValue: setValue
                        }, Date.now())
                    })
                ]
            }),
            watch("type") == 3 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "title_container form_container_title",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Text on the button",
                                listLabelClassName: "field-modal"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                ...register("default_value", {
                                    required: true,
                                    minLength: 3
                                }),
                                placeholder: watch("type") == 3 ? "Enter the label of the button action" : "Enter your variable's title",
                                className: "input_variable_dashboard_form"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "title_container form_container_title",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Tracking ID of the action",
                                listLabelClassName: "field-modal"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                ...register("value", {
                                    required: true,
                                    minLength: 3,
                                    maxLength: 200
                                }),
                                defaultValue: isButton() ? variable.value : "",
                                placeholder: "Enter the tracking ID where the API action is",
                                className: "input_variable_dashboard_form"
                            })
                        ]
                    })
                ]
            }),
            watch("type") == 4 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "title_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: "Default value",
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                            type: "number",
                            ...register("default_value_number", {
                                required: true,
                                minLength: 1
                            }),
                            defaultValue: isNumber() ? parseInt(variable.value) : "",
                            onKeyDown: (e)=>(0, $eaf3b7858f46cf51$export$74ff82ccb88f9fb1)(e),
                            placeholder: "Enter the default value number",
                            className: "input_variable_dashboard_form"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "dashboard_advanced_parameters",
                onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)(watch("type") == 3 ? "button_result" : "advanced"),
                children: [
                    " ",
                    watch("type") == 3 ? "Button" : "Advanced",
                    " Parameters ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        className: "fas fa-arrow-right",
                        style: {
                            marginLeft: "5px",
                            marginTop: watch("type") == 2 ? "25px" : ""
                        }
                    })
                ]
            })
        ]
    });
};
var $b2d24a8b2a57eed6$export$2e2bcd8739ae039 = $b2d24a8b2a57eed6$var$DashboardVariableFormMain;








const $a5ed1a3deef4db5d$var$DashboardVariableFormAdvancedSlide = ({ watch: watch, register: register })=>{
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "title_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            children: [
                                "Informations ",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                    className: "fas fa-info-circle"
                                })
                            ]
                        }),
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0db11626bd290ec1$export$2e2bcd8739ae039), {
                        className: "input full-width resize-area text_area_dashboard_form_variable",
                        ...register("information", {
                            maxLength: 200
                        }),
                        placeholder: "Enter the complementary informations  of the variable"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "title_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            children: [
                                " Regex ",
                                watch("type") == 1 ? "" : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "disabled_field_message",
                                    children: "Disabled"
                                })
                            ]
                        }),
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0db11626bd290ec1$export$2e2bcd8739ae039), {
                        ...register("regex"),
                        placeholder: "Enter the complementary informations  of the variable",
                        disabled: watch("type") == 1 ? false : true,
                        className: "input full-width resize-area text_area_dashboard_form_variable " + (watch("type") == 1 ? "" : "text_area_disabled")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "title_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            children: [
                                " Error message indication ",
                                watch("type") == 1 ? "" : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "disabled_field_message",
                                    children: "Disabled"
                                })
                            ]
                        }),
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                        ...register("placeholder_format"),
                        placeholder: "Example : Don't insert special character",
                        className: "input_variable_dashboard_form " + (watch("type") == 1 ? "" : "text_area_disabled"),
                        disabled: watch("type") == 1 ? false : true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "dashboard_advanced_parameters",
                        onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)(watch("type") == 3 ? "button_result" : "obligatory"),
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                className: "fas fa-arrow-left",
                                style: {
                                    marginRight: "10px",
                                    marginTop: "0"
                                }
                            }),
                            watch("type") == 3 ? "Button" : "Main",
                            " Parameters"
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "dashboard_advanced_parameters",
                        onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("conditionals"),
                        children: [
                            "Conditional Parameters ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                className: "fas fa-arrow-right",
                                style: {
                                    marginRight: "10px",
                                    marginTop: "0"
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $a5ed1a3deef4db5d$export$2e2bcd8739ae039 = $a5ed1a3deef4db5d$var$DashboardVariableFormAdvancedSlide;




var $bh6RR = parcelRequire("bh6RR");







var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");









const $2a4424969dd4928b$var$DashboardVariableCondition = ({ condition: condition, variables: variables, hookBlocks: hookBlocks, block: block })=>{
    const { removeCondition: removeCondition, modifyCondition: modifyCondition } = hookBlocks;
    const ref = (0, $bh6RR.useRef)();
    const [variable, setVariable] = (0, $bh6RR.useState)(condition.variable);
    const [listVariableDropdown, setListVariableDropdown] = (0, $bh6RR.useState)([]);
    const { register: register, getValues: getValues, setValue: setValue } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            value: condition.value ?? variable.default_value
        }
    });
    const { dropdownDefaultValue: dropdownDefaultValue, modifyDropdownValues: modifyDropdownValues } = (0, $688661aa3b2284ac$export$2e2bcd8739ae039)(variable.placeholder_format); // inutile si le type   n est pas la dropdown
    const updateCondition = (value, _variable = variable)=>{
        condition.variable = _variable;
        modifyCondition(block.index, condition, value);
        setValue("value", value);
    };
    const getVariableById = (id)=>variables.find((v)=>v.id == id);
    const setUpVariablesListDropdown = ()=>{
        let _variables = variables.sort((a, b)=>a.label > b.label ? 1 : b.label > a.label ? -1 : 0);
        let list = _variables.map((variable)=>{
            return {
                value: variable.id,
                text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    style: {
                        justifyContent: "start",
                        maxWidth: "200px"
                    },
                    title: variable.label,
                    children: [
                        " ",
                        (0, $142ea350c70b4680$export$b8850386e2a1b0ae)(variable.type),
                        variable.label,
                        " "
                    ]
                })
            };
        });
        if (list.length == 0) return; // si pas de variable, pas besoin d'aller plus loin
        setListVariableDropdown([
            ...list
        ]);
    };
    const updateCurrentVariable = (value)=>{
        let _variable = getVariableById(value);
        if (variable != _variable) setVariable(_variable);
        console.log(variable);
        console.log(_variable);
        if (_variable.type == 2) modifyDropdownValues(_variable.placeholder_format);
        modifyCurrentVariableDefaultValue(_variable);
    /*
        if (variable.type != _variable.type) {
            modifyCurrentVariableDefaultValue(_variable);

        }*/ };
    (0, $bh6RR.useEffect)(()=>{
        setUpVariablesListDropdown();
    }, [
        variable
    ]);
    const modifyCurrentVariableDefaultValue = (_variable)=>{
        //let currentVal = getValues("value") 
        switch(_variable.type){
            case (0, $142ea350c70b4680$export$52463409c7783422).find((type)=>type.name == "Toggle").value:
                // updateCondition(getValues("value") != null ? parseInt(getValues("value")) : false, _variable);
                updateCondition(false, _variable);
                break;
            case (0, $142ea350c70b4680$export$52463409c7783422).find((type)=>type.name == "Input").value:
                //updateCondition(currentVal != null ? currentVal : "", _variable);
                updateCondition("", _variable);
                break;
            case (0, $142ea350c70b4680$export$52463409c7783422).find((type)=>type.name == "Dropdown").value:
                modifyDropdownValues(_variable.placeholder_format);
                //updateCondition(currentVal != null ? parseInt(currentVal) : 0, _variable);
                updateCondition(0, _variable);
                break;
            case (0, $142ea350c70b4680$export$52463409c7783422).find((type)=>type.name == "Number").value:
                updateCondition(0, _variable);
                break;
            default:
                return "foo";
        }
    };
    const renderListVariable = listVariableDropdown.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
        reverse: true,
        choices: listVariableDropdown,
        defaultChoice: variable.id,
        width: "200px",
        setValue: (name, value)=>updateCurrentVariable(value)
    }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)());
    const renderDelete = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
        className: "fas fa-trash remove_condition_block_dashboard_variable_icon",
        style: {
            color: "var(--pink)"
        },
        onClick: ()=>{
            setValue("value", null);
            removeCondition(block.index, condition.index);
        }
    }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)());
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "container_block_condition_dashboard",
        style: {
            border: "0px",
            marginTop: variable?.type == 2 ? "-15px" : ""
        },
        children: listVariableDropdown.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            children: [
                variable?.type == 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "checkbox_dashboard_variable_container",
                    style: {
                        margin: "0"
                    },
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "list_variables_choose_dropdown",
                            children: renderListVariable
                        }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)()),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                                ref: ref,
                                name: (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)() + " dashboard_variable_condition_value",
                                onChange: ()=>updateCondition(!parseInt(getValues("value"))),
                                checked: parseInt(getValues("value"))
                            }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)())
                        }),
                        renderDelete
                    ]
                }),
                variable?.type == 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "input_dashboard_variable_container",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "list_variables_choose_dropdown",
                            children: renderListVariable
                        }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)()),
                        /*#__PURE__*/ (0, $bh6RR.createElement)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                            ref: ref,
                            ...register("value"),
                            key: (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)(),
                            placeholder: "Conditional value",
                            className: "input_conditionnal_block_dashboard_variable",
                            onChange: (e)=>updateCondition(e.target.value)
                        }),
                        renderDelete
                    ]
                }),
                variable?.type == 2 && dropdownDefaultValue.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "dropdown_container dropdown_dashboard_variable_container conditional_dropdown",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            children: renderListVariable
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            style: {
                                marginLeft: "10px"
                            },
                            className: "selector_dropdown_variable_cond",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                ref: ref,
                                id: "dashboard_variable_condition_value",
                                reverse: true,
                                choices: dropdownDefaultValue,
                                defaultChoice: getValues("value"),
                                width: "190px",
                                setValue: (name, value)=>{
                                    updateCondition(value);
                                }
                            }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)())
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            style: {
                                position: "relative",
                                bottom: "-5px"
                            },
                            children: [
                                renderDelete,
                                "  "
                            ]
                        })
                    ]
                }),
                variable?.type == 4 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "input_dashboard_variable_container",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "list_variables_choose_dropdown",
                            children: renderListVariable
                        }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)()),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                            ref: ref,
                            type: "number",
                            onKeyDown: (e)=>(0, $eaf3b7858f46cf51$export$74ff82ccb88f9fb1)(e),
                            defaultValue: getValues("value"),
                            placeholder: "Conditional number",
                            className: "input_variable_dashboard_form input_conditionnal_block_dashboard_variable",
                            onChange: (e)=>updateCondition(e.target.value)
                        }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)()),
                        renderDelete
                    ]
                })
            ]
        })
    }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)());
};
var $2a4424969dd4928b$export$2e2bcd8739ae039 = $2a4424969dd4928b$var$DashboardVariableCondition;




const $b7cdc0d660bb7762$var$DashboardBlockVariableCondition = ({ block: block, hookBlocks: hookBlocks })=>{
    const { getConditionsByBlock: getConditionsByBlock, createCondition: createCondition, getVariables: getVariables } = hookBlocks;
    var conditions = getConditionsByBlock(block.index);
    (0, $bh6RR.useEffect)(()=>{
        if (!conditions || conditions.length == 0) createCondition(block.index);
    }, [
        conditions
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "container_block_condition_dashboard",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: conditions != null && conditions.length > 0 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    conditions.map((cond, i)=>{
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            children: [
                                i != 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    style: {
                                        textAlign: "center",
                                        color: "var(--main)"
                                    },
                                    children: " OR "
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2a4424969dd4928b$export$2e2bcd8739ae039), {
                                    condition: cond,
                                    hookBlocks: hookBlocks,
                                    block: block,
                                    variables: getVariables()
                                }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)())
                            ]
                        }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)());
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                            id: block.index + "add_conditionnal_button",
                            className: "main-iconButton add-hover modalButtons-input",
                            icon: "fas fa-plus-circle",
                            onClick: ()=>createCondition(block.index)
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                    id: block.index + "add_conditionnal_button",
                    className: "main-iconButton add-hover modalButtons-input",
                    icon: "fas fa-plus-circle",
                    onClick: ()=>createCondition(block.index)
                })
            })
        })
    }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)());
};
var $b7cdc0d660bb7762$export$2e2bcd8739ae039 = $b7cdc0d660bb7762$var$DashboardBlockVariableCondition;




const $0e53107cf977f219$var$DashboardVariableFormConditionalsSlide = ({ hookBlocks: hookBlocks })=>{
    const { listBlockConditions: listBlockConditions, modifyBlockConditions: modifyBlockConditions, createBlockCondition: createBlockCondition, getConditionsByBlock: getConditionsByBlock, createCondition: createCondition, getVariables: getVariables } = hookBlocks;
    const [currentVariable, setCurrentVariable] = (0, $bh6RR.useState)(null);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "container_conditional_block",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "information_message",
                        style: {
                            marginTop: "20px",
                            marginBottom: "20px",
                            width: "85%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                className: "fas fa-info-circle",
                                style: {
                                    marginRight: "15px"
                                }
                            }),
                            "Set here any condition that is mandatory for your new variable to appear for the user"
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Add a new block condition",
                                listLabelClassName: "field-modal"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                    id: "button_add_block_condition",
                                    className: "main-iconButton add-hover modalButtons-input",
                                    icon: "fas fa-plus-circle",
                                    onClick: ()=>createBlockCondition()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "divider div-transparent div-dot",
                        style: {
                            marginTop: currentVariable == null ? "30px" : ""
                        }
                    }),
                    listBlockConditions != null && listBlockConditions.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "List of conditions",
                                listLabelClassName: "field-modal"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {})
                        ]
                    }),
                    listBlockConditions.map((block, i)=>{
                        let _conditions = getConditionsByBlock(block.index);
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            children: [
                                i != 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    style: {
                                        textAlign: "center",
                                        color: "var(--main)",
                                        marginBottom: "15px",
                                        marginTop: "15px"
                                    },
                                    children: " AND "
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b7cdc0d660bb7762$export$2e2bcd8739ae039), {
                                    hookBlocks: hookBlocks,
                                    variables: getVariables(),
                                    conditions: _conditions,
                                    block: block,
                                    setListConditions: modifyBlockConditions,
                                    createCondition: ()=>createCondition(block.index)
                                })
                            ]
                        }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)());
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "space-between"
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "dashboard_advanced_parameters",
                    onClick: ()=>(0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("advanced"),
                    children: [
                        " ",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                            className: "fas fa-arrow-left",
                            style: {
                                marginRight: "10px",
                                marginTop: "0"
                            }
                        }),
                        "Advanced Parameters"
                    ]
                })
            })
        ]
    });
};
var $0e53107cf977f219$export$2e2bcd8739ae039 = $0e53107cf977f219$var$DashboardVariableFormConditionalsSlide;



var $bh6RR = parcelRequire("bh6RR");
function $cdabd84129918a69$var$useBlocksConditions(_dashboard, _variable) {
    const [listBlockConditions, setListBlockConditions] = (0, $bh6RR.useState)([]);
    const [dashboard, setDashboard] = (0, $bh6RR.useState)(_dashboard);
    const [variable, setVariable] = (0, $bh6RR.useState)(_variable);
    var conditions = [];
    const createBlockCondition = ()=>{
        let indexBlock = listBlockConditions.length > 0 ? listBlockConditions.reduce((max, current)=>{
            return current.index > max ? current.index : max;
        }).index + 1 : 0;
        let _blocks_cond = listBlockConditions;
        _blocks_cond[_blocks_cond.length] = {
            conditions: [],
            index: indexBlock
        };
        setListBlockConditions([
            ..._blocks_cond
        ]);
    };
    const modifyBlockConditions = (newList, index, keepState = false)=>{
        let res = listBlockConditions;
        for(let i = 0; i < res.length; i++){
            if (res[i].index != index) continue;
            res[i] = {
                index: index,
                conditions: newList
            };
        }
        if (keepState == true) return res;
        conditions = [
            ...res
        ];
        setListBlockConditions([
            ...conditions
        ]);
        return res;
    };
    const removeBlock = (index)=>{
        let res = listBlockConditions.filter((block)=>block.index !== index);
        for(let i = 0; i < res.length; i++)res[i].index = i;
        setListBlockConditions([
            ...res
        ]);
    };
    const getConditionsByBlock = (index)=>{
        return listBlockConditions.find((block)=>index === block.index)?.conditions;
    };
    const insertAllData = (data)=>{
        setListBlockConditions(data);
    };
    const getVariables = (_dashboard = dashboard)=>{
        return _dashboard.blocks.filter((block)=>block.type == 0).map((block)=>block.variables).flat().filter((variable)=>variable.type != 3).filter((v)=>v.id != variable?.id);
    };
    const setUpConditionalsList = (dashboard, variable)=>{
        if (dashboard == null || variable == null) return;
        let variables = getVariables(dashboard);
        let array = [];
        for (let condition of variable.conditions){
            let variable = variables.find((variable)=>variable.id == condition.variable_target_id);
            let newCond = {
                id: condition.id,
                value: condition.value,
                variable: variable,
                block_index: condition.block_index,
                index: new Date().getTime() + "_" + Math.floor(Math.random() * 100000)
            };
            array.push(newCond);
        }
        // il faut egalement triee les conditions avec et sans index 
        let cond_blocks = [];
        for(let i = 0; i < array.length; i++){
            let ind = array[i].block_index;
            if (!cond_blocks[ind]) cond_blocks[ind] = {
                conditions: [],
                index: ind
            };
            cond_blocks[ind].conditions.push(array[i]);
        }
        cond_blocks = cond_blocks.filter((cond_block)=>cond_block);
        insertAllData([
            ...cond_blocks
        ]);
    };
    const createCondition = (block_index)=>{
        let variable = getVariables()[0];
        let newCond = {
            value: variable.default_value,
            variable: variable,
            block_index: block_index,
            index: new Date().getTime() + "_" + Math.floor(Math.random() * 100000)
        };
        let currentsList = getConditionsByBlock(block_index) ?? [];
        let newList = [
            ...currentsList,
            newCond
        ];
        return modifyBlockConditions(newList, block_index);
    };
    const modifyCondition = (block_index, condition, value)=>{
        const newList = getConditionsByBlock(block_index).map((cond)=>{
            if (cond.index === condition.index) return {
                ...cond,
                variable: condition.variable,
                value: value
            };
            return cond;
        });
        modifyBlockConditions(newList, block_index, true);
    };
    const removeCondition = (block_index, index_cond)=>{
        let conds = getConditionsByBlock(block_index);
        let res = modifyBlockConditions(conds.filter((cond)=>cond.index !== index_cond), block_index);
        let newConds = res.find((block)=>block.index === block_index)?.conditions;
        if (newConds.length == 0) removeBlock(block_index);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (_dashboard != null) {
            setDashboard(_dashboard);
            setUpConditionalsList(_dashboard, variable);
        }
    }, [
        _dashboard,
        _variable
    ]);
    return {
        listBlockConditions: listBlockConditions,
        createBlockCondition: createBlockCondition,
        modifyBlockConditions: modifyBlockConditions,
        getConditionsByBlock: getConditionsByBlock,
        insertAllData: insertAllData,
        getVariables: getVariables,
        createCondition: createCondition,
        modifyCondition: modifyCondition,
        removeCondition: removeCondition,
        removeBlock: removeBlock
    };
}
var $cdabd84129918a69$export$2e2bcd8739ae039 = $cdabd84129918a69$var$useBlocksConditions;



var $bh6RR = parcelRequire("bh6RR");

function $f3ef7769a2510d21$var$useDashboards(id) {
    const [dashboard, setDashboard] = (0, $bh6RR.useState)(null);
    const { getDashboard: getDashboard } = (0, $c67d47eff71309b3$export$2e2bcd8739ae039);
    async function setUpDashboard() {
        const [response, errors] = await getDashboard({
            id: id
        });
        if (errors != null) {
            console.log(errors);
            return;
        }
        let blocks = response.blocks.sort(function(a, b) {
            return (a.position === null) - (b.position === null) || +(a.position > b.position) || -(a.position < b.position);
        });
        response.blocks = blocks;
        setDashboard(response);
    }
    (0, $bh6RR.useEffect)(()=>{
        setUpDashboard();
    }, []);
    return {
        dashboard: dashboard,
        setUpDashboard: setUpDashboard
    };
}
var $f3ef7769a2510d21$export$2e2bcd8739ae039 = $f3ef7769a2510d21$var$useDashboards;


const $f30b2360e51cf167$var$DashboardVariableFormModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ dashboardChannel: dashboardChannel, variable: variable, block_id: block_id, bot: bot, postbackAction: postbackAction })=>{
    var dashboard_id = dashboardChannel.dashboard.id;
    const { dashboard: dashboard, setUpDashboard: setUpDashboard } = (0, $f3ef7769a2510d21$export$2e2bcd8739ae039)(dashboard_id);
    var type = variable ? "update" : "create";
    const formData = (0, $b19cef4654724e98$export$e03c0de46de1c54b)[type];
    const { addVariable: addVariable, editVariable: editVariable } = (0, $c67d47eff71309b3$export$2e2bcd8739ae039);
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const { variablesBot: variablesBot } = (0, $11cef0d734338ff6$export$2e2bcd8739ae039)(dashboardChannel.id, bot.id, variable?.bot_variable_id);
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const hookBlocks = (0, $cdabd84129918a69$export$2e2bcd8739ae039)(dashboard, variable);
    const isCheckbox = ()=>{
        return variable?.type == 0;
    };
    const isInput = ()=>{
        return variable?.type == 1;
    };
    const isDropdown = ()=>{
        return variable?.type == 2;
    };
    const isButton = ()=>{
        return variable?.type == 3;
    };
    const isNumber = ()=>{
        return variable?.type == 4;
    };
    const { register: register, handleSubmit: handleSubmit, getValues: getValues, setValue: setValue, watch: watch, formState: { errors: errors }, formState: formState } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            label: variable?.label,
            type: variable ? variable.type : 0,
            default_value: isInput() || isButton() || isNumber() ? variable.default_value : "",
            information: variable?.information,
            placeholder_format: variable && isDropdown() ? variable.placeholder_format : variable ? variable.placeholder_format : "The value doesn't match",
            regex: variable?.regex,
            value_dropdown: isDropdown() ? variable?.placeholder_format : "",
            default_value_checkbox: isCheckbox() ? parseInt(variable.default_value) : 0,
            enable_message_popup: isButton() && variable.regex != null ? true : false,
            message_popup: isButton() && variable.regex != null ? variable.regex : null,
            enable_response_popup: isButton() && variable.placeholder_format != null ? true : false,
            response_popup: isButton() && variable.placeholder_format != null ? variable.placeholder_format : null
        }
    });
    const onSubmit = async ()=>{
        let dataToSend = getValues();
        dataToSend.dashboard_block_id = block_id;
        dataToSend.label = dataToSend.label.trim();
        if (variable != null) dataToSend.id = variable.id;
        if (dataToSend.type == 0) dataToSend.default_value = dataToSend.default_value_checkbox;
        if (dataToSend.type == 1 && !dataToSend.default_value) dataToSend.default_value = null;
        else if (dataToSend.type == 2) {
            if (variable?.type == 2) {
                let nbChoice = dataToSend.value_dropdown.split("|").length - 1;
                dataToSend.default_value_dropdown = parseInt(dataToSend.default_value_dropdown) > nbChoice ? 0 : dataToSend.default_value_dropdown;
                dataToSend.value = variable?.value < nbChoice ? variable.value : 0;
            }
            dataToSend.placeholder_format = dataToSend.value_dropdown;
            dataToSend.default_value_dropdown = dataToSend.default_value_dropdown == -1 ? 0 : dataToSend.default_value_dropdown;
            dataToSend.default_value = dataToSend.default_value_dropdown;
        } else if (dataToSend.type == 3) {
            dataToSend.placeholder_format = dataToSend.enable_response_popup == true ? dataToSend.response_popup != null ? dataToSend.response_popup : "" : null;
            dataToSend.regex = dataToSend.enable_message_popup == true ? dataToSend.message_popup != null ? dataToSend.message_popup : "" : null;
            dataToSend.bot_variable_id = null;
        } else if (dataToSend.type == 4) dataToSend.default_value = dataToSend.default_value_number;
        dataToSend.conditions = hookBlocks.listBlockConditions;
        const [response, errors] = type == "create" ? await addVariable(dataToSend) : await editVariable(variable.id, dataToSend);
        if (errors != null) {
            console.log(errors);
            return;
        }
        modal.resolve(response);
        toast.success("Variable " + (variable ? " edited" : " added"), 'The variable " ' + response.label + ' " has been ' + (variable ? "edited !" : "added ! "));
        postbackAction(response);
        onClose();
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        name: "change-password",
        id: modal.id,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "leave-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            variablesBot && variablesBot.length > 0 || variable?.type == 3 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
                className: "container_dashbord_form_variable " + (watch("type") == 2 ? "dashboard_dropdown_form" : watch("type") == 3 ? "dashboard_button_form" : ""),
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                        children: formData.title
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                        className: "form_center_dashboard_variable_form",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $51a8b46ec4198ef9$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                                    name: "obligatory",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b2d24a8b2a57eed6$export$2e2bcd8739ae039), {
                                        setValue: setValue,
                                        watch: watch,
                                        register: register,
                                        variable: variable,
                                        variablesBot: variablesBot,
                                        getValues: getValues
                                    })
                                }),
                                watch("type") == 3 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                                    name: "button_result",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2bf44ffc3bdfdb72$export$2e2bcd8739ae039), {
                                        setValue: setValue,
                                        watch: watch,
                                        register: register,
                                        getValues: getValues
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                                    name: "advanced",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a5ed1a3deef4db5d$export$2e2bcd8739ae039), {
                                        watch: watch,
                                        register: register
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                                    name: "conditionals",
                                    className: "conditionnal_slide_dashboard_variable slider_dashboard_variable_form",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0e53107cf977f219$export$2e2bcd8739ae039), {
                                        dashboard_id: dashboard_id,
                                        watch: watch,
                                        variable: variable,
                                        hookBlocks: hookBlocks
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                className: "cancel",
                                label: "Cancel",
                                type: "button",
                                onClick: ()=>onClose(),
                                style: {
                                    marginRight: "20px"
                                }
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                className: "validate",
                                label: formData.send,
                                type: "submit",
                                disabled: !formState.isValid
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "no_variable",
                children: [
                    " The bot  \xa0 ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                        className: "title_bot",
                        children: [
                            " ",
                            (0, $c250361150c8f4e2$export$2e2bcd8739ae039)(bot.name),
                            " "
                        ]
                    }),
                    " \xa0 doesn't have any variable, you can't manage anything"
                ]
            })
        ]
    });
});
var $f30b2360e51cf167$export$2e2bcd8739ae039 = $f30b2360e51cf167$var$DashboardVariableFormModal;








var $bh6RR = parcelRequire("bh6RR");



function $70402776f546d272$var$DashboardToggle({ data: data, className: className, postbackAction: postbackAction }) {
    const [state, setState] = (0, $bh6RR.useState)(parseInt(data.value) == 0 || data.value == false ? false : true);
    const [switchTimer, setSwitchTimer] = (0, $bh6RR.useState)(null);
    const ref = (0, $bh6RR.useRef)(null);
    const switchButton = ()=>{
        setState(!state);
        saveData(!state == false ? false : true);
    };
    const saveData = (value)=>{
        if (postbackAction == null) return;
        console.log(value);
        clearTimeout(switchTimer);
        setSwitchTimer(setTimeout(()=>{
            postbackAction(value);
        }, 1500));
    };
    (0, $bh6RR.useEffect)(()=>{
        if (ref.current != null && switchTimer == null) ref.current.checked = data.value == false ? false : true;
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
            ref: ref,
            name: data.label + Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1),
            checked: state,
            onChange: ()=>switchButton(),
            classNameMainContainer: "checkbox dashboard_checkbox " + (className ? className : ""),
            defaultChecked: data.value
        })
    });
}
var $70402776f546d272$export$2e2bcd8739ae039 = $70402776f546d272$var$DashboardToggle;




var $bh6RR = parcelRequire("bh6RR");



function $41fcf33860e494d0$var$DashboardInput({ data: data, activeError: activeError, postbackAction: postbackAction }) {
    const [actualHeight, setActualHeight] = (0, $bh6RR.useState)("auto");
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const heightLine = 21;
    const [error, setError] = (0, $bh6RR.useState)(false);
    const [typingTimer, setTypingTimer] = (0, $bh6RR.useState)(null);
    const inputRef = (0, $bh6RR.useRef)();
    const checkLines = (event)=>{
        let text = event.target.value;
        modifyHeight(text);
        //////////////////
        if (text != "" && (data.regex == null || data.regex.replace(/\s/g, "").length == 0)) {
            setError(false);
            saveData(text);
            return;
        }
        saveData(text, checkError(text));
    };
    const checkError = (val)=>{
        let reg = data.regex;
        if (reg == null) reg = "";
        var regex = new RegExp(reg);
        let matched = regex.test(val);
        setError(!matched);
        activeError(!matched);
        return !matched;
    };
    const modifyHeight = (text)=>{
        const linesText = text.split("\n");
        var lines = linesText.length;
        const nbCaractersForOneRow = 85;
        linesText.forEach((line)=>{
            if (line.length > nbCaractersForOneRow) //console.log(line.length )
            lines += Math.floor(line.length / nbCaractersForOneRow);
        });
        if (lines > 10) setActualHeight(10 * heightLine);
        else setActualHeight(lines * heightLine);
    /* ANCIENNE VERSION : a supprimee quand sur de plus besoin
        if (lines >= 1 && lines <= 3) {
            if (lines == 1 && text.length > 60) {
                setActualHeight("auto");
            }
            else {
                setActualHeight(lines * heightLine);
            }
        }
        else if (lines < 3 && actualHeight > heightLine) {
            setActualHeight(lines * heightLine);
        }
            **/ };
    const saveData = (text, err)=>{
        clearTimeout(typingTimer);
        setTypingTimer(setTimeout(()=>{
            if (err) {
                inputRef.current.value = data.value;
                setError(false);
                activeError(false);
                toast.success("Variable's value reinitialized", 'The value of the variable " ' + data.label + " \" has been reinitialized because the last one didn't match with the wished structure !", 5000);
            } else postbackAction(text);
        }, 1500));
    };
    (0, $bh6RR.useEffect)(()=>{
        modifyHeight(data.value);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "dashboard_text_area",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0db11626bd290ec1$export$2e2bcd8739ae039), {
                ref: inputRef,
                defaultValue: data.value,
                style: {
                    height: actualHeight,
                    borderColor: error ? "var(--pink)" : ""
                },
                onChange: (event)=>checkLines(event),
                onInput: (e)=>{
                    'this.style.height = "";this.style.height = this.scrollHeight + "px"';
                }
            }),
            error == true && data.placeholder_format != null && data.placeholder_format.replace(/\s/g, "").length != 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "error_message",
                children: data.placeholder_format
            })
        ]
    }, data.id);
}
var $41fcf33860e494d0$export$2e2bcd8739ae039 = $41fcf33860e494d0$var$DashboardInput;






function $4bb1746f67427ccd$var$DashboardDropdown({ data: data, postbackAction: postbackAction }) {
    var choices = data.placeholder_format.split("|");
    var switchTimer;
    var arrayChoices = [];
    for(var i = 0; i < choices.length; i++)arrayChoices.push({
        value: i,
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                choices[i],
                " "
            ]
        })
    });
    const saveData = (value)=>{
        clearTimeout(switchTimer);
        switchTimer = setTimeout(()=>{
            postbackAction(value);
        }, 1500);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
            choices: arrayChoices,
            width: "220px",
            defaultChoice: data.value,
            setValue: (name, value)=>saveData(value)
        })
    });
}
var $4bb1746f67427ccd$export$2e2bcd8739ae039 = $4bb1746f67427ccd$var$DashboardDropdown;



parcelRequire("bh6RR");








var $bh6RR = parcelRequire("bh6RR");













const $e75b2b62c0cc82ab$var$DashboardButtonConfirmationModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ data: data, postbackAction: postbackAction, channels: channels })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const [resultButton, setResultButton] = (0, $bh6RR.useState)(false);
    const title = data.default_value;
    data.regex = !data.regex ? "" : data.regex;
    const content = data.regex.substring(data.regex.indexOf("\n") + 1);
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const { register: register, getValues: getValues, setValue: setValue, handleSubmit: handleSubmit, watch: watch, formState: { errors: errors }, formState: formState } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: ""
    });
    const onSubmit = async ()=>{
        setIsLoading("start");
        let res = await postbackAction(getValues().channel_key);
        setIsLoading("finish");
        if (data.placeholder_format != null) setTimeout(()=>setResultButton(res.data), 2000);
        else setTimeout(()=>{
            onClose();
            (0, $e71429213be6db03$export$d49a3a87e97a1269)();
        }, 2000);
        (0, $e71429213be6db03$export$d49a3a87e97a1269)() // 2 fois pour faire plus joli & dans le cas ou la modal se ferme pas, on le voit pour sur
        ;
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        name: resultButton != false ? "modal_button_dashboard_result_adapted" : "",
        id: modal.id,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "leave-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            isLoading == false && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
                className: "changePassword-container",
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                        children: data.label
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                                style: {
                                    fontSize: "16px",
                                    whiteSpace: "pre-line"
                                },
                                children: content
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                                        style: {
                                            fontSize: "16px"
                                        },
                                        children: [
                                            "Tap the name of the variable : ",
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                style: {
                                                    fontWeight: "bold"
                                                },
                                                children: data.label
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                        ...register("confirmation_input"),
                                        style: {
                                            marginBottom: "15px",
                                            borderColor: !watch("confirmation_input") ? "" : watch("confirmation_input") != data.label ? "var(--pink)" : ""
                                        }
                                    })
                                ]
                            }),
                            channels.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    marginBottom: "15px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                        label: "Channel",
                                        listLabelClassName: "titles-input"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        style: {
                                            marginLeft: "10%",
                                            marginTop: "2%"
                                        },
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                            ...register("channel_key"),
                                            setValue: setValue,
                                            choices: channels,
                                            defaultChoice: channels[0].id,
                                            width: "230px"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                className: "cancel",
                                label: "Cancel",
                                type: "button",
                                onClick: ()=>onClose(),
                                style: {
                                    marginRight: "20px"
                                }
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                className: "validate",
                                label: "Go",
                                type: "submit",
                                disabled: !(watch("confirmation_input") == data.label)
                            })
                        ]
                    })
                ]
            }),
            isLoading != false && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                id: "border_anim",
                className: "container_loader_button " + (resultButton != false ? "moove_loader_to_up" : ""),
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    id: "border_anim",
                    style: {
                        display: "flex"
                    },
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
                            id: "svg_checkfile",
                            viewBox: "0 0 52 52",
                            className: "checkmark",
                            style: {
                                display: isLoading == "finish" ? "block" : "none",
                                left: "44%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                                    className: "checkmark__circle",
                                    cy: "26",
                                    cx: "26",
                                    r: "25",
                                    fill: "none"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                    className: "checkmark__check",
                                    fill: "none",
                                    d: "M14.1 27.2l7.1 7.2 16.7-16.8"
                                })
                            ]
                        }),
                        isLoading == "start" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            id: "loader_anim",
                            className: "loader",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "load-one",
                                    style: {
                                        left: "43%"
                                    }
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "load-two",
                                    style: {
                                        left: "45.2%"
                                    }
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "load-three",
                                    style: {
                                        left: "47.5%"
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            resultButton != false && resultButton.messages.map((element, i)=>{
                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                            style: {
                                color: element.type == "error" ? "var(--pink)" : "var(--main)"
                            },
                            children: [
                                (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(element.type),
                                " "
                            ]
                        }),
                        ": ",
                        element.content
                    ]
                });
            })
        ]
    });
});
var $e75b2b62c0cc82ab$export$2e2bcd8739ae039 = $e75b2b62c0cc82ab$var$DashboardButtonConfirmationModal;




function $e637ec1adbcee531$var$DashboardButton({ data: data, bot: bot, dashboardsChannelsLinks: dashboardsChannelsLinks }) {
    const { loadBotBlock: loadBotBlock } = (0, $c67d47eff71309b3$export$2e2bcd8739ae039);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    let channels = dashboardsChannelsLinks.map((link)=>{
        return {
            value: link.channel.key,
            text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    " ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        srcSet: (0, $b3e51b95dcf04d66$export$2e2bcd8739ae039)[link.channel.type.name]
                    }),
                    link.channel.name
                ]
            })
        };
    });
    let hasModal = data.regex != null || channels.length > 1;
    const loadButton = ()=>{
        if (hasModal) {
            showConfirmationMessage();
            return;
        } else if (channels.length == 1) {
            onSubmit(channels[0].value);
            return;
        }
        toast.error("Error", "The dashboard is not linked to any channel", 4000);
    };
    const showConfirmationMessage = ()=>{
        (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $e75b2b62c0cc82ab$export$2e2bcd8739ae039), {
            data: data,
            postbackAction: onSubmit,
            channels: channels
        });
    };
    const onSubmit = async (channel_key)=>{
        const result = await loadBotBlock({
            tracking: data.value
        }, bot.company.name, bot.id, channel_key);
        if (hasModal == false) toast.success("Success", "The action has been done");
        if (!result) return;
        return result;
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
            id: data.id,
            style: {
                marginTop: "15px"
            },
            label: data.default_value,
            onClick: loadButton,
            defaultChoice: data.value,
            setValue: (name, value)=>saveData(value)
        })
    });
}
var $e637ec1adbcee531$export$2e2bcd8739ae039 = $e637ec1adbcee531$var$DashboardButton;




var $bh6RR = parcelRequire("bh6RR");




function $819a0b4670f6594e$var$DashboardNumber({ data: data, postbackAction: postbackAction }) {
    data.value = parseInt(data.value);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const [error, setError] = (0, $bh6RR.useState)(false);
    const [typingTimer, setTypingTimer] = (0, $bh6RR.useState)(null);
    const inputRef = (0, $bh6RR.useRef)();
    const checkError = (val)=>{
        let bool = val.length == 0;
        setError(bool);
        return bool;
    };
    const modifyValue = (nb)=>{
        saveData(nb, checkError(nb));
    };
    const saveData = (text, err)=>{
        clearTimeout(typingTimer);
        setTypingTimer(setTimeout(()=>{
            if (err) {
                inputRef.current.value = data.value;
                setError(false);
                toast.success("Variable's value reinitialized", 'The value of the variable " ' + data.label + " \" has been reinitialized because the last one didn't match with the wished structure !", 5000);
            } else postbackAction(text);
        }, 1500));
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "dashboard_text_area",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                ref: inputRef,
                type: "number",
                onKeyDown: (e)=>(0, $eaf3b7858f46cf51$export$74ff82ccb88f9fb1)(e),
                style: {
                    border: error ? "2px solid red" : ""
                },
                defaultValue: data.value,
                className: "input_number_variable_dashboard",
                onChange: (e)=>modifyValue(e.target.value)
            }),
            error && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "error_message",
                children: "The value has to be a number"
            })
        ]
    }, data.id);
}
var $819a0b4670f6594e$export$2e2bcd8739ae039 = $819a0b4670f6594e$var$DashboardNumber;





function $009c8b2515fcdb52$var$DashboardVariable({ dashboard_channel: dashboard_channel, variable: variable, postbackAction: postbackAction, bot: bot, className: className, access: access, index: index }) {
    const [render, setRender] = (0, $bh6RR.useState)(false);
    const [type, setType] = (0, $bh6RR.useState)(0);
    const { editVariable: editVariable, updateDashboardVariableShared: updateDashboardVariableShared, deleteVariable: deleteVariable, updatePositionVariable: updatePositionVariable } = (0, $c67d47eff71309b3$export$2e2bcd8739ae039);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const [hasError, setHasError] = (0, $bh6RR.useState)(false);
    const [hoverVariable, setHoverVariable] = (0, $bh6RR.useState)(false);
    const analysisVariable = ()=>{
        switch(variable.type){
            case (0, $142ea350c70b4680$export$52463409c7783422).find((type)=>type.name == "Toggle").value:
                setRender(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $70402776f546d272$export$2e2bcd8739ae039), {
                    data: variable,
                    postbackAction: updateVariable
                }, "variable" + variable.id));
                setType({
                    id: 0,
                    styleVariableContainer: getStyleByType(0)
                });
                break;
            case (0, $142ea350c70b4680$export$52463409c7783422).find((type)=>type.name == "Input").value:
                setRender(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $41fcf33860e494d0$export$2e2bcd8739ae039), {
                    data: variable,
                    activeError: setHasError,
                    postbackAction: updateVariable
                }));
                setType({
                    id: 1,
                    styleVariableContainer: getStyleByType(1)
                });
                break;
            case (0, $142ea350c70b4680$export$52463409c7783422).find((type)=>type.name == "Dropdown").value:
                setRender(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4bb1746f67427ccd$export$2e2bcd8739ae039), {
                    data: variable,
                    postbackAction: updateVariable
                }));
                setType({
                    id: 2,
                    styleVariableContainer: getStyleByType(2)
                });
                break;
            case (0, $142ea350c70b4680$export$52463409c7783422).find((type)=>type.name == "Button").value:
                setRender(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e637ec1adbcee531$export$2e2bcd8739ae039), {
                    data: variable,
                    bot: bot,
                    postbackAction: updateVariable,
                    dashboardsChannelsLinks: dashboard_channel.dashboards_channels_links
                }));
                setType({
                    id: 3,
                    styleVariableContainer: getStyleByType(3)
                });
                break;
            case (0, $142ea350c70b4680$export$52463409c7783422).find((type)=>type.name == "Number").value:
                setRender(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $819a0b4670f6594e$export$2e2bcd8739ae039), {
                    data: variable,
                    bot: bot,
                    postbackAction: updateVariable
                }));
                setType({
                    id: 4,
                    styleVariableContainer: getStyleByType(4)
                });
                break;
            default:
                return "foo";
        }
    };
    const updateVariable = async (value)=>{
        let dataToSend = variable;
        dataToSend.value = value;
        dataToSend.dashboard_channel_id = dashboard_channel.id;
        dataToSend.block_id = variable.dashboard_block_id;
        dataToSend.is_updating_value = true;
        const [response, errors] = variable.origin == 0 ? await updateDashboardVariableShared(variable.id, dataToSend) : await editVariable(variable.id, dataToSend);
        if (errors != null) {
            console.log(errors);
            return;
        }
        //modal.resolve(response);
        toast.success("Variable's value changed", 'The value of the variable " ' + response.label + ' " has been changed !');
        postbackAction();
    //onClose();
    };
    const modifyPositionVariable = async (pos)=>{
        if (pos < 0 || pos >= index.max) return;
        let dataToSend = {
            "position": pos
        };
        const [response, errors] = await updatePositionVariable(variable.id, dataToSend);
        if (errors != null) {
            console.log(errors);
            return;
        }
        //modal.resolve(response);
        //toast.success('Variable\'s position changed', 'The position of the variable " ' + response.label + ' " has been changed !');
        postbackAction();
    };
    const showRemoveVariableModal = async ()=>{
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete Variable",
            body: 'Do you really want to delete the variable : " ' + variable.label + ' " ?',
            api: {
                request: deleteVariable,
                param: [
                    variable.id
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel"
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ],
            confirm: {
                name: variable.label,
                fieldName: "this variable"
            }
        });
        toast.success("Variable removed", 'The variable "' + variable.label + ' "has been removed ! ');
        postbackAction();
    };
    (0, $bh6RR.useEffect)(()=>{
        analysisVariable();
    }, [
        variable
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (variable.position == null) modifyPositionVariable(index.current);
    }, []);
    const showEditVariableModal = ()=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $f30b2360e51cf167$export$2e2bcd8739ae039), {
            block_id: variable.dashboard_block_id,
            postbackAction: postbackAction,
            bot: bot,
            variable: variable,
            dashboardChannel: dashboard_channel
        });
    const getStyleByType = (id)=>{
        let res = null;
        if (id != 1) res = {
            paddingTop: "10px",
            paddingBottom: "10px",
            minHeight: "60px"
        };
        if (id == 2) res = {
            paddingTop: "15px",
            paddingBottom: "15px",
            alignItems: "normal",
            minHeight: "60px"
        };
        return res;
    };
    //console.log(variable);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: variable.bot_variable_id == null && variable.type != 3 ? "error_bot_variable_doesnt_exist" : "",
            onMouseEnter: ()=>setHoverVariable(true),
            onMouseLeave: ()=>setHoverVariable(false),
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "dashboard_variable_container " + (className ? className : ""),
                    style: type.styleVariableContainer,
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "position_variable_dashboard " + (variable.position == index.max - 1 || variable.position == 0 ? "position_arrow_dropdown" : ""),
                            children: hoverVariable == true && (0, $da2068bd2c317854$export$fc970ed23da99565)(access) && variable.origin != 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                children: [
                                    variable.position != 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                        className: "fas fa-chevron-up",
                                        style: {
                                            marginBottom: variable.position != index.max - 1 ? "15px" : ""
                                        },
                                        "aria-hidden": "true",
                                        onClick: ()=>modifyPositionVariable(variable.position - 1)
                                    }),
                                    variable.position != index.max - 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                        className: "fas fa-chevron-down",
                                        "aria-hidden": "true",
                                        onClick: ()=>modifyPositionVariable(variable.position + 1)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "dashboard_variable_title",
                            children: [
                                variable.conditions.length > 0 && (0, $da2068bd2c317854$export$fc970ed23da99565)(access) && variable.printedInView == true && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                    className: "fas fa-eye",
                                    style: {
                                        color: "var(--main)",
                                        marginRight: "15px"
                                    }
                                }),
                                variable.conditions.length > 0 && (0, $da2068bd2c317854$export$fc970ed23da99565)(access) && variable.printedInView == false && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                    className: "fas fa-eye-slash",
                                    style: {
                                        color: "var(--main)",
                                        marginRight: "15px"
                                    }
                                }),
                                variable.label,
                                variable.information != null && variable.information.replace(/\s/g, "").length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $666be866da7290c5$export$2e2bcd8739ae039), {
                                        classNameContainer: "right",
                                        text: variable.information
                                    })
                                }),
                                type.id == 1 && hasError == true && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "error_message"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "dashboard_variable_content",
                            style: {
                                marginTop: variable.type == 2 ? "15px" : ""
                            },
                            children: [
                                " ",
                                render
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "dashboard_buttonActions_container",
                                    style: {
                                        marginTop: variable.type == 2 ? "15px" : ""
                                    },
                                    children: !(0, $da2068bd2c317854$export$7383f122bf48ec30)(access) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                className: "fas fa-edit dashboard_editAction dashboard_buttonAction",
                                                "aria-hidden": "true",
                                                onClick: ()=>showEditVariableModal()
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                className: "fas fa-trash dashboard_deleteAction dashboard_buttonAction",
                                                "aria-hidden": "true",
                                                onClick: ()=>showRemoveVariableModal()
                                            })
                                        ]
                                    })
                                }),
                                type.id == 1 && hasError == true && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "error_message"
                                })
                            ]
                        })
                    ]
                }),
                variable.bot_variable_id == null && variable.type != 3 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "error_message error_message_bot_variable_doesnt_exist",
                        children: [
                            (0, $da2068bd2c317854$export$fc970ed23da99565)(access) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                children: [
                                    " This variable doesn't exist anymore in the bot ",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                        style: {
                                            fontWeight: "bold"
                                        },
                                        children: [
                                            " ",
                                            bot.name
                                        ]
                                    }),
                                    ", please remove this row from the dashboard or restore the variable"
                                ]
                            }),
                            (0, $da2068bd2c317854$export$7383f122bf48ec30)(access) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
                                children: " This variable doesn't exist anymore, contact your administrator to remove this case of restore the variable if it's a mistake."
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var $009c8b2515fcdb52$export$2e2bcd8739ae039 = $009c8b2515fcdb52$var$DashboardVariable;








var $bh6RR = parcelRequire("bh6RR");













parcelRequire("bh6RR");










const $95d5d9beea471d90$var$DashboardFormBlockSlideVariable = ({ grid: grid, setValue: setValue, stateFormGrid: stateFormGrid, watch: watch, register: register })=>{
    const { dropdownDefaultValue: dropdownDefaultValue, modifyDropdownValues: modifyDropdownValues } = (0, $688661aa3b2284ac$export$2e2bcd8739ae039)(grid?.placeholder_format);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "dropdown_grid_slide_container title_container dropdown_dashboard_form_block_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: "Type variable",
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "special_container_dashboard_grid_form",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                            ...register("type_variable", {
                                valueAsNumber: true
                            }),
                            setValue: (name, value)=>setValue("type_variable", value),
                            choices: (0, $142ea350c70b4680$export$558122ad37458598),
                            width: "240px",
                            defaultChoice: grid?.type_variable
                        })
                    })
                ]
            }),
            watch("type_variable") == 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "checkbox_dashboard_variable_container title_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: "Default value",
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "special_container_dashboard_grid_form",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $24b9ab73e3f4b23c$export$2e2bcd8739ae039), {
                            ...register("empty"),
                            name: "default_value_checkbox",
                            onChange: (val)=>setValue("default_value_checkbox", val.target.checked),
                            checked: grid?.type_variable == 0 ? parseInt(grid.default_value) : false
                        })
                    })
                ]
            }),
            watch("type_variable") == 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "title_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: "Default value",
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                        ...register("default_value", {
                            required: true,
                            minLength: 1,
                            maxLength: 200
                        }),
                        defaultValue: stateFormGrid == 0 && grid?.default_value == "" ? "Valeur" : grid?.default_value,
                        placeholder: "Enter the default value",
                        className: "input_variable_dashboard_form"
                    })
                ]
            }),
            watch("type_variable") == 2 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "form_block_type_dropdown_container",
                style: {
                    marginTop: "40px"
                },
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        style: {
                            display: "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Variables in the dropdown",
                                listLabelClassName: "field-modal"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $666be866da7290c5$export$2e2bcd8739ae039), {
                                classNameContainer: "top",
                                classNameBoxText: "tooltip_upper",
                                text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                    children: [
                                        "You have to put values like : ",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                        " Orange|Banana|Tomato separate with pipes |"
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                        ...register("value_dropdown"),
                        onChange: (e)=>{
                            modifyDropdownValues(e.target.value), setValue("value_dropdown", e.target.value);
                        },
                        onKeyUp: (e)=>modifyDropdownValues(e.target.value),
                        placeholder: "Example : Orange|Banana|Tomato",
                        className: "input_variable_dashboard_form",
                        defaultValue: grid?.type_variable == 2 ? grid.placeholder_format : ""
                    })
                ]
            }),
            watch("type_variable") == 2 && dropdownDefaultValue.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "dropdown_grid_slide_container title_container dropdown_dashboard_form_block_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: "Default value",
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "special_container_dashboard_grid_form",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                            ...register("default_value_dropdown", {
                                valueAsNumber: true
                            }),
                            choices: dropdownDefaultValue,
                            defaultChoice: grid?.type_variable == 2 ? grid.default_value : "",
                            width: "240px",
                            setValue: setValue
                        }, Date.now())
                    })
                ]
            }),
            watch("type_variable") == 4 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "title_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: "Default value",
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                            type: "number",
                            ...register("default_value_number", {
                                required: true,
                                minLength: 1
                            }),
                            onKeyDown: (e)=>(0, $eaf3b7858f46cf51$export$74ff82ccb88f9fb1)(e),
                            defaultValue: grid?.type_variable == 4 ? parseInt(grid.default_value) : "",
                            placeholder: "Enter the default value number",
                            className: "input_variable_dashboard_form"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "title_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            children: [
                                " Regex ",
                                watch("type_variable") == 1 ? "" : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "blockForm_disabled_field_message",
                                    children: "Disabled"
                                })
                            ]
                        }),
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0db11626bd290ec1$export$2e2bcd8739ae039), {
                        ...register("regex"),
                        placeholder: "Enter the complementary informations  of the variable",
                        disabled: watch("type_variable") == 1 ? false : true,
                        className: "input full-width resize-area text_area_dashboard_form_variable " + (watch("type_variable") == 1 ? "" : "text_area_disabled"),
                        defaultValue: grid?.type_variable == 1 ? grid.regex : ""
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "title_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            children: [
                                " Error message indication ",
                                watch("type_variable") == 1 ? "" : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "disabled_field_message",
                                    children: "Disabled"
                                })
                            ]
                        }),
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                        ...register("placeholder_format"),
                        placeholder: "Example : Don't insert special character",
                        className: "input_variable_dashboard_form " + (watch("type_variable") == 1 ? "" : "text_area_disabled"),
                        disabled: watch("type_variable") == 1 ? false : true,
                        defaultValue: grid?.type_variable == 1 ? grid.placeholder_format : ""
                    })
                ]
            })
        ]
    });
};
var $95d5d9beea471d90$export$2e2bcd8739ae039 = $95d5d9beea471d90$var$DashboardFormBlockSlideVariable;



parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");















function $cedb606d7803982f$var$DashboardCell({ data: data, className: className, parents: parents, postbackAction: postbackAction, disabled: disabled, gridValues: gridValues, modifyErrorInput: modifyErrorInput, access: access }) {
    const modifyValue = (val)=>{
        postbackAction(data.index, val);
    };
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const { updateCellValueGrid: updateCellValueGrid } = (0, $c67d47eff71309b3$export$2e2bcd8739ae039);
    const [activeMode, setActiveMode] = (0, $bh6RR.useState)(data.cell?.active);
    const [errorInput, setErrorInput] = (0, $bh6RR.useState)(false);
    const [hover, setHover] = (0, $bh6RR.useState)(false);
    const { dropdownDefaultValue: dropdownDefaultValue } = (0, $688661aa3b2284ac$export$2e2bcd8739ae039)(gridValues?.placeholder_format);
    var type = gridValues?.type_variable;
    var defaultValue = gridValues?.default_value;
    const ref = (0, $bh6RR.useRef)(null);
    const refInputCell = (0, $bh6RR.useRef)(null);
    (0, $bh6RR.useEffect)(()=>{
        if (ref.current != null) ref.current.value = data.value;
        if (refInputCell.current != null && switchTimer == null) refInputCell.current.value = data.cell.value;
    }, [
        data
    ]);
    const checkErrorInput = (val)=>{
        var regex = new RegExp(gridValues.regex);
        let matched = regex.test(val);
        if (val == "") matched = false;
        setErrorInput(!matched);
        modifyErrorInput(parents, matched);
        return !matched;
    };
    const checkInput = (text)=>{
        if (text != "" && (gridValues.regex == null || gridValues.regex.replace(/\s/g, "").length == 0)) {
            setErrorInput(false);
            saveData(text);
            return;
        }
        saveData(text, checkErrorInput(text));
    };
    const checkNumberCell = (nb)=>{
        saveData(nb, nb.length == 0);
    };
    const [switchTimer, setSwitchTimer] = (0, $bh6RR.useState)(null);
    const saveData = (value, err)=>{
        clearTimeout(switchTimer);
        setSwitchTimer(setTimeout(()=>{
            if (err) {
                refInputCell.current.value = data.cell.value;
                setErrorInput(false);
                modifyErrorInput(parents, true);
            } else modifyValue(value);
        }, 1500));
    };
    const modifyActiveMode = (checked)=>{
        setActiveMode(checked);
        if (checked == false && type == 1) refInputCell.current.value = defaultValue;
        clearTimeout(switchTimer);
        setSwitchTimer(setTimeout(async ()=>{
            let dataToSend = {
                index: data.index,
                block_id: gridValues.block_id,
                active: checked,
                value: checked == false ? "NONE" : defaultValue
            };
            console.log(type);
            const [response, errors] = await updateCellValueGrid(data.index, dataToSend);
            if (errors != null) {
                console.log(errors);
                return;
            }
            toast.success("Variable's active mode changed", "The cell is now " + (checked ? "enabled" : "disabled"));
        }, 1500));
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            type == null && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                ref: ref,
                className: "dashboard_cell_main_container " + (className ? className : ""),
                placeholder: "Value...",
                defaultValue: data.value,
                onChange: (e)=>modifyValue(e.target.value),
                disabled: disabled ? disabled : false
            }),
            type == 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "containerToggleCell dashboard_cell_Editor " + (activeMode == false ? "desactivateCell" : "dashboard_cell_hover"),
                    onMouseEnter: (e)=>setHover(true),
                    onMouseLeave: (e)=>setHover(false),
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $70402776f546d272$export$2e2bcd8739ae039), {
                            data: {
                                label: data.index,
                                value: data.cell.value,
                                checked: defaultValue
                            },
                            className: activeMode == false ? "desactiveToggle" : "",
                            postbackAction: modifyValue
                        }),
                        hover == true && access != (0, $da2068bd2c317854$export$3026e5a52c747d2c).Client && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            style: {
                                display: "flex",
                                width: activeMode == false ? "" : "0px"
                            },
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                className: activeMode == false ? "containerDesactiveMode" : "containerActiveModeToggle",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $52b728934d836302$export$2e2bcd8739ae039), {
                                    id: data.index,
                                    setValue: (name, checked)=>{
                                        modifyActiveMode(checked);
                                    },
                                    check: activeMode
                                })
                            })
                        })
                    ]
                })
            }),
            type == 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "containerInputCell dashboard_cell_Editor " + (activeMode == false ? "desactivateCell" : "dashboard_cell_hover"),
                    onMouseEnter: (e)=>setHover(true),
                    onMouseLeave: (e)=>setHover(false),
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                            ref: refInputCell,
                            style: {
                                borderColor: errorInput ? "var(--pink)" : "",
                                width: hover == true && access != (0, $da2068bd2c317854$export$3026e5a52c747d2c).Client ? "110px" : "",
                                display: activeMode == false ? "none" : "block"
                            },
                            placeholder: "Value...",
                            defaultValue: data.cell.value,
                            disabled: !activeMode,
                            onChange: (e)=>checkInput(e.target.value)
                        }),
                        hover == true && access != (0, $da2068bd2c317854$export$3026e5a52c747d2c).Client && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            style: {
                                display: "flex",
                                width: activeMode == false ? "" : "0px"
                            },
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                className: activeMode == false ? "containerDesactiveMode" : "containerActiveModeInput",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $52b728934d836302$export$2e2bcd8739ae039), {
                                    id: data.index,
                                    setValue: (name, checked)=>modifyActiveMode(checked),
                                    check: activeMode
                                })
                            })
                        })
                    ]
                })
            }),
            type == 2 && dropdownDefaultValue != [] && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "containerDropdownCell dashboard_cell_Editor " + (activeMode == false ? "desactivateCell" : "dashboard_cell_hover"),
                onMouseEnter: (e)=>setHover(true),
                onMouseLeave: (e)=>setHover(false),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "dashboard_dropdowns_variable",
                        style: {
                            pointerEvents: activeMode == false ? "none" : "all",
                            display: activeMode == false ? "none" : "block"
                        },
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                            choices: dropdownDefaultValue,
                            width: hover == true && access != (0, $da2068bd2c317854$export$3026e5a52c747d2c).Client ? "130px" : "170px",
                            defaultChoice: data ? data.cell.value : defaultValue,
                            setValue: (name, value)=>saveData(value)
                        })
                    }),
                    hover == true && access != (0, $da2068bd2c317854$export$3026e5a52c747d2c).Client && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        style: {
                            display: "flex"
                        },
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            className: activeMode == false ? "containerDesactiveMode" : "containerActiveModeDropdown",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $52b728934d836302$export$2e2bcd8739ae039), {
                                id: data.index,
                                setValue: (name, checked)=>modifyActiveMode(checked),
                                check: activeMode
                            })
                        })
                    })
                ]
            }),
            type == 4 && // onChange={(e) => checkNumberCell(e.target.value)}
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "containerInputCell dashboard_cell_Editor " + (activeMode == false ? "desactivateCell" : "dashboard_cell_hover"),
                    onMouseEnter: (e)=>setHover(true),
                    onMouseLeave: (e)=>setHover(false),
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                            type: "number",
                            ref: refInputCell,
                            style: {
                                borderColor: errorInput ? "var(--pink)" : "",
                                width: hover == true && access != (0, $da2068bd2c317854$export$3026e5a52c747d2c).Client ? "110px" : "",
                                display: activeMode == false ? "none" : "block"
                            },
                            className: "full-width input-space cell_number",
                            placeholder: "Value...",
                            defaultValue: data.cell.value,
                            disabled: !activeMode,
                            onKeyDown: (e)=>(0, $eaf3b7858f46cf51$export$74ff82ccb88f9fb1)(e),
                            onChange: (e)=>checkNumberCell(e.target.value)
                        }),
                        hover == true && access != (0, $da2068bd2c317854$export$3026e5a52c747d2c).Client && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                            style: {
                                display: "flex",
                                width: activeMode == false ? "" : "0px"
                            },
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                className: activeMode == false ? "containerDesactiveMode" : "containerActiveModeInput",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $52b728934d836302$export$2e2bcd8739ae039), {
                                    id: data.index,
                                    setValue: (name, checked)=>modifyActiveMode(checked),
                                    check: activeMode
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $cedb606d7803982f$export$2e2bcd8739ae039 = $cedb606d7803982f$var$DashboardCell;


function $a1329a9929c06200$var$DashboardFormGrid({ _cells: _cells, data: data, setGrid: setGrid }) {
    const [cells, setCells] = (0, $bh6RR.useState)(_cells?.rows?.length > 0 || _cells?.columns?.length > 0 ? _cells : {
        rows: [],
        columns: [],
        cells: []
    });
    const addColumn = ()=>{
        let newColumn = {
            index: Date.now(),
            value: ""
        };
        let newCells = cells.cells;
        for(let i = 0; i < cells.rows.length; i++){
            let newCell = {
                value: null,
                active: null
            };
            let index = cells.columns.length * (i + 1) + i;
            newCells.splice(index, 0, newCell);
        }
        setCells({
            rows: cells.rows,
            columns: [
                ...cells.columns,
                newColumn
            ],
            cells: newCells
        }) //cells.cells });
        ;
    };
    const addRow = ()=>{
        let newRow = {
            index: Date.now(),
            value: ""
        };
        let newCells = cells.cells;
        for(let i = 0; i < cells.columns.length; i++){
            let newCell = {
                value: null,
                active: null
            };
            newCells.push(newCell);
        }
        console.log(newCells);
        console.log("-----");
        setCells({
            rows: [
                ...cells.rows,
                newRow
            ],
            columns: cells.columns,
            cells: newCells
        });
    };
    const removeRow = (_index, _i)=>{
        let newArrayCells = cells.cells;
        let index = _i * cells.columns.length;
        for(let i = 0; i < cells.columns.length; i++)newArrayCells.splice(index, 1);
        console.log(newArrayCells);
        setCells({
            rows: [
                ...cells.rows.filter((row)=>row.index != _index)
            ],
            columns: cells.columns,
            cells: newArrayCells
        });
    };
    const removeColumn = (_index, j)=>{
        console.log(cells.cells);
        let newArrayCells = cells.cells;
        let arrayIndexRemoved = [];
        for(let i = 0; i < cells.cells.length; i++){
            if (i % cells.columns.length != j) continue;
            arrayIndexRemoved.push(i);
        }
        for(let i = arrayIndexRemoved.length - 1; i >= 0; i--)newArrayCells.splice(arrayIndexRemoved[i], 1);
        setCells({
            rows: cells.rows,
            columns: [
                ...cells.columns.filter((column)=>column.index != _index)
            ],
            cells: newArrayCells
        });
    };
    const modifyValue = (index, value)=>{
        let rows = cells.rows;
        let columns = cells.columns;
        for(let i = 0; i < rows.length; i++)if (rows[i].index == index) rows[i].value = value;
        for(let i = 0; i < columns.length; i++)if (columns[i].index == index) columns[i].value = value;
        setCells({
            rows: rows,
            columns: columns,
            cells: cells.cells
        });
    };
    (0, $bh6RR.useEffect)(()=>{
        setGrid(cells);
    }, [
        cells
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "gridDashboard_main_container",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "dashboard_grid_column",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "root_cell " + (cells.length > 0 ? "" : "single_root")
                    }),
                    cells.columns.map((cell, i)=>{
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "dashboard_column_remove",
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                            className: "fas fa-trash dashboard_remove_cell",
                                            "aria-hidden": "true",
                                            onClick: ()=>removeColumn(cell.index, i)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cedb606d7803982f$export$2e2bcd8739ae039), {
                                    data: cell,
                                    className: "dashboard_column_cell",
                                    postbackAction: (index, value)=>modifyValue(index, value)
                                })
                            ]
                        });
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "dashboard_column_add",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                            className: "fas fa-plus dashboard_add_cell",
                            "aria-hidden": "true",
                            onClick: ()=>addColumn()
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "rows",
                children: [
                    cells.rows.map((cell, i)=>{
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            style: {
                                display: "flex"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "dashboard_row_remove",
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                            className: "fas fa-trash dashboard_remove_cell",
                                            "aria-hidden": "true",
                                            onClick: ()=>removeRow(cell.index, i)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cedb606d7803982f$export$2e2bcd8739ae039), {
                                    data: cell,
                                    className: "dashboard_row_cell",
                                    postbackAction: (index, value)=>modifyValue(index, value)
                                }),
                                cells.columns.map((cell, i)=>{
                                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "cell_border_grid",
                                        children: " "
                                    });
                                })
                            ]
                        });
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "dashboard_row_add",
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                className: "fas fa-plus dashboard_add_cell",
                                "aria-hidden": "true",
                                onClick: ()=>addRow()
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $a1329a9929c06200$export$2e2bcd8739ae039 = $a1329a9929c06200$var$DashboardFormGrid;



const $ff1590cfbfed39d3$export$d3280c7aa419b185 = [
    {
        name: "Simple",
        value: 0
    },
    {
        name: "Array",
        value: 1
    }
];
const $ff1590cfbfed39d3$export$48a580a8b4cc88de = [
    {
        value: 0,
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    class: "fas fa-square",
                    style: {
                        color: "var(--main)",
                        paddingRight: "25px"
                    }
                }),
                "  Simple "
            ]
        })
    },
    {
        value: 1,
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    class: "fas fa-th",
                    style: {
                        color: "var(--main)",
                        paddingRight: "25px"
                    }
                }),
                " Grid "
            ]
        })
    }
];


const $d54dd21f921acdf3$var$DashboardFormBlockMainSlide = ({ type: type, grid: grid, setValue: setValue, watch: watch, register: register, block: block })=>{
    var structure = type == "update" && block.type == 1 ? JSON.parse(grid.structure) : [];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: watch("type") == 1 ? "title_container_grid" : "title_container",
                style: {
                    marginTop: watch("type") == 1 ? "43px !important" : ""
                },
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: "Title",
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                        ...register("name", {
                            required: true,
                            minLength: 3
                        }),
                        placeholder: "Enter your block's title",
                        className: "input_dashboard_block_form"
                    })
                ]
            }),
            type == "create" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "dropdown_grid_slide_container title_container dropdown_dashboard_form_block_container",
                style: {
                    gap: watch("type") == 0 ? "44%" : "10%",
                    marginLeft: watch("type") == 0 ? "0px" : ""
                },
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                        label: "Type",
                        listLabelClassName: "field-modal"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                            ...register("type", {
                                valueAsNumber: true
                            }),
                            setValue: setValue,
                            choices: (0, $ff1590cfbfed39d3$export$48a580a8b4cc88de),
                            width: "165px",
                            defaultChoice: block?.type
                        })
                    })
                ]
            }),
            watch("type") == 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {})
                ]
            }),
            watch("type") == 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "dashboard_grid_container title_container",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                label: "Grid configuration",
                                listLabelClassName: "field-modal"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a1329a9929c06200$export$2e2bcd8739ae039), {
                                _cells: structure,
                                setGrid: (cells)=>setValue("structure", cells),
                                data: block?.grid
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $d54dd21f921acdf3$export$2e2bcd8739ae039 = $d54dd21f921acdf3$var$DashboardFormBlockMainSlide;








function $32e6802d8dc57080$var$ButtonsSubmitFormBlockModal({ typeForm: typeForm, formState: formState, stateFormGrid: stateFormGrid, setStateFormGrid: setStateFormGrid, watch: watch, clearErrors: clearErrors, onSubmit: onSubmit, onClose: onClose }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            watch("type") == 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        className: "cancel",
                        label: "Cancel",
                        type: "button",
                        onClick: ()=>onClose(),
                        style: {
                            marginRight: "20px"
                        }
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        className: "validate",
                        label: (0, $b19cef4654724e98$export$e5f1fc2c2eb7b5da)[typeForm].send,
                        type: "submit",
                        disabled: !formState.isValid
                    })
                ]
            }),
            watch("type") == 1 && stateFormGrid == 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        className: "cancel",
                        label: "Cancel",
                        type: "button",
                        onClick: ()=>onClose(),
                        style: {
                            marginRight: "20px"
                        }
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        className: "validate",
                        label: "Next",
                        disabled: !(watch("name").length > 3),
                        onClick: ()=>{
                            (0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("grid_slide_structure"), setStateFormGrid(1);
                        }
                    })
                ]
            }),
            watch("type") == 1 && stateFormGrid == 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        className: "validate",
                        label: "Previous",
                        type: "button",
                        onClick: ()=>{
                            (0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("obligatory"), setStateFormGrid(0), clearErrors();
                        },
                        style: {
                            marginRight: "20px"
                        }
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        className: "validate",
                        label: "Next",
                        type: "button",
                        onClick: ()=>{
                            (0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("grid_slide_variables"), setStateFormGrid(2);
                        },
                        disabled: !(watch("type_variable") == 2 && watch("value_dropdown")?.length > 0 || watch("type_variable") == 1 && watch("default_value")?.length > 0 || watch("type_variable") == 0 || watch("type_variable") == 4 && watch("default_value_number")?.length > 0)
                    })
                ]
            }),
            watch("type") == 1 && stateFormGrid == 2 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        className: "validate",
                        label: "Previous",
                        type: "button",
                        onClick: ()=>{
                            (0, $f125b7375f0f7cdc$export$2e2bcd8739ae039)("grid_slide_structure"), setStateFormGrid(1), clearErrors();
                        },
                        style: {
                            marginRight: "20px"
                        }
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        className: "validate",
                        label: (0, $b19cef4654724e98$export$e5f1fc2c2eb7b5da)[typeForm].send,
                        onClick: ()=>onSubmit(),
                        disabled: watch("bot_variable_id") == -1
                    })
                ]
            })
        ]
    });
}
var $32e6802d8dc57080$export$2e2bcd8739ae039 = $32e6802d8dc57080$var$ButtonsSubmitFormBlockModal;



const { addBlock: $d18c05d1708e7238$var$addBlock, addBlockGrid: $d18c05d1708e7238$var$addBlockGrid, editBlock: $d18c05d1708e7238$var$editBlock, editBlockGrid: $d18c05d1708e7238$var$editBlockGrid, editBlockV1: $d18c05d1708e7238$var$editBlockV1 } = (0, $c67d47eff71309b3$export$2e2bcd8739ae039);
async function $d18c05d1708e7238$export$6aad031f8cca4dc7(dataToSend) {
    let res = dataToSend.type == 0 ? await $d18c05d1708e7238$var$addDashboardSimpleBlock(dataToSend) : await $d18c05d1708e7238$var$addDashboardGridBlock(dataToSend);
    return {
        "response": res,
        "titlePopup": "Block added",
        "bodyPopup": "The block " + res.name + " has been added ! "
    };
}
async function $d18c05d1708e7238$var$addDashboardSimpleBlock(dataToSend) {
    //delete dataToSend.empty;
    delete dataToSend.type_variable;
    const [response, errors] = await $d18c05d1708e7238$var$addBlock(dataToSend);
    if (errors != null) {
        console.log(errors);
        return;
    }
    return response;
}
async function $d18c05d1708e7238$var$addDashboardGridBlock(dataToSend) {
    dataToSend = $d18c05d1708e7238$var$getVariableTypeModification(dataToSend);
    const [response, errors] = await $d18c05d1708e7238$var$addBlockGrid(dataToSend);
    if (errors != null) {
        console.log(errors);
        return;
    }
    return response;
}
async function $d18c05d1708e7238$export$3b93271a6234533c(dataToSend, block) {
    let res = dataToSend.type == 0 ? await $d18c05d1708e7238$var$updateSimpleBlock(dataToSend, block.id) : await $d18c05d1708e7238$var$updateGridBlock(dataToSend, block);
    return {
        "response": res,
        "titlePopup": "Block edited",
        "bodyPopup": "The block " + res.name + " has been edited ! "
    };
}
async function $d18c05d1708e7238$var$updateSimpleBlock(dataToSend, block_id) {
    delete dataToSend.type_variable;
    const [response, errors] = await $d18c05d1708e7238$var$editBlock(block_id, dataToSend);
    if (errors != null) {
        console.log(errors);
        return;
    }
    return response;
}
async function $d18c05d1708e7238$var$updateGridBlock(dataToSend, block) {
    dataToSend = $d18c05d1708e7238$var$getVariableTypeModification(dataToSend, block.grid);
    const [response, errors] = await $d18c05d1708e7238$var$editBlockGrid(block.id, dataToSend);
    if (errors != null) {
        console.log(errors);
        return;
    }
    return response;
}
function $d18c05d1708e7238$var$getVariableTypeModification(dataToSend, grid = null) {
    if (dataToSend.type_variable != 1 && dataToSend.type_variable != 2 && dataToSend.placeholder_format == null) dataToSend.placeholder_format = "";
    if (dataToSend.type_variable == 0) {
        dataToSend.placeholder_format = grid?.placeholder_format; // null ou l'ancien
        dataToSend.default_value = dataToSend.default_value_checkbox == undefined ? grid && grid.type_variable == 0 ? grid.default_value : false : dataToSend.default_value_checkbox;
    }
    if (dataToSend.type_variable == 1) {
        if (dataToSend.placeholder_format == null) dataToSend.placeholder_format = grid?.placeholder_format;
        if (dataToSend.regex == null) dataToSend.regex = grid?.regex;
    }
    if (dataToSend.type_variable == 2) {
        dataToSend.default_value = dataToSend.default_value_dropdown;
        dataToSend.placeholder_format = dataToSend.value_dropdown;
    }
    if (dataToSend.type_variable == 4) dataToSend.default_value = dataToSend.default_value_number;
    if (grid == null) dataToSend.structure.cells = new Array(dataToSend.structure.rows.length * dataToSend.structure.columns.length).fill({
        value: dataToSend.default_value,
        active: true
    });
    return dataToSend;
}


const $b54969fa69ce7e4e$var$DashboardFormBlockModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ block: block, setBlock: setBlock, dashboardChannel: dashboardChannel, bot: bot })=>{
    var dashboard_id = dashboardChannel.dashboard.id;
    var type = block ? "update" : "create";
    var grid = type == "update" && block.type == 1 ? block.grid : null;
    const formData = (0, $b19cef4654724e98$export$e5f1fc2c2eb7b5da)[type];
    const { variablesBot: variablesBot } = (0, $11cef0d734338ff6$export$2e2bcd8739ae039)(dashboardChannel.id, bot.id, grid != null ? [
        block.variables[0].bot_variable_id
    ] : [], {
        value: -1,
        text: "Nothing"
    });
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const [stateFormGrid, setStateFormGrid] = (0, $bh6RR.useState)(0);
    const { addBlock: addBlock, editBlock: editBlock } = (0, $c67d47eff71309b3$export$2e2bcd8739ae039);
    const { register: register, handleSubmit: handleSubmit, getValues: getValues, setValue: setValue, watch: watch, clearErrors: clearErrors, formState: { errors: errors }, formState: formState, setError: setError } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            "name": block ? block.name : "",
            "type": block ? block.type : 0
        }
    });
    const onSubmit = async ()=>{
        /*
                let dataToSend = getValues();
        
                
                //delete dataToSend.empty;
                dataToSend.dashboard_id = dashboard_id;
                if (block != null) { // edit mode
                    dataToSend.block_id = block.id;
                    if (grid != null) {
                        dataToSend.grid_id = grid.id;
                    }
                }
                if (dataToSend.type == 0){
                    delete dataToSend.type_variable;
                }
                if (dataToSend.type == 1) {
                    if (dataToSend.type_variable == 0) {
                        dataToSend.default_value = dataToSend.default_value_checkbox == undefined ? (block != null && grid.type_variable == 0 ? grid.default_value : false) : dataToSend.default_value_checkbox;
                    }
                    if (dataToSend.type_variable == 2) {
                        dataToSend.default_value = dataToSend.default_value_dropdown;
                        dataToSend.placeholder_format = dataToSend.value_dropdown;
                    }
                    if (block == null) { // if block is empty, fill the array of cells
                        dataToSend.structure.cells = new Array(dataToSend.structure.rows.length * dataToSend.structure.columns.length).fill({ value: dataToSend.default_value, active: true })
                    }
                    /*
                    delete dataToSend.empty;
                    delete dataToSend.value_dropdown;
                    delete dataToSend.default_value_checkbox;
                    delete dataToSend.default_value_dropdown;
                        }
                    */ /*
        const [response, errors] = block != null ? await editBlock(dataToSend) : await addBlock(dataToSend)
        if (errors != null) {
            console.log(errors)
            return;
        }
        */ let dataToSend = getValues();
        dataToSend.dashboard_id = dashboard_id;
        let res = null;
        dataToSend.name = dataToSend.name.trim();
        if (block == null) res = await (0, $d18c05d1708e7238$export$6aad031f8cca4dc7)(dataToSend);
        else res = await (0, $d18c05d1708e7238$export$3b93271a6234533c)(dataToSend, block);
        modal.resolve(res.response);
        toast.success(res.titlePopup, res.bodyPopup);
        //toast.success('Block ' + (block ? " edited" : " added"), 'The block ' + response.name + " has been " + (block ? "edited !" : "added ! "));
        setBlock(res);
        onClose();
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        name: watch("type") == 1 ? "form_block_grid" : "form_block",
        id: modal.id,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "leave-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
                className: "container_dashboard_form_block " + (watch("type") == 1 ? "dashboard_form_block_grid_mode" : ""),
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                        children: formData.title
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                        className: watch("type") == 1 ? "dashboard_form_block_grid_form_center" : "dashboard_simple_block_slide",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $51a8b46ec4198ef9$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                                    name: "obligatory",
                                    className: "dashboard_form_block_slide",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d54dd21f921acdf3$export$2e2bcd8739ae039), {
                                        type: type,
                                        grid: grid,
                                        setValue: setValue,
                                        watch: watch,
                                        register: register,
                                        block: block
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                                    name: "grid_slide_structure",
                                    className: watch("type") == 1 ? "dashboard_form_block_slide dashboard_slide_grid" : "",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $95d5d9beea471d90$export$2e2bcd8739ae039), {
                                        grid: grid,
                                        setValue: setValue,
                                        stateFormGrid: stateFormGrid,
                                        watch: watch,
                                        register: register
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $347e978f9327938b$export$2e2bcd8739ae039), {
                                    name: "grid_slide_variables",
                                    className: "dashboard_form_block_slide grid_slide_variable_space",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        children: Array.isArray(variablesBot) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "dropdown_grid_slide_container row_by_columnRow_container",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                    label: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                                        children: [
                                                            "Bot Variable",
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                                style: {
                                                                    color: "var(--pink)"
                                                                },
                                                                children: " * "
                                                            })
                                                        ]
                                                    }),
                                                    listLabelClassName: "field-modal"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    className: "special_container_dashboard_grid_form",
                                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                                        ...register("bot_variable_id", {
                                                            valueAsNumber: true
                                                        }),
                                                        setValue: setValue,
                                                        choices: variablesBot,
                                                        width: "240px",
                                                        defaultChoice: grid != null ? block.variables[0].bot_variable_id : -1
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $32e6802d8dc57080$export$2e2bcd8739ae039), {
                            onClose: onClose,
                            typeForm: type,
                            onSubmit: onSubmit,
                            formState: formState,
                            stateFormGrid: stateFormGrid,
                            setStateFormGrid: setStateFormGrid,
                            ScrollIntoSlide: (0, $f125b7375f0f7cdc$export$2e2bcd8739ae039),
                            watch: watch,
                            clearErrors: clearErrors
                        })
                    })
                ]
            })
        ]
    });
});
var $b54969fa69ce7e4e$export$2e2bcd8739ae039 = $b54969fa69ce7e4e$var$DashboardFormBlockModal;





var $bh6RR = parcelRequire("bh6RR");





function $d65d21c308e7beff$var$DashboardEditorGrid({ data: data, structure: structure, postbackAction: postbackAction, access: access }) {
    const ref = (0, $bh6RR.useRef)();
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const { updateCellValueGrid: updateCellValueGrid, updateDashboardVariableShared: updateDashboardVariableShared } = (0, $c67d47eff71309b3$export$2e2bcd8739ae039);
    const [errorMessage, setErrorMessage] = (0, $bh6RR.useState)([]);
    /**
     * Modify the error for the input cells in grid
     **/ const setErrorInput = (parents, clear)=>{
        if (clear == false) {
            if (errorMessage.filter((error)=>error.parents.column == parents.column && error.parents.row.index == parents.row.index).length == 0) setErrorMessage([
                ...errorMessage,
                {
                    parents: parents
                }
            ]);
        } else {
            let res = [];
            errorMessage.map((error)=>error.parents.column == parents.column && error.parents.row.index == parents.row.index || res.push(error));
            setErrorMessage(res);
        }
    };
    /**
     * Modify the value of the cell in the grid, not the structure
     */ const modifyValue = async (index, value, active)=>{
        let dataToSend = {
            index: index,
            value: value,
            block_id: data.id,
            active: active,
            dashboard_channel_id: data.dashboard_channel.id
        } // dashboard channel id for cell grid
        ;
        console.log(data);
        const [response, errors] = data.origin == 0 ? await updateDashboardVariableShared(data.variables[0].id, dataToSend) : await updateCellValueGrid(index, dataToSend);
        if (errors != null) {
            console.log(errors);
            return;
        }
        toast.success("Variable's value changed", "The value of a cell has been changed !");
    };
    /**
     * Retrieve the value of a cell in grid in shared dashboard, with it index 
     */ const getCellShared = (index)=>{
        let shared_values = data.shared_values_variables != null ? JSON.parse(data.shared_values_variables) : null;
        if (shared_values == null) return;
        const value = shared_values.find((val)=>val.dashboard_variable_id === data.variables[0].id).cells[index];
        return value;
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            ref: ref,
            className: "gridDashboardEditor_main_container",
            children: [
                data.grid.type_variable == 1 && errorMessage.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    className: "containerError_input_dashboard_grid",
                    children: [
                        data.grid.placeholder_format,
                        " :",
                        errorMessage.map((cell, i)=>{
                            console.log(cell);
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                className: "errorInput_dashboard_grid_editor",
                                children: [
                                    " [",
                                    cell.parents.row.value,
                                    ", ",
                                    cell.parents.column,
                                    "]"
                                ]
                            });
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "dashboard_editor_grid_column",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "root_cellEditor" + (structure.columns.length > 0 ? "" : "single_rootEditor")
                        }),
                        structure.columns.map((cell, i)=>{
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cedb606d7803982f$export$2e2bcd8739ae039), {
                                    data: cell,
                                    className: "dashboard_editor_column_cell dashboard_cell_Editor",
                                    disabled: true
                                })
                            }, i);
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "rowsEditor",
                    children: structure.rows.map((row, i)=>{
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            style: {
                                display: "flex"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cedb606d7803982f$export$2e2bcd8739ae039), {
                                    data: row,
                                    className: "dashboard_editor_row_cell dashboard_cell_Editor",
                                    disabled: true
                                }),
                                structure.cells?.map((cell, j)=>{
                                    if (j > structure.columns.length - 1) return;
                                    j = j + i * structure.columns.length;
                                    cell = data.origin == 0 ? getCellShared(j) : structure.cells[j];
                                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        style: {
                                            display: "flex"
                                        },
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cedb606d7803982f$export$2e2bcd8739ae039), {
                                            access: access,
                                            data: {
                                                cell: cell,
                                                index: j
                                            },
                                            gridValues: data.grid,
                                            parents: {
                                                row: row,
                                                column: structure.columns[j % structure.columns.length].value
                                            },
                                            className: "dashboard_editor_row_cell dashboard_cell_Editor",
                                            postbackAction: (index, value, active)=>modifyValue(index, value),
                                            modifyErrorInput: setErrorInput
                                        })
                                    }, j);
                                })
                            ]
                        }, i);
                    })
                }),
                data.grid.type_variable == 1 && errorMessage.length > 0 && ref.current?.clientHeight > 400 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    className: "containerError_input_dashboard_grid",
                    children: [
                        " ",
                        data.grid.placeholder_format,
                        "  :",
                        errorMessage.map((cell, i)=>{
                            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                className: "errorInput_dashboard_grid_editor",
                                children: [
                                    "[",
                                    cell.parents.row.value,
                                    ", ",
                                    cell.parents.column,
                                    "]"
                                ]
                            });
                        })
                    ]
                })
            ]
        })
    });
}
var $d65d21c308e7beff$export$2e2bcd8739ae039 = $d65d21c308e7beff$var$DashboardEditorGrid;



var $bh6RR = parcelRequire("bh6RR");


const $8d632a132b025211$var$nameSection = "dashboard_blocks_state";
function $8d632a132b025211$export$46da396e9ef57be4(block) {
    const [data, setData] = (0, $bh6RR.useState)($8d632a132b025211$export$508fb3e1932319fc(block.id));
    if (data == null) {
        $8d632a132b025211$var$updateUserParameters(block, true);
        setData($8d632a132b025211$export$508fb3e1932319fc(block.id));
    }
    const [animationBlock, setAnimationBlock] = (0, $bh6RR.useState)(data?.isOpen === true || data == null ? "" : "hide_block");
    const [rotateChevron, setRotateChevron] = (0, $bh6RR.useState)(data != null ? !data.isOpen : false);
    const [userParameters, setUserParameters] = (0, $bh6RR.useState)((0, $b6b235c5b8c1f5b6$export$e14f85ca0e45cc50)($8d632a132b025211$var$nameSection));
    const openBlock = async ()=>{
        let res = $8d632a132b025211$var$updateUserParameters(block, rotateChevron);
        setUserParameters(res);
        setRotateChevron(!rotateChevron);
        let css = !rotateChevron ? "hide_block" : "";
        setData($8d632a132b025211$export$508fb3e1932319fc(block.id));
        setAnimationBlock(css);
    };
    return {
        animationBlock: animationBlock,
        openBlock: openBlock,
        rotateChevron: rotateChevron,
        userParameters: userParameters
    };
}
function $8d632a132b025211$var$updateUserParameters(block, isOpen) {
    let currentData = $8d632a132b025211$var$getAllParameters();
    let currentBlock = currentData.find((b)=>b.id == block.id);
    if (currentBlock != null) currentBlock.isOpen = isOpen;
    else currentData.push({
        id: block.id,
        isOpen: isOpen
    });
    (0, $b6b235c5b8c1f5b6$export$436ab9ffc2d94549)($8d632a132b025211$var$nameSection, currentData);
    return (0, $b6b235c5b8c1f5b6$export$e14f85ca0e45cc50)($8d632a132b025211$var$nameSection);
}
function $8d632a132b025211$var$getAllParameters() {
    return (0, $b6b235c5b8c1f5b6$export$e14f85ca0e45cc50)($8d632a132b025211$var$nameSection).length > 0 ? (0, $b6b235c5b8c1f5b6$export$e14f85ca0e45cc50)($8d632a132b025211$var$nameSection) : [];
}
function $8d632a132b025211$export$508fb3e1932319fc(id) {
    return $8d632a132b025211$var$getAllParameters().find((b)=>b.id == id);
}


function $3d7be7d3196ccbd8$var$DashboardBlock({ data: data, bot: bot, modifyBlockAction: modifyBlockAction, arrowPointedAdd: arrowPointedAdd, access: access, index: index }) {
    const [block, setBlock] = (0, $bh6RR.useState)(data);
    const { animationBlock: animationBlock, rotateChevron: rotateChevron, openBlock: openBlock } = (0, $8d632a132b025211$export$46da396e9ef57be4)(block);
    const [showRemove, setShowRemove] = (0, $bh6RR.useState)((0, $8d632a132b025211$export$508fb3e1932319fc)(block.id));
    const { updatePositionBlock: updatePositionBlock, deleteBlock: deleteBlock } = (0, $c67d47eff71309b3$export$2e2bcd8739ae039);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const refBlockContainer = (0, $bh6RR.useRef)(null);
    var listVariableDashboard = block.dashboard.blocks.filter((block)=>block.type == 0).map((block)=>block.variables).flat().sort(function(a, b) {
        return (a.position === null) - (b.position === null) || +(a.position > b.position) || -(a.position < b.position);
    });
    var variables = block.variables.sort(function(a, b) {
        return (a.position === null) - (b.position === null) || +(a.position > b.position) || -(a.position < b.position);
    });
    var structure = block.type == 1 ? JSON.parse(block.grid.structure) : "";
    const rotate = rotateChevron ? "close_style" : "open_style";
    const showEditBlockModal = ()=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $b54969fa69ce7e4e$export$2e2bcd8739ae039), {
            dashboardChannel: block.dashboard_channel,
            block: block,
            setBlock: modifyBlockAction,
            bot: bot
        });
    const showAddVariableModal = ()=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $f30b2360e51cf167$export$2e2bcd8739ae039), {
            block_id: block.id,
            postbackAction: modifyBlockAction,
            bot: bot,
            dashboardChannel: block.dashboard_channel
        });
    const showRemoveBlockModal = async ()=>{
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete Block",
            body: 'Do you really want to delete the block : " ' + block.name + ' " ?',
            api: {
                request: deleteBlock,
                param: [
                    block.id
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel"
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ],
            confirm: {
                name: block.name,
                fieldName: "this block"
            }
        });
        toast.success("Block removed", "The block " + block.name + " has been removed ! ");
        modifyBlockAction();
    };
    const getStyleVariable = (i)=>{
        let res = "";
        if (i + 1 != variables.length) res += "separator_dashboard_variable ";
         // i == 0 : 1st row, i == variables.length-1 : last row
        return res;
    };
    const checkValueVariable = (_variable, _block)=>{
        let shared_values = _block.shared_values_variables ? JSON.parse(_block.shared_values_variables) : null;
        if (shared_values == null) return _variable.value;
        const value = shared_values.find((val)=>val.dashboard_variable_id === _variable.id).value;
        return value;
    };
    (0, $bh6RR.useEffect)(()=>{
        if (block != null) setBlock(data);
    });
    const checkCondition = (variable)=>{
        if (variable.conditions.length == 0) return true;
        let cpt = 0;
        let _block = block.dashboard.blocks.find((b)=>b.id === variable.dashboard_block_id);
        // on regroupe chaque block de condtions par index
        let blocksConds = [];
        variable.conditions.forEach((condition)=>{
            if (blocksConds[condition.block_index] == null) blocksConds[condition.block_index] = [];
            blocksConds[condition.block_index].push(condition);
        });
        blocksConds.forEach((blockCondition)=>{
            cpt = checkSingleBlock(blockCondition, _block) ? cpt + 1 : cpt - 1;
        });
        return cpt == blocksConds.length;
    };
    const modifyPositionBlock = async (pos)=>{
        if (pos < 0 || pos >= index.max) return;
        let dataToSend = {
            "position": pos
        };
        const [response, errors] = await updatePositionBlock(block.id, dataToSend);
        if (errors != null) {
            console.log(errors);
            return;
        }
        //modal.resolve(response);
        //toast.success('Variable\'s position changed', 'The position of the variable " ' + response.label + ' " has been changed !');
        modifyBlockAction();
    };
    const checkSingleBlock = (blockCondition, _block)=>{
        let cpt = 0;
        blockCondition.forEach((cond)=>{
            let variableCheck = listVariableDashboard.find((v)=>v.id === cond.variable_target_id); // recuperer la valeur de la variable actuelle, dashbaord partagee 
            if (checkValueVariable(variableCheck, _block) == cond.value) cpt++;
        });
        return cpt > 0; // si 0 signifie que toutes les conditions sont fausse, donc le ou renvoie aucune bonne valeur
    };
    (0, $bh6RR.useEffect)(()=>{
        if (block.position == null) modifyPositionBlock(index.current);
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        onMouseOut: ()=>{
            setShowRemove(false);
        },
        onMouseOver: ()=>{
            setShowRemove(true);
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "dashboard_title_mainBlock",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "block_title",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "position_block_container " + (block.position == index.max - 1 || block.position == 0 ? "position_arrow_dropdown" : ""),
                                    children: showRemove == true && (0, $da2068bd2c317854$export$fc970ed23da99565)(access) && block.origin != 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                        children: [
                                            block.position != 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                className: "fas fa-chevron-up",
                                                style: {
                                                    cursor: "pointer",
                                                    marginBottom: block.position != index.max - 1 ? "15px" : ""
                                                },
                                                "aria-hidden": "true",
                                                onClick: ()=>modifyPositionBlock(block.position - 1)
                                            }),
                                            block.position != index.max - 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                                className: "fas fa-chevron-down",
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                "aria-hidden": "true",
                                                onClick: ()=>modifyPositionBlock(block.position + 1)
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                onClick: ()=>{
                                    openBlock();
                                },
                                className: "main-iconButton profil_action main_add-button space_tableButton dashboard_button",
                                icon: "fas fa-chevron-right " + rotate
                            }, "buttonOpen-" + block.id),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "dashboard_title",
                                onClick: ()=>{
                                    openBlock();
                                },
                                children: block.name
                            }),
                            !(0, $da2068bd2c317854$export$7383f122bf48ec30)(access) && showRemove == true && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                        onClick: ()=>showEditBlockModal(),
                                        className: "main-iconButton profil_action main_add-button space_tableButton dashboard_button",
                                        icon: "fas fa-pencil-alt"
                                    }, "buttonEdit-" + block.id),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                        onClick: ()=>showRemoveBlockModal(),
                                        className: "main-iconButton remove-hover modalButtons-input delete_action red-button-action-bg_color dashboard_button",
                                        icon: "fas fa-trash"
                                    }, "buttonRemove-" + block.id)
                                ]
                            })
                        ]
                    }),
                    !(0, $da2068bd2c317854$export$7383f122bf48ec30)(access) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        style: {
                            display: "flex"
                        },
                        children: [
                            arrowPointedAdd == true && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "arrow_right bounce",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                    className: "fa fa-arrow-right fa-2x"
                                })
                            }),
                            block.type != 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                className: "main-iconButton profil_action main_add-button space_tableButton dashboard_button",
                                icon: "fas fa-plus",
                                onClick: ()=>showAddVariableModal()
                            }, "buttonAdd-" + block.id)
                        ]
                    })
                ]
            }),
            block.type == 0 && variables != null && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                ref: refBlockContainer,
                className: variables.length > 0 ? "dashboard_block_container_variable :  " + animationBlock : "",
                children: variables != null && variables.map((variable, i)=>{
                    variable.value = checkValueVariable(variable, block);
                    variable.origin = block.origin;
                    variable.printedInView = checkCondition(variable);
                    if (variable.printedInView == true || (0, $da2068bd2c317854$export$fc970ed23da99565)(access)) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $009c8b2515fcdb52$export$2e2bcd8739ae039), {
                        dashboard_channel: block.dashboard_channel,
                        access: access,
                        variable: variable,
                        postbackAction: modifyBlockAction,
                        bot: bot,
                        className: getStyleVariable(i),
                        index: {
                            current: i,
                            max: variables.length
                        }
                    }, i);
                })
            }),
            block.type == 1 && (structure.rows && structure.rows.length > 0 || structure.columns && structure.columns.length > 0) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                ref: refBlockContainer,
                className: "dashboard_block_container_variable :  " + animationBlock,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d65d21c308e7beff$export$2e2bcd8739ae039), {
                    data: block,
                    structure: structure,
                    postbackAction: modifyBlockAction,
                    access: access
                })
            })
        ]
    });
}
var $3d7be7d3196ccbd8$export$2e2bcd8739ae039 = $3d7be7d3196ccbd8$var$DashboardBlock;






parcelRequire("bh6RR");

function $031980298027a2e5$var$DashboardEditor({ data: data, access: access }) {
    const storage = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session");
    const currentCompany = storage.get("company");
    const { dashboard: dashboard, setUpDashboard: setUpDashboard } = (0, $f3ef7769a2510d21$export$2e2bcd8739ae039)(data.dashboard.id);
    let nbDashboardSharedPrinted = 0;
    let companyAlreadyWrite = [];
    const showAddBlockModal = ()=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $b54969fa69ce7e4e$export$2e2bcd8739ae039), {
            dashboardChannel: data,
            bot: data.dashboard.bot,
            setBlock: setUpDashboard
        });
    const hasOneVariable = ()=>{
        return dashboard.blocks.find((block)=>block.variables.length > 0) ? true : false;
    };
    const getSharedValues = ()=>{
        return dashboard.channels.find((channel)=>channel.id == data.id).values_variables;
    };
    const getNbOfSameCompany = (company_id)=>{
        return dashboard.channels.filter((obj)=>obj.company_id === company_id).length;
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                id: "firework-container"
            }),
            !(0, $da2068bd2c317854$export$7383f122bf48ec30)(access) && data.origin == 2 && dashboard != null && dashboard.blocks.length > 0 && getNbOfSameCompany(currentCompany.id) < dashboard.channels.length && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "dashboard_message",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                            className: "fas fa-info-circle",
                            style: {
                                marginRight: "15px"
                            }
                        }),
                        "Be careful, you are about to edit the structure of this dashboard.",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                        "Be aware that it is shared to other companies and will therefore impact the structure of their own dashboards. Here are the organizations :",
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                        dashboard.channels.map((channel, i)=>{
                            if (channel.company_id != currentCompany.id && companyAlreadyWrite.includes(channel.company_id) == false) {
                                nbDashboardSharedPrinted++;
                                companyAlreadyWrite.push(channel.company_id);
                                let count = getNbOfSameCompany(channel.company_id);
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                    style: {
                                        fontWeight: "bold"
                                    },
                                    children: [
                                        " ",
                                        channel.company ? nbDashboardSharedPrinted > 1 ? " | " : "" : "",
                                        " ",
                                        channel.company?.name,
                                        " ",
                                        count > 1 ? "(" + count + ")" : ""
                                    ]
                                }, i);
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: dashboard != null && dashboard.blocks.map((block, i)=>{
                    block.shared_values_variables = getSharedValues();
                    block.origin = data.origin;
                    block.dashboard_channel = data;
                    block.dashboard = dashboard;
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3d7be7d3196ccbd8$export$2e2bcd8739ae039), {
                        data: block,
                        access: access,
                        bot: dashboard.bot,
                        modifyBlockAction: setUpDashboard,
                        arrowPointedAdd: !hasOneVariable() && i == 0,
                        index: {
                            current: i,
                            max: dashboard.blocks.length
                        }
                    }, i);
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            !(0, $da2068bd2c317854$export$7383f122bf48ec30)(access) && dashboard != null && dashboard.blocks.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "divider div-transparent div-dot"
            }),
            dashboard != null && dashboard.blocks.length <= 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "dashboard_message informatif_message_dashboard",
                            children: [
                                !(0, $da2068bd2c317854$export$7383f122bf48ec30)(access) ? "You don't have any block for the moment... Just create a new block and let's go !" : "This dashboard is currently empty. Please, contact your administrator for more information.",
                                " "
                            ]
                        })
                    }),
                    !(0, $da2068bd2c317854$export$7383f122bf48ec30)(access) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        class: "arrow_anim bounce",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                            class: "fa fa-arrow-down fa-2x"
                        })
                    })
                ]
            }),
            !(0, $da2068bd2c317854$export$7383f122bf48ec30)(access) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                style: {
                    paddingBottom: "5%"
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "dashboard_add_block",
                    style: {
                        marginTop: dashboard != null && dashboard.blocks.length > 0 ? "5%" : "1%"
                    },
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                        className: "main-iconButton profil_action main_add-button space_tableButton dashboard_button",
                        icon: "fas fa-plus",
                        onClick: ()=>showAddBlockModal()
                    }, "buttonAddBlock")
                })
            })
        ]
    });
}
var $031980298027a2e5$export$2e2bcd8739ae039 = $031980298027a2e5$var$DashboardEditor;





var $bh6RR = parcelRequire("bh6RR");



function $404f4a33d2bffab8$var$DashboardEditorPage() {
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const params = (0, $6a9dcc96d11bcd0d$export$99eaa27ddbbb95ef)();
    const { getDashboardChannel: getDashboardChannel } = (0, $c67d47eff71309b3$export$2e2bcd8739ae039);
    const [data, setData] = (0, $bh6RR.useState)(location.state?.data);
    const [access, setAccess] = (0, $bh6RR.useState)(location.state?.access);
    const [currentDashboardPrinted, setCurrentDashboardPrinted] = (0, $bh6RR.useState)(params.id);
    const setDataWithUrl = async ()=>{
        setData(null);
        const [response, errors] = await getDashboardChannel({
            id: params.id
        });
        if (errors != null) {
            console.log(errors);
            return navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/dashboards/list"));
        }
        let acc = location.pathname.includes("/view/") ? (0, $da2068bd2c317854$export$3026e5a52c747d2c).Client : (0, $da2068bd2c317854$export$3026e5a52c747d2c).Administrator;
        setAccess(acc);
        if (response.origin == 0 && acc == (0, $da2068bd2c317854$export$3026e5a52c747d2c).Administrator) return navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/dashboards/list"));
        setData(response);
    };
    if (currentDashboardPrinted != params.id) {
        setCurrentDashboardPrinted(params.id);
        setDataWithUrl();
    }
    (0, $bh6RR.useEffect)(()=>{
        if (data == null) setDataWithUrl();
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: data != null && access != null && data.dashboard != null && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                    title: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                        children: [
                            "Dashboard " + (access == (0, $da2068bd2c317854$export$3026e5a52c747d2c).Administrator ? "editor" : "") + " - " + (data.name != null ? data.name : data.dashboard.name),
                            " ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                style: {
                                    fontSize: "x-large",
                                    fontStyle: "italic"
                                },
                                children: [
                                    "For the bot : ",
                                    data.dashboard.bot.name
                                ]
                            }),
                            " "
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $031980298027a2e5$export$2e2bcd8739ae039), {
                    data: data,
                    access: access,
                    id: params.id
                })
            ]
        })
    });
}
var $404f4a33d2bffab8$export$2e2bcd8739ae039 = $404f4a33d2bffab8$var$DashboardEditorPage;



const $4088befe0edd7f7f$var$rootSupervision = "company/:company/";
const $4088befe0edd7f7f$var$routes = [
    {
        path: $4088befe0edd7f7f$var$rootSupervision + "dashboards/list",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4986d5e51af661d2$export$2e2bcd8739ae039), {}),
        isPublic: false,
        isSidebar: true,
        permissions: [
            "view_dashboards"
        ]
    },
    {
        path: $4088befe0edd7f7f$var$rootSupervision + "dashboard/create",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7626f2bdde1fbfae$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "create_dashboard"
        ]
    },
    {
        path: $4088befe0edd7f7f$var$rootSupervision + "dashboard/update",
        component: (data, type)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7626f2bdde1fbfae$export$2e2bcd8739ae039), {
                data: data,
                type: type
            }),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "update_dashboard"
        ]
    },
    {
        path: $4088befe0edd7f7f$var$rootSupervision + "dashboard/editor/:id",
        component: (data)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $404f4a33d2bffab8$export$2e2bcd8739ae039), {
                data: data,
                access: (0, $da2068bd2c317854$export$3026e5a52c747d2c).Administrator
            }),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "update_dashboard"
        ]
    },
    {
        path: $4088befe0edd7f7f$var$rootSupervision + "dashboard/editor/view/:id",
        component: (data)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $404f4a33d2bffab8$export$2e2bcd8739ae039), {
                data: data,
                access: (0, $da2068bd2c317854$export$3026e5a52c747d2c).Client
            }),
        isSidebar: true,
        isPublic: false,
        permissions: [
            "update_dashboard"
        ]
    }
];
var $4088befe0edd7f7f$export$2e2bcd8739ae039 = $4088befe0edd7f7f$var$routes;









function $0a3e4b96172f3da9$var$RoleFormPage() {
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    var data = null;
    var type = null;
    if (location.state != null) {
        data = location.state.data;
        type = location.state.type;
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $afaae2ff7871e331$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f0aded74899c8465$export$2e2bcd8739ae039), {})
    });
}
var $0a3e4b96172f3da9$export$2e2bcd8739ae039 = $0a3e4b96172f3da9$var$RoleFormPage;


const $f83e68e4012526ca$var$routes = [
    {
        path: "company/:company/bots/list",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ced148e02704f9f9$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false
    },
    // {path : 'administration/role/create', component: () => <RoleFormPage/>, isSidebar : true, isPublic : false},
    // {path : 'administration/role/update', component: (data,type) => <RoleFormPage data={data} type={type}/>, isSidebar : true, isPublic : false},
    {
        path: "*",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $70b8a3ef3c035a5f$export$2e2bcd8739ae039), {}),
        isPublic: true,
        isSidebar: false
    }
];
var $f83e68e4012526ca$export$2e2bcd8739ae039 = $f83e68e4012526ca$var$routes;












var $c0304bc8ef63f1e6$export$2e2bcd8739ae039 = {
    getLlms: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`llms/list`, data)
};



var $eff83add62c01a0f$exports = {};
$eff83add62c01a0f$exports = JSON.parse('{"variables":[{"name":"response","type":"text"}],"timestamp":1711125085,"paths":[{"object_id":"1710883083420_53899","parent":"1710883081288_64644","child":"1710883040374_33334_0"},{"object_id":"1710883095248_38624","parent":"1710883040374_80871","child":"1710883093340_17280_0"}],"children":[{"object_id":"1710883040374_33334_0","index":0,"text":"","path":{"object_id":"1710883083420_53899"},"parent":"1710883040374_80871"},{"object_id":"1710883081288_67118_0","index":0,"text":"","path":null,"parent":"1710883081288_64644"},{"object_id":"1710883081288_89271_1","index":1,"text":"Custom Response","path":null,"parent":"1710883081288_64644"},{"object_id":"1710883093340_17280_0","index":0,"text":"","path":{"object_id":"1710883095248_38624"},"parent":"1710883093340_98602"}],"blocks":[{"object_id":"1710883040374_80871","name":"Model Name, Admin Prompt, User Input","x":-3558,"y":-872,"width":5,"height":3,"is_statistic":0,"type":{"name":"action"},"data":{"variables":[{"value":"llm(\\\\\'open-mixtral-8x7b\\\\\', \\\\\'\\\\\', \\\\\'Bonjour tu vas bien ?\\\\\')","is_operation":true,"index":"0","variable":{"id":14105,"name":"response","public":0,"global":0,"global_value_test":"","global_value_prod":"","type":{"id":1,"name":"text"}}}]},"action_type":{"id":5,"name":"set_var"}},{"object_id":"1710883081288_64644","name":"Prompt","x":-3273,"y":-838,"width":5,"height":3,"is_statistic":0,"type":{"id":4,"name":"propos"},"data":{"block_id":108871,"messages":[{"type":"text","content":"[RESPONSE]\\n"}],"responses":[{"type":"custom","content":"Custom Response"}],"variable_redirect":null}},{"object_id":"1710883093340_98602","name":"Mixtral","x":-3812,"y":-876,"width":5,"height":2,"is_statistic":0,"type":{"id":3,"name":"scenario"},"data":{"block_id":108872,"basic":0}}],"coords":{"y":{"max":-838,"min":-876},"x":{"max":-3273,"min":-3812}}}');


function $25ce7bdd80c87807$var$LlmTable() {
    const { getLlms: getLlms } = (0, $c0304bc8ef63f1e6$export$2e2bcd8739ae039);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const currentUser = JSON.parse(window.sessionStorage.getItem("user"));
    const cells = [
        {
            column: "PROVIDER",
            name: "provider",
            show: (value)=>(0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(value)
        },
        {
            column: "NAME",
            name: "model",
            sort: true,
            show: (value)=>value
        },
        {
            column: "STATUS",
            name: "status",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "container_avaibility",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "circle_point available",
                        style: {
                            marginLeft: 24
                        }
                    })
                })
        }
    ];
    const filters = [
        {
            type: "input",
            placeholder: "provider",
            name: "provider"
        },
        {
            type: "input",
            placeholder: "name",
            name: "name"
        }
    ];
    const handleDownload = ()=>{
        const jsonString = JSON.stringify((0, (/*@__PURE__*/$parcel$interopDefault($eff83add62c01a0f$exports))));
        const blob = new Blob([
            jsonString
        ], {
            type: "application/json"
        });
        saveAs(blob, "mistralai/Mixtral-8x7B-Instruct-v0.1.json");
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: "List Llms"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "entete-dataset",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "entete-dataset",
                    style: {
                        width: "115px"
                    }
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "warning_migrations_container",
                onClick: handleDownload,
                style: {
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                    listClassName: "warning_migrations",
                    children: "\u2728 Test our llms directly in our bot by downloading an example with mixtral by clicking here"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
                name: "Llm",
                cells: cells,
                api: getLlms,
                withPagination: false,
                filters: filters
            })
        ]
    });
}
var $25ce7bdd80c87807$export$2e2bcd8739ae039 = $25ce7bdd80c87807$var$LlmTable;


function $c860edaa4948d3f5$var$LlmList() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $25ce7bdd80c87807$export$2e2bcd8739ae039), {});
}
var $c860edaa4948d3f5$export$2e2bcd8739ae039 = $c860edaa4948d3f5$var$LlmList;










var $72bb0822dc325234$export$2e2bcd8739ae039 = {
    getBrains: ()=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("rag/brains"),
    getBrain: (id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`rag/brains/${id}`),
    createBrain: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post("rag/brains", data),
    deleteBrain: (id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`rag/brains/${id}/subscription`),
    updateBrain: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`rag/brains/${id}`, data),
    getModels: ()=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("rag/models")
};




parcelRequire("bh6RR");








var $bh6RR = parcelRequire("bh6RR");









var $bh6RR = parcelRequire("bh6RR");


const $2780f3a03afac6d3$var$DropDown = /*#__PURE__*/ (0, $bh6RR.forwardRef)(({ choices: choices, placeholder: placeholder, defaultChoice: defaultChoice, heightFix: heightFix, className: className, width: width, name: name, onChange: onChange, onBlur: onBlur, setValue: setValue, icon: icon, hideSelectItem: hideSelectItem, noChangeOnSelect: noChangeOnSelect, reverse: reverse, disabled: disabled }, ref)=>{
    // Définition du choix par défaut
    if (defaultChoice) defaultChoice = choices.find((choice)=>choice.value === defaultChoice) || choices[0];
    if (placeholder) defaultChoice = {
        text: placeholder,
        value: ""
    };
    const [expanded, setExpanded] = (0, $bh6RR.useState)(false);
    const [selected, setSelected] = (0, $bh6RR.useState)(defaultChoice);
    const [lastDefaultChoice, setLastDefaultChoice] = (0, $bh6RR.useState)(defaultChoice);
    if (lastDefaultChoice.value !== defaultChoice.value) {
        setSelected(defaultChoice);
        setLastDefaultChoice(defaultChoice);
    }
    if (hideSelectItem === true) choices = choices.filter((choice)=>selected.value !== choice.value);
    const listStyle = {
        overflowY: expanded ? "auto" : "hidden",
        height: expanded ? heightFix || `${choices.length * 35}px` : "0",
        paddingTop: reverse ? "0px" : "",
        bottom: reverse ? "15px" : ""
    };
    // Définit la largeur maximale
    const maxWidth = typeof width === "number" ? `${width - 60}px` : `calc(${width} - 60px)`;
    const adjustedWidth = typeof width === "number" ? `${width}px` : width;
    const onClick = ()=>{
        if (!expanded && dropdownRef.current) dropdownRef.current.style.zIndex = 10;
        else setTimeout(()=>dropdownRef.current ? dropdownRef.current.style.zIndex = 0 : null, 500);
        setExpanded(!expanded);
    };
    const onSelect = (choice)=>{
        if (choice.text === "Import my logo") {
            const fileInput = document.createElement("input");
            fileInput.type = "file";
            fileInput.name = "avatar";
            fileInput.click();
            fileInput.addEventListener("change", (event)=>{
                const file = event.target.files[0];
                if (setValue) {
                    setValue(name, file, {
                        state: selected,
                        func: setSelected
                    });
                    setSelected({
                        value: file.name,
                        text: file.name
                    });
                }
            });
        } else {
            if (!noChangeOnSelect) setSelected(choice);
            setExpanded(false);
            setTimeout(()=>dropdownRef.current ? dropdownRef.current.style.zIndex = 0 : null, 500);
            if (setValue) setValue(name, choice.value, {
                state: selected,
                func: setSelected
            });
            if (onChange) onChange(choice); // Notifie le parent lors de la sélection
        }
    };
    const dropdownRef = (0, $bh6RR.useRef)("dropdown");
    (0, $e9725e0bc7ac6543$export$2e2bcd8739ae039)(dropdownRef, ()=>{
        if (expanded) setTimeout(()=>dropdownRef.current ? dropdownRef.current.style.zIndex = 0 : null, 500);
        setExpanded(false);
    });
    // Définition de la fonction createChoice
    const createChoice = (choice)=>{
        const iconPadding = icon ? 30 : 60;
        const paddingLeft = choice.icon ? 0 : 25;
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: [
                choice.icon && (typeof choice.icon === "string" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "icon",
                    style: {
                        backgroundImage: `url(${choice.icon})`
                    }
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "icon",
                    children: choice.icon
                })),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    className: "text",
                    style: {
                        fontWeight: selected.value === choice.value ? 700 : 400,
                        maxWidth: `calc(${width} - ${iconPadding}px)`,
                        paddingLeft: paddingLeft
                    },
                    children: choice.text
                })
            ]
        });
    };
    if (disabled) className = className ? `${className} disabled` : "disabled";
    className = className ? `dropdown ${className}` : "dropdown";
    const iconBackground = icon || selected.icon;
    const paddingLeft = iconBackground ? 0 : 25;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: className,
        ref: dropdownRef,
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                ref: ref,
                onChange: onChange,
                onBlur: onBlur,
                name: name,
                type: "hidden",
                value: selected.value == null ? "" : selected.value
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "custom-dropdown",
                style: {
                    width: adjustedWidth
                },
                onClick: onClick,
                children: [
                    iconBackground && (typeof iconBackground === "string" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "icon",
                        style: {
                            width: "25px",
                            height: "25px",
                            backgroundImage: `url(${iconBackground})`
                        }
                    }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "icon",
                        style: {
                            width: "auto",
                            backgroundColor: "white"
                        },
                        children: iconBackground
                    })),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "text",
                        style: {
                            maxWidth: maxWidth,
                            paddingLeft: paddingLeft
                        },
                        children: selected.text
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "container-arrow",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: `arrow ${expanded ? "reverse" : ""}`
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("ul", {
                        style: {
                            ...listStyle
                        },
                        children: choices.map((choice, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                onClick: ()=>onSelect(choice),
                                children: createChoice(choice)
                            }, index))
                    })
                ]
            })
        ]
    });
});
$2780f3a03afac6d3$var$DropDown.defaultProps = {
    width: 170,
    choices: [],
    disable: false,
    name: "",
    defaultChoice: "",
    icon: "",
    hideSelectItem: true,
    noChangeOnSelect: false,
    reverse: false
};
var $2780f3a03afac6d3$export$2e2bcd8739ae039 = $2780f3a03afac6d3$var$DropDown;


function $a0a7a57c31f3344d$var$FormBrain({ form: form, onSend: onSend }) {
    const data = {
        id: form.data.id,
        name: form.data.name,
        description: form.data.description,
        status: form.data.status || "private",
        model: form.data.brain_model,
        max_tokens: form.data.max_tokens || 2000
    };
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors, isValid: isValid }, getValues: getValues, setValue: setValue, watch: watch } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            name: data.name,
            description: data.description,
            status: data.status,
            model: data.model,
            max_tokens: data.max_tokens
        }
    });
    const [models, setModels] = (0, $bh6RR.useState)([]);
    const [loadAnim, setLoading] = (0, $bh6RR.useState)(null);
    const model = watch("model", data.model);
    const maxTokens = watch("max_tokens", data.max_tokens);
    const defineMaxTokens = (modelName)=>{
        const selectedModel = models.find((model)=>model.value === modelName);
        return selectedModel ? selectedModel.maxOutput : 3000;
    };
    const handleModelChange = (selectedModel)=>{
        setValue("model", selectedModel);
        const newMaxTokens = defineMaxTokens(selectedModel);
        setValue("max_tokens", newMaxTokens);
    };
    (0, $bh6RR.useEffect)(()=>{
        const fetchModels = async ()=>{
            const [models, error] = await (0, $72bb0822dc325234$export$2e2bcd8739ae039).getModels();
            if (error) {
                console.error("Error fetching models:", error);
                return;
            }
            setModels(models.map((model)=>({
                    value: model.name,
                    text: model.name,
                    maxOutput: model.max_output
                })));
        };
        fetchModels();
    }, []);
    const onSubmit = async ()=>{
        const values = getValues();
        const dataToSend = {
            name: values.name,
            description: values.description,
            brain_type: "doc",
            snippet_color: values.snippet_color || "#ffffff",
            snippet_emoji: values.snippet_emoji || "\uD83E\uDDE0",
            status: values.status,
            model: values.model,
            max_tokens: values.max_tokens
        };
        const formData = new FormData();
        Object.entries(dataToSend).forEach(([key, value])=>{
            formData.append(key, value);
        });
        setLoading(true);
        let response, error;
        if (data.id !== undefined) response = await (0, $72bb0822dc325234$export$2e2bcd8739ae039).updateBrain(data.id, formData);
        else response = await (0, $72bb0822dc325234$export$2e2bcd8739ae039).createBrain(dataToSend);
        setLoading(false);
        if (error || !response) {
            console.error("Error during update or creation:", error || "Missing response data");
            return;
        }
        if (onSend) onSend(response[0]);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
            className: "edit-container",
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                    children: form.title || "Create New Brain"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                    className: "body-editModal-container",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            style: {
                                display: "block"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Brain Name"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ...register("name", {
                                        required: true
                                    }),
                                    style: errors.name ? {
                                        borderColor: "red"
                                    } : {},
                                    placeholder: "Enter the name of your brain"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "modal-bar",
                            style: {
                                display: "block"
                            },
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                    label: "Description"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3076e45868839394$export$2e2bcd8739ae039), {
                                    ...register("description", {
                                        required: true
                                    }),
                                    style: errors.description ? {
                                        borderColor: "red"
                                    } : {},
                                    placeholder: "Enter a description"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "flex modal-bar choice-models",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    style: {
                                        display: "block"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Model"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2780f3a03afac6d3$export$2e2bcd8739ae039), {
                                            choices: models.map(({ value: value, text: text })=>({
                                                    value: value,
                                                    text: text
                                                })),
                                            placeholder: data.model || "Select a model",
                                            defaultChoice: {
                                                value: data.model || "",
                                                text: models.find((model)=>model.value === data.model)?.text || "Select a model"
                                            },
                                            onChange: (choice)=>handleModelChange(choice.value),
                                            onBlur: ()=>setValue("model", model)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    style: {
                                        display: "block"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                                    label: "Max Tokens:"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    className: "max-tokens",
                                                    children: maxTokens
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                            type: "range",
                                            min: 100,
                                            max: defineMaxTokens(model),
                                            step: 100,
                                            ...register("max_tokens", {
                                                required: true
                                            }),
                                            value: maxTokens,
                                            onChange: (e)=>setValue("max_tokens", e.target.value)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                        type: "submit",
                        label: data.id ? "Update" : "Add",
                        disabled: !isValid,
                        onSubmit: onSubmit
                    })
                })
            ]
        })
    });
}
var $a0a7a57c31f3344d$export$2e2bcd8739ae039 = $a0a7a57c31f3344d$var$FormBrain;


function $e234643bcca86288$var$BrainModalBody({ form: form }) {
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a0a7a57c31f3344d$export$2e2bcd8739ae039), {
            form: form,
            onSend: (e)=>{
                onClose();
                modal.resolve(e);
            }
        })
    });
}
var $e234643bcca86288$export$2e2bcd8739ae039 = $e234643bcca86288$var$BrainModalBody;


const $4527a328a54c9198$var$BrainModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ title: title, data: data, llms: llms })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const form = {
        title: title,
        data: data ? data : {}
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $9c2d88d3df32f983$export$2e2bcd8739ae039), {
        name: "add-brain",
        id: modal.id,
        autoClose: "true",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e234643bcca86288$export$2e2bcd8739ae039), {
                form: form
            })
        ]
    });
});
var $4527a328a54c9198$export$2e2bcd8739ae039 = $4527a328a54c9198$var$BrainModal;



var $bh6RR = parcelRequire("bh6RR");




var $70eb327fa4b50615$export$2e2bcd8739ae039 = {
    askQuestion: (chatId, brainId, question)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`rag/chat/${chatId}/question/stream?brain_id=${brainId}`, {
            brain_id: brainId,
            question: question
        }),
    getChatHistory: (id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`rag/chat/${id}/history`),
    getChats: ()=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`rag/chat`),
    createChat: ()=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post("rag/chat", {
            name: "New Chat"
        }),
    deleteChat: (id)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`rag/chat/${id}`)
};






function $4d6673607a6cc3e8$var$BrainsTable() {
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const { getBrains: getBrains, deleteBrain: deleteBrain } = (0, $72bb0822dc325234$export$2e2bcd8739ae039);
    const company = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company");
    const [refreshKey, setRefreshKey] = (0, $bh6RR.useState)(0);
    const [apiError, setApiError] = (0, $bh6RR.useState)(null);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const fetchBrains = async (params)=>{
        try {
            const [response, error] = await getBrains(params);
            if (error) {
                if (error.status === 401) setApiError("Invalid API key. Please contact the Talkr administrator.");
                else setApiError(`Error fetching data: ${error.message}`);
                return [
                    null,
                    error
                ];
            }
            setApiError(null);
            return [
                response.brains.filter((brain)=>brain.rights === "Owner"),
                null
            ];
        } catch (error) {
            setApiError("An unexpected error occurred while fetching data.");
            return [
                null,
                error
            ];
        }
    };
    const cells = [
        {
            column: "ID",
            name: "id",
            show: (value)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    style: {
                        color: "var(--main)",
                        cursor: "pointer"
                    },
                    onClick: (e)=>navigator.clipboard.writeText(value).then((_)=>{
                            toast.success("Copy ID to clipboard", "You can paste this token where you need !", 5000);
                        }),
                    children: [
                        " ",
                        (0, $2ec34e35a5139fe7$export$2e2bcd8739ae039)(value)
                    ]
                })
        },
        {
            column: "NAME",
            name: "name",
            sort: true,
            show: (value)=>value
        },
        {
            column: "DESCRIPTION",
            name: "description",
            sort: true,
            show: (value)=>value
        },
        {
            column: "MODEL",
            name: "brain_model",
            sort: true,
            show: (value)=>value
        },
        {
            column: "MAX TOKENS",
            name: "max_tokens",
            show: (value)=>value
        },
        {
            column: "LAST UPDATE",
            name: "last_update",
            sort: true,
            show: (value)=>(0, $df9ad4654a227866$export$3ae94a2503e890a1)(value)
        }
    ];
    const showAddModal = ({ addRow: addRow })=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $4527a328a54c9198$export$2e2bcd8739ae039), {
            title: "Add Brain"
        }).then((brain)=>addRow(brain));
    const showEditModal = ({ updateRow: updateRow, row: row })=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $4527a328a54c9198$export$2e2bcd8739ae039), {
            title: "Modify your Brain",
            data: {
                ...row
            }
        }).then((brain)=>{
            setRefreshKey((oldKey)=>oldKey + 1);
        });
    const onClickDelete = async ({ row: row, deleteRow: deleteRow })=>{
        const { id: id, name: name } = row;
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete Brain " + name,
            body: "You really want to delete brain " + name + " ?",
            api: {
                request: deleteBrain,
                param: [
                    row.id
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel",
                    style: {
                        marginRight: "20px"
                    }
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ],
            confirm: {
                name: row.name,
                fieldName: "the brain"
            }
        }).then(()=>deleteRow(id));
    };
    const brainSettings = ({ row: row })=>{
        const { id: id } = row;
        navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)(`/ai/llm-rag/${id}`));
    };
    const talkToBrain = async ({ row: row })=>{
        const { id: id } = row;
        try {
            const response = await (0, $70eb327fa4b50615$export$2e2bcd8739ae039).createChat();
            if (response[0].chat_id) navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)(`/ai/llm-rag/chat/${response[0].chat_id}?brainId=${id}`));
            else console.error("Chat ID not found in response:", response);
        } catch (error) {
            console.error("Failed to create chat:", error);
        }
    };
    const actions = [
        {
            className: "fas fa-cog action-button edit_action",
            style: {},
            onClick: showEditModal
        },
        {
            className: "fas fa-robot action-button edit_action",
            style: {},
            onClick: talkToBrain
        },
        {
            className: "fas fa-download action-button edit_action",
            style: {},
            onClick: brainSettings
        },
        {
            className: "fas fa-trash action-button delete_action",
            style: {},
            onClick: onClickDelete
        }
    ].filter((action)=>action);
    const buttons = [
        {
            icon: "fas fa-plus",
            onClick: showAddModal
        }
    ];
    const filters = [
        {
            type: "input",
            placeholder: "brains",
            name: "name"
        }
    ];
    if (!company?.api_key_rag || apiError) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: "List of Brains"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "warning_container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                    listClassName: "warning",
                    children: apiError || "API key for Talkr RAG usage is not configured. Please contact the Talkr administrator."
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: "List of Brains"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
                name: "Brains List",
                buttons: buttons,
                actions: actions,
                cells: cells,
                api: fetchBrains,
                withPagination: false,
                filters: filters,
                defaultSort: {
                    column: "last_update",
                    val: false
                }
            }, refreshKey)
        ]
    });
}
var $4d6673607a6cc3e8$export$2e2bcd8739ae039 = $4d6673607a6cc3e8$var$BrainsTable;


function $25741316cc57a66f$var$BrainsList() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4d6673607a6cc3e8$export$2e2bcd8739ae039), {});
}
var $25741316cc57a66f$export$2e2bcd8739ae039 = $25741316cc57a66f$var$BrainsList;



parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");





var $642554aa8c465b5f$export$2e2bcd8739ae039 = {
    getKnowledge: (id, params = {})=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("rag/knowledge", {
            brain_id: id,
            ...params
        }),
    deleteKnowledge: (knowledgeId, brainId)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`rag/knowledge/${knowledgeId}`, {
            brain_id: brainId
        }),
    uploadKnowledge: (bulkId, brainId, formData)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`rag/upload?bulk_id=${bulkId}&brain_id=${brainId}`, formData),
    crawlWebsite: (bulkId, brainId, crawlOptions)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`rag/crawl?bulk_id=${bulkId}&brain_id=${brainId}`, {
            crawlOptions: crawlOptions
        }),
    downloadKnowledge: (knowledgeId)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get(`rag/knowledge/${knowledgeId}/signed_download_url`)
};






var $bh6RR = parcelRequire("bh6RR");









parcelRequire("bh6RR");
const $52a2f77919e567d8$var$FromConnections = ()=>{
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
            children: "Upload from Connections (API or database connections)"
        })
    });
};
var $52a2f77919e567d8$export$2e2bcd8739ae039 = $52a2f77919e567d8$var$FromConnections;



parcelRequire("bh6RR");


const $90d389389683a5ea$var$FromDocuments = ({ setFile: setFile, file: file, loadAnim: loadAnim })=>{
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                label: "Documents"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $47da697040d42413$export$2e2bcd8739ae039), {
                _setFile: setFile,
                currentFile: file,
                accept: ".pdf,.doc,.docx,.txt,.png,.jpg,.jpeg",
                loadAnim: loadAnim,
                colorBorder: "inset 0 0 0 1px #dddddd;"
            })
        ]
    });
};
var $90d389389683a5ea$export$2e2bcd8739ae039 = $90d389389683a5ea$var$FromDocuments;




var $bh6RR = parcelRequire("bh6RR");
const $9447f7d2bc750ee8$var$FromWebsites = ({ setUrl: setUrl, url: url })=>{
    const [inputUrl, setInputUrl] = (0, $bh6RR.useState)(url || "");
    const [error, setError] = (0, $bh6RR.useState)(null);
    (0, $bh6RR.useEffect)(()=>{
        setInputUrl(url);
    }, [
        url
    ]);
    const validateUrl = (url)=>{
        const urlPattern = new RegExp("^(https?:\\/\\/)((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$", "i");
        return urlPattern.test(url);
    };
    const handleUrlChange = (e)=>{
        const newUrl = e.target.value;
        setInputUrl(newUrl);
        if (validateUrl(newUrl)) {
            setUrl(newUrl);
            setError(null);
        } else setError("The URL must be valid and start with http:// or https://");
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "input-url",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                type: "text",
                placeholder: "Enter a website's page URL",
                value: inputUrl,
                onChange: handleUrlChange,
                className: "input full-width input-space",
                style: {
                    borderColor: error ? "var(--pink)" : ""
                }
            }),
            error && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                className: "error-text",
                children: error
            })
        ]
    });
};
var $9447f7d2bc750ee8$export$2e2bcd8739ae039 = $9447f7d2bc750ee8$var$FromWebsites;



const $ca1edf764a6c5d37$var$KnowledgeModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ title: title, sub_title: sub_title, brainId: brainId, onUploadComplete: onUploadComplete })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const [selectedTab, setSelectedTab] = (0, $bh6RR.useState)("Documents");
    const [file, setFile] = (0, $bh6RR.useState)(null);
    const [url, setUrl] = (0, $bh6RR.useState)("");
    const [loadAnim, setLoadAnim] = (0, $bh6RR.useState)(false);
    const tabs = [
        "Documents",
        "Connections",
        "Websites"
    ];
    const uploadFile = async (bulkId, file, brainId, toast)=>{
        const formData = new FormData();
        formData.append("file", file);
        const response = await (0, $642554aa8c465b5f$export$2e2bcd8739ae039).uploadKnowledge(bulkId, brainId, formData);
        if (Array.isArray(response) && response[0]?.message === "File processing has started.") ;
        else {
            let parsedMessage = "Unknown error";
            if (Array.isArray(response) && response[0]?.message) parsedMessage = response[0].message;
            if (parsedMessage.includes("already exists")) toast.error("File already exists", `The file ${file.name} already exists.`);
            else toast.error("Upload Error", "Failed to upload file.");
            throw new Error(parsedMessage);
        }
    };
    const crawlUrl = async (bulkId, url, brainId, toast)=>{
        const crawlOptions = {
            url: url,
            depth: 1,
            js: false,
            max_pages: 100,
            max_time: 60
        };
        try {
            await (0, $642554aa8c465b5f$export$2e2bcd8739ae039).crawlWebsite(bulkId, brainId, crawlOptions);
        } catch (error) {
            toast.error("Crawl Error", "Failed to crawl the URL.");
            throw error;
        }
    };
    const onSubmit = async ()=>{
        if (!file && !url) {
            toast.error("Upload Error", "Please provide a file or a URL.");
            return;
        }
        setLoadAnim(true);
        const response = await (0, $70eb327fa4b50615$export$2e2bcd8739ae039).createChat();
        if (!response[0].chat_id) throw new Error("Failed to create chat: Missing chat_id");
        const bulkId = response[0].chat_id;
        let uploadSuccess = true;
        try {
            const tasks = [];
            if (file) {
                const fileUpload = uploadFile(bulkId, file, brainId, toast).catch((error)=>{
                    uploadSuccess = false;
                    return Promise.reject(error);
                });
                tasks.push(fileUpload);
            }
            if (url) {
                const urlCrawl = crawlUrl(bulkId, url, brainId, toast).catch((error)=>{
                    uploadSuccess = false;
                    return Promise.reject(error);
                });
                tasks.push(urlCrawl);
            }
            await Promise.all(tasks);
            if (uploadSuccess) {
                toast.success("Upload Success", "File and/or URL processed successfully.");
                if (onUploadComplete) onUploadComplete();
            }
        } catch (error) {
            if (!uploadSuccess) toast.error("Upload Failed", "An error occurred during upload or crawling.");
        } finally{
            await (0, $70eb327fa4b50615$export$2e2bcd8739ae039).deleteChat(bulkId);
            setLoadAnim(false);
            onClose();
        }
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        name: "upload-knowledge",
        id: modal.id,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "leave-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
                className: "modal-form",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                        children: sub_title
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "tabs",
                                children: tabs.map((tab)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setSelectedTab(tab),
                                        className: selectedTab === tab ? "active" : "",
                                        children: tab
                                    }, tab))
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "tab-content",
                                children: [
                                    selectedTab === "Documents" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $90d389389683a5ea$export$2e2bcd8739ae039), {
                                        setFile: setFile,
                                        file: file,
                                        loadAnim: loadAnim
                                    }),
                                    selectedTab === "Connections" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $52a2f77919e567d8$export$2e2bcd8739ae039), {}),
                                    selectedTab === "Websites" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9447f7d2bc750ee8$export$2e2bcd8739ae039), {
                                        setUrl: setUrl,
                                        url: url
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                className: "cancel",
                                label: "Cancel",
                                onClick: onClose,
                                style: {
                                    margin: 10
                                }
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                className: "validate",
                                label: "Upload",
                                onClick: onSubmit,
                                style: {
                                    margin: 10
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
var $ca1edf764a6c5d37$export$2e2bcd8739ae039 = $ca1edf764a6c5d37$var$KnowledgeModal;



function $bcc16e37a0bc3790$var$KnowledgeTable({ brainId: brainId }) {
    const [knowledgeData, setKnowledgeData] = (0, $bh6RR.useState)([]);
    const [refreshKey, setRefreshKey] = (0, $bh6RR.useState)(0);
    const [brainName, setBrainName] = (0, $bh6RR.useState)("");
    const fetchKnowledge = (0, $bh6RR.useCallback)(async (params = {})=>{
        try {
            const response = await (0, $642554aa8c465b5f$export$2e2bcd8739ae039).getKnowledge(brainId, params);
            if (response.error) {
                console.error("Error fetching knowledge:", response.error);
                return [
                    [],
                    response.error
                ];
            }
            setKnowledgeData(response[0].knowledges || []);
            return [
                response[0].knowledges,
                null
            ];
        } catch (error) {
            console.error("Unexpected error fetching knowledge:", error);
            return [
                [],
                error
            ];
        }
    }, [
        brainId
    ]);
    const fetchBrain = async ()=>{
        try {
            const [response, error] = await (0, $72bb0822dc325234$export$2e2bcd8739ae039).getBrain(brainId);
            if (error) return [
                null,
                error
            ];
            setBrainName(response.name);
        } catch (error) {
            return [
                null,
                error
            ];
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        fetchKnowledge();
        fetchBrain();
    }, [
        brainId
    ]);
    const cells = [
        {
            column: "NAME",
            name: "file_name",
            sort: true,
            show: (value)=>value
        },
        {
            column: "STATUS",
            name: "status",
            show: (value)=>value === "UPLOADED" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    className: "fa fa-check",
                    "aria-hidden": "true",
                    style: {
                        color: "var(--green)"
                    }
                }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    style: {
                        color: "var(--pink)",
                        fontWeight: "bolder"
                    },
                    children: "X"
                })
        },
        {
            column: "LAST UPDATE",
            name: "updated_at",
            sort: true,
            show: (value)=>(0, $df9ad4654a227866$export$3ae94a2503e890a1)(value)
        }
    ];
    const showAddModal = ({ addRow: addRow })=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $ca1edf764a6c5d37$export$2e2bcd8739ae039), {
            title: "Add Knowledge",
            sub_title: "Feed your brain with knowledges from documents or websites",
            brainId: brainId,
            onUploadComplete: ()=>{
                fetchKnowledge();
                setRefreshKey((prev)=>prev + 1);
            }
        }).then((knowledge)=>addRow(knowledge));
    const onClickDelete = async ({ row: row, deleteRow: deleteRow })=>{
        const { id: id, file_name: file_name } = row;
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete resource ",
            body: "You really want to delete resource " + file_name + " ?",
            api: {
                request: (knowledgeId)=>(0, $642554aa8c465b5f$export$2e2bcd8739ae039).deleteKnowledge(knowledgeId, brainId),
                param: [
                    id
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel",
                    style: {
                        marginRight: "20px"
                    }
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ]
        }).then(()=>deleteRow(id));
    };
    const onClickDownload = async ({ row: row })=>{
        const { file_name: file_name, id: id } = row;
        if (/^https?:\/\//.test(file_name)) {
            window.open(file_name, "_blank");
            return;
        }
        try {
            const getUrlFile = await (0, $642554aa8c465b5f$export$2e2bcd8739ae039).downloadKnowledge(id);
            const url = getUrlFile[0].signedURL;
            if (!url) throw new Error("Download URL not found");
            const response = await fetch(url, {
                method: "GET"
            });
            if (!response.ok) throw new Error("Failed to fetch the file");
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = file_name || "downloaded_file";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(blobUrl);
            document.body.removeChild(a);
        } catch (error) {
            console.error("Error downloading the file:", error);
        }
    };
    const onClickOpenInNewTab = async ({ row: row })=>{
        const { file_name: file_name, id: id } = row;
        if (/^https?:\/\//.test(file_name)) {
            window.open(file_name, "_blank");
            return;
        }
        try {
            const getUrlFile = await (0, $642554aa8c465b5f$export$2e2bcd8739ae039).downloadKnowledge(id);
            const url = getUrlFile[0].signedURL;
            if (!url) throw new Error("Download URL not found");
            window.open(url, "_blank");
        } catch (error) {
            console.error("Error opening the URL in new tab:", error);
        }
    };
    const actions = [
        {
            className: "fas fa-up-right-from-square action-button edit_action",
            style: {},
            onClick: onClickOpenInNewTab
        },
        {
            className: "fas fa-upload action-button edit_action",
            style: {},
            onClick: onClickDownload
        },
        {
            className: "fas fa-trash action-button delete_action",
            style: {},
            onClick: onClickDelete
        }
    ].filter((action)=>action);
    const buttons = [
        {
            icon: "fas fa-file-arrow-down",
            onClick: showAddModal
        }
    ];
    const filters = [
        {
            type: "input",
            placeholder: "resources",
            name: "file_name"
        }
    ];
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: `Brain: ${brainName}`
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
                name: "Brains List",
                buttons: buttons,
                actions: actions,
                cells: cells,
                api: fetchKnowledge,
                withPagination: false,
                filters: filters,
                defaultSort: {
                    column: "updated_at",
                    val: false
                }
            }, refreshKey)
        ]
    });
}
var $bcc16e37a0bc3790$export$2e2bcd8739ae039 = $bcc16e37a0bc3790$var$KnowledgeTable;


function $521ebf6c2a758b5f$var$BrainPage({}) {
    const { brainId: brainId } = (0, $6a9dcc96d11bcd0d$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $bcc16e37a0bc3790$export$2e2bcd8739ae039), {
        brainId: brainId
    });
}
var $521ebf6c2a758b5f$export$2e2bcd8739ae039 = $521ebf6c2a758b5f$var$BrainPage;



parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");






function $f01140eb4499e407$var$ChatInput({ brainId: brainId, onQuestionSent: onQuestionSent, isLoading: isLoading }) {
    const { chatId: chatId } = (0, $6a9dcc96d11bcd0d$export$99eaa27ddbbb95ef)();
    const [message, setMessage] = (0, $bh6RR.useState)("");
    const [isSubmitting, setIsSubmitting] = (0, $bh6RR.useState)(false);
    const [brainName, setBrainName] = (0, $bh6RR.useState)(null);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    (0, $bh6RR.useEffect)(()=>{
        const fetchBrain = async (params)=>{
            try {
                const [response, error] = await (0, $72bb0822dc325234$export$2e2bcd8739ae039).getBrain(brainId);
                if (error) return [
                    null,
                    error
                ];
                setBrainName(response.name);
            } catch (error) {
                return [
                    null,
                    error
                ];
            }
        };
        if (brainId) fetchBrain();
    }, [
        brainId,
        toast
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!message.trim()) return;
        setIsSubmitting(true);
        try {
            const [response, error] = await (0, $70eb327fa4b50615$export$2e2bcd8739ae039).askQuestion(chatId, brainId, message);
            if (error) {
                toast.error("Error", "Failed to submit the question.");
                console.error("Error submitting question:", error);
            } else {
                setMessage("");
                onQuestionSent();
            }
        } catch (err) {
            toast.error("Error", "An unexpected error occurred.");
            console.error("Unexpected error submitting question:", err);
        } finally{
            setIsSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("form", {
        onSubmit: handleSubmit,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "chat-input-container",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($f01140eb4499e407$var$CurrentBrainDisplay, {
                    brainName: brainName
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "chat-editor-wrapper",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                            value: message,
                            onChange: (e)=>setMessage(e.target.value),
                            placeholder: "Type your message here...",
                            className: "chat-input"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                            type: "submit",
                            className: "chat-submit-button button validate",
                            label: isSubmitting || isLoading ? "Submitting..." : "Send",
                            disabled: isSubmitting || isLoading || !message.trim()
                        })
                    ]
                })
            ]
        })
    });
}
function $f01140eb4499e407$var$CurrentBrainDisplay({ brainName: brainName }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "current-brain-display",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                "Talking to ",
                brainName || "Current Brain"
            ]
        })
    });
}
var $f01140eb4499e407$export$2e2bcd8739ae039 = $f01140eb4499e407$var$ChatInput;




var $bh6RR = parcelRequire("bh6RR");

parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
const $9d02b3bb9bdc61a0$var$MessageRow = ({ speaker: speaker, text: text, metadata: metadata, isLast: isLast })=>{
    const [isSourcesOpen, setIsSourcesOpen] = (0, $bh6RR.useState)(false);
    const toggleSources = ()=>setIsSourcesOpen(!isSourcesOpen);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: `message-row ${speaker}`,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "message-content",
                children: text
            }),
            speaker === "assistant" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "metadata",
                children: metadata?.sources?.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "sources",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            onClick: toggleSources,
                            className: "toggle-sources",
                            children: isSourcesOpen ? "Hide sources" : "Show sources"
                        }),
                        isSourcesOpen && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("ul", {
                            className: "source-list",
                            children: metadata.sources.map((source, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                    children: source.citation && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                                        className: "citation",
                                        children: source.citation
                                    })
                                }, index))
                        })
                    ]
                })
            })
        ]
    });
};
var $9d02b3bb9bdc61a0$export$2e2bcd8739ae039 = $9d02b3bb9bdc61a0$var$MessageRow;



parcelRequire("bh6RR");

const $1c6b42788448b7ab$var$FollowUpQuestions = ({ questions: questions, chatId: chatId, brainId: brainId, onQuestionSent: onQuestionSent, setIsLoading: setIsLoading })=>{
    const handleFollowUpClick = async (question)=>{
        if (setIsLoading) setIsLoading(true);
        const [response, error] = await (0, $70eb327fa4b50615$export$2e2bcd8739ae039).askQuestion(chatId, brainId, question);
        if (error) console.error("Error sending follow-up question:", error);
        else onQuestionSent();
        if (setIsLoading) setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "follow-up-questions",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("ul", {
            children: questions.slice(0, 3).map((question, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                        className: "follow-up-button",
                        onClick: ()=>handleFollowUpClick(question),
                        children: question
                    })
                }, index))
        })
    });
};
var $1c6b42788448b7ab$export$2e2bcd8739ae039 = $1c6b42788448b7ab$var$FollowUpQuestions;


const $2fab48d3c8cdc73f$var$ChatItem = ({ content: content, isLast: isLast, brainId: brainId, chatId: chatId, onQuestionSent: onQuestionSent, setIsLoading: setIsLoading })=>{
    if (!content) return null;
    const { user_message: user_message, assistant: assistant, metadata: metadata } = content;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9d02b3bb9bdc61a0$export$2e2bcd8739ae039), {
                speaker: "user",
                text: user_message
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9d02b3bb9bdc61a0$export$2e2bcd8739ae039), {
                speaker: "assistant",
                text: assistant,
                metadata: metadata,
                isLast: isLast
            }),
            metadata?.followup_questions?.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1c6b42788448b7ab$export$2e2bcd8739ae039), {
                questions: metadata.followup_questions,
                chatId: chatId,
                brainId: brainId,
                onQuestionSent: onQuestionSent,
                setIsLoading: setIsLoading
            })
        ]
    });
};
var $2fab48d3c8cdc73f$export$2e2bcd8739ae039 = $2fab48d3c8cdc73f$var$ChatItem;


const $efc7079eecb2b576$var$ChatDialogueArea = ({ messages: messages, chatId: chatId, brainId: brainId, onQuestionSent: onQuestionSent, setIsLoading: setIsLoading })=>{
    const chatEndRef = (0, $bh6RR.useRef)(null);
    const scrollToBottom = ()=>{
        if (chatEndRef.current) chatEndRef.current.scrollIntoView({
            behavior: "smooth"
        });
    };
    (0, $bh6RR.useEffect)(()=>{
        scrollToBottom();
    }, [
        messages
    ]);
    if (!messages || messages.length === 0) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "empty-message",
        children: "Ask your question to get started"
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "chat-dialogue-area",
        children: [
            messages.map((message, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2fab48d3c8cdc73f$export$2e2bcd8739ae039), {
                    content: message,
                    isLast: index === messages.length - 1,
                    chatId: chatId,
                    brainId: brainId,
                    onQuestionSent: onQuestionSent,
                    setIsLoading: setIsLoading
                }, message.message_id)),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                ref: chatEndRef
            })
        ]
    });
};
var $efc7079eecb2b576$export$2e2bcd8739ae039 = $efc7079eecb2b576$var$ChatDialogueArea;




var $bh6RR = parcelRequire("bh6RR");

function $fb72bc630294abab$var$ThreadContent({ chatId: chatId, brainId: initialBrainId }) {
    const [messages, setMessages] = (0, $bh6RR.useState)([]);
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const [resolvedBrainId, setResolvedBrainId] = (0, $bh6RR.useState)(initialBrainId);
    const fetchChatHistory = async ()=>{
        setIsLoading(true);
        try {
            const [response] = await (0, $70eb327fa4b50615$export$2e2bcd8739ae039).getChatHistory(chatId);
            if (!resolvedBrainId) {
                const firstMessageWithBrainId = response.find((item)=>item.item_type === "MESSAGE" && item.body?.brain_id);
                if (firstMessageWithBrainId) setResolvedBrainId(firstMessageWithBrainId.body.brain_id);
            }
            const messages = response.filter((item)=>item.item_type === "MESSAGE").map((item)=>item.body);
            setMessages(messages);
        } catch (error) {
            console.error("Error loading history: ", error);
        } finally{
            setIsLoading(false);
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        fetchChatHistory();
    }, [
        chatId
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "thread-content-container",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h1", {
                children: [
                    "Chat ID: ",
                    chatId
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "thread-content",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $efc7079eecb2b576$export$2e2bcd8739ae039), {
                        messages: messages,
                        brainId: resolvedBrainId,
                        chatId: chatId,
                        onQuestionSent: fetchChatHistory,
                        setIsLoading: setIsLoading
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f01140eb4499e407$export$2e2bcd8739ae039), {
                        brainId: resolvedBrainId,
                        onQuestionSent: fetchChatHistory,
                        isLoading: isLoading
                    })
                ]
            })
        ]
    });
}
var $fb72bc630294abab$export$2e2bcd8739ae039 = $fb72bc630294abab$var$ThreadContent;



function $4ce7a80c690a8f39$var$ChatPage({}) {
    const { chatId: chatId } = (0, $6a9dcc96d11bcd0d$export$99eaa27ddbbb95ef)();
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    const queryParams = new URLSearchParams(location.search);
    const brainId = queryParams.get("brainId");
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a2ebea23332d16de$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fb72bc630294abab$export$2e2bcd8739ae039), {
            chatId: chatId,
            brainId: brainId
        })
    });
}
var $4ce7a80c690a8f39$export$2e2bcd8739ae039 = $4ce7a80c690a8f39$var$ChatPage;



parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");










function $d94e23d06ed22014$var$ThreadTable() {
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const company = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company");
    const [apiError, setApiError] = (0, $bh6RR.useState)(null);
    const [refreshKey, setRefreshKey] = (0, $bh6RR.useState)(0);
    const fetchChats = (0, $bh6RR.useCallback)(async ()=>{
        try {
            const [response, error] = await (0, $70eb327fa4b50615$export$2e2bcd8739ae039).getChats();
            if (error) {
                if (error.status === 401) setApiError("Invalid API key. Please contact the Talkr administrator.");
                else setApiError(`Error fetching data: ${error.message}`);
                return [
                    null,
                    error
                ];
            }
            const adaptedChats = response.chats.map((chat)=>({
                    chat_id: chat.chat_id,
                    chat_name: chat.chat_name || "Unnamed Chat",
                    creation_time: chat.creation_time
                }));
            setApiError(null);
            return [
                adaptedChats,
                null
            ];
        } catch (error) {
            setApiError("An unexpected error occurred while fetching data.");
            return [
                [],
                error
            ];
        }
    }, []);
    const cells = [
        {
            column: "NAME",
            name: "chat_name",
            sort: true,
            show: (value)=>value
        },
        {
            column: "CREATION",
            name: "creation_time",
            sort: true,
            show: (value)=>(0, $df9ad4654a227866$export$3ae94a2503e890a1)(value)
        }
    ];
    const onClickDelete = async ({ row: row })=>{
        const { chat_id: chat_id } = row;
        try {
            await (0, $70eb327fa4b50615$export$2e2bcd8739ae039).deleteChat(chat_id);
            setRefreshKey((prev)=>prev + 1);
        } catch (error) {
            console.error("Failed to delete chat:", error);
        }
    };
    const openChat = async ({ row: row })=>{
        const { chat_id: chat_id } = row;
        navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)(`/ai/llm-rag/chat/${chat_id}`));
    };
    const actions = [
        {
            className: "fas fa-robot action-button edit_action",
            style: {},
            onClick: openChat
        },
        {
            className: "fas fa-trash action-button delete_action",
            style: {},
            onClick: onClickDelete
        }
    ].filter((action)=>action);
    const filters = [
        {
            type: "input",
            placeholder: "Search by name",
            name: "chat_name"
        }
    ];
    if (!company?.api_key_rag || apiError) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: "Chat History"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "warning_container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                    listClassName: "warning",
                    children: apiError || "API key for Talkr RAG usage is not configured. Please contact the Talkr administrator."
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: `Chat History`
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3822f7270824b8aa$export$2e2bcd8739ae039), {
                name: "Chat",
                actions: actions,
                cells: cells,
                api: fetchChats,
                withPagination: false,
                filters: filters,
                defaultSort: {
                    column: "creation_time",
                    val: false
                },
                refreshState: [
                    refreshKey
                ]
            })
        ]
    });
}
var $d94e23d06ed22014$export$2e2bcd8739ae039 = $d94e23d06ed22014$var$ThreadTable;


function $1c43d34b12e646e0$var$ThreadsPage({}) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d94e23d06ed22014$export$2e2bcd8739ae039), {});
}
var $1c43d34b12e646e0$export$2e2bcd8739ae039 = $1c43d34b12e646e0$var$ThreadsPage;


const $fdb67506168be5f0$var$routes = [
    {
        path: "company/:company/ai/llm/list",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c860edaa4948d3f5$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false
    },
    {
        path: "company/:company/ai/llm-rag/list",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $25741316cc57a66f$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false
    },
    {
        path: "company/:company/ai/llm-rag/:brainId",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $521ebf6c2a758b5f$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false
    },
    {
        path: "company/:company/ai/llm-rag/chat/:chatId",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4ce7a80c690a8f39$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false
    },
    {
        path: "company/:company/ai/llm-rag/chat/history",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1c43d34b12e646e0$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false
    }
];
var $fdb67506168be5f0$export$2e2bcd8739ae039 = $fdb67506168be5f0$var$routes;







var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");







parcelRequire("bh6RR");










var $a143dfbca7d213e3$var$style = {
    color: "var(--main)",
    marginLeft: "10px"
};
const $a143dfbca7d213e3$export$f797c5ce3990b530 = [
    {
        value: 2,
        title: "Global",
        icon: "fas fa-globe" // global
    },
    {
        value: 1,
        title: "Admins",
        icon: "fas fa-users-cog" // admins
    },
    {
        value: 0,
        title: "Perso",
        icon: "fas fa-low-vision" // perso
    }
];
const $a143dfbca7d213e3$var$getIconDataByView = (indexView)=>{
    return $a143dfbca7d213e3$export$f797c5ce3990b530.find((icon)=>icon.value === indexView);
};
const $a143dfbca7d213e3$export$36fd7c526ffac799 = (title)=>{
    return $a143dfbca7d213e3$export$f797c5ce3990b530.find((row)=>row.title === title)?.value;
};
const $a143dfbca7d213e3$export$f3e48cc30b892ad7 = (indexView)=>{
    return $a143dfbca7d213e3$var$getIconDataByView(indexView)?.icon;
};
const $a143dfbca7d213e3$export$c3a0cf9b71d003fa = (indexView)=>{
    return $a143dfbca7d213e3$var$getIconDataByView(indexView)?.title;
};
const $a143dfbca7d213e3$export$86b35c3aa76c497d = [
    {
        value: $a143dfbca7d213e3$export$c3a0cf9b71d003fa(2),
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                "Global ",
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    class: $a143dfbca7d213e3$export$f3e48cc30b892ad7(2),
                    style: $a143dfbca7d213e3$var$style
                }),
                " "
            ]
        }) // global
    },
    {
        value: $a143dfbca7d213e3$export$c3a0cf9b71d003fa(1),
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                "Admins ",
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    class: $a143dfbca7d213e3$export$f3e48cc30b892ad7(1),
                    style: $a143dfbca7d213e3$var$style
                }),
                " "
            ]
        }) // admins
    },
    {
        value: $a143dfbca7d213e3$export$c3a0cf9b71d003fa(0),
        text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
            children: [
                "Perso ",
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                    class: $a143dfbca7d213e3$export$f3e48cc30b892ad7(0),
                    style: $a143dfbca7d213e3$var$style
                }),
                " "
            ]
        }) // perso
    }
];





var $451fb6505c494753$export$2e2bcd8739ae039 = {
    getMemos: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("memos", data),
    addMemo: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).post(`memo`, data),
    editMemo: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).put(`memo/${id}`, data),
    deleteMemo: (id, data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).delete(`memo/${id}`, data),
    getCategories: (data)=>(0, $04e377a52ef60d56$export$2e2bcd8739ae039).get("memos/categories", data)
};




var $bh6RR = parcelRequire("bh6RR");

function $87c19e73883f5bbf$var$useMemoCategories() {
    const [categories, setCategories] = (0, $bh6RR.useState)([]);
    const { getCategories: getCategories } = (0, $451fb6505c494753$export$2e2bcd8739ae039);
    const getAllCategories = async ()=>{
        let [response, error] = await getCategories();
        if (error !== null) {
            console.log(error);
            return;
        }
        setCategories(setUpCategories(response));
    };
    const setUpCategories = (_categories)=>_categories.map((category)=>{
            return {
                value: category.id,
                text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                    style: {
                        maxWidth: "200px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                            style: {
                                marginLeft: "10px",
                                color: category.color
                            },
                            className: category.icon
                        }),
                        " "
                    ]
                })
            };
        });
    const addFirstRow = (row)=>{
        setCategories((data)=>[
                row,
                ...data
            ]);
    };
    (0, $bh6RR.useEffect)(()=>{
        getAllCategories();
    }, []);
    return {
        categories: categories,
        addFirstRow: addFirstRow
    };
}
var $87c19e73883f5bbf$export$2e2bcd8739ae039 = $87c19e73883f5bbf$var$useMemoCategories;


const $bfb29f975a8863d6$var$MemoFormModal = (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).create(({ mode: mode = "edit", memo: memo, view: view })=>{
    const modal = (0, $36c8369d2da2c3c8$export$33ffd74ebf07f060)();
    const { onClose: onClose } = (0, $588bd62b5d9ae093$export$2e2bcd8739ae039)(modal);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const { categories: categories } = (0, $87c19e73883f5bbf$export$2e2bcd8739ae039)();
    const { addMemo: addMemo, editMemo: editMemo } = (0, $451fb6505c494753$export$2e2bcd8739ae039);
    const isCreateMode = mode == "create";
    const title = isCreateMode ? "Add" : "Edit";
    const { register: register, handleSubmit: handleSubmit, getValues: getValues, setValue: setValue, watch: watch, clearErrors: clearErrors, formState: { errors: errors }, formState: formState, setError: setError } = (0, $ee9f4a2880885da1$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: {
            "name": memo ? memo.name : "Title",
            "description": memo ? memo.description : "Content",
            "view": memo ? memo.view.view : view != null ? view : 2,
            "category_id": memo ? memo.category_id : 1
        }
    });
    const onSubmit = async ()=>{
        let dataToSend = getValues();
        let memoAction = isCreateMode ? addMemo : editMemo;
        let params = isCreateMode ? [
            dataToSend
        ] : [
            memo.id,
            dataToSend
        ];
        const [response, error] = await memoAction(...params);
        if (error !== null) {
            console.log(error);
            toast.error("Error", error.data);
            onClose();
            return;
        }
        modal.resolve(response);
        toast.success("Memo " + (!isCreateMode ? " edited" : " added"), "The memo has been " + (!isCreateMode ? "edited !" : "added ! "));
        onClose();
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e3f638d04018c279$export$2e2bcd8739ae039), {
        id: modal.id,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "leave-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "button-leave",
                    id: "close_modal_container",
                    onClick: ()=>onClose({
                            idIconModal: "close_modal_container"
                        }),
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        id: "close_modal",
                        className: "fa fa-times",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039), {
                onSubmit: handleSubmit(onSubmit),
                className: "memo_form",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Title, {
                        children: title + " Memo"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Body, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "content_form_memo",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "container_row_dropdown_memo",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "View mode",
                                            listLabelClassName: "titles-input"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            className: "memo_form_container_dropdown",
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                                ...register("view"),
                                                setValue: (name, value)=>setValue(name, (0, $a143dfbca7d213e3$export$36fd7c526ffac799)(value)),
                                                choices: (0, $a143dfbca7d213e3$export$86b35c3aa76c497d),
                                                width: "200px",
                                                defaultChoice: (0, $a143dfbca7d213e3$export$c3a0cf9b71d003fa)(isCreateMode ? view != null ? view : 2 : memo.view.view)
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "container_row_dropdown_memo",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $174898365ac03a05$export$2e2bcd8739ae039), {
                                            label: "Category",
                                            listLabelClassName: "titles-input"
                                        }),
                                        Array.isArray(categories) && categories.length > 0 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            className: "memo_form_container_dropdown",
                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                                ...register("category_id"),
                                                setValue: (name, value)=>setValue(name, value),
                                                choices: categories,
                                                width: "200px",
                                                defaultChoice: isCreateMode ? 0 : memo.category_id
                                            })
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $3df48224cec6bb9c$export$2e2bcd8739ae039).Buttons, {
                        className: "memo_form_space_buttons",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                type: "button",
                                label: "Cancel",
                                className: "button cancel",
                                onClick: onClose
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $06d28f450b1ec943$export$2e2bcd8739ae039), {
                                type: "submit",
                                label: "Ok",
                                className: "validate  btn-center",
                                disabled: !formState.isValid
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
var $bfb29f975a8863d6$export$2e2bcd8739ae039 = $bfb29f975a8863d6$var$MemoFormModal;








function $c6088f0659a1a81e$export$967b3d29ab7e7f53(bool) {
    $c6088f0659a1a81e$var$setMemoDataByKey("isClassified", bool);
}
function $c6088f0659a1a81e$export$f099cbeb3645932c(memo_id) {
    let favorites = $c6088f0659a1a81e$export$e44e633ae5a397ce()?.favorites;
    if (favorites == null) favorites = [];
    favorites = [
        ...favorites,
        memo_id
    ];
    $c6088f0659a1a81e$var$setMemoDataByKey("favorites", favorites);
}
function $c6088f0659a1a81e$export$d3c93dcdb44ec587(memo_id) {
    let favorites = $c6088f0659a1a81e$export$e44e633ae5a397ce().favorites;
    favorites = favorites.filter((id)=>id !== memo_id);
    $c6088f0659a1a81e$var$setMemoDataByKey("favorites", favorites);
}
function $c6088f0659a1a81e$export$e215ec00438c15af(memo_id) {
    return $c6088f0659a1a81e$export$e44e633ae5a397ce()?.favorites?.find((id)=>id === memo_id);
}
function $c6088f0659a1a81e$export$1bf436fcbb9a22b4(view, isOpen) {
    $c6088f0659a1a81e$var$setMemoDataByKey((0, $a143dfbca7d213e3$export$c3a0cf9b71d003fa)(view), isOpen);
}
function $c6088f0659a1a81e$export$e15e5d87ae46ceab(view) {
    return $c6088f0659a1a81e$export$e44e633ae5a397ce() != null ? $c6088f0659a1a81e$export$e44e633ae5a397ce()[(0, $a143dfbca7d213e3$export$c3a0cf9b71d003fa)(view)] : null;
}
function $c6088f0659a1a81e$var$setUserParameters(memo_datas) {
    return (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").set("user_memo", memo_datas);
}
function $c6088f0659a1a81e$var$setMemoDataByKey(key, value) {
    let currentData = $c6088f0659a1a81e$export$e44e633ae5a397ce();
    if (currentData == null) currentData = {};
    currentData[key] = value;
    $c6088f0659a1a81e$var$setUserParameters(currentData);
}
function $c6088f0659a1a81e$export$e44e633ae5a397ce() {
    return (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("user_memo");
}


function $f709abe918b1ba20$var$MemoCard({ memo: memo, mode: mode = "edit", view: view, postbackAction: postbackAction, postbackFavorites: postbackFavorites, isFav: isFav }) {
    const IS_CREATING_MODE = mode == "create";
    let _data = {
        title: memo ? memo.name : "Title",
        content: memo ? memo.description : "Content",
        createdAt: memo ? (0, $df9ad4654a227866$export$3ae94a2503e890a1)(memo.created_at) : "",
        color: memo ? memo.category.color : "#0e7aed",
        iconCategory: memo ? memo.category.icon : "fas fas-lightbulb"
    };
    const [data, setData] = (0, $bh6RR.useState)(_data);
    const ref = (0, $bh6RR.useRef)();
    const ref_fav = (0, $bh6RR.useRef)(memo?.id);
    const [isFavorite, setIsFavorite] = (0, $bh6RR.useState)(isFav);
    const [isHovering, setHovering] = (0, $bh6RR.useState)(false);
    const [typingTimer, setTypingTimer] = (0, $bh6RR.useState)(null);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const { editMemo: editMemo, deleteMemo: deleteMemo } = (0, $451fb6505c494753$export$2e2bcd8739ae039);
    const ref_title = (0, $bh6RR.useRef)(memo?.id + "_title");
    const ref_content = (0, $bh6RR.useRef)(memo?.id + "_content");
    const onClickAddFavorite = ()=>{
        if (!isFavorite == true) (0, $c6088f0659a1a81e$export$f099cbeb3645932c)(memo.id);
        else (0, $c6088f0659a1a81e$export$d3c93dcdb44ec587)(memo.id);
        setIsFavorite(!isFavorite);
        postbackFavorites();
    };
    const onClickDelete = async ()=>{
        var name = data.title;
        await (0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $defe4a8e979bd5d1$export$2e2bcd8739ae039), {
            title: "Delete memo " + name,
            body: "Do you really want to delete the memo " + name + " ?",
            api: {
                request: deleteMemo,
                param: [
                    memo.id
                ]
            },
            buttons: [
                {
                    className: "validate",
                    label: "Cancel",
                    style: {
                        marginRight: "20px"
                    }
                },
                {
                    className: "cancel",
                    label: "Delete",
                    type: "submit"
                }
            ]
        }).then(()=>deleteAction());
    };
    const deleteAction = ()=>{
        toast.success("Success", "The memo has been deleted");
        postbackAction();
    };
    const onClickUpdate = ()=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $bfb29f975a8863d6$export$2e2bcd8739ae039), {
            memo: memo
        }).then(()=>postbackAction());
    const onClickAdd = ()=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $bfb29f975a8863d6$export$2e2bcd8739ae039), {
            mode: mode,
            view: view
        }).then(()=>postbackAction());
    const hexToRGB = (hex, opacity = 0.2)=>{
        var r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g},${b}, ${opacity})`;
    };
    const getDescriptionWithUrls = ()=>{
        const links = ref_content.current.querySelectorAll("a");
        let fullText = ref_content.current.textContent;
        // Remplacer chaque domaine visible par l'URL complète pour obtenir le texte brut
        links.forEach((link)=>{
            const domain = link.textContent;
            const fullUrl = link.getAttribute("data-url");
            fullText = fullText.replace(domain, fullUrl);
        });
        return fullText;
    };
    const saveData = ()=>{
        let descriptionWithUrl = getDescriptionWithUrls();
        let dataToSend = {
            name: ref_title.current.textContent.trim(),
            description: descriptionWithUrl.trim()
        };
        clearTimeout(typingTimer);
        setTypingTimer(setTimeout(async ()=>{
            let [response, error] = await editMemo(memo.id, dataToSend);
            if (error !== null) {
                console.log(error);
                toast.error("Error", error.data);
                return;
            }
            toast.success("Memo's updated", "The value of the memo has been updated !", 5000);
            postbackAction();
        }, 1500));
    };
    const handleLinkClick = (event)=>{
        event.preventDefault();
        const url = event.target.getAttribute("data-url");
        window.open(url);
    };
    const clearContent = (txt)=>{
        const urlRegex = /(https?:\/\/(?:www\.)?([^\s/$.?#].[^\s]*))/gi;
        const newContent = txt.replace(urlRegex, (match, url, domain)=>{
            return `<a href="${url}" style="color: ${data.color};cursor: pointer" title=${url} target="_blank" rel="noopener noreferrer" data-url="${url}">${domain}</a>`;
        });
        ref_content.current.innerHTML = newContent;
        const links = ref_content.current.querySelectorAll("a");
        links.forEach((link)=>{
            link.addEventListener("click", handleLinkClick);
        });
    };
    (0, $bh6RR.useEffect)(()=>{
        if (memo != null) clearContent(memo.description);
    }, [
        memo
    ]);
    const separator = /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "memo_separator",
        style: {
            backgroundImage: `linear-gradient(to right, ${hexToRGB(data.color, 0.2)}, ${hexToRGB(data.color, 0)}, ${hexToRGB(data.color, 0.2)})`
        }
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        id: memo?.id + "v-",
        ref: ref,
        className: "memo_card memo_scrollable_container",
        style: {
            backgroundColor: hexToRGB(data.color)
        },
        onMouseEnter: ()=>{
            setHovering(true);
        },
        onMouseLeave: ()=>{
            setHovering(false);
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "memo_corner",
                style: {
                    borderLeftColor: hexToRGB(data.color)
                }
            }),
            !IS_CREATING_MODE ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                style: {
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        className: "memo_category_icon " + data.iconCategory,
                        style: {
                            color: data.color
                        },
                        title: memo.category.name,
                        "aria-hidden": "true"
                    }),
                    (isHovering || isFavorite) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                        ref: ref_fav,
                        className: "memo_favorite_icon " + (isFavorite ? "fas" : "far") + " fa-star",
                        style: {
                            color: data.color
                        },
                        "aria-hidden": "true",
                        onClick: ()=>onClickAddFavorite()
                    }, memo.id),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "memo_title_container",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            ref: ref_title,
                            contentEditable: true,
                            spellCheck: "false",
                            className: "memo_title",
                            suppressContentEditableWarning: true,
                            onInput: ()=>{
                                saveData();
                            },
                            children: [
                                " ",
                                data.title
                            ]
                        })
                    }),
                    separator,
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "memo_content_container",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                            ref: ref_content,
                            contentEditable: true,
                            spellCheck: "false",
                            className: "memo_content",
                            suppressContentEditableWarning: true,
                            onInput: ()=>{
                                saveData();
                            },
                            children: [
                                " ",
                                data.content
                            ]
                        })
                    }),
                    separator,
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "memo_footer_container",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("i", {
                                className: "memo_icon_view " + (0, $a143dfbca7d213e3$export$f3e48cc30b892ad7)(memo.view.view),
                                title: (0, $a143dfbca7d213e3$export$c3a0cf9b71d003fa)(memo.view.view),
                                style: {
                                    color: data.color
                                },
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "memo_date_creation",
                                children: [
                                    " ",
                                    data.createdAt
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "memo_options_container",
                                style: {
                                    display: isHovering ? "" : "none"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                        className: "main-iconButton add-hover",
                                        style: {
                                            color: data.color
                                        },
                                        icon: "fas fa-cog",
                                        onClick: onClickUpdate
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                        className: "main-iconButton remove-hover",
                                        style: {
                                            color: data.color
                                        },
                                        icon: "fas fa-trash",
                                        onClick: onClickDelete
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "add_memo_container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                    className: "main-iconButton memo_hover_add",
                    style: {
                        color: data.color
                    },
                    icon: "fas fa-plus",
                    onClick: onClickAdd
                })
            })
        ]
    }, "mc-" + memo?.id + ref);
}
var $f709abe918b1ba20$export$2e2bcd8739ae039 = $f709abe918b1ba20$var$MemoCard;



var $bh6RR = parcelRequire("bh6RR");

function $91e9f588f19aa686$export$36c771104581d4ac(view_type) {
    const [data, setData] = (0, $bh6RR.useState)((0, $c6088f0659a1a81e$export$e15e5d87ae46ceab)(view_type));
    const [animationMemo, setAnimationMemo] = (0, $bh6RR.useState)(data === true || data == null ? "" : "hide_memo");
    const [rotateChevron, setRotateChevron] = (0, $bh6RR.useState)(data != null ? !data : false);
    const openMemo = async ()=>{
        (0, $c6088f0659a1a81e$export$1bf436fcbb9a22b4)(view_type, rotateChevron);
        setRotateChevron(!rotateChevron);
        let css = !rotateChevron ? "hide_memo" : "";
        setAnimationMemo(css);
    };
    return {
        animationMemo: animationMemo,
        openMemo: openMemo,
        rotateChevron: rotateChevron
    };
}




function $17f7e3b8f1e817d4$var$MemosList({ data: data, title: title, postbackAction: postbackAction, view: view }) {
    const { animationMemo: animationMemo, rotateChevron: rotateChevron, openMemo: openMemo } = (0, $91e9f588f19aa686$export$36c771104581d4ac)(view);
    const rotate = rotateChevron ? "close_style_memo " : "open_style_memo ";
    const [memos, setMemos] = (0, $bh6RR.useState)(data);
    const [memosSorted, setMemosSorted] = (0, $bh6RR.useState)(data);
    const ref = (0, $bh6RR.useRef)();
    const arrangeListWithFavs = ()=>{
        let favorites = memos.filter((m)=>(0, $c6088f0659a1a81e$export$e215ec00438c15af)(m.id)).sort((a, b)=>new Date(b.created_at) - new Date(a.created_at));
        let notFavs = memos.filter((m)=>!(0, $c6088f0659a1a81e$export$e215ec00438c15af)(m.id)).sort((a, b)=>new Date(b.created_at) - new Date(a.created_at));
        setMemosSorted([
            ...favorites,
            ...notFavs
        ]);
    };
    (0, $bh6RR.useEffect)(()=>{
        setMemos([
            ...data
        ]);
    }, [
        data
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (memos != null) arrangeListWithFavs();
    }, [
        memos
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "memo_list_title",
                children: view != null && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "block_title",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                openMemo();
                            },
                            className: "main-iconButton profil_action main_add-button space_tableButton dashboard_button",
                            icon: "fas fa-chevron-right " + rotate
                        }, "buttonOpen"),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "dashboard_title",
                            onClick: ()=>{
                                openMemo();
                            },
                            children: title
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "memos_list_container " + animationMemo,
                ref: ref,
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f709abe918b1ba20$export$2e2bcd8739ae039), {
                        mode: "create",
                        view: view,
                        postbackAction: postbackAction
                    }, "create-memo-key" + view),
                    memosSorted != null && memosSorted.map((memo, i)=>{
                        let isFavorite = (0, $c6088f0659a1a81e$export$e215ec00438c15af)(memo.id);
                        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f709abe918b1ba20$export$2e2bcd8739ae039), {
                            memo: memo,
                            postbackAction: postbackAction,
                            postbackFavorites: arrangeListWithFavs,
                            isFav: isFavorite
                        }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)());
                    })
                ]
            })
        ]
    });
}
var $17f7e3b8f1e817d4$export$2e2bcd8739ae039 = $17f7e3b8f1e817d4$var$MemosList;









var $5c62fe6677fd8110$exports = {};
$5c62fe6677fd8110$exports = new URL("tag.4f530a2b.svg", import.meta.url).toString();




function $1b7de76b0dc7055b$var$Memos() {
    const { getMemos: getMemos } = (0, $451fb6505c494753$export$2e2bcd8739ae039);
    const sortList = (data)=>{
        return data.sort((a, b)=>{
            return new Date(b.updated_at) - new Date(a.updated_at);
        });
    };
    const [data, setData] = (0, $bh6RR.useState)([]);
    const { categories: categories, addFirstRow: addFirstRow } = (0, $87c19e73883f5bbf$export$2e2bcd8739ae039)();
    const [memosPrinted, setMemosPrinted] = (0, $bh6RR.useState)([]);
    const [classifiedMode, setClassifiedMode] = (0, $bh6RR.useState)((0, $c6088f0659a1a81e$export$e44e633ae5a397ce)() ? (0, $c6088f0659a1a81e$export$e44e633ae5a397ce)().isClassified : false); // true = Classified, false = Global
    const [filter, setFilter] = (0, $bh6RR.useState)({
        search: "",
        category: ""
    });
    const setUpData = async ()=>{
        const [response, errors] = await getMemos();
        if (errors != null) {
            console.log(errors);
            return;
        }
        setData(sortList(response));
        setData(response);
        setMemosPrinted(response);
    };
    const setUpMemosPrinted = ()=>{
        var res = data;
        if (filter.category != 0) res = res.filter((memo)=>memo.category.id == filter.category);
        if (filter.search != "") res = res.filter((memo)=>memo.name.toLowerCase().includes(filter.search) || memo.description.toLowerCase().includes(filter.search));
        setMemosPrinted([
            ...res
        ]);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (data != null) setUpData();
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        if (categories.length > 0 && categories[0].value != 0) addFirstRow({
            value: 0,
            text: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                style: {
                    maxWidth: "200px"
                },
                children: "All"
            })
        });
    }, [
        categories
    ]);
    const switchButton = ()=>{
        (0, $c6088f0659a1a81e$export$967b3d29ab7e7f53)(!classifiedMode);
        setClassifiedMode(!classifiedMode);
    };
    const changeCategory = (value)=>{
        setFilter({
            ...filter,
            category: value
        });
    };
    const research = async (value)=>{
        setFilter({
            ...filter,
            search: value.toLowerCase()
        });
    };
    (0, $bh6RR.useEffect)(()=>{
        setUpMemosPrinted();
    }, [
        filter
    ]);
    const getDataByViewType = (viewType)=>{
        return memosPrinted.filter((memo)=>memo.view.view == viewType);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "memo_page_container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "container_parameters_memo",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "input_memo_search",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b8b90ec975873f14$export$2e2bcd8739ae039), {
                                    placeholderLibelle: "content",
                                    onChange: (e)=>research(e.target.value)
                                })
                            }),
                            Array.isArray(categories) && categories.length > 0 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $161312200a6f79f6$export$2e2bcd8739ae039), {
                                className: "dropdown_category_memo_search",
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($5c62fe6677fd8110$exports))),
                                setValue: (name, value)=>changeCategory(value),
                                choices: categories,
                                width: "200px"
                            }) : null,
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $91ecd156adcbdc22$export$2e2bcd8739ae039), {
                                className: "main-iconButton profil_action main_add-button space_tableButton memo_button_ordering",
                                title: "Switch to " + (classifiedMode ? "Global" : "Classified") + " mode",
                                icon: classifiedMode ? "fas fa-list-alt" : "fas fa-sitemap",
                                onClick: ()=>switchButton()
                            }, "buttonMemoGroup")
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        children: [
                            classifiedMode ? (0, $a143dfbca7d213e3$export$f797c5ce3990b530).map((type, index)=>{
                                if ((0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("user").is_admin == false && type.value == 1) return;
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $17f7e3b8f1e817d4$export$2e2bcd8739ae039), {
                                    title: type.title + " section",
                                    view: type.value,
                                    data: getDataByViewType(type.value),
                                    postbackAction: setUpData
                                }, index);
                            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $17f7e3b8f1e817d4$export$2e2bcd8739ae039), {
                                title: "Company Memos",
                                data: memosPrinted,
                                type: "bots",
                                postbackAction: setUpData
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {})
                        ]
                    })
                ]
            })
        ]
    });
}
var $1b7de76b0dc7055b$export$2e2bcd8739ae039 = $1b7de76b0dc7055b$var$Memos;



function $79c58b8e95a3fd21$var$MemosPage() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $09ce86192bc64e9b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $87df71fcaf55612a$export$2e2bcd8739ae039), {
                title: "List of Memos"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1b7de76b0dc7055b$export$2e2bcd8739ae039), {})
        ]
    });
}
var $79c58b8e95a3fd21$export$2e2bcd8739ae039 = $79c58b8e95a3fd21$var$MemosPage;


const $af7df900e605d83b$var$routes = [
    {
        path: "company/:company/memos",
        component: ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $79c58b8e95a3fd21$export$2e2bcd8739ae039), {}),
        isSidebar: true,
        isPublic: false
    }
];
var $af7df900e605d83b$export$2e2bcd8739ae039 = $af7df900e605d83b$var$routes;


var $c2bf1c0139183290$export$2e2bcd8739ae039 = [
    ...(0, $c11fd52bdac0a00c$export$2e2bcd8739ae039),
    ...(0, $e821820b6d05b6dc$export$2e2bcd8739ae039),
    ...(0, $c074ccffdc32a79f$export$2e2bcd8739ae039),
    ...(0, $cbdd1ee87275a7c8$export$2e2bcd8739ae039),
    ...(0, $2bde61d945d4c1bb$export$2e2bcd8739ae039),
    ...(0, $281d11e810535ce5$export$2e2bcd8739ae039),
    ...(0, $0a051dc162399f74$export$2e2bcd8739ae039),
    ...(0, $9e8491672d0f3b27$export$2e2bcd8739ae039),
    ...(0, $d8940df0f6e1e717$export$2e2bcd8739ae039),
    ...(0, $50b2ac115c40ff2e$export$2e2bcd8739ae039),
    ...(0, $4088befe0edd7f7f$export$2e2bcd8739ae039),
    ...(0, $f83e68e4012526ca$export$2e2bcd8739ae039),
    ...(0, $fdb67506168be5f0$export$2e2bcd8739ae039),
    ...(0, $af7df900e605d83b$export$2e2bcd8739ae039)
];








var $bh6RR = parcelRequire("bh6RR");


function $cf0a5be541c6f925$var$WrapperTitle({ route: route }) {
    const Component = route.component;
    (0, $bh6RR.useEffect)(()=>{
        if (route.path == "*" || route.path == "/") {
            document.title = "Error";
            return;
        }
        var company = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company");
        const paths = [
            ...window.location.pathname.split("/")
        ].filter((piece)=>piece);
        var mainPart = paths.length >= 3 ? paths[1] : paths[0];
        mainPart = (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(mainPart);
        const lastPart = (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(paths[paths.length - 1]);
        var title = mainPart == lastPart ? mainPart : `${mainPart} - ${lastPart}`;
        title = `${title} | ${company ? company.name : " TALKR.ai"}`;
        document.title = decodeURI(title);
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)(Component, {});
}
var $cf0a5be541c6f925$export$2e2bcd8739ae039 = $cf0a5be541c6f925$var$WrapperTitle;





var $bh6RR = parcelRequire("bh6RR");


function $6714c639209960b1$var$useRequireAuth({ children: children }) {
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const [ready, setReady] = (0, $bh6RR.useState)(false);
    const params = new URLSearchParams(location.search);
    const sessionCode = params.get("session");
    (0, $bh6RR.useEffect)(()=>{
        if (!sessionCode) {
            setReady(true);
            return;
        }
        const exchange = async ()=>{
            const response = await fetch((0, $651df53b10514175$export$a7b6bc01c63cdfc3).REACT_APP_API_PATH + "/auth/session/" + sessionCode);
            const data = await response.json();
            if (response.ok) {
                (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").set("token", data.token);
                (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").set("refresh_token", data.refresh_token);
                (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").set("user", data.user);
                (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").set("company", data.company);
                (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").set("permissions", data.permissions);
            }
            navigate(location.pathname, {
                replace: true
            });
            setReady(true);
        };
        exchange();
    }, []);
    if (!ready) return null;
    if (localStorage.getItem("token") == null) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a9dcc96d11bcd0d$export$444b3ab0cb9aec40), {
        to: "/login",
        state: {
            from: location.pathname
        }
    });
    return children;
}
var $6714c639209960b1$export$2e2bcd8739ae039 = $6714c639209960b1$var$useRequireAuth;




var $bh6RR = parcelRequire("bh6RR");




function $ee326bdb126f3507$var$updateUser({ children: children, permissions: permissions }) {
    const [isLoaded, setIsLoaded] = (0, $bh6RR.useState)(false);
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    // Disable the return to enable resfh user each time you change page
    const dispatch = (0, $373f9505ebba8636$export$a03a56d03840936f)();
    (0, $bh6RR.useEffect)(()=>{
        var isUserInfo = true;
        const fetchData = async ()=>{
            const data = await (0, $575009abb68f6393$export$2e2bcd8739ae039).refreshUserInformation();
            if (!isUserInfo) return;
            if (!data) {
                (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").remove("user");
                (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").remove("token");
                (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").remove("refresh_token");
                dispatch({
                    type: "loginOut"
                });
                navigate("/login");
                return;
            }
            const { user: user, company: company, permissions: permissions } = data;
            (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").set("user", user);
            (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").set("company", company);
            (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").set("permissions", permissions);
            dispatch({
                type: "refreshUserInfo",
                payload: {
                    user: user,
                    token: (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("token")
                }
            });
            setIsLoaded(true);
        };
        fetchData().catch((err)=>console.error(err));
        return ()=>isUserInfo = false;
    }, [
        dispatch
    ]);
    if (!isLoaded) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
    if (permissions.length > 0 && !permissions.some((perm)=>(0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("permissions").includes(perm))) navigate("/404");
    return children;
}
var $ee326bdb126f3507$export$2e2bcd8739ae039 = $ee326bdb126f3507$var$updateUser;


function $73dfb228ee8fc095$var$BuilderRoute(route, index) {
    const Component = ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cf0a5be541c6f925$export$2e2bcd8739ae039), {
            route: route
        });
    const Page = ({ isPublic: isPublic })=>{
        if (isPublic) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)(Component, {});
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6714c639209960b1$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ee326bdb126f3507$export$2e2bcd8739ae039), {
                permissions: route.permissions ?? [],
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)(Component, {})
            })
        });
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6), {
        path: route.path,
        isSidebar: route.isSidebar,
        element: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)(Page, {
            isPublic: route.isPublic
        })
    }, index);
}
var $73dfb228ee8fc095$export$2e2bcd8739ae039 = $73dfb228ee8fc095$var$BuilderRoute;






var $f3faa83a378cef27$exports = {};
$f3faa83a378cef27$exports = new URL("logo-grey.d0489c93.png", import.meta.url).toString();





function $79ffe7889d651d17$var$Header() {
    const { user: user } = (0, $373f9505ebba8636$export$ea6ddbd83f749864)();
    //const storage = Storage('local').get("user");
    const storage = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company");
    var logo = storage?.logo;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "header",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0bd3411f2ec14e23$export$b0d92dbee9b5b60d), {
                to: "/user/no-company",
                target: user?.external_id || (0, $5c7e3cd8d8b7b66b$export$3b31a91e69d9331)() ? "_self" : "_blank",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                    style: {
                        marginLeft: 2.5
                    },
                    src: logo ? logo : null,
                    className: "logo-talkr"
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                children: "Platform"
            })
        ]
    });
}
var $79ffe7889d651d17$export$2e2bcd8739ae039 = $79ffe7889d651d17$var$Header;





function $cbea85f38851e325$var$Part({ name: name, isActive: isActive, children: children, isSelected: isSelected }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "part" + (name ? " " + name : ""),
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: isActive ? "parent_block active" : "parent_block",
                style: isSelected ? {
                    backgroundColor: "var(--main)"
                } : {}
            }),
            children
        ]
    });
}
var $cbea85f38851e325$export$2e2bcd8739ae039 = $cbea85f38851e325$var$Part;






var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
function $f06d369d7586d9ee$var$useSection(value = null) {
    const [section, setSection] = (0, $bh6RR.useState)(value);
    const setSectionTroughtEventClick = (event)=>{
        const el = event.target;
        const value = el.getAttribute("data-name");
        setSection(section == value ? null : value);
    };
    return [
        section,
        setSection,
        setSectionTroughtEventClick
    ];
}
var $f06d369d7586d9ee$export$2e2bcd8739ae039 = $f06d369d7586d9ee$var$useSection;


const $926684d85dc2d995$var$SectionContext = /*#__PURE__*/ (0, $bh6RR.createContext)();
function $926684d85dc2d995$var$SectionContextProvider({ children: children }) {
    const [section, setSection, setSectionTroughtEventClick] = (0, $f06d369d7586d9ee$export$2e2bcd8739ae039)(null);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($926684d85dc2d995$var$SectionContext.Provider, {
        value: {
            section: section,
            setSection: setSection,
            setSectionTroughtEventClick: setSectionTroughtEventClick
        },
        children: children
    });
}
var $926684d85dc2d995$export$2e2bcd8739ae039 = $926684d85dc2d995$var$SectionContextProvider;
const $926684d85dc2d995$export$a3931362f3958630 = ()=>(0, $bh6RR.useContext)($926684d85dc2d995$var$SectionContext);




function $c499fc00e37fb13a$var$ListPart({ data: data, name: name, numberOfData: numberOfData, plural: plural, svgName: svgName, path: path, label: label }) {
    const { section: section, setSectionTroughtEventClick: setSectionTroughtEventClick } = (0, $926684d85dc2d995$export$a3931362f3958630)();
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    label = label ? label : name;
    const labelPlural = plural ? label + "s" : label;
    const searchUrl = location.pathname.substring(0, location.pathname.lastIndexOf("/"));
    const isSelected = searchUrl.includes(`${name}`) || searchUrl.includes(`${labelPlural}`);
    const isActive = section == name;
    const createLink = (link)=>{
        return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0bd3411f2ec14e23$export$b0d92dbee9b5b60d), {
            to: link.url,
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                className: decodeURI(location.pathname) == link.url ? "current-page" : "child_btn",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        children: (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(link.name)
                    })
                })
            })
        }, (0, $83ec58cdee3d9422$export$2e2bcd8739ae039)());
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cbea85f38851e325$export$2e2bcd8739ae039), {
        isActive: isActive,
        isSelected: isSelected,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: `container-part ${isSelected ? "selected" : ""}`,
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "category index",
                    onClick: setSectionTroughtEventClick,
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "click-detector",
                            "data-name": name
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "svg " + (svgName != null ? svgName : name)
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                            className: "parent_txt",
                            children: [
                                (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(labelPlural),
                                " ",
                                numberOfData ? "(" + numberOfData + ")" : ""
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: `svg arrow ${isActive ? "reverse" : ""}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: `sidebar-list ${isActive ? "active" : ""}`,
                    children: data && data.map((link)=>createLink(link))
                })
            ]
        })
    });
}
$c499fc00e37fb13a$var$ListPart.defaultProps = {
    numberOfData: 0,
    plural: true
};
var $c499fc00e37fb13a$export$2e2bcd8739ae039 = $c499fc00e37fb13a$var$ListPart;









function $44d12f602941aba4$var$LinkPart({ name: name, url: url, label: label, externalLink: externalLink, plural: plural, numberOfData: numberOfData }) {
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    const { setSectionTroughtEventClick: setSectionTroughtEventClick } = (0, $926684d85dc2d995$export$a3931362f3958630)();
    const _url = externalLink != null ? externalLink : url;
    const match = location.pathname.match(`${_url}`);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cbea85f38851e325$export$2e2bcd8739ae039), {
        isSelected: match,
        name: name,
        children: externalLink == null ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0bd3411f2ec14e23$export$b0d92dbee9b5b60d), {
            to: _url,
            className: match ? "selected" : "",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "click-detector",
                        onClick: setSectionTroughtEventClick
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "svg " + name
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                        className: "parent_txt home_txt",
                        children: [
                            (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(label ? label : name) + (plural ? "s" : ""),
                            " ",
                            numberOfData != null && numberOfData > 0 ? "(" + numberOfData + ")" : ""
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            className: match ? "selected" : "",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                href: _url,
                target: (0, $5c7e3cd8d8b7b66b$export$3b31a91e69d9331)() ? "_self" : "_blank",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "click-detector",
                            onClick: setSectionTroughtEventClick
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "svg " + name
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                            className: "parent_txt home_txt",
                            children: [
                                (0, $8c1b7af6bdc5aba6$export$2e2bcd8739ae039)(label ? label : name),
                                " "
                            ]
                        })
                    ]
                })
            })
        })
    });
}
var $44d12f602941aba4$export$2e2bcd8739ae039 = $44d12f602941aba4$var$LinkPart;









function $d2d1ef0e4680c653$var$Footer() {
    const { user: user } = (0, $373f9505ebba8636$export$ea6ddbd83f749864)();
    const naviguate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const dispatch = (0, $373f9505ebba8636$export$a03a56d03840936f)();
    const showLogoutModal = ()=>(0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).show((0, $ce8e79713883c54a$export$2e2bcd8739ae039)).then(()=>{
            (0, $b6b235c5b8c1f5b6$export$4f7ec04666a44a3f)("conversation_filters");
            sessionStorage.removeItem("user");
            localStorage.removeItem("token");
            dispatch({
                type: "loginOut"
            });
            naviguate("/login");
        });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "footer",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "user",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0bd3411f2ec14e23$export$b0d92dbee9b5b60d), {
                    to: "user/settings",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        className: "user-image",
                        src: user.picture
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0bd3411f2ec14e23$export$b0d92dbee9b5b60d), {
                        to: "user/settings",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("var", {
                            "data-var": "user-name",
                            id: "user-name",
                            children: user.username
                        })
                    })
                }),
                !user?.external_id && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    id: "sidebar-disconnect",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "svg logout",
                        onClick: showLogoutModal
                    })
                })
            ]
        })
    });
}
var $d2d1ef0e4680c653$export$2e2bcd8739ae039 = $d2d1ef0e4680c653$var$Footer;








function $bf278ee2b7c2a5e1$var$checkPelletByTime(obj, time) {
    const updatedAt = new Date(obj.updated_at);
    const now = new Date();
    const res = new Date(now.getTime() - time);
    return updatedAt >= res;
}
var $bf278ee2b7c2a5e1$export$2e2bcd8739ae039 = $bf278ee2b7c2a5e1$var$checkPelletByTime;


//import useCompany from "/src/hooks/useCompany";
function $d23f68b9708b0ef9$var$SideBar() {
    // needed to reload sidebar
    (0, $373f9505ebba8636$export$ea6ddbd83f749864)();
    const user = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").get("user");
    var bots = [
        {
            name: "View more",
            url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)("bots/list")
        }
    ];
    var datasets = [
        {
            name: "View more",
            url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)("datasets/list")
        }
    ];
    var dashboards = [
        {
            name: "View more",
            url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)("dashboards/list")
        }
    ];
    const sortList = (data)=>{
        return data.sort((a, b)=>{
            return new Date(b.updated_at) - new Date(a.updated_at);
        });
    };
    const services = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_integrations") ? {
            name: "integrations",
            url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)("plugin/integrations/list")
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_channels") ? {
            name: "channels",
            url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)("plugin/channels/list")
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_migrations") ? {
            name: "duplicate",
            url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)("plugin/migrations/list")
        } : null
    ].filter((category)=>category);
    const ai = [
        //hasPermission("view_integrations") ? { name: "llm", url: urlWithRoutingCompany("ai/llm/list") } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_integrations") ? {
            name: "brains",
            url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)("ai/llm-rag/list")
        } : null
    ].filter((category)=>category);
    const supervision = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_analytics") ? {
            name: "analytics",
            url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)("supervision/analytics/list")
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_conversations") ? {
            name: "conversations",
            url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)("supervision/conversations/list")
        } : null
    ].filter((category)=>category);
    const admin = [
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_organizations") ? {
            name: "organizations",
            url: "/administration/company/list"
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_users") ? {
            name: "users",
            url: "/administration/user/list"
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_roles") ? {
            name: "roles",
            url: "/administration/role/list"
        } : null,
        (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_phones") ? {
            name: "phones",
            url: "/administration/phone/list"
        } : null
    ].filter((category)=>category);
    const sidebarRefEvents = (el)=>{
        if (!el) return;
        el.addEventListener("mouseenter", ()=>el.className = "sidebar visible transition");
        el.addEventListener("mouseleave", ()=>el.className = "sidebar reduced transition");
    };
    const hasPelletIn = (list)=>{
        if (list == null) return "";
        const hasOne = list.some((row)=>(0, $bf278ee2b7c2a5e1$export$2e2bcd8739ae039)(row, 172800000));
        return hasOne;
    };
    const company = (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").get("company");
    var company_name = "";
    var nb_bots = 0;
    var nb_datasets = 0;
    var nb_dashboards = 0;
    if (company) {
        let listBotsSorted = sortList(company.bots);
        let listDatasetsSorted = sortList(company.datasets);
        let listDashboardsSorted = sortList(company.dashboards);
        bots = [
            ...(0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_bot") ? listBotsSorted.slice(0, 3).map((bot)=>({
                    name: bot.name,
                    url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)(`bots/${bot.name}`)
                })) : [],
            ...bots
        ];
        datasets = [
            ...(0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_dataset") ? listDatasetsSorted.slice(0, 3).map((dataset)=>{
                return {
                    name: dataset.name,
                    url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)("datasets/" + dataset.name)
                };
            }) : [],
            ...datasets
        ];
        dashboards = [
            ...(0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("update_dashboard") ? listDashboardsSorted.slice(0, 3).map((dashboardChannel)=>{
                return {
                    name: dashboardChannel.name ? dashboardChannel.name : dashboardChannel.dashboard.name,
                    url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)("dashboard/editor" + (dashboardChannel.company_id != company.id ? "/view/" : "/") + dashboardChannel.id)
                };
            }) : [],
            ...dashboards
        ];
        company_name = company.name;
        nb_bots = company.bots.length;
        nb_datasets = company.datasets.length;
        nb_dashboards = company.dashboards.length;
    }
    //useCompany(user.company_id);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        id: "sidebar-container",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            id: "sidebar",
            className: "sidebar reduced transition",
            ref: sidebarRefEvents,
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $79ffe7889d651d17$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    id: "container",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $926684d85dc2d995$export$2e2bcd8739ae039), {
                        children: [
                            (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_home") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $44d12f602941aba4$export$2e2bcd8739ae039), {
                                url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)("home"),
                                name: "home",
                                label: company_name
                            }) : null,
                            (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_bots") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $44d12f602941aba4$export$2e2bcd8739ae039), {
                                url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/bots/list"),
                                name: "bot",
                                plural: true,
                                numberOfData: nb_bots
                            }) : null,
                            (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_datasets") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $44d12f602941aba4$export$2e2bcd8739ae039), {
                                url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/datasets/list"),
                                name: "dataset",
                                plural: true,
                                numberOfData: nb_datasets
                            }) : null,
                            (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_ais") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $44d12f602941aba4$export$2e2bcd8739ae039), {
                                url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)("ai/llm-rag/list"),
                                name: "ai",
                                label: "brain",
                                plural: true
                            }) : null,
                            (0, $a7b361f9108b1dc4$export$2e2bcd8739ae039)("view_dashboards") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $44d12f602941aba4$export$2e2bcd8739ae039), {
                                url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)("/dashboards/list"),
                                name: "dashboard",
                                plural: true,
                                numberOfData: nb_dashboards
                            }) : null,
                            services.length ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c499fc00e37fb13a$export$2e2bcd8739ae039), {
                                data: services,
                                name: "plugin"
                            }) : null,
                            supervision.length ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c499fc00e37fb13a$export$2e2bcd8739ae039), {
                                data: supervision,
                                name: "supervision",
                                plural: false
                            }) : null,
                            admin.length ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c499fc00e37fb13a$export$2e2bcd8739ae039), {
                                data: admin,
                                name: "admin",
                                plural: false
                            }) : null,
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $44d12f602941aba4$export$2e2bcd8739ae039), {
                                url: (0, $a6b02690ee57318b$export$2e2bcd8739ae039)("memos"),
                                name: "memos"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $44d12f602941aba4$export$2e2bcd8739ae039), {
                                url: "/user/settings/",
                                name: "settings"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $44d12f602941aba4$export$2e2bcd8739ae039), {
                                externalLink: "https://www.talkr.ai/fr/template/",
                                name: "help"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d2d1ef0e4680c653$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
var $d23f68b9708b0ef9$export$2e2bcd8739ae039 = $d23f68b9708b0ef9$var$SideBar;


var $ee812a5323328110$export$2e2bcd8739ae039 = (0, $d23f68b9708b0ef9$export$2e2bcd8739ae039);




var $bh6RR = parcelRequire("bh6RR");




const $46d814a1a88b92aa$var$Genesys = ()=>{
    const dispatch = (0, $373f9505ebba8636$export$a03a56d03840936f)();
    const navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    const authorizedUrl = [
        "*"
    ];
    (0, $bh6RR.useEffect)(()=>{
        const handleMessage = (event)=>{
            if (authorizedUrl.includes(event.origin) == false) return;
            const message = event.data;
            const { token: token, user: user, company: company, permissions: permissions, refresh_token: refresh_token } = message;
            dispatch({
                type: "loginSuccess",
                payload: {
                    refresh_token: refresh_token,
                    token: token,
                    user: user
                }
            });
            (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").set("token", token);
            (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").set("refresh_token", refresh_token);
            (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("local").set("user", user);
            (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").set("company", company);
            (0, $c8b97750e6a6e84e$export$2e2bcd8739ae039)("session").set("permissions", permissions);
            navigate((0, $a6b02690ee57318b$export$2e2bcd8739ae039)("home"));
        };
        window.addEventListener("message", handleMessage);
        return ()=>{
            window.removeEventListener("message", handleMessage);
        };
    }, [
        dispatch,
        navigate
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {});
};
var $46d814a1a88b92aa$export$2e2bcd8739ae039 = $46d814a1a88b92aa$var$Genesys;


function $2b4cc9ee7661ab3c$var$SidebarLayout({ routes: routes }) {
    const location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    const match = routes.filter((route)=>(0, $b8f852338811df1a$export$81336c211d5ff295)({
            path: route.path,
            exact: true,
            strict: false
        }, location.pathname) && route.path != "*");
    const route = match.pop();
    return route && route.isSidebar && localStorage.getItem("token") ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ee812a5323328110$export$2e2bcd8739ae039), {}) : null;
}
function $2b4cc9ee7661ab3c$var$Router({ routes: routes }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $0bd3411f2ec14e23$export$9ba4e89fdfa1fc54), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($2b4cc9ee7661ab3c$var$SidebarLayout, {
                routes: routes
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6a9dcc96d11bcd0d$export$3565eb3d00ca5a74), {
                children: routes.map((route, index)=>(0, $73dfb228ee8fc095$export$2e2bcd8739ae039)(route, index))
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $46d814a1a88b92aa$export$2e2bcd8739ae039), {})
        ]
    });
}
var $2b4cc9ee7661ab3c$export$2e2bcd8739ae039 = $2b4cc9ee7661ab3c$var$Router;









var $bh6RR = parcelRequire("bh6RR");

function $3608e24937eb47db$var$Toast({ title: title, children: children, type: type, index: index, id: id, duration: duration, deleteTime: deleteTime }) {
    (0, $bh6RR.useEffect)(()=>{
        setTimeout(()=>{
            const progressBarRef = document.querySelector(`#notification_${id} #bar`);
            if (!progressBarRef) return;
            progressBarRef.className = "start";
        }, 50);
        if (deleteTime != 0) return;
        setInterval(()=>{
            const progressBarRef = document.querySelector(`#notification_${id} #bar`);
            if (!progressBarRef) return;
            progressBarRef.className = "";
            progressBarRef.style.transition = "";
            setTimeout(()=>{
                progressBarRef.style.transition = "width ease " + duration + "ms";
                progressBarRef.className = "start";
            }, 100);
        }, duration);
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        setInterval(reloadNotificationPosition, 50);
        if (deleteTime == 0) return;
        setTimeout(()=>{
            const notificationRef = document.getElementById("notification_" + id);
            if (!notificationRef) return;
            notificationRef.className = "notification " + type + " disappear";
        }, deleteTime - 250);
    }, [
        deleteTime
    ]);
    const reloadNotificationPosition = ()=>{
        const element = document.getElementById("notification_" + id);
        if (!element) return;
        const { bottom: bottom, right: right } = getOffset();
        element.style.bottom = bottom + "px";
        element.style.right = right + "px";
    };
    const getOffset = ()=>{
        const chatbox = document.querySelector(".kwalys-chatbox-window.visible");
        const offsetBottom = chatbox ? 570 : 20;
        const window = document.getElementsByClassName("editor-window").item(0);
        const windowChannelWeb = document.getElementsByClassName("channel-web-window").item(0);
        const offsetRight = window ? 490 : windowChannelWeb ? 520 : 20;
        const bottom = offsetBottom + index * 110;
        const right = offsetRight;
        return {
            bottom: bottom,
            right: right
        };
    };
    const { bottom: bottom, right: right } = getOffset();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        id: "notification_" + id,
        className: "notification " + type,
        style: {
            maxWidth: 500,
            bottom: bottom,
            right: right
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "progress-bar",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    id: "bar",
                    style: {
                        transition: "width ease " + duration + "ms"
                    }
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                className: "title",
                children: title
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                className: "desc",
                children: children
            })
        ]
    });
}
$3608e24937eb47db$var$Toast.defaultProps = {
    type: "success",
    title: "Default Text"
};
var $3608e24937eb47db$export$2e2bcd8739ae039 = $3608e24937eb47db$var$Toast;



function $e1f2e52991f634bd$var$ToastContainer() {
    const { toasts: toasts } = (0, $8a53d819e82d540b$export$d2fbf2d5ee3dcf9e)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "toasts-wrapper",
        style: {
            zIndex: 10000
        },
        children: toasts.map((toast, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $3608e24937eb47db$export$2e2bcd8739ae039), {
                ...toast,
                index: index,
                children: toast.message
            }, toast.id))
    });
}
var $e1f2e52991f634bd$export$2e2bcd8739ae039 = $e1f2e52991f634bd$var$ToastContainer;


var $ff7f818fca2e0ae8$export$2e2bcd8739ae039 = (0, $8a53d819e82d540b$export$2e2bcd8739ae039);


function $5452b54ef2167a77$var$Providers({ children: children }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $ff7f818fca2e0ae8$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $373f9505ebba8636$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $36c8369d2da2c3c8$export$2e2bcd8739ae039).Provider, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $e1f2e52991f634bd$export$2e2bcd8739ae039), {}),
                    children
                ]
            })
        })
    });
}
var $5452b54ef2167a77$export$2e2bcd8739ae039 = $5452b54ef2167a77$var$Providers;



var $bh6RR = parcelRequire("bh6RR");

function $cb2498a1bd42c2c5$var$useNetwork() {
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const [toastData, setToastData] = (0, $bh6RR.useState)(null);
    /*
    if(!navigator.onLine) {
        //toast.error('No connexion', 'please connect', 0);
    }*/ const deleteTime = 250;
    const offlineDispatch = ()=>{
        if (toastData) setTimeout(()=>toast.dispatch({
                type: "deleteToast",
                payload: {
                    id: toastData.id
                }
            }), deleteTime);
        setTimeout(()=>{
            const data = toast.error("No connexion available", "Please connect your computer to a router wifi :'( ", 5000, 0);
            setToastData(data);
        }, deleteTime + 50);
    };
    const onlineDispatch = ()=>{
        if (!toastData) return;
        toast.dispatch({
            type: "updateToast",
            payload: {
                ...toastData,
                deleteTime: deleteTime
            }
        });
        setTimeout(()=>toast.dispatch({
                type: "deleteToast",
                payload: {
                    id: toastData.id
                }
            }), deleteTime);
        setTimeout(()=>{
            var data = toast.success("Your connexion is back !", "We are happy to see you back, have a nice time", 5000);
            setToastData(data);
        }, deleteTime + 50);
    };
    (0, $bh6RR.useEffect)(()=>{
        window.addEventListener("online", onlineDispatch);
        window.addEventListener("offline", offlineDispatch);
        return ()=>{
            window.removeEventListener("online", onlineDispatch);
            window.removeEventListener("offline", offlineDispatch);
        };
    }, [
        toastData
    ]);
}
var $cb2498a1bd42c2c5$export$2e2bcd8739ae039 = $cb2498a1bd42c2c5$var$useNetwork;



var $bh6RR = parcelRequire("bh6RR");

var $fd8eedb466df5bf6$export$2e2bcd8739ae039 = {
    dev: "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",
    prod: "iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAAEEfUpiAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAMzaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/Pg0KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS4wLWMwNjAgNjEuMTM0MzQyLCAyMDEwLzAxLzEwLTE4OjA2OjQzICAgICAgICAiPg0KICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPg0KICAgIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDUzUiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QzFCNzU0OTE5RjdBMTFFQzgwMDhCOUFDODJBMzUyNjIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QzFCNzU0OTI5RjdBMTFFQzgwMDhCOUFDODJBMzUyNjIiPg0KICAgICAgPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QzFCNzU0OEY5RjdBMTFFQzgwMDhCOUFDODJBMzUyNjIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QzFCNzU0OTA5RjdBMTFFQzgwMDhCOUFDODJBMzUyNjIiIC8+DQogICAgPC9yZGY6RGVzY3JpcHRpb24+DQogIDwvcmRmOlJERj4NCjwveDp4bXBtZXRhPg0KPD94cGFja2V0IGVuZD0iciI/PlTRe/IAAAQFSURBVEhLxZdbiFVVGMfPzKRm4g2imkYlLS8PRYld7KKihpei8cEHQQmHLEGyhxSdt6jAF3GI1CIvgyI+iBIxeENFIgJHxBuIVsw0YxMWYhe10plxnOn322ft4cyc4z5zU//wO2vttdflW2t969vrFLS1taUyZcG7pO9BMxSnKFgL7SqwmhlTldVHIayE8+CbDVF19FtI2yz4PJ1Nt406VTwfJmmBN6AcLsBYX5yAPXAbvoFMXcgyq7O0KlWASB40H8uySAmNO4qKW0IatSBZDQWF/JTBZ5RNJN0cXl4jmQ5zHeIomRnwE1yB10B9CzeskGiEs0iqUJK4Ds4ycx1qzQeVhbJs0dkI2AkbQ1GiYhOG0OF1Up+r4RTMg/kwCb4AVQxb4Tg8BA2uwtdkzkF/GAij4RnQZB1zDjwAsSyvg0aodPQ6WA+tEEvPqYIN0VOCtEBT/oOeqL6Qud8g80T6uVu6RNsxIZ8W1nwc2ZWsJggt2IXMh56o1x1kiQ4/hEpwS/MqctVYNHqU5Fn4B74KZbug1bwivw4WwBKfncIgVjPaRvL7SH6GETCL8sGUxXP8BXbDI+CB/R0q7MBQNhyMSQtBT7sJpTAhPMeqgmGgFxrHqp3CSPgbfoV+MAXmgpoc0lhvgm7t+nhultnBKHgY1oMOVQROyfPxNmTKxi+B50YHnOa8T8Ju55qhZtgBOk2SvncNcjmCp1ATnVKSVtqBKzok/dxtFbkGU9P5bquRbW6NI1JPrBhOB1djTxwa0q6q3MYhnxZW+JkwEuXT+6FJblFhebpels6CPtJBvT7O0SLmE4M8R+K5cM1+ZP6nLe8L5TWAwZeSeHE4Bv+C35ovMcLPSSTqDCJZDN5PvuOdxe3ivSHGY+ZR8vLxQ1wn0QAaLiJZAc7YGDUA/NCVwGg6aaGOgb0GYo8ydpXybj/vnib/CdwC3zfBRfgDaqhzwD00GBgljGHOoB5OwkyoAOPYYNDX7ehlMCR9BGuhEt6BztoLttHFPdpOQAN0X424Doc0YBMZl9eIZAVDlQM627fAVTL2/QXGzGVg5N4D22A7PA65dBkc2Bm7fXqsg7sNft3HuCzGU5fU/XE5zRtHP4Bx4KAGZTvQelOt1ylfhDsNrjT0MXDQBjBmexEYDxqz1BXw0+A1LrqsgNvxFGTKLRG341XwPBopvcc8CV2RRlwC+/D+qHG1OtoRiKVT3UkNsAoMCN63r0Jvtd0VcMZ+TO+HJka/GLE1sufe6tNo8FgUdP6s3k2tC8N2FC/803E3pY/NDsPlFhWKwKtdX2sN5A397aKyvA410FOdgRdClznVZYvoyKD1CriEz4NByxulAeVPMFj55+cgnCXOd+k77TEM2fuhVOp/LYT7VrimoEMAAAAASUVORK5CYII="
};




var $bh6RR = parcelRequire("bh6RR");

const $13cf30e4aaa720c5$var$isJavaScript = (content)=>{
    const jsRegex = /function\s*\w*\s*\(|\w+\s*=\s*function\s*\(|\(\s*function\s*\(|console\..*;/;
    return jsRegex.test(content);
};
const $13cf30e4aaa720c5$var$isScriptExist = ()=>new Promise((resolve, reject)=>{
        const scripts = [
            ...document.getElementsByTagName("script")
        ].filter((script)=>script.defer);
        const url = scripts.length > 1 ? scripts[1].src : scripts[0].src;
        const headers = new Headers();
        headers.append("pragma", "no-cache");
        headers.append("cache-control", "no-cache");
        const options = {
            method: "get",
            headers: headers
        };
        fetch(url, options).then((response)=>{
            return response.text();
        }).then((response)=>{
            return $13cf30e4aaa720c5$var$isJavaScript(response) ? resolve(true) : resolve(false);
        }).catch((error)=>{
            resolve(true);
        });
    });
const $13cf30e4aaa720c5$var$Updater = (props)=>{
    const channel = new BroadcastChannel("reloadChannel");
    const [isToast, setIsToast] = (0, $bh6RR.useState)(0);
    const toast = (0, $8a53d819e82d540b$export$ad0b1cd0425e5c95)();
    const reload = (event)=>{
        if (!event.data || event.data.command !== "reload") return;
        window.location.reload();
    };
    const check = async ()=>{
        if (isToast == 1) return;
        const isExist = await $13cf30e4aaa720c5$var$isScriptExist();
        if (isExist) return;
        setIsToast(1);
    };
    (0, $bh6RR.useEffect)(()=>{
        check();
        const intervalId = setInterval(async ()=>await check(), 60000);
        channel.addEventListener("message", reload);
        return ()=>{
            channel.close();
            clearInterval(intervalId);
        };
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        if (isToast == 0 || isToast == 2) return;
        toast.info("New Talkr version available !", /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
            onClick: ()=>channel.postMessage({
                    command: "reload"
                }),
            style: {
                fontWeight: 600,
                cursor: "pointer",
                textDecoration: "underline"
            },
            children: "To update the platform, click here \uD83D\uDC48"
        }), 5000, 0);
    }, [
        isToast
    ]);
};
var $13cf30e4aaa720c5$export$2e2bcd8739ae039 = $13cf30e4aaa720c5$var$Updater;


function $aa831a3b70830250$var$App() {
    const { dev: dev, prod: prod } = (0, $fd8eedb466df5bf6$export$2e2bcd8739ae039);
    (0, $bh6RR.useEffect)(()=>{
        document.getElementById("favicon").href = `data:image/x-icon;base64,${(0, $651df53b10514175$export$a7b6bc01c63cdfc3).REACT_APP_DEBUG != "true" ? prod : dev}`;
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $5452b54ef2167a77$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $cb2498a1bd42c2c5$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2b4cc9ee7661ab3c$export$2e2bcd8739ae039), {
                routes: (0, $c2bf1c0139183290$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $13cf30e4aaa720c5$export$2e2bcd8739ae039), {})
        ]
    });
}
var $aa831a3b70830250$export$2e2bcd8739ae039 = $aa831a3b70830250$var$App;



var $c44f2a50c4938b49$exports = {};
$c44f2a50c4938b49$exports = new URL("service-worker.js", import.meta.url).toString();


if ("serviceWorker" in navigator) window.addEventListener("load", ()=>{
    navigator.serviceWorker.register($c44f2a50c4938b49$exports).then((registration)=>{
        console.log("Service Worker registered with scope:", registration.scope);
    }).catch((error)=>{
        console.error("Service Worker registration failed:", error);
    });
});
const $1f0dc3b9307be026$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($6fc264ec92100d3a$exports))).createRoot(document.getElementById("root"));
$1f0dc3b9307be026$var$root.render(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $aa831a3b70830250$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.1ce355db.js.map
